const english = {
  Listing: 'Listing',
  'Try broadening the current search or status filter.':
    'Try broadening the current search or status filter.',
  'Try broadening the search, role, or status filters.':
    'Try broadening the search, role, or status filters.',
  'Monitor fleet compliance, validation status, and expiring insurance in one place.':
    'Monitor fleet compliance, validation status, and expiring insurance in one place.',
  'Active Listings': 'Active Listings',
  'Open transport requests': 'Open transport requests',
  'Quotes Today': 'Quotes Today',
  'Submitted in last 24h': 'Submitted in last 24h',
  'Platform Revenue (MTD)': 'Platform Revenue (MTD)',
  'Month to date': 'Month to date',
  'Pending Partners': 'Pending Partners',
  'Awaiting approval': 'Awaiting approval',
  'Unpaid Invoices': 'Unpaid Invoices',
  'Requires action': 'Requires action',
  'Completed Transports': 'Completed Transports',
  'All time delivered': 'All time delivered',
  'Admin Dashboard': 'Admin Dashboard',
  'Platform overview and key performance indicators.':
    'Platform overview and key performance indicators.',
  'Loading dashboard metrics...': 'Loading dashboard metrics...',
  Invoices: 'Invoices',
  'Review payout invoices uploaded by partners and keep payout processing organized.':
    'Review payout invoices uploaded by partners and keep payout processing organized.',
  Flexible: 'Flexible',
  'Flexible dates': 'Flexible dates',
  'Could not load this listing.': 'Could not load this listing.',
  'Listing canceled': 'Listing canceled',
  'Failed to cancel listing': 'Failed to cancel listing',
  Reference: 'Reference',
  Category: 'Category',
  'Client type': 'Client type',
  'Company country': 'Company country',
  Expires: 'Expires',
  'Back to listings': 'Back to listings',
  'Listing not found.': 'Listing not found.',
  'Cancel Listing': 'Cancel Listing',
  'Listing details': 'Listing details',
  'Reference {{id}}': 'Reference {{id}}',
  'Read-only listing overview for admins.':
    'Read-only listing overview for admins.',
  'Pick-up': 'Pick-up',
  'No exact coordinates are stored for this listing yet.':
    'No exact coordinates are stored for this listing yet.',
  'Structured overview of quantities and handling details.':
    'Structured overview of quantities and handling details.',
  'Shipment images': 'Shipment images',
  'No shipment images were uploaded for this listing.':
    'No shipment images were uploaded for this listing.',
  'Proof of pickup': 'Proof of pickup',
  'Final documents': 'Final documents',
  Description: 'Description',
  'Quotes ({{count}})': 'Quotes ({{count}})',
  'Loading quotes...': 'Loading quotes...',
  'No quotes for this listing.': 'No quotes for this listing.',
  'Score: {{score}}/100': 'Score: {{score}}/100',
  'Pickup: {{date}}': 'Pickup: {{date}}',
  'Delivery: {{date}}': 'Delivery: {{date}}',
  'Cancel Listing?': 'Cancel Listing?',
  'This will permanently cancel the listing and notify the client. Continue?':
    'This will permanently cancel the listing and notify the client. Continue?',
  Keep: 'Keep',
  'Review partner applications, check their documents, and keep approval decisions consistent.':
    'Review partner applications, check their documents, and keep approval decisions consistent.',
  'No client payments recorded yet': 'No client payments recorded yet',
  'Client payment rows will appear here when the payments backend is connected.':
    'Client payment rows will appear here when the payments backend is connected.',
  Method: 'Method',
  'No partner payouts recorded yet': 'No partner payouts recorded yet',
  'Payout rows will appear here once partner payout processing is enabled.':
    'Payout rows will appear here once partner payout processing is enabled.',
  'Payout Amount': 'Payout Amount',
  'No platform fees recorded yet': 'No platform fees recorded yet',
  'Fee rows will appear here once payment settlement data is available.':
    'Fee rows will appear here once payment settlement data is available.',
  Gross: 'Gross',
  'Fee (20%)': 'Fee (20%)',
  Payments: 'Payments',
  'Client payments, partner payouts, and platform fee tracking.':
    'Client payments, partner payouts, and platform fee tracking.',
  'Client Payments': 'Client Payments',
  'Partner Payouts': 'Partner Payouts',
  'Platform Fees': 'Platform Fees',
  'Failed to load reviews': 'Failed to load reviews',
  'Review removed': 'Review removed',
  'Failed to remove review': 'Failed to remove review',
  Reviews: 'Reviews',
  'All partner and transport reviews submitted by clients.':
    'All partner and transport reviews submitted by clients.',
  'Loading reviews...': 'Loading reviews...',
  'No reviews found': 'No reviews found',
  'Client feedback will appear here when reviews are submitted.':
    'Client feedback will appear here when reviews are submitted.',
  Stars: 'Stars',
  Comment: 'Comment',
  'Search, review, and maintain user accounts with one consistent admin workflow.':
    'Search, review, and maintain user accounts with one consistent admin workflow.',
  'Track paid and unpaid partner payout invoices, and upload the next delivered listing invoice quickly.':
    'Track paid and unpaid partner payout invoices, and upload the next delivered listing invoice quickly.',
  'Search by invoice number, file name, or listing ID':
    'Search by invoice number, file name, or listing ID',
  'Loading delivered listings...': 'Loading delivered listings...',
  'Search delivered listing by reference, title, or route':
    'Search delivered listing by reference, title, or route',
  'Route details available in listing': 'Route details available in listing',
  'No matching delivered listings': 'No matching delivered listings',
  'Selected listing': 'Selected listing',
  'Has quotes': 'Has quotes',
  'In transit': 'In transit',
  Open: 'Open',
  Accepted: 'Accepted',
  Completed: 'Completed',
  'Client Dashboard': 'Client Dashboard',
  'Overview of your current transport listings, quote activity, and recent requests.':
    'Overview of your current transport listings, quote activity, and recent requests.',
  'Total listings': 'Total listings',
  'Active listings': 'Active listings',
  'Listings with quotes': 'Listings with quotes',
  'Accepted transport': 'Accepted transport',
  'Listing status timeline': 'Listing status timeline',
  'Last 6 months of listings grouped by current status.':
    'Last 6 months of listings grouped by current status.',
  'No listing activity yet': 'No listing activity yet',
  'Create your first listing to start tracking request activity here.':
    'Create your first listing to start tracking request activity here.',
  'Create new listing': 'Create new listing',
  'Create a new transport request for the marketplace.':
    'Create a new transport request for the marketplace.',
  'View my listings': 'View my listings',
  'Review quote activity and manage your transport requests.':
    'Review quote activity and manage your transport requests.',
  'Recent listings': 'Recent listings',
  'No listings yet': 'No listings yet',
  'Your newest transport requests will appear here once you create them.':
    'Your newest transport requests will appear here once you create them.',
  'Unknown origin': 'Unknown origin',
  '{{count}} quote(s)': '{{count}} quote(s)',
  '{{value}} completed listings': '{{value}} completed listings',
  'Monitor current performance, fleet readiness, quote flow, and your active transport queue.':
    'Monitor current performance, fleet readiness, quote flow, and your active transport queue.',
  'Total assigned': 'Total assigned',
  'Quarter rating': 'Quarter rating',
  'Based on current quarter performance':
    'Based on current quarter performance',
  Rating: 'Rating',
  'Requirement met': 'Requirement met',
  'Requirement not met': 'Requirement not met',
  'Completed listings per period': 'Completed listings per period',
  'No completion data yet': 'No completion data yet',
  'Statistics will appear here after your first delivered work.':
    'Statistics will appear here after your first delivered work.',
  'Completed listings': 'Completed listings',
  'Review truck documents and refresh anything close to expiry.':
    'Review truck documents and refresh anything close to expiry.',
  'Search deliveries': 'Search deliveries',
  'Review available marketplace listings and submit quotes.':
    'Review available marketplace listings and submit quotes.',
  'My quotes': 'My quotes',
  'Track accepted, pending, and rejected quotes in one place.':
    'Track accepted, pending, and rejected quotes in one place.',
  'Profile settings': 'Profile settings',
  'Keep company information and compliance details up to date.':
    'Keep company information and compliance details up to date.',
  'No active queue items': 'No active queue items',
  'Accepted and in-progress work will appear here as your transport activity grows.':
    'Accepted and in-progress work will appear here as your transport activity grows.',
  'Your role does not have permission to open this page.':
    'Your role does not have permission to open this page.',
  'Go to dashboard': 'Go to dashboard',
  'Trailer capacity is required.': 'Trailer capacity is required.',
  'How many cars can this trailer carry?':
    'How many cars can this trailer carry?',
  'Set maximum number of cars this trailer can carry (1-20).':
    'Set maximum number of cars this trailer can carry (1-20).',
  'Invalid max load (kg).': 'Invalid max load (kg).',
  'Enter a valid weight between 1 and 100000 kg, or leave it empty.':
    'Enter a valid weight between 1 and 100000 kg, or leave it empty.',
  'Maximum payload weight this truck can carry (optional).':
    'Maximum payload weight this truck can carry (optional).',
  'Manage the company and contact details that appear across your listings, invoices, and account verification flows.':
    'Manage the company and contact details that appear across your listings, invoices, and account verification flows.',
  'Keep these details up to date so listings, invoices, and partner verification stay accurate.':
    'Keep these details up to date so listings, invoices, and partner verification stay accurate.',
  'Unsaved changes': 'Unsaved changes',
  'All changes saved': 'All changes saved',
  'auth.the_email_address_is_not_valid': 'The email address is not valid.',
  'auth.this_account_has_been_disabled': 'This account has been disabled.',
  'auth.no_account_found_with_this_email': 'No account found with this email.',
  'auth.too_many_failed_attempts_please_try_again_later_or_reset_your_password':
    'Too many failed attempts. Please try again later or reset your password.',
  'auth.network_error_check_your_connection_and_try_again':
    'Network error. Check your connection and try again.',
  'auth.invalid_credential':
    'Invalid email or password. Please check your credentials.',
  'auth.too_many_requests': 'Too many failed attempts. Please try again later.',
  'auth.user_disabled':
    'This account has been disabled. Please contact support.',
  'auth.user_not_found': 'No account found with this email.',
  'auth.wrong_password': 'Incorrect password. Please try again.',
  'auth.email_already_in_use':
    'An account with this email already exists. Please sign in instead.',
  'auth.sign_up_failed': 'Sign up failed',
  'auth.verification_email_resent': 'Verification email resent',
  'auth.please_check_your_inbox': 'Please check your inbox.',
  'auth.you_need_to_log_in_first': 'You need to log in first.',
  'auth.please_sign_in_to_resend_the_verification_email':
    'Please sign in to resend the verification email.',
  'auth.please_select_a_valid_role': 'Please select a valid role.',
  'booking.pickup_not_found': 'Pickup not found.',
  'booking.delivery_not_found': 'Delivery not found.',
  'booking.profile_incomplete_partner_message':
    'Please complete your company information (Company Name, VAT Number, Address, City, Post Code, Phone) before accepting orders.',
  'booking.profile_incomplete_partner_short':
    'Complete your company information to accept orders.',
  'booking.not_set': 'Not set',
  'booking.capacity': 'Capacity',
  'booking.cmr_expiry': 'CMR Expiry',
  'booking.weight_kg': 'Weight (kg)',
  'booking.uploaded': 'Uploaded',
  'booking.missing': 'Missing',
  'booking.cmr_document': 'CMR Document',
  'Finalize the handover plan with scheduling cues, site availability, and sustainability preferences. This view keeps everything critical in one place without repeating details from earlier steps.':
    'Finalize the handover plan with scheduling cues, site availability, and sustainability preferences. This view keeps everything critical in one place without repeating details from earlier steps.',
  'Preferences & notes': 'Preferences & notes',
  'Loading notifications': 'Loading notifications',
  None: 'None',
  '1 day before': '1 day before',
  '2 days before': '2 days before',
  '1 week before': '1 week before',
  'Sustainability options': 'Sustainability options',
  'Offset CO₂ emissions for this shipment':
    'Offset CO₂ emissions for this shipment',
  'Prefer biofuel usage where available':
    'Prefer biofuel usage where available',
  'Environmental or compliance notes': 'Environmental or compliance notes',
  'Share green requirements, certification numbers, or carbon reporting needs.':
    'Share green requirements, certification numbers, or carbon reporting needs.',
  Previous: 'Previous',
  Next: 'Next',
  'Select Pick up Date': 'Select Pick up Date',
  'Select the date when the cargo is to be picked up.':
    'Select the date when the cargo is to be picked up.',
  'Select Delivery Date': 'Select Delivery Date',
  'Select the date when the cargo is to be delivered.':
    'Select the date when the cargo is to be delivered.',
  'Vehicle pickup location': 'Vehicle pickup location',
  'Vehicle delivery location': 'Vehicle delivery location',
  'Route preview': 'Route preview',
  'Provide both pickup and delivery postal codes to preview the lane on the map.':
    'Provide both pickup and delivery postal codes to preview the lane on the map.',
  'No contact set': 'No contact set',
  'Vehicles scheduled': 'Vehicles scheduled',
  'Quoted price': 'Quoted price',
  'Excl. any partner fees': 'Excl. any partner fees',
  'No vehicles added yet.': 'No vehicles added yet.',
  'Recalculate price': 'Recalculate price',
  'Add at least one vehicle.': 'Add at least one vehicle.',
  'Add the vehicle weight.': 'Add the vehicle weight.',
  'Add at least one pickup time window.':
    'Add at least one pickup time window.',
  'Confirm the pickup opening hours.': 'Confirm the pickup opening hours.',
  'Pickup date must be selected.': 'Pickup date must be selected.',
  'Add at least one delivery time window.':
    'Add at least one delivery time window.',
  'Confirm the delivery opening hours.': 'Confirm the delivery opening hours.',
  'Add a weight for each vehicle.': 'Add a weight for each vehicle.',
  'One of the locations could not be positioned on the map.':
    'One of the locations could not be positioned on the map.',
  'Unable to load the map preview right now.':
    'Unable to load the map preview right now.',
  'Quote updated': 'Quote updated',
  'Estimated total client price €{{price}}':
    'Estimated total client price €{{price}}',
  'Complete missing data': 'Complete missing data',
  'Finish each step before creating the booking.':
    'Finish each step before creating the booking.',
  'User not logged in': 'User not logged in',
  'Booking created': 'Booking created',
  'Your transport request is now visible under My Orders.':
    'Your transport request is now visible under My Orders.',
  'Booking failed': 'Booking failed',
  Bookings: 'Bookings',
  Trucks: 'Trucks',
  Drivers: 'Drivers',
  'Booking was created but no id returned.':
    'Booking was created but no id returned.',
  'Error creating booking': 'Error creating booking',
  'An unexpected error occurred.': 'An unexpected error occurred.',
  'Fill in the address and contact person. This helps dispatch align pickups with logistics partners.':
    'Fill in the address and contact person. This helps dispatch align pickups with logistics partners.',
  'Loading only possible from 08:00 to 17:00. Ask for Johan.':
    'Loading only possible from 08:00 to 17:00. Ask for Johan.',
  'Avoid additional costs by sharing the exact depot availability.':
    'Avoid additional costs by sharing the exact depot availability.',
  'Avoid missed trips by matching the window the truck can enter the premises.':
    'Avoid missed trips by matching the window the truck can enter the premises.',
  'I confirm the pickup opening hours': 'I confirm the pickup opening hours',
  'I confirm the delivery opening hours':
    'I confirm the delivery opening hours',
  to: 'to',
  Closed: 'Closed',
  Mo: 'Mo',
  Tu: 'Tu',
  We: 'We',
  Th: 'Th',
  Fr: 'Fr',
  Sa: 'Sa',
  Su: 'Su',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  'e.g. 2200': 'e.g. 2200',
  'X vehicle(s)': '{{count}} vehicle(s)',
  'X total': '{{count}} total',
  kg: 'kg',
  'Weight (kg)*': 'Weight (kg)*',
  'Length (cm)': 'Length (cm)',
  'Height (cm)': 'Height (cm)',
  'Width (cm)': 'Width (cm)',
  'Dimensions (cm)': 'Dimensions (cm)',
  'Make / Model': 'Make / Model',
  'Chassis Number/Licence plate': 'Chassis Number/Licence plate',
  'Fill in the details and specify the parameters for every vehicle type.':
    'Fill in the details and specify the parameters for every vehicle type.',
  'Calculate a price to proceed.': 'Calculate a price to proceed.',
  'Zip Code': 'Zip Code',
  'Delivery Country': 'Delivery Country',
  'Pickup Country': 'Pickup Country',
  'Calculate price': 'Calculate price',
  Compact: 'Compact',
  Hatchback: 'Hatchback',
  Coupé: 'Coupé',
  Superauto: 'Superauto',
  Sedan: 'Sedan',
  'Station Wagon': 'Station Wagon',
  Crossover: 'Crossover',
  SUV: 'SUV',
  'Transport Car': 'Transport Car',
  Van: 'Van',
  'Provide route details': 'Provide route details',
  'City not set': 'City not set',
  From: 'From',
  To: 'To',
  'Body type': 'Body type',
  'Remove vehicle': 'Remove vehicle',
  'Vehicle type': 'Vehicle type',
  'Non-runner': 'Non-runner',
  'Avg. weight (kg)': 'Avg. weight (kg)',
  'Provide an estimated weight to calculate price.':
    'Provide an estimated weight to calculate price.',
  'Pickup document': 'Pickup document',
  'Upload or drag & drop. Accepted: .jpg, .png, .pdf, .docx, .xls':
    'Upload or drag & drop. Accepted: .jpg, .png, .pdf, .docx, .xls',
  'Remove file': 'Remove file',
  'Choose file': 'Choose file',
  'Company name': 'Company name',
  'Contact person': 'Contact person',
  'Contact language': 'Contact language',
  'Contact phone': 'Contact phone',
  'Contact email': 'Contact email',
  'Loading address is logistic centre': 'Loading address is logistic centre',
  'Documents needed on site': 'Documents needed on site',
  'Pick up document': 'Pick up document',
  'Pick up code': 'Pick up code',
  'Vehicle registration': 'Vehicle registration',
  'Notes for the partner': 'Notes for the partner',
  'Local time': 'Local time',
  'Add time': 'Add time',
  'Remove time slot': 'Remove time slot',
  'Keep an eye on the quote as you tweak route details or vehicle mix.':
    'Keep an eye on the quote as you tweak route details or vehicle mix.',
  'Transit time: {{hours}}h': 'Transit time: {{hours}}h',
  'Calculate to preview your quote.': 'Calculate to preview your quote.',
  total: 'total',
  Required: 'Required',
  'Add vehicle': 'Add vehicle',
  'Route details': 'Route details',
  'Latest quote preview': 'Latest quote preview',
  or: 'or',
  'Enter manual price': 'Enter manual price',
  Lane: 'Lane',
  'Distance & time': 'Distance & time',
  Language: 'Language',
  'Select language': 'Select language',
  'Change language': 'Change language',
  'Loading…': 'Loading…',
  'Loading...': 'Loading…',
  Error: 'Error',
  'Error:': 'Error:',
  Back: 'Back',
  Cancel: 'Cancel',
  Close: 'Close',
  Confirm: 'Confirm',
  Yes: 'Yes',
  No: 'No',
  'Keep order': 'Keep order',
  'Order details': 'Order details',
  'Order ID': 'Order ID',
  Date: 'Date',
  'Ready from': 'Ready from',
  'Latest pick up': 'Latest pick up',
  Price: 'Price',
  Status: 'Status',
  'Payment status': 'Payment status',
  'Customer information': 'Customer information',
  'Additional information': 'Additional information',
  'Documents & damages': 'Documents & damages',
  'Purchase terms': 'Purchase terms',
  'Purchase Terms Management': 'Purchase Terms Management',
  'Power of attorney': 'Power of attorney',
  Damages: 'Damages',
  'No files': 'No files',
  Performance: 'Performance',
  'Transport details': 'Transport details',
  Schedule: 'Schedule',
  Driver: 'Driver',
  'License plate': 'License plate',
  'Vehicle details': 'Vehicle details',
  Vehicle: 'Vehicle',
  'Chassis number': 'Chassis number',
  Width: 'Width',
  Height: 'Height',
  Length: 'Length',
  Weight: 'Weight',
  'Extra wheels': 'Extra wheels',
  Towing: 'Towing',
  'Electric / Hybrid': 'Electric / Hybrid',
  'Copy vehicle details': 'Copy vehicle details',
  'Payment instructions': 'Payment instructions',
  'Upload damages': 'Upload damages',
  'Download (PDF)': 'Download (PDF)',
  'Mark as picked up': 'Mark as picked up',
  'Mark as delivered': 'Mark as delivered',
  'Cancel order': 'Cancel order',
  'Cancel booking': 'Cancel booking',
  'Are you sure you want to cancel order {{id}}? This action cannot be undone.':
    'Are you sure you want to cancel order {{id}}? This action cannot be undone.',
  'Order marked as picked up': 'Order marked as picked up',
  'Order marked as delivered': 'Order marked as delivered',
  'Order canceled': 'Order canceled',
  'Failed to cancel order': 'Failed to cancel order',
  'Added {{count}} file(s)': 'Added {{count}} file(s)',
  Pages: 'Pages',
  'Awaiting Verification': 'Awaiting Verification',
  Dashboard: 'Dashboard',
  Profile: 'Profile',
  'View Profile': 'View Profile',
  'Profile Incomplete': 'Profile Incomplete',
  'Please complete your profile information (Company, Phone, Address, City, Post Code) to access all features.':
    'Please complete your profile information (Company, Phone, Address, City, Post Code) to access all features.',
  'Go to Profile': 'Go to Profile',
  Orders: 'Orders',
  'My Orders': 'My Orders',
  'New Order': 'New Order',
  Watchlist: 'Watchlist',
  'Fleet Management': 'Fleet Management',
  'Verify New Partners': 'Verify New Partners',
  'Manage All Users': 'Manage All Users',
  'Manage Pending Trucks': 'Manage Pending Trucks',
  'Forgot Password': 'Forgot Password',
  'Log out': 'Log out',
  'My Profile': 'My Profile',
  Hello: 'Hello',
  friend: 'friend',
  'Book your transport': 'Book your transport',
  'fast and easy': 'fast and easy',
  Route: 'Route',
  Summary: 'Summary',
  'Keep an eye on the route and quote at a glance.':
    'Keep an eye on the route and quote at a glance.',
  'Estimated price': 'Estimated price',
  'VIP price': 'VIP price',
  'Valid until {{date}}': 'Valid until {{date}}',
  'Transit time: ~{{hours}}h': 'Transit time: ~{{hours}}h',
  Origin: 'Origin',
  Destination: 'Destination',
  'Postal code': 'Postal code',
  'Calculate to preview': 'Calculate to preview',
  'Speed Score': 'Speed Score',
  "Can't be calculated yet": "Can't be calculated yet",
  'Planning Score': 'Planning Score',
  'Accurate Planning': 'Accurate Planning',
  'No Change of plans': 'No Change of plans',
  Preplanned: 'Preplanned',
  Planned: 'Planned',
  'Picked up': 'Picked up',
  Delivered: 'Delivered',
  Canceled: 'Canceled',
  Unknown: 'Unknown',
  Paid: 'Paid',
  'Awaiting payment': 'Awaiting payment',
  'Awaiting payment badge': 'Awaiting payment',
  'Ref {{id}}': 'Ref {{id}}',
  'Planned pickup date': 'Planned pickup date',
  'Planned arrival date': 'Planned arrival date',
  'Change planning': 'Change planning',
  'Change driver': 'Change driver',
  OK: 'OK',
  'Pickup contact': 'Pickup contact',
  'Delivery contact': 'Delivery contact',
  Pickup: 'Pickup',
  Delivery: 'Delivery',
  Vehicles: 'Vehicles',
  'No vehicles listed': 'No vehicles listed',
  Quantity: 'Quantity',
  'VIN / Chassis': 'VIN / Chassis',
  Info: 'Info',
  Beneficiary: 'Beneficiary',
  Address: 'Address',
  Bank: 'Bank',
  IBAN: 'IBAN',
  BIC: 'BIC',
  'Order not found.': 'Order not found.',
  'Not available': 'Not available',
  'For {{date}}': 'For {{date}}',
  'Picked on {{date}}': 'Picked on {{date}}',
  'Delivered on {{date}}': 'Delivered on {{date}}',
  'Loading notification: {{value}}': 'Loading notification: {{value}}',
  'CO₂ compensation: {{value}}': 'CO₂ compensation: {{value}}',
  'Bio fuel: {{value}}': 'Bio fuel: {{value}}',
  Remove: 'Remove',
  'Payment reference': 'Payment reference',
  'Use the details below to transfer the outstanding balance. Always include the reference so we can match your payment to the correct order.':
    'Use the details below to transfer the outstanding balance. Always include the reference so we can match your payment to the correct order.',
  'Got it': 'Got it',
  'Copied!': 'Copied!',
  Copy: 'Copy',
  'Copy {{label}}': 'Copy {{label}}',
  'Open navigation menu': 'Open navigation menu',
  'Open menu': 'Open menu',
  'System ID': 'System ID',
  'Human ID': 'Human ID',
  'Client Price': 'Client Price',
  'Partner Price': 'Partner Price',
  'View Details': 'View Details',
  'Cancel Booking': 'Cancel Booking',
  'Mark as Paid': 'Mark as Paid',
  'Mark booking as paid?': 'Mark booking as paid?',
  'This will mark the booking as paid. Continue?':
    'This will mark the booking as paid. Continue?',
  'Cancel booking?': 'Cancel booking?',
  'This action cannot be undone': 'This action cannot be undone',
  'Keep Booking': 'Keep Booking',
  'Yes, Cancel': 'Yes, Cancel',
  'Failed to load owner information': 'Failed to load owner information',
  'Unexpected error': 'Unexpected error',
  'Booking marked as paid successfully!':
    'Booking marked as paid successfully!',
  'Failed to mark booking as paid': 'Failed to mark booking as paid',
  'Booking canceled successfully!': 'Booking canceled successfully!',
  'Failed to cancel booking': 'Failed to cancel booking',
  'Review Unpaid Bookings': 'Review Unpaid Bookings',
  'Manage All Trucks': 'Manage All Trucks',
  'Monitor every booking with the same clarity as the New Order wizard. Filter by lane, status, or time window and jump into the details faster.':
    'Monitor every booking with the same clarity as the New Order wizard. Filter by lane, status, or time window and jump into the details faster.',
  'Open filters': 'Open filters',
  'Orders refresh automatically every 5 minutes.':
    'Orders refresh automatically every 5 minutes.',
  'Refresh now': 'Refresh now',
  'Filter orders': 'Filter orders',
  'No orders match your filter.': 'No orders match your filter.',
  'Error fetching data': 'Error fetching data',
  'Not set': 'Not set',
  ETA: 'ETA',
  'Add to watchlist': 'Add to watchlist',
  'Remove from watchlist': 'Remove from watchlist',
  'Open map': 'Open map',
  'Pick up': 'Pick up',
  'Opening hours': 'Opening hours',
  'Route map': 'Route map',
  'No opening hours provided': 'No opening hours provided',
  'Arrival Date': 'Arrival Date',
  'Pickup Date': 'Pickup Date',
  Point: 'Point',
  Country: 'Country',
  Location: 'Location',
  'Current price': 'Current price',
  Distance: 'Distance',
  Estimated: 'Estimated',
  Accept: 'Accept',
  Autobid: 'Autobid',
  'Set Autobid': 'Set Autobid',
  'Maximum price': 'Maximum price',
  'e.g. 200': 'e.g. 200',
  Save: 'Save',
  'Select Planned Date': 'Select Planned Date',
  'Select Truck and Driver': 'Select Truck and Driver',
  'Please select a planned date': 'Please select a planned date',
  'Please select a driver and truck': 'Please select a driver and truck',
  'Order accepted for {{date}}': 'Order accepted for {{date}}',
  'Failed to accept': 'Failed to accept',
  'booking.go_to_profile': 'Go to Profile',
  'booking.purchase_terms_label': 'Purchase terms',
  'booking.click_to_download_purchase_terms':
    'Click to download Purchase Terms',
  'booking.download_purchase_terms_caption':
    'Download and review the active purchase terms in your current interface language before continuing.',
  'booking.accept_contract_checkbox':
    'We make agreements and conclude a contract for the carriage of goods. I have just read this agreement in full and agree to its contents.',
  'booking.confirm_schedule_24h_checkbox':
    'I confirm that I will schedule this order within 24 hours',
  'booking.failed_to_load_purchase_terms_document':
    'Failed to load purchase terms document.',
  'admin.purchase_terms_management': 'Purchase Terms Management',
  'admin.purchase_terms_management_subtitle':
    'Upload and maintain localized Purchase Terms PDFs used in partner order acceptance.',
  'admin.document_language': 'Document language',
  'admin.click_to_download_purchase_terms': 'Click to download Purchase Terms',
  'admin.current_language_label': 'Current language: {{language}}',
  'admin.purchase_terms_unavailable_for_selected_language':
    'Purchase terms document is unavailable for the selected language.',
  'Click to download Purchase Terms': 'Click to download Purchase Terms',
  'Download and review the active purchase terms in your current interface language before continuing.':
    'Download and review the active purchase terms in your current interface language before continuing.',
  'We make agreements and conclude a contract for the carriage of goods. I have just read this agreement in full and agree to its contents.':
    'We make agreements and conclude a contract for the carriage of goods. I have just read this agreement in full and agree to its contents.',
  'I confirm that I will schedule this order within 24 hours':
    'I confirm that I will schedule this order within 24 hours',
  'Failed to load purchase terms document.':
    'Failed to load purchase terms document.',
  'Purchase terms document is unavailable for the selected language.':
    'Purchase terms document is unavailable for the selected language.',
  'Document language': 'Document language',
  'Current language: {{language}}': 'Current language: {{language}}',
  'Upload and maintain localized Purchase Terms PDFs used in partner order acceptance.':
    'Upload and maintain localized Purchase Terms PDFs used in partner order acceptance.',
  'Autobid set up to {{price}}': 'Autobid set up to {{price}}',
  'Select a Truck': 'Select a Truck',
  'Select a Trailer': 'Select a Trailer',
  'Select a Driver': 'Select a Driver',

  All: 'All',
  'Search by ID, ref, city...': 'Search by ID, ref, city...',
  'Pick up country': 'Pick up country',
  'Pick up city': 'Pick up city',
  'Delivery country': 'Delivery country',
  'Delivery city': 'Delivery city',
  'Min cars': 'Min cars',
  'Max cars': 'Max cars',
  'Loading notification': 'Loading notification',
  Email: 'Email',
  SMS: 'SMS',
  'Favorite routes stay saved for quick access.':
    'Favorite routes stay saved for quick access.',
  'Apply filters': 'Apply filters',
  Clear: 'Clear',
  'Save preset': 'Save preset',
  'Saved favorite route filter': 'Saved favorite route filter',
  km: 'km',
  mi: 'mi',
  'Radius search': 'Radius search',
  'City or town': 'City or town',
  'Country (optional)': 'Country (optional)',
  Radius: 'Radius',
  Search: 'Search',
  'Searching\u2026': 'Searching\u2026',
  'City not found': 'City not found',
  'Within {{radius}} {{unit}} of {{place}}':
    'Within {{radius}} {{unit}} of {{place}}',
  'Clear radius': 'Clear radius',
  '{{amount}} above the client target': '{{amount}} above the client target',
  '{{amount}} below the client target': '{{amount}} below the client target',
  '{{count}} image(s) added to the listing.':
    '{{count}} image(s) added to the listing.',
  '{{count}} quote(s) received': '{{count}} quote(s) received',
  '{{count}} reviews': '{{count}} reviews',
  '{{count}} total': '{{count}} total',
  '{{count}} visible': '{{count}} visible',
  '{{weight}} kg': '{{weight}} kg',
  'A Google route preview with pins A and B appears here once pickup and delivery coordinates are available.':
    'A Google route preview with pins A and B appears here once pickup and delivery coordinates are available.',
  'A route preview appears once map coordinates are available.':
    'A route preview appears once map coordinates are available.',
  'A timeline of clarifications connected to this listing.':
    'A timeline of clarifications connected to this listing.',
  "Accept {{partner}}'s quote for {{amount}}?":
    "Accept {{partner}}'s quote for {{amount}}?",
  'Accept Listing': 'Accept Listing',
  'Accept quote': 'Accept quote',
  'Accepted quote': 'Accepted quote',
  'Accepted quote required': 'Accepted quote required',
  'Accepting...': 'Accepting...',
  Active: 'Active',
  'Active statuses': 'Active statuses',
  'Add another item': 'Add another item',
  'Add images': 'Add images',
  'Add more shipment images': 'Add more shipment images',
  'After you confirm an AI action, open the prepared destination immediately instead of waiting for a manual click.':
    'After you confirm an AI action, open the prepared destination immediately instead of waiting for a manual click.',
  'AI Assistant': 'AI Assistant',
  'AI assistant disabled for all users.':
    'AI assistant disabled for all users.',
  'AI assistant enabled for all users.': 'AI assistant enabled for all users.',
  'AI assistant preferences updated': 'AI assistant preferences updated',
  'AI disabled for user.': 'AI disabled for user.',
  'AI enabled for user.': 'AI enabled for user.',
  'AI-powered message translation between languages':
    'AI-powered message translation between languages',
  'All route-critical information in one place before you review quotes or documents.':
    'All route-critical information in one place before you review quotes or documents.',
  View: 'View',
  Answer: 'Answer',
  Archive: 'Archive',
  'Archived statuses': 'Archived statuses',
  'Are you sure you want to reject the quote from':
    'Are you sure you want to reject the quote from',
  'Ask a question about this listing...':
    'Ask a question about this listing...',
  'Ask for matching lanes, quote help, or the next operational step.':
    'Ask for matching lanes, quote help, or the next operational step.',
  'Ask for quote comparisons or a prepared next step from this shipment screen.':
    'Ask for quote comparisons or a prepared next step from this shipment screen.',
  'Assistant history cleared': 'Assistant history cleared',
  'Automatically translate messages from other users into your preferred language using AI.':
    'Automatically translate messages from other users into your preferred language using AI.',
  'Back to listing': 'Back to listing',
  'Best offer': 'Best offer',
  'Best quote': 'Best quote',
  'Body type: {{type}}': 'Body type: {{type}}',
  'Breed: {{breed}}': 'Breed: {{breed}}',
  Budget: 'Budget',
  'Cancel listing': 'Cancel listing',
  'Canceled and completed work will appear here once listings move out of the active view.':
    'Canceled and completed work will appear here once listings move out of the active view.',
  'Cargo Details': 'Cargo Details',
  Categories: 'Categories',
  'Choose the interface language. This preference is saved locally and applies immediately.':
    'Choose the interface language. This preference is saved locally and applies immediately.',
  'Clear all': 'Clear all',
  'Clear assistant history': 'Clear assistant history',
  'Client price in EUR': 'Client price in EUR',
  'Client target price': 'Client target price',
  'Complete the payment below to lock the fixed-price acceptance and let the partner start planning.':
    'Complete the payment below to lock the fixed-price acceptance and let the partner start planning.',
  'Complete the payment below to lock the selected quote and let the partner start planning.':
    'Complete the payment below to lock the selected quote and let the partner start planning.',
  'Compose area prepared for listing Q&A. Submission remains disabled until the live question endpoint is connected on this page.':
    'Compose area prepared for listing Q&A. Submission remains disabled until the live question endpoint is connected on this page.',
  'Confirm delivery complete': 'Confirm delivery complete',
  'Confirm payment received': 'Confirm payment received',
  'Confirm that you have received the bank transfer or payment for this listing. This will move the listing to Paid status and allow the partner to mark it as planned.':
    'Confirm that you have received the bank transfer or payment for this listing. This will move the listing to Paid status and allow the partner to mark it as planned.',
  'Confirm the exact fleet and dates before the listing moves to Planned.':
    'Confirm the exact fleet and dates before the listing moves to Planned.',
  'Confirm Transport Plan': 'Confirm Transport Plan',
  'Confirming...': 'Confirming...',
  'Control how the web assistant behaves on this device. These settings do not change your account data.':
    'Control how the web assistant behaves on this device. These settings do not change your account data.',
  'Create listing': 'Create listing',
  'Create with AI': 'Create with AI',
  'Create your next transport request and it will appear here with route, item, and quote activity.':
    'Create your next transport request and it will appear here with route, item, and quote activity.',
  'Current stage:': 'Current stage:',
  'Current status': 'Current status',
  'Delivery confirmation needed': 'Delivery confirmation needed',
  'Delivery radius': 'Delivery radius',
  'Delivery:': 'Delivery:',
  'Describe the route and cargo, then review the prepared listing draft before publishing.':
    'Describe the route and cargo, then review the prepared listing draft before publishing.',
  'Describe the shipment you need and review the prepared request before publishing.':
    'Describe the shipment you need and review the prepared request before publishing.',
  'Download and review the purchase terms before confirming the transport plan.':
    'Download and review the purchase terms before confirming the transport plan.',
  'Download invoice': 'Download invoice',
  'Download Purchase Terms': 'Download Purchase Terms',
  'Draft with AI': 'Draft with AI',
  'Draft your review first, then submit it here when you are satisfied.':
    'Draft your review first, then submit it here when you are satisfied.',
  'Edit listing': 'Edit listing',
  'Edit Quote': 'Edit Quote',
  Enable: 'Enable',
  'Enable live translation': 'Enable live translation',
  'Enabled Users': 'Enabled Users',
  'Engagement Activity': 'Engagement Activity',
  'Expires:': 'Expires:',
  'Failed to accept listing': 'Failed to accept listing',
  'Failed to accept quote': 'Failed to accept quote',
  'Failed to clear assistant history': 'Failed to clear assistant history',
  'Failed to complete listing': 'Failed to complete listing',
  'Failed to confirm payment': 'Failed to confirm payment',
  'Failed to confirm transport plan': 'Failed to confirm transport plan',
  'Failed to disable AI for user.': 'Failed to disable AI for user.',
  'Failed to enable AI for user.': 'Failed to enable AI for user.',
  'Failed to load listing.': 'Failed to load listing.',
  'Failed to load listings': 'Failed to load listings',
  'Failed to load listings. Please try again.':
    'Failed to load listings. Please try again.',
  'Failed to load review context.': 'Failed to load review context.',
  'Failed to load settings.': 'Failed to load settings.',
  'Failed to refresh Stripe payment status':
    'Failed to refresh Stripe payment status',
  'Failed to reject quote': 'Failed to reject quote',
  'Failed to release listing': 'Failed to release listing',
  'Failed to save quote': 'Failed to save quote',
  'Failed to update listing': 'Failed to update listing',
  'Failed to update preferred language': 'Failed to update preferred language',
  'Failed to update setting.': 'Failed to update setting.',
  'Failed to update status': 'Failed to update status',
  'Failed to update translation preference':
    'Failed to update translation preference',
  'Failed to update watchlist': 'Failed to update watchlist',
  'Failed to withdraw quote': 'Failed to withdraw quote',
  'Feature Flags': 'Feature Flags',
  'Filter invoice uploads, search by reference, and page through payout records.':
    'Filter invoice uploads, search by reference, and page through payout records.',
  Filters: 'Filters',
  'Final delivery documents': 'Final delivery documents',
  'Fixed price only': 'Fixed price only',
  'Flexible / not set': 'Flexible / not set',
  'Generated automatically when the transport plan is confirmed.':
    'Generated automatically when the transport plan is confirmed.',
  'Generation: {{generation}}': 'Generation: {{generation}}',
  'Goods delivered — awaiting client confirmation.':
    'Goods delivered — awaiting client confirmation.',
  'Gross price': 'Gross price',
  'I have read and agree to the purchase terms for this transport job.':
    'I have read and agree to the purchase terms for this transport job.',
  'I understand that accepting this listing assigns it to me at the fixed client price shown above.':
    'I understand that accepting this listing assigns it to me at the fixed client price shown above.',
  'Image upload failed': 'Image upload failed',
  'Images uploaded': 'Images uploaded',
  'Interface language': 'Interface language',
  'Invoice documents': 'Invoice documents',
  'Item {{number}}': 'Item {{number}}',
  items: 'items',
  'Keep listing': 'Keep listing',
  'Keep quote': 'Keep quote',
  'Keep the current AI session available after closing the browser on this device.':
    'Keep the current AI session available after closing the browser on this device.',
  'Language & Region': 'Language & Region',
  'Lift: {{origin}} / {{destination}}': 'Lift: {{origin}} / {{destination}}',
  Listed: 'Listed',
  'Listing {{id}}': 'Listing {{id}}',
  'Listing accepted': 'Listing accepted',
  'Listing expired': 'Listing expired',
  'Listing images': 'Listing images',
  'Listing is live': 'Listing is live',
  'Listing reference': 'Listing reference',
  'Listing snapshot': 'Listing snapshot',
  'Listing unavailable': 'Listing unavailable',
  'Listing updated': 'Listing updated',
  'Live Translation': 'Live Translation',
  'Live translation disabled.': 'Live translation disabled.',
  'Live translation enabled.': 'Live translation enabled.',
  'Loading approved trucks...': 'Loading approved trucks...',
  'Loading fleet...': 'Loading fleet...',
  'Loading listing details...': 'Loading listing details...',
  'Loading listings...': 'Loading listings...',
  'Loading review details...': 'Loading review details...',
  'Loading settings...': 'Loading settings...',
  'Manage AI Assistant Users': 'Manage AI Assistant Users',
  'Manage platform-wide feature flags and configuration.':
    'Manage platform-wide feature flags and configuration.',
  'Manage Users': 'Manage Users',
  'Manage your transport requests, monitor quote activity, and keep active and archived work easy to scan.':
    'Manage your transport requests, monitor quote activity, and keep active and archived work easy to scan.',
  'Mark Picked Up': 'Mark Picked Up',
  'Matches the client target price': 'Matches the client target price',
  Media: 'Media',
  Messages: 'Messages',
  'Messages will be translated into this language.':
    'Messages will be translated into this language.',
  'Minimum net:': 'Minimum net:',
  'My invoices': 'My invoices',
  Net: 'Net',
  'Net price': 'Net price',
  'Net quote': 'Net quote',
  'New images appear immediately in the listing details for client, partner, and admin views.':
    'New images appear immediately in the listing details for client, partner, and admin views.',
  'Next step': 'Next step',
  'No active listings yet': 'No active listings yet',
  'No address provided': 'No address provided',
  'No answer yet.': 'No answer yet.',
  'No archived listings yet': 'No archived listings yet',
  'No description added.': 'No description added.',
  'no destination': 'no destination',
  'No expiry': 'No expiry',
  'No listings match the current filters. Try broadening the search or date range.':
    'No listings match the current filters. Try broadening the search or date range.',
  'no origin': 'no origin',
  'No questions yet': 'No questions yet',
  'No quotes yet': 'No quotes yet',
  'No shipment images uploaded yet.': 'No shipment images uploaded yet.',
  'No trailer selected': 'No trailer selected',
  'No unread messages': 'No unread messages',
  'No users found.': 'No users found.',
  'No users have AI enabled.': 'No users have AI enabled.',
  'Not selected': 'Not selected',
  'Offers summary': 'Offers summary',
  'Open AI assistant': 'Open AI assistant',
  'Open prepared screens automatically': 'Open prepared screens automatically',
  'Optional visible price shown to partners as your target budget.':
    'Optional visible price shown to partners as your target budget.',
  'Other quotes will be declined automatically once this offer is accepted.':
    'Other quotes will be declined automatically once this offer is accepted.',
  'Partner delivery': 'Partner delivery',
  'Partner pickup': 'Partner pickup',
  'Partner quote': 'Partner quote',
  'Payment confirmed': 'Payment confirmed',
  'Payment confirmed — listing status set to paid':
    'Payment confirmed — listing status set to paid',
  'Payment confirmed. Confirm the assigned fleet and planned dates before the listing moves to Planned.':
    'Payment confirmed. Confirm the assigned fleet and planned dates before the listing moves to Planned.',
  'Payment is confirmed. The partner now needs to confirm the truck, driver, and planned dates.':
    'Payment is confirmed. The partner now needs to confirm the truck, driver, and planned dates.',
  'Payment required': 'Payment required',
  'Photos uploaded for the shipment and visible across client, partner, and admin views.':
    'Photos uploaded for the shipment and visible across client, partner, and admin views.',
  'Pickup is complete and the transport is currently underway.':
    'Pickup is complete and the transport is currently underway.',
  'Pickup proof': 'Pickup proof',
  'Pickup proof and final delivery files uploaded by the transport partner.':
    'Pickup proof and final delivery files uploaded by the transport partner.',
  'Pickup to delivery overview': 'Pickup to delivery overview',
  'Pickup:': 'Pickup:',
  'Plan and authorization': 'Plan and authorization',
  'Plan transport': 'Plan transport',
  'Plan Transport': 'Plan Transport',
  'Planned dates:': 'Planned dates:',
  'Planned delivery date': 'Planned delivery date',
  'Platform Settings': 'Platform Settings',
  'Preferred language': 'Preferred language',
  'Preferred language updated': 'Preferred language updated',
  'Prepare a quote or ask for the next lane action, then confirm before anything is submitted.':
    'Prepare a quote or ask for the next lane action, then confirm before anything is submitted.',
  'Purchase Terms': 'Purchase Terms',
  'Quantities, dimensions, and handling details ready for transport review.':
    'Quantities, dimensions, and handling details ready for transport review.',
  Question: 'Question',
  Questions: 'Questions',
  'Questions & answers': 'Questions & answers',
  'Questions and answers for this listing will appear here once the messaging flow is active.':
    'Questions and answers for this listing will appear here once the messaging flow is active.',
  'Quick access to the current shipment, quote, and billing state.':
    'Quick access to the current shipment, quote, and billing state.',
  'Quote accepted': 'Quote accepted',
  'Quote count': 'Quote count',
  'Quote message': 'Quote message',
  'Quote rejected': 'Quote rejected',
  'Quote withdrawn': 'Quote withdrawn',
  Quotes: 'Quotes',
  'Quotes and questions': 'Quotes and questions',
  'Quotes are disabled for this listing. The first partner to accept the fixed price will be assigned automatically.':
    'Quotes are disabled for this listing. The first partner to accept the fixed price will be assigned automatically.',
  'Quotes are disabled for this shipment. If you accept it, the client price becomes an accepted booking immediately.':
    'Quotes are disabled for this shipment. If you accept it, the client price becomes an accepted booking immediately.',
  'Quotes from transport providers usually begin to appear shortly after publishing. Refresh to check again.':
    'Quotes from transport providers usually begin to appear shortly after publishing. Refresh to check again.',
  'Reference #{{id}}': 'Reference #{{id}}',
  'Refresh listings': 'Refresh listings',
  'Reject quote': 'Reject quote',
  'Rejecting...': 'Rejecting...',
  Release: 'Release',
  'Release Listing': 'Release Listing',
  'Remember assistant conversation': 'Remember assistant conversation',
  'Required for fixed-price listings. Partners accept this amount directly.':
    'Required for fixed-price listings. Partners accept this amount directly.',
  'Required. Partners will be able to accept this listing at the fixed client price without sending a quote.':
    'Required. Partners will be able to accept this listing at the fixed client price without sending a quote.',
  'Review submission failed.': 'Review submission failed.',
  'Review the completed transport using the standard product flow.':
    'Review the completed transport using the standard product flow.',
  'Route pending': 'Route pending',
  'Save changes': 'Save changes',
  'Saving...': 'Saving...',
  'Search by title, route, category, or item':
    'Search by title, route, category, or item',
  'Search Results': 'Search Results',
  'Search users by email...': 'Search users by email...',
  'Select a truck, driver, pickup date, and delivery date.':
    'Select a truck, driver, pickup date, and delivery date.',
  'Select approved truck': 'Select approved truck',
  'Select driver': 'Select driver',
  'Send Revision': 'Send Revision',
  Sentiment: 'Sentiment',
  'Share what went well and what could improve':
    'Share what went well and what could improve',
  'Shipment in transit': 'Shipment in transit',
  'Shipment notes': 'Shipment notes',
  'Shipment tracking will be shared': 'Shipment tracking will be shared',
  'Show AI launchers': 'Show AI launchers',
  'Show or hide AI assistant buttons on supported dashboard and listing pages.':
    'Show or hide AI assistant buttons on supported dashboard and listing pages.',
  'Special needs or notes': 'Special needs or notes',
  'Specify delivery dates': 'Specify delivery dates',
  'Specify pickup dates': 'Specify pickup dates',
  Stage: 'Stage',
  'Status updated to {{status}}': 'Status updated to {{status}}',
  'Stripe payment confirmed and booking updated':
    'Stripe payment confirmed and booking updated',
  'Stripe status: {{status}}': 'Stripe status: {{status}}',
  'Submit question': 'Submit question',
  'Submit review': 'Submit review',
  'Submitting...': 'Submitting...',
  'The AI assistant is currently disabled for this environment. Existing local session data can still be cleared here.':
    'The AI assistant is currently disabled for this environment. Existing local session data can still be cleared here.',
  'The listing expired before a transport was confirmed.':
    'The listing expired before a transport was confirmed.',
  'The listing has been fully completed and archived as a finished transport.':
    'The listing has been fully completed and archived as a finished transport.',
  'The lowest net price you would still accept for this shipment.':
    'The lowest net price you would still accept for this shipment.',
  'The partner has confirmed the route plan. Pickup and delivery dates are now scheduled.':
    'The partner has confirmed the route plan. Pickup and delivery dates are now scheduled.',
  'The partner marked the shipment as delivered. Review the final documents and confirm completion.':
    'The partner marked the shipment as delivered. Review the final documents and confirm completion.',
  'The partner-confirmed plan and LOA stay grouped together for faster review.':
    'The partner-confirmed plan and LOA stay grouped together for faster review.',
  'This action notifies the transport provider and removes the quote from active consideration.':
    'This action notifies the transport provider and removes the quote from active consideration.',
  'This listing is archived and no further transport actions are available.':
    'This listing is archived and no further transport actions are available.',
  'This listing needs an accepted quote before a review can be created.':
    'This listing needs an accepted quote before a review can be created.',
  'This will soft-cancel the listing and move it to your archive.':
    'This will soft-cancel the listing and move it to your archive.',
  'This will soft-cancel the listing for the client and remove it from active marketplace views.':
    'This will soft-cancel the listing for the client and remove it from active marketplace views.',
  'Total quote': 'Total quote',
  'Tracking not promised': 'Tracking not promised',
  'Tracking shared': 'Tracking shared',
  'Tracking visibility': 'Tracking visibility',
  'Trailer (Optional)': 'Trailer (Optional)',
  'Translation preference updated': 'Translation preference updated',
  'Transport completed': 'Transport completed',
  'Transport completed.': 'Transport completed.',
  'Transport documents': 'Transport documents',
  'Transport marked as complete': 'Transport marked as complete',
  'Transport package': 'Transport package',
  'Transport plan confirmed': 'Transport plan confirmed',
  'Transport plan updated': 'Transport plan updated',
  'Transport planned': 'Transport planned',
  'Transport Provider': 'Transport Provider',
  'Transport providers can review your shipment and send offers.':
    'Transport providers can review your shipment and send offers.',
  'Transport stage': 'Transport stage',
  Truck: 'Truck',
  'Truck, driver, trailer, and planned dates for this shipment.':
    'Truck, driver, trailer, and planned dates for this shipment.',
  'Try widening the current listing filters.':
    'Try widening the current listing filters.',
  'Unable to upload listing images.': 'Unable to upload listing images.',
  'Unknown error': 'Unknown error',
  'Untitled listing': 'Untitled listing',
  'Untitled Listing': 'Untitled Listing',
  'Update media': 'Update media',
  'Update transport plan': 'Update transport plan',
  'Update Transport Plan': 'Update Transport Plan',
  'Upload a CMR or delivery photos before marking delivered.':
    'Upload a CMR or delivery photos before marking delivered.',
  'Upload a CMR or delivery photos before the listing can move to Delivered.':
    'Upload a CMR or delivery photos before the listing can move to Delivered.',
  'Upload at least one pickup proof before the listing can move to Picked Up.':
    'Upload at least one pickup proof before the listing can move to Picked Up.',
  'Upload final documents': 'Upload final documents',
  'Upload proof of pickup': 'Upload proof of pickup',
  'Uploading...': 'Uploading...',
  'Use fresh photos when the shipment changes or you want to clarify the item condition.':
    'Use fresh photos when the shipment changes or you want to clarify the item condition.',
  'users enabled': 'users enabled',
  VAT: 'VAT',
  'Visible to you while quoting. You can still send your own net offer below or above this amount.':
    'Visible to you while quoting. You can still send your own net offer below or above this amount.',
  'Waiting for partner acceptance': 'Waiting for partner acceptance',
  'Waiting for transport planning': 'Waiting for transport planning',
  'When enabled, messages from other users will be automatically translated to your preferred language.':
    'When enabled, messages from other users will be automatically translated to your preferred language.',
  Withdraw: 'Withdraw',
  'Write Review': 'Write Review',
  'You are about to release this listing back to the marketplace.':
    'You are about to release this listing back to the marketplace.',
  'You are now the assigned partner for this fixed-price listing.':
    'You are now the assigned partner for this fixed-price listing.',
  'Your quote has been accepted. Awaiting payment confirmation from the admin before you can begin the job.':
    'Your quote has been accepted. Awaiting payment confirmation from the admin before you can begin the job.',
};

const sharedTranslations = {
  'auth.logiflow_platform': {
    en: 'LogiFlow Platform',
    bg: 'Платформа LogiFlow',
    de: 'LogiFlow-Plattform',
    fr: 'Plateforme LogiFlow',
    ro: 'Platforma LogiFlow',
    tr: 'LogiFlow Platformu',
    sr: 'LogiFlow платформа',
    mk: 'Платформа LogiFlow',
    hu: 'LogiFlow platform',
    sk: 'Platforma LogiFlow',
    sl: 'Platforma LogiFlow',
    es: 'Plataforma LogiFlow',
    fi: 'LogiFlow-alusta',
    el: 'Πλατφόρμα LogiFlow',
  },
  'auth.one_step_away_heading': {
    en: 'One step away',
    bg: 'Една стъпка разстояние',
    de: 'Nur noch ein Schritt',
    fr: "Plus qu'une étape",
    ro: 'La un singur pas distanță',
    tr: 'Son bir adım',
    sr: 'Још један корак',
    mk: 'Уште еден чекор',
    hu: 'Egy lépésre a céltól',
    sk: 'Iba jeden krok',
    sl: 'Le še korak',
    es: 'A un paso de distancia',
    fi: 'Vain yksi vaihe jäljellä',
    el: 'Ένα βήμα μακριά',
  },
  'auth.verify_email_subline': {
    en: 'Please verify your email address to access your account.',
    bg: 'Моля, потвърдете имейл адреса си, за да достъпите акаунта си.',
    de: 'Bitte bestätigen Sie Ihre E-Mail-Adresse, um auf Ihr Konto zuzugreifen.',
    fr: 'Veuillez vérifier votre adresse e-mail pour accéder à votre compte.',
    ro: 'Vă rugăm să vă verificați adresa de e-mail pentru a vă accesa contul.',
    tr: 'Hesabınıza erişmek için lütfen e-posta adresinizi doğrulayın.',
    sr: 'Молимо потврдите своју адресу е-поште да бисте приступили свом налогу.',
    mk: 'Ве молиме потврдете ја вашата е-пошта за да пристапите до вашата сметка.',
    hu: 'Kérjük, igazolja vissza e-mail címét a fiókja eléréséhez.',
    sk: 'Na prístup k účtu overte svoju e-mailovú adresu.',
    sl: 'Za dostop do računa potrdite svoj e-poštni naslov.',
    es: 'Verifique su dirección de correo electrónico para acceder a su cuenta.',
    fi: 'Vahvista sähköpostiosoitteesi päästäksesi tilillesi.',
    el: 'Παρακαλούμε επαληθεύστε τη διεύθυνση email σας για να αποκτήσετε πρόσβαση στον λογαριασμό σας.',
  },
  'auth.save_record_before_upload': {
    en: 'Save this record before uploading documents.',
    bg: 'Запазете записа, преди да качите документи.',
    de: 'Speichern Sie den Datensatz, bevor Sie Dokumente hochladen.',
    fr: "Enregistrez l'enregistrement avant de télécharger des documents.",
    ro: 'Salvați înregistrarea înainte de a încărca documente.',
    tr: 'Belgeleri yüklemeden önce kaydı kaydedin.',
    sr: 'Сачувајте запис пре отпремања докумената.',
    mk: 'Зачувајте го записот пред да поставувате документи.',
    hu: 'Mentse a rekordot dokumentumok feltöltése előtt.',
    sk: 'Pred nahrávaním dokumentov záznam uložte.',
    sl: 'Pred nalaganjem dokumentov shranite zapis.',
    es: 'Guarde el registro antes de subir documentos.',
    fi: 'Tallenna tietue ennen asiakirjojen lataamista.',
    el: 'Αποθηκεύστε αυτή την εγγραφή πριν ανεβάσετε έγγραφα.',
  },
  'auth.upload': {
    en: 'Upload',
    bg: 'Качване',
    de: 'Hochladen',
    fr: 'Télécharger',
    ro: 'Încărcare',
    tr: 'Yükle',
    sr: 'Отпреми',
    mk: 'Постави',
    hu: 'Feltöltés',
    sk: 'Nahrať',
    sl: 'Naloži',
    es: 'Subir',
    fi: 'Lataa',
    el: 'Μεταφόρτωση',
  },
  'auth.choose_file': {
    en: 'Choose file',
    bg: 'Избор на файл',
    de: 'Datei auswählen',
    fr: 'Choisir un fichier',
    ro: 'Alege fișierul',
    tr: 'Dosya seç',
    sr: 'Изабери датотеку',
    mk: 'Избери документ',
    hu: 'Fájl kiválasztása',
    sk: 'Vybrať súbor',
    sl: 'Izberi datoteko',
    es: 'Elegir archivo',
    fi: 'Valitse tiedosto',
    el: 'Επιλογή αρχείου',
  },
  'auth.choose_files': {
    en: 'Choose files',
    bg: 'Избор на файлове',
    de: 'Dateien auswählen',
    fr: 'Choisir des fichiers',
    ro: 'Alege fișierele',
    tr: 'Dosyaları seç',
    sr: 'Изабери датотеке',
    mk: 'Избери документи',
    hu: 'Fájlok kiválasztása',
    sk: 'Vybrať súbory',
    sl: 'Izberi datoteke',
    es: 'Elegir archivos',
    fi: 'Valitse tiedostot',
    el: 'Επιλέξτε αρχεία',
  },
  'auth.selected_files': {
    en: 'Selected files:',
    bg: 'Избрани файлове:',
    de: 'Ausgewählte Dateien:',
    fr: 'Fichiers sélectionnés :',
    ro: 'Fișiere selectate:',
    tr: 'Seçilen dosyalar:',
    sr: 'Изабране датотеке:',
    mk: 'Избрани документи:',
    hu: 'Kiválasztott fájlok:',
    sk: 'Vybrané súbory:',
    sl: 'Izbrane datoteke:',
    es: 'Archivos seleccionados:',
    fi: 'Valitut tiedostot:',
    el: 'Επιλεγμένα αρχεία:',
  },
  'auth.status_label': {
    en: 'Status',
    bg: 'Статус',
    de: 'Status',
    fr: 'Statut',
    ro: 'Stare',
    tr: 'Durum',
    sr: 'Статус',
    mk: 'Статус',
    hu: 'Állapot',
    sk: 'Stav',
    sl: 'Status',
    es: 'Estado',
    fi: 'Tila',
  },
  'auth.no_documents_found': {
    en: 'No documents found.',
    bg: 'Няма намерени документи.',
    de: 'Keine Dokumente gefunden.',
    fr: 'Aucun document trouvé.',
    ro: 'Nu s-au găsit documente.',
    tr: 'Belge bulunamadı.',
    sr: 'Није пронађен ниједан документ.',
    mk: 'Не се пронајдени документи.',
    hu: 'Nem találhatók dokumentumok.',
    sk: 'Nenašli sa žiadne dokumenty.',
    sl: 'Dokumentov ni bilo mogoče najti.',
    es: 'No se encontraron documentos.',
    fi: 'Asiakirjoja ei löytynyt.',
    el: 'Δεν βρέθηκαν έγγραφα.',
  },
  'auth.files_stored_securely': {
    en: 'Your files are stored securely.',
    bg: 'Вашите файлове се съхраняват сигурно.',
    de: 'Ihre Dateien werden sicher gespeichert.',
    fr: 'Vos fichiers sont stockés en toute sécurité.',
    ro: 'Fișierele dvs. sunt stocate în siguranță.',
    tr: 'Dosyalarınız güvenli bir şekilde saklanır.',
    sr: 'Ваше датотеке се безбедно чувају.',
    mk: 'Вашите документи се безбедно складирани.',
    hu: 'Fájljai biztonságosan tárolva.',
    sk: 'Vaše súbory sú bezpečne uložené.',
    sl: 'Vaše datoteke so varno shranjene.',
    es: 'Sus archivos se almacenan de forma segura.',
    fi: 'Tiedostosi tallennetaan suojatusti.',
    el: 'Τα αρχεία σας αποθηκεύονται με ασφάλεια.',
  },
  'auth.supported_formats_max_size': {
    en: 'Supported: {{formats}} • Max 10MB',
    bg: 'Поддържани: {{formats}} • Макс. 10MB',
    de: 'Unterstützt: {{formats}} • Max. 10 MB',
    fr: 'Pris en charge : {{formats}} • Max 10 Mo',
    ro: 'Acceptat: {{formats}} • Max 10 MB',
    tr: 'Desteklenen: {{formats}} • Maks. 10MB',
    sr: 'Подржано: {{formats}} • Макс. 10MB',
    mk: 'Поддржано: {{formats}} • Макс. 10MB',
    hu: 'Támogatott: {{formats}} • Max. 10MB',
    sk: 'Podporované: {{formats}} • Max 10 MB',
    sl: 'Podprto: {{formats}} • Največ 10 MB',
    es: 'Soportado: {{formats}} • Máx. 10 MB',
    fi: 'Tuetut: {{formats}} • Enintään 10 Mt',
    el: 'Υποστηρίζεται: {{formats}} • Μέγιστο 10MB',
  },
  'auth.drag_and_drop_files_here': {
    en: 'Drag and drop files here',
    bg: 'Плъзнете и пуснете файлове тук',
    de: 'Dateien hierher ziehen und ablegen',
    fr: 'Glissez-posez vos fichiers ici',
    ro: 'Trageți și plasați fișierele aici',
    tr: 'Dosyaları buraya sürükleyip bırakın',
    sr: 'Превуците и пустите датотеке овде',
    mk: 'Превлечете ги документите тук',
    hu: 'Húzza ide a fájlokat',
    sk: 'Sem presuňte súbory',
    sl: 'Povlecite in spustite datoteke sem',
    es: 'Arrastre y suelte los archivos aquí',
    fi: 'Raahaa ja pudota tiedostot tähän',
    el: 'Σύρετε και αφήστε τα αρχεία εδώ',
  },
  'auth.upload_completed': {
    en: 'Upload completed',
    bg: 'Качването завърши',
    de: 'Upload abgeschlossen',
    fr: 'Téléchargement terminé',
    ro: 'Încărcare finalizată',
    tr: 'Yükleme tamamlandı',
    sr: 'Отпремање завршено',
    mk: 'Поставувањето завршено',
    hu: 'Feltöltés kész',
    sk: 'Nahranie dokončené',
    sl: 'Nalaganje končano',
    es: 'Subida completada',
    fi: 'Lataus valmis',
    el: 'Η μεταφόρτωση ολοκληρώθηκε',
  },
  'auth.confirming_upload': {
    en: 'Confirming upload...',
    bg: 'Потвърждаване на качването...',
    de: 'Upload wird bestätigt...',
    fr: 'Confirmation du téléchargement...',
    ro: 'Se confirmă încărcarea...',
    tr: 'Yükleme onaylanıyor...',
    sr: 'Потврда отпремања...',
    mk: 'Се потвръждава поставувањето...',
    hu: 'Feltöltés megerősítése...',
    sk: 'Potvrdzovanie nahrania...',
    sl: 'Potrjevanje nalaganja...',
    es: 'Confirmando subida...',
    fi: 'Vahvistetaan latausta...',
    el: 'Επιβεβαίωση μεταφόρτωσης...',
  },
  'auth.uploading_to_storage': {
    en: 'Uploading to storage...',
    bg: 'Качване в хранилището...',
    de: 'Wird in den Speicher hochgeladen...',
    fr: 'Téléchargement vers le stockage...',
    ro: 'Se încarcă în spațiul de stocare...',
    tr: 'Depolama birimine yükleniyor...',
    sr: 'Отпремање у складиште...',
    mk: 'Се поставува во складиште...',
    hu: 'Feltöltés a felhőbe...',
    sk: 'Nahrávanie do úložiska...',
    sl: 'Nalaganje v shrambo...',
    es: 'Subiendo al almacenamiento...',
    fi: 'Ladataan tallennustilaan...',
    el: 'Μεταφόρτωση στο χώρο αποθήκευσης...',
  },
  'auth.requesting_upload_url': {
    en: 'Requesting upload URL...',
    bg: 'Заявка за URL за качване...',
    de: 'Upload-URL wird angefordert...',
    fr: "Demande de l'URL de téléchargement...",
    ro: 'Se solicită URL-ul de încărcare...',
    tr: "Yükleme URL'si isteniyor...",
    sr: 'Захтевање URL-а за отпремање...',
    mk: 'Се бара адреса за поставување...',
    hu: 'Feltöltési URL kérése...',
    sk: 'Žiadosť o adresu URL na nahranie...',
    sl: 'Zahtevanje URL-ja za nalaganje...',
    es: 'Solicitando URL de subida...',
    fi: 'Pyydetään lataus-URL-osoitetta...',
    el: 'Αίτημα URL μεταφόρτωσης...',
  },
  'auth.ready_to_upload': {
    en: 'Ready to upload',
    bg: 'Готовност за качване',
    de: 'Bereit zum Hochladen',
    fr: 'Prêt à télécharger',
    ro: 'Gata de încărcare',
    tr: 'Yüklemeye hazır',
    sr: 'Спремно за отпремање',
    mk: 'Спремно за поставување',
    hu: 'Feltöltésre kész',
    sk: 'Pripravené na nahranie',
    sl: 'Pripravljeno na nalaganje',
    es: 'Listo para subir',
    fi: 'Valmis ladattavaksi',
    el: 'Έτοιμο για μεταφόρτωση',
  },
  'auth.account_status_pending_review': {
    en: 'Account status: Pending review',
    bg: 'Статус на акаунта: Предстои преглед',
    de: 'Kontostatus: Prüfung ausstehend',
    fr: 'Statut du compte : En attente de révision',
    ro: 'Stare cont: În așteptarea revizuirii',
    tr: 'Hesap durumu: İnceleme bekliyor',
    sr: 'Статус налога: Чека на преглед',
    mk: 'Статус на сметката: Чека преглед',
    hu: 'Fiók állapota: Ellenőrzés alatt',
    sk: 'Stav účtu: Čaká na kontrolu',
    sl: 'Status računa: Čaka na pregled',
    es: 'Estado de la cuenta: Pendiente de revisión',
    fi: 'Tilin tila: Odottaa tarkistusta',
    el: 'Κατάσταση λογαριασμού: Εκκρεμεί έλεγχος',
  },
  'auth.pending': {
    en: 'Pending',
    bg: 'В изчакване',
    de: 'Ausstehend',
    fr: 'En attente',
    ro: 'În așteptare',
    tr: 'Beklemede',
    sr: 'На чекању',
    mk: 'Во тек',
    hu: 'Függőben',
    sk: 'Čaká sa',
    sl: 'V teku',
    es: 'Pendiente',
    fi: 'Odottaa',
    el: 'Εκκρεμεί',
  },
  'auth.your_account_is_pending_approval': {
    en: 'Your account is pending approval',
    bg: 'Вашият акаунт очаква одобрение',
    de: 'Ihr Konto wartet auf die Genehmigung',
    fr: "Votre compte est en attente d'approbation",
    ro: 'Contul dumneavoastră este în așteptarea aprobării',
    tr: 'Hesabınız onay bekliyor',
    sr: 'Ваш налог чека на одобрење',
    mk: 'Вашата сметка чека одобрување',
    hu: 'A fiókja jóváhagyásra vár',
    sk: 'Váš účet čaká na schválenie',
    sl: 'Vaš račun čaka na odobritev',
    es: 'Su cuenta está pendiente de aprobación',
    fi: 'Tilisi odottaa hyväksyntää',
    el: 'Ο λογαριασμός σας εκκρεμεί έγκριση',
  },
  'auth.upload_your_verification_documents_below_and_we_ll_notify_you_by_email_once_your_account_is_approved':
    {
      en: "Upload your verification documents below and we'll notify you by email once your account is approved.",
      bg: 'Качете документите си за проверка по-долу и ще ви уведомим по имейл, след като акаунтът ви бъде одобрен.',
      de: 'Laden Sie unten Ihre Verifizierungsdokumente hoch und wir benachrichtigen Sie per E-Mail, sobald Ihr Konto genehmigt wurde.',
      fr: 'Téléchargez vos documents de vérification ci-dessous et nous vous informerons par e-mail une fois votre compte approuvé.',
      ro: 'Încărcați documentele de verificare mai jos și vă vom notifica prin e-mail odată ce contul dvs. este aprobat.',
      tr: 'Doğrulama belgelerinizi aşağıya yükleyin; hesabınız onaylandığında size e-posta ile haber vereceğiz.',
      sr: 'Отпремите своје документе за верификацију испод и обавестићемо вас путем е-поште када ваш налог буде одобрен.',
      mk: 'Поставете ги вашите документи за верификација подолу и ќе ве известиме преку е-пошта штом вашата сметка ќе биде одобрена.',
      hu: 'Töltse fel az ellenőrző dokumentumokat alább, és e-mailben értesítjük, amint fiókját jóváhagytuk.',
      sk: 'Nahrajte svoje overovacie dokumenty nižšie a po schválení vášho účtu vás budeme informovať e-mailom.',
      sl: 'Spodaj naložite svoje dokumente za preverjanje in o odobritvi računa vas bomo obvestili po e-pošti.',
      es: 'Suba sus documentos de verificación a continuación y le notificaremos por correo electrónico una vez que su cuenta sea aprobada.',
      fi: 'Lataa vahvistusasiakirjasi alta, ja ilmoitamme sinulle sähköpostitse, kun tilisi on hyväksytty.',
      el: 'Μεταφορτώστε τα έγγραφα επαλήθευσης παρακάτω και θα σας ειδοποιήσουμε μέσω email μόλις εγκριθεί ο λογαριασμός σας.',
    },
  'auth.check_status': {
    en: 'Check status',
    bg: 'Провери статус',
    de: 'Status prüfen',
    fr: 'Vérifier le statut',
    ro: 'Verifică starea',
    tr: 'Durumu kontrol et',
    sr: 'Провери статус',
    mk: 'Провери статус',
    hu: 'Állapot ellenőrzése',
    sk: 'Skontrolovať stav',
    sl: 'Preveri stanje',
    es: 'Comprobar estado',
    fi: 'Tarkista tila',
    el: 'Έλεγχος κατάστασης',
  },
  'auth.upload_verification_documents': {
    en: 'Upload verification documents',
    bg: 'Качване на документи за проверка',
    de: 'Verifizierungsdokumente hochladen',
    fr: 'Télécharger les documents de vérification',
    ro: 'Încărcați documentele de verificare',
    tr: 'Doğrulama belgelerini yükle',
    sr: 'Отпреми документе за верификацију',
    mk: 'Постави документи за верификација',
    hu: 'Ellenőrző dokumentumok feltöltése',
    sk: 'Nahrať overovacie dokumenty',
    sl: 'Naloži dokumente za preverjanje',
    es: 'Subir documentos de verificación',
    fi: 'Lataa vahvistusasiakirjat',
    el: 'Μεταφόρτωση εγγράφων επαλήθευσης',
  },
  'auth.after_uploading_support_staff_can_review_and_approve_your_account': {
    en: 'After uploading, support staff can review and approve your account.',
    bg: 'След качването поддръжката ще прегледа и одобри акаунта ви.',
    de: 'Nach dem Hochladen können die Support-Mitarbeiter Ihr Konto prüfen und genehmigen.',
    fr: "Après le téléchargement, l'équipe d'assistance pourra examiner et approuver votre compte.",
    ro: 'După încărcare, personalul de asistență poate revizui și aproba contul dvs.',
    tr: 'Yüklemeden sonra destek ekibi hesabınızı inceleyebilir ve onaylayabilir.',
    sr: 'Након отпремања, особље подршке може да прегледа и одобри ваш налог.',
    mk: 'По поставувањето, персоналот за поддршка може да ја прегледа и одобри вашата сметка.',
    hu: 'A feltöltés után az ügyfélszolgálat ellenőrizheti és jóváhagyhatja fiókját.',
    sk: 'Po nahraní môže podporný personál skontrolovať a schváliť váš účet.',
    sl: 'Po nalaganju lahko podporno osebje pregleda in odobri vaš račun.',
    es: 'Después de subirlos, el personal de soporte podrá revisar y aprobar su cuenta.',
    fi: 'Lataamisen jälkeen tukihenkilöstö voi tarkistaa ja hyväksyä tilisi.',
    el: 'Μετά τη μεταφόρτωση, το προσωπικό υποστήριξης μπορεί να ελέγξει και να εγκρίνει το λογαριασμό σας.',
  },
  'auth.your_uploaded_documents': {
    en: 'Your uploaded documents',
    bg: 'Вашите качени документи',
    de: 'Ihre hochgeladenen Dokumente',
    fr: 'Vos documents téléchargés',
    ro: 'Documentele dumneavoastră încărcate',
    tr: 'Yüklenen belgeleriniz',
    sr: 'Ваши отпремљени документи',
    mk: 'Вашите поставени документи',
    hu: 'Az Ön által feltöltött dokumentumok',
    sk: 'Vaše nahrané dokumenty',
    sl: 'Vaši naloženi dokumenti',
    es: 'Sus documentos subidos',
    fi: 'Lataamasi asiakirjat',
    el: 'Τα έγγραφα που μεταφορτώσατε',
  },
  'auth.back_to_sign_in': {
    en: 'Back to sign in',
    bg: 'Назад към влизане',
    de: 'Zurück zur Anmeldung',
    fr: 'Retour à la connexion',
    ro: 'Înapoi la autentificare',
    tr: 'Giriş yapmaya dön',
    sr: 'Назад на пријаву',
    mk: 'Назад кон најава',
    hu: 'Vissza a bejelentkezéshez',
    sk: 'Späť na prihlásenie',
    sl: 'Nazaj na prijavo',
    es: 'Volver a iniciar sesión',
    fi: 'Takaisin kirjautumiseen',
    el: 'Επιστροφή στη σύνδεση',
  },
  'auth.account_verification_badge': {
    en: 'Account Verification',
    bg: 'Проверка на акаунта',
    de: 'Kontoverifizierung',
    fr: 'Vérification du compte',
    ro: 'Verificarea contului',
    tr: 'Hesap Doğrulama',
    sr: 'Верификација налога',
    mk: 'Верификација на сметка',
    hu: 'Fiókhitelesítés',
    sk: 'Overenie účtu',
    sl: 'Preverjanje računa',
    es: 'Verificación de la cuenta',
    fi: 'Tilin vahvistus',
    el: 'Επαλήθευση Λογαριασμού',
  },
  'auth.documents_under_review_heading': {
    en: 'Your documents are under review',
    bg: 'Вашите документи се преглеждат',
    de: 'Ihre Dokumente werden geprüft',
    fr: "Vos documents sont en cours d'examen",
    ro: 'Documentele dumneavoastră sunt în curs de revizuire',
    tr: 'Belgeleriniz inceleniyor',
    sr: 'Ваши документи су на прегледу',
    mk: 'Вашите документи се прегледуваат',
    hu: 'Dokumentumai ellenőrzés alatt állnak',
    sk: 'Vaše dokumenty sa kontrolujú',
    sl: 'Vaši dokumenti so v pregledu',
    es: 'Sus documentos están bajo revisión',
    fi: 'Asiakirjasi ovat tarkistettavana',
    el: 'Τα έγγραφά σας τελούν υπό έλεγχο',
  },
  'auth.documents_under_review_subline': {
    en: 'Upload your verification documents and our team will approve your account shortly.',
    bg: 'Качете документите си за проверка и нашият екип скоро ще одобри акаунта ви.',
    de: 'Laden Sie Ihre Verifizierungsdokumente hoch und unser Team wird Ihr Konto in Kürze genehmigen.',
    fr: 'Téléchargez vos documents de vérification et notre équipe approuvera votre compte sous peu.',
    ro: 'Încărcați documentele de verificare și echipa noastră vă va aproba contul în curând.',
    tr: 'Doğrulama belgelerinizi yükleyin; ekibimiz hesabınızı kısa süre içinde onaylayacaktır.',
    sr: 'Отпремите своје документе за верификацију и наш тим ће ускоро одобрити ваш налог.',
    mk: 'Поставете ги вашите документи за верификација и нашиот тим набрзо ќе ја одобри вашата сметка.',
    hu: 'Töltse fel az ellenőrző dokumentumokat, és csapatunk hamarosan jóváhagyja fiókját.',
    sk: 'Nahrajte svoje overovacie dokumenty a náš tím váš účet čoskoro schváli.',
    sl: 'Naložite svoje dokumente za preverjanje in naša ekipa bo vaš račun kmalu odobrila.',
    es: 'Suba sus documentos de verificación y nuestro equipo aprobará su cuenta en breve.',
    fi: 'Lataa vahvistusasiakirjasi, ja tiimimme hyväksyy tilisi pian.',
    el: 'Μεταφορτώστε τα έγγραφα επαλήθευσης και η ομάδα μας θα εγκρίνει το λογαριασμό σας σύντομα.',
  },
  validationStatus_unpaid: {
    en: 'Unpaid',
    bg: 'Неплатен',
    de: 'Unbezahlt',
    fr: 'Non payé',
    ro: 'Neplătit',
    tr: 'Ödenmemiş',
    sr: 'Неплаћено',
    mk: 'Неплатено',
    hu: 'Kifizetetlen',
    sk: 'Nezaplatené',
    sl: 'Neplačano',
    es: 'No pagado',
    fi: 'Maksamaton',
    el: 'Απλήρωτο',
  },

  validationStatus_expired: {
    en: 'Expired',
    bg: 'Изтекъл',
    de: 'Abgelaufen',
    fr: 'Expiré',
    ro: 'Expirat',
    tr: 'Süresi dolmuş',
    sr: 'Истекло',
    mk: 'Истечен',
    hu: 'Lejárt',
    sk: 'Vypršané',
    sl: 'Poteklo',
    es: 'Expirado',
    fi: 'Vanhentunut',
    el: 'Ληγμένο',
  },
  validationStatus_pending: {
    en: 'Pending',
    bg: 'В изчакване',
    de: 'Ausstehend',
    fr: 'En attente',
    ro: 'În așteptare',
    tr: 'Beklemede',
    sr: 'На чекању',
    mk: 'Во тек',
    hu: 'Függőben',
    sk: 'Čaká sa',
    sl: 'V teku',
    es: 'Pendiente',
    fi: 'Odottaa',
    el: 'Εκκρεμεί',
  },

  validationStatus_approved: {
    en: 'Approved',
    bg: 'Одобрен',
    de: 'Genehmigt',
    fr: 'Approuvé',
    ro: 'Aprobat',
    tr: 'Onaylandı',
    sr: 'Одобрено',
    mk: 'Одобрено',
    hu: 'Jóváhagyva',
    sk: 'Schválené',
    sl: 'Odobreno',
    es: 'Aprobado',
    fi: 'Hyväksytty',
    el: 'Εγκρίθηκε',
  },
  validationStatus_confirmed: {
    en: 'Confirmed',
    bg: 'Одобрен',
    de: 'Bestätigt',
    fr: 'Confirmé',
    ro: 'Confirmat',
    tr: 'Onaylandı',
    sr: 'Потврђено',
    mk: 'Потврдено',
    hu: 'Megerősítve',
    sk: 'Potvrdené',
    sl: 'Potrjeno',
    es: 'Confirmado',
    fi: 'Vahvistettu',
    el: 'Επιβεβαιωμένο',
  },
  validationStatus_rejected: {
    en: 'Rejected',
    bg: 'Отхвърлен',
    de: 'Abgelehnt',
    fr: 'Rejeté',
    ro: 'Respins',
    tr: 'Reddedildi',
    sr: 'Одбијено',
    mk: 'Одбиено',
    hu: 'Elutasítva',
    sk: 'Zamietnuté',
    sl: 'Zavrnjeno',
    es: 'Rechazado',
    fi: 'Hylätty',
    el: 'Απορρίφθηκε',
  },

  validationStatus_disabled: {
    en: 'Disabled',
    bg: 'Деактивиран',
    de: 'Deaktiviert',
    fr: 'Désactivé',
    ro: 'Dezactivat',
    tr: 'Devre dışı',
    sr: 'Онемогućено',
    mk: 'Оневозможено',
    hu: 'Letiltva',
    sk: 'Zakázané',
    sl: 'Onemogočeno',
    es: 'Deshabilitado',
    fi: 'Poistettu käytöstä',
    el: 'Απενεργοποιήθηκε',
  },

  validationStatus_paid: {
    en: 'Paid',
    bg: 'Платено',
    de: 'Bezahlt',
    fr: 'Payé',
    ro: 'Plătit',
    tr: 'Ödendi',
    sr: 'Плаћено',
    mk: 'Платено',
    hu: 'Fizetve',
    sk: 'Zaplatené',
    sl: 'Plačano',
    es: 'Pagado',
    fi: 'Maksettu',
    el: 'Πληρωμένο',
  },
  role_client: {
    en: 'Client',
    bg: 'Клиент',
    de: 'Kunde',
    fr: 'Client',
    ro: 'Client',
    tr: 'Müşteri',
    sr: 'Клијент',
    mk: 'Клиент',
    hu: 'Ügyfél',
    sk: 'Klient',
    sl: 'Stranka',
    es: 'Cliente',
    fi: 'Asiakas',
    el: 'Πελάτης',
  },

  'Route distance: {{distance}} km': {
    en: 'Route distance: {{distance}} km',
    bg: 'Разстояние по маршрут: {{distance}} km',
    de: 'Routenentfernung: {{distance}} km',
    fr: "Distance de l'itinéraire : {{distance}} km",
    ro: 'Distanța traseului: {{distance}} km',
    tr: 'Rota mesafesi: {{distance}} km',
    sr: 'Дужина руте: {{distance}} km',
    mk: 'Должина на рутата: {{distance}} km',
    hu: 'Útvonal távolság: {{distance}} km',
    sk: 'Vzdialenosť trasy: {{distance}} km',
    sl: 'Razdalja poti: {{distance}} km',
    es: 'Distancia de la ruta: {{distance}} km',
    fi: 'Reitin pituus: {{distance}} km',
  },

  'The map will appear when the pickup and delivery addresses are added.': {
    en: 'The map will appear when the pickup and delivery addresses are added.',
    bg: 'Картата ще се появи, когато се добавят адресите за взимане и доставка.',
    de: 'Die Karte erscheint, wenn Abhol- und Lieferadressen hinzugefügt wurden.',
    fr: "La carte apparaîtra lorsque les adresses d'enlèvement et de livraison seront ajoutées.",
    ro: 'Harta va apărea când sunt adăugate adresele de ridicare și livrare.',
    tr: 'Alım ve teslimat adresleri eklendiğinde harita görünecektir.',
    sr: 'Мапа ће се појавити када се додају адресе преузимања и испоруке.',
    mk: 'Мапата ќе се појави кога ќе се додадат адресите за подигнување и достава.',
    hu: 'A térkép akkor jelenik meg, amikor megadja a felvételi és szállítási címeket.',
    sk: 'Mapa sa zobrazí po pridaní adries vyzdvihnutia a doručenia.',
    sl: 'Zemljevid se bo prikazal, ko dodate naslove prevzema in dostave.',
    es: 'El mapa aparecerá cuando se agreguen las direcciones de recogida y entrega.',
    fi: 'Kartta näkyy, kun nouto- ja toimitusosoitteet on lisätty.',
  },

  'Go to item details': {
    en: 'Go to item details',
    bg: 'Към детайли на артикула',
    de: 'Zu den Artikeldetails',
    fr: "Voir les détails de l'article",
    ro: 'Vezi detalii articol',
    tr: 'Öğe detaylarına git',
    sr: 'Иди на детаље ставке',
    mk: 'Оди до детали за ставката',
    hu: 'Tétel részletei',
    sk: 'Prejsť na detaily položky',
    sl: 'Pojdi na podrobnosti elementa',
    es: 'Ir a los detalles del artículo',
    fi: 'Siirry tuotteen tietoihin',
  },

  'Pet type': {
    en: 'Pet type',
    bg: 'Тип домашен любимец',
    de: 'Haustiertyp',
    fr: "Type d'animal",
    ro: 'Tip animal',
    tr: 'Evcil hayvan türü',
    sr: 'Тип љубимца',
    mk: 'Тип на миленик',
    hu: 'Háziállat típusa',
    sk: 'Typ domáceho zvieraťa',
    sl: 'Vrsta hišnega ljubljenčka',
    es: 'Tipo de mascota',
    fi: 'Lemmikin tyyppi',
  },

  Breed: {
    en: 'Breed',
    bg: 'Порода',
    de: 'Rasse',
    fr: 'Race',
    ro: 'Rasă',
    tr: 'Irk',
    sr: 'Раса',
    mk: 'Раса',
    hu: 'Fajta',
    sk: 'Plemeno',
    sl: 'Pasma',
    es: 'Raza',
    fi: 'Rotu',
  },
  'Pick-up pending': {
    en: 'Pick-up pending',
    bg: 'Предстои вземане',
    de: 'Abholung ausstehend',
    fr: 'Enlèvement en attente',
    ro: 'Ridicare în așteptare',
    tr: 'Alım bekleniyor',
    sr: 'Preuzimanje na čekanju',
    mk: 'Преземање на чекање',
    hu: 'Felvétel függőben',
    sk: 'Vyzdvihnutie čaká',
    sl: 'Prevzem na čakanju',
    es: 'Recogida pendiente',
    fi: 'Nouto odottaa',
    el: 'Παραλαβή σε εκκρεμότητα',
  },

  'Delivery pending': {
    en: 'Delivery pending',
    bg: 'Предстои доставка',
    de: 'Lieferung ausstehend',
    fr: 'Livraison en attente',
    ro: 'Livrare în așteptare',
    tr: 'Teslimat bekleniyor',
    sr: 'Isporuka na čekanju',
    mk: 'Испорака на чекање',
    hu: 'Szállítás függőben',
    sk: 'Doručenie čaká',
    sl: 'Dostava na čakanju',
    es: 'Entrega pendiente',
    fi: 'Toimitus odottaa',
    el: 'Παράδοση σε εκκρεμότητα',
  },

  'No item details': {
    en: 'No item details',
    bg: 'Няма информация за артикула',
    de: 'Keine Artikeldetails',
    fr: 'Aucun détail sur l’article',
    ro: 'Fără detalii despre articol',
    tr: 'Ürün detayları yok',
    sr: 'Nema detalja o stavci',
    mk: 'Нема детали за ставката',
    hu: 'Nincs tétel részlet',
    sk: 'Žiadne podrobnosti o položke',
    sl: 'Ni podrobnosti o artiklu',
    es: 'Sin detalles del artículo',
    fi: 'Ei tietoja tuotteesta',
    el: 'Δεν υπάρχουν λεπτομέρειες αντικειμένου',
  },

  'Shipment details': {
    en: 'Shipment details',
    bg: 'Детайли за пратката',
    de: 'Sendungsdetails',
    fr: 'Détails de l’expédition',
    ro: 'Detalii despre transport',
    tr: 'Gönderi detayları',
    sr: 'Detalji pošiljke',
    mk: 'Детали за пратката',
    hu: 'Szállítmány részletei',
    sk: 'Podrobnosti o zásielke',
    sl: 'Podrobnosti pošiljke',
    es: 'Detalles del envío',
    fi: 'Lähetyksen tiedot',
    el: 'Λεπτομέρειες αποστολής',
  },

  EUR: {
    en: 'EUR',
    bg: 'EUR',
    de: 'EUR',
    fr: 'EUR',
    ro: 'EUR',
    tr: 'EUR',
    sr: 'EUR',
    mk: 'EUR',
    hu: 'EUR',
    sk: 'EUR',
    sl: 'EUR',
    es: 'EUR',
    fi: 'EUR',
    el: 'EUR',
  },

  Company: {
    en: 'Company',
    bg: 'Компания',
    de: 'Unternehmen',
    fr: 'Entreprise',
    ro: 'Companie',
    tr: 'Şirket',
    sr: 'Kompanija',
    mk: 'Компанија',
    hu: 'Cég',
    sk: 'Spoločnosť',
    sl: 'Podjetje',
    es: 'Empresa',
    fi: 'Yritys',
    el: 'Εταιρεία',
  },

  'Expires {{date}}': {
    en: 'Expires {{date}}',
    bg: 'Изтича на {{date}}',
    de: 'Läuft ab am {{date}}',
    fr: 'Expire le {{date}}',
    ro: 'Expiră la {{date}}',
    tr: '{{date}} tarihinde sona erer',
    sr: 'Ističe {{date}}',
    mk: 'Истекува на {{date}}',
    hu: 'Lejár: {{date}}',
    sk: 'Platí do {{date}}',
    sl: 'Poteče {{date}}',
    es: 'Expira el {{date}}',
    fi: 'Vanhenee {{date}}',
    el: 'Λήγει στις {{date}}',
  },

  'Fixed price': {
    en: 'Fixed price',
    bg: 'Фиксирана цена',
    de: 'Festpreis',
    fr: 'Prix fixe',
    ro: 'Preț fix',
    tr: 'Sabit fiyat',
    sr: 'Fiksna cena',
    mk: 'Фиксна цена',
    hu: 'Fix ár',
    sk: 'Pevná cena',
    sl: 'Fiksna cena',
    es: 'Precio fijo',
    fi: 'Kiinteä hinta',
    el: 'Σταθερή τιμή',
  },

  'Your quote': {
    en: 'Your quote',
    bg: 'Вашата оферта',
    de: 'Ihr Angebot',
    fr: 'Votre devis',
    ro: 'Oferta ta',
    tr: 'Teklifiniz',
    sr: 'Vaša ponuda',
    mk: 'Вашата понуда',
    hu: 'Az Ön ajánlata',
    sk: 'Vaša ponuka',
    sl: 'Vaša ponudba',
    es: 'Tu oferta',
    fi: 'Tarjouksesi',
    el: 'Η προσφορά σας',
  },

  'View listing': {
    en: 'View listing',
    bg: 'Преглед на обявата',
    de: 'Anzeige ansehen',
    fr: 'Voir l’annonce',
    ro: 'Vezi listarea',
    tr: 'İlanı görüntüle',
    sr: 'Pogledaj oglas',
    mk: 'Погледни оглас',
    hu: 'Hirdetés megtekintése',
    sk: 'Zobraziť inzerát',
    sl: 'Ogled oglasa',
    es: 'Ver anuncio',
    fi: 'Näytä ilmoitus',
    el: 'Προβολή αγγελίας',
  },

  'Failed to load quotes.': {
    en: 'Failed to load quotes.',
    bg: 'Неуспешно зареждане на оферти.',
    de: 'Angebote konnten nicht geladen werden.',
    fr: 'Échec du chargement des devis.',
    ro: 'Încărcarea ofertelor a eșuat.',
    tr: 'Teklifler yüklenemedi.',
    sr: 'Učitavanje ponuda nije uspelo.',
    mk: 'Неуспешно вчитување на понуди.',
    hu: 'Nem sikerült betölteni az ajánlatokat.',
    sk: 'Načítanie ponúk zlyhalo.',
    sl: 'Nalaganje ponudb ni uspelo.',
    es: 'Error al cargar las ofertas.',
    fi: 'Tarjousten lataus epäonnistui.',
    el: 'Αποτυχία φόρτωσης προσφορών.',
  },

  'No {{status}} quotes': {
    en: 'No {{status}} quotes',
    bg: 'Няма {{status}} оферти',
    de: 'Keine {{status}} Angebote',
    fr: 'Aucun devis {{status}}',
    ro: 'Nu există oferte {{status}}',
    tr: '{{status}} teklif yok',
    sr: 'Nema {{status}} ponuda',
    mk: 'Нема {{status}} понуди',
    hu: 'Nincs {{status}} ajánlat',
    sk: 'Žiadne {{status}} ponuky',
    sl: 'Ni {{status}} ponudb',
    es: 'No hay ofertas {{status}}',
    fi: 'Ei {{status}} tarjouksia',
    el: 'Δεν υπάρχουν προσφορές {{status}}',
  },

  'Submit quotes on open listings to see them here.': {
    en: 'Submit quotes on open listings to see them here.',
    bg: 'Изпратете оферти към активни обяви, за да ги видите тук.',
    de: 'Senden Sie Angebote für offene Inserate, um sie hier zu sehen.',
    fr: 'Soumettez des devis sur les annonces ouvertes pour les voir ici.',
    ro: 'Trimite oferte pentru listări deschise pentru a le vedea aici.',
    tr: 'Burada görmek için açık ilanlara teklifler gönderin.',
    sr: 'Pošaljite ponude na otvorene oglase da biste ih videli ovde.',
    mk: 'Испратете понуди на отворени огласи за да ги видите тука.',
    hu: 'Küldjön ajánlatokat nyitott hirdetésekre, hogy itt lássa őket.',
    sk: 'Odošlite ponuky na otvorené inzeráty, aby ste ich tu videli.',
    sl: 'Pošljite ponudbe na odprte oglase, da jih vidite tukaj.',
    es: 'Envía ofertas en anuncios abiertos para verlas aquí.',
    fi: 'Lähetä tarjouksia avoimiin ilmoituksiin nähdäksesi ne täällä.',
    el: 'Υποβάλετε προσφορές σε ανοιχτές αγγελίες για να τις δείτε εδώ.',
  },

  'You have no {{status}} quotes at the moment.': {
    en: 'You have no {{status}} quotes at the moment.',
    bg: 'В момента нямате {{status}} оферти.',
    de: 'Sie haben derzeit keine {{status}} Angebote.',
    fr: 'Vous n’avez actuellement aucun devis {{status}}.',
    ro: 'Nu ai oferte {{status}} momentan.',
    tr: 'Şu anda {{status}} teklifiniz yok.',
    sr: 'Trenutno nemate {{status}} ponuda.',
    mk: 'Моментално немате {{status}} понуди.',
    hu: 'Jelenleg nincs {{status}} ajánlata.',
    sk: 'Momentálne nemáte žiadne {{status}} ponuky.',
    sl: 'Trenutno nimate {{status}} ponudb.',
    es: 'No tienes ofertas {{status}} en este momento.',
    fi: 'Sinulla ei ole tällä hetkellä {{status}} tarjouksia.',
    el: 'Δεν έχετε {{status}} προσφορές αυτή τη στιγμή.',
  },

  'Track all quotes you have submitted to listings.': {
    en: 'Track all quotes you have submitted to listings.',
    bg: 'Проследявайте всички оферти, които сте изпратили към обяви.',
    de: 'Verfolgen Sie alle Angebote, die Sie für Inserate eingereicht haben.',
    fr: 'Suivez tous les devis que vous avez soumis aux annonces.',
    ro: 'Urmărește toate ofertele pe care le-ai trimis către listări.',
    tr: 'İlanlara gönderdiğiniz tüm teklifleri takip edin.',
    sr: 'Pratite sve ponude koje ste poslali na oglase.',
    mk: 'Следете ги сите понуди што сте ги испратиле кон огласи.',
    hu: 'Kövesse az összes ajánlatot, amelyet hirdetésekhez nyújtott be.',
    sk: 'Sledujte všetky ponuky, ktoré ste odoslali k inzerátom.',
    sl: 'Spremljajte vse ponudbe, ki ste jih poslali na oglase.',
    es: 'Sigue todas las ofertas que has enviado a los anuncios.',
    fi: 'Seuraa kaikkia tarjouksia, jotka olet lähettänyt ilmoituksiin.',
    el: 'Παρακολουθήστε όλες τις προσφορές που έχετε υποβάλει σε αγγελίες.',
  },
  Expired: {
    en: 'Expired',
    bg: 'Изтекла',
    de: 'Abgelaufen',
    fr: 'Expiré',
    ro: 'Expirat',
    tr: 'Süresi doldu',
    sr: 'Isteklo',
    mk: 'Истечено',
    hu: 'Lejárt',
    sk: 'Expirované',
    sl: 'Poteklo',
    es: 'Expirado',
    fi: 'Vanhentunut',
    el: 'Έληξε',
  },
  'Any special needs or notes': {
    en: 'Any special needs or notes',
    bg: 'Специални нужди или бележки',
    de: 'Besondere Bedürfnisse oder Hinweise',
    fr: 'Besoins particuliers ou notes',
    ro: 'Nevoi speciale sau note',
    tr: 'Özel ihtiyaçlar veya notlar',
    sr: 'Посебне потребе или напомене',
    mk: 'Посебни потреби или белешки',
    hu: 'Különleges igények vagy megjegyzések',
    sk: 'Špeciálne potreby alebo poznámky',
    sl: 'Posebne potrebe ali opombe',
    es: 'Necesidades especiales o notas',
    fi: 'Erityistarpeet tai huomautukset',
  },

  'Listing details': {
    en: 'Listing details',
    bg: 'Детайли за обявата',
    de: 'Anzeigendetails',
    fr: "Détails de l'annonce",
    ro: 'Detalii listare',
    tr: 'İlan detayları',
    sr: 'Детаљи огласа',
    mk: 'Детали за огласот',
    hu: 'Hirdetés részletei',
    sk: 'Detaily inzerátu',
    sl: 'Podrobnosti oglasa',
    es: 'Detalles del anuncio',
    fi: 'Ilmoituksen tiedot',
  },
  'Confirmed fleet and dates for the assigned transport.': {
    en: 'Confirmed fleet and dates for the assigned transport.',
    bg: 'Потвърден флот и дати за определения транспорт.',
    de: 'Bestätigte Flotte und Termine für den zugewiesenen Transport.',
    fr: 'Flotte et dates confirmées pour le transport assigné.',
    ro: 'Flotă și date confirmate pentru transportul atribuit.',
    tr: 'Atanan taşıma için doğrulanmış filo ve tarihler.',
    sr: 'Potvrđen vozni park i datumi za dodeljeni transport.',
    mk: 'Потврдени флота и датуми за доделениот транспорт.',
    hu: 'Megerősített flották és dátumok a kijelölt szállításhoz.',
    sk: 'Potvrdená flotila a dátumy pre pridelenú dopravu.',
    sl: 'Potrjena flota in datumi za dodeljen prevoz.',
    es: 'Flota y fechas confirmadas para el transporte asignado.',
    fi: 'Vahvistettu kalusto ja päivämäärät määritetylle kuljetukselle.',
    el: 'Επιβεβαιωμένος στόλος και ημερομηνίες για την εκχωρημένη μεταφορά.',
  },

  'The partner has not confirmed the transport plan yet.': {
    en: 'The partner has not confirmed the transport plan yet.',
    bg: 'Партньорът все още не е потвърдил транспортния план.',
    de: 'Der Partner hat den Transportplan noch nicht bestätigt.',
    fr: "Le partenaire n'a pas encore confirmé le plan de transport.",
    ro: 'Partenerul nu a confirmat încă planul de transport.',
    tr: 'Ortak henüz taşıma planını onaylamadı.',
    sr: 'Partner još nije potvrdio plan transporta.',
    mk: 'Партнерот сè уште не го потврдил планот за транспорт.',
    hu: 'A partner még nem erősítette meg a szállítási tervet.',
    sk: 'Partner zatiaľ nepotvrdil dopravný plán.',
    sl: 'Partner še ni potrdil načrta prevoza.',
    es: 'El socio aún no ha confirmado el plan de transporte.',
    fi: 'Kumppani ei ole vielä vahvistanut kuljetussuunnitelmaa.',
    el: 'Ο συνεργάτης δεν έχει ακόμη επιβεβαιώσει το σχέδιο μεταφοράς.',
  },
  'Letter of Attorney': {
    en: 'Letter of Attorney',
    bg: 'Пълномощно',
    de: 'Vollmacht',
    fr: 'Lettre de procuration',
    ro: 'Scrisoare de împuternicire',
    tr: 'Vekaletname',
    sr: 'Punomoćje',
    mk: 'Потврда за овластување',
    hu: 'Meghatalmazás',
    sk: 'Plná moc',
    sl: 'Pooblastilo',
    es: 'Carta de poder',
    fi: 'Valtakirja',
    el: 'Επιστολή πληρεξουσιότητας',
  },
  'Your quote has been accepted. Awaiting payment confirmation from the admin before you can begin the job.':
    {
      en: 'Your quote has been accepted. Awaiting payment confirmation from the admin before you can begin the job.',
      bg: 'Вашата оферта беше приета. Очаква се потвърждение на плащането от администратора, преди да можете да започнете работата.',
      de: 'Ihr Angebot wurde angenommen. Wir warten auf die Zahlungsbestätigung des Administrators, bevor Sie mit der Arbeit beginnen können.',
      fr: 'Votre devis a été accepté. En attente de la confirmation du paiement de l’administrateur avant que vous puissiez commencer le travail.',
      ro: 'Oferta dvs. a fost acceptată. Se așteaptă confirmarea plății de la administrator înainte de a putea începe lucrarea.',
      tr: 'Teklifiniz kabul edildi. İşe başlamadan önce yöneticiden ödeme onayı bekleniyor.',
      sr: 'Vaša ponuda je prihvaćena. Čeka se potvrda uplate od administratora pre nego što možete započeti posao.',
      mk: 'Вашата понуда е прифатена. Се чека потврда за плаќање од администраторот пред да можете да започнете со работа.',
      hu: 'Az ajánlatát elfogadták. A munka megkezdése előtt az adminisztrátor fizetési visszaigazolására várunk.',
      sk: 'Vaša ponuka bola prijatá. Čaká sa na potvrdenie platby od administrátora predtým, ako môžete začať pracovať.',
      sl: 'Vaša ponudba je bila sprejeta. Pred začetkom dela se čaka na potrditev plačila s strani administratorja.',
      es: 'Su presupuesto ha sido aceptado. Se está esperando la confirmación del pago por parte del administrador antes de que pueda comenzar el trabajo.',
      fi: 'Tarjouksesi on hyväksytty. Odotetaan järjestelmänvalvojan maksun vahvistusta ennen kuin voit aloittaa työn.',
      el: 'Η προσφορά σας έγινε αποδεκτή. Αναμένεται επιβεβαίωση πληρωμής από τον διαχειριστή πριν μπορέσετε να ξεκινήσετε την εργασία.',
    },
  'Reference number': {
    en: 'Reference #{{id}}',
    bg: 'Референтен №{{id}}',
    de: 'Referenznummer #{{id}}',
    fr: 'Référence n°{{id}}',
    ro: 'Referință #{{id}}',
    tr: 'Referans #{{id}}',
    sr: 'Referenca #{{id}}',
    mk: 'Референца #{{id}}',
    hu: 'Hivatkozási szám #{{id}}',
    sk: 'Referenčné číslo #{{id}}',
    sl: 'Referenca #{{id}}',
    es: 'Referencia #{{id}}',
    fi: 'Viite #{{id}}',
    el: 'Αναφορά #{{id}}',
  },
  'Fixed price only': {
    en: 'Fixed price only',
    bg: 'Само фиксирана цена',
    de: 'Nur Festpreis',
    fr: 'Prix fixe uniquement',
    ro: 'Doar preț fix',
    tr: 'Sadece sabit fiyat',
    sr: 'Samo fiksna cena',
    mk: 'Само фиксна цена',
    hu: 'Csak fix ár',
    sk: 'Iba pevná cena',
    sl: 'Samo fiksna cena',
    es: 'Solo precio fijo',
    fi: 'Vain kiinteä hinta',
    el: 'Μόνο σταθερή τιμή',
  },
  'Truck, driver, trailer, and planned dates for this shipment.': {
    en: 'Truck, driver, trailer, and planned dates for this shipment.',
    bg: 'Камион, шофьор, ремарке и планирани дати за тази пратка.',
    de: 'Lkw, Fahrer, Anhänger und geplante Termine für diese Sendung.',
    fr: 'Camion, chauffeur, remorque et dates prévues pour cet envoi.',
    ro: 'Camion, șofer, remorcă și datele planificate pentru această expediere.',
    tr: 'Bu sevkiyat için kamyon, sürücü, römork ve planlanan tarihler.',
    sr: 'Kamion, vozač, prikolica i planirani datumi za ovu pošiljku.',
    mk: 'Камион, возач, приколка и планирани датуми за оваа пратка.',
    hu: 'Teherautó, sofőr, pótkocsi és a szállítmány tervezett időpontjai.',
    sk: 'Nákladné vozidlo, vodič, príves a plánované dátumy pre túto zásielku.',
    sl: 'Tovornjak, voznik, prikolica in načrtovani datumi za to pošiljko.',
    es: 'Camión, conductor, remolque y fechas previstas para este envío.',
    fi: 'Kuorma-auto, kuljettaja, perävaunu ja suunnitellut päivämäärät tälle lähetykselle.',
    el: 'Φορτηγό, οδηγός, ρυμουλκούμενο και προγραμματισμένες ημερομηνίες για αυτή την αποστολή.',
  },
  'Generated automatically when the transport plan is confirmed.': {
    en: 'Generated automatically when the transport plan is confirmed.',
    bg: 'Генерира се автоматично при потвърждаване на транспортния план.',
    de: 'Wird automatisch generiert, wenn der Transportplan bestätigt wird.',
    fr: 'Généré automatiquement lorsque le plan de transport est confirmé.',
    ro: 'Generat automat la confirmarea planului de transport.',
    tr: 'Taşıma planı onaylandığında otomatik olarak oluşturulur.',
    sr: 'Automatski se generiše kada se plan transporta potvrdi.',
    mk: 'Се генерира автоматски кога транспортниот план е потврден.',
    hu: 'A szállítási terv megerősítésekor automatikusan generálódik.',
    sk: 'Automaticky sa vygeneruje po potvrdení prepravného plánu.',
    sl: 'Samodejno se ustvari ob potrditvi transportnega načrta.',
    es: 'Se genera automáticamente cuando se confirma el plan de transporte.',
    fi: 'Luodaan automaattisesti, kun kuljetussuunnitelma vahvistetaan.',
    el: 'Δημιουργείται αυτόματα όταν επιβεβαιώνεται το σχέδιο μεταφοράς.',
  },

  'quoteWorkspace.title': {
    en: 'Quote workspace',
    bg: 'Работно пространство за оферти',
    de: 'Angebotsübersicht',
    fr: 'Espace des devis',
    ro: 'Spațiu oferte',
    tr: 'Teklif alanı',
    sr: 'Radni prostor za ponude',
    mk: 'Работен простор за понуди',
    hu: 'Ajánlati munkaterület',
    sk: 'Pracovný priestor ponúk',
    sl: 'Delovni prostor ponudb',
    es: 'Espacio de presupuestos',
    fi: 'Tarjoustyötila',
    el: 'Χώρος προσφορών',
  },

  'quoteWorkspace.description': {
    en: 'Review accepted, pending, rejected, and expired quotes with the same delivery-card layout used in marketplace search.',
    bg: 'Преглеждайте приети, изчакващи, отхвърлени и изтекли оферти със същия изглед на карти, използван в търсенето в маркетплейса.',
    de: 'Überprüfen Sie angenommene, ausstehende, abgelehnte und abgelaufene Angebote im gleichen Kartenlayout wie in der Marktplatzsuche.',
    fr: 'Consultez les devis acceptés, en attente, refusés et expirés avec la même présentation en cartes que dans la recherche du marketplace.',
    ro: 'Vizualizați ofertele acceptate, în așteptare, respinse și expirate folosind același layout de tip card ca în căutarea din marketplace.',
    tr: 'Kabul edilen, bekleyen, reddedilen ve süresi dolmuş teklifleri, pazaryeri aramasında kullanılan aynı kart düzeniyle inceleyin.',
    sr: 'Pregledajte prihvaćene, na čekanju, odbijene i istekle ponude u istom kartičnom prikazu kao u pretrazi marketplace-a.',
    mk: 'Прегледајте прифатени, во тек, одбиени и истечени понуди со истиот изглед на картички како во пребарувањето на маркетплејс.',
    hu: 'Tekintse át az elfogadott, függőben lévő, elutasított és lejárt ajánlatokat a piactéri keresésben használt kártyanézetben.',
    sk: 'Prezerajte prijaté, čakajúce, zamietnuté a expirované ponuky v rovnakom kartovom rozhraní ako pri vyhľadávaní na marketplace.',
    sl: 'Preglejte sprejete, čakajoče, zavrnjene in potekle ponudbe z enako postavitvijo kartic, kot se uporablja v iskanju na tržnici.',
    es: 'Revise presupuestos aceptados, pendientes, rechazados y caducados con el mismo diseño de tarjeta de entrega utilizado en la búsqueda del marketplace.',
    fi: 'Tarkastele hyväksyttyjä, odottavia, hylättyjä ja vanhentuneita tarjouksia samalla korttinäkymällä, jota käytetään markkinapaikan haussa.',
    el: 'Ανασκοπήστε τις αποδεκτές, σε εκκρεμότητα, απορριφθείσες και ληγμένες προσφορές με την ίδια διάταξη καρτών παράδοσης που χρησιμοποιείται στην αναζήτηση του marketplace.',
  },
  'quotes.accepted.title': {
    en: 'Accepted quotes',
    bg: 'Приети оферти',
    de: 'Angeommene Angebote',
    fr: 'Devis acceptés',
    ro: 'Oferte acceptate',
    tr: 'Kabul edilen teklifler',
    sr: 'Prihvaćene ponude',
    mk: 'Прифатени понуди',
    hu: 'Elfogadott ajánlatok',
    sk: 'Prijaté ponuky',
    sl: 'Sprejete ponudbe',
    es: 'Presupuestos aceptados',
    fi: 'Hyväksytyt tarjoukset',
    el: 'Αποδεκτές προσφορές',
  },

  'quotes.accepted.description': {
    en: 'Accepted quotes stay first, with active transport work floated to the top.',
    bg: 'Приетите оферти остават първи, като активните транспортни задачи се показват най-отгоре.',
    de: 'Angenommene Angebote bleiben zuerst, mit aktiver Transportarbeit oben.',
    fr: 'Les devis acceptés restent en premier, avec le travail de transport actif en haut.',
    ro: 'Ofertele acceptate rămân primele, iar lucrările de transport active sunt afișate deasupra.',
    tr: 'Kabul edilen teklifler önce kalır, aktif taşıma işleri en üste çıkarılır.',
    sr: 'Prihvaćene ponude ostaju prve, a aktivni transportni radovi se prikazuju na vrhu.',
    mk: 'Прифатените понуди остануваат први, а активната транспортна работа се прикажува на врвот.',
    hu: 'Az elfogadott ajánlatok maradnak elöl, az aktív szállítási munkák pedig a tetejére kerülnek.',
    sk: 'Prijaté ponuky zostávajú navrchu a aktívna prepravná práca sa zobrazí hore.',
    sl: 'Sprejete ponudbe ostanejo prve, aktivno transportno delo pa je prikazano na vrhu.',
    es: 'Los presupuestos aceptados permanecen primeros, con el trabajo de transporte activo en la parte superior.',
    fi: 'Hyväksytyt tarjoukset pysyvät ensimmäisinä, ja aktiiviset kuljetustyöt nostetaan ylös.',
    el: 'Οι αποδεκτές προσφορές παραμένουν πρώτες, με την ενεργή μεταφορική εργασία να εμφανίζεται στην κορυφή.',
  },
  'Accepted.plural': {
    en: 'Accepted',
    bg: 'Приети',
    de: 'Akzeptierte',
    fr: 'Acceptés',
    ro: 'Acceptate',
    tr: 'Kabul edilen',
    sr: 'Prihvaćene',
    mk: 'Прифатени',
    hu: 'Elfogadott',
    sk: 'Prijaté',
    sl: 'Sprejete',
    es: 'Aceptados',
    fi: 'Hyväksytyt',
    el: 'Αποδεκτές',
  },

  'Pending.plural': {
    en: 'Pending',
    bg: 'Очакващи',
    de: 'Ausstehende',
    fr: 'En attente',
    ro: 'În așteptare',
    tr: 'Bekleyen',
    sr: 'Na čekanju',
    mk: 'Чекаат',
    hu: 'Függőben lévő',
    sk: 'Čakajúce',
    sl: 'Čakajoče',
    es: 'Pendientes',
    fi: 'Odotetut',
    el: 'Αναμενόμενες',
  },

  'Rejected.plural': {
    en: 'Rejected',
    bg: 'Отхвърлени',
    de: 'Abgelehnte',
    fr: 'Refusés',
    ro: 'Respinse',
    tr: 'Reddedilen',
    sr: 'Odbijene',
    mk: 'Одбиени',
    hu: 'Elutasított',
    sk: 'Zamietnuté',
    sl: 'Zavrnjene',
    es: 'Rechazados',
    fi: 'Hylätyt',
    el: 'Απορριφθείσες',
  },

  'Expired.plural': {
    en: 'Expired',
    bg: 'Изтекли',
    de: 'Abgelaufene',
    fr: 'Expirés',
    ro: 'Expirate',
    tr: 'Süresi dolmuş',
    sr: 'Istekle',
    mk: 'Истечени',
    hu: 'Lejárt',
    sk: 'Expirované',
    sl: 'Potekle',
    es: 'Caducados',
    fi: 'Vanhentuneet',
    el: 'Ληγμένες',
  },
  quotes: {
    en: 'quotes',
    bg: 'оферти',
    de: 'Angebote',
    fr: 'devis',
    ro: 'oferte',
    tr: 'teklifler',
    sr: 'ponude',
    mk: 'понуди',
    hu: 'ajánlatok',
    sk: 'ponuky',
    sl: 'ponudbe',
    es: 'presupuestos',
    fi: 'tarjoukset',
    el: 'προσφορές',
  },
  rejected: {
    en: 'rejected',
    bg: 'отхвърлен',
    de: 'abgelehnt',
    fr: 'refusé',
    ro: 'respins',
    tr: 'reddedildi',
    sr: 'odbijen',
    mk: 'одбиен',
    hu: 'elutasított',
    sk: 'zamietnutý',
    sl: 'zavrnjeno',
    es: 'rechazado',
    fi: 'hylätty',
    el: 'απορριφθείς',
  },
  'accepted.plural': {
    en: 'accepted',
    bg: 'приети',
    de: 'akzeptierte',
    fr: 'acceptés',
    ro: 'acceptate',
    tr: 'kabul edilen',
    sr: 'prihvaćene',
    mk: 'прифатени',
    hu: 'elfogadott',
    sk: 'prijaté',
    sl: 'sprejete',
    es: 'aceptados',
    fi: 'hyväksytyt',
    el: 'αποδεκτές',
  },

  'pending.plural': {
    en: 'pending',
    bg: 'очакващи',
    de: 'ausstehende',
    fr: 'en attente',
    ro: 'în așteptare',
    tr: 'bekleyen',
    sr: 'na čekanju',
    mk: 'чекаат',
    hu: 'függőben lévő',
    sk: 'čakajúce',
    sl: 'čakajoče',
    es: 'pendientes',
    fi: 'odotetut',
    el: 'αναμενόμενες',
  },

  'rejected.plural': {
    en: 'rejected',
    bg: 'отхвърлени',
    de: 'abgelehnte',
    fr: 'refusés',
    ro: 'respinse',
    tr: 'reddedilen',
    sr: 'odbijene',
    mk: 'одбиени',
    hu: 'elutasított',
    sk: 'zamietnuté',
    sl: 'zavrnjene',
    es: 'rechazados',
    fi: 'hylätyt',
    el: 'απορριφθείσες',
  },

  'expired.plural': {
    en: 'expired',
    bg: 'изтекли',
    de: 'abgelaufene',
    fr: 'expirés',
    ro: 'expirate',
    tr: 'süresi dolmuş',
    sr: 'istekle',
    mk: 'истечени',
    hu: 'lejárt',
    sk: 'expirované',
    sl: 'potekle',
    es: 'caducados',
    fi: 'vanhentuneet',
    el: 'ληγμένες',
  },
  items: {
    en: 'items',
    bg: 'артикули',
    de: 'Artikel',
    fr: 'articles',
    ro: 'articole',
    tr: 'artiküller',
    sr: 'stavke',
    mk: 'ставки',
    hu: 'elemek',
    sk: 'položky',
    sl: 'predmeti',
    es: 'artículos',
    fi: 'kohteet',
    el: 'αντικείμενα',
  },
  'Transport authorization generated after confirmation': {
    en: 'The transport authorization is generated once the assigned fleet and dates are confirmed.',
    bg: 'Разрешението за транспорт се генерира след като флотът и датите са потвърдени.',
    de: 'Die Transportgenehmigung wird erstellt, sobald die zugewiesene Flotte und die Termine bestätigt sind.',
    fr: "L'autorisation de transport est générée une fois que la flotte et les dates attribuées sont confirmées.",
    ro: 'Autorizația de transport se generează odată ce flotă și datele atribuite sunt confirmate.',
    tr: 'Atanan filo ve tarihler onaylandığında taşıma yetkilendirmesi oluşturulur.',
    sr: 'Dozvola za transport se generiše kada se potvrde dodeljeni vozni park i datumi.',
    mk: 'Одобрението за транспорт се генерира откако ќе бидат потврдени доделената флота и датумите.',
    hu: 'A szállítási engedély a kijelölt flották és dátumok megerősítése után jön létre.',
    sk: 'Dopravné oprávnenie sa vytvorí, keď sú potvrdené pridelené flotily a dátumy.',
    sl: 'Dovoljenje za prevoz se generira, ko so potrjene dodeljene flote in datumi.',
    es: 'La autorización de transporte se genera una vez que se confirman la flota y las fechas asignadas.',
    fi: 'Kuljetuslupa luodaan, kun määritetty kalusto ja päivämäärät on vahvistettu.',
    el: 'Η εξουσιοδότηση μεταφοράς δημιουργείται μόλις επιβεβαιωθεί ο εκχωρημένος στόλος και οι ημερομηνίες.',
  },

  'No letter of attorney generated has been generated yet': {
    en: 'No letter of attorney has been generated yet.',
    bg: 'Все още не е генерирано пълномощно.',
    de: 'Es wurde noch keine Vollmacht erstellt.',
    fr: "Aucune lettre de procuration n'a encore été générée.",
    ro: 'Nu a fost generată încă nicio scrisoare de împuternicire.',
    tr: 'Henüz vekaletname oluşturulmadı.',
    sr: 'Punomoć još nije generisana.',
    mk: 'Сè уште не е генерирано потврда за овластување.',
    hu: 'Még nem készült meghatalmazás.',
    sk: 'Žiadna plná moc ešte nebola vytvorená.',
    sl: 'Pooblastilo še ni bilo ustvarjeno.',
    es: 'Aún no se ha generado ninguna carta de poder.',
    fi: 'Valtakirjaa ei ole vielä luotu.',
    el: 'Δεν έχει δημιουργηθεί ακόμη επιστολή πληρεξουσιότητας.',
  },
  'Transport plan': {
    en: 'Transport plan',
    bg: 'Транспортен план',
    de: 'Transportplan',
    fr: 'Plan de transport',
    ro: 'Plan de transport',
    tr: 'Taşıma planı',
    sr: 'Plan transporta',
    mk: 'План за транспорт',
    hu: 'Szállítási terv',
    sk: 'Dopravný plán',
    sl: 'Načrt prevoza',
    es: 'Plan de transporte',
    fi: 'Kuljetussuunnitelma',
    el: 'Σχέδιο μεταφοράς',
  },
  'The transport authorization is generated once the assigned fleet and dates are confirmed.':
    {
      en: 'The transport authorization is generated once the assigned fleet and dates are confirmed.',
      bg: 'Разрешението за транспорт се генерира след като флотът и датите са потвърдени.',
      de: 'Die Transportgenehmigung wird erstellt, sobald die zugewiesene Flotte und die Termine bestätigt sind.',
      fr: "L'autorisation de transport est générée une fois que la flotte et les dates attribuées sont confirmées.",
      ro: 'Autorizația de transport se generează odată ce flotă și datele atribuite sunt confirmate.',
      tr: 'Atanan filo ve tarihler onaylandığında taşıma yetkilendirmesi oluşturulur.',
      sr: 'Dozvola za transport se generiše kada se potvrde dodeljeni vozni park i datumi.',
      mk: 'Одобрението за транспорт се генерира откако ќе бидат потврдени доделената флота и датумите.',
      hu: 'A szállítási engedély a kijelölt flották és dátumok megerősítése után jön létre.',
      sk: 'Doprava oprávnenie sa vytvorí, keď sú potvrdené pridelené flotily a dátumy.',
      sl: 'Dovoljenje za prevoz se generira, ko so potrjene dodeljene flote in datumi.',
      es: 'La autorización de transporte se genera una vez que se confirman la flota y las fechas asignadas.',
      fi: 'Kuljetuslupa luodaan, kun määritetty kalusto ja päivämäärät on vahvistettu.',
      el: 'Η εξουσιοδότηση μεταφοράς δημιουργείται μόλις επιβεβαιωθεί ο εκχωρημένος στόλος και οι ημερομηνίες.',
    },
  'All transport listing requests across the platform.': {
    en: 'All transport listing requests across the platform.',
    bg: 'Всички заявки за транспорт в платформата.',
    de: 'Alle Transportanfragen auf der Plattform.',
    fr: 'Toutes les demandes de transport sur la plateforme.',
    ro: 'Toate cererile de transport din platformă.',
    tr: 'Platformadaki tüm taşıma talepleri.',
    sr: 'Svi zahtevi za transport na platformi.',
    mk: 'Сите барања за транспорт на платформата.',
    hu: 'Az összes szállítási kérés a platformon.',
    sk: 'Všetky žiadosti o dopravu na platforme.',
    sl: 'Vse zahteve za prevoz na platformi.',
    es: 'Todas las solicitudes de transporte en la plataforma.',
    fi: 'Kaikki kuljetuspyynnöt alustalla.',
    el: 'Όλα τα αιτήματα μεταφοράς στην πλατφόρμα.',
  },
  Listings: {
    en: 'Listings',
    bg: 'Обяви',
    de: 'Angebote',
    fr: 'Annonces',
    ro: 'Listări',
    tr: 'İlanlar',
    sr: 'Oglasi',
    mk: 'Огласи',
    hu: 'Hirdetések',
    sk: 'Zoznamy',
    sl: 'Oglasi',
    es: 'Anuncios',
    fi: 'Ilmoitukset',
    el: 'Αγγελίες',
  },
  'Category: {{category}}': {
    en: 'Category: {{category}}',
    bg: 'Категория: {{category}}',
    de: 'Kategorie: {{category}}',
    fr: 'Catégorie : {{category}}',
    ro: 'Categorie: {{category}}',
    tr: 'Kategori: {{category}}',
    sr: 'Категорија: {{category}}',
    mk: 'Категорија: {{category}}',
    hu: 'Kategória: {{category}}',
    sk: 'Kategória: {{category}}',
    sl: 'Kategorija: {{category}}',
    es: 'Categoría: {{category}}',
    fi: 'Kategoria: {{category}}',
  },

  'All categories': {
    en: 'All categories',
    bg: 'Всички категории',
    de: 'Alle Kategorien',
    fr: 'Toutes les catégories',
    ro: 'Toate categoriile',
    tr: 'Tüm kategoriler',
    sr: 'Sve kategorije',
    mk: 'Сите категории',
    hu: 'Összes kategória',
    sk: 'Všetky kategórie',
    sl: 'Vse kategorije',
    es: 'Todas las categorías',
    fi: 'Kaikki kategoriat',
    el: 'Όλες οι κατηγορίες',
  },
  Title: {
    en: 'Title',
    bg: 'Заглавие',
    de: 'Titel',
    fr: 'Titre',
    ro: 'Titlu',
    tr: 'Başlık',
    sr: 'Naslov',
    mk: 'Наслов',
    hu: 'Cím',
    sk: 'Názov',
    sl: 'Naslov',
    es: 'Título',
    fi: 'Otsikko',
    el: 'Τίτλος',
  },
  'Item {{index}}': {
    en: 'Item {{index}}',
    bg: 'Артикул {{index}}',
    de: 'Artikel {{index}}',
    fr: 'Article {{index}}',
    ro: 'Articol {{index}}',
    tr: 'Öğe {{index}}',
    sr: 'Ставка {{index}}',
    mk: 'Ставка {{index}}',
    hu: 'Tétel {{index}}',
    sk: 'Položka {{index}}',
    sl: 'Element {{index}}',
    es: 'Artículo {{index}}',
    fi: 'Tuote {{index}}',
  },

  'Remove item': {
    en: 'Remove item',
    bg: 'Премахни артикул',
    de: 'Artikel entfernen',
    fr: "Supprimer l'article",
    ro: 'Elimină articol',
    tr: 'Öğeyi kaldır',
    sr: 'Уклони ставку',
    mk: 'Отстрани ставка',
    hu: 'Tétel eltávolítása',
    sk: 'Odstrániť položku',
    sl: 'Odstrani element',
    es: 'Eliminar artículo',
    fi: 'Poista tuote',
  },

  '+ Add another item': {
    en: '+ Add another item',
    bg: '+ Добави още един артикул',
    de: '+ Weiteren Artikel hinzufügen',
    fr: '+ Ajouter un autre article',
    ro: '+ Adaugă alt articol',
    tr: '+ Başka öğe ekle',
    sr: '+ Додај још једну ставку',
    mk: '+ Додај уште една ставка',
    hu: '+ Új tétel hozzáadása',
    sk: '+ Pridať ďalšiu položku',
    sl: '+ Dodaj še en element',
    es: '+ Añadir otro artículo',
    fi: '+ Lisää toinen tuote',
  },

  'I am listing delivery as': {
    en: 'I am listing delivery as',
    bg: 'Публикувам доставката като',
    de: 'Ich veröffentliche die Lieferung als',
    fr: 'Je publie la livraison en tant que',
    ro: 'Public livrarea ca',
    tr: 'Teslimatı şu şekilde listeliyorum',
    sr: 'Објављујем доставу као',
    mk: 'Ја објавувам доставата како',
    hu: 'A szállítást így hirdetem',
    sk: 'Dodanie zverejňujem ako',
    sl: 'Dostavo objavljam kot',
    es: 'Publico la entrega como',
    fi: 'Julkaisen toimituksen muodossa',
  },

  'Private person': {
    en: 'Private person',
    bg: 'Частно лице',
    de: 'Privatperson',
    fr: 'Particulier',
    ro: 'Persoană fizică',
    tr: 'Bireysel kişi',
    sr: 'Приватно лице',
    mk: 'Приватно лице',
    hu: 'Magánszemély',
    sk: 'Súkromná osoba',
    sl: 'Zasebna oseba',
    es: 'Persona particular',
    fi: 'Yksityishenkilö',
  },

  'A company': {
    en: 'A company',
    bg: 'Компания',
    de: 'Unternehmen',
    fr: 'Entreprise',
    ro: 'Companie',
    tr: 'Şirket',
    sr: 'Компанија',
    mk: 'Компанија',
    hu: 'Cég',
    sk: 'Spoločnosť',
    sl: 'Podjetje',
    es: 'Empresa',
    fi: 'Yritys',
  },

  'Company country': {
    en: 'Company country',
    bg: 'Държава на компанията',
    de: 'Land des Unternehmens',
    fr: "Pays de l'entreprise",
    ro: 'Țara companiei',
    tr: 'Şirket ülkesi',
    sr: 'Држава компаније',
    mk: 'Држава на компанијата',
    hu: 'Cég országa',
    sk: 'Krajina spoločnosti',
    sl: 'Država podjetja',
    es: 'País de la empresa',
    fi: 'Yrityksen maa',
  },

  'Pricing and quote policy': {
    en: 'Pricing and quote policy',
    bg: 'Политика за цени и оферти',
    de: 'Preis- und Angebotsrichtlinie',
    fr: 'Politique de prix et de devis',
    ro: 'Politica de preț și ofertă',
    tr: 'Fiyatlandırma ve teklif politikası',
    sr: 'Политика цена и понуда',
    mk: 'Политика за цени и понуди',
    hu: 'Árazási és ajánlati szabályzat',
    sk: 'Politika cien a ponúk',
    sl: 'Politika cen in ponudb',
    es: 'Política de precios y cotizaciones',
    fi: 'Hinnoittelu- ja tarjouskäytäntö',
  },

  'Allow partner quotes': {
    en: 'Allow partner quotes',
    bg: 'Разреши оферти от партньори',
    de: 'Partnerangebote erlauben',
    fr: 'Autoriser les devis partenaires',
    ro: 'Permite oferte de la parteneri',
    tr: 'Partner tekliflerine izin ver',
    sr: 'Дозволи понуде партнера',
    mk: 'Дозволи понуди од партнери',
    hu: 'Partner ajánlatok engedélyezése',
    sk: 'Povoliť ponuky partnerov',
    sl: 'Dovoli ponudbe partnerjev',
    es: 'Permitir ofertas de socios',
    fi: 'Salli kumppanien tarjoukset',
  },

  'Client price visible to partners': {
    en: 'Client price visible to partners',
    bg: 'Клиентска цена видима за партньори',
    de: 'Kundenpreis für Partner sichtbar',
    fr: 'Prix client visible pour les partenaires',
    ro: 'Preț client vizibil pentru parteneri',
    tr: 'Müşteri fiyatı ortaklara görünür',
    sr: 'Цена клијента видљива партнерима',
    mk: 'Цена на клиент видлива за партнери',
    hu: 'Ügyfélár látható a partnerek számára',
    sk: 'Cena klienta viditeľná pre partnerov',
    sl: 'Cena za stranko vidna partnerjem',
    es: 'Precio del cliente visible para socios',
    fi: 'Asiakkaan hinta näkyvissä kumppaneille',
  },

  'Enter amount in EUR': {
    en: 'Enter amount in EUR',
    bg: 'Въведете сума в EUR',
    de: 'Betrag in EUR eingeben',
    fr: 'Entrez le montant en EUR',
    ro: 'Introduceți suma în EUR',
    tr: 'EUR tutarını girin',
    sr: 'Унесите износ у EUR',
    mk: 'Внесете износ во EUR',
    hu: 'Adja meg az összeget EUR-ban',
    sk: 'Zadajte sumu v EUR',
    sl: 'Vnesite znesek v EUR',
    es: 'Introduzca la cantidad en EUR',
    fi: 'Anna summa euroissa',
  },

  'Visible price: {{price}}': {
    en: 'Visible price: {{price}}',
    bg: 'Видима цена: {{price}}',
    de: 'Sichtbarer Preis: {{price}}',
    fr: 'Prix visible : {{price}}',
    ro: 'Preț vizibil: {{price}}',
    tr: 'Görünen fiyat: {{price}}',
    sr: 'Видљива цена: {{price}}',
    mk: 'Видлива цена: {{price}}',
    hu: 'Látható ár: {{price}}',
    sk: 'Viditeľná cena: {{price}}',
    sl: 'Vidna cena: {{price}}',
    es: 'Precio visible: {{price}}',
    fi: 'Näkyvä hinta: {{price}}',
  },

  'Hide description': {
    en: 'Hide description',
    bg: 'Скрий описание',
    de: 'Beschreibung ausblenden',
    fr: 'Masquer la description',
    ro: 'Ascunde descrierea',
    tr: 'Açıklamayı gizle',
    sr: 'Сакриј опис',
    mk: 'Скриј опис',
    hu: 'Leírás elrejtése',
    sk: 'Skryť popis',
    sl: 'Skrij opis',
    es: 'Ocultar descripción',
    fi: 'Piilota kuvaus',
  },

  'Add description (optional)': {
    en: 'Add description (optional)',
    bg: 'Добави описание (по избор)',
    de: 'Beschreibung hinzufügen (optional)',
    fr: 'Ajouter une description (facultatif)',
    ro: 'Adaugă descriere (opțional)',
    tr: 'Açıklama ekle (isteğe bağlı)',
    sr: 'Додај опис (опционо)',
    mk: 'Додај опис (опционално)',
    hu: 'Leírás hozzáadása (opcionális)',
    sk: 'Pridať popis (voliteľné)',
    sl: 'Dodaj opis (neobvezno)',
    es: 'Añadir descripción (opcional)',
    fi: 'Lisää kuvaus (valinnainen)',
  },

  'Describe your shipment…': {
    en: 'Describe your shipment…',
    bg: 'Опишете вашата пратка…',
    de: 'Beschreiben Sie Ihre Sendung…',
    fr: 'Décrivez votre envoi…',
    ro: 'Descrieți transportul…',
    tr: 'Gönderinizi açıklayın…',
    sr: 'Опишите вашу пошиљку…',
    mk: 'Опишете ја вашата пратка…',
    hu: 'Írja le a szállítmányát…',
    sk: 'Popíšte vašu zásielku…',
    sl: 'Opišite svojo pošiljko…',
    es: 'Describe tu envío…',
    fi: 'Kuvaile lähetystäsi…',
  },

  'Add images (optional)': {
    en: 'Add images (optional)',
    bg: 'Добавете изображения (по избор)',
    de: 'Bilder hinzufügen (optional)',
    fr: 'Ajouter des images (facultatif)',
    ro: 'Adaugă imagini (opțional)',
    tr: 'Resimler ekle (isteğe bağlı)',
    sr: 'Додај слике (опционо)',
    mk: 'Додај слики (опционално)',
    hu: 'Képek hozzáadása (opcionális)',
    sk: 'Pridať obrázky (voliteľné)',
    sl: 'Dodaj slike (neobvezno)',
    es: 'Añadir imágenes (opcional)',
    fi: 'Lisää kuvia (valinnainen)',
  },

  'Upload shipment photos': {
    en: 'Upload shipment photos',
    bg: 'Качи снимки на пратката',
    de: 'Versandfotos hochladen',
    fr: "Télécharger des photos de l'envoi",
    ro: 'Încarcă fotografii ale transportului',
    tr: 'Gönderi fotoğraflarını yükle',
    sr: 'Отпреми фотографије пошиљке',
    mk: 'Прикачи фотографии од пратката',
    hu: 'Szállítmány fotók feltöltése',
    sk: 'Nahrať fotografie zásielky',
    sl: 'Naloži fotografije pošiljke',
    es: 'Subir fotos del envío',
    fi: 'Lataa lähetyksen kuvat',
  },

  'Choose images': {
    en: 'Choose images',
    bg: 'Изберете изображения',
    de: 'Bilder auswählen',
    fr: 'Choisir des images',
    ro: 'Alege imagini',
    tr: 'Resim seç',
    sr: 'Изабери слике',
    mk: 'Избери слики',
    hu: 'Képek kiválasztása',
    sk: 'Vybrať obrázky',
    sl: 'Izberi slike',
    es: 'Elegir imágenes',
    fi: 'Valitse kuvat',
  },

  'Remove {{name}}': {
    en: 'Remove {{name}}',
    bg: 'Премахни {{name}}',
    de: 'Entfernen {{name}}',
    fr: 'Supprimer {{name}}',
    ro: 'Elimină {{name}}',
    tr: '{{name}} kaldır',
    sr: 'Уклони {{name}}',
    mk: 'Отстрани {{name}}',
    hu: '{{name}} eltávolítása',
    sk: 'Odstrániť {{name}}',
    sl: 'Odstrani {{name}}',
    es: 'Eliminar {{name}}',
    fi: 'Poista {{name}}',
  },

  'Go to summary': {
    en: 'Go to summary',
    bg: 'Към обобщението',
    de: 'Zur Zusammenfassung',
    fr: 'Aller au résumé',
    ro: 'Vezi rezumat',
    tr: 'Özete git',
    sr: 'Иди на резиме',
    mk: 'Оди на резиме',
    hu: 'Ugrás az összegzéshez',
    sk: 'Prejsť na súhrn',
    sl: 'Pojdi na povzetek',
    es: 'Ir al resumen',
    fi: 'Siirry yhteenvetoon',
  },
  'Origin floor': {
    en: 'Origin floor',
    bg: 'Етаж на взимане',
    de: 'Abhol-Etage',
    fr: "Étage d'origine",
    ro: 'Etaj de ridicare',
    tr: 'Alım katı',
    sr: 'Етаж преузимања',
    mk: 'Етаж на подигнување',
    hu: 'Felvételi emelet',
    sk: 'Podlaží vyzvednutí',
    sl: 'Nadstropje izvora',
    es: 'Piso de origen',
    fi: 'Noutopaikan kerros',
  },

  'Add up to 10 images. JPG and PNG files work best for listing previews.': {
    en: 'Add up to 10 images. JPG and PNG files work best for listing previews.',
    bg: 'Добавете до 10 изображения. JPG и PNG файловете работят най-добре за преглед на обявата.',
    de: 'Fügen Sie bis zu 10 Bilder hinzu. JPG- und PNG-Dateien eignen sich am besten für Vorschauen.',
    fr: "Ajoutez jusqu'à 10 images. Les fichiers JPG et PNG fonctionnent le mieux pour les aperçus.",
    ro: 'Adăugați până la 10 imagini. Fișierele JPG și PNG sunt cele mai bune pentru previzualizări.',
    tr: '10 adede kadar resim ekleyin. JPG ve PNG dosyaları en iyi sonucu verir.',
    sr: 'Додајте до 10 слика. JPG и PNG фајлови су најбољи за преглед.',
    mk: 'Додадете до 10 слики. JPG и PNG датотеките се најдобри за преглед.',
    hu: 'Legfeljebb 10 képet adhat hozzá. JPG és PNG fájlok ajánlottak.',
    sk: 'Pridajte až 10 obrázkov. JPG a PNG sú najlepšie pre náhľad.',
    sl: 'Dodajte do 10 slik. JPG in PNG datoteke so najboljše za predogled.',
    es: 'Añade hasta 10 imágenes. JPG y PNG funcionan mejor.',
    fi: 'Lisää enintään 10 kuvaa. JPG ja PNG toimivat parhaiten.',
  },

  'List a delivery for free and with no commitment': {
    en: 'List a delivery for free and with no commitment',
    bg: 'Публикувайте доставка безплатно и без ангажимент',
    de: 'Lieferung kostenlos und unverbindlich einstellen',
    fr: 'Publiez une livraison gratuitement et sans engagement',
    ro: 'Publică o livrare gratuit și fără angajament',
    tr: 'Teslimatı ücretsiz ve taahhütsüz listele',
    sr: 'Објавите доставу бесплатно и без обавезе',
    mk: 'Објавете достава бесплатно и без обврска',
    hu: 'Hirdessen szállítást ingyenesen és kötelezettség nélkül',
    sk: 'Zverejnite prepravu zadarmo a bez záväzku',
    sl: 'Objavite dostavo brezplačno in brez obveznosti',
    es: 'Publica una entrega gratis y sin compromiso',
    fi: 'Lisää toimitus ilmaiseksi ilman sitoumusta',
  },

  'Preparing listing draft...': {
    en: 'Preparing listing draft...',
    bg: 'Подготвяне на чернова на обявата...',
    de: 'Entwurf der Anzeige wird vorbereitet...',
    fr: "Préparation du brouillon de l'annonce...",
    ro: 'Se pregătește schița listării...',
    tr: 'İlan taslağı hazırlanıyor...',
    sr: 'Припрема нацрта огласа...',
    mk: 'Подготовка на нацрт оглас...',
    hu: 'Hirdetés vázlat készítése...',
    sk: 'Pripravuje sa návrh inzerátu...',
    sl: 'Priprava osnutka oglasa...',
    es: 'Preparando borrador del anuncio...',
    fi: 'Valmistellaan ilmoituksen luonnosta...',
  },

  'Uploading image {{index}} of {{total}}...': {
    en: 'Uploading image {{index}} of {{total}}...',
    bg: 'Качване на изображение {{index}} от {{total}}...',
    de: 'Bild {{index}} von {{total}} wird hochgeladen...',
    fr: "Téléchargement de l'image {{index}} sur {{total}}...",
    ro: 'Se încarcă imaginea {{index}} din {{total}}...',
    tr: '{{total}} resimden {{index}} yükleniyor...',
    sr: 'Отпремање слике {{index}} од {{total}}...',
    mk: 'Прикачување на слика {{index}} од {{total}}...',
    hu: '{{index}} / {{total}} kép feltöltése...',
    sk: 'Nahráva sa obrázok {{index}} z {{total}}...',
    sl: 'Nalagam sliko {{index}} od {{total}}...',
    es: 'Subiendo imagen {{index}} de {{total}}...',
    fi: 'Ladataan kuva {{index}} / {{total}}...',
  },

  'Publishing listing...': {
    en: 'Publishing listing...',
    bg: 'Публикуване на обявата...',
    de: 'Anzeige wird veröffentlicht...',
    fr: "Publication de l'annonce...",
    ro: 'Se publică listarea...',
    tr: 'İlan yayınlanıyor...',
    sr: 'Објављивање огласа...',
    mk: 'Објавување на оглас...',
    hu: 'Hirdetés közzététele...',
    sk: 'Publikovanie inzerátu...',
    sl: 'Objavljanje oglasa...',
    es: 'Publicando anuncio...',
    fi: 'Julkaistaan ilmoitusta...',
  },

  'Listing created!': {
    en: 'Listing created!',
    bg: 'Обявата е създадена!',
    de: 'Anzeige erstellt!',
    fr: 'Annonce créée !',
    ro: 'Listarea a fost creată!',
    tr: 'İlan oluşturuldu!',
    sr: 'Оглас је креиран!',
    mk: 'Огласот е креиран!',
    hu: 'Hirdetés létrehozva!',
    sk: 'Inzerát vytvorený!',
    sl: 'Oglas ustvarjen!',
    es: '¡Anuncio creado!',
    fi: 'Ilmoitus luotu!',
  },

  'Your fixed-price listing is live. Partners can now accept it directly.': {
    en: 'Your fixed-price listing is live. Partners can now accept it directly.',
    bg: 'Вашата обява с фиксирана цена е активна. Партньорите могат да я приемат директно.',
    de: 'Ihre Festpreis-Anzeige ist live. Partner können sie direkt annehmen.',
    fr: "Votre annonce à prix fixe est en ligne. Les partenaires peuvent l'accepter directement.",
    ro: 'Listarea cu preț fix este activă. Partenerii o pot accepta direct.',
    tr: 'Sabit fiyatlı ilanınız yayında. Ortaklar doğrudan kabul edebilir.',
    sr: 'Ваш оглас са фиксном ценом је активан. Партнери га могу директно прихватити.',
    mk: 'Вашиот оглас со фиксна цена е активен. Партнерите можат директно да го прифатат.',
    hu: 'A fix árú hirdetése aktív. A partnerek közvetlenül elfogadhatják.',
    sk: 'Váš inzerát s pevnou cenou je aktívny. Partneri ho môžu prijať priamo.',
    sl: 'Vaš oglas s fiksno ceno je aktiven. Partnerji ga lahko sprejmejo neposredno.',
    es: 'Tu anuncio de precio fijo está activo. Los socios pueden aceptarlo directamente.',
    fi: 'Kiinteähintainen ilmoituksesi on julkaistu. Kumppanit voivat hyväksyä sen suoraan.',
  },

  'Your listing is live. Carriers will send quotes soon.': {
    en: 'Your listing is live. Carriers will send quotes soon.',
    bg: 'Вашата обява е активна. Превозвачите скоро ще изпратят оферти.',
    de: 'Ihre Anzeige ist live. Spediteure senden bald Angebote.',
    fr: 'Votre annonce est en ligne. Les transporteurs enverront bientôt des devis.',
    ro: 'Listarea este activă. Transportatorii vor trimite oferte curând.',
    tr: 'İlanınız yayında. Taşıyıcılar yakında teklif gönderecek.',
    sr: 'Ваш оглас је активан. Превозници ће ускоро послати понуде.',
    mk: 'Вашиот оглас е активен. Превозниците наскоро ќе испратат понуди.',
    hu: 'A hirdetése aktív. A fuvarozók hamarosan ajánlatokat küldenek.',
    sk: 'Váš inzerát je aktívny. Dopravcovia čoskoro pošlú ponuky.',
    sl: 'Vaš oglas je aktiven. Prevozniki bodo kmalu poslali ponudbe.',
    es: 'Tu anuncio está activo. Los transportistas enviarán ofertas pronto.',
    fi: 'Ilmoituksesi on julkaistu. Kuljettajat lähettävät tarjouksia pian.',
  },

  'Could not create listing': {
    en: 'Could not create listing',
    bg: 'Не можа да се създаде обява',
    de: 'Anzeige konnte nicht erstellt werden',
    fr: "Impossible de créer l'annonce",
    ro: 'Nu s-a putut crea listarea',
    tr: 'İlan oluşturulamadı',
    sr: 'Није могуће креирати оглас',
    mk: 'Не може да се креира оглас',
    hu: 'A hirdetés nem hozható létre',
    sk: 'Nepodarilo sa vytvoriť inzerát',
    sl: 'Oglasa ni bilo mogoče ustvariti',
    es: 'No se pudo crear el anuncio',
    fi: 'Ilmoitusta ei voitu luoda',
  },

  'Addresses and dates': {
    en: 'Addresses and dates',
    bg: 'Адреси и дати',
    de: 'Adressen und Daten',
    fr: 'Adresses et dates',
    ro: 'Adrese și date',
    tr: 'Adresler ve tarihler',
    sr: 'Адресе и датуми',
    mk: 'Адреси и датуми',
    hu: 'Címek és dátumok',
    sk: 'Adresy a dátumy',
    sl: 'Naslovi in datumi',
    es: 'Direcciones y fechas',
    fi: 'Osoitteet ja päivämäärät',
  },

  'Pick-up': {
    en: 'Pick-up',
    bg: 'Взимане',
    de: 'Abholung',
    fr: 'Enlèvement',
    ro: 'Ridicare',
    tr: 'Alım',
    sr: 'Преузимање',
    mk: 'Подигнување',
    hu: 'Felvétel',
    sk: 'Vyzdvihnutie',
    sl: 'Prevzem',
    es: 'Recogida',
    fi: 'Nouto',
  },

  'Item details': {
    en: 'Item details',
    bg: 'Детайли за артикула',
    de: 'Artikeldetails',
    fr: "Détails de l'article",
    ro: 'Detalii articol',
    tr: 'Öğe detayları',
    sr: 'Детаљи ставке',
    mk: 'Детали за ставка',
    hu: 'Tétel részletei',
    sk: 'Detaily položky',
    sl: 'Podrobnosti elementa',
    es: 'Detalles del artículo',
    fi: 'Tuotteen tiedot',
  },

  'Non-operable': {
    en: 'Non-operable',
    bg: 'Не е в движение',
    de: 'Nicht fahrbereit',
    fr: 'Non opérationnel',
    ro: 'Neoperațional',
    tr: 'Çalışmıyor',
    sr: 'Није у возном стању',
    mk: 'Не е во возна состојба',
    hu: 'Nem működőképes',
    sk: 'Nepojazdné',
    sl: 'Nevozen',
    es: 'No operable',
    fi: 'Epäkunnossa',
  },

  'Vehicle status': {
    en: 'Vehicle status',
    bg: 'Статус на превозното средство',
    de: 'Fahrzeugstatus',
    fr: 'Statut du véhicule',
    ro: 'Starea vehiculului',
    tr: 'Araç durumu',
    sr: 'Статус возила',
    mk: 'Статус на возилото',
    hu: 'Jármű állapota',
    sk: 'Stav vozidla',
    sl: 'Status vozila',
    es: 'Estado del vehículo',
    fi: 'Ajoneuvon tila',
  },

  'Make & Model': {
    en: 'Make & Model',
    bg: 'Марка и модел',
    de: 'Marke & Modell',
    fr: 'Marque et modèle',
    ro: 'Marcă și model',
    tr: 'Marka ve Model',
    sr: 'Марка и модел',
    mk: 'Марка и модел',
    hu: 'Gyártmány és modell',
    sk: 'Značka a model',
    sl: 'Znamka in model',
    es: 'Marca y modelo',
    fi: 'Merkki ja malli',
  },

  Choose: {
    en: 'Choose',
    bg: 'Избери',
    de: 'Wählen',
    fr: 'Choisir',
    ro: 'Alege',
    tr: 'Seç',
    sr: 'Изабери',
    mk: 'Избери',
    hu: 'Választás',
    sk: 'Vybrať',
    sl: 'Izberi',
    es: 'Elegir',
    fi: 'Valitse',
  },

  'Review each item, quantity and handling status before publishing.': {
    en: 'Review each item, quantity and handling status before publishing.',
    bg: 'Прегледайте всеки артикул, количество и статус на обработка преди публикуване.',
    de: 'Überprüfen Sie jeden Artikel, die Menge und den Status vor der Veröffentlichung.',
    fr: 'Vérifiez chaque article, quantité et statut avant publication.',
    ro: 'Revizuiți fiecare articol, cantitate și stare înainte de publicare.',
    tr: 'Yayınlamadan önce her öğeyi, miktarı ve durumu kontrol edin.',
    sr: 'Проверите сваку ставку, количину и статус пре објављивања.',
    mk: 'Проверете ја секоја ставка, количина и статус пред објавување.',
    hu: 'Ellenőrizze a tételeket, mennyiséget és állapotot közzététel előtt.',
    sk: 'Skontrolujte každú položku, množstvo a stav pred publikovaním.',
    sl: 'Pred objavo preverite vsak element, količino in stanje.',
    es: 'Revise cada artículo, cantidad y estado antes de publicar.',
    fi: 'Tarkista tuotteet, määrät ja tila ennen julkaisua.',
  },

  'Company ({{country}})': {
    en: 'Company ({{country}})',
    bg: 'Компания ({{country}})',
    de: 'Unternehmen ({{country}})',
    fr: 'Entreprise ({{country}})',
    ro: 'Companie ({{country}})',
    tr: 'Şirket ({{country}})',
    sr: 'Компанија ({{country}})',
    mk: 'Компанија ({{country}})',
    hu: 'Cég ({{country}})',
    sk: 'Spoločnosť ({{country}})',
    sl: 'Podjetje ({{country}})',
    es: 'Empresa ({{country}})',
    fi: 'Yritys ({{country}})',
  },

  'country not set': {
    en: 'country not set',
    bg: 'държавата не е зададена',
    de: 'Land nicht festgelegt',
    fr: 'pays non défini',
    ro: 'țara nu este setată',
    tr: 'ülke ayarlanmadı',
    sr: 'држава није подешена',
    mk: 'државата не е поставена',
    hu: 'ország nincs megadva',
    sk: 'krajina nie je nastavená',
    sl: 'država ni nastavljena',
    es: 'país no establecido',
    fi: 'maata ei ole asetettu',
  },

  'Attached images ({{count}})': {
    en: 'Attached images ({{count}})',
    bg: 'Прикачени изображения ({{count}})',
    de: 'Angehängte Bilder ({{count}})',
    fr: 'Images jointes ({{count}})',
    ro: 'Imagini atașate ({{count}})',
    tr: 'Ekli görseller ({{count}})',
    sr: 'Прикачене слике ({{count}})',
    mk: 'Прикачени слики ({{count}})',
    hu: 'Csatolt képek ({{count}})',
    sk: 'Priložené obrázky ({{count}})',
    sl: 'Priložene slike ({{count}})',
    es: 'Imágenes adjuntas ({{count}})',
    fi: 'Liitetyt kuvat ({{count}})',
  },

  Pricing: {
    en: 'Pricing',
    bg: 'Ценообразуване',
    de: 'Preisgestaltung',
    fr: 'Tarification',
    ro: 'Prețuri',
    tr: 'Fiyatlandırma',
    sr: 'Цене',
    mk: 'Цени',
    hu: 'Árazás',
    sk: 'Ceny',
    sl: 'Cene',
    es: 'Precios',
    fi: 'Hinnoittelu',
  },

  'No visible client price set': {
    en: 'No visible client price set',
    bg: 'Няма зададена видима цена за клиента',
    de: 'Kein sichtbarer Kundenpreis festgelegt',
    fr: 'Aucun prix client visible défini',
    ro: 'Nu este setat niciun preț vizibil pentru client',
    tr: 'Görünür müşteri fiyatı ayarlanmadı',
    sr: 'Није постављена видљива цена за клијента',
    mk: 'Нема поставена видлива цена за клиент',
    hu: 'Nincs beállítva látható ügyfélár',
    sk: 'Nie je nastavená viditeľná cena klienta',
    sl: 'Ni nastavljene vidne cene za stranko',
    es: 'No hay precio visible para el cliente',
    fi: 'Ei asetettua näkyvää asiakashintaa',
  },

  'Quotes are disabled. The first partner to accept this price will be assigned automatically.':
    {
      en: 'Quotes are disabled. The first partner to accept this price will be assigned automatically.',
      bg: 'Офертите са изключени. Първият партньор, който приеме тази цена, ще бъде назначен автоматично.',
      de: 'Angebote sind deaktiviert. Der erste Partner, der diesen Preis akzeptiert, wird automatisch zugewiesen.',
      fr: 'Les devis sont désactivés. Le premier partenaire acceptant ce prix sera attribué automatiquement.',
      ro: 'Ofertele sunt dezactivate. Primul partener care acceptă acest preț va fi atribuit automat.',
      tr: 'Teklifler devre dışı. Bu fiyatı kabul eden ilk ortak otomatik atanacaktır.',
      sr: 'Понуде су онемогућене. Први партнер који прихвати цену биће додељен.',
      mk: 'Понудите се исклучени. Првиот партнер што ќе ја прифати цената ќе биде доделен.',
      hu: 'Az ajánlatok le vannak tiltva. Az első partner automatikusan elfogadja.',
      sk: 'Ponuky sú vypnuté. Prvý partner prijímajúci cenu bude priradený.',
      sl: 'Ponudbe so onemogočene. Prvi partner bo samodejno dodeljen.',
      es: 'Las ofertas están desactivadas. El primer socio que acepte el precio será asignado.',
      fi: 'Tarjoukset on poistettu käytöstä. Ensimmäinen kumppani hyväksyy hinnan automaattisesti.',
      el: 'Οι προσφορές είναι απενεργοποιημένες. Ο πρώτος συνεργάτης που θα αποδεχτεί την τιμή θα ανατεθεί αυτόματα.',
    },
  role_partner: {
    en: 'Partner',
    bg: 'Партньор',
    de: 'Partner',
    fr: 'Partenaire',
    ro: 'Partener',
    tr: 'Ortak',
    sr: 'Партнер',
    mk: 'Партнер',
    hu: 'Partner',
    sk: 'Partner',
    sl: 'Partner',
    es: 'Socio',
    fi: 'Yhteistyökumppani',
    el: 'Συνεργάτης',
  },

  role_admin: {
    en: 'Admin',
    bg: 'Администратор',
    de: 'Administrator',
    fr: 'Administrateur',
    ro: 'Administrator',
    tr: 'Yönetici',
    sr: 'Администратор',
    mk: 'Администратор',
    hu: 'Adminisztrátor',
    sk: 'Administrátor',
    sl: 'Administrator',
    es: 'Administrador',
    fi: 'Ylläpitäjä',
    el: 'Διαχειριστής',
  },

  Gold: {
    en: 'Gold',
    bg: 'Златен',
    de: 'Gold',
    fr: 'Or',
    ro: 'Aur',
    tr: 'Altın',
    sr: 'Злато',
    mk: 'Злато',
    hu: 'Arany',
    sk: 'Zlato',
    sl: 'Zlato',
    es: 'Oro',
    fi: 'Kulta',
  },
  Bronze: {
    en: 'Bronze',
    bg: 'Бронзов',
    de: 'Bronze',
    fr: 'Bronze',
    ro: 'Bronz',
    tr: 'Bronz',
    sr: 'Бронза',
    mk: 'Бронза',
    hu: 'Bronz',
    sk: 'Bronz',
    sl: 'Bronasta',
    es: 'Bronce',
    fi: 'Pronssi',
  },
  client: {
    en: 'Client',
    bg: 'Клиент',
    de: 'Kunde',
    fr: 'Client',
    ro: 'Client',
    tr: 'Müşteri',
    sr: 'Клијент',
    mk: 'Клиент',
    hu: 'Ügyfél',
    sk: 'Klient',
    sl: 'Stranka',
    es: 'Cliente',
    fi: 'Asiakas',
    el: 'Πελάτης',
  },
  partner: {
    en: 'Partner',
    bg: 'Партньор',
    de: 'Partner',
    fr: 'Partenaire',
    ro: 'Partener',
    tr: 'Ortak',
    sr: 'Партнер',
    mk: 'Партнер',
    hu: 'Partner',
    sk: 'Partner',
    sl: 'Partner',
    es: 'Socio',
    fi: 'Kumppani',
    el: 'Συνεργάτης',
  },
  admin: {
    en: 'Admin',
    bg: 'Админ',
    de: 'Admin',
    fr: 'Admin',
    ro: 'Admin',
    tr: 'Yönetici',
    sr: 'Админ',
    mk: 'Админ',
    hu: 'Admin',
    sk: 'Admin',
    sl: 'Admin',
    es: 'Admin',
    fi: 'Järjestelmänvalvoja',
  },
  'Q1 2025': {
    en: 'Q1 2025',
    bg: 'Q1 2025',
    de: 'Q1 2025',
    fr: 'T1 2025',
    ro: 'T1 2025',
    tr: '2025 1. Çeyrek',
    sr: 'Q1 2025',
    mk: 'Q1 2025',
    hu: '2025. I. n.év',
    sk: 'Q1 2025',
    sl: 'Q1 2025',
    es: 'T1 2025',
    fi: 'Q1 2025',
  },
  'Q2 2025': {
    en: 'Q2 2025',
    bg: 'Q2 2025',
    de: 'Q2 2025',
    fr: 'T2 2025',
    ro: 'T2 2025',
    tr: '2025 2. Çeyrek',
    sr: 'Q2 2025',
    mk: 'Q2 2025',
    hu: '2025. II. n.év',
    sk: 'Q2 2025',
    sl: 'Q2 2025',
    es: 'T2 2025',
    fi: 'Q2 2025',
  },
  'Orders Delivered': {
    en: 'Orders Delivered',
    bg: 'Доставени поръчки',
    de: 'Gelieferte Bestellungen',
    fr: 'Commandes livrées',
    ro: 'Comenzi livrate',
    tr: 'Teslim Edilen Siparişler',
    sr: 'Испоручене наруџбине',
    mk: 'Испорачани нарачки',
    hu: 'Kézbesített rendelések',
    sk: 'Doručené objednávky',
    sl: 'Dostavljena naročila',
    es: 'Pedidos entregados',
    fi: 'Toimitetut tilaukset',
  },
  'Cars Delivered': {
    en: 'Cars Delivered',
    bg: 'Доставени автомобили',
    de: 'Gelieferte Autos',
    fr: 'Voitures livrées',
    ro: 'Mașini livrate',
    tr: 'Teslim Edilen Arabalar',
    sr: 'Испоручени аутомобили',
    mk: 'Испорачани автомобили',
    hu: 'Kézbesített autók',
    sk: 'Doručené autá',
    sl: 'Dostavljeni avtomobili',
    es: 'Coches entregados',
    fi: 'Toimitetut autot',
  },
  'Avg. Assign to Pick-up': {
    en: 'Avg. Assign to Pick-up',
    bg: 'Средно време от назначаване до взимане',
    de: 'Durchschnittliche Zeit von Zuweisung bis Abholung',
    fr: 'Moyenne. Attribution à la prise en charge',
    ro: 'Medie. Atribuire la preluare',
    tr: 'Ortalama. Atama ile Alım Arasında',
    sr: 'Просечно. Додељивање до преузимања',
    mk: 'Просечно. Доделување до преземање',
    hu: 'Átlagos. Kijelöléstől az átvételig',
    sk: 'Priemer. Priradenie k vyzdvihnutiu',
    sl: 'Povprečje. Dodelitev do prevzema',
    es: 'Promedio. Asignación a la recogida',
    fi: 'Keskim. Määritys noutoon',
  },
  'Correctly Planned Orders': {
    en: 'Correctly Planned Orders',
    bg: 'Правилно планирани поръчки',
    de: 'Korrekt geplante Bestellungen',
    fr: 'Commandes correctement planifiées',
    ro: 'Comenzi planificate corect',
    tr: 'Doğru Planlanmış Siparişler',
    sr: 'Правилно планиране наруџбине',
    mk: 'Правилно планирани нарачки',
    hu: 'Helyesen megtervezett rendelések',
    sk: 'Správne naplánované objednávky',
    sl: 'Pravilno načrtovana naročila',
    es: 'Pedidos correctamente planificados',
    fi: 'Oikein suunnitellut tilaukset',
  },
  'Plan Changes': {
    en: 'Plan Changes',
    bg: 'Промени в плана',
    de: 'Planänderungen',
    fr: 'Changements de plan',
    ro: 'Modificări ale planului',
    tr: 'Plan Değişiklikleri',
    sr: 'Промене плана',
    mk: 'Промени во планот',
    hu: 'Tervmódosítások',
    sk: 'Zmeny plánu',
    sl: 'Spremembe načrta',
    es: 'Cambios de plan',
    fi: 'Suunnitelman muutokset',
  },
  'Orders cancelled': {
    en: 'Orders cancelled',
    bg: 'Анулирани поръчки',
    de: 'Stornierte Bestellungen',
    fr: 'Commandes annulées',
    ro: 'Comenzi anulate',
    tr: 'İptal edilen siparişler',
    sr: 'Отказане наруџбине',
    mk: 'Откажани нарачки',
    hu: 'Törölt rendelések',
    sk: 'Zrušené objednávky',
    sl: 'Preklicana naročila',
    es: 'Pedidos cancelados',
    fi: 'Peruutetut tilaukset',
  },
  'Are you sure you want to cancel order {{id}}? This action cannot be undone.':
    {
      en: 'Are you sure you want to cancel order {{id}}? This action cannot be undone.',
      bg: 'Сигурни ли сте, че искате да отмените поръчка {{id}}? Това действие не може да бъде отменено.',
      de: 'Sind Sie sicher, dass Sie die Bestellung {{id}} stornieren möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      fr: 'Êtes-vous sûr de vouloir annuler la commande {{id}} ? Cette action est irréversible.',
      ro: 'Sigur doriți să anulați comanda {{id}}? Această acțiune nu poate fi anulată.',
      tr: '{{id}} numaralı siparişi iptal etmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
      sr: 'Да ли сте сигурни да желите да откажете поруџбину {{id}}? Ова радња се не може поништити.',
      mk: 'Дали сте сигурни дека сакате да ја откажете нарачката {{id}}? Оваа акција не може да се поништи.',
      hu: 'Biztosan törölni szeretné a(z) {{id}} rendelést? Ez a művelet nem vonható vissza.',
      sk: 'Naozaj chcete zrušiť objednávku {{id}}? Túto akciu nie je možné vrátiť späť.',
      sl: 'Ali ste prepričani, da želite preklicati naročilo {{id}}? Tega dejanja ni mogoče razveljaviti.',
      es: '¿Está seguro de que desea cancelar el pedido {{id}}? Esta acción no se puede deshacer.',
      fi: 'Haluatko varmasti peruuttaa tilauksen {{id}}? Tätä toimintoa ei voi kumota.',
    },

  'Orders Added': {
    en: 'Orders Added',
    bg: 'Добавени поръчки',
    de: 'Bestellungen hinzugefügt',
    fr: 'Commandes ajoutées',
    ro: 'Comenzi adăugate',
    tr: 'Eklenen Siparişler',
    sr: 'Додате наруџбине',
    mk: 'Додадени нарачки',
    hu: 'Hozzáadott rendelések',
    sk: 'Pridané objednávky',
    sl: 'Dodana naročila',
    es: 'Pedidos añadidos',
    fi: 'Lisätyt tilaukset',
  },
  'Wheels of Excellence — modernized overview': {
    en: 'Wheels of Excellence — modernized overview',
    bg: 'Колела на съвършенството — модернизиран преглед',
    de: 'Räder der Exzellenz – modernisierter Überblick',
    fr: "Roues d'excellence - aperçu modernisé",
    ro: 'Roțile excelenței - prezentare modernizată',
    tr: 'Mükemmellik Tekerlekleri — modernize edilmiş genel bakış',
    sr: 'Точкови изврсности — модернизовани преглед',
    mk: 'Тркала на извонредност — модернизиран преглед',
    hu: 'A kiválóság kerekei – modernizált áttekintés',
    sk: 'Kolesá excelentnosti — modernizovaný prehľad',
    sl: 'Kolesa odličnosti – posodobljen pregled',
    es: 'Ruedas de excelencia: descripción modernizada',
    fi: 'Huippuosaamisen pyörät – modernisoitu yleiskatsaus',
  },
  'Current Quarter': {
    en: 'Current Quarter',
    bg: 'Текущо тримесечие',
    de: 'Aktuelles Quartal',
    fr: 'Trimestre fleurant',
    ro: 'Trimestrul curent',
    tr: 'Mevcut Çeyrek',
    sr: 'Тренутни квартал',
    mk: 'Тековен квартал',
    hu: 'Jelenlegi negyedév',
    sk: 'Aktuálny štvrťrok',
    sl: 'Trenutno četrtletje',
    es: 'Trimestre actual',
    fi: 'Nykyinen vuosineljännes',
  },
  Rank: {
    en: 'Rank',
    bg: 'Ранг',
    de: 'Rang',
    fr: 'Rang',
    ro: 'Rang',
    tr: 'Sıra',
    sr: 'Ранг',
    mk: 'Ранг',
    hu: 'Rang',
    sk: 'Poradie',
    sl: 'Uvrstitev',
    es: 'Rango',
    fi: 'Sijoitus',
  },
  Score: {
    en: 'Score',
    bg: 'Резултат',
    de: 'Punktzahl',
    fr: 'Score',
    ro: 'Scor',
    tr: 'Puan',
    sr: 'Скор',
    mk: 'Скор',
    hu: 'Pontszám',
    sk: 'Skóre',
    sl: 'Rezultat',
    es: 'Puntuación',
    fi: 'Pisteet',
  },
  'Cancelled Bookings': {
    en: 'Cancelled Bookings',
    bg: 'Анулирани резервации',
    de: 'Stornierte Buchungen',
    fr: 'Réservations fleuries',
    ro: 'Rezervări anulate',
    tr: 'İptal Edilen Rezervasyonlar',
    sr: 'Отказане резервације',
    mk: 'Откажани резервации',
    hu: 'Törölt foglalások',
    sk: 'Zrušené rezervácie',
    sl: 'Preklicane rezervacije',
    es: 'Reservas canceladas',
    fi: 'Peruutetut varaukset',
  },
  'Delivered Bookings': {
    en: 'Delivered Bookings',
    bg: 'Доставени резервации',
    de: 'Gelieferte Buchungen',
    fr: 'Réservations livrées',
    ro: 'Rezervări livrate',
    tr: 'Teslim Edilen Rezervasyonlar',
    sr: 'Испоручене резервације',
    mk: 'Испорачани резервации',
    hu: 'Kézbesített foglalások',
    sk: 'Doručené rezervácie',
    sl: 'Dostavljene rezervacije',
    es: 'Reservas entregadas',
    fi: 'Toimitetut varaukset',
  },
  'Transport Titan score': {
    en: 'Transport Titan score',
    bg: 'Резултат на транспортния титан',
    de: 'Transport-Titan-Punktzahl',
    fr: 'Score de Titan du Transport',
    ro: 'Scorul Titanului de Transport',
    tr: 'Ulaşım Titan puanı',
    sr: 'Скор транспортног титана',
    mk: 'Скор на транспортниот титан',
    hu: 'Szállítási Titán pontszám',
    sk: 'Skóre dopravného titána',
    sl: 'Rezultat transportnega titana',
    es: 'Puntuación de Titán del Transporte',
    fi: 'Kuljetuksen Titaani-pisteet',
  },
  Days: {
    en: 'Days',
    bg: 'дни',
    de: 'Tage',
    fr: 'jours',
    ro: 'zile',
    tr: 'Gün',
    sr: 'дана',
    mk: 'дена',
    hu: 'nap',
    sk: 'dní',
    sl: 'dni',
    es: 'días',
    fi: 'päivää',
  },
  'Q3 2025': {
    en: 'Q3 2025',
    bg: 'Q3 2025',
    de: 'Q3 2025',
    fr: 'T3 2025',
    ro: 'T3 2025',
    tr: '2025 3. Çeyrek',
    sr: 'Q3 2025',
    mk: 'Q3 2025',
    hu: '2025. III. n.év',
    sk: 'Q3 2025',
    sl: 'Q3 2025',
    es: 'T3 2025',
    fi: 'Q3 2025',
  },
  'Not achieved yet': {
    en: 'Not achieved yet',
    bg: 'Все още не е постигнато',
    de: 'Noch nicht erreicht',
    fr: 'Pas encore fleuri',
    ro: 'Nu a fost încă atins',
    tr: 'Henüz ulaşılmadı',
    sr: 'Још није постигнуто',
    mk: 'Сè уште не е постигнато',
    hu: 'Még nem érték el',
    sk: 'Zatiaľ nedosiahnuté',
    sl: 'Še ni doseženo',
    es: 'Aún no se ha logrado',
    fi: 'Ei vielä saavutettu',
  },
  'Additional Metrics': {
    en: 'Additional Metrics',
    bg: 'Допълнителни показатели',
    de: 'Zusätzliche Metriken',
    fr: 'Métriques florales',
    ro: 'Metrici suplimentare',
    tr: 'Ek Metrikler',
    sr: 'Додатне метрике',
    mk: 'Дополнителни метрики',
    hu: 'További metrikák',
    sk: 'Ďalšie metriky',
    sl: 'Dodatne metrike',
    es: 'Métricas adicionales',
    fi: 'Lisämittarit',
  },
  'Previous Quarters': {
    en: 'Previous Quarters',
    bg: 'Предишни тримесечия',
    de: 'Frühere Quartale',
    fr: 'Trimestres floraux',
    ro: ' trimestrele anterioare',
    tr: 'Önceki Çeyrekler',
    sr: 'Претходни квартали',
    mk: 'Претходни квартали',
    hu: 'Előző negyedévek',
    sk: 'Predchádzajúce štvrťroky',
    sl: 'Pretekla četrtletja',
    es: 'Trimestres anteriores',
    fi: 'Aiemmat neljännekset',
  },
  Quarter: {
    en: 'Quarter',
    bg: 'тримесечие',
    de: 'Quartal',
    fr: 'Trimestre',
    ro: 'Trimestru',
    tr: 'Çeyrek',
    sr: 'Квартал',
    mk: 'Квартал',
    hu: 'Negyedév',
    sk: 'Štvrťrok',
    sl: 'Četrtletje',
    es: 'Trimestre',
    fi: 'Neljännes',
  },
  'Total orders': {
    en: 'Total orders',
    bg: 'Общо поръчки',
    de: 'Gesamtbestellungen',
    fr: 'Total des commandes',
    ro: 'Total comenzi',
    tr: 'Toplam siparişler',
    sr: 'Укупне наруџбине',
    mk: 'Вкупни нарачки',
    hu: 'Összes rendelés',
    sk: 'Celkový počet objednávok',
    sl: 'Skupna naročila',
    es: 'Total de pedidos',
    fi: 'Tilaukset yhteensä',
  },
  Speed: {
    en: 'Speed',
    bg: 'Скорост',
    de: 'Geschwindigkeit',
    fr: 'Vitesse',
    ro: 'Viteză',
    tr: 'Hız',
    sr: 'Брзина',
    mk: 'Брзина',
    hu: 'Sebesség',
    sk: 'Rýchlosť',
    sl: 'Hitrost',
    es: 'Velocidad',
    fi: 'Nopeus',
  },
  'Total score': {
    en: 'Total score',
    bg: 'Общ резултат',
    de: 'Gesamtpunktzahl',
    fr: 'Score total',
    ro: 'Scor total',
    tr: 'Toplam puan',
    sr: 'Укупан скор',
    mk: 'Вкупен скор',
    hu: 'Teljes pontszám',
    sk: 'Celkové skóre',
    sl: 'Skupni rezultat',
    es: 'Puntuación total',
    fi: 'Kokonaispisteet',
  },
  'Speed Score': {
    en: 'Speed Score',
    bg: 'Резултат за скорост',
    de: 'Geschwindigkeitsbewertung',
    fr: 'Score de vitesse',
    ro: 'Scor de viteză',
    tr: 'Hız Puanı',
    sr: 'Оцена брзине',
    mk: 'Оценка за брзина',
    hu: 'Sebesség pontszám',
    sk: 'Hodnotenie rýchlosti',
    sl: 'Ocena hitrosti',
    es: 'Puntuación de velocidad',
    fi: 'Nopeuspisteet',
  },
  'Planning Score': {
    en: 'Planning Score',
    bg: 'Планиран резултат',
    de: 'Planungsbewertung',
    fr: 'Score de planification',
    ro: 'Scor de planificare',
    tr: 'Planlama Puanı',
    sr: 'Оцена планирања',
    mk: 'Оценка за планирање',
    hu: 'Tervezési pontszám',
    sk: 'Hodnotenie plánovania',
    sl: 'Ocena načrtovanja',
    es: 'Puntuación de planificación',
    fi: 'Suunnittelupisteet',
  },
  'Order ID': {
    en: 'Order ID',
    bg: 'Номер на поръчка',
    de: 'Bestellnummer',
    fr: 'ID de commande',
    ro: 'ID comandă',
    tr: 'Siparis ID',
    sr: 'ИД наруџбине',
    mk: 'ИД нарачка',
    hu: 'Rendeles azonosito',
    sk: 'ID objednavky',
    sl: 'ID narocila',
    es: 'ID de pedido',
    fi: 'Tilaus ID',
  },
  'Payment status': {
    en: 'Payment status',
    bg: 'Статус на плащане',
    de: 'Zahlungsstatus',
    fr: 'Statut de paiement',
    ro: 'Stare plata',
    tr: 'Odeme durumu',
    sr: 'Статус плаћања',
    mk: 'Статус на плаќање',
    hu: 'Fizetesi allapot',
    sk: 'Stav platby',
    sl: 'Stanje placila',
    es: 'Estado de pago',
    fi: 'Maksun tila',
  },
  Paid: {
    en: 'Paid',
    bg: 'Платено',
    de: 'Bezahlt',
    fr: 'Payé',
    ro: 'Platit',
    tr: 'Odenmis',
    sr: 'Плаћено',
    mk: 'Платено',
    hu: 'Fizetve',
    sk: 'Zaplatené',
    sl: 'Pla?ano',
    es: 'Pagado',
    fi: 'Maksettu',
  },
  'Awaiting payment': {
    en: 'Awaiting payment',
    bg: 'Очакване на плащане',
    de: 'Zahlung ausstehend',
    fr: 'En attente de paiement',
    ro: 'In asteptarea platii',
    tr: 'Odeme bekleniyor',
    sr: 'Чека се плаћање',
    mk: 'Чекање на плаќање',
    hu: 'Fizetes varhato',
    sk: 'Cakanie na platbu',
    sl: 'Cakanje na placilo',
    es: 'En espera de pago',
    fi: 'Odottaa maksua',
  },
  'Find the right order': {
    en: 'Find the right order',
    bg: 'Намерете правилната поръчка',
    de: 'Finden Sie die richtige Bestellung',
    fr: 'Trouver la bonne commande',
    ro: 'Gasi?i comanda potrivita',
    tr: 'Dogru siparisi bulun',
    sr: 'Пронађите праву наруџбину',
    mk: 'Најдете ја вистинската нарачка',
    hu: 'Talalja meg a megfelelo rendelest',
    sk: 'Najdite spravnu objednavku',
    sl: 'Poiscite pravo narocilo',
    es: 'Encuentra el pedido correcto',
    fi: 'Loyda oikea tilaus',
  },
  'Match the wizard styling with graceful mobile stacking by using the shortcut controls below.':
    {
      en: 'Match the wizard styling with graceful mobile stacking by using the shortcut controls below.',
      bg: 'Съчетайте стила на съветника с грациозно мобилно подреждане, като използвате контролите за бърз достъп по-долу.',
      de: 'Passen Sie das Styling des Assistenten mit anmutigem mobilem Stapeln an, indem Sie die folgenden Shortcut-Steuerelemente verwenden.',
      fr: "Associez le style de l'assistant a un empilement mobile gracieux a l'aide des commandes de raccourci ci-dessous.",
      ro: 'Potrivi?i stilul expertului cu stivuirea mobila gra?ioasa utilizand controalele de comanda rapida de mai jos.',
      tr: 'Asag?daki k?sayol kontrollerini kullanarak sihirbaz stilini zarif mobil istifleme ile eslestirin.',
      sr: 'Упарите стил чаробњака са грациозним мобилним слагањем помоћу контрола пречица испод.',
      mk: 'Поклопете го стилот на волшебникот со грациозно мобилно редење со користење на контролите за кратенки подолу.',
      hu: 'Parositsa a varazslo stilusat a kecses mobil halmozassal az alabbi parancsikonok segitsegevel.',
      sk: 'Zladte styl sprievodcu s elegantnym mobilnym skladanim pomocou klavesovych skratiek nizsie.',
      sl: 'Ujemajte slog carovnika z elegantnim zlaganjem za mobilne naprave z uporabo bliznjic spodaj.',
      es: 'Haga coincidir el estilo del asistente con el apilamiento movil elegante usando los controles de acceso directo a continuacion.',
      fi: 'Yhdista ohjatun toiminnon muotoilu siroon mobiilipinoon kayttamalla alla olevia pikavalintapainikkeita.',
    },
  Sorting: {
    en: 'Sorting',
    bg: 'Сортиране',
    de: 'Sortierung',
    fr: 'Tri',
    ro: 'Sortare',
    tr: 'S?ralama',
    sr: 'Сортирање',
    mk: 'Сортирање',
    hu: 'Valogatas',
    sk: 'Triedenie',
    sl: 'Razvrscanje',
    es: 'Clasificacion',
    fi: 'Lajittelu',
  },
  'Keep an eye on the route and quote at a glance.': {
    en: 'Keep an eye on the route and quote at a glance.',
    bg: 'Следете маршрута и офертата с един поглед.',
    de: 'Behalten Sie die Route und das Angebot auf einen Blick im Auge.',
    fr: "Gardez un oeil sur l'itineraire et le devis en un coup d'oeil.",
    ro: 'Urmariti ruta si oferta dintr-o privire.',
    tr: 'Rotayi ve teklifi bir bakista takip edin.',
    sr: 'Пратите руту и понуду на први поглед.',
  },
  'Ready from date · Newest first': {
    en: 'Ready from date · Newest first',
    bg: 'Готово от дата · Първо най-новите',
    de: 'Fertig ab Datum · Neueste zuerst',
    fr: 'Pret a partir de la date · Le plus recent en premier',
    ro: 'Gata de la data · Cele mai noi mai intai',
    tr: 'Tarihten itibaren haz?r · Once en yeni',
    sr: 'Спремно од датума · Најновије прво',
    mk: 'Подготвено од датум · Најнови на почеток',
    hu: 'Kesz a datumtol · Legujabb elol',
    sk: 'Pripravene od datumu · Najnovsie ako prve',
    sl: 'Pripravljeno od datuma · Najnovejse najprej',
    es: 'Listo desde la fecha · El mas reciente primero',
    fi: 'Valmis paivamaarasta · Uusin ensin',
  },
  'Ready from date · Oldest first': {
    en: 'Ready from date · Oldest first',
    bg: 'Готово от дата · Най-стари първо',
    de: 'Fertig ab Datum · Alteste zuerst',
    fr: 'Pret a partir de la date · Le plus ancien en premier',
    ro: 'Gata de la data · Cele mai vechi mai intai',
    tr: 'Tarihten itibaren haz?r · Once en eski',
    sr: 'Спремно од датума · Најстарије прво',
    mk: 'Подготвено од датум · Најстари на почеток',
    hu: 'Kesz a datumtol · Legregebbi elol',
    sk: 'Pripravene od datumu · Najstarsie ako prve',
    sl: 'Pripravljeno od datuma · Najstarejse najprej',
    es: 'Listo desde la fecha · El mas antiguo primero',
    fi: 'Valmis paivamaarasta · Vanhin ensin',
  },
  Search: {
    en: 'Search',
    bg: 'Търсене',
    de: 'Suche',
    fr: 'Rechercher',
    ro: 'Cautare',
    tr: 'Arama',
    sr: 'Претрага',
    mk: 'Пребарување',
    hu: 'Kereses',
    sk: 'Vyhladavanie',
    sl: 'Iskanje',
    es: 'Buscar',
    fi: 'Hae',
  },
  'Payment instructions': {
    en: 'Payment instructions',
    bg: 'Инструкции за плащане',
    de: 'Zahlungsanweisungen',
    fr: 'Instructions de paiement',
    ro: 'Instrucțiuni de plată',
    tr: 'Odeme talimatlari',
    sr: 'Упутства за плаћање',
    mk: 'Упатства за плаќање',
    hu: 'Fizetesi utasitasok',
    sk: 'Pokyny na platbu',
    sl: 'Navodila za placilo',
    es: 'Instrucciones de pago',
    fi: 'Maksuohjeet',
  },
  'Search by ID, Ref, City': {
    en: 'Search by ID, Ref, City',
    bg: 'Търсене по идентификатор, референция и град',
    de: 'Suche nach ID, Ref, Stadt',
    fr: 'Rechercher par ID, Ref, Ville',
    ro: 'Cautare dupa ID, Ref, Oras',
    tr: 'ID, Ref, Sehire gore ara',
    sr: 'Претрага по ИД, Реф, Град',
    mk: 'Пребарување по ИД, Реф, Град',
    hu: 'Kereses azonosito, Ref, Varos szerint',
    sk: 'Vyhladavanie podla ID, Ref, Mesto',
    sl: 'Iskanje po ID, Ref, Mesto',
    es: 'Buscar por ID, Ref, Ciudad',
    fi: 'Hae tunnuksella, viitteella, kaupungilla',
  },
  'No orders match your criteria.': {
    en: 'No orders match your criteria.',
    bg: 'Няма поръчки, които да отговарят на вашите критерии.',
    de: 'Keine Bestellungen entsprechen Ihren Kriterien.',
    fr: 'Aucune commande ne correspond a vos criteres.',
    ro: 'Nicio comanda nu corespunde criteriilor dvs.',
    tr: 'Kriterlerinize uygun siparis bulunamad?.',
    sr: 'Ниједна наруџбина не одговара вашим критеријумима.',
    mk: 'Нема нарачки што одговараат на вашите критериуми.',
    hu: 'Nincs a felteteleknek megfelelo rendeles.',
    sk: 'Ziadne objednavky nezodpovedaju vasim kriteriam.',
    sl: 'Nobeno narocilo ne ustreza vasim kriterijem.',
    es: 'Ningun pedido coincide con sus criterios.',
    fi: 'Yksikaan tilaus ei vastaa hakuehtojasi.',
  },
  Preplanned: {
    en: 'Preplanned',
    bg: 'Предварително планирано',
    de: 'Vorgeplant',
    fr: 'Pre-planifie',
    ro: 'Pre-planificat',
    tr: 'Onceden planlanm?s',
    sr: 'Унапред планирано',
    mk: 'Однапред испланирано',
    hu: 'Elore tervezett',
    sk: 'Vopred naplanovane',
    sl: 'Vnaprej nacrtovano',
    es: 'Pre-planificado',
    fi: 'Esisuunniteltu',
  },
  Planned: {
    en: 'Planned',
    bg: 'Планирано',
    de: 'Geplant',
    fr: 'Planifie',
    ro: 'Planificat',
    tr: 'Planlanm?s',
    sr: 'Планирано',
    mk: 'Планирано',
    hu: 'Tervezett',
    sk: 'Planovane',
    sl: 'Nacrtovano',
    es: 'Planificado',
    fi: 'Suunniteltu',
  },
  'Picked up': {
    en: 'Picked up',
    bg: 'Взето',
    de: 'Abgeholt',
    fr: 'Recupere',
    ro: 'Preluat',
    tr: 'Teslim al?nd?',
    sr: 'Покупљено',
    mk: 'Подигнато',
    hu: 'Felvett',
    sk: 'Vyzdvihnute',
    sl: 'Prevzeto',
    es: 'Recogido',
    fi: 'Noudettu',
  },
  Delivered: {
    en: 'Delivered',
    bg: 'Доставено',
    de: 'Geliefert',
    fr: 'Livre',
    ro: 'Livrat',
    tr: 'Teslim edildi',
    sr: 'Достављено',
    mk: 'Доставено',
    hu: 'Kiszallitva',
    sk: 'Dorucene',
    sl: 'Dostavljeno',
    es: 'Entregado',
    fi: 'Toimitettu',
  },
  Canceled: {
    en: 'Canceled',
    bg: 'Отменено',
    de: 'Storniert',
    fr: 'Annule',
    ro: 'Anulat',
    tr: 'Iptal edildi',
    sr: 'Отказано',
    mk: 'Откажано',
    hu: 'Torolve',
    sk: 'Zrusene',
    sl: 'Preklicano',
    es: 'Cancelado',
    fi: 'Peruutettu',
  },
  'Cancel order': {
    en: 'Cancel order',
    bg: 'Отмени поръчка',
    de: 'Bestellung stornieren',
    fr: 'Annuler la commande',
    ro: 'Anulează comanda',
    tr: 'Siparişi iptal et',
    sr: 'Откажи поруџбину',
    mk: 'Откажи нарачка',
    hu: 'Rendelés törlése',
    sk: 'Zrušiť objednávku',
    sl: 'Prekliči naročilo',
    es: 'Cancelar pedido',
    fi: 'Peruuta tilaus',
  },

  All: {
    en: 'All',
    bg: 'Всички',
    de: 'Alle',
    fr: 'Tous',
    ro: 'Toate',
    tr: 'Tumu',
    sr: 'Све',
    mk: 'Сите',
    hu: 'Mind',
    sk: 'Vsetky',
    sl: 'Vse',
    es: 'Todos',
    fi: 'Kaikki',
  },
  'Client ref · {order.clientRef}': {
    en: 'Client ref · {order.clientRef}',
    bg: 'Клиентска реф. · {order.clientRef}',
    de: 'Kundenref. · {order.clientRef}',
    fr: 'Ref. client · {order.clientRef}',
    ro: 'Ref. client · {order.clientRef}',
    tr: 'Musteri ref. · {order.clientRef}',
    sr: 'Клијент реф. · {order.clientRef}',
    mk: 'Реф. на клиент · {order.clientRef}',
    hu: 'Ugyfelhivatkozas · {order.clientRef}',
    sk: 'Ref. klienta · {order.clientRef}',
    sl: 'Referenca stranke · {order.clientRef}',
    es: 'Ref. cliente · {order.clientRef}',
    fi: 'Asiakasviite · {order.clientRef}',
  },
  'Planned for': {
    en: 'Planned for',
    bg: 'Планирано за ',
    de: 'Geplant fur',
    fr: 'Prevu pour',
    ro: 'Planificat pentru',
    tr: 'Planlanan',
    sr: 'Планирано за',
    mk: 'Планирано за',
    hu: 'Tervezett',
    sk: 'Planovane na',
    sl: 'Nacrtovano za',
    es: 'Planificado para',
    fi: 'Suunniteltu',
  },
  TBD: {
    en: 'TBD',
    bg: 'Ще бъде определено',
    de: 'Noch zu bestimmen',
    fr: 'A determiner',
    ro: 'De stabilit',
    tr: 'Belirlenecek',
    sr: 'Биће одређено',
    mk: 'Ќе биде одредено',
    hu: 'Meghatarozando',
    sk: 'Bude stanovene',
    sl: 'Bo doloceno',
    es: 'Por determinar',
    fi: 'Paatetaan myohemmin',
  },
  'Driver info': {
    en: 'Driver info',
    bg: 'Информация за шофьора',
    de: 'Fahrerinfo',
    fr: 'Infos chauffeur',
    ro: 'Informa?ii ?ofer',
    tr: 'Surucu bilgisi',
    sr: 'Информације о возачу',
    mk: 'Информации за возачот',
    hu: 'Sofor adatai',
    sk: 'Informacie o vodicovi',
    sl: 'Informacije o vozniku',
    es: 'Informacion del conductor',
    fi: 'Kuljettajan tiedot',
  },
  'No driver has been assigned yet': {
    en: 'No driver has been assigned yet',
    bg: 'Все още не е назначен шофьор',
    de: 'Es wurde noch kein Fahrer zugewiesen',
    fr: "Aucun chauffeur n'a encore ete assigne",
    ro: 'Nu a fost inca alocat niciun ?ofer',
    tr: 'Henuz bir surucu atanmad?',
    sr: 'Још увек није додељен возач',
    mk: 'Сe уште не е доделен возач',
    hu: 'Meg nincs hozzarendelve sofor',
    sk: 'Zatial nebol prideleny ziadny vodic',
    sl: 'Voznik se ni bil dodeljen',
    es: 'Aun no se ha asignado ningun conductor',
    fi: 'Kuljettajaa ei ole viela maaritetty',
  },
  'When a partner picks up this order, a driver will be assigned': {
    en: 'When a partner picks up this order, a driver will be assigned',
    bg: 'Когато партньор вземе тази поръчка, ще бъде назначен шофьор',
    de: 'Wenn ein Partner diese Bestellung abholt, wird ein Fahrer zugewiesen',
    fr: "Lorsqu'un partenaire recupere cette commande, un chauffeur sera assigne",
    ro: 'Cand un partener preia aceasta comanda, va fi alocat un ?ofer',
    tr: 'Bir ortak bu siparisi ald?g?nda bir surucu atanacakt?r',
    sr: 'Када партнер преузме ову наруџбину, биће додељен возач',
    mk: 'Кога партнер ќе ја подигне оваа нарачка, ќе биде доделен возач',
    hu: 'Amikor egy partner felveszi ezt a rendelest, hozza lesz rendelve egy sofor',
    sk: 'Ked partner vyzdvihne tuto objednavku, bude prideleny vodic',
    sl: 'Ko partner prevzame to narocilo, bo dodeljen voznik',
    es: 'Cuando un socio recoja este pedido, se asignara un conductor',
    fi: 'Kun kumppani noutaa taman tilauksen, kuljettaja maaritetaan',
  },
  'Route summary': {
    en: 'Route summary',
    bg: 'Обобщение на маршрута',
    de: 'Routenzusammenfassung',
    fr: 'Resume de l’itineraire',
    ro: 'Rezumatul rutei',
    tr: 'Rota ozeti',
    sr: 'Резиме руте',
    mk: 'Резиме на рутата',
    hu: 'Utvonal osszesitese',
    sk: 'Zhrnutie trasy',
    sl: 'Povzetek poti',
    es: 'Resumen de la ruta',
    fi: 'Reitin yhteenveto',
  },
  Vehicle: {
    en: 'Vehicle',
    bg: 'Превозно средство',
    de: 'Fahrzeug',
    fr: 'Véhicule',
    ro: 'Vehicul',
    tr: 'Araç',
    sr: 'Возило',
    mk: 'Возило',
    hu: 'Jarmu',
    sk: 'Vozidlo',
    sl: 'Vozilo',
    es: 'Vehículo',
    fi: 'Ajoneuvo',
  },
  Quantity: {
    en: 'Quantity',
    bg: 'Количество',
    de: 'Menge',
    fr: 'Quantité',
    ro: 'Cantitate',
    tr: 'Miktar',
    sr: 'Количина',
    mk: 'Количина',
    hu: 'Mennyiseg',
    sk: 'Mnozstvo',
    sl: 'Kolicina',
    es: 'Cantidad',
    fi: 'Maara',
  },
  Weight: {
    en: 'Weight',
    bg: 'Тегло',
    de: 'Gewicht',
    fr: 'Poids',
    ro: 'Greutate',
    tr: 'Agirlik',
    sr: 'Тежина',
    mk: 'Тежина',
    hu: 'Suly',
    sk: 'Hmotnost',
    sl: 'Teza',
    es: 'Peso',
    fi: 'Paino',
  },
  'VIN / Chassis': {
    en: 'VIN / Chassis',
    bg: 'VIN / Шаси',
    de: 'VIN / Fahrgestell',
    fr: 'VIN / Chassis',
    ro: 'VIN / Sasiu',
    tr: 'VIN / Sase',
    sr: 'ВИН / Шасија',
    mk: 'ВИН / Шасија',
    hu: 'VIN / Alvaz',
    sk: 'VIN / Podvozok',
    sl: 'VIN / Podvozje',
    es: 'VIN / Chasis',
    fi: 'VIN / Alusta',
  },
  'Pick up': {
    en: 'Pick up',
    bg: 'Вземане',
    de: 'Abholung',
    fr: 'Ramasser',
    ro: 'Preluare',
    tr: 'Alma',
    sr: 'Преузимање',
    mk: 'Подигнување',
    hu: 'Felvetel',
    sk: 'Vyzdvihnutie',
    sl: 'Prevzem',
    es: 'Recoger',
    fi: 'Nouto',
  },
  'Ready from': {
    en: 'Ready from',
    bg: 'Готово от',
    de: 'Fertig ab',
    fr: 'Pret a partir de',
    ro: 'Gata de la',
    tr: 'Haz?rdan itibaren',
    sr: 'Спремно од',
    mk: 'Подготвено од',
    hu: 'Kesz a',
    sk: 'Pripravene od',
    sl: 'Pripravljeno od',
    es: 'Listo desde',
    fi: 'Valmis alkaen',
  },
  'Use the details below to transfer the outstanding balance. Always include the reference so we can match your payment to the correct order.':
    {
      en: 'Use the details below to transfer the outstanding balance. Always include the reference so we can match your payment to the correct order.',
      bg: 'Използвайте подробностите по-долу, за да прехвърлите неизплатения баланс. Винаги включвайте референцията, за да можем да съпоставим плащането ви с правилната поръчка.',
      de: 'Verwenden Sie die unten stehenden Angaben, um den ausstehenden Saldo zu uberweisen. Geben Sie immer die Referenz an, damit wir Ihre Zahlung der richtigen Bestellung zuordnen konnen.',
      fr: 'Utilisez les details ci-dessous pour transferer le solde impaye. Incluez toujours la reference afin que nous puissions associer votre paiement a la bonne commande.',
      ro: 'Utiliza?i detaliile de mai jos pentru a transfera soldul restant. Include?i intotdeauna referin?a pentru a putea potrivi plata cu comanda corecta.',
      tr: 'Kalan bakiyeyi transfer etmek icin asagidaki detaylari kullanin. Odemenizi dogru siparise eslestirebilmemiz icin her zaman referansi dahil edin.',
      sr: 'Користите детаље испод за пренос преосталог стања. Увек укључите референцу како бисмо вашу уплату могли повезати са исправном наруџбином.',
      mk: 'Користете ги деталите подолу за да го префрлите преостанатиот биланс. Секогаш вклучувајте ја референцата за да можеме да ја усогласиме вашата уплата со точната нарачка.',
      hu: 'Hasznalja az alabbi adatokat a fennmarado egyenleg atutalasahoz. Mindig tartalmazza a hivatkozast, hogy ossze tudjuk parositani a fizeteset a megfelelo rendelessel.',
      sk: 'Pouzite nizsie uvedene udaje na prevod zostavajuceho zostatku. Vzdy uveďte referenciu, aby sme mohli vasu platbu priradit k spravnej objednavke.',
      sl: 'Uporabite spodnje podatke za prenos neporavnanega stanja. Vedno vkljucite referenco, da lahko vas placilo uskladimo s pravilnim narocilom.',
      es: 'Utilice los detalles a continuacion para transferir el saldo pendiente. Siempre incluya la referencia para que podamos hacer coincidir su pago con el pedido correcto.',
      fi: 'Käytä alla olevia tietoja siirtääksesi avoimen saldon. Sisällytä aina viite, jotta voimme kohdistaa maksusi oikeaan tilaukseen.',
    },
  Beneficiary: {
    en: 'Beneficiary',
    bg: 'Бенефициент',
    de: 'Begunstigter',
    fr: 'Bénéficiaire',
    ro: 'Beneficiar',
    tr: 'Lehine',
    sr: 'Корисник',
    mk: 'Корисник',
    hu: 'Kedvezmenyzett',
    sk: 'Prijemca',
    sl: 'Koristnik',
    es: 'Beneficiario',
    fi: 'Saaja',
  },
  Address: {
    en: 'Address',
    bg: 'Адрес',
    de: 'Adresse',
    fr: 'Adresse',
    ro: 'Adresa',
    tr: 'Adres',
    sr: 'Адреса',
    mk: 'Адреса',
    hu: 'Cim',
    sk: 'Adresa',
    sl: 'Naslov',
    es: 'Direccion',
    fi: 'Osoite',
  },
  Bank: {
    en: 'Bank',
    bg: 'Банка',
    de: 'Bank',
    fr: 'Banque',
    ro: 'Banca',
    tr: 'Banka',
    sr: 'Банка',
    mk: 'Банка',
    hu: 'Bank',
    sk: 'Banka',
    sl: 'Banka',
    es: 'Banco',
    fi: 'Pankki',
  },
  'Payment reference': {
    en: 'Payment reference',
    bg: 'Платежна референция',
    de: 'Zahlungsreferenz',
    fr: 'Reference de paiement',
    ro: 'Referință de plată',
    tr: 'Odeme referansi',
    sr: 'Референца плаћања',
    mk: 'Референца за плаќање',
    hu: 'Fizetesi hivatkozas',
    sk: 'Platobna referencia',
    sl: 'Referenca placila',
    es: 'Referencia de pago',
    fi: 'Maksuviite',
  },
  Date: {
    en: 'Date',
    bg: 'Дата',
    de: 'Datum',
    fr: 'Date',
    ro: 'Data',
    tr: 'Tarih',
    sr: 'Датум',
    mk: 'Датум',
    hu: 'Datum',
    sk: 'Datum',
    sl: 'Datum',
    es: 'Fecha',
    fi: 'Paiva',
  },
  'Latest pick up': {
    en: 'Latest pick up',
    bg: 'Последно вземане',
    de: 'Spateste Abholung',
    fr: 'Dernier ramassage',
    ro: 'Ultima preluare',
    tr: 'En son alma',
    sr: 'Најкасније преузимање',
    mk: 'Најдоцна подигнување',
    hu: 'Legkeso felvetel',
    sk: 'Najneskoršie vyzdvihnutie',
    sl: 'Najpoznejsi prevzem',
    es: 'Ultima recogida',
    fi: 'Viimeisin nouto',
  },
  Status: {
    en: 'Status',
    bg: 'Статус',
    de: 'Status',
    fr: 'Statut',
    ro: 'Stare',
    tr: 'Durum',
    sr: 'Статус',
    mk: 'Статус',
    hu: 'Allapot',
    sk: 'Stav',
    sl: 'Stanje',
    es: 'Estado',
    fi: 'Tila',
  },
  'Customer information': {
    en: 'Customer information',
    bg: 'Информация за клиента',
    de: 'Kundeninformation',
    fr: 'Informations client',
    ro: 'Informații pentru clienți',
    tr: 'Musteri bilgileri',
    sr: 'Информације о купцу',
    mk: 'Информации за клиентот',
    hu: 'Ugyfel informaciok',
    sk: 'Informacie o zakaznikovi',
    sl: 'Podrobnosti stranke',
    es: 'Información del cliente',
    fi: 'Asiakastiedot',
  },
  'Documents & damages': {
    en: 'Documents & damages',
    bg: 'Документи и щети',
    de: 'Dokumente & Schäden',
    fr: 'Documents & dommages',
    ro: 'Documente și daune',
    tr: 'Belgeler ve hasarlar',
    sr: 'Документи и оштећења',
    mk: 'Документи и оштетувања',
    hu: 'Dokumentumok & karosodasok',
    sk: 'Dokumenty a skody',
    sl: 'Dokumenti in skode',
    es: 'Documentos y daños',
    fi: 'Asiakirjat ja vahingot',
  },
  Damages: {
    en: 'Damages',
    bg: 'Щети',
    de: 'Schäden',
    fr: 'Dommages',
    ro: 'Daune',
    tr: 'Hasarlar',
    sr: 'Оштећења',
    mk: 'Оштетувања',
    hu: 'Karosodasok',
    sk: 'Skody',
    sl: 'Skode',
    es: 'Daños',
    fi: 'Vahingot',
  },
  'No files': {
    en: 'No files',
    bg: 'Няма файлове',
    de: 'Keine Dateien',
    fr: 'Aucun fichier',
    ro: 'Niciun fisier',
    tr: 'Dosya yok',
    sr: 'Нема датотека',
    mk: 'Нема датотеки',
    hu: 'Nincsenek fajlok',
    sk: 'Ziadne subory',
    sl: 'Ni datotek',
    es: 'No hay archivos',
    fi: 'Ei tiedostoja',
  },
  'Got it': {
    en: 'Got it',
    bg: 'Разбрах',
    de: 'Verstanden',
    fr: 'Compris',
    ro: 'Am inteles',
    tr: 'Anladim',
    sr: 'Разумео сам',
    mk: 'Разбрав',
    hu: 'Megertettem',
    sk: 'Rozumiem',
    sl: 'Razumem',
    es: 'Lo tengo',
    fi: 'Ymmarsin',
  },
  'Order Details': {
    en: 'Order Details',
    bg: 'Детайли за поръчката',
    de: 'Bestelldetails',
    fr: 'Details de la commande',
    ro: 'Detalii comanda',
    tr: 'Siparis Detaylari',
    sr: 'Детаљи наруџбине',
    mk: 'Детали за нарачката',
    hu: 'Rendeles reszletei',
    sk: 'Detaily objednavky',
    sl: 'Podrobnosti narocila',
    es: 'Detalles del pedido',
    fi: 'Tilaustiedot',
  },
  Performance: {
    en: 'Performance',
    bg: 'Представяне',
    de: 'Leistung',
    fr: 'Performance',
    ro: 'Performanta',
    tr: 'Performans',
    sr: 'Перформансе',
    mk: 'Перформанси',
    hu: 'Teljesitmeny',
    sk: 'Vykon',
    sl: 'Ucinkovitost',
    es: 'Rendimiento',
    fi: 'Suorituskyky',
  },
  'Accurate Planning': {
    en: 'Accurate Planning',
    bg: 'Точно планиране',
    de: 'Genaues Planen',
    fr: 'Planification precise',
    ro: 'Planificare precisa',
    tr: 'Dogru Planlama',
    sr: 'Точно планирање',
    mk: 'Точно планирање',
    hu: 'Pontos tervezes',
    sk: 'Presne planovanie',
    sl: 'Natan?no nacrtovanje',
    es: 'Planificacion precisa',
    fi: 'Tarkka suunnittelu',
  },
  'No Change of plans': {
    en: 'No Change of plans',
    bg: 'Без промяна на плановете',
    de: 'Keine Planänderung',
    fr: 'Pas de changement de plans',
    ro: 'Fara schimbare de planuri',
    tr: 'Planlarda Degisiklik Yok',
    sr: 'Без промене планова',
    mk: 'Без промена на плановите',
    hu: 'Nincs valtozas a tervekben',
    sk: 'Ziadna zmena planov',
    sl: 'Brez spremembe nacrtov',
    es: 'Sin cambio de planes',
    fi: 'Ei muutoksia suunnitelmiin',
  },
  Driver: {
    en: 'Driver',
    bg: 'Шофьор',
    de: 'Fahrer',
    fr: 'Chauffeur',
    ro: 'Șofer',
    tr: 'Surucu',
    sr: 'Возач',
    mk: 'Возач',
    hu: 'Sofor',
    sk: 'Vodic',
    sl: 'Voznik',
    es: 'Conductor',
    fi: 'Kuljettaja',
  },
  'License plate': {
    en: 'License plate',
    bg: 'Регистрационен номер',
    de: 'Kennzeichen',
    fr: "Plaque d'immatriculation",
    ro: 'Numar de inmatriculare',
    tr: 'Plaka',
    sr: 'Регистарска таблица',
    mk: 'Регистарска табличка',
    hu: 'Rendszam',
    sk: 'Evidencne cislo',
    sl: 'Registrska tablica',
    es: 'Matricula',
    fi: 'Rekisterikilpi',
  },
  Schedule: {
    en: 'Schedule',
    bg: 'График',
    de: 'Zeitplan',
    fr: 'Horaire',
    ro: 'Program',
    tr: 'Program',
    sr: 'Распоред',
    mk: 'Распоред',
    hu: 'Menetrend',
    sk: 'Rozvrh',
    sl: 'Razpored',
    es: 'Horario',
    fi: 'Aikataulu',
  },
  'Planned pickup date': {
    en: 'Planned pickup date',
    bg: 'Планирана дата на вземане',
    de: 'Geplantes Abholdatum',
    fr: 'Date de ramassage prevue',
    ro: 'Data planificata pentru preluare',
    tr: 'Planlanan alma tarihi',
    sr: 'Планирани датум преузимања',
    mk: 'Планиран датум на подигнување',
    hu: 'Tervezett felveteli datum',
    sk: 'Planovany datum vyzdvihnutia',
    sl: 'Na?rtovani datum prevzema',
    es: 'Fecha de recogida planificada',
    fi: 'Suunniteltu noutopäivä',
  },
  'Planned arrival date': {
    en: 'Planned arrival date',
    bg: 'Планирана дата на пристигане',
    de: 'Geplantes Ankunftsdatum',
    fr: "Date d'arrivee prevue",
    ro: 'Data planificata pentru sosire',
    tr: 'Planlanan varis tarihi',
    sr: 'Планирани датум доласка',
    mk: 'Планиран датум на пристигнување',
    hu: 'Tervezett erkezesi datum',
    sk: 'Planovany datum prichodu',
    sl: 'Na?rtovani datum prihoda',
    es: 'Fecha de llegada planificada',
    fi: 'Suunniteltu saapumispäivä',
  },
  'Chassis number': {
    en: 'Chassis number',
    bg: 'Номер на шаси',
    de: 'Fahrgestellnummer',
    fr: 'Numéro de châssis',
    ro: 'Numar de sasiu',
    tr: 'Sase numarasi',
    sr: 'Број шасије',
    mk: 'Број на шасија',
    hu: 'Alvazszam',
    sk: 'Cislo podvozku',
    sl: 'Stevilka podvozja',
    es: 'Numero de chasis',
    fi: 'Alustan numero',
  },
  Width: {
    en: 'Width',
    bg: 'Ширина',
    de: 'Breite',
    fr: 'Largeur',
    ro: 'Latime',
    tr: 'Genislik',
    sr: 'Ширина',
    mk: 'Ширина',
    hu: 'Szelesseg',
    sk: 'Sirka',
    sl: 'Sirina',
    es: 'Ancho',
    fi: 'Leveys',
  },
  Height: {
    en: 'Height',
    bg: 'Височина',
    de: 'Höhe',
    fr: 'Hauteur',
    ro: 'Inaltime',
    tr: 'Yukseklik',
    sr: 'Висина',
    mk: 'Висина',
    hu: 'Magassag',
    sk: 'Vyska',
    sl: 'Visina',
    es: 'Altura',
    fi: 'Korkeus',
  },
  Length: {
    en: 'Length',
    bg: 'Дължина',
    de: 'Länge',
    fr: 'Longueur',
    ro: 'Lungime',
    tr: 'Uzunluk',
    sr: 'Дужина',
    mk: 'Должина',
    hu: 'Hosszusag',
    sk: 'Dlzka',
    sl: 'Dolzina',
    es: 'Longitud',
    fi: 'Pituus',
  },
  Towing: {
    en: 'Towing',
    bg: 'Теглене',
    de: 'Abschleppen',
    fr: 'Remorquage',
    ro: 'Tractare',
    tr: 'Cekme',
    sr: 'Вуцање',
    mk: 'Влечење',
    hu: 'Vontatas',
    sk: 'Tahanie',
    sl: 'Vlecenje',
    es: 'Remolque',
    fi: 'Vetaminen',
  },
  'Copy vehicle details': {
    en: 'Copy vehicle details',
    bg: 'Копиране на детайли за превозното средство',
    de: 'Fahrzeugdetails kopieren',
    fr: 'Copier les détails du véhicule',
    ro: 'Copiaza detaliile vehiculului',
    tr: 'Araç detaylarini kopyala',
    sr: 'Копирајте детаље возила',
    mk: 'Копирајте ги деталите за возилото',
    hu: 'Jarmu adatok masolasa',
    sk: 'Kopirovat detaily vozidla',
    sl: 'Kopiraj podrobnosti vozila',
    es: 'Copiar detalles del vehículo',
    fi: 'Kopioi ajoneuvon tiedot',
  },
  'Transit time: ~{{hours}}h': {
    en: 'Transit time: ~{{hours}}h',
    bg: 'Време за транзит: ~{{hours}}ч',
    de: 'Transitzeit: ~{{hours}}h',
    fr: 'Temps de transit : ~{{hours}}h',
    ro: 'Timp de tranzit: ~{{hours}}h',
    tr: 'Transit süresi: ~{{hours}}s',
    sr: 'Време транзита: ~{{hours}}ч',
    mk: 'Време на транзит: ~{{hours}}ч',
    hu: 'Atmeneti ido: ~{{hours}}o',
    sk: 'Prepravny cas: ~{{hours}}h',
    sl: 'Cas prevoza: ~{{hours}}h',
    es: 'Tiempo de transito: ~{{hours}}h',
    fi: 'Kuljetusaika: ~{{hours}}h',
  },
  'Vehicle details': {
    en: 'Vehicle details',
    bg: 'Детайли за превозното средство',
    de: 'Fahrzeugdetails',
    fr: 'Détails du véhicule',
    ro: 'Detalii vehicul',
    tr: 'Araç detayları',
    sr: 'Детаљи возила',
    mk: 'Детали за возилото',
    hu: 'Jármű részletei',
    sk: 'Detaily vozidla',
    sl: 'Podrobnosti o vozilu',
    es: 'Detalles del vehículo',
    fi: 'Ajoneuvon tiedot',
  },
  'X vehicle(s)': {
    en: '{{count}} vehicle(s)',
    bg: '{{count}} превозни средства',
    de: '{{count}} Fahrzeug(e)',
    fr: '{{count}} véhicule(s)',
    ro: '{{count}} vehicul(e)',
    tr: '{{count}} araç',
    sr: '{{count}} возила',
    mk: '{{count}} возила',
    hu: '{{count}} jármű',
    sk: '{{count}} vozidiel',
    sl: '{{count}} vozil',
    es: '{{count}} vehículo(s)',
    fi: '{{count}} ajoneuvo(a)',
  },
  Details: {
    en: 'Details',
    bg: 'Детайли',
    de: 'Details',
    fr: 'Détails',
    ro: 'Detalii',
    tr: 'Detaylar',
    sr: 'Детаљи',
    mk: 'Детали',
    hu: 'Részletek',
    sk: 'Detaily',
    sl: 'Podrobnosti',
    es: 'Detalles',
    fi: 'Tiedot',
  },
  'No vehicles selected yet.': {
    en: 'No vehicles selected yet.',
    bg: 'Все още няма избрани превозни средства.',
    de: 'Noch keine Fahrzeuge ausgewählt.',
    fr: 'Aucun véhicule sélectionné pour le moment.',
    ro: 'Niciun vehicul selectat încă.',
    tr: 'Henüz araç seçilmedi.',
    sr: 'Још нема изабраних возила.',
    mk: 'Сè уште няма избрано возила.',
    hu: 'Még nincs kiválasztott jármű.',
    sk: 'Zatiaľ nie sú vybrané žiadne vozidlá.',
    sl: 'Še ni izbranih vozil.',
    es: 'Aún no se han seleccionado vehículos.',
    fi: 'Yhtään ajoneuvoa ei ole vielä valittu.',
  },
  'Please add the vehicle weight to continue.': {
    en: 'Please add the vehicle weight to continue.',
    bg: 'Моля, добавете теглото на превозното средство, за да продължите.',
    de: 'Bitte fügen Sie das Fahrzeuggewicht hinzu, um fortzufahren.',
    fr: 'Veuillez ajouter le poids du véhicule pour continuer.',
    ro: 'Te rog adaugă greutatea vehiculului pentru a continua.',
    tr: 'Devam etmek için lütfen araç ağırlığını ekleyin.',
    sr: 'Молимо додајте тежину возила да бисте наставили.',
    mk: 'Ве молиме додадете ја тежината на возилото за да продолжите.',
    hu: 'Kérjük, adja meg a jármű súlyát a folytatáshoz.',
    sk: 'Prosím, pridajte hmotnosť vozidla, aby ste mohli pokračovať.',
    sl: 'Prosimo, dodajte težo vozila za nadaljevanje.',
    es: 'Por favor, añade el peso del vehículo para continuar.',
    fi: 'Lisää ajoneuvon paino jatkaaksesi.',
  },
  'Weight (kg)': {
    en: 'Weight (kg)',
    bg: 'Тегло (кг)',
    de: 'Gewicht (kg)',
    fr: 'Poids (kg)',
    ro: 'Greutate (kg)',
    tr: 'Ağırlık (kg)',
    sr: 'Тежина (кг)',
    mk: 'Тежина (кг)',
    hu: 'Súly (kg)',
    sk: 'Hmotnosť (kg)',
    sl: 'Teža (kg)',
    es: 'Peso (kg)',
    fi: 'Paino (kg)',
  },
  kg: {
    en: 'kg',
    bg: 'кг',
    de: 'kg',
    fr: 'kg',
    ro: 'kg',
    tr: 'kg',
    sr: 'кг',
    mk: 'кг',
    hu: 'kg',
    sk: 'kg',
    sl: 'kg',
    es: 'kg',
    fi: 'kg',
  },
  Vehicles: {
    en: 'Vehicles',
    bg: 'Превозни средства',
    de: 'Fahrzeuge',
    fr: 'Véhicules',
    ro: 'Vehicule',
    tr: 'Araçlar',
    sr: 'Возила',
    mk: 'Возила',
    hu: 'Járművek',
    sk: 'Vozidlá',
    sl: 'Vozila',
    es: 'Vehículos',
    fi: 'Ajoneuvot',
  },
  English: {
    en: 'English',
    bg: 'Английски',
    de: 'Englisch',
    fr: 'Anglais',
    ro: 'Engleză',
    tr: 'İngilizce',
    sr: 'Енглески',
    mk: 'Англиски',
    hu: 'Angol',
    sk: 'Angličtina',
    sl: 'Angleščina',
    es: 'Inglés',
    fi: 'Englanti',
  },
  German: {
    en: 'German',
    bg: 'Немски',
    de: 'Deutsch',
    fr: 'Allemand',
    ro: 'Germană',
    tr: 'Almanca',
    sr: 'Немачки',
    mk: 'Германски',
    hu: 'Német',
    sk: 'Nemčina',
    sl: 'Nemščina',
    es: 'Alemán',
    fi: 'Saksa',
  },
  Dutch: {
    en: 'Dutch',
    bg: 'Холандски',
    de: 'Niederländisch',
    fr: 'Néerlandais',
    ro: 'Olandeză',
    tr: 'Felemenkçe',
    sr: 'Холандски',
    mk: 'Холандски',
    hu: 'Holland',
    sk: 'Holandčina',
    sl: 'Nizozemščina',
    es: 'Neerlandés',
    fi: 'Hollanti',
  },
  French: {
    en: 'French',
    bg: 'Френски',
    de: 'Französisch',
    fr: 'Français',
    ro: 'Franceză',
    tr: 'Fransızca',
    sr: 'Француски',
    mk: 'Француски',
    hu: 'Francia',
    sk: 'Francúzština',
    sl: 'Francoščina',
    es: 'Francés',
    fi: 'Ranska',
  },
  Spanish: {
    en: 'Spanish',
    bg: 'Испански',
    de: 'Spanisch',
    fr: 'Espagnol',
    ro: 'Spaniolă',
    tr: 'İspanyolca',
    sr: 'Шпански',
    mk: 'Шпански',
    hu: 'Spanyol',
    sk: 'Španielčina',
    sl: 'Španščina',
    es: 'Español',
    fi: 'Espanja',
  },
  Italian: {
    en: 'Italian',
    bg: 'Италиански',
    de: 'Italienisch',
    fr: 'Italien',
    ro: 'Italiană',
    tr: 'İtalyanca',
    sr: 'Италијански',
    mk: 'Италијански',
    hu: 'Olasz',
    sk: 'Taliančina',
    sl: 'Italijanščina',
    es: 'Italiano',
    fi: 'Italia',
  },
  Albania: {
    en: 'Albania',
    bg: 'Албания',
    de: 'Albanien',
    fr: 'Albanie',
    ro: 'Albania',
    tr: 'Arnavutluk',
    sr: 'Албанија',
    mk: 'Албанија',
    hu: 'Albánia',
    sk: 'Albánsko',
    sl: 'Albanija',
    es: 'Albania',
    fi: 'Albania',
  },
  Andorra: {
    en: 'Andorra',
    bg: 'Андора',
    de: 'Andorra',
    fr: 'Andorre',
    ro: 'Andorra',
    tr: 'Andorra',
    sr: 'Андора',
    mk: 'Андора',
    hu: 'Andorra',
    sk: 'Andorra',
    sl: 'Andora',
    es: 'Andorra',
    fi: 'Andorra',
  },
  Armenia: {
    en: 'Armenia',
    bg: 'Армения',
    de: 'Armenien',
    fr: 'Arménie',
    ro: 'Armenia',
    tr: 'Ermenistan',
    sr: 'Јерменија',
    mk: 'Ерменија',
    hu: 'Örményország',
    sk: 'Arménsko',
    sl: 'Armenija',
    es: 'Armenia',
    fi: 'Armenia',
  },
  Austria: {
    en: 'Austria',
    bg: 'Австрия',
    de: 'Österreich',
    fr: 'Autriche',
    ro: 'Austria',
    tr: 'Avusturya',
    sr: 'Аустрија',
    mk: 'Австрија',
    hu: 'Ausztria',
    sk: 'Rakúsko',
    sl: 'Avstrija',
    es: 'Austria',
    fi: 'Itävalta',
  },
  Azerbaijan: {
    en: 'Azerbaijan',
    bg: 'Азербайджан',
    de: 'Aserbaidschan',
    fr: 'Azerbaïdjan',
    ro: 'Azerbaidjan',
    tr: 'Azerbaycan',
    sr: 'Азербејџан',
    mk: 'Азербејџан',
    hu: 'Azerbajdzsán',
    sk: 'Azerbajdžan',
    sl: 'Azerbajdžan',
    es: 'Azerbaiyán',
    fi: 'Azerbaidžan',
  },
  Belarus: {
    en: 'Belarus',
    bg: 'Беларус',
    de: 'Weißrussland',
    fr: 'Biélorussie',
    ro: 'Belarus',
    tr: 'Beyaz Rusya',
    sr: 'Белорусија',
    mk: 'Белорусија',
    hu: 'Fehéroroszország',
    sk: 'Bielorusko',
    sl: 'Belorusija',
    es: 'Bielorrusia',
    fi: 'Valko-Venäjä',
  },
  Belgium: {
    en: 'Belgium',
    bg: 'Белгия',
    de: 'Belgien',
    fr: 'Belgique',
    ro: 'Belgia',
    tr: 'Belçika',
    sr: 'Белгија',
    mk: 'Белгија',
    hu: 'Belgium',
    sk: 'Belgicko',
    sl: 'Belgija',
    es: 'Bélgica',
    fi: 'Belgia',
  },
  'Bosnia and Herzegovina': {
    en: 'Bosnia and Herzegovina',
    bg: 'Босна и Херцеговина',
    de: 'Bosnien und Herzegowina',
    fr: 'Bosnie-Herzégovine',
    ro: 'Bosnia si Hertegovina',
    tr: 'Bosna Hersek',
    sr: 'Босна и Херцеговина',
    mk: 'Босна и Херцеговина',
    hu: 'Bosznia-Hercegovina',
    sk: 'Bosna a Hercegovina',
    sl: 'Bosna in Hercegovina',
    es: 'Bosnia y Herzegovina',
    fi: 'Bosnia ja Hertsegovina',
  },
  Bulgaria: {
    en: 'Bulgaria',
    bg: 'България',
    de: 'Bulgarien',
    fr: 'Bulgarie',
    ro: 'Bulgaria',
    tr: 'Bulgaristan',
    sr: 'Бугарска',
    mk: 'Бугарија',
    hu: 'Bulgária',
    sk: 'Bulharsko',
    sl: 'Bolgarija',
    es: 'Bulgaria',
    fi: 'Bulgaria',
  },
  Croatia: {
    en: 'Croatia',
    bg: 'Хърватия',
    de: 'Kroatien',
    fr: 'Croatie',
    ro: 'Croaţia',
    tr: 'Hırvatistan',
    sr: 'Хрватска',
    mk: 'Хрватска',
    hu: 'Horvátország',
    sk: 'Chorvátsko',
    sl: 'Hrvaška',
    es: 'Croacia',
    fi: 'Kroatia',
  },
  Cyprus: {
    en: 'Cyprus',
    bg: 'Кипър',
    de: 'Zypern',
    fr: 'Chypre',
    ro: 'Cipru',
    tr: 'Kıbrıs',
    sr: 'Кипар',
    mk: 'Кипар',
    hu: 'Ciprus',
    sk: 'Cyprus',
    sl: 'Ciper',
    es: 'Chipre',
    fi: 'Kypros',
  },
  'Czech Republic': {
    en: 'Czech Republic',
    bg: 'Чехия',
    de: 'Tschechische Republik',
    fr: 'République tchèque',
    ro: 'Republica Cehă',
    tr: 'Çek Cumhuriyeti',
    sr: 'Чешка Република',
    mk: 'Чешка Република',
    hu: 'Csehország',
    sk: 'Česká republika',
    sl: 'Češka',
    es: 'República Checa',
    fi: 'Tšekki',
  },
  Denmark: {
    en: 'Denmark',
    bg: 'Дания',
    de: 'Dänemark',
    fr: 'Danemark',
    ro: 'Danemarca',
    tr: 'Danimarka',
    sr: 'Данска',
    mk: 'Данска',
    hu: 'Dánia',
    sk: 'Dánsko',
    sl: 'Danska',
    es: 'Dinamarca',
    fi: 'Tanska',
  },
  Estonia: {
    en: 'Estonia',
    bg: 'Естония',
    de: 'Estland',
    fr: 'Estonie',
    ro: 'Estonia',
    tr: 'Estonya',
    sr: 'Естонија',
    mk: 'Естонија',
    hu: 'Észtország',
    sk: 'Estónsko',
    sl: 'Estonija',
    es: 'Estonia',
    fi: 'Viro',
  },
  Finland: {
    en: 'Finland',
    bg: 'Финландия',
    de: 'Finnland',
    fr: 'Finlande',
    ro: 'Finlanda',
    tr: 'Finlandiya',
    sr: 'Финска',
    mk: 'Финска',
    hu: 'Finnország',
    sk: 'Fínsko',
    sl: 'Finska',
    es: 'Finlandia',
    fi: 'Suomi',
  },
  France: {
    en: 'France',
    bg: 'Франция',
    de: 'Frankreich',
    fr: 'France',
    ro: 'Franţa',
    tr: 'Fransa',
    sr: 'Француска',
    mk: 'Франција',
    hu: 'Franciaország',
    sk: 'Francúzsko',
    sl: 'Francija',
    es: 'Francia',
    fi: 'Ranska',
  },
  Georgia: {
    en: 'Georgia',
    bg: 'Грузия',
    de: 'Georgien',
    fr: 'Géorgie',
    ro: 'Georgia',
    tr: 'Gürcistan',
    sr: 'Грузија',
    mk: 'Грузија',
    hu: 'Grúzia',
    sk: 'Gruzínsko',
    sl: 'Gruzija',
    es: 'Georgia',
    fi: 'Georgia',
  },
  Germany: {
    en: 'Germany',
    bg: 'Германия',
    de: 'Deutschland',
    fr: 'Allemagne',
    ro: 'Germania',
    tr: 'Almanya',
    sr: 'Немачка',
    mk: 'Германија',
    hu: 'Németország',
    sk: 'Nemecko',
    sl: 'Nemčija',
    es: 'Alemania',
    fi: 'Saksa',
  },
  Greece: {
    en: 'Greece',
    bg: 'Гърция',
    de: 'Griechenland',
    fr: 'Grèce',
    ro: 'Grecia',
    tr: 'Yunanistan',
    sr: 'Грчка',
    mk: 'Грција',
    hu: 'Görögország',
    sk: 'Grécko',
    sl: 'Grčija',
    es: 'Grecia',
    fi: 'Kreikka',
  },
  Hungary: {
    en: 'Hungary',
    bg: 'Унгария',
    de: 'Ungarn',
    fr: 'Hongrie',
    ro: 'Ungaria',
    tr: 'Macaristan',
    sr: 'Мађарска',
    mk: 'Унгарија',
    hu: 'Magyarország',
    sk: 'Maďarsko',
    sl: 'Madžarska',
    es: 'Hungría',
    fi: 'Unkari',
  },
  Iceland: {
    en: 'Iceland',
    bg: 'Исландия',
    de: 'Island',
    fr: 'Islande',
    ro: 'Islanda',
    tr: 'İzlanda',
    sr: 'Исланд',
    mk: 'Исланд',
    hu: 'Izland',
    sk: 'Island',
    sl: 'Islandija',
    es: 'Islandia',
    fi: 'Islanti',
  },
  Ireland: {
    en: 'Ireland',
    bg: 'Ирландия',
    de: 'Irland',
    fr: 'Irlande',
    ro: 'Irlanda',
    tr: 'İrlanda',
    sr: 'Ирска',
    mk: 'Ирска',
    hu: 'Írország',
    sk: 'Írsko',
    sl: 'Irska',
    es: 'Irlanda',
    fi: 'Irlanti',
  },
  Italy: {
    en: 'Italy',
    bg: 'Италия',
    de: 'Italien',
    fr: 'Italie',
    ro: 'Italia',
    tr: 'İtalya',
    sr: 'Италија',
    mk: 'Италија',
    hu: 'Olaszország',
    sk: 'Taliansko',
    sl: 'Italija',
    es: 'Italia',
    fi: 'Italia',
  },
  Kazakhstan: {
    en: 'Kazakhstan',
    bg: 'Казахстан',
    de: 'Kasachstan',
    fr: 'Kazakhstan',
    ro: 'Kazahstan',
    tr: 'Kazakistan',
    sr: 'Казахстан',
    mk: 'Казахстан',
    hu: 'Kazahsztán',
    sk: 'Kazachstan',
    sl: 'Kazahstan',
    es: 'Kazajistán',
    fi: 'Kazakstan',
  },
  Kosovo: {
    en: 'Kosovo',
    bg: 'Косово',
    de: 'Kosovo',
    fr: 'Kosovo',
    ro: 'Kosovo',
    tr: 'Kosova',
    sr: 'Косово',
    mk: 'Косово',
    hu: 'Koszovó',
    sk: 'Kosovo',
    sl: 'Kosovo',
    es: 'Kosovo',
    fi: 'Kosovo',
  },
  Latvia: {
    en: 'Latvia',
    bg: 'Латвия',
    de: 'Lettland',
    fr: 'Lettonie',
    ro: 'Letonia',
    tr: 'Letonya',
    sr: 'Летонија',
    mk: 'Летонија',
    hu: 'Lettország',
    sk: 'Lotyšsko',
    sl: 'Latvija',
    es: 'Letonia',
    fi: 'Latvia',
  },
  Liechtenstein: {
    en: 'Liechtenstein',
    bg: 'Лихтенщайн',
    de: 'Liechtenstein',
    fr: 'Liechtenstein',
    ro: 'Liechtenstein',
    tr: 'Lihtenştayn',
    sr: 'Лихтенштајн',
    mk: 'Лихтенштајн',
    hu: 'Liechtenstein',
    sk: 'Lichtenštajnsko',
    sl: 'Lihtenštajn',
    es: 'Liechtenstein',
    fi: 'Liechtenstein',
  },
  Lithuania: {
    en: 'Lithuania',
    bg: 'Литва',
    de: 'Litauen',
    fr: 'Lituanie',
    ro: 'Lituania',
    tr: 'Litvanya',
    sr: 'Литванија',
    mk: 'Литванија',
    hu: 'Litvánia',
    sk: 'Litva',
    sl: 'Litva',
    es: 'Lituania',
    fi: 'Liettua',
  },
  Luxembourg: {
    en: 'Luxembourg',
    bg: 'Люксембург',
    de: 'Luxemburg',
    fr: 'Luxembourg',
    ro: 'Luxemburg',
    tr: 'Lüksemburg',
    sr: 'Луксембург',
    mk: 'Луксембург',
    hu: 'Luxemburg',
    sk: 'Luxembursko',
    sl: 'Luksemburg',
    es: 'Luxemburgo',
    fi: 'Luxemburg',
  },
  Malta: {
    en: 'Malta',
    bg: 'Малта',
    de: 'Malta',
    fr: 'Malte',
    ro: 'Malta',
    tr: 'Malta',
    sr: 'Малта',
    mk: 'Малта',
    hu: 'Málta',
    sk: 'Malta',
    sl: 'Malta',
    es: 'Malta',
    fi: 'Malta',
  },
  Moldova: {
    en: 'Moldova',
    bg: 'Молдова',
    de: 'Moldawien',
    fr: 'Moldavie',
    ro: 'Moldova',
    tr: 'Moldova',
    sr: 'Молдавија',
    mk: 'Молдавија',
    hu: 'Moldova',
    sk: 'Moldavsko',
    sl: 'Moldavija',
    es: 'Moldavia',
    fi: 'Moldova',
  },
  Monaco: {
    en: 'Monaco',
    bg: 'Монако',
    de: 'Monaco',
    fr: 'Monaco',
    ro: 'Monaco',
    tr: 'Monako',
    sr: 'Монако',
    mk: 'Монако',
    hu: 'Monaco',
    sk: 'Monako',
    sl: 'Monako',
    es: 'Mónaco',
    fi: 'Monaco',
  },
  Montenegro: {
    en: 'Montenegro',
    bg: 'Черна гора',
    de: 'Montenegro',
    fr: 'Monténégro',
    ro: 'Muntenegru',
    tr: 'Karadağ',
    sr: 'Црна Гора',
    mk: 'Црна Гора',
    hu: 'Montenegró',
    sk: 'Čierna Hora',
    sl: 'Črna gora',
    es: 'Montenegro',
    fi: 'Montenegro',
  },
  Netherlands: {
    en: 'Netherlands',
    bg: 'Нидерландия',
    de: 'Niederlande',
    fr: 'Pays-Bas',
    ro: 'Olanda',
    tr: 'Hollanda',
    sr: 'Холандија',
    mk: 'Холандија',
    hu: 'Hollandia',
    sk: 'Holandsko',
    sl: 'Nizozemska',
    es: 'Países Bajos',
    fi: 'Alankomaat',
  },
  'North Macedonia': {
    en: 'North Macedonia',
    bg: 'Северна Македония',
    de: 'Nordmazedonien',
    fr: 'Macédoine du Nord',
    ro: 'Macedonia de Nord',
    tr: 'Kuzey Makedonya',
    sr: 'Северна Македонија',
    mk: 'Северна Македонија',
    hu: 'Észak-Macedónia',
    sk: 'Severné Macedónsko',
    sl: 'Severna Makedonija',
    es: 'Macedonia del Norte',
    fi: 'Pohjois-Makedonia',
  },
  Norway: {
    en: 'Norway',
    bg: 'Норвегия',
    de: 'Norwegen',
    fr: 'Norvège',
    ro: 'Norvegia',
    tr: 'Norveç',
    sr: 'Норвешка',
    mk: 'Норвешка',
    hu: 'Norvégia',
    sk: 'Nórsko',
    sl: 'Norveška',
    es: 'Noruega',
    fi: 'Norja',
  },
  Poland: {
    en: 'Poland',
    bg: 'Полша',
    de: 'Polen',
    fr: 'Pologne',
    ro: 'Polonia',
    tr: 'Polonya',
    sr: 'Пољска',
    mk: 'Полска',
    hu: 'Lengyelország',
    sk: 'Poľsko',
    sl: 'Poljska',
    es: 'Polonia',
    fi: 'Puola',
  },
  Portugal: {
    en: 'Portugal',
    bg: 'Португалия',
    de: 'Portugal',
    fr: 'Portugal',
    ro: 'Portugalia',
    tr: 'Portekiz',
    sr: 'Португал',
    mk: 'Португалија',
    hu: 'Portugália',
    sk: 'Portugalsko',
    sl: 'Portugalska',
    es: 'Portugal',
    fi: 'Portugali',
  },
  Romania: {
    en: 'Romania',
    bg: 'Румъния',
    de: 'Rumänien',
    fr: 'Roumanie',
    ro: 'România',
    tr: 'Romanya',
    sr: 'Румунија',
    mk: 'Романија',
    hu: 'Románia',
    sk: 'Rumunsko',
    sl: 'Romunija',
    es: 'Rumania',
    fi: 'Romania',
  },
  Russia: {
    en: 'Russia',
    bg: 'Русия',
    de: 'Russland',
    fr: 'Russie',
    ro: 'Rusia',
    tr: 'Rusya',
    sr: 'Русија',
    mk: 'Русија',
    hu: 'Oroszország',
    sk: 'Rusko',
    sl: 'Rusija',
    es: 'Rusia',
    fi: 'Venäjä',
  },
  'San Marino': {
    en: 'San Marino',
    bg: 'Сан Марино',
    de: 'San Marino',
    fr: 'Saint-Marin',
    ro: 'San Marino',
    tr: 'San Marino',
    sr: 'Сан Марино',
    mk: 'Сан Марино',
    hu: 'San Marino',
    sk: 'San Maríno',
    sl: 'San Marino',
    es: 'San Marino',
    fi: 'San Marino',
  },
  Serbia: {
    en: 'Serbia',
    bg: 'Сърбия',
    de: 'Serbien',
    fr: 'Serbie',
    ro: 'Serbia',
    tr: 'Sırbistan',
    sr: 'Србија',
    mk: 'Србија',
    hu: 'Szerbia',
    sk: 'Srbsko',
    sl: 'Srbija',
    es: 'Serbia',
    fi: 'Serbia',
  },
  Slovakia: {
    en: 'Slovakia',
    bg: 'Словакия',
    de: 'Slowakei',
    fr: 'Slovaquie',
    ro: 'Slovacia',
    tr: 'Slovakya',
    sr: 'Словачка',
    mk: 'Словачка',
    hu: 'Szlovákia',
    sk: 'Slovensko',
    sl: 'Slovaška',
    es: 'Eslovaquia',
    fi: 'Slovakia',
  },
  Slovenia: {
    en: 'Slovenia',
    bg: 'Словения',
    de: 'Slowenien',
    fr: 'Slovénie',
    ro: 'Slovenia',
    tr: 'Slovenya',
    sr: 'Словенија',
    mk: 'Словенија',
    hu: 'Szlovénia',
    sk: 'Slovinsko',
    sl: 'Slovenija',
    es: 'Eslovenia',
    fi: 'Slovenia',
  },
  Spain: {
    en: 'Spain',
    bg: 'Испания',
    de: 'Spanien',
    fr: 'Espagne',
    ro: 'Spania',
    tr: 'İspanya',
    sr: 'Шпанија',
    mk: 'Шпанија',
    hu: 'Spanyolország',
    sk: 'Španielsko',
    sl: 'Španija',
    es: 'España',
    fi: 'Espanja',
  },
  Sweden: {
    en: 'Sweden',
    bg: 'Швеция',
    de: 'Schweden',
    fr: 'Suède',
    ro: 'Suedia',
    tr: 'İsveç',
    sr: 'Шведска',
    mk: 'Шведска',
    hu: 'Svédország',
    sk: 'Švédsko',
    sl: 'Švedska',
    es: 'Suecia',
    fi: 'Ruotsi',
  },
  Switzerland: {
    en: 'Switzerland',
    bg: 'Швейцария',
    de: 'Schweiz',
    fr: 'Suisse',
    ro: 'Elveția',
    tr: 'İsviçre',
    sr: 'Швајцарска',
    mk: 'Швајцарија',
    hu: 'Svájc',
    sk: 'Švajčiarsko',
    sl: 'Švica',
    es: 'Suiza',
    fi: 'Sveitsi',
  },
  Turkey: {
    en: 'Turkey',
    bg: 'Турция',
    de: 'Türkei',
    fr: 'Turquie',
    ro: 'Turcia',
    tr: 'Türkiye',
    sr: 'Турска',
    mk: 'Турција',
    hu: 'Törökország',
    sk: 'Turecko',
    sl: 'Turčija',
    es: 'Turquía',
    fi: 'Turkki',
  },
  Ukraine: {
    en: 'Ukraine',
    bg: 'Украйна',
    de: 'Ukraine',
    fr: 'Ukraine',
    ro: 'Ucraina',
    tr: 'Ukrayna',
    sr: 'Украјина',
    mk: 'Украина',
    hu: 'Ukrajna',
    sk: 'Ukrajina',
    sl: 'Ukrajina',
    es: 'Ucrania',
    fi: 'Ukraina',
  },
  'United Kingdom': {
    en: 'United Kingdom',
    bg: 'Великобритания',
    de: 'Vereinigtes Königreich',
    fr: 'Royaume-Uni',
    ro: 'Regatul Unit',
    tr: 'Birleşik Krallık',
    sr: 'Уједињено Краљевство',
    mk: 'Обединето Кралство',
    hu: 'Egyesült Királyság',
    sk: 'Spojené kráľovstvo',
    sl: 'Združeno kraljestvo',
    es: 'Reino Unido',
    fi: 'Yhdistynyt kuningaskunta',
  },
  'Vatican City': {
    en: 'Vatican City',
    bg: 'Ватикан',
    de: 'Vatikanstadt',
    fr: 'Cité du Vatican',
    ro: 'Vatican',
    tr: 'Vatikan',
    sr: 'Ватикан',
    mk: 'Ватикан',
    hu: 'Vatikán',
    sk: 'Vatikán',
    sl: 'Vatikan',
    es: 'Ciudad del Vaticano',
    fi: 'Vatikaanivaltio',
  },
  'Pickup Country': {
    en: 'Pickup Country',
    bg: 'Държава на вземане',
    de: 'Abholland',
    fr: 'Pays de collecte',
    ro: 'Țara de ridicare',
    tr: 'Teslim alma ülkesi',
    sr: 'Држава преузимања',
    mk: 'Држава на подигање',
    hu: 'Felvételi ország',
    sk: 'Krajina vyzdvihnutia',
    sl: 'Država prevzema',
    es: 'País de recogida',
    fi: 'Noutomaa',
  },
  'Delivery Country': {
    en: 'Delivery Country',
    bg: 'Държава на доставка',
    de: 'Lieferland',
    fr: 'pays de livraison',
    ro: 'țara de livrare',
    tr: 'teslimat ülkesi',
    sr: 'zemlja isporuke',
    mk: 'земја на испорака',
    hu: 'szállítási ország',
    sk: 'krajina doručenia',
    sl: 'država dostave',
    es: 'país de entrega',
    fi: 'toimitusmaa',
  },
  'Add vehicle': {
    en: 'Add vehicle',
    bg: 'Добави превозно средство',
    de: 'Fahrzeug hinzufügen',
    fr: 'Ajouter un véhicule',
    ro: 'Adaugă vehicul',
    tr: 'Araç ekle',
    sr: 'Додај возило',
    mk: 'Додај возило',
    hu: 'Jármű hozzáadása',
    sk: 'Pridať vozidlo',
    sl: 'Dodaj vozilo',
    es: 'Añadir vehículo',
    fi: 'Lisää ajoneuvo',
  },
  'Add time': {
    en: 'Add time',
    bg: 'Добави час',
    de: 'Zeit hinzufügen',
    fr: 'Ajouter un créneau',
    ro: 'Adaugă interval',
    tr: 'Zaman ekle',
    sr: 'Додај време',
    mk: 'Додај време',
    hu: 'Idő hozzáadása',
    sk: 'Pridať čas',
    sl: 'Dodaj čas',
    es: 'Añadir horario',
    fi: 'Lisää aika',
  },
  'Avg. weight (kg)': {
    en: 'Avg. weight (kg)',
    bg: 'Средно тегло (кг)',
    de: 'Durchschn. Gewicht (kg)',
    fr: 'Poids moyen (kg)',
    ro: 'Greutate medie (kg)',
    tr: 'Ort. ağırlık (kg)',
    sr: 'Прос. тежина (kg)',
    mk: 'Прос. тежина (kg)',
    hu: 'Átl. tömeg (kg)',
    sk: 'Priem. hmotnosť (kg)',
    sl: 'Povpr. teža (kg)',
    es: 'Peso medio (kg)',
    fi: 'Keskim. paino (kg)',
  },
  'Provide an estimated weight to calculate price.': {
    en: 'Provide an estimated weight to calculate price.',
    bg: 'Посочете приблизително тегло, за да изчислим цената.',
    de: 'Geben Sie ein geschätztes Gewicht an, um den Preis zu berechnen.',
    fr: 'Indiquez un poids estimé pour calculer le prix.',
    ro: 'Introdu o greutate estimată pentru a calcula prețul.',
    tr: 'Fiyatı hesaplamak için tahmini bir ağırlık girin.',
    sr: 'Унесите процењену тежину да бисмо израчунали цену.',
    mk: 'Внесете проценета тежина за да ја пресметаме цената.',
    hu: 'Adjon meg egy becsült tömeget az ár kiszámításához.',
    sk: 'Zadajte odhadovanú hmotnosť na výpočet ceny.',
    sl: 'Vnesite ocenjeno težo za izračun cene.',
    es: 'Introduce un peso estimado para calcular el precio.',
    fi: 'Anna arvioitu paino hinnan laskemista varten.',
  },
  'Choose file': {
    en: 'Choose file',
    bg: 'Избери файл',
    de: 'Datei auswählen',
    fr: 'Choisir un fichier',
    ro: 'Alege fișier',
    tr: 'Dosya seç',
    sr: 'Изабери фајл',
    mk: 'Избери датотека',
    hu: 'Fájl kiválasztása',
    sk: 'Vybrať súbor',
    sl: 'Izberi datoteko',
    es: 'Elegir archivo',
    fi: 'Valitse tiedosto',
  },
  'Remove file': {
    en: 'Remove file',
    bg: 'Премахни файла',
    de: 'Datei entfernen',
    fr: 'Supprimer le fichier',
    ro: 'Șterge fișierul',
    tr: 'Dosyayı kaldır',
    sr: 'Уклони фајл',
    mk: 'Отстрани датотеката',
    hu: 'Fájl eltávolítása',
    sk: 'Odstrániť súbor',
    sl: 'Odstrani datoteko',
    es: 'Eliminar archivo',
    fi: 'Poista tiedosto',
  },
  'Vehicle type': {
    en: 'Vehicle type',
    bg: 'Тип превозно средство',
    de: 'Fahrzeugtyp',
    fr: 'Type de véhicule',
    ro: 'Tip vehicul',
    tr: 'Araç tipi',
    sr: 'Тип возила',
    mk: 'Тип возило',
    hu: 'Járműtípus',
    sk: 'Typ vozidla',
    sl: 'Vrsta vozila',
    es: 'Tipo de vehículo',
    fi: 'Ajoneuvotyyppi',
  },
  'Body type': {
    en: 'Body type',
    bg: 'Каросерия',
    de: 'Karosserie',
    fr: 'Type de carrosserie',
    ro: 'Tip caroserie',
    tr: 'Kasa tipi',
    sr: 'Каросерија',
    mk: 'Каросерија',
    hu: 'Karosszériatípus',
    sk: 'Typ karosérie',
    sl: 'Vrsta karoserije',
    es: 'Tipo de carrocería',
    fi: 'Korimalli',
  },
  'BodyType.Compact': {
    en: 'Compact',
    bg: 'Компактен',
    de: 'Kompakt',
    fr: 'Compacte',
    ro: 'Compact',
    tr: 'Kompakt',
    sr: 'Компакт',
    mk: 'Компактен',
    hu: 'Kompakt',
    sk: 'Kompaktný',
    sl: 'Kompakten',
    es: 'Compacto',
    fi: 'Kompakti',
  },

  'Market Activity': {
    en: 'Market Activity',
    bg: 'Пазарна активност',
    de: 'Marktaktivität',
    fr: 'Activité du marché',
    ro: 'Activitate de piață',
    tr: 'Piyasa hareketleri',
    sr: 'Aktivnost tržišta',
    mk: 'Пазарна активност',
    hu: 'Piaci aktivitás',
    sk: 'Aktivita trhu',
    sl: 'Tržna aktivnost',
    es: 'Actividad del mercado',
    fi: 'Markkina-aktiivisuus',
    el: 'Δραστηριότητα αγοράς',
  },
  messages: {
    en: 'Messages',
    bg: 'Съобщения',
    de: 'Nachrichten',
    fr: 'Messages',
    ro: 'Mesaje',
    tr: 'Mesajlar',
    sr: 'Поруке',
    mk: 'Пораки',
    hu: 'Üzenetek',
    sk: 'Správy',
    sl: 'Sporočila',
    es: 'Mensajes',
    fi: 'Viestit',
    el: 'Μηνύματα',
  },

  directCommunication: {
    en: 'Direct communication',
    bg: 'Директна комуникация',
    de: 'Direkte Kommunikation',
    fr: 'Communication directe',
    ro: 'Comunicare directă',
    tr: 'Doğrudan iletişim',
    sr: 'Директна комуникација',
    mk: 'Директна комуникација',
    hu: 'Közvetlen kommunikáció',
    sk: 'Priama komunikácia',
    sl: 'Neposredna komunikacija',
    es: 'Comunicación directa',
    fi: 'Suora viestintä',
    el: 'Άμεση επικοινωνία',
  },

  discussTransportDetails: {
    en: 'Discuss transport details, pickup arrangements, and delivery coordination.',
    bg: 'Обсъдете транспортни детайли, организация на вземане и координация на доставката.',
    de: 'Besprechen Sie Transportdetails, Abholvereinbarungen und Lieferkoordination.',
    fr: 'Discutez des détails du transport, des modalités de collecte et de la coordination de la livraison.',
    ro: 'Discutați detaliile transportului, aranjamentele de preluare și coordonarea livrării.',
    tr: 'Taşıma detaylarını, teslim alma düzenlemelerini ve teslimat koordinasyonunu görüşün.',
    sr: 'Разговарајте о детаљима транспорта, преузимању и координацији испоруке.',
    mk: 'Разговарајте за детали за транспорт, подигање и координација на испорака.',
    hu: 'Beszélje meg a szállítás részleteit, az átvételi megállapodásokat és a kézbesítés koordinációját.',
    sk: 'Diskutujte o detailoch prepravy, vyzdvihnutí a koordinácii doručenia.',
    sl: 'Pogovorite se o podrobnostih prevoza, prevzemu in usklajevanju dostave.',
    es: 'Hable sobre los detalles del transporte, la recogida y la coordinación de la entrega.',
    fi: 'Keskustele kuljetuksen yksityiskohdista, noudosta ja toimituksen koordinoinnista.',
    el: 'Συζητήστε λεπτομέρειες μεταφοράς, παραλαβής και συντονισμού παράδοσης.',
  },

  noMessagesYet: {
    en: 'No messages yet',
    bg: 'Все още няма съобщения',
    de: 'Noch keine Nachrichten',
    fr: 'Aucun message pour le moment',
    ro: 'Nu există mesaje încă',
    tr: 'Henüz mesaj yok',
    sr: 'Још нема порука',
    mk: 'Сè уште нема пораки',
    hu: 'Még nincsenek üzenetek',
    sk: 'Zatiaľ žiadne správy',
    sl: 'Še ni sporočil',
    es: 'Aún no hay mensajes',
    fi: 'Ei vielä viestejä',
    el: 'Δεν υπάρχουν μηνύματα ακόμη',
  },

  startConversation: {
    en: 'Start the conversation by sending a message below.',
    bg: 'Започнете разговора, като изпратите съобщение по-долу.',
    de: 'Starten Sie das Gespräch, indem Sie unten eine Nachricht senden.',
    fr: 'Commencez la conversation en envoyant un message ci-dessous.',
    ro: 'Începeți conversația trimițând un mesaj mai jos.',
    tr: 'Aşağıdan bir mesaj göndererek konuşmayı başlatın.',
    sr: 'Започните разговор слањем поруке испод.',
    mk: 'Започнете разговор со испраќање порака подолу.',
    hu: 'Kezdje a beszélgetést egy üzenet küldésével alább.',
    sk: 'Začnite konverzáciu odoslaním správy nižšie.',
    sl: 'Začnite pogovor s pošiljanjem sporočila spodaj.',
    es: 'Inicie la conversación enviando un mensaje a continuación.',
    fi: 'Aloita keskustelu lähettämällä viesti alla.',
    el: 'Ξεκινήστε τη συνομιλία στέλνοντας ένα μήνυμα παρακάτω.',
  },

  typeMessage: {
    en: 'Type a message...',
    bg: 'Напишете съобщение...',
    de: 'Nachricht eingeben...',
    fr: 'Tapez un message...',
    ro: 'Scrieți un mesaj...',
    tr: 'Bir mesaj yazın...',
    sr: 'Унесите поруку...',
    mk: 'Напишете порака...',
    hu: 'Írjon üzenetet...',
    sk: 'Napíšte správu...',
    sl: 'Vnesite sporočilo...',
    es: 'Escriba un mensaje...',
    fi: 'Kirjoita viesti...',
    el: 'Πληκτρολογήστε μήνυμα...',
  },
  sendMessage: {
    en: 'Send message',
    bg: 'Изпрати съобщение',
    de: 'Nachricht senden',
    fr: 'Envoyer le message',
    ro: 'Trimite mesaj',
    tr: 'Mesaj gönder',
    sr: 'Пошаљи поруку',
    mk: 'Испрати порака',
    hu: 'Üzenet küldése',
    sk: 'Odoslať správu',
    sl: 'Pošlji sporočilo',
    es: 'Enviar mensaje',
    fi: 'Lähetä viesti',
    el: 'Αποστολή μηνύματος',
  },
  translated: {
    en: 'translated',
    bg: 'преведено',
    de: 'übersetzt',
    fr: 'traduit',
    ro: 'tradus',
    tr: 'çevirildi',
    sr: 'преведено',
    mk: 'преведено',
    hu: 'lefordítva',
    sk: 'preložené',
    sl: 'prevedeno',
    es: 'traducido',
    fi: 'käännetty',
    el: 'μεταφρασμένο',
  },
  'Listed {{date}}': {
    en: 'Listed {{date}}',
    bg: 'Публикувана на {{date}}',
    de: 'Veröffentlicht am {{date}}',
    fr: 'Publié le {{date}}',
    ro: 'Publicat la {{date}}',
    tr: '{{date}} tarihinde listelendi',
    sr: 'Objavljeno {{date}}',
    mk: 'Објавено на {{date}}',
    hu: 'Közzétéve: {{date}}',
    sk: 'Zverejnené {{date}}',
    sl: 'Objavljeno {{date}}',
    es: 'Publicado el {{date}}',
    fi: 'Listattu {{date}}',
    el: 'Καταχωρήθηκε στις {{date}}',
  },

  Open: {
    en: 'Open',
    bg: 'Отворена',
    de: 'Offen',
    fr: 'Ouvert',
    ro: 'Deschis',
    tr: 'Açık',
    sr: 'Otvoreno',
    mk: 'Отворено',
    hu: 'Nyitott',
    sk: 'Otvorené',
    sl: 'Odprto',
    es: 'Abierto',
    fi: 'Avoin',
    el: 'Ανοιχτό',
  },

  Reference: {
    en: 'Reference',
    bg: 'Референция',
    de: 'Referenz',
    fr: 'Référence',
    ro: 'Referință',
    tr: 'Referans',
    sr: 'Referenca',
    mk: 'Референца',
    hu: 'Hivatkozás',
    sk: 'Referencia',
    sl: 'Referenca',
    es: 'Referencia',
    fi: 'Viite',
    el: 'Αναφορά',
  },

  'Quote mode': {
    en: 'Quote mode',
    bg: 'Режим на офериране',
    de: 'Angebotsmodus',
    fr: 'Mode devis',
    ro: 'Mod ofertare',
    tr: 'Teklif modu',
    sr: 'Režim ponude',
    mk: 'Режим на понуδα',
    hu: 'Ajánlati mód',
    sk: 'Režim ponuky',
    sl: 'Način ponudbe',
    es: 'Modo de oferta',
    fi: 'Tarjoustila',
    el: 'Λειτουργία προσφοράς',
  },

  'Delivery window': {
    en: 'Delivery window',
    bg: 'Прозорец за доставка',
    de: 'Lieferzeitfenster',
    fr: 'Créneau de livraison',
    ro: 'Interval livrare',
    tr: 'Teslimat aralığı',
    sr: 'Vremenski okvir isporuke',
    mk: 'Временски прозорец за испорака',
    hu: 'Szállításι időablak',
    sk: 'Dodacie okno',
    sl: 'Časovno okno dostave',
    es: 'Ventana de entrega',
    fi: 'Toimitusikkuna',
    el: 'Παράθυρο παράδοσης',
  },

  'Pickup window': {
    en: 'Pickup window',
    bg: 'Прозорец за вземане',
    de: 'Abholzeitfenster',
    fr: 'Créneau d’enlèvement',
    ro: 'Interval preluare',
    tr: 'Alım aralığı',
    sr: 'Vremenski okvir preuzimanja',
    mk: 'Временски прозорец за подигање',
    hu: 'Felvételi időablak',
    sk: 'Okno vyzdvihnutia',
    sl: 'Časovno okno prevzema',
    es: 'Ventana de recogida',
    fi: 'Noutoikkuna',
    el: 'Παράθυρο παραλαβής',
  },

  'Quantities and handling details visible at a glance.': {
    en: 'Quantities and handling details visible at a glance.',
    bg: 'Количество и детайли за обработка, видими с един поглед.',
    de: 'Mengen- und Handhabungsdetails auf einen Blick sichtbar.',
    fr: 'Quantités et détails de manutention visibles en un coup d’œil.',
    ro: 'Cantitățile și detaliile de manipulare vizibile dintr-o privire.',
    tr: 'Miktarlar ve taşıma detayları bir bakışta görülebilir.',
    sr: 'Količine i detalji rukovanja vidljivi na prvi pogled.',
    mk: 'Количини и детали за ракување видливи на прв поглед.',
    hu: 'Mennyiségek és kezelési részletek egy pillantással láthatók.',
    sk: 'Množstvá a detaily manipulácie viditeľné na prvý pohľad.',
    sl: 'Količine in podrobnosti ravnanja vidne na prvi pogled.',
    es: 'Cantidades y detalles de manejo visibles de un vistazo.',
    fi: 'Määrät ja käsittelytiedot näkyvät yhdellä silmäyksellä.',
    el: 'Ποσότητες και λεπτομέρειες χειρισμού ορατές με μια ματιά.',
  },

  'The client has not uploaded any shipment images.': {
    en: 'The client has not uploaded any shipment images.',
    bg: 'Клиентът не е качил изображения на пратката.',
    de: 'Der Kunde hat keine Versandbilder hochgeladen.',
    fr: 'Le client n’a téléchargé aucune image de l’envoi.',
    ro: 'Clientul nu a încărcat imagini ale transportului.',
    tr: 'Müşteri herhangi bir gönderi görseli yüklemedi.',
    sr: 'Klijent nije otpremio slike pošiljke.',
    mk: 'Клиентот нема прикачено слики од пратката.',
    hu: 'Az ügyfél nem töltött fel képeket a szállítmányról.',
    sk: 'Klient nenahral žiadne obrázky zásielky.',
    sl: 'Stranka ni naložila slik pošiljke.',
    es: 'El cliente no ha subido imágenes del envío.',
    fi: 'Asiakas ei ole ladannut kuvia lähetyksestä.',
    el: 'Ο πελάτης δεν έχει μεταφορτώσει εικόνες αποστολής.',
  },
  'The gross price is what the customer pays. Our system calculates VAT based on your set rate.':
    {
      en: 'The gross price is what the customer pays. Our system calculates VAT based on your set rate.',
      bg: 'Брутната цена е товα, коеτо клиенτъτ плаща. Нашаτα сисτема изчислява ДДС според зададенаτα оτ вас сτавκα.',
      de: 'Der Bruttopreis ist das, was der Kunde zahlt. Unser System berechnet die MwSt. basierend auf Ihrem festgelegten Satz.',
      fr: 'Le prix brut est ce que le client paie. Notre système calcule la TVA selon votre taux défini.',
      ro: 'Prețul brut este ceea ce plătește clientul. Sistemul nostru calculează TVA-ul pe baza ratei setate de dvs.',
      tr: 'Brüt fiyat müşterinin ödediği tutardır. Sistemimiz KDV’yi belirlediğiniz orana göre hesaplar.',
      sr: 'Bruto cena je ono što klijent plaća. Naš sistem obračunava PDV na osnovu vaše stope.',
      mk: 'Бруто цеνατα е тоα што клиенτοτ го плаέα. Нашиοτ сисτεμα го пресметува ДДВ според вашаτα стапка.',
      hu: 'A bruttó ár az, amit az ügyfél fizet. Rendszerünk az ÁFA-t az Ön által beállított kulcs alapján számolja.',
      sk: 'Hrubá cena je to, čo zákazník platí. Náš systém vypočíta DPH na základe vašej sadzby.',
      sl: 'Bruto cena je tista, ki jo plača stranka. Naš sistem izračuna DDV glede na vašo stopnjo.',
      es: 'El precio bruto es lo que paga el cliente. Nuestro sistema calcula el IVA según tu tasa establecida.',
      fi: 'Bruttohinta on se, jonka asiakas maksaa. Järjestelmämme laskee ALV:n asetetun verokannan mukaan.',
      el: 'Η μικτή τιμή είναι αυτή που πληρώνει ο πελάτης. Το σύστημά μας υπολογίζει τον ΦΠΑ με βάση τον καθορισμένο συντελεστή σας.',
    },
  'BodyType.Hatchback': {
    en: 'Hatchback',
    bg: 'Хечбек',
    de: 'Kompaktwagen',
    fr: 'Berline',
    ro: 'Hatchback',
    tr: 'Hatchback',
    sr: 'Хечбек',
    mk: 'Хечбек',
    hu: 'Ferdehátú',
    sk: 'Hatchback',
    sl: 'Hatchback',
    es: 'Hatchback',
    fi: 'Viistoperä',
  },

  'BodyType.Coupe': {
    en: 'Coupé',
    bg: 'Купе',
    de: 'Coupé',
    fr: 'Coupé',
    ro: 'Coupé',
    tr: 'Coupé',
    sr: 'Купе',
    mk: 'Купе',
    hu: 'Kupé',
    sk: 'Kupé',
    sl: 'Kupe',
    es: 'Coupé',
    fi: 'Coupé',
  },

  'BodyType.Superauto': {
    en: 'Supercar',
    bg: 'Суперавтомобил',
    de: 'Supersportwagen',
    fr: 'Supercar',
    ro: 'Supermașină',
    tr: 'Süper otomobil',
    sr: 'Супераутомобил',
    mk: 'Суперавтомобил',
    hu: 'Szupersportautó',
    sk: 'Superšport',
    sl: 'Superavto',
    es: 'Superdeportivo',
    fi: 'Superauto',
  },

  'BodyType.Sedan': {
    en: 'Sedan',
    bg: 'Седан',
    de: 'Limousine',
    fr: 'Berline',
    ro: 'Sedan',
    tr: 'Sedan',
    sr: 'Седан',
    mk: 'Седан',
    hu: 'Sedan',
    sk: 'Sedan',
    sl: 'Limuzina',
    es: 'Sedán',
    fi: 'Sedan',
  },

  'BodyType.StationWagon': {
    en: 'Station Wagon',
    bg: 'Комби',
    de: 'Kombi',
    fr: 'Break',
    ro: 'Break',
    tr: 'Station Wagon',
    sr: 'Караван',
    mk: 'Караван',
    hu: 'Kombi',
    sk: 'Kombi',
    sl: 'Karavan',
    es: 'Familiar',
    fi: 'Farmari',
  },

  'BodyType.Crossover': {
    en: 'Crossover',
    bg: 'Кросоувър',
    de: 'Crossover',
    fr: 'Crossover',
    ro: 'Crossover',
    tr: 'Crossover',
    sr: 'Кросовер',
    mk: 'Кросовер',
    hu: 'Crossover',
    sk: 'Crossover',
    sl: 'Crossover',
    es: 'Crossover',
    fi: 'Crossover',
  },

  'BodyType.SUV': {
    en: 'SUV',
    bg: 'SUV',
    de: 'SUV',
    fr: 'SUV',
    ro: 'SUV',
    tr: 'SUV',
    sr: 'SUV',
    mk: 'SUV',
    hu: 'SUV',
    sk: 'SUV',
    sl: 'SUV',
    es: 'SUV',
    fi: 'SUV',
  },

  'BodyType.Pickup': {
    en: 'Pickup',
    bg: 'Пикап',
    de: 'Pickup',
    fr: 'Pick-up',
    ro: 'Pickup',
    tr: 'Pickup',
    sr: 'Пикап',
    mk: 'Пикап',
    hu: 'Pickup',
    sk: 'Pickup',
    sl: 'Pickup',
    es: 'Pickup',
    fi: 'Pickup',
  },

  'BodyType.Transport': {
    en: 'Transport Car',
    bg: 'Транспортен автомобил',
    de: 'Transportfahrzeug',
    fr: 'Véhicule de transport',
    ro: 'Vehicul de transport',
    tr: 'Taşıma aracı',
    sr: 'Транспортно возило',
    mk: 'Транспортно возило',
    hu: 'Szállítójármű',
    sk: 'Prepravné vozidlo',
    sl: 'Transportno vozilo',
    es: 'Vehículo de transporte',
    fi: 'Kuljetusajoneuvo',
  },

  'BodyType.Van': {
    en: 'Van',
    bg: 'Ван',
    de: 'Van',
    fr: 'Fourgon',
    ro: 'Van',
    tr: 'Van',
    sr: 'Ван',
    mk: 'Ван',
    hu: 'Furgon',
    sk: 'Dodávka',
    sl: 'Kombi',
    es: 'Furgoneta',
    fi: 'Pakettiauto',
  },

  'No vehicles added yet.': {
    en: 'No vehicles added yet.',
    bg: 'Все още няма добавени превозни средства.',
    de: 'Noch keine Fahrzeuge hinzugefügt.',
    fr: 'Aucun véhicule ajouté pour le moment.',
    ro: 'Încă nu au fost adăugate vehicule.',
    tr: 'Henüz araç eklenmedi.',
    sr: 'Још нема додатих возила.',
    mk: 'Сè уште няма додадено возила.',
    hu: 'Még nincs hozzáadott jármű.',
    sk: 'Zatiaľ neboli pridané žiadne vozidlá.',
    sl: 'Še ni dodanih vozil.',
    es: 'Todavía no se han añadido vehículos.',
    fi: 'Yhtään ajoneuvoa ei ole vielä valittu.',
  },
  'Documents needed on site': {
    en: 'Documents needed on site',
    bg: 'Необходими документи на място',
    de: 'Erforderliche Dokumente vor Ort',
    fr: 'Documents requis sur place',
    ro: 'Documente necesare la fața locului',
    tr: 'Sahada gereken belgeler',
    sr: 'Потребна документа на локацији',
    mk: 'Потребни документи на лице место',
    hu: 'Helyszínen szükséges dokumentumok',
    sk: 'Dokumenty potrebné na mieste',
    sl: 'Zahtevani dokumenti na lokaciji',
    es: 'Documentos necesarios en el sitio',
    fi: 'Paikan päällä tarvittavat asiakirjat',
  },
  'Notes for the partner': {
    en: 'Notes for the partner',
    bg: 'Бележки за партньора',
    de: 'Hinweise für den Partner',
    fr: 'Notes pour le partenaire',
    ro: 'Note pentru partener',
    tr: 'Partner notları',
    sr: 'Напомене за партнера',
    mk: 'Забелешки за партнерот',
    hu: 'Megjegyzések a partnernek',
    sk: 'Poznámky pre partnera',
    sl: 'Opombe za partnerja',
    es: 'Notas para el socio',
    fi: 'Huomiot kumppalille',
  },
  'Loading address is logistic centre': {
    en: 'Loading address is logistic centre',
    bg: 'Адресът за товарене е логистичен център',
    de: 'Ladeadresse ist Logistikzentrum',
    fr: 'L’adresse de chargement est un centre logistique',
    ro: 'Adresa de încărcare este un centru logistic',
    tr: 'Yükleme adresi lojistik merkezidir',
    sr: 'Адреса утовара је логистички центар',
    mk: 'Адресата за товарење е логистички центар',
    hu: 'A felrakó cím logisztikai központ',
    sk: 'Nakladacia adresa je logistické centrum',
    sl: 'Naslov nakladanja je logistični center',
    es: 'La dirección de carga es un centro logístico',
    fi: 'Lastausosoite on logistiikkakeskus',
  },
  'Loading address is not logistic centre': {
    en: 'Loading address is not logistic centre',
    bg: 'Адресът за товарене не е логистичен център',
    de: 'Ladeadresse ist kein Logistikzentrum',
    fr: 'L’adresse de chargement n’est pas un centre logistique',
    ro: 'Adresa de încărcare nu este un centru logistic',
    tr: 'Yükleme adresi lojistik merkezi değildir',
    sr: 'Адреса утовара није логистички центар',
    mk: 'Адресата за товарење не е логистички центар',
    hu: 'A felrakó cím nem logisztikai központ',
    sk: 'Nakladacia adresa nie je logistické centrum',
    sl: 'Naslov nakladanja ni logistični center',
    es: 'La dirección de carga no es un centro logístico',
    fi: 'Lastausosoite ei ole logistiikkakeskus',
  },
  'Company name': {
    en: 'Company name',
    bg: 'Име на компания',
    de: 'Firmenname',
    fr: "Nom de l'entreprise",
    ro: 'Numele companiei',
    tr: 'Şirket adı',
    sr: 'Назив компаније',
    mk: 'Име на компанија',
    hu: 'Cégnév',
    sk: 'Názov spoločnosti',
    sl: 'Ime podjetja',
    es: 'Nombre de la empresa',
    fi: 'Yrityksen nimi',
  },
  'Contact person': {
    en: 'Contact person',
    bg: 'Контакт лице',
    de: 'Ansprechpartner',
    fr: 'Personne de contact',
    ro: 'Persoană de contact',
    tr: 'İrtibat kişisi',
    sr: 'Контакт особа',
    mk: 'Контакт лице',
    hu: 'Kapcsolattartó',
    sk: 'Kontaktná osoba',
    sl: 'Kontaktna oseba',
    es: 'Persona de contacto',
    fi: 'Yhteyshenkilö',
  },
  'VAT Number': {
    en: 'VAT Number',
    bg: 'ДДС номер',
    de: 'USt-IdNr.',
    fr: 'Numéro de TVA',
    ro: 'Număr TVA',
    tr: 'KDV Numarası',
    sr: 'ПДВ број',
    mk: 'ДДВ број',
    hu: 'ÁFA-szám',
    sk: 'DIČ',
    sl: 'DDV številka',
    es: 'Número de IVA',
    fi: 'ALV-numero',
  },
  'VAT number is required': {
    en: 'VAT number is required',
    bg: 'ДДС номерът е задължителен',
    de: 'USt-IdNr. ist erforderlich',
    fr: 'Le numéro de TVA est requis',
    ro: 'Numărul TVA este obligatoriu',
    tr: 'KDV numarası gereklidir',
    sr: 'ПДВ број је обавезан',
    mk: 'ДДВ бројот е задолжителен',
    hu: 'Az ÁFA-szám kötelező',
    sk: 'DIČ je povinné',
    sl: 'DDV številka je obvezna',
    es: 'El número de IVA es obligatorio',
    fi: 'ALV-numero on pakollinen',
  },
  'Company name is required': {
    en: 'Company name is required',
    bg: 'Името на фирмата е задължително',
    de: 'Firmenname ist erforderlich',
    fr: "Le nom de l'entreprise est requis",
    ro: 'Numele companiei este obligatoriu',
    tr: 'Şirket adı gereklidir',
    sr: 'Назив компаније је обавезан',
    mk: 'Името на компанијата е задолжително',
    hu: 'A cégnév kötelező',
    sk: 'Názov spoločnosti je povinný',
    sl: 'Ime podjetja je obvezno',
    es: 'El nombre de la empresa es obligatorio',
    fi: 'Yrityksen nimi on pakollinen',
  },
  'VAT number must not exceed 30 characters': {
    en: 'VAT number must not exceed 30 characters',
    bg: 'ДДС номерът не трябва да надвишава 30 символа',
    de: 'USt-IdNr. darf nicht länger als 30 Zeichen sein',
    fr: 'Le numéro de TVA ne doit pas dépasser 30 caractères',
    ro: 'Numărul TVA nu trebuie să depășească 30 de caractere',
    tr: 'KDV numarası 30 karakteri aşmamalıdır',
    sr: 'ПДВ број не сме бити дужи од 30 карактера',
    mk: 'ДДВ бројот не смее да надминува 30 карактери',
    hu: 'Az ÁFA-szám nem lehet hosszabb 30 karakternél',
    sk: 'DIČ nesmie presiahnuť 30 znakov',
    sl: 'DDV številka ne sme presegati 30 znakov',
    es: 'El número de IVA no debe exceder 30 caracteres',
    fi: 'ALV-numero ei saa ylittää 30 merkkiä',
  },
  'Contact language': {
    en: 'Contact language',
    bg: 'Език за контакт',
    de: 'Kontakt­sprache',
    fr: 'Langue de contact',
    ro: 'Limba de contact',
    tr: 'İletişim dili',
    sr: 'Језик за контакт',
    mk: 'Јазик за контакт',
    hu: 'Kapcsolattartási nyelv',
    sk: 'Komunikačný jazyk',
    sl: 'Jezik za stik',
    es: 'Idioma de contacto',
    fi: 'Yhteydenottokieli',
  },
  'Contact phone': {
    en: 'Contact phone',
    bg: 'Телефон за контакт',
    de: 'Kontakttelefon',
    fr: 'Téléphone de contact',
    ro: 'Telefon de contact',
    tr: 'İletişim telefonu',
    sr: 'Контакт телефон',
    mk: 'Телефон за контакт',
    hu: 'Kapcsolattartó telefonszám',
    sk: 'Kontaktné číslo',
    sl: 'Kontaktna telefonska številka',
    es: 'Teléfono de contacto',
    fi: 'Yhteyshenkilön puhelin',
  },
  'Contact email': {
    en: 'Contact email',
    bg: 'Имейл за контакт',
    de: 'Kontakt-E-Mail',
    fr: 'E-mail de contact',
    ro: 'Email de contact',
    tr: 'İletişim e-postası',
    sr: 'Контакт имејл',
    mk: 'Контакт е-пошта',
    hu: 'Kapcsolattartó e-mail',
    sk: 'Kontaktný e-mail',
    sl: 'Kontaktni e-naslov',
    es: 'Correo de contacto',
    fi: 'Yhteyshenkilön sähköposti',
  },
  'Pickup document': {
    en: 'Pickup document',
    bg: 'Документ за вземане',
    de: 'Abhol­dokument',
    fr: "Document d'enlèvement",
    ro: 'Document de ridicare',
    tr: 'Teslim alma belgesi',
    sr: 'Документ за преузимање',
    mk: 'Документ за подигање',
    hu: 'Átvételi dokumentum',
    sk: 'Doklad na prevzatie',
    sl: 'Dokument za prevzem',
    es: 'Documento de recogida',
    fi: 'Noutoasiakirja',
  },
  'Pick up document': {
    en: 'Pick up document',
    bg: 'Документ за вземане',
    de: 'Abhol­dokument',
    fr: "Document d'enlèvement",
    ro: 'Document de ridicare',
    tr: 'Teslim alma belgesi',
    sr: 'Документ за преузимање',
    mk: 'Документ за подигање',
    hu: 'Átvételi dokumentum',
    sk: 'Doklad na prevzatie',
    sl: 'Dokument za prevzem',
    es: 'Documento de recogida',
    fi: 'Noutoasiakirja',
  },
  'Pick up code': {
    en: 'Pick up code',
    bg: 'Код за вземане',
    de: 'Abholcode',
    fr: "Code d'enlèvement",
    ro: 'Cod de ridicare',
    tr: 'Teslim kodu',
    sr: 'Код за преузимање',
    mk: 'Код за подигање',
    hu: 'Átvételi kód',
    sk: 'Kód na prevzatie',
    sl: 'Koda za prevzem',
    es: 'Código de recogida',
    fi: 'Noutokoodi',
  },
  'Vehicle registration': {
    en: 'Vehicle registration',
    bg: 'Регистрация на превозно средство',
    de: 'Zulassungspapiere',
    fr: 'Carte grise',
    ro: 'Certificat de înmatriculare',
    tr: 'Araç ruhsatı',
    sr: 'Саобраћајна дозвола',
    mk: 'Сообраќајна дозвола',
    hu: 'Forgalmi engedély',
    sk: 'Osvedčenie o vozidle',
    sl: 'Prometna dovolilnica',
    es: 'Permiso de circulación',
    fi: 'Rekisteriote',
  },
  'Remove vehicle': {
    en: 'Remove vehicle',
    bg: 'Премахни превозното средство',
    de: 'Fahrzeug entfernen',
    fr: 'Retirer le véhicule',
    ro: 'Elimină vehiculul',
    tr: 'Aracı kaldır',
    sr: 'Уклони возило',
    mk: 'Отстрани возилото',
    hu: 'Jármű eltávolítása',
    sk: 'Odstrániť vozidlo',
    sl: 'Odstrani vozilo',
    es: 'Quitar vehículo',
    fi: 'Poista ajoneuvo',
  },
  'Remove time slot': {
    en: 'Remove time slot',
    bg: 'Премахни времеви интервал',
    de: 'Zeitfenster entfernen',
    fr: 'Supprimer le créneau',
    ro: 'Șterge intervalul',
    tr: 'Zaman dilimini kaldır',
    sr: 'Уклони термин',
    mk: 'Отстрани термин',
    hu: 'Idősáv törlése',
    sk: 'Odstrániť časový úsek',
    sl: 'Odstrani termin',
    es: 'Eliminar franja horaria',
    fi: 'Poista aikajakso',
  },
  'Upload or drag & drop. Accepted: .jpg, .png, .pdf, .docx, .xls': {
    en: 'Upload or drag & drop. Accepted: .jpg, .png, .pdf, .docx, .xls',
    bg: 'Качи или плъзни и пусни. Приемат се: .jpg, .png, .pdf, .docx, .xls',
    de: 'Hochladen oder per Drag & Drop. Erlaubt: .jpg, .png, .pdf, .docx, .xls',
    fr: 'Téléchargez ou glissez-déposez. Formats acceptés : .jpg, .png, .pdf, .docx, .xls',
    ro: 'Încarcă sau trage și plasează. Acceptate: .jpg, .png, .pdf, .docx, .xls',
    tr: 'Yükleyin veya sürükleyip bırakın. Desteklenen: .jpg, .png, .pdf, .docx, .xls',
    sr: 'Отпреми или превуци и пусти. Подржано: .jpg, .png, .pdf, .docx, .xls',
    mk: 'Прикачи или повлечи и пушти. Поддржано: .jpg, .png, .pdf, .docx, .xls',
    hu: 'Tölts fel vagy húzd ide. Elfogadott: .jpg, .png, .pdf, .docx, .xls',
    sk: 'Nahrajte alebo presuňte. Podporované: .jpg, .png, .pdf, .docx, .xls',
    sl: 'Naloži ali povleci in spusti. Podprto: .jpg, .png, .pdf, .docx, .xls',
    es: 'Sube o arrastra y suelta. Admitidos: .jpg, .png, .pdf, .docx, .xls',
    fi: 'Lataa tai vedä ja pudota. Tuetut: .jpg, .png, .pdf, .docx, .xls',
  },
  'Local time': {
    en: 'Local time',
    bg: 'Местно време',
    de: 'Ortszeit',
    fr: 'Heure locale',
    ro: 'Ora locală',
    tr: 'Yerel saat',
    sr: 'Локално време',
    mk: 'Локално време',
    hu: 'Helyi idő',
    sk: 'Miestny čas',
    sl: 'Lokalni čas',
    es: 'Hora local',
    fi: 'Paikallinen aika',
  },
  Closed: {
    en: 'Closed',
    bg: 'Затворено',
    de: 'Geschlossen',
    fr: 'Fermé',
    ro: 'Închis',
    tr: 'Kapalı',
    sr: 'Затворено',
    mk: 'Затворено',
    hu: 'Zárva',
    sk: 'Zatvorené',
    sl: 'Zaprto',
    es: 'Cerrado',
    fi: 'Suljettu',
  },
  'I confirm these opening hours are correct': {
    en: 'I confirm these opening hours are correct',
    bg: 'Потвърждавам, че работното време е вярно',
    de: 'Ich bestätige, dass diese Öffnungszeiten korrekt sind',
    fr: 'Je confirme que ces horaires sont corrects',
    ro: 'Confirm că acest program este corect',
    tr: 'Bu çalışma saatlerinin doğru olduğunu onaylıyorum',
    sr: 'Потврђујем да е ова радно време тачно',
    mk: 'Потврдувам дека овој распоред е точен',
    hu: 'Megerősítem, hogy a nyitvatartás helyes',
    sk: 'Potvrdzujem, že tieto otváracie hodiny sú správne',
    sl: 'Potrjujem, da so ti urniki pravilni',
    es: 'Confirmo que este horario es correcto',
    fi: 'Vahvistan, että nämä aukioloajat ovat oikeat',
  },
  'Avoid missed trips by matching the window the truck can enter the premises.':
    {
      en: 'Avoid missed trips by matching the window the truck can enter the premises.',
      bg: 'Избегнете пропуснати курсове като посочите времето, когато камионът може да влезе.',
      de: 'Vermeiden Sie Fehlfahrten, indem Sie das Zeitfenster angeben, in dem der Lkw auf das Gelände darf.',
      fr: 'Évitez les courses manquées en précisant le créneau pendant lequel le camion peut entrer.',
      ro: 'Evita cursele ratate indicând intervalul în care camionul poate intra.',
      tr: 'Kamyonun tesise girebildiği zaman aralığını paylaşarak kaçırılan seferleri önleyin.',
      sr: 'Избегните промашаје тако што ћете навести термин када камион може да уђе у круг.',
      mk: 'Избегнете промашени курсови со наведување кога камионот смее да влезе.',
      hu: 'Kerülje el a sikertelen fuvarokat azzal, hogy megadja, mikor hajthat be a teherautó.',
      sk: 'Predíďte zmeškaným nakládkam určením okna, kedy môže kamión vojsť do areálu.',
      sl: 'Izognite se zamujenim vožnjam z določanjem termina, ko sme tovornjak na lokacijo.',
      es: 'Evita viajes fallidos indicando la franja en la que el camión puede entrar.',
      fi: 'Vältä epäonnistuneet ajot kertomalla, milloin kuorma-auto pääsee alueelle.',
    },
  'Avoid additional costs by sharing the exact depot availability.': {
    en: 'Avoid additional costs by sharing the exact depot availability.',
    bg: 'Избегнете допълнителни разходи, като посочите точната заетост на депото.',
    de: 'Vermeiden Sie Mehrkosten, indem Sie die genaue Depotverfügbarkeit mitteilen.',
    fr: 'Évitez les coûts supplémentaires en partageant précisément les disponibilités du dépôt.',
    ro: 'Evită costurile suplimentare oferind disponibilitatea exactă a depozitului.',
    tr: 'Depo uygunluğunu paylaşarak ek maliyetlerden kaçının.',
    sr: 'Избегните додатне трошкове тако што ћете поделити тачну доступност депоа.',
    mk: 'Избегнете дополнителни трошоци со споделување на точната достапност на депото.',
    hu: 'Kerülje el a többletköltségeket a raktár pontos nyitvatartásának megadásával.',
    sk: 'Vyhnite sa dodatočným nákladom zdieľaním presnej dostupnosti depa.',
    sl: 'Izognite se dodatnim stroškom z natančno objavo razpoložljivosti terminala.',
    es: 'Evita costes adicionales compartiendo la disponibilidad exacta del depósito.',
    fi: 'Vältä lisäkuluja jakamalla varikon tarkka aukiolo.',
  },
  'Provide both pickup and delivery postal codes to preview the lane on the map.':
    {
      en: 'Provide both pickup and delivery postal codes to preview the lane on the map.',
      bg: 'Въведете пощенските кодове за товарене и доставка, за да видите трасето на картата.',
      de: 'Geben Sie Abhol- und Liefer-Postleitzahl an, um die Strecke auf der Karte zu sehen.',
      fr: 'Indiquez les codes postaux de collecte et de livraison pour prévisualiser l’itinéraire sur la carte.',
      ro: 'Introdu codurile poștale de ridicare și livrare pentru a previzualiza ruta pe hartă.',
      tr: 'Haritada güzergâhı görmek için yükleme ve teslim posta kodlarını girin.',
      sr: 'Унесите поштанске кодове за утовар и истовар да бисте видели трасу на карти.',
      mk: 'Внесете поштенски код за подигање и достава за да ја видите трасата.',
      hu: 'Adja meg a felrakó és lerakó irányítószámát, hogy lássa az útvonalat a térképen.',
      sk: 'Zadajte PSČ nakládky aj vykládky, aby ste videli trasu na mape.',
      sl: 'Vnesite poštni številki prevzema in dostave za predogled poti na zemljevidu.',
      es: 'Introduce los códigos postales de origen y destino para previsualizar la ruta.',
      fi: 'Anna sekä nouto- että toimituspostinumerot nähdäksesi reitin kartalla.',
    },
  'Provide route details': {
    en: 'Provide route details',
    bg: 'Добавете данни за маршрута',
    de: 'Geben Sie Routen­details an',
    fr: 'Fournissez les détails de l’itinéraire',
    ro: 'Oferă detalii despre rută',
    tr: 'Rota ayrıntılarını paylaşın',
    sr: 'Додајте детаље руте',
    mk: 'Додадете детали за рутата',
    hu: 'Adjon meg útvonal részleteket',
    sk: 'Zadajte detaily trasy',
    sl: 'Dodajte podrobnosti poti',
    es: 'Proporciona los detalles de la ruta',
    fi: 'Lisää reitin tiedot',
  },
  'City not set': {
    en: 'City not set',
    bg: 'Градът не е зададен',
    de: 'Stadt nicht gesetzt',
    fr: 'Ville non renseignée',
    ro: 'Oraș necompletat',
    tr: 'Şehir belirtilmedi',
    sr: 'Град није подешен',
    mk: 'Град не е зададен',
    hu: 'Város nincs megadva',
    sk: 'Mesto nie je vyplnené',
    sl: 'Mesto ni nastavljeno',
    es: 'Ciudad no definida',
    fi: 'Kaupunkia ei ole asetettu',
  },
  'Route details': {
    en: 'Route details',
    bg: 'Детайли за маршрута',
    de: 'Routendetails',
    fr: 'Détails de l’itinéraire',
    ro: 'Detalii rută',
    tr: 'Rota ayrıntıları',
    sr: 'Детаљи руте',
    mk: 'Детали за рутата',
    hu: 'Útvonal részletek',
    sk: 'Detaily trasy',
    sl: 'Podrobnosti poti',
    es: 'Detalles de la ruta',
    fi: 'Reitin tiedot',
  },
  Lane: {
    en: 'Lane',
    bg: 'Линия',
    de: 'Relation',
    fr: 'Ligne',
    ro: 'Coridor',
    tr: 'Hat',
    sr: 'Линија',
    mk: 'Линија',
    hu: 'Reláció',
    sk: 'Relácia',
    sl: 'Relacija',
    es: 'Corredor',
    fi: 'Linja',
  },
  'Distance & time': {
    en: 'Distance & time',
    bg: 'Разстояние и време',
    de: 'Distanz & Zeit',
    fr: 'Distance & temps',
    ro: 'Distanță și timp',
    tr: 'Mesafe ve süre',
    sr: 'Раздаљина и време',
    mk: 'Растојание и време',
    hu: 'Távolság és idő',
    sk: 'Vzdialenosť a čas',
    sl: 'Razdalja in čas',
    es: 'Distancia y tiempo',
    fi: 'Etäisyys ja aika',
  },
  'Latest quote preview': {
    en: 'Latest quote preview',
    bg: 'Преглед на последната оферта',
    de: 'Neueste Angebotsvorschau',
    fr: 'Dernier aperçu de devis',
    ro: 'Ultima previzualizare a ofertei',
    tr: 'Son teklif önizlemesi',
    sr: 'Преглед последње понуде',
    mk: 'Преглед на последната понуда',
    hu: 'Legutóbbi ajánlat előnézete',
    sk: 'Náhľad poslednej ponuky',
    sl: 'Predogled zadnje ponudbe',
    es: 'Previsualización de la última oferta',
    fi: 'Viimeisin tarjousesikatselu',
  },
  or: {
    en: 'or',
    bg: 'или',
    de: 'oder',
    fr: 'ou',
    ro: 'sau',
    tr: 'veya',
    sr: 'или',
    mk: 'или',
    hu: 'vagy',
    sk: 'alebo',
    sl: 'ali',
    es: 'o',
    fi: 'tai',
  },
  'Enter manual price': {
    en: 'Enter manual price',
    bg: 'Въведете ръчна цена',
    de: 'Manuellen Preis eingeben',
    fr: 'Saisir un prix manuel',
    ro: 'Introduceți prețul manual',
    tr: 'Manuel fiyat girin',
    sr: 'Унесите ручну цену',
    mk: 'Внесете рачна цена',
    hu: 'Adjon meg manuális árat',
    sk: 'Zadajte manuálnu cenu',
    sl: 'Vnesite ročno ceno',
    es: 'Introducir precio manual',
    fi: 'Syötä manuaalinen hinta',
  },

  'Inputs changed · recalc to refresh quote': {
    en: 'Inputs changed · recalc to refresh quote',
    bg: 'Данните са променени · преизчислете за нова оферта',
    de: 'Eingaben geändert · neu berechnen für aktualisiertes Angebot',
    fr: 'Entrées modifiées · recalculer pour actualiser le devis',
    ro: 'Date modificate · recalcul pentru a reîmprospăta oferta',
    tr: 'Veriler değişti · teklifi yenilemek için tekrar hesaplayın',
    sr: 'Подаци измењени · израчунати поново за нову понуду',
    mk: 'Внесовите се сменети · пресметајте повторно за нова понуда',
    hu: 'Bemenetek módosultak · számolja újra az ajánlat frissítéséhez',
    sk: 'Vstupy sa zmenili · prepočítajte ponuku',
    sl: 'Vnosi so se spremenili · ponovno izračunaj ponudbo',
    es: 'Cambios en datos · recalcula para actualizar la oferta',
    fi: 'Syötteet muuttuivat · laske uudelleen tarjouksen päivittämiseksi',
  },
  'Route preview': {
    en: 'Route preview',
    bg: 'Преглед на маршрута',
    de: 'Routenvorschau',
    fr: 'Prévisualisation de l’itinéraire',
    ro: 'Previzualizare rută',
    tr: 'Rota önizlemesi',
    sr: 'Преглед руте',
    mk: 'Преглед на рутата',
    hu: 'Útvonal előnézet',
    sk: 'Náhľad trasy',
    sl: 'Predogled poti',
    es: 'Vista previa de la ruta',
    fi: 'Reitin esikatselu',
  },
  'Fill in the VIN or specs for each vehicle type.': {
    en: 'Fill in the VIN or specs for each vehicle type.',
    bg: 'Попълнете VIN или параметри за всеки тип превозно средство.',
    de: 'Tragen Sie VIN oder Spezifikationen für jeden Fahrzeugtyp ein.',
    fr: 'Renseignez le VIN ou les spécifications pour chaque type de véhicule.',
    ro: 'Completează VIN-ul sau specificațiile pentru fiecare tip de vehicul.',
    tr: 'Her araç türü için ayrıntıları doldurun ve parametreleri belirtin.',
    sr: 'Попуните детаље и наведите параметре за сваки тип возила.',
    mk: 'Пополнете ги деталите и наведете ги параметрите за секој тип возило.',
    hu: 'Töltse ki a részleteket és adja meg a paramétereket minden járműtípushoz.',
    sk: 'Vyplňte podrobnosti a špecifikujte parametre pre každý typ vozidla.',
    sl: 'Izpolnite podrobnosti in določite parametre za vsak tip vozila.',
    es: 'Rellene los detalles y especifique los parámetros para cada tipo de vehículo.',
    fi: 'Täytä tiedot ja määritä parametrit jokaiselle ajoneuvotyypille.',
  },
  'Tell us where we collect the vehicles and who to contact.': {
    en: 'Tell us where we collect the vehicles and who to contact.',
    bg: 'Кажете ни откъде да вземем превозните средства и кого да потърсим.',
    de: 'Nennen Sie den Abholort und den Ansprechpartner.',
    fr: 'Indiquez où récupérer les véhicules et qui contacter.',
    ro: 'Spune-ne de unde ridicăm vehiculele și pe cine contactăm.',
    tr: 'Araçları nereden alacağımızı ve kime ulaşacağımızı belirtin.',
    sr: 'Реците нам где преузимамо возила и кога да контактирамо.',
    mk: 'Кажете ни од каде да ги подигнеме возилата и со кого да се чуеме.',
    hu: 'Adja meg az átvételi helyet és a kapcsolattartót.',
    sk: 'Povedzte, kde vozidlá preberáme a koho kontaktovať.',
    sl: 'Povejte, kje prevzamemo vozila in koga kontaktirati.',
    es: 'Indica dónde recogemos los vehículos y con quién hablar.',
    fi: 'Kerro, mistä ajoneuvot noudetaan ja keneen ollaan yhteydessä.',
  },
  'Confirm the destination contact and address.': {
    en: 'Confirm the destination contact and address.',
    bg: 'Потвърдете контакт и адрес за доставка.',
    de: 'Bestätigen Sie Kontakt und Adresse am Ziel.',
    fr: 'Confirmez le contact et l’adresse de destination.',
    ro: 'Confirmă contactul și adresa destinației.',
    tr: 'Teslimat için iletişim ve adresi doğrulayın.',
    sr: 'Потврдите контакт и адресу одредишта.',
    mk: 'Потврдете контакт и адреса на дестинацијата.',
    hu: 'Erősítse meg a célállomás címét és kapcsolattartóját.',
    sk: 'Potvrďte kontakt a adresu cieľa.',
    sl: 'Potrdite kontakt in naslov dostave.',
    es: 'Confirma el contacto y la dirección de destino.',
    fi: 'Vahvista kohteen yhteystiedot ja osoite.',
  },
  'Add schedule, opening hours, and special instructions.': {
    en: 'Add schedule, opening hours, and special instructions.',
    bg: 'Добавете график, работно време и специални инструкции.',
    de: 'Fügen Sie Zeitplan, Öffnungszeiten und besondere Anweisungen hinzu.',
    fr: 'Ajoutez planning, horaires d’ouverture et consignes spéciales.',
    ro: 'Adaugă program, orar și instrucțiuni speciale.',
    tr: 'Programı, çalışma saatlerini ve özel talimatları ekleyin.',
    sr: 'Додајте распоред, радно време и специјалне инструкције.',
    mk: 'Додајте распоред, работно време и специјални насоки.',
    hu: 'Adjon hozzá menetrendet, nyitvatartást és külön utasításokat.',
    sk: 'Pridajte harmonogram, otváracie hodiny a špeciálne pokyny.',
    sl: 'Dodajte urnik, odpiralni čas in posebna navodila.',
    es: 'Añade agenda, horarios y instrucciones especiales.',
    fi: 'Lisää aikataulu, aukioloajat ja erityisohjeet.',
  },
  'Finalize the handover plan': {
    en: 'Finalize the handover plan with scheduling cues, site availability, and sustainability preferences. This view keeps everything critical in one place without repeating details from earlier steps.',
    bg: 'Финализирайте плана за предаване с график, наличност на площадката и устойчиви предпочитания, без да повтаряте информацията от предишните стъпки.',
    de: 'Finalisieren Sie den Übergabeplan mit Terminhinweisen, Standortverfügbarkeit und Nachhaltigkeits­präferenzen – alles auf einer Ansicht ohne Wiederholungen.',
    fr: 'Finalisez le plan de remise avec les créneaux, la disponibilité du site et les préférences durables. Tout est regroupé ici sans répéter les étapes précédentes.',
    ro: 'Finalizează planul de predare cu indicii de planificare, disponibilitatea locației și preferințele de sustenabilitate, fără a repeta informațiile din pașii anteriori.',
    tr: 'Teslim planını zamanlama ipuçları, saha uygunluğu ve sürdürülebilirlik tercihleriyle tamamlayın; tüm kritik bilgiler tek ekranda toplanır.',
    sr: 'Завршите план предаје са терминима, доступношћу локације и одрживим преференцијама у екранираном прегледу.',
    mk: 'Завршете го планот за предавање со распоред, достапност на локацијата и еколошки преференции – сè на едно место.',
    hu: 'Véglegesítse az átadási tervet az időpontokkal, telephelyi elérhetőséggel és fenntarthatósági preferenciákkal; minden fontos adat egy nézetben van.',
    sk: 'Dokončite plán odovzdania so signálmi pre harmonogram, dostupnosťou miesta a preferenciami udržateľnosti bez opakovania predchádzajúcich krokov.',
    sl: 'Zaključite načrt predaje z urniki, razpoložljivostjo lokacije in trajnostnimi željami – vse ključno je na enem mestu.',
    es: 'Finaliza el plan de entrega con horarios, disponibilidad del sitio y preferencias de sostenibilidad sin repetir datos de pasos anteriores.',
    fi: 'Viimeistele luovutussuunnitelma aikataulujen, paikan saatavuuden ja kestävyyspreferenssien kanssa – kaikki tärkeä löytyy yhdestä näkymästä.',
  },
  'Share green requirements, certification numbers, or carbon reporting needs.':
    {
      en: 'Share green requirements, certification numbers, or carbon reporting needs.',
      bg: 'Споделете екологични изисквания, номера на сертификати или нужди от въглеродно отчитане.',
      de: 'Teilen Sie grüne Anforderungen, Zertifizierungsnummern oder CO₂-Berichtsanforderungen mit.',
      fr: 'Partagez les exigences écologiques, les numéros de certification ou les besoins en matière de rapport carbone.',
      ro: 'Distribuie cerințele ecologice, numerele de certificare sau nevoile de raportare a emisiilor de carbon.',
      tr: 'Yeşil gereksinimleri, sertifika numaralarını veya karbon raporlama ihtiyaçlarını paylaşın.',
      sr: 'Поделите еколошке захтеве, бројеве сертификата или потребе за извештавање о угљенику.',
      mk: 'Споделете зелени барања, броеви на сертификати или потреби за известување за јаглерод.',
      hu: 'Ossza meg a zöld követelményeket, tanúsítvány számokat vagy a szén-dioxid jelentési igényeket.',
      sk: 'Zdieľajte ekologické požiadavky, čísla certifikátov alebo potreby hlásenia uhlíka.',
      sl: 'Delite zelene zahteve, številke certifikatov ali potrebe po poročanju o ogljiku.',
      es: 'Comparte los requisitos ecológicos, los números de certificación o las necesidades de informes de carbono.',
      fi: 'Jaa vihreät vaatimukset, sertifiointinumerot tai hiilidioksidiraportointitarpeet.',
    },
  'Select Pick up Date': {
    en: 'Select Pick up Date',
    bg: 'Изберете дата на вземане',
    de: 'Abholdatum auswählen',
    fr: 'Sélectionner la date de ramassage',
    ro: 'Selectează data de ridicare',
    tr: 'Alma Tarihini Seçin',
    sr: 'Изаберите датум преузимања',
    mk: 'Изберете датум на подигање',
    hu: 'Válassza ki a felvétel dátumát',
    sk: 'Vyberte dátum vyzdvihnutia',
    sl: 'Izberite datum prevzema',
    es: 'Seleccionar fecha de recogida',
    fi: 'Valitse noutopäivä',
  },
  'Select the date when the cargo is to be picked up.': {
    en: 'Select the date when the cargo is to be picked up.',
    bg: 'Изберете датата, когато товарът трябва да бъде взет.',
    de: 'Wählen Sie das Datum, an dem die Ladung abgeholt werden soll.',
    fr: 'Sélectionnez la date à laquelle la cargaison doit être ramassée.',
    ro: 'Selectați data când marfa trebuie ridicată.',
    tr: 'Yükün alınacağı tarihi seçin.',
    sr: 'Изаберите датум када треба преузети терет.',
    mk: 'Изберете датум кога треба да се подигне товарот.',
    hu: 'Válassza ki a rakomány felvételének dátumát.',
    sk: 'Vyberte dátum, kedy sa má náklad vyzdvihnúť.',
    sl: 'Izberite datum, ko naj se tovor prevzame.',
    es: 'Seleccione la fecha en que se recogerá la carga.',
    fi: 'Valitse päivämäärä, jolloin rahti noudetaan.',
  },
  'Select Delivery Date': {
    en: 'Select Delivery Date',
    bg: 'Изберете дата на доставка',
    de: 'Lieferdatum auswählen',
    fr: 'Sélectionner la date de livraison',
    ro: 'Selectează data de livrare',
    tr: 'Teslimat Tarihini Seçin',
    sr: 'Изаберите датум испоруке',
    mk: 'Изберете датум на испорака',
    hu: 'Válassza ki a szállítás dátumát',
    sk: 'Vyberte dátum doručenia',
    sl: 'Izberite datum dostave',
    es: 'Seleccionar fecha de entrega',
    fi: 'Valitse toimituspäivä',
  },
  'Vehicle pickup location': {
    en: 'Vehicle pickup location',
    bg: 'Място за вземане на превозно средство',
    de: 'Abholadresse des Fahrzeugs',
    fr: 'Lieu de ramassage du véhicule',
    ro: 'Locația de ridicare a vehiculului',
    tr: 'Araç alma yeri',
    sr: 'Адреса преузимања возила',
    mk: 'Адреса за подигање на возилото',
    hu: 'Jármű felvételi hely',
    sk: 'Adresa vyzdvihnutia vozidla',
    sl: 'Naslov prevzema vozila',
    es: 'Ubicación de recogida del vehículo',
    fi: 'Ajoneuvon noutopaikka',
  },
  'Vehicle delivery location': {
    en: 'Vehicle delivery location',
    bg: 'Адресът за разтоварване е логистичен център',
    de: 'Entladeadresse ist Logistikzentrum',
    fr: 'L’adresse de déchargement est un centre logistique',
    ro: 'Adresa de descărcare este un centru logistic',
    tr: 'Boşaltma adresi lojistik merkezidir',
    sr: 'Адреса истовара је логистички центар',
    mk: 'Адресата за истовар е логистички центар',
    hu: 'A lerakó cím logisztikai központ',
    sk: 'Vykladacia adresa je logistické centrum',
    sl: 'Naslov razkladanja je logistični center',
    es: 'La dirección de descarga es un centro logístico',
    fi: 'Purkausosoite on logistiikkakeskus',
  },
  'No contact set': {
    en: 'No contact set',
    bg: 'Не е зададен контакт',
    de: 'Kein Kontakt festgelegt',
    fr: 'Aucun contact défini',
    ro: 'Niciun contact setat',
    tr: 'İletişim ayarlanmadı',
    sr: 'Није постављен контакт',
    mk: 'Не е поставен контакт',
    hu: 'Nincs beállított kapcsolat',
    sk: 'Nie je nastavený kontakt',
    sl: 'Ni nastavljenega kontakta',
    es: 'No se ha establecido contacto',
    fi: 'Yhteystietoja ei ole asetettu',
  },
  'Vehicles scheduled': {
    en: 'Vehicles scheduled',
    bg: 'Планирани превозни средства',
    de: 'Fahrzeuge geplant',
    fr: 'Véhicules programmés',
    ro: 'Vehicule programate',
    tr: 'Araçlar planlandı',
    sr: 'Возила су планирана',
    mk: 'Возила се закажани',
    hu: 'Járművek ütemezve',
    sk: 'Vozidlá naplánované',
    sl: 'Vozila so načrtovana',
    es: 'Vehículos programados',
    fi: 'Ajoneuvot aikataulutettu',
  },
  'Quoted price': {
    en: 'Quoted price',
    bg: 'Офертирана цена',
    de: 'Angebotspreis',
    fr: 'Prix indiqué',
    ro: 'Preț cotat',
    tr: 'Teklif edilen fiyat',
    sr: 'Понуђена цена',
    mk: 'Понудена цена',
    hu: 'Ajánlati ár',
    sk: 'Odhadovaná cena',
    sl: 'Ponujena cena',
    es: 'Precio cotizado',
    fi: 'Tarjottu hinta',
  },
  'Excl. any partner fees': {
    en: 'Excl. any partner fees',
    bg: 'Без такси на партньори',
    de: 'Ohne Partnergebühren',
    fr: 'Hors frais de partenaires',
    ro: 'Excl. orice taxe ale partenerilor',
    tr: 'Herhangi bir ortak ücret hariç',
    sr: 'Искључујући било какве партнерске накнаде',
    mk: 'Без такси на партнери',
    hu: 'Kizárva minden partneri díjat',
    sk: 'Bez poplatkov partnerov',
    sl: 'Brez partnerskih pristojbin',
    es: 'Excl. cualquier tarifa de socio',
    fi: 'Pois lukien mahdolliset kumppanimaksut',
  },
  'Premium pricing for VIP customers': {
    en: 'Premium pricing for VIP customers',
    bg: 'Премиум ценообразуване за VIP клиенти',
    de: 'Premium-Preise für VIP-Kunden',
    fr: 'Tarification premium pour les clients VIP',
    ro: 'Prețuri premium pentru clienții VIP',
    tr: 'VIP müşteriler için premium fiyatlandırma',
    sr: 'Премиум цене за VIP клијенте',
    mk: 'Премиум цени за VIP клиенти',
    hu: 'Prémium árképzés VIP ügyfelek számára',
    sk: 'Prémiové ceny pre VIP klientov',
    sl: 'Premium cene za VIP stranke',
    es: 'Precios premium para clientes VIP',
    fi: 'Premium-hinnoittelu VIP-asiakkaille',
  },
  'Determine the route and select options that match your vehicle mix.': {
    en: 'Determine the route and select options that match your vehicle mix.',
    bg: 'Определете маршрута и изберете опции според видовете превозни средства.',
    de: 'Bestimmen Sie die Relation und wählen Sie Optionen passend zu Ihrer Fahrzeugmischung.',
    fr: 'Définissez la liaison et sélectionnez les options adaptées à votre flotte.',
    ro: 'Stabilește traseul și opțiunile potrivite pentru flota ta.',
    tr: 'Güzergâhı belirleyin ve araç karmasına uygun seçenekleri seçin.',
    sr: 'Одредите руту и изаберите опције које одговарају вашем миксу возила.',
    mk: 'Одредете ја трасата и проценете го миксот на возила.',
    hu: 'Határozza meg az útvonalat, és válasszon a járműmixhez illeszkedő opciókat.',
    sk: 'Určite trasu a zvoľte možnosti zodpovedajúce zloženiu vozidiel.',
    sl: 'Določite relacijo in izberite možnosti, ki ustrezajo vaši floti.',
    es: 'Define el corredor y selecciona opciones acordes a tu mezcla de vehículos.',
    fi: 'Määritä reitti ja valitse ajoneuvokokoonpano.',
  },
  'Recalculate price': {
    en: 'Recalculate price',
    bg: 'Пресметни отново цената',
    de: 'Preis neu berechnen',
    fr: 'Recalculer le prix',
    ro: 'Recalculați prețul',
    tr: 'Fiyatı yeniden hesapla',
    sr: 'Пресметајте поново цену',
    mk: 'Пресметај ја цената повторно',
    hu: 'Ár újraszámítása',
    sk: 'Znovu vypočítať cenu',
    sl: 'Ponovno izračunaj ceno',
    es: 'Recalcular precio',
    fi: 'Laske hinta uudelleen',
  },
  'Add at least one vehicle.': {
    en: 'Add at least one vehicle.',
    bg: 'Добавете поне едно превозно средство.',
    de: 'Fügen Sie mindestens ein Fahrzeug hinzu.',
    fr: 'Ajoutez au moins un véhicule.',
    ro: 'Adaugă cel puțin un vehicul.',
    tr: 'En az bir araç ekleyin.',
    sr: 'Додајте најмање једно возило.',
    mk: 'Додајте барем едно возило.',
    hu: 'Adjon hozzá legalább egy járművet.',
    sk: 'Pridajte aspoň jedno vozidlo.',
    sl: 'Dodajte vsaj eno vozilo.',
    es: 'Añade al menos un vehículo.',
    fi: 'Lisää vähintään yksi ajoneuvo.',
  },
  'Add the vehicle weight.': {
    en: 'Add the vehicle weight.',
    bg: 'Добавете теглото на превозното средство.',
    de: 'Fügen Sie das Fahrzeuggewicht hinzu.',
    fr: 'Ajoutez le poids du véhicule.',
    ro: 'Adaugă greutatea vehiculului.',
    tr: 'Araç ağırlığını ekleyin.',
    sr: 'Додајте тежину возила.',
    mk: 'Додајте ја тежината на возилото.',
    hu: 'Adja meg a jármű súlyát.',
    sk: 'Pridajte hmotnosť vozidla.',
    sl: 'Dodajte težo vozila.',
    es: 'Añade el peso del vehículo.',
    fi: 'Lisää ajoneuvon paino.',
  },
  'Add at least one pickup time window.': {
    en: 'Add at least one pickup time window.',
    bg: 'Добавете поне един прозорец за вземане.',
    de: 'Fügen Sie mindestens ein Abholzeitfenster hinzu.',
    fr: 'Ajoutez au moins une plage horaire de ramassage.',
    ro: 'Adaugă cel puțin o fereastră de timp pentru ridicare.',
    tr: 'En az bir alma zaman aralığı ekleyin.',
    sr: 'Додајте најмање један прозор за преузимање.',
    mk: 'Додајте барем еден прозор за подигање.',
    hu: 'Adjon hozzá legalább egy felvételi időablakot.',
    sk: 'Pridajte aspoň jedno časové okno vyzdvihnutia.',
    sl: 'Dodajte vsaj eno časovno okno prevzema.',
    es: 'Añade al menos una franja horaria de recogida.',
    fi: 'Lisää vähintään yksi noutoaika.',
  },
  'Confirm the pickup opening hours.': {
    en: 'Confirm the pickup opening hours.',
    bg: 'Потвърдете работното време за вземане.',
    de: 'Bestätigen Sie die Abholöffnungszeiten.',
    fr: "Confirmez les horaires d'ouverture du ramassage.",
    ro: 'Confirmă orele de deschidere pentru ridicare.',
    tr: 'Alma çalışma saatlerini doğrulayın.',
    sr: 'Потврђујем да е ова радно време точно',
    mk: 'Потврдете работното време за подигање.',
    hu: 'Erősítse meg a felvételi nyitvatartási időket.',
    sk: 'Potvrdzujem, že tieto otváracie hodiny sú správne',
    sl: 'Potrjujem, da so ti urniki pravilni',
    es: 'Confirmo que este horario es correcto',
    fi: 'Vahvistan, että nämä aukioloajat ovat oikeat',
  },
  'Pickup date must be selected.': {
    en: 'Pickup date must be selected.',
    bg: 'Трябва да бъде избрана дата за вземане.',
    de: 'Abholdatum muss ausgewählt werden.',
    fr: 'La date de ramassage doit être sélectionnée.',
    ro: 'Trebuie selectată data de ridicare.',
    tr: 'Alma tarihi seçilmelidir.',
    sr: 'Мора бити изабран датум преузимања.',
    mk: 'Мора да се избере датум на подигање.',
    hu: 'A felvétel dátumát ki kell választani.',
    sk: 'Dátum vyzdvihnutia musí byť vybraný.',
    sl: 'Datum prevzema mora biti izbran.',
    es: 'Se debe seleccionar la fecha de recogida.',
    fi: 'Noutopäivä on valittava.',
  },
  'Add at least one delivery time window.': {
    en: 'Add at least one delivery time window.',
    bg: 'Добавете поне един прозорец за доставка.',
    de: 'Fügen Sie mindestens ein Lieferzeitfenster hinzu.',
    fr: 'Ajoutez au moins une plage horaire de livraison.',
    ro: 'Adaugă cel puțin o fereastră de timp pentru livrare.',
    tr: 'En az bir teslimat zaman aralığı ekleyin.',
    sr: 'Додајте најмање један прозор за испоруку.',
    mk: 'Додајте барем еден прозор за испорака.',
    hu: 'Adjon hozzá legalább egy szállítási időablakot.',
    sk: 'Pridajte aspoň jedno časové okno doručenia.',
    sl: 'Dodajte vsaj eno časovno okno dostave.',
    es: 'Añade al menos una franja horaria de entrega.',
    fi: 'Lisää vähintään yksi toimitusaika.',
  },
  'Confirm the delivery opening hours.': {
    en: 'Confirm the delivery opening hours.',
    bg: 'Потвърдете работното време за доставка.',
    de: 'Bestätigen Sie die Lieferöffnungszeiten.',
    fr: "Confirmez les horaires d'ouverture de la livraison.",
    ro: 'Confirmă orele de deschidere pentru livrare.',
    tr: 'Teslimat çalışma saatlerini doğrulayın.',
    sr: 'Потвърђујем да е ова радно време точно',
    mk: 'Потврдете работното време за испорака.',
    hu: 'Megerősítem a szállítási nyitvatartási időket.',
    sk: 'Potvrdzujem, že tieto otváracie hodiny sú správne',
    sl: 'Potrjujem, da so ti urniki pravilni',
    es: 'Confirmo que este horario es correcto',
    fi: 'Vahvistan, että nämä aukioloajat ovat oikeat',
  },
  'Add a weight for each vehicle.': {
    en: 'Add a weight for each vehicle.',
    bg: 'Добавете тегло за всяко превозно средство.',
    de: 'Fügen Sie für jedes Fahrzeug ein Gewicht hinzu.',
    fr: 'Ajoutez un poids pour chaque véhicule.',
    ro: 'Adaugă o greutate pentru fiecare vehicul.',
    tr: 'Her araç için bir ağırlık ekleyin.',
    sr: 'Додајте тежину за сваки тип возила.',
    mk: 'Додајте тежина за секој тип возило.',
    hu: 'Adjon meg egy súlyt minden járműhöz.',
    sk: 'Pridajte hmotnosť pre každé vozidlo.',
    sl: 'Dodajte težo za vsako vozilo.',
    es: 'Añade un peso para cada vehículo.',
    fi: 'Lisää paino jokaiselle ajoneuvolle.',
  },
  'One of the locations could not be positioned on the map.': {
    en: 'One of the locations could not be positioned on the map.',
    bg: 'Едно от местоположенията не може да бъде позиционирано на картата.',
    de: 'Einer der Standorte konnte nicht auf der Karte positioniert werden.',
    fr: 'L’un des emplacements n’a pas pu être positionné sur la carte.',
    ro: 'Una dintre locații nu a putut fi poziționată pe hartă.',
    tr: 'Konumlardan biri haritada konumlandırılamadı.',
    sr: 'Једна од локација није могла бити позиционирана на мапи.',
    mk: 'Една од локациите не можеше да се позиционира на мапата.',
    hu: 'Az egyik helyszín nem helyezhető el a térképen.',
    sk: 'Jedno z miest nebolo možné umiestniť na mapu.',
    sl: 'Ena od lokacij ni bila mogoče postaviti na zemljevid.',
    es: 'No se pudo posicionar una de las ubicaciones en el mapa.',
    fi: 'Yhtä sijaintia ei voitu sijoittaa kartalle.',
  },
  'Unable to load the map preview right now.': {
    en: 'Unable to load the map preview right now.',
    bg: 'В момента не може да се зареди визуализацията на картата.',
    de: 'Die Karten-Vorschau kann derzeit nicht geladen werden.',
    fr: 'Impossible de charger l’aperçu de la carte pour le moment.',
    ro: 'Previzualizarea hărții nu poate fi încărcată chiar acum.',
    tr: 'Harita önizlemesi şu anda yüklenemiyor.',
    sr: 'Тренутно није могуће учитати преглед мапе.',
    mk: 'Не може да се вчита прегледот на мапата во моментов.',
    hu: 'A térkép előnézete jelenleg nem tölthető be.',
    sk: 'Náhľad mapy sa momentálne nedá načítať.',
    sl: 'Predogled zemljevida trenutno ni mogoče naložiti.',
    es: 'No se puede cargar la vista previa del mapa en este momento.',
    fi: 'Karttavideota ei voi ladata juuri nyt.',
  },
  'Quote updated': {
    en: 'Quote updated',
    bg: 'Офертата е актуализирана.',
    de: 'Angebot aktualisiert',
    fr: 'Devis mis à jour',
    ro: 'Cotația a fost actualizată.',
    tr: 'Teklif güncellendi',
    sr: 'Понуда је ажурирана.',
    mk: 'Понудата е ажурирана.',
    hu: 'Az ajánlat frissítve.',
    sk: 'Ponuka aktualizovaná',
    sl: 'Ponudba posodobljena',
    es: 'Cotización actualizada',
    fi: 'Tarjous päivitetty',
  },
  'Estimated total client price €{{price}}': {
    en: 'Estimated total client price €{{price}}',
    bg: 'Прогнозирана обща цена за клиента €{{price}}',
    de: 'Geschätzter Gesamtpreis für den Kunden €{{price}}',
    fr: 'Prix client total estimé €{{price}}',
    ro: 'Prețul total estimat pentru client €{{price}}',
    tr: 'Tahmini toplam müşteri fiyatı €{{price}}',
    sr: 'Процењена укупна цена за клијента €{{price}}',
    mk: 'Проценета вкупна цена за клиентот €{{price}}',
    hu: 'Becsült teljes ügyfélár €{{price}}',
    sk: 'Odhadovaná celková cena pre klienta €{{price}}',
    sl: 'Ocenjena skupna cena za stranko €{{price}}',
    es: 'Precio total estimado para el cliente €{{price}}',
    fi: 'Arvioitu kokonaisasiakashinta €{{price}}',
  },
  'Complete missing data': {
    en: 'Complete missing data',
    bg: 'Попълнете липсващите данни.',
    de: 'Fehlende Daten vervollständigen.',
    fr: 'Complétez les données manquantes.',
    ro: 'Completează datele lipsă.',
    tr: 'Eksik verileri tamamlayın.',
    sr: 'Попуните недостајуће податке.',
    mk: 'Пополнете ги недостасувачките податоци.',
    hu: 'Töltse ki a hiányzó adatokat.',
    sk: 'Doplňte chýbajúce údaje.',
    sl: 'Izpolnite manjkajoče podatke.',
    es: 'Completa los datos que faltan.',
    fi: 'Täydennä puuttuvat tiedot.',
  },
  'Finish each step before creating the booking.': {
    en: 'Finish each step before creating the booking.',
    bg: 'Завършете всяка стъпка, преди да създадете резервацията.',
    de: 'Beenden Sie jeden Schritt, bevor Sie die Buchung erstellen.',
    fr: 'Terminez chaque étape avant de créer la réservation.',
    ro: 'Finalizează fiecare pas înainte de a crea rezervarea.',
    tr: 'Rezervasyonu oluşturmadan önce her adımı tamamlayın.',
    sr: 'Завршите сваки корак пре него што креирате резервацију.',
    mk: 'Завршете го секој чекор пред да ја креирате резервацијата.',
    hu: 'Fejezze be az egyes lépéseket a foglalás létrehozása előtt.',
    sk: 'Dokončite každý krok pred vytvorením rezervácie.',
    sl: 'Dokončajte vsak korak, preden ustvarite rezervacijo.',
    es: 'Termina cada paso antes de crear la reserva.',
    fi: 'Viimeistele jokainen vaihe ennen varauksen luomista.',
  },
  'User not logged in': {
    en: 'User not logged in',
    bg: 'Потребно е влизане на потребителя.',
    de: 'Benutzer nicht eingeloggt.',
    fr: 'Utilisateur non connecté.',
    ro: 'Utilizator neautentificat.',
    tr: 'Kullanıcı giriş yapmadı.',
    sr: 'Корисник није пријављен.',
    mk: 'Корисникот не е најавен.',
    hu: 'A felhasználó nincs bejelentkezve.',
    sk: 'Používateľ nie je prihlásený.',
    sl: 'Uporabnik ni prijavljen.',
    es: 'Usuario no ha iniciado sesión.',
    fi: 'Käyttäjä ei ole kirjautunut sisään.',
  },
  'Booking created': {
    en: 'Booking created',
    bg: 'Резервацията е създадена.',
    de: 'Buchung erstellt',
    fr: 'Réservation créée',
    ro: 'Rezervarea a fost creată.',
    tr: 'Rezervasyon oluşturuldu',
    sr: 'Резервација је креирана.',
    mk: 'Резервацијата е креирана.',
    hu: 'Foglalás létrehozva.',
    sk: 'Rezervácia vytvorená',
    sl: 'Rezervacija ustvarjena',
    es: 'Reserva creada.',
    fi: 'Varaus luotu.',
  },
  Bookings: {
    en: 'Bookings',
    bg: 'Резервации',
    de: 'Buchungen',
    fr: 'Réservations',
    ro: 'Rezervări',
    tr: 'Rezervasyonlar',
    sr: 'Резервације',
    mk: 'Резервации',
    hu: 'Foglalások',
    sk: 'Rezervácie',
    sl: 'Rezervacije',
    es: 'Reservas',
    fi: 'Varaukset',
  },
  Trucks: {
    en: 'Trucks',
    bg: 'Камиони',
    de: 'LKW',
    fr: 'Camions',
    ro: 'Camioane',
    tr: 'Kamyonlar',
    sr: 'Камиони',
    mk: 'Камиони',
    hu: 'Teherautók',
    sk: 'Nákladné vozidlá',
    sl: 'Tovornjaki',
    es: 'Camiones',
    fi: 'Kuorma-autot',
  },
  Drivers: {
    en: 'Drivers',
    bg: 'Шофьори',
    de: 'Fahrer',
    fr: 'Chauffeurs',
    ro: 'Șoferi',
    tr: 'Sürücüler',
    sr: 'Возачи',
    mk: 'Возачи',
    hu: 'Sofőrök',
    sk: 'Vodiči',
    sl: 'Vozniki',
    es: 'Conductores',
    fi: 'Kuljettajat',
  },
  'Your transport request is now visible under My Orders.': {
    en: 'Your transport request is now visible under My Orders.',
    bg: 'Вашата заявка за транспорт вече е видима в Моите поръчки.',
    de: 'Ihre Transportanfrage ist jetzt unter Meine Bestellungen sichtbar.',
    fr: 'Votre demande de transport est désormais visible dans Mes commandes.',
    ro: 'Cererea dvs. de transport este acum vizibilă în secțiunea Comenzile mele.',
    tr: 'Taşıma talebiniz artık Siparişlerim altında görünür.',
    sr: 'Ваш захтев за транспорт је сада видљив у Моје наруџбине.',
    mk: 'Вашето барање за транспорт сега е видливо во Моите нарачки.',
    hu: 'A szállítási kérelme mostantól látható a Saját rendelések alatt.',
    sk: 'Vaša požiadavka na prepravu je teraz viditeľná v sekcii Moje objednávky.',
    sl: 'Vaša zahteva za prevoz je zdaj vidna pod Moje naročila.',
    es: 'Su solicitud de transporte ahora es visible en Mis pedidos.',
    fi: 'Kuljetuspyyntösi on nyt näkyvissä Tilaukseni-osiossa.',
  },
  'Booking failed': {
    en: 'Booking failed',
    bg: 'Неуспешна резервация.',
    de: 'Buchung fehlgeschlagen',
    fr: 'Échec de la réservation',
    ro: 'Rezervarea a eșuat.',
    tr: 'Rezervasyon başarısız oldu',
    sr: 'Резервација није успела.',
    mk: 'Неуспешна резервација.',
    hu: 'Foglalás sikertelen.',
    sk: 'Rezervácia zlyhala',
    sl: 'Rezervacija ni uspela',
    es: 'La reserva ha fallado.',
    fi: 'Varauksen luominen epäonnistui.',
  },
  'Booking was created but no id returned.': {
    en: 'Booking was created but no id returned.',
    bg: 'Резервацията е създадена, но не е върнат идентификатор.',
    de: 'Die Buchung wurde erstellt, aber keine ID zurückgegeben.',
    fr: 'La réservation a été créée, pero no se ha devuelto ningún ID.',
    ro: 'Rezervarea a fost creată, dar nu a fost returnat niciun ID.',
    tr: 'Rezervasyon oluşturuldu ancak kimlik döndürülmedi.',
    sr: 'Резервација је креирана, али није враћен идентификатор.',
    mk: 'Резервацијата е креирана, но не е вратен идентификатор.',
    hu: 'A foglalás létrejött, de nem tért vissza azonosító.',
    sk: 'Rezervácia bola vytvorená, ale nebol vrátený žiadny identifikátor.',
    sl: 'Rezervacija je bila ustvarjena, vendar ni bil vrnjen noben ID.',
    es: 'La reserva se creó pero no se devolvió ningún ID.',
    fi: 'Varaus luotiin, mutta tunnistetta ei palautettu.',
  },
  'Error creating booking': {
    en: 'Error creating booking',
    bg: 'Грешка при създаване на резервация.',
    de: 'Fehler bei der Buchungserstellung.',
    fr: 'Erreur lors de la création de la réservation.',
    ro: 'Eroare la crearea rezervării.',
    tr: 'Rezervasyon oluşturulurken hata oluştu.',
    sr: 'Грешка при креирању резервације.',
    mk: 'Грешка при креирање на резервација.',
    hu: 'Hiba a foglalás létrehozásakor.',
    sk: 'Chyba pri vytváraní rezervácie.',
    sl: 'Napaka pri ustvarjanju rezervacije.',
    es: 'Error al crear la reserva.',
    fi: 'Virhe varauksen luomisessa.',
  },
  'An unexpected error occurred.': {
    en: 'An unexpected error occurred.',
    bg: 'Възникна неочаквана грешка.',
    de: 'Ein unerwarteter Fehler ist aufgetreten.',
    fr: 'Une erreur inattendue s’est produite.',
    ro: 'A apărut o eroare neașteptată.',
    tr: 'Beklenmeyen bir hata oluştu.',
    sr: 'Догодила се неочекивана грешка.',
    mk: 'Настана неочекувана грешка.',
    hu: 'Váratlan hiba történt.',
    sk: 'Došlo k neočakávanej chybe.',
    sl: 'Prišlo je do nepričakovane napake.',
    es: 'Ocurrió un error inesperado.',
    fi: 'Tapahtui odottamaton virhe.',
  },
  'I confirm the pickup opening hours': {
    en: 'I confirm the pickup opening hours',
    bg: 'Потвърждавам работното време за вземане',
    de: 'Ich bestätige die Abholöffnungszeiten',
    fr: "Je confirme les horaires d'ouverture du ramassage",
    ro: 'Confirm orele de deschidere pentru ridicare',
    tr: 'Alma çalışma saatlerini onaylıyorum',
    sr: 'Потврђујем да е ова радно време точно',
    mk: 'Потврдете работното време за подигање.',
    hu: 'Megerősítem a felvételi nyitvatartási időket',
    sk: 'Potvrdzujem, že tieto otváracie hodiny sú správne',
    sl: 'Potrjujem, da so ti urniki pravilni',
    es: 'Confirmo que este horario es correcto',
    fi: 'Vahvistan, että nämä aukioloajat ovat oikeat',
  },
  'I confirm the delivery opening hours': {
    en: 'I confirm the delivery opening hours',
    bg: 'Потвърждавам работното време за доставка',
    de: 'Ich bestätige die Lieferöffnungszeiten',
    fr: "Je confirme les horaires d'ouverture de la livraison",
    ro: 'Confirm orele de deschidere pentru livrare',
    tr: 'Teslimat çalışma saatlerini onaylıyorum',
    sr: 'Потвърђујем да е ова радно време точно',
    mk: 'Потврдете работното време за испорака.',
    hu: 'Megerősítem a szállítási nyitvatartási időket',
    sk: 'Potvrdzujem, že tieto otváracie hodiny sú správne',
    sl: 'Potrjujem, da so ti urniki pravilni',
    es: 'Confirmo que este horario es correcto',
    fi: 'Vahvistan, että nämä aukioloajat ovat oikeat',
  },
  Mo: {
    en: 'Mo',
    bg: 'Пн',
    de: 'Mo',
    fr: 'Lu',
    ro: 'Lu',
    tr: 'Pt',
    sr: 'Пн',
    mk: 'Пн',
    hu: 'Hé',
    sk: 'Po',
    sl: 'Po',
    es: 'Lu',
    fi: 'Ma',
  },
  Tu: {
    en: 'Tu',
    bg: 'Вт',
    de: 'Di',
    fr: 'Ma',
    ro: 'Ma',
    tr: 'Sa',
    sr: 'Вт',
    mk: 'Вт',
    hu: 'Ke',
    sk: 'Ut',
    sl: 'To',
    es: 'Ma',
    fi: 'Ti',
  },
  We: {
    en: 'We',
    bg: 'Ср',
    de: 'Mi',
    fr: 'Me',
    ro: 'Mi',
    tr: 'Ça',
    sr: 'Ср',
    mk: 'Ср',
    hu: 'Sze',
    sk: 'St',
    sl: 'Sr',
    es: 'Mi',
    fi: 'Ke',
  },
  Th: {
    en: 'Th',
    bg: 'Чт',
    de: 'Do',
    fr: 'Je',
    ro: 'Jo',
    tr: 'Pe',
    sr: 'Чт',
    mk: 'Чт',
    hu: 'Cs',
    sk: 'Št',
    sl: 'Če',
    es: 'Ju',
    fi: 'To',
  },
  Fr: {
    en: 'Fr',
    bg: 'Пт',
    de: 'Fr',
    fr: 'Ve',
    ro: 'Vi',
    tr: 'Cu',
    sr: 'Пт',
    mk: 'Пт',
    hu: 'Pé',
    sk: 'Pi',
    sl: 'Pe',
    es: 'Vi',
    fi: 'Pe',
  },
  Sa: {
    en: 'Sa',
    bg: 'Сб',
    de: 'Sa',
    fr: 'Sa',
    ro: 'Sâ',
    tr: 'Ct',
    sr: 'Сб',
    mk: 'Сб',
    hu: 'Szo',
    sk: 'So',
    sl: 'Sobota',
    es: 'Sá',
    fi: 'La',
  },
  Su: {
    en: 'Su',
    bg: 'Нд',
    de: 'So',
    fr: 'Di',
    ro: 'Du',
    tr: 'Pz',
    sr: 'Нд',
    mk: 'Нд',
    hu: 'Vas',
    sk: 'Ne',
    sl: 'Ne',
    es: 'Do',
    fi: 'Su',
  },
  Monday: {
    en: 'Monday',
    bg: 'Понеделник',
    de: 'Montag',
    fr: 'Lundi',
    ro: 'Luni',
    tr: 'Pazartesi',
    sr: 'Понедељак',
    mk: 'Понеделник',
    hu: 'Hétfő',
    sk: 'Pondelok',
    sl: 'Ponedeljek',
    es: 'Lunes',
    fi: 'Maanantai',
  },
  Tuesday: {
    en: 'Tuesday',
    bg: 'Вторник',
    de: 'Dienstag',
    fr: 'Mardi',
    ro: 'Marți',
    tr: 'Salı',
    sr: 'Уторак',
    mk: 'Вторник',
    hu: 'Kedd',
    sk: 'Utorok',
    sl: 'Torek',
    es: 'Martes',
    fi: 'Tiistai',
  },
  Wednesday: {
    en: 'Wednesday',
    bg: 'Сряда',
    de: 'Mittwoch',
    fr: 'Mercredi',
    ro: 'Miercuri',
    tr: 'Çarşamba',
    sr: 'Среда',
    mk: 'Среда',
    hu: 'Szerda',
    sk: 'Streda',
    sl: 'Sreda',
    es: 'Miércoles',
    fi: 'Keskiviikko',
  },
  Thursday: {
    en: 'Thursday',
    bg: 'Четвъртък',
    de: 'Donnerstag',
    fr: 'Jeudi',
    ro: 'Joi',
    tr: 'Perşembe',
    sr: 'Четвртак',
    mk: 'Четврток',
    hu: 'Csütörtök',
    sk: 'Štvrtok',
    sl: 'Četrtek',
    es: 'Jueves',
    fi: 'Torstai',
  },
  Friday: {
    en: 'Friday',
    bg: 'Петък',
    de: 'Freitag',
    fr: 'Vendredi',
    ro: 'Vineri',
    tr: 'Cuma',
    sr: 'Петак',
    mk: 'Петок',
    hu: 'Péntek',
    sk: 'Piatok',
    sl: 'Petek',
    es: 'Viernes',
    fi: 'Perjantai',
  },
  Saturday: {
    en: 'Saturday',
    bg: 'Събота',
    de: 'Samstag',
    fr: 'Samedi',
    ro: 'Sâmbătă',
    tr: 'Cumartesi',
    sr: 'Субота',
    mk: 'Сабота',
    hu: 'Szombat',
    sk: 'Sobota',
    sl: 'Sobota',
    es: 'Sábado',
    fi: 'Lauantai',
  },
  Sunday: {
    en: 'Sunday',
    bg: 'Неделя',
    de: 'Sonntag',
    fr: 'Dimanche',
    ro: 'Duminică',
    tr: 'Pazar',
    sr: 'Недеља',
    mk: 'Недела',
    hu: 'Vasárnap',
    sk: 'Nedeľa',
    sl: 'Nedelja',
    es: 'Domingo',
    fi: 'Sunnuntai',
  },
  'Calculate price': {
    en: 'Calculate price',
    bg: 'Изчисли цена',
    de: 'Preis berechnen',
    fr: 'Calculer le prix',
    ro: 'Calculați prețul',
    tr: 'Fiyat hesapla',
    sr: 'Izračunaj cenu',
    mk: 'Пресметај цена',
    hu: 'Ár kiszámítása',
    sk: 'Vypočítať cenu',
    sl: 'Izračunaj ceno',
    es: 'Calcular precio',
    fi: 'Laske hinta',
  },
  'Zip Code': {
    en: 'Zip Code',
    bg: 'Пощенски код',
    de: 'Postleitzahl',
    fr: 'Code postal',
    ro: 'Cod poștal',
    tr: 'Posta kodu',
    sr: 'Poštanski broj',
    mk: 'Поштенски код',
    hu: 'Irányítószám',
    sk: 'PSČ',
    sl: 'Poštna številka',
    es: 'Código postal',
    fi: 'Postinumero',
  },
  'Calculate a price to proceed.': {
    en: 'Calculate a price to proceed.',
    bg: 'Изчислете цена, за да продължите.',
    de: 'Berechnen Sie einen Preis, um fortzufahren.',
    fr: 'Calculez un prix pour continuer.',
    ro: 'Calculați un preț pentru a continua.',
    tr: 'Devam etmek için bir fiyat hesaplayın.',
    sr: 'Izračunajte cenu da biste nastavili.',
    mk: 'Пресметајте цена за да продолжите.',
    hu: 'Árajánlatot számoljon a folytatáshoz.',
    sk: 'Vypočítajte cenu pre pokračovanie.',
    sl: 'Izračunaj ceno za nadaljevanje.',
    es: 'Calcule un precio para continuar.',
    fi: 'Laske hinta jatkaaksesi.',
  },
  'Fill in the details and specify the parameters for every vehicle type.': {
    en: 'Fill in the details and specify the parameters for every vehicle type.',
    bg: 'Попълнете данните и посочете параметрите за всеки тип превозно средство.',
    de: 'Geben Sie die Details ein und legen Sie die Parameter für jeden Fahrzeugtyp fest.',
    fr: 'Remplissez les détails et spécifiez les paramètres pour chaque type de véhicule.',
    ro: 'Completați detaliile și specificați parametrii pentru fiecare tip de vehicul.',
    tr: 'Her araç tipi için ayrıntıları doldurun ve parametreleri belirtin.',
    sr: 'Попуните детаље и наведите параметре за сваки тип возила.',
    mk: 'Пополнете ги деталите и наведете ги параметрите за секој тип возило.',
    hu: 'Töltse ki a részleteket és adja meg a paramétereket minden járműtípushoz.',
    sk: 'Vyplňte podrobnosti a špecifikujte parametre pre každý typ vozidla.',
    sl: 'Izpolnite podrobnosti in določite parametre za vsak tip vozila.',
    es: 'Rellene los detalles y especifique los parámetros para cada tipo de vehículo.',
    fi: 'Täytä tiedot ja määritä parametrit jokaiselle ajoneuvotyypille.',
  },
  'Chassis Number/Licence plate': {
    en: 'Chassis Number/Licence plate',
    bg: 'Номер на шасито/Регистрационен номер',
    de: 'Fahrgestellnummer/Kennzeichen',
    fr: "Numéro de châssis/Plaque d'immatriculation",
    ro: 'Serie de șasiu/Număr de înmatriculare',
    tr: 'Şasi Numarası/Plaka',
    sr: 'Broj šasije/Registarske tablice',
    mk: 'Број на шасија/Регистарски таблички',
    hu: 'Alvázszám/Rendszámtábla',
    sk: 'VIN číslo/Evidenčné číslo vozidla (ŠPZ)',
    sl: 'Številka šasije/Registrske tablice',
    es: 'Número de bastidor/Matrícula',
    fi: 'Alustanumero/Rekisterikilpi',
  },
  'Make / Model': {
    en: 'Make / Model',
    bg: 'Марка / Модел',
    de: 'Marke / Modell',
    fr: 'Marque / Modèle',
    ro: 'Marcă / Model',
    tr: 'Yapı / Model',
    sr: 'Marka / Model',
    mk: 'Марка / Модел',
    hu: 'Márka / Modell',
    sk: 'Značka / Model',
    sl: 'Znamka / Model',
    es: 'Marca / Modelo',
    fi: 'Merkki / Malli',
  },
  'Dimensions (cm)': {
    en: 'Dimensions (cm)',
    bg: 'Размери (см)',
    de: 'Abmessungen (cm)',
    fr: 'Dimensions (cm)',
    ro: 'Dimensiuni (cm)',
    tr: 'Boyutlar (cm)',
    sr: 'Димензије (cm)',
    mk: 'Димензии (см)',
    hu: 'Méretek (cm)',
    sk: 'Rozmery (cm)',
    sl: 'Dimenzije (cm)',
    es: 'Dimensiones (cm)',
    fi: 'Mitat (cm)',
  },
  'Width (cm)': {
    en: 'Width (cm)',
    bg: 'Ширина (см)',
    de: 'Breite (cm)',
    fr: 'Largeur (cm)',
    ro: 'Lățime (cm)',
    tr: 'Genişlik (cm)',
    sr: 'Ширина (cm)',
    mk: 'Ширина (см)',
    hu: 'Szélesség (cm)',
    sk: 'Šírka (cm)',
    sl: 'Širina (cm)',
    es: 'Ancho (cm)',
    fi: 'Leveys (cm)',
  },
  'Height (cm)': {
    en: 'Height (cm)',
    bg: 'Височина (см)',
    de: 'Höhe (cm)',
    fr: 'Hauteur (cm)',
    ro: 'Înălțime (cm)',
    tr: 'Boy (cm)',
    sr: 'Visina (cm)',
    mk: 'Висина (cm)',
    hu: 'Magasság (cm)',
    sk: 'Výška (cm)',
    sl: 'Višina (cm)',
    es: 'Altura (cm)',
    fi: 'Korkeus (cm)',
  },
  'Length (cm)': {
    en: 'Length (cm)',
    bg: 'Дължина (см)',
    de: 'Länge (cm)',
    fr: 'Longueur (cm)',
    ro: 'Lungime (cm)',
    tr: 'Uzunluk (cm)',
    sr: 'Dužina (cm)',
    mk: 'Должина (см)',
    hu: 'Hossz (cm)',
    sk: 'Dĺžka (cm)',
    sl: 'Dolžina (cm)',
    es: 'Longitud (cm)',
    fi: 'Pituus (cm)',
  },
  'Weight (kg)*': {
    en: 'Weight (kg)*',
    bg: 'Тегло (кг)*',
    de: 'Gewicht (kg)*',
    fr: 'Poids (kg)*',
    ro: 'Greutate (kg)*',
    tr: 'Ağırlık (kg)*',
    sr: 'Тежина (кг)*',
    mk: 'Тежина (кг)*',
    hu: 'Súly (kg)*',
    sk: 'Hmotnosť (kg)*',
    sl: 'Teža (kg)*',
    es: 'Peso (kg)*',
    fi: 'Paino (kg)*',
  },
  'Valid until {{date}}': {
    en: 'Valid until {{date}}',
    bg: 'Валидно до {{date}}',
    de: 'Gültig bis {{date}}',
    fr: "Valable jusqu'au {{date}}",
    ro: 'Valabil până la {{date}}',
    tr: '-e kadar geçerlidir {{date}}',
    sr: 'Važi do {{date}}',
    mk: 'Важи до {{date}}',
    hu: 'Érvényes eddig {{date}}',
    sk: 'Platný do {{date}}',
    sl: 'Velja do {{date}}',
    es: 'Válido hasta {{date}}',
    fi: 'Voimassa asti {{date}}',
  },
  'X total': {
    en: '{{count}} total',
    bg: '{{count}} общо',
    de: '{{count}} gesamt',
    fr: '{{count}} total',
    ro: '{{count}} total',
    tr: '{{count}} toplam',
    sr: '{{count}} укупно',
    mk: '{{count}} вкупно',
    hu: '{{count}} összesen',
    sk: '{{count}} celkom',
    sl: '{{count}} skupaj',
    es: '{{count}} total',
    fi: '{{count}} yhteensä',
  },
  'e.g. 2200': {
    en: 'e.g. 2200',
    bg: 'напр. 2200',
    de: 'z.B. 2200',
    fr: 'ex. 2200',
    ro: 'ex. 2200',
    tr: 'ör. 2200',
    sr: 'нпр. 2200',
    mk: 'напр. 2200',
    hu: 'pl. 2200',
    sk: 'napr. 2200',
    sl: 'npr. 2200',
    es: 'p.ej. 2200',
    fi: 'esim. 2200',
  },

  Compact: {
    en: 'Compact',
    bg: 'Компактен',
    de: 'Kompakt',
    fr: 'Compact',
    ro: 'Compact',
    tr: 'Kompakt',
    sr: 'Компактан',
    mk: 'Компактен',
    hu: 'Kompakt',
    sk: 'Kompaktný',
    sl: 'Kompakten',
    es: 'Compacto',
    fi: 'Kompakti',
  },
  Hatchback: {
    en: 'Hatchback',
    bg: 'Хечбек',
    de: 'Kleinwagen',
    fr: 'Hatchback',
    ro: 'Hatchback',
    tr: 'Hatchback',
    sr: 'Хечбек',
    mk: 'Хечбек',
    hu: 'Hatchback',
    sk: 'Hatchback',
    sl: 'Hatchback',
    es: 'Hatchback',
    fi: 'Hatchback',
  },
  Coupé: {
    en: 'Coupé',
    bg: 'Купе',
    de: 'Coupé',
    fr: 'Coupé',
    ro: 'Coupé',
    tr: 'Coupé',
    sr: 'Купе',
    mk: 'Купе',
    hu: 'Kupé',
    sk: 'Coupé',
    sl: 'Coupé',
    es: 'Coupé',
    fi: 'Coupé',
  },
  Superauto: {
    en: 'Superauto',
    bg: 'Супер автомобил',
    de: 'Supersportwagen',
    fr: 'Supercar',
    ro: 'Supercar',
    tr: 'Süper araba',
    sr: 'Супераутомобил',
    mk: 'Суперавтомобил',
    hu: 'Szuperautó',
    sk: 'Superauto',
    sl: 'Superavto',
    es: 'Superdeportivo',
    fi: 'Superauto',
  },
  Sedan: {
    en: 'Sedan',
    bg: 'Седан',
    de: 'Limousine',
    fr: 'Berline',
    ro: 'Sedan',
    tr: 'Sedan',
    sr: 'Седан',
    mk: 'Седан',
    hu: 'Szédán',
    sk: 'Sedan',
    sl: 'Sedan',
    es: 'Sedán',
    fi: 'Sedan',
  },
  'Station Wagon': {
    en: 'Station Wagon',
    bg: 'Комби',
    de: 'Kombi',
    fr: 'Break',
    ro: 'Break',
    tr: 'Station Wagon',
    sr: 'Комби',
    mk: 'Комби',
    hu: 'Kombi',
    sk: 'Kombi',
    sl: 'Karavan',
    es: 'Familiar',
    fi: 'Farmari',
  },
  Crossover: {
    en: 'Crossover',
    bg: 'Кросоувър',
    de: 'Crossover',
    fr: 'Crossover',
    ro: 'Crossover',
    tr: 'Crossover',
    sr: 'Кросовер',
    mk: 'Кросовер',
    hu: 'Crossover',
    sk: 'Crossover',
    sl: 'Crossover',
    es: 'Crossover',
    fi: 'Crossover',
  },
  SUV: {
    en: 'SUV',
    bg: 'SUV',
    de: 'SUV',
    fr: 'SUV',
    ro: 'SUV',
    tr: 'SUV',
    sr: 'SUV',
    mk: 'SUV',
    hu: 'SUV',
    sk: 'SUV',
    sl: 'SUV',
    es: 'SUV',
    fi: 'SUV',
  },
  'Transport Car': {
    en: 'Transport Car',
    bg: 'Транспортен автомобил',
    de: 'Transportwagen',
    fr: 'Voiture de transport',
    ro: 'Mașină de transport',
    tr: 'Taşıma Aracı',
    sr: 'Транспортни аутомобил',
    mk: 'Транспортно возило',
    hu: 'Szállító autó',
    sk: 'Prepravné auto',
    sl: 'Prevozno vozilo',
    es: 'Coche de transporte',
    fi: 'Kuljetusauto',
  },
  Van: {
    en: 'Van',
    bg: 'Ван',
    de: 'Van',
    fr: 'Fourgonnette',
    ro: 'Van',
    tr: 'Panelvan',
    sr: 'Ван',
    mk: 'Ван',
    hu: 'Kisteherautó',
    sk: 'Dodávka',
    sl: 'Kombi',
    es: 'Furgoneta',
    fi: 'Pakettiauto',
  },

  'Keep an eye on the quote as you tweak route details or vehicle mix.': {
    en: 'Keep an eye on the quote as you tweak route details or vehicle mix.',
    bg: 'Следете офертата, докато променяте подробностите за маршрута или микса на превозните средства.',
    de: 'Behalten Sie das Angebot im Auge, während Sie die Routendetails oder die Fahrzeugmischung anpassen.',
    fr: 'Gardez un œil sur le devis pendant que vous ajustez les détails de l’itinéraire ou le mélange de véhicules.',
    ro: 'Urmăriți cotația în timp ce ajustați detaliile traseului sau mixul de vehicule.',
    tr: 'Rota detaylarını veya araç karışımını ayarlarken teklife göz kulak olun.',
    sr: 'Пратите понуду док прилагођавате детаље руте или мешавину возила.',
    mk: 'Следете ја понудата додека ги прилагодувате деталите за рутата или мешавината на возила.',
    hu: 'Figyelje az ajánlatot, miközben módosítja az útvonal részleteit vagy a járművek összetételét.',
    sk: 'Majte ponuku na pamäti, keď upravujete detaily trasy alebo zloženie vozidiel.',
    sl: 'Ohranite pogled na ponudbo, ko prilagajate podrobnosti poti ali mešanico vozil.',
    es: 'Mantén un ojo en la cotización mientras ajustas los detalles de la ruta o la combinación de vehículos.',
    fi: 'Pidä silmällä tarjousta, kun säädät reittitietoja tai ajoneuvosekoitusta.',
  },
  'Transit time: {{hours}}h': {
    en: 'Transit time: {{hours}}h',
    bg: 'Време за транзит: {{hours}}ч',
    de: 'Transitzeit: {{hours}}h',
    fr: 'Temps de transit : {{hours}}h',
    ro: 'Timp de tranzit: {{hours}}h',
    tr: 'Transit süresi: {{hours}}s',
    sr: 'Време транзита: {{hours}}ч',
    mk: 'Време на транзит: {{hours}}ч',
    hu: 'Átutazási idő: {{hours}}h',
    sk: 'Prepravný čas: {{hours}}h',
    sl: 'Čas prevoza: {{hours}}h',
    es: 'Tiempo de tránsito: {{hours}}h',
    fi: 'Kuljetusaika: {{hours}}h',
  },
  'Delivery opening hours': {
    en: 'Delivery opening hours',
    bg: 'Работно време за доставка',
    de: 'Lieferöffnungszeiten',
    fr: "Heures d'ouverture de la livraison",
    ro: 'Orele de deschidere pentru livrare',
    tr: 'Teslimat çalışma saatleri',
    sr: 'Радно време за испоруку',
    mk: 'Работно време за испорака',
    hu: 'Szállítási nyitvatartási idő',
    sk: 'Otváracie hodiny doručenia',
    sl: 'Odpiralni čas dostave',
    es: 'Horario de entrega',
    fi: 'Toimitusaika',
  },
  Route: {
    en: 'Route',
    bg: 'Маршрут',
    de: 'Route',
    fr: 'Itinéraire',
    ro: 'Rută',
    tr: 'Rota',
    sr: 'Рута',
    mk: 'Рута',
    hu: 'Útvonal',
    sk: 'Trasa',
    sl: 'Pot',
    es: 'Ruta',
    fi: 'Reitti',
  },
  Summary: {
    en: 'Summary',
    bg: 'Резюме',
    de: 'Zusammenfassung',
    fr: 'Résumé',
    ro: 'Sumar',
    tr: 'Özet',
    sr: 'Резиме',
    mk: 'Резиме',
    hu: 'Összefoglaló',
    sk: 'Zhrnutie',
    sl: 'Povzetek',
    es: 'Resumen',
    fi: 'Yhteenveto',
  },
  'Estimated price': {
    en: 'Estimated price',
    bg: 'Прогнозна цена',
    de: 'Geschätzter Preis',
    fr: 'Prix estimé',
    ro: 'Preț estimat',
    tr: 'Tahmini fiyat',
    sr: 'Procijenjena cijena',
    mk: 'Проценета цена',
    hu: 'Becsült ár',
    sk: 'Odhadovaná cena',
    sl: 'Ocenjena cena',
    es: 'Precio estimado',
    fi: 'Arvioitu hinta',
  },
  'VIP price': {
    en: 'VIP price',
    bg: 'VIP цена',
    de: 'VIP Preis',
    fr: 'Prix VIP',
    ro: 'Preț VIP',
    tr: 'VIP fiyatı',
    sr: 'VIP cijena',
    mk: 'VIP цена',
    hu: 'VIP ár',
    sk: 'VIP cena',
    sl: 'VIP cena',
    es: 'Precio VIP',
  },
  ' total': {
    en: ' total',
    bg: ' общо',
    de: ' gesamt',
    fr: ' total',
    ro: ' total',
    tr: ' toplam',
    sr: ' укупно',
    mk: ' вкупно',
    hu: 'összesen',
    sk: ' celkom',
    sl: ' skupaj',
    es: ' total',
    fi: ' yhteensä',
  },
  'Non-runner': {
    en: 'Non-runner',
    bg: 'Неработещ',
    de: 'Nicht fahrbereit',
    fr: 'Non roulant',
    ro: 'Nefuncțional',
    tr: 'Çalışmayan',
    sr: 'Неупотребљив',
    mk: 'Неисправен',
    hu: 'Nem működő',
    sk: 'Nejazdné',
    sl: 'Nevozno',
    es: 'No funcional',
    fi: 'Ei käynnisty',
  },
  total: {
    en: 'total',
    bg: 'общо',
    de: 'gesamt',
    fr: 'total',
    ro: 'total',
    tr: 'toplam',
    sr: 'укупно',
    mk: 'вкупно',
    hu: 'összesen',
    sk: 'celkom',
    sl: 'skupaj',
    es: 'total',
    fi: 'yhteensä',
  },
  'Calculate to preview your quote.': {
    en: 'Calculate to preview your quote.',
    bg: 'Изчислете, за да видите офертата си.',
    de: 'Berechnen Sie, um Ihr Angebot anzuzeigen.',
    fr: 'Calculez pour prévisualiser votre devis.',
    ro: 'Calculați pentru a previzualiza cotația dvs.',
    tr: 'Teklifinizi önizlemek için hesaplayın.',
    sr: 'Izračunajte da biste pregledali svoju ponudu.',
    mk: 'Пресметајте за да ја прегледате вашата понуда.',
    hu: 'Számolja ki, hogy megtekinthesse árajánlatát.',
    sk: 'Vypočítajte si náhľad svojej ponuky.',
    sl: 'Izračunajte, da si ogledate svojo ponudbo.',
    es: 'Calcule para previsualizar su cotización.',
    fi: 'Laske esikatselu tarjouksestasi.',
  },
  From: {
    en: 'From',
    bg: 'От',
    de: 'Von',
    fr: 'De',
    ro: 'De la',
    tr: 'Den',
    sr: 'Од',
    mk: 'Од',
    hu: 'Innen',
    sk: 'Z',
    sl: 'Iz',
    es: 'Desde',
    fi: 'Lähettäjä',
  },
  To: {
    en: 'To',
    bg: 'До',
    de: 'Zu',
    fr: 'À',
    ro: 'Către',
    tr: 'İçin',
    sr: 'До',
    mk: 'До',
    hu: 'Hozzá',
    sk: 'Do',
    sl: 'Za',
    es: 'Hacia',
    fi: 'Vastaanottaja',
  },
  'Electric / Hybrid': {
    en: 'Electric/Hybrid',
    bg: 'Електрически/Хибриден',
    de: 'Elektrisch/Hybrid',
    fr: 'Électrique/Hybride',
    ro: 'Electric/Hibrid',
    tr: 'Elektrikli/Hibrit',
    sr: 'Електрични/Хибридни',
    mk: 'Електричен/Хибриден',
    hu: 'Elektromos/Hibrid',
    sk: 'Elektrický/Hybridný',
    sl: 'Električni/Hibridni',
    es: 'Eléctrico/Híbrido',
    fi: 'Sähkö/Hybridi',
  },
  'e.g. Mercedes-Benz GLE 450': {
    en: 'e.g. Mercedes-Benz GLE 450',
    bg: 'напр. Mercedes-Benz GLE 450',
    de: 'z.B. Mercedes-Benz GLE 450',
    fr: 'ex. Mercedes-Benz GLE 450',
    ro: 'ex. Mercedes-Benz GLE 450',
    tr: 'ör. Mercedes-Benz GLE 450',
    sr: 'нпр. Mercedes-Benz GLE 450',
    mk: 'напр. Mercedes-Benz GLE 450',
    hu: 'pl. Mercedes-Benz GLE 450',
    sk: 'napr. Mercedes-Benz GLE 450',
    sl: 'npr. Mercedes-Benz GLE 450',
    es: 'p.ej. Mercedes-Benz GLE 450',
    fi: 'esim. Mercedes-Benz GLE 450',
  },
  Next: {
    en: 'Next',
    bg: 'Напред',
    de: 'Weiter',
    fr: 'Suivant',
    ro: 'Următor',
    tr: 'İleri',
    sr: 'Следећи',
    mk: 'Следно',
    hu: 'Következő',
    sk: 'Ďalej',
    sl: 'Naprej',
    es: 'Siguiente',
    fi: 'Seuraava',
  },
  Previous: {
    en: 'Previous',
    bg: 'Назад',
    de: 'Zurück',
    fr: 'Précédent',
    ro: 'Anterior',
    tr: 'Geri',
    sr: 'Претходни',
    mk: 'Претходно',
    hu: 'Előző',
    sk: 'Predchádzajúci',
    sl: 'Prejšnji',
    es: 'Anterior',
    fi: 'Edellinen',
  },
  'Extra wheels': {
    en: 'Extra wheels',
    bg: 'Допълнителни колела',
    de: 'Zusätzliche Räder',
    fr: 'Roues supplémentaires',
    ro: 'Roți suplimentare',
    tr: 'Ekstra tekerlekler',
    sr: 'Dodatni točkovi',
    mk: 'Дополнителни тркала',
    hu: 'Extra kerekek',
    sk: 'Extra kolesá',
    sl: 'Dodatna kolesa',
    es: 'Ruedas extra',
    fi: 'Lisäpyörät',
  },

  'Additional information': {
    en: 'Additional information',
    bg: 'Допълнителна информация',
    de: 'Zusätzliche Informationen',
    fr: 'Informations supplémentaires',
    ro: 'Informații suplimentare',
    tr: 'Ek bilgi',
    sr: 'Додатне информације',
    mk: 'Дополнителни информации',
    hu: 'További információk',
    sk: 'Ďalšie informácie',
    sl: 'Dodatne informacije',
    es: 'Información adicional',
    fi: 'Lisätietoja',
  },
  'Select the date when the cargo is to be delivered.': {
    en: 'Select the date when the cargo is to be delivered.',
    bg: 'Изберете датата, на която трябва да бъде доставен товарът.',
    de: 'Wählen Sie das Datum aus, an dem die Fracht geliefert werden soll.',
    fr: 'Sélectionnez la date à laquelle la cargaison doit être livrée.',
    ro: 'Selectați data la care trebuie livrată marfa.',
    tr: 'Yükün teslim edileceği tarihi seçin.',
    sr: 'Изаберите датум када терет треба да буде испоручен.',
    mk: 'Изберете го датумот кога треба да се испорача товарот.',
    hu: 'Válassza ki a dátumot, amikor a rakományt szállítani kell.',
    sk: 'Vyberte dátum, kedy má byť náklad doručený.',
    sl: 'Izberite datum, koledor je treba dostaviti tovor.',
    es: 'Seleccione la fecha en que se debe entregar la carga.',
    fi: 'Valitse päivämäärä, jolloin rahti on toimitettava.',
  },
  'Fill in the address and contact person. This helps dispatch align pickups with logistics partners.':
    {
      en: 'Fill in the address and contact person. This helps dispatch align pickups with logistics partners.',
      bg: 'Попълнете адреса и контактното лице. Това помага на изпращането да координира вземанията с логистичните партньори.',
      de: 'Füllen Sie die Adresse und die Kontaktperson aus. Dies hilft der Disposition, Abholungen mit Logistikpartnern abzustimmen.',
      fr: "Remplissez l'adresse et la personne de contact. Cela aide l'expédition à aligner les collectes avec les partenaires logistiques.",
      ro: 'Completați adresa și persoana de contact. Acest lucru ajută expedierea să alinieze preluările cu partenerii logistici.',
      tr: 'Adresi ve iletişim kişisini doldurun. Bu, sevkiyatın lojistik ortaklarla alımları hizalamasına yardımcı olur.',
      sr: 'Попуните адресу и контакт особу. Ово помаже диспечеру да усагласи преузимања са логистичким партнерима.',
      mk: 'Пополнете ја адресата и контакт лицето. Ова помага при испраќањето да ги усогласи подигнувањата со логистичките партнери.',
      hu: 'Töltse ki a címet és a kapcsolattartó személyt. Ez segíti a feladást az átvételek összehangolásában a logisztikai partnerekkel.',
      sk: 'Vyplňte adresu a kontaktnú osobu. To pomáha dispečingu zosúladiť vyzdvihnutia s logistickými partnermi.',
      sl: 'Izpolnite naslov in kontaktno osebo. To pomaga pošiljanju uskladiti prevzeme z logističnimi partnerji.',
      es: 'Complete la dirección y la persona de contacto. Esto ayuda al despacho a alinear las recogidas con los socios logísticos.',
      fi: 'Täytä osoite ja yhteyshenkilö. Tämä auttaa lähetyksiä sovittamaan noudot logistiikkakumppaneiden kanssa.',
    },
  'Loading only possible from 08:00 to 17:00. Ask for Johan.': {
    en: 'Loading only possible from 08:00 to 17:00. Ask for Johan.',
    bg: 'Зареждането е възможно само от 08:00 до 17:00. Попитайте за Йохан.',
    de: 'Laden nur von 08:00 bis 17:00 Uhr möglich. Fragen Sie nach Johan.',
    fr: "Le chargement n'est possible que de 08h00 à 17h00. Demandez Johan.",
    ro: 'Încărcarea este posibilă numai între 08:00 și 17:00. Întrebați de Johan.',
    tr: "Yükleme sadece 08:00 ile 17:00 arasında mümkündür. Johan'a sor.",
    sr: 'Учитавање је могуће само од 08:00 до 17:00. Питајте за Јохана.',
    mk: 'Вчитувањето е можно само од 08:00 до 17:00. Прашајте за Јохан.',
    hu: 'A rakodás csak 08:00 és 17:00 óra között lehetséges. Kérdezze Johan-t.',
    sk: 'Nakladanie je možné iba od 08:00 do 17:00. Opýtajte sa na Johana.',
    sl: 'Nakladanje je mogoče le od 08:00 do 17:00. Vprašajte za Johana.',
    es: 'La carga solo es posible de 08:00 a 17:00. Pregunte por Johan.',
    fi: 'Lastaus on mahdollista vain klo 08.00–17.00. Kysy Johanilta.',
  },
  'Pickup opening hours': {
    en: 'Pickup opening hours',
    bg: 'Работно време за вземане',
    de: 'Abholöffnungszeiten',
    fr: "Heures d'ouverture de la collecte",
    ro: 'Orele de deschidere pentru preluare',
    tr: 'Teslim alma çalışma saatleri',
    sr: 'Радно време за преузимање',
    mk: 'Работно време за подигање',
    hu: 'Átvételi nyitvatartási idő',
    sk: 'Otváracie hodiny vyzdvihnutia',
    sl: 'Odpiralni čas prevzema',
    es: 'Horario de recogida',
    fi: 'Noutoaika',
  },
  'Pickup contact': {
    en: 'Pickup contact',
    bg: 'Контакт за вземане',
    de: 'Abholkontakt',
    fr: 'Contact de collecte',
    ro: 'Contact pentru preluare',
    tr: 'Teslim alma iletişimi',
    sr: 'Контакт за преузимање',
    mk: 'Контакт за подигање',
    hu: 'Átvételi kapcsolat',
    sk: 'Kontaktná osoba na vyzdvihnutie',
    sl: 'Kontakt za prevzem',
    es: 'Contacto de recogida',
    fi: 'Noutoyhteyshenkilö',
  },
  'Delivery contact': {
    en: 'Delivery contact',
    bg: 'Контакт за доставка',
    de: 'Lieferkontakt',
    fr: 'Contact de livraison',
    ro: 'Contact pentru livrare',
    tr: 'Teslimat iletişimi',
    sr: 'Контакт за испоруку',
    mk: 'Контакт за испорака',
    hu: 'Szállítási kapcsolat',
    sk: 'Kontaktná osoba na doručenie',
    sl: 'Kontakt za dostavo',
    es: 'Contacto de entrega',
    fi: 'Toimitusyhteyshenkilö',
  },
  'Preferences & notes': {
    en: 'Preferences & notes',
    bg: 'Предпочитания и бележки',
    de: 'Präferenzen & Notizen',
    fr: 'Préférences et notes',
    ro: 'Preferințe și note',
    tr: 'Tercihler ve notlar',
    sr: 'Преференције и белешке',
    mk: 'Преференции и белешки',
    hu: 'Preferenciák és megjegyzések',
    sk: 'Preferencie a poznámky',
    sl: 'Nastavitve in opombe',
    es: 'Preferencias y notas',
    fi: 'Asetukset ja muistiinpanot',
  },
  'Loading notifications': {
    en: 'Loading notifications',
    bg: 'Известия за зареждане',
    de: 'Ladebenachrichtigungen',
    fr: 'Notifications de chargement',
    ro: 'Notificări de încărcare',
    tr: 'Yükleme bildirimleri',
    sr: 'Обавештења о учитавању',
    mk: 'Известувања за вчитување',
    hu: 'Betöltési értesítések',
    sk: 'Oznámenia o nakladaní',
    sl: 'Obvestila o nalaganju',
    es: 'Notificaciones de carga',
    fi: 'Latausilmoitukset',
  },
  'Sustainability options': {
    en: 'Sustainability options',
    bg: 'Опции за устойчивост',
    de: 'Nachhaltigkeitsoptionen',
    fr: 'Options de durabilité',
    ro: 'Opțiuni de durabilitate',
    tr: 'Sürdürülebilirlik seçenekleri',
    sr: 'Опције одрживости',
    mk: 'Опции за одржливост',
    hu: 'Fenntarthatósági lehetőségek',
    sk: 'Možnosti udržateľnosti',
    sl: 'Možnosti trajnosti',
    es: 'Opciones de sostenibilidad',
    fi: 'Kestävyysvaihtoehdot',
  },
  'Offset CO₂ emissions for this shipment': {
    en: 'Offset CO₂ emissions for this shipment',
    bg: 'Компенсирайте емисиите на CO₂ за тази пратка',
    de: 'Kompensieren Sie die CO₂-Emissionen für diese Sendung',
    fr: 'Compenser les émissions de CO₂ pour cet envoi',
    ro: 'Compensați emisiile de CO₂ pentru această expediere',
    tr: 'Bu gönderim için CO₂ emisyonlarını dengeleyin',
    sr: 'Компензујте CO₂ емисије за ову пошиљку',
    mk: 'Компензирајте ги емисиите на CO₂ за оваа пратка',
    hu: 'Komppenzálja a CO₂-kibocsátást ezen a szállítmányon',
    sk: 'Kompensujte emisie CO₂ za túto zásielku',
    sl: 'Izravnajte emisije CO₂ za to pošiljko',
    es: 'Compense las emisiones de CO₂ para este envío',
    fi: 'Hyvitä tämän lähetyksen CO₂-päästöt',
  },
  'Prefer biofuel usage where available': {
    en: 'Prefer biofuel usage where available',
    bg: 'Предпочитайте използването на биогорива, където е възможно',
    de: 'Bevorzugen Sie die Verwendung von Biokraftstoffen, wo verfügbar',
    fr: "Privilégier l'utilisation de biocarburants lorsque cela est possible",
    ro: 'Preferă utilizarea biocombustibililor acolo unde este disponibil',
    tr: 'Mevcut olduğunda biyoyakıt kullanımını tercih edin',
    sr: 'Преферирајте употребу биогорива где је доступно',
    mk: 'Преферирајте ја употребата на биогорива каде што е достапно',
    hu: 'Előnyben részesítse a bioüzemanyag használatát, ahol elérhető',
    sk: 'Uprednostnite používanie biopalív, kde je to možné',
    sl: 'Prednostno uporabljajte biogoriva, kjer so na voljo',
    es: 'Prefiera el uso de biocombustibles cuando estén disponibles',
    fi: 'Suosi biopolttoaineiden käyttöä, kun se on mahdollista',
  },
  'Environmental or compliance notes': {
    en: 'Environmental or compliance notes',
    bg: 'Бележки за околната среда или съответствието',
    de: 'Umwelt- oder Compliance-Hinweise',
    fr: 'Notes environnementales ou de conformité',
    ro: 'Note de mediu sau de conformitate',
    tr: 'Çevresel veya uyumluluk notları',
    sr: 'Еколошке или усаглашене белешке',
    mk: 'Еколошки или усогласени белешки',
    hu: 'Környezeti vagy megfelelőségi megjegyzések',
    sk: 'Environmentálne alebo súladové poznámky',
    sl: 'Okoljske ali skladnostne opombe',
    es: 'Notas ambientales o de cumplimiento',
    fi: 'Ympäristö- tai vaatimustenmukaisuustiedot',
  },
  'Finalize the handover plan with scheduling cues, site availability, and sustainability preferences. This view keeps everything critical in one place without repeating details from earlier steps.':
    {
      en: 'Finalize the handover plan with scheduling cues, site availability, and sustainability preferences. This view keeps everything critical in one place without repeating details from earlier steps.',
      bg: 'Завършете плана за предаване с графици, наличност на обекта и предпочитания за устойчивост. Този изглед съхранява всичко критично на едно място, без да повтаря подробности от по-ранни стъпки.',
      de: 'Finalisieren Sie den Übergabeplan mit Zeitplanhinweisen, Standortverfügbarkeit und Nachhaltigkeitspräferenzen. Diese Ansicht hält alles Kritische an einem Ort, ohne Details aus früheren Schritten zu wiederholen.',
      fr: 'Finalisez le plan de remise avec des indices de planification, la disponibilité du site et les préférences de durabilité. Cette vue garde tout ce qui est critique en un seul endroit sans répéter les détails des étapes précédentes.',
      ro: 'Finalizați planul de predare cu indicii de programare, disponibilitatea site-ului și preferințele de durabilitate. Această vizualizare păstrează tot ce este critic într-un singur loc, fără a repeta detaliile din pașii anteriori.',
      tr: 'Teslim planını zamanlama ipuçları, site kullanılabilirliği ve sürdürülebilirlik tercihleri ile tamamlayın. Bu görünüm, önceki adımlardan ayrıntıları tekrarlamadan kritik olan her şeyi tek bir yerde tutar.',
      sr: 'Завршите план предаје са наговештајима о распореду, доступношћу локације и преференцијама одрживости. Овај приказ држи све критично на једном месту без понављања детаља из претходних корака.',
      mk: 'Завршете го планот за предавање со навестувања за распоред, достапност на локацијата и преференции за одржливост. Овој приказ ги чува сите критични работи на едно место без повторување детали од претходните чекори.',
      hu: 'Fejezze be az átadási tervet ütemezési jelzésekkel, helyszín elérhetőségével és fenntarthatósági preferenciákkal. Ez a nézet minden kritikus elemet egy helyen tart anélkül, hogy megismételné a korábbi lépések részleteit.',
      sk: 'Finalizujte plán odovzdania s časovými pokynmi, dostupnosťou miesta a preferenciami udržateľnosti. Tento pohľad uchováva všetko kritické na jednom mieste bez opakovania podrobností z predchádzajúcich krokov.',
      sl: 'Zaključite načrt predaje z namigi za razporejanje, razpoložljivostjo lokacije in nastavitvami trajnosti. Ta pogled ohranja vse kritično na enem mestu, ne da bi ponavljal podrobnosti iz prejšnjih korakov.',
      es: 'Finalice el plan de entrega con indicaciones de programación, disponibilidad del sitio y preferencias de sostenibilidad. Esta vista mantiene todo lo crítico en un solo lugar sin repetir detalles de pasos anteriores.',
      fi: 'Viimeistele luovutussuunnitelma aikatauluvihjeillä, sivuston saatavuudella ja kestävyysasetuksilla. Tämä näkymä pitää kaiken kriittisen yhdessä paikassa ilman, että toistetaan aiempien vaiheiden yksityiskohtia.',
    },
  None: {
    en: 'None',
    bg: 'Няма',
    de: 'Keine',
    fr: 'Aucun',
    ro: 'Niciunul',
    tr: 'Hiçbiri',
    sr: 'Ниједан',
    mk: 'Никој',
    hu: 'Egyik sem',
    sk: 'Žiadne',
    sl: 'Noben',
    es: 'Ninguno',
    fi: 'Ei mitään',
  },
  '1 week before': {
    en: '1 week before',
    bg: '1 седмица преди',
    de: '1 Woche vorher',
    fr: '1 semaine avant',
    ro: 'Cu 1 săptămână înainte',
    tr: '1 hafta önce',
    sr: '1 недеља раније',
    mk: '1 недела пред',
    hu: '1 héttel korábban',
    sk: '1 týždeň predtým',
    sl: '1 teden prej',
    es: '1 semana antes',
    fi: '1 viikko ennen',
  },
  '1 day before': {
    en: '1 day before',
    bg: '1 ден преди',
    de: '1 Tag vorher',
    fr: '1 jour avant',
    ro: 'Cu 1 zi înainte',
    tr: '1 gün önce',
    sr: '1 дан раније',
    mk: '1 ден пред',
    hu: '1 nappal korábban',
    sk: '1 deň predtým',
    sl: '1 dan prej',
    es: '1 día antes',
    fi: '1 päivä ennen',
  },
  '2 days before': {
    en: '2 days before',
    bg: '2 дни преди',
    de: '2 Tage vorher',
    fr: '2 jours avant',
    ro: 'Cu 2 zile înainte',
    tr: '2 gün önce',
    sr: '2 дана раније',
    mk: '2 дена пред',
    hu: '2 nappal korábban',
    sk: '2 dni predtým',
    sl: '2 dni prej',
    es: '2 días antes',
    fi: '2 päivää ennen',
  },
  Pickup: {
    en: 'Pickup',
    bg: 'Вземане',
    de: 'Abholung',
    fr: 'Enlèvement',
    ro: 'Ridicare',
    tr: 'Alım',
    sr: 'Преузимање',
    mk: 'Преземање',
    hu: 'Felvétel',
    sk: 'Vyzdvihnutie',
    sl: 'Prevzem',
    es: 'Recogida',
    fi: 'Nouto',
  },
  Delivery: {
    en: 'Delivery',
    bg: 'Доставка',
    de: 'Lieferung',
    fr: 'Livraison',
    ro: 'Livrare',
    tr: 'Teslimat',
    sr: 'Испорука',
    mk: 'Испорака',
    hu: 'Kézbesítés',
    sk: 'Doručenie',
    sl: 'Dostava',
    es: 'Entrega',
    fi: 'Toimitus',
  },
  Info: {
    en: 'Info',
    bg: 'Информация',
    de: 'Info',
    fr: 'Infos',
    ro: 'Informații',
    tr: 'Bilgi',
    sr: 'Информације',
    mk: 'Информации',
    hu: 'Információ',
    sk: 'Informácie',
    sl: 'Informacije',
    es: 'Información',
    fi: 'Tiedot',
  },
  'No name': {
    en: 'No name',
    bg: 'Без име',
    de: 'Kein Name',
    fr: 'Sans nom',
    ro: 'Fără nume',
    tr: 'İsim yok',
    sr: 'Без имена',
    mk: 'Без име',
    hu: 'Nincs név',
    sk: 'Bez mena',
    sl: 'Brez imena',
    es: 'Sin nombre',
    fi: 'Ei nimeä',
  },

  '(you)': {
    en: '(you)',
    bg: '(вие)',
    de: '(Sie)',
    fr: '(vous)',
    ro: '(tu)',
    tr: '(sen)',
    sr: '(ви)',
    mk: '(ти)',
    hu: '(te)',
    sk: '(vy)',
    sl: '(vi)',
    es: '(tú)',
    fi: '(sinä)',
  },

  'User email has been verified': {
    en: 'User email has been verified',
    bg: 'Имейлът на потребителя е потвърден',
    de: 'Die E-Mail des Benutzers wurde bestätigt',
    fr: 'L’e-mail de l’utilisateur a été vérifié',
    ro: 'Emailul utilizatorului a fost verificat',
    tr: 'Kullanıcının e-postası doğrulandı',
    sr: 'Имејл корисника је потврђен',
    mk: 'Е-поштата на корисникот е потврдена',
    hu: 'A felhasználó e-mail címe ellenőrizve',
    sk: 'E-mail používateľa bol overený',
    sl: 'E-pošta uporabnika je preverjena',
    es: 'El correo del usuario ha sido verificado',
    fi: 'Käyttäjän sähköposti on vahvistettu',
  },
  VIP: {
    en: 'VIP',
    bg: 'VIP',
    de: 'VIP',
    fr: 'VIP',
    ro: 'VIP',
    tr: 'VIP',
    sr: 'VIP',
    mk: 'VIP',
    hu: 'VIP',
    sk: 'VIP',
    sl: 'VIP',
    es: 'VIP',
    fi: 'VIP',
  },

  'Mark as VIP': {
    en: 'Mark as VIP',
    bg: 'Маркирай като VIP',
    de: 'Als VIP markieren',
    fr: 'Marquer comme VIP',
    ro: 'Marchează ca VIP',
    tr: 'VIP olarak işaretle',
    sr: 'Означи као VIP',
    mk: 'Означи како VIP',
    hu: 'Megjelölés VIP-ként',
    sk: 'Označiť ako VIP',
    sl: 'Označi kot VIP',
    es: 'Marcar como VIP',
    fi: 'Merkitse VIP-asiakkaaksi',
  },

  'Unmark as VIP': {
    en: 'Unmark as VIP',
    bg: 'Премахни VIP статуса',
    de: 'VIP-Status entfernen',
    fr: 'Retirer le statut VIP',
    ro: 'Elimină statutul VIP',
    tr: 'VIP işaretini kaldır',
    sr: 'Уклони VIP статус',
    mk: 'Отстрани VIP статус',
    hu: 'VIP státusz eltávolítása',
    sk: 'Odstrániť VIP status',
    sl: 'Odstrani VIP status',
    es: 'Quitar estado VIP',
    fi: 'Poista VIP-tila',
  },

  'This is a VIP client functionality only': {
    en: 'This is a VIP client functionality only',
    bg: 'Тази функционалност е само за VIP клиенти',
    de: 'Diese Funktion ist nur für VIP-Kunden verfügbar',
    fr: 'Cette fonctionnalité est réservée aux clients VIP',
    ro: 'Această funcționalitate este doar pentru clienții VIP',
    tr: 'Bu özellik yalnızca VIP müşteriler içindir',
    sr: 'Ова функционалност је доступна само за VIP клијенте',
    mk: 'Оваа функционалност е само за VIP клиенти',
    hu: 'Ez a funkció csak VIP ügyfelek számára érhető el',
    sk: 'Táto funkcia je dostupná iba pre VIP klientov',
    sl: 'Ta funkcionalnost je na voljo samo za VIP stranke',
    es: 'Esta funcionalidad es solo para clientes VIP',
    fi: 'Tämä toiminto on vain VIP-asiakkaille',
  },
  'N/A': {
    en: 'N/A',
    bg: 'Н/П',
    de: 'k. A.',
    fr: 'N/A',
    ro: 'N/A',
    tr: 'Yok',
    sr: 'Н/Д',
    mk: 'Н/Д',
    hu: 'N/A',
    sk: 'N/A',
    sl: 'N/A',
    es: 'N/D',
    fi: 'Ei saatavilla',
  },

  Approved: {
    en: 'Approved',
    bg: 'Одобрен',
    de: 'Genehmigt',
    fr: 'Approuvé',
    ro: 'Aprobat',
    tr: 'Onaylandı',
    sr: 'Одобрен',
    mk: 'Одобрен',
    hu: 'Jóváhagyva',
    sk: 'Schválený',
    sl: 'Odobren',
    es: 'Aprobado',
    fi: 'Hyväksytty',
  },

  Pending: {
    en: 'Pending',
    bg: 'В изчакване',
    de: 'Ausstehend',
    fr: 'En attente',
    ro: 'În așteptare',
    tr: 'Beklemede',
    sr: 'На чекању',
    mk: 'Во очекување',
    hu: 'Függőben',
    sk: 'Čaká sa',
    sl: 'V teku',
    es: 'Pendiente',
    fi: 'Odottaa',
  },

  Rejected: {
    en: 'Rejected',
    bg: 'Отхвърлен',
    de: 'Abgelehnt',
    fr: 'Rejeté',
    ro: 'Respins',
    tr: 'Reddedildi',
    sr: 'Одбијен',
    mk: 'Одбиен',
    hu: 'Elutasítva',
    sk: 'Zamietnutý',
    sl: 'Zavrnjen',
    es: 'Rechazado',
    fi: 'Hylätty',
  },

  Disabled: {
    en: 'Disabled',
    bg: 'Деактивиран',
    de: 'Deaktiviert',
    fr: 'Désactivé',
    ro: 'Dezactivat',
    tr: 'Devre dışı',
    sr: 'Деактивиран',
    mk: 'Деактивиран',
    hu: 'Letiltva',
    sk: 'Zakázaný',
    sl: 'Onemogočen',
    es: 'Deshabilitado',
    fi: 'Poistettu käytöstä',
  },

  Unknown: {
    en: 'Unknown',
    bg: 'Неизвестен',
    de: 'Unbekannt',
    fr: 'Inconnu',
    ro: 'Necunoscut',
    tr: 'Bilinmiyor',
    sr: 'Непознато',
    mk: 'Непознато',
    hu: 'Ismeretlen',
    sk: 'Neznáme',
    sl: 'Neznano',
    es: 'Desconocido',
    fi: 'Tuntematon',
  },

  'Partner validated by:': {
    en: 'Partner validated by:',
    bg: 'Партньорът е валидиран от:',
    de: 'Partner validiert von:',
    fr: 'Partenaire validé par :',
    ro: 'Partener validat de:',
    tr: 'İş ortağı doğrulayan:',
    sr: 'Партнера је верификовао:',
    mk: 'Партнерот е валидиран од:',
    hu: 'Partner ellenőrizte:',
    sk: 'Partner overený:',
    sl: 'Partner potrjen s strani:',
    es: 'Socio validado por:',
    fi: 'Kumppanin vahvistanut:',
  },

  Approve: {
    en: 'Approve',
    bg: 'Одобри',
    de: 'Genehmigen',
    fr: 'Approuver',
    ro: 'Aprobă',
    tr: 'Onayla',
    sr: 'Одобри',
    mk: 'Одобри',
    hu: 'Jóváhagyás',
    sk: 'Schváliť',
    sl: 'Odobri',
    es: 'Aprobar',
    fi: 'Hyväksy',
  },

  Reject: {
    en: 'Reject',
    bg: 'Отхвърли',
    de: 'Ablehnen',
    fr: 'Rejeter',
    ro: 'Respinge',
    tr: 'Reddet',
    sr: 'Одбиј',
    mk: 'Одбиј',
    hu: 'Elutasítás',
    sk: 'Zamietnuť',
    sl: 'Zavrni',
    es: 'Rechazar',
    fi: 'Hylkää',
  },

  Disable: {
    en: 'Disable',
    bg: 'Деактивирай',
    de: 'Deaktivieren',
    fr: 'Désactiver',
    ro: 'Dezactivează',
    tr: 'Devre dışı bırak',
    sr: 'Деактивирај',
    mk: 'Деактивирај',
    hu: 'Letiltás',
    sk: 'Deaktivovať',
    sl: 'Onemogoči',
    es: 'Desactivar',
    fi: 'Poista käytöstä',
  },

  'Confirm action': {
    en: 'Confirm action',
    bg: 'Потвърди действие',
    de: 'Aktion bestätigen',
    fr: 'Confirmer l’action',
    ro: 'Confirmă acțiunea',
    tr: 'İşlemi onayla',
    sr: 'Потврди радњу',
    mk: 'Потврди акција',
    hu: 'Művelet megerősítése',
    sk: 'Potvrdiť akciu',
    sl: 'Potrdi dejanje',
    es: 'Confirmar acción',
    fi: 'Vahvista toiminto',
  },

  'Are you sure you want to approve this user?': {
    en: 'Are you sure you want to approve this user?',
    bg: 'Сигурни ли сте, че искате да одобрите този потребител?',
    de: 'Möchten Sie diesen Benutzer wirklich genehmigen?',
    fr: 'Voulez-vous vraiment approuver cet utilisateur ?',
    ro: 'Sigur doriți să aprobați acest utilizator?',
    tr: 'Bu kullanıcıyı onaylamak istediğinizden emin misiniz?',
    sr: 'Да ли сте сигурни да желите да одобрите овог корисника?',
    mk: 'Дали сте сигурни дека сакате да го одобрите овој корисник?',
    hu: 'Biztosan jóváhagyja ezt a felhasználót?',
    sk: 'Naozaj chcete schváliť tohto používateľa?',
    sl: 'Ali ste prepričani, da želite odobriti tega uporabnika?',
    es: '¿Seguro que deseas aprobar a este usuario?',
    fi: 'Haluatko varmasti hyväksyä tämän käyttäjän?',
  },

  'Are you sure you want to reject this user?': {
    en: 'Are you sure you want to reject this user?',
    bg: 'Сигурни ли сте, че искате да отхвърлите този потребител?',
    de: 'Möchten Sie diesen Benutzer wirklich ablehnen?',
    fr: 'Voulez-vous vraiment rejeter cet utilisateur ?',
    ro: 'Sigur doriți să respingeți acest utilizator?',
    tr: 'Bu kullanıcıyı reddetmek istediğinizden emin misiniz?',
    sr: 'Да ли сте сигурни да желите да одбијете овог корисника?',
    mk: 'Дали сте сигурни дека сакате да го одбиете овој корисник?',
    hu: 'Biztosan elutasítja ezt a felhasználót?',
    sk: 'Naozaj chcete zamietnuť tohto používateľa?',
    sl: 'Ali ste prepričani, da želite zavrniti tega uporabnika?',
    es: '¿Seguro que deseas rechazar a este usuario?',
    fi: 'Haluatko varmasti hylätä tämän käyttäjän?',
  },
  'Are you sure you want to mark this client as VIP?': {
    en: 'Are you sure you want to mark this client as VIP?',
    bg: 'Сигурни ли сте, че искате да маркирате този клиент като VIP?',
    de: 'Sind Sie sicher, dass Sie diesen Kunden als VIP markieren möchten?',
    fr: 'Êtes-vous sûr de vouloir marquer ce client comme VIP ?',
    ro: 'Sigur doriți să marcați acest client ca VIP?',
    tr: 'Bu müşteriyi VIP olarak işaretlemek istediğinizden emin misiniz?',
    sr: 'Да ли сте сигурни да желите да означите овог клијента као VIP?',
    mk: 'Дали сте сигурни дека сакате да го означите овој клиент како VIP?',
    hu: 'Biztosan VIP-ként szeretné megjelölni ezt az ügyfelet?',
    sk: 'Naozaj chcete označiť tohto klienta ako VIP?',
    sl: 'Ali ste prepričani, da želite to stranko označiti kot VIP?',
    es: '¿Está seguro de que desea marcar a este cliente como VIP?',
    fi: 'Haluatko varmasti merkitä tämän asiakkaan VIP-asiakkaaksi?',
  },
  'Are you sure you want to unmark this client as VIP?': {
    en: 'Are you sure you want to unmark this client as VIP?',
    bg: 'Сигурни ли сте, че искате да премахнете VIP статуса на този клиент?',
    de: 'Sind Sie sicher, dass Sie den VIP-Status dieses Kunden entfernen möchten?',
    fr: 'Êtes-vous sûr de vouloir retirer le statut VIP de ce client ?',
    ro: 'Sigur doriți să eliminați statutul VIP pentru acest client?',
    tr: 'Bu müşterinin VIP durumunu kaldırmak istediğinizden emin misiniz?',
    sr: 'Да ли сте сигурни да желите да уклоните VIP статус овог клијента?',
    mk: 'Дали сте сигурни дека сакате да го отстраните VIP статусот на овој клиент?',
    hu: 'Biztosan el szeretné távolítani ennek az ügyfélnek a VIP státuszát?',
    sk: 'Naozaj chcete odstrániť VIP status tohto klienta?',
    sl: 'Ali ste prepričani, da želite odstraniti VIP status te stranke?',
    es: '¿Está seguro de que desea quitar el estado VIP de este cliente?',
    fi: 'Haluatko varmasti poistaa tämän asiakkaan VIP-tilan?',
  },
  'This will disable the user account. Continue?': {
    en: 'This will disable the user account. Continue?',
    bg: 'Това ще деактивира потребителския акаунт. Продължаване?',
    de: 'Dadurch wird das Benutzerkonto deaktiviert. Fortfahren?',
    fr: 'Cela désactivera le compte utilisateur. Continuer ?',
    ro: 'Aceasta va dezactiva contul utilizatorului. Continuați?',
    tr: 'Bu işlem kullanıcı hesabını devre dışı bırakır. Devam edilsin mi?',
    sr: 'Ово ће деактивирати кориснички налог. Наставити?',
    mk: 'Ова ќе ја деактивира корисничката сметка. Продолжи?',
    hu: 'Ez letiltja a felhasználói fiókot. Folytatja?',
    sk: 'Týmto sa deaktivuje používateľský účet. Pokračovať?',
    sl: 'S tem boste onemogočili uporabniški račun. Nadaljujem?',
    es: 'Esto deshabilitará la cuenta del usuario. ¿Continuar?',
    fi: 'Tämä poistaa käyttäjätilin käytöstä. Jatketaanko?',
  },

  Client: {
    en: 'Client',
    bg: 'Клиент',
    de: 'Kunde',
    fr: 'Client',
    ro: 'Client',
    tr: 'Müşteri',
    sr: 'Клијент',
    mk: 'Клиент',
    hu: 'Ügyfél',
    sk: 'Klient',
    sl: 'Stranka',
    es: 'Cliente',
    fi: 'Asiakas',
  },

  Partner: {
    en: 'Partner',
    bg: 'Партньор',
    de: 'Partner',
    fr: 'Partenaire',
    ro: 'Partener',
    tr: 'Ortak',
    sr: 'Партнер',
    mk: 'Партнер',
    hu: 'Partner',
    sk: 'Partner',
    sl: 'Partner',
    es: 'Socio',
    fi: 'Kumppani',
  },

  Admin: {
    en: 'Admin',
    bg: 'Администратор',
    de: 'Administrator',
    fr: 'Administrateur',
    ro: 'Administrator',
    tr: 'Yönetici',
    sr: 'Администратор',
    mk: 'Администратор',
    hu: 'Adminisztrátor',
    sk: 'Administrátor',
    sl: 'Administrator',
    es: 'Administrador',
    fi: 'Ylläpitäjä',
  },
  'User disabled': {
    en: 'User disabled',
    bg: 'Потребителят е деактивиран ',
    de: 'Benutzer deaktiviert ',
    fr: 'Utilisateur désactivé ',
    ro: 'Utilizator dezactivat ',
    tr: 'Kullanıcı devre dışı bırakıldı ',
    sr: 'Корисник је онемогућен ',
    mk: 'Корисникот е оневозможен ',
    hu: 'Felhasználó letiltva ',
    sk: 'Používateľ deaktivovaný ',
    sl: 'Uporabnik onemogočen ',
    es: 'Usuario deshabilitado ',
    fi: 'Käyttäjä poistettu käytöstä ',
  },
  'User approved': {
    en: 'User approved',
    bg: 'Потребителят е одобрен ',
    de: 'Benutzer genehmigt ',
    fr: 'Utilisateur approuvé ',
    ro: 'Utilizator aprobat ',
    tr: 'Kullanıcı onaylandı ',
    sr: 'Корисник је одобрен ',
    mk: 'Корисникот е одобрен ',
    hu: 'Felhasználó jóváhagyva ',
    sk: 'Používateľ schválený ',
    sl: 'Uporabnik odobren ',
    es: 'Usuario aprobado ',
    fi: 'Käyttäjä hyväksytty ',
  },
  'Invalid Date': {
    en: 'Invalid Date',
    bg: 'Невалидна дата',
    de: 'Ungültiges Datum',
    fr: 'Date invalide',
    ro: 'Dată invalidă',
    tr: 'Geçersiz Tarih',
    sr: 'Неважећи датум',
    mk: 'Невалиден датум',
    hu: 'Érvénytelen dátum',
    sk: 'Neplatný dátum',
    sl: 'Neveljaven datum',
    es: 'Fecha no válida',
    fi: 'Virheellinen päivämäärä',
  },
  'User rejected': {
    en: 'User rejected',
    bg: 'Потребителят е отхвърлен ',
    de: 'Benutzer abgelehnt ',
    fr: 'Utilisateur rejeté ',
    ro: 'Utilizator respins ',
    tr: 'Kullanıcı reddedildi ',
    sr: 'Корисник је одбијен ',
    mk: 'Корисникот е одбиен ',
    hu: 'Felhasználó elutasítva ',
    sk: 'Používateľ zamietnutý ',
    sl: 'Uporabnik zavrnjen ',
    es: 'Usuario rechazado ',
    fi: 'Käyttäjä hylätty ',
  },
  'System ID': {
    en: 'System ID',
    bg: 'Системен ID',
    de: 'System-ID',
    fr: 'ID système',
    ro: 'ID sistem',
    tr: 'Sistem Kimliği',
    sr: 'Системски ID',
    mk: 'Системски ID',
    hu: 'Rendszerazonosító',
    sk: 'Systémové ID',
    sl: 'Sistemski ID',
    es: 'ID del sistema',
    fi: 'Järjestelmä-ID',
  },
  'Human ID': {
    en: 'Human ID',
    bg: 'Четимо ID',
    de: 'Lesbare ID',
    fr: 'ID lisible',
    ro: 'ID uman',
    tr: 'İnsan Kimliği',
    sr: 'Људски ID',
    mk: 'Човечки ID',
    hu: 'Olvasható azonosító',
    sk: 'Čitateľné ID',
    sl: 'Človeški ID',
    es: 'ID legible',
    fi: 'Ihmisen luettava ID',
  },
  'Client Price': {
    en: 'Client Price',
    bg: 'Цена за клиент',
    de: 'Kundenpreis',
    fr: 'Prix client',
    ro: 'Preț client',
    tr: 'Müşteri Fiyatı',
    sr: 'Цена за клијента',
    mk: 'Цена за клиент',
    hu: 'Ügyfél ár',
    sk: 'Cena pre klienta',
    sl: 'Cena za stranko',
    es: 'Precio del cliente',
    fi: 'Asiakashinta',
  },
  'Partner Price': {
    en: 'Partner Price',
    bg: 'Цена за партньор',
    de: 'Partnerpreis',
    fr: 'Prix partenaire',
    ro: 'Preț partener',
    tr: 'Partner Fiyatı',
    sr: 'Цена за партнера',
    mk: 'Цена за партнер',
    hu: 'Partner ár',
    sk: 'Partnerská cena',
    sl: 'Partnerska cena',
    es: 'Precio del socio',
    fi: 'Kumppanihinta',
  },
  'View Details': {
    en: 'View Details',
    bg: 'Преглед на детайли',
    de: 'Details anzeigen',
    fr: 'Voir les détails',
    ro: 'Vezi detalii',
    tr: 'Detayları Gör',
    sr: 'Прикажи детаље',
    mk: 'Преглед на детали',
    hu: 'Részletek megtekintése',
    sk: 'Zobraziť detaily',
    sl: 'Ogled podrobnosti',
    es: 'Ver detalles',
    fi: 'Näytä tiedot',
  },
  'Cancel Booking': {
    en: 'Cancel Booking',
    bg: 'Отказ на резервация',
    de: 'Buchung stornieren',
    fr: 'Annuler la réservation',
    ro: 'Anulează rezervarea',
    tr: 'Rezervasyonu İptal Et',
    sr: 'Откажи резервацију',
    mk: 'Откажи резервација',
    hu: 'Foglalás törlése',
    sk: 'Zrušiť rezerváciu',
    sl: 'Prekliči rezervacijo',
    es: 'Cancelar reserva',
    fi: 'Peruuta varaus',
  },
  'Mark as Paid': {
    en: 'Mark as Paid',
    bg: 'Маркирай като платено',
    de: 'Als bezahlt markieren',
    fr: 'Marquer comme payé',
    ro: 'Marchează ca plătit',
    tr: 'Ödenmiş Olarak İşaretle',
    sr: 'Означи као плаћено',
    mk: 'Означи како платено',
    hu: 'Megjelölés fizetettként',
    sk: 'Označiť ako zaplatené',
    sl: 'Označi kot plačano',
    es: 'Marcar como pagado',
    fi: 'Merkitse maksetuksi',
  },
  'Mark booking as paid?': {
    en: 'Mark booking as paid?',
    bg: 'Маркирайте резервацията като платена?',
    de: 'Buchung als bezahlt markieren?',
    fr: 'Marquer la réservation comme payée ?',
    ro: 'Marcați rezervarea ca plătită?',
    tr: 'Rezervasyonu ödenmiş olarak işaretle?',
    sr: 'Означити резервацију као плаћену?',
    mk: 'Означете ја резервацијата како платена?',
    hu: 'Jelölje meg a foglalást fizetettként?',
    sk: 'Označiť rezerváciu ako zaplatenú?',
    sl: 'Označi rezervacijo kot plačano?',
    es: '¿Marcar la reserva como pagada?',
    fi: 'Merkitse varaus maksetuksi?',
  },
  'This will mark the booking as paid. Continue?': {
    en: 'This will mark the booking as paid. Continue?',
    bg: 'Резервацията ще бъде маркирана като платена. Продължаване?',
    de: 'Die Buchung wird als bezahlt markiert. Fortfahren?',
    fr: 'La réservation sera marquée comme payée. Continuer ?',
    ro: 'Rezervarea va fi marcată ca plătită. Continuați?',
    tr: 'Rezervasyon ödenmiş olarak işaretlenecek. Devam edilsin mi?',
    sr: 'Резервација ће бити означена као плаћена. Наставити?',
    mk: 'Резервацијата ќе биде означена како платена. Продолжи?',
    hu: 'A foglalás fizetettként lesz megjelölve. Folytatja?',
    sk: 'Rezervácia bude označená ako zaplatená. Pokračovať?',
    sl: 'Rezervacija bo označena kot plačana. Nadaljujem?',
    es: 'La reserva se marcará como pagada. ¿Continuar?',
    fi: 'Varaus merkitään maksetuksi. Jatketaanko?',
  },
  Confirm: {
    en: 'Confirm',
    bg: 'Потвърди',
    de: 'Bestätigen',
    fr: 'Confirmer',
    ro: 'Confirmă',
    tr: 'Onayla',
    sr: 'Потврди',
    mk: 'Потврди',
    hu: 'Megerősítés',
    sk: 'Potvrdiť',
    sl: 'Potrdi',
    es: 'Confirmar',
    fi: 'Vahvista',
  },
  Cancel: {
    en: 'Cancel',
    bg: 'Отказ',
    de: 'Abbrechen',
    fr: 'Annuler',
    ro: 'Anulează',
    tr: 'İptal',
    sr: 'Откажи',
    mk: 'Откажи',
    hu: 'Mégse',
    sk: 'Zrušiť',
    sl: 'Prekliči',
    es: 'Cancelar',
    fi: 'Peruuta',
  },

  'Check Stripe': {
    en: 'Check Stripe',
    bg: 'Проверка в Stripe',
    de: 'Stripe prüfen',
    fr: 'Vérifier Stripe',
    ro: 'Verifică Stripe',
    tr: "Stripe'ı Kontrol Et",
    sr: 'Proveri Stripe',
    mk: 'Провери Stripe',
    hu: 'Stripe ellenőrzése',
    sk: 'Skontrolovať Stripe',
    sl: 'Preveri Stripe',
    es: 'Comprobar Stripe',
    fi: 'Tarkista Stripe',
    el: 'Έλεγχος Stripe',
  },
  'Confirm Payment': {
    en: 'Confirm Payment',
    bg: 'Потвърждаване на плащане',
    de: 'Zahlung bestätigen',
    fr: 'Confirmer le paiement',
    ro: 'Confirmă plata',
    tr: 'Ödemeyi Onayla',
    sr: 'Potvrdi plaćanje',
    mk: 'Потврди плаќање',
    hu: 'Fizetés megerősítése',
    sk: 'Potvrdiť platbu',
    sl: 'Potrdi plačilo',
    es: 'Confirmar pago',
    fi: 'Vahvista maksu',
    el: 'Επιβεβαίωση πληρωμής',
  },
  View: {
    en: 'View',
    bg: 'Преглед',
    de: 'Ansehen',
    fr: 'Voir',
    ro: 'Vizualizare',
    tr: 'Görüntüle',
    sr: 'Pogledaj',
    mk: 'Види',
    hu: 'Megtekintés',
    sk: 'Zobraziť',
    sl: 'Poglej',
    es: 'Ver',
    fi: 'Näytä',
    el: 'Προβολή',
  },
  'Cancel booking?': {
    en: 'Cancel booking?',
    bg: 'Отказ на резервация?',
    de: 'Buchung stornieren?',
    fr: 'Annuler la réservation ?',
    ro: 'Anulați rezervarea?',
    tr: 'Rezervasyon iptal edilsin mi?',
    sr: 'Отказати резервацију?',
    mk: 'Откажи резервација?',
    hu: 'Törli a foglalást?',
    sk: 'Zrušiť rezerváciu?',
    sl: 'Prekliči rezervacijo?',
    es: '¿Cancelar la reserva?',
    fi: 'Peruutetaanko varaus?',
  },
  'This action cannot be undone': {
    en: 'This action cannot be undone',
    bg: 'Това действие не може да бъде отменено',
    de: 'Diese Aktion kann nicht rückgängig gemacht werden',
    fr: 'Cette action est irréversible',
    ro: 'Această acțiune nu poate fi anulată',
    tr: 'Bu işlem geri alınamaz',
    sr: 'Ова радња се не може поништити',
    mk: 'Оваа акција не може да се врати',
    hu: 'Ez a művelet nem vonható vissza',
    sk: 'Túto akciu nemožno vrátiť späť',
    sl: 'Tega dejanja ni mogoče razveljaviti',
    es: 'Esta acción no se puede deshacer',
    fi: 'Tätä toimintoa ei voi perua',
  },
  'Keep Booking': {
    en: 'Keep Booking',
    bg: 'Запази резервацията',
    de: 'Buchung behalten',
    fr: 'Conserver la réservation',
    ro: 'Păstrează rezervarea',
    tr: 'Rezervasyonu Koru',
    sr: 'Задржи резервацију',
    mk: 'Задржи резервација',
    hu: 'Foglalás megtartása',
    sk: 'Ponechať rezerváciu',
    sl: 'Ohrani rezervacijo',
    es: 'Mantener reserva',
    fi: 'Pidä varaus',
  },
  'Yes, Cancel': {
    en: 'Yes, Cancel',
    bg: 'Да, откажи',
    de: 'Ja, stornieren',
    fr: 'Oui, annuler',
    ro: 'Da, anulează',
    tr: 'Evet, iptal et',
    sr: 'Да, откажи',
    mk: 'Да, откажи',
    hu: 'Igen, törlés',
    sk: 'Áno, zrušiť',
    sl: 'Da, prekliči',
    es: 'Sí, cancelar',
    fi: 'Kyllä, peruuta',
  },
  'Failed to mark booking as paid': {
    en: 'Failed to mark booking as paid',
    bg: 'Неуспешно маркиране на резервацията като платена',
    de: 'Fehler beim Markieren der Buchung als bezahlt',
    fr: 'Échec de la marque de la réservation comme payée',
    ro: 'Marcarea rezervării ca plătită a eșuat',
    tr: 'Rezervasyonun ödenmiş olarak işaretlenmesi başarısız oldu',
    sr: 'Неуспело означавање резервације као плаћене',
    mk: 'Неуспешно означување на резервацијата како платена',
    hu: 'A foglalás fizetettként történő megjelölése sikertelen',
    sk: 'Nepodarilo sa označiť rezerváciu ako zaplatenú',
    sl: 'Označevanje rezervacije kot plačane ni uspelo',
    es: 'No se pudo marcar la reserva como pagada',
    fi: 'Varauksen merkitseminen maksetuksi epäonnistui',
  },
  'Unexpected error': {
    en: 'Unexpected error',
    bg: 'Неочаквана грешка',
    de: 'Unerwarteter Fehler',
    fr: 'Erreur inattendue',
    ro: 'Eroare neașteptată',
    tr: 'Beklenmeyen hata',
    sr: 'Неочекивана грешка',
    mk: 'Неочекувана грешка',
    hu: 'Váratlan hiba',
    sk: 'Neočekávaná chyba',
    sl: 'Nepričakovana napaka',
    es: 'Error inesperado',
    fi: 'Odottamaton virhe',
  },
  'Failed to cancel booking': {
    en: 'Failed to cancel booking',
    bg: 'Неуспешно анулиране на резервация',
    de: 'Buchung konnte nicht storniert werden',
    fr: "Échec de l'annulation de la réservation",
    ro: 'Anularea rezervării a eșuat',
    tr: 'Rezervasyon iptali başarısız oldu',
    sr: 'Неуспело отказивање резервације',
    mk: 'Неуспешно откажување на резервација',
    hu: 'A foglalás törlése sikertelen',
    sk: 'Nepodarilo sa zrušiť rezerváciu',
    sl: 'Preklic rezervacije ni uspel',
    es: 'No se pudo cancelar la reserva',
    fi: 'Varauksen peruuttaminen epäonnistui',
  },
  'Failed to load owner information': {
    en: 'Failed to load owner information',
    bg: 'Неуспешно зареждане на информация за собственика',
    de: 'Fehler beim Laden der Eigentümerinformationen',
    fr: 'Échec du chargement des informations sur le propriétaire',
    ro: 'Încărcarea informațiilor despre proprietar a eșuat',
    tr: 'Sahip bilgileri yüklenemedi',
    sr: 'Неуспело учитавање информација о власнику',
    mk: 'Неуспешно вчитување на информации за сопственикот',
    hu: 'A tulajdonosi információk betöltése sikertelen',
    sk: 'Nepodarilo sa načítať informácie o vlastníkovi',
    sl: 'Nalaganje informacij o lastniku ni uspelo',
    es: 'No se pudo cargar la información del propietario',
    fi: 'Omistajatietojen lataaminen epäonnistui',
  },
  'Booking marked as paid successfully!': {
    en: 'Booking marked as paid successfully!',
    bg: 'Резервацията беше успешно маркирана като платена!',
    de: 'Buchung erfolgreich als bezahlt markiert!',
    fr: 'Réservation marquée comme payée avec succès !',
    ro: 'Rezervarea a fost marcată ca plătită cu succes!',
    tr: 'Rezervasyon başarıyla ödenmiş olarak işaretlendi!',
    sr: 'Резервација је успешно означена као плаћена!',
    mk: 'Резервацијата успешно е означена како платена!',
    hu: 'A foglalás sikeresen fizetettként lett megjelölve!',
    sk: 'Rezervácia bola úspešne označená ako zaplatená!',
    sl: 'Rezervacija je bila uspešno označena kot plačana!',
    es: '¡Reserva marcada como pagada con éxito!',
    fi: 'Varaus on merkitty onnistuneesti maksetuksi!',
  },
  'Booking canceled successfully!': {
    en: 'Booking canceled successfully!',
    bg: 'Резервацията беше успешно анулирана!',
    de: 'Buchung erfolgreich storniert!',
    fr: 'Réservation annulée avec succès !',
    ro: 'Rezervarea a fost anulată cu succes!',
    tr: 'Rezervasyon başarıyla iptal edildi!',
    sr: 'Резервација је успешно отказана!',
    mk: 'Резервацијата успешно е откажана!',
    hu: 'A foglalás sikeresen törölve!',
    sk: 'Rezervácia bola úspešne zrušená!',
    sl: 'Rezervacija je bila uspešno preklicana!',
    es: '¡Reserva cancelada con éxito!',
    fi: 'Varaus on peruutettu onnistuneesti!',
  },
  'Review Unpaid Bookings': {
    en: 'Review Unpaid Bookings',
    bg: 'Преглед на неплатени резервации',
    de: 'Unbezahlte Buchungen überprüfen',
    fr: 'Examiner les réservations impayées',
    ro: 'Revizuiește rezervările neplătite',
    tr: 'Ödenmemiş Rezervasyonları İncele',
    sr: 'Прегледајте неплаћене резервације',
    mk: 'Прегледајте неплатени резервации',
    hu: 'Nem fizetett foglalások áttekintése',
    sk: 'Skontrolujte nezaplatené rezervácie',
    sl: 'Preglejte neplačane rezervacije',
    es: 'Revisar reservas no pagadas',
    fi: 'Tarkastele maksamattomia varauksia',
  },
  'Manage All Trucks': {
    en: 'Manage All Trucks',
    bg: 'Управление на всички камиони',
    de: 'Alle Lkw verwalten',
    fr: 'Gérer tous les camions',
    ro: 'Gestionează toate camioanele',
    tr: 'Tüm Kamyonları Yönetin',
    sr: 'Управљајте свим камионима',
    mk: 'Управувајте со сите камиони',
    hu: 'Az összes teherautó kezelése',
    sk: 'Spravovať všetky nákladné vozidlá',
    sl: 'Upravljajte z vsemi tovornjaki',
    es: 'Gestionar todos los camiones',
    fi: 'Hallitse kaikkia kuorma-autoja',
  },
  'View Documents': {
    en: 'View Documents',
    bg: 'Преглед на документи',
    de: 'Dokumente anzeigen',
    fr: 'Voir les documents',
    ro: 'Vezi documentele',
    tr: 'Belgeleri Görüntüle',
    sr: 'Преглед докумената',
    mk: 'Преглед на документи',
    hu: 'Dokumentumok megtekintése',
    sk: 'Zobraziť dokumenty',
    sl: 'Ogled dokumentov',
    es: 'Ver documentos',
    fi: 'Näytä asiakirjat',
  },
  'Partner approved successfully!': {
    en: 'Partner approved successfully!',
    bg: 'Партньорът е одобрен успешно!',
    de: 'Partner erfolgreich genehmigt!',
    fr: 'Partenaire approuvé avec succès !',
    ro: 'Partener aprobat cu succes!',
    tr: 'İş ortağı başarıyla onaylandı!',
    sr: 'Партнер је успешно одобрен!',
    mk: 'Партнерот е успешно одобрен!',
    hu: 'A partner sikeresen jóváhagyva!',
    sk: 'Partner bol úspešne schválený!',
    sl: 'Partner je bil uspešno odobren!',
    es: '¡Socio aprobado con éxito!',
    fi: 'Kumppani hyväksytty onnistuneesti!',
  },
  'Failed to approve partner': {
    en: 'Failed to approve partner',
    bg: 'Неуспешно одобряване на партньора',
    de: 'Partner konnte nicht genehmigt werden',
    fr: 'Échec de l’approbation du partenaire',
    ro: 'Nu s-a putut aproba partenerul',
    tr: 'İş ortağı onaylanamadı',
    sr: 'Неуспешно одобравање партнера',
    mk: 'Неуспешно одобрување на партнерот',
    hu: 'A partner jóváhagyása sikertelen',
    sk: 'Nepodarilo sa schváliť partnera',
    sl: 'Odobritev partnerja ni uspela',
    es: 'No se pudo aprobar el socio',
    fi: 'Kumppanin hyväksyminen epäonnistui',
  },
  'There was an issue approving this partner.': {
    en: 'There was an issue approving this partner.',
    bg: 'Възникна проблем при одобряването на този партньор.',
    de: 'Beim Genehmigen dieses Partners ist ein Problem aufgetreten.',
    fr: 'Un problème est survenu lors de l’approbation de ce partenaire.',
    ro: 'A apărut o problemă la aprobarea acestui partener.',
    tr: 'Bu iş ortağı onaylanırken bir sorun oluştu.',
    sr: 'Дошло је до проблема при одобравању партнера.',
    mk: 'Настана проблем при одобрување на овој партнер.',
    hu: 'Hiba történt a partner jóváhagyásakor.',
    sk: 'Pri schvaľovaní partnera nastal problém.',
    sl: 'Pri odobritvi partnerja je prišlo do težave.',
    es: 'Hubo un problema al aprobar a este socio.',
    fi: 'Kumppanin hyväksymisessä ilmeni ongelma.',
  },
  'Partner rejected successfully.': {
    en: 'Partner rejected successfully.',
    bg: 'Партньорът е отхвърлен успешно.',
    de: 'Partner erfolgreich abgelehnt.',
    fr: 'Partenaire rejeté avec succès.',
    ro: 'Partener respins cu succes.',
    tr: 'İş ortağı başarıyla reddedildi.',
    sr: 'Партнер је успешно одбијен.',
    mk: 'Партнерот е успешно одбиен.',
    hu: 'A partner sikeresen elutasítva.',
    sk: 'Partner bol úspešne zamietnutý.',
    sl: 'Partner je bil uspešno zavrnjen.',
    es: 'Socio rechazado con éxito.',
    fi: 'Kumppani hylätty onnistuneesti.',
  },
  'Failed to reject partner': {
    en: 'Failed to reject partner',
    bg: 'Неуспешно отхвърляне на партньора',
    de: 'Partner konnte nicht abgelehnt werden',
    fr: 'Échec du rejet du partenaire',
    ro: 'Nu s-a putut respinge partenerul',
    tr: 'İş ortağı reddedilemedi',
    sr: 'Неуспешно одбијање партнера',
    mk: 'Неуспешно одбивање на партнерот',
    hu: 'A partner elutasítása sikertelen',
    sk: 'Nepodarilo sa zamietnuť partnera',
    sl: 'Zavrnitev partnerja ni uspela',
    es: 'No se pudo rechazar al socio',
    fi: 'Kumppanin hylkääminen epäonnistui',
  },
  'There was an issue rejecting this partner.': {
    en: 'There was an issue rejecting this partner.',
    bg: 'Възникна проблем при отхвърлянето на този партньор.',
    de: 'Beim Ablehnen dieses Partners ist ein Problem aufgetreten.',
    fr: 'Un problème est survenu lors du rejet de ce partenaire.',
    ro: 'A apărut o problemă la respingerea acestui partener.',
    tr: 'Bu iş ortağı reddedilirken bir sorun oluştu.',
    sr: 'Дошло је до проблема при одбијању партнера.',
    mk: 'Настана проблем при одбивање на овој партнер.',
    hu: 'Hiba történt a partner elutasításakor.',
    sk: 'Pri zamietnutí partnera nastal problém.',
    sl: 'Pri zavrnitvi partnerja je prišlo do težave.',
    es: 'Hubo un problema al rechazar a este socio.',
    fi: 'Kumppanin hylkäämisessä ilmeni ongelma.',
  },
  'Approve partner?': {
    en: 'Approve partner?',
    bg: 'Одобряване на партньора?',
    de: 'Partner genehmigen?',
    fr: 'Approuver le partenaire ?',
    ro: 'Aprobați partenerul?',
    tr: 'İş ortağı onaylansın mı?',
    sr: 'Одобрити партнера?',
    mk: 'Одобри партнер?',
    hu: 'Jóváhagyja a partnert?',
    sk: 'Schváliť partnera?',
    sl: 'Odobriti partnerja?',
    es: '¿Aprobar socio?',
    fi: 'Hyväksytäänkö kumppani?',
  },
  'This will approve the partner and grant access.': {
    en: 'This will approve the partner and grant access.',
    bg: 'Това ще одобри партньора и ще му даде достъп.',
    de: 'Dies genehmigt den Partner und gewährt Zugriff.',
    fr: 'Cela approuvera le partenaire et accordera l’accès.',
    ro: 'Aceasta va aproba partenerul și îi va oferi acces.',
    tr: 'Bu işlem iş ortağını onaylar ve erişim verir.',
    sr: 'Ово ће одобрити партнера и омогућити приступ.',
    mk: 'Ова ќе го одобри партнерот и ќе му даде пристап.',
    hu: 'Ez jóváhagyja a partnert és hozzáférést ad.',
    sk: 'Týmto schválite partnera a udelíte prístup.',
    sl: 'S tem boste odobrili partnerja in mu omogočili dostop.',
    es: 'Esto aprobará al socio y le dará acceso.',
    fi: 'Tämä hyväksyy kumppanin ja myöntää käyttöoikeuden.',
  },

  'nav.myListings': {
    en: 'My Listings',
    bg: 'Моите заявки',
    de: 'Meine Anfragen',
    fr: 'Mes demandes',
    ro: 'Cererile mele',
    tr: 'Taleplerim',
    sr: 'Moji zahtevi',
    mk: 'Мои нарачки',
    hu: 'Saját kérések',
    sk: 'Moje dopyty',
    sl: 'Moja povpraševanja',
    es: 'Mis solicitudes',
    fi: 'Omat tilaukset',
    el: 'Οι καταχωρίσεις μου',
  },
  'nav.completedListings': {
    en: 'Completed Listings',
    bg: 'Завършени заявки',
    de: 'Abgeschlossene Anfragen',
    fr: 'Demandes terminées',
    ro: 'Cereri finalizate',
    tr: 'Tamamlanan talepler',
    sr: 'Završeni zahtevi',
    mk: 'Завршени нарачки',
    hu: 'Befejezett kérelmek',
    sk: 'Dokončené dopyty',
    sl: 'Zaključena povpraševanja',
    es: 'Solicitudes completadas',
    fi: 'Valmiit tilaukset',
    el: 'Ολοκληρωμένες καταχωρίσεις',
  },
  'nav.listingDetails': {
    en: 'Listing Details',
    bg: 'Детайли за заявка',
    de: 'Anfragedetails',
    fr: 'Détails de la demande',
    ro: 'Detalii cerere',
    tr: 'Talep detayları',
    sr: 'Detalji zahteva',
    mk: 'Детали за нарачка',
    hu: 'Kérés részletei',
    sk: 'Detaily dopytu',
    sl: 'Podrobnosti povpraševanja',
    es: 'Detalles de la solicitud',
    fi: 'Tilauksen tiedot',
    el: 'Λεπτομέρειες καταχώρισης',
  },
  'nav.searchListings': {
    en: 'Search Listings',
    bg: 'Търси заявки',
    de: 'Anfragen suchen',
    fr: 'Rechercher des demandes',
    ro: 'Caută cereri',
    tr: 'Talepleri ara',
    sr: 'Pretraži zahteve',
    mk: 'Пребарај нарачки',
    hu: 'Kérések keresése',
    sk: 'Vyhľadať dopyty',
    sl: 'Išči povpraševanja',
    es: 'Buscar solicitudes',
    fi: 'Hae tilauksia',
    el: 'Αναζήτηση καταχωρίσεων',
  },
  'Reject partner?': {
    en: 'Reject partner?',
    bg: 'Отхвърляне на партньора?',
    de: 'Partner ablehnen?',
    fr: 'Rejeter le partenaire ?',
    ro: 'Respingeți partenerul?',
    tr: 'İş ortağı reddedilsin mi?',
    sr: 'Одбити партнера?',
    mk: 'Одбиј партнер?',
    hu: 'Elutasítja a partnert?',
    sk: 'Zamietnuť partnera?',
    sl: 'Zavrniti partnerja?',
    es: '¿Rechazar socio?',
    fi: 'Hylätäänkö kumppani?',
  },
  'ValidationStatus.pending': {
    en: 'Pending',
    bg: 'В изчакване',
    de: 'Ausstehend',
    fr: 'En attente',
    ro: 'În așteptare',
    tr: 'Beklemede',
    sr: 'На чекању',
    mk: 'Во тек',
    hu: 'Függőben',
    sk: 'Čaká sa',
    sl: 'V teku',
    es: 'Pendiente',
    fi: 'Odottaa',
    el: 'Εκκρεμεί',
  },
  'ValidationStatus.approved': {
    en: 'Approved',
    bg: 'Одобрен',
    de: 'Genehmigt',
    fr: 'Approuvé',
    ro: 'Aprobat',
    tr: 'Onaylandı',
    sr: 'Одобрено',
    mk: 'Одобрено',
    hu: 'Jóváhagyva',
    sk: 'Schválené',
    sl: 'Odobreno',
    es: 'Aprobado',
    fi: 'Hyväksytty',
    el: 'Εγκρίθηκε',
  },
  'ValidationStatus.confirmed': {
    en: 'Confirmed',
    bg: 'Одобрен',
    de: 'Bestätigt',
    fr: 'Confirmé',
    ro: 'Confirmat',
    tr: 'Onaylandı',
    sr: 'Потврђено',
    mk: 'Потврдено',
    hu: 'Megerősítve',
    sk: 'Potvrdené',
    sl: 'Potrjeno',
    es: 'Confirmado',
    fi: 'Vahvistettu',
    el: 'Επιβεβαιωμένο',
  },
  'ValidationStatus.rejected': {
    en: 'Rejected',
    bg: 'Отхвърлен',
    de: 'Abgelehnt',
    fr: 'Rejeté',
    ro: 'Respins',
    tr: 'Reddedildi',
    sr: 'Одбијено',
    mk: 'Одбиено',
    hu: 'Elutasítva',
    sk: 'Zamietnuté',
    sl: 'Zavrnjeno',
    es: 'Rechazado',
    fi: 'Hylätty',
    el: 'Απορρίφθηκε',
  },
  'ValidationStatus.disabled': {
    en: 'Disabled',
    bg: 'Деактивиран',
    de: 'Deaktiviert',
    fr: 'Désactivé',
    ro: 'Dezactivat',
    tr: 'Devre dışı',
    sr: 'Онемогućено',
    mk: 'Оневозможено',
    hu: 'Letiltva',
    sk: 'Zakázané',
    sl: 'Onemogočeno',
    es: 'Deshabilitado',
    fi: 'Poistettu käytöstä',
    el: 'Απενεργοποιήθηκε',
  },
  'ValidationStatus.paid': {
    en: 'Paid',
    bg: 'Платено',
    de: 'Bezahlt',
    fr: 'Payé',
    ro: 'Plătit',
    tr: 'Ödendi',
    sr: 'Плаћено',
    mk: 'Платено',
    hu: 'Fizetve',
    sk: 'Zaplatené',
    sl: 'Plačano',
    es: 'Pagado',
    fi: 'Maksettu',
    el: 'Πληρωμένο',
  },
  'ValidationStatus.unpaid': {
    en: 'Unpaid',
    bg: 'Неплатено',
    de: 'Unbezahlt',
    fr: 'Impayé',
    ro: 'Neplătit',
    tr: 'Ödenmedi',
    sr: 'Неплаћено',
    mk: 'Неплатен',
    hu: 'Kifizetetlen',
    sk: 'Neplatené',
    sl: 'Neplačano',
    es: 'No pagado',
    fi: 'Maksamaton',
    el: 'Απλήρωτο',
  },
  'ValidationStatus.expired': {
    en: 'Expired',
    bg: 'Изтекла',
    de: 'Abgelaufen',
    fr: 'Expiré',
    ro: 'Expirat',
    tr: 'Süresi doldu',
    sr: 'Isteklo',
    mk: 'Истечено',
    hu: 'Lejárt',
    sk: 'Vypršané',
    sl: 'Poteklo',
    es: 'Expirado',
    fi: 'Vanhentunut',
    el: 'Έληξε',
  },
  Error: {
    en: 'Error',
    bg: 'Грешка',
    de: 'Fehler',
    fr: 'Erreur',
    ro: 'Eroare',
    tr: 'Hata',
    sr: 'Грешка',
    mk: 'Грешка',
    hu: 'Hiba',
    sk: 'Chyba',
    sl: 'Napaka',
    es: 'Error',
    fi: 'Virhe',
  },
  'No pending partners found.': {
    en: 'No pending partners found.',
    bg: 'Няма намерени чакащи партньори.',
    de: 'Keine ausstehenden Partner gefunden.',
    fr: 'Aucun partenaire en attente trouvé.',
    ro: 'Nu au fost găsiți parteneri în așteptare.',
    tr: 'Bekleyen iş ortağı bulunamadı.',
    sr: 'Нису пронађени партнери на чекању.',
    mk: 'Не се пронајдени партнери на чекање.',
    hu: 'Nincsenek függőben lévő partnerek.',
    sk: 'Nenašli sa žiadni čakajúci partneri.',
    sl: 'Ni čakajočih partnerjev.',
    es: 'No se encontraron socios pendientes.',
    fi: 'Odottavia kumppaneita ei löytynyt.',
  },

  'Monitor every booking with the same clarity as the New Order wizard. Filter by lane, status, or time window and jump into the details faster.':
    {
      en: 'Monitor every booking with the same clarity as the New Order wizard. Filter by lane, status, or time window and jump into the details faster.',
      bg: 'Проследявайте всяка резервация с същата яснота като съветника за нова поръчка. Филтрирайте по лента, статус или времеви прозорец и преминете по-бързо към подробностите.',
      de: 'Überwachen Sie jede Buchung mit der gleichen Klarheit wie der New Order-Assistent. Filtern Sie nach Spur, Status oder Zeitfenster und springen Sie schneller zu den Details.',
      fr: "Surveillez chaque réservation avec la même clarté que l'assistant de nouvelle commande. Filtrez par voie, statut ou plage horaire et accédez plus rapidement aux détails.",
      ro: 'Monitorizați fiecare rezervare cu aceeași claritate ca și expertul pentru comenzi noi. Filtrați după bandă, stare sau fereastră de timp și accesați detaliile mai rapid.',
      tr: 'Her rezervasyonu Yeni Sipariş sihirbazı ile aynı netlikte izleyin. Şeride, duruma veya zaman penceresine göre filtreleyin ve ayrıntılara daha hızlı atlayın.',
      sr: 'Пратите сваку резервацију са истом јасноћом као и чаробњак за нову наруџбину. Филтрирајте по траци, статусу или временском прозору и брже пређите на детаље.',
      mk: 'Следете ја секоја резервација со иста јасност како и волшебникот за нова нарачка. Филтрирајте по лента, статус или временски прозор и побрзо преминете на деталите.',
      hu: 'Kövesse nyomon minden foglalást ugyanazzal a tisztasággal, mint az Új rendelés varázsló. Szűrje sáv, állapot vagy időablak szerint, és ugorjon gyorsabban a részletekre.',
      sk: 'Sledujte každú rezerváciu s rovnakou jasnosťou ako sprievodca novou objednávkou. Filtrovať podľa jazdného pruhu, stavu alebo časového okna a rýchlejšie prejsť na podrobnosti.',
      sl: 'Spremljajte vsako rezervacijo z enako jasnostjo kot čarovnik za novo naročilo. Filtrirajte po pasu, stanju ali časovnem oknu in hitreje skočite na podrobnosti.',
      es: 'Monitoree cada reserva con la misma claridad que el asistente de nuevo pedido. Filtre por carril, estado o ventana de tiempo y acceda a los detalles más rápido.',
      fi: 'Seuraa jokaista varausta samalla selkeydellä kuin Uusi tilaus -velho. Suodata kaistan, tilan tai aikavälin mukaan ja siirry yksityiskohtiin nopeammin.',
    },
  'Open filters': {
    en: 'Open filters',
    bg: 'Отвори филтри',
    de: 'Filter öffnen',
    fr: 'Ouvrir les filtres',
    ro: 'Deschide filtrele',
    tr: 'Filtreleri aç',
    sr: 'Отворите филтере',
    mk: 'Отворете филтри',
    hu: 'Szűrők megnyitása',
    sk: 'Otvoriť filtre',
    sl: 'Odpri filtre',
    es: 'Abrir filtros',
    fi: 'Avaa suodattimet',
  },
  'Orders refresh automatically every 5 minutes.': {
    en: 'Orders refresh automatically every 5 minutes.',
    bg: 'Поръчките се обновяват автоматично на всеки 5 минути.',
    de: 'Bestellungen werden alle 5 Minuten automatisch aktualisiert.',
    fr: 'Les commandes se rafraîchissent automatiquement toutes les 5 minutes.',
    ro: 'Comenzile se reîmprospătează automat la fiecare 5 minute.',
    tr: 'Siparişler her 5 dakikada bir otomatik olarak yenilenir.',
    sr: 'Наруџбине се аутоматски освежавају на сваких 5 минута.',
    mk: 'Нарачките се автоматски освежуваат на секои 5 минути.',
    hu: 'A rendelések automatikusan frissülnek 5 percenként.',
    sk: 'Objednávky sa automaticky obnovujú každých 5 minút.',
    sl: 'Naročila se samodejno osvežujejo na vsakih 5 minut.',
    es: 'Los pedidos se actualizan automáticamente cada 5 minutos.',
    fi: 'Tilaukset päivittyvät automaattisesti 5 minuutin välein.',
  },
  'Refresh now': {
    en: 'Refresh now',
    bg: 'Обнови сега',
    de: 'Jetzt aktualisieren',
    fr: 'Rafraîchir maintenant',
    ro: 'Reîmprospătează acum',
    tr: 'Şimdi yenile',
    sr: 'Освежи сада',
    mk: 'Освежи сега',
    hu: 'Frissítés most',
    sk: 'Obnoviť teraz',
    sl: 'Osveži zdaj',
    es: 'Actualizar ahora',
    fi: 'Päivitä nyt',
  },
  'Filter orders': {
    en: 'Filter orders',
    bg: 'Филтрирай поръчки',
    de: 'Bestellungen filtern',
    fr: 'Filtrer les commandes',
    ro: 'Filtrează comenzile',
    tr: 'Siparişleri filtrele',
    sr: 'Филтрирај наруџбине',
    mk: 'Филтрирај нарачки',
    hu: 'Rendelések szűrése',
    sk: 'Filtrovať objednávky',
    sl: 'Filtriraj naročila',
    es: 'Filtrar pedidos',
    fi: 'Suodata tilaukset',
  },
  'No orders match your filter.': {
    en: 'No orders match your filter.',
    bg: 'Няма поръчки, които да отговарят на вашия филтър.',
    de: 'Keine Bestellungen entsprechen Ihrem Filter.',
    fr: 'Aucune commande ne correspond à votre filtre.',
    ro: 'Nicio comandă nu corespunde filtrului dvs.',
    tr: 'Filtrenize uyan sipariş yok.',
    sr: 'Нема наруџбина које одговарају вашем филтеру.',
    mk: 'Нема нарачки што одговараат на вашиот филтер.',
    hu: 'Nincs olyan rendelés, amely megfelel a szűrőnek.',
    sk: 'Žiadne objednávky nevyhovujú vášmu filtru.',
    sl: 'Nobenega naročila ne ustreza vašemu filtru.',
    es: 'Ningún pedido coincide con su filtro.',
    fi: 'Yhtään tilausta ei vastaa suodatintasi.',
  },
  'Error fetching data.': {
    en: 'Error fetching data.',
    bg: 'Грешка при извличане на данни.',
    de: 'Fehler beim Abrufen der Daten.',
    fr: 'Erreur lors de la récupération des données.',
    ro: 'Eroare la preluarea datelor.',
    tr: 'Veri alınırken hata oluştu.',
    sr: 'Грешка при преузимању података.',
    mk: 'Грешка при преземање на податоци.',
    hu: 'Hiba az adatok lekérésekor.',
    sk: 'Chyba pri získavaní údajov.',
    sl: 'Napaka pri pridobivanju podatkov.',
    es: 'Error al obtener datos.',
    fi: 'Virhe haettaessa tietoja.',
  },
  'Add to watchlist': {
    en: 'Add to watchlist',
    bg: 'Добави в списъка за наблюдение',
    de: 'Zur Merkliste hinzufügen',
    fr: 'Ajouter à la liste de surveillance',
    ro: 'Adaugă la lista de urmărire',
    tr: 'İzleme listesine ekle',
    sr: 'Додај на листу за праћење',
    mk: 'Додади на листата за следење',
    hu: 'Hozzáadás a figyelőlistához',
    sk: 'Pridať na sledovací zoznam',
    sl: 'Dodaj na seznam spremljanja',
    es: 'Agregar a la lista de seguimiento',
    fi: 'Lisää tarkkailulistalle',
  },
  'Remove from watchlist': {
    en: 'Remove from watchlist',
    bg: 'Премахни от списъка за наблюдение',
    de: 'Von der Merkliste entfernen',
    fr: 'Retirer de la liste de surveillance',
    ro: 'Elimină din lista de urmărire',
    tr: 'İzleme listesinden kaldır',
    sr: 'Уклони са листе за праћење',
    mk: 'Отстрани од листата за следење',
    hu: 'Eltávolítás a figyelőlistáról',
    sk: 'Odstrániť zo sledovacieho zoznamu',
    sl: 'Odstrani s seznama spremljanja',
    es: 'Eliminar de la lista de seguimiento',
    fi: 'Poista tarkkailulistalta',
  },
  'Open map': {
    en: 'Open map',
    bg: 'Отвори карта',
    de: 'Karte öffnen',
    fr: 'Ouvrir la carte',
    ro: 'Deschide harta',
    tr: 'Haritayı aç',
    sr: 'Отвори мапу',
    mk: 'Отвори мапа',
    hu: 'Térkép megnyitása',
    sk: 'Otvoriť mapu',
    sl: 'Odpri zemljevid',
    es: 'Abrir mapa',
    fi: 'Avaa kartta',
  },
  'Opening hours': {
    en: 'Opening hours',
    bg: 'Час на отваряне',
    de: 'Öffnungszeiten',
    fr: "Heures d'ouverture",
    ro: 'Orele de deschidere',
    tr: 'Çalışma saatleri',
    sr: 'Радно време',
    mk: 'Работно време',
    hu: 'Nyitvatartási idő',
    sk: 'Otváracie hodiny',
    sl: 'Delovni čas',
    es: 'Horario de apertura',
    fi: 'Aukioloajat',
  },
  'Route map': {
    en: 'Route map',
    bg: 'Карта на маршрута',
    de: 'Routenkarte',
    fr: "Carte de l'itinéraire",
    ro: 'Hartă rutieră',
    tr: 'Rota haritası',
    sr: 'Мапа руте',
    mk: 'Мапа на рутата',
    hu: 'Útvonal térkép',
    sk: 'Mapa trasy',
    sl: 'Zemljevid poti',
    es: 'Mapa de ruta',
    fi: 'Reittikartta',
  },
  'No opening hours provided.': {
    en: 'No opening hours provided.',
    bg: 'Не са предоставени часове на отваряне.',
    de: 'Keine Öffnungszeiten angegeben.',
    fr: "Aucun horaire d'ouverture fourni.",
    ro: 'Nu au fost furnizate ore de deschidere.',
    tr: 'Açılış saatleri sağlanmadı.',
    sr: 'Нема наведеног радног времена.',
    mk: 'Не се обезбедени работни часови.',
    hu: 'Nincsenek megadva nyitvatartási idők.',
    sk: 'Nie sú poskytnuté otváracie hodiny.',
    sl: 'Ni podanih delovnih ur.',
    es: 'No se proporcionaron horas de apertura.',
    fi: 'Aukioloaikoja ei ole annettu.',
  },
  'Pickup Date': {
    en: 'Pickup Date',
    bg: 'Дата на вземане',
    de: 'Abholdatum',
    fr: 'Date de ramassage',
    ro: 'Data ridicării',
    tr: 'Alım Tarihi',
    sr: 'Датум преузимања',
    mk: 'Датум на преземање',
    hu: 'Felvétel dátuma',
    sk: 'Dátum vyzdvihnutia',
    sl: 'Datum prevzema',
    es: 'Fecha de recogida',
    fi: 'Noutopäivä',
  },
  'Arrival Date': {
    en: 'Arrival Date',
    bg: 'Дата на пристигане',
    de: 'Ankunftsdatum',
    fr: "Date d'arrivée",
    ro: 'Data sosirii',
    tr: 'Varış Tarihi',
    sr: 'Датум доласка',
    mk: 'Датум на пристигнување',
    hu: 'Érkezés dátuma',
    sk: 'Dátum príchodu',
    sl: 'Datum prihoda',
    es: 'Fecha de llegada',
    fi: 'Saapumispäivä',
  },
  StartPoint: {
    en: 'Start',
    bg: 'Начална',
    de: 'Start',
    fr: 'Initiale', // ж.р.
    ro: 'Inițială', // ж.р.
    tr: 'Start',
    sr: 'Почетна', // ж.р.
    mk: 'Почетна', // ж.р.
    hu: 'Start',
    sk: 'Úvodná', // ж.р.
    sl: 'Začetna', // ж.р.
    es: 'Inicial', // ж.р.
    fi: 'Start',
  },
  ETA: {
    en: 'ЕТА',
    bg: 'Очаквано време на пристигане',
    de: 'Voraussichtliche Ankunftszeit',
    fr: "Heure d'arrivée estimée",
    ro: 'Ora estimată de sosire',
    tr: 'Tahmini varış zamanı',
    sr: 'Процењено време доласка',
    mk: 'Проценето време на пристигнување',
    hu: 'Várható érkezési idő',
    sk: 'Odhadovaný čas príchodu',
    sl: 'Predviden čas prihoda',
    es: 'Hora estimada de llegada',
    fi: 'Arvioitu saapumisaika',
  },
  EndPoint: {
    en: 'End',
    bg: 'Крайна',
    de: 'End',
    fr: 'Finale', // ж.р.
    ro: 'Finală', // ж.р.
    tr: 'End',
    sr: 'Крајња', // ж.р.
    mk: 'Крајна', // ж.р.
    hu: 'End',
    sk: 'Konečná', // ж.р.
    sl: 'Končna', // ж.р.
    es: 'Final', // ж.р.
    fi: 'End',
  },
  Point: {
    en: 'Point',
    bg: 'Точка',
    de: 'Punkt',
    fr: 'Point',
    ro: 'Punct',
    tr: 'Nokta',
    sr: 'Тачка',
    mk: 'Точка',
    hu: 'Pont',
    sk: 'Bod',
    sl: 'Točka',
    es: 'Punto',
    fi: 'Piste',
  },
  Country: {
    en: 'Country',
    bg: 'Държава',
    de: 'Land',
    fr: 'Pays',
    ro: 'Țară',
    tr: 'Ülke',
    sr: 'Земља',
    mk: 'Држава',
    hu: 'Ország',
    sk: 'Krajina',
    sl: 'Država',
    es: 'País',
    fi: 'Maa',
  },
  Location: {
    en: 'Location',
    bg: 'Местоположение',
    de: 'Standort',
    fr: 'Emplacement',
    ro: 'Locație',
    tr: 'Konum',
    sr: 'Локација',
    mk: 'Локација',
    hu: 'Helyszín',
    sk: 'Poloha',
    sl: 'Lokacija',
    es: 'Ubicación',
    fi: 'Sijainti',
  },
  'Current price': {
    en: 'Current price',
    bg: 'Текуща цена',
    de: 'Aktueller Preis',
    fr: 'Prix actuel',
    ro: 'Preț curent',
    tr: 'Mevcut fiyat',
    sr: 'Тренутна цена',
    mk: 'Тековна цена',
    hu: 'Jelenlegi ár',
    sk: 'Aktuálna cena',
    sl: 'Trenutna cena',
    es: 'Precio actual',
    fi: 'Nykyinen hinta',
  },
  Distance: {
    en: 'Distance',
    bg: 'Разстояние',
    de: 'Entfernung',
    fr: 'Distance',
    ro: 'Distanță',
    tr: 'Mesafe',
    sr: 'Удаљеност',
    mk: 'Растојание',
    hu: 'Távolság',
    sk: 'Vzdialenosť',
    sl: 'Razdalja',
    es: 'Distancia',
    fi: 'Etäisyys',
  },
  Estimated: {
    en: 'Estimated',
    bg: 'Оценено',
    de: 'Geschätzt',
    fr: 'Estimé',
    ro: 'Estimare',
    tr: 'Tahmini',
    sr: 'Процењено',
    mk: 'Проценето',
    hu: 'Becsült',
    sk: 'Odhadované',
    sl: 'Ocenjeno',
    es: 'Estimado',
    fi: 'Arvioitu',
  },
  Accept: {
    en: 'Accept',
    bg: 'Приеми',
    de: 'Akzeptieren',
    fr: 'Accepter',
    ro: 'Acceptă',
    tr: 'Kabul et',
    sr: 'Прихвати',
    mk: 'Прифати',
    hu: 'Elfogad',
    sk: 'Prijať',
    sl: 'Sprejmi',
    es: 'Aceptar',
    fi: 'Hyväksy',
  },
  Autobid: {
    en: 'Autobid',
    bg: 'Автоматично наддаване',
    de: 'Automatisches Gebot',
    fr: 'Offre automatique',
    ro: 'Ofertă automată',
    tr: 'Otomatik teklif',
    sr: 'Аутоматска понуда',
    mk: 'Автоматска понуда',
    hu: 'Automatikus licit',
    sk: 'Automatická ponuka',
    sl: 'Samodejna ponudba',
    es: 'Oferta automática',
    fi: 'Automaattitarjous',
  },
  'Set Autobid': {
    en: 'Set Autobid',
    bg: 'Настрой автоматичното наддаване',
    de: 'Automatisches Gebot festlegen',
    fr: "Définir l'offre automatique",
    ro: 'Setează ofertă automată',
    tr: 'Otomatik teklifi ayarla',
    sr: 'Постави аутоматску понуду',
    mk: 'Постави автоматска понуда',
    hu: 'Automatikus licit beállítása',
    sk: 'Nastaviť automatickú ponuku',
    sl: 'Nastavi samodejno ponudbo',
    es: 'Establecer oferta automática',
    fi: 'Aseta automaattitarjous',
  },
  'Maximum price': {
    en: 'Maximum price',
    bg: 'Максимална цена',
    de: 'Maximaler Preis',
    fr: 'Prix maximum',
    ro: 'Preț maxim',
    tr: 'Maksimum fiyat',
    sr: 'Максимална цена',
    mk: 'Максимална цена',
    hu: 'Maximális ár',
    sk: 'Maximálna cena',
    sl: 'Maksimalna cena',
    es: 'Precio máximo',
    fi: 'Maksimihinta',
  },
  'e.g. 200': {
    en: 'e.g. 200',
    bg: 'напр. 200',
    de: 'z.B. 200',
    fr: 'ex. 200',
    ro: 'ex. 200',
    tr: 'ör. 200',
    sr: 'нпр. 200',
    mk: 'напр. 200',
    hu: 'pl. 200',
    sk: 'napr. 200',
    sl: 'npr. 200',
    es: 'p.ej. 200',
    fi: 'esim. 200',
  },
  Save: {
    en: 'Save',
    bg: 'Запази',
    de: 'Speichern',
    fr: 'Enregistrer',
    ro: 'Salvează',
    tr: 'Kaydet',
    sr: 'Сачувај',
    mk: 'Зачувај',
    hu: 'Mentés',
    sk: 'Uložiť',
    sl: 'Shrani',
    es: 'Guardar',
    fi: 'Tallenna',
  },
  'Select Planned Date': {
    en: 'Select Planned Date',
    bg: 'Изберете планирана дата',
    de: 'Geplantes Datum auswählen',
    fr: 'Sélectionner la date prévue',
    ro: 'Selectați data planificată',
    tr: 'Planlanan Tarihi Seçin',
    sr: 'Изаберите планирани датум',
    mk: 'Изберете планиран датум',
    hu: 'Válassza ki a tervezett dátumot',
    sk: 'Vyberte plánovaný dátum',
    sl: 'Izberite načrtovani datum',
    es: 'Seleccionar fecha planificada',
    fi: 'Valitse suunniteltu päivämäärä',
  },
  'Select Truck and Driver': {
    en: 'Select Truck and Driver',
    bg: 'Изберете камион и шофьор',
    de: 'Lkw und Fahrer auswählen',
    fr: 'Sélectionner le camion et le conducteur',
    ro: 'Selectați camionul și șoferul',
    tr: 'Kamyon ve Sürücüyü Seçin',
    sr: 'Изаберите камион и возача',
    mk: 'Изберете камион и возач',
    hu: 'Válassza ki a teherautót és a vezetőt',
    sk: 'Vyberte nákladné auto a vodiča',
    sl: 'Izberite tovornjak in voznika',
    es: 'Seleccionar camión y conductor',
    fi: 'Valitse kuorma-auto ja kuljettaja',
  },
  'Please select a planned date.': {
    en: 'Please select a planned date.',
    bg: 'Моля, изберете планирана дата.',
    de: 'Bitte wählen Sie ein geplantes Datum aus.',
    fr: 'Veuillez sélectionner une date prévue.',
    ro: 'Vă rugăm să selectați o dată planificată.',
    tr: 'Lütfen planlanan bir tarih seçin.',
    sr: 'Молимо изаберите планирани датум.',
    mk: 'Ве молиме изберете планиран датум.',
    hu: 'Kérjük, válasszon egy tervezett dátumot.',
    sk: 'Vyberte plánovaný dátum.',
    sl: 'Izberite načrtovani datum.',
    es: 'Por favor seleccione una fecha planificada.',
    fi: 'Valitse suunniteltu päivämäärä.',
  },
  'Please select a driver and truck': {
    en: 'Please select a driver and truck.',
    bg: 'Моля, изберете шофьор и камион.',
    de: 'Bitte wählen Sie einen Fahrer und einen Lkw aus.',
    fr: 'Veuillez sélectionner un conducteur et un camion.',
    ro: 'Vă rugăm să selectați un șofer și un camion.',
    tr: 'Lütfen bir sürücü ve kamyon seçin.',
    sr: 'Молимо изаберите возача и камион.',
    mk: 'Ве молиме изберете возач и камион.',
    hu: 'Kérjük, válasszon egy vezetőt és egy teherautót.',
    sk: 'Vyberte vodiča a nákladné auto.',
    sl: 'Izberite voznika in tovornjak.',
    es: 'Por favor seleccione un conductor y un camión.',
    fi: 'Valitse kuljettaja ja kuorma-auto.',
  },
  'Order accepted for {{date}}': {
    en: 'Order accepted for {{date}}',
    bg: 'Поръчката е приета за {{date}}',
    de: 'Bestellung akzeptiert für {{date}}',
    fr: 'Commande acceptée pour le {{date}}',
    ro: 'Comanda acceptată pentru {{date}}',
    tr: '{{date}} için sipariş kabul edildi',
    sr: 'Наручено прихваћено за {{date}}',
    mk: 'Нарачката е прифатена за {{date}}',
    hu: 'Rendelés elfogadva {{date}}',
    sk: 'Objednávka prijatá na {{date}}',
    sl: 'Naročilo sprejeto za {{date}}',
    es: 'Pedido aceptado para {{date}}',
    fi: 'Tilaus hyväksytty päivälle {{date}}',
  },
  'Failed to accept': {
    en: 'Failed to accept',
    bg: 'Неуспешно приемане',
    de: 'Akzeptieren fehlgeschlagen',
    fr: "Échec de l'acceptation",
    ro: 'Acceptare eșuată',
    tr: 'Kabul edilemedi',
    sr: 'Прихватање није успело',
    mk: 'Неуспешно прифаќање',
    hu: 'Elfogadás sikertelen',
    sk: 'Nepodarilo sa prijať',
    sl: 'Sprejem ni uspel',
    es: 'Error al aceptar',
    fi: 'Hyväksyminen epäonnistui',
  },
  'Autobid set up to {{price}}': {
    en: 'Autobid set up to {{price}}',
    bg: 'Автоматичната оферта е настроена до {{price}}',
    de: 'Automatisches Gebot eingerichtet bis {{price}}',
    fr: "Offre automatique configurée jusqu'à {{price}}",
    ro: 'Ofertă automată setată până la {{price}}',
    tr: "Otomatik teklif {{price}}'e kadar ayarlandı",
    sr: 'Аутоматска понуда постављена до {{price}}',
    mk: 'Автоматската понуда е поставена до {{price}}',
    hu: 'Automatikus licit beállítva {{price}}-ig',
    sk: 'Automatická ponuka nastavená na {{price}}',
    sl: 'Samodejna ponudba nastavljena do {{price}}',
    es: 'Oferta automática configurada hasta {{price}}',
    fi: 'Automaattitarjous asetettu arvoon {{price}}',
  },

  'Select a Driver': {
    en: 'Select a Driver',
    bg: 'Изберете шофьор',
    de: 'Wählen Sie einen Fahrer aus',
    fr: 'Sélectionner un conducteur',
    ro: 'Selectați un șofer',
    tr: 'Bir Sürücü Seçin',
    sr: 'Изаберите возача',
    mk: 'Изберете возач',
    hu: 'Válasszon egy vezetőt',
    sk: 'Vyberte vodiča',
    sl: 'Izberite voznika',
    es: 'Seleccionar un conductor',
    fi: 'Valitse kuljettaja',
  },
  'Select a Truck': {
    en: 'Select a Truck',
    bg: 'Изберете камион',
    de: 'Wählen Sie einen Lkw aus',
    fr: 'Sélectionner un camion',
    ro: 'Selectați un camion',
    tr: 'Bir Kamyon Seçin',
    sr: 'Изаберите камион',
    mk: 'Изберете камион',
    hu: 'Válasszon egy teherautót',
    sk: 'Vyberte nákladné auto',
    sl: 'Izberite tovornjak',
    es: 'Seleccionar un camión',
    fi: 'Valitse kuorma-auto',
  },
  'Select a Trailer': {
    en: 'Select a Trailer',
    bg: 'Изберете ремарке',
    de: 'Wählen Sie einen Anhänger aus',
    fr: 'Sélectionner une remorque',
    ro: 'Selectați o remorcă',
    tr: 'Bir Römork Seçin',
    sr: 'Изаберите приколицу',
    mk: 'Изберете приколка',
    hu: 'Válasszon egy utánfutót',
    sk: 'Vyberte príves',
    sl: 'Izberite prikolico',
    es: 'Seleccionar un remolque',
    fi: 'Valitse perävaunu',
  },
  'Search by ID, ref, city...': {
    en: 'Search by ID, ref, city...',
    bg: 'Търсене по ID, реф., град...',
    de: 'Suche nach ID, Referenz, Stadt...',
    fr: 'Rechercher par ID, réf., ville...',
    ro: 'Căutare după ID, ref, oraș...',
    tr: 'ID, ref, şehir ile ara...',
    sr: 'Претрага по ИД, реф., граду...',
    mk: 'Пребарување по ИД, реф., град...',
    hu: 'Keresés azonosító, ref, város szerint...',
    sk: 'Vyhľadávanie podľa ID, ref, mesto...',
    sl: 'Iskanje po ID, ref, mesto...',
    es: 'Buscar por ID, ref, ciudad...',
    fi: 'Hae tunnuksella, viitteellä, kaupungilla...',
  },
  'Pick up country': {
    en: 'Pick up country',
    bg: 'Държава за вземане',
    de: 'Abholland',
    fr: 'Pays de ramassage',
    ro: 'Țara de ridicare',
    tr: 'Alım ülkesi',
    sr: 'Земља преузимања',
    mk: 'Држава на преземање',
    hu: 'Felvétel országa',
    sk: 'Krajina vyzdvihnutia',
    sl: 'Država prevzema',
    es: 'País de recogida',
    fi: 'Noutomaan',
  },
  'Pick up city': {
    en: 'Pick up city',
    bg: 'Град за вземане',
    de: 'Abholstadt',
    fr: 'Ville de ramassage',
    ro: 'Oraș de ridicare',
    tr: 'Alım şehri',
    sr: 'Град преузимања',
    mk: 'Град на преземање',
    hu: 'Felvétel városa',
    sk: 'Mesto vyzdvihnutia',
    sl: 'Mesto prevzema',
    es: 'Ciudad de recogida',
    fi: 'Noutokaupunki',
  },
  'Delivery country': {
    en: 'Delivery country',
    bg: 'Държава за доставка',
    de: 'Lieferland',
    fr: 'Pays de livraison',
    ro: 'Țara de livrare',
    tr: 'Teslimat ülkesi',
    sr: 'Земља испоруке',
    mk: 'Држава на достава',
    hu: 'Szállítási ország',
    sk: 'Krajina doručenia',
    sl: 'Država dostave',
    es: 'País de entrega',
    fi: 'Toimitusmaa',
  },
  'Delivery city': {
    en: 'Delivery city',
    bg: 'Град за доставка',
    de: 'Lieferstadt',
    fr: 'Ville de livraison',
    ro: 'Oraș de livrare',
    tr: 'Teslimat şehri',
    sr: 'Град испоруке',
    mk: 'Град на достава',
    hu: 'Szállítási város',
    sk: 'Mesto doručenia',
    sl: 'Mesto dostave',
    es: 'Ciudad de entrega',
    fi: 'Toimituskaupunki',
  },
  'Min cars': {
    en: 'Min cars',
    bg: 'Мин. коли',
    de: 'Min. Autos',
    fr: 'Min voitures',
    ro: 'Min mașini',
    tr: 'Min araba',
    sr: 'Мин аутомобили',
    mk: 'Мин коли',
    hu: 'Min autók',
    sk: 'Min autá',
    sl: 'Min avtomobili',
    es: 'Min coches',
    fi: 'Min autot',
  },
  'Max cars': {
    en: 'Max cars',
    bg: 'Макс. коли',
    de: 'Max. Autos',
    fr: 'Max voitures',
    ro: 'Max mașini',
    tr: 'Maks araba',
    sr: 'Макс аутомобили',
    mk: 'Макс коли',
    hu: 'Max autók',
    sk: 'Max autá',
    sl: 'Maks avtomobili',
    es: 'Max coches',
    fi: 'Maks autot',
  },
  'Loading notification': {
    en: 'Loading notification',
    bg: 'Зареждане на известие',
    de: 'Lade Benachrichtigung',
    fr: 'Chargement de la notification',
    ro: 'Se încarcă notificarea',
    tr: 'Bildirim yükleniyor',
    sr: 'Учитавање обавештења',
    mk: 'Се вчитува известување',
    hu: 'Értesítés betöltése',
    sk: 'Načítavanie oznámenia',
    sl: 'Nalaganje obvestila',
    es: 'Cargando notificación',
    fi: 'Ladataan ilmoitusta',
  },
  Email: {
    en: 'Email',
    bg: 'Имейл',
    de: 'E-Mail',
    fr: 'Email',
    ro: 'Email',
    tr: 'E-posta',
    sr: 'Е-пошта',
    mk: 'Е-пошта',
    hu: 'Email',
    sk: 'Email',
    sl: 'E-pošta',
    es: 'Correo electrónico',
    fi: 'Sähköposti',
  },
  SMS: {
    en: 'SMS',
    bg: 'СМС',
    de: 'SMS',
    fr: 'SMS',
    ro: 'SMS',
    tr: 'SMS',
    sr: 'СМС',
    mk: 'СМС',
    hu: 'SMS',
    sk: 'SMS',
    sl: 'SMS',
    es: 'SMS',
    fi: 'SMS',
  },
  'Favorite routes stay saved for quick access.': {
    en: 'Favorite routes stay saved for quick access.',
    bg: 'Любимите маршрути остават запазени за бърз достъп.',
    de: 'Favoritenrouten bleiben für den schnellen Zugriff gespeichert.',
    fr: 'Les itinéraires favoris restent enregistrés pour un accès rapide.',
    ro: 'Rutele favorite rămân salvate pentru acces rapid.',
    tr: 'Favori rotalar hızlı erişim için kaydedilir.',
    sr: 'Омиљене руте остају сачуване за брзи приступ.',
    mk: 'Омилените рути остануваат зачувани за брз пристап.',
    hu: 'A kedvenc útvonalak mentve maradnak a gyors hozzáférés érdekében.',
    sk: 'Obľúbené trasy zostávajú uložené pre rýchly prístup.',
    sl: 'Priljubljene poti ostanejo shranjene za hiter dostop.',
    es: 'Las rutas favoritas permanecen guardadas para un acceso rápido.',
    fi: 'Suosikkireitit pysyvät tallennettuina nopeaa käyttöä varten.',
  },
  'Apply filters': {
    en: 'Apply filters',
    bg: 'Приложи филтри',
    de: 'Filter anwenden',
    fr: 'Appliquer les filtres',
    ro: 'Aplică filtrele',
    tr: 'Filtreleri uygula',
    sr: 'Примени филтере',
    mk: 'Примени филтри',
    hu: 'Szűrők alkalmazása',
    sk: 'Použiť filtre',
    sl: 'Uporabi filtre',
    es: 'Aplicar filtros',
    fi: 'Käytä suodattimia',
  },
  Clear: {
    en: 'Clear',
    bg: 'Изчисти',
    de: 'Löschen',
    fr: 'Effacer',
    ro: 'Curăță',
    tr: 'Temizle',
    sr: 'Очисти',
    mk: 'Исчисти',
    hu: 'Törlés',
    sk: 'Vyčistiť',
    sl: 'Počisti',
    es: 'Limpiar',
    fi: 'Tyhjennä',
  },
  'Save preset': {
    en: 'Save preset',
    bg: 'Запази предварителна настройка',
    de: 'Voreinstellung speichern',
    fr: 'Enregistrer le préréglage',
    ro: 'Salvează presetare',
    tr: 'Ön ayarı kaydet',
    sr: 'Сачувај претходно подешавање',
    mk: 'Зачувај претходно поставување',
    hu: 'Előre beállítás mentése',
    sk: 'Uložiť predvoľbu',
    sl: 'Shrani prednastavitev',
    es: 'Guardar preajuste',
    fi: 'Tallenna esiasetus',
  },
  'Saved favorite route filters': {
    en: 'Saved favorite route filters',
    bg: 'Запазени филтри за любими маршрути',
    de: 'Gespeicherte Favoritenroutenfilter',
    fr: "Filtres d'itinéraires favoris enregistrés",
    ro: 'Filtre de rută favorite salvate',
    tr: 'Kaydedilmiş favori rota filtreleri',
    sr: 'Сачувани филтери омиљених рута',
    mk: 'Зачувани филтри за омилени рути',
    hu: 'Mentett kedvenc útvonal szűrők',
    sk: 'Uložené filtre obľúbených trás',
    sl: 'Shranjeni filtri priljubljenih poti',
    es: 'Filtros de rutas favoritas guardadas',
    fi: 'Tallennetut suosikkireittisuodattimet',
  },
  km: {
    en: 'km',
    bg: 'км',
    de: 'km',
    fr: 'km',
    ro: 'km',
    tr: 'km',
    sr: 'км',
    mk: 'км',
    hu: 'km',
    sk: 'km',
    sl: 'km',
    es: 'km',
    fi: 'km',
  },
  mi: {
    en: 'mi',
    bg: 'ми',
    de: 'mi',
    fr: 'mi',
    ro: 'mi',
    tr: 'mi',
    sr: 'ми',
    mk: 'ми',
    hu: 'mi',
    sk: 'mi',
    sl: 'mi',
    es: 'mi',
    fi: 'mi',
  },
  Trailers: {
    en: 'Trailers',
    bg: 'Ремаркета',
    de: 'Anhänger',
    fr: 'Remorques',
    ro: 'Remorci',
    tr: 'Römorklar',
    sr: 'Приколице',
    mk: 'Приколки',
    hu: 'Pótkocsik',
    sk: 'Prívesy',
    sl: 'Prikolice',
    es: 'Remolques',
    fi: 'Perävaunut',
  },

  'Search trailers...': {
    en: 'Search trailers...',
    bg: 'Търсене на ремаркета...',
    de: 'Anhänger suchen...',
    fr: 'Rechercher des remorques...',
    ro: 'Caută remorci...',
    tr: 'Römork ara...',
    sr: 'Претрага приколица...',
    mk: 'Пребарување приколки...',
    hu: 'Pótkocsik keresése...',
    sk: 'Vyhľadávanie prívesov...',
    sl: 'Iskanje prikolic...',
    es: 'Buscar remolques...',
    fi: 'Hae perävaunuja...',
  },

  'Add trailer': {
    en: 'Add trailer',
    bg: 'Добави ремарке',
    de: 'Anhänger hinzufügen',
    fr: 'Ajouter une remorque',
    ro: 'Adaugă remorcă',
    tr: 'Römork ekle',
    sr: 'Додај приколицу',
    mk: 'Додај приколка',
    hu: 'Pótkocsi hozzáadása',
    sk: 'Pridať príves',
    sl: 'Dodaj prikolico',
    es: 'Agregar remolque',
    fi: 'Lisää perävaunu',
  },

  'Error loading trailers': {
    en: 'Error loading trailers',
    bg: 'Грешка при зареждане на ремаркетата',
    de: 'Fehler beim Laden der Anhänger',
    fr: 'Erreur lors du chargement des remorques',
    ro: 'Eroare la încărcarea remorcilor',
    tr: 'Römorklar yüklenirken hata oluştu',
    sr: 'Грешка при учитавању приколица',
    mk: 'Грешка при вчитување на приколките',
    hu: 'Hiba a pótkocsik betöltésekor',
    sk: 'Chyba pri načítaní prívesov',
    sl: 'Napaka pri nalaganju prikolic',
    es: 'Error al cargar los remolques',
    fi: 'Virhe perävaunujen lataamisessa',
  },

  'No trailers found.': {
    en: 'No trailers found.',
    bg: 'Няма намерени ремаркета.',
    de: 'Keine Anhänger gefunden.',
    fr: 'Aucune remorque trouvée.',
    ro: 'Nu au fost găsite remorci.',
    tr: 'Römork bulunamadı.',
    sr: 'Нису пронађене приколице.',
    mk: 'Не се пронајдени приколки.',
    hu: 'Nem találhatók pótkocsik.',
    sk: 'Nenašli sa žiadne prívesy.',
    sl: 'Ni najdenih prikolic.',
    es: 'No se encontraron remolques.',
    fi: 'Perävaunuja ei löytynyt.',
  },

  'No trailers found for your search.': {
    en: 'No trailers found for your search.',
    bg: 'Няма намерени ремаркета за вашето търсене.',
    de: 'Keine Anhänger für Ihre Suche gefunden.',
    fr: 'Aucune remorque trouvée pour votre recherche.',
    ro: 'Nu au fost găsite remorci pentru căutarea dvs.',
    tr: 'Aramanız için römork bulunamadı.',
    sr: 'Нису пронађене приколице за вашу претрагу.',
    mk: 'Не се пронајдени приколки за вашето пребарување.',
    hu: 'A kereséshez nem találhatók pótkocsik.',
    sk: 'Pre vaše vyhľadávanie sa nenašli žiadne prívesy.',
    sl: 'Za vaše iskanje ni bilo najdenih prikolic.',
    es: 'No se encontraron remolques para tu búsqueda.',
    fi: 'Hakuehdoilla ei löytynyt perävaunuja.',
  },

  'Edit trailer': {
    en: 'Edit trailer',
    bg: 'Редактирай ремарке',
    de: 'Anhänger bearbeiten',
    fr: 'Modifier la remorque',
    ro: 'Editează remorca',
    tr: 'Römorku düzenle',
    sr: 'Измени приколицу',
    mk: 'Уреди приколка',
    hu: 'Pótkocsi szerkesztése',
    sk: 'Upraviť príves',
    sl: 'Uredi prikolico',
    es: 'Editar remolque',
    fi: 'Muokkaa perävaunua',
  },
  'Loading profile...': {
    en: 'Loading profile...',
    bg: 'Зареждане на профила...',
    de: 'Profil wird geladen...',
    fr: 'Chargement du profil...',
    ro: 'Se încarcă profilul...',
    tr: 'Profil yükleniyor...',
    sr: 'Учитавање профила...',
    mk: 'Се вчитува профилот...',
    hu: 'Profil betöltése...',
    sk: 'Načítava sa profil...',
    sl: 'Nalaganje profila...',
    es: 'Cargando perfil...',
    fi: 'Profiilia ladataan...',
  },
  'Error loading profile': {
    en: 'Error loading profile',
    bg: 'Грешка при зареждане на профила',
    de: 'Fehler beim Laden des Profils',
    fr: 'Erreur lors du chargement du profil',
    ro: 'Eroare la încărcarea profilului',
    tr: 'Profil yüklenirken hata oluştu',
    sr: 'Грешка при учитавању профила',
    mk: 'Грешка при вчитување на профилот',
    hu: 'Hiba a profil betöltésekor',
    sk: 'Chyba pri načítaní profilu',
    sl: 'Napaka pri nalaganju profila',
    es: 'Error al cargar el perfil',
    fi: 'Virhe profiilin lataamisessa',
  },
  'User not found.': {
    en: 'User not found.',
    bg: 'Потребителят не е намерен.',
    de: 'Benutzer nicht gefunden.',
    fr: 'Utilisateur introuvable.',
    ro: 'Utilizatorul nu a fost găsit.',
    tr: 'Kullanıcı bulunamadı.',
    sr: 'Корисник није пронађен.',
    mk: 'Корисникот не е пронајден.',
    hu: 'Felhasználó nem található.',
    sk: 'Používateľ nebol nájdený.',
    sl: 'Uporabnik ni bil najden.',
    es: 'Usuario no encontrado.',
    fi: 'Käyttäjää ei löytynyt.',
  },
  'Not logged in': {
    en: 'Not logged in',
    bg: 'Не сте влезли в системата',
    de: 'Nicht angemeldet',
    fr: 'Non connecté',
    ro: 'Neautentificat',
    tr: 'Giriş yapılmamış',
    sr: 'Нисте пријављени',
    mk: 'Не сте најавени',
    hu: 'Nincs bejelentkezve',
    sk: 'Neprihlásený',
    sl: 'Ni prijavljen',
    es: 'No has iniciado sesión',
    fi: 'Et ole kirjautunut sisään',
  },
  'Company Information': {
    en: 'Company Information',
    bg: 'Информация за компанията',
    de: 'Unternehmensinformationen',
    fr: 'Informations sur l’entreprise',
    ro: 'Informații despre companie',
    tr: 'Şirket bilgileri',
    sr: 'Информације о компанији',
    mk: 'Информации за компанијата',
    hu: 'Céginformációk',
    sk: 'Informácie o spoločnosti',
    sl: 'Podatki o podjetju',
    es: 'Información de la empresa',
    fi: 'Yrityksen tiedot',
  },
  'Company Name': {
    en: 'Company Name',
    bg: 'Име на компанията',
    de: 'Firmenname',
    fr: 'Nom de l’entreprise',
    ro: 'Numele companiei',
    tr: 'Şirket adı',
    sr: 'Назив компаније',
    mk: 'Име на компанијата',
    hu: 'Cégnév',
    sk: 'Názov spoločnosti',
    sl: 'Ime podjetja',
    es: 'Nombre de la empresa',
    fi: 'Yrityksen nimi',
  },
  City: {
    en: 'City',
    bg: 'Град',
    de: 'Stadt',
    fr: 'Ville',
    ro: 'Oraș',
    tr: 'Şehir',
    sr: 'Град',
    mk: 'Град',
    hu: 'Város',
    sk: 'Mesto',
    sl: 'Mesto',
    es: 'Ciudad',
    fi: 'Kaupunki',
  },
  'Post code': {
    en: 'Post code',
    bg: 'Пощенски код',
    de: 'Postleitzahl',
    fr: 'Code postal',
    ro: 'Cod poștal',
    tr: 'Posta kodu',
    sr: 'Поштански број',
    mk: 'Поштенски број',
    hu: 'Irányítószám',
    sk: 'PSČ',
    sl: 'Poštna številka',
    es: 'Código postal',
    fi: 'Postinumero',
  },
  'Phone Number': {
    en: 'Phone Number',
    bg: 'Телефонен номер',
    de: 'Telefonnummer',
    fr: 'Numéro de téléphone',
    ro: 'Număr de telefon',
    tr: 'Telefon numarası',
    sr: 'Број телефона',
    mk: 'Телефонски број',
    hu: 'Telefonszám',
    sk: 'Telefónne číslo',
    sl: 'Telefonska številka',
    es: 'Número de teléfono',
    fi: 'Puhelinnumero',
  },
  'Upload your documents': {
    en: 'Upload your documents',
    bg: 'Качете вашите документи',
    de: 'Laden Sie Ihre Dokumente hoch',
    fr: 'Téléchargez vos documents',
    ro: 'Încărcați documentele',
    tr: 'Belgelerinizi yükleyin',
    sr: 'Отпремите своја документа',
    mk: 'Прикачете ги вашите документи',
    hu: 'Töltse fel dokumentumait',
    sk: 'Nahrajte svoje dokumenty',
    sl: 'Naložite svoje dokumente',
    es: 'Sube tus documentos',
    fi: 'Lataa asiakirjasi',
  },
  'Submitted {{date}}': {
    en: 'Submitted {{date}}',
    bg: 'Изпратено на {{date}}',
    de: 'Eingereicht am {{date}}',
    fr: 'Soumis le {{date}}',
    ro: 'Trimis la {{date}}',
    tr: '{{date}} tarihinde gönderildi',
    sr: 'Poslato {{date}}',
    mk: 'Испратено на {{date}}',
    hu: '{{date}}-án benyújtva',
    sk: 'Odoslané {{date}}',
    sl: 'Poslano {{date}}',
    es: 'Enviado el {{date}}',
    fi: 'Lähetetty {{date}}',
    el: 'Υποβλήθηκε στις {{date}}',
  },
  'Manage quote': {
    en: 'Manage quote',
    bg: 'Управление на оферта',
    de: 'Angebot verwalten',
    fr: 'Gérer le devis',
    ro: 'Gestionează oferta',
    tr: 'Teklifi yönet',
    sr: 'Upravljaj ponudom',
    mk: 'Управувај со понудата',
    hu: 'Ajánlat kezelése',
    sk: 'Spravovať ponuku',
    sl: 'Upravljaj ponudbo',
    es: 'Gestionar oferta',
    fi: 'Hallitse tarjousta',
    el: 'Διαχείριση προσφοράς',
  },

  'Quick view': {
    en: 'Quick view',
    bg: 'Бърз преглед',
    de: 'Schnellansicht',
    fr: 'Aperçu rapide',
    ro: 'Vizualizare rapidă',
    tr: 'Hızlı görünüm',
    sr: 'Brzi pregled',
    mk: 'Брз преглед',
    hu: 'Gyors nézet',
    sk: 'Rýchly náhľad',
    sl: 'Hiter pregled',
    es: 'Vista rápida',
    fi: 'Pikanäkymä',
    el: 'Γρήγορη προβολή',
  },
  'Store identity or compliance files securely so admins can verify your profile. Supported types: PDF, JPG, PNG, DOC.':
    {
      en: 'Store identity or compliance files securely so admins can verify your profile. Supported types: PDF, JPG, PNG, DOC.',
      bg: 'Съхранявайте документи за самоличност или съответствие сигурно, за да могат администраторите да потвърдят профила ви. Поддържани формати: PDF, JPG, PNG, DOC.',
      de: 'Speichern Sie Identitäts- oder Compliance-Dokumente sicher, damit Administratoren Ihr Profil überprüfen können. Unterstützte Formate: PDF, JPG, PNG, DOC.',
      fr: 'Stockez en toute sécurité des documents d’identité ou de conformité afin que les administrateurs puissent vérifier votre profil. Formats pris en charge : PDF, JPG, PNG, DOC.',
      ro: 'Stocați în siguranță documente de identitate sau de conformitate pentru ca administratorii să vă poată verifica profilul. Formate acceptate: PDF, JPG, PNG, DOC.',
      tr: 'Yöneticilerin profilinizi doğrulayabilmesi için kimlik veya uyumluluk belgelerini güvenli bir şekilde saklayın. Desteklenen formatlar: PDF, JPG, PNG, DOC.',
      sr: 'Безбедно сачувајте документа за идентификацију или усклађеност како би администратори могли да верификују ваш профил. Подржани формати: PDF, JPG, PNG, DOC.',
      mk: 'Безбедно зачувајте документи за идентификација или усогласеност за администраторите да можат да го потврдат вашиот профил. Поддржани формати: PDF, JPG, PNG, DOC.',
      hu: 'Tárolja biztonságosan az azonosító vagy megfelelőségi dokumentumokat, hogy az adminisztrátorok ellenőrizhessék profilját. Támogatott formátumok: PDF, JPG, PNG, DOC.',
      sk: 'Bezpečne uložte identifikačné alebo súladové dokumenty, aby mohli administrátori overiť váš profil. Podporované formáty: PDF, JPG, PNG, DOC.',
      sl: 'Varno shranite dokumente za identifikacijo ali skladnost, da lahko skrbniki preverijo vaš profil. Podprti formati: PDF, JPG, PNG, DOC.',
      es: 'Guarde de forma segura documentos de identidad o cumplimiento para que los administradores puedan verificar su perfil. Formatos compatibles: PDF, JPG, PNG, DOC.',
      fi: 'Tallenna henkilöllisyys- tai vaatimustenmukaisuusasiakirjat turvallisesti, jotta ylläpitäjät voivat vahvistaa profiilisi. Tuetut muodot: PDF, JPG, PNG, DOC.',
    },

  'Sign in to upload documents to your profile.': {
    en: 'Sign in to upload documents to your profile.',
    bg: 'Влезте в профила си, за да качите документи.',
    de: 'Melden Sie sich an, um Dokumente in Ihr Profil hochzuladen.',
    fr: 'Connectez-vous pour télécharger des documents dans votre profil.',
    ro: 'Autentificați-vă pentru a încărca documente în profilul dvs.',
    tr: 'Profilinize belge yüklemek için giriş yapın.',
    sr: 'Пријавите се да бисте отпремили документа на свој профил.',
    mk: 'Најавете се за да прикачите документи на вашиот профил.',
    hu: 'Jelentkezzen be, hogy dokumentumokat tölthessen fel a profiljába.',
    sk: 'Prihláste sa, aby ste mohli nahrať dokumenty do profilu.',
    sl: 'Prijavite se za nalaganje dokumentov v profil.',
    es: 'Inicia sesión para subir documentos a tu perfil.',
    fi: 'Kirjaudu sisään ladataksesi asiakirjoja profiiliisi.',
  },

  'After uploading, support staff can review and approve your account.': {
    en: 'After uploading, support staff can review and approve your account.',
    bg: 'След качването служителите по поддръжката могат да прегледат и одобрят вашия акаунт.',
    de: 'Nach dem Hochladen kann das Support-Team Ihr Konto prüfen und genehmigen.',
    fr: 'Après le téléchargement, le personnel d’assistance peut examiner et approuver votre compte.',
    ro: 'După încărcare, personalul de suport poate revizui și aproba contul dvs.',
    tr: 'Yüklemeden sonra destek ekibi hesabınızı inceleyip onaylayabilir.',
    sr: 'Након отпремања, служба подршке може прегледати и одобрити ваш налог.',
    mk: 'По прикачувањето, службата за поддршка може да го прегледа и одобри вашиот профил.',
    hu: 'Feltöltés után az ügyfélszolgálat ellenőrizheti és jóváhagyhatja fiókját.',
    sk: 'Po nahraní môže podpora skontrolovať a schváliť váš účet.',
    sl: 'Po nalaganju lahko podpora pregleda in odobri vaš račun.',
    es: 'Después de subirlos, el personal de soporte puede revisar y aprobar su cuenta.',
    fi: 'Lataamisen jälkeen tukihenkilöstö voi tarkistaa ja hyväksyä tilisi.',
  },
  Name: {
    en: 'Name',
    bg: 'Име',
    de: 'Name',
    fr: 'Nom',
    ro: 'Nume',
    tr: 'İsim',
    sr: 'Име',
    mk: 'Име',
    hu: 'Név',
    sk: 'Meno',
    sl: 'Ime',
    es: 'Nombre',
    fi: 'Nimi',
  },

  'No Name': {
    en: 'No Name',
    bg: 'Без име',
    de: 'Kein Name',
    fr: 'Sans nom',
    ro: 'Fără nume',
    tr: 'İsim yok',
    sr: 'Без имена',
    mk: 'Без име',
    hu: 'Nincs név',
    sk: 'Bez mena',
    sl: 'Brez imena',
    es: 'Sin nombre',
    fi: 'Ei nimeä',
  },
  'No Email': {
    en: 'No Email',
    bg: 'Няма имейл',
    de: 'Keine E-Mail',
    fr: 'Pas d’e-mail',
    ro: 'Fără email',
    tr: 'E-posta yok',
    sr: 'Нема е-поште',
    mk: 'Нема е-пошта',
    hu: 'Nincs e-mail',
    sk: 'Žiadny e-mail',
    sl: 'Ni e-pošte',
    es: 'Sin correo',
    fi: 'Ei sähköpostia',
  },

  Role: {
    en: 'Role',
    bg: 'Роля',
    de: 'Rolle',
    fr: 'Rôle',
    ro: 'Rol',
    tr: 'Rol',
    sr: 'Улога',
    mk: 'Улога',
    hu: 'Szerep',
    sk: 'Rola',
    sl: 'Vloga',
    es: 'Rol',
    fi: 'Rooli',
  },

  'Manage fleet': {
    en: 'Manage fleet',
    bg: 'Управление на автопарка',
    de: 'Fuhrpark verwalten',
    fr: 'Gérer la flotte',
    ro: 'Gestionează flota',
    tr: 'Filoyu yönet',
    sr: 'Управљај флотом',
    mk: 'Управување со флотата',
    hu: 'Flotta kezelése',
    sk: 'Spravovať flotilu',
    sl: 'Upravljanje flote',
    es: 'Gestionar flota',
    fi: 'Hallitse kalustoa',
  },

  'No pending trucks found': {
    en: 'No pending trucks found',
    bg: 'Няма намерени камиони в изчакване',
    de: 'Keine ausstehenden LKW gefunden',
    fr: 'Aucun camion en attente trouvé',
    ro: 'Nu au fost găsite camioane în așteptare',
    tr: 'Bekleyen kamyon bulunamadı',
    sr: 'Нису пронађени камиони на чекању',
    mk: 'Не се пронајдени камиони во чекање',
    hu: 'Nincsenek függőben lévő teherautók',
    sk: 'Nenašli sa žiadne čakajúce nákladné vozidlá',
    sl: 'Ni najdenih čakajočih tovornjakov',
    es: 'No se encontraron camiones pendientes',
    fi: 'Ei löytynyt odottavia kuorma-autoja',
  },

  'View Profile': {
    en: 'Profile overview',
    bg: 'Преглед на профил',
    de: 'Profilübersicht',
    fr: 'Aperçu du profil',
    ro: 'Prezentare profil',
    tr: 'Profil özeti',
    sr: 'Преглед профила',
    mk: 'Преглед на профил',
    hu: 'Profil áttekintése',
    sk: 'Prehľad profilu',
    sl: 'Pregled profila',
    es: 'Resumen del perfil',
    fi: 'Profiilin yleiskatsaus',
  },
  'Truck approved successfully!': {
    en: 'Truck approved successfully!',
    bg: 'Камионът е одобрен успешно!',
    de: 'LKW erfolgreich genehmigt!',
    fr: 'Camion approuvé avec succès !',
    ro: 'Camionul a fost aprobat cu succes!',
    tr: 'Kamyon başarıyla onaylandı!',
    sr: 'Камион је успешно одобрен!',
    mk: 'Камионот е успешно одобрен!',
    hu: 'A teherautó sikeresen jóváhagyva!',
    sk: 'Nákladné vozidlo bolo úspešne schválené!',
    sl: 'Tovornjak je bil uspešno odobren!',
    es: '¡Camión aprobado con éxito!',
    fi: 'Kuorma-auto hyväksyttiin onnistuneesti!',
  },

  'Failed to approve truck': {
    en: 'Failed to approve truck',
    bg: 'Неуспешно одобряване на камиона',
    de: 'Genehmigung des LKW fehlgeschlagen',
    fr: 'Échec de l’approbation du camion',
    ro: 'Aprobarea camionului a eșuat',
    tr: 'Kamyon onaylanamadı',
    sr: 'Одобравање камиона није успело',
    mk: 'Неуспешно одобрување на камионот',
    hu: 'A teherautó jóváhagyása sikertelen',
    sk: 'Schválenie nákladného vozidla zlyhalo',
    sl: 'Odobritev tovornjaka ni uspela',
    es: 'Error al aprobar el camión',
    fi: 'Kuorma-auton hyväksyntä epäonnistui',
  },

  'There was an issue approving this truck.': {
    en: 'There was an issue approving this truck.',
    bg: 'Възникна проблем при одобряването на този камион.',
    de: 'Beim Genehmigen dieses LKW ist ein Problem aufgetreten.',
    fr: 'Un problème est survenu lors de l’approbation de ce camion.',
    ro: 'A apărut o problemă la aprobarea acestui camion.',
    tr: 'Bu kamyon onaylanırken bir sorun oluştu.',
    sr: 'Дошло је до проблема при одобравању овог камиона.',
    mk: 'Се појави проблем при одобрување на овој камион.',
    hu: 'Probléma merült fel a teherautó jóváhagyásakor.',
    sk: 'Pri schvaľovaní tohto nákladného vozidla nastal problém.',
    sl: 'Pri odobritvi tega tovornjaka je prišlo do težave.',
    es: 'Hubo un problema al aprobar este camión.',
    fi: 'Tämän kuorma-auton hyväksymisessä ilmeni ongelma.',
  },

  'Truck rejected successfully.': {
    en: 'Truck rejected successfully.',
    bg: 'Камионът е отхвърлен успешно.',
    de: 'LKW erfolgreich abgelehnt.',
    fr: 'Camion rejeté avec succès.',
    ro: 'Camionul a fost respins cu succes.',
    tr: 'Kamyon başarıyla reddedildi.',
    sr: 'Камион је успешно одбијен.',
    mk: 'Камионот е успешно одбиен.',
    hu: 'A teherautó sikeresen elutasítva.',
    sk: 'Nákladné vozidlo bolo úspešne zamietnuté.',
    sl: 'Tovornjak je bil uspešno zavrnjen.',
    es: 'Camión rechazado con éxito.',
    fi: 'Kuorma-auto hylättiin onnistuneesti.',
  },

  'Failed to reject truck': {
    en: 'Failed to reject truck',
    bg: 'Неуспешно отхвърляне на камиона',
    de: 'Ablehnung des LKW fehlgeschlagen',
    fr: 'Échec du rejet du camion',
    ro: 'Respingerea camionului a eșuat',
    tr: 'Kamyon reddedilemedi',
    sr: 'Одбијање камиона није успело',
    mk: 'Неуспешно одбивање на камионот',
    hu: 'A teherautó elutasítása sikertelen',
    sk: 'Zamietnutie nákladného vozidla zlyhalo',
    sl: 'Zavrnitev tovornjaka ni uspela',
    es: 'Error al rechazar el camión',
    fi: 'Kuorma-auton hylkäys epäonnistui',
  },

  'There was an issue rejecting this truck.': {
    en: 'There was an issue rejecting this truck.',
    bg: 'Възникна проблем при отхвърлянето на този камион.',
    de: 'Beim Ablehnen dieses LKW ist ein Problem aufgetreten.',
    fr: 'Un problème est survenu lors du rejet de ce camion.',
    ro: 'A apărut o problemă la respingerea acestui camion.',
    tr: 'Bu kamyon reddedilirken bir sorun oluştu.',
    sr: 'Дошло је до проблема при одбијању овог камиона.',
    mk: 'Се појави проблем при одбивање на овој камион.',
    hu: 'Probléma merült fel a teherautó elutasításakor.',
    sk: 'Pri zamietnutí tohto nákladného vozidla nastal problém.',
    sl: 'Pri zavrnitvi tega tovornjaka je prišlo do težave.',
    es: 'Hubo un problema al rechazar este camión.',
    fi: 'Tämän kuorma-auton hylkäämisessä ilmeni ongelma.',
  },

  'Approve truck?': {
    en: 'Approve truck?',
    bg: 'Одобряване на камиона?',
    de: 'LKW genehmigen?',
    fr: 'Approuver le camion ?',
    ro: 'Aprobi camionul?',
    tr: 'Kamyon onaylansın mı?',
    sr: 'Одобрити камион?',
    mk: 'Да се одобри камионот?',
    hu: 'Jóváhagyod a teherautót?',
    sk: 'Schváliť nákladné vozidlo?',
    sl: 'Odobriti tovornjak?',
    es: '¿Aprobar camión?',
    fi: 'Hyväksytäänkö kuorma-auto?',
  },

  'This will approve the truck and make it available for bookings.': {
    en: 'This will approve the truck and make it available for bookings.',
    bg: 'Това ще одобри камиона и ще го направи достъпен за резервации.',
    de: 'Dies genehmigt den LKW und macht ihn für Buchungen verfügbar.',
    fr: 'Cela approuvera le camion et le rendra disponible pour les réservations.',
    ro: 'Aceasta va aproba camionul și îl va face disponibil pentru rezervări.',
    tr: 'Bu işlem kamyonu onaylar ve rezervasyonlara açar.',
    sr: 'Ово ће одобрити камион и учинити га доступним за резервације.',
    mk: 'Ова акција ќе го одобри камионот и ќе го направи достапен за резервации.',
    hu: 'Ez jóváhagyja a teherautót és elérhetővé teszi foglalásra.',
    sk: 'Týmto sa vozidlo schváli a sprístupní na rezervácie.',
    sl: 'To bo odobrilo tovornjak in ga omogočilo za rezervacije.',
    es: 'Esto aprobará el camión y lo hará disponible para reservas.',
    fi: 'Tämä hyväksyy kuorma-auton ja tekee sen varattavaksi.',
  },

  'Reject truck?': {
    en: 'Reject truck?',
    bg: 'Отхвърляне на камиона?',
    de: 'LKW ablehnen?',
    fr: 'Rejeter le camion ?',
    ro: 'Respinge camionul?',
    tr: 'Kamyon reddedilsin mi?',
    sr: 'Одбити камион?',
    mk: 'Да се одбие камионот?',
    hu: 'Elutasítod a teherautót?',
    sk: 'Zamietnuť nákladné vozidlo?',
    sl: 'Zavrniti tovornjak?',
    es: '¿Rechazar camión?',
    fi: 'Hylätäänkö kuorma-auto?',
  },

  'This action will reject the truck and cannot be undone.': {
    en: 'This action will reject the truck and cannot be undone.',
    bg: 'Това действие ще отхвърли камиона и не може да бъде отменено.',
    de: 'Diese Aktion lehnt den LKW ab und kann nicht rückgängig gemacht werden.',
    fr: 'Cette action rejettera le camion et ne pourra pas être annulée.',
    ro: 'Această acțiune va respinge camionul și nu poate fi anulată.',
    tr: 'Bu işlem kamyonu reddeder ve geri alınamaz.',
    sr: 'Ова радња ће одбити камион и не може се поништити.',
    mk: 'Оваа акција ќе го одбие камионот и не може да се врати.',
    hu: 'Ez a művelet elutasítja a teherautót és nem vonható vissza.',
    sk: 'Táto akcia zamietne vozidlo a nedá sa vrátiť späť.',
    sl: 'To dejanje bo zavrnilo tovornjak in ga ni mogoče razveljaviti.',
    es: 'Esta acción rechazará el camión y no se puede deshacer.',
    fi: 'Tämä toiminto hylkää kuorma-auton eikä sitä voi perua.',
  },

  'Error fetching trucks': {
    en: 'Error fetching trucks',
    bg: 'Грешка при зареждане на камионите',
    de: 'Fehler beim Laden der LKW',
    fr: 'Erreur lors du chargement des camions',
    ro: 'Eroare la încărcarea camioanelor',
    tr: 'Kamyonlar yüklenirken hata oluştu',
    sr: 'Грешка при учитавању камиона',
    mk: 'Грешка при вчитување на камионите',
    hu: 'Hiba a teherautók betöltésekor',
    sk: 'Chyba pri načítaní nákladných vozidiel',
    sl: 'Napaka pri nalaganju tovornjakov',
    es: 'Error al cargar los camiones',
    fi: 'Virhe kuorma-autojen lataamisessa',
  },
  VIN: {
    en: 'VIN',
    bg: 'VIN',
    de: 'FIN',
    fr: 'VIN',
    ro: 'VIN',
    tr: 'VIN',
    sr: 'VIN',
    mk: 'VIN',
    hu: 'VIN',
    sk: 'VIN',
    sl: 'VIN',
    es: 'VIN',
    fi: 'VIN',
  },

  'Truck has been validated by:': {
    en: 'Truck has been validated by:',
    bg: 'Камионът е валидиран от:',
    de: 'Der LKW wurde validiert von:',
    fr: 'Le camion a été validé par :',
    ro: 'Camionul a fost validat de:',
    tr: 'Kamyon şu kişi tarafından doğrulandı:',
    sr: 'Камион је валидиран од:',
    mk: 'Камионот е валидиран од:',
    hu: 'A teherautót jóváhagyta:',
    sk: 'Vozidlo bolo overené používateľom:',
    sl: 'Tovornjak je bil potrjen s strani:',
    es: 'El camión fue validado por:',
    fi: 'Kuorma-auton vahvisti:',
  },

  on: {
    en: 'on',
    bg: 'на',
    de: 'am',
    fr: 'le',
    ro: 'la',
    tr: 'tarihinde',
    sr: 'дана',
    mk: 'на',
    hu: '-',
    sk: 'dňa',
    sl: 'dne',
    es: 'el',
    fi: '-',
  },

  'Coming soon': {
    en: 'Coming soon',
    bg: 'Очаквайте скоро',
    de: 'Demnächst verfügbar',
    fr: 'Bientôt disponible',
    ro: 'Disponibil în curând',
    tr: 'Yakında',
    sr: 'Ускоро',
    mk: 'Наскоро',
    hu: 'Hamarosan',
    sk: 'Už čoskoro',
    sl: 'Kmalu na voljo',
    es: 'Próximamente',
    fi: 'Tulossa pian',
  },

  'View documents': {
    en: 'View documents',
    bg: 'Виж документи',
    de: 'Dokumente anzeigen',
    fr: 'Voir les documents',
    ro: 'Vezi documentele',
    tr: 'Belgeleri görüntüle',
    sr: 'Погледај документе',
    mk: 'Види документи',
    hu: 'Dokumentumok megtekintése',
    sk: 'Zobraziť dokumenty',
    sl: 'Ogled dokumentov',
    es: 'Ver documentos',
    fi: 'Näytä asiakirjat',
  },

  'This truck is already disabled': {
    en: 'This truck is already disabled',
    bg: 'Този камион вече е деактивиран',
    de: 'Dieser LKW ist bereits deaktiviert',
    fr: 'Ce camion est déjà désactivé',
    ro: 'Acest camion este deja dezactivat',
    tr: 'Bu kamyon zaten devre dışı',
    sr: 'Овај камион је већ онемогућен',
    mk: 'Овој камион е веќе оневозможен',
    hu: 'Ez a teherautó már le van tiltva',
    sk: 'Toto vozidlo je už zakázané',
    sl: 'Ta tovornjak je že onemogočen',
    es: 'Este camión ya está deshabilitado',
    fi: 'Tämä kuorma-auto on jo poistettu käytöstä',
  },

  'Disable this truck': {
    en: 'Disable this truck',
    bg: 'Деактивирай този камион',
    de: 'Diesen LKW deaktivieren',
    fr: 'Désactiver ce camion',
    ro: 'Dezactivează acest camion',
    tr: 'Bu kamyonu devre dışı bırak',
    sr: 'Онемогући овај камион',
    mk: 'Оневозможи го овој камион',
    hu: 'Teherautó letiltása',
    sk: 'Zakázať toto vozidlo',
    sl: 'Onemogoči ta tovornjak',
    es: 'Deshabilitar este camión',
    fi: 'Poista tämä kuorma-auto käytöstä',
  },

  'Disable Truck': {
    en: 'Disable Truck',
    bg: 'Деактивиране на камион',
    de: 'LKW deaktivieren',
    fr: 'Désactiver le camion',
    ro: 'Dezactivare camion',
    tr: 'Kamyonu devre dışı bırak',
    sr: 'Онемогућавање камиона',
    mk: 'Оневозможување на камион',
    hu: 'Teherautó letiltása',
    sk: 'Zakázanie vozidla',
    sl: 'Onemogočanje tovornjaka',
    es: 'Deshabilitar camión',
    fi: 'Kuorma-auton poistaminen käytöstä',
  },

  'Are you sure you want to disable this truck? This action cannot be undone.':
    {
      en: 'Are you sure you want to disable this truck? This action cannot be undone.',
      bg: 'Сигурни ли сте, че искате да деактивирате този камион? Това действие не може да бъде отменено.',
      de: 'Möchten Sie diesen LKW wirklich deaktivieren? Diese Aktion kann nicht rückgängig gemacht werden.',
      fr: 'Êtes-vous sûr de vouloir désactiver ce camion ? Cette action est irréversible.',
      ro: 'Sigur doriți să dezactivați acest camion? Această acțiune nu poate fi anulată.',
      tr: 'Bu kamyonu devre dışı bırakmak istediğinizden emin misiniz? Bu işlem geri alınamaz.',
      sr: 'Да ли сте сигурни да желите да онемогућите овај камион? Ова радња се не може поништити.',
      mk: 'Дали сте сигурни дека сакате да го оневозможите овој камион? Оваа акција не може да се врати.',
      hu: 'Biztosan letiltod ezt a teherautót? Ez a művelet nem vonható vissza.',
      sk: 'Naozaj chcete zakázať toto vozidlo? Túto akciu nie je možné vrátiť späť.',
      sl: 'Ali ste prepričani, da želite onemogočiti ta tovornjak? Tega dejanja ni mogoče razveljaviti.',
      es: '¿Estás seguro de que deseas deshabilitar este camión? Esta acción no se puede deshacer.',
      fi: 'Haluatko varmasti poistaa tämän kuorma-auton käytöstä? Tätä toimintoa ei voi perua.',
    },
  'Email verified': {
    en: 'Email verified',
    bg: 'Имейлът е потвърден',
    de: 'E-Mail verifiziert',
    fr: 'E-mail vérifié',
    ro: 'Email verificat',
    tr: 'E-posta doğrulandı',
    sr: 'Е-пошта је потврђена',
    mk: 'Е-поштата е потврдена',
    hu: 'E-mail megerősítve',
    sk: 'E-mail overený',
    sl: 'E-pošta potrjena',
    es: 'Correo verificado',
    fi: 'Sähköposti vahvistettu',
  },

  'View profile': {
    en: 'Profile overview',
    bg: 'Преглед на профил',
    de: 'Profilübersicht',
    fr: 'Aperçu du profil',
    ro: 'Prezentare profil',
    tr: 'Profil özeti',
    sr: 'Преглед профила',
    mk: 'Преглед на профил',
    hu: 'Profil áttekintése',
    sk: 'Prehľad profilu',
    sl: 'Pregled profila',
    es: 'Resumen del perfil',
    fi: 'Profiilin yleiskatsaus',
  },
  'No unpaid bookings found.': {
    en: 'No unpaid bookings found.',
    bg: 'Не са намерени неплатени резервации.',
    de: 'Keine unbezahlten Buchungen gefunden.',
    fr: 'Aucune réservation impayée trouvée.',
    ro: 'Nu s-au găsit rezervări neplătite.',
    tr: 'Ödenmemiş rezervasyon bulunamadı.',
    sr: 'Није пронађена ниједна неплаћена резервација.',
    mk: 'Не се пронајдени неплатени резервации.',
    hu: 'Nincsenek nem fizetett foglalások.',
    sk: 'Nenašli sa žiadne neplatené rezervácie.',
    sl: 'Ni najdenih neplačanih rezervacij.',
    es: 'No se encontraron reservas impagas.',
    fi: 'Ei löydetty maksamattomia varauksia.',
  },
  'Add Truck': {
    en: 'Add Truck',
    bg: 'Добави камион',
    de: 'LKW hinzufügen',
    fr: 'Ajouter un camion',
    ro: 'Adaugă camion',
    tr: 'Kamyon ekle',
    sr: 'Додај камион',
    mk: 'Додај камион',
    hu: 'Teherautó hozzáadása',
    sk: 'Pridať nákladné vozidlo',
    sl: 'Dodaj tovornjak',
    es: 'Agregar camión',
    fi: 'Lisää kuorma-auto',
  },
  'Edit Truck': {
    en: 'Edit Truck',
    bg: 'Редактирай камион',
    de: 'LKW bearbeiten',
    fr: 'Modifier le camion',
    ro: 'Editează camion',
    tr: 'Kamyonu düzenle',
    sr: 'Измени камион',
    mk: 'Уреди камион',
    hu: 'Teherautó szerkesztése',
    sk: 'Upraviť nákladné vozidlo',
    sl: 'Uredi tovornjak',
    es: 'Editar camión',
    fi: 'Muokkaa kuorma-autoa',
  },
  Make: {
    en: 'Make',
    bg: 'Марка',
    de: 'Marke',
    fr: 'Marque',
    ro: 'Marcă',
    tr: 'Marka',
    sr: 'Марка',
    mk: 'Марка',
    hu: 'Márka',
    sk: 'Značka',
    sl: 'Znamka',
    es: 'Marca',
    fi: 'Merkki',
  },
  Model: {
    en: 'Model',
    bg: 'Модел',
    de: 'Modell',
    fr: 'Modèle',
    ro: 'Model',
    tr: 'Model',
    sr: 'Модел',
    mk: 'Модел',
    hu: 'Modell',
    sk: 'Model',
    sl: 'Model',
    es: 'Modelo',
    fi: 'Malli',
  },
  Year: {
    en: 'Year',
    bg: 'Година',
    de: 'Jahr',
    fr: 'Année',
    ro: 'An',
    tr: 'Yıl',
    sr: 'Година',
    mk: 'Година',
    hu: 'Év',
    sk: 'Rok',
    sl: 'Leto',
    es: 'Año',
    fi: 'Vuosi',
  },
  'License Plate': {
    en: 'License Plate',
    bg: 'Регистрационен номер',
    de: 'Kennzeichen',
    fr: 'Plaque d’immatriculation',
    ro: 'Număr de înmatriculare',
    tr: 'Plaka',
    sr: 'Регистарска таблица',
    mk: 'Регистарска табличка',
    hu: 'Rendszám',
    sk: 'ŠPZ',
    sl: 'Registrska tablica',
    es: 'Matrícula',
    fi: 'Rekisterinumero',
  },

  Documents: {
    en: 'Documents',
    bg: 'Документи',
    de: 'Dokumente',
    fr: 'Documents',
    ro: 'Documente',
    tr: 'Belgeler',
    sr: 'Документи',
    mk: 'Документи',
    hu: 'Dokumentumok',
    sk: 'Dokumenty',
    sl: 'Dokumenti',
    es: 'Documentos',
    fi: 'Asiakirjat',
  },
  'Save the truck first to enable document uploads.': {
    en: 'Save the truck first to enable document uploads.',
    bg: 'Първо запази камиона, за да качиш документи.',
    de: 'Speichern Sie zuerst den LKW, um Dokumente hochzuladen.',
    fr: 'Enregistrez d’abord le camion pour activer le téléchargement de documents.',
    ro: 'Salvați mai întâi camionul pentru a putea încărca documente.',
    tr: 'Belge yüklemeyi etkinleştirmek için önce kamyonu kaydedin.',
    sr: 'Прво сачувај камион да би отпремање докумената било омогућено.',
    mk: 'Прво зачувај го камионот за да можеш да прикачуваш документи.',
    hu: 'Először mentse el a teherautót a dokumentumok feltöltéséhez.',
    sk: 'Najprv uložte vozidlo, aby ste mohli nahrávať dokumenty.',
    sl: 'Najprej shranite tovornjak za omogočanje nalaganja dokumentov.',
    es: 'Guarde primero el camión para habilitar la carga de documentos.',
    fi: 'Tallenna ajoneuvo ensin, jotta asiakirjojen lataus on mahdollista.',
  },
  'Search trucks...': {
    en: 'Search trucks...',
    bg: 'Търси камиони...',
    de: 'LKW suchen...',
    fr: 'Rechercher des camions...',
    ro: 'Caută camioane...',
    tr: 'Kamyon ara...',
    sr: 'Претражи камионе...',
    mk: 'Пребарај камиони...',
    hu: 'Teherautók keresése...',
    sk: 'Hľadať nákladné vozidlá...',
    sl: 'Išči tovornjake...',
    es: 'Buscar camiones...',
    fi: 'Hae kuorma-autoja...',
  },
  'Error loading trucks': {
    en: 'Error loading trucks',
    bg: 'Грешка при зареждане на камионите',
    de: 'Fehler beim Laden der LKW',
    fr: 'Erreur lors du chargement des camions',
    ro: 'Eroare la încărcarea camioanelor',
    tr: 'Kamyonlar yüklenirken hata oluştu',
    sr: 'Грешка при учитавању камиона',
    mk: 'Грешка при вчитување на камионите',
    hu: 'Hiba a teherautók betöltésekor',
    sk: 'Chyba pri načítaní nákladných vozidiel',
    sl: 'Napaka pri nalaganju tovornjakov',
    es: 'Error al cargar los camiones',
    fi: 'Virhe kuorma-autojen lataamisessa',
  },
  'No trucks found.': {
    en: 'No trucks found.',
    bg: 'Няма намерени камиони.',
    de: 'Keine LKW gefunden.',
    fr: 'Aucun camion trouvé.',
    ro: 'Nu au fost găsite camioane.',
    tr: 'Kamyon bulunamadı.',
    sr: 'Није пронађен ниједан камион.',
    mk: 'Не се пронајдени камиони.',
    hu: 'Nem található teherautó.',
    sk: 'Nenašli sa žiadne nákladné vozidlá.',
    sl: 'Ni najdenih tovornjakov.',
    es: 'No se encontraron camiones.',
    fi: 'Kuorma-autoja ei löytynyt.',
  },
  'No trucks found for your search.': {
    en: 'No trucks found for your search.',
    bg: 'Няма камиони, отговарящи на търсенето.',
    de: 'Keine LKW für Ihre Suche gefunden.',
    fr: 'Aucun camion ne correspond à votre recherche.',
    ro: 'Nu s-au găsit camioane pentru căutarea dvs.',
    tr: 'Aramanız için kamyon bulunamadı.',
    sr: 'Нема камиона који одговарају претрази.',
    mk: 'Нема камиони што одговараат на пребарувањето.',
    hu: 'A keresésnek megfelelő teherautó nem található.',
    sk: 'Pre vaše vyhľadávanie sa nenašli žiadne nákladné vozidlá.',
    sl: 'Za vaše iskanje ni bilo najdenih tovornjakov.',
    es: 'No se encontraron camiones para su búsqueda.',
    fi: 'Hakuasi vastaavia kuorma-autoja ei löytynyt.',
  },
  'Pending approval': {
    en: 'Pending approval',
    bg: 'Чака одобрение',
    de: 'Ausstehende Genehmigung',
    fr: 'En attente d’approbation',
    ro: 'În așteptarea aprobării',
    tr: 'Onay bekliyor',
    sr: 'Чека одобрење',
    mk: 'Чека одобрување',
    hu: 'Jóváhagyásra vár',
    sk: 'Čaká na schválenie',
    sl: 'Čaka na odobritev',
    es: 'Pendiente de aprobación',
    fi: 'Odottaa hyväksyntää',
  },
  Plate: {
    en: 'Plate',
    bg: 'Рег. номер',
    de: 'Kennzeichen',
    fr: 'Plaque',
    ro: 'Număr',
    tr: 'Plaka',
    sr: 'Рег. број',
    mk: 'Рег. број',
    hu: 'Rendszám',
    sk: 'ŠPZ',
    sl: 'Registrska tablica',
    es: 'Matrícula',
    fi: 'Rekisterinumero',
  },
  Edit: {
    en: 'Edit',
    bg: 'Редактирай',
    de: 'Bearbeiten',
    fr: 'Modifier',
    ro: 'Editează',
    tr: 'Düzenle',
    sr: 'Измени',
    mk: 'Уреди',
    hu: 'Szerkesztés',
    sk: 'Upraviť',
    sl: 'Uredi',
    es: 'Editar',
    fi: 'Muokkaa',
  },
  Delete: {
    en: 'Delete',
    bg: 'Изтрий',
    de: 'Löschen',
    fr: 'Supprimer',
    ro: 'Șterge',
    tr: 'Sil',
    sr: 'Обриши',
    mk: 'Избриши',
    hu: 'Törlés',
    sk: 'Vymazať',
    sl: 'Izbriši',
    es: 'Eliminar',
    fi: 'Poista',
  },
  'Truck updated.': {
    en: 'Truck updated.',
    bg: 'Камионът е обновен.',
    de: 'LKW aktualisiert.',
    fr: 'Camion mis à jour.',
    ro: 'Camion actualizat.',
    tr: 'Kamyon güncellendi.',
    sr: 'Камион је ажуриран.',
    mk: 'Камионот е ажуриран.',
    hu: 'A teherautó frissítve.',
    sk: 'Nákladné auto aktualizované.',
    sl: 'Tovornjak posodobljen.',
    es: 'Camión actualizado.',
    fi: 'Kuorma-auto päivitetty.',
  },
  'The truck has been successfully updated.': {
    en: 'The truck has been successfully updated.',
    bg: 'Камионът беше успешно обновен.',
    de: 'Der LKW wurde erfolgreich aktualisiert.',
    fr: 'Le camion a été mis à jour avec succès.',
    ro: 'Camionul a fost actualizat cu succes.',
    tr: 'Kamyon başarıyla güncellendi.',
    sr: 'Камион је успешно ажуриран.',
    mk: 'Камионот е успешно ажуриран.',
    hu: 'A teherautó sikeresen frissítve.',
    sk: 'Nákladné auto bolo úspešne aktualizované.',
    sl: 'Tovornjak je bil uspešno posodobljen.',
    es: 'El camión se actualizó correctamente.',
    fi: 'Kuorma-auto päivitettiin onnistuneesti.',
  },
  'Truck added.': {
    en: 'Truck added.',
    bg: 'Камионът е добавен.',
    de: 'LKW hinzugefügt.',
    fr: 'Camion ajouté.',
    ro: 'Camion adăugat.',
    tr: 'Kamyon eklendi.',
    sr: 'Камион је додат.',
    mk: 'Камионот е додаден.',
    hu: 'Teherautó hozzáadva.',
    sk: 'Nákladné auto pridané.',
    sl: 'Tovornjak dodan.',
    es: 'Camión añadido.',
    fi: 'Kuorma-auto lisätty.',
  },
  'The new truck has been successfully added.': {
    en: 'The new truck has been successfully added.',
    bg: 'Новият камион беше успешно добавен.',
    de: 'Der neue LKW wurde erfolgreich hinzugefügt.',
    fr: 'Le nouveau camion a été ajouté avec succès.',
    ro: 'Noul camion a fost adăugat cu succes.',
    tr: 'Yeni kamyon başarıyla eklendi.',
    sr: 'Нови камион је успешно додат.',
    mk: 'Новиот камион е успешно додаден.',
    hu: 'Az új teherautó sikeresen hozzáadva.',
    sk: 'Nové nákladné auto bolo úspešne pridané.',
    sl: 'Novi tovornjak je bil uspešno dodan.',
    es: 'El nuevo camión se añadió correctamente.',
    fi: 'Uusi kuorma-auto lisättiin onnistuneesti.',
  },
  'Truck deleted.': {
    en: 'Truck deleted.',
    bg: 'Камионът е изтрит.',
    de: 'LKW gelöscht.',
    fr: 'Camion supprimé.',
    ro: 'Camion șters.',
    tr: 'Kamyon silindi.',
    sr: 'Камион је обрисан.',
    mk: 'Камионот е избришан.',
    hu: 'Teherautó törölve.',
    sk: 'Nákladné auto vymazané.',
    sl: 'Tovornjak izbrisan.',
    es: 'Camión eliminado.',
    fi: 'Kuorma-auto poistettu.',
  },
  'Delete Truck': {
    en: 'Delete Truck',
    bg: 'Изтрий камион',
    de: 'LKW löschen',
    fr: 'Supprimer le camion',
    ro: 'Șterge camion',
    tr: 'Kamyonu sil',
    sr: 'Обриши камион',
    mk: 'Избриши камион',
    hu: 'Teherautó törlése',
    sk: 'Vymazať nákladné auto',
    sl: 'Izbriši tovornjak',
    es: 'Eliminar camión',
    fi: 'Poista kuorma-auto',
  },
  'Delete Driver': {
    en: 'Delete Driver',
    bg: 'Изтрий шофьор',
    de: 'Fahrer löschen',
    fr: 'Supprimer le chauffeur',
    ro: 'Șterge șofer',
    tr: 'Sürücüyü sil',
    sr: 'Обриши возача',
    mk: 'Избриши возач',
    hu: 'Sofőr törlése',
    sk: 'Vymazať vodiča',
    sl: 'Izbriši voznika',
    es: 'Eliminar conductor',
    fi: 'Poista kuljettaja',
  },
  'Delete Trailer': {
    en: 'Delete Trailer',
    bg: 'Изтрий ремарке',
    de: 'Anhänger löschen',
    fr: 'Supprimer la remorque',
    ro: 'Șterge remorcă',
    tr: 'Römorku sil',
    sr: 'Обриши приколицу',
    mk: 'Избриши приколка',
    hu: 'Pótkocsi törlése',
    sk: 'Vymazať príves',
    sl: 'Izbriši prikolico',
    es: 'Eliminar remolque',
    fi: 'Poista perävaunu',
  },
  "Are you sure? You can't undo this action afterwards.": {
    en: "Are you sure? You can't undo this action afterwards.",
    bg: 'Сигурни ли сте? Това действие не може да бъде отменено.',
    de: 'Sind Sie sicher? Diese Aktion kann nicht rückgängig gemacht werden.',
    fr: 'Êtes-vous sûr ? Cette action est irréversible.',
    ro: 'Sigur? Această acțiune nu poate fi anulată.',
    tr: 'Emin misiniz? Bu işlem geri alınamaz.',
    sr: 'Да ли сте сигурни? Ова радња се не може поништити.',
    mk: 'Дали сте сигурни? Оваа акција не може да се врати.',
    hu: 'Biztos benne? Ez a művelet nem vonható vissza.',
    sk: 'Ste si istý? Túto akciu nemožno vrátiť späť.',
    sl: 'Ste prepričani? Dejanja ni mogoče razveljaviti.',
    es: '¿Está seguro? Esta acción no se puede deshacer.',
    fi: 'Oletko varma? Tätä toimintoa ei voi perua.',
  },
  'The truck has been successfully deleted.': {
    en: 'The truck has been successfully deleted.',
    bg: 'Камионът беше успешно изтрит.',
    de: 'Der LKW wurde erfolgreich gelöscht.',
    fr: 'Le camion a été supprimé avec succès.',
    ro: 'Camionul a fost șters cu succes.',
    tr: 'Kamyon başarıyla silindi.',
    sr: 'Камион је успешно обрисан.',
    mk: 'Камионот е успешно избришан.',
    hu: 'A teherautó sikeresen törölve.',
    sk: 'Nákladné auto bolo úspešne vymazané.',
    sl: 'Tovornjak je bil uspešno izbrisan.',
    es: 'El camión se eliminó correctamente.',
    fi: 'Kuorma-auto poistettiin onnistuneesti.',
  },
  'Search drivers...': {
    en: 'Search drivers...',
    bg: 'Търсене на шофьори...',
    de: 'Fahrer suchen...',
    fr: 'Rechercher des chauffeurs...',
    ro: 'Caută șoferi...',
    tr: 'Sürücü ara...',
    sr: 'Претрага возача...',
    mk: 'Пребарување возачи...',
    hu: 'Sofőrök keresése...',
    sk: 'Vyhľadávanie vodičov...',
    sl: 'Iskanje voznikov...',
    es: 'Buscar conductores...',
    fi: 'Hae kuljettajia...',
  },
  'Add driver': {
    en: 'Add driver',
    bg: 'Добави шофьор',
    de: 'Fahrer hinzufügen',
    fr: 'Ajouter un chauffeur',
    ro: 'Adaugă șofer',
    tr: 'Sürücü ekle',
    sr: 'Додај возача',
    mk: 'Додај возач',
    hu: 'Sofőr hozzáadása',
    sk: 'Pridať vodiča',
    sl: 'Dodaj voznika',
    es: 'Agregar conductor',
    fi: 'Lisää kuljettaja',
  },
  'Error loading drivers': {
    en: 'Error loading drivers',
    bg: 'Грешка при зареждане на шофьорите',
    de: 'Fehler beim Laden der Fahrer',
    fr: 'Erreur lors du chargement des chauffeurs',
    ro: 'Eroare la încărcarea șoferilor',
    tr: 'Sürücüler yüklenirken hata oluştu',
    sr: 'Грешка при учитавању возача',
    mk: 'Грешка при вчитување на возачите',
    hu: 'Hiba a sofőrök betöltésekor',
    sk: 'Chyba pri načítaní vodičov',
    sl: 'Napaka pri nalaganju voznikov',
    es: 'Error al cargar los conductores',
    fi: 'Virhe kuljettajien lataamisessa',
  },
  'No drivers found.': {
    en: 'No drivers found.',
    bg: 'Няма намерени шофьори.',
    de: 'Keine Fahrer gefunden.',
    fr: 'Aucun chauffeur trouvé.',
    ro: 'Nu au fost găsiți șoferi.',
    tr: 'Sürücü bulunamadı.',
    sr: 'Нису пронађени возачи.',
    mk: 'Не се пронајдени возачи.',
    hu: 'Nem találhatók sofőrök.',
    sk: 'Nenašli sa žiadni vodiči.',
    sl: 'Ni najdenih voznikov.',
    es: 'No se encontraron conductores.',
    fi: 'Kuljettajia ei löytynyt.',
  },
  'No drivers found for your search.': {
    en: 'No drivers found for your search.',
    bg: 'Няма намерени шофьори за вашето търсене.',
    de: 'Keine Fahrer für Ihre Suche gefunden.',
    fr: 'Aucun chauffeur trouvé pour votre recherche.',
    ro: 'Nu au fost găsiți șoferi pentru căutarea dvs.',
    tr: 'Aramanız için sürücü bulunamadı.',
    sr: 'Нису пронађени возачи за вашу претрагу.',
    mk: 'Не се пронајдени возачи за вашето пребарување.',
    hu: 'A kereséshez nem találhatók sofőrök.',
    sk: 'Pre vaše vyhľadávanie sa nenašli žiadni vodiči.',
    sl: 'Za vaše iskanje ni bilo najdenih voznikov.',
    es: 'No se encontraron conductores para tu búsqueda.',
    fi: 'Hakuehdoilla ei löytynyt kuljettajia.',
  },
  'Edit driver': {
    en: 'Edit driver',
    bg: 'Редактирай шофьор',
    de: 'Fahrer bearbeiten',
    fr: 'Modifier le chauffeur',
    ro: 'Editează șofer',
    tr: 'Sürücüyü düzenle',
    sr: 'Измени возача',
    mk: 'Уреди возач',
    hu: 'Sofőr szerkesztése',
    sk: 'Upraviť vodiča',
    sl: 'Uredi voznika',
    es: 'Editar conductor',
    fi: 'Muokkaa kuljettajaa',
  },

  'First Name': {
    en: 'First Name',
    bg: 'Име',
    de: 'Vorname',
    fr: 'Prénom',
    ro: 'Prenume',
    tr: 'Ad',
    sr: 'Име',
    mk: 'Име',
    hu: 'Keresztnév',
    sk: 'Meno',
    sl: 'Ime',
    es: 'Nombre',
    fi: 'Etunimi',
  },

  'Last Name': {
    en: 'Last Name',
    bg: 'Фамилия',
    de: 'Nachname',
    fr: 'Nom de famille',
    ro: 'Nume',
    tr: 'Soyad',
    sr: 'Презиме',
    mk: 'Презиме',
    hu: 'Vezetéknév',
    sk: 'Priezvisko',
    sl: 'Priimek',
    es: 'Apellido',
    fi: 'Sukunimi',
  },

  'License ID': {
    en: 'License ID',
    bg: 'Номер на книжка',
    de: 'Führerscheinnummer',
    fr: 'Numéro de permis',
    ro: 'ID permis',
    tr: 'Ehliyet numarası',
    sr: 'Број дозволе',
    mk: 'Број на дозвола',
    hu: 'Jogosítvány száma',
    sk: 'Číslo vodičského preukazu',
    sl: 'Številka vozniškega dovoljenja',
    es: 'Número de licencia',
    fi: 'Ajokortin numero',
  },

  'License Date of Issue': {
    en: 'License Date of Issue',
    bg: 'Дата на издаване на книжката',
    de: 'Ausstellungsdatum des Führerscheins',
    fr: 'Date de délivrance du permis',
    ro: 'Data emiterii permisului',
    tr: 'Ehliyet veriliş tarihi',
    sr: 'Датум издавања дозволе',
    mk: 'Датум на издавање на дозволата',
    hu: 'Jogosítvány kiállításának dátuma',
    sk: 'Dátum vydania vodičského preukazu',
    sl: 'Datum izdaje vozniškega dovoljenja',
    es: 'Fecha de expedición de la licencia',
    fi: 'Ajokortin myöntämispäivä',
  },

  'License Date of Expiration': {
    en: 'License Date of Expiration',
    bg: 'Дата на валидност на книжката',
    de: 'Ablaufdatum des Führerscheins',
    fr: 'Date d’expiration du permis',
    ro: 'Data expirării permisului',
    tr: 'Ehliyet bitiş tarihi',
    sr: 'Датум истека дозволе',
    mk: 'Датум на истек на дозволата',
    hu: 'Jogosítvány lejárati dátuma',
    sk: 'Dátum platnosti vodičského preukazu',
    sl: 'Datum poteka vozniškega dovoljenja',
    es: 'Fecha de vencimiento de la licencia',
    fi: 'Ajokortin voimassaolon päättymispäivä',
  },
  'No phone': {
    en: 'No phone',
    bg: 'Няма телефон',
    de: 'Keine Telefonnummer',
    fr: 'Pas de téléphone',
    ro: 'Fără telefon',
    tr: 'Telefon yok',
    sr: 'Нема телефона',
    mk: 'Нема телефон',
    hu: 'Nincs telefonszám',
    sk: 'Žiadny telefón',
    sl: 'Ni telefona',
    es: 'Sin teléfono',
    fi: 'Ei puhelinta',
  },

  'No email': {
    en: 'No email',
    bg: 'Няма имейл',
    de: 'Keine E-Mail',
    fr: 'Pas d’e-mail',
    ro: 'Fără email',
    tr: 'E-posta yok',
    sr: 'Нема е-поште',
    mk: 'Нема е-пошта',
    hu: 'Nincs e-mail',
    sk: 'Žiadny e-mail',
    sl: 'Ni e-pošte',
    es: 'Sin correo',
    fi: 'Ei sähköpostia',
  },

  'No license': {
    en: 'No license',
    bg: 'Няма книжка',
    de: 'Kein Führerschein',
    fr: 'Pas de permis',
    ro: 'Fără permis',
    tr: 'Ehliyet yok',
    sr: 'Нема дозволе',
    mk: 'Нема дозвола',
    hu: 'Nincs jogosítvány',
    sk: 'Žiadny vodičský preukaz',
    sl: 'Ni vozniškega dovoljenja',
    es: 'Sin licencia',
    fi: 'Ei ajokorttia',
  },

  Issue: {
    en: 'Issue',
    bg: 'Издаване',
    de: 'Ausgestellt',
    fr: 'Délivrance',
    ro: 'Emitere',
    tr: 'Veriliş',
    sr: 'Издавање',
    mk: 'Издавање',
    hu: 'Kiadás',
    sk: 'Vydanie',
    sl: 'Izdaja',
    es: 'Emisión',
    fi: 'Myöntäminen',
  },
  Expiry: {
    en: 'Expiry',
    bg: 'Валидност',
    de: 'Ablauf',
    fr: 'Expiration',
    ro: 'Expirare',
    tr: 'Bitiş',
    sr: 'Истек',
    mk: 'Истек',
    hu: 'Lejárat',
    sk: 'Platnosť',
    sl: 'Potek',
    es: 'Vencimiento',
    fi: 'Päättyminen',
  },
  'Sign in': {
    en: 'Sign in',
    bg: 'Вход',
    de: 'Anmelden',
    fr: 'Se connecter',
    ro: 'Autentificare',
    tr: 'Giriş yap',
    sr: 'Пријава',
    mk: 'Најава',
    hu: 'Bejelentkezés',
    sk: 'Prihlásiť sa',
    sl: 'Prijava',
    es: 'Iniciar sesión',
    fi: 'Kirjaudu sisään',
  },
  'Sign up': {
    en: 'Sign up',
    bg: 'Регистрация',
    de: 'Registrieren',
    fr: "S'inscrire",
    ro: 'Înregistrare',
    tr: 'Kayıt ol',
    sr: 'Регистрација',
    mk: 'Регистрација',
    hu: 'Regisztráció',
    sk: 'Registrovať sa',
    sl: 'Registracija',
    es: 'Registrarse',
    fi: 'Rekisteröidy',
  },
  'Enter your email and password to sign in!': {
    en: 'Enter your email and password to sign in!',
    bg: 'Въведете имейла и паролата си, за да влезете!',
    de: 'Geben Sie Ihre E-Mail und Ihr Passwort ein, um sich anzumelden!',
    fr: 'Entrez votre email et mot de passe pour vous connecter !',
    ro: 'Introduceți emailul și parola pentru a vă autentifica!',
    tr: 'Giriş yapmak için e-posta ve şifrenizi girin!',
    sr: 'Унесите имејл и лозинку да бисте се пријавили!',
    mk: 'Внесете ја вашата е-пошта и лозинка за најава!',
    hu: 'Adja meg e-mail címét és jelszavát a bejelentkezéshez!',
    sk: 'Zadajte e-mail a heslo pre prihlásenie!',
    sl: 'Vnesite e-pošto in geslo za prijavo!',
    es: 'Introduce tu correo y contraseña para iniciar sesión!',
    fi: 'Anna sähköpostiosoite ja salasana kirjautuaksesi sisään!',
  },
  'Enter your email, create a password, and choose a role to register.': {
    en: 'Enter your email, create a password, and choose a role to register.',
    bg: 'Въведете имейл, създайте парола и изберете роля за регистрация.',
    de: 'Geben Sie Ihre E-Mail ein, erstellen Sie ein Passwort und wählen Sie eine Rolle.',
    fr: 'Entrez votre email, créez un mot de passe et choisissez un rôle.',
    ro: 'Introduceți emailul, creați o parolă și alegeți un rol.',
    tr: 'E-posta girin, şifre oluşturun ve bir rol seçin.',
    sr: 'Унесите имејл, направите лозинку и изаберите улогу.',
    mk: 'Внесете е-пошта, креирајте лозинка и изберете улога.',
    hu: 'Adja meg e-mail címét, hozzon létre jelszót és válasszon szerepet.',
    sk: 'Zadajte e-mail, vytvorte heslo a vyberte rolu.',
    sl: 'Vnesite e-pošto, ustvarite geslo in izberite vlogo.',
    es: 'Introduce tu correo, crea una contraseña y elige un rol.',
    fi: 'Syötä sähköposti, luo salasana ja valitse rooli.',
  },
  'Login Failed': {
    en: 'Login Failed',
    bg: 'Неуспешен вход',
    de: 'Anmeldung fehlgeschlagen',
    fr: 'Échec de la connexion',
    ro: 'Autentificare eșuată',
    tr: 'Giriş başarısız',
    sr: 'Неуспешна пријава',
    mk: 'Неуспешна најава',
    hu: 'Sikertelen bejelentkezés',
    sk: 'Prihlásenie zlyhalo',
    sl: 'Prijava ni uspela',
    es: 'Error de inicio de sesión',
    fi: 'Kirjautuminen epäonnistui',
  },
  'Verification Email Sent': {
    en: 'Verification Email Sent',
    bg: 'Изпратен имейл за потвърждение',
    de: 'Bestätigungs-E-Mail gesendet',
    fr: 'Email de vérification envoyé',
    ro: 'Email de verificare trimis',
    tr: 'Doğrulama e-postası gönderildi',
    sr: 'Послат имејл за верификацију',
    mk: 'Испратен е-пошта за верификација',
    hu: 'Megerősítő email elküldve',
    sk: 'Overovací e-mail odoslaný',
    sl: 'Potrditveno e-poštno sporočilo poslano',
    es: 'Correo de verificación enviado',
    fi: 'Vahvistussähköposti lähetetty',
  },
  'Sign-up failed': {
    en: 'Sign-up failed',
    bg: 'Регистрацията не бе успешна',
    de: 'Registrierung fehlgeschlagen',
    fr: "Échec de l'inscription",
    ro: 'Înregistrare eșuată',
    tr: 'Kayıt başarısız',
    sr: 'Регистрација није успела',
    mk: 'Регистрацијата не успеа',
    hu: 'Regisztráció sikertelen',
    sk: 'Registrácia zlyhala',
    sl: 'Registracija ni uspela',
    es: 'Registro fallido',
    fi: 'Rekisteröinti epäonnistui',
  },
  'Please select a valid role': {
    en: 'Please select a valid role',
    bg: 'Моля, изберете валидна роля',
    de: 'Bitte wählen Sie eine gültige Rolle',
    fr: 'Veuillez sélectionner un rôle valide',
    ro: 'Vă rugăm să selectați un rol valid',
    tr: 'Lütfen geçerli bir rol seçin',
    sr: 'Молимо изаберите важећу улогу',
    mk: 'Ве молиме изберете валидна улога',
    hu: 'Kérjük válasszon érvényes szerepet',
    sk: 'Vyberte platnú rolu',
    sl: 'Izberite veljavno vlogo',
    es: 'Seleccione un rol válido',
    fi: 'Valitse kelvollinen rooli',
  },
  'Passwords do not match': {
    en: 'Passwords do not match',
    bg: 'Паролите не съвпадат',
    de: 'Passwörter stimmen nicht überein',
    fr: 'Les mots de passe ne correspondent pas',
    ro: 'Parolele nu coincid',
    tr: 'Şifreler eşleşmiyor',
    sr: 'Лозинке се не поклапају',
    mk: 'Лозинките не се совпаѓаат',
    hu: 'A jelszavak nem egyeznek',
    sk: 'Heslá sa nezhodujú',
    sl: 'Gesli se ne ujemata',
    es: 'Las contraseñas no coinciden',
    fi: 'Salasanat eivät täsmää',
  },
  'Sign In': {
    en: 'Sign In',
    bg: 'Вход',
    de: 'Anmelden',
    fr: 'Connexion',
    ro: 'Autentificare',
    tr: 'Giriş Yap',
    sr: 'Пријави се',
    mk: 'Најави се',
    hu: 'Bejelentkezés',
    sk: 'Prihlásiť sa',
    sl: 'Prijava',
    es: 'Iniciar sesión',
    fi: 'Kirjaudu',
  },
  'Create Account': {
    en: 'Create Account',
    bg: 'Създай акаунт',
    de: 'Konto erstellen',
    fr: 'Créer un compte',
    ro: 'Creează cont',
    tr: 'Hesap oluştur',
    sr: 'Креирај налог',
    mk: 'Креирај сметка',
    hu: 'Fiók létrehozása',
    sk: 'Vytvoriť účet',
    sl: 'Ustvari račun',
    es: 'Crear cuenta',
    fi: 'Luo tili',
  },
  'I want to register as a': {
    en: 'I want to register as a',
    bg: 'Искам да се регистрирам като',
    de: 'Ich möchte mich registrieren als',
    fr: "Je souhaite m'inscrire en tant que",
    ro: 'Vreau să mă înregistrez ca',
    tr: 'Şu olarak kayıt olmak istiyorum',
    sr: 'Желим да се региструјем као',
    mk: 'Сакам да се регистрирам како',
    hu: 'Szeretnék regisztrálni mint',
    sk: 'Chcem sa zaregistrovať ako',
    sl: 'Želim se registrirati kot',
    es: 'Quiero registrarme como',
    fi: 'Haluan rekisteröityä rooliin',
  },

  Username: {
    en: 'Username',
    bg: 'Потребителско име',
    de: 'Benutzername',
    fr: "Nom d'utilisateur",
    ro: 'Nume utilizator',
    tr: 'Kullanıcı adı',
    sr: 'Корисничко име',
    mk: 'Корисничко име',
    hu: 'Felhasználónév',
    sk: 'Používateľské meno',
    sl: 'Uporabniško ime',
    es: 'Nombre de usuario',
    fi: 'Käyttäjänimi',
  },
  'Your name': {
    en: 'Your name',
    bg: 'Вашето име',
    de: 'Ihr Name',
    fr: 'Votre nom',
    ro: 'Numele tău',
    tr: 'Adınız',
    sr: 'Ваше име',
    mk: 'Вашето име',
    hu: 'Az Ön neve',
    sk: 'Vaše meno',
    sl: 'Vaše ime',
    es: 'Tu nombre',
    fi: 'Nimesi',
  },
  'Username is required.': {
    en: 'Username is required.',
    bg: 'Потребителското име е задължително.',
    de: 'Benutzername ist erforderlich.',
    fr: "Le nom d'utilisateur est requis.",
    ro: 'Numele de utilizator este obligatoriu.',
    tr: 'Kullanıcı adı zorunludur.',
    sr: 'Корисничко име је обавезно.',
    mk: 'Корисничкото име е задолжително.',
    hu: 'A felhasználónév kötelező.',
    sk: 'Používateľské meno je povinné.',
    sl: 'Uporabniško ime je obvezno.',
    es: 'El nombre de usuario es obligatorio.',
    fi: 'Käyttäjänimi on pakollinen.',
  },
  'Email is required.': {
    en: 'Email is required.',
    bg: 'Имейлът е задължителен.',
    de: 'E-Mail ist erforderlich.',
    fr: "L'email est requis.",
    ro: 'Emailul este obligatoriu.',
    tr: 'E-posta zorunludur.',
    sr: 'Имејл је обавезан.',
    mk: 'Е-поштата е задолжителна.',
    hu: 'Az email kötelező.',
    sk: 'Email je povinný.',
    sl: 'E-pošta je obvezna.',
    es: 'El correo electrónico es obligatorio.',
    fi: 'Sähköposti on pakollinen.',
  },
  'Invalid email format.': {
    en: 'Invalid email format.',
    bg: 'Невалиден имейл формат.',
    de: 'Ungültiges E-Mail-Format.',
    fr: "Format d'email invalide.",
    ro: 'Format email invalid.',
    tr: 'Geçersiz e-posta formatı.',
    sr: 'Неисправан формат имејла.',
    mk: 'Невалиден формат на е-пошта.',
    hu: 'Érvénytelen email formátum.',
    sk: 'Neplatný formát emailu.',
    sl: 'Neveljaven format e-pošte.',
    es: 'Formato de correo inválido.',
    fi: 'Virheellinen sähköpostimuoto.',
  },
  Password: {
    en: 'Password',
    bg: 'Парола',
    de: 'Passwort',
    fr: 'Mot de passe',
    ro: 'Parolă',
    tr: 'Şifre',
    sr: 'Лозинка',
    mk: 'Лозинка',
    hu: 'Jelszó',
    sk: 'Heslo',
    sl: 'Geslo',
    es: 'Contraseña',
    fi: 'Salasana',
  },
  'Password is required.': {
    en: 'Password is required.',
    bg: 'Паролата е задължителна.',
    de: 'Passwort ist erforderlich.',
    fr: 'Le mot de passe est requis.',
    ro: 'Parola este obligatorie.',
    tr: 'Şifre zorunludur.',
    sr: 'Лозинка је обавезна.',
    mk: 'Лозинката е задолжителна.',
    hu: 'A jelszó kötelező.',
    sk: 'Heslo je povinné.',
    sl: 'Geslo je obvezno.',
    es: 'La contraseña es obligatoria.',
    fi: 'Salasana on pakollinen.',
  },
  'Confirm password': {
    en: 'Confirm password',
    bg: 'Потвърди парола',
    de: 'Passwort bestätigen',
    fr: 'Confirmer le mot de passe',
    ro: 'Confirmă parola',
    tr: 'Şifreyi onayla',
    sr: 'Потврди лозинку',
    mk: 'Потврди лозинка',
    hu: 'Jelszó megerősítése',
    sk: 'Potvrdiť heslo',
    sl: 'Potrdi geslo',
    es: 'Confirmar contraseña',
    fi: 'Vahvista salasana',
  },
  'Confirm password is required.': {
    en: 'Confirm password is required.',
    bg: 'Потвърждението на паролата е задължително.',
    de: 'Passwortbestätigung ist erforderlich.',
    fr: 'La confirmation du mot de passe est requise.',
    ro: 'Confirmarea parolei este obligatorie.',
    tr: 'Şifre onayı zorunludur.',
    sr: 'Потврда лозинке је обавезна.',
    mk: 'Потврдата на лозинка е задолжителна.',
    hu: 'A jelszó megerősítése kötelező.',
    sk: 'Potvrdenie hesla je povinné.',
    sl: 'Potrditev gesla je obvezna.',
    es: 'La confirmación de contraseña es obligatoria.',
    fi: 'Salasanan vahvistus on pakollinen.',
  },

  'Passwords do not match.': {
    en: 'Passwords do not match.',
    bg: 'Паролите не съвпадат.',
    de: 'Passwörter stimmen nicht überein.',
    fr: 'Les mots de passe ne correspondent pas.',
    ro: 'Parolele nu coincid.',
    tr: 'Şifreler eşleşmiyor.',
    sr: 'Лозинке се не поклапају.',
    mk: 'Лозинките не се совпаѓаат.',
    hu: 'A jelszavak nem egyeznek.',
    sk: 'Heslá sa nezhodujú.',
    sl: 'Gesli se ne ujemata.',
    es: 'Las contraseñas no coinciden.',
    fi: 'Salasanat eivät täsmää.',
  },

  'Forgot password?': {
    en: 'Forgot password?',
    bg: 'Забравена парола?',
    de: 'Passwort vergessen?',
    fr: 'Mot de passe oublié ?',
    ro: 'Ai uitat parola?',
    tr: 'Şifreni mi unuttun?',
    sr: 'Заборављена лозинка?',
    mk: 'Заборавена лозинка?',
    hu: 'Elfelejtett jelszó?',
    sk: 'Zabudnuté heslo?',
    sl: 'Ste pozabili geslo?',
    es: '¿Olvidaste tu contraseña?',
    fi: 'Unohditko salasanan?',
  },

  'Min. 8 characters': {
    en: 'Min. 8 characters',
    bg: 'Мин. 8 символа',
    de: 'Min. 8 Zeichen',
    fr: 'Min. 8 caractères',
    ro: 'Min. 8 caractere',
    tr: 'En az 8 karakter',
    sr: 'Мин. 8 карактера',
    mk: 'Мин. 8 карактери',
    hu: 'Min. 8 karakter',
    sk: 'Min. 8 znakov',
    sl: 'Min. 8 znakov',
    es: 'Mín. 8 caracteres',
    fi: 'Väh. 8 merkkiä',
  },

  'Order transportation in the automotive branch.': {
    en: 'Order transportation in the automotive branch.',
    bg: 'Поръчайте транспорт в автомобилния бранш.',
    de: 'Transport im Automobilbereich bestellen.',
    fr: 'Commander un transport dans le secteur automobile.',
    ro: 'Comandă transport în domeniul auto.',
    tr: 'Otomotiv sektöründe taşımacılık sipariş edin.',
    sr: 'Наручите транспорт у аутомобилској индустрији.',
    mk: 'Нарачај транспорт во автомобилската индустрија.',
    hu: 'Szállítás rendelése az autóiparban.',
    sk: 'Objednajte dopravu v automobilovom sektore.',
    sl: 'Naročite prevoz v avtomobilski panogi.',
    es: 'Solicita transporte en el sector automotriz.',
    fi: 'Tilaa kuljetus autoteollisuuden alalla.',
  },

  'Join our network of transport partners.': {
    en: 'Join our network of transport partners.',
    bg: 'Присъединете се към нашата мрежа от транспортни партньори.',
    de: 'Treten Sie unserem Netzwerk von Transportpartnern bei.',
    fr: 'Rejoignez notre réseau de partenaires de transport.',
    ro: 'Alătură-te rețelei noastre de parteneri de transport.',
    tr: 'Taşımacılık ortakları ağımıza katılın.',
    sr: 'Придружите се нашој мрежи транспортних партнера.',
    mk: 'Приклучи се на нашата мрежа на транспортни партнери.',
    hu: 'Csatlakozzon szállítmányozási partnereink hálózatához.',
    sk: 'Pripojte sa k našej sieti dopravných partnerov.',
    sl: 'Pridružite se naši mreži transportnih partnerjev.',
    es: 'Únete a nuestra red de socios de transporte.',
    fi: 'Liity kuljetuskumppaneidemme verkostoon.',
  },

  'Sign Up': {
    en: 'Sign Up',
    bg: 'Регистрация',
    de: 'Registrieren',
    fr: 'Inscription',
    ro: 'Înregistrare',
    tr: 'Kayıt Ol',
    sr: 'Регистрација',
    mk: 'Регистрација',
    hu: 'Regisztráció',
    sk: 'Registrácia',
    sl: 'Registracija',
    es: 'Registrarse',
    fi: 'Rekisteröidy',
  },
  'Driver with this phone number already exists.': {
    en: 'Driver with this phone number already exists.',
    bg: 'Шофьор с този телефон вече съществува.',
    de: 'Ein Fahrer mit dieser Telefonnummer existiert bereits.',
    fr: 'Un chauffeur avec ce numéro de téléphone existe déjà.',
    ro: 'Un șofer cu acest număr de telefon există deja.',
    tr: 'Bu telefon numarasıyla bir sürücü zaten var.',
    sr: 'Возач са овим бројем телефона већ postoji.',
    mk: 'Возач со овој телефонски број веќе постои.',
    hu: 'Ezzel a telefonszámmal rendelkező sofőr már létezik.',
    sk: 'Řidič s tímto telefonním číslem již existuje.',
    sl: 'Voznik s tem telefonskim številom že obstaja.',
    es: 'Ya existe un conductor con este número de teléfono.',
    fi: 'Tällä puhelinnumerolla on jo kuljettaja.',
  },
  'First name is required': {
    en: 'First name is required.',
    bg: 'Името е задължително.',
    de: 'Vorname ist erforderlich.',
    fr: 'Le prénom est requis.',
    ro: 'Prenumele este obligatoriu.',
    tr: 'Ad gerekli.',
    sr: 'Име је обавезно.',
    mk: 'Името е задолжително.',
    hu: 'Keresztnév megadása kötelező.',
    sk: 'Jméno je povinné.',
    sl: 'Ime je obvezno.',
    es: 'El nombre es obligatorio.',
    fi: 'Etunimi on pakollinen.',
  },
  'Last name is required': {
    en: 'Last name is required.',
    bg: 'Фамилията е задължителна.',
    de: 'Nachname ist erforderlich.',
    fr: 'Le nom de famille est requis.',
    ro: 'Numele este obligatoriu.',
    tr: 'Soyad gerekli.',
    sr: 'Презиме је обавезно.',
    mk: 'Презимето е задолжително.',
    hu: 'Vezetéknév megadása kötelező.',
    sk: 'Příjmení je povinné.',
    sl: 'Priimek je obvezen.',
    es: 'El apellido es obligatorio.',
    fi: 'Sukunimi on pakollinen.',
  },
  'Phone number is required': {
    en: 'Phone number is required.',
    bg: 'Телефонният номер е задължителен.',
    de: 'Telefonnummer ist erforderlich.',
    fr: 'Le numéro de téléphone est requis.',
    ro: 'Numărul de telefon este obligatoriu.',
    tr: 'Telefon numarası gerekli.',
    sr: 'Broj telefona je obavezan.',
    mk: 'Телефонскиот број е задолжителен.',
    hu: 'Telefonszám megadása kötelező.',
    sk: 'Telefonní číslo je povinné.',
    sl: 'Telefonska številka je obvezna.',
    es: 'El número de teléfono es obligatorio.',
    fi: 'Puhelinnumero on pakollinen.',
  },
  'Driver with this phone already exists.': {
    en: 'Driver with this phone number already exists.',
    bg: 'Шофьор с този телефон вече съществува.',
    de: 'Ein Fahrer mit dieser Telefonnummer existiert bereits.',
    fr: 'Un chauffeur avec ce numéro de téléphone existe déjà.',
    ro: 'Un șofer cu acest număr de telefon există deja.',
    tr: 'Bu telefon numarasıyla bir sürücü zaten var.',
    sr: 'Возач са овим бројем телефона већ postoji.',
    mk: 'Возач со овој телефонски број веќе постои.',
    hu: 'Ezzel a telefonszámmal rendelkező sofőr már létezik.',
    sk: 'Řidič s tímto telefonním číslem již existuje.',
    sl: 'Voznik s tem telefonskim številom že obstaja.',
    es: 'Ya existe un conductor con este número de teléfono.',
    fi: 'Tällä puhelinnumerolla on jo kuljettaja.',
  },
  "Driver's phone number must contain only digits and be 8–15 characters long. Optional leading + allowed.":
    {
      en: "Driver's phone number must contain only digits and be 8–15 characters long. Optional leading + allowed.",
      bg: 'Телефонният номер на шофьора трябва да съдържа само цифри и да бъде дълъг 8–15 символа. Възможен е водещ +.',
      de: 'Die Telefonnummer des Fahrers darf nur Ziffern enthalten und muss 8–15 Zeichen lang sein. Optionales führendes + erlaubt.',
      fr: 'Le numéro de téléphone du chauffeur doit contenir uniquement des chiffres et comporter entre 8 et 15 caractères. Un + en début de numéro est autorisé.',
      ro: 'Numărul de telefon al șoferului trebuie să conțină doar cifre și să aibă între 8 și 15 caractere. Se permite un + opțional la început.',
      tr: 'Sürücünün telefon numarası yalnızca rakamlardan oluşmalı ve 8–15 karakter uzunluğunda olmalıdır. İsteğe bağlı olarak başında + olabilir.',
      sr: 'Broj telefona vozača mora sadržavati samo cifre i biti dug 8–15 znakova. Opcionalno je dozvoljen vodeći +.',
      mk: 'Телефонскиот број на возачот мора да содржи само цифри и да биде долг 8–15 знаци. Дозволен е опционален водечки +.',
      hu: 'A sofőr telefonszámának csak számjegyeket szabad tartalmaznia, és 8–15 karakter hosszúnak kell lennie. Opcionálisan megengedett egy vezető +.',
      sk: 'Telefonní číslo řidiče musí obsahovat pouze číslice a být dlouhé 8–15 znaků. Volitelně je povolen vedoucí +.',
      sl: 'Telefonska številka voznika mora vsebovati samo številke in biti dolga 8–15 znakov. Neobvezno je dovoljeno vodilno +.',
      es: 'El número de teléfono del conductor debe contener solo dígitos y tener entre 8 y 15 caracteres. Se permite un + opcional al principio.',
      fi: 'Kuljettajan puhelinnumeron tulee sisältää vain numeroita ja olla 8–15 merkkiä pitkä. Valinnainen johtava + on sallittu.',
    },
  'Manage Fleet': {
    en: 'Manage Fleet',
    bg: 'Управление на автопарка',
    de: 'Fuhrpark verwalten',
    fr: 'Gérer la flotte',
    ro: 'Gestionare flotă',
    tr: 'Flotu Yönet',
    sr: 'Управљање автопарком',
    mk: 'Управување со автопарк',
    hu: 'Kocsicsoport kezelése',
    sk: 'Správa vozového parku',
    sl: 'Upravljanje floto',
    es: 'Gestionar flota',
    fi: 'Hallitse flotta',
  },
  'Select a category': {
    en: 'Select a category',
    bg: 'Изберете категория',
    de: 'Kategorie auswählen',
    fr: 'Sélectionnez une catégorie',
    ro: 'Selectați o categorie',
    tr: 'Kategori seçin',
    sr: 'Изаберите категорију',
    mk: 'Изберете категорија',
    hu: 'Válasszon kategóriát',
    sk: 'Vyberte kategóriu',
    sl: 'Izberite kategorijo',
    es: 'Seleccionar una categoría',
    fi: 'Valitse kategoria',
  },

  'You will receive the best transport quotes and save up to 60%!': {
    en: 'You will receive the best transport quotes and save up to 60%!',
    bg: 'Ще получите най-добрите транспортни оферти и ще спестите до 60%!',
    de: 'Sie erhalten die besten Transportangebote und sparen bis zu 60%!',
    fr: "Vous recevrez les meilleures offres de transport et économiserez jusqu'à 60 %!",
    ro: 'Veți primi cele mai bune oferte de transport și veți economisi până la 60%!',
    tr: "En iyi taşıma tekliflerini alacak ve %60'a kadar tasarruf edeceksiniz!",
    sr: 'Добићете најбоље понуде за транспорт и уштедети до 60%!',
    mk: 'Ќе ги добиете најдобрите понуди за транспорт и ќе заштедите до 60%!',
    hu: 'A legjobb szállítási ajánlatokat kapja és akár 60%-ot spórolhat!',
    sk: 'Získate najlepšie ponuky na prepravu a ušetríte až 60 %!',
    sl: 'Prejeli boste najboljše ponudbe za prevoz in prihranili do 60 %!',
    es: 'Recibirás las mejores ofertas de transporte y ahorrarás hasta un 60 %!',
    fi: 'Saat parhaat kuljetustarjoukset ja säästät jopa 60 %!',
  },
  category_transport: {
    en: '{{category}} transport',
    bg: 'Транспорт на {{category}}',
    de: 'Transport von {{category}}',
    fr: 'Transport de {{category}}',
    ro: 'Transport de {{category}}',
    tr: '{{category}} taşımacılığı',
    sr: 'Transport {{category}}',
    mk: 'Транспорт на {{category}}',
    hu: '{{category}} szállítás',
    sk: 'Preprava {{category}}',
    sl: 'Prevoz {{category}}',
    es: 'Transporte de {{category}}',
    fi: '{{category}} kuljetus',
    el: 'Μεταφορά {{category}}',
  },
  Furniture: {
    en: 'Furniture',
    bg: 'Мебели',
    de: 'Möbel',
    fr: 'Meubles',
    ro: 'Mobilă',
    tr: 'Mobilya',
    sr: 'Намештај',
    mk: 'Мебел',
    hu: 'Bútor',
    sk: 'Nábytok',
    sl: 'Pohištvo',
    es: 'Muebles',
    fi: 'Huonekalut',
  },

  Removals: {
    en: 'Removals',
    bg: 'Преместване',
    de: 'Umzüge',
    fr: 'Déménagements',
    ro: 'Mutări',
    tr: 'Taşınma',
    sr: 'Сеобе',
    mk: 'Преселби',
    hu: 'Költöztetés',
    sk: 'Sťahovanie',
    sl: 'Selitve',
    es: 'Mudanzas',
    fi: 'Muutot',
  },

  cars: {
    en: 'Cars',
    bg: 'Автомобили',
    de: 'Autos',
    fr: 'Voitures',
    ro: 'Mașini',
    tr: 'Arabalar',
    sr: 'Аутомобили',
    mk: 'Автомобили',
    hu: 'Autók',
    sk: 'Autá',
    sl: 'Avtomobili',
    es: 'Coches',
    fi: 'Autot',
  },

  building_materials: {
    en: 'building materials',
    bg: 'строителни материали',
    de: 'Baustoffe',
    fr: 'matériaux de construction',
    ro: 'materiale de construcție',
    tr: 'inşaat malzemeleri',
    sr: 'građevinski materijal',
    mk: 'градежни материјали',
    hu: 'építőanyagok',
    sk: 'stavebný materiál',
    sl: 'gradbeni material',
    es: 'materiales de construcción',
    fi: 'rakennusmateriaalit',
    el: 'οικοδομικά υλικά',
  },

  machinery: {
    en: 'machinery',
    bg: 'машини',
    de: 'Maschinen',
    fr: 'machines',
    ro: 'utilaje',
    tr: 'makineler',
    sr: 'mašine',
    mk: 'машини',
    hu: 'gépek',
    sk: 'stroje',
    sl: 'stroji',
    es: 'maquinaria',
    fi: 'koneet',
    el: 'μηχανήματα',
  },
  motorcycles: {
    en: 'Motorcycles & Scooters',
    bg: 'Мотоциклети и скутери',
    de: 'Motorräder & Roller',
    fr: 'Motos et scooters',
    ro: 'Motociclete și scutere',
    tr: 'Motosikletler ve scooterlar',
    sr: 'Мотоцикли и скутери',
    mk: 'Мотоцикли и скутери',
    hu: 'Motorkerékpárok és robogók',
    sk: 'Motocykle a skútre',
    sl: 'Motorji in skuterji',
    es: 'Motocicletas y scooters',
    fi: 'Moottoripyörät ja skootterit',
  },

  freight: {
    en: 'freight',
    bg: 'товар',
    de: 'Fracht',
    fr: 'fret',
    ro: 'marfă',
    tr: 'navlun',
    sr: 'teret',
    mk: 'товар',
    hu: 'szállítmány',
    sk: 'náklad',
    sl: 'tovor',
    es: 'flete',
    fi: 'rahti',
    el: 'φορτίο',
  },
  pallets: {
    en: 'pallets',
    bg: 'палети',
    de: 'Paletten',
    fr: 'palettes',
    ro: 'paleți',
    tr: 'paletler',
    sr: 'palete',
    mk: 'палети',
    hu: 'raklapok',
    sk: 'palety',
    sl: 'palete',
    es: 'palets',
    fi: 'lavat',
    el: 'παλέτες',
  },
  furniture: {
    en: 'furniture',
    bg: 'мебели',
    de: 'Möbel',
    fr: 'meubles',
    ro: 'mobilier',
    tr: 'mobilya',
    sr: 'nameštaj',
    mk: 'мебел',
    hu: 'bútor',
    sk: 'nábytok',
    sl: 'pohištvo',
    es: 'muebles',
    fi: 'huonekalut',
    el: 'έπιπλα',
  },

  other: {
    en: 'other',
    bg: 'други',
    de: 'andere',
    fr: 'autre',
    ro: 'altele',
    tr: 'diğer',
    sr: 'ostalo',
    mk: 'друго',
    hu: 'egyéb',
    sk: 'iné',
    sl: 'drugo',
    es: 'otro',
    fi: 'muu',
    el: 'άλλα',
  },
  other_vehicles: {
    en: 'other vehicles',
    bg: 'други превозни средства',
    de: 'andere Fahrzeuge',
    fr: 'autres véhicules',
    ro: 'alte vehicule',
    tr: 'diğer araçлар',
    sr: 'druga vozila',
    mk: 'други возила',
    hu: 'egyéb járművek',
    sk: 'iné vozidlá',
    sl: 'druga vozila',
    es: 'otros vehículos',
    fi: 'muut ajoneuvot',
    el: 'άλλα οχήματα',
  },

  pets: {
    en: 'pets',
    bg: 'домашни любимци',
    de: 'Haustiere',
    fr: 'animaux de compagnie',
    ro: 'animale de companie',
    tr: 'evcil hayvanlar',
    sr: 'kućni ljubimci',
    mk: 'домашни миленичиња',
    hu: 'háziállatok',
    sk: 'domáce zvieratá',
    sl: 'hišni ljubljenčki',
    es: 'mascotas',
    fi: 'lemmikit',
    el: 'κατοικίδια',
  },

  removals: {
    en: 'removals',
    bg: 'преместване',
    de: 'Umzüge',
    fr: 'déménagements',
    ro: 'mutări',
    tr: 'taşınma',
    sr: 'selidbe',
    mk: 'преселби',
    hu: 'költöztetés',
    sk: 'sťahovanie',
    sl: 'selitve',
    es: 'mudanzas',
    fi: 'muutot',
    el: 'μετακομίσεις',
  },

  parcels: {
    en: 'parcels',
    bg: 'пратки',
    de: 'Pakete',
    fr: 'colis',
    ro: 'colete',
    tr: 'paketler',
    sr: 'paketi',
    mk: 'пакети',
    hu: 'csomagok',
    sk: 'balíky',
    sl: 'paketi',
    es: 'paquetes',
    fi: 'paketit',
    el: 'δέματα',
  },
  Pallets: {
    en: 'Pallets',
    bg: 'Палети',
    de: 'Paletten',
    fr: 'Palettes',
    ro: 'Paleți',
    tr: 'Paletler',
    sr: 'Палете',
    mk: 'Палети',
    hu: 'Raklapok',
    sk: 'Palety',
    sl: 'Palete',
    es: 'Palés',
    fi: 'Lavat',
  },

  Freight: {
    en: 'Freight',
    bg: 'Товар',
    de: 'Fracht',
    fr: 'Fret',
    ro: 'Marfă',
    tr: 'Yük',
    sr: 'Терет',
    mk: 'Товар',
    hu: 'Áru',
    sk: 'Náklad',
    sl: 'Tovor',
    es: 'Carga',
    fi: 'Rahti',
  },

  Parcels: {
    en: 'Parcels',
    bg: 'Пратки',
    de: 'Pakete',
    fr: 'Colis',
    ro: 'Colete',
    tr: 'Paketler',
    sr: 'Пакети',
    mk: 'Пакети',
    hu: 'Csomagok',
    sk: 'Balíky',
    sl: 'Paketi',
    es: 'Paquetes',
    fi: 'Paketit',
  },

  'Machinery & Equipment': {
    en: 'Machinery & Equipment',
    bg: 'Машини и оборудване',
    de: 'Maschinen & Ausrüstung',
    fr: 'Machines et équipements',
    ro: 'Utilaje și echipamente',
    tr: 'Makine ve ekipman',
    sr: 'Машине и опрема',
    mk: 'Машини и опрема',
    hu: 'Gépek és berendezések',
    sk: 'Stroje a zariadenia',
    sl: 'Stroji in oprema',
    es: 'Maquinaria y equipos',
    fi: 'Koneet ja laitteet',
  },

  'Other Vehicles': {
    en: 'Other Vehicles',
    bg: 'Други превозни средства',
    de: 'Andere Fahrzeuge',
    fr: 'Autres véhicules',
    ro: 'Alte vehicule',
    tr: 'Diğer araçlar',
    sr: 'Друга возила',
    mk: 'Други возила',
    hu: 'Egyéb járművek',
    sk: 'Iné vozidlá',
    sl: 'Druga vozila',
    es: 'Otros vehículos',
    fi: 'Muut ajoneuvot',
  },

  Pets: {
    en: 'Pets',
    bg: 'Домашни любимци',
    de: 'Haustiere',
    fr: 'Animaux de compagnie',
    ro: 'Animale de companie',
    tr: 'Evcil hayvanlar',
    sr: 'Кућни љубимци',
    mk: 'Домашни миленици',
    hu: 'Háziállatok',
    sk: 'Domáce zvieratá',
    sl: 'Hišni ljubljenčki',
    es: 'Mascotas',
    fi: 'Lemmikit',
  },

  'Building Materials': {
    en: 'Building Materials',
    bg: 'Строителни материали',
    de: 'Baumaterialien',
    fr: 'Matériaux de construction',
    ro: 'Materiale de construcții',
    tr: 'İnşaat malzemeleri',
    sr: 'Грађевински материјали',
    mk: 'Градежни материјали',
    hu: 'Építőanyagok',
    sk: 'Stavebné materiály',
    sl: 'Gradbeni materiali',
    es: 'Materiales de construcción',
    fi: 'Rakennusmateriaalit',
  },

  'Fragile Goods': {
    en: 'Fragile Goods',
    bg: 'Чупливи стоки',
    de: 'Zerbrechliche Güter',
    fr: 'Marchandises fragiles',
    ro: 'Bunuri fragile',
    tr: 'Kırılabilir eşyalar',
    sr: 'Крхка роба',
    mk: 'Кршливи стоки',
    hu: 'Törékeny áruk',
    sk: 'Krehký tovar',
    sl: 'Krhko blago',
    es: 'Mercancías frágiles',
    fi: 'Särkyvät tavarat',
  },

  fragile: {
    en: 'fragile',
    bg: 'чупливо',
    de: 'zerbrechlich',
    fr: 'fragile',
    ro: 'fragil',
    tr: 'kърълган',
    sr: 'lomljivo',
    mk: 'кршливо',
    hu: 'törékeny',
    sk: 'krehké',
    sl: 'lomljivo',
    es: 'frágil',
    fi: 'särkyvää',
    el: 'εύθραυστο',
  },

  boats: {
    en: 'boats',
    bg: 'лодки',
    de: 'Boote',
    fr: 'bateaux',
    ro: 'bărci',
    tr: 'tekneler',
    sr: 'čamci',
    mk: 'чамци',
    hu: 'hajók',
    sk: 'lode',
    sl: 'čolni',
    es: 'barcos',
    fi: 'veneet',
    el: 'σκάφη',
  },

  bicycles: {
    en: 'bicycles',
    bg: 'велосипеди',
    de: 'Fahrräder',
    fr: 'vélos',
    ro: 'biciclete',
    tr: 'bisikletler',
    sr: 'bicikli',
    mk: 'велосипеди',
    hu: 'kerékpárok',
    sk: 'bicykle',
    sl: 'kolesa',
    es: 'bicicletas',
    fi: 'polkupyörät',
    el: 'ποδήλατα',
  },

  household: {
    en: 'household',
    bg: 'домакински стоки',
    de: 'Haushaltsgegenstände',
    fr: 'articles ménagers',
    ro: 'articole de uz casnic',
    tr: 'ev eşyaları',
    sr: 'domaćinstvo',
    mk: 'домаќинство',
    hu: 'háztartási cikkek',
    sk: 'domácnosť',
    sl: 'gospodinjstvo',
    es: 'hogar',
    fi: 'kotitalous',
    el: 'οικιακά είδη',
  },
  vehicle_parts: {
    en: 'vehicle parts',
    bg: 'авточасти',
    de: 'Fahrzeugteile',
    fr: 'pièces de véhicules',
    ro: 'piese auto',
    tr: 'araç parçaları',
    sr: 'auto delovi',
    mk: 'автоделови',
    hu: 'járműalkatrészek',
    sk: 'autodiely',
    sl: 'avtodeli',
    es: 'piezas de vehículos',
    fi: 'ajoneuvon osat',
    el: 'ανταλλακτικά οχημάτων',
  },
  Boats: {
    en: 'Boats',
    bg: 'Лодки',
    de: 'Boote',
    fr: 'Bateaux',
    ro: 'Bărci',
    tr: 'Tekneler',
    sr: 'Чамци',
    mk: 'Чамци',
    hu: 'Csónakok',
    sk: 'Lode',
    sl: 'Čolni',
    es: 'Barcos',
    fi: 'Veneet',
  },

  Bicycles: {
    en: 'Bicycles',
    bg: 'Велосипеди',
    de: 'Fahrräder',
    fr: 'Vélos',
    ro: 'Biciclete',
    tr: 'Bisikletler',
    sr: 'Бицикли',
    mk: 'Велосипеди',
    hu: 'Kerékpárok',
    sk: 'Bicykle',
    sl: 'Kolesa',
    es: 'Bicicletas',
    fi: 'Polkupyörät',
  },

  'Vehicle Parts': {
    en: 'Vehicle Parts',
    bg: 'Авточасти',
    de: 'Fahrzeugteile',
    fr: 'Pièces de véhicule',
    ro: 'Piese auto',
    tr: 'Araç parçaları',
    sr: 'Ауто делови',
    mk: 'Делови за возила',
    hu: 'Járműalkatrészek',
    sk: 'Autodiely',
    sl: 'Avtodeli',
    es: 'Piezas de vehículos',
    fi: 'Ajoneuvon osat',
  },

  'Household Appliances': {
    en: 'Household Appliances',
    bg: 'Домакински уреди',
    de: 'Haushaltsgeräte',
    fr: 'Appareils ménagers',
    ro: 'Electrocasnice',
    tr: 'Ev aletleri',
    sr: 'Кућни апарати',
    mk: 'Апарати за домаќинство',
    hu: 'Háztartási gépek',
    sk: 'Domáce spotrebiče',
    sl: 'Gospodinjski aparati',
    es: 'Electrodomésticos',
    fi: 'Kodinkoneet',
  },

  Other: {
    en: 'Other',
    bg: 'Друго',
    de: 'Andere',
    fr: 'Autre',
    ro: 'Altul',
    tr: 'Diğer',
    sr: 'Остало',
    mk: 'Друго',
    hu: 'Egyéb',
    sk: 'Iné',
    sl: 'Drugo',
    es: 'Otro',
    fi: 'Muu',
  },
  awaiting_payment: {
    en: 'Awaiting payment',
    bg: 'Очаква плащане',
    de: 'Wartet auf Zahlung',
    fr: 'En attente de paiement',
    ro: 'Așteaptă plata',
    tr: 'Ödeme bekleniyor',
    sr: 'Čeka se uplata',
    mk: 'Чека плаќање',
    hu: 'Fizetésre vár',
    sk: 'Čaká na platbu',
    sl: 'Čaka na plačilo',
    es: 'Esperando pago',
    fi: 'Odottaa maksua',
    el: 'Αναμονή πληρωμής',
  },
  completed: {
    en: 'completed',
    bg: 'завършена',
    de: 'abgeschlossen',
    fr: 'terminé',
    ro: 'finalizat',
    tr: 'tamamlandı',
    sr: 'završeno',
    mk: 'завршено',
    hu: 'befejezett',
    sk: 'dokončený',
    sl: 'zaključeno',
    es: 'completado',
    fi: 'valmis',
    el: 'ολοκληρωμένο',
  },
  open: {
    en: 'open',
    bg: 'отворена',
    de: 'offen',
    fr: 'ouvert',
    ro: 'deschis',
    tr: 'açık',
    sr: 'otvoreno',
    mk: 'отворено',
    hu: 'nyitott',
    sk: 'otvorený',
    sl: 'odprto',
    es: 'abierto',
    fi: 'avoin',
    el: 'ανοιχτό',
  },
  has_quotes: {
    en: 'has quotes',
    bg: 'с оферти',
    de: 'hat Angebote',
    fr: 'a des offres',
    ro: 'are oferte',
    tr: 'teklif var',
    sr: 'ima ponude',
    mk: 'има понуди',
    hu: 'vannak ajánlatok',
    sk: 'má ponuky',
    sl: 'ima ponudbe',
    es: 'tiene ofertas',
    fi: 'on tarjouksia',
    el: 'έχει προσφορές',
  },
  accepted: {
    en: 'accepted',
    bg: 'приета',
    de: 'akzeptiert',
    fr: 'accepté',
    ro: 'acceptat',
    tr: 'kabul edildi',
    sr: 'prihvaćeno',
    mk: 'прифатено',
    hu: 'elfogadva',
    sk: 'prijatý',
    sl: 'sprejeto',
    es: 'aceptado',
    fi: 'hyväksytty',
    el: 'έγινε αποδεκτό',
  },
  paid: {
    en: 'paid',
    bg: 'платена',
    de: 'bezahlt',
    fr: 'payé',
    ro: 'plătit',
    tr: 'ödendi',
    sr: 'plaćeno',
    mk: 'платено',
    hu: 'fizetve',
    sk: 'zaplatený',
    sl: 'plačano',
    es: 'pagado',
    fi: 'maksettu',
    el: 'πληρώθηκε',
  },
  planned: {
    en: 'planned',
    bg: 'планирана',
    de: 'geplant',
    fr: 'planifié',
    ro: 'planificat',
    tr: 'planlandı',
    sr: 'planirano',
    mk: 'планирано',
    hu: 'tervezве',
    sk: 'naplánovaný',
    sl: 'načrtovano',
    es: 'planificado',
    fi: 'suunniteltu',
    el: 'σχεδιάστηκε',
  },
  in_transit: {
    en: 'in transit',
    bg: 'в транзит',
    de: 'unterwegs',
    fr: 'en transit',
    ro: 'în tranzit',
    tr: 'transitte',
    sr: 'u tranzitu',
    mk: 'во транзит',
    hu: 'szállítás alatt',
    sk: 'v tranzite',
    sl: 'v tranzitu',
    es: 'en tránsito',
    fi: 'matkalla',
    el: 'σε διαμετακόμιση',
  },
  pickedUp: {
    en: 'picked up',
    bg: 'взета',
    de: 'abgeholt',
    fr: 'récupéré',
    ro: 'ridicat',
    tr: 'alındı',
    sr: 'preuzeto',
    mk: 'подигнато',
    hu: 'felvéve',
    sk: 'vyzdvihnutý',
    sl: 'prevzeto',
    es: 'recogido',
    fi: 'noudettu',
    el: 'παραλήφθηκε',
  },
  delivered: {
    en: 'delivered',
    bg: 'доставена',
    de: 'zugestellt',
    fr: 'livré',
    ro: 'livrat',
    tr: 'teslim edildi',
    sr: 'isporučeno',
    mk: 'доставено',
    hu: 'kézbesítve',
    sk: 'doručený',
    sl: 'dostavljeno',
    es: 'entregado',
    fi: 'toimitettu',
    el: 'παραδόθηκε',
  },
  canceled: {
    en: 'canceled',
    bg: 'анулирана',
    de: 'storniert',
    fr: 'annulé',
    ro: 'anulat',
    tr: 'iptal edildi',
    sr: 'otkazano',
    mk: 'откажано',
    hu: 'törölve',
    sk: 'zrušený',
    sl: 'preklicano',
    es: 'cancelado',
    fi: 'peruttu',
    el: 'ακυρώθηκε',
  },
  expired: {
    en: 'expired',
    bg: 'изтекла',
    de: 'abgelaufen',
    fr: 'expiré',
    ro: 'expirat',
    tr: 'süresi doldu',
    sr: 'isteklo',
    mk: 'истечено',
    hu: 'lejárt',
    sk: 'vypršaný',
    sl: 'poteklo',
    es: 'expirado',
    fi: 'vanhentunut',
    el: 'έληξε',
  },
  'Choose a route': {
    en: 'Choose a route',
    bg: 'Изберете маршрут',
    de: 'Route auswählen',
    fr: 'Choisir un itinéraire',
    ro: 'Alegeți o rută',
    tr: 'Bir rota seçin',
    sr: 'Изаберите руту',
    mk: 'Изберете рута',
    hu: 'Válasszon útvonalat',
    sk: 'Vyberte trasu',
    sl: 'Izberite pot',
    es: 'Elegir ruta',
    fi: 'Valitse reitti',
  },

  'Enter pick-up and delivery locations.': {
    en: 'Enter pick-up and delivery locations.',
    bg: 'Въведете места за взимане и доставка',
    de: 'Abhol- und Lieferorte eingeben',
    fr: "Saisissez les lieux d'enlèvement et de livraison",
    ro: 'Introduceți locațiile de ridicare și livrare',
    tr: 'Alım ve teslimat konumlarını girin',
    sr: 'Унесите места преузимања и испоруке',
    mk: 'Внесете локации за подигнување и достава',
    hu: 'Adja meg a felvételi és szállítási helyeket',
    sk: 'Zadajte miesto vyzdvihnutia a doručenia',
    sl: 'Vnesite lokacijo prevzema in dostave',
    es: 'Introduzca lugares de recogida y entrega',
    fi: 'Anna nouto- ja toimituspaikat',
  },

  'Pick-up location': {
    en: 'Pick-up location',
    bg: 'Място за взимане',
    de: 'Abholort',
    fr: 'Lieu de collecte',
    ro: 'Locație de ridicare',
    tr: 'Alım konumu',
    sr: 'Место преузимања',
    mk: 'Локација на подигнување',
    hu: 'Felvételi hely',
    sk: 'Miesto vyzdvihnutia',
    sl: 'Lokacija prevzema',
    es: 'Lugar de recogida',
    fi: 'Noutopaikka',
  },

  'Search with AI': {
    en: 'Search with AI',
    bg: 'Търси с AI',
    de: 'Mit KI suchen',
    fr: "Rechercher avec l'IA",
    ro: 'Cauta cu AI',
    tr: 'YZ ile ara',
    sr: 'Претражи уз AI',
    mk: 'Пребарај со AI',
    hu: 'Keresés MI-vel',
    sk: 'Hľadať s AI',
    sl: 'Išči z UI',
    es: 'Buscar con IA',
    fi: 'Hae tekoälyllä',
  },

  'Describe the lane you want and review the prepared marketplace filters.': {
    en: 'Describe the lane you want and review the prepared marketplace filters.',
    bg: 'Опишете желания маршрут и прегледайте подготвените филтри за пазара.',
    de: 'Beschreiben Sie die gewuenschte Route und pruefen Sie die vorbereiteten Marktplatzfilter.',
    fr: "Décrivez l'itinéraire souhaité et vérifiez les filtres préparés pour la marketplace.",
    ro: 'Descrieti ruta dorita si verificati filtrele pregatite pentru marketplace.',
    tr: 'İstediğiniz hattı açıklayın ve hazırlanan pazar yeri filtrelerini gözden geçirin.',
    sr: 'Опишите жељену руту и прегледајте припремљене филтере за тржиште.',
    mk: 'Опишете ја посакуваната рута и прегледајте ги подготвените филтри за пазарот.',
    hu: 'Írja le a kívánt útvonalat, és nézze át az előkészített piactéri szűrőket.',
    sk: 'Popíšte požadovanú trasu a skontrolujte pripravené filtre marketplace.',
    sl: 'Opišite želeno relacijo in preglejte pripravljene filtre tržnice.',
    es: 'Describe la ruta que deseas y revisa los filtros preparados del marketplace.',
    fi: 'Kuvaile haluamasi reitti ja tarkista valmistellut marketplace-suodattimet.',
  },

  'Scan open marketplace requests quickly with a compact filter bar and richer delivery cards built for quoting decisions.':
    {
      en: 'Scan open marketplace requests quickly with a compact filter bar and richer delivery cards built for quoting decisions.',
      bg: 'Преглеждайте бързо отворените заявки в пазара с компактен филтър и по-богати карти за вземане на решение при офериране.',
      de: 'Pruefen Sie offene Marktplatzanfragen schnell mit einer kompakten Filterleiste und aussagekraeftigen Lieferkarten fuer Angebotsentscheidungen.',
      fr: 'Parcourez rapidement les demandes ouvertes sur la marketplace grâce à une barre de filtres compacte et à des cartes de livraison plus riches pour prendre vos décisions de devis.',
      ro: 'Analizati rapid cererile deschise din marketplace cu o bara compacta de filtre si carduri mai detaliate pentru deciziile de ofertare.',
      tr: 'Teklif kararları için kompakt bir filtre çubuğu ve daha zengin teslimat kartlarıyla açık pazar yeri taleplerini hızlıca tarayın.',
      sr: 'Брзо прегледајте отворене захтеве на тржишту уз компактну траку филтера и богатије картице испоруке за доношење одлука о понудама.',
      mk: 'Брзо прегледајте ги отворените барања на пазарот со компактен филтер и побогати картички за испорака при донесување одлуки за понуда.',
      hu: 'Gyorsan tekintse át a nyitott piactéri kéréseket egy kompakt szűrősávval és részletesebb szállítási kártyákkal az ajánlati döntésekhez.',
      sk: 'Rýchlo si prezrite otvorené požiadavky marketplace pomocou kompaktného filtra a bohatších kariet zásielok pre rozhodovanie o ponukách.',
      sl: 'Hitro preglejte odprte zahteve na tržnici s kompaktno vrstico filtrov in bogatejšimi karticami dostave za odločanje o ponudbah.',
      es: 'Revisa rápidamente las solicitudes abiertas del marketplace con una barra de filtros compacta y tarjetas de entrega más completas para decidir tus ofertas.',
      fi: 'Selaa avoimia marketplace-pyyntöjä nopeasti kompaktin suodatinpalkin ja tarjousten päätöksiä tukevien monipuolisempien toimituskorttien avulla.',
    },

  'Select all': {
    en: 'Select all',
    bg: 'Избери всички',
    de: 'Alle auswaehlen',
    fr: 'Tout sélectionner',
    ro: 'Selecteaza tot',
    tr: 'Tümünü seç',
    sr: 'Изабери све',
    mk: 'Избери сè',
    hu: 'Összes kijelölése',
    sk: 'Vybrať všetko',
    sl: 'Izberi vse',
    es: 'Seleccionar todo',
    fi: 'Valitse kaikki',
  },

  Watching: {
    en: 'Watching',
    bg: 'Наблюдавани',
    de: 'Beobachtet',
    fr: 'Suivies',
    ro: 'Urmarite',
    tr: 'İzleniyor',
    sr: 'Праћено',
    mk: 'Следени',
    hu: 'Figyelt',
    sk: 'Sledované',
    sl: 'Spremljano',
    es: 'En seguimiento',
    fi: 'Seurannassa',
  },

  Watched: {
    en: 'Watched',
    bg: 'Следени',
    de: 'Beobachten',
    fr: 'Suivies',
    ro: 'Urmarite',
    tr: 'İzlenenler',
    sr: 'Праћене',
    mk: 'Следени',
    hu: 'Figyelt',
    sk: 'Sledované',
    sl: 'Spremljano',
    es: 'Seguidas',
    fi: 'Seuratut',
  },

  'Search title, city, description...': {
    en: 'Search title, city, description...',
    bg: 'Търси по заглавие, град, описание...',
    de: 'Nach Titel, Stadt, Beschreibung suchen...',
    fr: 'Rechercher par titre, ville, description...',
    ro: 'Cauta dupa titlu, oras, descriere...',
    tr: 'Başlık, şehir, açıklama ara...',
    sr: 'Претражи наслов, град, опис...',
    mk: 'Пребарај наслов, град, опис...',
    hu: 'Keresés cím, város, leírás alapján...',
    sk: 'Hľadať názov, mesto, popis...',
    sl: 'Išči naslov, mesto, opis...',
    es: 'Buscar título, ciudad, descripción...',
    fi: 'Hae otsikkoa, kaupunkia, kuvausta...',
  },

  'Hide filters': {
    en: 'Hide filters',
    bg: 'Скрий филтрите',
    de: 'Filter ausblenden',
    fr: 'Masquer les filtres',
    ro: 'Ascunde filtrele',
    tr: 'Filtreleri gizle',
    sr: 'Сакриј филтере',
    mk: 'Скриј филтри',
    hu: 'Szűrők elrejtése',
    sk: 'Skryť filtre',
    sl: 'Skrij filtre',
    es: 'Ocultar filtros',
    fi: 'Piilota suodattimet',
  },

  'More filters': {
    en: 'More filters',
    bg: 'Още филтри',
    de: 'Mehr Filter',
    fr: 'Plus de filtres',
    ro: 'Mai multe filtre',
    tr: 'Daha fazla filtre',
    sr: 'Још филтера',
    mk: 'Повеќе филтри',
    hu: 'További szűrők',
    sk: 'Viac filtrov',
    sl: 'Več filtrov',
    es: 'Más filtros',
    fi: 'Lisää suodattimia',
  },

  Refresh: {
    en: 'Refresh',
    bg: 'Обнови',
    de: 'Aktualisieren',
    fr: 'Actualiser',
    ro: 'Reimprospateaza',
    tr: 'Yenile',
    sr: 'Освежи',
    mk: 'Освежи',
    hu: 'Frissítés',
    sk: 'Obnoviť',
    sl: 'Osveži',
    es: 'Actualizar',
    fi: 'Päivitä',
  },

  'Marketplace view': {
    en: 'Marketplace view',
    bg: 'Изглед на пазара',
    de: 'Marktplatzansicht',
    fr: 'Vue marketplace',
    ro: 'Vizualizare marketplace',
    tr: 'Pazar yeri görünümü',
    sr: 'Приказ тржишта',
    mk: 'Приказ на пазарот',
    hu: 'Piactér nézet',
    sk: 'Zobrazenie marketplace',
    sl: 'Pogled tržnice',
    es: 'Vista de marketplace',
    fi: 'Marketplace-näkymä',
  },

  'Any country': {
    en: 'Any country',
    bg: 'Всяка държава',
    de: 'Beliebiges Land',
    fr: 'Tous les pays',
    ro: 'Orice tara',
    tr: 'Herhangi bir ülke',
    sr: 'Било која држава',
    mk: 'Која било држава',
    hu: 'Bármely ország',
    sk: 'Ľubovoľná krajina',
    sl: 'Katera koli država',
    es: 'Cualquier país',
    fi: 'Mikä tahansa maa',
  },

  Postcode: {
    en: 'Postcode',
    bg: 'Пощенски код',
    de: 'Postleitzahl',
    ro: 'Cod postal',
    tr: 'Posta kodu',
    sr: 'Поштански број',
    mk: 'Поштенски код',
    hu: 'Irányítószám',
    sk: 'PSČ',
    sl: 'Poštna številka',
    es: 'Código postal',
    fi: 'Postinumero',
  },

  'Any radius': {
    en: 'Any radius',
    bg: 'Всеки радиус',
    de: 'Beliebiger Radius',
    fr: 'Tout rayon',
    ro: 'Orice raza',
    tr: 'Herhangi bir yarıçap',
    sr: 'Било који радијус',
    mk: 'Кој било радиус',
    hu: 'Bármilyen sugár',
    sk: 'Ľubovoľný rádius',
    sl: 'Poljuben radij',
    es: 'Cualquier radio',
    fi: 'Mikä tahansa säde',
  },

  Keyword: {
    en: 'Keyword',
    bg: 'Ключова дума',
    de: 'Stichwort',
    fr: 'Mot-clé',
    ro: 'Cuvant-cheie',
    tr: 'Anahtar kelime',
    sr: 'Кључна реч',
    mk: 'Клучен збор',
    hu: 'Kulcsszó',
    sk: 'Kľúčové slovo',
    sl: 'Ključna beseda',
    es: 'Palabra clave',
    fi: 'Avainsana',
  },

  'Title, item, route, description...': {
    en: 'Title, item, route, description...',
    bg: 'Заглавие, артикул, маршрут, описание...',
    de: 'Titel, Artikel, Route, Beschreibung...',
    fr: 'Titre, article, itinéraire, description...',
    ro: 'Titlu, articol, ruta, descriere...',
    tr: 'Başlık, öğe, rota, açıklama...',
    sr: 'Наслов, ставка, рута, опис...',
    mk: 'Наслов, ставка, рута, опис...',
    hu: 'Cím, tétel, útvonal, leírás...',
    sk: 'Názov, položka, trasa, popis...',
    sl: 'Naslov, predmet, pot, opis...',
    es: 'Título, artículo, ruta, descripción...',
    fi: 'Otsikko, kohde, reitti, kuvaus...',
  },

  'Searching marketplace...': {
    en: 'Searching marketplace...',
    bg: 'Търсене в пазара...',
    de: 'Marktplatz wird durchsucht...',
    fr: 'Recherche sur la marketplace...',
    ro: 'Se cauta in marketplace...',
    tr: 'Pazar yerinde aranıyor...',
    sr: 'Претрага тржишта...',
    mk: 'Се пребарува на пазарот...',
    hu: 'Marketplace keresése...',
    sk: 'Vyhľadáva sa v marketplace...',
    sl: 'Iskanje po tržnici...',
    es: 'Buscando en el marketplace...',
    fi: 'Haetaan marketplacea...',
  },

  '{{count}} open deliveries': {
    en: '{{count}} open deliveries',
    bg: '{{count}} отворени доставки',
    de: '{{count}} offene Lieferungen',
    fr: '{{count}} livraisons ouvertes',
    ro: '{{count}} livrari deschise',
    tr: '{{count}} açık teslimat',
    sr: '{{count}} отворених испорука',
    mk: '{{count}} отворени испораки',
    hu: '{{count}} nyitott szállítás',
    sk: '{{count}} otvorených dodávok',
    sl: '{{count}} odprtih dostav',
    es: '{{count}} entregas abiertas',
    fi: '{{count}} avointa toimitusta',
  },

  'Route filtered': {
    en: 'Route filtered',
    bg: 'Маршрутът е филтриран',
    de: 'Route gefiltert',
    fr: 'Itinéraire filtré',
    ro: 'Ruta filtrata',
    tr: 'Rota filtrelendi',
    sr: 'Рута је филтрирана',
    mk: 'Рутата е филтрирана',
    hu: 'Útvonal szűrve',
    sk: 'Trasa filtrovaná',
    sl: 'Pot filtrirana',
    es: 'Ruta filtrada',
    fi: 'Reitti suodatettu',
  },

  'Loading open deliveries...': {
    en: 'Loading open deliveries...',
    bg: 'Зареждане на отворени доставки...',
    de: 'Offene Lieferungen werden geladen...',
    fr: 'Chargement des livraisons ouvertes...',
    ro: 'Se incarca livrarile deschise...',
    tr: 'Açık teslimatlar yükleniyor...',
    sr: 'Учитавање отворених испорука...',
    mk: 'Се вчитуваат отворените испораки...',
    hu: 'Nyitott szállítások betöltése...',
    sk: 'Načítavajú sa otvorené dodávky...',
    sl: 'Nalaganje odprtih dostav...',
    es: 'Cargando entregas abiertas...',
    fi: 'Ladataan avoimia toimituksia...',
  },

  'No listings found': {
    en: 'No listings found',
    bg: 'Няма намерени обяви',
    de: 'Keine Inserate gefunden',
    fr: 'Aucune annonce trouvée',
    ro: 'Nu au fost gasite listari',
    tr: 'Listeleme bulunamadı',
    sr: 'Нема пронађених огласа',
    mk: 'Не се пронајдени огласи',
    hu: 'Nincs találat',
    sk: 'Nenašli sa žiadne inzeráty',
    sl: 'Ni najdenih oglasov',
    es: 'No se encontraron anuncios',
    fi: 'Ilmoituksia ei löytynyt',
  },

  'Try widening the route, date, keyword, or category filters to see more marketplace opportunities.':
    {
      en: 'Try widening the route, date, keyword, or category filters to see more marketplace opportunities.',
      bg: 'Опитайте да разширите филтрите за маршрут, дата, ключова дума или категория, за да видите повече възможности в пазара.',
      de: 'Erweitern Sie Route, Datum, Stichwort oder Kategorie, um mehr Marktplatzmoeglichkeiten zu sehen.',
      fr: 'Essayez d’élargir les filtres d’itinéraire, de date, de mot-clé ou de catégorie pour voir plus d’opportunités sur la marketplace.',
      ro: 'Incercati sa largiti filtrele de ruta, data, cuvant-cheie sau categorie pentru a vedea mai multe oportunitati in marketplace.',
      tr: 'Pazar yerinde daha fazla fırsat görmek için rota, tarih, anahtar kelime veya kategori filtrelerini genişletmeyi deneyin.',
      sr: 'Покушајте да проширите филтере за руту, датум, кључну реч или категорију да бисте видели више прилика на тржишту.',
      mk: 'Обидете се да ги проширите филтрите за рута, датум, клучен збор или категорија за да видите повеќе можности на пазарот.',
      hu: 'Próbálja bővíteni az útvonal-, dátum-, kulcsszó- vagy kategóriaszűrőket, hogy több piactéri lehetőséget lásson.',
      sk: 'Skúste rozšíriť filtre trasy, dátumu, kľúčového slova alebo kategórie, aby ste videli viac príležitostí na marketplace.',
      sl: 'Poskusite razširiti filtre poti, datuma, ključne besede ali kategorije, da vidite več priložnosti na tržnici.',
      es: 'Prueba a ampliar los filtros de ruta, fecha, palabra clave o categoría para ver más oportunidades en el marketplace.',
      fi: 'Laajenna reitti-, päivämäärä-, avainsana- tai kategoriasuodattimia nähdäksesi enemmän mahdollisuuksia marketplace-palvelussa.',
    },

  'Clear filters': {
    en: 'Clear filters',
    bg: 'Изчисти филтрите',
    de: 'Filter zuruecksetzen',
    fr: 'Effacer les filtres',
    ro: 'Sterge filtrele',
    tr: 'Filtreleri temizle',
    sr: 'Очисти филтере',
    mk: 'Исчисти филтри',
    hu: 'Szűrők törlése',
    sk: 'Vymazať filtre',
    sl: 'Počisti filtre',
    es: 'Borrar filtros',
    fi: 'Tyhjennä suodattimet',
  },

  'Load more deliveries': {
    en: 'Load more deliveries',
    bg: 'Зареди още доставки',
    de: 'Mehr Lieferungen laden',
    fr: 'Charger plus de livraisons',
    ro: 'Incarca mai multe livrari',
    tr: 'Daha fazla teslimat yükle',
    sr: 'Учитај још испорука',
    mk: 'Вчитај уште испораки',
    hu: 'További szállítások betöltése',
    sk: 'Načítať viac dodávok',
    sl: 'Naloži več dostav',
    es: 'Cargar más entregas',
    fi: 'Lataa lisää toimituksia',
  },

  'Search Listings': {
    en: 'Search Listings',
    bg: 'Търси обяви',
    de: 'Inserate suchen',
    fr: 'Rechercher des annonces',
    ro: 'Cauta listari',
    tr: 'İlan ara',
    sr: 'Претражи огласе',
    mk: 'Пребарај огласи',
    hu: 'Hirdetések keresése',
    sk: 'Hľadať inzeráty',
    sl: 'Išči oglase',
    es: 'Buscar anuncios',
    fi: 'Hae ilmoituksia',
  },

  '{{count}} categories': {
    en: '{{count}} categories',
    bg: '{{count}} категории',
    de: '{{count}} Kategorien',
    fr: '{{count}} catégories',
    ro: '{{count}} categorii',
    tr: '{{count}} kategori',
    sr: '{{count}} категорија',
    mk: '{{count}} категории',
    hu: '{{count}} kategória',
    sk: '{{count}} kategórií',
    sl: '{{count}} kategorij',
    es: '{{count}} categorías',
    fi: '{{count}} kategoriaa',
  },

  '{{count}} item(s)': {
    en: '{{count}} item(s)',
    bg: '{{count}} артикул(а)',
    de: '{{count}} Artikel',
    fr: '{{count}} article(s)',
    ro: '{{count}} articol(e)',
    tr: '{{count}} öğe',
    sr: '{{count}} ставка(и)',
    mk: '{{count}} ставка(и)',
    hu: '{{count}} tétel',
    sk: '{{count}} položka(y)',
    sl: '{{count}} element(ov)',
    es: '{{count}} artículo(s)',
    fi: '{{count}} kohde(tta)',
  },

  Qty: {
    en: 'Qty',
    bg: 'Бр.',
    de: 'Menge',
    fr: 'Qté',
    ro: 'Cant.',
    tr: 'Adet',
    sr: 'Кол.',
    mk: 'Кол.',
    hu: 'Menny.',
    sk: 'Množ.',
    sl: 'Kol.',
    es: 'Cant.',
    fi: 'Määrä',
  },

  Operable: {
    en: 'Operable',
    bg: 'В движение',
    de: 'Fahrbereit',
    fr: 'En état de marche',
    ro: 'Functional',
    tr: 'Çalışır durumda',
    sr: 'Исправно',
    mk: 'Оперативно',
    hu: 'Üzemképes',
    sk: 'Pojazdné',
    sl: 'Vozno',
    es: 'Operativo',
    fi: 'Ajokuntoinen',
  },

  'Target budget': {
    en: 'Target budget',
    bg: 'Целеви бюджет',
    de: 'Zielbudget',
    fr: 'Budget cible',
    ro: 'Buget tinta',
    tr: 'Hedef bütçe',
    sr: 'Циљни буџет',
    mk: 'Целен буџет',
    hu: 'Célköltségvetés',
    sk: 'Cieľový rozpočet',
    sl: 'Ciljni proračun',
    es: 'Presupuesto objetivo',
    fi: 'Tavoitebudjetti',
  },

  'Accept listing': {
    en: 'Accept listing',
    bg: 'Приеми обявата',
    de: 'Inserat annehmen',
    fr: "Accepter l'annonce",
    ro: 'Accepta listarea',
    tr: 'İlanı kabul et',
    sr: 'Прихвати оглас',
    mk: 'Прифати оглас',
    hu: 'Hirdetés elfogadása',
    sk: 'Prijať inzerát',
    sl: 'Sprejmi oglas',
    es: 'Aceptar anuncio',
    fi: 'Hyväksy ilmoitus',
  },

  Watch: {
    en: 'Watch',
    bg: 'Следи',
    de: 'Beobachten',
    fr: 'Suivre',
    ro: 'Urmareste',
    tr: 'İzle',
    sr: 'Прати',
    mk: 'Следи',
    hu: 'Figyelés',
    sk: 'Sledovať',
    sl: 'Spremljaj',
    es: 'Seguir',
    fi: 'Seuraa',
  },

  Unwatch: {
    en: 'Unwatch',
    bg: 'Спри следенето',
    de: 'Nicht mehr beobachten',
    fr: 'Ne plus suivre',
    ro: 'Nu mai urmari',
    tr: 'İzlemeyi bırak',
    sr: 'Престани да пратиш',
    mk: 'Престани да следиш',
    hu: 'Figyelés leállítása',
    sk: 'Prestať sledovať',
    sl: 'Prenehaj spremljati',
    es: 'Dejar de seguir',
    fi: 'Lopeta seuraaminen',
  },

  'Pick-up window': {
    en: 'Pick-up window',
    bg: 'Прозорец за вземане',
    de: 'Abholfenster',
    fr: 'Fenêtre de ramassage',
    ro: 'Interval de ridicare',
    tr: 'Teslim alma aralığı',
    sr: 'Време преузимања',
    mk: 'Прозорец за подигнување',
    hu: 'Felvételi időablak',
    sk: 'Okno vyzdvihnutia',
    sl: 'Prevzemno okno',
    es: 'Ventana de recogida',
    fi: 'Noutoikkuna',
  },

  Posted: {
    en: 'Posted',
    bg: 'Публикувано',
    de: 'Veröffentlicht',
    fr: 'Publié',
    ro: 'Publicat',
    tr: 'Yayınlandı',
    sr: 'Објављено',
    mk: 'Објавено',
    hu: 'Közzétéve',
    sk: 'Zverejnené',
    sl: 'Objavljeno',
    es: 'Publicado',
    fi: 'Julkaistu',
  },

  item: {
    en: 'item',
    bg: 'артикул',
    de: 'Artikel',
    fr: 'article',
    ro: 'articol',
    tr: 'öğe',
    sr: 'ставка',
    mk: 'ставка',
    hu: 'tétel',
    sk: 'položka',
    sl: 'element',
    es: 'artículo',
    fi: 'kohde',
  },

  OPEN: {
    en: 'OPEN',
    bg: 'ОТВОРЕНА',
    de: 'OFFEN',
    fr: 'OUVERTE',
    ro: 'DESCHIS',
    tr: 'AÇIK',
    sr: 'ОТВОРЕНО',
    mk: 'ОТВОРЕНО',
    hu: 'NYITOTT',
    sk: 'OTVORENÉ',
    sl: 'ODPRTO',
    es: 'ABIERTA',
    fi: 'AVOIN',
  },

  'quick view': {
    en: 'quick view',
    bg: 'бърз преглед',
    de: 'Schnellansicht',
    fr: 'aperçu rapide',
    ro: 'vizualizare rapida',
    tr: 'hızlı görünüm',
    sr: 'брзи преглед',
    mk: 'брз преглед',
    hu: 'gyorsnézet',
    sk: 'rýchly náhľad',
    sl: 'hitri pogled',
    es: 'vista rápida',
    fi: 'pikakatselu',
  },

  'Private Person': {
    en: 'Private Person',
    bg: 'Частно лице',
    de: 'Privatperson',
    fr: 'Particulier',
    ro: 'Persoana privata',
    tr: 'Bireysel kişi',
    sr: 'Приватно лице',
    mk: 'Приватно лице',
    hu: 'Magánszemély',
    sk: 'Súkromná osoba',
    sl: 'Fizična oseba',
    es: 'Particular',
    fi: 'Yksityishenkilö',
  },

  Cars: {
    en: 'Cars',
    bg: 'Автомобили',
    de: 'Autos',
    fr: 'Voitures',
    ro: 'Mașini',
    tr: 'Arabalar',
    sr: 'Аутомобили',
    mk: 'Автомобили',
    hu: 'Autók',
    sk: 'Autá',
    sl: 'Avtomobili',
    es: 'Coches',
    fi: 'Autot',
  },

  Motorcycles: {
    en: 'Motorcycles',
    bg: 'Мотоциклети',
    de: 'Motorräder',
    fr: 'Motos',
    ro: 'Motociclete',
    tr: 'Motosikletler',
    sr: 'Мотоцикли',
    mk: 'Мотоцикли',
    hu: 'Motorkerékpárok',
    sk: 'Motocykle',
    sl: 'Motorji',
    es: 'Motocicletas',
    fi: 'Moottoripyörät',
  },

  Machinery: {
    en: 'Machinery',
    bg: 'Машини',
    de: 'Maschinen',
    fr: 'Machines',
    ro: 'Utilaje',
    tr: 'Makineler',
    sr: 'Машине',
    mk: 'Машини',
    hu: 'Gépek',
    sk: 'Stroje',
    sl: 'Stroji',
    es: 'Maquinaria',
    fi: 'Koneet',
  },

  Fragile: {
    en: 'Fragile',
    bg: 'Чупливо',
    de: 'Zerbrechlich',
    fr: 'Fragile',
    ro: 'Fragil',
    tr: 'Kırılabilir',
    sr: 'Крхко',
    mk: 'Кршливо',
    hu: 'Törékeny',
    sk: 'Krehké',
    sl: 'Krhko',
    es: 'Frágil',
    fi: 'Särkyvä',
  },

  Household: {
    en: 'Household',
    bg: 'Домакинство',
    de: 'Haushalt',
    fr: 'Maison',
    ro: 'Casnic',
    tr: 'Ev eşyaları',
    sr: 'Домаћинство',
    mk: 'Домаќинство',
    hu: 'Háztartás',
    sk: 'Domácnosť',
    sl: 'Gospodinjstvo',
    es: 'Hogar',
    fi: 'Kotitalous',
  },

  'HAS QUOTES': {
    en: 'HAS QUOTES',
    bg: 'ИМА ОФЕРТИ',
    de: 'HAT ANGEBOTE',
    fr: 'A DES DEVIS',
    ro: 'ARE OFERTE',
    tr: 'TEKLİFLER VAR',
    sr: 'ИМА ПОНУДЕ',
    mk: 'ИМА ПОНУДИ',
    hu: 'VAN AJÁNLAT',
    sk: 'MÁ PONUKY',
    sl: 'IMA PONUDBE',
    es: 'TIENE OFERTAS',
    fi: 'ON TARJOUKSIA',
  },

  'Street address': {
    en: 'Street address',
    bg: 'Улица и номер',
    de: 'Straßenadresse',
    fr: 'Adresse',
    ro: 'Adresă',
    tr: 'Sokak adresi',
    sr: 'Улична адреса',
    mk: 'Улична адреса',
    hu: 'Utca és házszám',
    sk: 'Ulica a číslo',
    sl: 'Ulica in številka',
    es: 'Dirección',
    fi: 'Katuosoite',
  },
  'City *': {
    en: 'City *',
    bg: 'Град',
    de: 'Stadt',
    fr: 'Ville',
    ro: 'Oraș',
    tr: 'Şehir',
    sr: 'Град',
    mk: 'Град',
    hu: 'Város',
    sk: 'Mesto',
    sl: 'Mesto',
    es: 'Ciudad',
    fi: 'Kaupunki',
  },

  'Country *': {
    en: 'Country *',
    bg: 'Държава',
    de: 'Land',
    fr: 'Pays',
    ro: 'Țară',
    tr: 'Ülke',
    sr: 'Држава',
    mk: 'Држава',
    hu: 'Ország',
    sk: 'Krajina',
    sl: 'Država',
    es: 'País',
    fi: 'Maa',
  },

  'Delivery location': {
    en: 'Delivery location',
    bg: 'Място за доставка',
    de: 'Lieferort',
    fr: 'Lieu de livraison',
    ro: 'Locație de livrare',
    tr: 'Teslimat konumu',
    sr: 'Место испоруке',
    mk: 'Локација на достава',
    hu: 'Szállítási hely',
    sk: 'Miesto doručenia',
    sl: 'Lokacija dostave',
    es: 'Lugar de entrega',
    fi: 'Toimituspaikka',
  },

  'I want to specify dates': {
    en: 'I want to specify dates',
    bg: 'Искам да посоча дати',
    de: 'Ich möchte Termine angeben',
    fr: 'Je veux préciser des dates',
    ro: 'Vreau să specific date',
    tr: 'Tarih belirtmek istiyorum',
    sr: 'Желим да наведем датуме',
    mk: 'Сакам да наведам датуми',
    hu: 'Szeretnék dátumokat megadni',
    sk: 'Chcem zadať dátumy',
    sl: 'Želim določiti datume',
    es: 'Quiero especificar fechas',
    fi: 'Haluan määrittää päivämäärät',
  },

  'Pick-up date range': {
    en: 'Pick-up date range',
    bg: 'Диапазон на дата за взимане',
    de: 'Abholdatum Bereich',
    fr: "Plage de date d'enlèvement",
    ro: 'Interval dată ridicare',
    tr: 'Alım tarih aralığı',
    sr: 'Опсег датума преузимања',
    mk: 'Опсег на датум за подигнување',
    hu: 'Felvételi dátumtartomány',
    sk: 'Rozsah dátumu vyzdvihnutia',
    sl: 'Obdobje prevzema',
    es: 'Rango de fecha de recogida',
    fi: 'Noutopäivän aikaväli',
  },

  'Delivery date range': {
    en: 'Delivery date range',
    bg: 'Диапазон на дата за доставка',
    de: 'Lieferdatum Bereich',
    fr: 'Plage de date de livraison',
    ro: 'Interval dată livrare',
    tr: 'Teslimat tarih aralığı',
    sr: 'Опсег датума испоруке',
    mk: 'Опсег на датум за достава',
    hu: 'Szállítási dátumtartomány',
    sk: 'Rozsah dátumu doručenia',
    sl: 'Obdobje dostave',
    es: 'Rango de fecha de entrega',
    fi: 'Toimituspäivän aikaväli',
  },

  'Invalid date': {
    en: 'Invalid date',
    bg: 'Невалидна дата',
    de: 'Ungültiges Datum',
    fr: 'Date invalide',
    ro: 'Dată invalidă',
    tr: 'Geçersiz tarih',
    sr: 'Неважећи датум',
    mk: 'Невалиден датум',
    hu: 'Érvénytelen dátum',
    sk: 'Neplatný dátum',
    sl: 'Neveljaven datum',
    es: 'Fecha inválida',
    fi: 'Virheellinen päivämäärä',
  },

  'Delivery must be after pickup': {
    en: 'Delivery must be after pickup',
    bg: 'Доставката трябва да е след взимането',
    de: 'Lieferung muss nach der Abholung erfolgen',
    fr: "La livraison doit être après l'enlèvement",
    ro: 'Livrarea trebuie să fie după ridicare',
    tr: 'Teslimat alımdan sonra olmalıdır',
    sr: 'Испорука мора бити након преузимања',
    mk: 'Доставата мора да биде по подигнувањето',
    hu: 'A szállításnak az átvétel után kell lennie',
    sk: 'Doručenie musí byť po vyzdvihnutí',
    sl: 'Dostava mora biti po prevzemu',
    es: 'La entrega debe ser después de la recogida',
    fi: 'Toimituksen on oltava noudon jälkeen',
  },

  'Add or select pick-up and delivery addresses to preview the Google map route with pins A and B.':
    {
      en: 'Add or select pick-up and delivery addresses to preview the Google map route with pins A and B.',
      bg: 'Добавете или изберете адреси за взимане и доставка, за да видите маршрута в Google Maps с маркери A и B.',
      de: 'Fügen Sie Abhol- und Lieferadressen hinzu oder wählen Sie sie aus, um die Google-Maps-Route mit Markierungen A und B anzuzeigen.',
      fr: "Ajoutez ou sélectionnez les adresses d'enlèvement et de livraison pour prévisualiser l'itinéraire Google Maps avec les repères A et B.",
      ro: 'Adăugați sau selectați adresele de ridicare și livrare pentru a previzualiza ruta pe Google Maps cu marcajele A și B.',
      tr: 'Google Haritalar rotasını A ve B işaretleriyle görmek için alım ve teslimat adresleri ekleyin veya seçin.',
      sr: 'Додајте или изаберите адресе преузимања и испоруке да бисте видели Google мапу са ознакама A и B.',
      mk: 'Додадете или изберете адреси за подигнување и достава за да ја видите рутата на Google Maps со точки A и B.',
      hu: 'Adja meg vagy válassza ki a felvételi és szállítási címeket a Google Maps útvonal előnézetéhez A és B jelölőkkel.',
      sk: 'Pridajte alebo vyberte adresy vyzdvihnutia a doručenia pre náhľad trasy Google Maps s bodmi A a B.',
      sl: 'Dodajte ali izberite naslove prevzema in dostave za predogled poti v Google Maps z oznakama A in B.',
      es: 'Añade o selecciona direcciones de recogida y entrega para ver la ruta en Google Maps con los pines A y B.',
      fi: 'Lisää tai valitse nouto- ja toimitusosoitteet nähdäksesi Google Maps -reitin pisteillä A ja B.',
    },
  'Give your listing a title (optional)': {
    en: 'Give your listing a title (optional)',
    bg: 'Дайте заглавие на обявата (по избор)',
    de: 'Geben Sie Ihrer Anzeige einen Titel (optional)',
    fr: 'Donnez un titre à votre annonce (facultatif)',
    ro: 'Adaugă un titlu listării (opțional)',
    tr: 'İlanınıza başlık verin (isteğe bağlı)',
    sr: 'Дајте наслов огласу (опционо)',
    mk: 'Додадете наслов на огласот (опционално)',
    hu: 'Adjon címet a hirdetésnek (opcionális)',
    sk: 'Pridajte názov inzerátu (voliteľné)',
    sl: 'Dodajte naslov oglasu (neobvezno)',
    es: 'Añade un título al anuncio (opcional)',
    fi: 'Anna ilmoitukselle otsikko (valinnainen)',
  },

  'Add a listing title (optional)': {
    en: 'Add a listing title (optional)',
    bg: 'Добавете заглавие на обявата (по избор)',
    de: 'Titel zur Anzeige hinzufügen (optional)',
    fr: "Ajouter un titre à l'annonce (facultatif)",
    ro: 'Adaugă titlu listării (opțional)',
    tr: 'İlan başlığı ekle (isteğe bağlı)',
    sr: 'Додајте наслов огласа (опционо)',
    mk: 'Додајте наслов на оглас (опционално)',
    hu: 'Hirdetés címének hozzáadása (opcionális)',
    sk: 'Pridať názov inzerátu (voliteľné)',
    sl: 'Dodaj naslov oglasa (neobvezno)',
    es: 'Añadir título al anuncio (opcional)',
    fi: 'Lisää ilmoituksen otsikko (valinnainen)',
  },

  'Edit title': {
    en: 'Edit title',
    bg: 'Редактирай заглавие',
    de: 'Titel bearbeiten',
    fr: 'Modifier le titre',
    ro: 'Editează titlul',
    tr: 'Başlığı düzenle',
    sr: 'Измени наслов',
    mk: 'Измени наслов',
    hu: 'Cím szerkesztése',
    sk: 'Upraviť názov',
    sl: 'Uredi naslov',
    es: 'Editar título',
    fi: 'Muokkaa otsikkoa',
  },

  'Publish Fixed Price': {
    en: 'Publish Fixed Price',
    bg: 'Публикувай фиксирана цена',
    de: 'Festpreis veröffentlichen',
    fr: 'Publier un prix fixe',
    ro: 'Publică preț fix',
    tr: 'Sabit fiyat yayınla',
    sr: 'Објави фиксну цену',
    mk: 'Објави фиксна цена',
    hu: 'Fix ár közzététele',
    sk: 'Publikovať pevnú cenu',
    sl: 'Objavi fiksno ceno',
    es: 'Publicar precio fijo',
    fi: 'Julkaise kiinteä hinta',
  },

  'Get Quotes': {
    en: 'Get Quotes',
    bg: 'Получаване на оферти',
    de: 'Angebote erhalten',
    fr: 'Obtenir des devis',
    ro: 'Primește oferte',
    tr: 'Teklif al',
    sr: 'Добиј понуде',
    mk: 'Добиј понуди',
    hu: 'Ajánlatok kérése',
    sk: 'Získať ponuky',
    sl: 'Pridobi ponudbe',
    es: 'Obtener cotizaciones',
    fi: 'Hae tarjouksia',
  },

  'Publishing...': {
    en: 'Publishing...',
    bg: 'Публикуване...',
    de: 'Wird veröffentlicht...',
    fr: 'Publication...',
    ro: 'Se publică...',
    tr: 'Yayınlanıyor...',
    sr: 'Објављивање...',
    mk: 'Објавување...',
    hu: 'Közzététel...',
    sk: 'Publikovanie...',
    sl: 'Objavljanje...',
    es: 'Publicando...',
    fi: 'Julkaistaan...',
  },

  'Set a fixed price': {
    en: 'Set a fixed price',
    bg: 'Задайте фиксирана цена',
    de: 'Festpreis festlegen',
    fr: 'Définir un prix fixe',
    ro: 'Setează un preț fix',
    tr: 'Sabit fiyat belirle',
    sr: 'Постави фиксну цену',
    mk: 'Постави фиксна цена',
    hu: 'Fix ár beállítása',
    sk: 'Nastaviť pevnú cenu',
    sl: 'Nastavi fiksno ceno',
    es: 'Establecer precio fijo',
    fi: 'Aseta kiinteä hinta',
  },

  'A fixed-price listing needs a visible client price before publishing.': {
    en: 'A fixed-price listing needs a visible client price before publishing.',
    bg: 'Обява с фиксирана цена изисква видима цена за клиента преди публикуване.',
    de: 'Eine Festpreis-Anzeige benötigt vor der Veröffentlichung einen sichtbaren Kundenpreis.',
    fr: 'Une annonce à prix fixe nécessite un prix client visible avant publication.',
    ro: 'O listare cu preț fix necesită un preț vizibil pentru client înainte de publicare.',
    tr: 'Sabit fiyatlı ilan için yayınlamadan önce görünür müşteri fiyatı gerekir.',
    sr: 'Оглас са фиксном ценом захтева видљиву цену за клијента пре објављивања.',
    mk: 'Оглас со фиксна цена бара видлива цена за клиент пред објавување.',
    hu: 'A fix árú hirdetéshez látható ügyfélár szükséges közzététel előtt.',
    sk: 'Inzerát s pevnou cenou potrebuje viditeľnú cenu klienta pred publikovaním.',
    sl: 'Oglas s fiksno ceno potrebuje vidno ceno za stranko pred objavo.',
    es: 'Un anuncio de precio fijo necesita un precio visible antes de publicarse.',
    fi: 'Kiinteähintainen ilmoitus tarvitsee näkyvän hinnan ennen julkaisua.',
  },

  'Create Listing': {
    en: 'Create Listing',
    bg: 'Създай обява',
    de: 'Anzeige erstellen',
    fr: 'Créer une annonce',
    ro: 'Creează listare',
    tr: 'İlan oluştur',
    sr: 'Креирај оглас',
    mk: 'Креирај оглас',
    hu: 'Hirdetés létrehozása',
    sk: 'Vytvoriť inzerát',
    sl: 'Ustvari oglas',
    es: 'Crear anuncio',
    fi: 'Luo ilmoitus',
  },

  'Publish a transport request using the same structured workflow used across partner operations.':
    {
      en: 'Publish a transport request using the same structured workflow used across partner operations.',
      bg: 'Публикувайте транспортна заявка със същия структуриран процес, използван от партньорите.',
      de: 'Veröffentlichen Sie eine Transportanfrage mit dem gleichen strukturierten Ablauf wie Partner.',
      fr: 'Publiez une demande de transport avec le même flux structuré utilisé par les partenaires.',
      ro: 'Publică o cerere de transport folosind același flux structurat ca partenerii.',
      tr: 'Partner operasyonlarında kullanılan yapılandırılmış akış ile taşıma talebi yayınla.',
      sr: 'Објавите захтев за транспорт користећи исти процес као партнери.',
      mk: 'Објавете транспортно барање со истата структура како партнерите.',
      hu: 'Tegyen közzé szállítási kérelmet a partnerekhez hasonló folyamattal.',
      sk: 'Zverejnite požiadavku na prepravu rovnakým spôsobom ako partneri.',
      sl: 'Objavite zahtevo za prevoz z enakim postopkom kot partnerji.',
      es: 'Publica una solicitud de transporte con el mismo flujo que los socios.',
      fi: 'Julkaise kuljetuspyyntö samalla prosessilla kuin kumppanit.',
    },

  'Select category': {
    en: 'Select category',
    bg: 'Изберете категория',
    de: 'Kategorie auswählen',
    fr: 'Sélectionner une catégorie',
    ro: 'Selectează categorie',
    tr: 'Kategori seç',
    sr: 'Изаберите категорију',
    mk: 'Изберете категорија',
    hu: 'Válasszon kategóriát',
    sk: 'Vyberte kategóriu',
    sl: 'Izberite kategorijo',
    es: 'Seleccionar categoría',
    fi: 'Valitse kategoria',
  },

  'Choose route': {
    en: 'Choose route',
    bg: 'Изберете маршрут',
    de: 'Route auswählen',
    fr: 'Choisir un itinéraire',
    ro: 'Alege rută',
    tr: 'Rota seç',
    sr: 'Изаберите руту',
    mk: 'Изберете рута',
    hu: 'Útvonal kiválasztása',
    sk: 'Vyberte trasu',
    sl: 'Izberi pot',
    es: 'Elegir ruta',
    fi: 'Valitse reitti',
  },

  'Status not set': {
    en: 'Status not set',
    bg: 'Статусът не е зададен',
    de: 'Status nicht festgelegt',
    fr: 'Statut non défini',
    ro: 'Status nesetat',
    tr: 'Durum ayarlanmadı',
    sr: 'Статус није постављен',
    mk: 'Статусот не е поставен',
    hu: 'Állapot nincs beállítva',
    sk: 'Stav nie je nastavený',
    sl: 'Status ni nastavljen',
    es: 'Estado no establecido',
    fi: 'Tila ei asetettu',
  },

  Items: {
    en: 'Items',
    bg: 'Артикули',
    de: 'Artikel',
    fr: 'Articles',
    ro: 'Articole',
    tr: 'Öğeler',
    sr: 'Ставке',
    mk: 'Ставки',
    hu: 'Tételek',
    sk: 'Položky',
    sl: 'Elementi',
    es: 'Artículos',
    fi: 'Tuotteet',
  },

  'VIN: {{vin}}': {
    en: 'VIN: {{vin}}',
    bg: 'VIN: {{vin}}',
    de: 'VIN: {{vin}}',
    fr: 'VIN : {{vin}}',
    ro: 'VIN: {{vin}}',
    tr: 'VIN: {{vin}}',
    sr: 'VIN: {{vin}}',
    mk: 'VIN: {{vin}}',
    hu: 'VIN: {{vin}}',
    sk: 'VIN: {{vin}}',
    sl: 'VIN: {{vin}}',
    es: 'VIN: {{vin}}',
    fi: 'VIN: {{vin}}',
  },

  'Pallet type: {{type}}': {
    en: 'Pallet type: {{type}}',
    bg: 'Тип палет: {{type}}',
    de: 'Palettentyp: {{type}}',
    fr: 'Type de palette : {{type}}',
    ro: 'Tip palet: {{type}}',
    tr: 'Palet türü: {{type}}',
    sr: 'Тип палете: {{type}}',
    mk: 'Тип палета: {{type}}',
    hu: 'Raklap típusa: {{type}}',
    sk: 'Typ palety: {{type}}',
    sl: 'Tip palete: {{type}}',
    es: 'Tipo de palé: {{type}}',
    fi: 'Lavatyppi: {{type}}',
  },

  'Material: {{type}}': {
    en: 'Material: {{type}}',
    bg: 'Материал: {{type}}',
    de: 'Material: {{type}}',
    fr: 'Matériau : {{type}}',
    ro: 'Material: {{type}}',
    tr: 'Malzeme: {{type}}',
    sr: 'Материјал: {{type}}',
    mk: 'Материјал: {{type}}',
    hu: 'Anyag: {{type}}',
    sk: 'Materiál: {{type}}',
    sl: 'Material: {{type}}',
    es: 'Material: {{type}}',
    fi: 'Materiaali: {{type}}',
  },

  'Special handling: {{details}}': {
    en: 'Special handling: {{details}}',
    bg: 'Специална обработка: {{details}}',
    de: 'Spezielle Handhabung: {{details}}',
    fr: 'Manipulation spéciale : {{details}}',
    ro: 'Manipulare specială: {{details}}',
    tr: 'Özel işlem: {{details}}',
    sr: 'Посебно руковање: {{details}}',
    mk: 'Специјално ракување: {{details}}',
    hu: 'Speciális kezelés: {{details}}',
    sk: 'Špeciálne zaobchádzanie: {{details}}',
    sl: 'Posebno ravnanje: {{details}}',
    es: 'Manipulación especial: {{details}}',
    fi: 'Erityiskäsittely: {{details}}',
  },

  'Freight type: {{type}}': {
    en: 'Freight type: {{type}}',
    bg: 'Тип товар: {{type}}',
    de: 'Frachttyp: {{type}}',
    fr: 'Type de fret : {{type}}',
    ro: 'Tip marfă: {{type}}',
    tr: 'Yük türü: {{type}}',
    sr: 'Тип терета: {{type}}',
    mk: 'Тип товар: {{type}}',
    hu: 'Rakomány típusa: {{type}}',
    sk: 'Typ nákladu: {{type}}',
    sl: 'Vrsta tovora: {{type}}',
    es: 'Tipo de carga: {{type}}',
    fi: 'Rahtityyppi: {{type}}',
  },

  'Weight: {{weight}} kg': {
    en: 'Weight: {{weight}} kg',
    bg: 'Тегло: {{weight}} kg',
    de: 'Gewicht: {{weight}} kg',
    fr: 'Poids : {{weight}} kg',
    ro: 'Greutate: {{weight}} kg',
    tr: 'Ağırlık: {{weight}} kg',
    sr: 'Тежина: {{weight}} kg',
    mk: 'Тежина: {{weight}} kg',
    hu: 'Súly: {{weight}} kg',
    sk: 'Hmotnosť: {{weight}} kg',
    sl: 'Teža: {{weight}} kg',
    es: 'Peso: {{weight}} kg',
    fi: 'Paino: {{weight}} kg',
  },

  'Volume: {{volume}} m³': {
    en: 'Volume: {{volume}} m³',
    bg: 'Обем: {{volume}} m³',
    de: 'Volumen: {{volume}} m³',
    fr: 'Volume : {{volume}} m³',
    ro: 'Volum: {{volume}} m³',
    tr: 'Hacim: {{volume}} m³',
    sr: 'Запремина: {{volume}} m³',
    mk: 'Волумен: {{volume}} m³',
    hu: 'Térfogat: {{volume}} m³',
    sk: 'Objem: {{volume}} m³',
    sl: 'Prostornina: {{volume}} m³',
    es: 'Volumen: {{volume}} m³',
    fi: 'Tilavuus: {{volume}} m³',
  },

  'Size: {{dimensions}}': {
    en: 'Size: {{dimensions}}',
    bg: 'Размер: {{dimensions}}',
    de: 'Größe: {{dimensions}}',
    fr: 'Taille : {{dimensions}}',
    ro: 'Dimensiune: {{dimensions}}',
    tr: 'Boyut: {{dimensions}}',
    sr: 'Величина: {{dimensions}}',
    mk: 'Големина: {{dimensions}}',
    hu: 'Méret: {{dimensions}}',
    sk: 'Veľkosť: {{dimensions}}',
    sl: 'Velikost: {{dimensions}}',
    es: 'Tamaño: {{dimensions}}',
    fi: 'Koko: {{dimensions}}',
  },

  'Floors: {{from}} to {{to}}': {
    en: 'Floors: {{from}} to {{to}}',
    bg: 'Етажи: {{from}} до {{to}}',
    de: 'Stockwerke: {{from}} bis {{to}}',
    fr: 'Étages : {{from}} à {{to}}',
    ro: 'Etaje: {{from}} la {{to}}',
    tr: 'Katlar: {{from}} - {{to}}',
    sr: 'Спратови: {{from}} до {{to}}',
    mk: 'Катови: {{from}} до {{to}}',
    hu: 'Emeletek: {{from}} - {{to}}',
    sk: 'Poschodia: {{from}} do {{to}}',
    sl: 'Nadstropja: {{from}} do {{to}}',
    es: 'Pisos: {{from}} a {{to}}',
    fi: 'Kerrokset: {{from}} - {{to}}',
  },

  origin: {
    en: 'origin',
    bg: 'начало',
    de: 'Ursprung',
    fr: 'origine',
    ro: 'origine',
    tr: 'başlangıç',
    sr: 'полазиште',
    mk: 'почеток',
    hu: 'eredet',
    sk: 'pôvod',
    sl: 'izvor',
    es: 'origen',
    fi: 'alkuperä',
  },

  destination: {
    en: 'destination',
    bg: 'дестинация',
    de: 'Ziel',
    fr: 'destination',
    ro: 'destinație',
    tr: 'varış',
    sr: 'одредиште',
    mk: 'дестинација',
    hu: 'cél',
    sk: 'cieľ',
    sl: 'cilj',
    es: 'destino',
    fi: 'määränpää',
  },

  'QTY {{quantity}}': {
    en: 'QTY {{quantity}}',
    bg: 'Брой {{quantity}}',
    de: 'Menge {{quantity}}',
    fr: 'Qté {{quantity}}',
    ro: 'Cant {{quantity}}',
    tr: 'Adet {{quantity}}',
    sr: 'Кол {{quantity}}',
    mk: 'Кол {{quantity}}',
    hu: 'Menny {{quantity}}',
    sk: 'Množ {{quantity}}',
    sl: 'Kol {{quantity}}',
    es: 'Cant {{quantity}}',
    fi: 'Määrä {{quantity}}',
  },

  'e.g. Wooden dining table': {
    en: 'e.g. Wooden dining table',
    bg: 'напр. Дървена маса за хранене',
    de: 'z.B. Holzes Esstisch',
    fr: 'ex. Table à manger en bois',
    ro: 'ex. Masă de lemn pentru sufragerie',
    tr: 'ör. Ahşap yemek masası',
    sr: 'npr. Drveni trpezarijski sto',
    mk: 'напр. Дрвен трпезариски сто',
    hu: 'pl. Fa étkezőasztal',
    sk: 'např. Dřevěný jídelní stůl',
    sl: 'npr. Lesena jedilna miza',
    es: 'ej. Mesa de comedor de madera',
    fi: 'esim. Puinen ruokapöytä',
  },

  'L cm': {
    en: 'L cm',
    bg: 'Д cm',
    de: 'L cm',
    fr: 'L cm',
    ro: 'L cm',
    tr: 'L cm',
    sr: 'Д cm',
    mk: 'Д cm',
    hu: 'H cm',
    sk: 'D cm',
    sl: 'D cm',
    es: 'L cm',
    fi: 'P cm',
  },
  'W cm': {
    en: 'W cm',
    bg: 'Ш cm',
    de: 'B cm',
    fr: 'l cm',
    ro: 'l cm',
    tr: 'G cm',
    sr: 'Ш cm',
    mk: 'Ш cm',
    hu: 'V cm',
    sk: 'Š cm',
    sl: 'Š cm',
    es: 'l cm',
    fi: 'L cm',
  },
  'H cm': {
    en: 'H cm',
    bg: 'В cm',
    de: 'H cm',
    fr: 'H cm',
    ro: 'H cm',
    tr: 'Y cm',
    sr: 'В cm',
    mk: 'В cm',
    hu: 'M cm',
    sk: 'V cm',
    sl: 'V cm',
    es: 'H cm',
    fi: 'K cm',
  },

  'Optional. Partners will see this as your target budget, but they can still send their own quote.':
    {
      en: 'Optional. Partners will see this as your target budget, but they can still send their own quote.',
      bg: 'По избор. Партньорите ще видят това като ваш цел бюджет, но все пак могат да изпратят свое собствено предложение.',
      de: 'Optional. Partner sehen dies als Ihr Zielbudget, können aber trotzdem ihr eigenes Angebot senden.',
      fr: 'Optionnel. Les partenaires verront cela comme votre budget cible, mais ils peuvent toujours envoyer leur propre devis.',
      ro: 'Opțional. Partenerii vor vedea acest lucru ca bugetul țintă, dar pot trimite în continuare propria ofertă.',
      tr: 'İsteğe bağlı. Ortaklar bunu hedef bütçeniz olarak görecekler, ancak yine de kendi tekliflerini gönderebilirler.',
      sr: 'Opcionalno. Partneri će ovo videti kao vaš ciljni budžet, ali i dalje mogu poslati svoju ponudu.',
      mk: 'Опционално. Партнерите ќе го видат ова како ваш целевиот буџет, но сепак можат да испратат своја понуда.',
      hu: 'Opcionális. A partnerek ezt célnak tekintik, de továbbra is küldhetnek saját ajánlatot.',
      sk: 'Voliteľné. Partneri to uvidí jako váš cílový rozpočet, ale stále mohou poslat svou vlastní nabídku.',
      sl: 'Neobvezno. Partnerji bodo to videli kot vaš ciljni proračun, vendar lahko še vedno pošljejo svojo ponudbo.',
      es: 'Opcional. Los socios verán esto como su presupuesto objetivo, pero aún pueden enviar su propia cotización.',
      fi: 'Valinnainen. Kumppanit näkevät tämän kohdebudjettina, mutta he voivat silti lähettää oman tarjouksensa.',
    },

  'Turn this off to publish a fixed-price listing that partners can accept directly.':
    {
      en: 'Turn this off to publish a fixed-price listing that partners can accept directly.',
      bg: 'Изключете това, за да публикувате обява с фиксирана цена, която партньорите могат да приемат директно.',
      de: 'Schalten Sie dies aus, um eine Festpreis-Anzeige zu veröffentlichen, die Partner direkt akzeptieren können.',
      fr: 'Désactivez ceci pour publier une annonce à prix fixe que les partenaires peuvent accepter directement.',
      ro: 'Dezactivați acest lucru pentru a publica o listare cu preț fix pe care partenerii o pot accepta direct.',
      tr: 'Bunu kapatın, böylece ortakların doğrudan kabul edebileceği sabit fiyatlı bir ilan yayınlayabilirsiniz.',
      sr: 'Isključite ovo da biste objavili oglas s fiksnom cenom koji partneri mogu direktno prihvatiti.',
      mk: 'Исклучете го ова за да објавите оглас со фиксна цена кој партнерите можат директно да го прифатат.',
      hu: 'Kapcsolja ki ezt a beállítást, hogy közzé tehessen egy fix árú hirdetést, amelyet a partnerek közvetlenül elfogadhatnak.',
      sk: 'Vypněte toto nastavení pro publikování inzerátu s pevnou cenou, který mohou partneři přímo přijmout.',
      sl: 'Izklopite to, da objavite oglas s fiksno ceno, ki ga lahko partnerji neposredno sprejmejo.',
      es: 'Desactiva esto para publicar un anuncio de precio fijo que los socios puedan aceptar directamente.',
      fi: 'Kytke tämä pois päältä julkaistaksesi kiinteähintaisen ilmoituksen, jonka kumppanit voivat hyväksyä suoraan.',
    },

  'Quotes are enabled. Partners can see this price as a target budget and still send their own offers.':
    {
      en: 'Quotes are enabled. Partners can see this price as a target budget and still send their own offers.',
      bg: 'Офертите са включени. Партньорите могат да видят тази цена като целеви бюджет и все пак да изпратят свои собствени оферти.',
      de: 'Angebote sind aktiviert. Partner können diesen Preis als Zielbudget sehen und trotzdem ihre eigenen Angebote senden.',
      fr: 'Les devis sont activés. Les partenaires peuvent voir ce prix comme un budget cible et peuvent toujours envoyer leurs propres offres.',
      ro: 'Ofertele sunt activate. Partenerii pot vedea acest preț ca un buget țintă și pot trimite în continuare propriile oferte.',
      tr: 'Teklifler etkin. Ortaklar bu fiyatı hedef bütçe olarak görebilir ve yine de kendi tekliflerini gönderebilirler.',
      sr: 'Ponuđene su omogućene. Partneri mogu videti ovu cenu kao ciljni budžet i i dalje slati svoje ponude.',
      mk: 'Понудите се овозможени. Партнерите можат да ја видат оваа цена како целен буџет и сепак да испратат свои понуди.',
      hu: 'Ajánlatok engedélyezve. A partnerek ezt az árat célnak tekintik, de továbbra is küldhetnek saját ajánlatot.',
      sk: 'Ponuky jsou povoleny. Partneři mohou vidět tuto cenu jako cílový rozpočet a stále mohou posílat své vlastní nabídky.',
      sl: 'Ponudbe so omogočene. Partnerji lahko vidijo to ceno kot ciljni proračun in še vedno pošljejo svoje ponudbe.',
      es: 'Las cotizaciones están habilitadas. Los socios pueden ver este precio como un presupuesto objetivo y aún pueden enviar sus propias ofertas.',
      fi: 'Tarjoukset ovat käytössä. Kumppanit voivat nähdä tämän hinnan kohdebudjettina ja silti lähettää omia tarjouksiaan.',
    },
  'Total volume (m³)': {
    en: 'Total volume (m³)',
    bg: 'Общ обем (m³)',
    de: 'Gesamtvolumen (m³)',
    fr: 'Volume total (m³)',
    ro: 'Volum total (m³)',
    tr: 'Toplam hacim (m³)',
    sr: 'Ukupni volumen (m³)',
    mk: 'Вкупен волумен (m³)',
    hu: 'Teljes térfogat (m³)',
    sk: 'Celkový objem (m³)',
    sl: 'Skupni volumen (m³)',
    es: 'Volumen total (m³)',
    fi: 'Kokonaisvolyymi (m³)',
  },
  'Dest. floor': {
    en: 'Dest. floor',
    bg: 'Етаж на дестинацията',
    de: 'Ziel Stock',
    fr: 'Étage de destination',
    ro: 'Etaj dest.',
    tr: 'Varış katı',
    sr: 'Одредишни спрат',
    mk: 'Дестинација кат',
    hu: 'Cél emelet',
    sk: 'Cílové patro',
    sl: 'Dest. nadstropje',
    es: 'Piso de destino',
    fi: 'Kohdekerros',
  },
  'Elevator at destination': {
    en: 'Elevator at destination',
    bg: 'Асансьор на дестинацията',
    de: 'Aufzug am Ziel',
    fr: 'Ascenseur à destination',
    ro: 'Lift la destinație',
    tr: 'Varışta asansör',
    sr: 'Лифт на одредишту',
    mk: 'Лифт на дестинација',
    hu: 'Lift a célhelyen',
    sk: 'Výtah v cíli',
    sl: 'Dvigalo na destinaciji',
    es: 'Ascensor en destino',
    fi: 'Hissi kohteessa',
  },
  'Elevator at origin': {
    en: 'Elevator at origin',
    bg: 'Асансьор в началото',
    de: 'Aufzug am Ursprung',
    fr: "Ascenseur à l'origine",
    ro: 'Lift la origine',
    tr: 'Başlangıçta asansör',
    sr: 'Лифт на полазишту',
    mk: 'Лифт на почеток',
    hu: 'Lift a kiindulási helyen',
    sk: 'Výtah v původu',
    sl: 'Dvigalo na izvoru',
    es: 'Ascensor en origen',
    fi: 'Hissi lähtöpisteessä',
  },
  'e.g. BMW 3 Series': {
    en: 'e.g. BMW 3 Series',
    bg: 'напр. BMW 3 Series',
    de: 'z.B. BMW 3er Reihe',
    fr: 'ex. BMW Série 3',
    ro: 'ex. BMW Seria 3',
    tr: 'ör. BMW 3 Serisi',
    sr: 'npr. BMW 3 Series',
    mk: 'напр. BMW 3 Series',
    hu: 'pl. BMW 3-as sorozat',
    sk: 'např. BMW 3 Series',
    sl: 'npr. BMW 3 Series',
    es: 'ej. BMW Serie 3',
    fi: 'esim. BMW 3-sarja',
  },
  'Partner quotes allowed': {
    en: 'Partner quotes allowed',
    bg: 'Позволени са оферти от партньори',
    de: 'Partnerangebote erlaubt',
    fr: 'Devis des partenaires autorisés',
    ro: 'Oferte de la parteneri permise',
    tr: 'Partner tekliflerine izin verilir',
    sr: 'Dozvoljene ponude partnera',
    mk: 'Дозволени се понуди од партнери',
    hu: 'Partneri ajánlatok engedélyezve',
    sk: 'Ponuky partnerov povolené',
    sl: 'Ponudbe partnerjev dovoljene',
    es: 'Se permiten ofertas de socios',
    fi: 'Kumppanien tarjoukset sallittu',
    el: 'Επιτρέπονται προσφορές συνεργατών',
  },
  'e.g. Dog': {
    en: 'e.g. Dog',
    bg: 'напр. Куче',
    de: 'z.B. Hund',
    fr: 'ex. Chien',
    ro: 'ex. Câine',
    tr: 'ör. Köpek',
    sr: 'npr. Pas',
    mk: 'напр. Куче',
    hu: 'pl. Kutya',
    sk: 'např. Pes',
    sl: 'npr. Pes',
    es: 'ej. Perro',
    fi: 'esim. Koira',
    el: 'π.χ. Σκύλος',
  },
  'e.g. Labrador': {
    en: 'e.g. Labrador',
    bg: 'напр. Лабрадор',
    de: 'z.B. Labrador',
    fr: 'ex. Labrador',
    ro: 'ex. Labrador',
    tr: 'ör. Labrador',
    sr: 'npr. Labrador',
    mk: 'напр. Лабрадор',
    hu: 'pl. Labrador',
    sk: 'např. Labrador',
    sl: 'npr. Labrador',
    es: 'ej. Labrador',
    fi: 'esim. Labrador',
    el: 'π.χ. Λαμπραντόρ',
  },
  'My Quote': {
    en: 'My Quote',
    bg: 'Моята оферта',
    de: 'Mein Angebot',
    fr: 'Mon offre',
    ro: 'Oferta mea',
    tr: 'Teklifim',
    sr: 'Moja ponuda',
    mk: 'Моја понуда',
    hu: 'Ajánlatom',
    sk: 'Moja ponuka',
    sl: 'Moja ponudba',
    es: 'Mi oferta',
    fi: 'Tarjoukseni',
    el: 'Η προσφορά μου',
  },
  'Review the offer currently visible to the client.': {
    en: 'Review the offer currently visible to the client.',
    bg: 'Прегледайте офертата, която в момента се вижда от клиента.',
    de: 'Prüfen Sie das Angebot, das dem Kunden aktuell angezeigt wird.',
    fr: 'Examinez l’offre actuellement visible pour le client.',
    ro: 'Revizuiește oferta vizibilă momentan clientului.',
    tr: 'Şu anda müşteriye görünen teklifi inceleyin.',
    sr: 'Pregledajte ponudu koja je trenutno vidljiva klijentu.',
    mk: 'Прегледајте ја понудата што моментално му е видлива на клиентоτ.',
    hu: 'Tekintse át azt az ajánlatot, amely jelenleg látható az ügyfél számára.',
    sk: 'Skontrolujte ponuku, ktorá je momentálne viditeľná pre klienta.',
    sl: 'Preglejte ponudbo, ki je trenutno vidna stranki.',
    es: 'Revisa la oferta visible actualmente para el cliente.',
    fi: 'Tarkista asiakkaalle tällä hetkellä näkyvä tarjous.',
    el: 'Ελέγξτε την προσφορά που είναι αυτή τη στιγμή ορατή στον πελάτη.',
  },
  'Fixed Price Listing': {
    en: 'Fixed Price Listing',
    bg: 'Заявка с фиксирана цена',
    de: 'Festpreisanfrage',
    fr: 'Demande à prix fixe',
    ro: 'Cerere cu preț fix',
    tr: 'Sabit fiyatlı talep',
    sr: 'Zahtev sa fiksnom cenom',
    mk: 'Нарачка со фиксна цена',
    hu: 'Fix árú kérés',
    sk: 'Dopyt s pevnou cenou',
    sl: 'Povpraševanje s fiksno ceno',
    es: 'Solicitud de precio fijo',
    fi: 'Kiinteähintainen tilaus',
    el: 'Καταχώριση σταθερής τιμής',
  },
  'Client fixed price': {
    en: 'Client fixed price',
    bg: 'Фиксирана цена на клиента',
    de: 'Fester Kundenpreis',
    fr: 'Prix fixe client',
    ro: 'Preț fix client',
    tr: 'Müşteri sabit fiyatı',
    sr: 'Fiksna cena klijenta',
    mk: 'Фиксна цена на клиентот',
    hu: 'Ügyfél fix ára',
    sk: 'Pevná cena klienta',
    sl: 'Fiksna cena stranke',
    es: 'Precio fijo del cliente',
    fi: 'Asiakkaan kiinteä hinta',
    el: 'Σταθερή τιμή πελάτη',
  },
  'Quote #{{count}}': {
    en: 'Quote #{{count}}',
    bg: 'Оферта №{{count}}',
    de: 'Angebot #{{count}}',
    fr: 'Offre n°{{count}}',
    ro: 'Ofertă #{{count}}',
    tr: 'Teklif #{{count}}',
    sr: 'Ponuda #{{count}}',
    mk: 'Понуда #{{count}}',
    hu: 'Ajánlat #{{count}}',
    sk: 'Ponuka #{{count}}',
    sl: 'Ponudba #{{count}}',
    es: 'Oferta #{{count}}',
    fi: 'Tarjous #{{count}}',
    el: 'Προσφορά #{{count}}',
  },
  'Transport Progress': {
    en: 'Transport Progress',
    bg: 'Напредък на транспорта',
    de: 'Transportfortschritt',
    fr: 'Progression du transport',
    ro: 'Progres transport',
    tr: 'Taşıma ilerlemesi',
    sr: 'Napredak transporta',
    mk: 'Напредок на транспортот',
    hu: 'Szállítási folyamat',
    sk: 'Priebeh prepravy',
    sl: 'Napredek prevoza',
    es: 'Progreso del transporte',
    fi: 'Kuljetuksen eteneminen',
    el: 'Πρόοδος μεταφοράς',
  },
  'Upload Final Docs & Mark Delivered': {
    en: 'Upload Final Docs & Mark Delivered',
    bg: 'Качи финални документи и маркирай като доставена',
    de: 'Enddokumente hochladen und als geliefert markieren',
    fr: 'Téléverser les documents finaux et marquer comme livré',
    ro: 'Încarcă documentele finale și marchează ca livrat',
    tr: 'Son belgeleri yükle ve teslim edildi olarak işaretle',
    sr: 'Otpremi završna dokumenta i označi kao isporučeno',
    mk: 'Постави финални документи и означи како испорачано',
    hu: 'Végleges dokumentumok feltöltése és kézbesítettként jelölés',
    sk: 'Nahrať finálne dokumenty a označiť ako doručené',
    sl: 'Naloži končne dokumente in označi kot dostavljeno',
    es: 'Sube los documentos finales y marca como entregado',
    fi: 'Lataa lopulliset asiakirjat ja merkitse toimitetuksi',
    el: 'Μεταφορτώστε τα τελικά έγγραφα & σημειώστε ως παραδομένο',
  },
  'Confirmed Transport': {
    en: 'Confirmed Transport',
    bg: 'Потвърден транспорт',
    de: 'Bestätigter Transport',
    fr: 'Transport confirmé',
    ro: 'Transport confirmat',
    tr: 'Onaylı taşıma',
    sr: 'Potvrđen transport',
    mk: 'Потврден транспорт',
    hu: 'Megerősített szállítás',
    sk: 'Potvrdená preprava',
    sl: 'Potrjen prevoz',
    es: 'Transporte confirmado',
    fi: 'Vahvistettu kuljetus',
    el: 'Επιβεβαιωμένη μεταφορά',
  },
  'Transport Documents': {
    en: 'Transport Documents',
    bg: 'Транспортни документи',
    de: 'Transportdokumente',
    fr: 'Documents de transport',
    ro: 'Documente de transport',
    tr: 'Taşıma belgeleri',
    sr: 'Transportna dokumenta',
    mk: 'Транспортни документи',
    hu: 'Szállításι dokumentumok',
    sk: 'Prepravné dokumenty',
    sl: 'Prevozni dokumenti',
    es: 'Documentos de transporte',
    fi: 'Kuljetusasiakirjat',
    el: 'Έγγραφα μεταφοράς',
  },
  'Proof of Pickup': {
    en: 'Proof of Pickup',
    bg: 'Доказателство за вземане',
    de: 'Abholnachweis',
    fr: 'Preuve d’enlèvement',
    ro: 'Dovadă de preluare',
    tr: 'Teslim alma kanıtı',
    sr: 'Dokaz o preuzimanju',
    mk: 'Доказ за подигање',
    hu: 'Átvételi igazolás',
    sk: 'Doklad o vyzdvihnutí',
    sl: 'Dokazilo o prevzemu',
    es: 'Comprobante de recogida',
    fi: 'Noudon todiste',
    el: 'Αποδεικτικό παραλαβής',
  },
  'Final Documents': {
    en: 'Final Documents',
    bg: 'Финални документи',
    de: 'Abschlussdokumente',
    fr: 'Documents finaux',
    ro: 'Documente finale',
    tr: 'Son belgeler',
    sr: 'Završna dokumenta',
    mk: 'Финални документи',
    hu: 'Végleges dokumentumok',
    sk: 'Finálne dokumenty',
    sl: 'Končni dokumenti',
    es: 'Documentos finales',
    fi: 'Lopulliset asiakirjat',
    el: 'Τελικά έγγραφα',
  },
  'Upload & Mark Picked Up': {
    en: 'Upload & Mark Picked Up',
    bg: 'Качи и маркирай като взета',
    de: 'Hochladen und als abgeholt markieren',
    fr: 'Téléverser et marquer comme enlevé',
    ro: 'Încarcă și marchează ca preluat',
    tr: 'Yükle ve teslim alındı olarak işaretle',
    sr: 'Otpremi i označi kao preuzeto',
    mk: 'Постави и означи како подигнато',
    hu: 'Feltöltés és átvettként jelölés',
    sk: 'Nahrať a označiť ako vyzdvihnuté',
    sl: 'Naloži in označi kot prevzeto',
    es: 'Subir y marcar como recogido',
    fi: 'Lataa ja merkitse noudetuksi',
    el: 'Μεταφόρτωση & Σήμανση ως Παραλήφθηκε',
  },
  'Upload & Mark Delivered': {
    en: 'Upload & Mark Delivered',
    bg: 'Качи и маркирай като доставена',
    de: 'Hochladen und als geliefert markieren',
    fr: 'Téléverser et marquer comme livré',
    ro: 'Încarcă și marchează ca livrat',
    tr: 'Yükle ve teslim edildi olarak işaretle',
    sr: 'Otpremi i označi kao isporučeno',
    mk: 'Постави и означи како испоραчано',
    hu: 'Feltöltés és kézbesítettként jelölés',
    sk: 'Nahrať a označiť ako doručené',
    sl: 'Naloži in označi kot dostavljeno',
    es: 'Subir y marcar como entregado',
    fi: 'Lataa ja merkitse toimitetuksi',
    el: 'Μεταφόρτωση & Σήμανση ως Παραδόθηκε',
  },
  'Delivery photos': {
    en: 'Delivery photos',
    bg: 'Снимки от доставката',
    de: 'Lieferfotos',
    fr: 'Photos de livraison',
    ro: 'Fotografii de livrare',
    tr: 'Teslimat fotoğrafları',
    sr: 'Fotografije isporuke',
    mk: 'Фотографии од испоρακα',
    hu: 'Kézbesítési fotók',
    sk: 'Fotografie doručenia',
    sl: 'Fotografije dostave',
    es: 'Fotos de entrega',
    fi: 'Toimituskuvat',
    el: 'Φωτογραφίες παράδοσης',
  },
  'Release Listing?': {
    en: 'Release Listing?',
    bg: 'Да освободите ли заявката?',
    de: 'Anfrage freigeben?',
    fr: 'Relâcher la demande ?',
    ro: 'Eliberați cererea?',
    tr: 'Talep bırakılsın mı?',
    sr: 'Osloboditi zahtev?',
    mk: 'Да се осλοбоди нарачката?',
    hu: 'Felszabadítja a kérést?',
    sk: 'Uvoľniť dopyt?',
    sl: 'Sprostiti povpraševanje?',
    es: '¿Liberar solicitud?',
    fi: 'Vapautetaanko tilaus?',
    el: 'Αποδέσμευση καταχώρισης;',
  },
  'Quotes on this listing': {
    en: 'Quotes on this listing',
    bg: 'Оферти по тази заявка',
    de: 'Angebote zu dieser Anfrage',
    fr: 'Offres sur cette demande',
    ro: 'Oferte pentru această cerere',
    tr: 'Bu talepteki teklifler',
    sr: 'Ponude za ovaj zahtev',
    mk: 'Понуди за оваа нарачка',
    hu: 'Ajánlatok ennél a kérésnél',
    sk: 'Ponuky pri tomto dopyte',
    sl: 'Ponudbe za to povpraševanje',
    es: 'Ofertas en esta solicitud',
    fi: 'Tarjoukset tästä tilauksesta',
    el: 'Προσφορές σε αυτήν την καταχώριση',
  },
  'Refresh to check the latest market activity.': {
    en: 'Refresh to check the latest market activity.',
    bg: 'Обновете, за да проверите последнаτα пазарна активност.',
    de: 'Aktualisieren Sie, um die neueste Marktaktivität zu prüfen.',
    fr: 'Actualisez pour vérifier la dernière activité du marché.',
    ro: 'Reîmprospăταți pentru a verifica ultima activitate de piață.',
    tr: 'En son pazar hareketlerini görmek için yenileyin.',
    sr: 'Osvežite da proverite najnoviju aktivnost tržišta.',
    mk: 'Освежете за да ја проверите најноваτα пазарна активност.',
    hu: 'Frissítsen a legfrissebb piaci aktivitás ellenőrzéséhez.',
    sk: 'Obnovte pre kontrolu najnovšej aktivity trhu.',
    sl: 'Osvežite za preverjanje najnovejše tržne aktivnosti.',
    es: 'Actualiza para revisar la actividad más reciente del mercado.',
    fi: 'Päivitä tarkistaaksesi uusimman markkina-aktiivisuuden.',
    el: 'Ανανεώστε για να δείτε την τελευταία δραστηριότητα της αγοράς.',
  },
  'This will negatively affect your reliability score.': {
    en: 'This will negatively affect your reliability score.',
    bg: 'Това ще повлияе негативно на вашия рейтинг за надеждност.',
    de: 'Dies wird Ihre Zuverlässigkeitsbewertung negativ beeinflussen.',
    fr: 'Cela affectera négativement votre score de fiabilité.',
    ro: 'Acest lucru va afecta negativ scorul dvs. de încredere.',
    tr: 'Bu, güvenilirlik puanınızı olumsuz etkileyecektir.',
    sr: 'Ovo će negativno uticati na vašu ocenu pouzdanosti.',
    mk: 'Ова негативно ќе влијае на вашиот рејтинг за доверливост.',
    hu: 'Ez negatívan befolyásolja a megbízhatósági pontszámát.',
    sk: 'To negatívne ovplyvní vaše hodnotenie spoľahlivosti.',
    sl: 'To bo negativno vplivalo na vašo oceno zanesljivosti.',
    es: 'Esto afectará negativamente tu puntuación de fiabilidad.',
    fi: 'Tämä vaikuttaa negatiivisesti luotettavuuspisteisiisi.',
    el: 'Αυτό θα επηρεάσει αρνητικά τη βαθμολογία αξιοπιστίας σας.',
  },
  'Keep it': {
    en: 'Keep it',
    bg: 'Запази я',
    de: 'Behalten',
    fr: 'La garder',
    ro: 'Păstreaz-o',
    tr: 'Kalsın',
    sr: 'Zadrži',
    mk: 'Задржи ја',
    hu: 'Megtartás',
    sk: 'Ponechať',
    sl: 'Obdrži',
    es: 'Mantenerla',
    fi: 'Pidä se',
    el: 'Κρατήστε το',
  },
  'Listing released. Your score has been penalised.': {
    en: 'Listing released. Your score has been penalised.',
    bg: 'Заявката е освободена. Рейтингът ви беше наказан.',
    de: 'Anfrage freigegeben. Ihre Punktzahl wurde reduziert.',
    fr: 'La demande a été relâchée. Votre score a été péναlisé.',
    ro: 'Cererea a fost eliberată. Scorul dvs. a fost penalizat.',
    tr: 'Talep bırakıldı. Puanınız düşürüldü.',
    sr: 'Zahtev je oslobođen. Vaš skor je kažnjen.',
    mk: 'Нарачкаτα е осλοбодена. Вашиот резултаτ е казνετ.',
    hu: 'A kérés felszabadítva. A pontszámát csökkentettük.',
    sk: 'Dopyt bol uvoľnený. Vaše skóre bolo penalizované.',
    sl: 'Povpraševanje je spροščeno. Vaša ocena je bila kaznovana.',
    es: 'La solicitud ha sido liberada. Tu puntuación ha sido penalizada.',
    fi: 'Tilaus vapautettu. Pisteitäsi on vähennetty.',
    el: 'Η καταχώριση αποδεσμεύτηκε. Η βαθμολογία σας έχει υποστεί ποινή.',
  },
  'Submit Quote': {
    en: 'Submit Quote',
    bg: 'Изпрати оферта',
    de: 'Angebot absenden',
    fr: 'Soumettre l’offre',
    ro: 'Trimite oferta',
    tr: 'Teklifi Gönder',
    sr: 'Pošalji ponudu',
    mk: 'Поτврди понуда',
    hu: 'Ajánlat beküldése',
    sk: 'Odeslat nabídku',
    sl: 'Oddaj ponudbo',
    es: 'Enviar oferta',
    fi: 'Lähetä tarjous',
    el: 'Υποβολή προσφοράς',
  },
  'Keep the offer tight and clear. The client will see pricing, message, dates, vehicle choice, and tracking commitment.':
    {
      en: 'Keep the offer tight and clear. The client will see pricing, message, dates, vehicle choice, and tracking commitment.',
      bg: 'Поддържайте оферτατα ясна и краτκα. Клиенτъτ ще вижда цена, съобщение, даτι, избор на превозно средство и ангажименτ за проследяване.',
      de: 'Halten Sie das Angebot klar und prägnant. Der Kunde sieht Preis, Nachricht, Daten, Fahrzeugauswahl und Tracking-Verpflichtung.',
      fr: 'Gardez l’offre claire et concise. Le client verra le prix, le message, les dates, le choix du véhicule et l’engagement de suivi.',
      ro: 'Păstrează oferta clară și concisă. Clientul va vedea prețul, mesajul, datele, alegerea vehiculului și angajamentul de urmărire.',
      tr: 'Teklifi kısa ve net tutun. Müşteri fiyat, mesaj, tarihler, araç seçimi ve takip taahhüdünü görecektir.',
      sr: 'Neka ponuda bude jasna i sažeta. Klijent će videti cenu, poruku, datume, izbor vozila i obavezu praćenja.',
      mk: 'Одржувајτε ја понуδατα јасна и краτκα. Клиенτοτ ще ги види цеνατα, пораγατα, δατυμιτε, избороτ на возиλο и обврскаτα за следење.',
      hu: 'Tartsa az ajánlatot tömören és világosan. Az ügyfél látni fogja az árat, üzenetet, dátumokat, jáρműválasztást és a követési kötelezettséget.',
      sk: 'Udržujte ponuku stručnú a jasnú. Klient uvidí cenu, správu, dátumy, výber vozidla a záväzok sledovania.',
      sl: 'Naj bo ponudba jasna in jedrnata. Stranka bo videla ceno, sporočilo, datume, izbiro vozila in zavezo za sledenje.',
      es: 'Mantén la oferta clara y concisa. El cliente verá el precio, el mensaje, las fechas, la elección del vehículo y el compromiso de seguimiento.',
      fi: 'Pidä tarjous selkeänä ja ytimekkäänä. Asiakas näkee hinnan, viestin, päivämäärät, ajoneuvovalinnan ja seurantasitoumuksen.',
      el: 'Κρατήστε την προσφορά σύντομη και σαφή. Ο πελάτης θα δει την τιμολόγηση, το μήνυμα, τις ημερομηνίες, την επιλογή οχήματος και τη δέσμευση παρακολούθησης.',
    },
  'Pick-up date': {
    en: 'Pick-up date',
    bg: 'Дата на вземане',
    de: 'Abholdatum',
    fr: 'Date d’enlèvement',
    ro: 'Data preluării',
    tr: 'Alım tarihi',
    sr: 'Datum preuzimanja',
    mk: 'Датум на подигање',
    hu: 'Felvétel dátuma',
    sk: 'Dátum vyzdvihnutia',
    sl: 'Datum prevzema',
    es: 'Fecha de recogida',
    fi: 'Noutopäivä',
    el: 'Ημερομηνία παραλαβής',
  },

  'Delivery date': {
    en: 'Delivery date',
    bg: 'Дата на доставка',
    de: 'Lieferdatum',
    fr: 'Date de livraison',
    ro: 'Data livrării',
    tr: 'Teslimat tarihi',
    sr: 'Datum isporuke',
    mk: 'Датум на испораκα',
    hu: 'Szállítás dátuma',
    sk: 'Dátum doručenia',
    sl: 'Datum dostave',
    es: 'Fecha de entrega',
    fi: 'Toimituspäivä',
    el: 'Ημερομηνία παράδοσης',
  },

  'Quote expiry date': {
    en: 'Quote expiry date',
    bg: 'Крайна дата на офертата',
    de: 'Ablaufdatum des Angebots',
    fr: 'Date d’expiration de l’offre',
    ro: 'Data expirării ofertei',
    tr: 'Teklif son geçerlilik tarihi',
    sr: 'Datum isteka ponude',
    mk: 'Датум на истекување на понудата',
    hu: 'Ajánlat lejárati dátuma',
    sk: 'Dátum expirácie ponuky',
    sl: 'Datum poteka ponudbe',
    es: 'Fecha de expiración de la oferta',
    fi: 'Tarjouksen voimassaoloaika päättyy',
    el: 'Ημερομηνία λήξης προσφοράς',
  },

  'Add quote to group': {
    en: 'Add quote to group',
    bg: 'Добави оферта към група',
    de: 'Angebot zur Gruppe hinzufügen',
    fr: 'Ajouter l’offre au groupe',
    ro: 'Adaugă oferta la grup',
    tr: 'Teklifi gruba ekle',
    sr: 'Dodaj ponudu u grupu',
    mk: 'Додај понуδα во група',
    hu: 'Ajánlat hozzáadása a csoporthoz',
    sk: 'Pridať ponuku do skupiny',
    sl: 'Dodaj ponudbo v skupino',
    es: 'Agregar oferta al grupo',
    fi: 'Lisää tarjous ryhmään',
    el: 'Προσθήκη προσφοράς στην ομάδα',
  },

  'Total gross price (paid by client)': {
    en: 'Total gross price (paid by client)',
    bg: 'Обща брутна цена (платена от клиента)',
    de: 'Gesamtbruttopreis (vom Kunden bezahlt)',
    fr: 'Prix brut total (payé par le client)',
    ro: 'Preț brut total (plătit de client)',
    tr: 'Toplam brüt fiyat (müşteri tarafından ödenir)',
    sr: 'Ukupna bruto cena (plaća klijent)',
    mk: 'Вкупна бруτο цеνα (платеνα од клиенτοτ)',
    hu: 'Teljes bruttó ár (az ügyfél fizeti)',
    sk: 'Celková hrubá cena (platí zákazník)',
    sl: 'Skupna bruto cena (plača stranka)',
    es: 'Precio bruto total (pagado por el cliente)',
    fi: 'Kokonaisbruttohinta (asiakas maksaa)',
    el: 'Συνολική μικτή τιμή (καταβάλλεται από τον πελάτη)',
  },

  'Enter a net quote': {
    en: 'Enter a net quote',
    bg: 'Въведете нетна оферта',
    de: 'Nettopreis eingeben',
    fr: 'Saisir un prix net',
    ro: 'Introduceți un preț net',
    tr: 'Net teklif girin',
    sr: 'Unesite neto ponudu',
    mk: 'Внесете нето понуδα',
    hu: 'Adja meg a nettó ajánlatot',
    sk: 'Zadajte čistú ponuku',
    sl: 'Vnesite neto ponudbo',
    es: 'Introduce un precio neto',
    fi: 'Syötä nettohinta',
    el: 'Εισαγάγετε μια καθαρή προσφορά',
  },

  'Your net quote': {
    en: 'Your net quote',
    bg: 'Вашата нетна оферτα',
    de: 'Ihr Nettopreis',
    fr: 'Votre prix net',
    ro: 'Prețul dvs. net',
    tr: 'Net teklifiniz',
    sr: 'Vaša neto ponuda',
    mk: 'Вашаτα неτο понуδα',
    hu: 'Az Ön nettó ajánlata',
    sk: 'Vaša čistá ponuka',
    sl: 'Vaša neto ponudba',
    es: 'Tu precio neto',
    fi: 'Nettohintasi',
    el: 'Η καθαρή προσφορά σας',
  },

  'VAT rate': {
    en: 'VAT rate',
    bg: 'ДДС ставка',
    de: 'MwSt.-Satz',
    fr: 'Taux de TVA',
    ro: 'Cota TVA',
    tr: 'KDV oranı',
    sr: 'Stopa PDV-a',
    mk: 'Стапка на ДДВ',
    hu: 'ÁFA kulcs',
    sk: 'Sadzba DPH',
    sl: 'Stopnja DDV',
    es: 'Tipo de IVA',
    fi: 'ALV-kanta',
    el: 'Συντελεστής ΦΠΑ',
  },

  'No quotes submitted yet for this listing.': {
    en: 'No quotes submitted yet for this listing.',
    bg: 'Все още няма подадени оферти за тази заявка.',
    de: 'Für diese Anfrage wurden noch keine Angebote abgegeben.',
    fr: 'Aucune offre n’a encore été soumise pour cette demande.',
    ro: 'Nu au fost încă trimise oferte pentru această cerere.',
    tr: 'Bu talep için henüz teklif gönderilmedi.',
    sr: 'Još uvek nema ponuda za ovaj zahtev.',
    mk: 'Сè уште нема поднесени понуди за оваа нарачка.',
    hu: 'Ehhez a kéréshez még nem érkezett ajánlat.',
    sk: 'Pre tento dopyt zatiaľ neboli predložené žiadne ponuky.',
    sl: 'Za to povpraševanje še ni bilo oddanih ponudb.',
    es: 'Aún no se han enviado ofertas para esta solicitud.',
    fi: 'Tähän tilaukseen ei ole vielä jätetty tarjouksια.',
    el: 'Δεν έχουν υποβληθεί ακόμη προσφορές για αυτήν την καταχώριση.',
  },

  'Quote description': {
    en: 'Quote description',
    bg: 'Описание на офертата',
    de: 'Angebotsbeschreibung',
    fr: 'Description de l’offre',
    ro: 'Descriere ofertă',
    tr: 'Teklif açıklaması',
    sr: 'Opis ponude',
    mk: 'Опис на понудаτα',
    hu: 'Ajánlat leírása',
    sk: 'Popis ponuky',
    sl: 'Opis ponudbe',
    es: 'Descripción de la oferta',
    fi: 'Tarjouksen kuvaus',
    el: 'Περιγραφή προσφοράς',
  },

  'You can add information about your quote here, e.g. cargo insurance, route planning, or loading approach.':
    {
      en: 'You can add information about your quote here, e.g. cargo insurance, route planning, or loading approach.',
      bg: 'Тук можете да добавите информация за офертата си, напр. застраховка на товара, планиране на маршрут или начин на товарене.',
      de: 'Hier können Sie Informationen zu Ihrem Angebot hinzufügen, z. B. Frachtversicherung, Routenplanung oder Ladeweise.',
      fr: 'Vous pouvez ajouter ici des informations sur votre offre, par ex. assurance cargo, planification d’itinéraire ou méthode de chargement.',
      ro: 'Puteți adăuga aici informații despre ofertă, de ex. asigurarea mărfii, planificarea rutei sau metoda de încărcare.',
      tr: 'Buraya teklifiniz hakkında bilgi ekleyebilirsiniz, örn. kargo sigortası, rota planlaması veya yükleme yöntemi.',
      sr: 'Ovde možete dodati informacije o svojoj ponudi, npr. osiguranje tereta, planiranje rute ili način utovara.',
      mk: 'Тука можете да додадете информации за вашаτα понуδα, на пр. осигурување на товар, планирање на руτα или начин на τοваρεње.',
      hu: 'Itt adhat meg információkat az ajánlatáról, pl. rakománybiztosítás, útvonaltervezés vagy rakodási mód.',
      sk: 'Tu môžete pridať informácie o svojej ponuke, napr. poistenie nákladu, plánovanie trasy alebo spôsob nakládky.',
      sl: 'Tukaj lahko dodate informacije o svoji ponudbi, npr. zavarovanje tovora, načrtovanje poti ali način nalaganja.',
      es: 'Aquí puedes añadir información sobre tu oferta, por ejemplo, seguro de carga, planificación de ruta o método de carga.',
      fi: 'Voit lisätä tähän tietoja tarjouksestasi, esim. kuljetusvakuutus, reittisuunnittelu tai lastaustapa.',
      el: 'Μπορείτε να προσθέσετε πληροφορίες σχετικά με την προσφορά σας εδώ, π.χ. ασφάλιση φορτίου, σχεδιασμό διαδρομής ή προσέγγιση φόρτωσης.',
    },

  'Enter net quote': {
    en: 'Enter net quote',
    bg: 'Въведете нетна оферта',
    de: 'Nettopreis eingeben',
    fr: 'Saisir un prix net',
    ro: 'Introduceți prețul net',
    tr: 'Net teklif girin',
    sr: 'Unesite neto ponudu',
    mk: 'Внесете неτο понуδα',
    hu: 'Adja meg a nettó ajánlatot',
    sk: 'Zadajte čistú ponuku',
    sl: 'Vnesite neto ponudbo',
    es: 'Introduce el precio neto',
    fi: 'Syötä nettohinta',
    el: 'Εισαγάγετε καθαρή προσφορά',
  },

  'Minimum quote (net)': {
    en: 'Minimum quote (net)',
    bg: 'Минимална оферта (нето)',
    de: 'Mindestangebot (netto)',
    fr: 'Offre minimale (net)',
    ro: 'Ofertă minimă (net)',
    tr: 'Minimum teklif (net)',
    sr: 'Minimalna ponuda (neto)',
    mk: 'Минимална понуδα (нето)',
    hu: 'Minimum ajánlat (nettó)',
    sk: 'Minimálna ponuka (netto)',
    sl: 'Minimalna ponudba (neto)',
    es: 'Oferta mínima (neta)',
    fi: 'Vähimmäistarjous (netto)',
    el: 'Ελάχιστη προσφορά (καθαρή)',
  },

  'Do not include your contact information.': {
    en: 'Do not include your contact information.',
    bg: 'Не включвайте вашаτα контактна информация.',
    de: 'Geben Sie keine Kontaktinformationen an.',
    fr: 'N’incluez pas vos coordonnées.',
    ro: 'Nu includeți informațiile dvs. de contact.',
    tr: 'İletişim bilgilerinizi eklemeyin.',
    sr: 'Ne uključujte svoje kontakt podatke.',
    mk: 'Не ги вклучувајτε вашите конτακτ инφορμαции.',
    hu: 'Ne adja meg az elérhetőségeit.',
    sk: 'Neuvádzajte svoje kontaktné údaje.',
    sl: 'Ne vključujte svojih kontaktnih podatkov.',
    es: 'No incluyas tu información de contacto.',
    fi: 'Älä lisää yhteystietojasi.',
    el: 'Μην συμπεριλάβετε τα στοιχεία επικοινωνίας σας.',
  },

  'Back to search': {
    en: 'Back to search',
    bg: 'Обратно към търсенето',
    de: 'Zurück zur Suche',
    fr: 'Retour à la recherche',
    ro: 'Înapoi la căutare',
    tr: 'Aramaya dön',
    sr: 'Nazad na pretragu',
    mk: 'Назад кон пребарување',
    hu: 'Vissza a kereséshez',
    sk: 'Späť na vyhľadávanie',
    sl: 'Nazaj na iskanje',
    es: 'Volver a la búsqueda',
    fi: 'Takaisin hakuun',
    el: 'Επιστροφή στην αναζήτηση',
  },
  'Show details': {
    en: 'Show details',
    bg: 'Покажи детайли',
    de: 'Details anzeigen',
    fr: 'Afficher les détails',
    ro: 'Afișează detalii',
    tr: 'Detayları göster',
    sr: 'Prikaži detalje',
    mk: 'Приκαжи δетали',
    hu: 'Részletek megjelenítése',
    sk: 'Zobraziť detaily',
    sl: 'Prikaži podrobnosti',
    es: 'Mostrar detalles',
    fi: 'Näytä tiedot',
    el: 'Εμφάνιση λεπτομερειών',
  },

  'Hide details': {
    en: 'Hide details',
    bg: 'Скрий детайли',
    de: 'Details ausblenden',
    fr: 'Masquer les détails',
    ro: 'Ascunde detalii',
    tr: 'Detayları gizle',
    sr: 'Sakrij detalje',
    mk: 'Скриј детали',
    hu: 'Részletek elrejtése',
    sk: 'Skryť detaily',
    sl: 'Skrij podrobnosti',
    es: 'Ocultar detalles',
    fi: 'Piilota tiedot',
    el: 'Απόκρυψη λεπτομερειών',
  },

  "I'm going to share shipment tracking information": {
    en: "I'm going to share shipment tracking information",
    bg: 'Ще споделя информация за проследяване на пратκατα',
    de: 'Ich werde Sendungsverfolgungsinformationen teilen',
    fr: 'Je vais partager les informations de suivi de l’expédition',
    ro: 'Voi partaja informații de urmărire a transportului',
    tr: 'Gönderi takip bilgilerini paylaşacağım',
    sr: 'Podeliću informacije o praćenju pošiljke',
    mk: 'Ќе споделам информации за следење на праткаτα',
    hu: 'Megosztom a szállítmány követési adatait',
    sk: 'Zdieľam informácie o sledovaní zásielky',
    sl: 'Delil bom informacije o sledenju pošiljke',
    es: 'Voy a compartir la información de seguimiento del envío',
    fi: 'Aion jakaa lähetyksen seurantatiedot',
    el: 'Θα μοιραστώ πληροφορίες παρακολούθησης αποστολής',
  },

  'Use the information in future quotes': {
    en: 'Use the information in future quotes',
    bg: 'Използвай информацияτα в бъдещи оферти',
    de: 'Verwenden Sie die Informationen in zukünftigen Angeboten',
    fr: 'Utiliser les informations dans les futures offres',
    ro: 'Folosește informațiile în ofertele viitoare',
    tr: 'Bilgileri gelecekteki tekliflerde kullan',
    sr: 'Koristi informacije u budućim ponudama',
    mk: 'Користи ги инφορμαциите во идни понуди',
    hu: 'Használja az információkat a jövőbeli ajánlatokban',
    sk: 'Použite informácie v budúcich ponukách',
    sl: 'Uporabi informacije v prihodnjih ponudbah',
    es: 'Usar la información en futuras ofertas',
    fi: 'Käytä tietoja tulevissa tarjouksissa',
    el: 'Χρησιμοποιήστε τις πληροφορίες σε μελλοντικές προσφορές',
  },

  '{{count}} day(s) left': {
    en: '{{count}} day(s) left',
    bg: 'Остават {{count}} ден(дни)',
    de: '{{count}} Tag(e) übrig',
    fr: '{{count}} jour(s) restant(s)',
    ro: '{{count}} zi(le) rămase',
    tr: '{{count}} gün kaldı',
    sr: 'Preostalo {{count}} dan(a)',
    mk: 'Остануваατ {{count}} ден(а)',
    hu: '{{count}} nap van hátra',
    sk: 'Zostáva {{count}} deň(dní)',
    sl: 'Preostalo {{count}} dni',
    es: 'Quedan {{count}} día(s)',
    fi: '{{count}} päivää jäljellä',
    el: '{{count}} ημέρα(ες) απομένουν',
  },

  'Ask AI': {
    en: 'Ask AI',
    bg: 'Попитай AI',
    de: 'Fragen Sie KI',
    fr: 'Demandez à l’IA',
    ro: 'Întreabă AI',
    tr: 'Yapay Zekaya Sor',
    sr: 'Pitaj AI',
    mk: 'Питај AI',
    hu: 'Kérdezd az AI-t',
    sk: 'Zeptej se AI',
    sl: 'Vprašaj AI',
    es: 'Preguntar a la IA',
    fi: 'Kysy tekoälyltä',
    el: 'Ρωτήστε το AI',
  },

  'Confirm Quote': {
    en: 'Confirm Quote',
    bg: 'Потвърди офертата',
    de: 'Angebot bestätigen',
    fr: 'Confirmer l’offre',
    ro: 'Confirmă oferta',
    tr: 'Teklifi Onayla',
    sr: 'Potvrdi ponudu',
    mk: 'Поτврди понуда',
    hu: 'Ajánlat megerősítése',
    sk: 'Potvrdiť ponuku',
    sl: 'Potrdi ponudbo',
    es: 'Confirmar oferta',
    fi: 'Vahvista tarjous',
    el: 'Επιβεβαίωση προσφοράς',
  },

  'Enter a valid net price': {
    en: 'Enter a valid net price',
    bg: 'Въведете валидна нетна цена',
    de: 'Geben Sie einen gültigen Nettopreis ein',
    fr: 'Entrez un prix net valide',
    ro: 'Introduceți un preț net valid',
    tr: 'Geçerli bir net fiyat girin',
    sr: 'Unesite važeću neto cenu',
    mk: 'Внесеτε валиδна неτο цена',
    hu: 'Adjon meg egy érvényes nettó árat',
    sk: 'Zadajte platnú čistú cenu',
    sl: 'Vnesite veljavno neto ceno',
    es: 'Introduce un precio neto válido',
    fi: 'Syötä kelvollinen nettohinta',
    el: 'Εισαγάγετε μια έγκυρη καθαρή τιμή',
  },
  'Completed Deliveries': {
    en: 'Completed Deliveries',
    bg: 'Завършени доставки',
    de: 'Abgeschlossene Lieferungen',
    fr: 'Livraisons terminées',
    ro: 'Livrări finalizate',
    tr: 'Tamamlanan teslimatlar',
    sr: 'Završene isporuke',
    mk: 'Завршени достави',
    hu: 'Befejezett szállítások',
    sk: 'Dokončené dodávky',
    sl: 'Končane dostave',
    es: 'Entregas completadas',
    fi: 'Valmiit toimitukset',
    el: 'Ολοκληρωμένες παραδόσεις',
  },
  'History of your successfully delivered transport requests.': {
    en: 'History of your successfully delivered transport requests.',
    bg: 'История на вашите успешно доставени транспортни заявки.',
    de: 'Historie Ihrer erfolgreich zugestellten Transportaufträge.',
    fr: 'Historique de vos demandes de transport livrées avec succès.',
    ro: 'Istoricul cererilor de transport livrate cu succes.',
    tr: 'Başarıyla teslim edilen taşıma taleplerinizin geçmişi.',
    sr: 'Istorija vaših uspešno dostavljenih transportnih zahteva.',
    mk: 'Историја на вашите успешно доставени транспортни барања.',
    hu: 'A sikeresen kézbesített szállítási kérelmek előzményei.',
    sk: 'História vašich úspešne doručených prepravných požiadaviek.',
    sl: 'Zgodovina vaših uspešno dostavljenih prevoznih zahtevkov.',
    es: 'Historial de sus solicitudes de transporte entregadas con éxito.',
    fi: 'Onnistuneesti toimitettujen kuljetuspyyntöjesi historia.',
    el: 'Ιστορικό των επιτυχώς παραδοθέντων αιτημάτων μεταφοράς σας.',
  },
  'Loading deliveries...': {
    en: 'Loading deliveries...',
    bg: 'Зареждане на доставки...',
    de: 'Lieferungen werden geladen...',
    fr: 'Chargement des livraisons...',
    ro: 'Se încarcă livrările...',
    tr: 'Teslimatlar yükleniyor...',
    sr: 'Učitavanje isporuka...',
    mk: 'Вчитување на достави...',
    hu: 'Szállítások betöltése...',
    sk: 'Načítavanie dodávok...',
    sl: 'Nalaganje dostav...',
    es: 'Cargando entregas...',
    fi: 'Ladataan toimituksia...',
    el: 'Φόρτωση παραδόσεων...',
  },
  '{{count}} completed deliveries': {
    en: '{{count}} completed deliveries',
    bg: '{{count}} завършени доставки',
    de: '{{count}} abgeschlossene Lieferungen',
    fr: '{{count}} livraisons terminées',
    ro: '{{count}} livrări finalizate',
    tr: '{{count}} tamamlanan teslimat',
    sr: '{{count}} završene isporuke',
    mk: '{{count}} завршени достави',
    hu: '{{count}} befejezett szállítás',
    sk: '{{count}} dokončených dodávok',
    sl: '{{count}} končanih dostav',
    es: '{{count}} entregas completadas',
    fi: '{{count}} valmista toimitusta',
    el: '{{count}} ολοκληρωμένες παραδόσεις',
  },
  'Loading completed deliveries...': {
    en: 'Loading completed deliveries...',
    bg: 'Зареждане на завършени доставки...',
    de: 'Abgeschlossene Lieferungen werden geladen...',
    fr: 'Chargement des livraisons terminées...',
    ro: 'Se încarcă livrările finalizate...',
    tr: 'Tamamlanan teslimatlar yükleniyor...',
    sr: 'Učitavanje završenih isporuka...',
    mk: 'Вчитување на завршени достави...',
    hu: 'Befejezett szállítások betöltése...',
    sk: 'Načítavanie dokončených dodávok...',
    sl: 'Nalaganje končanih dostav...',
    es: 'Cargando entregas completadas...',
    fi: 'Ladataan valmiita toimituksia...',
    el: 'Φόρτωση ολοκληρωμένων παραδόσεων...',
  },
  'No completed listings': {
    en: 'No completed listings',
    bg: 'Няма завършени обяви',
    de: 'Keine abgeschlossenen Angebote',
    fr: 'Aucune annonce terminée',
    ro: 'Nu există anunțuri finalizate',
    tr: 'Tamamlanan ilan yok',
    sr: 'Nema završenih oglasa',
    mk: 'Нема завршени огласи',
    hu: 'Nincsenek befejezett hirdetések',
    sk: 'Žiadne dokončené ponuky',
    sl: 'Ni končanih oglasov',
    es: 'No hay anuncios completados',
    fi: 'Ei valmiita ilμοituksia',
    el: 'Δεν υπάρχουν ολοκληρωμένες καταχωρίσεις',
  },
  'You have no completed deliveries yet.': {
    en: 'You have no completed deliveries yet.',
    bg: 'Все още нямате завършени доставки.',
    de: 'Sie haben noch keine abgeschlossenen Lieferungen.',
    fr: "Vous n'avez pas encore de livraisons terminées.",
    ro: 'Nu aveți încă livrări finalizate.',
    tr: 'Henüz tamamlanmış bir teslimatınız yok.',
    sr: 'Još uvek nemate završenih isporuka.',
    mk: 'Сè уште немате завршени достави.',
    hu: 'Még nincsenek befejezett szállításai.',
    sk: 'Ešte nemáte žiadne dokončené dodávky.',
    sl: 'Še nimate končanih dostav.',
    es: 'Aún no tiene entregas completadas.',
    fi: 'Sinulla ei ole vielä valmiita toimituksia.',
    el: 'Δεν έχετε ακόμη ολοκληρωμένες παραδόσεις.',
  },
  'Added to watchlist': {
    en: 'Added to watchlist',
    bg: 'Добавено към списъка за следене',
    de: 'Zur Beobachtungsliste hinzugefügt',
    fr: 'Ajouté à la liste de suivi',
    ro: 'Adăugat în lista de urmărire',
    tr: 'İzleme listesine eklendi',
    sr: 'Dodato na listu praćenja',
    mk: 'Додадено во списокот за следење',
    hu: 'Hozzáadva a figyelőlistához',
    sk: 'Pridané do sledovaného zoznamu',
    sl: 'Dodano na seznam za spremljanje',
    es: 'Añadido a la lista de seguimiento',
    fi: 'Lisätty seurantalistalle',
    el: 'Προστέθηκε στη λίστα παρακολούθησης',
  },

  'Removed from watchlist': {
    en: 'Removed from watchlist',
    bg: 'Премахнато от списъка за следене',
    de: 'Aus der Beobachtungsliste entfernt',
    fr: 'Retiré de la liste de suivi',
    ro: 'Eliminat din lista de urmărire',
    tr: 'İzleme listesinden kaldırıldı',
    sr: 'Uklonjeno sa liste praćenja',
    mk: 'Отстрането од списокот за следење',
    hu: 'Eltávolítva a figyelőlistáról',
    sk: 'Odstránené zo sledovaného zoznamu',
    sl: 'Odstranjeno s seznama za spremljanje',
    es: 'Eliminado de la lista de seguimiento',
    fi: 'Poistettu seurantalistalta',
    el: 'Αφαιρέθηκε από τη λίστα παρακολούθησης',
  },
  'Quote submitted': {
    en: 'Quote submitted',
    bg: 'Офертата е изпратена',
    de: 'Angebot gesendet',
    fr: 'Offre soumise',
    ro: 'Oferta a fost trimisă',
    tr: 'Teklif gönderildi',
    sr: 'Ponuda je poslata',
    mk: 'Понуδατα е испраτενα',
    hu: 'Ajánlat elküldve',
    sk: 'Ponuka odoslaná',
    sl: 'Ponudba oddana',
    es: 'Oferta enviada',
    fi: 'Tarjous lähetetty',
    el: 'Η προσφορά υποβλήθηκε',
  },

  'Update Quote': {
    en: 'Update Quote',
    bg: 'Актуализирай офертата',
    de: 'Angebot aktualisieren',
    fr: 'Mettre à jour l’offre',
    ro: 'Actualizează oferta',
    tr: 'Teklifi güncelle',
    sr: 'Ažuriraj ponudu',
    mk: 'Ажурирај понуδα',
    hu: 'Ajánlat frissítése',
    sk: 'Aktualizovať ponuku',
    sl: 'Posodobi ponudbo',
    es: 'Actualizar oferta',
    fi: 'Päivitä tarjous',
    el: 'Ενημέρωση προσφοράς',
  },

  'status.draft': {
    en: 'Draft',
    bg: 'Чернова',
    de: 'Entwurf',
    fr: 'Brouillon',
    ro: 'Ciornă',
    tr: 'Taslak',
    sr: 'Nacrt',
    mk: 'Нацрт',
    hu: 'Piszkozat',
    sk: 'Návrh',
    sl: 'Osnutek',
    es: 'Borrador',
    fi: 'Luonnos',
    el: 'Προσχέδιο',
  },

  'status.open': {
    en: 'Open',
    bg: 'Отворена',
    de: 'Offen',
    fr: 'Ouvert',
    ro: 'Deschis',
    tr: 'Açık',
    sr: 'Otvoreno',
    mk: 'Отворено',
    hu: 'Nyitott',
    sk: 'Otvorené',
    sl: 'Odprto',
    es: 'Abierto',
    fi: 'Avoin',
    el: 'Ανοιχτό',
  },

  'status.has_quotes': {
    en: 'Has Quotes',
    bg: 'Има оферти',
    de: 'Hat Angebote',
    fr: 'A des offres',
    ro: 'Are oferte',
    tr: 'Teklif var',
    sr: 'Ima ponude',
    mk: 'Има понуди',
    hu: 'Van ajánlat',
    sk: 'Má ponuky',
    sl: 'Ima ponudbe',
    es: 'Tiene ofertas',
    fi: 'Tarjouksia saatavilla',
    el: 'Έχει προσφορές',
  },

  'status.accepted': {
    en: 'Accepted',
    bg: 'Приета',
    de: 'Akzeptiert',
    fr: 'Accepté',
    ro: 'Acceptat',
    tr: 'Kabul edildi',
    sr: 'Prihvaćeno',
    mk: 'Прифатено',
    hu: 'Elfogadva',
    sk: 'Prijaté',
    sl: 'Sprejeto',
    es: 'Aceptado',
    fi: 'Hyväksytty',
    el: 'Αποδεκτό',
  },

  'status.awaiting_payment': {
    en: 'Awaiting Payment',
    bg: 'Очаква плащане',
    de: 'Warten auf Zahlung',
    fr: 'En attente de paiement',
    ro: 'În așteptarea plății',
    tr: 'Ödeme bekleniyor',
    sr: 'Čeka uplatu',
    mk: 'Чеκα плаќање',
    hu: 'Fizetésre vár',
    sk: 'Čaká na platbu',
    sl: 'Čaka na plačilo',
    es: 'En espera de pago',
    fi: 'Odottaa maksua',
    el: 'Αναμονή πληρωμής',
  },

  'status.paid': {
    en: 'Paid',
    bg: 'Платена',
    de: 'Bezahlt',
    fr: 'Payé',
    ro: 'Plătit',
    tr: 'Ödendi',
    sr: 'Plaćeno',
    mk: 'Платеνο',
    hu: 'Kifizetve',
    sk: 'Zaplatené',
    sl: 'Plačano',
    es: 'Pagado',
    fi: 'Maksettu',
    el: 'Πληρωμένο',
  },

  'status.planned': {
    en: 'Planned',
    bg: 'Планирана',
    de: 'Geplant',
    fr: 'Planifié',
    ro: 'Planificat',
    tr: 'Planlandı',
    sr: 'Planirano',
    mk: 'Планирано',
    hu: 'Tervezett',
    sk: 'Plánované',
    sl: 'Načrtovano',
    es: 'Planificado',
    fi: 'Suunniteltu',
    el: 'Προγραμματισμένο',
  },

  'status.in_transit': {
    en: 'In Transit',
    bg: 'В транспорт',
    de: 'Unterwegs',
    fr: 'En transit',
    ro: 'În tranzit',
    tr: 'Yolda',
    sr: 'U transportu',
    mk: 'Во транспорт',
    hu: 'Szállítás alatt',
    sk: 'V preprave',
    sl: 'V prevozu',
    es: 'En tránsito',
    fi: 'Kuljetuksessa',
    el: 'Σε μεταφορά',
  },

  'status.pickedUp': {
    en: 'Picked Up',
    bg: 'Взета',
    de: 'Abgeholt',
    fr: 'Enlevé',
    ro: 'Preluat',
    tr: 'Alındı',
    sr: 'Preuzeto',
    mk: 'Подигнаτο',
    hu: 'Felvéve',
    sk: 'Vyzvihnuté',
    sl: 'Prevzeto',
    es: 'Recogido',
    fi: 'Noudettu',
    el: 'Παραλήφθηκε',
  },

  'status.delivered': {
    en: 'Delivered',
    bg: 'Доставена',
    de: 'Zugestellt',
    fr: 'Livré',
    ro: 'Livrat',
    tr: 'Teslim edildi',
    sr: 'Isporučeno',
    mk: 'Испоραчано',
    hu: 'Kézbesítve',
    sk: 'Doručené',
    sl: 'Dostavljeno',
    es: 'Entregado',
    fi: 'Toimitettu',
    el: 'Παραδόθηκε',
  },

  'status.completed': {
    en: 'Completed',
    bg: 'Завършена',
    de: 'Abgeschlossen',
    fr: 'Terminé',
    ro: 'Finalizat',
    tr: 'Tamamlandı',
    sr: 'Završeno',
    mk: 'Завршено',
    hu: 'Befejezve',
    sk: 'Dokončené',
    sl: 'Zaključeno',
    es: 'Completado',
    fi: 'Valmis',
    el: 'Ολοκληρώθηκε',
  },

  'status.canceled': {
    en: 'Canceled',
    bg: 'Отказана',
    de: 'Storniert',
    fr: 'Annulé',
    ro: 'Anulat',
    tr: 'İptal edildi',
    sr: 'Otkazano',
    mk: 'Оτкажано',
    hu: 'Törölve',
    sk: 'Zrušené',
    sl: 'Preklicano',
    es: 'Cancelado',
    fi: 'Peruutettu',
    el: 'Ακυρώθηκε',
  },

  'status.expired': {
    en: 'Expired',
    bg: 'Изтекла',
    de: 'Abgelaufen',
    fr: 'Expiré',
    ro: 'Expirat',
    tr: 'Süresi doldu',
    sr: 'Isteklo',
    mk: 'Истечено',
    hu: 'Lejárt',
    sk: 'Vypršané',
    sl: 'Poteklo',
    es: 'Expirado',
    fi: 'Vanhentunut',
    el: 'Έληξε',
  },

  'status.unknown': {
    en: 'Unknown',
    bg: 'Неизвестно',
    de: 'Unbekannt',
    fr: 'Inconnu',
    ro: 'Necunoscut',
    tr: 'Bilinmiyor',
    sr: 'Nepoznato',
    mk: 'Непознаτο',
    hu: 'Ismeretlen',
    sk: 'Neznáme',
    sl: 'Neznano',
    es: 'Desconocido',
    fi: 'Tuntematon',
    el: 'Άγνωστο',
  },

  'Choose from fleet': {
    en: 'Choose from fleet',
    bg: 'Избери от автопарка',
    de: 'Aus der Flotte wählen',
    fr: 'Choisir dans la flotte',
    ro: 'Alege din flotă',
    tr: 'Filodan seç',
    sr: 'Izaberi iz flote',
    mk: 'Избеρι од возниοτ парк',
    hu: 'Válasszon a flottából',
    sk: 'Vybrať z flotily',
    sl: 'Izberi iz voznega parka',
    es: 'Elegir de la flota',
    fi: 'Valitse kalustosta',
    el: 'Επιλέξτε από τον στόλο',
  },

  'nav.signIn': {
    en: 'Sign In',
    bg: 'Вход',
    de: 'Anmelden',
    fr: 'Connexion',
    ro: 'Autentificare',
    tr: 'Giriş',
    sr: 'Prijava',
    mk: 'Најава',
    hu: 'Bejelentkezés',
    sk: 'Prihlásiť sa',
    sl: 'Prijava',
    es: 'Iniciar sesión',
    fi: 'Kirjaudu sisään',
    el: 'Είσοδος',
  },

  'nav.forgotPassword': {
    en: 'Forgot Password',
    bg: 'Забравена парола',
    de: 'Passwort vergessen',
    fr: 'Mot de passe oublié',
    ro: 'Parolă uitată',
    tr: 'Şifremi unuttum',
    sr: 'Zaboravljena lozinka',
    mk: 'Заборавена лозинка',
    hu: 'Elfelejtett jelszó',
    sk: 'Zabudnuté heslo',
    sl: 'Pozabljeno geslo',
    es: 'Olvidé mi contraseña',
    fi: 'Unohtunut salasana',
    el: 'Ξέχασα τον κωδικό πρόσβασης',
  },

  'nav.dashboard': {
    en: 'Dashboard',
    bg: 'Табло',
    de: 'Dashboard',
    fr: 'Tableau de bord',
    ro: 'Panou de control',
    tr: 'Panel',
    sr: 'Kontrolna tabla',
    mk: 'Конτροлна τабла',
    hu: 'Iράνγιτόπult',
    sk: 'Prehľad',
    sl: 'Nadzorna plošča',
    es: 'Panel',
    fi: 'Hallintapaneeli',
    el: 'Πίνακας ελέγχου',
  },

  'nav.profile': {
    en: 'Profile',
    bg: 'Профил',
    de: 'Profil',
    fr: 'Profil',
    ro: 'Profil',
    tr: 'Profil',
    sr: 'Profil',
    mk: 'Проφил',
    hu: 'Profil',
    sk: 'Profil',
    sl: 'Profil',
    es: 'Perfil',
    fi: 'Profiili',
    el: 'Προφίλ',
  },

  'nav.createListing': {
    en: 'Create Listing',
    bg: 'Създай заявка',
    de: 'Anfrage erstellen',
    fr: 'Créer une demande',
    ro: 'Creează cerere',
    tr: 'Talep oluştur',
    sr: 'Kreiraj zahtev',
    mk: 'Креирај нарачка',
    hu: 'Kérés létrehozása',
    sk: 'Vytvoriť dopyt',
    sl: 'Ustvari povpraševanje',
    es: 'Crear solicitud',
    fi: 'Luo tilaus',
    el: 'Δημιουργία καταχώρισης',
  },
  'nav.myQuotes': {
    en: 'My Quotes',
    bg: 'Моите оферти',
    de: 'Meine Angebote',
    fr: 'Mes offres',
    ro: 'Ofertele mele',
    tr: 'Tekliflerim',
    sr: 'Moje ponude',
    mk: 'Мои понуди',
    hu: 'Ajánlataim',
    sk: 'Moje ponuky',
    sl: 'Moje ponudbe',
    es: 'Mis ofertas',
    fi: 'Tarjoukseni',
    el: 'Οι προσφορές μου',
  },

  'nav.createReview': {
    en: 'Create Review',
    bg: 'Създай отзив',
    de: 'Bewertung erstellen',
    fr: 'Créer un avis',
    ro: 'Creează recenzie',
    tr: 'Değerlendirme oluştur',
    sr: 'Kreiraj recenziju',
    mk: 'Креирај рецензија',
    hu: 'Értékelés létrehozása',
    sk: 'Vytvoriť recenziu',
    sl: 'Ustvari oceno',
    es: 'Crear reseña',
    fi: 'Luo arvostelu',
    el: 'Δημιουργία αξιολόγησης',
  },

  'nav.manageFleet': {
    en: 'Manage Fleet',
    bg: 'Управление на автопарк',
    de: 'Flotte verwalten',
    fr: 'Gérer la flotte',
    ro: 'Gestionează flota',
    tr: 'Filoyu yönet',
    sr: 'Upravljanje flotom',
    mk: 'Управување со возен парк',
    hu: 'Flotta kezelése',
    sk: 'Správa flotily',
    sl: 'Upravljanje voznega parka',
    es: 'Gestionar flota',
    fi: 'Hallitse kalustoa',
    el: 'Διαχείριση στόλου',
  },

  'nav.myInvoices': {
    en: 'My Invoices',
    bg: 'Моите фактури',
    de: 'Meine Rechnungen',
    fr: 'Mes factures',
    ro: 'Facturile mele',
    tr: 'Faturalarım',
    sr: 'Moje fakture',
    mk: 'Мои φакτυρι',
    hu: 'Számláim',
    sk: 'Moje faktúry',
    sl: 'Moji računi',
    es: 'Mis facturas',
    fi: 'Laskuni',
    el: 'Τα τιμολόγιά μου',
  },

  'nav.adminDashboard': {
    en: 'Dashboard',
    bg: 'Табло',
    de: 'Dashboard',
    fr: 'Tableau de bord',
    ro: 'Panou',
    tr: 'Panel',
    sr: 'Tabla',
    mk: 'Табла',
    hu: 'Irányítópult',
    sk: 'Prehľad',
    sl: 'Nadzorna plošča',
    es: 'Panel',
    fi: 'Hallintapaneeli',
    el: 'Πίνακας ελέγχου',
  },

  'nav.adminListings': {
    en: 'Listings',
    bg: 'Заявки',
    de: 'Anfragen',
    fr: 'Demandes',
    ro: 'Cereri',
    tr: 'Talepler',
    sr: 'Zahtevi',
    mk: 'Нарачки',
    hu: 'Kérések',
    sk: 'Dopyty',
    sl: 'Povpraševanja',
    es: 'Solicitudes',
    fi: 'Tilaukset',
    el: 'Καταχωρίσεις',
  },

  'nav.adminPartners': {
    en: 'Partners',
    bg: 'Партньори',
    de: 'Partner',
    fr: 'Partenaires',
    ro: 'Parteneri',
    tr: 'Ortaklar',
    sr: 'Partneri',
    mk: 'Партнери',
    hu: 'Partnerek',
    sk: 'Partneri',
    sl: 'Partnerji',
    es: 'Socios',
    fi: 'Kumppanit',
    el: 'Συνεργάτες',
  },

  'nav.adminUsers': {
    en: 'Manage All Users',
    bg: 'Управление на потребители',
    de: 'Alle Benutzer verwalten',
    fr: 'Gérer tous les utilisateurs',
    ro: 'Gestionează utilizatorii',
    tr: 'Tüm kullanıcıları yönet',
    sr: 'Upravljanje korisnicima',
    mk: 'Управување со корисници',
    hu: 'Felhasználók kezelése',
    sk: 'Správa používateľov',
    sl: 'Upravljanje uporabnikov',
    es: 'Gestionar usuarios',
    fi: 'Hallitse käyttäjiä',
    el: 'Διαχείριση όλων των χρηστών',
  },

  'nav.adminTrucks': {
    en: 'Manage All Trucks',
    bg: 'Управление на камиони',
    de: 'Alle LKW verwalten',
    fr: 'Gérer tous les camions',
    ro: 'Gestionează camioanele',
    tr: 'Tüm kamyonları yönet',
    sr: 'Upravljanje kamionima',
    mk: 'Управување со камиони',
    hu: 'Teherautók kezelése',
    sk: 'Správa kamiónov',
    sl: 'Upravljanje tovornjakov',
    es: 'Gestionar camiones',
    fi: 'Hallitse kuorma-autoja',
    el: 'Διαχείριση όλων των φορτηγών',
  },

  'nav.adminPayments': {
    en: 'Payments',
    bg: 'Плащания',
    de: 'Zahlungen',
    fr: 'Paiements',
    ro: 'Plăți',
    tr: 'Ödemeler',
    sr: 'Plaćanja',
    mk: 'Плаќања',
    hu: 'Fizetések',
    sk: 'Platby',
    sl: 'Plačila',
    es: 'Pagos',
    fi: 'Maksut',
    el: 'Πληρωμές',
  },

  'nav.adminInvoices': {
    en: 'Invoices',
    bg: 'Фактури',
    de: 'Rechnungen',
    fr: 'Factures',
    ro: 'Facturi',
    tr: 'Faturalar',
    sr: 'Fakture',
    mk: 'Фактури',
    hu: 'Számlák',
    sk: 'Faktúry',
    sl: 'Računi',
    es: 'Facturas',
    fi: 'Laskut',
    el: 'Τιμολόγια',
  },

  'nav.adminPurchaseTerms': {
    en: 'Purchase Terms',
    bg: 'Условия за покупκα',
    de: 'Kaufbedingungen',
    fr: 'Conditions d’achat',
    ro: 'Termeni de achiziție',
    tr: 'Satın alma şartları',
    sr: 'Uslovi kupovine',
    mk: 'Услови за купување',
    hu: 'Vásárlási feltételek',
    sk: 'Podmienky nákupu',
    sl: 'Pogoji nakupa',
    es: 'Términos de compra',
    fi: 'Ostoehdot',
    el: 'Όροι αγοράς',
  },

  'nav.adminReviews': {
    en: 'Reviews',
    bg: 'Отзиви',
    de: 'Bewertungen',
    fr: 'Avis',
    ro: 'Recenzii',
    tr: 'Yorumlar',
    sr: 'Recenzije',
    mk: 'Рецензии',
    hu: 'Értékelések',
    sk: 'Recenzie',
    sl: 'Ocene',
    es: 'Reseñas',
    fi: 'Arvostelut',
    el: 'Κριτικές',
  },
};

Object.entries(sharedTranslations).forEach(([key, values]) => {
  if (!english[key] && values.en) {
    english[key] = values.en;
  }
});

const AUTO_FILLED_ENGLISH_ONLY = {
  'Error loading documents': 'Error loading documents',
  'Are you sure you want to delete this document?':
    'Are you sure you want to delete this document?',
  'Document deleted': 'Document deleted',
  'Failed to delete': 'Failed to delete',
  'Failed to get download link': 'Failed to get download link',
  'Status updated': 'Status updated',
  'Update failed': 'Update failed',
  'Email cannot be changed.': 'Email cannot be changed.',
  'No documents found.': 'No documents found.',
  'Invoice #': 'Invoice #',
  'File Name': 'File Name',
  Amount: 'Amount',
  Actions: 'Actions',
  Download: 'Download',
  'Mark Unpaid': 'Mark Unpaid',
  'Mark Paid': 'Mark Paid',
  'Please save the record before uploading documents.':
    'Please save the record before uploading documents.',
  'Select a file before uploading.': 'Select a file before uploading.',
  'Please enter an invoice number.': 'Please enter an invoice number.',
  'Upload successful': 'Upload successful',
  '{{count}} file(s) uploaded successfully.':
    '{{count}} file(s) uploaded successfully.',
  'Upload failed': 'Upload failed',
  'Unable to upload the document.': 'Unable to upload the document.',
  'Invoice Number': 'Invoice Number',
  'Selected files:': 'Selected files:',
  Upload: 'Upload',
  'Save this record before uploading documents.':
    'Save this record before uploading documents.',
  'Error approving user': 'Error approving user',
  'Error rejecting user': 'Error rejecting user',
  'Error disabling user': 'Error disabling user',
  'User marked as VIP': 'User marked as VIP',
  'User unmarked as VIP': 'User unmarked as VIP',
  'Error marking user as VIP': 'Error marking user as VIP',
  'Error unmarking user as VIP': 'Error unmarking user as VIP',
  'Failed to approve user': 'Failed to approve user',
  'Failed to reject user': 'Failed to reject user',
  'Failed to disable user': 'Failed to disable user',
  'Failed to unmark user as VIP': 'Failed to unmark user as VIP',
  'Failed to mark user as VIP': 'Failed to mark user as VIP',
  'Invoice Management': 'Invoice Management',
  'All Invoices': 'All Invoices',
  'Manage all invoices uploaded by partners.':
    'Manage all invoices uploaded by partners.',
  'An unexpected error occurred. Please try again.':
    'An unexpected error occurred. Please try again.',
  'The email address is not valid.': 'The email address is not valid.',
  'This account has been disabled.': 'This account has been disabled.',
  'No account found with this email.': 'No account found with this email.',
  'Incorrect password. Please try again.':
    'Incorrect password. Please try again.',
  'Invalid email or password. Please check your credentials and try again.':
    'Invalid email or password. Please check your credentials and try again.',
  'Too many failed attempts. Please try again later or reset your password.':
    'Too many failed attempts. Please try again later or reset your password.',
  'Network error. Check your connection and try again.':
    'Network error. Check your connection and try again.',
  'A verification email has been sent to your email address. Please verify your email before logging in.':
    'A verification email has been sent to your email address. Please verify your email before logging in.',
  'Please make sure both passwords are the same.':
    'Please make sure both passwords are the same.',
  'Verification email resent!': 'Verification email resent!',
  'Please check your inbox.': 'Please check your inbox.',
  'You need to log in first': 'You need to log in first',
  'Please sign in to resend the verification email.':
    'Please sign in to resend the verification email.',
  'Failed to resend email': 'Failed to resend email',
  'Resend verification email': 'Resend verification email',
  'Show password': 'Show password',
  'Hide password': 'Hide password',
  'Awaiting verification artwork': 'Awaiting verification artwork',
  'Account status: Pending review': 'Account status: Pending review',
  'Your account is pending approval': 'Your account is pending approval',
  "Upload your verification documents below and we'll notify you by email once your account is approved.":
    "Upload your verification documents below and we'll notify you by email once your account is approved.",
  'Check status': 'Check status',
  Pending: 'Pending',
  'Upload verification documents': 'Upload verification documents',
  'Your uploaded documents': 'Your uploaded documents',
  'Back to sign in': 'Back to sign in',
  'Hide documents': 'Hide documents',
  'Email verification required': 'Email verification required',
  'Waiting for email verification': 'Waiting for email verification',
  'Check your email': 'Check your email',
  'We sent your verification link to': 'We sent your verification link to',
  "Didn't receive it? Check your spam folder or try again.":
    "Didn't receive it? Check your spam folder or try again.",
  'Resend email': 'Resend email',
  "I've verified my email": "I've verified my email",
  'Email verified': 'Email verified',
  'Redirecting you now.': 'Redirecting you now.',
  'Email not verified yet': 'Email not verified yet',
  'Please click the link in your inbox and try again.':
    'Please click the link in your inbox and try again.',
  'Unable to resend verification email right now.':
    'Unable to resend verification email right now.',
  'Unable to check verification status right now.':
    'Unable to check verification status right now.',
  "We've sent a new verification link to your email address.":
    "We've sent a new verification link to your email address.",
  'We automatically check your verification status every 30 seconds. You can also trigger an instant check after verifying your email.':
    'We automatically check your verification status every 30 seconds. You can also trigger an instant check after verifying your email.',
  'We automatically check your verification status every 15 seconds. You can also trigger an instant check after verifying your email.':
    'We automatically check your verification status every 15 seconds. You can also trigger an instant check after verifying your email.',
  '—': '—',
  'Inputs changed. Recalculate the price.':
    'Inputs changed. Recalculate the price.',
  'My Invoices': 'My Invoices',
  'Upload New Invoice': 'Upload New Invoice',
  'Please enter the invoice number and upload the invoice document. It will be reviewed by an administrator.':
    'Please enter the invoice number and upload the invoice document. It will be reviewed by an administrator.',
  'Invoice History': 'Invoice History',
  'Client ref · {{clientRef}}': 'Client ref · {{clientRef}}',
  'Order Documents': 'Order Documents',
  'Upload Proof of Pickup': 'Upload Proof of Pickup',
  'Status will be updated to Picked Up after successful upload.':
    'Status will be updated to Picked Up after successful upload.',
  'Upload Proof of Delivery': 'Upload Proof of Delivery',
  'Status will be updated to Delivered after successful upload.':
    'Status will be updated to Delivered after successful upload.',
  'Enter first name': 'Enter first name',
  'Enter last name': 'Enter last name',
  'Enter phone number': 'Enter phone number',
  'Driver updated.': 'Driver updated.',
  'The driver has been successfully updated.':
    'The driver has been successfully updated.',
  'Driver added.': 'Driver added.',
  'The new driver has been successfully added.':
    'The new driver has been successfully added.',
  'Driver deleted.': 'Driver deleted.',
  'The driver has been successfully deleted.':
    'The driver has been successfully deleted.',
  'Trailer updated.': 'Trailer updated.',
  'The trailer has been successfully updated.':
    'The trailer has been successfully updated.',
  'Trailer added.': 'Trailer added.',
  'The new trailer has been successfully added.':
    'The new trailer has been successfully added.',
  'Trailer deleted.': 'Trailer deleted.',
  'The trailer has been successfully deleted.':
    'The trailer has been successfully deleted.',
  'User account not found. Please complete registration.':
    'User account not found. Please complete registration.',
  'No token provided': 'No token provided',
  'Token expired': 'Token expired',
  'Token revoked': 'Token revoked',
  'Invalid ID token': 'Invalid ID token',
  Unauthorized: 'Unauthorized',
  'Unauthorized: User not authenticated.':
    'Unauthorized: User not authenticated.',
  'Unauthorized: User role not found.': 'Unauthorized: User role not found.',
  'Forbidden: Your role is not allowed to perform this action.':
    'Forbidden: Your role is not allowed to perform this action.',
  'Forbidden: This action requires a partner role.':
    'Forbidden: This action requires a partner role.',
  'Forbidden: This action requires a client role.':
    'Forbidden: This action requires a client role.',
  'Forbidden: This action requires an admin role.':
    'Forbidden: This action requires an admin role.',
  'This user has not been approved': 'This user has not been approved',
  'User email has not been verified': 'User email has not been verified',
  'User account has been disabled': 'User account has been disabled',
  'Booking not found': 'Booking not found',
  'Route not found': 'Route not found',
  'Pickup location (country and postalCode) is required':
    'Pickup location (country and postalCode) is required',
  'Delivery location (country and postalCode) is required':
    'Delivery location (country and postalCode) is required',
  'Unable to calculate route. Please check the locations and try again.':
    'Unable to calculate route. Please check the locations and try again.',
  'Error calculating transport price': 'Error calculating transport price',
  'Booking canceled successfully': 'Booking canceled successfully',
  'Invalid request.': 'Invalid request.',
  'Access denied.': 'Access denied.',
  'Resource not found.': 'Resource not found.',
  'Request conflict.': 'Request conflict.',
  'Invalid data provided.': 'Invalid data provided.',
  'Too many requests. Please try again later.':
    'Too many requests. Please try again later.',
  'Internal server error. Please try again later.':
    'Internal server error. Please try again later.',
  'Service temporarily unavailable.': 'Service temporarily unavailable.',
  'booking.load_preset': 'Load preset',
  'booking.save_preset_tooltip':
    'Save current filters as your quick-access preset',
  'booking.load_preset_tooltip': 'Load your saved filter preset',
  'booking.preset_saved': 'Preset saved',
  'booking.preset_saved_desc': 'Your filter preset has been saved.',
  'booking.preset_loaded': 'Preset loaded',
  'booking.preset_load_error': 'Failed to load preset',
  'booking.no_preset_saved': 'No preset saved yet',
  'booking.date_from': 'Date from',
  'booking.date_to': 'Date to',
  'Active filters': 'Active filters',
  'All booking states': 'All booking states',
  'All partners': 'All partners',
  'All payments': 'All payments',
  'All roles': 'All roles',
  'All statuses': 'All statuses',
  'All Users': 'All Users',
  'Are you sure you want to cancel booking {{id}}?':
    'Are you sure you want to cancel booking {{id}}?',
  'Attach the CMR Insurance before finishing truck setup.':
    'Attach the CMR Insurance before finishing truck setup.',
  Awaiting: 'Awaiting',
  'Awaiting payout': 'Awaiting payout',
  'Booking canceled': 'Booking canceled',
  'Booking marked as paid': 'Booking marked as paid',
  'Booking released and returned to marketplace':
    'Booking released and returned to marketplace',
  'booking.allowed_range': 'Allowed range',
  'booking.assign_transport': 'Assign transport',
  'booking.back': 'Back',
  'booking.back_to_summary': 'Back to summary',
  'booking.booking_created_but_pickup_document_not_uploaded_upload_from_order_details':
    'The booking was created, but the pickup document was not uploaded. You can upload it from Order Details.',
  'booking.city_not_found': 'City not found',
  'booking.city_or_town': 'City or town',
  'booking.clear_radius': 'Clear radius',
  'booking.continue': 'Continue',
  'booking.country_optional': 'Country (optional)',
  'booking.delivery_constraint_info':
    'Delivery date must be on or after pickup date.',
  'booking.delivery_date_cannot_be_earlier_than_pickup_date':
    'Delivery date cannot be earlier than pickup date',
  'booking.driver': 'Driver',
  'booking.failed_to_open_letter_of_attorney':
    'Failed to open letter of attorney',
  'booking.go_to_order': 'Go to Order',
  'booking.i_accept_terms': 'I accept the terms',
  'booking.invalid_license_plate_or_vin_length':
    'Invalid license plate or VIN length.',
  'booking.invalid_vin_format_i_o_q_not_allowed':
    'Invalid VIN format. Characters I, O, and Q are not allowed.',
  'booking.letter_of_attorney_file_is_empty':
    'Letter of attorney file is empty',
  'booking.no_additional_details': 'No additional details',
  'booking.no_vehicle_info': 'No vehicle info',
  'booking.open_letter_of_attorney': 'Open Letter of Attorney',
  'booking.opening_letter_of_attorney': 'Opening letter of attorney...',
  'booking.order_accepted_successfully': 'Order accepted successfully',
  'booking.order_cars_exceed_selected_truck_capacity':
    'This order has {{orderCars}} cars but selected truck capacity is {{capacity}}.',
  'booking.pickup_constraint_info':
    'Pickup date is required before assigning transport.',
  'booking.pickup_document_upload_failed': 'Pickup document upload failed',
  'booking.preparing_secure_document_preview':
    'Preparing secure document preview...',
  'booking.radius_km': 'Radius (km)',
  'booking.radius_search': 'Radius search',
  'booking.route_and_details': 'Route and details',
  'booking.schedule': 'Schedule',
  'booking.searching': 'Searching…',
  'booking.select_pickup_and_delivery': 'Select pickup and delivery',
  'booking.select_pickup_and_delivery_dates_before_confirming':
    'Select pickup and delivery dates before confirming',
  'booking.select_pickup_date': 'Select pickup date',
  'booking.select_truck_driver_and_trailer':
    'Select truck, driver, and trailer',
  'booking.supported_formats_jpg_png_pdf_doc_docx':
    'Supported formats: JPG, PNG, PDF, DOC, DOCX',
  'booking.terms_and_conditions': 'Terms and conditions',
  'booking.terms_text':
    'I confirm the transport terms and liability conditions.',
  'booking.track_shipment': 'Track shipment',
  'booking.trailer': 'Trailer',
  'booking.transport_details': 'Transport details',
  'booking.truck': 'Truck',
  'booking.truck_driver_planning_saved_letter_of_attorney_available':
    'Truck, driver, and planning dates were saved. The letter of attorney is now available.',
  'booking.unexpected_error': 'Unexpected error',
  'booking.vehicles_plural': 'Vehicles',
  'booking.view_details': 'View details',
  'booking.vip_price_must_be_between_min_max_50_to_150_percent_of_estimated_price':
    'VIP price must be between {{min}} EUR and {{max}} EUR (50% to 150% of estimated price).',
  'booking.vip_price_must_be_positive_number':
    'VIP price must be a positive number.',
  'booking.within_radius_km_of_place': 'Within {{radius}} km of {{place}}',
  'Canceling...': '..',
  Capacity: 'Capacity',
  'Car Capacity': 'Car Capacity',
  'Car capacity is required.': 'Car capacity is required.',
  cars: 'cars',
  Changed: 'Changed',
  'CMR Document': 'CMR Document',
  'CMR expiry': 'CMR expiry',
  'CMR Expiry': 'CMR Expiry',
  'CMR expiry date is required': 'CMR expiry date is required',
  'CMR Insurance': 'CMR Insurance',
  'CMR insurance expiry date': 'CMR insurance expiry date',
  'CMR Insurance Expiry Date': 'CMR Insurance Expiry Date',
  'CMR insurance has expired. Upload a new CMR Insurance for review.':
    'Upload a new CMR Insurance for review.',
  'CMR insurance is expiring within 14 days.':
    'CMR insurance is expiring within 14 days.',
  'CMR Insurance required': 'CMR Insurance required',
  Company: 'Company',
  'Copy order ID': 'Copy order ID',
  Created: 'Created',
  'Current expiry': 'Current expiry',
  'Date range': 'Date range',
  days: 'days',
  Delay: 'Delay',
  'Delivered + partner invoice uploaded + unpaid':
    'Delivered + partner invoice uploaded + unpaid',
  Document: 'Document',
  'Documents uploaded': 'Documents uploaded',
  Done: 'Done',
  'Download Client Invoice #{{id}}': 'Download Client Invoice #{{id}}',
  'Download Invoice': 'Download Invoice',
  'Downloading...': '..',
  'Enter a valid capacity between 1 and 20 cars.':
    'Enter a valid capacity between 1 and 20 cars.',
  'Enter license plate': 'Enter license plate',
  'Enter plate and upload CMR to add truck':
    'Enter plate and upload CMR to add truck',
  'Error fetching users': 'Error fetching users',
  'Expire Soon (14 days)': 'Expire Soon (14 days)',
  'Explain why this CMR was rejected': 'Explain why this CMR was rejected',
  'Failed to copy order ID': 'Failed to copy order ID',
  'Failed to download invoice': 'Failed to download invoice',
  'Failed to download proforma invoice': 'Failed to download proforma invoice',
  'Failed to generate invoice': 'Failed to generate invoice',
  'Failed to load invoice summary': 'Failed to load invoice summary',
  'Failed to load letter of attorney': 'Failed to load letter of attorney',
  'Failed to open letter of attorney': 'Failed to open letter of attorney',
  'Failed to release booking': 'Failed to release booking',
  'Fleet data refreshed': 'Fleet data refreshed',
  'Generate Client Invoice': 'Generate Client Invoice',
  'Generate Invoice': 'Generate Invoice',
  'Generated at': 'Generated at',
  'Generating...': '..',
  'How many cars can this truck carry?': 'How many cars can this truck carry?',
  'In progress': 'In progress',
  Invoice: 'Invoice',
  'Invoice generated': 'Invoice generated',
  'Invoice generated successfully': 'Invoice generated successfully',
  'Invoice uploaded': 'Invoice uploaded',
  'Invoices uploaded by partners for platform payout processing. Client invoices are generated in each order view.':
    'Client invoices are generated in each order view.',
  'Keep booking': 'Keep booking',
  'Keep your active drivers and contact details up to date.':
    'Keep your active drivers and contact details up to date.',
  'Last Rejection': 'Last Rejection',
  'Last rejection reason': 'Last rejection reason',
  'Letter of Attorney': 'Letter of Attorney',
  'Letter of attorney file is empty': 'Letter of attorney file is empty',
  'License plate cannot be changed after creation. Re-upload CMR Insurance instead.':
    'Re-upload CMR Insurance instead.',
  'License plate is required.': 'License plate is required.',
  'Loading bookings...': '..',
  'Loading delivered orders...': '..',
  'Loading drivers...': '..',
  'Loading letter of attorney...': '..',
  'Loading partners...': '..',
  'Loading pending trucks...': '..',
  'Loading trailers...': '..',
  'Loading trucks...': '..',
  'Loading users...': '..',
  'Manage large order volumes with search, payment actions, and invoice workflows.':
    'Manage large order volumes with search, payment actions, and invoice workflows.',
  'Manage license plates and keep CMR Insurances approved and valid.':
    'Manage license plates and keep CMR Insurances approved and valid.',
  'Manage status updates, documents, and payment steps from one place.':
    'Manage status updates, documents, and payment steps from one place.',
  'Manage trailer plate records and keep availability current.':
    'Manage trailer plate records and keep availability current.',
  'Mark booking {{id}} as paid?': 'Mark booking {{id}} as paid?',
  'Marking Paid...': '..',
  Missing: 'Missing',
  'Needs attention': 'Needs attention',
  'New (14 days)': 'New (14 days)',
  'No bookings found for the current filters.':
    'No bookings found for the current filters.',
  'No confirmed CMR document uploaded yet.':
    'No confirmed CMR document uploaded yet.',
  'No driver assigned': 'No driver assigned',
  'No letter of attorney has been generated yet.':
    'No letter of attorney has been generated yet.',
  'No matching delivered orders': 'No matching delivered orders',
  'No new notifications': 'No new notifications',
  'No partners found.': 'No partners found.',
  'No trucks found for this filter.': 'No trucks found for this filter.',
  'No users found for current filters.': 'No users found for current filters.',
  'Not uploaded': 'Not uploaded',
  Notifications: 'Notifications',
  of: 'of',
  'Only admins can set or update this expiry date after reviewing your CMR insurance.':
    'Only admins can set or update this expiry date after reviewing your CMR insurance.',
  'Open letter of attorney': 'Open letter of attorney',
  'Opening letter of attorney...': '..',
  Order: 'Order',
  'Order actions': 'Order actions',
  'Order ID copied': 'Order ID copied',
  Owner: 'Owner',
  Page: 'Page',
  'Paid date': 'Paid date',
  'Partner delivery date': 'Partner delivery date',
  'Partner documents': 'Partner documents',
  'Partner Invoice': 'Partner Invoice',
  'Partner invoice uploaded': 'Partner invoice uploaded',
  'Partner Payout Invoices': 'Partner Payout Invoices',
  'Partner pickup date': 'Partner pickup date',
  'Partner score': 'Partner score',
  Payment: 'Payment',
  'Payout date': 'Payout date',
  'penalties applied': 'penalties applied',
  'Pending admin review': 'Pending admin review',
  'Pending review': 'Pending review',
  'Pending trucks': 'Pending trucks',
  'Please provide a clear reason for rejection.':
    'Please provide a clear reason for rejection.',
  'Please select an order before uploading an invoice.':
    'Please select an order before uploading an invoice.',
  'Please try again.': 'Please try again.',
  'Preparing secure document preview...': '..',
  'Proforma Invoice': 'Proforma Invoice',
  'Provide a rejection reason for this CMR review.':
    'Provide a rejection reason for this CMR review.',
  'Quarter Score': 'Quarter Score',
  'Re-upload CMR': 'Re-upload CMR',
  Refresh: 'Refresh',
  'Rejection reason': 'Rejection reason',
  'Rejection reason is required': 'Rejection reason is required',
  'Release booking {{id}} back to the marketplace so another partner can accept it?':
    'Release booking {{id}} back to the marketplace so another partner can accept it?',
  Reset: 'Reset',
  'Review Bookings': 'Review Bookings',
  Revision: 'Revision',
  Rows: 'Rows',
  'Search by invoice number, file name, or booking ID':
    'Search by invoice number, file name, or booking ID',
  'Search by name, email, company': 'Search by name, email, company',
  'Search by name, email, company, uid': 'Search by name, email, company, uid',
  'Search client': 'Search client',
  'Search delivered order': 'Search delivered order',
  'Search license plate or owner': 'Search license plate or owner',
  'Search order ID': 'Search order ID',
  'Search partner': 'Search partner',
  'Select a new CMR Insurance to re-upload for this truck.':
    'Select a new CMR Insurance to re-upload for this truck.',
  'Select paid date': 'Select paid date',
  'Set CMR insurance expiry date to approve this truck.':
    'Set CMR insurance expiry date to approve this truck.',
  'Set maximum number of cars this truck can carry (1-20).':
    'Set maximum number of cars this truck can carry (1-20).',
  'Set the CMR insurance expiry date before approval.':
    'Set the CMR insurance expiry date before approval.',
  Showing: 'Showing',
  'Showing page {{page}} of {{pages}} • {{total}} invoices':
    'Showing page {{page}} of {{pages}} • {{total}} invoices',
  'Status will be updated to Picked Up after successful upload. You can add multiple car photos before uploading.':
    'You can add multiple car photos before uploading.',
  Terms: 'Terms',
  Total: 'Total',
  'Track paid and unpaid invoices, expected payout dates, and upload new invoices quickly.':
    'Track paid and unpaid invoices, expected payout dates, and upload new invoices quickly.',
  'Truck approved successfully': 'Truck approved successfully',
  'Truck documents': 'Truck documents',
  'Truck license plate': 'Truck license plate',
  'Truck rejected successfully': 'Truck rejected successfully',
  'truck(s) are pending admin CMR expiry date.':
    'truck(s) are pending admin CMR expiry date.',
  'truck(s) have expired CMR insurance and are disabled.':
    'truck(s) have expired CMR insurance and are disabled.',
  'truck(s) will expire within 14 days.':
    'truck(s) will expire within 14 days.',
  'Unable to prepare the record for upload.':
    'Unable to prepare the record for upload.',
  Unpaid: 'Unpaid',
  'Upload a CMR Insurance before closing this truck setup.':
    'Upload a CMR Insurance before closing this truck setup.',
  'Upload a valid CMR insurance. Each upload sends the truck back to pending review.':
    'Each upload sends the truck back to pending review.',
  'Upload documents': 'Upload documents',
  'Upload Invoice': 'Upload Invoice',
  'Upload order documents': 'Upload order documents',
  'Upload unavailable': 'Upload unavailable',
  Uploaded: 'Uploaded',
  'Uploaded • Paid': 'Uploaded • Paid',
  'Uploaded • Partially paid': 'Uploaded • Partially paid',
  'Uploaded by partner for platform payout processing.':
    'Uploaded by partner for platform payout processing.',
  User: 'User',
  'Verification code': 'Verification code',
  'View details': 'View details',
  'View Partners': 'View Partners',
  'Working hours not provided': 'Working hours not provided',

  '{{value}} orders': '{{value}} orders',
  Invoiced: 'Invoiced',
  'Loading admin data...': 'Loading admin data...',
  'Pending partners': 'Pending partners',
  'Unpaid bookings': 'Unpaid bookings',
  'Total users': 'Total users',
  'Orders per period': 'Orders per period',
  'Orders by status': 'Orders by status',
  'Quick actions': 'Quick actions',
  'Verify new partners': 'Verify new partners',
  'Review partner applications and approve or reject requests.':
    'Review partner applications and approve or reject requests.',
  'Manage all trucks': 'Manage all trucks',
  'Review, approve, reject, disable, and filter all trucks.':
    'Review, approve, reject, disable, and filter all trucks.',
  'Review bookings': 'Review bookings',
  'Review all transport orders, payment states, and generated invoices.':
    'Review all transport orders, payment states, and generated invoices.',
  'Manage all users': 'Manage all users',
  'Manage user status, roles, and validation records.':
    'Manage user status, roles, and validation records.',
  'User breakdown': 'User breakdown',
  Clients: 'Clients',
  Partners: 'Partners',
  Admins: 'Admins',
  'Top 5 pending partners': 'Top 5 pending partners',
  'No pending partners right now.': 'No pending partners right now.',
  pending: 'pending',
  'Top 5 pending trucks': 'Top 5 pending trucks',
  'No pending trucks right now.': 'No pending trucks right now.',
  'Unknown owner': 'Unknown owner',
  'KPI cards and top lists link directly to filtered admin screens.':
    'KPI cards and top lists link directly to filtered admin screens.',
  'booking.available_orders_title': 'Available Orders',
  'booking.available_orders_description':
    'Review incoming transport opportunities and apply filters to match your capacity.',
  'booking.vehicle_pickup_location': 'Vehicle pickup location',
  'booking.pickup_opening_hours': 'Pickup opening hours',
  'booking.vehicle_delivery_location': 'Vehicle delivery location',
  'booking.delivery_opening_hours': 'Delivery opening hours',
  'booking.pickup_contact': 'Pickup contact',
  'booking.delivery_contact': 'Delivery contact',
  'booking.vehicles_scheduled': 'Vehicles scheduled',
  'booking.watchlist_title': 'Watchlist',
  'booking.watchlist_description':
    'Track saved opportunities and act quickly as availability changes.',
  'Loading dashboard...': 'Loading dashboard...',
  'Total bookings': 'Total bookings',
  'Open bookings': 'Open bookings',
  'Order status timeline': 'Order status timeline',
  'Last 6 months of bookings grouped by current status.':
    'Last 6 months of bookings grouped by current status.',
  'Create new order': 'Create new order',
  'Create a new transport booking request.':
    'Create a new transport booking request.',
  'View my orders': 'View my orders',
  'Review status and details of your bookings.':
    'Review status and details of your bookings.',
  'Open profile': 'Open profile',
  'Update company and contact details.': 'Update company and contact details.',
  'Recent bookings': 'Recent bookings',
  'No bookings yet.': 'No bookings yet.',
  'Unknown destination': 'Unknown destination',
  'Quarter score': 'Quarter score',
  '{{value}} completed': '{{value}} completed',
  'Truck CMR warning': 'Truck CMR warning',
  'One truck has CMR expiry risk. Review it in Fleet.':
    'One truck has CMR expiry risk. Review it in Fleet.',
  '{{count}} trucks have CMR expiry risk. Review them in Fleet.':
    '{{count}} trucks have CMR expiry risk. Review them in Fleet.',
  'Active queue': 'Active queue',
  'Delivered bookings': 'Delivered bookings',
  'Cars delivered': 'Cars delivered',
  'Canceled bookings': 'Canceled bookings',
  'Avg assign-to-pickup': 'Avg assign-to-pickup',
  'Quarter Partner Score': 'Quarter Partner Score',
  'Payment delay: +{{days}} days': 'Payment delay: +{{days}} days',
  'Penalty events': 'Penalty events',
  'Partner rating': 'Partner rating',
  'Bronze requirements': 'Bronze requirements',
  'Orders in quarter': 'Orders in quarter',
  'Cancellation rate / 100 orders': 'Cancellation rate / 100 orders',
  'Damage claims / 100 orders': 'Damage claims / 100 orders',
  '{{current}} / min {{target}}': '{{current}} / min {{target}}',
  '{{current}} / max {{target}}': '{{current}} / max {{target}}',
  Met: 'Met',
  'Not met': 'Not met',
  Unranked: 'Unranked',
  Current: 'Current',
  'Completed orders per period': 'Completed orders per period',
  'Completed orders': 'Completed orders',
  'Truck CMR status alerts': 'Truck CMR status alerts',
  '{{count}} truck(s) have expired CMR insurance.':
    '{{count}} truck(s) have expired CMR insurance.',
  '{{count}} truck(s) will expire within 14 days.':
    '{{count}} truck(s) will expire within 14 days.',
  '{{count}} truck(s) are missing CMR expiry date.':
    '{{count}} truck(s) are missing CMR expiry date.',
  'Upload a new CMR Insurance in Fleet. The truck will stay pending until admin review.':
    'Upload a new CMR Insurance in Fleet. The truck will stay pending until admin review.',
  'Open fleet to resolve CMR alerts': 'Open fleet to resolve CMR alerts',
  'Operational actions': 'Operational actions',
  'Open marketplace orders': 'Open marketplace orders',
  'Review available orders and plan assignments.':
    'Review available orders and plan assignments.',
  'My accepted orders': 'My accepted orders',
  'Manage delivery progress and documents.':
    'Manage delivery progress and documents.',
  'Update trucks, trailers, and availability.':
    'Update trucks, trailers, and availability.',
  'Partner invoices': 'Partner invoices',
  'Upload and track invoice payments.': 'Upload and track invoice payments.',
  'No active orders in queue.': 'No active orders in queue.',
  'profile.incompleteTitle': 'Profile Incomplete',
  'profile.incompleteDescription':
    'Please complete your profile information (Company, Phone, Address, City, Post Code) to access all features.',
  'profile.incompleteDescriptionPartner':
    'Please complete your profile information (Company, Phone, Address, City, Post Code, VAT Number) to access all features.',
  'profile.incompleteDescriptionClient':
    'Please complete your profile information (Phone Number) to access all features.',
  'profile.goToProfile': 'Go to Profile',
  'auth.email_placeholder': 'name@company.com',
  'auth.authentication_mode_switch': 'Authentication mode switch',
  'auth.invalid_email': 'Invalid email',
  'auth.please_enter_a_valid_email_address':
    'Please enter a valid email address.',
  'auth.email_not_found': 'Email not found',
  'auth.no_account_found_with_that_email_address':
    'No account found with that email address.',
  'auth.email_sent': 'Email sent!',
  'auth.something_went_wrong_try_again': 'Something went wrong. Try again.',
  'auth.we_sent_a_password_reset_link_open_your_inbox_and_follow_the_instructions':
    'We sent a password reset link. Open your inbox and follow the instructions.',
  'auth.forgot_your_password': 'Forgot your password?',
  'auth.enter_your_account_email_and_we_will_send_you_a_password_reset_link':
    'Enter your account email and we will send you a password reset link.',
  'auth.email_address': 'Email address',
  'auth.send_reset_link': 'Send reset link',
  'auth.cancel': 'Cancel',
  'auth.tip_if_you_do_not_receive_the_email_check_spam_and_promotions_folders':
    'Tip: if you do not receive the email, check spam and promotions folders.',
  'auth.client': 'Client',
  'auth.partner': 'Partner',
  'auth.confirm_password': 'Confirm password',
  'auth.confirm_password_is_required': 'Confirm password is required.',
  'auth.create_account': 'Create Account',
  'auth.email': 'Email',
  'auth.email_is_required': 'Email is required.',
  'auth.enter_your_email_and_password_to_sign_in':
    'Enter your email and password to sign in!',
  'auth.enter_your_email_create_a_password_and_choose_a_role_to_register':
    'Enter your email, create a password, and choose a role to register.',
  'auth.failed_to_resend_email': 'Failed to resend email',
  'auth.forgot_password': 'Forgot password?',
  'auth.show_password': 'Show password',
  'auth.hide_password': 'Hide password',
  'auth.i_want_to_register_as_a': 'I want to register as a',
  'auth.incorrect_password_please_try_again':
    'Incorrect password. Please try again.',
  'auth.invalid_email_format': 'Invalid email format.',
  'auth.invalid_email_or_password_please_check_your_credentials_and_try_again':
    'Invalid email or password. Please check your credentials and try again.',
  'auth.join_our_network_of_transport_partners':
    'Join our network of transport partners.',
  'auth.login_failed': 'Login Failed',
  'auth.min_8_characters': 'Min. 8 characters',
  'auth.order_transportation_in_the_automotive_branch':
    'Order transportation in the automotive branch.',
  'auth.password': 'Password',
  'auth.password_is_required': 'Password is required.',
  'auth.passwords_do_not_match': 'Passwords do not match.',
  'auth.resend_verification_email': 'Resend verification email',
  'auth.verification_email_sent': 'Verification email sent',
  'auth.we_sent_a_new_verification_link':
    'We sent a new verification link to your email address.',
  'auth.unable_to_resend_verification_email_right_now':
    'Unable to resend verification email right now.',
  'auth.email_verified': 'Email verified',
  'auth.redirecting_you_now': 'Redirecting you now.',
  'auth.email_not_verified_yet': 'Email not verified yet',
  'auth.please_click_the_link_in_your_inbox_and_try_again':
    'Please click the link in your inbox and try again.',
  'auth.error': 'Error',
  'auth.unable_to_check_verification_status_right_now':
    'Unable to check verification status right now.',
  'auth.email_verification_required': 'Email Verification Required',
  'auth.check_your_email': 'Check your email',
  'auth.waiting_for_email_verification': 'Waiting for email verification',
  'auth.we_sent_your_verification_link_to': 'We sent your verification link to',
  'auth.didnt_receive_it_check_spam_or_try_again':
    "Didn't receive it? Check your spam or try again.",
  'auth.i_verified_my_email': 'I verified my email',
  'auth.resend_email': 'Resend email',
  'auth.back_to_sign_in': 'Back to sign in',
  'auth.we_automatically_check_every_15_seconds':
    'We automatically check your verification status every 15 seconds. You can also trigger an instant check after verifying your email.',
  'auth.sign_in': 'Sign In',
  'auth.sign_in_2': 'Sign in',
  'auth.sign_up': 'Sign Up',
  'auth.sign_up_2': 'Sign up',
  'auth.username': 'Username',
  'auth.username_is_required': 'Username is required.',
  'auth.your_name': 'Your name',
  'booking.e_g_berlin': 'e.g. Berlin',
  'booking.e_g_germany': 'e.g. Germany',
  'booking.watchlist': 'Watchlist',
  'booking.view_map': 'View map',
  'booking.invalid_input': 'Invalid input',
  'booking.please_enter_only_numbers_for_the_zip_code':
    'Please enter only numbers for the zip code.',
  'booking.pickup_zip_code': 'Pickup Zip Code',
  'booking.delivery_zip_code': 'Delivery Zip Code',
  'booking.select_vehicle_make': 'Select vehicle make',
  'booking.unnamed_item': 'Unnamed item',
  'booking.cars': 'cars',
  'booking.more_info': 'More info',
  'booking.loading': 'Loading...',
  'booking.no_items_found': 'No items found',
  'booking.selected_cars': 'Selected Cars',
  'booking.unknown_type': 'Unknown type',
  'booking.delete_car': 'Delete car',
  'Toggle details': 'Toggle details',
  'booking.order': 'Order',
  'booking.duration': 'Duration',
  'booking.vehicles_overview': 'Vehicles overview',
  'booking.body': 'Body',
  'booking.dims': 'Dims',
  'booking.select_vehicle_model': 'Select vehicle model',
  'booking.selected_type_value': 'Selected: {{value}}',
  'booking.select_a_vehicle_type': 'Select a vehicle type:',
  'booking.select_vehicle_weight': 'Select vehicle weight',
  'booking.selected_weight_kg': 'Selected: {{value}} kg',
  'booking.adjust_weight': 'Adjust weight',
  'Dates updated successfully': 'Dates updated successfully',
  'Error updating dates': 'Error updating dates',
  'Set Planned Dates': 'Set Planned Dates',
  'Set your planned pickup and arrival dates below.':
    'Set your planned pickup and arrival dates below.',
  'Changing dates after initial setup will deduct 20% from your performance score for this order.':
    'Changing dates after initial setup will deduct 20% from your performance score for this order.',
  'Planned Pickup Date': 'Planned Pickup Date',
  'Planned Arrival Date': 'Planned Arrival Date',
};

const SEMANTIC_KEY_ALIASES = {
  'auth.a_verification_email_has_been_sent_to_your_email_address_please_verify_your_emai':
    'A verification email has been sent to your email address. Please verify your email before logging in.',
  'auth.an_unexpected_error_occurred_please_try_again':
    'An unexpected error occurred. Please try again.',
  'auth.client': 'client',
  'auth.partner': 'partner',
  'auth.confirm_password': 'Confirm password',
  'auth.confirm_password_is_required': 'Confirm password is required.',
  'auth.create_account': 'Create Account',
  'auth.email': 'Email',
  'auth.email_is_required': 'Email is required.',
  'auth.enter_your_email_and_password_to_sign_in':
    'Enter your email and password to sign in!',
  'auth.enter_your_email_create_a_password_and_choose_a_role_to_register':
    'Enter your email, create a password, and choose a role to register.',
  'auth.failed_to_resend_email': 'Failed to resend email',
  'auth.forgot_password': 'Forgot password?',
  'auth.show_password': 'Show password',
  'auth.hide_password': 'Hide password',
  'auth.i_want_to_register_as_a': 'I want to register as a',
  'auth.incorrect_password_please_try_again':
    'Incorrect password. Please try again.',
  'auth.invalid_email_format': 'Invalid email format.',
  'auth.invalid_email_or_password_please_check_your_credentials_and_try_again':
    'Invalid email or password. Please check your credentials and try again.',
  'auth.join_our_network_of_transport_partners':
    'Join our network of transport partners.',
  'auth.login_failed': 'Login Failed',
  'auth.min_8_characters': 'Min. 8 characters',
  'auth.order_transportation_in_the_automotive_branch':
    'Order transportation in the automotive branch.',
  'auth.password': 'Password',
  'auth.password_is_required': 'Password is required.',
  'auth.passwords_do_not_match': 'Passwords do not match.',
  'auth.resend_verification_email': 'Resend verification email',
  'auth.sign_in': 'Sign In',
  'auth.sign_in_2': 'Sign in',
  'auth.sign_up': 'Sign Up',
  'auth.sign_up_2': 'Sign up',
  'auth.username': 'Username',
  'auth.username_is_required': 'Username is required.',
  'auth.your_name': 'Your name',
  'auth.verification_email_sent': 'Verification email sent',
  'auth.we_sent_a_new_verification_link':
    'We sent a new verification link to your email address.',
  'auth.unable_to_resend_verification_email_right_now':
    'Unable to resend verification email right now.',
  'auth.email_verified': 'Email verified',
  'auth.redirecting_you_now': 'Redirecting you now.',
  'auth.email_not_verified_yet': 'Email not verified yet',
  'auth.please_click_the_link_in_your_inbox_and_try_again':
    'Please click the link in your inbox and try again.',
  'auth.error': 'Error',
  'auth.unable_to_check_verification_status_right_now':
    'Unable to check verification status right now.',
  'auth.email_verification_required': 'Email Verification Required',
  'auth.check_your_email': 'Check your email',
  'auth.waiting_for_email_verification': 'Waiting for email verification',
  'auth.we_sent_your_verification_link_to': 'We sent your verification link to',
  'auth.didnt_receive_it_check_spam_or_try_again':
    "Didn't receive it? Check your spam or try again.",
  'auth.i_verified_my_email': 'I verified my email',
  'auth.resend_email': 'Resend email',
  'auth.back_to_sign_in': 'Back to sign in',
  'auth.we_automatically_check_every_15_seconds':
    'We automatically check your verification status every 15 seconds. You can also trigger an instant check after verifying your email.',
  'booking.accept': 'Accept',
  'booking.add_a_weight_for_each_vehicle': 'Add a weight for each vehicle.',
  'booking.add_at_least_one_delivery_time_window':
    'Add at least one delivery time window.',
  'booking.add_at_least_one_pickup_time_window':
    'Add at least one pickup time window.',
  'booking.add_at_least_one_vehicle': 'Add at least one vehicle.',
  'booking.add_time': 'Add time',
  'booking.add_to_watchlist': 'Add to watchlist',
  'booking.add_vehicle': 'Add vehicle',
  'booking.additional_information': 'Additional information',
  'booking.address': 'Address',
  'booking.an_unexpected_error_occurred': 'An unexpected error occurred.',
  'booking.apply_filters': 'Apply filters',
  'booking.arrival_date': 'Arrival Date',
  'booking.autobid': 'Autobid',
  'booking.autobid_set_up_to_price': 'Autobid set up to {{price}}',
  'booking.avg_weight_kg': 'Avg. weight (kg)',
  'booking.avoid_missed_trips_by_matching_the_window_the_truck_can_enter_the_premises':
    'Avoid missed trips by matching the window the truck can enter the premises.',
  'booking.body_type': 'Body type',
  'booking.booking_created': 'Booking created',
  'booking.booking_failed': 'Booking failed',
  'booking.booking_was_created_but_no_id_returned':
    'Booking was created but no id returned.',
  'booking.calculate_a_price_to_proceed': 'Calculate a price to proceed.',
  'booking.calculate_to_preview_your_quote': 'Calculate to preview your quote.',
  'booking.cancel': 'Cancel',
  'booking.chassis_number_licence_plate': 'Chassis Number/Licence plate',
  'booking.choose_file': 'Choose file',
  'booking.city_not_set': 'City not set',
  'booking.clear': 'Clear',
  'booking.closed': 'Closed',
  'booking.company_name': 'Company name',
  'booking.complete_missing_data': 'Complete missing data',
  'booking.confirm': 'Confirm',
  'booking.confirm_the_delivery_opening_hours':
    'Confirm the delivery opening hours.',
  'booking.confirm_the_pickup_opening_hours':
    'Confirm the pickup opening hours.',
  'booking.contact_email': 'Contact email',
  'booking.contact_language': 'Contact language',
  'booking.contact_person': 'Contact person',
  'booking.contact_phone': 'Contact phone',
  'booking.country': 'Country',
  'booking.current_price': 'Current price',
  'booking.delivery': 'Delivery',
  'booking.delivery_city': 'Delivery city',
  'booking.delivery_country': 'Delivery country',
  'booking.details': 'Details',
  'booking.determine_the_route_and_select_options_that_match_your_vehicle_mix':
    'Determine the route and select options that match your vehicle mix.',
  'booking.dimensions_cm': 'Dimensions (cm)',
  'booking.distance': 'Distance',
  'booking.distance_and_time': 'Distance & time',
  'booking.documents_needed_on_site': 'Documents needed on site',
  'booking.e_g_200': 'e.g. 200',
  'booking.e_g_2200': 'e.g. 2200',
  'booking.e_g_mercedes_benz_gle_450': 'e.g. Mercedes-Benz GLE 450',
  'booking.email': 'Email',
  'booking.endpoint': 'EndPoint',
  'booking.enter_manual_price': 'Enter manual price',
  'booking.environmental_or_compliance_notes':
    'Environmental or compliance notes',
  'booking.error_creating_booking': 'Error creating booking',
  'booking.error_fetching_data': 'Error fetching data',
  'booking.estimated': 'Estimated',
  'booking.estimated_price': 'Estimated price',
  'booking.estimated_total_client_price_price':
    'Estimated total client price €{{price}}',
  'booking.eta': 'ETA',
  'booking.excl_any_partner_fees': 'Excl. any partner fees',
  'booking.failed_to_accept': 'Failed to accept',
  'booking.profile_incomplete_title': 'Profile Incomplete',
  'booking.profile_incomplete_partner_message':
    'Please complete your company information (Company Name, VAT, Address, City, Post Code, Phone) before accepting bookings.',
  'booking.profile_incomplete_partner_short':
    'Complete your company info to accept bookings.',
  'booking.favorite_routes_stay_saved_for_quick_access':
    'Favorite routes stay saved for quick access.',
  'booking.fill_in_the_address_and_contact_person_this_helps_dispatch_align_pickups_with_lo':
    'Fill in the address and contact person. This helps dispatch align pickups with logistics partners.',
  'booking.fill_in_the_details_and_specify_the_parameters_for_every_vehicle_type':
    'Fill in the details and specify the parameters for every vehicle type.',
  'booking.filter_orders': 'Filter orders',
  'booking.finalize_the_handover_plan_with_scheduling_cues_site_availability_and_sustainabi':
    'Finalize the handover plan with scheduling cues, site availability, and sustainability preferences. This view keeps everything critical in one place without repeating details from earlier steps.',
  'booking.finish_each_step_before_creating_the_booking':
    'Finish each step before creating the booking.',
  'booking.from': 'From',
  'booking.height_cm': 'Height (cm)',
  'booking.i_confirm_the_delivery_opening_hours':
    'I confirm the delivery opening hours',
  'booking.i_confirm_the_pickup_opening_hours':
    'I confirm the pickup opening hours',
  'booking.i_confirm_these_opening_hours_are_correct':
    'I confirm these opening hours are correct',
  'booking.inputs_changed_recalc_to_refresh_quote':
    'Inputs changed · recalc to refresh quote',
  'booking.inputs_changed_recalculate_the_price':
    'Inputs changed. Recalculate the price.',
  'booking.keep_an_eye_on_the_quote_as_you_tweak_route_details_or_vehicle_mix':
    'Keep an eye on the quote as you tweak route details or vehicle mix.',
  'booking.kg': 'kg',
  'booking.km': 'km',
  'booking.lane': 'Lane',
  'booking.latest_quote_preview': 'Latest quote preview',
  'booking.length_cm': 'Length (cm)',
  'booking.loading_address_is_logistic_centre':
    'Loading address is logistic centre',
  'booking.loading_address_is_not_logistic_centre':
    'Loading address is not logistic centre',
  'booking.loading_notification': 'Loading notification',
  'booking.loading_notifications': 'Loading notifications',
  'booking.loading_only_possible_from_08_00_to_17_00_ask_for_johan':
    'Loading only possible from 08:00 to 17:00. Ask for Johan.',
  'booking.local_time': 'Local time',
  'booking.location': 'Location',
  'booking.make_model': 'Make / Model',
  'booking.max_cars': 'Max cars',
  'booking.maximum_price': 'Maximum price',
  'booking.mi': 'mi',
  'booking.min_cars': 'Min cars',
  'booking.monitor_every_booking_with_the_same_clarity_as_the_new_order_wizard_filter_by_la':
    'Monitor every booking with the same clarity as the New Order wizard. Filter by lane, status, or time window and jump into the details faster.',
  'booking.n_1_day_before': '1 day before',
  'booking.n_1_week_before': '1 week before',
  'booking.n_2_days_before': '2 days before',
  'booking.next': 'Next',
  'booking.no_contact_set': 'No contact set',
  'booking.no_opening_hours_provided': 'No opening hours provided',
  'booking.no_orders_match_your_filter': 'No orders match your filter.',
  'booking.no_vehicles_added_yet': 'No vehicles added yet.',
  'booking.no_vehicles_listed': 'No vehicles listed',
  'booking.no_vehicles_selected_yet': 'No vehicles selected yet.',
  'booking.non_runner': 'Non-runner',
  'booking.none': 'None',
  'booking.not_available': 'Not available',
  'booking.not_set': 'Not set',
  'booking.notes_for_the_partner': 'Notes for the partner',
  'booking.offset_co_emissions_for_this_shipment':
    'Offset CO₂ emissions for this shipment',
  'booking.one_of_the_locations_could_not_be_positioned_on_the_map':
    'One of the locations could not be positioned on the map.',
  'booking.open_filters': 'Open filters',
  'booking.open_map': 'Open map',
  'booking.opening_hours': 'Opening hours',
  'booking.or': 'or',
  'booking.order_accepted_for_date': 'Order accepted for {{date}}',
  'booking.orders_refresh_automatically_every_5_minutes':
    'Orders refresh automatically every 5 minutes.',
  'booking.pick_up': 'Pick up',
  'booking.pick_up_city': 'Pick up city',
  'booking.pick_up_country': 'Pick up country',
  'booking.pickup_date': 'Pickup Date',
  'booking.pickup_date_must_be_selected': 'Pickup date must be selected.',
  'booking.pickup_document': 'Pickup document',
  'booking.please_select_a_driver_and_truck':
    'Please select a driver and truck',
  'booking.please_select_a_planned_date': 'Please select a planned date',
  'booking.point': 'Point',
  'booking.prefer_biofuel_usage_where_available':
    'Prefer biofuel usage where available',
  'booking.preferences_and_notes': 'Preferences & notes',
  'booking.premium_pricing_for_vip_customers':
    'Premium pricing for VIP customers',
  'booking.previous': 'Previous',
  'booking.provide_an_estimated_weight_to_calculate_price':
    'Provide an estimated weight to calculate price.',
  'booking.provide_both_pickup_and_delivery_postal_codes_to_preview_the_lane_on_the_map':
    'Provide both pickup and delivery postal codes to preview the lane on the map.',
  'booking.provide_route_details': 'Provide route details',
  'booking.quantity': 'Quantity',
  'booking.quote_updated': 'Quote updated',
  'booking.quoted_price': 'Quoted price',
  'booking.ready_from': 'Ready from',
  'booking.refresh_now': 'Refresh now',
  'booking.remove_file': 'Remove file',
  'booking.remove_from_watchlist': 'Remove from watchlist',
  'booking.remove_time_slot': 'Remove time slot',
  'booking.remove_vehicle': 'Remove vehicle',
  'booking.required': 'Required',
  'booking.route': 'Route',
  'booking.route_details': 'Route details',
  'booking.route_map': 'Route map',
  'booking.route_preview': 'Route preview',
  'booking.save': 'Save',
  'booking.save_preset': 'Save preset',
  'booking.search_by_id_ref_city': 'Search by ID, ref, city...',
  'booking.select_a_driver': 'Select a Driver',
  'booking.select_a_trailer': 'Select a Trailer',
  'booking.select_a_truck': 'Select a Truck',
  'booking.select_delivery_date': 'Select Delivery Date',
  'booking.select_pick_up_date': 'Select Pick up Date',
  'booking.select_planned_date': 'Select Planned Date',
  'booking.select_the_date_when_the_cargo_is_to_be_delivered':
    'Select the date when the cargo is to be delivered.',
  'booking.select_the_date_when_the_cargo_is_to_be_picked_up':
    'Select the date when the cargo is to be picked up.',
  'booking.select_truck_and_driver': 'Select Truck and Driver',
  'booking.set_autobid': 'Set Autobid',
  'booking.share_green_requirements_certification_numbers_or_carbon_reporting_needs':
    'Share green requirements, certification numbers, or carbon reporting needs.',
  'booking.sms': 'SMS',
  'booking.startpoint': 'StartPoint',
  'booking.summary': 'Summary',
  'booking.sustainability_options': 'Sustainability options',
  'booking.text': '—',
  'booking.this_is_a_vip_client_functionality_only':
    'This is a VIP client functionality only',
  'booking.to': 'to',
  'booking.to_2': 'To',
  'booking.total': 'total',
  'booking.transit_time_hours_h': 'Transit time: {{hours}}h',
  'booking.unable_to_load_the_map_preview_right_now':
    'Unable to load the map preview right now.',
  'booking.upload_or_drag_and_drop_accepted_jpg_png_pdf_docx_xls':
    'Upload or drag & drop. Accepted: .jpg, .png, .pdf, .docx, .xls',
  'booking.user_not_logged_in': 'User not logged in',
  'booking.valid_until_date': 'Valid until {{date}}',
  'booking.vehicle': 'Vehicle',
  'booking.vehicle_details': 'Vehicle details',
  'booking.vehicle_type': 'Vehicle type',
  'booking.vehicles': 'Vehicles',
  'booking.vin_chassis': 'VIN / Chassis',
  'booking.vip_price': 'VIP price',
  'booking.weight': 'Weight',
  'booking.weight_kg': 'Weight (kg)',
  'booking.width_cm': 'Width (cm)',
  'booking.x_vehicle_s': 'X vehicle(s)',
  'booking.your_transport_request_is_now_visible_under_my_orders':
    'Your transport request is now visible under My Orders.',
  'Payment delay: +{{days}} days': 'Payment delay: +{{days}} days',
  '{{count}} truck(s) have expired CMR insurance.':
    '{{count}} truck(s) have expired CMR insurance.',
  '{{count}} truck(s) will expire within 14 days.':
    '{{count}} truck(s) will expire within 14 days.',
  '{{count}} truck(s) are missing CMR expiry date.':
    '{{count}} truck(s) are missing CMR expiry date.',
};

Object.entries(AUTO_FILLED_ENGLISH_ONLY).forEach(([key, value]) => {
  if (!english[key]) {
    english[key] = value;
  }
});

Object.entries(SEMANTIC_KEY_ALIASES).forEach(([semanticKey, legacyKey]) => {
  if (!english[semanticKey] && english[legacyKey]) {
    english[semanticKey] = english[legacyKey];
  }
});

const applySemanticAliases = (pack) => {
  const next = { ...pack };
  Object.entries(SEMANTIC_KEY_ALIASES).forEach(([semanticKey, legacyKey]) => {
    if (next[legacyKey]) {
      next[semanticKey] = next[legacyKey];
    }
  });
  return next;
};

const AUTO_TRANSLATED_LOCALE_OVERRIDES = {
  bg: {
    to: 'към',
    Required: 'Задължително',
    'Change language': 'Промяна на езика',
    'Loading...': 'Зарежда се...',
    'Error:': 'грешка:',
    Close: 'затвори',
    Yes: 'да',
    No: 'не',
    'Keep order': 'Спазвайте реда',
    'Purchase terms': 'Условия за покупка',
    'Power of attorney': 'Пълномощно',
    'Transport details': 'Подробности за транспорта',
    'Download (PDF)': 'Изтегляне (PDF)',
    'Mark as picked up': 'Маркирайте като взето',
    'Mark as delivered': 'Маркирайте като доставено',
    'Cancel booking': 'Отказ от резервация',
    'Order marked as picked up': 'Поръчката е маркирана като взета',
    'Order marked as delivered': 'Поръчката е маркирана като доставена',
    'Order canceled': 'Поръчката е отменена',
    'Failed to cancel order': 'Неуспешно анулиране на поръчката',
    'Added {{count}} file(s)': 'Добавени {{count}} файл(ове)',
    'Awaiting Verification': 'Очаква се проверка',
    'Forgot Password': 'Забравена парола',
    Hello: 'здравей',
    friend: 'приятел',
    'Book your transport': 'Резервирайте своя транспорт',
    'fast and easy': 'бързо и лесно',
    Origin: 'Произход',
    Destination: 'Дестинация',
    'Postal code': 'Пощенски код',
    'Calculate to preview': 'Изчислете за преглед',
    "Can't be calculated yet": 'Все още не може да се изчисли',
    'Awaiting payment badge': 'Очаква се плащане',
    'Ref {{id}}': 'Реф. {{id}}',
    'Change planning': 'Променете планирането',
    'Change driver': 'Смяна на драйвера',
    'No vehicles listed': 'Няма посочени превозни средства',
    'Order not found.': 'Поръчката не е намерена.',
    'Not available': 'Не е наличен',
    'For {{date}}': 'За {{date}}',
    'Picked on {{date}}': 'Избрано на {{date}}',
    'Delivered on {{date}}': 'Доставено на {{date}}',
    'Loading notification: {{value}}': 'Известие за зареждане: {{value}}',
    'CO₂ compensation: {{value}}': 'CO₂ компенсация: {{value}}',
    'Bio fuel: {{value}}': 'Биогориво: {{value}}',
    Remove: 'Премахнете',
    'Copy {{label}}': 'Копирайте {{label}}',
    'Open navigation menu': 'Отворете менюто за навигация',
    'Open menu': 'Отворете менюто',
    'Error fetching data': 'Грешка при извличане на данни',
    'Not set': 'Не е зададено',
    'No opening hours provided': 'Не е посочено работно време',
    'Please select a planned date': 'Моля, изберете планирана дата',
    'Saved favorite route filter': 'Запазен филтър за любим маршрут',
    'Radius search': 'Търсене по радиус',
    'City or town': 'Град или град',
    'Country (optional)': 'Държава (по избор)',
    Radius: 'Радиус',
    'Searching…': 'Търсене...',
    'City not found': 'Градът не е намерен',
    'Within {{radius}} {{unit}} of {{place}}':
      'В {{radius}} {{unit}} от {{place}}',
    'Clear radius': 'Ясен радиус',
    'auth.account_status_pending_review':
      'Състояние на акаунта: Предстои преглед',
    'auth.your_account_is_pending_approval': 'Вашият акаунт чака одобрение',
    'auth.upload_your_verification_documents_below_and_we_ll_notify_you_by_email_once_your_account_is_approved':
      'Качете вашите документи за потвърждение по-долу и ние ще ви уведомим по имейл, след като акаунтът ви бъде одобрен.',
    'auth.check_status': 'Проверете състоянието',
    'auth.upload_verification_documents': 'Качете документи за проверка',
    'auth.your_uploaded_documents': 'Вашите качени документи',
    'auth.back_to_sign_in': 'Назад към влизане',
    'Q1 2025': 'Q1 2025',
    'Q2 2025': 'Q2 2025',
    'Q3 2025': 'Q3 2025',
    'Error loading documents': 'Грешка при зареждане на документи',
    'Are you sure you want to delete this document?':
      'Сигурни ли сте, че искате да изтриете този документ?',
    'Document deleted': 'Документът е изтрит',
    'Failed to delete': 'Неуспешно изтриване',
    'Failed to get download link':
      'Неуспешно получаване на връзка за изтегляне',
    'Status updated': 'Състоянието е актуализирано',
    'Update failed': 'Неуспешна актуализация',
    'Email cannot be changed.': 'Имейлът не може да се променя.',
    'No documents found.': 'Няма намерени документи.',
    'Invoice #': 'Фактура №',
    'File Name': 'Име на файл',
    Amount: 'Сума',
    Actions: 'Действия',
    Download: 'Изтегляне',
    'Mark Unpaid': 'Маркирайте Неплатено',
    'Mark Paid': 'Маркирайте Платено',
    'Please save the record before uploading documents.':
      'Моля, запазете записа, преди да качите документи.',
    'Select a file before uploading.': 'Изберете файл преди качване.',
    'Please enter an invoice number.': 'Моля, въведете номер на фактура.',
    'Upload successful': 'Качването е успешно',
    '{{count}} file(s) uploaded successfully.':
      '{{count}} файловете са качени успешно.',
    'Upload failed': 'Качването не бе успешно',
    'Unable to upload the document.': 'Не може да се качи документът.',
    'Invoice Number': 'Номер на фактура',
    'Selected files:': 'Избрани файлове:',
    Upload: 'Качване',
    'Save this record before uploading documents.':
      'Запазете този запис, преди да качвате документи.',
    'Error approving user': 'Грешка при одобряване на потребителя',
    'Error rejecting user': 'Грешка при отхвърляне на потребител',
    'Error disabling user': 'Грешка при деактивирането на потребителя',
    'User marked as VIP': 'Потребител, маркиран като VIP',
    'User unmarked as VIP': 'Потребителят е демаркиран като VIP',
    'Error marking user as VIP':
      'Грешка при маркирането на потребителя като VIP',
    'Error unmarking user as VIP':
      'Грешка при демаркирането на потребителя като VIP',
    'Failed to approve user': 'Неуспешно одобрение на потребителя',
    'Failed to reject user': 'Неуспешно отхвърляне на потребителя',
    'Failed to disable user': 'Неуспешно деактивиране на потребителя',
    'Failed to unmark user as VIP':
      'Демаркирането на потребителя като VIP не бе успешно',
    'Failed to mark user as VIP': 'Неуспешно маркиране на потребителя като VIP',
    'Invoice Management': 'Управление на фактури',
    'All Invoices': 'Всички фактури',
    'Manage all invoices uploaded by partners.':
      'Управлявайте всички фактури, качени от партньори.',
    'An unexpected error occurred. Please try again.':
      'Възникна неочаквана грешка. Моля, опитайте отново.',
    'The email address is not valid.': 'Имейл адресът не е валиден.',
    'This account has been disabled.': 'Този акаунт е деактивиран.',
    'No account found with this email.': 'Няма намерен акаунт с този имейл.',
    'Incorrect password. Please try again.':
      'Неправилна парола. Моля, опитайте отново.',
    'Invalid email or password. Please check your credentials and try again.':
      'Невалиден имейл или парола. Моля, проверете идентификационните си данни и опитайте отново.',
    'Too many failed attempts. Please try again later or reset your password.':
      'Твърде много неуспешни опити. Моля, опитайте отново по-късно или нулирайте паролата си.',
    'Network error. Check your connection and try again.':
      'Мрежова грешка. Проверете връзката си и опитайте отново.',
    'A verification email has been sent to your email address. Please verify your email before logging in.':
      'На вашия имейл адрес е изпратен имейл за потвърждение. Моля, потвърдете своя имейл, преди да влезете.',
    'Please make sure both passwords are the same.':
      'Моля, уверете се, че и двете пароли са еднакви.',
    'Verification email resent!':
      'Повторно изпращане на имейл за потвърждение!',
    'Please check your inbox.': 'Моля, проверете входящата си кутия.',
    'You need to log in first': 'Първо трябва да влезете',
    'Please sign in to resend the verification email.':
      'Моля, влезте, за да изпратите повторно имейла за потвърждение.',
    'Failed to resend email': 'Неуспешно повторно изпращане на имейл',
    'Resend verification email': 'Повторно изпращане на имейл за потвърждение',
    'Show password': 'Покажи парола',
    'Hide password': 'Скриване на паролата',
    'Awaiting verification artwork':
      'Очаква се проверка на произведения на изкуството',
    'Account status: Pending review': 'Състояние на акаунта: Предстои преглед',
    'Your account is pending approval': 'Вашият акаунт чака одобрение',
    "Upload your verification documents below and we'll notify you by email once your account is approved.":
      'Качете вашите документи за потвърждение по-долу и ние ще ви уведомим по имейл, след като акаунтът ви бъде одобрен.',
    'Check status': 'Проверете състоянието',
    'Upload verification documents': 'Качете документи за проверка',
    'Your uploaded documents': 'Вашите качени документи',
    'Back to sign in': 'Назад към влизане',
    'Hide documents': 'Скриване на документи',
    'Email verification required': 'Изисква се потвърждение на имейл',
    'Waiting for email verification': 'Изчакване на имейл потвърждение',
    'Check your email': 'Проверете имейла си',
    'We sent your verification link to':
      'Изпратихме вашата връзка за потвърждение на',
    "Didn't receive it? Check your spam folder or try again.":
      'Не го получихте? Проверете папката си със спам или опитайте отново.',
    'Resend email': 'Повторно изпращане на имейл',
    "I've verified my email": 'Потвърдих имейла си',
    'Redirecting you now.': 'Пренасочвам ви сега.',
    'Email not verified yet': 'Имейл все още не е потвърден',
    'Please click the link in your inbox and try again.':
      'Моля, щракнете върху връзката във входящата си поща и опитайте отново.',
    'Unable to resend verification email right now.':
      'В момента не може да се изпрати повторно имейл за потвърждение.',
    'Unable to check verification status right now.':
      'В момента не може да се провери състоянието на потвърждението.',
    "We've sent a new verification link to your email address.":
      'Изпратихме нова връзка за потвърждение на вашия имейл адрес.',
    'We automatically check your verification status every 30 seconds. You can also trigger an instant check after verifying your email.':
      'Ние автоматично проверяваме състоянието ви на потвърждение на всеки 30 секунди. Можете също така да задействате незабавна проверка, след като потвърдите имейла си.',
    'We automatically check your verification status every 15 seconds. You can also trigger an instant check after verifying your email.':
      'Ние автоматично проверяваме състоянието ви на потвърждение на всеки 15 секунди. Можете също така да задействате незабавна проверка, след като потвърдите имейла си.',
    'Inputs changed. Recalculate the price.':
      'Входовете са променени. Преизчислете цената.',
    'My Invoices': 'Моите фактури',
    'Upload New Invoice': 'Качване на нова фактура',
    'Please enter the invoice number and upload the invoice document. It will be reviewed by an administrator.':
      'Моля, въведете номера на фактурата и качете документа за фактура. Ще бъде прегледан от администратор.',
    'Invoice History': 'История на фактурите',
    'Client ref · {{clientRef}}': 'Реф. клиент · {{clientRef}}',
    'Order Documents': 'Документи за поръчка',
    'Upload Proof of Pickup': 'Качете доказателство за получаване',
    'Status will be updated to Picked Up after successful upload.':
      'Състоянието ще бъде актуализирано на Взето след успешно качване.',
    'Upload Proof of Delivery': 'Качете доказателство за доставка',
    'Status will be updated to Delivered after successful upload.':
      'Състоянието ще бъде актуализирано на Доставено след успешно качване.',
    'Enter first name': 'Въведете собствено име',
    'Enter last name': 'Въведете фамилия',
    'Enter phone number': 'Въведете телефонен номер',
    'Driver updated.': 'Актуализиран драйвер.',
    'The driver has been successfully updated.':
      'Драйверът е актуализиран успешно.',
    'Driver added.': 'Добавен драйвер.',
    'The new driver has been successfully added.':
      'Новият драйвер е добавен успешно.',
    'Driver deleted.': 'Драйверът е изтрит.',
    'The driver has been successfully deleted.': 'Драйверът е изтрит успешно.',
    'Trailer updated.': 'Трейлърът е актуализиран.',
    'The trailer has been successfully updated.':
      'Трейлърът е актуализиран успешно.',
    'Trailer added.': 'Добавен трейлър.',
    'The new trailer has been successfully added.':
      'Новият трейлър е добавен успешно.',
    'Trailer deleted.': 'Трейлърът е изтрит.',
    'The trailer has been successfully deleted.': 'Трейлърът е изтрит успешно.',
    'User account not found. Please complete registration.':
      'Потребителският акаунт не е намерен. Моля, завършете регистрацията.',
    'No token provided': 'Не е предоставен токен',
    'Token expired': 'Токенът е изтекъл',
    'Token revoked': 'Токенът е отменен',
    'Invalid ID token': 'Невалиден ID токен',
    Unauthorized: 'Неразрешено',
    'Unauthorized: User not authenticated.':
      'Неоторизиран: потребителят не е удостоверен.',
    'Unauthorized: User role not found.':
      'Неупълномощен: Потребителската роля не е намерена.',
    'Forbidden: Your role is not allowed to perform this action.':
      'Забранено: Вашата роля няма право да изпълнява това действие.',
    'Forbidden: This action requires a partner role.':
      'Забранено: Това действие изисква партньорска роля.',
    'Forbidden: This action requires a client role.':
      'Забранено: Това действие изисква клиентска роля.',
    'Forbidden: This action requires an admin role.':
      'Забранено: Това действие изисква администраторска роля.',
    'This user has not been approved': 'Този потребител не е одобрен',
    'User email has not been verified': 'Имейлът на потребителя не е потвърден',
    'User account has been disabled': 'Потребителският акаунт е деактивиран',
    'Booking not found': 'Резервацията не е намерена',
    'Route not found': 'Маршрутът не е намерен',
    'Pickup location (country and postalCode) is required':
      'Изисква се място на получаване (държава и пощенски код).',
    'Delivery location (country and postalCode) is required':
      'Изисква се място за доставка (държава и пощенски код).',
    'Unable to calculate route. Please check the locations and try again.':
      'Не може да се изчисли маршрут. Моля, проверете местоположенията и опитайте отново.',
    'Error calculating transport price':
      'Грешка при изчисляване на транспортната цена',
    'Booking canceled successfully': 'Резервацията е анулирана успешно',
    'Invalid request.': 'Невалидна заявка.',
    'Access denied.': 'Достъпът е отказан.',
    'Resource not found.': 'Ресурсът не е намерен.',
    'Request conflict.': 'Конфликт на заявката.',
    'Invalid data provided.': 'Предоставени са невалидни данни.',
    'Too many requests. Please try again later.':
      'Твърде много заявки. Моля, опитайте отново по-късно.',
    'Internal server error. Please try again later.':
      'Вътрешна грешка на сървъра. Моля, опитайте отново по-късно.',
    'Service temporarily unavailable.': 'Услугата е временно недостъпна.',
    'booking.load_preset': 'Заредете предварителна настройка',
    'booking.save_preset_tooltip':
      'Запазете текущите филтри като предварителна настройка за бърз достъп',
    'booking.load_preset_tooltip':
      'Заредете вашите запазени предварително зададени филтри',
    'booking.preset_saved': 'Предварителната настройка е запазена',
    'booking.preset_saved_desc':
      'Вашият предварително зададен филтър е запазен.',
    'booking.preset_loaded': 'Предварителната настройка е заредена',
    'booking.preset_load_error':
      'Неуспешно зареждане на предварителна настройка',
    'booking.no_preset_saved': 'Все още няма запазена предварителна настройка',
    'booking.date_from': 'Дата от',
    'booking.date_to': 'Дата до',
    'Active filters': 'Активни филтри',
    'All booking states': 'Всички състояния на резервация',
    'All partners': 'Всички партньори',
    'All payments': 'Всички плащания',
    'All roles': 'Всички роли',
    'All statuses': 'Всички статуси',
    'All Users': 'Всички потребители',
    'Are you sure you want to cancel booking {{id}}?':
      'Сигурни ли сте, че искате да отмените резервация {{id}}?',
    'Attach the CMR Insurance before finishing truck setup.':
      'Прикачете CMR фактурата, преди да завършите настройката на камиона.',
    Awaiting: 'В очакване',
    'Awaiting payout': 'Очаква се изплащане',
    'Booking canceled': 'Резервацията е отменена',
    'Booking marked as paid': 'Резервацията е отбелязана като платена',
    'Booking released and returned to marketplace':
      'Резервацията е освободена и върната на пазара',
    'booking.allowed_range': 'Разрешен диапазон',
    'booking.assign_transport': 'Задайте транспорт',
    'booking.back': 'Назад',
    'booking.back_to_summary': 'Назад към резюмето',
    'booking.booking_created_but_pickup_document_not_uploaded_upload_from_order_details':
      'Резервацията е създадена, но документът за получаване не е качен. Можете да го качите от Подробности за поръчката.',
    'booking.city_not_found': 'Градът не е намерен',
    'booking.city_or_town': 'Град',
    'booking.clear_radius': 'Ясен радиус',
    'booking.continue': 'Продължи',
    'booking.country_optional': 'Държава (по избор)',
    'booking.delivery_constraint_info':
      'Датата на доставка трябва да е на или след датата на получаване.',
    'booking.delivery_date_cannot_be_earlier_than_pickup_date':
      'Датата на доставка не може да бъде по-ранна от датата на получаване',
    'booking.driver': 'Шофьор',
    'booking.failed_to_open_letter_of_attorney':
      'Неуспешно отваряне на пълномощно',
    'booking.go_to_order': 'Отидете на Поръчка',
    'booking.i_accept_terms': 'Приемам условията',
    'booking.invalid_license_plate_or_vin_length':
      'Невалидна регистрационна табела или дължина на VIN.',
    'booking.invalid_vin_format_i_o_q_not_allowed':
      'Невалиден VIN формат. Знаците I, O и Q не са разрешени.',
    'booking.letter_of_attorney_file_is_empty':
      'Досието на пълномощното е празно',
    'booking.no_additional_details': 'Без допълнителни подробности',
    'booking.no_vehicle_info': 'Няма информация за автомобила',
    'booking.open_letter_of_attorney': 'Отворено пълномощно',
    'booking.opening_letter_of_attorney': 'Встъпително пълномощно...',
    'booking.order_accepted_successfully': 'Поръчката е приета успешно',
    'booking.order_cars_exceed_selected_truck_capacity':
      'Тази поръчка включва автомобили {{orderCars}}, но избраният капацитет на камиона е {{capacity}}.',
    'booking.pickup_constraint_info':
      'Датата на получаване е необходима, преди да се възложи транспорт.',
    'booking.pickup_document_upload_failed':
      'Неуспешно качване на документ за получаване',
    'booking.preparing_secure_document_preview':
      'Подготвя се визуализация на защитен документ...',
    'booking.radius_km': 'Радиус (km)',
    'booking.radius_search': 'Търсене по радиус',
    'booking.route_and_details': 'Маршрут и подробности',
    'booking.schedule': 'График',
    'booking.searching': 'Търсене...',
    'booking.select_pickup_and_delivery': 'Изберете получаване и доставка',
    'booking.select_pickup_and_delivery_dates_before_confirming':
      'Изберете дати за получаване и доставка, преди да потвърдите',
    'booking.select_pickup_date': 'Изберете дата на получаване',
    'booking.select_truck_driver_and_trailer':
      'Изберете камион, шофьор и ремарке',
    'booking.supported_formats_jpg_png_pdf_doc_docx':
      'Поддържани формати: JPG, PNG, PDF, DOC, DOCX',
    'booking.terms_and_conditions': 'Правила и условия',
    'booking.terms_text':
      'Потвърждавам транспортните условия и условията за отговорност.',
    'booking.track_shipment': 'Проследяване на пратката',
    'booking.trailer': 'Трейлър',
    'booking.transport_details': 'Подробности за транспорта',
    'booking.truck': 'Камион',
    'booking.truck_driver_planning_saved_letter_of_attorney_available':
      'Камионът, шофьорът и датите за планиране бяха запазени. Пълномощното вече е налично.',
    'booking.unexpected_error': 'Неочаквана грешка',
    'booking.vehicles_plural': 'Превозни средства',
    'booking.view_details': 'Подробности',
    'booking.vip_price_must_be_between_min_max_50_to_150_percent_of_estimated_price':
      'VIP цената трябва да бъде между {{min}} EUR и {{max}} EUR (50% до 150% от прогнозната цена).',
    'booking.vip_price_must_be_positive_number':
      'VIP цената трябва да е положително число.',
    'booking.within_radius_km_of_place':
      'В рамките на {{radius}} км от {{place}}',
    Capacity: 'Капацитет',
    'Car Capacity': 'Капацитет на автомобила',
    'Car capacity is required.': 'Необходим е капацитет на автомобила.',
    cars: 'автомобили',
    Changed: 'Променен',
    'CMR Document': 'CMR документ',
    'CMR expiry': 'CMR изтичане',
    'CMR Expiry': 'CMR Изтичане',
    'CMR expiry date is required': 'Изисква се дата на изтичане на CMR',
    'CMR Insurance': 'CMR застраховка',
    'CMR insurance expiry date': 'Дата на изтичане на застраховката CMR',
    'CMR Insurance Expiry Date': 'Дата на изтичане на CMR застраховката',
    'CMR insurance has expired. Upload a new CMR Insurance for review.':
      'Качете нова CMR фактура за преглед.',
    'CMR insurance is expiring within 14 days.':
      'CMR застраховката изтича до 14 дни.',
    'CMR Insurance required': 'Необходима е CMR фактура',
    Company: 'Компания',
    'Copy order ID': 'Копирайте ID на поръчката',
    Created: 'Създаден',
    'Current expiry': 'Текущо изтичане',
    'Date range': 'Период от време',
    days: 'дни',
    Delay: 'Закъснение',
    'Delivered + partner invoice uploaded + unpaid':
      'Доставено + качена фактура на партньор + неплатена',
    Document: 'Документ',
    'Documents uploaded': 'Качени документи',
    Done: 'Готово',
    'Download Client Invoice #{{id}}': 'Изтеглете клиентска фактура #{{id}}',
    'Download Invoice': 'Изтегляне на фактура',
    'Enter a valid capacity between 1 and 20 cars.':
      'Въведете валиден капацитет между 1 и 20 коли.',
    'Enter license plate': 'Въведете регистрационния номер',
    'Enter plate and upload CMR to add truck':
      'Въведете номер и качете CMR, за да добавите камион',
    'Error fetching users': 'Грешка при извличане на потребители',
    'Expire Soon (14 days)': 'Изтича скоро (14 дни)',
    'Explain why this CMR was rejected': 'Обяснете защо този CMR е отхвърлен',
    'Failed to copy order ID': 'Неуспешно копиране на ID на поръчката',
    'Failed to download invoice': 'Неуспешно изтегляне на фактура',
    'Failed to download proforma invoice':
      'Неуспешно изтегляне на проформа фактура',
    'Failed to generate invoice': 'Неуспешно генериране на фактура',
    'Failed to load invoice summary':
      'Неуспешно зареждане на резюмето на фактурата',
    'Failed to load letter of attorney': 'Неуспешно зареждане на пълномощно',
    'Failed to open letter of attorney': 'Неуспешно отваряне на пълномощно',
    'Failed to release booking': 'Неуспешно освобождаване на резервацията',
    'Fleet data refreshed': 'Данните за автопарка са обновени',
    'Generate Client Invoice': 'Генериране на клиентска фактура',
    'Generate Invoice': 'Генериране на фактура',
    'Generated at': 'Генерирани в',
    'How many cars can this truck carry?':
      'Колко коли може да превози този камион?',
    'In progress': 'В ход',
    Invoice: 'Фактура',
    'Invoice generated': 'Генерирана фактура',
    'Invoice generated successfully': 'Фактурата е генерирана успешно',
    'Invoice uploaded': 'Фактурата е качена',
    'Invoices uploaded by partners for platform payout processing. Client invoices are generated in each order view.':
      'Клиентските фактури се генерират във всеки изглед на поръчка.',
    'Keep booking': 'Продължете да резервирате',
    'Keep your active drivers and contact details up to date.':
      'Поддържайте активните си драйвери и данните за контакт актуални.',
    'Last Rejection': 'Последно отхвърляне',
    'Last rejection reason': 'Последна причина за отказ',
    'Letter of Attorney': 'Пълномощно',
    'Letter of attorney file is empty': 'Досието на пълномощното е празно',
    'License plate cannot be changed after creation. Re-upload CMR Insurance instead.':
      'Вместо това качете отново CMR фактура.',
    'License plate is required.': 'Изисква се регистрационен номер.',
    'Manage large order volumes with search, payment actions, and invoice workflows.':
      'Управлявайте големи обеми поръчки с търсене, действия по плащане и работни процеси за фактури.',
    'Manage license plates and keep CMR Insurances approved and valid.':
      'Управлявайте регистрационни номера и поддържайте CMR фактурите одобрени и валидни.',
    'Manage status updates, documents, and payment steps from one place.':
      'Управлявайте актуализации на състоянието, документи и стъпки за плащане от едно място.',
    'Manage trailer plate records and keep availability current.':
      'Управлявайте записите с номера на ремаркето и поддържайте наличността актуална.',
    'Mark booking {{id}} as paid?':
      'Да се ​​маркира ли резервацията {{id}} като платена?',
    Missing: 'Липсва',
    'Needs attention': 'Нуждае се от внимание',
    'New (14 days)': 'Ново (14 дни)',
    'No bookings found for the current filters.':
      'Няма намерени резервации за текущите филтри.',
    'No confirmed CMR document uploaded yet.':
      'Все още няма качен потвърден CMR документ.',
    'No driver assigned': 'Няма назначен шофьор',
    'No letter of attorney has been generated yet.':
      'Все още не е генерирано пълномощно.',
    'No matching delivered orders': 'Няма съответстващи доставени поръчки',
    'No new notifications': 'Няма нови известия',
    'No partners found.': 'Няма намерени партньори.',
    'No trucks found for this filter.': 'Няма намерени камиони за този филтър.',
    'No users found for current filters.':
      'Няма намерени потребители за текущите филтри.',
    'Not uploaded': 'Не е качено',
    Notifications: 'Известия',
    of: 'на',
    'Only admins can set or update this expiry date after reviewing your CMR insurance.':
      'Само администраторите могат да задават или актуализират тази дата на изтичане след преглед на вашата CMR застраховка.',
    'Open letter of attorney': 'Отворено пълномощно',
    Order: 'ред',
    'Order actions': 'Поръчайте действия',
    'Order ID copied': 'ID на поръчката е копиран',
    Owner: 'Собственик',
    Page: 'Страница',
    'Paid date': 'Платена дата',
    'Partner delivery date': 'Дата на доставка на партньор',
    'Partner documents': 'Партньорски документи',
    'Partner Invoice': 'Партньорска фактура',
    'Partner invoice uploaded': 'Фактурата на партньора е качена',
    'Partner Payout Invoices': 'Фактури за изплащане на партньори',
    'Partner pickup date': 'Дата на вземане от партньор',
    'Partner score': 'Партньорски резултат',
    Payment: 'Плащане',
    'Payout date': 'Дата на изплащане',
    'penalties applied': 'приложени санкции',
    'Pending admin review': 'Предстои преглед от администратор',
    'Pending review': 'Предстои преглед',
    'Pending trucks': 'Чакащи камиони',
    'Please provide a clear reason for rejection.':
      'Моля, посочете ясна причина за отказ.',
    'Please select an order before uploading an invoice.':
      'Моля, изберете поръчка, преди да качите фактура.',
    'Please try again.': 'Моля, опитайте отново.',
    'Proforma Invoice': 'Проформа фактура',
    'Provide a rejection reason for this CMR review.':
      'Посочете причина за отхвърляне на този CMR преглед.',
    'Quarter Score': 'Четвърт резултат',
    'Re-upload CMR': 'Повторно качване на CMR',
    Refresh: 'Опресняване',
    'Rejection reason': 'Причина за отказ',
    'Rejection reason is required': 'Изисква се причина за отхвърляне',
    'Release booking {{id}} back to the marketplace so another partner can accept it?':
      'Да се пусне ли резервацията {{id}} обратно на пазара, така че друг партньор да може да я приеме?',
    Reset: 'Нулиране',
    'Review Bookings': 'Преглед на резервациите',
    Revision: 'Ревизия',
    Rows: 'Редове',
    'Search by invoice number, file name, or booking ID':
      'Търсете по номер на фактура, име на файл или ID на резервация',
    'Search by name, email, company': 'Търсете по име, имейл, фирма',
    'Search by name, email, company, uid': 'Търсете по име, имейл, фирма, uid',
    'Search client': 'Клиент за търсене',
    'Search delivered order': 'Търсете доставена поръчка',
    'Search license plate or owner':
      'Търсете регистрационен номер или собственик',
    'Search order ID': 'ID на поръчката за търсене',
    'Search partner': 'Партньор за търсене',
    'Select a new CMR Insurance to re-upload for this truck.':
      'Изберете нова CMR фактура за повторно качване за този камион.',
    'Select paid date': 'Изберете дата на плащане',
    'Set CMR insurance expiry date to approve this truck.':
      'Задайте дата на изтичане на застраховката CMR, за да одобрите този камион.',
    'Set maximum number of cars this truck can carry (1-20).':
      'Задайте максимален брой автомобили, които този камион може да превозва (1-20).',
    'Set the CMR insurance expiry date before approval.':
      'Задайте датата на изтичане на застраховката CMR преди одобрението.',
    Showing: 'Показване',
    'Showing page {{page}} of {{pages}} • {{total}} invoices':
      'Показана е страница {{page}} от {{pages}} • {{total}} фактури',
    'Status will be updated to Picked Up after successful upload. You can add multiple car photos before uploading.':
      'Можете да добавите няколко снимки на автомобили преди качване.',
    Terms: 'Условия',
    Total: 'Общо',
    'Track paid and unpaid invoices, expected payout dates, and upload new invoices quickly.':
      'Проследявайте платени и неплатени фактури, очаквани дати на изплащане и бързо качвайте нови фактури.',
    'Truck approved successfully': 'Камионът е одобрен успешно',
    'Truck documents': 'Документи за камион',
    'Truck license plate': 'Регистрационен номер на камион',
    'Truck rejected successfully': 'Камионът е отхвърлен успешно',
    'truck(s) are pending admin CMR expiry date.':
      'камиони са в очакване на административна дата на изтичане на CMR.',
    'truck(s) have expired CMR insurance and are disabled.':
      'камионите са с изтекла CMR застраховка и са инвалидизирани.',
    'truck(s) will expire within 14 days.':
      'камион(и) ще изтече в рамките на 14 дни.',
    'Unable to prepare the record for upload.':
      'Не може да се подготви записът за качване.',
    Unpaid: 'Неплатени',
    'Upload a CMR Insurance before closing this truck setup.':
      'Качете CMR фактура, преди да затворите тази настройка на камиона.',
    'Upload a valid CMR insurance. Each upload sends the truck back to pending review.':
      'Всяко качване изпраща камиона обратно към изчакващ преглед.',
    'Upload documents': 'Качване на документи',
    'Upload Invoice': 'Качване на фактура',
    'Upload order documents': 'Качване на документи за поръчка',
    'Upload unavailable': 'Качването не е налично',
    Uploaded: 'Качено',
    'Uploaded • Paid': 'Качен • Платен',
    'Uploaded • Partially paid': 'Качен • Частично платен',
    'Uploaded by partner for platform payout processing.':
      'Качен от партньор за обработка на изплащания от платформата.',
    User: 'Потребител',
    'Verification code': 'Код за потвърждение',
    'View details': 'Вижте подробности',
    'View Partners': 'Вижте партньори',
    'Working hours not provided': 'Не е предвидено работно време',
    '{{value}} orders': '{{value}} поръчки',
    Invoiced: 'Фактуриран',
    'Loading admin data...': 'Данните на администратора се зареждат...',
    'Pending partners': 'Чакащи партньори',
    'Unpaid bookings': 'Неплатени резервации',
    'Total users': 'Общо потребители',
    'Orders per period': 'Поръчки за период',
    'Orders by status': 'Поръчки по статус',
    'Quick actions': 'Бързи действия',
    'Verify new partners': 'Проверете нови партньори',
    'Review partner applications and approve or reject requests.':
      'Преглеждайте заявките за партньори и одобрявайте или отхвърляйте заявки.',
    'Manage all trucks': 'Управлявайте всички камиони',
    'Review, approve, reject, disable, and filter all trucks.':
      'Прегледайте, одобрете, отхвърлете, деактивирайте и филтрирайте всички камиони.',
    'Review bookings': 'Прегледайте резервациите',
    'Review all transport orders, payment states, and generated invoices.':
      'Прегледайте всички транспортни поръчки, състояния на плащане и генерирани фактури.',
    'Manage all users': 'Управление на всички потребители',
    'Manage user status, roles, and validation records.':
      'Управление на потребителски статус, роли и записи за валидиране.',
    'User breakdown': 'Разбивка на потребителя',
    Clients: 'клиенти',
    Partners: 'Партньори',
    Admins: 'Администратори',
    'Top 5 pending partners': 'Топ 5 чакащи партньори',
    'No pending partners right now.': 'В момента няма чакащи партньори.',
    pending: 'в очакване',
    'Top 5 pending trucks': 'Топ 5 чакащи камиона',
    'No pending trucks right now.': 'В момента няма чакащи камиони.',
    'Unknown owner': 'Неизвестен собственик',
    'KPI cards and top lists link directly to filtered admin screens.':
      'KPI карти и топ списъци се свързват директно към филтрирани администраторски екрани.',
    'booking.available_orders_title': 'Налични поръчки',
    'booking.available_orders_description':
      'Прегледайте възможностите за входящ транспорт и приложете филтри, за да отговарят на вашия капацитет.',
    'booking.vehicle_pickup_location': 'Място за вземане на превозно средство',
    'booking.pickup_opening_hours': 'Работно време за получаване',
    'booking.vehicle_delivery_location': 'Място за доставка на автомобила',
    'booking.delivery_opening_hours': 'Работно време за доставка',
    'booking.pickup_contact': 'Контакт за вземане',
    'booking.delivery_contact': 'Контакт за доставка',
    'booking.vehicles_scheduled': 'Превозни средства по график',
    'booking.watchlist_title': 'Списък за наблюдение',
    'booking.watchlist_description':
      'Проследявайте запазените възможности и действайте бързо при промени в наличността.',
    'Loading dashboard...': 'Таблото за управление се зарежда...',
    'Total bookings': 'Общо резервации',
    'Open bookings': 'Отворени резервации',
    'Order status timeline': 'График на състоянието на поръчката',
    'Last 6 months of bookings grouped by current status.':
      'Последните 6 месеца резервации, групирани по текущо състояние.',
    'Create new order': 'Създайте нова поръчка',
    'Create a new transport booking request.':
      'Създайте нова заявка за резервация на транспорт.',
    'View my orders': 'Вижте моите поръчки',
    'Review status and details of your bookings.':
      'Прегледайте състоянието и подробностите за вашите резервации.',
    'Open profile': 'Отворен профил',
    'Update company and contact details.':
      'Актуализирайте фирмените данни и данните за контакт.',
    'Recent bookings': 'Скорошни резервации',
    'No bookings yet.': 'Все още няма резервации.',
    'Unknown destination': 'Неизвестна дестинация',
    'Quarter score': 'Четвърт резултат',
    '{{value}} completed': '{{value}} завършен',
    'Truck CMR warning': 'CMR предупреждение за камион',
    'One truck has CMR expiry risk. Review it in Fleet.':
      'Един камион има риск от изтичане на CMR. Прегледайте го във Fleet.',
    '{{count}} trucks have CMR expiry risk. Review them in Fleet.':
      'Камионите {{count}} имат риск от изтичане на CMR. Прегледайте ги във Fleet.',
    'Active queue': 'Активна опашка',
    'Delivered bookings': 'Доставени резервации',
    'Cars delivered': 'Доставени автомобили',
    'Canceled bookings': 'Отменени резервации',
    'Avg assign-to-pickup': 'Средно назначение до вземане',
    'Quarter Partner Score': 'Резултат за тримесечие',
    'Payment delay: +{{days}} days': 'Забавяне на плащането: +{{days}} дни',
    'Penalty events': 'Наказателни събития',
    Current: 'Текущ',
    'Completed orders per period': 'Изпълнени поръчки за период',
    'Completed orders': 'Изпълнени поръчки',
    'Truck CMR status alerts': 'Сигнали за CMR състояние на камиони',
    '{{count}} truck(s) have expired CMR insurance.':
      'Камионът(ите) на {{count}} е с изтекла CMR застраховка.',
    '{{count}} truck(s) will expire within 14 days.':
      'Камионът(ите) на {{count}} ще изтече след 14 дни.',
    '{{count}} truck(s) are missing CMR expiry date.':
      '{{count}} камиони нямат срок на годност на CMR.',
    'Upload a new CMR Insurance in Fleet. The truck will stay pending until admin review.':
      'Качете нова CMR фактура във Fleet. Камионът ще остане в очакване до преглед от администратор.',
    'Open fleet to resolve CMR alerts':
      'Отворете флота за разрешаване на CMR сигнали',
    'Operational actions': 'Оперативни действия',
    'Open marketplace orders': 'Поръчки на отворен пазар',
    'Review available orders and plan assignments.':
      'Прегледайте наличните поръчки и планирайте задания.',
    'My accepted orders': 'Моите приети поръчки',
    'Manage delivery progress and documents.':
      'Управлявайте напредъка на доставката и документите.',
    'Update trucks, trailers, and availability.':
      'Актуализирайте камиони, ремаркета и наличност.',
    'Partner invoices': 'Партньорски фактури',
    'Upload and track invoice payments.':
      'Качвайте и проследявайте плащанията по фактури.',
    'No active orders in queue.': 'Няма активни поръчки в опашката.',
    'profile.incompleteTitle': 'Профилът е незавършен',
    'profile.incompleteDescription':
      'Моля, попълнете информацията за вашия профил (фирма, телефон, адрес, град, пощенски код), за да получите достъп до всички функции.',
    'profile.goToProfile': 'Отидете на Профил',
    'auth.email_placeholder': 'име@компания.com',
    'auth.authentication_mode_switch':
      'Превключвател на режима на удостоверяване',
    'auth.invalid_email': 'Невалиден имейл',
    'auth.please_enter_a_valid_email_address':
      'Моля, въведете валиден имейл адрес.',
    'auth.email_not_found': 'Имейлът не е намерен',
    'auth.no_account_found_with_that_email_address':
      'Няма намерен акаунт с този имейл адрес.',
    'auth.email_sent': 'Имейлът е изпратен!',
    'auth.something_went_wrong_try_again': 'Нещо се обърка. Опитайте отново.',
    'auth.we_sent_a_password_reset_link_open_your_inbox_and_follow_the_instructions':
      'Изпратихме връзка за повторно задаване на парола. Отворете входящата си кутия и следвайте инструкциите.',
    'auth.forgot_your_password': 'Забравена парола?',
    'auth.enter_your_account_email_and_we_will_send_you_a_password_reset_link':
      'Въведете имейл адреса на вашия акаунт и ние ще ви изпратим връзка за повторно задаване на парола.',
    'auth.email_address': 'Имейл адрес',
    'auth.send_reset_link': 'Изпратете връзка за нулиране',
    'auth.cancel': 'Отказ',
    'auth.tip_if_you_do_not_receive_the_email_check_spam_and_promotions_folders':
      'Съвет: ако не получите имейла, проверете папките за спам и промоции.',
    'booking.e_g_berlin': 'напр. Берлин',
    'booking.e_g_germany': 'напр. Германия',
    'booking.watchlist': 'Списък за наблюдение',
    'booking.view_map': 'Вижте картата',
    'booking.invalid_input': 'Невалиден вход',
    'booking.please_enter_only_numbers_for_the_zip_code':
      'Моля, въведете само цифри за пощенския код.',
    'booking.pickup_zip_code': 'Пощенски код за получаване',
    'booking.delivery_zip_code': 'Пощенски код за доставка',
    'booking.select_vehicle_make': 'Изберете марка превозно средство',
    'booking.unnamed_item': 'Елемент без име',
    'booking.cars': 'автомобили',
    'booking.more_info': 'Повече информация',
    'booking.loading': 'Зареждане...',
    'booking.no_items_found': 'Няма намерени елементи',
    'booking.selected_cars': 'Избрани автомобили',
    'booking.unknown_type': 'Неизвестен тип',
    'booking.delete_car': 'Изтрий колата',
    'Toggle details': 'Превключване на детайлите',
    'auth.a_verification_email_has_been_sent_to_your_email_address_please_verify_your_emai':
      'На вашия имейл адрес е изпратен имейл за потвърждение. Моля, потвърдете своя имейл, преди да влезете.',
    'auth.an_unexpected_error_occurred_please_try_again':
      'Възникна неочаквана грешка. Моля, опитайте отново.',
    'auth.failed_to_resend_email': 'Неуспешно повторно изпращане на имейл',
    'auth.show_password': 'Покажи парола',
    'auth.hide_password': 'Скриване на паролата',
    'auth.incorrect_password_please_try_again':
      'Неправилна парола. Моля, опитайте отново.',
    'auth.invalid_email_or_password_please_check_your_credentials_and_try_again':
      'Невалиден имейл или парола. Моля, проверете идентификационните си данни и опитайте отново.',
    'auth.network_error_check_your_connection_and_try_again':
      'Мрежова грешка. Проверете връзката си и опитайте отново.',
    'auth.no_account_found_with_this_email':
      'Няма намерен акаунт с този имейл.',
    'auth.please_check_your_inbox': 'Моля, проверете входящата си кутия.',
    'auth.please_make_sure_both_passwords_are_the_same':
      'Моля, уверете се, че и двете пароли са еднакви.',
    'auth.please_sign_in_to_resend_the_verification_email':
      'Моля, влезте, за да изпратите повторно имейла за потвърждение.',
    'auth.resend_verification_email':
      'Повторно изпращане на имейл за потвърждение',
    'auth.awaiting_verification_artwork':
      'Очаква се проверка на произведения на изкуството',
    'auth.email_verification_required': 'Изисква се потвърждение на имейл',
    'auth.waiting_for_email_verification': 'Изчакване на имейл потвърждение',
    'auth.check_your_email': 'Проверете имейла си',
    'auth.we_sent_your_verification_link_to':
      'Изпратихме вашата връзка за потвърждение на',
    'auth.didnt_receive_it_check_spam_or_try_again':
      'Не го получихте? Проверете папката си със спам или опитайте отново.',
    'auth.resend_email': 'Повторно изпращане на имейл',
    'auth.i_verified_my_email': 'Потвърдих имейла си',
    'auth.redirecting_you_now': 'Пренасочвам ви сега.',
    'auth.email_not_verified_yet': 'Имейл все още не е потвърден',
    'auth.please_click_the_link_in_your_inbox_and_try_again':
      'Моля, щракнете върху връзката във входящата си поща и опитайте отново.',
    'auth.unable_to_resend_verification_email_right_now':
      'В момента не може да се изпрати повторно имейл за потвърждение.',
    'auth.unable_to_check_verification_status_right_now':
      'В момента не може да се провери състоянието на потвърждението.',
    'auth.we_sent_a_new_verification_link':
      'Изпратихме нова връзка за потвърждение на вашия имейл адрес.',
    'auth.we_automatically_check_every_30_seconds':
      'Ние автоматично проверяваме състоянието ви на потвърждение на всеки 30 секунди. Можете също така да задействате незабавна проверка, след като потвърдите имейла си.',
    'auth.we_automatically_check_every_15_seconds':
      'Ние автоматично проверяваме състоянието ви на потвърждение на всеки 15 секунди. Можете също така да задействате незабавна проверка, след като потвърдите имейла си.',
    'auth.the_email_address_is_not_valid': 'Имейл адресът не е валиден.',
    'auth.this_account_has_been_disabled': 'Този акаунт е деактивиран.',
    'auth.too_many_failed_attempts_please_try_again_later_or_reset_your_password':
      'Твърде много неуспешни опити. Моля, опитайте отново по-късно или нулирайте паролата си.',
    'auth.verification_email_resent':
      'Повторно изпращане на имейл за потвърждение!',
    'auth.you_need_to_log_in_first': 'Първо трябва да влезете',
    'booking.error_fetching_data': 'Грешка при извличане на данни',
    'booking.inputs_changed_recalculate_the_price':
      'Входовете са променени. Преизчислете цената.',
    'booking.no_opening_hours_provided': 'Не е посочено работно време',
    'booking.no_vehicles_listed': 'Няма посочени превозни средства',
    'booking.not_available': 'Не е наличен',
    'booking.not_set': 'Не е зададено',
    'booking.please_select_a_planned_date': 'Моля, изберете планирана дата',
    'booking.required': 'Задължително',
    'booking.to': 'към',
    'booking.order': 'ред',
    'booking.duration': 'Продължителност',
    'booking.vehicles_overview': 'Преглед на превозните средства',
    'booking.body': 'Тяло',
    'booking.dims': 'Димс',
    'booking.select_vehicle_model': 'Изберете модел превозно средство',
    'booking.selected_type_value': 'Избрано: {{value}}',
    'booking.select_a_vehicle_type': 'Изберете тип превозно средство:',
    'booking.select_vehicle_weight': 'Изберете тегло на автомобила',
    'booking.selected_weight_kg': 'Избрано: {{value}} кг',
    'booking.adjust_weight': 'Коригирайте теглото',
    'Dates updated successfully': 'Датите са актуализирани успешно',
    'Error updating dates': 'Грешка при актуализирането на датите',
    'Set Planned Dates': 'Задайте планирани дати',
    'Set your planned pickup and arrival dates below.':
      'Задайте планираните си дати за вземане и пристигане по-долу.',
    'Changing dates after initial setup will deduct 20% from your performance score for this order.':
      'Промяната на датите след първоначалната настройка ще приспадне 20% от резултата ви за изпълнение за тази поръчка.',
    'Planned Pickup Date': 'Планирана дата на получаване',
    'Planned Arrival Date': 'Планирана дата на пристигане',
    Listing: 'Списък',
    'Try broadening the current search or status filter.':
      'Опитайте да разширите текущото търсене или филтър за състояние.',
    'Try broadening the search, role, or status filters.':
      'Опитайте да разширите филтрите за търсене, роля или състояние.',
    'Monitor fleet compliance, validation status, and expiring insurance in one place.':
      'Наблюдавайте съответствието на автопарка, състоянието на валидиране и изтичащата застраховка на едно място.',
    'Active Listings': 'Активни обяви',
    'Open transport requests': 'Отворете заявки за транспорт',
    'Quotes Today': 'Цитати днес',
    'Submitted in last 24h': 'Изпратено през последните 24 часа',
    'Platform Revenue (MTD)': 'Приходи от платформа (MTD)',
    'Month to date': 'Месец до днес',
    'Pending Partners': 'Чакащи партньори',
    'Awaiting approval': 'Очаква се одобрение',
    'Unpaid Invoices': 'Неплатени фактури',
    'Requires action': 'Изисква действие',
    'Completed Transports': 'Извършени транспорти',
    'All time delivered': 'Доставено през цялото време',
    'Admin Dashboard': 'Администраторско табло',
    'Platform overview and key performance indicators.':
      'Преглед на платформата и ключови показатели за ефективност.',
    'Loading dashboard metrics...':
      'Зареждат се показателите на таблото за управление...',
    Invoices: 'Фактури',
    'Review payout invoices uploaded by partners and keep payout processing organized.':
      'Преглеждайте фактурите за изплащане, качени от партньори, и организирайте обработката на изплащанията.',
    Flexible: 'Гъвкав',
    'Flexible dates': 'Гъвкави дати',
    'Could not load this listing.': 'Тази обява не можа да се зареди.',
    'Listing canceled': 'Обявата е отменена',
    'Failed to cancel listing': 'Неуспешно анулиране на списъка',
    Reference: 'справка',
    Category: 'Категория',
    'Client type': 'Тип клиент',
    'Company country': 'Държава на компанията',
    Expires: 'Изтича',
    'Back to listings': 'Назад към списъците',
    'Listing not found.': 'Обявата не е намерена.',
    'Cancel Listing': 'Отказ от регистрацията',
    'Listing details': 'Подробности за обявата',
    'Reference {{id}}': 'Справка {{id}}',
    'Read-only listing overview for admins.':
      'Общ преглед на списъка само за четене за администратори.',
    'Pick-up': 'Вземане',
    'No exact coordinates are stored for this listing yet.':
      'Все още няма съхранени точни координати за тази обява.',
    'Structured overview of quantities and handling details.':
      'Структуриран преглед на количествата и подробности за обработката.',
    'Shipment images': 'Изображения на пратката',
    'No shipment images were uploaded for this listing.':
      'Няма качени изображения на пратка за тази обява.',
    'Proof of pickup': 'Доказателство за вземане',
    'Final documents': 'Окончателни документи',
    Description: 'Описание',
    'Quotes ({{count}})': 'Цитати ({{count}})',
    'Loading quotes...': 'Офертите се зареждат...',
    'No quotes for this listing.': 'Няма котировки за тази обява.',
    'Score: {{score}}/100': 'Резултат: {{score}}/100',
    'Pickup: {{date}}': 'Вземане: {{date}}',
    'Delivery: {{date}}': 'Доставка: {{date}}',
    'Cancel Listing?': 'Отмяна на регистрацията?',
    'This will permanently cancel the listing and notify the client. Continue?':
      'Това ще анулира окончателно списъка и ще уведоми клиента. Продължаване?',
    Keep: 'Запазете',
    'Review partner applications, check their documents, and keep approval decisions consistent.':
      'Прегледайте кандидатурите на партньори, проверете техните документи и поддържайте последователни решения за одобрение.',
    'No client payments recorded yet':
      'Все още няма регистрирани клиентски плащания',
    'Client payment rows will appear here when the payments backend is connected.':
      'Редовете за клиентски плащания ще се появят тук, когато бекендът за плащания е свързан.',
    Method: 'Метод',
    'No partner payouts recorded yet':
      'Все още няма записани изплащания на партньори',
    'Payout rows will appear here once partner payout processing is enabled.':
      'Редовете за изплащане ще се появят тук, след като обработката на изплащане от партньор е активирана.',
    'Payout Amount': 'Сума на изплащане',
    'No platform fees recorded yet':
      'Все още няма записани такси за платформата',
    'Fee rows will appear here once payment settlement data is available.':
      'Редовете за таксите ще се появят тук, след като данните за плащането са налични.',
    Gross: 'Брутно',
    'Fee (20%)': 'Такса (20%)',
    Payments: 'Плащания',
    'Client payments, partner payouts, and platform fee tracking.':
      'Плащания на клиенти, изплащания на партньори и проследяване на такси за платформа.',
    'Client Payments': 'Клиентски плащания',
    'Partner Payouts': 'Партньорски изплащания',
    'Platform Fees': 'Платформени такси',
    'Failed to load reviews': 'Неуспешно зареждане на рецензии',
    'Review removed': 'Отзивът е премахнат',
    'Failed to remove review': 'Премахването на прегледа не бе успешно',
    Reviews: 'Отзиви',
    'All partner and transport reviews submitted by clients.':
      'Всички мнения за партньори и транспорт, предоставени от клиенти.',
    'Loading reviews...': 'Отзивите се зареждат...',
    'No reviews found': 'Няма намерени отзиви',
    'Client feedback will appear here when reviews are submitted.':
      'Отзивите на клиентите ще се появят тук, когато бъдат изпратени рецензии.',
    Stars: 'Звезди',
    Comment: 'Коментирайте',
    'Search, review, and maintain user accounts with one consistent admin workflow.':
      'Търсете, преглеждайте и поддържайте потребителски акаунти с един последователен администраторски работен процес.',
    'Track paid and unpaid partner payout invoices, and upload the next delivered listing invoice quickly.':
      'Проследявайте платени и неплатени фактури за изплащане на партньори и бързо качвайте следващата доставена фактура за обява.',
    'Search by invoice number, file name, or listing ID':
      'Търсете по номер на фактура, име на файл или идентификатор на обява',
    'Loading delivered listings...': 'Доставените обяви се зареждат...',
    'Search delivered listing by reference, title, or route':
      'Търсене в доставен списък по препратка, заглавие или маршрут',
    'Route details available in listing':
      'Подробности за маршрута са налични в списъка',
    'No matching delivered listings': 'Няма съответстващи доставени обяви',
    'Selected listing': 'Избрана обява',
    'Has quotes': 'Има цитати',
    'In transit': 'В транзит',
    Open: 'Отворете',
    Accepted: 'Прието',
    Completed: 'Завършено',
    'Client Dashboard': 'Клиентско табло',
    'Overview of your current transport listings, quote activity, and recent requests.':
      'Преглед на текущите ви транспортни обяви, дейност с оферти и скорошни заявки.',
    'Total listings': 'Общо обяви',
    'Active listings': 'Активни обяви',
    'Listings with quotes': 'Оферти с котировки',
    'Accepted transport': 'Приет транспорт',
    'Listing status timeline': 'Хронология на състоянието на списъка',
    'Last 6 months of listings grouped by current status.':
      'Последните 6 месеца обяви, групирани по текущо състояние.',
    'No listing activity yet': 'Все още няма активност в списъка',
    'Create your first listing to start tracking request activity here.':
      'Създайте първата си обява, за да започнете да проследявате активността на заявките тук.',
    'Create new listing': 'Създайте нова обява',
    'Create a new transport request for the marketplace.':
      'Създайте нова заявка за транспорт за пазара.',
    'View my listings': 'Вижте моите обяви',
    'Review quote activity and manage your transport requests.':
      'Прегледайте активността на офертите и управлявайте заявките си за транспорт.',
    'Recent listings': 'Последни обяви',
    'No listings yet': 'Все още няма обяви',
    'Your newest transport requests will appear here once you create them.':
      'Най-новите ви заявки за транспорт ще се появят тук, след като ги създадете.',
    'Unknown origin': 'Неизвестен произход',
    '{{count}} quote(s)': '{{count}} цитат(и)',
    '{{value}} completed listings': '{{value}} завършени обяви',
    'Monitor current performance, fleet readiness, quote flow, and your active transport queue.':
      'Наблюдавайте текущата производителност, готовността на автопарка, потока от оферти и вашата активна транспортна опашка.',
    'Total assigned': 'Общо присвоени',
    'Quarter rating': 'Четвърт рейтинг',
    'Based on current quarter performance':
      'Въз основа на представянето за текущото тримесечие',
    Rating: 'Рейтинг',
    'Requirement met': 'Изискването е изпълнено',
    'Requirement not met': 'Изискването не е изпълнено',
    'Completed listings per period': 'Завършени обяви за период',
    'No completion data yet': 'Все още няма данни за завършване',
    'Statistics will appear here after your first delivered work.':
      'Статистиката ще се появи тук след първата ви доставена работа.',
    'Completed listings': 'Завършени обяви',
    'Review truck documents and refresh anything close to expiry.':
      'Прегледайте документите на камиона и обновете всичко, което е близо до изтичане.',
    'Search deliveries': 'Търсене на доставки',
    'Review available marketplace listings and submit quotes.':
      'Прегледайте наличните обяви на пазара и изпратете оферти.',
    'My quotes': 'Моите цитати',
    'Track accepted, pending, and rejected quotes in one place.':
      'Проследявайте приети, чакащи и отхвърлени оферти на едно място.',
    'Profile settings': 'Настройки на профила',
    'Keep company information and compliance details up to date.':
      'Поддържайте информацията за компанията и подробностите за съответствие актуални.',
    'No active queue items': 'Няма активни елементи от опашката',
    'Accepted and in-progress work will appear here as your transport activity grows.':
      'Приетите и текущата работа ще се показват тук, когато вашата транспортна дейност нараства.',
    'Your role does not have permission to open this page.':
      'Вашата роля няма разрешение за отваряне на тази страница.',
    'Go to dashboard': 'Отидете на таблото за управление',
    'Trailer capacity is required.': 'Изисква се капацитет на ремаркето.',
    'How many cars can this trailer carry?':
      'Колко коли може да превози това ремарке?',
    'Set maximum number of cars this trailer can carry (1-20).':
      'Задайте максимален брой автомобили, които това ремарке може да превозва (1-20).',
    'Invalid max load (kg).': 'Невалидно максимално натоварване (кг).',
    'Enter a valid weight between 1 and 100000 kg, or leave it empty.':
      'Въведете валидно тегло между 1 и 100 000 kg или го оставете празно.',
    'Maximum payload weight this truck can carry (optional).':
      'Максимално тегло на полезен товар, което може да носи този камион (опция).',
    'Manage the company and contact details that appear across your listings, invoices, and account verification flows.':
      'Управлявайте компанията и данните за контакт, които се показват във вашите обяви, фактури и потоци за проверка на акаунта.',
    'Keep these details up to date so listings, invoices, and partner verification stay accurate.':
      'Поддържайте тези подробности актуални, така че обявите, фактурите и потвърждението на партньора да останат точни.',
    'Unsaved changes': 'Незапазени промени',
    'All changes saved': 'Всички промени са запазени',
    'auth.sign_up_failed': 'Регистрацията е неуспешна',
    'auth.please_select_a_valid_role': 'Моля, изберете валидна роля.',
    'booking.pickup_not_found': 'Пикапът не е намерен.',
    'booking.delivery_not_found': 'Доставката не е намерена.',
    'booking.capacity': 'Капацитет',
    'booking.cmr_expiry': 'CMR Изтичане',
    'booking.uploaded': 'Качено',
    'booking.missing': 'Липсва',
    'booking.cmr_document': 'CMR документ',
    'booking.go_to_profile': 'Отидете на Профил',
    'booking.click_to_download_purchase_terms':
      'Кликнете, за да изтеглите Условията за покупка',
    'admin.purchase_terms_management': 'Управление на условията за покупка',
    'admin.purchase_terms_management_subtitle':
      'Качете и поддържайте локализирани PDF файлове с условия за покупка, използвани при приемане на поръчки от партньори.',
    'admin.document_language': 'Език на документа',
    'admin.click_to_download_purchase_terms':
      'Кликнете, за да изтеглите Условията за покупка',
    'admin.current_language_label': 'Текущ език: {{language}}',
    'admin.purchase_terms_unavailable_for_selected_language':
      'Документът с условията за покупка не е наличен за избрания език.',
    'Download and review the active purchase terms in your current interface language before continuing.':
      'Изтеглете и прегледайте активните условия за покупка на текущия език на интерфейса, преди да продължите.',
    'We make agreements and conclude a contract for the carriage of goods. I have just read this agreement in full and agree to its contents.':
      'Договаряме и сключваме договор за превоз на товари. Току-що прочетох това споразумение изцяло и съм съгласен със съдържанието му.',
    'I confirm that I will schedule this order within 24 hours':
      'Потвърждавам, че ще планирам тази поръчка в рамките на 24 часа',
    'Failed to load purchase terms document.':
      'Неуспешно зареждане на документа с условията за покупка.',
    'Partner rating': 'Партньорска оценка',
    'Bronze requirements': 'Изисквания за бронз',
    'Orders in quarter': 'Поръчки на тримесечие',
    'Cancellation rate / 100 orders': 'Процент на анулиране / 100 поръчки',
    'Damage claims / 100 orders': 'Искове за щети / 100 поръчки',
    '{{current}} / min {{target}}': '{{current}} / мин {{target}}',
    '{{current}} / max {{target}}': '{{current}} / макс. {{target}}',
    Met: 'Мет',
    'Not met': 'Не е изпълнено',
    Unranked: 'Некласиран',
    'profile.incompleteDescriptionPartner':
      'Моля, попълнете информацията за вашия профил (фирма, телефон, адрес, град, пощенски код, ДДС номер), за да получите достъп до всички функции.',
    'profile.incompleteDescriptionClient':
      'Моля, попълнете информацията за вашия профил (телефонен номер), за да получите достъп до всички функции.',
    'auth.verification_email_sent': 'Имейлът за потвърждение е изпратен',
    '{{amount}} above the client target': '{{amount}} над клиентската цел',
    '{{amount}} below the client target': '{{amount}} под клиентската цел',
    '{{count}} image(s) added to the listing.':
      '{{count}} изображения, добавени към списъка.',
    '{{count}} quote(s) received': '{{count}} получена оферта(и).',
    '{{count}} reviews': '{{count}} отзиви',
    '{{count}} total': '{{count}} общо',
    '{{count}} visible': '{{count}} се вижда',
    '{{weight}} kg': '{{weight}} кг',
    'A Google route preview with pins A and B appears here once pickup and delivery coordinates are available.':
      'Визуализация на маршрут от Google с щифтове A и B се появява тук, след като са налични координатите за получаване и доставка.',
    'A route preview appears once map coordinates are available.':
      'Визуализация на маршрута се появява, след като са налични координатите на картата.',
    'A timeline of clarifications connected to this listing.':
      'График на разясненията, свързани с този списък.',
    "Accept {{partner}}'s quote for {{amount}}?":
      'Да приемете ли офертата на {{partner}} за {{amount}}?',
    'Accept Listing': 'Приеми регистрацията',
    'Accept quote': 'Приеми офертата',
    'Accepted quote': 'Приета оферта',
    'Accepted quote required': 'Изисква се приета оферта',
    'Accepting...': 'Приема се...',
    Active: 'Активен',
    'Active statuses': 'Активни състояния',
    'Add another item': 'Добавяне на друг елемент',
    'Add images': 'Добавете изображения',
    'Add more shipment images': 'Добавете още изображения на пратката',
    'After you confirm an AI action, open the prepared destination immediately instead of waiting for a manual click.':
      'След като потвърдите действие на AI, отворете незабавно подготвената дестинация, вместо да чакате ръчно щракване.',
    'AI Assistant': 'AI асистент',
    'AI assistant disabled for all users.':
      'AI помощникът е деактивиран за всички потребители.',
    'AI assistant enabled for all users.':
      'AI асистентът е активиран за всички потребители.',
    'AI assistant preferences updated':
      'Предпочитанията за AI помощник са актуализирани',
    'AI disabled for user.': 'AI е деактивиран за потребителя.',
    'AI enabled for user.': 'AI активиран за потребителя.',
    'AI-powered message translation between languages':
      'Задвижван от AI превод на съобщения между езици',
    'All route-critical information in one place before you review quotes or documents.':
      'Цялата критична за маршрута информация на едно място, преди да прегледате оферти или документи.',
    View: 'Преглед',
    Answer: 'отговор',
    Archive: 'Архив',
    'Archived statuses': 'Архивирани състояния',
    'Are you sure you want to reject the quote from':
      'Сигурни ли сте, че искате да отхвърлите цитата от',
    'Ask a question about this listing...':
      'Задайте въпрос относно тази обява...',
    'Ask for matching lanes, quote help, or the next operational step.':
      'Поискайте съвпадащи ленти, предложете помощ или следващата оперативна стъпка.',
    'Ask for quote comparisons or a prepared next step from this shipment screen.':
      'Поискайте сравнения на оферти или подготвена следваща стъпка от този екран за доставка.',
    'Assistant history cleared': 'Историята на Асистент е изчистена',
    'Automatically translate messages from other users into your preferred language using AI.':
      'Автоматично превеждайте съобщения от други потребители на предпочитания от вас език с помощта на AI.',
    'Back to listing': 'Обратно към списъка',
    'Best offer': 'Най-добра оферта',
    'Best quote': 'Най-добър цитат',
    'Body type: {{type}}': 'Тип тяло: {{type}}',
    'Breed: {{breed}}': 'Порода: {{breed}}',
    Budget: 'Бюджет',
    'Cancel listing': 'Отказ от регистрацията',
    'Canceled and completed work will appear here once listings move out of the active view.':
      'Отменената и завършена работа ще се покаже тук, след като списъците излязат от активния изглед.',
    'Cargo Details': 'Подробности за товара',
    Categories: 'Категории',
    'Choose the interface language. This preference is saved locally and applies immediately.':
      'Изберете езика на интерфейса. Това предпочитание се запазва локално и се прилага незабавно.',
    'Clear all': 'Изчисти всички',
    'Clear assistant history': 'Изчистване на хронологията на асистента',
    'Client price in EUR': 'Клиентска цена в евро',
    'Client target price': 'Целева цена за клиента',
    'Complete the payment below to lock the fixed-price acceptance and let the partner start planning.':
      'Завършете плащането по-долу, за да заключите приемането на фиксирана цена и да позволите на партньора да започне да планира.',
    'Complete the payment below to lock the selected quote and let the partner start planning.':
      'Завършете плащането по-долу, за да заключите избраната оферта и да позволите на партньора да започне да планира.',
    'Compose area prepared for listing Q&A. Submission remains disabled until the live question endpoint is connected on this page.':
      'Зона за писане, подготвена за списък с въпроси и отговори. Изпращането остава деактивирано, докато крайната точка на живия въпрос не бъде свързана на тази страница.',
    'Confirm delivery complete': 'Потвърдете, че доставката е завършена',
    'Confirm payment received': 'Потвърдете полученото плащане',
    'Confirm that you have received the bank transfer or payment for this listing. This will move the listing to Paid status and allow the partner to mark it as planned.':
      'Потвърдете, че сте получили банковия превод или плащането за тази обява. Това ще премести списъка в статус Платено и ще позволи на партньора да го маркира като планирано.',
    'Confirm the exact fleet and dates before the listing moves to Planned.':
      'Потвърдете точния флот и датите, преди списъкът да се премести в Планиран.',
    'Confirm Transport Plan': 'Потвърдете транспортния план',
    'Confirming...': 'Потвърждава се...',
    'Control how the web assistant behaves on this device. These settings do not change your account data.':
      'Контролирайте как се държи уеб асистентът на това устройство. Тези настройки не променят данните в акаунта ви.',
    'Create listing': 'Създаване на обява',
    'Create with AI': 'Създавайте с AI',
    'Create your next transport request and it will appear here with route, item, and quote activity.':
      'Създайте следващата си заявка за транспорт и тя ще се появи тук с дейност по маршрут, артикул и оферта.',
    'Current stage:': 'Текущ етап:',
    'Current status': 'Текущо състояние',
    'Delivery confirmation needed': 'Необходимо е потвърждение за доставка',
    'Delivery radius': 'Радиус на доставка',
    'Delivery:': 'Доставка:',
    'Describe the route and cargo, then review the prepared listing draft before publishing.':
      'Опишете маршрута и товара, след което прегледайте подготвения проект на списък преди публикуване.',
    'Describe the shipment you need and review the prepared request before publishing.':
      'Опишете необходимата ви пратка и прегледайте подготвената заявка преди публикуване.',
    'Download and review the purchase terms before confirming the transport plan.':
      'Изтеглете и прегледайте условията за покупка, преди да потвърдите транспортния план.',
    'Download invoice': 'Изтегляне на фактура',
    'Download Purchase Terms': 'Изтеглете Условия за покупка',
    'Draft with AI': 'Чернова с AI',
    'Draft your review first, then submit it here when you are satisfied.':
      'Първо напишете своя преглед, след което го изпратете тук, когато сте доволни.',
    'Edit listing': 'Редактиране на обява',
    'Edit Quote': 'Редактиране на цитат',
    Enable: 'Активирайте',
    'Enable live translation': 'Активирайте превода на живо',
    'Enabled Users': 'Активирани потребители',
    'Engagement Activity': 'Ангажирана дейност',
    'Expires:': 'Изтича:',
    'Failed to accept listing': 'Неуспешно приемане на списъка',
    'Failed to accept quote': 'Неуспешно приемане на оферта',
    'Failed to clear assistant history':
      'Неуспешно изчистване на хронологията на асистента',
    'Failed to complete listing': 'Неуспешно завършване на списъка',
    'Failed to confirm payment': 'Неуспешно потвърждаване на плащането',
    'Failed to confirm transport plan':
      'Неуспешно потвърждаване на транспортния план',
    'Failed to disable AI for user.':
      'Неуспешно деактивиране на AI за потребителя.',
    'Failed to enable AI for user.':
      'Неуспешно активиране на AI за потребителя.',
    'Failed to load listing.': 'Неуспешно зареждане на списъка.',
    'Failed to load listings': 'Неуспешно зареждане на обявите',
    'Failed to load listings. Please try again.':
      'Неуспешно зареждане на обявите. Моля, опитайте отново.',
    'Failed to load review context.':
      'Неуспешно зареждане на контекста на прегледа.',
    'Failed to load settings.': 'Неуспешно зареждане на настройките.',
    'Failed to refresh Stripe payment status':
      'Неуспешно опресняване на състоянието на плащане в Stripe',
    'Failed to reject quote': 'Неуспешно отхвърляне на офертата',
    'Failed to release listing': 'Неуспешно публикуване на списъка',
    'Failed to save quote': 'Неуспешно запазване на офертата',
    'Failed to update listing': 'Неуспешно актуализиране на списъка',
    'Failed to update preferred language':
      'Неуспешно актуализиране на предпочитания език',
    'Failed to update setting.': 'Неуспешно актуализиране на настройката.',
    'Failed to update status': 'Неуспешно актуализиране на състоянието',
    'Failed to update translation preference':
      'Неуспешно актуализиране на предпочитанието за превод',
    'Failed to update watchlist':
      'Неуспешно актуализиране на списъка за наблюдение',
    'Failed to withdraw quote': 'Оттеглянето на офертата не бе успешно',
    'Feature Flags': 'Флагове за функции',
    'Filter invoice uploads, search by reference, and page through payout records.':
      'Филтрирайте качванията на фактури, търсете по справка и преглеждайте записите за изплащания.',
    Filters: 'Филтри',
    'Final delivery documents': 'Окончателни документи за доставка',
    'Fixed price only': 'Само фиксирана цена',
    'Flexible / not set': 'Гъвкав / не е зададен',
    'Generated automatically when the transport plan is confirmed.':
      'Генерира се автоматично при потвърждаване на транспортния план.',
    'Generation: {{generation}}': 'Генерация: {{generation}}',
    'Goods delivered — awaiting client confirmation.':
      'Стоките са доставени — очакват потвърждение от клиента.',
    'Gross price': 'Цена бруто',
    'I have read and agree to the purchase terms for this transport job.':
      'Прочетох и съм съгласен с условията за закупуване на тази транспортна работа.',
    'I understand that accepting this listing assigns it to me at the fixed client price shown above.':
      'Разбирам, че приемането на тази обява ми я възлага на фиксираната клиентска цена, показана по-горе.',
    'Image upload failed': 'Неуспешно качване на изображение',
    'Images uploaded': 'Изображенията са качени',
    'Interface language': 'Език на интерфейса',
    'Invoice documents': 'Документи за фактури',
    'Item {{number}}': 'Артикул {{number}}',
    items: 'елементи',
    'Keep listing': 'Продължавайте да изброявате',
    'Keep quote': 'Запазете цитата',
    'Keep the current AI session available after closing the browser on this device.':
      'Запазете текущата AI сесия достъпна след затваряне на браузъра на това устройство.',
    'Language & Region': 'Език и регион',
    'Lift: {{origin}} / {{destination}}':
      'Асансьор: {{origin}} / {{destination}}',
    Listed: 'В списъка',
    'Listing {{id}}': 'Обява {{id}}',
    'Listing accepted': 'Обявата е приета',
    'Listing expired': 'Обявата е изтекла',
    'Listing images': 'Изброяване на изображения',
    'Listing is live': 'Обявата е активна',
    'Listing reference': 'Справка за списък',
    'Listing snapshot': 'Моментна снимка на списъка',
    'Listing unavailable': 'Обявата не е налична',
    'Listing updated': 'Обявата е актуализирана',
    'Live Translation': 'Превод на живо',
    'Live translation disabled.': 'Преводът на живо е деактивиран.',
    'Live translation enabled.': 'Активиран превод на живо.',
    'Loading approved trucks...': 'Зареждане на одобрени камиони...',
    'Loading fleet...': 'Автопаркът се зарежда...',
    'Loading listing details...': 'Подробностите за обява се зареждат...',
    'Loading listings...': 'Зареждат се обяви...',
    'Loading review details...': 'Подробностите за рецензията се зареждат...',
    'Loading settings...': 'Настройките се зареждат...',
    'Manage AI Assistant Users': 'Управление на потребителите на AI Assistant',
    'Manage platform-wide feature flags and configuration.':
      'Управлявайте флагове и конфигурация на функции за цялата платформа.',
    'Manage Users': 'Управление на потребителите',
    'Manage your transport requests, monitor quote activity, and keep active and archived work easy to scan.':
      'Управлявайте заявките си за транспорт, наблюдавайте активността на офертите и поддържайте активна и архивирана работа лесна за сканиране.',
    'Mark Picked Up': 'Марк взето',
    'Matches the client target price': 'Отговаря на целевата цена на клиента',
    Media: 'Медия',
    Messages: 'Съобщения',
    'Messages will be translated into this language.':
      'Съобщенията ще бъдат преведени на този език.',
    'Minimum net:': 'Минимална мрежа:',
    'My invoices': 'Моите фактури',
    Net: 'Нет',
    'Net price': 'Чиста цена',
    'Net quote': 'Нетна оферта',
    'New images appear immediately in the listing details for client, partner, and admin views.':
      'Новите изображения се появяват незабавно в детайлите на списъка за клиентски, партньорски и администраторски изгледи.',
    'Next step': 'Следваща стъпка',
    'No active listings yet': 'Все още няма активни обяви',
    'No address provided': 'Не е предоставен адрес',
    'No answer yet.': 'Все още няма отговор.',
    'No archived listings yet': 'Все още няма архивирани обяви',
    'No description added.': 'Няма добавено описание.',
    'no destination': 'няма дестинация',
    'No expiry': 'Без изтичане',
    'No listings match the current filters. Try broadening the search or date range.':
      'Няма обяви, които отговарят на текущите филтри. Опитайте да разширите търсенето или диапазона от дати.',
    'no origin': 'без произход',
    'No questions yet': 'Все още няма въпроси',
    'No quotes yet': 'Все още няма цитати',
    'No shipment images uploaded yet.':
      'Все още няма качени изображения на пратката.',
    'No trailer selected': 'Няма избран трейлър',
    'No unread messages': 'Няма непрочетени съобщения',
    'No users found.': 'Няма намерени потребители.',
    'No users have AI enabled.': 'Няма потребители с активиран AI.',
    'Not selected': 'Не е избрано',
    'Offers summary': 'Резюме на офертите',
    'Open AI assistant': 'Отворете AI помощник',
    'Open prepared screens automatically':
      'Автоматично отваряне на подготвени екрани',
    'Optional visible price shown to partners as your target budget.':
      'Незадължителна видима цена, показана на партньорите като целеви бюджет.',
    'Other quotes will be declined automatically once this offer is accepted.':
      'Други оферти ще бъдат отхвърлени автоматично, след като тази оферта бъде приета.',
    'Partner delivery': 'Партньорска доставка',
    'Partner pickup': 'Партньорско вземане',
    'Partner quote': 'Партньорска оферта',
    'Payment confirmed': 'Плащането е потвърдено',
    'Payment confirmed — listing status set to paid':
      'Плащането е потвърдено — състоянието на списъка е платено',
    'Payment confirmed. Confirm the assigned fleet and planned dates before the listing moves to Planned.':
      'Плащането е потвърдено. Потвърдете зададения флот и планираните дати, преди списъкът да се премести в Планиран.',
    'Payment is confirmed. The partner now needs to confirm the truck, driver, and planned dates.':
      'Плащането е потвърдено. Сега партньорът трябва да потвърди камиона, шофьора и планираните дати.',
    'Payment required': 'Изисква се плащане',
    'Photos uploaded for the shipment and visible across client, partner, and admin views.':
      'Снимки, качени за пратката и видими в клиентски, партньорски и администраторски изгледи.',
    'Pickup is complete and the transport is currently underway.':
      'Приемането е завършено и транспортът е в ход.',
    'Pickup proof': 'Доказателство за вземане',
    'Pickup proof and final delivery files uploaded by the transport partner.':
      'Файлове за доказателство за получаване и окончателна доставка, качени от транспортния партньор.',
    'Pickup to delivery overview': 'Преглед на вземане до доставка',
    'Pickup:': 'Приемане:',
    'Plan and authorization': 'План и оторизация',
    'Plan transport': 'Планирайте транспорт',
    'Plan Transport': 'Планирайте транспорта',
    'Planned dates:': 'Планирани дати:',
    'Planned delivery date': 'Планирана дата на доставка',
    'Platform Settings': 'Настройки на платформата',
    'Preferred language': 'Предпочитан език',
    'Preferred language updated': 'Предпочитаният език е актуализиран',
    'Prepare a quote or ask for the next lane action, then confirm before anything is submitted.':
      'Подгответе оферта или поискайте следващото действие в лентата, след което потвърдете, преди да бъде изпратено нещо.',
    'Purchase Terms': 'Условия за покупка',
    'Quantities, dimensions, and handling details ready for transport review.':
      'Количества, размери и подробности за обработка, готови за транспортен преглед.',
    Question: 'Въпрос',
    Questions: 'Въпроси',
    'Questions & answers': 'Въпроси и отговори',
    'Questions and answers for this listing will appear here once the messaging flow is active.':
      'Въпросите и отговорите за този списък ще се появят тук, след като потокът от съобщения е активен.',
    'Quick access to the current shipment, quote, and billing state.':
      'Бърз достъп до текущата пратка, оферта и състояние на фактуриране.',
    'Quote accepted': 'Цитатът е приет',
    'Quote count': 'Брой цитати',
    'Quote message': 'Цитирай съобщение',
    'Quote rejected': 'Цитатът е отхвърлен',
    'Quote withdrawn': 'Цитатът е оттеглен',
    Quotes: 'Цитати',
    'Quotes and questions': 'Цитати и въпроси',
    'Quotes are disabled for this listing. The first partner to accept the fixed price will be assigned automatically.':
      'Цитатите са деактивирани за тази обява. Първият партньор, който приеме фиксираната цена, ще бъде назначен автоматично.',
    'Quotes are disabled for this shipment. If you accept it, the client price becomes an accepted booking immediately.':
      'Офертите са деактивирани за тази пратка. Ако я приемете, клиентската цена веднага се превръща в приета резервация.',
    'Quotes from transport providers usually begin to appear shortly after publishing. Refresh to check again.':
      'Офертите на доставчиците на транспорт обикновено започват да се появяват скоро след публикуването. Опреснете, за да проверите отново.',
    'Reference #{{id}}': 'Референтен #{{id}}',
    'Refresh listings': 'Опресняване на списъците',
    'Reject quote': 'Отхвърлете офертата',
    'Rejecting...': 'Отхвърляне...',
    Release: 'Освобождаване',
    'Release Listing': 'Списък на изданието',
    'Remember assistant conversation': 'Запомнете разговора на асистента',
    'Required for fixed-price listings. Partners accept this amount directly.':
      'Изисква се за обяви с фиксирана цена. Партньорите приемат тази сума директно.',
    'Required. Partners will be able to accept this listing at the fixed client price without sending a quote.':
      'Задължително. Партньорите ще могат да приемат тази обява на фиксирана клиентска цена, без да изпращат оферта.',
    'Review submission failed.': 'Изпращането на преглед не бе успешно.',
    'Review the completed transport using the standard product flow.':
      'Прегледайте завършения транспорт, като използвате стандартния продуктов поток.',
    'Route pending': 'Предстоящ маршрут',
    'Save changes': 'Запазете промените',
    'Saving...': 'Запазва се...',
    'Search by title, route, category, or item':
      'Търсете по заглавие, маршрут, категория или артикул',
    'Search Results': 'Резултати от търсенето',
    'Search users by email...': 'Търсете потребители по имейл...',
    'Select a truck, driver, pickup date, and delivery date.':
      'Изберете камион, шофьор, дата на получаване и дата на доставка.',
    'Select approved truck': 'Изберете одобрен камион',
    'Select driver': 'Изберете драйвер',
    'Send Revision': 'Изпрати редакция',
    Sentiment: 'настроения',
    'Share what went well and what could improve':
      'Споделете какво върви добре и какво може да се подобри',
    'Shipment in transit': 'Транзитна пратка',
    'Shipment notes': 'Товарни бележки',
    'Shipment tracking will be shared':
      'Проследяването на пратката ще бъде споделено',
    'Show AI launchers': 'Показване на AI стартери',
    'Show or hide AI assistant buttons on supported dashboard and listing pages.':
      'Показване или скриване на бутоните за AI помощник на поддържаните табла за управление и страници със списъци.',
    'Special needs or notes': 'Специални нужди или бележки',
    'Specify delivery dates': 'Посочете дати за доставка',
    'Specify pickup dates': 'Посочете датите на получаване',
    Stage: 'Етап',
    'Status updated to {{status}}': 'Статусът е актуализиран до {{status}}',
    'Stripe payment confirmed and booking updated':
      'Плащането на Stripe е потвърдено и резервацията е актуализирана',
    'Stripe status: {{status}}': 'Статус на лентата: {{status}}',
    'Submit question': 'Изпратете въпрос',
    'Submit review': 'Изпратете преглед',
    'Submitting...': 'Изпраща се...',
    'The AI assistant is currently disabled for this environment. Existing local session data can still be cleared here.':
      'AI асистентът в момента е деактивиран за тази среда. Съществуващите данни за локална сесия все още могат да бъдат изчистени тук.',
    'The listing expired before a transport was confirmed.':
      'Списъкът е изтекъл преди да бъде потвърден транспорт.',
    'The listing has been fully completed and archived as a finished transport.':
      'Обявата е напълно завършена и архивирана като готов транспорт.',
    'The lowest net price you would still accept for this shipment.':
      'Най-ниската нетна цена, която бихте приели за тази пратка.',
    'The partner has confirmed the route plan. Pickup and delivery dates are now scheduled.':
      'Партньорът потвърди плана на маршрута. Датите за получаване и доставка вече са насрочени.',
    'The partner marked the shipment as delivered. Review the final documents and confirm completion.':
      'Партньорът маркира пратката като доставена. Прегледайте окончателните документи и потвърдете завършването.',
    'The partner-confirmed plan and LOA stay grouped together for faster review.':
      'Потвърденият от партньор план и LOA остават групирани заедно за по-бърз преглед.',
    'This action notifies the transport provider and removes the quote from active consideration.':
      'Това действие уведомява доставчика на транспорт и премахва офертата от активно разглеждане.',
    'This listing is archived and no further transport actions are available.':
      'Този списък е архивиран и не са налични други транспортни действия.',
    'This listing needs an accepted quote before a review can be created.':
      'Тази обява се нуждае от приета оферта, преди да може да бъде създаден преглед.',
    'This will soft-cancel the listing and move it to your archive.':
      'Това ще анулира плавно списъка и ще го премести във вашия архив.',
    'This will soft-cancel the listing for the client and remove it from active marketplace views.':
      'Това ще анулира плавно списъка за клиента и ще го премахне от активните изгледи на пазара.',
    'Total quote': 'Обща оферта',
    'Tracking not promised': 'Проследяването не е обещано',
    'Tracking shared': 'Споделено проследяване',
    'Tracking visibility': 'Проследяване на видимостта',
    'Trailer (Optional)': 'Трейлър (по избор)',
    'Translation preference updated':
      'Предпочитанията за превод са актуализирани',
    'Transport completed': 'Транспортът е завършен',
    'Transport completed.': 'Транспортът е завършен.',
    'Transport documents': 'Транспортни документи',
    'Transport marked as complete': 'Транспортът е маркиран като завършен',
    'Transport package': 'Транспортна опаковка',
    'Transport plan confirmed': 'Транспортният план е потвърден',
    'Transport plan updated': 'Актуализиран транспортен план',
    'Transport planned': 'Планиран транспорт',
    'Transport Provider': 'Доставчик на транспорт',
    'Transport providers can review your shipment and send offers.':
      'Транспортните доставчици могат да прегледат вашата пратка и да изпратят оферти.',
    'Transport stage': 'Транспортен етап',
    Truck: 'Камион',
    'Truck, driver, trailer, and planned dates for this shipment.':
      'Камион, шофьор, ремарке и планирани дати за тази пратка.',
    'Try widening the current listing filters.':
      'Try widening the current listing filters.',
    'Unable to upload listing images.':
      'Не може да се качат изображения на списък.',
    'Unknown error': 'Неизвестна грешка',
    'Untitled listing': 'Неозаглавен списък',
    'Untitled Listing': 'Обява без заглавие',
    'Update media': 'Актуализирайте медиите',
    'Update transport plan': 'Актуализирайте транспортния план',
    'Update Transport Plan': 'Актуализирайте транспортния план',
    'Upload a CMR or delivery photos before marking delivered.':
      'Качете CMR или снимки за доставка, преди да маркирате доставено.',
    'Upload a CMR or delivery photos before the listing can move to Delivered.':
      'Качете CMR или снимки за доставка, преди списъкът да може да се премести в Delivered.',
    'Upload at least one pickup proof before the listing can move to Picked Up.':
      'Качете поне едно доказателство за получаване, преди обявата да може да се премести в „Взето“.',
    'Upload final documents': 'Качете окончателни документи',
    'Upload proof of pickup': 'Качете доказателство за получаване',
    'Uploading...': 'Качване...',
    'Use fresh photos when the shipment changes or you want to clarify the item condition.':
      'Използвайте свежи снимки при промяна на пратката или искате да изясните състоянието на артикула.',
    'users enabled': 'активирани потребители',
    'Visible to you while quoting. You can still send your own net offer below or above this amount.':
      'Вижда се за вас, докато цитирате. Все още можете да изпратите своя собствена нетна оферта под или над тази сума.',
    'Waiting for partner acceptance': 'Изчакване за приемане от партньор',
    'Waiting for transport planning': 'В очакване на транспортно планиране',
    'When enabled, messages from other users will be automatically translated to your preferred language.':
      'Когато е активирано, съобщенията от други потребители ще бъдат автоматично преведени на предпочитания от вас език.',
    Withdraw: 'Оттегляне',
    'Write Review': 'Напишете отзив',
    'You are about to release this listing back to the marketplace.':
      'На път сте да пуснете тази обява обратно на пазара.',
    'You are now the assigned partner for this fixed-price listing.':
      'Вече сте избраният партньор за тази обява с фиксирана цена.',
    'Your quote has been accepted. Awaiting payment confirmation from the admin before you can begin the job.':
      'Вашата оферта е приета. Очаква се потвърждение за плащане от администратора, преди да можете да започнете работа.',
    'VIN: {{vin}}': 'VIN: {{vin}}',
  },
  de: {
    to: 'zu',
    Mo: 'Mo',
    Fr: 'Fr',
    Sa: 'Sa',
    kg: 'kg',
    Coupé: 'Coupé',
    Crossover: 'Crossover',
    Van: 'Van',
    Required: 'Erforderlich',
    'Change language': 'Sprache ändern',
    'Loading...': 'Laden…',
    'Error:': 'Fehler:',
    Close: 'Schließen',
    Yes: 'Ja',
    No: 'Nein',
    'Keep order': 'Halten Sie Ordnung',
    Price: 'Preis',
    Status: 'Status',
    'Purchase terms': 'Einkaufsbedingungen',
    'Power of attorney': 'Vollmacht',
    'Transport details': 'Transportdetails',
    'Upload damages': 'Schadensersatz hochladen',
    'Download (PDF)': 'Herunterladen (PDF)',
    'Mark as picked up': 'Als abgeholt markieren',
    'Mark as delivered': 'Als geliefert markieren',
    'Cancel booking': 'Buchung stornieren',
    'Order marked as picked up': 'Bestellung als abgeholt markiert',
    'Order marked as delivered': 'Bestellung als geliefert markiert',
    'Order canceled': 'Bestellung storniert',
    'Failed to cancel order': 'Bestellung konnte nicht storniert werden',
    'Added {{count}} file(s)': '{{count}}-Datei(en) hinzugefügt',
    Pages: 'Seiten',
    'Awaiting Verification': 'Warten auf Bestätigung',
    Dashboard: 'Armaturenbrett',
    'Profile Incomplete': 'Profil unvollständig',
    'Please complete your profile information (Company, Phone, Address, City, Post Code) to access all features.':
      'Bitte vervollständigen Sie Ihre Profilinformationen (Firma, Telefon, Adresse, Stadt, Postleitzahl), um auf alle Funktionen zugreifen zu können.',
    'Go to Profile': 'Gehen Sie zu Profil',
    'Forgot Password': 'Passwort vergessen',
    Hello: 'Hallo',
    friend: 'Freund',
    'Book your transport': 'Buchen Sie Ihren Transport',
    'fast and easy': 'schnell und einfach',
    Route: 'Route',
    Origin: 'Herkunft',
    Destination: 'Ziel',
    'Postal code': 'Postleitzahl',
    'Calculate to preview': 'Berechnen Sie, um eine Vorschau anzuzeigen',
    "Can't be calculated yet": 'Kann noch nicht berechnet werden',
    'Awaiting payment badge': 'Warten auf Zahlung',
    'Ref {{id}}': 'Ref. {{id}}',
    'Change planning': 'Änderungsplanung',
    'Change driver': 'Fahrer wechseln',
    'No vehicles listed': 'Keine Fahrzeuge aufgeführt',
    Info: 'Infos',
    Bank: 'Bank',
    'Order not found.': 'Bestellung nicht gefunden.',
    'Not available': 'Nicht verfügbar',
    'For {{date}}': 'Für {{date}}',
    'Picked on {{date}}': 'Gepflückt am {{date}}',
    'Delivered on {{date}}': 'Geliefert am {{date}}',
    'Loading notification: {{value}}': 'Ladebenachrichtigung: {{value}}',
    'CO₂ compensation: {{value}}': 'CO₂-Kompensation: {{value}}',
    'Bio fuel: {{value}}': 'Biokraftstoff: {{value}}',
    Remove: 'Entfernen',
    'Copy {{label}}': 'Kopieren Sie {{label}}',
    'Open navigation menu': 'Navigationsmenü öffnen',
    'Open menu': 'Menü öffnen',
    'Error fetching data': 'Fehler beim Abrufen der Daten',
    'Not set': 'Nicht festgelegt',
    'No opening hours provided': 'Keine Öffnungszeiten angegeben',
    'Please select a planned date':
      'Bitte wählen Sie einen geplanten Termin aus',
    'Saved favorite route filter': 'Gespeicherter Lieblingsroutenfilter',
    km: 'km',
    mi: 'mi',
    'Radius search': 'Umkreissuche',
    'City or town': 'Stadt oder Gemeinde',
    'Country (optional)': 'Land (optional)',
    Radius: 'Radius',
    'Searching…': 'Suche...',
    'City not found': 'Stadt nicht gefunden',
    'Within {{radius}} {{unit}} of {{place}}':
      'Innerhalb {{radius}} {{unit}} von {{place}}',
    'Clear radius': 'Freier Radius',
    'auth.status_label': 'Status',
    'auth.account_status_pending_review': 'Kontostatus: Überprüfung ausstehend',
    'auth.your_account_is_pending_approval':
      'Ihr Konto muss noch genehmigt werden',
    'auth.upload_your_verification_documents_below_and_we_ll_notify_you_by_email_once_your_account_is_approved':
      'Laden Sie unten Ihre Verifizierungsdokumente hoch und wir benachrichtigen Sie per E-Mail, sobald Ihr Konto genehmigt wurde.',
    'auth.check_status': 'Status prüfen',
    'auth.upload_verification_documents': 'Verifizierungsdokumente hochladen',
    'auth.your_uploaded_documents': 'Ihre hochgeladenen Dokumente',
    'auth.back_to_sign_in': 'Zurück zur Anmeldung',
    role_partner: 'Partner',
    Gold: 'Gold',
    Bronze: 'Bronze',
    partner: 'Partner',
    admin: 'Admin',
    'Q1 2025': 'Q1 2025',
    'Q2 2025': 'Q2 2025',
    'Q3 2025': 'Q3 2025',
    Details: 'Details',
    Andorra: 'Andorra',
    Kosovo: 'Kosovo',
    Liechtenstein: 'Liechtenstein',
    Malta: 'Malta',
    Monaco: 'Monaco',
    Montenegro: 'Montenegro',
    Portugal: 'Portugal',
    'San Marino': 'San Marino',
    Ukraine: 'Ukraine',
    'BodyType.Coupe': 'Coupé',
    'BodyType.Crossover': 'Crossover',
    'BodyType.Pickup': 'Abholung',
    'BodyType.Van': 'Van',
    Partner: 'Partner',
    StartPoint: 'Starten',
    EndPoint: 'Ende',
    Name: 'Name',
    'Error loading documents': 'Fehler beim Laden der Dokumente',
    'Are you sure you want to delete this document?':
      'Möchten Sie dieses Dokument wirklich löschen?',
    'Document deleted': 'Dokument gelöscht',
    'Failed to delete': 'Fehler beim Löschen',
    'Failed to get download link':
      'Download-Link konnte nicht abgerufen werden',
    'Status updated': 'Status aktualisiert',
    'Update failed': 'Update fehlgeschlagen',
    'Email cannot be changed.':
      'Die E-Mail-Adresse kann nicht geändert werden.',
    'No documents found.': 'Keine Dokumente gefunden.',
    'Invoice #': 'Rechnungsnummer',
    'File Name': 'Dateiname',
    Amount: 'Betrag',
    Actions: 'Aktionen',
    Download: 'Herunterladen',
    'Mark Unpaid': 'Als unbezahlt markieren',
    'Mark Paid': 'Mark bezahlt',
    'Please save the record before uploading documents.':
      'Bitte speichern Sie den Datensatz, bevor Sie Dokumente hochladen.',
    'Select a file before uploading.':
      'Wählen Sie vor dem Hochladen eine Datei aus.',
    'Please enter an invoice number.':
      'Bitte geben Sie eine Rechnungsnummer ein.',
    'Upload successful': 'Hochladen erfolgreich',
    '{{count}} file(s) uploaded successfully.':
      '{{count}}-Datei(en) erfolgreich hochgeladen.',
    'Upload failed': 'Der Upload ist fehlgeschlagen',
    'Unable to upload the document.':
      'Das Dokument kann nicht hochgeladen werden.',
    'Invoice Number': 'Rechnungsnummer',
    'Selected files:': 'Ausgewählte Dateien:',
    Upload: 'Hochladen',
    'Save this record before uploading documents.':
      'Speichern Sie diesen Datensatz, bevor Sie Dokumente hochladen.',
    'Error approving user': 'Fehler beim Genehmigen des Benutzers',
    'Error rejecting user': 'Fehler beim Ablehnen des Benutzers',
    'Error disabling user': 'Fehler beim Deaktivieren des Benutzers',
    'User marked as VIP': 'Benutzer als VIP markiert',
    'User unmarked as VIP': 'Benutzer als VIP nicht markiert',
    'Error marking user as VIP': 'Fehler beim Markieren des Benutzers als VIP',
    'Error unmarking user as VIP':
      'Fehler beim Aufheben der Markierung des Benutzers als VIP',
    'Failed to approve user': 'Benutzer konnte nicht genehmigt werden',
    'Failed to reject user': 'Benutzer konnte nicht abgelehnt werden',
    'Failed to disable user': 'Benutzer konnte nicht deaktiviert werden',
    'Failed to unmark user as VIP':
      'Die Markierung des Benutzers als VIP konnte nicht aufgehoben werden',
    'Failed to mark user as VIP':
      'Benutzer konnte nicht als VIP markiert werden',
    'Invoice Management': 'Rechnungsverwaltung',
    'All Invoices': 'Alle Rechnungen',
    'Manage all invoices uploaded by partners.':
      'Verwalten Sie alle von Partnern hochgeladenen Rechnungen.',
    'An unexpected error occurred. Please try again.':
      'Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    'The email address is not valid.': 'Die E-Mail-Adresse ist ungültig.',
    'This account has been disabled.': 'Dieses Konto wurde deaktiviert.',
    'No account found with this email.':
      'Mit dieser E-Mail wurde kein Konto gefunden.',
    'Incorrect password. Please try again.':
      'Falsches Passwort. Bitte versuchen Sie es erneut.',
    'Invalid email or password. Please check your credentials and try again.':
      'Ungültige E-Mail-Adresse oder ungültiges Passwort. Bitte überprüfen Sie Ihre Anmeldedaten und versuchen Sie es erneut.',
    'Too many failed attempts. Please try again later or reset your password.':
      'Zu viele gescheiterte Versuche. Bitte versuchen Sie es später erneut oder setzen Sie Ihr Passwort zurück.',
    'Network error. Check your connection and try again.':
      'Netzwerkfehler. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
    'A verification email has been sent to your email address. Please verify your email before logging in.':
      'Eine Bestätigungs-E-Mail wurde an Ihre E-Mail-Adresse gesendet. Bitte überprüfen Sie Ihre E-Mail-Adresse, bevor Sie sich anmelden.',
    'Please make sure both passwords are the same.':
      'Bitte stellen Sie sicher, dass beide Passwörter gleich sind.',
    'Verification email resent!': 'Bestätigungs-E-Mail erneut gesendet!',
    'Please check your inbox.': 'Bitte überprüfen Sie Ihren Posteingang.',
    'You need to log in first': 'Sie müssen sich zuerst anmelden',
    'Please sign in to resend the verification email.':
      'Bitte melden Sie sich an, um die Bestätigungs-E-Mail erneut zu senden.',
    'Failed to resend email': 'E-Mail konnte nicht erneut gesendet werden',
    'Resend verification email': 'Bestätigungs-E-Mail erneut senden',
    'Show password': 'Passwort anzeigen',
    'Hide password': 'Passwort verbergen',
    'Awaiting verification artwork':
      'Warten auf die Verifizierung des Bildmaterials',
    'Account status: Pending review': 'Kontostatus: Überprüfung ausstehend',
    'Your account is pending approval': 'Ihr Konto muss noch genehmigt werden',
    "Upload your verification documents below and we'll notify you by email once your account is approved.":
      'Laden Sie unten Ihre Verifizierungsdokumente hoch und wir benachrichtigen Sie per E-Mail, sobald Ihr Konto genehmigt wurde.',
    'Check status': 'Status prüfen',
    'Upload verification documents': 'Verifizierungsdokumente hochladen',
    'Your uploaded documents': 'Ihre hochgeladenen Dokumente',
    'Back to sign in': 'Zurück zur Anmeldung',
    'Hide documents': 'Dokumente ausblenden',
    'Email verification required': 'E-Mail-Bestätigung erforderlich',
    'Waiting for email verification': 'Warten auf E-Mail-Bestätigung',
    'Check your email': 'Überprüfen Sie Ihre E-Mails',
    'We sent your verification link to':
      'Wir haben Ihren Bestätigungslink an gesendet',
    "Didn't receive it? Check your spam folder or try again.":
      'Sie haben es nicht erhalten? Überprüfen Sie Ihren Spam-Ordner oder versuchen Sie es erneut.',
    'Resend email': 'E-Mail erneut senden',
    "I've verified my email": 'Ich habe meine E-Mail-Adresse bestätigt',
    'Redirecting you now.': 'Ich leite Sie jetzt weiter.',
    'Email not verified yet': 'E-Mail noch nicht bestätigt',
    'Please click the link in your inbox and try again.':
      'Bitte klicken Sie auf den Link in Ihrem Posteingang und versuchen Sie es erneut.',
    'Unable to resend verification email right now.':
      'Das erneute Senden der Bestätigungs-E-Mail ist derzeit nicht möglich.',
    'Unable to check verification status right now.':
      'Der Verifizierungsstatus kann derzeit nicht überprüft werden.',
    "We've sent a new verification link to your email address.":
      'Wir haben einen neuen Bestätigungslink an Ihre E-Mail-Adresse gesendet.',
    'We automatically check your verification status every 30 seconds. You can also trigger an instant check after verifying your email.':
      'Wir überprüfen Ihren Verifizierungsstatus automatisch alle 30 Sekunden. Sie können auch eine sofortige Überprüfung auslösen, nachdem Sie Ihre E-Mail-Adresse bestätigt haben.',
    'We automatically check your verification status every 15 seconds. You can also trigger an instant check after verifying your email.':
      'Wir überprüfen Ihren Verifizierungsstatus automatisch alle 15 Sekunden. Sie können auch eine sofortige Überprüfung auslösen, nachdem Sie Ihre E-Mail-Adresse bestätigt haben.',
    'Inputs changed. Recalculate the price.':
      'Eingaben geändert. Berechnen Sie den Preis neu.',
    'My Invoices': 'Meine Rechnungen',
    'Upload New Invoice': 'Neue Rechnung hochladen',
    'Please enter the invoice number and upload the invoice document. It will be reviewed by an administrator.':
      'Bitte geben Sie die Rechnungsnummer ein und laden Sie das Rechnungsdokument hoch. Es wird von einem Administrator überprüft.',
    'Invoice History': 'Rechnungsverlauf',
    'Client ref · {{clientRef}}': 'Kundenreferenz · {{clientRef}}',
    'Order Documents': 'Bestellunterlagen',
    'Upload Proof of Pickup': 'Laden Sie den Abholnachweis hoch',
    'Status will be updated to Picked Up after successful upload.':
      'Der Status wird nach erfolgreichem Hochladen auf „Abgeholt“ aktualisiert.',
    'Upload Proof of Delivery': 'Laden Sie einen Liefernachweis hoch',
    'Status will be updated to Delivered after successful upload.':
      'Nach erfolgreichem Hochladen wird der Status auf „Geliefert“ aktualisiert.',
    'Enter first name': 'Geben Sie den Vornamen ein',
    'Enter last name': 'Geben Sie den Nachnamen ein',
    'Enter phone number': 'Geben Sie die Telefonnummer ein',
    'Driver updated.': 'Treiber aktualisiert.',
    'The driver has been successfully updated.':
      'Der Treiber wurde erfolgreich aktualisiert.',
    'Driver added.': 'Treiber hinzugefügt.',
    'The new driver has been successfully added.':
      'Der neue Treiber wurde erfolgreich hinzugefügt.',
    'Driver deleted.': 'Treiber gelöscht.',
    'The driver has been successfully deleted.':
      'Der Treiber wurde erfolgreich gelöscht.',
    'Trailer updated.': 'Trailer aktualisiert.',
    'The trailer has been successfully updated.':
      'Der Trailer wurde erfolgreich aktualisiert.',
    'Trailer added.': 'Trailer hinzugefügt.',
    'The new trailer has been successfully added.':
      'Der neue Trailer wurde erfolgreich hinzugefügt.',
    'Trailer deleted.': 'Trailer gelöscht.',
    'The trailer has been successfully deleted.':
      'Der Trailer wurde erfolgreich gelöscht.',
    'User account not found. Please complete registration.':
      'Benutzerkonto nicht gefunden. Bitte schließen Sie die Registrierung ab.',
    'No token provided': 'Kein Token bereitgestellt',
    'Token expired': 'Token abgelaufen',
    'Token revoked': 'Token widerrufen',
    'Invalid ID token': 'Ungültiges ID-Token',
    Unauthorized: 'Nicht autorisiert',
    'Unauthorized: User not authenticated.':
      'Nicht autorisiert: Benutzer nicht authentifiziert.',
    'Unauthorized: User role not found.':
      'Nicht autorisiert: Benutzerrolle nicht gefunden.',
    'Forbidden: Your role is not allowed to perform this action.':
      'Verboten: Ihre Rolle darf diese Aktion nicht ausführen.',
    'Forbidden: This action requires a partner role.':
      'Verboten: Für diese Aktion ist eine Partnerrolle erforderlich.',
    'Forbidden: This action requires a client role.':
      'Verboten: Für diese Aktion ist eine Client-Rolle erforderlich.',
    'Forbidden: This action requires an admin role.':
      'Verboten: Für diese Aktion ist eine Administratorrolle erforderlich.',
    'This user has not been approved': 'Dieser Benutzer wurde nicht genehmigt',
    'User email has not been verified':
      'Die E-Mail-Adresse des Benutzers wurde nicht überprüft',
    'User account has been disabled': 'Das Benutzerkonto wurde deaktiviert',
    'Booking not found': 'Buchung nicht gefunden',
    'Route not found': 'Route nicht gefunden',
    'Pickup location (country and postalCode) is required':
      'Abholort (Land und Postleitzahl) ist erforderlich',
    'Delivery location (country and postalCode) is required':
      'Lieferort (Land und Postleitzahl) ist erforderlich',
    'Unable to calculate route. Please check the locations and try again.':
      'Route kann nicht berechnet werden. Bitte überprüfen Sie die Standorte und versuchen Sie es erneut.',
    'Error calculating transport price':
      'Fehler bei der Berechnung des Transportpreises',
    'Booking canceled successfully': 'Buchung erfolgreich storniert',
    'Invalid request.': 'Ungültige Anfrage.',
    'Access denied.': 'Zugriff verweigert.',
    'Resource not found.': 'Ressource nicht gefunden.',
    'Request conflict.': 'Konflikt anfordern.',
    'Invalid data provided.': 'Ungültige Daten angegeben.',
    'Too many requests. Please try again later.':
      'Zu viele Anfragen. Bitte versuchen Sie es später noch einmal.',
    'Internal server error. Please try again later.':
      'Interner Serverfehler. Bitte versuchen Sie es später noch einmal.',
    'Service temporarily unavailable.':
      'Der Dienst ist vorübergehend nicht verfügbar.',
    'booking.load_preset': 'Voreinstellung laden',
    'booking.save_preset_tooltip':
      'Speichern Sie aktuelle Filter als Ihre Schnellzugriffsvoreinstellung',
    'booking.load_preset_tooltip':
      'Laden Sie Ihre gespeicherte Filtervoreinstellung',
    'booking.preset_saved': 'Voreinstellung gespeichert',
    'booking.preset_saved_desc': 'Ihre Filtervoreinstellung wurde gespeichert.',
    'booking.preset_loaded': 'Voreinstellung geladen',
    'booking.preset_load_error': 'Voreinstellung konnte nicht geladen werden',
    'booking.no_preset_saved': 'Noch keine Voreinstellung gespeichert',
    'booking.date_from': 'Datum von',
    'booking.date_to': 'Datum bis',
    'Active filters': 'Aktive Filter',
    'All booking states': 'Alle Buchungsstatus',
    'All partners': 'Alle Partner',
    'All payments': 'Alle Zahlungen',
    'All roles': 'Alle Rollen',
    'All statuses': 'Alle Status',
    'All Users': 'Alle Benutzer',
    'Are you sure you want to cancel booking {{id}}?':
      'Sind Sie sicher, dass Sie die Buchung {{id}} stornieren möchten?',
    'Attach the CMR Insurance before finishing truck setup.':
      'Fügen Sie die CMR-Rechnung bei, bevor Sie die LKW-Einrichtung abschließen.',
    Awaiting: 'Warten',
    'Awaiting payout': 'Warten auf Auszahlung',
    'Booking canceled': 'Buchung storniert',
    'Booking marked as paid': 'Buchung als bezahlt markiert',
    'Booking released and returned to marketplace':
      'Buchung freigegeben und an den Marktplatz zurückgegeben',
    'booking.allowed_range': 'Zulässiger Bereich',
    'booking.assign_transport': 'Transport zuweisen',
    'booking.back': 'Zurück',
    'booking.back_to_summary': 'Zurück zur Zusammenfassung',
    'booking.booking_created_but_pickup_document_not_uploaded_upload_from_order_details':
      'Die Buchung wurde erstellt, der Abholbeleg wurde jedoch nicht hochgeladen. Sie können es unter „Bestelldetails“ hochladen.',
    'booking.city_not_found': 'Stadt nicht gefunden',
    'booking.city_or_town': 'Stadt oder Gemeinde',
    'booking.clear_radius': 'Freier Radius',
    'booking.continue': 'Weiter',
    'booking.country_optional': 'Land (optional)',
    'booking.delivery_constraint_info':
      'Der Liefertermin muss am oder nach dem Abholtermin liegen.',
    'booking.delivery_date_cannot_be_earlier_than_pickup_date':
      'Der Liefertermin darf nicht vor dem Abholtermin liegen',
    'booking.driver': 'Fahrer',
    'booking.failed_to_open_letter_of_attorney':
      'Vollmachtsschreiben konnte nicht geöffnet werden',
    'booking.go_to_order': 'Gehen Sie zu „Bestellen“.',
    'booking.i_accept_terms': 'Ich akzeptiere die Bedingungen',
    'booking.invalid_license_plate_or_vin_length':
      'Ungültige Nummernschild- oder Fahrgestellnummer-Länge.',
    'booking.invalid_vin_format_i_o_q_not_allowed':
      'Ungültiges VIN-Format. Die Zeichen I, O und Q sind nicht erlaubt.',
    'booking.letter_of_attorney_file_is_empty':
      'Die Akte der Vollmacht ist leer',
    'booking.no_additional_details': 'Keine weiteren Details',
    'booking.no_vehicle_info': 'Keine Fahrzeuginformationen',
    'booking.open_letter_of_attorney': 'Offene Vollmacht',
    'booking.opening_letter_of_attorney': 'Eröffnungsvollmacht...',
    'booking.order_accepted_successfully': 'Bestellung erfolgreich angenommen',
    'booking.order_cars_exceed_selected_truck_capacity':
      'Dieser Auftrag umfasst {{orderCars}}-Wagen, die ausgewählte LKW-Kapazität beträgt jedoch {{capacity}}.',
    'booking.pickup_constraint_info':
      'Vor der Beauftragung des Transports muss das Abholdatum angegeben werden.',
    'booking.pickup_document_upload_failed':
      'Das Hochladen des Abholdokuments ist fehlgeschlagen',
    'booking.preparing_secure_document_preview':
      'Vorschau des sicheren Dokuments wird vorbereitet...',
    'booking.radius_km': 'Radius (km)',
    'booking.radius_search': 'Umkreissuche',
    'booking.route_and_details': 'Route und Details',
    'booking.schedule': 'Zeitplan',
    'booking.searching': 'Suche...',
    'booking.select_pickup_and_delivery': 'Wählen Sie Abholung und Lieferung',
    'booking.select_pickup_and_delivery_dates_before_confirming':
      'Wählen Sie vor der Bestätigung den Abhol- und Liefertermin aus',
    'booking.select_pickup_date': 'Abholdatum auswählen',
    'booking.select_truck_driver_and_trailer':
      'Wählen Sie LKW, Fahrer und Anhänger aus',
    'booking.supported_formats_jpg_png_pdf_doc_docx':
      'Unterstützte Formate: JPG, PNG, PDF, DOC, DOCX',
    'booking.terms_and_conditions': 'Allgemeine Geschäftsbedingungen',
    'booking.terms_text':
      'Ich bestätige die Transport- und Haftungsbedingungen.',
    'booking.track_shipment': 'Sendung verfolgen',
    'booking.trailer': 'Anhänger',
    'booking.transport_details': 'Transportdetails',
    'booking.truck': 'LKW',
    'booking.truck_driver_planning_saved_letter_of_attorney_available':
      'LKW-, Fahrer- und Planungsdaten wurden gespeichert. Die Vollmacht liegt nun vor.',
    'booking.unexpected_error': 'Unerwarteter Fehler',
    'booking.vehicles_plural': 'Fahrzeuge',
    'booking.view_details': 'Details anzeigen',
    'booking.vip_price_must_be_between_min_max_50_to_150_percent_of_estimated_price':
      'Der VIP-Preis muss zwischen {{min}} EUR und {{max}} EUR liegen (50 % bis 150 % des geschätzten Preises).',
    'booking.vip_price_must_be_positive_number':
      'Der VIP-Preis muss eine positive Zahl sein.',
    'booking.within_radius_km_of_place':
      'Innerhalb von {{radius}} km von {{place}}',
    Capacity: 'Kapazität',
    'Car Capacity': 'Autokapazität',
    'Car capacity is required.': 'Pkw-Kapazität ist erforderlich.',
    cars: 'Autos',
    Changed: 'Geändert',
    'CMR Document': 'CMR-Dokument',
    'CMR expiry': 'CMR-Ablauf',
    'CMR Expiry': 'CMR-Ablauf',
    'CMR expiry date is required': 'Das CMR-Ablaufdatum ist erforderlich',
    'CMR Insurance': 'CMR-Versicherung',
    'CMR insurance expiry date': 'Ablaufdatum der CMR-Versicherung',
    'CMR Insurance Expiry Date': 'Ablaufdatum der CMR-Versicherung',
    'CMR insurance has expired. Upload a new CMR Insurance for review.':
      'Laden Sie eine neue CMR-Rechnung zur Überprüfung hoch.',
    'CMR insurance is expiring within 14 days.':
      'Die CMR-Versicherung läuft innerhalb von 14 Tagen ab.',
    'CMR Insurance required': 'CMR-Rechnung erforderlich',
    Company: 'Unternehmen',
    'Copy order ID': 'Bestell-ID kopieren',
    Created: 'Erstellt',
    'Current expiry': 'Aktueller Ablauf',
    'Date range': 'Datumsbereich',
    days: 'Tage',
    Delay: 'Verzögerung',
    'Delivered + partner invoice uploaded + unpaid':
      'Geliefert + Partnerrechnung hochgeladen + unbezahlt',
    Document: 'Dokument',
    'Documents uploaded': 'Dokumente hochgeladen',
    Done: 'Fertig',
    'Download Client Invoice #{{id}}':
      'Laden Sie die Kundenrechnung Nr. {{id}} herunter',
    'Download Invoice': 'Rechnung herunterladen',
    'Enter a valid capacity between 1 and 20 cars.':
      'Geben Sie eine gültige Kapazität zwischen 1 und 20 Autos ein.',
    'Enter license plate': 'Kennzeichen eingeben',
    'Enter plate and upload CMR to add truck':
      'Geben Sie das Kennzeichen ein und laden Sie CMR hoch, um den LKW hinzuzufügen',
    'Error fetching users': 'Fehler beim Abrufen der Benutzer',
    'Expire Soon (14 days)': 'Läuft bald ab (14 Tage)',
    'Explain why this CMR was rejected':
      'Erklären Sie, warum dieser CMR abgelehnt wurde',
    'Failed to copy order ID': 'Das Kopieren der Bestell-ID ist fehlgeschlagen',
    'Failed to download invoice':
      'Rechnung konnte nicht heruntergeladen werden',
    'Failed to download proforma invoice':
      'Proforma-Rechnung konnte nicht heruntergeladen werden',
    'Failed to generate invoice': 'Rechnung konnte nicht erstellt werden',
    'Failed to load invoice summary':
      'Rechnungszusammenfassung konnte nicht geladen werden',
    'Failed to load letter of attorney':
      'Vollmacht konnte nicht geladen werden',
    'Failed to open letter of attorney':
      'Vollmachtsschreiben konnte nicht geöffnet werden',
    'Failed to release booking': 'Buchung konnte nicht freigegeben werden',
    'Fleet data refreshed': 'Flottendaten aktualisiert',
    'Generate Client Invoice': 'Kundenrechnung erstellen',
    'Generate Invoice': 'Rechnung erstellen',
    'Generated at': 'Erstellt am',
    'How many cars can this truck carry?':
      'Wie viele Autos kann dieser LKW transportieren?',
    'In progress': 'In Bearbeitung',
    Invoice: 'Rechnung',
    'Invoice generated': 'Rechnung erstellt',
    'Invoice generated successfully': 'Rechnung erfolgreich erstellt',
    'Invoice uploaded': 'Rechnung hochgeladen',
    'Invoices uploaded by partners for platform payout processing. Client invoices are generated in each order view.':
      'Kundenrechnungen werden in jeder Bestellansicht generiert.',
    'Keep booking': 'Buchen Sie weiter',
    'Keep your active drivers and contact details up to date.':
      'Halten Sie Ihre aktiven Fahrer und Kontaktdaten auf dem neuesten Stand.',
    'Last Rejection': 'Letzte Ablehnung',
    'Last rejection reason': 'Letzter Ablehnungsgrund',
    'Letter of Attorney': 'Vollmachtsschreiben',
    'Letter of attorney file is empty': 'Die Akte der Vollmacht ist leer',
    'License plate cannot be changed after creation. Re-upload CMR Insurance instead.':
      'Laden Sie stattdessen die CMR-Rechnung erneut hoch.',
    'License plate is required.': 'Kennzeichen ist erforderlich.',
    'Manage large order volumes with search, payment actions, and invoice workflows.':
      'Verwalten Sie große Bestellmengen mit Such-, Zahlungsaktionen und Rechnungsworkflows.',
    'Manage license plates and keep CMR Insurances approved and valid.':
      'Verwalten Sie Nummernschilder und sorgen Sie dafür, dass CMR-Rechnungen genehmigt und gültig sind.',
    'Manage status updates, documents, and payment steps from one place.':
      'Verwalten Sie Statusaktualisierungen, Dokumente und Zahlungsschritte von einem Ort aus.',
    'Manage trailer plate records and keep availability current.':
      'Verwalten Sie Anhängerkennzeichenaufzeichnungen und halten Sie die Verfügbarkeit auf dem neuesten Stand.',
    'Mark booking {{id}} as paid?': 'Buchung {{id}} als bezahlt markieren?',
    Missing: 'Fehlt',
    'Needs attention': 'Braucht Aufmerksamkeit',
    'New (14 days)': 'Neu (14 Tage)',
    'No bookings found for the current filters.':
      'Für die aktuellen Filter wurden keine Buchungen gefunden.',
    'No confirmed CMR document uploaded yet.':
      'Es wurde noch kein bestätigtes CMR-Dokument hochgeladen.',
    'No driver assigned': 'Kein Fahrer zugewiesen',
    'No letter of attorney has been generated yet.':
      'Es wurde noch keine Vollmacht erstellt.',
    'No matching delivered orders': 'Keine passenden gelieferten Bestellungen',
    'No new notifications': 'Keine neuen Benachrichtigungen',
    'No partners found.': 'Keine Partner gefunden.',
    'No trucks found for this filter.':
      'Für diesen Filter wurden keine LKWs gefunden.',
    'No users found for current filters.':
      'Für die aktuellen Filter wurden keine Benutzer gefunden.',
    'Not uploaded': 'Nicht hochgeladen',
    Notifications: 'Benachrichtigungen',
    of: 'von',
    'Only admins can set or update this expiry date after reviewing your CMR insurance.':
      'Nur Administratoren können dieses Ablaufdatum festlegen oder aktualisieren, nachdem sie Ihre CMR-Versicherung überprüft haben.',
    'Open letter of attorney': 'Offene Vollmacht',
    Order: 'Bestellen',
    'Order actions': 'Bestellaktionen',
    'Order ID copied': 'Bestell-ID kopiert',
    Owner: 'Besitzer',
    Page: 'Seite',
    'Paid date': 'Bezahltes Datum',
    'Partner delivery date': 'Liefertermin des Partners',
    'Partner documents': 'Partnerdokumente',
    'Partner Invoice': 'Partnerrechnung',
    'Partner invoice uploaded': 'Partnerrechnung hochgeladen',
    'Partner Payout Invoices': 'Auszahlungsrechnungen für Partner',
    'Partner pickup date': 'Abholtermin des Partners',
    'Partner score': 'Partnerpunktzahl',
    Payment: 'Zahlung',
    'Payout date': 'Auszahlungsdatum',
    'penalties applied': 'Strafen verhängt',
    'Pending admin review': 'Ausstehende Überprüfung durch den Administrator',
    'Pending review': 'Ausstehende Überprüfung',
    'Pending trucks': 'Ausstehende LKWs',
    'Please provide a clear reason for rejection.':
      'Bitte geben Sie einen klaren Grund für die Ablehnung an.',
    'Please select an order before uploading an invoice.':
      'Bitte wählen Sie eine Bestellung aus, bevor Sie eine Rechnung hochladen.',
    'Please try again.': 'Bitte versuchen Sie es erneut.',
    'Proforma Invoice': 'Proforma-Rechnung',
    'Provide a rejection reason for this CMR review.':
      'Geben Sie einen Ablehnungsgrund für diese CMR-Bewertung an.',
    'Quarter Score': 'Viertelpunktzahl',
    'Re-upload CMR': 'Laden Sie CMR erneut hoch',
    Refresh: 'Aktualisieren',
    'Rejection reason': 'Ablehnungsgrund',
    'Rejection reason is required': 'Ein Ablehnungsgrund ist erforderlich',
    'Release booking {{id}} back to the marketplace so another partner can accept it?':
      'Buchung {{id}} wieder auf den Marktplatz freigeben, damit ein anderer Partner sie annehmen kann?',
    Reset: 'Zurücksetzen',
    'Review Bookings': 'Überprüfen Sie Buchungen',
    Revision: 'Überarbeitung',
    Rows: 'Reihen',
    'Search by invoice number, file name, or booking ID':
      'Suchen Sie nach Rechnungsnummer, Dateiname oder Buchungs-ID',
    'Search by name, email, company': 'Suche nach Name, E-Mail, Firma',
    'Search by name, email, company, uid':
      'Suche nach Name, E-Mail, Firma, UID',
    'Search client': 'Client suchen',
    'Search delivered order': 'Zugestellte Bestellung suchen',
    'Search license plate or owner': 'Kennzeichen oder Besitzer suchen',
    'Search order ID': 'Bestell-ID suchen',
    'Search partner': 'Suchpartner',
    'Select a new CMR Insurance to re-upload for this truck.':
      'Wählen Sie eine neue CMR-Rechnung aus, die Sie für diesen LKW erneut hochladen möchten.',
    'Select paid date': 'Bezahldatum auswählen',
    'Set CMR insurance expiry date to approve this truck.':
      'Legen Sie das Ablaufdatum der CMR-Versicherung fest, um diesen LKW zu genehmigen.',
    'Set maximum number of cars this truck can carry (1-20).':
      'Legen Sie die maximale Anzahl an Autos fest, die dieser LKW transportieren kann (1-20).',
    'Set the CMR insurance expiry date before approval.':
      'Legen Sie vor der Genehmigung das Ablaufdatum der CMR-Versicherung fest.',
    Showing: 'Zeigt',
    'Showing page {{page}} of {{pages}} • {{total}} invoices':
      'Seite {{page}} von {{pages}} wird angezeigt • {{total}}-Rechnungen',
    'Status will be updated to Picked Up after successful upload. You can add multiple car photos before uploading.':
      'Sie können vor dem Hochladen mehrere Autofotos hinzufügen.',
    Terms: 'Bedingungen',
    Total: 'Insgesamt',
    'Track paid and unpaid invoices, expected payout dates, and upload new invoices quickly.':
      'Verfolgen Sie bezahlte und unbezahlte Rechnungen sowie erwartete Auszahlungstermine und laden Sie schnell neue Rechnungen hoch.',
    'Truck approved successfully': 'Lkw-Zulassung erfolgreich',
    'Truck documents': 'LKW-Dokumente',
    'Truck license plate': 'LKW-Kennzeichen',
    'Truck rejected successfully': 'LKW erfolgreich abgelehnt',
    'truck(s) are pending admin CMR expiry date.':
      'Für den/die LKW(s) steht das Ablaufdatum des Administrator-CMR an.',
    'truck(s) have expired CMR insurance and are disabled.':
      'LKW(s) haben die CMR-Versicherung abgelaufen und sind funktionsuntüchtig.',
    'truck(s) will expire within 14 days.':
      'LKW(s) verfallen innerhalb von 14 Tagen.',
    'Unable to prepare the record for upload.':
      'Der Datensatz konnte nicht zum Hochladen vorbereitet werden.',
    Unpaid: 'Unbezahlt',
    'Upload a CMR Insurance before closing this truck setup.':
      'Laden Sie eine CMR-Rechnung hoch, bevor Sie dieses LKW-Setup schließen.',
    'Upload a valid CMR insurance. Each upload sends the truck back to pending review.':
      'Bei jedem Upload wird der LKW in den Zustand der ausstehenden Überprüfung zurückgeschickt.',
    'Upload documents': 'Dokumente hochladen',
    'Upload Invoice': 'Rechnung hochladen',
    'Upload order documents': 'Bestellunterlagen hochladen',
    'Upload unavailable': 'Upload nicht verfügbar',
    Uploaded: 'Hochgeladen',
    'Uploaded • Paid': 'Hochgeladen • Bezahlt',
    'Uploaded • Partially paid': 'Hochgeladen • Teilweise bezahlt',
    'Uploaded by partner for platform payout processing.':
      'Vom Partner zur Plattform-Auszahlungsabwicklung hochgeladen.',
    User: 'Benutzer',
    'Verification code': 'Bestätigungscode',
    'View details': 'Details anzeigen',
    'View Partners': 'Partner anzeigen',
    'Working hours not provided': 'Arbeitszeiten nicht angegeben',
    '{{value}} orders': '{{value}}-Bestellungen',
    Invoiced: 'In Rechnung gestellt',
    'Loading admin data...': 'Admin-Daten werden geladen...',
    'Pending partners': 'Ausstehende Partner',
    'Unpaid bookings': 'Unbezahlte Buchungen',
    'Total users': 'Gesamtzahl der Benutzer',
    'Orders per period': 'Bestellungen pro Periode',
    'Orders by status': 'Bestellungen nach Status',
    'Quick actions': 'Schnelle Aktionen',
    'Verify new partners': 'Überprüfen Sie neue Partner',
    'Review partner applications and approve or reject requests.':
      'Überprüfen Sie Partneranträge und genehmigen oder lehnen Sie Anfragen ab.',
    'Manage all trucks': 'Verwalten Sie alle LKWs',
    'Review, approve, reject, disable, and filter all trucks.':
      'Überprüfen, genehmigen, ablehnen, deaktivieren und filtern Sie alle LKWs.',
    'Review bookings': 'Überprüfen Sie Buchungen',
    'Review all transport orders, payment states, and generated invoices.':
      'Überprüfen Sie alle Transportaufträge, Zahlungsstatus und generierten Rechnungen.',
    'Manage all users': 'Verwalten Sie alle Benutzer',
    'Manage user status, roles, and validation records.':
      'Verwalten Sie Benutzerstatus, Rollen und Validierungsdatensätze.',
    'User breakdown': 'Benutzeraufschlüsselung',
    Clients: 'Kunden',
    Partners: 'Partner',
    Admins: 'Administratoren',
    'Top 5 pending partners': 'Top 5 der ausstehenden Partner',
    'No pending partners right now.':
      'Im Moment gibt es keine ausstehenden Partner.',
    pending: 'ausstehend',
    'Top 5 pending trucks': 'Top 5 der ausstehenden Trucks',
    'No pending trucks right now.': 'Im Moment sind keine LKWs ausstehend.',
    'Unknown owner': 'Unbekannter Besitzer',
    'KPI cards and top lists link directly to filtered admin screens.':
      'KPI-Karten und Top-Listen verweisen direkt auf gefilterte Admin-Bildschirme.',
    'booking.available_orders_title': 'Verfügbare Bestellungen',
    'booking.available_orders_description':
      'Überprüfen Sie eingehende Transportmöglichkeiten und wenden Sie Filter entsprechend Ihrer Kapazität an.',
    'booking.vehicle_pickup_location': 'Ort der Fahrzeugabholung',
    'booking.pickup_opening_hours': 'Öffnungszeiten der Abholung',
    'booking.vehicle_delivery_location': 'Ort der Fahrzeugauslieferung',
    'booking.delivery_opening_hours': 'Lieferöffnungszeiten',
    'booking.pickup_contact': 'Abholkontakt',
    'booking.delivery_contact': 'Lieferkontakt',
    'booking.vehicles_scheduled': 'Fahrzeuge geplant',
    'booking.watchlist_title': 'Beobachtungsliste',
    'booking.watchlist_description':
      'Verfolgen Sie gespeicherte Opportunities und reagieren Sie schnell, wenn sich die Verfügbarkeit ändert.',
    'Loading dashboard...': 'Dashboard wird geladen...',
    'Total bookings': 'Gesamtbuchungen',
    'Open bookings': 'Offene Buchungen',
    'Order status timeline': 'Zeitleiste des Bestellstatus',
    'Last 6 months of bookings grouped by current status.':
      'Buchungen der letzten 6 Monate, gruppiert nach aktuellem Status.',
    'Create new order': 'Neue Bestellung erstellen',
    'Create a new transport booking request.':
      'Erstellen Sie eine neue Transportbuchungsanfrage.',
    'View my orders': 'Sehen Sie sich meine Bestellungen an',
    'Review status and details of your bookings.':
      'Überprüfen Sie den Status und die Details Ihrer Buchungen.',
    'Open profile': 'Profil öffnen',
    'Update company and contact details.':
      'Aktualisieren Sie Firmen- und Kontaktdaten.',
    'Recent bookings': 'Aktuelle Buchungen',
    'No bookings yet.': 'Noch keine Buchungen.',
    'Unknown destination': 'Unbekanntes Ziel',
    'Quarter score': 'Viertelpunktzahl',
    '{{value}} completed': '{{value}} abgeschlossen',
    'Truck CMR warning': 'CMR-Warnung für LKW',
    'One truck has CMR expiry risk. Review it in Fleet.':
      'Bei einem LKW besteht das Risiko eines CMR-Ablaufs. Überprüfen Sie es in Fleet.',
    '{{count}} trucks have CMR expiry risk. Review them in Fleet.':
      'Bei {{count}}-Lastkraftwagen besteht das Risiko eines CMR-Ablaufs. Überprüfen Sie sie in Fleet.',
    'Active queue': 'Aktive Warteschlange',
    'Delivered bookings': 'Gelieferte Buchungen',
    'Cars delivered': 'Autos geliefert',
    'Canceled bookings': 'Stornierte Buchungen',
    'Avg assign-to-pickup': 'Durchschnittliche Zuweisung zur Abholung',
    'Quarter Partner Score': 'Viertel-Partner-Score',
    'Payment delay: +{{days}} days': 'Zahlungsverzögerung: +{{days}} Tage',
    'Penalty events': 'Strafereignisse',
    Current: 'Aktuell',
    'Completed orders per period': 'Abgeschlossene Bestellungen pro Periode',
    'Completed orders': 'Abgeschlossene Bestellungen',
    'Truck CMR status alerts': 'LKW-CMR-Statuswarnungen',
    '{{count}} truck(s) have expired CMR insurance.':
      'Für {{count}}-LKWs ist die CMR-Versicherung abgelaufen.',
    '{{count}} truck(s) will expire within 14 days.':
      '{{count}}-LKWs laufen innerhalb von 14 Tagen ab.',
    '{{count}} truck(s) are missing CMR expiry date.':
      'Bei {{count}}-LKWs fehlt das CMR-Ablaufdatum.',
    'Upload a new CMR Insurance in Fleet. The truck will stay pending until admin review.':
      'Laden Sie eine neue CMR-Rechnung in Fleet hoch. Der LKW bleibt bis zur Überprüfung durch den Administrator ausstehend.',
    'Open fleet to resolve CMR alerts':
      'Öffnen Sie die Flotte, um CMR-Warnungen zu lösen',
    'Operational actions': 'Operative Maßnahmen',
    'Open marketplace orders': 'Offene Marktplatzbestellungen',
    'Review available orders and plan assignments.':
      'Überprüfen Sie verfügbare Bestellungen und planen Sie Zuweisungen.',
    'My accepted orders': 'Meine angenommenen Befehle',
    'Manage delivery progress and documents.':
      'Verwalten Sie den Lieferfortschritt und die Dokumente.',
    'Update trucks, trailers, and availability.':
      'Aktualisieren Sie LKWs, Anhänger und Verfügbarkeit.',
    'Partner invoices': 'Partnerrechnungen',
    'Upload and track invoice payments.':
      'Laden Sie Rechnungszahlungen hoch und verfolgen Sie sie.',
    'No active orders in queue.':
      'Keine aktiven Bestellungen in der Warteschlange.',
    'profile.incompleteTitle': 'Profil unvollständig',
    'profile.incompleteDescription':
      'Bitte vervollständigen Sie Ihre Profilinformationen (Firma, Telefon, Adresse, Stadt, Postleitzahl), um auf alle Funktionen zugreifen zu können.',
    'profile.goToProfile': 'Gehen Sie zu Profil',
    'auth.email_placeholder': 'name@company.com',
    'auth.authentication_mode_switch':
      'Schalter für den Authentifizierungsmodus',
    'auth.invalid_email': 'Ungültige E-Mail',
    'auth.please_enter_a_valid_email_address':
      'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    'auth.email_not_found': 'E-Mail nicht gefunden',
    'auth.no_account_found_with_that_email_address':
      'Mit dieser E-Mail-Adresse wurde kein Konto gefunden.',
    'auth.email_sent': 'E-Mail gesendet!',
    'auth.something_went_wrong_try_again':
      'Etwas ist schief gelaufen. Versuchen Sie es erneut.',
    'auth.we_sent_a_password_reset_link_open_your_inbox_and_follow_the_instructions':
      'Wir haben einen Link zum Zurücksetzen des Passworts gesendet. Öffnen Sie Ihren Posteingang und folgen Sie den Anweisungen.',
    'auth.forgot_your_password': 'Passwort vergessen?',
    'auth.enter_your_account_email_and_we_will_send_you_a_password_reset_link':
      'Geben Sie die E-Mail-Adresse Ihres Kontos ein und wir senden Ihnen einen Link zum Zurücksetzen des Passworts.',
    'auth.email_address': 'E-Mail-Adresse',
    'auth.send_reset_link': 'Link zum Zurücksetzen senden',
    'auth.cancel': 'Abbrechen',
    'auth.tip_if_you_do_not_receive_the_email_check_spam_and_promotions_folders':
      'Tipp: Wenn Sie die E-Mail nicht erhalten, überprüfen Sie die Spam- und Werbeordner.',
    'booking.e_g_berlin': 'z.B. Berlin',
    'booking.e_g_germany': 'z.B. Deutschland',
    'booking.watchlist': 'Beobachtungsliste',
    'booking.view_map': 'Karte ansehen',
    'booking.invalid_input': 'Ungültige Eingabe',
    'booking.please_enter_only_numbers_for_the_zip_code':
      'Bitte geben Sie für die Postleitzahl nur Zahlen ein.',
    'booking.pickup_zip_code': 'Postleitzahl der Abholung',
    'booking.delivery_zip_code': 'Postleitzahl der Lieferung',
    'booking.select_vehicle_make': 'Fahrzeugmarke auswählen',
    'booking.unnamed_item': 'Unbenannter Artikel',
    'booking.cars': 'Autos',
    'booking.more_info': 'Weitere Informationen',
    'booking.loading': 'Laden...',
    'booking.no_items_found': 'Keine Artikel gefunden',
    'booking.selected_cars': 'Ausgewählte Autos',
    'booking.unknown_type': 'Unbekannter Typ',
    'booking.delete_car': 'Auto löschen',
    'Toggle details': 'Details umschalten',
    'auth.a_verification_email_has_been_sent_to_your_email_address_please_verify_your_emai':
      'Eine Bestätigungs-E-Mail wurde an Ihre E-Mail-Adresse gesendet. Bitte überprüfen Sie Ihre E-Mail-Adresse, bevor Sie sich anmelden.',
    'auth.an_unexpected_error_occurred_please_try_again':
      'Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    'auth.failed_to_resend_email': 'E-Mail konnte nicht erneut gesendet werden',
    'auth.show_password': 'Passwort anzeigen',
    'auth.hide_password': 'Passwort verbergen',
    'auth.incorrect_password_please_try_again':
      'Falsches Passwort. Bitte versuchen Sie es erneut.',
    'auth.invalid_email_or_password_please_check_your_credentials_and_try_again':
      'Ungültige E-Mail-Adresse oder ungültiges Passwort. Bitte überprüfen Sie Ihre Anmeldedaten und versuchen Sie es erneut.',
    'auth.network_error_check_your_connection_and_try_again':
      'Netzwerkfehler. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
    'auth.no_account_found_with_this_email':
      'Mit dieser E-Mail wurde kein Konto gefunden.',
    'auth.partner': 'Partner',
    'auth.please_check_your_inbox': 'Bitte überprüfen Sie Ihren Posteingang.',
    'auth.please_make_sure_both_passwords_are_the_same':
      'Bitte stellen Sie sicher, dass beide Passwörter gleich sind.',
    'auth.please_sign_in_to_resend_the_verification_email':
      'Bitte melden Sie sich an, um die Bestätigungs-E-Mail erneut zu senden.',
    'auth.resend_verification_email': 'Bestätigungs-E-Mail erneut senden',
    'auth.awaiting_verification_artwork':
      'Warten auf die Verifizierung des Bildmaterials',
    'auth.email_verification_required': 'E-Mail-Bestätigung erforderlich',
    'auth.waiting_for_email_verification': 'Warten auf E-Mail-Bestätigung',
    'auth.check_your_email': 'Überprüfen Sie Ihre E-Mails',
    'auth.we_sent_your_verification_link_to':
      'Wir haben Ihren Bestätigungslink an gesendet',
    'auth.didnt_receive_it_check_spam_or_try_again':
      'Sie haben es nicht erhalten? Überprüfen Sie Ihren Spam-Ordner oder versuchen Sie es erneut.',
    'auth.resend_email': 'E-Mail erneut senden',
    'auth.i_verified_my_email': 'Ich habe meine E-Mail-Adresse bestätigt',
    'auth.redirecting_you_now': 'Ich leite Sie jetzt weiter.',
    'auth.email_not_verified_yet': 'E-Mail noch nicht bestätigt',
    'auth.please_click_the_link_in_your_inbox_and_try_again':
      'Bitte klicken Sie auf den Link in Ihrem Posteingang und versuchen Sie es erneut.',
    'auth.unable_to_resend_verification_email_right_now':
      'Das erneute Senden der Bestätigungs-E-Mail ist derzeit nicht möglich.',
    'auth.unable_to_check_verification_status_right_now':
      'Der Verifizierungsstatus kann derzeit nicht überprüft werden.',
    'auth.we_sent_a_new_verification_link':
      'Wir haben einen neuen Bestätigungslink an Ihre E-Mail-Adresse gesendet.',
    'auth.we_automatically_check_every_30_seconds':
      'Wir überprüfen Ihren Verifizierungsstatus automatisch alle 30 Sekunden. Sie können auch eine sofortige Überprüfung auslösen, nachdem Sie Ihre E-Mail-Adresse bestätigt haben.',
    'auth.we_automatically_check_every_15_seconds':
      'Wir überprüfen Ihren Verifizierungsstatus automatisch alle 15 Sekunden. Sie können auch eine sofortige Überprüfung auslösen, nachdem Sie Ihre E-Mail-Adresse bestätigt haben.',
    'auth.the_email_address_is_not_valid': 'Die E-Mail-Adresse ist ungültig.',
    'auth.this_account_has_been_disabled': 'Dieses Konto wurde deaktiviert.',
    'auth.too_many_failed_attempts_please_try_again_later_or_reset_your_password':
      'Zu viele gescheiterte Versuche. Bitte versuchen Sie es später erneut oder setzen Sie Ihr Passwort zurück.',
    'auth.verification_email_resent': 'Bestätigungs-E-Mail erneut gesendet!',
    'auth.you_need_to_log_in_first': 'Sie müssen sich zuerst anmelden',
    'booking.details': 'Details',
    'booking.endpoint': 'Ende',
    'booking.error_fetching_data': 'Fehler beim Abrufen der Daten',
    'booking.inputs_changed_recalculate_the_price':
      'Eingaben geändert. Berechnen Sie den Preis neu.',
    'booking.kg': 'kg',
    'booking.km': 'km',
    'booking.mi': 'mi',
    'booking.no_opening_hours_provided': 'Keine Öffnungszeiten angegeben',
    'booking.no_vehicles_listed': 'Keine Fahrzeuge aufgeführt',
    'booking.not_available': 'Nicht verfügbar',
    'booking.not_set': 'Nicht festgelegt',
    'booking.please_select_a_planned_date':
      'Bitte wählen Sie einen geplanten Termin aus',
    'booking.required': 'Erforderlich',
    'booking.route': 'Route',
    'booking.startpoint': 'Starten',
    'booking.to': 'zu',
    'booking.order': 'Bestellen',
    'booking.duration': 'Dauer',
    'booking.vehicles_overview': 'Fahrzeugübersicht',
    'booking.body': 'Körper',
    'booking.dims': 'Verdunkelt sich',
    'booking.select_vehicle_model': 'Fahrzeugmodell auswählen',
    'booking.selected_type_value': 'Ausgewählt: {{value}}',
    'booking.select_a_vehicle_type': 'Wählen Sie einen Fahrzeugtyp:',
    'booking.select_vehicle_weight': 'Fahrzeuggewicht auswählen',
    'booking.selected_weight_kg': 'Ausgewählt: {{value}} kg',
    'booking.adjust_weight': 'Gewicht anpassen',
    'Dates updated successfully': 'Termine erfolgreich aktualisiert',
    'Error updating dates': 'Fehler beim Aktualisieren der Daten',
    'Set Planned Dates': 'Legen Sie geplante Termine fest',
    'Set your planned pickup and arrival dates below.':
      'Legen Sie unten Ihre geplanten Abhol- und Ankunftstermine fest.',
    'Changing dates after initial setup will deduct 20% from your performance score for this order.':
      'Wenn Sie die Daten nach der Ersteinrichtung ändern, werden 20 % von Ihrer Leistungsbewertung für diese Bestellung abgezogen.',
    'Planned Pickup Date': 'Geplanter Abholtermin',
    'Planned Arrival Date': 'Geplantes Ankunftsdatum',
    Listing: 'Auflistung',
    'Try broadening the current search or status filter.':
      'Versuchen Sie, den aktuellen Such- oder Statusfilter zu erweitern.',
    'Try broadening the search, role, or status filters.':
      'Versuchen Sie, die Such-, Rollen- oder Statusfilter zu erweitern.',
    'Monitor fleet compliance, validation status, and expiring insurance in one place.':
      'Überwachen Sie die Einhaltung der Flottenvorschriften, den Validierungsstatus und die auslaufende Versicherung an einem Ort.',
    'Active Listings': 'Aktive Einträge',
    'Open transport requests': 'Offene Transportanfragen',
    'Quotes Today': 'Zitate heute',
    'Submitted in last 24h': 'Eingereicht in den letzten 24 Stunden',
    'Platform Revenue (MTD)': 'Plattformumsatz (MTD)',
    'Month to date': 'Monat bis heute',
    'Pending Partners': 'Ausstehende Partner',
    'Awaiting approval': 'Warten auf Genehmigung',
    'Unpaid Invoices': 'Unbezahlte Rechnungen',
    'Requires action': 'Erfordert Maßnahmen',
    'Completed Transports': 'Abgeschlossene Transporte',
    'All time delivered': 'Immer geliefert',
    'Admin Dashboard': 'Admin-Dashboard',
    'Platform overview and key performance indicators.':
      'Plattformübersicht und wichtige Leistungsindikatoren.',
    'Loading dashboard metrics...': 'Dashboard-Metriken werden geladen...',
    Invoices: 'Rechnungen',
    'Review payout invoices uploaded by partners and keep payout processing organized.':
      'Überprüfen Sie die von Partnern hochgeladenen Auszahlungsrechnungen und sorgen Sie für eine organisierte Auszahlungsabwicklung.',
    Flexible: 'Flexibel',
    'Flexible dates': 'Flexible Termine',
    'Could not load this listing.':
      'Dieser Eintrag konnte nicht geladen werden.',
    'Listing canceled': 'Eintrag storniert',
    'Failed to cancel listing': 'Eintrag konnte nicht storniert werden',
    Reference: 'Referenz',
    Category: 'Kategorie',
    'Client type': 'Kundentyp',
    'Company country': 'Firmenland',
    Expires: 'Läuft ab',
    'Back to listings': 'Zurück zu den Auflistungen',
    'Listing not found.': 'Eintrag nicht gefunden.',
    'Cancel Listing': 'Eintrag stornieren',
    'Listing details': 'Auflistungsdetails',
    'Reference {{id}}': 'Referenz {{id}}',
    'Read-only listing overview for admins.':
      'Schreibgeschützte Auflistungsübersicht für Administratoren.',
    'Pick-up': 'Abholung',
    'No exact coordinates are stored for this listing yet.':
      'Für diesen Eintrag sind noch keine genauen Koordinaten hinterlegt.',
    'Structured overview of quantities and handling details.':
      'Strukturierter Überblick über Mengen und Handhabungsdetails.',
    'Shipment images': 'Sendungsbilder',
    'No shipment images were uploaded for this listing.':
      'Für dieses Angebot wurden keine Sendungsbilder hochgeladen.',
    'Proof of pickup': 'Abholnachweis',
    'Final documents': 'Abschlussdokumente',
    Description: 'Beschreibung',
    'Quotes ({{count}})': 'Angebote ({{count}})',
    'Loading quotes...': 'Angebote werden geladen...',
    'No quotes for this listing.':
      'Für diesen Eintrag sind keine Angebote vorhanden.',
    'Score: {{score}}/100': 'Punktestand: {{score}}/100',
    'Delivery: {{date}}': 'Lieferung: {{date}}',
    'Cancel Listing?': 'Eintrag stornieren?',
    'This will permanently cancel the listing and notify the client. Continue?':
      'Dadurch wird die Auflistung dauerhaft gelöscht und der Kunde benachrichtigt. Weitermachen?',
    Keep: 'Behalten',
    'Review partner applications, check their documents, and keep approval decisions consistent.':
      'Überprüfen Sie Partneranträge, überprüfen Sie deren Dokumente und sorgen Sie für konsistente Genehmigungsentscheidungen.',
    'No client payments recorded yet':
      'Es wurden noch keine Kundenzahlungen erfasst',
    'Client payment rows will appear here when the payments backend is connected.':
      'Kundenzahlungszeilen werden hier angezeigt, wenn das Zahlungs-Backend verbunden ist.',
    Method: 'Methode',
    'No partner payouts recorded yet':
      'Es wurden noch keine Partnerauszahlungen erfasst',
    'Payout rows will appear here once partner payout processing is enabled.':
      'Auszahlungszeilen werden hier angezeigt, sobald die Partnerauszahlungsverarbeitung aktiviert ist.',
    'Payout Amount': 'Auszahlungsbetrag',
    'No platform fees recorded yet':
      'Es wurden noch keine Plattformgebühren erfasst',
    'Fee rows will appear here once payment settlement data is available.':
      'Sobald die Zahlungsabrechnungsdaten verfügbar sind, werden hier Gebührenzeilen angezeigt.',
    Gross: 'Brutto',
    'Fee (20%)': 'Gebühr (20 %)',
    Payments: 'Zahlungen',
    'Client payments, partner payouts, and platform fee tracking.':
      'Kundenzahlungen, Partnerauszahlungen und Verfolgung von Plattformgebühren.',
    'Client Payments': 'Kundenzahlungen',
    'Partner Payouts': 'Partnerauszahlungen',
    'Platform Fees': 'Plattformgebühren',
    'Failed to load reviews': 'Bewertungen konnten nicht geladen werden',
    'Review removed': 'Rezension entfernt',
    'Failed to remove review': 'Die Bewertung konnte nicht entfernt werden',
    Reviews: 'Rezensionen',
    'All partner and transport reviews submitted by clients.':
      'Alle von Kunden abgegebenen Partner- und Transportbewertungen.',
    'Loading reviews...': 'Bewertungen werden geladen...',
    'No reviews found': 'Keine Bewertungen gefunden',
    'Client feedback will appear here when reviews are submitted.':
      'Kundenfeedback wird hier angezeigt, wenn Bewertungen eingereicht werden.',
    Stars: 'Sterne',
    Comment: 'Kommentar',
    'Search, review, and maintain user accounts with one consistent admin workflow.':
      'Suchen, überprüfen und verwalten Sie Benutzerkonten mit einem einheitlichen Administrator-Workflow.',
    'Track paid and unpaid partner payout invoices, and upload the next delivered listing invoice quickly.':
      'Verfolgen Sie bezahlte und unbezahlte Partnerauszahlungsrechnungen und laden Sie schnell die nächste zugestellte Angebotsrechnung hoch.',
    'Search by invoice number, file name, or listing ID':
      'Suchen Sie nach Rechnungsnummer, Dateiname oder Angebots-ID',
    'Loading delivered listings...': 'Zugestellte Angebote werden geladen...',
    'Search delivered listing by reference, title, or route':
      'Durchsuchen Sie gelieferte Einträge nach Referenz, Titel oder Route',
    'Route details available in listing':
      'Routendetails finden Sie in der Auflistung',
    'No matching delivered listings': 'Keine passenden gelieferten Angebote',
    'Selected listing': 'Ausgewählter Eintrag',
    'Has quotes': 'Hat Zitate',
    'In transit': 'Auf der Durchreise',
    Open: 'Offen',
    Accepted: 'Akzeptiert',
    Completed: 'Abgeschlossen',
    'Client Dashboard': 'Kunden-Dashboard',
    'Overview of your current transport listings, quote activity, and recent requests.':
      'Überblick über Ihre aktuellen Transporteinträge, Angebotsaktivitäten und letzten Anfragen.',
    'Total listings': 'Gesamteinträge',
    'Active listings': 'Aktive Einträge',
    'Listings with quotes': 'Einträge mit Zitaten',
    'Accepted transport': 'Akzeptierter Transport',
    'Listing status timeline': 'Zeitleiste für den Eintragsstatus',
    'Last 6 months of listings grouped by current status.':
      'Einträge der letzten 6 Monate, gruppiert nach aktuellem Status.',
    'No listing activity yet': 'Noch keine Eintragsaktivität',
    'Create your first listing to start tracking request activity here.':
      'Erstellen Sie hier Ihren ersten Eintrag, um die Anfrageaktivität zu verfolgen.',
    'Create new listing': 'Neuen Eintrag erstellen',
    'Create a new transport request for the marketplace.':
      'Erstellen Sie eine neue Transportanfrage für den Marktplatz.',
    'View my listings': 'Sehen Sie sich meine Angebote an',
    'Review quote activity and manage your transport requests.':
      'Überprüfen Sie die Angebotsaktivitäten und verwalten Sie Ihre Transportanfragen.',
    'Recent listings': 'Aktuelle Angebote',
    'No listings yet': 'Noch keine Einträge',
    'Your newest transport requests will appear here once you create them.':
      'Ihre neuesten Transportanfragen werden hier angezeigt, sobald Sie sie erstellt haben.',
    'Unknown origin': 'Unbekannter Ursprung',
    '{{count}} quote(s)': '{{count}} Angebot(e)',
    '{{value}} completed listings': '{{value}} abgeschlossene Angebote',
    'Monitor current performance, fleet readiness, quote flow, and your active transport queue.':
      'Überwachen Sie die aktuelle Leistung, die Flottenbereitschaft, den Angebotsfluss und Ihre aktive Transportwarteschlange.',
    'Total assigned': 'Insgesamt zugewiesen',
    'Quarter rating': 'Viertelbewertung',
    'Based on current quarter performance':
      'Basierend auf der Leistung des aktuellen Quartals',
    Rating: 'Bewertung',
    'Requirement met': 'Anforderung erfüllt',
    'Requirement not met': 'Anforderung nicht erfüllt',
    'Completed listings per period': 'Abgeschlossene Inserate pro Zeitraum',
    'No completion data yet': 'Noch keine Fertigstellungsdaten',
    'Statistics will appear here after your first delivered work.':
      'Statistiken werden hier nach Ihrer ersten gelieferten Arbeit angezeigt.',
    'Completed listings': 'Abgeschlossene Angebote',
    'Review truck documents and refresh anything close to expiry.':
      'Überprüfen Sie die LKW-Dokumente und aktualisieren Sie alles, was kurz vor dem Ablauf steht.',
    'Search deliveries': 'Lieferungen suchen',
    'Review available marketplace listings and submit quotes.':
      'Überprüfen Sie verfügbare Marktplatzangebote und reichen Sie Angebote ein.',
    'My quotes': 'Meine Zitate',
    'Track accepted, pending, and rejected quotes in one place.':
      'Verfolgen Sie angenommene, ausstehende und abgelehnte Angebote an einem Ort.',
    'Profile settings': 'Profileinstellungen',
    'Keep company information and compliance details up to date.':
      'Halten Sie Unternehmensinformationen und Compliance-Details auf dem neuesten Stand.',
    'No active queue items': 'Keine aktiven Warteschlangenelemente',
    'Accepted and in-progress work will appear here as your transport activity grows.':
      'Akzeptierte und laufende Arbeiten werden hier angezeigt, wenn Ihre Transportaktivität zunimmt.',
    'Your role does not have permission to open this page.':
      'Ihre Rolle verfügt nicht über die Berechtigung, diese Seite zu öffnen.',
    'Go to dashboard': 'Gehen Sie zum Dashboard',
    'Trailer capacity is required.': 'Anhängerkapazität ist erforderlich.',
    'How many cars can this trailer carry?':
      'Wie viele Autos kann dieser Anhänger transportieren?',
    'Set maximum number of cars this trailer can carry (1-20).':
      'Legen Sie die maximale Anzahl an Autos fest, die dieser Anhänger transportieren kann (1–20).',
    'Invalid max load (kg).': 'Ungültige Höchstlast (kg).',
    'Enter a valid weight between 1 and 100000 kg, or leave it empty.':
      'Geben Sie ein gültiges Gewicht zwischen 1 und 100.000 kg ein oder lassen Sie das Feld leer.',
    'Maximum payload weight this truck can carry (optional).':
      'Maximales Nutzlastgewicht, das dieser LKW transportieren kann (optional).',
    'Manage the company and contact details that appear across your listings, invoices, and account verification flows.':
      'Verwalten Sie die Unternehmens- und Kontaktdaten, die in Ihren Einträgen, Rechnungen und Kontobestätigungsabläufen angezeigt werden.',
    'Keep these details up to date so listings, invoices, and partner verification stay accurate.':
      'Halten Sie diese Details auf dem neuesten Stand, damit Einträge, Rechnungen und Partnerüberprüfungen korrekt bleiben.',
    'Unsaved changes': 'Nicht gespeicherte Änderungen',
    'All changes saved': 'Alle Änderungen gespeichert',
    'auth.sign_up_failed': 'Die Anmeldung ist fehlgeschlagen',
    'auth.please_select_a_valid_role':
      'Bitte wählen Sie eine gültige Rolle aus.',
    'booking.pickup_not_found': 'Abholung nicht gefunden.',
    'booking.delivery_not_found': 'Lieferung nicht gefunden.',
    'booking.capacity': 'Kapazität',
    'booking.cmr_expiry': 'CMR-Ablauf',
    'booking.uploaded': 'Hochgeladen',
    'booking.missing': 'Fehlt',
    'booking.cmr_document': 'CMR-Dokument',
    'booking.go_to_profile': 'Gehen Sie zu Profil',
    'booking.click_to_download_purchase_terms':
      'Klicken Sie hier, um die Einkaufsbedingungen herunterzuladen',
    'admin.purchase_terms_management': 'Verwaltung der Einkaufsbedingungen',
    'admin.purchase_terms_management_subtitle':
      'Laden Sie lokalisierte PDFs mit Kaufbedingungen hoch und pflegen Sie diese, die bei der Annahme von Partnerbestellungen verwendet werden.',
    'admin.document_language': 'Dokumentsprache',
    'admin.click_to_download_purchase_terms':
      'Klicken Sie hier, um die Einkaufsbedingungen herunterzuladen',
    'admin.current_language_label': 'Aktuelle Sprache: {{language}}',
    'admin.purchase_terms_unavailable_for_selected_language':
      'Das Dokument mit den Einkaufsbedingungen ist für die ausgewählte Sprache nicht verfügbar.',
    'Download and review the active purchase terms in your current interface language before continuing.':
      'Laden Sie die aktiven Kaufbedingungen herunter und lesen Sie sie in Ihrer aktuellen Benutzeroberflächensprache, bevor Sie fortfahren.',
    'We make agreements and conclude a contract for the carriage of goods. I have just read this agreement in full and agree to its contents.':
      'Wir treffen Vereinbarungen und schließen einen Vertrag über die Beförderung von Gütern ab. Ich habe diese Vereinbarung soeben vollständig gelesen und bin mit ihrem Inhalt einverstanden.',
    'I confirm that I will schedule this order within 24 hours':
      'Ich bestätige, dass ich diese Bestellung innerhalb von 24 Stunden terminieren werde',
    'Failed to load purchase terms document.':
      'Das Dokument mit den Einkaufsbedingungen konnte nicht geladen werden.',
    'Partner rating': 'Partnerbewertung',
    'Bronze requirements': 'Anforderungen an Bronze',
    'Orders in quarter': 'Bestellungen im Quartal',
    'Cancellation rate / 100 orders': 'Stornoquote / 100 Bestellungen',
    'Damage claims / 100 orders': 'Schadensersatzansprüche / 100 Bestellungen',
    '{{current}} / min {{target}}': '{{current}} / min {{target}}',
    Met: 'Getroffen',
    'Not met': 'Nicht erfüllt',
    Unranked: 'Ohne Rang',
    'profile.incompleteDescriptionPartner':
      'Bitte vervollständigen Sie Ihre Profilinformationen (Firma, Telefon, Adresse, Stadt, Postleitzahl, Umsatzsteuer-Identifikationsnummer), um auf alle Funktionen zugreifen zu können.',
    'profile.incompleteDescriptionClient':
      'Bitte vervollständigen Sie Ihre Profilinformationen (Telefonnummer), um auf alle Funktionen zugreifen zu können.',
    'auth.verification_email_sent': 'Bestätigungs-E-Mail gesendet',
    '{{amount}} above the client target': '{{amount}} über dem Kundenziel',
    '{{amount}} below the client target': '{{amount}} unter dem Kundenziel',
    '{{count}} image(s) added to the listing.':
      '{{count}} Bild(er) zur Auflistung hinzugefügt.',
    '{{count}} quote(s) received': '{{count}} Angebot(e) erhalten',
    '{{count}} reviews': '{{count}} Bewertungen',
    '{{count}} total': '{{count}} insgesamt',
    '{{count}} visible': '{{count}} sichtbar',
    '{{weight}} kg': '{{weight}} kg',
    'A Google route preview with pins A and B appears here once pickup and delivery coordinates are available.':
      'Sobald die Abhol- und Lieferkoordinaten verfügbar sind, wird hier eine Google-Routenvorschau mit den Pins A und B angezeigt.',
    'A route preview appears once map coordinates are available.':
      'Sobald Kartenkoordinaten verfügbar sind, wird eine Routenvorschau angezeigt.',
    'A timeline of clarifications connected to this listing.':
      'Eine Zeitleiste der Klarstellungen im Zusammenhang mit dieser Auflistung.',
    "Accept {{partner}}'s quote for {{amount}}?":
      'Angebot von {{partner}} für {{amount}} annehmen?',
    'Accept Listing': 'Angebot akzeptieren',
    'Accept quote': 'Angebot annehmen',
    'Accepted quote': 'Angenommenes Angebot',
    'Accepted quote required': 'Akzeptiertes Angebot erforderlich',
    'Accepting...': 'Akzeptieren...',
    Active: 'Aktiv',
    'Active statuses': 'Aktive Status',
    'Add another item': 'Fügen Sie ein weiteres Element hinzu',
    'Add images': 'Bilder hinzufügen',
    'Add more shipment images': 'Fügen Sie weitere Sendungsbilder hinzu',
    'After you confirm an AI action, open the prepared destination immediately instead of waiting for a manual click.':
      'Nachdem Sie eine KI-Aktion bestätigt haben, öffnen Sie das vorbereitete Ziel sofort, anstatt auf einen manuellen Klick zu warten.',
    'AI Assistant': 'KI-Assistent',
    'AI assistant disabled for all users.':
      'KI-Assistent für alle Benutzer deaktiviert.',
    'AI assistant enabled for all users.':
      'KI-Assistent für alle Benutzer aktiviert.',
    'AI assistant preferences updated':
      'Einstellungen für KI-Assistenten aktualisiert',
    'AI disabled for user.': 'KI für Benutzer deaktiviert.',
    'AI enabled for user.': 'KI für Benutzer aktiviert.',
    'AI-powered message translation between languages':
      'KI-gestützte Nachrichtenübersetzung zwischen Sprachen',
    'All route-critical information in one place before you review quotes or documents.':
      'Alle routenkritischen Informationen an einem Ort, bevor Sie Angebote oder Dokumente prüfen.',
    View: 'Ansehen',
    Answer: 'Antwort',
    Archive: 'Archiv',
    'Archived statuses': 'Archivierte Status',
    'Are you sure you want to reject the quote from':
      'Sind Sie sicher, dass Sie das Angebot ablehnen möchten?',
    'Ask a question about this listing...':
      'Stellen Sie eine Frage zu diesem Eintrag...',
    'Ask for matching lanes, quote help, or the next operational step.':
      'Fragen Sie nach passenden Fahrspuren, bieten Sie Hilfe an oder informieren Sie sich über den nächsten Betriebsschritt.',
    'Ask for quote comparisons or a prepared next step from this shipment screen.':
      'Fordern Sie auf diesem Versandbildschirm Angebotsvergleiche oder einen vorbereiteten nächsten Schritt an.',
    'Assistant history cleared': 'Der Assistentenverlauf wurde gelöscht',
    'Automatically translate messages from other users into your preferred language using AI.':
      'Übersetzen Sie Nachrichten anderer Benutzer mithilfe von KI automatisch in Ihre bevorzugte Sprache.',
    'Back to listing': 'Zurück zur Auflistung',
    'Best offer': 'Bestes Angebot',
    'Best quote': 'Bestes Zitat',
    'Body type: {{type}}': 'Körpertyp: {{type}}',
    'Breed: {{breed}}': 'Rasse: {{breed}}',
    Budget: 'Budget',
    'Cancel listing': 'Eintrag stornieren',
    'Canceled and completed work will appear here once listings move out of the active view.':
      'Abgebrochene und abgeschlossene Arbeiten werden hier angezeigt, sobald die Einträge die aktive Ansicht verlassen.',
    'Cargo Details': 'Frachtdetails',
    Categories: 'Kategorien',
    'Choose the interface language. This preference is saved locally and applies immediately.':
      'Wählen Sie die Sprache der Benutzeroberfläche. Diese Präferenz wird lokal gespeichert und gilt sofort.',
    'Clear all': 'Alles löschen',
    'Clear assistant history': 'Klarer Assistentenverlauf',
    'Client price in EUR': 'Kundenpreis in EUR',
    'Client target price': 'Zielpreis des Kunden',
    'Complete the payment below to lock the fixed-price acceptance and let the partner start planning.':
      'Schließen Sie die Zahlung unten ab, um die Annahme des Festpreises zu sperren und den Partner mit der Planung beginnen zu lassen.',
    'Complete the payment below to lock the selected quote and let the partner start planning.':
      'Schließen Sie die Zahlung unten ab, um das ausgewählte Angebot zu sperren und den Partner mit der Planung beginnen zu lassen.',
    'Compose area prepared for listing Q&A. Submission remains disabled until the live question endpoint is connected on this page.':
      'Verfassen Sie einen Bereich, der für die Auflistung von Fragen und Antworten vorbereitet ist. Die Übermittlung bleibt deaktiviert, bis der Live-Fragenendpunkt auf dieser Seite verbunden wird.',
    'Confirm delivery complete': 'Bestätigen Sie den Abschluss der Lieferung',
    'Confirm payment received': 'Bestätigen Sie den Zahlungseingang',
    'Confirm that you have received the bank transfer or payment for this listing. This will move the listing to Paid status and allow the partner to mark it as planned.':
      'Bestätigen Sie, dass Sie die Banküberweisung oder Zahlung für dieses Angebot erhalten haben. Dadurch wird das Inserat in den Status „Bezahlt“ versetzt und der Partner kann es als geplant markieren.',
    'Confirm the exact fleet and dates before the listing moves to Planned.':
      'Bestätigen Sie die genaue Flotte und die Daten, bevor die Auflistung auf „Geplant“ verschoben wird.',
    'Confirm Transport Plan': 'Bestätigen Sie den Transportplan',
    'Confirming...': 'Bestätigen...',
    'Control how the web assistant behaves on this device. These settings do not change your account data.':
      'Steuern Sie, wie sich der Webassistent auf diesem Gerät verhält. Durch diese Einstellungen ändern sich Ihre Kontodaten nicht.',
    'Create listing': 'Eintrag erstellen',
    'Create with AI': 'Erstellen Sie mit KI',
    'Create your next transport request and it will appear here with route, item, and quote activity.':
      'Erstellen Sie Ihre nächste Transportanfrage und sie wird hier mit Route, Artikel und Angebotsaktivität angezeigt.',
    'Current stage:': 'Aktueller Stand:',
    'Current status': 'Aktueller Stand',
    'Delivery confirmation needed': 'Lieferbestätigung erforderlich',
    'Delivery radius': 'Lieferradius',
    'Delivery:': 'Lieferung:',
    'Describe the route and cargo, then review the prepared listing draft before publishing.':
      'Beschreiben Sie die Route und die Ladung und überprüfen Sie dann den vorbereiteten Listungsentwurf, bevor Sie ihn veröffentlichen.',
    'Describe the shipment you need and review the prepared request before publishing.':
      'Beschreiben Sie die Sendung, die Sie benötigen, und überprüfen Sie die vorbereitete Anfrage, bevor Sie sie veröffentlichen.',
    'Download and review the purchase terms before confirming the transport plan.':
      'Laden Sie die Kaufbedingungen herunter und lesen Sie sie durch, bevor Sie den Transportplan bestätigen.',
    'Download invoice': 'Rechnung herunterladen',
    'Download Purchase Terms': 'Laden Sie die Einkaufsbedingungen herunter',
    'Draft with AI': 'Entwurf mit KI',
    'Draft your review first, then submit it here when you are satisfied.':
      'Verfassen Sie zunächst Ihre Bewertung und reichen Sie sie dann hier ein, wenn Sie zufrieden sind.',
    'Edit listing': 'Eintrag bearbeiten',
    'Edit Quote': 'Angebot bearbeiten',
    Enable: 'Aktivieren',
    'Enable live translation': 'Live-Übersetzung aktivieren',
    'Enabled Users': 'Aktivierte Benutzer',
    'Engagement Activity': 'Engagement-Aktivität',
    'Expires:': 'Läuft ab:',
    'Failed to accept listing': 'Eintrag konnte nicht angenommen werden',
    'Failed to accept quote': 'Angebot konnte nicht angenommen werden',
    'Failed to clear assistant history':
      'Der Assistentenverlauf konnte nicht gelöscht werden',
    'Failed to complete listing':
      'Die Auflistung konnte nicht abgeschlossen werden',
    'Failed to confirm payment': 'Die Zahlung konnte nicht bestätigt werden',
    'Failed to confirm transport plan':
      'Transportplan konnte nicht bestätigt werden',
    'Failed to disable AI for user.':
      'KI konnte für den Benutzer nicht deaktiviert werden.',
    'Failed to enable AI for user.':
      'KI konnte für den Benutzer nicht aktiviert werden.',
    'Failed to load listing.': 'Die Auflistung konnte nicht geladen werden.',
    'Failed to load listings': 'Die Einträge konnten nicht geladen werden',
    'Failed to load listings. Please try again.':
      'Die Einträge konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
    'Failed to load review context.':
      'Der Überprüfungskontext konnte nicht geladen werden.',
    'Failed to load settings.':
      'Die Einstellungen konnten nicht geladen werden.',
    'Failed to refresh Stripe payment status':
      'Der Stripe-Zahlungsstatus konnte nicht aktualisiert werden',
    'Failed to reject quote': 'Angebot konnte nicht abgelehnt werden',
    'Failed to release listing': 'Eintrag konnte nicht veröffentlicht werden',
    'Failed to save quote': 'Angebot konnte nicht gespeichert werden',
    'Failed to update listing': 'Eintrag konnte nicht aktualisiert werden',
    'Failed to update preferred language':
      'Die bevorzugte Sprache konnte nicht aktualisiert werden',
    'Failed to update setting.':
      'Die Einstellung konnte nicht aktualisiert werden.',
    'Failed to update status': 'Status konnte nicht aktualisiert werden',
    'Failed to update translation preference':
      'Die Übersetzungseinstellung konnte nicht aktualisiert werden',
    'Failed to update watchlist':
      'Die Beobachtungsliste konnte nicht aktualisiert werden',
    'Failed to withdraw quote': 'Das Angebot konnte nicht zurückgezogen werden',
    'Feature Flags': 'Feature-Flags',
    'Filter invoice uploads, search by reference, and page through payout records.':
      'Filtern Sie Rechnungs-Uploads, suchen Sie nach Referenz und blättern Sie durch Auszahlungsdatensätze.',
    Filters: 'Filter',
    'Final delivery documents': 'Endgültige Lieferdokumente',
    'Fixed price only': 'Nur Festpreis',
    'Flexible / not set': 'Flexibel / nicht festgelegt',
    'Generated automatically when the transport plan is confirmed.':
      'Wird automatisch generiert, wenn der Transportplan bestätigt wird.',
    'Generation: {{generation}}': 'Generation: {{generation}}',
    'Goods delivered — awaiting client confirmation.':
      'Waren geliefert – warten auf Bestätigung durch den Kunden.',
    'Gross price': 'Bruttopreis',
    'I have read and agree to the purchase terms for this transport job.':
      'Ich habe die Einkaufsbedingungen für diesen Transportauftrag gelesen und stimme ihnen zu.',
    'I understand that accepting this listing assigns it to me at the fixed client price shown above.':
      'Mir ist bewusst, dass ich durch die Annahme dieses Angebots den oben angegebenen festen Kundenpreis erhalte.',
    'Image upload failed': 'Das Hochladen des Bildes ist fehlgeschlagen',
    'Images uploaded': 'Bilder hochgeladen',
    'Interface language': 'Schnittstellensprache',
    'Invoice documents': 'Rechnungsunterlagen',
    'Item {{number}}': 'Artikel {{number}}',
    items: 'Artikel',
    'Keep listing': 'Listen Sie weiter auf',
    'Keep quote': 'Zitat behalten',
    'Keep the current AI session available after closing the browser on this device.':
      'Halten Sie die aktuelle AI-Sitzung verfügbar, nachdem Sie den Browser auf diesem Gerät geschlossen haben.',
    'Language & Region': 'Sprache und Region',
    Listed: 'Gelistet',
    'Listing {{id}}': 'Auflistung {{id}}',
    'Listing accepted': 'Eintrag angenommen',
    'Listing expired': 'Eintrag abgelaufen',
    'Listing images': 'Bilder auflisten',
    'Listing is live': 'Der Eintrag ist live',
    'Listing reference': 'Auflistungsreferenz',
    'Listing snapshot': 'Schnappschuss der Auflistung',
    'Listing unavailable': 'Eintrag nicht verfügbar',
    'Listing updated': 'Eintrag aktualisiert',
    'Live Translation': 'Live-Übersetzung',
    'Live translation disabled.': 'Live-Übersetzung deaktiviert.',
    'Live translation enabled.': 'Live-Übersetzung aktiviert.',
    'Loading approved trucks...': 'Beladen zugelassener LKWs...',
    'Loading fleet...': 'Flotte wird geladen...',
    'Loading listing details...': 'Details zum Eintrag werden geladen...',
    'Loading listings...': 'Einträge werden geladen...',
    'Loading review details...': 'Bewertungsdetails werden geladen...',
    'Loading settings...': 'Einstellungen werden geladen...',
    'Manage AI Assistant Users': 'Verwalten Sie AI Assistant-Benutzer',
    'Manage platform-wide feature flags and configuration.':
      'Verwalten Sie plattformweite Funktionsflags und Konfigurationen.',
    'Manage Users': 'Benutzer verwalten',
    'Manage your transport requests, monitor quote activity, and keep active and archived work easy to scan.':
      'Verwalten Sie Ihre Transportanfragen, überwachen Sie die Angebotsaktivität und sorgen Sie dafür, dass aktive und archivierte Arbeiten einfach zu scannen sind.',
    'Mark Picked Up': 'Mark abgeholt',
    'Matches the client target price': 'Entspricht dem Zielpreis des Kunden',
    Media: 'Medien',
    Messages: 'Nachrichten',
    'Messages will be translated into this language.':
      'Nachrichten werden in diese Sprache übersetzt.',
    'Minimum net:': 'Mindestnetto:',
    'My invoices': 'Meine Rechnungen',
    Net: 'Netz',
    'Net price': 'Nettopreis',
    'Net quote': 'Nettokurs',
    'New images appear immediately in the listing details for client, partner, and admin views.':
      'Neue Bilder erscheinen sofort in den Eintragsdetails für Kunden-, Partner- und Administratoransichten.',
    'Next step': 'Nächster Schritt',
    'No active listings yet': 'Noch keine aktiven Einträge',
    'No address provided': 'Keine Adresse angegeben',
    'No answer yet.': 'Noch keine Antwort.',
    'No archived listings yet': 'Noch keine archivierten Einträge',
    'No description added.': 'Keine Beschreibung hinzugefügt.',
    'no destination': 'kein Ziel',
    'No expiry': 'Kein Ablauf',
    'No listings match the current filters. Try broadening the search or date range.':
      'Keine Einträge entsprechen den aktuellen Filtern. Versuchen Sie, die Suche oder den Datumsbereich zu erweitern.',
    'no origin': 'keine Herkunft',
    'No questions yet': 'Noch keine Fragen',
    'No quotes yet': 'Noch keine Zitate',
    'No shipment images uploaded yet.':
      'Es wurden noch keine Sendungsbilder hochgeladen.',
    'No trailer selected': 'Kein Trailer ausgewählt',
    'No unread messages': 'Keine ungelesenen Nachrichten',
    'No users found.': 'Keine Benutzer gefunden.',
    'No users have AI enabled.': 'Bei keinem Benutzer ist KI aktiviert.',
    'Not selected': 'Nicht ausgewählt',
    'Offers summary': 'Zusammenfassung der Angebote',
    'Open AI assistant': 'Öffnen Sie den KI-Assistenten',
    'Open prepared screens automatically':
      'Vorbereitete Bildschirme automatisch öffnen',
    'Optional visible price shown to partners as your target budget.':
      'Optional sichtbarer Preis, der Partnern als Zielbudget angezeigt wird.',
    'Other quotes will be declined automatically once this offer is accepted.':
      'Andere Angebote werden automatisch abgelehnt, sobald dieses Angebot angenommen wird.',
    'Partner delivery': 'Partnerlieferung',
    'Partner pickup': 'Abholung durch den Partner',
    'Partner quote': 'Partnerzitat',
    'Payment confirmed': 'Zahlung bestätigt',
    'Payment confirmed — listing status set to paid':
      'Zahlung bestätigt – Angebotsstatus auf „bezahlt“ gesetzt',
    'Payment confirmed. Confirm the assigned fleet and planned dates before the listing moves to Planned.':
      'Zahlung bestätigt. Bestätigen Sie die zugewiesene Flotte und die geplanten Daten, bevor die Auflistung auf „Geplant“ verschoben wird.',
    'Payment is confirmed. The partner now needs to confirm the truck, driver, and planned dates.':
      'Die Zahlung wird bestätigt. Der Partner muss nun den LKW, den Fahrer und die geplanten Termine bestätigen.',
    'Payment required': 'Zahlung erforderlich',
    'Photos uploaded for the shipment and visible across client, partner, and admin views.':
      'Für die Sendung hochgeladene Fotos, die in den Kunden-, Partner- und Administratoransichten sichtbar sind.',
    'Pickup is complete and the transport is currently underway.':
      'Die Abholung ist abgeschlossen und der Transport läuft derzeit.',
    'Pickup proof': 'Abholbeweis',
    'Pickup proof and final delivery files uploaded by the transport partner.':
      'Vom Transportpartner hochgeladene Abholnachweise und endgültige Lieferdateien.',
    'Pickup to delivery overview':
      'Übersicht von der Abholung bis zur Lieferung',
    'Pickup:': 'Abholung:',
    'Plan and authorization': 'Plan und Genehmigung',
    'Plan transport': 'Transport planen',
    'Plan Transport': 'Transport planen',
    'Planned dates:': 'Geplante Termine:',
    'Planned delivery date': 'Geplanter Liefertermin',
    'Platform Settings': 'Plattformeinstellungen',
    'Preferred language': 'Bevorzugte Sprache',
    'Preferred language updated': 'Bevorzugte Sprache aktualisiert',
    'Prepare a quote or ask for the next lane action, then confirm before anything is submitted.':
      'Bereiten Sie ein Angebot vor oder fragen Sie nach der nächsten Lane-Aktion und bestätigen Sie es dann, bevor Sie etwas absenden.',
    'Purchase Terms': 'Einkaufsbedingungen',
    'Quantities, dimensions, and handling details ready for transport review.':
      'Mengen, Abmessungen und Handhabungsdetails stehen für die Transportüberprüfung bereit.',
    Question: 'Frage',
    Questions: 'Fragen',
    'Questions & answers': 'Fragen & Antworten',
    'Questions and answers for this listing will appear here once the messaging flow is active.':
      'Fragen und Antworten zu diesem Eintrag werden hier angezeigt, sobald der Nachrichtenfluss aktiv ist.',
    'Quick access to the current shipment, quote, and billing state.':
      'Schneller Zugriff auf den aktuellen Sendungs-, Angebots- und Rechnungsstatus.',
    'Quote accepted': 'Angebot angenommen',
    'Quote count': 'Zitatanzahl',
    'Quote message': 'Zitatnachricht',
    'Quote rejected': 'Angebot abgelehnt',
    'Quote withdrawn': 'Zitat zurückgezogen',
    Quotes: 'Zitate',
    'Quotes and questions': 'Zitate und Fragen',
    'Quotes are disabled for this listing. The first partner to accept the fixed price will be assigned automatically.':
      'Angebote sind für diesen Eintrag deaktiviert. Der erste Partner, der den Festpreis akzeptiert, wird automatisch zugewiesen.',
    'Quotes are disabled for this shipment. If you accept it, the client price becomes an accepted booking immediately.':
      'Angebote sind für diese Sendung deaktiviert. Wenn Sie es akzeptieren, wird der Kundenpreis sofort zu einer akzeptierten Buchung.',
    'Quotes from transport providers usually begin to appear shortly after publishing. Refresh to check again.':
      'Angebote von Transportanbietern erscheinen in der Regel kurz nach der Veröffentlichung. Aktualisieren Sie die Datei, um eine erneute Überprüfung durchzuführen.',
    'Reference #{{id}}': 'Referenz #{{id}}',
    'Refresh listings': 'Einträge aktualisieren',
    'Reject quote': 'Angebot ablehnen',
    'Rejecting...': 'Ablehnen...',
    Release: 'Veröffentlichung',
    'Release Listing': 'Veröffentlichungsliste',
    'Remember assistant conversation':
      'Erinnern Sie sich an das Gespräch mit dem Assistenten',
    'Required for fixed-price listings. Partners accept this amount directly.':
      'Erforderlich für Festpreisangebote. Partner akzeptieren diesen Betrag direkt.',
    'Required. Partners will be able to accept this listing at the fixed client price without sending a quote.':
      'Erforderlich. Partner können dieses Angebot zum festen Kundenpreis annehmen, ohne ein Angebot zu senden.',
    'Review submission failed.':
      'Die Übermittlung der Bewertung ist fehlgeschlagen.',
    'Review the completed transport using the standard product flow.':
      'Überprüfen Sie den abgeschlossenen Transport anhand des Standardproduktflusses.',
    'Route pending': 'Route ausstehend',
    'Save changes': 'Änderungen speichern',
    'Saving...': 'Sparen...',
    'Search by title, route, category, or item':
      'Suchen Sie nach Titel, Route, Kategorie oder Artikel',
    'Search Results': 'Suchergebnisse',
    'Search users by email...': 'Benutzer per E-Mail suchen...',
    'Select a truck, driver, pickup date, and delivery date.':
      'Wählen Sie einen LKW, einen Fahrer, ein Abholdatum und ein Lieferdatum aus.',
    'Select approved truck': 'Wählen Sie einen zugelassenen LKW aus',
    'Select driver': 'Treiber auswählen',
    'Send Revision': 'Überarbeitung senden',
    Sentiment: 'Stimmung',
    'Share what went well and what could improve':
      'Teilen Sie mit, was gut gelaufen ist und was verbessert werden könnte',
    'Shipment in transit': 'Versand im Transit',
    'Shipment notes': 'Versandscheine',
    'Shipment tracking will be shared': 'Die Sendungsverfolgung wird geteilt',
    'Show AI launchers': 'KI-Werfer anzeigen',
    'Show or hide AI assistant buttons on supported dashboard and listing pages.':
      'KI-Assistentenschaltflächen auf unterstützten Dashboard- und Auflistungsseiten ein- oder ausblenden.',
    'Special needs or notes': 'Besondere Bedürfnisse oder Hinweise',
    'Specify delivery dates': 'Liefertermine angeben',
    'Specify pickup dates': 'Geben Sie Abholtermine an',
    Stage: 'Bühne',
    'Status updated to {{status}}': 'Status auf {{status}} aktualisiert',
    'Stripe payment confirmed and booking updated':
      'Stripe-Zahlung bestätigt und Buchung aktualisiert',
    'Stripe status: {{status}}': 'Stripe-Status: {{status}}',
    'Submit question': 'Frage abschicken',
    'Submit review': 'Bewertung abgeben',
    'Submitting...': 'Einreichen...',
    'The AI assistant is currently disabled for this environment. Existing local session data can still be cleared here.':
      'Der KI-Assistent ist derzeit für diese Umgebung deaktiviert. Vorhandene lokale Sitzungsdaten können hier weiterhin gelöscht werden.',
    'The listing expired before a transport was confirmed.':
      'Die Auflistung ist abgelaufen, bevor ein Transport bestätigt wurde.',
    'The listing has been fully completed and archived as a finished transport.':
      'Die Auflistung ist vollständig abgeschlossen und als fertiger Transport archiviert.',
    'The lowest net price you would still accept for this shipment.':
      'Der niedrigste Nettopreis, den Sie für diese Sendung noch akzeptieren würden.',
    'The partner has confirmed the route plan. Pickup and delivery dates are now scheduled.':
      'Der Partner hat den Routenplan bestätigt. Abhol- und Liefertermine sind jetzt festgelegt.',
    'The partner marked the shipment as delivered. Review the final documents and confirm completion.':
      'Der Partner hat die Sendung als zugestellt markiert. Überprüfen Sie die endgültigen Dokumente und bestätigen Sie den Abschluss.',
    'The partner-confirmed plan and LOA stay grouped together for faster review.':
      'Der vom Partner bestätigte Plan und die LOA bleiben zur schnelleren Überprüfung zusammengefasst.',
    'This action notifies the transport provider and removes the quote from active consideration.':
      'Durch diese Aktion wird der Transportanbieter benachrichtigt und das Angebot aus der aktiven Prüfung entfernt.',
    'This listing is archived and no further transport actions are available.':
      'Diese Auflistung ist archiviert und es sind keine weiteren Transportaktionen verfügbar.',
    'This listing needs an accepted quote before a review can be created.':
      'Für diesen Eintrag ist ein akzeptiertes Angebot erforderlich, bevor eine Bewertung erstellt werden kann.',
    'This will soft-cancel the listing and move it to your archive.':
      'Dadurch wird der Eintrag vorläufig gelöscht und in Ihr Archiv verschoben.',
    'This will soft-cancel the listing for the client and remove it from active marketplace views.':
      'Dadurch wird der Eintrag für den Kunden vorläufig storniert und aus den aktiven Marktplatzansichten entfernt.',
    'Total quote': 'Gesamtangebot',
    'Tracking not promised': 'Sendungsverfolgung nicht versprochen',
    'Tracking shared': 'Tracking geteilt',
    'Tracking visibility': 'Sichtbarkeit verfolgen',
    'Trailer (Optional)': 'Anhänger (optional)',
    'Translation preference updated': 'Übersetzungseinstellung aktualisiert',
    'Transport completed': 'Transport abgeschlossen',
    'Transport completed.': 'Transport abgeschlossen.',
    'Transport documents': 'Transportdokumente',
    'Transport marked as complete': 'Transport als abgeschlossen markiert',
    'Transport package': 'Transportpaket',
    'Transport plan confirmed': 'Transportplan bestätigt',
    'Transport plan updated': 'Transportplan aktualisiert',
    'Transport planned': 'Transport geplant',
    'Transport Provider': 'Transportanbieter',
    'Transport providers can review your shipment and send offers.':
      'Transportdienstleister können Ihre Sendung überprüfen und Angebote senden.',
    'Transport stage': 'Transportphase',
    Truck: 'LKW',
    'Truck, driver, trailer, and planned dates for this shipment.':
      'LKW, Fahrer, Anhänger und geplante Termine für diese Sendung.',
    'Try widening the current listing filters.':
      'Versuchen Sie, die aktuellen Eintragsfilter zu erweitern.',
    'Unable to upload listing images.':
      'Eintragsbilder können nicht hochgeladen werden.',
    'Unknown error': 'Unbekannter Fehler',
    'Untitled listing': 'Auflistung ohne Titel',
    'Untitled Listing': 'Unbenannte Auflistung',
    'Update media': 'Medien aktualisieren',
    'Update transport plan': 'Transportplan aktualisieren',
    'Update Transport Plan': 'Transportplan aktualisieren',
    'Upload a CMR or delivery photos before marking delivered.':
      'Laden Sie ein CMR- oder Lieferfoto hoch, bevor Sie es als „Zugestellt“ markieren.',
    'Upload a CMR or delivery photos before the listing can move to Delivered.':
      'Laden Sie ein CMR- oder Lieferfoto hoch, bevor das Angebot auf „Geliefert“ verschoben werden kann.',
    'Upload at least one pickup proof before the listing can move to Picked Up.':
      'Laden Sie mindestens einen Abholnachweis hoch, bevor das Angebot auf „Abgeholt“ verschoben werden kann.',
    'Upload final documents': 'Abschlussdokumente hochladen',
    'Upload proof of pickup': 'Laden Sie einen Abholbeleg hoch',
    'Uploading...': 'Hochladen...',
    'Use fresh photos when the shipment changes or you want to clarify the item condition.':
      'Verwenden Sie aktuelle Fotos, wenn sich die Sendung ändert oder Sie den Zustand des Artikels klären möchten.',
    'users enabled': 'Benutzer aktiviert',
    'Visible to you while quoting. You can still send your own net offer below or above this amount.':
      'Für Sie beim Zitieren sichtbar. Sie können auch unterhalb oder oberhalb dieses Betrags Ihr eigenes Nettoangebot absenden.',
    'Waiting for partner acceptance': 'Warten auf Partnerakzeptanz',
    'Waiting for transport planning': 'Warten auf die Transportplanung',
    'When enabled, messages from other users will be automatically translated to your preferred language.':
      'Wenn diese Option aktiviert ist, werden Nachrichten von anderen Benutzern automatisch in Ihre bevorzugte Sprache übersetzt.',
    Withdraw: 'Zurückziehen',
    'Write Review': 'Bewertung schreiben',
    'You are about to release this listing back to the marketplace.':
      'Sie sind dabei, dieses Angebot wieder auf dem Marktplatz freizugeben.',
    'You are now the assigned partner for this fixed-price listing.':
      'Sie sind nun der zugewiesene Partner für dieses Festpreisangebot.',
    'Your quote has been accepted. Awaiting payment confirmation from the admin before you can begin the job.':
      'Ihr Angebot wurde angenommen. Warten Sie auf die Zahlungsbestätigung vom Administrator, bevor Sie mit der Arbeit beginnen können.',
    'VIN: {{vin}}': 'Fahrgestellnummer: {{vin}}',
    'Material: {{type}}': 'Material: {{type}}',
    'L cm': 'L cm',
    'H cm': 'H cm',
    'nav.dashboard': 'Armaturenbrett',
    'nav.adminDashboard': 'Armaturenbrett',
    'Lift: {{origin}} / {{destination}}':
      'Aufzug: {{origin}} / {{destination}}',
  },
  fr: {
    to: 'à',
    Sa: 'Sa',
    kg: 'kilos',
    'Dimensions (cm)': 'Dimensions (cm)',
    Compact: 'Compacte',
    Hatchback: 'Hayon',
    Coupé: 'Coupé',
    Crossover: 'Croisement',
    total: 'total',
    Required: 'Obligatoire',
    'Change language': 'Changer de langue',
    'Loading...': 'Chargement…',
    'Error:': 'Erreur :',
    Close: 'Fermer',
    Yes: 'Oui',
    No: 'Non',
    'Keep order': "Gardez l'ordre",
    Date: 'Date',
    Price: 'Prix',
    'Purchase terms': "Conditions d'achat",
    'Power of attorney': 'Procuration',
    Performance: 'Performances',
    'Transport details': 'Détails du transport',
    'Upload damages': 'Télécharger des dommages',
    'Download (PDF)': 'Télécharger (PDF)',
    'Mark as picked up': 'Marquer comme récupéré',
    'Mark as delivered': 'Marquer comme livré',
    'Cancel booking': 'Annuler la réservation',
    'Order marked as picked up': 'Commande marquée comme récupérée',
    'Order marked as delivered': 'Commande marquée comme livrée',
    'Order canceled': 'Commande annulée',
    'Failed to cancel order': "Échec de l'annulation de la commande",
    'Added {{count}} file(s)': 'Fichier(s) {{count}} ajouté(s)',
    Pages: 'Pages',
    'Awaiting Verification': 'En attente de vérification',
    'Profile Incomplete': 'Profil incomplet',
    'Please complete your profile information (Company, Phone, Address, City, Post Code) to access all features.':
      'Veuillez compléter les informations de votre profil (Entreprise, Téléphone, Adresse, Ville, Code Postal) pour accéder à toutes les fonctionnalités.',
    'Go to Profile': 'Aller au profil',
    'Forgot Password': 'Mot de passe oublié',
    Hello: 'Bonjour',
    friend: 'ami',
    'Book your transport': 'Réservez votre transport',
    'fast and easy': 'rapide et facile',
    Origin: 'Origine',
    Destination: 'Destination',
    'Postal code': 'Code postal',
    'Calculate to preview': 'Calculer pour prévisualiser',
    "Can't be calculated yet": 'Ne peut pas encore être calculé',
    'Awaiting payment badge': 'En attente de paiement',
    'Ref {{id}}': 'Réf {{id}}',
    'Change planning': 'Planification du changement',
    'Change driver': 'Changer de pilote',
    'No vehicles listed': 'Aucun véhicule répertorié',
    'VIN / Chassis': 'NIV / Châssis',
    'Order not found.': 'Commande introuvable.',
    'Not available': 'Non disponible',
    'For {{date}}': 'Pour {{date}}',
    'Picked on {{date}}': 'Choisi sur {{date}}',
    'Delivered on {{date}}': 'Livré sur {{date}}',
    'Loading notification: {{value}}': 'Notification de chargement : {{value}}',
    'CO₂ compensation: {{value}}': 'Compensation CO₂ : {{value}}',
    'Bio fuel: {{value}}': 'Biocarburant : {{value}}',
    Remove: 'Supprimer',
    'Copy {{label}}': 'Copier {{label}}',
    'Open navigation menu': 'Ouvrir le menu de navigation',
    'Open menu': 'Ouvrir le menu',
    'Error fetching data': 'Erreur lors de la récupération des données',
    'Not set': 'Non défini',
    'No opening hours provided': "Aucune heure d'ouverture fournie",
    Point: 'Point',
    Distance: 'Distance',
    'Please select a planned date': 'Veuillez sélectionner une date prévue',
    Email: 'Courriel',
    'Saved favorite route filter': "Filtre d'itinéraire favori enregistré",
    km: 'kilomètres',
    mi: 'mi',
    'Radius search': 'Recherche de rayon',
    'City or town': 'Ville ou village',
    'Country (optional)': 'Pays (facultatif)',
    Radius: 'Rayon',
    'Searching…': 'Recherche…',
    'City not found': 'Ville introuvable',
    'Within {{radius}} {{unit}} of {{place}}':
      'Dans {{radius}} {{unit}} de {{place}}',
    'Clear radius': 'Rayon clair',
    'auth.account_status_pending_review':
      "Statut du compte : En attente d'examen",
    'auth.your_account_is_pending_approval':
      "Votre compte est en attente d'approbation",
    'auth.upload_your_verification_documents_below_and_we_ll_notify_you_by_email_once_your_account_is_approved':
      'Téléchargez vos documents de vérification ci-dessous et nous vous informerons par e-mail une fois votre compte approuvé.',
    'auth.check_status': "Vérifier l'état",
    'auth.upload_verification_documents':
      'Télécharger des documents de vérification',
    'auth.your_uploaded_documents': 'Vos documents téléchargés',
    'auth.back_to_sign_in': 'Retour pour vous connecter',
    role_client: 'Client',
    Bronze: 'Bronze',
    client: 'Client',
    admin: 'Administrateur',
    Score: 'Score',
    France: 'France',
    Kazakhstan: 'Kazakhstan',
    Kosovo: 'Kosovo',
    Liechtenstein: 'Liechtenstein',
    Luxembourg: 'Luxembourg',
    Monaco: 'Monaco',
    Portugal: 'Portugal',
    Ukraine: 'Ukraine',
    'BodyType.Coupe': 'Coupé',
    'BodyType.Superauto': 'Supercar',
    'BodyType.Crossover': 'Croisement',
    ' total': 'total',
    'N/A': 'N/D',
    Client: 'Client',
    Documents: 'Documents',
    'Error loading documents': 'Erreur lors du chargement des documents',
    'Are you sure you want to delete this document?':
      'Êtes-vous sûr de vouloir supprimer ce document ?',
    'Document deleted': 'Document supprimé',
    'Failed to delete': 'Échec de la suppression',
    'Failed to get download link':
      "Impossible d'obtenir le lien de téléchargement",
    'Status updated': 'Statut mis à jour',
    'Update failed': 'La mise à jour a échoué',
    'Email cannot be changed.': "L'e-mail ne peut pas être modifié.",
    'No documents found.': 'Aucun document trouvé.',
    'Invoice #': 'Numéro de facture',
    'File Name': 'Nom du fichier',
    Amount: 'Montant',
    Actions: 'Actions',
    Download: 'Télécharger',
    'Mark Unpaid': 'Marquer comme impayé',
    'Mark Paid': 'Marquer comme payé',
    'Please save the record before uploading documents.':
      'Veuillez sauvegarder le dossier avant de télécharger des documents.',
    'Select a file before uploading.':
      'Sélectionnez un fichier avant de le télécharger.',
    'Please enter an invoice number.': 'Veuillez saisir un numéro de facture.',
    'Upload successful': 'Téléchargement réussi',
    '{{count}} file(s) uploaded successfully.':
      'Fichier(s) {{count}} téléchargé(s) avec succès.',
    'Upload failed': 'Échec du téléchargement',
    'Unable to upload the document.': 'Impossible de télécharger le document.',
    'Invoice Number': 'Numéro de facture',
    'Selected files:': 'Fichiers sélectionnés :',
    Upload: 'Télécharger',
    'Save this record before uploading documents.':
      'Enregistrez cet enregistrement avant de télécharger des documents.',
    'Error approving user': "Erreur lors de l'approbation de l'utilisateur",
    'Error rejecting user': "Erreur lors du rejet de l'utilisateur",
    'Error disabling user': "Erreur lors de la désactivation de l'utilisateur",
    'User marked as VIP': 'Utilisateur marqué comme VIP',
    'User unmarked as VIP': 'Utilisateur non marqué comme VIP',
    'Error marking user as VIP':
      "Erreur lors du marquage de l'utilisateur comme VIP",
    'Error unmarking user as VIP':
      "Erreur lors de la démarquage de l'utilisateur en tant que VIP",
    'Failed to approve user': "Échec de l'approbation de l'utilisateur",
    'Failed to reject user': "Échec du rejet de l'utilisateur",
    'Failed to disable user': "Échec de la désactivation de l'utilisateur",
    'Failed to unmark user as VIP':
      "Échec de la démarquage de l'utilisateur en tant que VIP",
    'Failed to mark user as VIP':
      "Échec du marquage de l'utilisateur comme VIP",
    'Invoice Management': 'Gestion des factures',
    'All Invoices': 'Toutes les factures',
    'Manage all invoices uploaded by partners.':
      'Gérez toutes les factures téléchargées par les partenaires.',
    'An unexpected error occurred. Please try again.':
      "Une erreur inattendue s'est produite. Veuillez réessayer.",
    'The email address is not valid.': "L'adresse email n'est pas valide.",
    'This account has been disabled.': 'Ce compte a été désactivé.',
    'No account found with this email.': 'Aucun compte trouvé avec cet email.',
    'Incorrect password. Please try again.':
      'Mot de passe incorrect. Veuillez réessayer.',
    'Invalid email or password. Please check your credentials and try again.':
      "Email ou mot de passe invalide. Veuillez vérifier vos informations d'identification et réessayer.",
    'Too many failed attempts. Please try again later or reset your password.':
      'Trop de tentatives infructueuses. Veuillez réessayer plus tard ou réinitialiser votre mot de passe.',
    'Network error. Check your connection and try again.':
      'Erreur réseau. Vérifiez votre connexion et réessayez.',
    'A verification email has been sent to your email address. Please verify your email before logging in.':
      'Un e-mail de vérification a été envoyé à votre adresse e-mail. Veuillez vérifier votre adresse e-mail avant de vous connecter.',
    'Please make sure both passwords are the same.':
      'Veuillez vous assurer que les deux mots de passe sont identiques.',
    'Verification email resent!': 'E-mail de vérification renvoyé !',
    'Please check your inbox.': 'Veuillez vérifier votre boîte de réception.',
    'You need to log in first': "Vous devez d'abord vous connecter",
    'Please sign in to resend the verification email.':
      "Veuillez vous connecter pour renvoyer l'e-mail de vérification.",
    'Failed to resend email': "Échec du renvoi de l'e-mail",
    'Resend verification email': "Renvoyer l'e-mail de vérification",
    'Show password': 'Afficher le mot de passe',
    'Hide password': 'Masquer le mot de passe',
    'Awaiting verification artwork':
      "En attente de l'illustration de vérification",
    'Account status: Pending review': "Statut du compte : En attente d'examen",
    'Your account is pending approval':
      "Votre compte est en attente d'approbation",
    "Upload your verification documents below and we'll notify you by email once your account is approved.":
      'Téléchargez vos documents de vérification ci-dessous et nous vous informerons par e-mail une fois votre compte approuvé.',
    'Check status': "Vérifier l'état",
    'Upload verification documents':
      'Télécharger des documents de vérification',
    'Your uploaded documents': 'Vos documents téléchargés',
    'Back to sign in': 'Retour pour vous connecter',
    'Hide documents': 'Masquer les documents',
    'Email verification required': "Vérification de l'e-mail requise",
    'Waiting for email verification': 'En attente de vérification par e-mail',
    'Check your email': 'Vérifiez votre courrier électronique',
    'We sent your verification link to':
      'Nous avons envoyé votre lien de vérification à',
    "Didn't receive it? Check your spam folder or try again.":
      "Vous ne l'avez pas reçu ? Vérifiez votre dossier spam ou réessayez.",
    'Resend email': "Renvoyer l'e-mail",
    "I've verified my email": "J'ai vérifié mon email",
    'Redirecting you now.': 'Je vous redirige maintenant.',
    'Email not verified yet': 'E-mail pas encore vérifié',
    'Please click the link in your inbox and try again.':
      'Veuillez cliquer sur le lien dans votre boîte de réception et réessayer.',
    'Unable to resend verification email right now.':
      "Impossible de renvoyer l'e-mail de vérification pour le moment.",
    'Unable to check verification status right now.':
      "Impossible de vérifier l'état de vérification pour le moment.",
    "We've sent a new verification link to your email address.":
      'Nous avons envoyé un nouveau lien de vérification à votre adresse e-mail.',
    'We automatically check your verification status every 30 seconds. You can also trigger an instant check after verifying your email.':
      'Nous vérifions automatiquement votre statut de vérification toutes les 30 secondes. Vous pouvez également déclencher une vérification instantanée après avoir vérifié votre e-mail.',
    'We automatically check your verification status every 15 seconds. You can also trigger an instant check after verifying your email.':
      'Nous vérifions automatiquement votre statut de vérification toutes les 15 secondes. Vous pouvez également déclencher une vérification instantanée après avoir vérifié votre e-mail.',
    'Inputs changed. Recalculate the price.':
      'Les entrées ont changé. Recalculez le prix.',
    'My Invoices': 'Mes factures',
    'Upload New Invoice': 'Télécharger une nouvelle facture',
    'Please enter the invoice number and upload the invoice document. It will be reviewed by an administrator.':
      'Veuillez saisir le numéro de facture et télécharger le document de facturation. Il sera examiné par un administrateur.',
    'Invoice History': 'Historique des factures',
    'Client ref · {{clientRef}}': 'Réf client · {{clientRef}}',
    'Order Documents': 'Documents de commande',
    'Upload Proof of Pickup': 'Télécharger la preuve de ramassage',
    'Status will be updated to Picked Up after successful upload.':
      'Le statut sera mis à jour sur Ramassé après le téléchargement réussi.',
    'Upload Proof of Delivery': 'Télécharger une preuve de livraison',
    'Status will be updated to Delivered after successful upload.':
      'Le statut sera mis à jour sur Livré après un téléchargement réussi.',
    'Enter first name': 'Entrez le prénom',
    'Enter last name': 'Entrez le nom de famille',
    'Enter phone number': 'Entrez le numéro de téléphone',
    'Driver updated.': 'Pilote mis à jour.',
    'The driver has been successfully updated.':
      'Le pilote a été mis à jour avec succès.',
    'Driver added.': 'Pilote ajouté.',
    'The new driver has been successfully added.':
      'Le nouveau pilote a été ajouté avec succès.',
    'Driver deleted.': 'Pilote supprimé.',
    'The driver has been successfully deleted.':
      'Le pilote a été supprimé avec succès.',
    'Trailer updated.': 'Bande-annonce mise à jour.',
    'The trailer has been successfully updated.':
      'La bande-annonce a été mise à jour avec succès.',
    'Trailer added.': 'Bande-annonce ajoutée.',
    'The new trailer has been successfully added.':
      'La nouvelle bande-annonce a été ajoutée avec succès.',
    'Trailer deleted.': 'Bande-annonce supprimée.',
    'The trailer has been successfully deleted.':
      'La bande-annonce a été supprimée avec succès.',
    'User account not found. Please complete registration.':
      "Compte utilisateur introuvable. Veuillez compléter l'inscription.",
    'No token provided': 'Aucun jeton fourni',
    'Token expired': 'Jeton expiré',
    'Token revoked': 'Jeton révoqué',
    'Invalid ID token': "Jeton d'identification invalide",
    Unauthorized: 'Non autorisé',
    'Unauthorized: User not authenticated.':
      'Non autorisé : utilisateur non authentifié.',
    'Unauthorized: User role not found.':
      "Non autorisé : rôle d'utilisateur introuvable.",
    'Forbidden: Your role is not allowed to perform this action.':
      "Interdit : votre rôle n'est pas autorisé à effectuer cette action.",
    'Forbidden: This action requires a partner role.':
      'Interdit : cette action nécessite un rôle de partenaire.',
    'Forbidden: This action requires a client role.':
      'Interdit : Cette action nécessite un rôle client.',
    'Forbidden: This action requires an admin role.':
      "Interdit : cette action nécessite un rôle d'administrateur.",
    'This user has not been approved': "Cet utilisateur n'a pas été approuvé",
    'User email has not been verified':
      "L'e-mail de l'utilisateur n'a pas été vérifié",
    'User account has been disabled': 'Le compte utilisateur a été désactivé',
    'Booking not found': 'Réservation introuvable',
    'Route not found': 'Itinéraire introuvable',
    'Pickup location (country and postalCode) is required':
      'Le lieu de retrait (pays et code postal) est requis',
    'Delivery location (country and postalCode) is required':
      'Le lieu de livraison (pays et code postal) est requis',
    'Unable to calculate route. Please check the locations and try again.':
      "Impossible de calculer l'itinéraire. Veuillez vérifier les emplacements et réessayer.",
    'Error calculating transport price':
      'Erreur lors du calcul du prix du transport',
    'Booking canceled successfully': 'Réservation annulée avec succès',
    'Invalid request.': 'Demande invalide.',
    'Access denied.': 'Accès refusé.',
    'Resource not found.': 'Ressource introuvable.',
    'Request conflict.': 'Conflit de demande.',
    'Invalid data provided.': 'Données non valides fournies.',
    'Too many requests. Please try again later.':
      'Trop de demandes. Veuillez réessayer plus tard.',
    'Internal server error. Please try again later.':
      'Erreur interne du serveur. Veuillez réessayer plus tard.',
    'Service temporarily unavailable.': 'Service temporairement indisponible.',
    'booking.load_preset': 'Charger le préréglage',
    'booking.save_preset_tooltip':
      "Enregistrez les filtres actuels en tant que préréglage d'accès rapide",
    'booking.load_preset_tooltip':
      'Chargez votre préréglage de filtre enregistré',
    'booking.preset_saved': 'Préréglage enregistré',
    'booking.preset_saved_desc': 'Votre préréglage de filtre a été enregistré.',
    'booking.preset_loaded': 'Préréglage chargé',
    'booking.preset_load_error': 'Échec du chargement du préréglage',
    'booking.no_preset_saved': "Aucun préréglage n'a encore été enregistré",
    'booking.date_from': 'Date de',
    'booking.date_to': 'Date à',
    'Active filters': 'Filtres actifs',
    'All booking states': 'Tous les états de réservation',
    'All partners': 'Tous les partenaires',
    'All payments': 'Tous les paiements',
    'All roles': 'Tous les rôles',
    'All statuses': 'Tous les statuts',
    'All Users': 'Tous les utilisateurs',
    'Are you sure you want to cancel booking {{id}}?':
      'Etes-vous sûr de vouloir annuler la réservation {{id}} ?',
    'Attach the CMR Insurance before finishing truck setup.':
      'Joignez la facture CMR avant de terminer l’installation du camion.',
    Awaiting: 'En attente',
    'Awaiting payout': 'En attente de paiement',
    'Booking canceled': 'Réservation annulée',
    'Booking marked as paid': 'Réservation marquée comme payée',
    'Booking released and returned to marketplace':
      'Réservation libérée et renvoyée sur le marché',
    'booking.allowed_range': 'Plage autorisée',
    'booking.assign_transport': 'Attribuer un transport',
    'booking.back': 'Retour',
    'booking.back_to_summary': 'Retour au résumé',
    'booking.booking_created_but_pickup_document_not_uploaded_upload_from_order_details':
      "La réservation a été créée, mais le document de retrait n'a pas été téléchargé. Vous pouvez le télécharger à partir des détails de la commande.",
    'booking.city_not_found': 'Ville introuvable',
    'booking.city_or_town': 'Ville ou village',
    'booking.clear_radius': 'Rayon clair',
    'booking.continue': 'Continuer',
    'booking.country_optional': 'Pays (facultatif)',
    'booking.delivery_constraint_info':
      'La date de livraison doit être à la date de ramassage ou après.',
    'booking.delivery_date_cannot_be_earlier_than_pickup_date':
      'La date de livraison ne peut pas être antérieure à la date de ramassage',
    'booking.driver': 'Chauffeur',
    'booking.failed_to_open_letter_of_attorney':
      "Impossible d'ouvrir la lettre d'avocat",
    'booking.go_to_order': 'Aller à la commande',
    'booking.i_accept_terms': "J'accepte les conditions",
    'booking.invalid_license_plate_or_vin_length':
      "Plaque d'immatriculation ou longueur de VIN invalide.",
    'booking.invalid_vin_format_i_o_q_not_allowed':
      'Format VIN invalide. Les caractères I, O et Q ne sont pas autorisés.',
    'booking.letter_of_attorney_file_is_empty':
      "Le dossier de la lettre d'avocat est vide",
    'booking.no_additional_details': 'Aucun détail supplémentaire',
    'booking.no_vehicle_info': 'Aucune information sur le véhicule',
    'booking.open_letter_of_attorney': "Lettre ouverte d'avocat",
    'booking.opening_letter_of_attorney': "Lettre d'ouverture du procureur...",
    'booking.order_accepted_successfully': 'Commande acceptée avec succès',
    'booking.order_cars_exceed_selected_truck_capacity':
      'Cette commande comprend des voitures {{orderCars}}, mais la capacité des camions sélectionnés est {{capacity}}.',
    'booking.pickup_constraint_info':
      'La date de ramassage est requise avant d’attribuer le transport.',
    'booking.pickup_document_upload_failed':
      'Échec du téléchargement du document de ramassage',
    'booking.preparing_secure_document_preview':
      "Préparation de l'aperçu sécurisé du document...",
    'booking.radius_km': 'Rayon (km)',
    'booking.radius_search': 'Recherche de rayon',
    'booking.route_and_details': 'Itinéraire et détails',
    'booking.schedule': 'Calendrier',
    'booking.searching': 'Recherche…',
    'booking.select_pickup_and_delivery':
      'Sélectionnez le ramassage et la livraison',
    'booking.select_pickup_and_delivery_dates_before_confirming':
      'Sélectionnez les dates de ramassage et de livraison avant de confirmer',
    'booking.select_pickup_date': 'Sélectionnez la date de ramassage',
    'booking.select_truck_driver_and_trailer':
      'Sélectionnez le camion, le chauffeur et la remorque',
    'booking.supported_formats_jpg_png_pdf_doc_docx':
      'Formats pris en charge : JPG, PNG, PDF, DOC, DOCX',
    'booking.terms_and_conditions': 'Termes et conditions',
    'booking.terms_text':
      'Je confirme les conditions de transport et les conditions de responsabilité.',
    'booking.track_shipment': "Suivre l'expédition",
    'booking.trailer': 'Bande-annonce',
    'booking.transport_details': 'Détails du transport',
    'booking.truck': 'Camion',
    'booking.truck_driver_planning_saved_letter_of_attorney_available':
      "Les dates du camion, du chauffeur et de la planification ont été enregistrées. La lettre d'avocat est maintenant disponible.",
    'booking.unexpected_error': 'Erreur inattendue',
    'booking.vehicles_plural': 'Véhicules',
    'booking.view_details': 'Afficher les détails',
    'booking.vip_price_must_be_between_min_max_50_to_150_percent_of_estimated_price':
      'Le prix VIP doit être compris entre {{min}} EUR et {{max}} EUR (50 % à 150 % du prix estimé).',
    'booking.vip_price_must_be_positive_number':
      'Le prix VIP doit être un nombre positif.',
    'booking.within_radius_km_of_place':
      'À moins de km de {{radius}} de {{place}}',
    Capacity: 'Capacité',
    'Car Capacity': 'Capacité de la voiture',
    'Car capacity is required.': 'La capacité de la voiture est requise.',
    cars: 'voitures',
    Changed: 'Changé',
    'CMR Document': 'Document CMR',
    'CMR expiry': 'Expiration du CMR',
    'CMR Expiry': 'Expiration du CMR',
    'CMR expiry date is required': 'La date d’expiration du CMR est requise',
    'CMR Insurance': 'Assurance CMR',
    'CMR insurance expiry date': 'Date d’expiration de l’assurance CMR',
    'CMR Insurance Expiry Date': 'Date d’expiration de l’assurance CMR',
    'CMR insurance has expired. Upload a new CMR Insurance for review.':
      'Téléchargez une nouvelle facture CMR pour examen.',
    'CMR insurance is expiring within 14 days.':
      "L'assurance CMR expire dans les 14 jours.",
    'CMR Insurance required': 'Facture CMR obligatoire',
    Company: 'Entreprise',
    'Copy order ID': "Copier l'ID de la commande",
    Created: 'Créé',
    'Current expiry': 'Expiration actuelle',
    'Date range': 'Plage de dates',
    days: 'jours',
    Delay: 'Retard',
    'Delivered + partner invoice uploaded + unpaid':
      'Livré + facture partenaire téléchargée + impayé',
    Document: 'Documenter',
    'Documents uploaded': 'Documents téléchargés',
    Done: 'Terminé',
    'Download Client Invoice #{{id}}': 'Télécharger la facture client #{{id}}',
    'Download Invoice': 'Télécharger la facture',
    'Enter a valid capacity between 1 and 20 cars.':
      'Entrez une capacité valide comprise entre 1 et 20 voitures.',
    'Enter license plate': "Entrez la plaque d'immatriculation",
    'Enter plate and upload CMR to add truck':
      'Entrez la plaque et téléchargez le CMR pour ajouter un camion',
    'Error fetching users': 'Erreur lors de la récupération des utilisateurs',
    'Expire Soon (14 days)': 'Expire bientôt (14 jours)',
    'Explain why this CMR was rejected':
      'Expliquez pourquoi cette CMR a été rejetée',
    'Failed to copy order ID': "Échec de la copie de l'ID de commande",
    'Failed to download invoice': 'Échec du téléchargement de la facture',
    'Failed to download proforma invoice':
      'Échec du téléchargement de la facture pro forma',
    'Failed to generate invoice': 'Échec de la génération de la facture',
    'Failed to load invoice summary':
      'Échec du chargement du récapitulatif de la facture',
    'Failed to load letter of attorney':
      "Échec du chargement de la lettre d'avocat",
    'Failed to open letter of attorney':
      "Impossible d'ouvrir la lettre d'avocat",
    'Failed to release booking': 'Échec de la libération de la réservation',
    'Fleet data refreshed': 'Données de flotte actualisées',
    'Generate Client Invoice': 'Générer une facture client',
    'Generate Invoice': 'Générer une facture',
    'Generated at': 'Généré à',
    'How many cars can this truck carry?':
      'Combien de voitures ce camion peut-il transporter ?',
    'In progress': 'En cours',
    Invoice: 'Facture',
    'Invoice generated': 'Facture générée',
    'Invoice generated successfully': 'Facture générée avec succès',
    'Invoice uploaded': 'Facture téléchargée',
    'Invoices uploaded by partners for platform payout processing. Client invoices are generated in each order view.':
      'Les factures clients sont générées dans chaque vue de commande.',
    'Keep booking': 'Continuer à réserver',
    'Keep your active drivers and contact details up to date.':
      'Gardez vos conducteurs actifs et vos coordonnées à jour.',
    'Last Rejection': 'Dernier rejet',
    'Last rejection reason': 'Motif du dernier refus',
    'Letter of Attorney': "Lettre d'avocat",
    'Letter of attorney file is empty':
      "Le dossier de la lettre d'avocat est vide",
    'License plate cannot be changed after creation. Re-upload CMR Insurance instead.':
      'Téléchargez à nouveau la facture CMR à la place.',
    'License plate is required.': "La plaque d'immatriculation est requise.",
    'Manage large order volumes with search, payment actions, and invoice workflows.':
      "Gérez des volumes de commandes importants grâce aux workflows de recherche, d'actions de paiement et de facturation.",
    'Manage license plates and keep CMR Insurances approved and valid.':
      "Gérez les plaques d'immatriculation et gardez les factures CMR approuvées et valides.",
    'Manage status updates, documents, and payment steps from one place.':
      "Gérez les mises à jour de statut, les documents et les étapes de paiement à partir d'un seul endroit.",
    'Manage trailer plate records and keep availability current.':
      'Gérez les enregistrements de plaques de remorque et maintenez la disponibilité à jour.',
    'Mark booking {{id}} as paid?':
      'Marquer la réservation {{id}} comme payée ?',
    Missing: 'Manquant',
    'Needs attention': "A besoin d'attention",
    'New (14 days)': 'Nouveau (14 jours)',
    'No bookings found for the current filters.':
      'Aucune réservation trouvée pour les filtres actuels.',
    'No confirmed CMR document uploaded yet.':
      "Aucun document CMR confirmé n'a encore été téléchargé.",
    'No driver assigned': 'Aucun chauffeur assigné',
    'No letter of attorney has been generated yet.':
      "Aucune lettre de procuration n'a encore été générée.",
    'No matching delivered orders': 'Aucune commande livrée correspondante',
    'No new notifications': 'Aucune nouvelle notification',
    'No partners found.': 'Aucun partenaire trouvé.',
    'No trucks found for this filter.': 'Aucun camion trouvé pour ce filtre.',
    'No users found for current filters.':
      'Aucun utilisateur trouvé pour les filtres actuels.',
    'Not uploaded': 'Non téléchargé',
    Notifications: 'Notifications',
    of: 'de',
    'Only admins can set or update this expiry date after reviewing your CMR insurance.':
      "Seuls les administrateurs peuvent définir ou mettre à jour cette date d'expiration après avoir examiné votre assurance CMR.",
    'Open letter of attorney': "Lettre ouverte d'avocat",
    Order: 'Commande',
    'Order actions': 'Actions de commande',
    'Order ID copied': 'Numéro de commande copié',
    Owner: 'Propriétaire',
    Page: 'Pages',
    'Paid date': 'Date de paiement',
    'Partner delivery date': 'Date de livraison du partenaire',
    'Partner documents': 'Documents partenaires',
    'Partner Invoice': 'Facture du partenaire',
    'Partner invoice uploaded': 'Facture du partenaire téléchargée',
    'Partner Payout Invoices': 'Factures de paiement des partenaires',
    'Partner pickup date': 'Date de retrait du partenaire',
    'Partner score': 'Note du partenaire',
    Payment: 'Paiement',
    'Payout date': 'Date de paiement',
    'penalties applied': 'pénalités appliquées',
    'Pending admin review': "En attente d'examen par l'administrateur",
    'Pending review': "En attente d'examen",
    'Pending trucks': 'Camions en attente',
    'Please provide a clear reason for rejection.':
      'Veuillez fournir une raison claire de votre refus.',
    'Please select an order before uploading an invoice.':
      'Veuillez sélectionner une commande avant de télécharger une facture.',
    'Please try again.': 'Veuillez réessayer.',
    'Proforma Invoice': 'Facture pro forma',
    'Provide a rejection reason for this CMR review.':
      'Fournissez un motif de rejet pour cet examen CMR.',
    'Quarter Score': 'Score du trimestre',
    'Re-upload CMR': 'Ré-importer le CMR',
    Refresh: 'Actualiser',
    'Rejection reason': 'Motif du refus',
    'Rejection reason is required': 'Le motif du refus est requis',
    'Release booking {{id}} back to the marketplace so another partner can accept it?':
      "Remettre la réservation {{id}} sur le marché afin qu'un autre partenaire puisse l'accepter ?",
    Reset: 'Réinitialiser',
    'Review Bookings': 'Examiner les réservations',
    Revision: 'Révision',
    Rows: 'Lignes',
    'Search by invoice number, file name, or booking ID':
      'Rechercher par numéro de facture, nom de fichier ou identifiant de réservation',
    'Search by name, email, company': 'Recherche par nom, email, entreprise',
    'Search by name, email, company, uid':
      'Recherche par nom, email, entreprise, uid',
    'Search client': 'Rechercher un client',
    'Search delivered order': 'Rechercher une commande livrée',
    'Search license plate or owner':
      "Rechercher une plaque d'immatriculation ou un propriétaire",
    'Search order ID': 'Rechercher un numéro de commande',
    'Search partner': 'Partenaire de recherche',
    'Select a new CMR Insurance to re-upload for this truck.':
      'Sélectionnez une nouvelle facture CMR à télécharger à nouveau pour ce camion.',
    'Select paid date': 'Sélectionnez la date de paiement',
    'Set CMR insurance expiry date to approve this truck.':
      'Fixez la date d’expiration de l’assurance CMR pour approuver ce camion.',
    'Set maximum number of cars this truck can carry (1-20).':
      'Définissez le nombre maximum de voitures que ce camion peut transporter (1-20).',
    'Set the CMR insurance expiry date before approval.':
      'Fixez la date d’expiration de l’assurance CMR avant l’approbation.',
    Showing: 'Affichage',
    'Showing page {{page}} of {{pages}} • {{total}} invoices':
      'Affichage de la page {{page}} de {{pages}} • Factures {{total}}',
    'Status will be updated to Picked Up after successful upload. You can add multiple car photos before uploading.':
      'Vous pouvez ajouter plusieurs photos de voitures avant de les télécharger.',
    Terms: 'Conditions',
    Total: 'Total',
    'Track paid and unpaid invoices, expected payout dates, and upload new invoices quickly.':
      'Suivez les factures payées et impayées, les dates de paiement prévues et téléchargez rapidement de nouvelles factures.',
    'Truck approved successfully': 'Camion homologué avec succès',
    'Truck documents': 'Documents du camion',
    'Truck license plate': "Plaque d'immatriculation de camion",
    'Truck rejected successfully': 'Camion rejeté avec succès',
    'truck(s) are pending admin CMR expiry date.':
      'les camions sont en attente de la date d’expiration administrative du CMR.',
    'truck(s) have expired CMR insurance and are disabled.':
      'le ou les camions ont expiré leur assurance CMR et sont en panne.',
    'truck(s) will expire within 14 days.':
      'les camions expireront dans les 14 jours.',
    'Unable to prepare the record for upload.':
      "Impossible de préparer l'enregistrement pour le téléchargement.",
    Unpaid: 'Impayé',
    'Upload a CMR Insurance before closing this truck setup.':
      'Téléchargez une facture CMR avant de fermer cette configuration de camion.',
    'Upload a valid CMR insurance. Each upload sends the truck back to pending review.':
      "Chaque téléchargement renvoie le camion en attente d'examen.",
    'Upload documents': 'Télécharger des documents',
    'Upload Invoice': 'Télécharger la facture',
    'Upload order documents': 'Télécharger les documents de commande',
    'Upload unavailable': 'Téléchargement indisponible',
    Uploaded: 'Téléchargé',
    'Uploaded • Paid': 'Téléchargé • Payé',
    'Uploaded • Partially paid': 'Téléversé • Partiellement payé',
    'Uploaded by partner for platform payout processing.':
      'Téléchargé par le partenaire pour le traitement des paiements sur la plateforme.',
    User: 'Utilisateur',
    'Verification code': 'Code de vérification',
    'View details': 'Afficher les détails',
    'View Partners': 'Voir les partenaires',
    'Working hours not provided': 'Horaires de travail non fournis',
    '{{value}} orders': 'Commandes {{value}}',
    Invoiced: 'Facturé',
    'Loading admin data...': "Chargement des données d'administration...",
    'Pending partners': 'Partenaires en attente',
    'Unpaid bookings': 'Réservations impayées',
    'Total users': "Nombre total d'utilisateurs",
    'Orders per period': 'Commandes par période',
    'Orders by status': 'Commandes par statut',
    'Quick actions': 'Actions rapides',
    'Verify new partners': 'Vérifier les nouveaux partenaires',
    'Review partner applications and approve or reject requests.':
      'Examinez les candidatures des partenaires et approuvez ou rejetez les demandes.',
    'Manage all trucks': 'Gérer tous les camions',
    'Review, approve, reject, disable, and filter all trucks.':
      'Examinez, approuvez, rejetez, désactivez et filtrez tous les camions.',
    'Review bookings': 'Examiner les réservations',
    'Review all transport orders, payment states, and generated invoices.':
      'Examinez tous les ordres de transport, les états de paiement et les factures générées.',
    'Manage all users': 'Gérer tous les utilisateurs',
    'Manage user status, roles, and validation records.':
      'Gérez le statut des utilisateurs, les rôles et les enregistrements de validation.',
    'User breakdown': 'Répartition des utilisateurs',
    Clients: 'Clientèle',
    Partners: 'Partenaires',
    Admins: 'Administrateurs',
    'Top 5 pending partners': 'Top 5 des partenaires en attente',
    'No pending partners right now.':
      'Aucun partenaire en attente pour le moment.',
    pending: 'en attente',
    'Top 5 pending trucks': 'Top 5 des camions en attente',
    'No pending trucks right now.': 'Aucun camion en attente pour le moment.',
    'Unknown owner': 'Propriétaire inconnu',
    'KPI cards and top lists link directly to filtered admin screens.':
      "Les cartes KPI et les meilleures listes sont directement liées aux écrans d'administration filtrés.",
    'booking.available_orders_title': 'Commandes disponibles',
    'booking.available_orders_description':
      'Examinez les opportunités de transport entrant et appliquez des filtres en fonction de votre capacité.',
    'booking.vehicle_pickup_location': 'Lieu de prise en charge du véhicule',
    'booking.pickup_opening_hours': "Horaires d'ouverture du ramassage",
    'booking.vehicle_delivery_location': 'Lieu de livraison du véhicule',
    'booking.delivery_opening_hours': "Horaires d'ouverture de livraison",
    'booking.pickup_contact': 'Contact de ramassage',
    'booking.delivery_contact': 'Contact livraison',
    'booking.vehicles_scheduled': 'Véhicules programmés',
    'booking.watchlist_title': 'Liste de surveillance',
    'booking.watchlist_description':
      'Suivez les opportunités enregistrées et agissez rapidement lorsque la disponibilité change.',
    'Loading dashboard...': 'Chargement du tableau de bord...',
    'Total bookings': 'Réservations totales',
    'Open bookings': 'Réservations ouvertes',
    'Order status timeline': "Chronologie de l'état de la commande",
    'Last 6 months of bookings grouped by current status.':
      '6 derniers mois de réservations regroupées par statut actuel.',
    'Create new order': 'Créer une nouvelle commande',
    'Create a new transport booking request.':
      'Créez une nouvelle demande de réservation de transport.',
    'View my orders': 'Consulter mes commandes',
    'Review status and details of your bookings.':
      'Consultez le statut et les détails de vos réservations.',
    'Open profile': 'Ouvrir le profil',
    'Update company and contact details.':
      'Mettre à jour l’entreprise et les coordonnées.',
    'Recent bookings': 'Réservations récentes',
    'No bookings yet.': "Aucune réservation pour l'instant.",
    'Unknown destination': 'Destination inconnue',
    'Quarter score': 'Score du quart',
    '{{value}} completed': '{{value}} terminé',
    'Truck CMR warning': 'Avertissement CMR pour camion',
    'One truck has CMR expiry risk. Review it in Fleet.':
      'Un camion présente un risque d’expiration du CMR. Examinez-le dans Fleet.',
    '{{count}} trucks have CMR expiry risk. Review them in Fleet.':
      'Les camions {{count}} présentent un risque d’expiration CMR. Passez-les en revue dans Fleet.',
    'Active queue': "File d'attente active",
    'Delivered bookings': 'Réservations livrées',
    'Cars delivered': 'Voitures livrées',
    'Canceled bookings': 'Réservations annulées',
    'Avg assign-to-pickup': "Moyenne d'attribution au ramassage",
    'Quarter Partner Score': 'Score du partenaire du trimestre',
    'Payment delay: +{{days}} days': 'Délai de paiement : +{{days}} jours',
    'Penalty events': 'Événements de pénalité',
    Current: 'Actuel',
    'Completed orders per period': 'Commandes terminées par période',
    'Completed orders': 'Commandes terminées',
    'Truck CMR status alerts': 'Alertes d’état CMR des camions',
    '{{count}} truck(s) have expired CMR insurance.':
      'Les camions {{count}} ont expiré leur assurance CMR.',
    '{{count}} truck(s) will expire within 14 days.':
      'Les camions {{count}} expireront dans les 14 jours.',
    '{{count}} truck(s) are missing CMR expiry date.':
      'Les camions {{count}} n’ont pas la date d’expiration du CMR.',
    'Upload a new CMR Insurance in Fleet. The truck will stay pending until admin review.':
      "Téléchargez une nouvelle facture CMR dans Fleet. Le camion restera en attente jusqu'à l'examen de l'administrateur.",
    'Open fleet to resolve CMR alerts':
      'Flotte ouverte pour résoudre les alertes CMR',
    'Operational actions': 'Actions opérationnelles',
    'Open marketplace orders': 'Ordres de marché ouverts',
    'Review available orders and plan assignments.':
      'Examinez les commandes disponibles et planifiez les affectations.',
    'My accepted orders': 'Mes commandes acceptées',
    'Manage delivery progress and documents.':
      'Gérer l’avancement de la livraison et les documents.',
    'Update trucks, trailers, and availability.':
      'Mettez à jour les camions, les remorques et la disponibilité.',
    'Partner invoices': 'Factures partenaires',
    'Upload and track invoice payments.':
      'Téléchargez et suivez les paiements des factures.',
    'No active orders in queue.': "Aucune commande active en file d'attente.",
    'profile.incompleteTitle': 'Profil incomplet',
    'profile.incompleteDescription':
      'Veuillez compléter les informations de votre profil (Entreprise, Téléphone, Adresse, Ville, Code Postal) pour accéder à toutes les fonctionnalités.',
    'profile.goToProfile': 'Aller au profil',
    'auth.email_placeholder': 'nom@entreprise.com',
    'auth.authentication_mode_switch': "Changement de mode d'authentification",
    'auth.invalid_email': 'E-mail invalide',
    'auth.please_enter_a_valid_email_address':
      'Veuillez saisir une adresse e-mail valide.',
    'auth.email_not_found': 'E-mail introuvable',
    'auth.no_account_found_with_that_email_address':
      'Aucun compte trouvé avec cette adresse e-mail.',
    'auth.email_sent': 'E-mail envoyé !',
    'auth.something_went_wrong_try_again':
      "Quelque chose s'est mal passé. Essayer à nouveau.",
    'auth.we_sent_a_password_reset_link_open_your_inbox_and_follow_the_instructions':
      'Nous avons envoyé un lien de réinitialisation du mot de passe. Ouvrez votre boîte de réception et suivez les instructions.',
    'auth.forgot_your_password': 'Vous avez oublié votre mot de passe ?',
    'auth.enter_your_account_email_and_we_will_send_you_a_password_reset_link':
      "Entrez l'e-mail de votre compte et nous vous enverrons un lien de réinitialisation de mot de passe.",
    'auth.email_address': 'Adresse e-mail',
    'auth.send_reset_link': 'Envoyer le lien de réinitialisation',
    'auth.cancel': 'Annuler',
    'auth.tip_if_you_do_not_receive_the_email_check_spam_and_promotions_folders':
      "Astuce : si vous ne recevez pas l'e-mail, vérifiez les dossiers spam et promotions.",
    'booking.e_g_berlin': 'par ex. Berlin',
    'booking.e_g_germany': 'par ex. Allemagne',
    'booking.watchlist': 'Liste de surveillance',
    'booking.view_map': 'Voir la carte',
    'booking.invalid_input': 'Entrée invalide',
    'booking.please_enter_only_numbers_for_the_zip_code':
      'Veuillez saisir uniquement des chiffres pour le code postal.',
    'booking.pickup_zip_code': 'Code postal de ramassage',
    'booking.delivery_zip_code': 'Code postal de livraison',
    'booking.select_vehicle_make': 'Sélectionnez la marque du véhicule',
    'booking.unnamed_item': 'Élément sans nom',
    'booking.cars': 'voitures',
    'booking.more_info': "Plus d'informations",
    'booking.loading': 'Chargement...',
    'booking.no_items_found': 'Aucun article trouvé',
    'booking.selected_cars': 'Voitures sélectionnées',
    'booking.unknown_type': 'Type inconnu',
    'booking.delete_car': 'Supprimer la voiture',
    'Toggle details': 'Basculer les détails',
    'auth.a_verification_email_has_been_sent_to_your_email_address_please_verify_your_emai':
      'Un e-mail de vérification a été envoyé à votre adresse e-mail. Veuillez vérifier votre adresse e-mail avant de vous connecter.',
    'auth.an_unexpected_error_occurred_please_try_again':
      "Une erreur inattendue s'est produite. Veuillez réessayer.",
    'auth.client': 'Client',
    'auth.email': 'Courriel',
    'auth.failed_to_resend_email': "Échec du renvoi de l'e-mail",
    'auth.show_password': 'Afficher le mot de passe',
    'auth.hide_password': 'Masquer le mot de passe',
    'auth.incorrect_password_please_try_again':
      'Mot de passe incorrect. Veuillez réessayer.',
    'auth.invalid_email_or_password_please_check_your_credentials_and_try_again':
      "Email ou mot de passe invalide. Veuillez vérifier vos informations d'identification et réessayer.",
    'auth.network_error_check_your_connection_and_try_again':
      'Erreur réseau. Vérifiez votre connexion et réessayez.',
    'auth.no_account_found_with_this_email':
      'Aucun compte trouvé avec cet email.',
    'auth.please_check_your_inbox':
      'Veuillez vérifier votre boîte de réception.',
    'auth.please_make_sure_both_passwords_are_the_same':
      'Veuillez vous assurer que les deux mots de passe sont identiques.',
    'auth.please_sign_in_to_resend_the_verification_email':
      "Veuillez vous connecter pour renvoyer l'e-mail de vérification.",
    'auth.resend_verification_email': "Renvoyer l'e-mail de vérification",
    'auth.awaiting_verification_artwork':
      "En attente de l'illustration de vérification",
    'auth.email_verification_required': "Vérification de l'e-mail requise",
    'auth.waiting_for_email_verification':
      'En attente de vérification par e-mail',
    'auth.check_your_email': 'Vérifiez votre courrier électronique',
    'auth.we_sent_your_verification_link_to':
      'Nous avons envoyé votre lien de vérification à',
    'auth.didnt_receive_it_check_spam_or_try_again':
      "Vous ne l'avez pas reçu ? Vérifiez votre dossier spam ou réessayez.",
    'auth.resend_email': "Renvoyer l'e-mail",
    'auth.i_verified_my_email': "J'ai vérifié mon email",
    'auth.redirecting_you_now': 'Je vous redirige maintenant.',
    'auth.email_not_verified_yet': 'E-mail pas encore vérifié',
    'auth.please_click_the_link_in_your_inbox_and_try_again':
      'Veuillez cliquer sur le lien dans votre boîte de réception et réessayer.',
    'auth.unable_to_resend_verification_email_right_now':
      "Impossible de renvoyer l'e-mail de vérification pour le moment.",
    'auth.unable_to_check_verification_status_right_now':
      "Impossible de vérifier l'état de vérification pour le moment.",
    'auth.we_sent_a_new_verification_link':
      'Nous avons envoyé un nouveau lien de vérification à votre adresse e-mail.',
    'auth.we_automatically_check_every_30_seconds':
      'Nous vérifions automatiquement votre statut de vérification toutes les 30 secondes. Vous pouvez également déclencher une vérification instantanée après avoir vérifié votre e-mail.',
    'auth.we_automatically_check_every_15_seconds':
      'Nous vérifions automatiquement votre statut de vérification toutes les 15 secondes. Vous pouvez également déclencher une vérification instantanée après avoir vérifié votre e-mail.',
    'auth.the_email_address_is_not_valid': "L'adresse email n'est pas valide.",
    'auth.this_account_has_been_disabled': 'Ce compte a été désactivé.',
    'auth.too_many_failed_attempts_please_try_again_later_or_reset_your_password':
      'Trop de tentatives infructueuses. Veuillez réessayer plus tard ou réinitialiser votre mot de passe.',
    'auth.verification_email_resent': 'E-mail de vérification renvoyé !',
    'auth.you_need_to_log_in_first': "Vous devez d'abord vous connecter",
    'booking.dimensions_cm': 'Dimensions (cm)',
    'booking.distance': 'Distance',
    'booking.email': 'Courriel',
    'booking.error_fetching_data': 'Erreur lors de la récupération des données',
    'booking.inputs_changed_recalculate_the_price':
      'Les entrées ont changé. Recalculez le prix.',
    'booking.kg': 'kilos',
    'booking.km': 'kilomètres',
    'booking.mi': 'mi',
    'booking.no_opening_hours_provided': "Aucune heure d'ouverture fournie",
    'booking.no_vehicles_listed': 'Aucun véhicule répertorié',
    'booking.not_available': 'Non disponible',
    'booking.not_set': 'Non défini',
    'booking.please_select_a_planned_date':
      'Veuillez sélectionner une date prévue',
    'booking.point': 'Point',
    'booking.required': 'Obligatoire',
    'booking.to': 'à',
    'booking.total': 'total',
    'booking.vin_chassis': 'NIV / Châssis',
    'booking.order': 'Commande',
    'booking.duration': 'Durée',
    'booking.vehicles_overview': 'Aperçu des véhicules',
    'booking.body': 'Corps',
    'booking.dims': 'Atténue',
    'booking.select_vehicle_model': 'Sélectionnez le modèle de véhicule',
    'booking.selected_type_value': 'Sélectionné : 0{{value}}',
    'booking.select_a_vehicle_type': 'Sélectionnez un type de véhicule :',
    'booking.select_vehicle_weight': 'Sélectionnez le poids du véhicule',
    'booking.adjust_weight': 'Ajuster le poids',
    'Dates updated successfully': 'Dates mises à jour avec succès',
    'Error updating dates': 'Erreur lors de la mise à jour des dates',
    'Set Planned Dates': 'Définir les dates prévues',
    'Set your planned pickup and arrival dates below.':
      'Définissez ci-dessous vos dates de prise en charge et d’arrivée prévues.',
    'Changing dates after initial setup will deduct 20% from your performance score for this order.':
      'La modification des dates après la configuration initiale déduira 20 % de votre score de performance pour cette commande.',
    'Planned Pickup Date': 'Date de ramassage prévue',
    'Planned Arrival Date': "Date d'arrivée prévue",
    Listing: 'Annonce',
    'Try broadening the current search or status filter.':
      "Essayez d'élargir la recherche actuelle ou le filtre d'état.",
    'Try broadening the search, role, or status filters.':
      "Essayez d'élargir les filtres de recherche, de rôle ou de statut.",
    'Monitor fleet compliance, validation status, and expiring insurance in one place.':
      'Surveillez la conformité de la flotte, le statut de validation et l’expiration de l’assurance en un seul endroit.',
    'Active Listings': 'Annonces actives',
    'Open transport requests': 'Demandes de transport ouvertes',
    'Quotes Today': "Citations aujourd'hui",
    'Submitted in last 24h': 'Soumis au cours des dernières 24 heures',
    'Platform Revenue (MTD)': 'Revenus de la plateforme (MTD)',
    'Month to date': 'Mois à ce jour',
    'Pending Partners': 'Partenaires en attente',
    'Awaiting approval': "En attente d'approbation",
    'Unpaid Invoices': 'Factures impayées',
    'Requires action': 'Nécessite une action',
    'Completed Transports': 'Transports terminés',
    'All time delivered': 'Tout le temps livré',
    'Admin Dashboard': "Tableau de bord d'administration",
    'Platform overview and key performance indicators.':
      'Aperçu de la plateforme et indicateurs de performance clés.',
    'Loading dashboard metrics...':
      'Chargement des métriques du tableau de bord...',
    Invoices: 'Factures',
    'Review payout invoices uploaded by partners and keep payout processing organized.':
      'Examinez les factures de paiement téléchargées par les partenaires et organisez le traitement des paiements.',
    Flexible: 'Flexible',
    'Flexible dates': 'Dates flexibles',
    'Could not load this listing.': 'Impossible de charger cette liste.',
    'Listing canceled': 'Annonce annulée',
    'Failed to cancel listing': "Échec de l'annulation de l'annonce",
    Reference: 'Référence',
    Category: 'Catégorie',
    'Client type': 'Type de client',
    'Company country': "Pays de l'entreprise",
    Expires: 'Expire',
    'Back to listings': 'Retour aux annonces',
    'Listing not found.': 'Annonce introuvable.',
    'Cancel Listing': "Annuler l'annonce",
    'Listing details': "Détails de l'annonce",
    'Read-only listing overview for admins.':
      'Aperçu de la liste en lecture seule pour les administrateurs.',
    'Pick-up': 'Ramassage',
    'No exact coordinates are stored for this listing yet.':
      "Aucune coordonnée exacte n'est encore stockée pour cette annonce.",
    'Structured overview of quantities and handling details.':
      'Aperçu structuré des quantités et des détails de manutention.',
    'Shipment images': "Images d'expédition",
    'No shipment images were uploaded for this listing.':
      "Aucune image d'expédition n'a été téléchargée pour cette annonce.",
    'Proof of pickup': 'Preuve de ramassage',
    'Final documents': 'Documents finaux',
    Description: 'Descriptif',
    'Loading quotes...': 'Chargement des devis...',
    'No quotes for this listing.': 'Aucune citation pour cette annonce.',
    'Cancel Listing?': "Annuler l'annonce ?",
    'This will permanently cancel the listing and notify the client. Continue?':
      "Cela annulera définitivement l'annonce et en informera le client. Continuer?",
    Keep: 'Garder',
    'Review partner applications, check their documents, and keep approval decisions consistent.':
      'Examinez les candidatures des partenaires, vérifiez leurs documents et assurez la cohérence des décisions d’approbation.',
    'No client payments recorded yet':
      'Aucun paiement client enregistré pour le moment',
    'Client payment rows will appear here when the payments backend is connected.':
      'Les lignes de paiement client apparaîtront ici lorsque le backend de paiement sera connecté.',
    Method: 'Méthode',
    'No partner payouts recorded yet':
      "Aucun paiement de partenaire enregistré pour l'instant",
    'Payout rows will appear here once partner payout processing is enabled.':
      'Les lignes de paiement apparaîtront ici une fois que le traitement des paiements des partenaires sera activé.',
    'Payout Amount': 'Montant du paiement',
    'No platform fees recorded yet':
      "Aucun frais de plateforme enregistré pour l'instant",
    'Fee rows will appear here once payment settlement data is available.':
      'Les lignes de frais apparaîtront ici une fois que les données de règlement des paiements seront disponibles.',
    Gross: 'Brut',
    'Fee (20%)': 'Frais (20%)',
    Payments: 'Paiements',
    'Client payments, partner payouts, and platform fee tracking.':
      'Paiements des clients, paiements des partenaires et suivi des frais de plateforme.',
    'Client Payments': 'Paiements clients',
    'Partner Payouts': 'Paiements des partenaires',
    'Platform Fees': 'Frais de plateforme',
    'Failed to load reviews': 'Échec du chargement des avis',
    'Review removed': 'Avis supprimé',
    'Failed to remove review': "Échec de la suppression de l'avis",
    Reviews: 'Avis',
    'All partner and transport reviews submitted by clients.':
      'Tous les avis de partenaires et de transports soumis par les clients.',
    'Loading reviews...': 'Chargement des avis...',
    'No reviews found': 'Aucun avis trouvé',
    'Client feedback will appear here when reviews are submitted.':
      'Les commentaires des clients apparaîtront ici lorsque les avis seront soumis.',
    Stars: 'Étoiles',
    Comment: 'Commentaire',
    'Search, review, and maintain user accounts with one consistent admin workflow.':
      "Recherchez, examinez et gérez les comptes d'utilisateurs avec un flux de travail d'administration cohérent.",
    'Track paid and unpaid partner payout invoices, and upload the next delivered listing invoice quickly.':
      "Suivez les factures de paiement des partenaires payées et impayées et téléchargez rapidement la prochaine facture d'annonce livrée.",
    'Search by invoice number, file name, or listing ID':
      "Rechercher par numéro de facture, nom de fichier ou identifiant d'annonce",
    'Loading delivered listings...': 'Chargement des annonces livrées...',
    'Search delivered listing by reference, title, or route':
      'Rechercher une annonce livrée par référence, titre ou itinéraire',
    'Route details available in listing':
      "Détails de l'itinéraire disponibles dans la liste",
    'No matching delivered listings': 'Aucune annonce livrée correspondante',
    'Selected listing': 'Annonce sélectionnée',
    'Has quotes': 'A des citations',
    'In transit': 'En transit',
    Open: 'Ouvert',
    Accepted: 'Accepté',
    Completed: 'Terminé',
    'Client Dashboard': 'Tableau de bord client',
    'Overview of your current transport listings, quote activity, and recent requests.':
      'Aperçu de vos annonces de transport actuelles, de votre activité de devis et de vos demandes récentes.',
    'Total listings': 'Total des annonces',
    'Active listings': 'Annonces actives',
    'Listings with quotes': 'Annonces avec citations',
    'Accepted transport': 'Transport accepté',
    'Listing status timeline': "Chronologie de l'état de l'annonce",
    'Last 6 months of listings grouped by current status.':
      "6 derniers mois d'annonces regroupées par statut actuel.",
    'No listing activity yet': "Aucune activité d'annonce pour l'instant",
    'Create your first listing to start tracking request activity here.':
      "Créez votre première annonce pour commencer à suivre l'activité des demandes ici.",
    'Create new listing': 'Créer une nouvelle annonce',
    'Create a new transport request for the marketplace.':
      'Créez une nouvelle demande de transport pour la place de marché.',
    'View my listings': 'Voir mes annonces',
    'Review quote activity and manage your transport requests.':
      'Consultez l’activité des devis et gérez vos demandes de transport.',
    'Recent listings': 'Annonces récentes',
    'No listings yet': "Aucune annonce pour l'instant",
    'Your newest transport requests will appear here once you create them.':
      'Vos demandes de transport les plus récentes apparaîtront ici une fois que vous les aurez créées.',
    'Unknown origin': 'Origine inconnue',
    '{{value}} completed listings': '0{{value}} annonces complétées',
    'Monitor current performance, fleet readiness, quote flow, and your active transport queue.':
      'Surveillez les performances actuelles, l’état de préparation de la flotte, le flux des devis et votre file d’attente de transport active.',
    'Total assigned': 'Total attribué',
    'Quarter rating': 'Note trimestrielle',
    'Based on current quarter performance':
      'Basé sur la performance du trimestre en cours',
    Rating: 'Note',
    'Requirement met': 'Exigence satisfaite',
    'Requirement not met': 'Exigence non satisfaite',
    'Completed listings per period': 'Annonces complétées par période',
    'No completion data yet': "Aucune donnée d'achèvement pour l'instant",
    'Statistics will appear here after your first delivered work.':
      'Les statistiques apparaîtront ici après votre premier travail livré.',
    'Completed listings': 'Annonces terminées',
    'Review truck documents and refresh anything close to expiry.':
      "Examinez les documents du camion et actualisez tout ce qui est proche de la date d'expiration.",
    'Search deliveries': 'Rechercher des livraisons',
    'Review available marketplace listings and submit quotes.':
      'Consultez les listes de marchés disponibles et soumettez des devis.',
    'My quotes': 'Mes citations',
    'Track accepted, pending, and rejected quotes in one place.':
      'Suivez les devis acceptés, en attente et rejetés en un seul endroit.',
    'Profile settings': 'Paramètres du profil',
    'Keep company information and compliance details up to date.':
      'Gardez les informations sur l’entreprise et les détails de conformité à jour.',
    'No active queue items': "Aucun élément de file d'attente actif",
    'Accepted and in-progress work will appear here as your transport activity grows.':
      'Les travaux acceptés et en cours apparaîtront ici au fur et à mesure que votre activité de transport se développera.',
    'Your role does not have permission to open this page.':
      "Votre rôle n'est pas autorisé à ouvrir cette page.",
    'Go to dashboard': 'Aller au tableau de bord',
    'Trailer capacity is required.': 'La capacité de la remorque est requise.',
    'How many cars can this trailer carry?':
      'Combien de voitures cette remorque peut-elle transporter ?',
    'Set maximum number of cars this trailer can carry (1-20).':
      'Définissez le nombre maximum de voitures que cette remorque peut transporter (1-20).',
    'Invalid max load (kg).': 'Charge maximale invalide (kg).',
    'Enter a valid weight between 1 and 100000 kg, or leave it empty.':
      'Saisissez un poids valide compris entre 1 et 100 000 kg, ou laissez-le vide.',
    'Maximum payload weight this truck can carry (optional).':
      'Charge utile maximale que ce camion peut transporter (en option).',
    'Manage the company and contact details that appear across your listings, invoices, and account verification flows.':
      "Gérez l'entreprise et les coordonnées qui apparaissent dans vos listes, factures et flux de vérification de compte.",
    'Keep these details up to date so listings, invoices, and partner verification stay accurate.':
      'Gardez ces informations à jour afin que les annonces, les factures et la vérification des partenaires restent exactes.',
    'Unsaved changes': 'Modifications non enregistrées',
    'All changes saved': 'Toutes les modifications enregistrées',
    'auth.sign_up_failed': "Échec de l'inscription",
    'auth.please_select_a_valid_role': 'Veuillez sélectionner un rôle valide.',
    'booking.pickup_not_found': 'Ramassage introuvable.',
    'booking.delivery_not_found': 'Livraison introuvable.',
    'booking.capacity': 'Capacité',
    'booking.cmr_expiry': 'Expiration du CMR',
    'booking.uploaded': 'Téléchargé',
    'booking.missing': 'Manquant',
    'booking.cmr_document': 'Document CMR',
    'booking.go_to_profile': 'Aller au profil',
    'booking.click_to_download_purchase_terms':
      "Cliquez pour télécharger les conditions d'achat",
    'admin.purchase_terms_management': "Gestion des conditions d'achat",
    'admin.purchase_terms_management_subtitle':
      "Téléchargez et conservez les PDF des conditions d'achat localisés utilisés dans l'acceptation des commandes des partenaires.",
    'admin.document_language': 'Langue du document',
    'admin.click_to_download_purchase_terms':
      "Cliquez pour télécharger les conditions d'achat",
    'admin.current_language_label': 'Langue actuelle : 0{{language}}',
    'admin.purchase_terms_unavailable_for_selected_language':
      'Le document des conditions d’achat n’est pas disponible pour la langue sélectionnée.',
    'Download and review the active purchase terms in your current interface language before continuing.':
      "Téléchargez et consultez les conditions d'achat actives dans la langue de votre interface actuelle avant de continuer.",
    'We make agreements and conclude a contract for the carriage of goods. I have just read this agreement in full and agree to its contents.':
      "Nous concluons des accords et concluons un contrat pour le transport de marchandises. Je viens de lire cet accord dans son intégralité et j'accepte son contenu.",
    'I confirm that I will schedule this order within 24 hours':
      'Je confirme que je planifierai cette commande dans les 24 heures',
    'Failed to load purchase terms document.':
      "Échec du chargement du document des conditions d'achat.",
    'Partner rating': 'Évaluation des partenaires',
    'Bronze requirements': 'Exigences de bronze',
    'Orders in quarter': 'Commandes au trimestre',
    'Cancellation rate / 100 orders': "Taux d'annulation / 100 commandes",
    'Damage claims / 100 orders': 'Réclamations pour dommages / 100 commandes',
    Met: 'Rencontré',
    'Not met': 'Non atteint',
    Unranked: 'Non classé',
    'profile.incompleteDescriptionPartner':
      'Veuillez compléter les informations de votre profil (Entreprise, Téléphone, Adresse, Ville, Code postal, Numéro de TVA) pour accéder à toutes les fonctionnalités.',
    'profile.incompleteDescriptionClient':
      'Veuillez compléter les informations de votre profil (numéro de téléphone) pour accéder à toutes les fonctionnalités.',
    'auth.verification_email_sent': 'E-mail de vérification envoyé',
    '{{amount}} above the client target':
      "{{amount}} au dessus de l'objectif client",
    '{{count}} reviews': '{{count}} avis',
    '{{count}} visible': '0{{count}} visible',
    'A Google route preview with pins A and B appears here once pickup and delivery coordinates are available.':
      "Un aperçu de l'itinéraire Google avec les épingles A et B apparaît ici une fois que les coordonnées de ramassage et de livraison sont disponibles.",
    'A route preview appears once map coordinates are available.':
      "Un aperçu de l'itinéraire apparaît une fois que les coordonnées de la carte sont disponibles.",
    'A timeline of clarifications connected to this listing.':
      'Une chronologie des clarifications liées à ce listing.',
    'Accept Listing': "Accepter l'annonce",
    'Accept quote': 'Accepter le devis',
    'Accepted quote': 'Devis accepté',
    'Accepted quote required': 'Devis accepté requis',
    'Accepting...': 'Accepter...',
    Active: 'Actif',
    'Active statuses': 'Statuts actifs',
    'Add another item': 'Ajouter un autre élément',
    'Add images': 'Ajouter des images',
    'Add more shipment images': "Ajouter plus d'images d'expédition",
    'After you confirm an AI action, open the prepared destination immediately instead of waiting for a manual click.':
      "Après avoir confirmé une action AI, ouvrez immédiatement la destination préparée au lieu d'attendre un clic manuel.",
    'AI Assistant': 'Assistant IA',
    'AI assistant disabled for all users.':
      'Assistant IA désactivé pour tous les utilisateurs.',
    'AI assistant enabled for all users.':
      'Assistant AI activé pour tous les utilisateurs.',
    'AI assistant preferences updated':
      "Préférences de l'assistant IA mises à jour",
    'AI disabled for user.': "IA désactivée pour l'utilisateur.",
    'AI enabled for user.': "IA activée pour l'utilisateur.",
    'AI-powered message translation between languages':
      "Traduction de messages entre langues basée sur l'IA",
    'All route-critical information in one place before you review quotes or documents.':
      'Toutes les informations critiques en un seul endroit avant de consulter des devis ou des documents.',
    View: 'Voir',
    Answer: 'Réponse',
    Archive: 'Archiver',
    'Archived statuses': 'Statuts archivés',
    'Are you sure you want to reject the quote from':
      'Etes-vous sûr de vouloir rejeter le devis de',
    'Ask a question about this listing...':
      'Posez une question sur cette annonce...',
    'Ask for matching lanes, quote help, or the next operational step.':
      "Demandez des voies correspondantes, de l'aide pour un devis ou la prochaine étape opérationnelle.",
    'Ask for quote comparisons or a prepared next step from this shipment screen.':
      'Demandez des comparaisons de devis ou une prochaine étape préparée à partir de cet écran d’expédition.',
    'Assistant history cleared': "Historique de l'assistant effacé",
    'Automatically translate messages from other users into your preferred language using AI.':
      "Traduisez automatiquement les messages des autres utilisateurs dans votre langue préférée à l'aide de l'IA.",
    'Back to listing': 'Retour à la liste',
    'Best offer': 'Meilleure offre',
    'Best quote': 'Meilleure citation',
    Budget: 'Budget',
    'Cancel listing': "Annuler l'annonce",
    'Canceled and completed work will appear here once listings move out of the active view.':
      'Les travaux annulés et terminés apparaîtront ici une fois que les annonces quitteront la vue active.',
    'Cargo Details': 'Détails du fret',
    Categories: 'Catégories',
    'Choose the interface language. This preference is saved locally and applies immediately.':
      "Choisissez la langue de l'interface. Cette préférence est enregistrée localement et s'applique immédiatement.",
    'Clear all': 'Tout effacer',
    'Clear assistant history': "Effacer l'historique de l'assistant",
    'Client price in EUR': 'Prix client en EUR',
    'Client target price': 'Prix indicatif client',
    'Complete the payment below to lock the fixed-price acceptance and let the partner start planning.':
      "Effectuez le paiement ci-dessous pour verrouiller l'acceptation du prix fixe et permettre au partenaire de commencer à planifier.",
    'Complete the payment below to lock the selected quote and let the partner start planning.':
      'Effectuez le paiement ci-dessous pour verrouiller le devis sélectionné et permettre au partenaire de commencer à planifier.',
    'Compose area prepared for listing Q&A. Submission remains disabled until the live question endpoint is connected on this page.':
      "Zone de rédaction préparée pour la liste des questions et réponses. La soumission reste désactivée jusqu'à ce que le point de terminaison de la question en direct soit connecté sur cette page.",
    'Confirm delivery complete': 'Confirmer la livraison terminée',
    'Confirm payment received': 'Confirmer le paiement reçu',
    'Confirm that you have received the bank transfer or payment for this listing. This will move the listing to Paid status and allow the partner to mark it as planned.':
      'Confirmez que vous avez reçu le virement bancaire ou le paiement pour cette annonce. This will move the listing to Paid status and allow the partner to mark it as planned.',
    'Confirm the exact fleet and dates before the listing moves to Planned.':
      "Confirmez la flotte exacte et les dates avant que l'annonce ne passe à Planifié.",
    'Confirm Transport Plan': 'Confirmer le plan de transport',
    'Confirming...': 'Confirmation...',
    'Control how the web assistant behaves on this device. These settings do not change your account data.':
      "Contrôlez le comportement de l'assistant Web sur cet appareil. Ces paramètres ne modifient pas les données de votre compte.",
    'Create listing': 'Créer une annonce',
    'Create with AI': "Créer avec l'IA",
    'Create your next transport request and it will appear here with route, item, and quote activity.':
      "Créez votre prochaine demande de transport et elle apparaîtra ici avec l'itinéraire, l'article et l'activité de devis.",
    'Current stage:': 'Stade actuel :',
    'Current status': 'Statut actuel',
    'Delivery confirmation needed': 'Confirmation de livraison nécessaire',
    'Delivery radius': 'Rayon de livraison',
    'Delivery:': 'Livraison :',
    'Describe the route and cargo, then review the prepared listing draft before publishing.':
      "Décrivez l'itinéraire et la cargaison, puis examinez le projet de liste préparé avant de le publier.",
    'Describe the shipment you need and review the prepared request before publishing.':
      "Décrivez l'envoi dont vous avez besoin et examinez la demande préparée avant de la publier.",
    'Download and review the purchase terms before confirming the transport plan.':
      "Téléchargez et consultez les conditions d'achat avant de confirmer le plan de transport.",
    'Download invoice': 'Télécharger la facture',
    'Download Purchase Terms': "Télécharger les conditions d'achat",
    'Draft with AI': "Brouillon avec l'IA",
    'Draft your review first, then submit it here when you are satisfied.':
      'Rédigez d’abord votre avis, puis soumettez-le ici lorsque vous êtes satisfait.',
    'Edit listing': 'Modifier la fiche',
    'Edit Quote': 'Modifier le devis',
    Enable: 'Activer',
    'Enable live translation': 'Activer la traduction en direct',
    'Enabled Users': 'Utilisateurs autorisés',
    'Engagement Activity': 'Activité de mobilisation',
    'Expires:': 'Expire :',
    'Failed to accept listing': "Échec de l'acceptation de l'annonce",
    'Failed to accept quote': "Échec de l'acceptation du devis",
    'Failed to clear assistant history':
      "Échec de la suppression de l'historique de l'assistant",
    'Failed to complete listing': 'Échec de la finalisation de la liste',
    'Failed to confirm payment': 'Échec de la confirmation du paiement',
    'Failed to confirm transport plan':
      'Échec de la confirmation du plan de transport',
    'Failed to disable AI for user.':
      "Échec de la désactivation de l'IA pour l'utilisateur.",
    'Failed to enable AI for user.':
      "Échec de l'activation de l'IA pour l'utilisateur.",
    'Failed to load listing.': 'Échec du chargement de la liste.',
    'Failed to load listings': 'Échec du chargement des annonces',
    'Failed to load listings. Please try again.':
      'Échec du chargement des annonces. Veuillez réessayer.',
    'Failed to load review context.':
      'Échec du chargement du contexte de révision.',
    'Failed to load settings.': 'Échec du chargement des paramètres.',
    'Failed to refresh Stripe payment status':
      "Échec de l'actualisation du statut de paiement Stripe",
    'Failed to reject quote': 'Échec du rejet du devis',
    'Failed to release listing': 'Échec de la publication de la fiche',
    'Failed to save quote': "Échec de l'enregistrement du devis",
    'Failed to update listing': 'Échec de la mise à jour de la liste',
    'Failed to update preferred language':
      'Échec de la mise à jour de la langue préférée',
    'Failed to update setting.': 'Échec de la mise à jour du paramètre.',
    'Failed to update status': 'Échec de la mise à jour du statut',
    'Failed to update translation preference':
      'Échec de la mise à jour des préférences de traduction',
    'Failed to update watchlist':
      'Échec de la mise à jour de la liste de surveillance',
    'Failed to withdraw quote': 'Échec du retrait du devis',
    'Feature Flags': 'Indicateurs de fonctionnalités',
    'Filter invoice uploads, search by reference, and page through payout records.':
      'Filtrez les téléchargements de factures, effectuez une recherche par référence et parcourez les enregistrements de paiement.',
    Filters: 'Filtres',
    'Final delivery documents': 'Documents de livraison finaux',
    'Fixed price only': 'Prix fixe uniquement',
    'Flexible / not set': 'Flexible / non défini',
    'Generated automatically when the transport plan is confirmed.':
      'Généré automatiquement lorsque le plan de transport est confirmé.',
    'Goods delivered — awaiting client confirmation.':
      'Marchandises livrées - en attente de confirmation du client.',
    'Gross price': 'Prix brut',
    'I have read and agree to the purchase terms for this transport job.':
      "J'ai lu et j'accepte les conditions d'achat de ce travail de transport.",
    'I understand that accepting this listing assigns it to me at the fixed client price shown above.':
      "Je comprends qu'accepter cette annonce me l'attribue au prix client fixe indiqué ci-dessus.",
    'Image upload failed': "Échec du téléchargement de l'image",
    'Images uploaded': 'Images téléchargées',
    'Interface language': "Langue de l'interface",
    'Invoice documents': 'Documents de facturation',
    items: 'articles',
    'Keep listing': 'Conserver la liste',
    'Keep quote': 'Conserver le devis',
    'Keep the current AI session available after closing the browser on this device.':
      'Gardez la session AI actuelle disponible après la fermeture du navigateur sur cet appareil.',
    'Language & Region': 'Langue et région',
    Listed: 'Inscrit',
    'Listing accepted': 'Annonce acceptée',
    'Listing expired': 'Annonce expirée',
    'Listing images': 'Liste des images',
    'Listing is live': "L'annonce est en ligne",
    'Listing reference': "Référence de l'annonce",
    'Listing snapshot': 'Instantané de la liste',
    'Listing unavailable': 'Annonce indisponible',
    'Listing updated': 'Annonce mise à jour',
    'Live Translation': 'Traduction en direct',
    'Live translation disabled.': 'Traduction en direct désactivée.',
    'Live translation enabled.': 'Traduction en direct activée.',
    'Loading approved trucks...': 'Chargement de camions agréés...',
    'Loading fleet...': 'Chargement de la flotte...',
    'Loading listing details...': "Chargement des détails de l'annonce...",
    'Loading listings...': 'Chargement des annonces...',
    'Loading review details...': "Chargement des détails de l'avis...",
    'Loading settings...': 'Chargement des paramètres...',
    'Manage AI Assistant Users': 'Gérer les utilisateurs de AI Assistant',
    'Manage platform-wide feature flags and configuration.':
      'Gérez les indicateurs de fonctionnalités et la configuration à l’échelle de la plate-forme.',
    'Manage Users': 'Gérer les utilisateurs',
    'Manage your transport requests, monitor quote activity, and keep active and archived work easy to scan.':
      "Gérez vos demandes de transport, surveillez l'activité des devis et gardez le travail actif et archivé facile à numériser.",
    'Mark Picked Up': 'Marque ramassée',
    'Matches the client target price': 'Correspond au prix indicatif du client',
    Media: 'Médias',
    Messages: 'Messages',
    'Messages will be translated into this language.':
      'Les messages seront traduits dans cette langue.',
    'Minimum net:': 'Net minimum :',
    'My invoices': 'Mes factures',
    Net: 'Filet',
    'Net price': 'Prix net',
    'Net quote': 'Cotation nette',
    'New images appear immediately in the listing details for client, partner, and admin views.':
      'De nouvelles images apparaissent immédiatement dans les détails de la liste pour les vues client, partenaire et administrateur.',
    'Next step': 'Étape suivante',
    'No active listings yet': 'Aucune annonce active pour le moment',
    'No address provided': 'Aucune adresse fournie',
    'No answer yet.': "Pas de réponse pour l'instant.",
    'No archived listings yet': "Aucune annonce archivée pour l'instant",
    'No description added.': 'Aucune description ajoutée.',
    'no destination': 'aucune destination',
    'No expiry': "Pas d'expiration",
    'No listings match the current filters. Try broadening the search or date range.':
      "Aucune annonce ne correspond aux filtres actuels. Essayez d'élargir la recherche ou la plage de dates.",
    'no origin': "pas d'origine",
    'No questions yet': "Aucune question pour l'instant",
    'No quotes yet': 'Pas encore de citations',
    'No shipment images uploaded yet.':
      "Aucune image d'expédition téléchargée pour l'instant.",
    'No trailer selected': 'Aucune bande-annonce sélectionnée',
    'No unread messages': 'Aucun message non lu',
    'No users found.': 'Aucun utilisateur trouvé.',
    'No users have AI enabled.': "Aucun utilisateur n'a activé l'IA.",
    'Not selected': 'Non sélectionné',
    'Offers summary': 'Résumé des offres',
    'Open AI assistant': 'Assistant IA ouvert',
    'Open prepared screens automatically':
      'Ouvrir automatiquement les écrans préparés',
    'Optional visible price shown to partners as your target budget.':
      'Prix visible facultatif affiché aux partenaires comme budget cible.',
    'Other quotes will be declined automatically once this offer is accepted.':
      'Les autres devis seront refusés automatiquement une fois cette offre acceptée.',
    'Partner delivery': 'Livraison partenaire',
    'Partner pickup': 'Prise en charge par le partenaire',
    'Partner quote': 'Devis partenaire',
    'Payment confirmed': 'Paiement confirmé',
    'Payment confirmed — listing status set to paid':
      "Paiement confirmé — le statut de l'annonce est défini sur Payé",
    'Payment confirmed. Confirm the assigned fleet and planned dates before the listing moves to Planned.':
      'Paiement confirmé. Confirmez la flotte attribuée et les dates planifiées avant que la liste ne passe à Planifié.',
    'Payment is confirmed. The partner now needs to confirm the truck, driver, and planned dates.':
      'Le paiement est confirmé. Le partenaire doit maintenant confirmer le camion, le chauffeur et les dates prévues.',
    'Payment required': 'Paiement requis',
    'Photos uploaded for the shipment and visible across client, partner, and admin views.':
      "Photos téléchargées pour l'expédition et visibles dans les vues client, partenaire et administrateur.",
    'Pickup is complete and the transport is currently underway.':
      "L'enlèvement est terminé et le transport est actuellement en cours.",
    'Pickup proof': 'Preuve de ramassage',
    'Pickup proof and final delivery files uploaded by the transport partner.':
      "Preuve d'enlèvement et fichiers de livraison finale mis en ligne par le partenaire de transport.",
    'Pickup to delivery overview': 'Aperçu du ramassage à la livraison',
    'Pickup:': 'Ramassage :',
    'Plan and authorization': 'Plan et autorisation',
    'Plan transport': 'Planifier les transports',
    'Plan Transport': 'Planifier les transports',
    'Planned dates:': 'Dates prévues :',
    'Planned delivery date': 'Date de livraison prévue',
    'Platform Settings': 'Paramètres de la plateforme',
    'Preferred language': 'Langue préférée',
    'Preferred language updated': 'Langue préférée mise à jour',
    'Prepare a quote or ask for the next lane action, then confirm before anything is submitted.':
      'Préparez un devis ou demandez la prochaine action sur la voie, puis confirmez avant de soumettre quoi que ce soit.',
    'Purchase Terms': "Conditions d'achat",
    'Quantities, dimensions, and handling details ready for transport review.':
      "Quantités, dimensions et détails de manutention prêts pour l'examen du transport.",
    Question: 'Question',
    Questions: 'Questions',
    'Questions & answers': 'Questions et réponses',
    'Questions and answers for this listing will appear here once the messaging flow is active.':
      'Les questions et réponses pour cette liste apparaîtront ici une fois que le flux de messagerie sera actif.',
    'Quick access to the current shipment, quote, and billing state.':
      'Accès rapide à l’état actuel de l’expédition, du devis et de la facturation.',
    'Quote accepted': 'Devis accepté',
    'Quote count': 'Nombre de devis',
    'Quote message': 'Message de devis',
    'Quote rejected': 'Devis rejeté',
    'Quote withdrawn': 'Devis retiré',
    Quotes: 'Citations',
    'Quotes and questions': 'Citations et questions',
    'Quotes are disabled for this listing. The first partner to accept the fixed price will be assigned automatically.':
      'Les citations sont désactivées pour cette annonce. Le premier partenaire à accepter le prix fixe sera attribué automatiquement.',
    'Quotes are disabled for this shipment. If you accept it, the client price becomes an accepted booking immediately.':
      "Les devis sont désactivés pour cette expédition. Si vous l'acceptez, le prix client devient immédiatement une réservation acceptée.",
    'Quotes from transport providers usually begin to appear shortly after publishing. Refresh to check again.':
      'Les offres des prestataires de transport commencent généralement à apparaître peu de temps après leur publication. Actualisez pour vérifier à nouveau.',
    'Reference #{{id}}': 'Référence #{{id}}',
    'Refresh listings': 'Actualiser les annonces',
    'Reject quote': 'Rejeter le devis',
    'Rejecting...': 'Rejeter...',
    Release: 'Libération',
    'Release Listing': 'Liste des versions',
    'Remember assistant conversation':
      "Mémoriser la conversation avec l'assistant",
    'Required for fixed-price listings. Partners accept this amount directly.':
      'Obligatoire pour les annonces à prix fixe. Les partenaires acceptent ce montant directement.',
    'Required. Partners will be able to accept this listing at the fixed client price without sending a quote.':
      'Requis. Les partenaires pourront accepter ce référencement au prix fixe client sans envoi de devis.',
    'Review submission failed.': "Échec de la soumission de l'avis.",
    'Review the completed transport using the standard product flow.':
      'Examinez le transport terminé à l’aide du flux de produits standard.',
    'Route pending': 'Itinéraire en attente',
    'Save changes': 'Enregistrer les modifications',
    'Saving...': 'Sauvegarde...',
    'Search by title, route, category, or item':
      'Rechercher par titre, itinéraire, catégorie ou élément',
    'Search Results': 'Résultats de la recherche',
    'Search users by email...': 'Rechercher des utilisateurs par e-mail...',
    'Select a truck, driver, pickup date, and delivery date.':
      'Sélectionnez un camion, un chauffeur, une date de ramassage et une date de livraison.',
    'Select approved truck': 'Sélectionnez un camion agréé',
    'Select driver': 'Sélectionnez le pilote',
    'Send Revision': 'Envoyer la révision',
    Sentiment: 'Sentiment',
    'Share what went well and what could improve':
      "Partagez ce qui s'est bien passé et ce qui pourrait s'améliorer",
    'Shipment in transit': 'Expédition en transit',
    'Shipment notes': "Notes d'expédition",
    'Shipment tracking will be shared': 'Le suivi des expéditions sera partagé',
    'Show AI launchers': 'Afficher les lanceurs IA',
    'Show or hide AI assistant buttons on supported dashboard and listing pages.':
      "Affichez ou masquez les boutons de l'assistant IA sur les pages de tableau de bord et de liste prises en charge.",
    'Special needs or notes': 'Besoins spéciaux ou remarques',
    'Specify delivery dates': 'Préciser les dates de livraison',
    'Specify pickup dates': 'Préciser les dates de ramassage',
    Stage: 'Scène',
    'Status updated to {{status}}': 'Statut mis à jour à 0{{status}}',
    'Stripe payment confirmed and booking updated':
      'Paiement Stripe confirmé et réservation mise à jour',
    'Stripe status: {{status}}': 'Statut de la bande : {{status}}',
    'Submit question': 'Soumettre une question',
    'Submit review': "Envoyer l'avis",
    'Submitting...': 'Envoi...',
    'The AI assistant is currently disabled for this environment. Existing local session data can still be cleared here.':
      "L'assistant IA est actuellement désactivé pour cet environnement. Les données de session locale existantes peuvent toujours être effacées ici.",
    'The listing expired before a transport was confirmed.':
      "L'annonce a expiré avant qu'un transport ne soit confirmé.",
    'The listing has been fully completed and archived as a finished transport.':
      'Le listing a été entièrement complété et archivé comme un transport terminé.',
    'The lowest net price you would still accept for this shipment.':
      'Le prix net le plus bas que vous accepteriez encore pour cet envoi.',
    'The partner has confirmed the route plan. Pickup and delivery dates are now scheduled.':
      'Le partenaire a confirmé le plan de route. Les dates de ramassage et de livraison sont désormais programmées.',
    'The partner marked the shipment as delivered. Review the final documents and confirm completion.':
      "Le partenaire a marqué l'envoi comme livré. Examinez les documents finaux et confirmez leur achèvement.",
    'The partner-confirmed plan and LOA stay grouped together for faster review.':
      'Le plan confirmé par le partenaire et la LOA restent regroupés pour un examen plus rapide.',
    'This action notifies the transport provider and removes the quote from active consideration.':
      'Cette action informe le prestataire de transport et supprime le devis de la considération active.',
    'This listing is archived and no further transport actions are available.':
      "Cette annonce est archivée et aucune autre action de transport n'est disponible.",
    'This listing needs an accepted quote before a review can be created.':
      "Cette annonce nécessite un devis accepté avant qu'un avis puisse être créé.",
    'This will soft-cancel the listing and move it to your archive.':
      'Cela annulera en douceur la liste et la déplacera vers vos archives.',
    'This will soft-cancel the listing for the client and remove it from active marketplace views.':
      'Cela annulera en douceur la liste du client et la supprimera des vues actives du marché.',
    'Total quote': 'Devis total',
    'Tracking not promised': 'Suivi non promis',
    'Tracking shared': 'Suivi partagé',
    'Tracking visibility': 'Visibilité du suivi',
    'Trailer (Optional)': 'Remorque (En option)',
    'Translation preference updated': 'Préférence de traduction mise à jour',
    'Transport completed': 'Transport terminé',
    'Transport completed.': 'Transport terminé.',
    'Transport documents': 'Documents de transport',
    'Transport marked as complete': 'Transport marqué comme terminé',
    'Transport package': 'Forfait transport',
    'Transport plan confirmed': 'Plan de transport confirmé',
    'Transport plan updated': 'Plan de transport mis à jour',
    'Transport planned': 'Transports prévus',
    'Transport Provider': 'Prestataire de transport',
    'Transport providers can review your shipment and send offers.':
      'Les prestataires de transport peuvent examiner votre envoi et envoyer des offres.',
    'Transport stage': 'Étape de transport',
    Truck: 'Camion',
    'Truck, driver, trailer, and planned dates for this shipment.':
      'Camion, chauffeur, remorque et dates prévues pour cette expédition.',
    'Try widening the current listing filters.':
      "Essayez d'élargir les filtres de liste actuels.",
    'Unable to upload listing images.':
      'Impossible de télécharger les images de la liste.',
    'Unknown error': 'Erreur inconnue',
    'Untitled listing': 'Annonce sans titre',
    'Untitled Listing': 'Annonce sans titre',
    'Update media': 'Mettre à jour les médias',
    'Update transport plan': 'Mettre à jour le plan de transport',
    'Update Transport Plan': 'Mettre à jour le plan de transport',
    'Upload a CMR or delivery photos before marking delivered.':
      'Téléchargez un CMR ou des photos de livraison avant de marquer la livraison.',
    'Upload a CMR or delivery photos before the listing can move to Delivered.':
      "Téléchargez un CMR ou des photos de livraison avant que l'annonce puisse être déplacée vers Livré.",
    'Upload at least one pickup proof before the listing can move to Picked Up.':
      "Téléchargez au moins une preuve de ramassage avant que l'annonce puisse être déplacée vers Picked Up.",
    'Upload final documents': 'Télécharger les documents finaux',
    'Upload proof of pickup': 'Télécharger une preuve de ramassage',
    'Uploading...': 'Téléchargement...',
    'Use fresh photos when the shipment changes or you want to clarify the item condition.':
      'Utilisez de nouvelles photos lorsque l’envoi change ou si vous souhaitez clarifier l’état de l’article.',
    'users enabled': 'utilisateurs activés',
    'Visible to you while quoting. You can still send your own net offer below or above this amount.':
      'Visible pour vous lors de la citation. Vous pouvez toujours envoyer votre propre offre nette en dessous ou au-dessus de ce montant.',
    'Waiting for partner acceptance':
      "En attente de l'acceptation du partenaire",
    'Waiting for transport planning':
      'En attente de la planification des transports',
    'When enabled, messages from other users will be automatically translated to your preferred language.':
      "Lorsqu'il est activé, les messages des autres utilisateurs seront automatiquement traduits dans votre langue préférée.",
    Withdraw: 'Se retirer',
    'Write Review': 'Écrire un avis',
    'You are about to release this listing back to the marketplace.':
      'Vous êtes sur le point de remettre cette annonce sur le marché.',
    'You are now the assigned partner for this fixed-price listing.':
      'Vous êtes désormais le partenaire désigné pour cette annonce à prix fixe.',
    'Your quote has been accepted. Awaiting payment confirmation from the admin before you can begin the job.':
      "Votre devis a été accepté. En attente de confirmation de paiement de la part de l'administrateur avant de pouvoir commencer le travail.",
    fragile: 'fragile',
    Postcode: 'Code postal',
    Fragile: 'Fragile',
    destination: 'destination',
    'L cm': 'Lcm',
    'H cm': 'H cm',
    '{{amount}} below the client target':
      "{{amount}} en dessous de l'objectif client",
    '{{count}} image(s) added to the listing.':
      "{{count}} image(s) ajoutée(s) à l'annonce.",
    '{{count}} quote(s) received': '{{count}} devis reçu(s)',
    '{{count}} total': '{{count}} au total',
    '{{weight}} kg': '{{weight}} kg',
    "Accept {{partner}}'s quote for {{amount}}?":
      'Accepter le devis de {{partner}} pour {{amount}} ?',
    'Body type: {{type}}': 'Type de carrosserie : {{type}}',
    'Breed: {{breed}}': 'Race : {{breed}}',
    'Generation: {{generation}}': 'Génération : {{generation}}',
    'Item {{number}}': 'Article {{number}}',
    'Lift: {{origin}} / {{destination}}':
      'Ascenseur : {{origin}} / {{destination}}',
    'Listing {{id}}': 'Annonce {{id}}',
  },
  ro: {
    to: 'la',
    'X total': '{{count}} total',
    kg: 'kg',
    Compact: 'Compact',
    Hatchback: 'Hatchback',
    Coupé: 'Coupé',
    Sedan: 'Sedan',
    Crossover: 'Crossover',
    Van: 'Van',
    total: 'total',
    Required: 'Necesar',
    'Change language': 'Schimbați limba',
    'Loading...': 'Se încarcă…',
    'Error:': 'Eroare:',
    Close: 'Închide',
    Yes: 'Da',
    No: 'Nu',
    'Keep order': 'Păstrați ordinea',
    Price: 'Preț',
    'Purchase terms': 'Condiții de cumpărare',
    'Power of attorney': 'Imputernicire',
    'Transport details': 'Detalii transport',
    'Upload damages': 'Încărcați daune',
    'Download (PDF)': 'Descărcați (PDF)',
    'Mark as picked up': 'Marcați ca fiind ridicat',
    'Mark as delivered': 'Marcați ca livrat',
    'Cancel booking': 'Anulați rezervarea',
    'Order marked as picked up': 'Comanda marcată ca fiind ridicată',
    'Order marked as delivered': 'Comanda marcată ca livrată',
    'Order canceled': 'Comanda anulată',
    'Failed to cancel order': 'Nu s-a putut anula comanda',
    'Added {{count}} file(s)': 'S-au adăugat fișiere {{count}}',
    Pages: 'Pagini',
    'Awaiting Verification': 'Se așteaptă verificarea',
    Profile: 'Profil',
    'Profile Incomplete': 'Profil incomplet',
    'Please complete your profile information (Company, Phone, Address, City, Post Code) to access all features.':
      'Vă rugăm să completați informațiile de profil (Companie, Telefon, Adresă, Oraș, Cod poștal) pentru a accesa toate funcțiile.',
    'Go to Profile': 'Accesați Profil',
    'Forgot Password': 'Am uitat parola',
    Hello: 'Bună ziua',
    friend: 'prieten',
    'Book your transport': 'Rezervă-ți transportul',
    'fast and easy': 'rapid si usor',
    Origin: 'Originea',
    Destination: 'Destinație',
    'Postal code': 'Cod poștal',
    'Calculate to preview': 'Calculați pentru a previzualiza',
    "Can't be calculated yet": 'Nu poate fi calculat încă',
    'Awaiting payment badge': 'În așteptarea plății',
    'Ref {{id}}': 'Ref {{id}}',
    'Change planning': 'Schimbați planificarea',
    'Change driver': 'Schimbați șoferul',
    'No vehicles listed': 'Nu există vehicule listate',
    'Order not found.': 'Comanda nu a fost găsită.',
    'Not available': 'Nu este disponibil',
    'For {{date}}': 'Pentru {{date}}',
    'Picked on {{date}}': 'Alegerea de pe {{date}}',
    'Delivered on {{date}}': 'Livrat pe {{date}}',
    'Loading notification: {{value}}': 'Notificare de încărcare: {{value}}',
    'CO₂ compensation: {{value}}': 'Compensare CO₂: {{value}}',
    'Bio fuel: {{value}}': 'Combustibil bio: {{value}}',
    Remove: 'Eliminați',
    'Copy {{label}}': 'Copiați {{label}}',
    'Open navigation menu': 'Deschideți meniul de navigare',
    'Open menu': 'Deschide meniul',
    'Error fetching data': 'Eroare la preluarea datelor',
    'Not set': 'Nu setat',
    'No opening hours provided': 'Nu sunt furnizate ore de deschidere',
    'Please select a planned date': 'Vă rugăm să selectați o dată planificată',
    Email: 'E-mail',
    'Saved favorite route filter': 'Filtrul de traseu preferat salvat',
    km: 'km',
    mi: 'mi',
    'Radius search': 'Căutare pe rază',
    'City or town': 'Oraș sau oraș',
    'Country (optional)': 'Țara (opțional)',
    Radius: 'Raza',
    'Searching…': 'Se caută…',
    'City not found': 'Orașul nu a fost găsit',
    'Within {{radius}} {{unit}} of {{place}}':
      'În cadrul {{radius}} {{unit}} de la {{place}}',
    'Clear radius': 'Raza clară',
    'auth.account_status_pending_review':
      'Starea contului: în așteptarea examinării',
    'auth.your_account_is_pending_approval':
      'Contul dvs. este în așteptarea aprobării',
    'auth.upload_your_verification_documents_below_and_we_ll_notify_you_by_email_once_your_account_is_approved':
      'Încărcați documentele de verificare de mai jos și vă vom anunța prin e-mail odată ce contul dvs. este aprobat.',
    'auth.check_status': 'Verificați starea',
    'auth.upload_verification_documents': 'Încărcați documente de verificare',
    'auth.your_uploaded_documents': 'Documentele încărcate de dvs',
    'auth.back_to_sign_in': 'Înapoi pentru a vă conecta',
    role_client: 'Client',
    client: 'Client',
    admin: 'Admin',
    Albania: 'Albania',
    Andorra: 'Andorra',
    Armenia: 'Armenia',
    Austria: 'Austria',
    Belarus: 'Belarus',
    Bulgaria: 'Bulgaria',
    Estonia: 'Estonia',
    Georgia: 'Georgia',
    Kosovo: 'Kosovo',
    Liechtenstein: 'Liechtenstein',
    Malta: 'Malta',
    Moldova: 'Moldova',
    Monaco: 'Monaco',
    'San Marino': 'San Marino',
    Serbia: 'Serbia',
    Slovenia: 'Slovenia',
    'BodyType.Compact': 'Compact',
    'BodyType.Hatchback': 'Hatchback',
    'BodyType.Coupe': 'Coupé',
    'BodyType.Sedan': 'Sedan',
    'BodyType.Crossover': 'Crossover',
    'BodyType.Pickup': 'Ridicare',
    'BodyType.Van': 'Van',
    ' total': 'total',
    'N/A': 'N/A',
    Client: 'Client',
    Model: 'Model',
    'Error loading documents': 'Eroare la încărcarea documentelor',
    'Are you sure you want to delete this document?':
      'Sigur doriți să ștergeți acest document?',
    'Document deleted': 'Document șters',
    'Failed to delete': 'Ștergerea eșuată',
    'Failed to get download link': 'Nu s-a putut obține linkul de descărcare',
    'Status updated': 'Stare actualizată',
    'Update failed': 'Actualizarea a eșuat',
    'Email cannot be changed.': 'E-mailul nu poate fi schimbat.',
    'No documents found.': 'Nu s-au găsit documente.',
    'Invoice #': 'Factura #',
    'File Name': 'Nume fișier',
    Amount: 'Suma',
    Actions: 'Acțiuni',
    Download: 'Descărcați',
    'Mark Unpaid': 'Marcați neplătit',
    'Mark Paid': 'Mark Plătit',
    'Please save the record before uploading documents.':
      'Salvați înregistrarea înainte de a încărca documentele.',
    'Select a file before uploading.':
      'Selectați un fișier înainte de a încărca.',
    'Please enter an invoice number.':
      'Vă rugăm să introduceți un număr de factură.',
    'Upload successful': 'Încărcare reușită',
    '{{count}} file(s) uploaded successfully.':
      'Fișierele {{count}} au fost încărcate cu succes.',
    'Upload failed': 'Încărcarea nu a reușit',
    'Unable to upload the document.': 'Nu se poate încărca documentul.',
    'Invoice Number': 'Numărul facturii',
    'Selected files:': 'Fișiere selectate:',
    Upload: 'Încărcați',
    'Save this record before uploading documents.':
      'Salvați această înregistrare înainte de a încărca documente.',
    'Error approving user': 'Eroare la aprobarea utilizatorului',
    'Error rejecting user': 'Eroare la respingerea utilizatorului',
    'Error disabling user': 'Eroare la dezactivarea utilizatorului',
    'User marked as VIP': 'Utilizator marcat ca VIP',
    'User unmarked as VIP': 'Utilizator nemarcat ca VIP',
    'Error marking user as VIP': 'Eroare la marcarea utilizatorului ca VIP',
    'Error unmarking user as VIP': 'Eroare la demarcarea utilizatorului ca VIP',
    'Failed to approve user': 'Utilizatorul nu a putut fi aprobat',
    'Failed to reject user': 'Utilizatorul nu a putut fi respins',
    'Failed to disable user': 'Nu s-a putut dezactiva utilizatorul',
    'Failed to unmark user as VIP': 'Nu s-a demarcat utilizatorul ca VIP',
    'Failed to mark user as VIP': 'Nu s-a marcat utilizatorul ca VIP',
    'Invoice Management': 'Managementul facturilor',
    'All Invoices': 'Toate facturile',
    'Manage all invoices uploaded by partners.':
      'Gestionați toate facturile încărcate de parteneri.',
    'An unexpected error occurred. Please try again.':
      'A apărut o eroare neașteptată. Vă rugăm să încercați din nou.',
    'The email address is not valid.': 'Adresa de e-mail nu este validă.',
    'This account has been disabled.': 'Acest cont a fost dezactivat.',
    'No account found with this email.':
      'Nu s-a găsit niciun cont cu acest e-mail.',
    'Incorrect password. Please try again.':
      'Parolă incorectă. Vă rugăm să încercați din nou.',
    'Invalid email or password. Please check your credentials and try again.':
      'E-mail sau parolă nevalidă. Vă rugăm să vă verificați acreditările și să încercați din nou.',
    'Too many failed attempts. Please try again later or reset your password.':
      'Prea multe încercări eșuate. Vă rugăm să încercați din nou mai târziu sau să vă resetați parola.',
    'Network error. Check your connection and try again.':
      'Eroare de rețea. Verificați conexiunea și încercați din nou.',
    'A verification email has been sent to your email address. Please verify your email before logging in.':
      'Un e-mail de verificare a fost trimis la adresa dvs. de e-mail. Vă rugăm să vă verificați adresa de e-mail înainte de a vă autentifica.',
    'Please make sure both passwords are the same.':
      'Vă rugăm să vă asigurați că ambele parole sunt aceleași.',
    'Verification email resent!': 'E-mailul de verificare a fost retransmis!',
    'Please check your inbox.': 'Vă rugăm să vă verificați căsuța de e-mail.',
    'You need to log in first': 'Mai întâi trebuie să vă conectați',
    'Please sign in to resend the verification email.':
      'Vă rugăm să vă conectați pentru a retrimite e-mailul de verificare.',
    'Failed to resend email': 'E-mailul nu a fost retrimis',
    'Resend verification email': 'Retrimiteți e-mailul de verificare',
    'Show password': 'Afișați parola',
    'Hide password': 'Ascunde parola',
    'Awaiting verification artwork': 'Se așteaptă verificarea ilustrației',
    'Account status: Pending review':
      'Starea contului: în așteptarea examinării',
    'Your account is pending approval':
      'Contul dvs. este în așteptarea aprobării',
    "Upload your verification documents below and we'll notify you by email once your account is approved.":
      'Încărcați documentele de verificare de mai jos și vă vom anunța prin e-mail odată ce contul dvs. este aprobat.',
    'Check status': 'Verificați starea',
    'Upload verification documents': 'Încărcați documente de verificare',
    'Your uploaded documents': 'Documentele încărcate de dvs',
    'Back to sign in': 'Înapoi pentru a vă conecta',
    'Hide documents': 'Ascunde documentele',
    'Email verification required': 'Este necesară verificarea e-mailului',
    'Waiting for email verification': 'Se așteaptă verificarea e-mailului',
    'Check your email': 'Verifică-ți e-mailul',
    'We sent your verification link to':
      'Am trimis linkul dvs. de verificare la',
    "Didn't receive it? Check your spam folder or try again.":
      'Nu l-ai primit? Verificați folderul de spam sau încercați din nou.',
    'Resend email': 'Retrimiteți e-mailul',
    "I've verified my email": 'Mi-am verificat adresa de e-mail',
    'Redirecting you now.': 'Te redirecționează acum.',
    'Email not verified yet': 'E-mail neverificat încă',
    'Please click the link in your inbox and try again.':
      'Dați clic pe linkul din căsuța dvs. de e-mail și încercați din nou.',
    'Unable to resend verification email right now.':
      'Nu se poate retrimite e-mailul de verificare în acest moment.',
    'Unable to check verification status right now.':
      'Nu se poate verifica starea verificării în acest moment.',
    "We've sent a new verification link to your email address.":
      'Am trimis un nou link de verificare la adresa ta de e-mail.',
    'We automatically check your verification status every 30 seconds. You can also trigger an instant check after verifying your email.':
      'Verificăm automat starea dvs. de verificare la fiecare 30 de secunde. De asemenea, puteți declanșa o verificare instantanee după verificarea e-mailului.',
    'We automatically check your verification status every 15 seconds. You can also trigger an instant check after verifying your email.':
      'Verificăm automat starea dvs. de verificare la fiecare 15 secunde. De asemenea, puteți declanșa o verificare instantanee după verificarea e-mailului.',
    'Inputs changed. Recalculate the price.':
      'Intrările s-au schimbat. Recalculați prețul.',
    'My Invoices': 'Facturile mele',
    'Upload New Invoice': 'Încărcați o nouă factură',
    'Please enter the invoice number and upload the invoice document. It will be reviewed by an administrator.':
      'Vă rugăm să introduceți numărul facturii și să încărcați documentul facturii. Acesta va fi revizuit de un administrator.',
    'Invoice History': 'Istoricul facturilor',
    'Client ref · {{clientRef}}': 'Ref client · {{clientRef}}',
    'Order Documents': 'Documente de comandă',
    'Upload Proof of Pickup': 'Încărcați dovada ridicării',
    'Status will be updated to Picked Up after successful upload.':
      'Starea va fi actualizată la Ridicat după încărcarea cu succes.',
    'Upload Proof of Delivery': 'Încărcați dovada livrării',
    'Status will be updated to Delivered after successful upload.':
      'Starea va fi actualizată la Livrat după încărcarea cu succes.',
    'Enter first name': 'Introduceți prenumele',
    'Enter last name': 'Introduceți numele de familie',
    'Enter phone number': 'Introduceți numărul de telefon',
    'Driver updated.': 'Driver actualizat.',
    'The driver has been successfully updated.':
      'Driverul a fost actualizat cu succes.',
    'Driver added.': 'Șofer adăugat.',
    'The new driver has been successfully added.':
      'Noul driver a fost adăugat cu succes.',
    'Driver deleted.': 'Driverul a fost șters.',
    'The driver has been successfully deleted.':
      'Driverul a fost șters cu succes.',
    'Trailer updated.': 'Trailer actualizat.',
    'The trailer has been successfully updated.':
      'Trailerul a fost actualizat cu succes.',
    'Trailer added.': 'Trailer adăugat.',
    'The new trailer has been successfully added.':
      'Noul trailer a fost adăugat cu succes.',
    'Trailer deleted.': 'Trailerul a fost șters.',
    'The trailer has been successfully deleted.':
      'Trailerul a fost șters cu succes.',
    'User account not found. Please complete registration.':
      'Contul de utilizator nu a fost găsit. Vă rugăm să finalizați înregistrarea.',
    'No token provided': 'Nu este furnizat un jeton',
    'Token expired': 'Tokenul a expirat',
    'Token revoked': 'Token revocat',
    'Invalid ID token': 'Indicativ de identitate nevalid',
    Unauthorized: 'Neautorizat',
    'Unauthorized: User not authenticated.':
      'Neautorizat: utilizatorul nu este autentificat.',
    'Unauthorized: User role not found.':
      'Neautorizat: Rolul de utilizator nu a fost găsit.',
    'Forbidden: Your role is not allowed to perform this action.':
      'Interzis: rolul dvs. nu are voie să efectueze această acțiune.',
    'Forbidden: This action requires a partner role.':
      'Interzis: această acțiune necesită un rol de partener.',
    'Forbidden: This action requires a client role.':
      'Interzis: această acțiune necesită un rol de client.',
    'Forbidden: This action requires an admin role.':
      'Interzis: această acțiune necesită un rol de administrator.',
    'This user has not been approved': 'Acest utilizator nu a fost aprobat',
    'User email has not been verified':
      'E-mailul utilizatorului nu a fost verificat',
    'User account has been disabled': 'Contul de utilizator a fost dezactivat',
    'Booking not found': 'Rezervarea nu a fost găsită',
    'Route not found': 'Ruta nu a fost găsită',
    'Pickup location (country and postalCode) is required':
      'Locația de ridicare (țară și cod poștal) este necesară',
    'Delivery location (country and postalCode) is required':
      'Este necesară locația de livrare (țara și codul poștal).',
    'Unable to calculate route. Please check the locations and try again.':
      'Imposibil de calculat ruta. Verificați locațiile și încercați din nou.',
    'Error calculating transport price':
      'Eroare la calcularea prețului de transport',
    'Booking canceled successfully': 'Rezervarea a fost anulată cu succes',
    'Invalid request.': 'Solicitare nevalidă.',
    'Access denied.': 'Acces interzis.',
    'Resource not found.': 'Resursa nu a fost găsită.',
    'Request conflict.': 'Solicitați conflict.',
    'Invalid data provided.': 'Date nevalide furnizate.',
    'Too many requests. Please try again later.':
      'Prea multe cereri. Vă rugăm să încercați din nou mai târziu.',
    'Internal server error. Please try again later.':
      'Internal Server Error. Vă rugăm să încercați din nou mai târziu.',
    'Service temporarily unavailable.': 'Serviciul este temporar indisponibil.',
    'booking.load_preset': 'Încărcați presetarea',
    'booking.save_preset_tooltip':
      'Salvați filtrele curente ca presetare pentru acces rapid',
    'booking.load_preset_tooltip': 'Încărcați presetarea filtrului salvat',
    'booking.preset_saved': 'Presetarea salvată',
    'booking.preset_saved_desc': 'Filtrul dvs. presetat a fost salvat.',
    'booking.preset_loaded': 'Presetarea încărcată',
    'booking.preset_load_error': 'Nu s-a încărcat presetarea',
    'booking.no_preset_saved': 'Nicio presetare nu a fost salvată încă',
    'booking.date_from': 'Data de la',
    'booking.date_to': 'Data la',
    'Active filters': 'Filtre active',
    'All booking states': 'Toate statele de rezervare',
    'All partners': 'Toți partenerii',
    'All payments': 'Toate plățile',
    'All roles': 'Toate rolurile',
    'All statuses': 'Toate stările',
    'All Users': 'Toți utilizatorii',
    'Are you sure you want to cancel booking {{id}}?':
      'Sigur doriți să anulați rezervarea {{id}}?',
    'Attach the CMR Insurance before finishing truck setup.':
      'Atașați factura CMR înainte de a finaliza configurarea camionului.',
    Awaiting: 'În așteptare',
    'Awaiting payout': 'Se așteaptă plata',
    'Booking canceled': 'Rezervarea a fost anulată',
    'Booking marked as paid': 'Rezervarea este marcată ca plătită',
    'Booking released and returned to marketplace':
      'Rezervarea a fost eliberată și a fost returnată pe piață',
    'booking.allowed_range': 'Interval permis',
    'booking.assign_transport': 'Atribuiți transport',
    'booking.back': 'Înapoi',
    'booking.back_to_summary': 'Înapoi la rezumat',
    'booking.booking_created_but_pickup_document_not_uploaded_upload_from_order_details':
      'Rezervarea a fost creată, dar documentul de ridicare nu a fost încărcat. Îl puteți încărca din Detalii comandă.',
    'booking.city_not_found': 'Orașul nu a fost găsit',
    'booking.city_or_town': 'Oraș sau oraș',
    'booking.clear_radius': 'Raza clară',
    'booking.continue': 'Continuă',
    'booking.country_optional': 'Țara (opțional)',
    'booking.delivery_constraint_info':
      'Data de livrare trebuie să fie la sau după data ridicării.',
    'booking.delivery_date_cannot_be_earlier_than_pickup_date':
      'Data de livrare nu poate fi anterioară datei de ridicare',
    'booking.driver': 'Șofer',
    'booking.failed_to_open_letter_of_attorney':
      'Nu s-a deschis scrisoarea de avocatură',
    'booking.go_to_order': 'Mergeți la Comandă',
    'booking.i_accept_terms': 'Accept termenii',
    'booking.invalid_license_plate_or_vin_length':
      'Lungimea plăcuței de înmatriculare sau VIN nevalidă.',
    'booking.invalid_vin_format_i_o_q_not_allowed':
      'Format VIN nevalid. Caracterele I, O și Q nu sunt permise.',
    'booking.letter_of_attorney_file_is_empty':
      'Dosarul cu scrisoarea de avocatură este gol',
    'booking.no_additional_details': 'Fără detalii suplimentare',
    'booking.no_vehicle_info': 'Fără informații despre vehicul',
    'booking.open_letter_of_attorney': 'Scrisoare deschisă de avocatură',
    'booking.opening_letter_of_attorney':
      'Scrisoarea de deschidere a avocatului...',
    'booking.order_accepted_successfully': 'Comanda a fost acceptată cu succes',
    'booking.order_cars_exceed_selected_truck_capacity':
      'Această comandă are mașini {{orderCars}}, dar capacitatea de camion selectată este {{capacity}}.',
    'booking.pickup_constraint_info':
      'Data ridicării este necesară înainte de alocarea transportului.',
    'booking.pickup_document_upload_failed':
      'Încărcarea documentului de preluare a eșuat',
    'booking.preparing_secure_document_preview':
      'Se pregătește previzualizarea securizată a documentului...',
    'booking.radius_km': 'Raza (km)',
    'booking.radius_search': 'Căutare pe rază',
    'booking.route_and_details': 'Traseu și detalii',
    'booking.schedule': 'Program',
    'booking.searching': 'Se caută…',
    'booking.select_pickup_and_delivery': 'Selectați ridicarea și livrarea',
    'booking.select_pickup_and_delivery_dates_before_confirming':
      'Selectați datele de ridicare și livrare înainte de a confirma',
    'booking.select_pickup_date': 'Selectați data ridicării',
    'booking.select_truck_driver_and_trailer':
      'Selectați camionul, șoferul și remorca',
    'booking.supported_formats_jpg_png_pdf_doc_docx':
      'Formate acceptate: JPG, PNG, PDF, DOC, DOCX',
    'booking.terms_and_conditions': 'Termeni și condiții',
    'booking.terms_text':
      'Confirm termenii de transport și condițiile de răspundere.',
    'booking.track_shipment': 'Urmăriți expedierea',
    'booking.trailer': 'Trailer',
    'booking.transport_details': 'Detalii transport',
    'booking.truck': 'Camion',
    'booking.truck_driver_planning_saved_letter_of_attorney_available':
      'Camionul, șoferul și datele de planificare au fost salvate. Scrisoarea de avocatură este acum disponibilă.',
    'booking.unexpected_error': 'Eroare neașteptată',
    'booking.vehicles_plural': 'Vehicule',
    'booking.view_details': 'Vezi detalii',
    'booking.vip_price_must_be_between_min_max_50_to_150_percent_of_estimated_price':
      'Prețul VIP trebuie să fie între {{min}} EUR și {{max}} EUR (50% până la 150% din prețul estimat).',
    'booking.vip_price_must_be_positive_number':
      'Prețul VIP trebuie să fie un număr pozitiv.',
    'booking.within_radius_km_of_place':
      'În intervalul {{radius}} km de {{place}}',
    Capacity: 'Capacitate',
    'Car Capacity': 'Capacitatea mașinii',
    'Car capacity is required.': 'Capacitatea mașinii este necesară.',
    cars: 'mașini',
    Changed: 'Schimbat',
    'CMR Document': 'Document CMR',
    'CMR expiry': 'expirarea CMR',
    'CMR Expiry': 'CMR expirare',
    'CMR expiry date is required': 'Este necesară data de expirare a CMR',
    'CMR Insurance': 'Asigurare CMR',
    'CMR insurance expiry date': 'Data expirării asigurării CMR',
    'CMR Insurance Expiry Date': 'Data de expirare a asigurării CMR',
    'CMR insurance has expired. Upload a new CMR Insurance for review.':
      'Încărcați o nouă factură CMR pentru examinare.',
    'CMR insurance is expiring within 14 days.':
      'Asigurarea CMR expiră în 14 zile.',
    'CMR Insurance required': 'Este necesară factura CMR',
    Company: 'Compania',
    'Copy order ID': 'Copiați ID-ul comenzii',
    Created: 'Creat',
    'Current expiry': 'Expirare curentă',
    'Date range': 'Interval de date',
    days: 'zile',
    Delay: 'Întârziere',
    'Delivered + partner invoice uploaded + unpaid':
      'Livrat + factura de partener încărcată + neplătită',
    Document: 'Document',
    'Documents uploaded': 'Documente încărcate',
    Done: 'Gata',
    'Download Client Invoice #{{id}}': 'Descărcați factura clientului #{{id}}',
    'Download Invoice': 'Descărcați Factură',
    'Enter a valid capacity between 1 and 20 cars.':
      'Introduceți o capacitate valabilă între 1 și 20 de mașini.',
    'Enter license plate': 'Introduceți plăcuța de înmatriculare',
    'Enter plate and upload CMR to add truck':
      'Introduceți placa și încărcați CMR pentru a adăuga camion',
    'Error fetching users': 'Eroare la preluarea utilizatorilor',
    'Expire Soon (14 days)': 'Expiră în curând (14 zile)',
    'Explain why this CMR was rejected':
      'Explicați de ce acest CMR a fost respins',
    'Failed to copy order ID': 'Nu s-a putut copia ID-ul comenzii',
    'Failed to download invoice': 'Nu s-a putut descărca factura',
    'Failed to download proforma invoice':
      'Nu s-a putut descărca factura proforma',
    'Failed to generate invoice': 'Nu s-a generat factura',
    'Failed to load invoice summary': 'Nu s-a încărcat rezumatul facturii',
    'Failed to load letter of attorney':
      'Nu s-a încărcat scrisoarea de avocatură',
    'Failed to open letter of attorney':
      'Nu s-a deschis scrisoarea de avocatură',
    'Failed to release booking': 'Nu s-a eliberat rezervarea',
    'Fleet data refreshed': 'Datele flotei au fost reîmprospătate',
    'Generate Client Invoice': 'Generați factura client',
    'Generate Invoice': 'Generați factura',
    'Generated at': 'Generat la',
    'How many cars can this truck carry?':
      'Câte mașini poate transporta acest camion?',
    'In progress': 'În curs',
    Invoice: 'Factură',
    'Invoice generated': 'Factură generată',
    'Invoice generated successfully': 'Factura generata cu succes',
    'Invoice uploaded': 'Factură încărcată',
    'Invoices uploaded by partners for platform payout processing. Client invoices are generated in each order view.':
      'Facturile clientului sunt generate în fiecare vizualizare a comenzii.',
    'Keep booking': 'Continuați să rezervați',
    'Keep your active drivers and contact details up to date.':
      'Țineți șoferii activi și detaliile de contact actualizate.',
    'Last Rejection': 'Ultima respingere',
    'Last rejection reason': 'Ultimul motiv de respingere',
    'Letter of Attorney': 'Scrisoare de avocat',
    'Letter of attorney file is empty':
      'Dosarul cu scrisoarea de avocatură este gol',
    'License plate cannot be changed after creation. Re-upload CMR Insurance instead.':
      'În schimb, reîncărcați factura CMR.',
    'License plate is required.': 'Este necesară plăcuța de înmatriculare.',
    'Manage large order volumes with search, payment actions, and invoice workflows.':
      'Gestionați volume mari de comenzi cu fluxuri de lucru de căutare, acțiuni de plată și factură.',
    'Manage license plates and keep CMR Insurances approved and valid.':
      'Gestionați plăcuțele de înmatriculare și păstrați facturile CMR aprobate și valabile.',
    'Manage status updates, documents, and payment steps from one place.':
      'Gestionați actualizările de stare, documentele și pașii de plată dintr-un singur loc.',
    'Manage trailer plate records and keep availability current.':
      'Gestionați înregistrările plăcilor remorcii și păstrați disponibilitatea la zi.',
    'Mark booking {{id}} as paid?': 'Marcați rezervarea {{id}} ca plătită?',
    Missing: 'Lipsă',
    'Needs attention': 'Necesită atenție',
    'New (14 days)': 'Nou (14 zile)',
    'No bookings found for the current filters.':
      'Nu s-au găsit rezervări pentru filtrele actuale.',
    'No confirmed CMR document uploaded yet.':
      'Încă nu a fost încărcat niciun document CMR confirmat.',
    'No driver assigned': 'Niciun șofer desemnat',
    'No letter of attorney has been generated yet.':
      'Încă nu a fost generată nicio scrisoare de avocatură.',
    'No matching delivered orders': 'Nu se potrivește comenzi livrate',
    'No new notifications': 'Fără notificări noi',
    'No partners found.': 'Nu s-au găsit parteneri.',
    'No trucks found for this filter.':
      'Nu s-au găsit camioane pentru acest filtru.',
    'No users found for current filters.':
      'Nu s-au găsit utilizatori pentru filtrele actuale.',
    'Not uploaded': 'Nu a fost încărcat',
    Notifications: 'Notificări',
    of: 'de',
    'Only admins can set or update this expiry date after reviewing your CMR insurance.':
      'Numai administratorii pot seta sau actualiza această dată de expirare după ce vă examinează asigurarea CMR.',
    'Open letter of attorney': 'Scrisoare deschisă de avocatură',
    Order: 'Comanda',
    'Order actions': 'Comanda actiuni',
    'Order ID copied': 'ID-ul comenzii a fost copiat',
    Owner: 'Proprietar',
    Page: 'Pagina',
    'Paid date': 'Data plătită',
    'Partner delivery date': 'Data livrării partenerului',
    'Partner documents': 'Documente partener',
    'Partner Invoice': 'Factură partener',
    'Partner invoice uploaded': 'S-a încărcat factura de partener',
    'Partner Payout Invoices': 'Facturi de plată pentru parteneri',
    'Partner pickup date': 'Data ridicării partenerului',
    'Partner score': 'Scorul partenerului',
    Payment: 'Plata',
    'Payout date': 'Data plății',
    'penalties applied': 'penalități aplicate',
    'Pending admin review': 'În așteptarea examinării de către administrator',
    'Pending review': 'În așteptarea examinării',
    'Pending trucks': 'Camioane în așteptare',
    'Please provide a clear reason for rejection.':
      'Vă rugăm să furnizați un motiv clar pentru respingere.',
    'Please select an order before uploading an invoice.':
      'Vă rugăm să selectați o comandă înainte de a încărca o factură.',
    'Please try again.': 'Vă rugăm să încercați din nou.',
    'Proforma Invoice': 'Factura proforma',
    'Provide a rejection reason for this CMR review.':
      'Furnizați un motiv de respingere pentru această revizuire CMR.',
    'Quarter Score': 'Scor sfert',
    'Re-upload CMR': 'Reîncărcați CMR',
    Refresh: 'Reîmprospătați',
    'Rejection reason': 'Motivul respingerii',
    'Rejection reason is required': 'Este necesar un motiv de respingere',
    'Release booking {{id}} back to the marketplace so another partner can accept it?':
      'Eliberați rezervarea {{id}} înapoi pe piață, astfel încât un alt partener să o accepte?',
    Reset: 'Resetați',
    'Review Bookings': 'Examinați rezervările',
    Revision: 'Revizuire',
    Rows: 'Rânduri',
    'Search by invoice number, file name, or booking ID':
      'Căutați după numărul facturii, numele fișierului sau ID-ul rezervării',
    'Search by name, email, company': 'Căutați după nume, e-mail, companie',
    'Search by name, email, company, uid':
      'Căutați după nume, e-mail, companie, uid',
    'Search client': 'Caută client',
    'Search delivered order': 'Cauta comanda livrata',
    'Search license plate or owner':
      'Căutați plăcuța de înmatriculare sau proprietarul',
    'Search order ID': 'Căutați ID-ul comenzii',
    'Search partner': 'Caută partener',
    'Select a new CMR Insurance to re-upload for this truck.':
      'Selectați o nouă factură CMR pentru a încărca din nou pentru acest camion.',
    'Select paid date': 'Selectați data plății',
    'Set CMR insurance expiry date to approve this truck.':
      'Setați data de expirare a asigurării CMR pentru a aproba acest camion.',
    'Set maximum number of cars this truck can carry (1-20).':
      'Setați numărul maxim de mașini pe care acest camion poate transporta (1-20).',
    'Set the CMR insurance expiry date before approval.':
      'Setați data de expirare a asigurării CMR înainte de aprobare.',
    Showing: 'Se arată',
    'Showing page {{page}} of {{pages}} • {{total}} invoices':
      'Pagina {{page}} a {{pages}} • Facturi {{total}}',
    'Status will be updated to Picked Up after successful upload. You can add multiple car photos before uploading.':
      'Puteți adăuga mai multe fotografii de mașină înainte de a le încărca.',
    Terms: 'Termeni',
    Total: 'Total',
    'Track paid and unpaid invoices, expected payout dates, and upload new invoices quickly.':
      'Urmăriți facturile plătite și neplătite, datele estimate de plată și încărcați rapid noi facturi.',
    'Truck approved successfully': 'Camion aprobat cu succes',
    'Truck documents': 'Documentele camionului',
    'Truck license plate': 'Plăcuța de înmatriculare a camionului',
    'Truck rejected successfully': 'Camionul a fost respins cu succes',
    'truck(s) are pending admin CMR expiry date.':
      'camioanele sunt în așteptarea datei de expirare a CMR de administrator.',
    'truck(s) have expired CMR insurance and are disabled.':
      'camioanele au o asigurare CMR expirată și sunt dezactivate.',
    'truck(s) will expire within 14 days.': 'camioanele vor expira în 14 zile.',
    'Unable to prepare the record for upload.':
      'Nu se poate pregăti înregistrarea pentru încărcare.',
    Unpaid: 'Neplătit',
    'Upload a CMR Insurance before closing this truck setup.':
      'Încărcați o factură CMR înainte de a închide configurarea acestui camion.',
    'Upload a valid CMR insurance. Each upload sends the truck back to pending review.':
      'Fiecare încărcare trimite camionul înapoi la examinare în așteptare.',
    'Upload documents': 'Încărcați documente',
    'Upload Invoice': 'Încărcați factura',
    'Upload order documents': 'Încărcați documentele de comandă',
    'Upload unavailable': 'Încărcarea nu este disponibilă',
    Uploaded: 'Încărcat',
    'Uploaded • Paid': 'Încărcat • Plătit',
    'Uploaded • Partially paid': 'Încărcat • Plătit parțial',
    'Uploaded by partner for platform payout processing.':
      'Încărcat de partener pentru procesarea plăților pe platformă.',
    User: 'Utilizator',
    'Verification code': 'Cod de verificare',
    'View details': 'Vezi detalii',
    'View Partners': 'Vedeți Partenerii',
    'Working hours not provided': 'Programul de lucru nu este furnizat',
    '{{value}} orders': 'comenzi {{value}}',
    Invoiced: 'Facturat',
    'Loading admin data...': 'Se încarcă datele de administrator...',
    'Pending partners': 'Parteneri în așteptare',
    'Unpaid bookings': 'Rezervări neplătite',
    'Total users': 'Total utilizatori',
    'Orders per period': 'Comenzi pe perioadă',
    'Orders by status': 'Comenzi după statut',
    'Quick actions': 'Acțiuni rapide',
    'Verify new partners': 'Verificați noi parteneri',
    'Review partner applications and approve or reject requests.':
      'Examinați cererile partenerilor și aprobați sau respingeți cererile.',
    'Manage all trucks': 'Gestionați toate camioanele',
    'Review, approve, reject, disable, and filter all trucks.':
      'Examinați, aprobați, respingeți, dezactivați și filtrați toate camioanele.',
    'Review bookings': 'Examinați rezervările',
    'Review all transport orders, payment states, and generated invoices.':
      'Examinați toate comenzile de transport, stările de plată și facturile generate.',
    'Manage all users': 'Gestionați toți utilizatorii',
    'Manage user status, roles, and validation records.':
      'Gestionați starea utilizatorului, rolurile și înregistrările de validare.',
    'User breakdown': 'Defalcarea utilizatorului',
    Clients: 'Clienții',
    Partners: 'Parteneri',
    Admins: 'Administratorii',
    'Top 5 pending partners': 'Top 5 parteneri în așteptare',
    'No pending partners right now.':
      'Nu există parteneri în așteptare momentan.',
    pending: 'în aşteptare',
    'Top 5 pending trucks': 'Top 5 camioane în așteptare',
    'No pending trucks right now.': 'Nu există camioane în așteptare momentan.',
    'Unknown owner': 'Proprietar necunoscut',
    'KPI cards and top lists link directly to filtered admin screens.':
      'Cardurile KPI și listele de top se leagă direct la ecranele de administrare filtrate.',
    'booking.available_orders_title': 'Comenzi disponibile',
    'booking.available_orders_description':
      'Examinați oportunitățile de transport de intrare și aplicați filtre pentru a se potrivi cu capacitatea dvs.',
    'booking.vehicle_pickup_location': 'Locația de preluare a vehiculului',
    'booking.pickup_opening_hours': 'Program de ridicare',
    'booking.vehicle_delivery_location': 'Locația de livrare a vehiculului',
    'booking.delivery_opening_hours': 'Program de livrare',
    'booking.pickup_contact': 'Contact de preluare',
    'booking.delivery_contact': 'Contact de livrare',
    'booking.vehicles_scheduled': 'Vehicule programate',
    'booking.watchlist_title': 'Lista de urmărire',
    'booking.watchlist_description':
      'Urmăriți oportunitățile salvate și acționați rapid pe măsură ce disponibilitatea se modifică.',
    'Loading dashboard...': 'Se încarcă tabloul de bord...',
    'Total bookings': 'Total rezervări',
    'Open bookings': 'Rezervări deschise',
    'Order status timeline': 'Cronologie privind starea comenzii',
    'Last 6 months of bookings grouped by current status.':
      'Ultimele 6 luni de rezervări grupate după starea curentă.',
    'Create new order': 'Creați o nouă comandă',
    'Create a new transport booking request.':
      'Creați o nouă cerere de rezervare de transport.',
    'View my orders': 'Vezi comenzile mele',
    'Review status and details of your bookings.':
      'Examinați starea și detaliile rezervărilor dvs.',
    'Open profile': 'Deschide profilul',
    'Update company and contact details.':
      'Actualizați compania și datele de contact.',
    'Recent bookings': 'Rezervări recente',
    'No bookings yet.': 'Încă nu există rezervări.',
    'Unknown destination': 'Destinație necunoscută',
    'Quarter score': 'Scor sfert',
    '{{value}} completed': '{{value}} finalizat',
    'Truck CMR warning': 'Avertizare CMR pentru camion',
    'One truck has CMR expiry risk. Review it in Fleet.':
      'Un camion are risc de expirare CMR. Examinați-l în Fleet.',
    '{{count}} trucks have CMR expiry risk. Review them in Fleet.':
      'Camioanele {{count}} au risc de expirare CMR. Examinați-le în Fleet.',
    'Active queue': 'Coada activă',
    'Delivered bookings': 'Rezervări livrate',
    'Cars delivered': 'Mașini livrate',
    'Canceled bookings': 'Rezervări anulate',
    'Avg assign-to-pickup': 'Alocare medie la ridicare',
    'Quarter Partner Score': 'Scorul trimestrial al partenerului',
    'Payment delay: +{{days}} days': 'Întârziere la plată: +{{days}} zile',
    'Penalty events': 'Evenimente de penalizare',
    Current: 'Curent',
    'Completed orders per period': 'Comenzi finalizate pe perioadă',
    'Completed orders': 'Comenzi finalizate',
    'Truck CMR status alerts': 'Alerte de stare CMR pentru camion',
    '{{count}} truck(s) have expired CMR insurance.':
      'Camioanele {{count}} au asigurarea CMR expirată.',
    '{{count}} truck(s) will expire within 14 days.':
      'Camioanele {{count}} vor expira în 14 zile.',
    '{{count}} truck(s) are missing CMR expiry date.':
      'Camioanelor {{count}} lipsește data de expirare CMR.',
    'Upload a new CMR Insurance in Fleet. The truck will stay pending until admin review.':
      'Încărcați o nouă factură CMR în Fleet. Camionul va rămâne în așteptare până la examinarea de către administrator.',
    'Open fleet to resolve CMR alerts':
      'Deschideți flota pentru a rezolva alertele CMR',
    'Operational actions': 'Acțiuni operaționale',
    'Open marketplace orders': 'Comenzi pe piață deschisă',
    'Review available orders and plan assignments.':
      'Examinați comenzile disponibile și planificați sarcinile.',
    'My accepted orders': 'Comenzile mele acceptate',
    'Manage delivery progress and documents.':
      'Gestionați progresul livrării și documentele.',
    'Update trucks, trailers, and availability.':
      'Actualizați camioanele, remorcile și disponibilitatea.',
    'Partner invoices': 'Facturi pentru parteneri',
    'Upload and track invoice payments.':
      'Încărcați și urmăriți plățile facturilor.',
    'No active orders in queue.': 'Nu există comenzi active în coadă.',
    'profile.incompleteTitle': 'Profil incomplet',
    'profile.incompleteDescription':
      'Vă rugăm să completați informațiile de profil (Companie, Telefon, Adresă, Oraș, Cod poștal) pentru a accesa toate funcțiile.',
    'profile.goToProfile': 'Accesați Profil',
    'auth.email_placeholder': 'nume@company.com',
    'auth.authentication_mode_switch': 'Comutator de mod de autentificare',
    'auth.invalid_email': 'E-mail nevalid',
    'auth.please_enter_a_valid_email_address':
      'Vă rugăm să introduceți o adresă de e-mail validă.',
    'auth.email_not_found': 'E-mail nu a fost găsit',
    'auth.no_account_found_with_that_email_address':
      'Nu s-a găsit niciun cont cu acea adresă de e-mail.',
    'auth.email_sent': 'Email trimis!',
    'auth.something_went_wrong_try_again':
      'Ceva a mers prost. Încearcă din nou.',
    'auth.we_sent_a_password_reset_link_open_your_inbox_and_follow_the_instructions':
      'Am trimis un link de resetare a parolei. Deschideți căsuța de e-mail și urmați instrucțiunile.',
    'auth.forgot_your_password': 'Ați uitat parola?',
    'auth.enter_your_account_email_and_we_will_send_you_a_password_reset_link':
      'Introduceți e-mailul contului și vă vom trimite un link de resetare a parolei.',
    'auth.email_address': 'Adresă de e-mail',
    'auth.send_reset_link': 'Trimite linkul de resetare',
    'auth.cancel': 'Anulează',
    'auth.tip_if_you_do_not_receive_the_email_check_spam_and_promotions_folders':
      'Sfat: dacă nu primiți e-mailul, verificați dosarele de spam și promoții.',
    'booking.e_g_berlin': 'de ex. Berlin',
    'booking.e_g_germany': 'de ex. Germania',
    'booking.watchlist': 'Lista de urmărire',
    'booking.view_map': 'Vizualizați harta',
    'booking.invalid_input': 'Intrare nevalidă',
    'booking.please_enter_only_numbers_for_the_zip_code':
      'Vă rugăm să introduceți numai numere pentru codul poștal.',
    'booking.pickup_zip_code': 'Cod poștal de ridicare',
    'booking.delivery_zip_code': 'Cod poștal de livrare',
    'booking.select_vehicle_make': 'Selectați marca vehiculului',
    'booking.unnamed_item': 'Element fără nume',
    'booking.cars': 'mașini',
    'booking.more_info': 'Mai multe informații',
    'booking.loading': 'Se încarcă...',
    'booking.no_items_found': 'Nu s-au găsit articole',
    'booking.selected_cars': 'Mașini alese',
    'booking.unknown_type': 'Tip necunoscut',
    'booking.delete_car': 'Șterge mașina',
    'Toggle details': 'Comutați detaliile',
    'auth.a_verification_email_has_been_sent_to_your_email_address_please_verify_your_emai':
      'Un e-mail de verificare a fost trimis la adresa dvs. de e-mail. Vă rugăm să vă verificați adresa de e-mail înainte de a vă autentifica.',
    'auth.an_unexpected_error_occurred_please_try_again':
      'A apărut o eroare neașteptată. Vă rugăm să încercați din nou.',
    'auth.client': 'Client',
    'auth.email': 'E-mail',
    'auth.failed_to_resend_email': 'E-mailul nu a fost retrimis',
    'auth.show_password': 'Afișați parola',
    'auth.hide_password': 'Ascunde parola',
    'auth.incorrect_password_please_try_again':
      'Parolă incorectă. Vă rugăm să încercați din nou.',
    'auth.invalid_email_or_password_please_check_your_credentials_and_try_again':
      'E-mail sau parolă nevalidă. Vă rugăm să vă verificați acreditările și să încercați din nou.',
    'auth.network_error_check_your_connection_and_try_again':
      'Eroare de rețea. Verificați conexiunea și încercați din nou.',
    'auth.no_account_found_with_this_email':
      'Nu s-a găsit niciun cont cu acest e-mail.',
    'auth.please_check_your_inbox':
      'Vă rugăm să vă verificați căsuța de e-mail.',
    'auth.please_make_sure_both_passwords_are_the_same':
      'Vă rugăm să vă asigurați că ambele parole sunt aceleași.',
    'auth.please_sign_in_to_resend_the_verification_email':
      'Vă rugăm să vă conectați pentru a retrimite e-mailul de verificare.',
    'auth.resend_verification_email': 'Retrimiteți e-mailul de verificare',
    'auth.awaiting_verification_artwork': 'Se așteaptă verificarea ilustrației',
    'auth.email_verification_required': 'Este necesară verificarea e-mailului',
    'auth.waiting_for_email_verification': 'Se așteaptă verificarea e-mailului',
    'auth.check_your_email': 'Verifică-ți e-mailul',
    'auth.we_sent_your_verification_link_to':
      'Am trimis linkul dvs. de verificare la',
    'auth.didnt_receive_it_check_spam_or_try_again':
      'Nu l-ai primit? Verificați folderul de spam sau încercați din nou.',
    'auth.resend_email': 'Retrimiteți e-mailul',
    'auth.i_verified_my_email': 'Mi-am verificat adresa de e-mail',
    'auth.redirecting_you_now': 'Te redirecționează acum.',
    'auth.email_not_verified_yet': 'E-mail neverificat încă',
    'auth.please_click_the_link_in_your_inbox_and_try_again':
      'Dați clic pe linkul din căsuța dvs. de e-mail și încercați din nou.',
    'auth.unable_to_resend_verification_email_right_now':
      'Nu se poate retrimite e-mailul de verificare în acest moment.',
    'auth.unable_to_check_verification_status_right_now':
      'Nu se poate verifica starea verificării în acest moment.',
    'auth.we_sent_a_new_verification_link':
      'Am trimis un nou link de verificare la adresa ta de e-mail.',
    'auth.we_automatically_check_every_30_seconds':
      'Verificăm automat starea dvs. de verificare la fiecare 30 de secunde. De asemenea, puteți declanșa o verificare instantanee după verificarea e-mailului.',
    'auth.we_automatically_check_every_15_seconds':
      'Verificăm automat starea dvs. de verificare la fiecare 15 secunde. De asemenea, puteți declanșa o verificare instantanee după verificarea e-mailului.',
    'auth.the_email_address_is_not_valid': 'Adresa de e-mail nu este validă.',
    'auth.this_account_has_been_disabled': 'Acest cont a fost dezactivat.',
    'auth.too_many_failed_attempts_please_try_again_later_or_reset_your_password':
      'Prea multe încercări eșuate. Vă rugăm să încercați din nou mai târziu sau să vă resetați parola.',
    'auth.verification_email_resent':
      'E-mailul de verificare a fost retransmis!',
    'auth.you_need_to_log_in_first': 'Mai întâi trebuie să vă conectați',
    'booking.email': 'E-mail',
    'booking.error_fetching_data': 'Eroare la preluarea datelor',
    'booking.inputs_changed_recalculate_the_price':
      'Intrările s-au schimbat. Recalculați prețul.',
    'booking.kg': 'kg',
    'booking.km': 'km',
    'booking.mi': 'mi',
    'booking.no_opening_hours_provided': 'Nu sunt furnizate ore de deschidere',
    'booking.no_vehicles_listed': 'Nu există vehicule listate',
    'booking.not_available': 'Nu este disponibil',
    'booking.not_set': 'Nu setat',
    'booking.please_select_a_planned_date':
      'Vă rugăm să selectați o dată planificată',
    'booking.required': 'Necesar',
    'booking.to': 'la',
    'booking.total': 'total',
    'booking.order': 'Comanda',
    'booking.duration': 'Durata',
    'booking.vehicles_overview': 'Prezentare generală a vehiculelor',
    'booking.body': 'Corpul',
    'booking.dims': 'Dims',
    'booking.select_vehicle_model': 'Selectați modelul vehiculului',
    'booking.selected_type_value': 'Selectat: {{value}}',
    'booking.select_a_vehicle_type': 'Selectați un tip de vehicul:',
    'booking.select_vehicle_weight': 'Selectați greutatea vehiculului',
    'booking.selected_weight_kg': 'Selectat: {{value}} kg',
    'booking.adjust_weight': 'Reglați greutatea',
    'Dates updated successfully': 'Datele au fost actualizate cu succes',
    'Error updating dates': 'Eroare la actualizarea datelor',
    'Set Planned Dates': 'Stabiliți Date planificate',
    'Set your planned pickup and arrival dates below.':
      'Setați mai jos datele planificate de preluare și sosire.',
    'Changing dates after initial setup will deduct 20% from your performance score for this order.':
      'Modificarea datelor după configurarea inițială va deduce 20% din scorul dvs. de performanță pentru această comandă.',
    'Planned Pickup Date': 'Data planificată de ridicare',
    'Planned Arrival Date': 'Data planificată de sosire',
    Listing: 'Listare',
    'Try broadening the current search or status filter.':
      'Încercați să extindeți căutarea curentă sau filtrul de stare.',
    'Try broadening the search, role, or status filters.':
      'Încercați să extindeți filtrele de căutare, rol sau stare.',
    'Monitor fleet compliance, validation status, and expiring insurance in one place.':
      'Monitorizați conformitatea flotei, starea de validare și asigurarea care expiră într-un singur loc.',
    'Active Listings': 'Listări active',
    'Open transport requests': 'Cereri de transport deschise',
    'Quotes Today': 'Citate Azi',
    'Submitted in last 24h': 'Trimis în ultimele 24 de ore',
    'Platform Revenue (MTD)': 'Venitul platformei (MTD)',
    'Month to date': 'Lună până în prezent',
    'Pending Partners': 'Parteneri în așteptare',
    'Awaiting approval': 'În așteptarea aprobării',
    'Unpaid Invoices': 'Facturi neplătite',
    'Requires action': 'Necesită acțiune',
    'Completed Transports': 'Transporturi finalizate',
    'All time delivered': 'Tot timpul livrat',
    'Admin Dashboard': 'Tabloul de bord administrativ',
    'Platform overview and key performance indicators.':
      'Prezentare generală a platformei și indicatori cheie de performanță.',
    'Loading dashboard metrics...': 'Se încarcă valorile tabloului de bord...',
    Invoices: 'Facturi',
    'Review payout invoices uploaded by partners and keep payout processing organized.':
      'Examinați facturile de plată încărcate de parteneri și mențineți organizarea procesării plăților.',
    Flexible: 'Flexibil',
    'Flexible dates': 'Date flexibile',
    'Could not load this listing.': 'Nu s-a putut încărca această listă.',
    'Listing canceled': 'Listare anulată',
    'Failed to cancel listing': 'Nu s-a putut anula înregistrarea',
    Reference: 'Referință',
    Category: 'categorie',
    'Client type': 'Tipul de client',
    'Company country': 'Țara companiei',
    Expires: 'Expiră',
    'Back to listings': 'Înapoi la listări',
    'Listing not found.': 'Lista nu a fost găsită.',
    'Cancel Listing': 'Anulează înregistrarea',
    'Listing details': 'Detalii listare',
    'Reference {{id}}': 'Referință {{id}}',
    'Read-only listing overview for admins.':
      'Prezentare generală numai în citire pentru administratori.',
    'Pick-up': 'Ridicare',
    'No exact coordinates are stored for this listing yet.':
      'Nu sunt încă stocate coordonate exacte pentru această listă.',
    'Structured overview of quantities and handling details.':
      'Prezentare generală structurată a cantităților și detaliilor de manipulare.',
    'Shipment images': 'Imagini de expediere',
    'No shipment images were uploaded for this listing.':
      'Nu au fost încărcate imagini de expediere pentru această listă.',
    'Proof of pickup': 'Dovada ridicării',
    'Final documents': 'Documente finale',
    Description: 'Descriere',
    'Quotes ({{count}})': 'Citate ({{count}})',
    'Loading quotes...': 'Se încarcă citatele...',
    'No quotes for this listing.': 'Fără ghilimele pentru această listă.',
    'Score: {{score}}/100': 'Scor: {{score}}/100',
    'Pickup: {{date}}': 'Ridicare: {{date}}',
    'Delivery: {{date}}': 'Livrare: {{date}}',
    'Cancel Listing?': 'Anulați înregistrarea?',
    'This will permanently cancel the listing and notify the client. Continue?':
      'Acest lucru va anula definitiv listarea și va notifica clientul. Continua?',
    Keep: 'Păstrează',
    'Review partner applications, check their documents, and keep approval decisions consistent.':
      'Examinați cererile partenerilor, verificați documentele acestora și mențineți coerente deciziile de aprobare.',
    'No client payments recorded yet':
      'Nu au fost înregistrate încă plăți ale clienților',
    'Client payment rows will appear here when the payments backend is connected.':
      'Rândurile de plată ale clienților vor apărea aici când backend-ul de plăți este conectat.',
    Method: 'Metoda',
    'No partner payouts recorded yet':
      'Nu s-au înregistrat încă plăți pentru parteneri',
    'Payout rows will appear here once partner payout processing is enabled.':
      'Rândurile de plată vor apărea aici odată ce procesarea plăților partenerului este activată.',
    'Payout Amount': 'Suma de plată',
    'No platform fees recorded yet':
      'Nu au fost încă înregistrate taxe de platformă',
    'Fee rows will appear here once payment settlement data is available.':
      'Rândurile de taxe vor apărea aici după ce datele de decontare a plăților sunt disponibile.',
    Gross: 'Brut',
    'Fee (20%)': 'Taxa (20%)',
    Payments: 'Plăți',
    'Client payments, partner payouts, and platform fee tracking.':
      'Plățile clienților, plățile partenerilor și urmărirea taxelor de platformă.',
    'Client Payments': 'Plățile clienților',
    'Partner Payouts': 'Plăți pentru parteneri',
    'Platform Fees': 'Taxe de platformă',
    'Failed to load reviews': 'Nu s-au încărcat recenziile',
    'Review removed': 'Recenzia a fost eliminată',
    'Failed to remove review': 'Recenzia nu a fost eliminată',
    Reviews: 'Recenzii',
    'All partner and transport reviews submitted by clients.':
      'Toate recenziile pentru parteneri și transport trimise de clienți.',
    'Loading reviews...': 'Se încarcă recenziile...',
    'No reviews found': 'Nu au fost găsite recenzii',
    'Client feedback will appear here when reviews are submitted.':
      'Feedbackul clienților va apărea aici când sunt trimise recenzii.',
    Stars: 'Stele',
    Comment: 'Comentariu',
    'Search, review, and maintain user accounts with one consistent admin workflow.':
      'Căutați, examinați și mențineți conturile de utilizator cu un singur flux de lucru administrativ consecvent.',
    'Track paid and unpaid partner payout invoices, and upload the next delivered listing invoice quickly.':
      'Urmăriți facturile plătite și neplătite ale partenerilor și încărcați rapid următoarea factură de înregistrare livrată.',
    'Search by invoice number, file name, or listing ID':
      'Căutați după numărul facturii, numele fișierului sau ID-ul listării',
    'Loading delivered listings...': 'Se încarcă listele livrate...',
    'Search delivered listing by reference, title, or route':
      'Căutați lista livrată după referință, titlu sau traseu',
    'Route details available in listing':
      'Detalii despre traseu disponibile în listare',
    'No matching delivered listings': 'Nu se potrivește înregistrări livrate',
    'Selected listing': 'Lista selectată',
    'Has quotes': 'Are ghilimele',
    'In transit': 'În tranzit',
    Open: 'Deschide',
    Accepted: 'Acceptat',
    Completed: 'Terminat',
    'Client Dashboard': 'Tabloul de bord client',
    'Overview of your current transport listings, quote activity, and recent requests.':
      'Prezentare generală a listelor dvs. actuale de transport, a activității de cotație și a solicitărilor recente.',
    'Total listings': 'Total listări',
    'Active listings': 'Listări active',
    'Listings with quotes': 'Listări cu ghilimele',
    'Accepted transport': 'Transport acceptat',
    'Listing status timeline': 'Cronologie privind starea listării',
    'Last 6 months of listings grouped by current status.':
      'Ultimele 6 luni de listări grupate după starea actuală.',
    'No listing activity yet': 'Nicio activitate de înregistrare încă',
    'Create your first listing to start tracking request activity here.':
      'Creați-vă prima înregistrare pentru a începe să urmăriți activitatea de solicitare aici.',
    'Create new listing': 'Creați o nouă înregistrare',
    'Create a new transport request for the marketplace.':
      'Creați o nouă cerere de transport pentru piață.',
    'View my listings': 'Vizualizați înregistrările mele',
    'Review quote activity and manage your transport requests.':
      'Examinați activitatea de cotație și gestionați-vă cererile de transport.',
    'Recent listings': 'Listări recente',
    'No listings yet': 'Nicio listă încă',
    'Your newest transport requests will appear here once you create them.':
      'Cele mai noi solicitări de transport vor apărea aici după ce le creați.',
    'Unknown origin': 'Origine necunoscută',
    '{{count}} quote(s)': '{{count}} cotație(e)',
    '{{value}} completed listings': '{{value}} înregistrări finalizate',
    'Monitor current performance, fleet readiness, quote flow, and your active transport queue.':
      'Monitorizați performanța actuală, pregătirea flotei, fluxul de cotații și coada dvs. de transport activă.',
    'Total assigned': 'Total atribuit',
    'Quarter rating': 'Evaluare trimestrială',
    'Based on current quarter performance':
      'Pe baza performanței trimestrului curent',
    Rating: 'Evaluare',
    'Requirement met': 'Cerință îndeplinită',
    'Requirement not met': 'Cerința nu este îndeplinită',
    'Completed listings per period': 'Listări finalizate pe perioadă',
    'No completion data yet': 'Nu există date de finalizare încă',
    'Statistics will appear here after your first delivered work.':
      'Statisticile vor apărea aici după prima lucrare livrată.',
    'Completed listings': 'Listări finalizate',
    'Review truck documents and refresh anything close to expiry.':
      'Examinați documentele camionului și reîmprospătați orice este aproape de expirare.',
    'Search deliveries': 'Căutați livrări',
    'Review available marketplace listings and submit quotes.':
      'Examinați listele de pe piață disponibile și trimiteți oferte.',
    'My quotes': 'Citatele mele',
    'Track accepted, pending, and rejected quotes in one place.':
      'Urmăriți ofertele acceptate, în așteptare și respinse într-un singur loc.',
    'Profile settings': 'Setări profil',
    'Keep company information and compliance details up to date.':
      'Păstrați informațiile despre companie și detaliile de conformitate actualizate.',
    'No active queue items': 'Nu există elemente active în coadă',
    'Accepted and in-progress work will appear here as your transport activity grows.':
      'Lucrările acceptate și în curs vor apărea aici pe măsură ce activitatea dvs. de transport crește.',
    'Your role does not have permission to open this page.':
      'Rolul dumneavoastră nu are permisiunea de a deschide această pagină.',
    'Go to dashboard': 'Accesați tabloul de bord',
    'Trailer capacity is required.': 'Capacitatea remorcii este necesară.',
    'How many cars can this trailer carry?':
      'Câte mașini poate transporta această remorcă?',
    'Set maximum number of cars this trailer can carry (1-20).':
      'Setați numărul maxim de mașini pe care le poate transporta această remorcă (1-20).',
    'Invalid max load (kg).': 'Sarcina maximă nevalidă (kg).',
    'Enter a valid weight between 1 and 100000 kg, or leave it empty.':
      'Introduceți o greutate valabilă între 1 și 100000 kg sau lăsați-o goală.',
    'Maximum payload weight this truck can carry (optional).':
      'Greutatea maximă a încărcăturii pe care acest camion o poate transporta (opțional).',
    'Manage the company and contact details that appear across your listings, invoices, and account verification flows.':
      'Gestionați compania și detaliile de contact care apar în înregistrările, facturile și fluxurile de verificare a contului.',
    'Keep these details up to date so listings, invoices, and partner verification stay accurate.':
      'Păstrați aceste detalii la zi, astfel încât înregistrările, facturile și verificarea partenerilor să rămână exacte.',
    'Unsaved changes': 'Modificări nesalvate',
    'All changes saved': 'Toate modificările au fost salvate',
    'auth.sign_up_failed': 'Înregistrarea a eșuat',
    'auth.please_select_a_valid_role': 'Vă rugăm să selectați un rol valid.',
    'booking.pickup_not_found': 'Ridicare nu a fost găsită.',
    'booking.delivery_not_found': 'Livrarea nu a fost găsită.',
    'booking.capacity': 'Capacitate',
    'booking.cmr_expiry': 'CMR expirare',
    'booking.uploaded': 'Încărcat',
    'booking.missing': 'Lipsă',
    'booking.cmr_document': 'Document CMR',
    'booking.go_to_profile': 'Accesați Profil',
    'booking.click_to_download_purchase_terms':
      'Faceți clic pentru a descărca Termenii de achiziție',
    'admin.purchase_terms_management': 'Gestionarea condițiilor de achiziție',
    'admin.purchase_terms_management_subtitle':
      'Încărcați și mențineți PDF-uri localizate privind Termenii de achiziție utilizate în acceptarea comenzilor partenere.',
    'admin.document_language': 'Limba documentului',
    'admin.click_to_download_purchase_terms':
      'Faceți clic pentru a descărca Termenii de achiziție',
    'admin.current_language_label': 'Limba curentă: {{language}}',
    'admin.purchase_terms_unavailable_for_selected_language':
      'Documentul privind condițiile de achiziție nu este disponibil pentru limba selectată.',
    'Download and review the active purchase terms in your current interface language before continuing.':
      'Descărcați și examinați termenii de achiziție activi în limba actuală a interfeței înainte de a continua.',
    'We make agreements and conclude a contract for the carriage of goods. I have just read this agreement in full and agree to its contents.':
      'Facem acorduri și încheiem un contract de transport de mărfuri. Tocmai am citit integral acest acord și sunt de acord cu conținutul acestuia.',
    'I confirm that I will schedule this order within 24 hours':
      'Confirm că voi programa această comandă în 24 de ore',
    'Failed to load purchase terms document.':
      'Nu s-a încărcat documentul privind condițiile de cumpărare.',
    'Partner rating': 'Evaluare partener',
    'Bronze requirements': 'Cerințe de bronz',
    'Orders in quarter': 'Comenzi in trimestru',
    'Cancellation rate / 100 orders': 'Rata de anulare / 100 comenzi',
    'Damage claims / 100 orders': 'Reclamații de daune / 100 de comenzi',
    '{{current}} / min {{target}}': '{{current}} / min {{target}}',
    '{{current}} / max {{target}}': '{{current}} / max {{target}}',
    Met: 'Met',
    'Not met': 'Neîntâlnit',
    Unranked: 'Neclasat',
    'profile.incompleteDescriptionPartner':
      'Vă rugăm să completați informațiile de profil (companie, telefon, adresă, oraș, cod poștal, număr de TVA) pentru a accesa toate funcțiile.',
    'profile.incompleteDescriptionClient':
      'Vă rugăm să completați informațiile de profil (Număr de telefon) pentru a accesa toate funcțiile.',
    'auth.verification_email_sent': 'E-mail de verificare trimis',
    '{{amount}} above the client target': '{{amount}} peste ținta clientului',
    '{{amount}} below the client target': '{{amount}} sub ținta clientului',
    '{{count}} image(s) added to the listing.':
      '{{count}} imagini adăugate în listă.',
    '{{count}} quote(s) received': '{{count}} cotație(e) primite',
    '{{count}} reviews': '{{count}} recenzii',
    '{{count}} total': '{{count}} total',
    '{{count}} visible': '{{count}} vizibil',
    '{{weight}} kg': '{{weight}} kg',
    'A Google route preview with pins A and B appears here once pickup and delivery coordinates are available.':
      'O previzualizare a rutei Google cu pinii A și B apare aici odată ce coordonatele de ridicare și livrare sunt disponibile.',
    'A route preview appears once map coordinates are available.':
      'O previzualizare a rutei apare când coordonatele hărții sunt disponibile.',
    'A timeline of clarifications connected to this listing.':
      'O cronologie a clarificărilor legate de această listă.',
    'Accept Listing': 'Acceptați listarea',
    'Accept quote': 'Accept citatul',
    'Accepted quote': 'Citat acceptat',
    'Accepted quote required': 'Se cere o ofertă acceptată',
    'Accepting...': 'Se acceptă...',
    Active: 'Activ',
    'Active statuses': 'Stare active',
    'Add another item': 'Adăugați un alt articol',
    'Add images': 'Adăugați imagini',
    'Add more shipment images': 'Adăugați mai multe imagini de expediere',
    'After you confirm an AI action, open the prepared destination immediately instead of waiting for a manual click.':
      'După ce confirmați o acțiune AI, deschideți imediat destinația pregătită în loc să așteptați un clic manual.',
    'AI Assistant': 'Asistent AI',
    'AI assistant disabled for all users.':
      'Asistentul AI este dezactivat pentru toți utilizatorii.',
    'AI assistant enabled for all users.':
      'Asistent AI activat pentru toți utilizatorii.',
    'AI assistant preferences updated':
      'Preferințele asistentului AI au fost actualizate',
    'AI disabled for user.': 'AI dezactivat pentru utilizator.',
    'AI enabled for user.': 'AI activat pentru utilizator.',
    'AI-powered message translation between languages':
      'Traducerea mesajelor bazată pe inteligență artificială între limbi',
    'All route-critical information in one place before you review quotes or documents.':
      'Toate informațiile critice pentru traseu într-un singur loc înainte de a examina ofertele sau documentele.',
    View: 'Vizualizați',
    Answer: 'Raspunde',
    Archive: 'Arhiva',
    'Archived statuses': 'Stări arhivate',
    'Are you sure you want to reject the quote from':
      'Sigur vrei să respingi citatul de la',
    'Ask a question about this listing...':
      'Pune o întrebare despre această listă...',
    'Ask for matching lanes, quote help, or the next operational step.':
      'Solicitați benzi potrivite, ajutor pentru cotație sau următorul pas operațional.',
    'Ask for quote comparisons or a prepared next step from this shipment screen.':
      'Solicitați comparații de cotație sau un următor pas pregătit din acest ecran de expediere.',
    'Assistant history cleared': 'Istoricul asistentului a fost șters',
    'Automatically translate messages from other users into your preferred language using AI.':
      'Traduceți automat mesajele de la alți utilizatori în limba dvs. preferată folosind AI.',
    'Back to listing': 'Înapoi la listare',
    'Best offer': 'Cea mai buna oferta',
    'Best quote': 'Cel mai bun citat',
    'Body type: {{type}}': 'Tip caroserie: {{type}}',
    'Breed: {{breed}}': 'Rasa: {{breed}}',
    Budget: 'Buget',
    'Cancel listing': 'Anulează înregistrarea',
    'Canceled and completed work will appear here once listings move out of the active view.':
      'Lucrările anulate și finalizate vor apărea aici odată ce listele vor ieși din vizualizarea activă.',
    'Cargo Details': 'Detalii de marfă',
    Categories: 'Categorii',
    'Choose the interface language. This preference is saved locally and applies immediately.':
      'Alegeți limba interfeței. Această preferință este salvată local și se aplică imediat.',
    'Clear all': 'Ștergeți totul',
    'Clear assistant history': 'Ștergeți istoricul asistentului',
    'Client price in EUR': 'Pretul clientului in EUR',
    'Client target price': 'Prețul țintă pentru client',
    'Complete the payment below to lock the fixed-price acceptance and let the partner start planning.':
      'Finalizați plata de mai jos pentru a bloca acceptarea la preț fix și a lăsa partenerul să înceapă planificarea.',
    'Complete the payment below to lock the selected quote and let the partner start planning.':
      'Finalizați plata de mai jos pentru a bloca oferta selectată și a lăsa partenerul să înceapă planificarea.',
    'Compose area prepared for listing Q&A. Submission remains disabled until the live question endpoint is connected on this page.':
      'Compuneți zona pregătită pentru listarea de întrebări și răspunsuri. Trimiterea rămâne dezactivată până când punctul final al întrebării live este conectat pe această pagină.',
    'Confirm delivery complete': 'Confirmați livrarea finalizată',
    'Confirm payment received': 'Confirmați plata primită',
    'Confirm that you have received the bank transfer or payment for this listing. This will move the listing to Paid status and allow the partner to mark it as planned.':
      'Confirmați că ați primit transferul bancar sau plata pentru această înregistrare. Aceasta va muta înregistrarea în starea Plătit și va permite partenerului să o marcheze așa cum a fost planificată.',
    'Confirm the exact fleet and dates before the listing moves to Planned.':
      'Confirmați flota exactă și datele înainte ca listarea să fie mutată în Planificat.',
    'Confirm Transport Plan': 'Confirmați planul de transport',
    'Confirming...': 'Se confirmă...',
    'Control how the web assistant behaves on this device. These settings do not change your account data.':
      'Controlați modul în care se comportă asistentul web pe acest dispozitiv. Aceste setări nu schimbă datele contului dvs.',
    'Create listing': 'Creați o listă',
    'Create with AI': 'Creați cu AI',
    'Create your next transport request and it will appear here with route, item, and quote activity.':
      'Creați următoarea cerere de transport și va apărea aici cu ruta, articolul și activitatea de cotație.',
    'Current stage:': 'Etapa curentă:',
    'Current status': 'Starea actuală',
    'Delivery confirmation needed': 'Este necesară confirmarea livrării',
    'Delivery radius': 'Raza de livrare',
    'Delivery:': 'Livrare:',
    'Describe the route and cargo, then review the prepared listing draft before publishing.':
      'Descrieți ruta și încărcătura, apoi examinați proiectul de listă pregătit înainte de publicare.',
    'Describe the shipment you need and review the prepared request before publishing.':
      'Descrieți expedierea de care aveți nevoie și examinați solicitarea pregătită înainte de a o publica.',
    'Download and review the purchase terms before confirming the transport plan.':
      'Descărcați și examinați termenii de achiziție înainte de a confirma planul de transport.',
    'Download invoice': 'Descărcați factura',
    'Download Purchase Terms': 'Descărcați Termenii de achiziție',
    'Draft with AI': 'Schiță cu AI',
    'Draft your review first, then submit it here when you are satisfied.':
      'Scrieți mai întâi recenzia, apoi trimiteți-o aici când sunteți mulțumit.',
    'Edit listing': 'Editați înregistrarea',
    'Edit Quote': 'Editați citatul',
    Enable: 'Activați',
    'Enable live translation': 'Activați traducerea live',
    'Enabled Users': 'Utilizatori activați',
    'Engagement Activity': 'Activitate de implicare',
    'Expires:': 'Expiră:',
    'Failed to accept listing': 'Nu s-a acceptat înregistrarea',
    'Failed to accept quote': 'Nu s-a acceptat oferta',
    'Failed to clear assistant history': 'Istoricul asistentului nu s-a șters',
    'Failed to complete listing': 'Nu s-a finalizat înregistrarea',
    'Failed to confirm payment': 'Nu s-a confirmat plata',
    'Failed to confirm transport plan': 'Nu s-a confirmat planul de transport',
    'Failed to disable AI for user.':
      'Nu s-a putut dezactiva AI pentru utilizator.',
    'Failed to enable AI for user.': 'Nu s-a activat AI pentru utilizator.',
    'Failed to load listing.': 'Nu s-a putut încărca lista.',
    'Failed to load listings': 'Nu s-au încărcat înregistrările',
    'Failed to load listings. Please try again.':
      'Nu s-au încărcat înregistrările. Vă rugăm să încercați din nou.',
    'Failed to load review context.': 'Nu s-a încărcat contextul recenziei.',
    'Failed to load settings.': 'Nu s-au încărcat setările.',
    'Failed to refresh Stripe payment status':
      'Nu s-a reîmprospătat starea plății Stripe',
    'Failed to reject quote': 'Cotația nu a fost respinsă',
    'Failed to release listing': 'Nu s-a putut elibera lista',
    'Failed to save quote': 'Nu s-a salvat cotația',
    'Failed to update listing': 'Nu s-a putut actualiza înregistrarea',
    'Failed to update preferred language':
      'Nu s-a putut actualiza limba preferată',
    'Failed to update setting.': 'Setarea nu a fost actualizată.',
    'Failed to update status': 'Nu s-a putut actualiza starea',
    'Failed to update translation preference':
      'Nu s-a putut actualiza preferința de traducere',
    'Failed to update watchlist': 'Nu s-a putut actualiza lista de urmărire',
    'Failed to withdraw quote': 'Cotația nu a fost retrasă',
    'Feature Flags': 'Caracteristici Steaguri',
    'Filter invoice uploads, search by reference, and page through payout records.':
      'Filtrați încărcările facturilor, căutați după referință și parcurgeți înregistrările de plată.',
    Filters: 'Filtre',
    'Final delivery documents': 'Documente finale de livrare',
    'Fixed price only': 'Doar preț fix',
    'Flexible / not set': 'Flexibil/nu setat',
    'Generated automatically when the transport plan is confirmed.':
      'Generat automat la confirmarea planului de transport.',
    'Generation: {{generation}}': 'Generație: {{generation}}',
    'Goods delivered — awaiting client confirmation.':
      'Bunuri livrate — în așteptarea confirmării clientului.',
    'Gross price': 'Preț brut',
    'I have read and agree to the purchase terms for this transport job.':
      'Am citit și sunt de acord cu condițiile de achiziție pentru acest job de transport.',
    'I understand that accepting this listing assigns it to me at the fixed client price shown above.':
      'Înțeleg că acceptând această listă mi-o atribuie la prețul client fix afișat mai sus.',
    'Image upload failed': 'Încărcarea imaginii a eșuat',
    'Images uploaded': 'Imaginile încărcate',
    'Interface language': 'Limbajul interfeței',
    'Invoice documents': 'Documente de facturare',
    'Item {{number}}': 'Articol {{number}}',
    items: 'articole',
    'Keep listing': 'Continuați listarea',
    'Keep quote': 'Păstrați citatul',
    'Keep the current AI session available after closing the browser on this device.':
      'Păstrați disponibilă sesiunea curentă AI după închiderea browserului de pe acest dispozitiv.',
    'Language & Region': 'Limbă și regiune',
    'Lift: {{origin}} / {{destination}}': 'Lift: {{origin}} / {{destination}}',
    Listed: 'Listată',
    'Listing {{id}}': 'Listare {{id}}',
    'Listing accepted': 'Listare acceptată',
    'Listing expired': 'Lista a expirat',
    'Listing images': 'Listarea imaginilor',
    'Listing is live': 'Listarea este live',
    'Listing reference': 'Referință de listă',
    'Listing snapshot': 'Instantaneu înregistrării',
    'Listing unavailable': 'Listare indisponibilă',
    'Listing updated': 'Listare actualizată',
    'Live Translation': 'Traducere live',
    'Live translation disabled.': 'Traducerea live a fost dezactivată.',
    'Live translation enabled.': 'Traducerea live este activată.',
    'Loading approved trucks...': 'Se încarcă camioane aprobate...',
    'Loading fleet...': 'Se încarcă flota...',
    'Loading listing details...': 'Se încarcă detaliile anunțului...',
    'Loading listings...': 'Se încarcă listele...',
    'Loading review details...': 'Se încarcă detaliile recenziei...',
    'Loading settings...': 'Se încarcă setările...',
    'Manage AI Assistant Users': 'Gestionați utilizatorii AI Assistant',
    'Manage platform-wide feature flags and configuration.':
      'Gestionați indicatoarele și configurația caracteristicilor la nivel de platformă.',
    'Manage Users': 'Gestionați utilizatorii',
    'Manage your transport requests, monitor quote activity, and keep active and archived work easy to scan.':
      'Gestionați-vă cererile de transport, monitorizați activitatea de cotație și mențineți munca activă și arhivată ușor de scanat.',
    'Mark Picked Up': 'Mark a ridicat',
    'Matches the client target price':
      'Se potrivește cu prețul țintă al clientului',
    Media: 'Media',
    Messages: 'Mesaje',
    'Messages will be translated into this language.':
      'Mesajele vor fi traduse în această limbă.',
    'Minimum net:': 'Net minim:',
    'My invoices': 'Facturile mele',
    Net: 'Net',
    'Net price': 'Preț net',
    'Net quote': 'Cotația netă',
    'New images appear immediately in the listing details for client, partner, and admin views.':
      'Imagini noi apar imediat în detaliile listării pentru vizualizările client, partener și administrator.',
    'Next step': 'Următorul pas',
    'No active listings yet': 'Nicio listă activă încă',
    'No address provided': 'Nu este furnizată nicio adresă',
    'No answer yet.': 'Niciun răspuns încă.',
    'No archived listings yet': 'Nicio listă arhivată încă',
    'No description added.': 'Nu a fost adăugată nicio descriere.',
    'no destination': 'nicio destinatie',
    'No expiry': 'Fără expirare',
    'No listings match the current filters. Try broadening the search or date range.':
      'Nicio listă nu se potrivește cu filtrele actuale. Încercați să extindeți căutarea sau intervalul de date.',
    'no origin': 'nici o origine',
    'No questions yet': 'Nicio întrebare încă',
    'No quotes yet': 'Încă nu există ghilimele',
    'No shipment images uploaded yet.':
      'Nu au fost încărcate imagini de expediere încă.',
    'No trailer selected': 'Nicio remorcă selectată',
    'No unread messages': 'Fără mesaje necitite',
    'No users found.': 'Nu s-au găsit utilizatori.',
    'No users have AI enabled.': 'Niciun utilizator nu are AI activat.',
    'Not selected': 'Neselectat',
    'Offers summary': 'Rezumat oferte',
    'Open AI assistant': 'Deschideți asistentul AI',
    'Open prepared screens automatically':
      'Deschide automat ecranele pregătite',
    'Optional visible price shown to partners as your target budget.':
      'Preț vizibil opțional afișat partenerilor ca buget țintă.',
    'Other quotes will be declined automatically once this offer is accepted.':
      'Alte oferte vor fi refuzate automat odată ce această ofertă este acceptată.',
    'Partner delivery': 'Livrare partener',
    'Partner pickup': 'Ridicare partener',
    'Partner quote': 'Citat de partener',
    'Payment confirmed': 'Plata confirmata',
    'Payment confirmed — listing status set to paid':
      'Plată confirmată — starea înregistrării este setată la plătit',
    'Payment confirmed. Confirm the assigned fleet and planned dates before the listing moves to Planned.':
      'Plata confirmata. Confirmați flota alocată și datele planificate înainte ca listarea să fie mutată în Planificat.',
    'Payment is confirmed. The partner now needs to confirm the truck, driver, and planned dates.':
      'Plata este confirmata. Partenerul trebuie acum să confirme camionul, șoferul și datele planificate.',
    'Payment required': 'Este necesară plata',
    'Photos uploaded for the shipment and visible across client, partner, and admin views.':
      'Fotografii încărcate pentru expediere și vizibile în vizualizările client, partener și administrator.',
    'Pickup is complete and the transport is currently underway.':
      'Ridicarea este finalizată, iar transportul este în curs de desfășurare.',
    'Pickup proof': 'Dovada de ridicare',
    'Pickup proof and final delivery files uploaded by the transport partner.':
      'Dovada ridicării și fișierele de livrare finale încărcate de partenerul de transport.',
    'Pickup to delivery overview':
      'Prezentare generală a ridicării până la livrare',
    'Pickup:': 'Ridicare:',
    'Plan and authorization': 'Plan si autorizare',
    'Plan transport': 'Planificați transportul',
    'Plan Transport': 'Planificați transportul',
    'Planned dates:': 'Date planificate:',
    'Planned delivery date': 'Data de livrare planificată',
    'Platform Settings': 'Setări platformă',
    'Preferred language': 'Limba preferată',
    'Preferred language updated': 'Limba preferată a fost actualizată',
    'Prepare a quote or ask for the next lane action, then confirm before anything is submitted.':
      'Pregătiți o ofertă sau cereți următoarea acțiune pe bandă, apoi confirmați înainte de a trimite ceva.',
    'Purchase Terms': 'Condiții de achiziție',
    'Quantities, dimensions, and handling details ready for transport review.':
      'Cantitățile, dimensiunile și detaliile de manipulare sunt gata pentru revizuirea transportului.',
    Question: 'Întrebare',
    Questions: 'Întrebări',
    'Questions & answers': 'Întrebări și răspunsuri',
    'Questions and answers for this listing will appear here once the messaging flow is active.':
      'Întrebările și răspunsurile pentru această listă vor apărea aici odată ce fluxul de mesaje este activ.',
    'Quick access to the current shipment, quote, and billing state.':
      'Acces rapid la starea curentă de expediere, cotație și facturare.',
    'Quote accepted': 'Citat acceptat',
    'Quote count': 'Număr de citate',
    'Quote message': 'Citat mesaj',
    'Quote rejected': 'Citat respins',
    'Quote withdrawn': 'Citat retras',
    Quotes: 'Citate',
    'Quotes and questions': 'Citate și întrebări',
    'Quotes are disabled for this listing. The first partner to accept the fixed price will be assigned automatically.':
      'Citatele sunt dezactivate pentru această listă. Primul partener care acceptă prețul fix va fi atribuit automat.',
    'Quotes are disabled for this shipment. If you accept it, the client price becomes an accepted booking immediately.':
      'Cotațiile sunt dezactivate pentru această expediere. Dacă îl acceptați, prețul clientului devine imediat o rezervare acceptată.',
    'Quotes from transport providers usually begin to appear shortly after publishing. Refresh to check again.':
      'Citatele de la furnizorii de transport încep de obicei să apară la scurt timp după publicare. Actualizează pentru a verifica din nou.',
    'Reference #{{id}}': 'Referință #{{id}}',
    'Refresh listings': 'Actualizează listele',
    'Reject quote': 'Respinge citatul',
    'Rejecting...': 'Se respinge...',
    Release: 'Eliberare',
    'Release Listing': 'Lista de lansare',
    'Remember assistant conversation': 'Amintiți-vă conversația cu asistentul',
    'Required for fixed-price listings. Partners accept this amount directly.':
      'Necesar pentru listele cu preț fix. Partenerii acceptă această sumă direct.',
    'Required. Partners will be able to accept this listing at the fixed client price without sending a quote.':
      'Necesar. Partenerii vor putea accepta această listă la prețul fix pentru client fără a trimite o ofertă.',
    'Review submission failed.': 'Trimiterea revizuirii a eșuat.',
    'Review the completed transport using the standard product flow.':
      'Examinați transportul finalizat folosind fluxul standard de produse.',
    'Route pending': 'Traseu în așteptare',
    'Save changes': 'Salvați modificările',
    'Saving...': 'Se salvează...',
    'Search by title, route, category, or item':
      'Căutați după titlu, traseu, categorie sau articol',
    'Search Results': 'Rezultatele căutării',
    'Search users by email...': 'Căutați utilizatori prin e-mail...',
    'Select a truck, driver, pickup date, and delivery date.':
      'Selectați un camion, șofer, data ridicării și data livrării.',
    'Select approved truck': 'Selectați camionul aprobat',
    'Select driver': 'Selectați șoferul',
    'Send Revision': 'Trimite revizuire',
    Sentiment: 'Sentiment',
    'Share what went well and what could improve':
      'Distribuie ce a mers bine și ce s-ar putea îmbunătăți',
    'Shipment in transit': 'Livrare în tranzit',
    'Shipment notes': 'Note de expediere',
    'Shipment tracking will be shared': 'Urmărirea expedierii va fi partajată',
    'Show AI launchers': 'Afișați lansatoarele AI',
    'Show or hide AI assistant buttons on supported dashboard and listing pages.':
      'Afișează sau ascunde butoanele asistentului AI pe tabloul de bord și paginile de listă acceptate.',
    'Special needs or notes': 'Nevoi speciale sau note',
    'Specify delivery dates': 'Specificați datele de livrare',
    'Specify pickup dates': 'Specificați datele de ridicare',
    Stage: 'Scena',
    'Status updated to {{status}}': 'Starea a fost actualizată la {{status}}',
    'Stripe payment confirmed and booking updated':
      'Plata Stripe confirmată și rezervarea actualizată',
    'Stripe status: {{status}}': 'Stare dungi: {{status}}',
    'Submit question': 'Trimiteți întrebarea',
    'Submit review': 'Trimite recenzia',
    'Submitting...': 'Se trimite...',
    'The AI assistant is currently disabled for this environment. Existing local session data can still be cleared here.':
      'Asistentul AI este în prezent dezactivat pentru acest mediu. Datele existente ale sesiunii locale pot fi șterse în continuare aici.',
    'The listing expired before a transport was confirmed.':
      'Lista a expirat înainte ca un transport să fie confirmat.',
    'The listing has been fully completed and archived as a finished transport.':
      'Lista a fost complet completată și arhivată ca transport terminat.',
    'The lowest net price you would still accept for this shipment.':
      'Cel mai mic preț net pe care l-ați accepta în continuare pentru această expediere.',
    'The partner has confirmed the route plan. Pickup and delivery dates are now scheduled.':
      'Partenerul a confirmat planul rutei. Datele de ridicare și livrare sunt acum programate.',
    'The partner marked the shipment as delivered. Review the final documents and confirm completion.':
      'Partenerul a marcat transportul ca fiind livrat. Examinați documentele finale și confirmați finalizarea.',
    'The partner-confirmed plan and LOA stay grouped together for faster review.':
      'Planul confirmat de partener și LOA rămân grupate pentru o examinare mai rapidă.',
    'This action notifies the transport provider and removes the quote from active consideration.':
      'Această acțiune notifică furnizorul de transport și elimină oferta din considerația activă.',
    'This listing is archived and no further transport actions are available.':
      'Această listă este arhivată și nu sunt disponibile alte acțiuni de transport.',
    'This listing needs an accepted quote before a review can be created.':
      'Această listă necesită o ofertă acceptată înainte de a putea fi creată o recenzie.',
    'This will soft-cancel the listing and move it to your archive.':
      'Aceasta va anula ușor lista și o va muta în arhiva dvs.',
    'This will soft-cancel the listing for the client and remove it from active marketplace views.':
      'Aceasta va anula ușor lista pentru client și o va elimina din vizualizările active ale pieței.',
    'Total quote': 'Cotația totală',
    'Tracking not promised': 'Urmărirea nu este promisă',
    'Tracking shared': 'Urmărire partajată',
    'Tracking visibility': 'Vizibilitatea urmăririi',
    'Trailer (Optional)': 'Trailer (Opțional)',
    'Translation preference updated':
      'Preferința de traducere a fost actualizată',
    'Transport completed': 'Transport finalizat',
    'Transport completed.': 'Transport finalizat.',
    'Transport documents': 'Documente de transport',
    'Transport marked as complete': 'Transport marcat ca finalizat',
    'Transport package': 'Pachetul de transport',
    'Transport plan confirmed': 'Planul de transport confirmat',
    'Transport plan updated': 'Planul de transport actualizat',
    'Transport planned': 'Transport planificat',
    'Transport Provider': 'Furnizor de transport',
    'Transport providers can review your shipment and send offers.':
      'Furnizorii de transport vă pot revizui expedierea și trimite oferte.',
    'Transport stage': 'Etapa de transport',
    Truck: 'Camion',
    'Truck, driver, trailer, and planned dates for this shipment.':
      'Camion, șofer, remorcă și datele planificate pentru această expediere.',
    'Try widening the current listing filters.':
      'Încercați să extindeți filtrele actuale de listă.',
    'Unable to upload listing images.': 'Nu se pot încărca imagini de listă.',
    'Unknown error': 'Eroare necunoscută',
    'Untitled listing': 'Listare fără titlu',
    'Untitled Listing': 'Listare fără titlu',
    'Update media': 'Actualizați media',
    'Update transport plan': 'Actualizați planul de transport',
    'Update Transport Plan': 'Actualizați planul de transport',
    'Upload a CMR or delivery photos before marking delivered.':
      'Încărcați un CMR sau fotografii de livrare înainte de a marca livrarea.',
    'Upload a CMR or delivery photos before the listing can move to Delivered.':
      'Încărcați un CMR sau fotografii de livrare înainte ca înregistrarea să poată fi mutată în Livrat.',
    'Upload at least one pickup proof before the listing can move to Picked Up.':
      'Încărcați cel puțin o dovadă de ridicare înainte ca înregistrarea să poată fi mutată la Ridicat.',
    'Upload final documents': 'Încărcați documentele finale',
    'Upload proof of pickup': 'Încărcați dovada ridicării',
    'Uploading...': 'Se încarcă...',
    'Use fresh photos when the shipment changes or you want to clarify the item condition.':
      'Utilizați fotografii proaspete atunci când expedierea se schimbă sau doriți să clarificați starea articolului.',
    'users enabled': 'utilizatorii activați',
    'Visible to you while quoting. You can still send your own net offer below or above this amount.':
      'Vizibil pentru tine în timp ce citezi. Puteți trimite în continuare propria ofertă netă sub sau peste această sumă.',
    'Waiting for partner acceptance': 'Se așteaptă acceptarea partenerului',
    'Waiting for transport planning': 'Asteptam planificarea transportului',
    'When enabled, messages from other users will be automatically translated to your preferred language.':
      'Când este activată, mesajele de la alți utilizatori vor fi traduse automat în limba preferată.',
    Withdraw: 'Retrageți-vă',
    'Write Review': 'Scrie o recenzie',
    'You are about to release this listing back to the marketplace.':
      'Sunteți pe cale să lansați această listă înapoi pe piață.',
    'You are now the assigned partner for this fixed-price listing.':
      'Acum sunteți partenerul alocat pentru această listă cu preț fix.',
    'Your quote has been accepted. Awaiting payment confirmation from the admin before you can begin the job.':
      'Cotația dvs. a fost acceptată. Se așteaptă confirmarea plății de la administrator înainte de a putea începe munca.',
    'VIN: {{vin}}': 'VIN: {{vin}}',
    'Material: {{type}}': 'Material: {{type}}',
    'L cm': 'L cm',
    'H cm': 'H cm',
    "Accept {{partner}}'s quote for {{amount}}?":
      'Acceptați oferta lui {{partner}} pentru {{amount}}?',
  },
  tr: {
    to: 'için',
    kg: 'kilo',
    Hatchback: 'Hatchback',
    Coupé: 'Coupe',
    Sedan: 'Sedan',
    'Station Wagon': 'İstasyon Vagonu',
    Crossover: 'Geçiş',
    Required: 'Gerekli',
    'Change language': 'Dili değiştir',
    'Loading...': 'Yükleniyor…',
    'Error:': 'Hata:',
    Close: 'Kapat',
    Yes: 'Evet',
    No: 'Hayır',
    'Keep order': 'Siparişi koruyun',
    Price: 'Fiyat',
    'Purchase terms': 'Satın alma koşulları',
    'Power of attorney': 'Vekaletname',
    'Transport details': 'Taşıma detayları',
    'Upload damages': 'Hasarları yükle',
    'Download (PDF)': 'İndir (PDF)',
    'Mark as picked up': 'Alındı olarak işaretle',
    'Mark as delivered': 'Teslim edildi olarak işaretle',
    'Cancel booking': 'Rezervasyonu iptal et',
    'Order marked as picked up': 'Sipariş teslim alındı olarak işaretlendi',
    'Order marked as delivered': 'Sipariş teslim edildi olarak işaretlendi',
    'Order canceled': 'Sipariş iptal edildi',
    'Failed to cancel order': 'Sipariş iptal edilemedi',
    'Added {{count}} file(s)': '{{count}} dosya(lar)ı eklendi',
    Pages: 'Sayfalar',
    'Awaiting Verification': 'Doğrulama Bekleniyor',
    'Profile Incomplete': 'Profil Tamamlanmadı',
    'Please complete your profile information (Company, Phone, Address, City, Post Code) to access all features.':
      'Tüm özelliklere erişebilmek için lütfen profil bilgilerinizi (Şirket, Telefon, Adres, Şehir, Posta Kodu) doldurun.',
    'Go to Profile': 'Profile Git',
    'Forgot Password': 'Şifremi Unuttum',
    Hello: 'Merhaba',
    friend: 'arkadaş',
    'Book your transport': 'Ulaşım rezervasyonunuzu yapın',
    'fast and easy': 'hızlı ve kolay',
    Origin: 'Menşei',
    Destination: 'Hedef',
    'Postal code': 'Posta kodu',
    'Calculate to preview': 'Önizlemek için hesaplayın',
    "Can't be calculated yet": 'Henüz hesaplanamıyor',
    'Awaiting payment badge': 'Ödeme bekleniyor',
    'Ref {{id}}': 'Referans {{id}}',
    'Change planning': 'Planlamayı değiştir',
    'Change driver': 'Sürücüyü değiştir',
    'No vehicles listed': 'Listelenen araç yok',
    'Order not found.': 'Sipariş bulunamadı.',
    'Not available': 'Mevcut değil',
    'For {{date}}': '{{date}} için',
    'Picked on {{date}}': "{{date}}'te seçildi",
    'Delivered on {{date}}': '{{date}} tarihinde teslim edildi',
    'Loading notification: {{value}}': 'Bildirim yükleniyor: {{value}}',
    'CO₂ compensation: {{value}}': 'CO₂ telafisi: {{value}}',
    'Bio fuel: {{value}}': 'Biyo yakıt: {{value}}',
    Remove: 'Kaldır',
    'Copy {{label}}': "{{label}}'i kopyala",
    'Open navigation menu': 'Gezinme menüsünü aç',
    'Open menu': 'Menüyü aç',
    'Error fetching data': 'Veriler getirilirken hata oluştu',
    'Not set': 'Ayarlanmadı',
    'No opening hours provided': 'Açılış saati belirtilmedi',
    'Please select a planned date': 'Lütfen planlanan bir tarih seçin',
    'Saved favorite route filter': 'Kaydedilen favori rota filtresi',
    km: 'kilometre',
    mi: 'mi',
    'Radius search': 'Yarıçap arama',
    'City or town': 'Şehir veya kasaba',
    'Country (optional)': 'Ülke (isteğe bağlı)',
    Radius: 'Yarıçap',
    'Searching…': 'Aranıyor…',
    'City not found': 'Şehir bulunamadı',
    'Within {{radius}} {{unit}} of {{place}}':
      "{{place}}'in {{radius}} {{unit}}'i dahilinde",
    'Clear radius': 'Yarıçapı temizle',
    'auth.account_status_pending_review': 'Hesap durumu: İncelenmeyi bekliyor',
    'auth.your_account_is_pending_approval': 'Hesabınız onay bekliyor',
    'auth.upload_your_verification_documents_below_and_we_ll_notify_you_by_email_once_your_account_is_approved':
      'Doğrulama belgelerinizi aşağıya yükleyin; hesabınız onaylandığında sizi e-postayla bilgilendireceğiz.',
    'auth.check_status': 'Durumu kontrol et',
    'auth.upload_verification_documents': 'Doğrulama belgelerini yükleyin',
    'auth.your_uploaded_documents': 'Yüklediğiniz belgeler',
    'auth.back_to_sign_in': 'Oturum açmak için geri dön',
    Andorra: 'Andorra',
    Malta: 'Malta',
    Moldova: 'Moldova',
    'San Marino': 'San Marino',
    'BodyType.Hatchback': 'Hatchback',
    'BodyType.Coupe': 'Coupe',
    'BodyType.Sedan': 'Sedan',
    'BodyType.StationWagon': 'İstasyon Vagonu',
    'BodyType.Crossover': 'Geçiş',
    'BodyType.Pickup': 'Teslim alma',
    'BodyType.Van': 'Van',
    StartPoint: 'Başlat',
    EndPoint: 'Bitiş',
    Model: 'Modeli',
    'Error loading documents': 'Belgeler yüklenirken hata oluştu',
    'Are you sure you want to delete this document?':
      'Bu belgeyi silmek istediğinizden emin misiniz?',
    'Document deleted': 'Doküman silindi',
    'Failed to delete': 'Silinemedi',
    'Failed to get download link': 'İndirme bağlantısı alınamadı',
    'Status updated': 'Durum güncellendi',
    'Update failed': 'Güncelleme başarısız oldu',
    'Email cannot be changed.': 'E-posta değiştirilemez.',
    'No documents found.': 'Hiçbir belge bulunamadı.',
    'Invoice #': 'Fatura #',
    'File Name': 'Dosya Adı',
    Amount: 'Tutar',
    Actions: 'Eylemler',
    Download: 'İndir',
    'Mark Unpaid': 'Ödenmedi Olarak İşaretle',
    'Mark Paid': 'Ödendi Olarak İşaretle',
    'Please save the record before uploading documents.':
      'Lütfen belgeleri yüklemeden önce kaydı kaydedin.',
    'Select a file before uploading.': 'Yüklemeden önce bir dosya seçin.',
    'Please enter an invoice number.': 'Lütfen bir fatura numarası girin.',
    'Upload successful': 'Yükleme başarılı',
    '{{count}} file(s) uploaded successfully.':
      '{{count}} dosya(lar)ı başarıyla yüklendi.',
    'Upload failed': 'Yükleme başarısız oldu',
    'Unable to upload the document.': 'Belge yüklenemiyor.',
    'Invoice Number': 'Fatura Numarası',
    'Selected files:': 'Seçilen dosyalar:',
    Upload: 'Yükle',
    'Save this record before uploading documents.':
      'Belgeleri yüklemeden önce bu kaydı kaydedin.',
    'Error approving user': 'Kullanıcı onaylanırken hata oluştu',
    'Error rejecting user': 'Kullanıcı reddedilirken hata oluştu',
    'Error disabling user': 'Kullanıcı devre dışı bırakılırken hata oluştu',
    'User marked as VIP': 'Kullanıcı VIP olarak işaretlendi',
    'User unmarked as VIP': 'Kullanıcının VIP işareti kaldırıldı',
    'Error marking user as VIP':
      'Kullanıcı VIP olarak işaretlenirken hata oluştu',
    'Error unmarking user as VIP':
      'Kullanıcının VIP işareti kaldırılırken hata oluştu',
    'Failed to approve user': 'Kullanıcı onaylanamadı',
    'Failed to reject user': 'Kullanıcı reddedilemedi',
    'Failed to disable user': 'Kullanıcı devre dışı bırakılamadı',
    'Failed to unmark user as VIP': 'Kullanıcının VIP işareti kaldırılamadı',
    'Failed to mark user as VIP': 'Kullanıcı VIP olarak işaretlenemedi',
    'Invoice Management': 'Fatura Yönetimi',
    'All Invoices': 'Tüm Faturalar',
    'Manage all invoices uploaded by partners.':
      'İş ortakları tarafından yüklenen tüm faturaları yönetin.',
    'An unexpected error occurred. Please try again.':
      'Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.',
    'The email address is not valid.': 'E-posta adresi geçerli değil.',
    'This account has been disabled.': 'Bu hesap devre dışı bırakıldı.',
    'No account found with this email.': 'Bu e-postaya ait hesap bulunamadı.',
    'Incorrect password. Please try again.':
      'Yanlış şifre. Lütfen tekrar deneyin.',
    'Invalid email or password. Please check your credentials and try again.':
      'Geçersiz e-posta veya şifre. Lütfen kimlik bilgilerinizi kontrol edip tekrar deneyin.',
    'Too many failed attempts. Please try again later or reset your password.':
      'Çok fazla başarısız deneme. Lütfen daha sonra tekrar deneyin veya şifrenizi sıfırlayın.',
    'Network error. Check your connection and try again.':
      'Ağ hatası. Bağlantınızı kontrol edip tekrar deneyin.',
    'A verification email has been sent to your email address. Please verify your email before logging in.':
      'E-posta adresinize bir doğrulama e-postası gönderildi. Lütfen giriş yapmadan önce e-posta adresinizi doğrulayın.',
    'Please make sure both passwords are the same.':
      'Lütfen her iki şifrenin de aynı olduğundan emin olun.',
    'Verification email resent!': 'Doğrulama e-postası yeniden gönderildi!',
    'Please check your inbox.': 'Lütfen gelen kutunuzu kontrol edin.',
    'You need to log in first': 'İlk önce giriş yapmanız gerekiyor',
    'Please sign in to resend the verification email.':
      'Doğrulama e-postasını yeniden göndermek için lütfen oturum açın.',
    'Failed to resend email': 'E-posta yeniden gönderilemedi',
    'Resend verification email': 'Doğrulama e-postasını yeniden gönder',
    'Show password': 'Şifreyi göster',
    'Hide password': 'Şifreyi gizle',
    'Awaiting verification artwork': 'Doğrulama resmi bekleniyor',
    'Account status: Pending review': 'Hesap durumu: İncelenmeyi bekliyor',
    'Your account is pending approval': 'Hesabınız onay bekliyor',
    "Upload your verification documents below and we'll notify you by email once your account is approved.":
      'Doğrulama belgelerinizi aşağıya yükleyin; hesabınız onaylandığında sizi e-postayla bilgilendireceğiz.',
    'Check status': 'Durumu kontrol et',
    'Upload verification documents': 'Doğrulama belgelerini yükleyin',
    'Your uploaded documents': 'Yüklediğiniz belgeler',
    'Back to sign in': 'Oturum açmak için geri dön',
    'Hide documents': 'Belgeleri gizle',
    'Email verification required': 'E-posta doğrulaması gerekli',
    'Waiting for email verification': 'E-posta doğrulaması bekleniyor',
    'Check your email': 'E-postanızı kontrol edin',
    'We sent your verification link to':
      'Doğrulama bağlantınızı şu adrese gönderdik:',
    "Didn't receive it? Check your spam folder or try again.":
      'Almadınız mı? Spam klasörünüzü kontrol edin veya tekrar deneyin.',
    'Resend email': 'E-postayı yeniden gönder',
    "I've verified my email": 'E-postamı doğruladım',
    'Redirecting you now.': 'Şimdi sizi yönlendiriyorum.',
    'Email not verified yet': 'E-posta henüz doğrulanmadı',
    'Please click the link in your inbox and try again.':
      'Lütfen gelen kutunuzdaki bağlantıya tıklayın ve tekrar deneyin.',
    'Unable to resend verification email right now.':
      'Doğrulama e-postası şu anda yeniden gönderilemiyor.',
    'Unable to check verification status right now.':
      'Doğrulama durumu şu anda kontrol edilemiyor.',
    "We've sent a new verification link to your email address.":
      'E-posta adresinize yeni bir doğrulama bağlantısı gönderdik.',
    'We automatically check your verification status every 30 seconds. You can also trigger an instant check after verifying your email.':
      'Doğrulama durumunuzu her 30 saniyede bir otomatik olarak kontrol ederiz. E-postanızı doğruladıktan sonra anında kontrol de tetikleyebilirsiniz.',
    'We automatically check your verification status every 15 seconds. You can also trigger an instant check after verifying your email.':
      'Doğrulama durumunuzu her 15 saniyede bir otomatik olarak kontrol ederiz. E-postanızı doğruladıktan sonra anında kontrol de tetikleyebilirsiniz.',
    'Inputs changed. Recalculate the price.':
      'Girişler değiştirildi. Fiyatı yeniden hesaplayın.',
    'My Invoices': 'Faturalarım',
    'Upload New Invoice': 'Yeni Fatura Yükle',
    'Please enter the invoice number and upload the invoice document. It will be reviewed by an administrator.':
      'Lütfen fatura numarasını girin ve fatura belgesini yükleyin. Bir yönetici tarafından incelenecektir.',
    'Invoice History': 'Fatura Geçmişi',
    'Client ref · {{clientRef}}': 'Müşteri referansı · {{clientRef}}',
    'Order Documents': 'Sipariş Belgeleri',
    'Upload Proof of Pickup': 'Teslim Alma Kanıtını Yükleyin',
    'Status will be updated to Picked Up after successful upload.':
      'Başarılı yükleme sonrasında durum Alındı olarak güncellenecektir.',
    'Upload Proof of Delivery': 'Teslimat Kanıtını Yükleyin',
    'Status will be updated to Delivered after successful upload.':
      'Başarılı yükleme sonrasında durum Teslim Edildi olarak güncellenecektir.',
    'Enter first name': 'Adını girin',
    'Enter last name': 'Soyadını girin',
    'Enter phone number': 'Telefon numarasını girin',
    'Driver updated.': 'Sürücü güncellendi.',
    'The driver has been successfully updated.':
      'Sürücü başarıyla güncellendi.',
    'Driver added.': 'Sürücü eklendi.',
    'The new driver has been successfully added.':
      'Yeni sürücü başarıyla eklendi.',
    'Driver deleted.': 'Sürücü silindi.',
    'The driver has been successfully deleted.': 'Sürücü başarıyla silindi.',
    'Trailer updated.': 'Fragman güncellendi.',
    'The trailer has been successfully updated.':
      'Fragman başarıyla güncellendi.',
    'Trailer added.': 'Fragman eklendi.',
    'The new trailer has been successfully added.':
      'Yeni fragman başarıyla eklendi.',
    'Trailer deleted.': 'Fragman silindi.',
    'The trailer has been successfully deleted.': 'Fragman başarıyla silindi.',
    'User account not found. Please complete registration.':
      'Kullanıcı hesabı bulunamadı. Lütfen kaydı tamamlayın.',
    'No token provided': 'Belirteç sağlanmadı',
    'Token expired': 'Jetonun süresi doldu',
    'Token revoked': 'Jeton iptal edildi',
    'Invalid ID token': 'Geçersiz kimlik belirteci',
    Unauthorized: 'Yetkisiz',
    'Unauthorized: User not authenticated.':
      'Yetkisiz: Kullanıcının kimliği doğrulanmadı.',
    'Unauthorized: User role not found.':
      'Yetkisiz: Kullanıcı rolü bulunamadı.',
    'Forbidden: Your role is not allowed to perform this action.':
      'Yasak: Rolünüzün bu eylemi gerçekleştirmesine izin verilmiyor.',
    'Forbidden: This action requires a partner role.':
      'Yasak: Bu eylem bir iş ortağı rolü gerektirir.',
    'Forbidden: This action requires a client role.':
      'Yasak: Bu eylem bir istemci rolü gerektirir.',
    'Forbidden: This action requires an admin role.':
      'Yasak: Bu eylem yönetici rolü gerektirir.',
    'This user has not been approved': 'Bu kullanıcı onaylanmadı',
    'User email has not been verified': 'Kullanıcı e-postası doğrulanmadı',
    'User account has been disabled': 'Kullanıcı hesabı devre dışı bırakıldı',
    'Booking not found': 'Rezervasyon bulunamadı',
    'Route not found': 'Rota bulunamadı',
    'Pickup location (country and postalCode) is required':
      'Teslim alma konumu (ülke ve posta kodu) gerekli',
    'Delivery location (country and postalCode) is required':
      'Teslimat yeri (ülke ve posta kodu) gereklidir',
    'Unable to calculate route. Please check the locations and try again.':
      'Rota hesaplanamıyor. Lütfen konumları kontrol edip tekrar deneyin.',
    'Error calculating transport price':
      'Nakliye fiyatı hesaplanırken hata oluştu',
    'Booking canceled successfully': 'Rezervasyon başarıyla iptal edildi',
    'Invalid request.': 'Geçersiz istek.',
    'Access denied.': 'Erişim engellendi.',
    'Resource not found.': 'Kaynak bulunamadı.',
    'Request conflict.': 'Çatışma isteyin.',
    'Invalid data provided.': 'Geçersiz veri sağlandı.',
    'Too many requests. Please try again later.':
      'Çok fazla istek var. Lütfen daha sonra tekrar deneyin.',
    'Internal server error. Please try again later.':
      'İç Sunucu Hatası. Lütfen daha sonra tekrar deneyin.',
    'Service temporarily unavailable.': 'Hizmet geçici olarak kullanılamıyor.',
    'booking.load_preset': 'Ön ayarı yükle',
    'booking.save_preset_tooltip':
      'Mevcut filtreleri hızlı erişim ön ayarınız olarak kaydedin',
    'booking.load_preset_tooltip': 'Kaydedilmiş filtre ön ayarınızı yükleyin',
    'booking.preset_saved': 'Ön ayar kaydedildi',
    'booking.preset_saved_desc': 'Filtre ön ayarınız kaydedildi.',
    'booking.preset_loaded': 'Ön ayar yüklendi',
    'booking.preset_load_error': 'Ön ayar yüklenemedi',
    'booking.no_preset_saved': 'Henüz kayıtlı bir ön ayar yok',
    'booking.date_from': 'Başlangıç tarihi',
    'booking.date_to': 'Tarih',
    'Active filters': 'Aktif filtreler',
    'All booking states': 'Tüm rezervasyon durumları',
    'All partners': 'Tüm ortaklar',
    'All payments': 'Tüm ödemeler',
    'All roles': 'Tüm roller',
    'All statuses': 'Tüm durumlar',
    'All Users': 'Tüm Kullanıcılar',
    'Are you sure you want to cancel booking {{id}}?':
      '{{id}} rezervasyonunu iptal etmek istediğinizden emin misiniz?',
    'Attach the CMR Insurance before finishing truck setup.':
      'Kamyon kurulumunu tamamlamadan önce CMR faturasını ekleyin.',
    Awaiting: 'Bekleniyor',
    'Awaiting payout': 'Ödeme bekleniyor',
    'Booking canceled': 'Rezervasyon iptal edildi',
    'Booking marked as paid': 'Rezervasyon ödendi olarak işaretlendi',
    'Booking released and returned to marketplace':
      'Rezervasyon yayınlandı ve pazara iade edildi',
    'booking.allowed_range': 'İzin verilen aralık',
    'booking.assign_transport': 'Taşımayı ata',
    'booking.back': 'Geri',
    'booking.back_to_summary': 'Özete geri dön',
    'booking.booking_created_but_pickup_document_not_uploaded_upload_from_order_details':
      'Rezervasyon oluşturuldu ancak teslim alma belgesi yüklenmedi. Sipariş Detaylarından yükleyebilirsiniz.',
    'booking.city_not_found': 'Şehir bulunamadı',
    'booking.city_or_town': 'Şehir veya kasaba',
    'booking.clear_radius': 'Yarıçapı temizle',
    'booking.continue': 'Devam et',
    'booking.country_optional': 'Ülke (isteğe bağlı)',
    'booking.delivery_constraint_info':
      'Teslimat tarihi teslim alma tarihi ile aynı veya sonra olmalıdır.',
    'booking.delivery_date_cannot_be_earlier_than_pickup_date':
      'Teslim tarihi teslim alma tarihinden önce olamaz',
    'booking.driver': 'Sürücü',
    'booking.failed_to_open_letter_of_attorney': 'Vekaletname açılamadı',
    'booking.go_to_order': 'Siparişe Git',
    'booking.i_accept_terms': 'Şartları kabul ediyorum',
    'booking.invalid_license_plate_or_vin_length':
      'Geçersiz plaka veya VIN uzunluğu.',
    'booking.invalid_vin_format_i_o_q_not_allowed':
      'Geçersiz VIN biçimi. I, O ve Q karakterlerine izin verilmez.',
    'booking.letter_of_attorney_file_is_empty': 'Vekaletname dosyası boş',
    'booking.no_additional_details': 'Ek ayrıntı yok',
    'booking.no_vehicle_info': 'Araç bilgisi yok',
    'booking.open_letter_of_attorney': 'Açık Vekaletname',
    'booking.opening_letter_of_attorney': 'Vekaletnamenin açılması...',
    'booking.order_accepted_successfully': 'Sipariş başarıyla kabul edildi',
    'booking.order_cars_exceed_selected_truck_capacity':
      "Bu siparişte {{orderCars}} arabaları var ancak seçilen kamyon kapasitesi {{capacity}}'tir.",
    'booking.pickup_constraint_info':
      'Taşımayı atamadan önce teslim alma tarihi gereklidir.',
    'booking.pickup_document_upload_failed':
      'Teslim alma belgesinin yüklenmesi başarısız oldu',
    'booking.preparing_secure_document_preview':
      'Güvenli belge önizlemesi hazırlanıyor...',
    'booking.radius_km': 'Yarıçap (km)',
    'booking.radius_search': 'Yarıçap arama',
    'booking.route_and_details': 'Rota ve ayrıntılar',
    'booking.schedule': 'Program',
    'booking.searching': 'Aranıyor…',
    'booking.select_pickup_and_delivery': 'Teslim alma ve teslimatı seçin',
    'booking.select_pickup_and_delivery_dates_before_confirming':
      'Onaylamadan önce teslim alma ve teslimat tarihlerini seçin',
    'booking.select_pickup_date': 'Teslim alma tarihini seçin',
    'booking.select_truck_driver_and_trailer':
      'Kamyonu, sürücüyü ve römorku seçin',
    'booking.supported_formats_jpg_png_pdf_doc_docx':
      'Desteklenen formatlar: JPG, PNG, PDF, DOC, DOCX',
    'booking.terms_and_conditions': 'Şartlar ve koşullar',
    'booking.terms_text':
      'Taşıma şartlarını ve sorumluluk koşullarını onaylıyorum.',
    'booking.track_shipment': 'Gönderiyi takip edin',
    'booking.trailer': 'Fragman',
    'booking.transport_details': 'Taşıma detayları',
    'booking.truck': 'Kamyon',
    'booking.truck_driver_planning_saved_letter_of_attorney_available':
      'Kamyon, sürücü ve planlama tarihleri kaydedildi. Vekaletname artık mevcuttur.',
    'booking.unexpected_error': 'Beklenmeyen hata',
    'booking.vehicles_plural': 'Araçlar',
    'booking.view_details': 'Ayrıntıları görüntüle',
    'booking.vip_price_must_be_between_min_max_50_to_150_percent_of_estimated_price':
      "VIP fiyatı {{min}} EUR ile {{max}} EUR arasında olmalıdır (tahmini fiyatın %50 ila %150'si).",
    'booking.vip_price_must_be_positive_number':
      'VIP fiyatı pozitif bir sayı olmalıdır.',
    'booking.within_radius_km_of_place': "{{place}}'in {{radius}} km'si içinde",
    Capacity: 'Kapasite',
    'Car Capacity': 'Araç Kapasitesi',
    'Car capacity is required.': 'Araç kapasitesi gereklidir.',
    cars: 'arabalar',
    Changed: 'Değiştirildi',
    'CMR Document': 'CMR Belgesi',
    'CMR expiry': "CMR'nin sona ermesi",
    'CMR Expiry': "CMR'nin Sona Ermesi",
    'CMR expiry date is required': "CMR'nin son kullanma tarihi gerekli",
    'CMR Insurance': 'CMR Sigortası',
    'CMR insurance expiry date': 'CMR sigortasının sona erme tarihi',
    'CMR Insurance Expiry Date': 'CMR Sigortası Bitiş Tarihi',
    'CMR insurance has expired. Upload a new CMR Insurance for review.':
      'İncelenmek üzere yeni bir CMR faturası yükleyin.',
    'CMR insurance is expiring within 14 days.':
      'CMR sigortasının süresi 14 gün içinde doluyor.',
    'CMR Insurance required': 'CMR faturası gerekli',
    Company: 'Şirket',
    'Copy order ID': 'Sipariş kimliğini kopyala',
    Created: 'Oluşturuldu',
    'Current expiry': 'Geçerli sona erme',
    'Date range': 'Tarih aralığı',
    days: 'günler',
    Delay: 'Gecikme',
    'Delivered + partner invoice uploaded + unpaid':
      'Teslim edildi + iş ortağı faturası yüklendi + ödenmedi',
    Document: 'Belge',
    'Documents uploaded': 'Yüklenen belgeler',
    Done: 'Bitti',
    'Download Client Invoice #{{id}}': 'Müşteri Faturasını İndirin #{{id}}',
    'Download Invoice': 'Faturayı İndir',
    'Enter a valid capacity between 1 and 20 cars.':
      '1 ila 20 araba arasında geçerli bir kapasite girin.',
    'Enter license plate': 'Plakayı girin',
    'Enter plate and upload CMR to add truck':
      "Kamyon eklemek için plakayı girin ve CMR'yi yükleyin",
    'Error fetching users': 'Kullanıcılar getirilirken hata oluştu',
    'Expire Soon (14 days)': 'Yakında Sona Erecek (14 gün)',
    'Explain why this CMR was rejected':
      "Bu CMR'nin neden reddedildiğini açıklayın",
    'Failed to copy order ID': 'Sipariş kimliği kopyalanamadı',
    'Failed to download invoice': 'Fatura indirilemedi',
    'Failed to download proforma invoice': 'Proforma fatura indirilemedi',
    'Failed to generate invoice': 'Fatura oluşturulamadı',
    'Failed to load invoice summary': 'Fatura özeti yüklenemedi',
    'Failed to load letter of attorney': 'Vekaletname yüklenemedi',
    'Failed to open letter of attorney': 'Vekaletname açılamadı',
    'Failed to release booking': 'Rezervasyon yayınlanamadı',
    'Fleet data refreshed': 'Filo verileri yenilendi',
    'Generate Client Invoice': 'Müşteri Faturası Oluştur',
    'Generate Invoice': 'Fatura Oluştur',
    'Generated at': 'Oluşturulma tarihi:',
    'How many cars can this truck carry?': 'Bu kamyon kaç araba taşıyabilir?',
    'In progress': 'Devam ediyor',
    Invoice: 'Fatura',
    'Invoice generated': 'Fatura oluşturuldu',
    'Invoice generated successfully': 'Fatura başarıyla oluşturuldu',
    'Invoice uploaded': 'Fatura yüklendi',
    'Invoices uploaded by partners for platform payout processing. Client invoices are generated in each order view.':
      'Müşteri faturaları her sipariş görünümünde oluşturulur.',
    'Keep booking': 'Rezervasyona devam edin',
    'Keep your active drivers and contact details up to date.':
      'Aktif sürücülerinizi ve iletişim bilgilerinizi güncel tutun.',
    'Last Rejection': 'Son Reddetme',
    'Last rejection reason': 'Son ret nedeni',
    'Letter of Attorney': 'Vekaletname',
    'Letter of attorney file is empty': 'Vekaletname dosyası boş',
    'License plate cannot be changed after creation. Re-upload CMR Insurance instead.':
      'Bunun yerine CMR faturasını yeniden yükleyin.',
    'License plate is required.': 'Plaka gereklidir.',
    'Manage large order volumes with search, payment actions, and invoice workflows.':
      'Arama, ödeme işlemleri ve fatura iş akışlarıyla büyük sipariş hacimlerini yönetin.',
    'Manage license plates and keep CMR Insurances approved and valid.':
      'Plakaları yönetin ve CMR faturalarını onaylı ve geçerli tutun.',
    'Manage status updates, documents, and payment steps from one place.':
      'Durum güncellemelerini, belgeleri ve ödeme adımlarını tek yerden yönetin.',
    'Manage trailer plate records and keep availability current.':
      'Treyler plakası kayıtlarını yönetin ve kullanılabilirliği güncel tutun.',
    'Mark booking {{id}} as paid?':
      '{{id}} rezervasyonu ödendi olarak işaretlensin mi?',
    Missing: 'Eksik',
    'Needs attention': 'Dikkat edilmesi gerekiyor',
    'New (14 days)': 'Yeni (14 gün)',
    'No bookings found for the current filters.':
      'Mevcut filtreler için rezervasyon bulunamadı.',
    'No confirmed CMR document uploaded yet.':
      'Henüz onaylanmış bir CMR belgesi yüklenmedi.',
    'No driver assigned': 'Hiçbir sürücü atanmadı',
    'No letter of attorney has been generated yet.':
      'Henüz vekaletname oluşturulmadı.',
    'No matching delivered orders': 'Eşleşen teslim edilmiş sipariş yok',
    'No new notifications': 'Yeni bildirim yok',
    'No partners found.': 'Hiçbir ortak bulunamadı.',
    'No trucks found for this filter.': 'Bu filtreye uygun kamyon bulunamadı.',
    'No users found for current filters.':
      'Mevcut filtreler için kullanıcı bulunamadı.',
    'Not uploaded': 'Yüklenmedi',
    Notifications: 'Bildirimler',
    of: 'arasında',
    'Only admins can set or update this expiry date after reviewing your CMR insurance.':
      'Bu son kullanma tarihini yalnızca yöneticiler CMR sigortanızı inceledikten sonra ayarlayabilir veya güncelleyebilir.',
    'Open letter of attorney': 'Açık vekaletname',
    Order: 'Sipariş',
    'Order actions': 'Sipariş işlemleri',
    'Order ID copied': 'Sipariş kimliği kopyalandı',
    Owner: 'Sahip',
    Page: 'Sayfa',
    'Paid date': 'Ödeme tarihi',
    'Partner delivery date': 'İş ortağı teslim tarihi',
    'Partner documents': 'İş ortağı belgeleri',
    'Partner Invoice': 'İş Ortağı Faturası',
    'Partner invoice uploaded': 'İş ortağı faturası yüklendi',
    'Partner Payout Invoices': 'İş Ortağı Ödeme Faturaları',
    'Partner pickup date': 'İş ortağı teslim alma tarihi',
    'Partner score': 'İş ortağı puanı',
    Payment: 'Ödeme',
    'Payout date': 'Ödeme tarihi',
    'penalties applied': 'uygulanan cezalar',
    'Pending admin review': 'Yönetici incelemesi bekleniyor',
    'Pending review': 'İnceleme bekleniyor',
    'Pending trucks': 'Bekleyen kamyonlar',
    'Please provide a clear reason for rejection.':
      'Lütfen reddedilme gerekçenizi açık bir şekilde belirtin.',
    'Please select an order before uploading an invoice.':
      'Lütfen faturayı yüklemeden önce bir sipariş seçin.',
    'Please try again.': 'Lütfen tekrar deneyin.',
    'Proforma Invoice': 'Proforma Fatura',
    'Provide a rejection reason for this CMR review.':
      'Bu CMR incelemesi için bir ret nedeni belirtin.',
    'Quarter Score': 'Çeyrek Puanı',
    'Re-upload CMR': "CMR'yi yeniden yükle",
    Refresh: 'Yenile',
    'Rejection reason': 'Reddetme nedeni',
    'Rejection reason is required': 'Reddetme nedeni gerekli',
    'Release booking {{id}} back to the marketplace so another partner can accept it?':
      'Başka bir iş ortağının kabul edebilmesi için {{id}} rezervasyonunu pazara geri gönderelim mi?',
    Reset: 'Sıfırla',
    'Review Bookings': 'Rezervasyonları İnceleyin',
    Revision: 'Revizyon',
    Rows: 'Satırlar',
    'Search by invoice number, file name, or booking ID':
      'Fatura numarasına, dosya adına veya rezervasyon kimliğine göre arama yapın',
    'Search by name, email, company': 'Ada, e-postaya, şirkete göre arayın',
    'Search by name, email, company, uid':
      'Ada, e-postaya, şirkete, kullanıcı kimliğine göre arayın',
    'Search client': 'Müşteri ara',
    'Search delivered order': 'Teslim edilen siparişi ara',
    'Search license plate or owner': 'Plakayı veya sahibini arayın',
    'Search order ID': 'Sipariş kimliğini ara',
    'Search partner': 'Arama ortağı',
    'Select a new CMR Insurance to re-upload for this truck.':
      'Bu kamyon için yeniden yüklemek üzere yeni bir CMR faturası seçin.',
    'Select paid date': 'Ödeme tarihini seçin',
    'Set CMR insurance expiry date to approve this truck.':
      'Bu kamyonu onaylamak için CMR sigortasının son kullanma tarihini ayarlayın.',
    'Set maximum number of cars this truck can carry (1-20).':
      'Bu kamyonun taşıyabileceği maksimum araba sayısını ayarlayın (1-20).',
    'Set the CMR insurance expiry date before approval.':
      'Onaydan önce CMR sigortasının son kullanma tarihini ayarlayın.',
    Showing: 'Gösterilen',
    'Showing page {{page}} of {{pages}} • {{total}} invoices':
      "{{pages}}'in {{page}} sayfası gösteriliyor • {{total}} faturaları",
    'Status will be updated to Picked Up after successful upload. You can add multiple car photos before uploading.':
      'Yüklemeden önce birden fazla araba fotoğrafı ekleyebilirsiniz.',
    Terms: 'Şartlar',
    Total: 'Toplam',
    'Track paid and unpaid invoices, expected payout dates, and upload new invoices quickly.':
      'Ödenmiş ve ödenmemiş faturaları, beklenen ödeme tarihlerini takip edin ve yeni faturaları hızla yükleyin.',
    'Truck approved successfully': 'Kamyon başarıyla onaylandı',
    'Truck documents': 'Kamyon belgeleri',
    'Truck license plate': 'Kamyon plakası',
    'Truck rejected successfully': 'Kamyon başarıyla reddedildi',
    'truck(s) are pending admin CMR expiry date.':
      "kamyon(lar) yönetici CMR'nin son kullanma tarihini bekliyor.",
    'truck(s) have expired CMR insurance and are disabled.':
      'Kamyonun/kamyonların CMR sigortasının süresi doldu ve devre dışı bırakıldı.',
    'truck(s) will expire within 14 days.':
      'Kamyonun/kamyonların kullanım süresi 14 gün içinde dolacaktır.',
    'Unable to prepare the record for upload.':
      'Kayıt yükleme için hazırlanamadı.',
    Unpaid: 'ödenmemiş',
    'Upload a CMR Insurance before closing this truck setup.':
      'Bu kamyon kurulumunu kapatmadan önce bir CMR faturası yükleyin.',
    'Upload a valid CMR insurance. Each upload sends the truck back to pending review.':
      'Her yükleme, kamyonu beklemedeki incelemeye geri gönderir.',
    'Upload documents': 'Belgeleri yükleyin',
    'Upload Invoice': 'Fatura Yükle',
    'Upload order documents': 'Sipariş belgelerini yükleyin',
    'Upload unavailable': 'Yükleme kullanılamıyor',
    Uploaded: 'Yüklendi',
    'Uploaded • Paid': 'Yüklendi • Ücretli',
    'Uploaded • Partially paid': 'Yüklendi • Kısmen ödendi',
    'Uploaded by partner for platform payout processing.':
      'Platform ödeme işlemi için iş ortağı tarafından yüklendi.',
    User: 'Kullanıcı',
    'Verification code': 'Doğrulama kodu',
    'View details': 'Ayrıntıları görüntüle',
    'View Partners': 'İş Ortaklarını Görüntüle',
    'Working hours not provided': 'Çalışma saatleri belirtilmedi',
    '{{value}} orders': '{{value}} siparişleri',
    Invoiced: 'Faturalandı',
    'Loading admin data...': 'Yönetici verileri yükleniyor...',
    'Pending partners': 'Bekleyen iş ortakları',
    'Unpaid bookings': 'Ödenmemiş rezervasyonlar',
    'Total users': 'Toplam kullanıcı',
    'Orders per period': 'Dönem başına siparişler',
    'Orders by status': 'Duruma göre siparişler',
    'Quick actions': 'Hızlı eylemler',
    'Verify new partners': 'Yeni iş ortaklarını doğrulayın',
    'Review partner applications and approve or reject requests.':
      'İş ortağı başvurularını inceleyin ve istekleri onaylayın veya reddedin.',
    'Manage all trucks': 'Tüm kamyonları yönet',
    'Review, approve, reject, disable, and filter all trucks.':
      'Tüm kamyonları inceleyin, onaylayın, reddedin, devre dışı bırakın ve filtreleyin.',
    'Review bookings': 'Rezervasyonları inceleyin',
    'Review all transport orders, payment states, and generated invoices.':
      'Tüm taşıma siparişlerini, ödeme durumlarını ve oluşturulan faturaları inceleyin.',
    'Manage all users': 'Tüm kullanıcıları yönet',
    'Manage user status, roles, and validation records.':
      'Kullanıcı durumunu, rollerini ve doğrulama kayıtlarını yönetin.',
    'User breakdown': 'Kullanıcı dökümü',
    Clients: 'Müşteriler',
    Partners: 'Ortaklar',
    Admins: 'Yöneticiler',
    'Top 5 pending partners': 'Bekleyen ilk 5 iş ortağı',
    'No pending partners right now.': 'Şu anda bekleyen iş ortağı yok.',
    pending: 'beklemede',
    'Top 5 pending trucks': 'Bekleyen ilk 5 kamyon',
    'No pending trucks right now.': 'Şu anda bekleyen kamyon yok.',
    'Unknown owner': 'Bilinmeyen sahip',
    'KPI cards and top lists link directly to filtered admin screens.':
      'KPI kartları ve üst listeler doğrudan filtrelenmiş yönetici ekranlarına bağlanır.',
    'booking.available_orders_title': 'Mevcut Siparişler',
    'booking.available_orders_description':
      'Gelen ulaşım fırsatlarını inceleyin ve kapasitenize uygun filtreler uygulayın.',
    'booking.vehicle_pickup_location': 'Araç teslim alma yeri',
    'booking.pickup_opening_hours': 'Teslim alma çalışma saatleri',
    'booking.vehicle_delivery_location': 'Araç teslim yeri',
    'booking.delivery_opening_hours': 'Teslimat açılış saatleri',
    'booking.pickup_contact': 'Teslim alma kontağı',
    'booking.delivery_contact': 'Teslimat iletişim bilgisi',
    'booking.vehicles_scheduled': 'Planlanan araçlar',
    'booking.watchlist_title': 'İzleme listesi',
    'booking.watchlist_description':
      'Kaydedilen fırsatları takip edin ve kullanılabilirlik değiştikçe hızla harekete geçin.',
    'Loading dashboard...': 'Kontrol paneli yükleniyor...',
    'Total bookings': 'Toplam rezervasyonlar',
    'Open bookings': 'Açık rezervasyonlar',
    'Order status timeline': 'Sipariş durumu zaman çizelgesi',
    'Last 6 months of bookings grouped by current status.':
      'Mevcut duruma göre gruplandırılmış son 6 aylık rezervasyonlar.',
    'Create new order': 'Yeni sipariş oluştur',
    'Create a new transport booking request.':
      'Yeni bir ulaşım rezervasyonu talebi oluşturun.',
    'View my orders': 'Siparişlerimi görüntüle',
    'Review status and details of your bookings.':
      'Rezervasyonlarınızın durumunu ve ayrıntılarını inceleyin.',
    'Open profile': 'Profili aç',
    'Update company and contact details.':
      'Şirket ve iletişim bilgilerini güncelleyin.',
    'Recent bookings': 'Son rezervasyonlar',
    'No bookings yet.': 'Henüz rezervasyon yok.',
    'Unknown destination': 'Bilinmeyen hedef',
    'Quarter score': 'Çeyrek skoru',
    '{{value}} completed': '{{value}} tamamlandı',
    'Truck CMR warning': 'Kamyon CMR uyarısı',
    'One truck has CMR expiry risk. Review it in Fleet.':
      "Bir kamyonun CMR'nin sona erme riski vardır. Filo'da inceleyin.",
    '{{count}} trucks have CMR expiry risk. Review them in Fleet.':
      "{{count}} kamyonların CMR'nin sona ermesi riski vardır. Bunları Filo'da inceleyin.",
    'Active queue': 'Aktif kuyruk',
    'Delivered bookings': 'Teslim edilen rezervasyonlar',
    'Cars delivered': 'Teslim edilen arabalar',
    'Canceled bookings': 'İptal edilen rezervasyonlar',
    'Avg assign-to-pickup': 'Ortalama alıma atama',
    'Quarter Partner Score': 'Çeyrek İş Ortağı Puanı',
    'Payment delay: +{{days}} days': 'Ödeme gecikmesi: +{{days}} gün',
    'Penalty events': 'Penaltı etkinlikleri',
    Current: 'Mevcut',
    'Completed orders per period': 'Dönem başına tamamlanan siparişler',
    'Completed orders': 'Tamamlanan siparişler',
    'Truck CMR status alerts': 'Kamyon CMR durumu uyarıları',
    '{{count}} truck(s) have expired CMR insurance.':
      '{{count}} kamyon(lar)ının CMR sigortasının süresi dolmuştur.',
    '{{count}} truck(s) will expire within 14 days.':
      '{{count}} kamyon(lar)ının kullanım süresi 14 gün içinde dolacaktır.',
    '{{count}} truck(s) are missing CMR expiry date.':
      '{{count}} kamyon(lar)ında CMR son kullanma tarihi eksik.',
    'Upload a new CMR Insurance in Fleet. The truck will stay pending until admin review.':
      "Filo'ya yeni bir CMR faturası yükleyin. Kamyon, yönetici incelemesine kadar beklemede kalacak.",
    'Open fleet to resolve CMR alerts': 'CMR uyarılarını çözmek için açık filo',
    'Operational actions': 'Operasyonel eylemler',
    'Open marketplace orders': 'Açık pazar yeri siparişleri',
    'Review available orders and plan assignments.':
      'Mevcut siparişleri gözden geçirin ve atamaları planlayın.',
    'My accepted orders': 'Kabul edilen siparişlerim',
    'Manage delivery progress and documents.':
      'Teslimat ilerlemesini ve belgelerini yönetin.',
    'Update trucks, trailers, and availability.':
      'Kamyonları, römorkları ve kullanılabilirliği güncelleyin.',
    'Partner invoices': 'İş ortağı faturaları',
    'Upload and track invoice payments.':
      'Fatura ödemelerini yükleyin ve takip edin.',
    'No active orders in queue.': 'Kuyrukta aktif sipariş yok.',
    'profile.incompleteTitle': 'Profil Tamamlanmadı',
    'profile.incompleteDescription':
      'Tüm özelliklere erişebilmek için lütfen profil bilgilerinizi (Şirket, Telefon, Adres, Şehir, Posta Kodu) doldurun.',
    'profile.goToProfile': 'Profile Git',
    'auth.email_placeholder': 'isim@şirket.com',
    'auth.authentication_mode_switch': 'Kimlik doğrulama modu anahtarı',
    'auth.invalid_email': 'Geçersiz e-posta',
    'auth.please_enter_a_valid_email_address':
      'Lütfen geçerli bir e-posta adresi girin.',
    'auth.email_not_found': 'E-posta bulunamadı',
    'auth.no_account_found_with_that_email_address':
      'Bu e-posta adresiyle hesap bulunamadı.',
    'auth.email_sent': 'E-posta gönderildi!',
    'auth.something_went_wrong_try_again':
      'Bir şeyler ters gitti. Tekrar deneyin.',
    'auth.we_sent_a_password_reset_link_open_your_inbox_and_follow_the_instructions':
      'Şifre sıfırlama bağlantısı gönderdik. Gelen kutunuzu açın ve talimatları izleyin.',
    'auth.forgot_your_password': 'Şifrenizi mi unuttunuz?',
    'auth.enter_your_account_email_and_we_will_send_you_a_password_reset_link':
      'Hesap e-postanızı girin, size bir şifre sıfırlama bağlantısı göndereceğiz.',
    'auth.email_address': 'E-posta adresi',
    'auth.send_reset_link': 'Sıfırlama bağlantısını gönder',
    'auth.cancel': 'İptal',
    'auth.tip_if_you_do_not_receive_the_email_check_spam_and_promotions_folders':
      'İpucu: E-postayı almazsanız spam ve promosyonlar klasörlerini kontrol edin.',
    'booking.e_g_berlin': 'örneğin berlin',
    'booking.e_g_germany': 'örneğin Almanya',
    'booking.watchlist': 'İzleme listesi',
    'booking.view_map': 'Haritayı görüntüle',
    'booking.invalid_input': 'Geçersiz giriş',
    'booking.please_enter_only_numbers_for_the_zip_code':
      'Lütfen posta kodu için yalnızca sayıları girin.',
    'booking.pickup_zip_code': 'Teslim Alma Posta Kodu',
    'booking.delivery_zip_code': 'Teslimat Posta Kodu',
    'booking.select_vehicle_make': 'Araç markasını seçin',
    'booking.unnamed_item': 'Adsız öğe',
    'booking.cars': 'arabalar',
    'booking.more_info': 'Daha fazla bilgi',
    'booking.loading': 'Yükleniyor...',
    'booking.no_items_found': 'Hiçbir öğe bulunamadı',
    'booking.selected_cars': 'Seçilmiş Arabalar',
    'booking.unknown_type': 'Bilinmeyen tür',
    'booking.delete_car': 'Arabayı sil',
    'Toggle details': 'Ayrıntıları değiştir',
    'auth.a_verification_email_has_been_sent_to_your_email_address_please_verify_your_emai':
      'E-posta adresinize bir doğrulama e-postası gönderildi. Lütfen giriş yapmadan önce e-posta adresinizi doğrulayın.',
    'auth.an_unexpected_error_occurred_please_try_again':
      'Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.',
    'auth.failed_to_resend_email': 'E-posta yeniden gönderilemedi',
    'auth.show_password': 'Şifreyi göster',
    'auth.hide_password': 'Şifreyi gizle',
    'auth.incorrect_password_please_try_again':
      'Yanlış şifre. Lütfen tekrar deneyin.',
    'auth.invalid_email_or_password_please_check_your_credentials_and_try_again':
      'Geçersiz e-posta veya şifre. Lütfen kimlik bilgilerinizi kontrol edip tekrar deneyin.',
    'auth.network_error_check_your_connection_and_try_again':
      'Ağ hatası. Bağlantınızı kontrol edip tekrar deneyin.',
    'auth.no_account_found_with_this_email':
      'Bu e-postaya ait hesap bulunamadı.',
    'auth.please_check_your_inbox': 'Lütfen gelen kutunuzu kontrol edin.',
    'auth.please_make_sure_both_passwords_are_the_same':
      'Lütfen her iki şifrenin de aynı olduğundan emin olun.',
    'auth.please_sign_in_to_resend_the_verification_email':
      'Doğrulama e-postasını yeniden göndermek için lütfen oturum açın.',
    'auth.resend_verification_email': 'Doğrulama e-postasını yeniden gönder',
    'auth.awaiting_verification_artwork': 'Doğrulama resmi bekleniyor',
    'auth.email_verification_required': 'E-posta doğrulaması gerekli',
    'auth.waiting_for_email_verification': 'E-posta doğrulaması bekleniyor',
    'auth.check_your_email': 'E-postanızı kontrol edin',
    'auth.we_sent_your_verification_link_to':
      'Doğrulama bağlantınızı şu adrese gönderdik:',
    'auth.didnt_receive_it_check_spam_or_try_again':
      'Almadınız mı? Spam klasörünüzü kontrol edin veya tekrar deneyin.',
    'auth.resend_email': 'E-postayı yeniden gönder',
    'auth.i_verified_my_email': 'E-postamı doğruladım',
    'auth.redirecting_you_now': 'Şimdi sizi yönlendiriyorum.',
    'auth.email_not_verified_yet': 'E-posta henüz doğrulanmadı',
    'auth.please_click_the_link_in_your_inbox_and_try_again':
      'Lütfen gelen kutunuzdaki bağlantıya tıklayın ve tekrar deneyin.',
    'auth.unable_to_resend_verification_email_right_now':
      'Doğrulama e-postası şu anda yeniden gönderilemiyor.',
    'auth.unable_to_check_verification_status_right_now':
      'Doğrulama durumu şu anda kontrol edilemiyor.',
    'auth.we_sent_a_new_verification_link':
      'E-posta adresinize yeni bir doğrulama bağlantısı gönderdik.',
    'auth.we_automatically_check_every_30_seconds':
      'Doğrulama durumunuzu her 30 saniyede bir otomatik olarak kontrol ederiz. E-postanızı doğruladıktan sonra anında kontrol de tetikleyebilirsiniz.',
    'auth.we_automatically_check_every_15_seconds':
      'Doğrulama durumunuzu her 15 saniyede bir otomatik olarak kontrol ederiz. E-postanızı doğruladıktan sonra anında kontrol de tetikleyebilirsiniz.',
    'auth.the_email_address_is_not_valid': 'E-posta adresi geçerli değil.',
    'auth.this_account_has_been_disabled': 'Bu hesap devre dışı bırakıldı.',
    'auth.too_many_failed_attempts_please_try_again_later_or_reset_your_password':
      'Çok fazla başarısız deneme. Lütfen daha sonra tekrar deneyin veya şifrenizi sıfırlayın.',
    'auth.verification_email_resent': 'Doğrulama e-postası yeniden gönderildi!',
    'auth.you_need_to_log_in_first': 'İlk önce giriş yapmanız gerekiyor',
    'booking.endpoint': 'Bitiş',
    'booking.error_fetching_data': 'Veriler getirilirken hata oluştu',
    'booking.inputs_changed_recalculate_the_price':
      'Girişler değiştirildi. Fiyatı yeniden hesaplayın.',
    'booking.kg': 'kilo',
    'booking.km': 'kilometre',
    'booking.mi': 'mi',
    'booking.no_opening_hours_provided': 'Açılış saati belirtilmedi',
    'booking.no_vehicles_listed': 'Listelenen araç yok',
    'booking.not_available': 'Mevcut değil',
    'booking.not_set': 'Ayarlanmadı',
    'booking.please_select_a_planned_date': 'Lütfen planlanan bir tarih seçin',
    'booking.required': 'Gerekli',
    'booking.startpoint': 'Başlat',
    'booking.to': 'için',
    'booking.order': 'Sipariş',
    'booking.duration': 'Süre',
    'booking.vehicles_overview': 'Araçlara genel bakış',
    'booking.body': 'Vücut',
    'booking.dims': 'Loş',
    'booking.select_vehicle_model': 'Araç modelini seçin',
    'booking.selected_type_value': 'Seçilen: {{value}}',
    'booking.select_a_vehicle_type': 'Bir araç türü seçin:',
    'booking.select_vehicle_weight': 'Araç ağırlığını seçin',
    'booking.selected_weight_kg': 'Seçilen: {{value}} kg',
    'booking.adjust_weight': 'Ağırlığı ayarlayın',
    'Dates updated successfully': 'Tarihler başarıyla güncellendi',
    'Error updating dates': 'Tarihler güncellenirken hata oluştu',
    'Set Planned Dates': 'Planlanan Tarihleri Ayarlayın',
    'Set your planned pickup and arrival dates below.':
      'Planladığınız teslim alma ve varış tarihlerini aşağıda ayarlayın.',
    'Changing dates after initial setup will deduct 20% from your performance score for this order.':
      'İlk kurulumdan sonra tarihlerin değiştirilmesi, bu sipariş için performans puanınızdan %20 düşülecektir.',
    'Planned Pickup Date': 'Planlanan Teslim Alma Tarihi',
    'Planned Arrival Date': 'Planlanan Varış Tarihi',
    Listing: 'Listeleme',
    'Try broadening the current search or status filter.':
      'Mevcut aramayı veya durum filtresini genişletmeyi deneyin.',
    'Try broadening the search, role, or status filters.':
      'Arama, rol veya durum filtrelerini genişletmeyi deneyin.',
    'Monitor fleet compliance, validation status, and expiring insurance in one place.':
      'Filo uyumluluğunu, doğrulama durumunu ve süresi dolan sigortayı tek bir yerden izleyin.',
    'Active Listings': 'Aktif Listelemeler',
    'Open transport requests': 'Taşıma isteklerini aç',
    'Quotes Today': 'Bugün Alıntılar',
    'Submitted in last 24h': 'Son 24 saat içinde gönderildi',
    'Platform Revenue (MTD)': 'Platform Geliri (MTD)',
    'Month to date': 'Aydan bugüne',
    'Pending Partners': 'Bekleyen İş Ortakları',
    'Awaiting approval': 'Onay bekleniyor',
    'Unpaid Invoices': 'Ödenmemiş Faturalar',
    'Requires action': 'Eylem gerektirir',
    'Completed Transports': 'Tamamlanan Taşımalar',
    'All time delivered': 'Tüm zamanlar teslim edildi',
    'Admin Dashboard': 'Yönetici Kontrol Paneli',
    'Platform overview and key performance indicators.':
      'Platforma genel bakış ve temel performans göstergeleri.',
    'Loading dashboard metrics...': 'Kontrol paneli metrikleri yükleniyor...',
    Invoices: 'Faturalar',
    'Review payout invoices uploaded by partners and keep payout processing organized.':
      'İş ortakları tarafından yüklenen ödeme faturalarını inceleyin ve ödeme işlemlerini düzenli tutun.',
    Flexible: 'Esnek',
    'Flexible dates': 'Esnek tarihler',
    'Could not load this listing.': 'Bu liste yüklenemedi.',
    'Listing canceled': 'Listeleme iptal edildi',
    'Failed to cancel listing': 'Listeleme iptal edilemedi',
    Reference: 'Referans',
    Category: 'Kategori',
    'Client type': 'Müşteri türü',
    'Company country': 'Şirket ülkesi',
    Expires: 'Süresi doluyor',
    'Back to listings': 'Listelere geri dön',
    'Listing not found.': 'İlan bulunamadı.',
    'Cancel Listing': 'Listelemeyi İptal Et',
    'Listing details': 'Listeleme ayrıntıları',
    'Reference {{id}}': 'Referans {{id}}',
    'Read-only listing overview for admins.':
      'Yöneticiler için salt okunur listelemeye genel bakış.',
    'Pick-up': 'Teslim alma',
    'No exact coordinates are stored for this listing yet.':
      'Bu liste için henüz kesin koordinatlar kaydedilmedi.',
    'Structured overview of quantities and handling details.':
      'Miktarlara ve taşıma ayrıntılarına yapılandırılmış genel bakış.',
    'Shipment images': 'Gönderi resimleri',
    'No shipment images were uploaded for this listing.':
      'Bu liste için herhangi bir gönderi resmi yüklenmedi.',
    'Proof of pickup': 'Teslim alma kanıtı',
    'Final documents': 'Nihai belgeler',
    Description: 'Açıklama',
    'Quotes ({{count}})': 'Fiyatlar ({{count}})',
    'Loading quotes...': 'Fiyat teklifleri yükleniyor...',
    'No quotes for this listing.': 'Bu liste için teklif yok.',
    'Score: {{score}}/100': 'Puan: {{score}}/100',
    'Pickup: {{date}}': 'Teslim alma: {{date}}',
    'Delivery: {{date}}': 'Teslimat: {{date}}',
    'Cancel Listing?': 'Listeleme İptal Edilsin mi?',
    'This will permanently cancel the listing and notify the client. Continue?':
      'Bu, listelemeyi kalıcı olarak iptal edecek ve müşteriye bilgi verecektir. Devam etmek?',
    Keep: 'Tut',
    'Review partner applications, check their documents, and keep approval decisions consistent.':
      'İş ortağı başvurularını inceleyin, belgelerini kontrol edin ve onay kararlarının tutarlı olmasını sağlayın.',
    'No client payments recorded yet': 'Henüz kayıtlı müşteri ödemesi yok',
    'Client payment rows will appear here when the payments backend is connected.':
      'Ödeme arka ucu bağlandığında müşteri ödeme satırları burada görünecektir.',
    Method: 'Yöntem',
    'No partner payouts recorded yet': 'Henüz iş ortağı ödemesi kaydedilmedi',
    'Payout rows will appear here once partner payout processing is enabled.':
      'İş ortağı ödeme işlemi etkinleştirildiğinde ödeme satırları burada görünecektir.',
    'Payout Amount': 'Ödeme Tutarı',
    'No platform fees recorded yet': 'Henüz platform ücreti kaydedilmedi',
    'Fee rows will appear here once payment settlement data is available.':
      'Ödeme ödeme verileri mevcut olduğunda ücret satırları burada görünecektir.',
    Gross: 'Brüt',
    'Fee (20%)': 'Ücret (%20)',
    Payments: 'Ödemeler',
    'Client payments, partner payouts, and platform fee tracking.':
      'Müşteri ödemeleri, iş ortağı ödemeleri ve platform ücreti takibi.',
    'Client Payments': 'Müşteri Ödemeleri',
    'Partner Payouts': 'İş Ortağı Ödemeleri',
    'Platform Fees': 'Platform Ücretleri',
    'Failed to load reviews': 'İncelemeler yüklenemedi',
    'Review removed': 'İnceleme kaldırıldı',
    'Failed to remove review': 'İnceleme kaldırılamadı',
    Reviews: 'Yorumlar',
    'All partner and transport reviews submitted by clients.':
      'Müşteriler tarafından gönderilen tüm ortak ve taşıma incelemeleri.',
    'Loading reviews...': 'İncelemeler yükleniyor...',
    'No reviews found': 'Hiç yorum bulunamadı',
    'Client feedback will appear here when reviews are submitted.':
      'İncelemeler gönderildiğinde müşteri geri bildirimleri burada görünecektir.',
    Stars: 'Yıldızlar',
    Comment: 'Yorum',
    'Search, review, and maintain user accounts with one consistent admin workflow.':
      'Tek bir tutarlı yönetici iş akışıyla kullanıcı hesaplarını arayın, inceleyin ve bakımını yapın.',
    'Track paid and unpaid partner payout invoices, and upload the next delivered listing invoice quickly.':
      'Ödenmiş ve ödenmemiş iş ortağı ödeme faturalarını takip edin ve bir sonraki teslim edilen listeleme faturasını hızla yükleyin.',
    'Search by invoice number, file name, or listing ID':
      'Fatura numarasına, dosya adına veya listeleme kimliğine göre arama yapın',
    'Loading delivered listings...': 'Teslim edilen ilanlar yükleniyor...',
    'Search delivered listing by reference, title, or route':
      'Teslim edilen listeyi referansa, başlığa veya rotaya göre arayın',
    'Route details available in listing': 'Rota ayrıntıları listede mevcut',
    'No matching delivered listings': 'Eşleşen teslim edilmiş liste yok',
    'Selected listing': 'Seçilen liste',
    'Has quotes': 'Tırnak işaretleri var',
    'In transit': 'Transit halinde',
    Open: 'Açık',
    Accepted: 'Kabul edildi',
    Completed: 'Tamamlandı',
    'Client Dashboard': 'Müşteri Kontrol Paneli',
    'Overview of your current transport listings, quote activity, and recent requests.':
      'Mevcut taşıma listelerinize, teklif faaliyetlerinize ve son taleplerinize genel bakış.',
    'Total listings': 'Toplam listeler',
    'Active listings': 'Aktif listeler',
    'Listings with quotes': 'Alıntı içeren listeler',
    'Accepted transport': 'Kabul edilen taşıma',
    'Listing status timeline': 'Listeleme durumu zaman çizelgesi',
    'Last 6 months of listings grouped by current status.':
      'Mevcut duruma göre gruplandırılmış son 6 aylık ilanlar.',
    'No listing activity yet': 'Henüz listeleme etkinliği yok',
    'Create your first listing to start tracking request activity here.':
      'Talep etkinliğini izlemeye başlamak için ilk listelemenizi burada oluşturun.',
    'Create new listing': 'Yeni liste oluştur',
    'Create a new transport request for the marketplace.':
      'Market için yeni bir taşıma talebi oluşturun.',
    'View my listings': 'İlanlarımı görüntüle',
    'Review quote activity and manage your transport requests.':
      'Teklif etkinliğini inceleyin ve taşıma taleplerinizi yönetin.',
    'Recent listings': 'Son listeler',
    'No listings yet': 'Henüz ilan yok',
    'Your newest transport requests will appear here once you create them.':
      'En yeni ulaşım talepleriniz, onları oluşturduğunuzda burada görünecektir.',
    'Unknown origin': 'Bilinmeyen köken',
    '{{count}} quote(s)': '{{count}} alıntı(lar)',
    '{{value}} completed listings': '{{value}} tamamlanmış listeler',
    'Monitor current performance, fleet readiness, quote flow, and your active transport queue.':
      'Mevcut performansı, filo hazırlığını, teklif akışını ve aktif taşıma kuyruğunuzu izleyin.',
    'Total assigned': 'Toplam atanan',
    'Quarter rating': 'Çeyrek derecelendirme',
    'Based on current quarter performance': 'Mevcut çeyrek performansına göre',
    Rating: 'Derecelendirme',
    'Requirement met': 'Gereksinim karşılandı',
    'Requirement not met': 'Gereksinim karşılanmadı',
    'Completed listings per period': 'Dönem başına tamamlanan listelemeler',
    'No completion data yet': 'Henüz tamamlanma verisi yok',
    'Statistics will appear here after your first delivered work.':
      'İlk teslim ettiğiniz çalışmadan sonra istatistikler burada görünecektir.',
    'Completed listings': 'Tamamlanan listeler',
    'Review truck documents and refresh anything close to expiry.':
      'Kamyon belgelerini inceleyin ve süresi dolmak üzere olan her şeyi yenileyin.',
    'Search deliveries': 'Teslimatları arayın',
    'Review available marketplace listings and submit quotes.':
      'Mevcut pazar yeri listelerini inceleyin ve teklif gönderin.',
    'My quotes': 'Alıntılarım',
    'Track accepted, pending, and rejected quotes in one place.':
      'Kabul edilen, bekleyen ve reddedilen teklifleri tek bir yerden takip edin.',
    'Profile settings': 'Profil ayarları',
    'Keep company information and compliance details up to date.':
      'Şirket bilgilerini ve uyumluluk ayrıntılarını güncel tutun.',
    'No active queue items': 'Etkin kuyruk öğesi yok',
    'Accepted and in-progress work will appear here as your transport activity grows.':
      'Taşıma faaliyetiniz büyüdükçe kabul edilmiş ve devam eden çalışmalar burada görünecektir.',
    'Your role does not have permission to open this page.':
      'Rolünüzün bu sayfayı açma izni yok.',
    'Go to dashboard': 'Kontrol paneline git',
    'Trailer capacity is required.': 'Römork kapasitesi gereklidir.',
    'How many cars can this trailer carry?': 'Bu römork kaç araba taşıyabilir?',
    'Set maximum number of cars this trailer can carry (1-20).':
      'Bu römorkun taşıyabileceği maksimum araba sayısını ayarlayın (1-20).',
    'Invalid max load (kg).': 'Geçersiz maksimum yük (kg).',
    'Enter a valid weight between 1 and 100000 kg, or leave it empty.':
      '1 ile 100000 kg arasında geçerli bir ağırlık girin veya boş bırakın.',
    'Maximum payload weight this truck can carry (optional).':
      'Bu kamyonun taşıyabileceği maksimum yük ağırlığı (isteğe bağlı).',
    'Manage the company and contact details that appear across your listings, invoices, and account verification flows.':
      'Listelemelerinizde, faturalarınızda ve hesap doğrulama akışlarınızda görünen şirket ve iletişim ayrıntılarını yönetin.',
    'Keep these details up to date so listings, invoices, and partner verification stay accurate.':
      'Listelemelerin, faturaların ve iş ortağı doğrulamasının doğru kalması için bu ayrıntıları güncel tutun.',
    'Unsaved changes': 'Kaydedilmemiş değişiklikler',
    'All changes saved': 'Tüm değişiklikler kaydedildi',
    'auth.sign_up_failed': 'Kayıt başarısız oldu',
    'auth.please_select_a_valid_role': 'Lütfen geçerli bir rol seçin.',
    'booking.pickup_not_found': 'Teslim alma bulunamadı.',
    'booking.delivery_not_found': 'Teslimat bulunamadı.',
    'booking.capacity': 'Kapasite',
    'booking.cmr_expiry': "CMR'nin Sona Ermesi",
    'booking.uploaded': 'Yüklendi',
    'booking.missing': 'Eksik',
    'booking.cmr_document': 'CMR Belgesi',
    'booking.go_to_profile': 'Profile Git',
    'booking.click_to_download_purchase_terms':
      'Satın Alma Koşullarını indirmek için tıklayın',
    'admin.purchase_terms_management': 'Satın Alma Koşulları Yönetimi',
    'admin.purchase_terms_management_subtitle':
      "İş ortağı sipariş kabulünde kullanılan yerelleştirilmiş Satın Alma Şartları PDF'lerini yükleyin ve saklayın.",
    'admin.document_language': 'Belge dili',
    'admin.click_to_download_purchase_terms':
      'Satın Alma Koşullarını indirmek için tıklayın',
    'admin.current_language_label': 'Geçerli dil: {{language}}',
    'admin.purchase_terms_unavailable_for_selected_language':
      'Satın alma koşulları belgesi seçilen dil için mevcut değil.',
    'Download and review the active purchase terms in your current interface language before continuing.':
      'Devam etmeden önce etkin satın alma koşullarını mevcut arayüz dilinizde indirin ve inceleyin.',
    'We make agreements and conclude a contract for the carriage of goods. I have just read this agreement in full and agree to its contents.':
      'Malların taşınması için anlaşmalar yapıyor ve bir sözleşme imzalıyoruz. Bu sözleşmenin tamamını okudum ve içeriğini kabul ediyorum.',
    'I confirm that I will schedule this order within 24 hours':
      'Bu siparişi 24 saat içinde planlayacağımı onaylıyorum',
    'Failed to load purchase terms document.':
      'Satın alma koşulları belgesi yüklenemedi.',
    'Partner rating': 'İş ortağı derecelendirmesi',
    'Bronze requirements': 'Bronz gereksinimleri',
    'Orders in quarter': 'Çeyrekteki siparişler',
    'Cancellation rate / 100 orders': 'İptal oranı / 100 sipariş',
    'Damage claims / 100 orders': 'Hasar talepleri / 100 sipariş',
    '{{current}} / min {{target}}': '{{current}} / dak {{target}}',
    '{{current}} / max {{target}}': '{{current}} / maksimum {{target}}',
    Met: 'Buluştu',
    'Not met': 'Karşılanmadı',
    Unranked: 'Sıralanmamış',
    'profile.incompleteDescriptionPartner':
      'Tüm özelliklere erişebilmek için lütfen profil bilgilerinizi (Şirket, Telefon, Adres, Şehir, Posta Kodu, KDV Numarası) doldurun.',
    'profile.incompleteDescriptionClient':
      'Tüm özelliklere erişebilmek için lütfen profil bilgilerinizi (Telefon Numarası) doldurun.',
    'auth.verification_email_sent': 'Doğrulama e-postası gönderildi',
    '{{amount}} above the client target':
      '{{amount}} müşteri hedefinin üzerinde',
    '{{amount}} below the client target':
      '{{amount}} müşteri hedefinin altında',
    '{{count}} image(s) added to the listing.':
      '{{count}} resim(ler) listeye eklendi.',
    '{{count}} quote(s) received': '{{count}} teklif(ler) alındı',
    '{{count}} reviews': '{{count}} yorumlar',
    '{{count}} total': '{{count}} toplam',
    '{{count}} visible': '{{count}} görünür',
    '{{weight}} kg': '{{weight}} kg',
    'A Google route preview with pins A and B appears here once pickup and delivery coordinates are available.':
      'Teslim alma ve teslimat koordinatları mevcut olduğunda, A ve B pinlerini içeren bir Google rota önizlemesi burada görünür.',
    'A route preview appears once map coordinates are available.':
      'Harita koordinatları mevcut olduğunda bir rota önizlemesi görüntülenir.',
    'A timeline of clarifications connected to this listing.':
      'Bu listeyle bağlantılı açıklamaların zaman çizelgesi.',
    "Accept {{partner}}'s quote for {{amount}}?":
      "{{partner}}'in {{amount}} için teklifini kabul ediyor musunuz?",
    'Accept Listing': 'İlanı Kabul Et',
    'Accept quote': 'Teklifi kabul et',
    'Accepted quote': 'Kabul edilen teklif',
    'Accepted quote required': 'Kabul edilen teklif gerekli',
    'Accepting...': 'Kabul ediliyor...',
    Active: 'Aktif',
    'Active statuses': 'Aktif durumlar',
    'Add another item': 'Başka bir öğe ekle',
    'Add images': 'Resim ekle',
    'Add more shipment images': 'Daha fazla gönderi resmi ekleyin',
    'After you confirm an AI action, open the prepared destination immediately instead of waiting for a manual click.':
      'Bir AI eylemini onayladıktan sonra, manuel tıklamayı beklemek yerine hazırlanan hedefi hemen açın.',
    'AI Assistant': 'Yapay Zeka Asistanı',
    'AI assistant disabled for all users.':
      'AI asistanı tüm kullanıcılar için devre dışı bırakıldı.',
    'AI assistant enabled for all users.':
      'AI asistanı tüm kullanıcılar için etkinleştirildi.',
    'AI assistant preferences updated':
      'Yapay zeka asistanı tercihleri güncellendi',
    'AI disabled for user.': 'AI kullanıcı için devre dışı bırakıldı.',
    'AI enabled for user.': 'Kullanıcı için AI etkinleştirildi.',
    'AI-powered message translation between languages':
      'Diller arasında yapay zeka destekli mesaj çevirisi',
    'All route-critical information in one place before you review quotes or documents.':
      'Teklifleri veya belgeleri incelemeden önce tüm rota açısından kritik bilgiler tek bir yerde.',
    View: 'Görüntüle',
    Answer: 'Cevap',
    Archive: 'Arşiv',
    'Archived statuses': 'Arşivlenmiş durumlar',
    'Are you sure you want to reject the quote from':
      'Teklifi reddetmek istediğinizden emin misiniz?',
    'Ask a question about this listing...':
      'Bu ilanla ilgili bir soru sorun...',
    'Ask for matching lanes, quote help, or the next operational step.':
      'Eşleşen şeritleri, teklif yardımını veya bir sonraki operasyonel adımı isteyin.',
    'Ask for quote comparisons or a prepared next step from this shipment screen.':
      'Bu gönderi ekranından teklif karşılaştırmaları veya hazırlanmış bir sonraki adım isteyin.',
    'Assistant history cleared': 'Asistan geçmişi temizlendi',
    'Automatically translate messages from other users into your preferred language using AI.':
      'Yapay zekayı kullanarak diğer kullanıcılardan gelen mesajları otomatik olarak tercih ettiğiniz dile çevirin.',
    'Back to listing': 'Listelemeye geri dön',
    'Best offer': 'En iyi teklif',
    'Best quote': 'En iyi teklif',
    'Body type: {{type}}': 'Gövde tipi: {{type}}',
    'Breed: {{breed}}': 'Cins: {{breed}}',
    Budget: 'Bütçe',
    'Cancel listing': 'Listelemeyi iptal et',
    'Canceled and completed work will appear here once listings move out of the active view.':
      'İptal edilen ve tamamlanan çalışmalar, listeler aktif görünümden çıktığında burada görünecektir.',
    'Cargo Details': 'Kargo Detayları',
    Categories: 'Kategoriler',
    'Choose the interface language. This preference is saved locally and applies immediately.':
      'Arayüz dilini seçin. Bu tercih yerel olarak kaydedilir ve hemen uygulanır.',
    'Clear all': 'Tümünü temizle',
    'Clear assistant history': 'Asistan geçmişini temizle',
    'Client price in EUR': 'EUR cinsinden müşteri fiyatı',
    'Client target price': 'Müşteri hedef fiyatı',
    'Complete the payment below to lock the fixed-price acceptance and let the partner start planning.':
      'Sabit fiyat kabulünü kilitlemek ve iş ortağının planlamaya başlamasını sağlamak için aşağıdaki ödemeyi tamamlayın.',
    'Complete the payment below to lock the selected quote and let the partner start planning.':
      'Seçilen teklifi kilitlemek ve iş ortağının planlamaya başlamasını sağlamak için aşağıdaki ödemeyi tamamlayın.',
    'Compose area prepared for listing Q&A. Submission remains disabled until the live question endpoint is connected on this page.':
      'Soru-Cevap listelemesi için hazırlanan alanı oluşturun. Canlı soru uç noktası bu sayfaya bağlanana kadar gönderim devre dışı kalır.',
    'Confirm delivery complete': 'Teslimatın tamamlandığını onaylayın',
    'Confirm payment received': 'Ödemenin alındığını onaylayın',
    'Confirm that you have received the bank transfer or payment for this listing. This will move the listing to Paid status and allow the partner to mark it as planned.':
      'Bu giriş için banka havalesini veya ödemeyi aldığınızı onaylayın. Bu, girişi Ücretli durumuna taşıyacak ve iş ortağının bunu planlandığı gibi işaretlemesine olanak tanıyacaktır.',
    'Confirm the exact fleet and dates before the listing moves to Planned.':
      "Listeleme Planlananlar'a taşınmadan önce tam filoyu ve tarihleri ​​doğrulayın.",
    'Confirm Transport Plan': 'Taşıma Planını Onaylayın',
    'Confirming...': 'Onaylanıyor...',
    'Control how the web assistant behaves on this device. These settings do not change your account data.':
      'Web asistanının bu cihazda nasıl davranacağını kontrol edin. Bu ayarlar hesap verilerinizi değiştirmez.',
    'Create listing': 'Giriş oluştur',
    'Create with AI': 'Yapay zeka ile yaratın',
    'Create your next transport request and it will appear here with route, item, and quote activity.':
      'Bir sonraki taşıma talebinizi oluşturduğunuzda rota, öğe ve fiyat teklifi etkinliğiyle birlikte burada görünecektir.',
    'Current stage:': 'Mevcut aşama:',
    'Current status': 'Mevcut durum',
    'Delivery confirmation needed': 'Teslimat onayı gerekli',
    'Delivery radius': 'Teslimat yarıçapı',
    'Delivery:': 'Teslimat:',
    'Describe the route and cargo, then review the prepared listing draft before publishing.':
      'Güzergahı ve kargoyu tanımlayın, ardından hazırlanan liste taslağını yayınlamadan önce inceleyin.',
    'Describe the shipment you need and review the prepared request before publishing.':
      'İhtiyacınız olan gönderiyi tanımlayın ve hazırlanan talebi yayınlamadan önce inceleyin.',
    'Download and review the purchase terms before confirming the transport plan.':
      'Taşıma planını onaylamadan önce satın alma koşullarını indirin ve inceleyin.',
    'Download invoice': 'Faturayı indir',
    'Download Purchase Terms': 'Satın Alma Şartlarını İndirin',
    'Draft with AI': 'Yapay zeka ile taslak',
    'Draft your review first, then submit it here when you are satisfied.':
      'Önce incelemenizin taslağını hazırlayın, ardından memnun kaldığınızda buraya gönderin.',
    'Edit listing': 'İlanı düzenle',
    'Edit Quote': 'Teklifi Düzenle',
    Enable: 'Etkinleştir',
    'Enable live translation': 'Canlı çeviriyi etkinleştir',
    'Enabled Users': 'Etkin Kullanıcılar',
    'Engagement Activity': 'Katılım Etkinliği',
    'Expires:': 'Sona erme tarihi:',
    'Failed to accept listing': 'Listeleme kabul edilemedi',
    'Failed to accept quote': 'Teklif kabul edilemedi',
    'Failed to clear assistant history': 'Asistan geçmişi temizlenemedi',
    'Failed to complete listing': 'Listeleme tamamlanamadı',
    'Failed to confirm payment': 'Ödeme onaylanamadı',
    'Failed to confirm transport plan': 'Taşıma planı onaylanamadı',
    'Failed to disable AI for user.':
      'Kullanıcı için AI devre dışı bırakılamadı.',
    'Failed to enable AI for user.': 'Kullanıcı için AI etkinleştirilemedi.',
    'Failed to load listing.': 'Liste yüklenemedi.',
    'Failed to load listings': 'Listeler yüklenemedi',
    'Failed to load listings. Please try again.':
      'Listeler yüklenemedi. Lütfen tekrar deneyin.',
    'Failed to load review context.': 'İnceleme bağlamı yüklenemedi.',
    'Failed to load settings.': 'Ayarlar yüklenemedi.',
    'Failed to refresh Stripe payment status':
      'Stripe ödeme durumu yenilenemedi',
    'Failed to reject quote': 'Teklif reddedilemedi',
    'Failed to release listing': 'Liste yayınlanamadı',
    'Failed to save quote': 'Fiyat teklifi kaydedilemedi',
    'Failed to update listing': 'Liste güncellenemedi',
    'Failed to update preferred language': 'Tercih edilen dil güncellenemedi',
    'Failed to update setting.': 'Ayar güncellenemedi.',
    'Failed to update status': 'Durum güncellenemedi',
    'Failed to update translation preference': 'Çeviri tercihi güncellenemedi',
    'Failed to update watchlist': 'İzleme listesi güncellenemedi',
    'Failed to withdraw quote': 'Teklif geri çekilemedi',
    'Feature Flags': 'Özellik Bayrakları',
    'Filter invoice uploads, search by reference, and page through payout records.':
      'Fatura yüklemelerini filtreleyin, referansa göre arama yapın ve ödeme kayıtları arasında sayfalarca dolaşın.',
    Filters: 'Filtreler',
    'Final delivery documents': 'Nihai teslimat belgeleri',
    'Fixed price only': 'Yalnızca sabit fiyat',
    'Flexible / not set': 'Esnek / ayarlanmamış',
    'Generated automatically when the transport plan is confirmed.':
      'Taşıma planı onaylandığında otomatik olarak oluşturulur.',
    'Generation: {{generation}}': 'Nesil: {{generation}}',
    'Goods delivered — awaiting client confirmation.':
      'Ürünler teslim edildi - müşteri onayı bekleniyor.',
    'Gross price': 'Brüt fiyat',
    'I have read and agree to the purchase terms for this transport job.':
      'Bu nakliye işinin satın alma koşullarını okudum ve kabul ediyorum.',
    'I understand that accepting this listing assigns it to me at the fixed client price shown above.':
      'Bu listelemeyi kabul etmenin onu yukarıda gösterilen sabit müşteri fiyatı üzerinden bana devrettiğini anlıyorum.',
    'Image upload failed': 'Resim yükleme başarısız oldu',
    'Images uploaded': 'Yüklenen resimler',
    'Interface language': 'Arayüz dili',
    'Invoice documents': 'Fatura belgeleri',
    'Item {{number}}': 'Ürün {{number}}',
    items: 'öğeler',
    'Keep listing': 'Listelemeye devam et',
    'Keep quote': 'Teklifi sakla',
    'Keep the current AI session available after closing the browser on this device.':
      'Bu cihazdaki tarayıcıyı kapattıktan sonra mevcut AI oturumunu kullanılabilir durumda tutun.',
    'Language & Region': 'Dil ve Bölge',
    'Lift: {{origin}} / {{destination}}':
      'Kaldırma: {{origin}} / {{destination}}',
    Listed: 'Listelendi',
    'Listing {{id}}': 'İlan {{id}}',
    'Listing accepted': 'Listeleme kabul edildi',
    'Listing expired': 'İlanın süresi doldu',
    'Listing images': 'Resimleri listeleme',
    'Listing is live': 'İlan yayında',
    'Listing reference': 'Listeleme referansı',
    'Listing snapshot': 'Anlık görüntü listeleniyor',
    'Listing unavailable': 'Listeleme mevcut değil',
    'Listing updated': 'İlan güncellendi',
    'Live Translation': 'Canlı Çeviri',
    'Live translation disabled.': 'Canlı çeviri devre dışı bırakıldı.',
    'Live translation enabled.': 'Canlı çeviri etkinleştirildi.',
    'Loading approved trucks...': 'Onaylı kamyonlar yükleniyor...',
    'Loading fleet...': 'Filo yükleniyor...',
    'Loading listing details...': 'İlan ayrıntıları yükleniyor...',
    'Loading listings...': 'Listeler yükleniyor...',
    'Loading review details...': 'İnceleme ayrıntıları yükleniyor...',
    'Loading settings...': 'Ayarlar yükleniyor...',
    'Manage AI Assistant Users': 'AI Asistanı Kullanıcılarını Yönetin',
    'Manage platform-wide feature flags and configuration.':
      'Platform çapında özellik işaretlerini ve yapılandırmasını yönetin.',
    'Manage Users': 'Kullanıcıları Yönet',
    'Manage your transport requests, monitor quote activity, and keep active and archived work easy to scan.':
      'Taşıma taleplerinizi yönetin, fiyat teklifi etkinliğini izleyin ve etkin ve arşivlenmiş işlerin kolayca taranmasını sağlayın.',
    'Mark Picked Up': 'Alındığını İşaretle',
    'Matches the client target price': 'Müşteri hedef fiyatıyla eşleşir',
    Media: 'Medya',
    Messages: 'Mesajlar',
    'Messages will be translated into this language.':
      'Mesajlar bu dile çevrilecektir.',
    'Minimum net:': 'Asgari net:',
    'My invoices': 'Faturalarım',
    Net: 'ağ',
    'Net price': 'Net fiyat',
    'Net quote': 'Net teklif',
    'New images appear immediately in the listing details for client, partner, and admin views.':
      'Müşteri, iş ortağı ve yönetici görünümlerinin listeleme ayrıntılarında yeni görseller hemen görünür.',
    'Next step': 'Sonraki adım',
    'No active listings yet': 'Henüz aktif ilan yok',
    'No address provided': 'Adres belirtilmedi',
    'No answer yet.': 'Henüz cevap yok.',
    'No archived listings yet': 'Henüz arşivlenmiş ilan yok',
    'No description added.': 'Açıklama eklenmedi.',
    'no destination': 'hedef yok',
    'No expiry': 'Son kullanma tarihi yok',
    'No listings match the current filters. Try broadening the search or date range.':
      'Mevcut filtrelerle eşleşen liste yok. Aramayı veya tarih aralığını genişletmeyi deneyin.',
    'no origin': 'köken yok',
    'No questions yet': 'Henüz soru yok',
    'No quotes yet': 'Henüz teklif yok',
    'No shipment images uploaded yet.': 'Henüz gönderi resmi yüklenmedi.',
    'No trailer selected': 'Fragman seçilmedi',
    'No unread messages': 'Okunmamış mesaj yok',
    'No users found.': 'Hiçbir kullanıcı bulunamadı.',
    'No users have AI enabled.': 'Hiçbir kullanıcıda AI etkin değil.',
    'Not selected': 'Seçilmedi',
    'Offers summary': 'Teklif özeti',
    'Open AI assistant': 'AI asistanını aç',
    'Open prepared screens automatically':
      'Hazırlanan ekranları otomatik olarak aç',
    'Optional visible price shown to partners as your target budget.':
      'İş ortaklarınıza hedef bütçeniz olarak gösterilen isteğe bağlı görünür fiyat.',
    'Other quotes will be declined automatically once this offer is accepted.':
      'Bu teklif kabul edildiğinde diğer teklifler otomatik olarak reddedilecektir.',
    'Partner delivery': 'İş ortağı teslimatı',
    'Partner pickup': 'İş ortağından teslim alma',
    'Partner quote': 'İş ortağı teklifi',
    'Payment confirmed': 'Ödeme onaylandı',
    'Payment confirmed — listing status set to paid':
      'Ödeme onaylandı — listeleme durumu ödendi olarak ayarlandı',
    'Payment confirmed. Confirm the assigned fleet and planned dates before the listing moves to Planned.':
      "Ödeme onaylandı. Listeleme Planlanan'a taşınmadan önce atanan filoyu ve planlanan tarihleri ​​onaylayın.",
    'Payment is confirmed. The partner now needs to confirm the truck, driver, and planned dates.':
      'Ödeme onaylandı. İş ortağının artık kamyonu, sürücüyü ve planlanan tarihleri ​​onaylaması gerekiyor.',
    'Payment required': 'Ödeme gerekli',
    'Photos uploaded for the shipment and visible across client, partner, and admin views.':
      'Gönderi için yüklenen ve müşteri, iş ortağı ve yönetici görünümlerinde görülebilen fotoğraflar.',
    'Pickup is complete and the transport is currently underway.':
      'Toplama işlemi tamamlandı ve taşıma işlemi şu anda devam ediyor.',
    'Pickup proof': 'Alma kanıtı',
    'Pickup proof and final delivery files uploaded by the transport partner.':
      'Nakliye ortağı tarafından yüklenen teslim alma kanıtı ve son teslimat dosyaları.',
    'Pickup to delivery overview': 'Teslim alımdan teslimata genel bakış',
    'Pickup:': 'Teslim alma:',
    'Plan and authorization': 'Plan ve yetkilendirme',
    'Plan transport': 'Taşımayı planlayın',
    'Plan Transport': 'Ulaşımı Planlayın',
    'Planned dates:': 'Planlanan tarihler:',
    'Planned delivery date': 'Planlanan teslimat tarihi',
    'Platform Settings': 'Platform Ayarları',
    'Preferred language': 'Tercih edilen dil',
    'Preferred language updated': 'Tercih edilen dil güncellendi',
    'Prepare a quote or ask for the next lane action, then confirm before anything is submitted.':
      'Bir fiyat teklifi hazırlayın veya bir sonraki şerit eylemini isteyin, ardından herhangi bir şey gönderilmeden önce onaylayın.',
    'Purchase Terms': 'Satın Alma Şartları',
    'Quantities, dimensions, and handling details ready for transport review.':
      'Miktarlar, boyutlar ve taşıma ayrıntıları nakliye incelemesi için hazır.',
    Question: 'Soru',
    Questions: 'Sorular',
    'Questions & answers': 'Sorular ve cevaplar',
    'Questions and answers for this listing will appear here once the messaging flow is active.':
      'Bu listeye ilişkin sorular ve yanıtlar, mesajlaşma akışı aktif hale geldiğinde burada görünecektir.',
    'Quick access to the current shipment, quote, and billing state.':
      'Mevcut gönderiye, teklife ve fatura durumuna hızlı erişim.',
    'Quote accepted': 'Teklif kabul edildi',
    'Quote count': 'Teklif sayısı',
    'Quote message': 'Alıntı mesajı',
    'Quote rejected': 'Teklif reddedildi',
    'Quote withdrawn': 'Fiyat teklifi geri çekildi',
    Quotes: 'Alıntılar',
    'Quotes and questions': 'Alıntılar ve sorular',
    'Quotes are disabled for this listing. The first partner to accept the fixed price will be assigned automatically.':
      'Bu liste için teklifler devre dışı bırakıldı. Sabit fiyatı kabul eden ilk ortak otomatik olarak atanacaktır.',
    'Quotes are disabled for this shipment. If you accept it, the client price becomes an accepted booking immediately.':
      'Bu gönderi için teklifler devre dışı bırakıldı. Kabul ederseniz müşteri fiyatı anında kabul edilen bir rezervasyon haline gelir.',
    'Quotes from transport providers usually begin to appear shortly after publishing. Refresh to check again.':
      'Taşıma sağlayıcılarından alıntılar genellikle yayınlandıktan kısa bir süre sonra görünmeye başlar. Tekrar kontrol etmek için yenileyin.',
    'Reference #{{id}}': 'Referans #{{id}}',
    'Refresh listings': 'Listeleri yenile',
    'Reject quote': 'Teklifi reddet',
    'Rejecting...': 'Reddediliyor...',
    Release: 'Sürüm',
    'Release Listing': 'Sürüm Listesi',
    'Remember assistant conversation': 'Asistan konuşmasını hatırla',
    'Required for fixed-price listings. Partners accept this amount directly.':
      'Sabit fiyatlı listelemeler için gereklidir. Ortaklar bu tutarı doğrudan kabul eder.',
    'Required. Partners will be able to accept this listing at the fixed client price without sending a quote.':
      'Gerekli. İş ortakları, bu listelemeyi fiyat teklifi göndermeden sabit müşteri fiyatı üzerinden kabul edebilecektir.',
    'Review submission failed.': 'İnceleme gönderimi başarısız oldu.',
    'Review the completed transport using the standard product flow.':
      'Tamamlanan taşıma işlemini standart ürün akışını kullanarak inceleyin.',
    'Route pending': 'Rota beklemede',
    'Save changes': 'Değişiklikleri kaydet',
    'Saving...': 'Kaydediliyor...',
    'Search by title, route, category, or item':
      'Başlığa, rotaya, kategoriye veya öğeye göre arayın',
    'Search Results': 'Arama Sonuçları',
    'Search users by email...': 'Kullanıcıları e-postayla arayın...',
    'Select a truck, driver, pickup date, and delivery date.':
      'Bir kamyon, sürücü, teslim alma tarihi ve teslimat tarihi seçin.',
    'Select approved truck': 'Onaylanmış kamyonu seçin',
    'Select driver': 'Sürücüyü seçin',
    'Send Revision': 'Revizyonu Gönder',
    Sentiment: 'Duygu',
    'Share what went well and what could improve':
      'Nelerin iyi gittiğini ve nelerin iyileştirilebileceğini paylaşın',
    'Shipment in transit': 'Transit sevkiyat',
    'Shipment notes': 'Gönderi notları',
    'Shipment tracking will be shared': 'Gönderi takibi paylaşılacak',
    'Show AI launchers': 'AI başlatıcılarını göster',
    'Show or hide AI assistant buttons on supported dashboard and listing pages.':
      'Desteklenen kontrol panelinde ve listeleme sayfalarında AI asistanı düğmelerini gösterin veya gizleyin.',
    'Special needs or notes': 'Özel ihtiyaçlar veya notlar',
    'Specify delivery dates': 'Teslimat tarihlerini belirtin',
    'Specify pickup dates': 'Teslim alma tarihlerini belirtin',
    Stage: 'Sahne',
    'Status updated to {{status}}': 'Durum {{status}} olarak güncellendi',
    'Stripe payment confirmed and booking updated':
      'Stripe ödemesi onaylandı ve rezervasyon güncellendi',
    'Stripe status: {{status}}': 'Şerit durumu: {{status}}',
    'Submit question': 'Soruyu gönder',
    'Submit review': 'İncelemeyi gönder',
    'Submitting...': 'Gönderiliyor...',
    'The AI assistant is currently disabled for this environment. Existing local session data can still be cleared here.':
      'Yapay zeka asistanı şu anda bu ortam için devre dışı. Mevcut yerel oturum verileri burada hâlâ temizlenebilir.',
    'The listing expired before a transport was confirmed.':
      'Bir taşıma onaylanmadan önce listenin süresi doldu.',
    'The listing has been fully completed and archived as a finished transport.':
      'Listeleme tamamen tamamlandı ve tamamlanmış bir taşıma olarak arşivlendi.',
    'The lowest net price you would still accept for this shipment.':
      'Bu gönderi için hâlâ kabul edebileceğiniz en düşük net fiyat.',
    'The partner has confirmed the route plan. Pickup and delivery dates are now scheduled.':
      'Ortak rota planını onayladı. Teslim alma ve teslim tarihleri ​​artık planlanıyor.',
    'The partner marked the shipment as delivered. Review the final documents and confirm completion.':
      'İş ortağı, gönderiyi teslim edildi olarak işaretledi. Nihai belgeleri inceleyin ve tamamlandığını onaylayın.',
    'The partner-confirmed plan and LOA stay grouped together for faster review.':
      'İş ortağı tarafından onaylanan plan ve LOA, daha hızlı inceleme için birlikte gruplandırılır.',
    'This action notifies the transport provider and removes the quote from active consideration.':
      'Bu eylem, taşıma sağlayıcısını bilgilendirir ve teklifi aktif değerlendirmeden çıkarır.',
    'This listing is archived and no further transport actions are available.':
      'Bu liste arşivlendi ve başka taşıma işlemi mevcut değil.',
    'This listing needs an accepted quote before a review can be created.':
      'Bir incelemenin oluşturulabilmesi için bu listenin kabul edilmiş bir teklife ihtiyacı var.',
    'This will soft-cancel the listing and move it to your archive.':
      'Bu, listelemeyi geçici olarak iptal edecek ve arşivinize taşıyacaktır.',
    'This will soft-cancel the listing for the client and remove it from active marketplace views.':
      'Bu, müşterinin listelemesini geçici olarak iptal edecek ve onu aktif pazar yeri görünümlerinden kaldıracaktır.',
    'Total quote': 'Toplam teklif',
    'Tracking not promised': 'Takip sözü verilmedi',
    'Tracking shared': 'Takip paylaşıldı',
    'Tracking visibility': 'İzleme görünürlüğü',
    'Trailer (Optional)': 'Fragman (Opsiyonel)',
    'Translation preference updated': 'Çeviri tercihi güncellendi',
    'Transport completed': 'Taşıma tamamlandı',
    'Transport completed.': 'Taşıma tamamlandı.',
    'Transport documents': 'Taşıma belgeleri',
    'Transport marked as complete': 'Taşıma tamamlandı olarak işaretlendi',
    'Transport package': 'Taşıma paketi',
    'Transport plan confirmed': 'Ulaşım planı onaylandı',
    'Transport plan updated': 'Ulaşım planı güncellendi',
    'Transport planned': 'Ulaşım planlandı',
    'Transport Provider': 'Taşıma Sağlayıcısı',
    'Transport providers can review your shipment and send offers.':
      'Nakliye sağlayıcıları gönderinizi inceleyebilir ve teklif gönderebilir.',
    'Transport stage': 'Taşıma aşaması',
    Truck: 'Kamyon',
    'Truck, driver, trailer, and planned dates for this shipment.':
      'Bu sevkiyat için kamyon, sürücü, treyler ve planlanan tarihler.',
    'Try widening the current listing filters.':
      'Mevcut listeleme filtrelerini genişletmeyi deneyin.',
    'Unable to upload listing images.': 'Listeleme görselleri yüklenemiyor.',
    'Unknown error': 'Bilinmeyen hata',
    'Untitled listing': 'Başlıksız listeleme',
    'Untitled Listing': 'İsimsiz Listeleme',
    'Update media': 'Medyayı güncelle',
    'Update transport plan': 'Taşıma planını güncelle',
    'Update Transport Plan': 'Ulaşım Planını Güncelle',
    'Upload a CMR or delivery photos before marking delivered.':
      'Teslim edildi olarak işaretlemeden önce bir CMR veya teslimat fotoğrafı yükleyin.',
    'Upload a CMR or delivery photos before the listing can move to Delivered.':
      "Listelemenin Teslim Edildi'ye taşınmadan önce bir CMR veya teslimat fotoğrafı yükleyin.",
    'Upload at least one pickup proof before the listing can move to Picked Up.':
      "İlanın Teslim Alındı'ya taşınabilmesi için en az bir teslim alma kanıtı yükleyin.",
    'Upload final documents': 'Nihai belgeleri yükleyin',
    'Upload proof of pickup': 'Teslim alma kanıtını yükleyin',
    'Uploading...': 'Yükleniyor...',
    'Use fresh photos when the shipment changes or you want to clarify the item condition.':
      'Gönderi değiştiğinde veya ürünün durumunu netleştirmek istediğinizde yeni fotoğraflar kullanın.',
    'users enabled': 'kullanıcılar etkinleştirildi',
    'Visible to you while quoting. You can still send your own net offer below or above this amount.':
      'Alıntı yaparken size görünür. Bu tutarın altında veya üstünde kendi net teklifinizi yine de gönderebilirsiniz.',
    'Waiting for partner acceptance': 'İş ortağı kabulü bekleniyor',
    'Waiting for transport planning': 'Ulaşım planlaması bekleniyor',
    'When enabled, messages from other users will be automatically translated to your preferred language.':
      'Etkinleştirildiğinde, diğer kullanıcılardan gelen mesajlar otomatik olarak tercih ettiğiniz dile çevrilecektir.',
    Withdraw: 'Çekilme',
    'Write Review': 'İnceleme Yaz',
    'You are about to release this listing back to the marketplace.':
      'Bu listelemeyi tekrar piyasaya sürmek üzeresiniz.',
    'You are now the assigned partner for this fixed-price listing.':
      'Artık bu sabit fiyatlı listenin atanmış ortağısınız.',
    'Your quote has been accepted. Awaiting payment confirmation from the admin before you can begin the job.':
      'Teklifiniz kabul edildi. İşe başlamadan önce yöneticiden ödeme onayı bekleniyor.',
    'VIN: {{vin}}': 'VIN: {{vin}}',
    'L cm': 'U cm',
  },
  sr: {
    'Added {{count}} file(s)': 'Додато {{count}} фајл(е)',
    'Ref {{id}}': 'Реф {{id}}',
    'For {{date}}': 'За {{date}}',
    'Picked on {{date}}': 'Изабран на {{date}}',
    'Delivered on {{date}}': 'Испоручено {{date}}',
    'Loading notification: {{value}}': 'Обавештење о учитавању: {{value}}',
    'CO₂ compensation: {{value}}': 'ЦО₂ компензација: {{value}}',
    'Bio fuel: {{value}}': 'Биогориво: {{value}}',
    'Copy {{label}}': 'Копирај {{label}}',
    'Within {{radius}} {{unit}} of {{place}}':
      'Унутар {{radius}} {{unit}} од {{place}}',
    '{{count}} file(s) uploaded successfully.':
      '{{count}} датотека(а) је успешно отпремљено.',
    'Client ref · {{clientRef}}': 'Реф. клијента · {{clientRef}}',
    'Are you sure you want to cancel booking {{id}}?':
      'Да ли сте сигурни да желите да откажете резервацију {{id}}?',
    'booking.order_cars_exceed_selected_truck_capacity':
      'Ова наруџбина има {{orderCars}} аутомобила, али одабрани капацитет камиона је {{capacity}}.',
    'booking.vip_price_must_be_between_min_max_50_to_150_percent_of_estimated_price':
      'ВИП цена мора бити између {{min}} ЕУР и {{max}} ЕУР (50% до 150% процењене цене).',
    'booking.within_radius_km_of_place':
      'У кругу од {{radius}} км од {{place}}',
    'Download Client Invoice #{{id}}': 'Преузмите рачун клијента #{{id}}',
    'Mark booking {{id}} as paid?': 'Означити резервацију {{id}} као плаћену?',
    'Release booking {{id}} back to the marketplace so another partner can accept it?':
      'Отпустити резервацију {{id}} назад на тржиште да би други партнер могао да је прихвати?',
    'Showing page {{page}} of {{pages}} • {{total}} invoices':
      'Приказује се страница {{page}} од {{pages}} • {{total}} фактуре',
    '{{value}} orders': '{{value}} наруџбине',
    '{{value}} completed': '{{value}} завршено',
    '{{count}} trucks have CMR expiry risk. Review them in Fleet.':
      'Камиони од {{count}} имају ризик од истека ЦМР-а. Прегледајте их у Флоти.',
    'Payment delay: +{{days}} days': 'Кашњење плаћања: +{{days}} дана',
    '{{count}} truck(s) have expired CMR insurance.':
      'Камион(и) од {{count}} имају истекло ЦМР осигурање.',
    '{{count}} truck(s) will expire within 14 days.':
      'Камион(и) од {{count}} истиче у року од 14 дана.',
    '{{count}} truck(s) are missing CMR expiry date.':
      '{{count}} камион(и) недостаје ЦМР датум истека.',
    to: 'да',
    Required: 'Обавезно',
    'Change language': 'Промени језик',
    'Loading...': 'Учитавање…',
    'Error:': 'Грешка:',
    Close: 'Затвори',
    Yes: 'Да',
    No: 'бр',
    'Keep order': 'Одржавајте ред',
    Price: 'Цена',
    'Purchase terms': 'Услови куповине',
    'Power of attorney': 'Пуномоћје',
    'Transport details': 'Детаљи транспорта',
    'Upload damages': 'Учитавање штете',
    'Download (PDF)': 'Преузми (ПДФ)',
    'Mark as picked up': 'Означи као подигнуто',
    'Mark as delivered': 'Означите као испоручено',
    'Cancel booking': 'Откажите резервацију',
    'Order marked as picked up': 'Поруџбина је означена као преузета',
    'Order marked as delivered': 'Поруџбина је означена као испоручена',
    'Order canceled': 'Поруџбина је отказана',
    'Failed to cancel order': 'Отказивање поруџбине није успело',
    Pages: 'Пагес',
    'Awaiting Verification': 'Чека се верификација',
    'Profile Incomplete': 'Профил Непотпун',
    'Please complete your profile information (Company, Phone, Address, City, Post Code) to access all features.':
      'Молимо вас да попуните информације о свом профилу (компанија, телефон, адреса, град, поштански број) да бисте приступили свим функцијама.',
    'Go to Profile': 'Идите на Профил',
    'Forgot Password': 'Заборавили сте лозинку',
    Hello: 'Здраво',
    friend: 'пријатељу',
    'Book your transport': 'Резервишите свој превоз',
    'fast and easy': 'брзо и лако',
    Origin: 'Порекло',
    Destination: 'Одредиште',
    'Postal code': 'Поштански број',
    'Calculate to preview': 'Израчунајте за преглед',
    "Can't be calculated yet": 'Још се не може израчунати',
    'Awaiting payment badge': 'Чекају исплату',
    'Change planning': 'Планирање промена',
    'Change driver': 'Промени драјвер',
    'No vehicles listed': 'Нема наведених возила',
    'Order not found.': 'Поруџбина није пронађена.',
    'Not available': 'Није доступно',
    Remove: 'Уклони',
    'Open navigation menu': 'Отворите мени за навигацију',
    'Open menu': 'Отворите мени',
    'Error fetching data': 'Грешка при преузимању података',
    'Not set': 'Није постављено',
    'No opening hours provided': 'Није наведено радно време',
    'Please select a planned date': 'Молимо изаберите планирани датум',
    'Saved favorite route filter': 'Сачуван филтер омиљених рута',
    'Radius search': 'Претрага радијуса',
    'City or town': 'Град или место',
    'Country (optional)': 'Земља (опционо)',
    Radius: 'Радијус',
    'Searching…': 'Тражење…',
    'City not found': 'Град није пронађен',
    'Clear radius': 'Јасан радијус',
    'auth.account_status_pending_review': 'Статус налога: чека се преглед',
    'auth.your_account_is_pending_approval': 'Ваш налог чека одобрење',
    'auth.upload_your_verification_documents_below_and_we_ll_notify_you_by_email_once_your_account_is_approved':
      'Отпремите документе за верификацију у наставку и обавестићемо вас е-поштом када ваш налог буде одобрен.',
    'auth.check_status': 'Проверите статус',
    'auth.upload_verification_documents': 'Отпремите верификационе документе',
    'auth.your_uploaded_documents': 'Ваши отпремљени документи',
    'auth.back_to_sign_in': 'Назад да се пријавите',
    'Q1 2025': 'К1 2025',
    'Q2 2025': '2. квартал 2025',
    'Q3 2025': 'К3 2025',
    'Error loading documents': 'Грешка при учитавању докумената',
    'Are you sure you want to delete this document?':
      'Да ли сте сигурни да желите да избришете овај документ?',
    'Document deleted': 'Документ је избрисан',
    'Failed to delete': 'Брисање није успело',
    'Failed to get download link': 'Преузимање линка за преузимање није успело',
    'Status updated': 'Статус ажуриран',
    'Update failed': 'Ажурирање није успело',
    'Email cannot be changed.': 'Емаил се не може променити.',
    'No documents found.': 'Није пронађен ниједан документ.',
    'Invoice #': 'број фактуре',
    'File Name': 'Име датотеке',
    Amount: 'Износ',
    Actions: 'Акције',
    Download: 'Преузми',
    'Mark Unpaid': 'Означите неплаћено',
    'Mark Paid': 'Марк Паид',
    'Please save the record before uploading documents.':
      'Сачувајте запис пре него што отпремите документе.',
    'Select a file before uploading.': 'Изаберите датотеку пре отпремања.',
    'Please enter an invoice number.': 'Унесите број фактуре.',
    'Upload successful': 'Отпремање је успешно',
    'Upload failed': 'Отпремање није успело',
    'Unable to upload the document.': 'Није могуће отпремити документ.',
    'Invoice Number': 'Број фактуре',
    'Selected files:': 'Изабране датотеке:',
    Upload: 'Уплоад',
    'Save this record before uploading documents.':
      'Сачувајте овај запис пре него што отпремите документе.',
    'Error approving user': 'Грешка при одобравању корисника',
    'Error rejecting user': 'Грешка при одбијању корисника',
    'Error disabling user': 'Грешка при онемогућавању корисника',
    'User marked as VIP': 'Корисник означен као ВИП',
    'User unmarked as VIP': 'Корисник није означен као ВИП',
    'Error marking user as VIP': 'Грешка при означавању корисника као ВИП',
    'Error unmarking user as VIP':
      'Грешка при укидању ознаке корисника као ВИП',
    'Failed to approve user': 'Одобрење корисника није успело',
    'Failed to reject user': 'Одбијање корисника није успело',
    'Failed to disable user': 'Онемогућавање корисника није успело',
    'Failed to unmark user as VIP':
      'Уклањање ознаке корисника као ВИП није успело',
    'Failed to mark user as VIP': 'Означавање корисника као ВИП није успело',
    'Invoice Management': 'Управљање фактурама',
    'All Invoices': 'Све фактуре',
    'Manage all invoices uploaded by partners.':
      'Управљајте свим фактурама које су отпремили партнери.',
    'An unexpected error occurred. Please try again.':
      'Дошло је до неочекиване грешке. Покушајте поново.',
    'The email address is not valid.': 'Адреса е-поште није важећа.',
    'This account has been disabled.': 'Овај налог је онемогућен.',
    'No account found with this email.':
      'Није пронађен ниједан налог са овом е-поштом.',
    'Incorrect password. Please try again.':
      'Нетачна лозинка. Покушајте поново.',
    'Invalid email or password. Please check your credentials and try again.':
      'Неважећа адреса е-поште или лозинка. Проверите своје акредитиве и покушајте поново.',
    'Too many failed attempts. Please try again later or reset your password.':
      'Превише неуспешних покушаја. Покушајте поново касније или ресетујте лозинку.',
    'Network error. Check your connection and try again.':
      'Мрежна грешка. Проверите везу и покушајте поново.',
    'A verification email has been sent to your email address. Please verify your email before logging in.':
      'Порука за верификацију је послата на вашу адресу е-поште. Молимо вас да потврдите своју е-пошту пре него што се пријавите.',
    'Please make sure both passwords are the same.':
      'Уверите се да су обе лозинке исте.',
    'Verification email resent!': 'Имејл за верификацију је поново послат!',
    'Please check your inbox.': 'Молимо проверите пријемно сандуче.',
    'You need to log in first': 'Прво се морате пријавити',
    'Please sign in to resend the verification email.':
      'Пријавите се да бисте поново послали е-поруку за верификацију.',
    'Failed to resend email': 'Поново слање е-поште није успело',
    'Resend verification email': 'Поново пошаљи е-поруку за верификацију',
    'Show password': 'Прикажи лозинку',
    'Hide password': 'Сакриј лозинку',
    'Awaiting verification artwork': 'Чекају верификацију уметничког дела',
    'Account status: Pending review': 'Статус налога: чека се преглед',
    'Your account is pending approval': 'Ваш налог чека одобрење',
    "Upload your verification documents below and we'll notify you by email once your account is approved.":
      'Отпремите документе за верификацију у наставку и обавестићемо вас е-поштом када ваш налог буде одобрен.',
    'Check status': 'Проверите статус',
    'Upload verification documents': 'Отпремите верификационе документе',
    'Your uploaded documents': 'Ваши отпремљени документи',
    'Back to sign in': 'Назад да се пријавите',
    'Hide documents': 'Сакриј документе',
    'Email verification required': 'Потребна је верификација е-поште',
    'Waiting for email verification': 'Чека се верификацију е-поште',
    'Check your email': 'Проверите своју е-пошту',
    'We sent your verification link to':
      'Послали смо вашу везу за верификацију на',
    "Didn't receive it? Check your spam folder or try again.":
      'Нисте га примили? Проверите фасциклу нежељене поште или покушајте поново.',
    'Resend email': 'Поново пошаљи е-пошту',
    "I've verified my email": 'Верификовао сам своју е-пошту',
    'Redirecting you now.': 'Преусмеравам вас сада.',
    'Email not verified yet': 'Имејл још није верификован',
    'Please click the link in your inbox and try again.':
      'Кликните на везу у пријемном сандучету и покушајте поново.',
    'Unable to resend verification email right now.':
      'Тренутно није могуће поново послати е-поруку за верификацију.',
    'Unable to check verification status right now.':
      'Тренутно није могуће проверити статус верификације.',
    "We've sent a new verification link to your email address.":
      'Послали смо нову везу за верификацију на вашу адресу е-поште.',
    'We automatically check your verification status every 30 seconds. You can also trigger an instant check after verifying your email.':
      'Аутоматски проверавамо ваш статус верификације сваких 30 секунди. Такође можете покренути тренутну проверу након верификације е-поште.',
    'We automatically check your verification status every 15 seconds. You can also trigger an instant check after verifying your email.':
      'Аутоматски проверавамо ваш статус верификације сваких 15 секунди. Такође можете покренути тренутну проверу након верификације е-поште.',
    'Inputs changed. Recalculate the price.':
      'Уноси су промењени. Прерачунајте цену.',
    'My Invoices': 'Моје фактуре',
    'Upload New Invoice': 'Отпремите нову фактуру',
    'Please enter the invoice number and upload the invoice document. It will be reviewed by an administrator.':
      'Унесите број фактуре и отпремите документ фактуре. Прегледаће га администратор.',
    'Invoice History': 'Историја фактура',
    'Order Documents': 'Ордер Доцументс',
    'Upload Proof of Pickup': 'Отпремите доказ о преузимању',
    'Status will be updated to Picked Up after successful upload.':
      'Статус ће бити ажуриран на Преузето након успешног отпремања.',
    'Upload Proof of Delivery': 'Отпремите доказ о испоруци',
    'Status will be updated to Delivered after successful upload.':
      'Статус ће бити ажуриран на Испоручено након успешног отпремања.',
    'Enter first name': 'Унесите име',
    'Enter last name': 'Унесите презиме',
    'Enter phone number': 'Унесите број телефона',
    'Driver updated.': 'Драјвер је ажуриран.',
    'The driver has been successfully updated.': 'Драјвер је успешно ажуриран.',
    'Driver added.': 'Возач је додат.',
    'The new driver has been successfully added.':
      'Нови драјвер је успешно додат.',
    'Driver deleted.': 'Драјвер је избрисан.',
    'The driver has been successfully deleted.': 'Драјвер је успешно обрисан.',
    'Trailer updated.': 'Трејлер је ажуриран.',
    'The trailer has been successfully updated.':
      'Трејлер је успешно ажуриран.',
    'Trailer added.': 'Трејлер је додат.',
    'The new trailer has been successfully added.':
      'Нови трејлер је успешно додат.',
    'Trailer deleted.': 'Трејлер је избрисан.',
    'The trailer has been successfully deleted.':
      'Трејлер је успешно избрисан.',
    'User account not found. Please complete registration.':
      'Кориснички налог није пронађен. Молимо довршите регистрацију.',
    'No token provided': 'Није обезбеђен токен',
    'Token expired': 'Токен је истекао',
    'Token revoked': 'Токен је опозван',
    'Invalid ID token': 'Неважећи ИД токен',
    Unauthorized: 'Неовлашћено',
    'Unauthorized: User not authenticated.':
      'Неовлашћено: Корисник није аутентификован.',
    'Unauthorized: User role not found.':
      'Неовлашћено: Улога корисника није пронађена.',
    'Forbidden: Your role is not allowed to perform this action.':
      'Забрањено: Вашој улози није дозвољено да изврши ову радњу.',
    'Forbidden: This action requires a partner role.':
      'Забрањено: Ова радња захтева улогу партнера.',
    'Forbidden: This action requires a client role.':
      'Забрањено: Ова радња захтева улогу клијента.',
    'Forbidden: This action requires an admin role.':
      'Забрањено: Ова радња захтева улогу администратора.',
    'This user has not been approved': 'Овај корисник није одобрен',
    'User email has not been verified':
      'Корисничка адреса е-поште није верификована',
    'User account has been disabled': 'Кориснички налог је онемогућен',
    'Booking not found': 'Резервација није пронађена',
    'Route not found': 'Рута није пронађена',
    'Pickup location (country and postalCode) is required':
      'Потребна је локација за преузимање (земља и поштански број).',
    'Delivery location (country and postalCode) is required':
      'Обавезна је локација испоруке (земља и поштански број).',
    'Unable to calculate route. Please check the locations and try again.':
      'Није могуће израчунати руту. Проверите локације и покушајте поново.',
    'Error calculating transport price': 'Грешка при израчунавању цене превоза',
    'Booking canceled successfully': 'Резервација је успешно отказана',
    'Invalid request.': 'Неважећи захтев.',
    'Access denied.': 'Приступ одбијен.',
    'Resource not found.': 'Ресурс није пронађен.',
    'Request conflict.': 'Конфликт захтева.',
    'Invalid data provided.': 'Наведени су неважећи подаци.',
    'Too many requests. Please try again later.':
      'Превише захтева. Покушајте поново касније.',
    'Internal server error. Please try again later.':
      'Интерна грешка сервера. Покушајте поново касније.',
    'Service temporarily unavailable.': 'Услуга је привремено недоступна.',
    'booking.load_preset': 'Учитај унапред подешено',
    'booking.save_preset_tooltip':
      'Сачувајте тренутне филтере као унапред подешене поставке за брзи приступ',
    'booking.load_preset_tooltip': 'Учитајте сачувани унапред подешени филтер',
    'booking.preset_saved': 'Пресет је сачуван',
    'booking.preset_saved_desc': 'Ваш филтер унапред је сачуван.',
    'booking.preset_loaded': 'Пресет је учитан',
    'booking.preset_load_error':
      'Учитавање унапред подешених поставки није успело',
    'booking.no_preset_saved':
      'Још увек нема сачуваних унапред подешених поставки',
    'booking.date_from': 'Датум од',
    'booking.date_to': 'Датум до',
    'Active filters': 'Активни филтери',
    'All booking states': 'Све резервисане државе',
    'All partners': 'Сви партнери',
    'All payments': 'Сва плаћања',
    'All roles': 'Све улоге',
    'All statuses': 'Сви статуси',
    'All Users': 'Сви корисници',
    'Attach the CMR Insurance before finishing truck setup.':
      'Приложите ЦМР фактуру пре него што завршите подешавање камиона.',
    Awaiting: 'Аваитинг',
    'Awaiting payout': 'Чекају исплату',
    'Booking canceled': 'Резервација је отказана',
    'Booking marked as paid': 'Резервација је означена као плаћена',
    'Booking released and returned to marketplace':
      'Резервација је објављена и враћена на тржиште',
    'booking.allowed_range': 'Дозвољени опсег',
    'booking.assign_transport': 'Додели транспорт',
    'booking.back': 'Назад',
    'booking.back_to_summary': 'Назад на резиме',
    'booking.booking_created_but_pickup_document_not_uploaded_upload_from_order_details':
      'Резервација је направљена, али документ за преузимање није отпремљен. Можете га отпремити из Детаљи поруџбине.',
    'booking.city_not_found': 'Град није пронађен',
    'booking.city_or_town': 'Град или место',
    'booking.clear_radius': 'Јасан радијус',
    'booking.continue': 'Настави',
    'booking.country_optional': 'Земља (опционо)',
    'booking.delivery_constraint_info':
      'Датум испоруке мора бити на или након датума преузимања.',
    'booking.delivery_date_cannot_be_earlier_than_pickup_date':
      'Датум испоруке не може бити ранији од датума преузимања',
    'booking.driver': 'Возач',
    'booking.failed_to_open_letter_of_attorney':
      'Отварање пуномоћја није успело',
    'booking.go_to_order': 'Идите на Ордер',
    'booking.i_accept_terms': 'Прихватам услове',
    'booking.invalid_license_plate_or_vin_length':
      'Неважећа регистарска таблица или ВИН дужина.',
    'booking.invalid_vin_format_i_o_q_not_allowed':
      'Неважећи ВИН формат. Знакови И, О и К нису дозвољени.',
    'booking.letter_of_attorney_file_is_empty': 'Досије о пуномоћју је празан',
    'booking.no_additional_details': 'Нема додатних детаља',
    'booking.no_vehicle_info': 'Нема информација о возилу',
    'booking.open_letter_of_attorney': 'Отворено пуномоћје',
    'booking.opening_letter_of_attorney': 'Уводно пуномоћје...',
    'booking.order_accepted_successfully': 'Поруџбина је успешно прихваћена',
    'booking.pickup_constraint_info':
      'Датум преузимања је неопходан пре додељивања превоза.',
    'booking.pickup_document_upload_failed':
      'Отпремање документа за преузимање није успело',
    'booking.preparing_secure_document_preview':
      'Припрема безбедног прегледа документа...',
    'booking.radius_km': 'Радијус (км)',
    'booking.radius_search': 'Претрага радијуса',
    'booking.route_and_details': 'Рута и детаљи',
    'booking.schedule': 'Распоред',
    'booking.searching': 'Тражење…',
    'booking.select_pickup_and_delivery': 'Изаберите преузимање и испоруку',
    'booking.select_pickup_and_delivery_dates_before_confirming':
      'Изаберите датуме преузимања и испоруке пре него што потврдите',
    'booking.select_pickup_date': 'Изаберите датум преузимања',
    'booking.select_truck_driver_and_trailer':
      'Изаберите камион, возача и приколицу',
    'booking.supported_formats_jpg_png_pdf_doc_docx':
      'Подржани формати: ЈПГ, ПНГ, ПДФ, ДОЦ, ДОЦКС',
    'booking.terms_and_conditions': 'Услови и одредбе',
    'booking.terms_text': 'Потврђујем услове транспорта и услове одговорности.',
    'booking.track_shipment': 'Пратите пошиљку',
    'booking.trailer': 'Траилер',
    'booking.transport_details': 'Детаљи транспорта',
    'booking.truck': 'Камион',
    'booking.truck_driver_planning_saved_letter_of_attorney_available':
      'Камион, возач и датуми планирања су сачувани. Пуномоћје је сада доступно.',
    'booking.unexpected_error': 'Неочекивана грешка',
    'booking.vehicles_plural': 'Возила',
    'booking.view_details': 'Погледајте детаље',
    'booking.vip_price_must_be_positive_number':
      'ВИП цена мора бити позитиван број.',
    Capacity: 'Капацитет',
    'Car Capacity': 'Цар Цапацити',
    'Car capacity is required.': 'Потребан је капацитет аутомобила.',
    cars: 'аутомобили',
    Changed: 'Промењено',
    'CMR Document': 'ЦМР документ',
    'CMR expiry': 'Истек ЦМР-а',
    'CMR Expiry': 'ЦМР Екпири',
    'CMR expiry date is required': 'Потребан је датум истека ЦМР-а',
    'CMR Insurance': 'ЦМР осигурање',
    'CMR insurance expiry date': 'Датум истека ЦМР осигурања',
    'CMR Insurance Expiry Date': 'Датум истека ЦМР осигурања',
    'CMR insurance has expired. Upload a new CMR Insurance for review.':
      'Отпремите нову ЦМР фактуру на преглед.',
    'CMR insurance is expiring within 14 days.':
      'ЦМР осигурање истиче у року од 14 дана.',
    'CMR Insurance required': 'Потребна је ЦМР фактура',
    Company: 'Компанија',
    'Copy order ID': 'Копирај ИД поруџбине',
    Created: 'Цреатед',
    'Current expiry': 'Тренутни истек',
    'Date range': 'Период',
    days: 'дана',
    Delay: 'Кашњење',
    'Delivered + partner invoice uploaded + unpaid':
      'Испоручено + отпремљена фактура партнера + неплаћена',
    Document: 'Документ',
    'Documents uploaded': 'Документи су отпремљени',
    Done: 'Готово',
    'Download Invoice': 'Преузмите фактуру',
    'Enter a valid capacity between 1 and 20 cars.':
      'Унесите важећи капацитет између 1 и 20 аутомобила.',
    'Enter license plate': 'Унесите регистарску таблицу',
    'Enter plate and upload CMR to add truck':
      'Унесите таблицу и отпремите ЦМР да додате камион',
    'Error fetching users': 'Грешка при преузимању корисника',
    'Expire Soon (14 days)': 'Ускоро истиче (14 дана)',
    'Explain why this CMR was rejected': 'Објасните зашто је овај ЦМР одбијен',
    'Failed to copy order ID': 'Копирање ИД-а поруџбине није успело',
    'Failed to download invoice': 'Преузимање фактуре није успело',
    'Failed to download proforma invoice': 'Преузимање предрачуна није успело',
    'Failed to generate invoice': 'Генерисање фактуре није успело',
    'Failed to load invoice summary': 'Учитавање резимеа фактуре није успело',
    'Failed to load letter of attorney': 'Учитавање пуномоћја није успело',
    'Failed to open letter of attorney': 'Отварање пуномоћја није успело',
    'Failed to release booking': 'Отпуштање резервације није успело',
    'Fleet data refreshed': 'Подаци о флоти су освежени',
    'Generate Client Invoice': 'Генеришите фактуру клијента',
    'Generate Invoice': 'Генеришите фактуру',
    'Generated at': 'Генерирано у',
    'How many cars can this truck carry?':
      'Колико аутомобила може да превезе овај камион?',
    'In progress': 'У току',
    Invoice: 'фактура',
    'Invoice generated': 'Фактура је генерисана',
    'Invoice generated successfully': 'Фактура је успешно генерисана',
    'Invoice uploaded': 'Фактура је отпремљена',
    'Invoices uploaded by partners for platform payout processing. Client invoices are generated in each order view.':
      'Фактуре клијента се генеришу у сваком приказу поруџбине.',
    'Keep booking': 'Наставите да резервишете',
    'Keep your active drivers and contact details up to date.':
      'Ажурирајте своје активне драјвере и контакт податке.',
    'Last Rejection': 'Ласт Рејецтион',
    'Last rejection reason': 'Последњи разлог одбијања',
    'Letter of Attorney': 'пуномоћје',
    'Letter of attorney file is empty': 'Досије о пуномоћју је празан',
    'License plate cannot be changed after creation. Re-upload CMR Insurance instead.':
      'Уместо тога, поново отпремите ЦМР фактуру.',
    'License plate is required.': 'Обавезна је регистарска таблица.',
    'Manage large order volumes with search, payment actions, and invoice workflows.':
      'Управљајте великим количинама поруџбина помоћу претраге, радњи плаћања и токова фактура.',
    'Manage license plates and keep CMR Insurances approved and valid.':
      'Управљајте регистарским таблицама и одржавајте ЦМР фактуре одобреним и важећим.',
    'Manage status updates, documents, and payment steps from one place.':
      'Управљајте ажурирањима статуса, документима и корацима плаћања са једног места.',
    'Manage trailer plate records and keep availability current.':
      'Управљајте евиденцијом таблица приколице и одржавајте доступност актуелном.',
    Missing: 'Недостаје',
    'Needs attention': 'Потребна је пажња',
    'New (14 days)': 'Ново (14 дана)',
    'No bookings found for the current filters.':
      'Нису пронађене резервације за тренутне филтере.',
    'No confirmed CMR document uploaded yet.':
      'Још увек није отпремљен ниједан потврђени ЦМР документ.',
    'No driver assigned': 'Није додељен возач',
    'No letter of attorney has been generated yet.':
      'Још увек није генерисано пуномоћје.',
    'No matching delivered orders': 'Нема одговарајућих испоручених поруџбина',
    'No new notifications': 'Нема нових обавештења',
    'No partners found.': 'Није пронађен ниједан партнер.',
    'No trucks found for this filter.':
      'Није пронађен ниједан камион за овај филтер.',
    'No users found for current filters.':
      'Није пронађен ниједан корисник за тренутне филтере.',
    'Not uploaded': 'Није отпремљено',
    Notifications: 'Обавештења',
    of: 'оф',
    'Only admins can set or update this expiry date after reviewing your CMR insurance.':
      'Само администратори могу да поставе или ажурирају овај датум истека након прегледа вашег ЦМР осигурања.',
    'Open letter of attorney': 'Отворено пуномоћје',
    Order: 'Ред',
    'Order actions': 'Наручите акције',
    'Order ID copied': 'ИД поруџбине је копиран',
    Owner: 'Власник',
    Page: 'Страница',
    'Paid date': 'Плаћени датум',
    'Partner delivery date': 'Датум испоруке партнера',
    'Partner documents': 'Партнерски документи',
    'Partner Invoice': 'Партнерска фактура',
    'Partner invoice uploaded': 'Партнерска фактура је отпремљена',
    'Partner Payout Invoices': 'Партнерске фактуре за исплату',
    'Partner pickup date': 'Датум преузимања партнера',
    'Partner score': 'Резултат партнера',
    Payment: 'Плаћање',
    'Payout date': 'Датум исплате',
    'penalties applied': 'примењене казне',
    'Pending admin review': 'Чека се преглед администратора',
    'Pending review': 'Чека се преглед',
    'Pending trucks': 'Камиони на чекању',
    'Please provide a clear reason for rejection.':
      'Наведите јасан разлог за одбијање.',
    'Please select an order before uploading an invoice.':
      'Изаберите поруџбину пре него што отпремите фактуру.',
    'Please try again.': 'Покушајте поново.',
    'Proforma Invoice': 'Проформа фактура',
    'Provide a rejection reason for this CMR review.':
      'Наведите разлог одбијања за овај ЦМР преглед.',
    'Quarter Score': 'Куартер Сцоре',
    'Re-upload CMR': 'Поново отпремите ЦМР',
    Refresh: 'Освежи',
    'Rejection reason': 'Разлог одбијања',
    'Rejection reason is required': 'Разлог одбијања је обавезан',
    Reset: 'Ресетуј',
    'Review Bookings': 'Прегледајте резервације',
    Revision: 'Ревизија',
    Rows: 'Редови',
    'Search by invoice number, file name, or booking ID':
      'Претражујте по броју фактуре, називу датотеке или ИД-у резервације',
    'Search by name, email, company': 'Претражујте по имену, имејлу, компанији',
    'Search by name, email, company, uid':
      'Претражујте по имену, е-пошти, компанији, уид-у',
    'Search client': 'Сеарцх цлиент',
    'Search delivered order': 'Претражите испоручену наруџбу',
    'Search license plate or owner':
      'Претражи регистарску таблицу или власника',
    'Search order ID': 'Претражите ИД налога',
    'Search partner': 'Партнер за претрагу',
    'Select a new CMR Insurance to re-upload for this truck.':
      'Изаберите нову ЦМР фактуру за поновно отпремање за овај камион.',
    'Select paid date': 'Изаберите датум плаћања',
    'Set CMR insurance expiry date to approve this truck.':
      'Подесите датум истека ЦМР осигурања да бисте одобрили овај камион.',
    'Set maximum number of cars this truck can carry (1-20).':
      'Подесите максималан број аутомобила који овај камион може да превезе (1-20).',
    'Set the CMR insurance expiry date before approval.':
      'Подесите датум истека ЦМР осигурања пре одобрења.',
    Showing: 'Приказивање',
    'Status will be updated to Picked Up after successful upload. You can add multiple car photos before uploading.':
      'Можете додати више фотографија аутомобила пре отпремања.',
    Terms: 'Услови',
    Total: 'Укупно',
    'Track paid and unpaid invoices, expected payout dates, and upload new invoices quickly.':
      'Пратите плаћене и неплаћене фактуре, очекиване датуме исплате и брзо отпремајте нове фактуре.',
    'Truck approved successfully': 'Камион је успешно одобрен',
    'Truck documents': 'Документи камиона',
    'Truck license plate': 'Регистарске таблице камиона',
    'Truck rejected successfully': 'Камион је успешно одбијен',
    'truck(s) are pending admin CMR expiry date.':
      'камион(и) чекају админ ЦМР датум истека.',
    'truck(s) have expired CMR insurance and are disabled.':
      'камион(и) имају истекло ЦМР осигурање и онеспособљени су.',
    'truck(s) will expire within 14 days.':
      'камион(и) ће истећи у року од 14 дана.',
    'Unable to prepare the record for upload.':
      'Није могуће припремити запис за отпремање.',
    Unpaid: 'Неплаћено',
    'Upload a CMR Insurance before closing this truck setup.':
      'Отпремите ЦМР фактуру пре затварања овог подешавања камиона.',
    'Upload a valid CMR insurance. Each upload sends the truck back to pending review.':
      'Свако отпремање шаље камион назад на преглед на чекању.',
    'Upload documents': 'Отпремите документе',
    'Upload Invoice': 'Отпреми фактуру',
    'Upload order documents': 'Отпремите документе поруџбине',
    'Upload unavailable': 'Отпремање није доступно',
    Uploaded: 'Отпремљено',
    'Uploaded • Paid': 'Отпремљено • Плаћено',
    'Uploaded • Partially paid': 'Отпремљено • Делимично плаћено',
    'Uploaded by partner for platform payout processing.':
      'Отпремио партнер за обраду исплата на платформи.',
    User: 'Корисник',
    'Verification code': 'Верификациони код',
    'View details': 'Погледајте детаље',
    'View Partners': 'Прикажи партнере',
    'Working hours not provided': 'Радно време није предвиђено',
    Invoiced: 'Фактурисано',
    'Loading admin data...': 'Учитавање администраторских података...',
    'Pending partners': 'Партнери на чекању',
    'Unpaid bookings': 'Неплаћене резервације',
    'Total users': 'Укупно корисника',
    'Orders per period': 'Налози по периоду',
    'Orders by status': 'Поруџбине по статусу',
    'Quick actions': 'Брзе акције',
    'Verify new partners': 'Верификујте нове партнере',
    'Review partner applications and approve or reject requests.':
      'Прегледајте пријаве партнера и одобрите или одбијте захтеве.',
    'Manage all trucks': 'Управљајте свим камионима',
    'Review, approve, reject, disable, and filter all trucks.':
      'Прегледајте, одобрите, одбијте, онемогућите и филтрирајте све камионе.',
    'Review bookings': 'Прегледајте резервације',
    'Review all transport orders, payment states, and generated invoices.':
      'Прегледајте све транспортне налоге, стања плаћања и генерисане фактуре.',
    'Manage all users': 'Управљајте свим корисницима',
    'Manage user status, roles, and validation records.':
      'Управљајте статусом корисника, улогама и записима о валидацији.',
    'User breakdown': 'Преглед корисника',
    Clients: 'Клијенти',
    Partners: 'Партнери',
    Admins: 'Админс',
    'Top 5 pending partners': 'Топ 5 партнера на чекању',
    'No pending partners right now.': 'Тренутно нема партнера на чекању.',
    pending: 'на чекању',
    'Top 5 pending trucks': 'Топ 5 камиона на чекању',
    'No pending trucks right now.': 'Тренутно нема камиона на чекању.',
    'Unknown owner': 'Непознати власник',
    'KPI cards and top lists link directly to filtered admin screens.':
      'КПИ картице и топ листе се директно повезују са филтрираним екранима администратора.',
    'booking.available_orders_title': 'Доступне поруџбине',
    'booking.available_orders_description':
      'Прегледајте могућности долазног транспорта и примените филтере који одговарају вашим капацитетима.',
    'booking.vehicle_pickup_location': 'Локација преузимања возила',
    'booking.pickup_opening_hours': 'Радно време преузимања',
    'booking.vehicle_delivery_location': 'Место испоруке возила',
    'booking.delivery_opening_hours': 'Радно време доставе',
    'booking.pickup_contact': 'Контакт за преузимање',
    'booking.delivery_contact': 'Контакт за испоруку',
    'booking.vehicles_scheduled': 'Возила заказана',
    'booking.watchlist_title': 'Листа за посматрање',
    'booking.watchlist_description':
      'Пратите сачуване прилике и реагујте брзо када се доступност промени.',
    'Loading dashboard...': 'Учитавање контролне табле...',
    'Total bookings': 'Укупно резервација',
    'Open bookings': 'Отворене резервације',
    'Order status timeline': 'Временска линија статуса поруџбине',
    'Last 6 months of bookings grouped by current status.':
      'Последњих 6 месеци резервација груписаних према тренутном статусу.',
    'Create new order': 'Креирајте нови налог',
    'Create a new transport booking request.':
      'Креирајте нови захтев за резервацију превоза.',
    'View my orders': 'Погледајте моја наређења',
    'Review status and details of your bookings.':
      'Прегледајте статус и детаље својих резервација.',
    'Open profile': 'Отвори профил',
    'Update company and contact details.':
      'Ажурирајте податке о компанији и контакту.',
    'Recent bookings': 'Недавне резервације',
    'No bookings yet.': 'Још нема резервација.',
    'Unknown destination': 'Непознато одредиште',
    'Quarter score': 'Четвртина резултата',
    'Truck CMR warning': 'Камион ЦМР упозорење',
    'One truck has CMR expiry risk. Review it in Fleet.':
      'Један камион има ризик од истека ЦМР. Прегледајте то у Флоти.',
    'Active queue': 'Активан ред',
    'Delivered bookings': 'Испоручене резервације',
    'Cars delivered': 'Аутомобили испоручени',
    'Canceled bookings': 'Отказане резервације',
    'Avg assign-to-pickup': 'Прос. додељивање за преузимање',
    'Quarter Partner Score': 'Четврти резултат партнера',
    'Penalty events': 'Казнени догађаји',
    Current: 'Цуррент',
    'Completed orders per period': 'Завршени налози по периоду',
    'Completed orders': 'Завршене поруџбине',
    'Truck CMR status alerts': 'Камион ЦМР статус упозорења',
    'Upload a new CMR Insurance in Fleet. The truck will stay pending until admin review.':
      'Отпремите нову ЦМР фактуру у Флеет. Камион ће остати на чекању до административног прегледа.',
    'Open fleet to resolve CMR alerts':
      'Отворите флоту за решавање ЦМР упозорења',
    'Operational actions': 'Оперативне акције',
    'Open marketplace orders': 'Налози на отвореном тржишту',
    'Review available orders and plan assignments.':
      'Прегледајте доступне поруџбине и планске задатке.',
    'My accepted orders': 'Моје прихваћене поруџбине',
    'Manage delivery progress and documents.':
      'Управљајте напретком испоруке и документима.',
    'Update trucks, trailers, and availability.':
      'Ажурирајте камионе, приколице и доступност.',
    'Partner invoices': 'Партнерске фактуре',
    'Upload and track invoice payments.':
      'Отпремите и пратите плаћања фактура.',
    'No active orders in queue.': 'Нема активних налога у реду.',
    'profile.incompleteTitle': 'Профил Непотпун',
    'profile.incompleteDescription':
      'Молимо вас да попуните информације о свом профилу (компанија, телефон, адреса, град, поштански број) да бисте приступили свим функцијама.',
    'profile.goToProfile': 'Идите на Профил',
    'auth.email_placeholder': 'име@компанија.цом',
    'auth.authentication_mode_switch': 'Прекидач режима аутентификације',
    'auth.invalid_email': 'Неважећа адреса е-поште',
    'auth.please_enter_a_valid_email_address': 'Унесите важећу адресу е-поште.',
    'auth.email_not_found': 'Е-пошта није пронађена',
    'auth.no_account_found_with_that_email_address':
      'Није пронађен ниједан налог са том адресом е-поште.',
    'auth.email_sent': 'Емаил послат!',
    'auth.something_went_wrong_try_again':
      'Нешто је пошло по злу. Покушајте поново.',
    'auth.we_sent_a_password_reset_link_open_your_inbox_and_follow_the_instructions':
      'Послали смо везу за ресетовање лозинке. Отворите пријемно сандуче и пратите упутства.',
    'auth.forgot_your_password': 'Заборавили сте лозинку?',
    'auth.enter_your_account_email_and_we_will_send_you_a_password_reset_link':
      'Унесите адресу е-поште свог налога и ми ћемо вам послати везу за ресетовање лозинке.',
    'auth.email_address': 'Адреса е-поште',
    'auth.send_reset_link': 'Пошаљи везу за ресетовање',
    'auth.cancel': 'Откажи',
    'auth.tip_if_you_do_not_receive_the_email_check_spam_and_promotions_folders':
      'Савет: ако не примите е-пошту, проверите фасцикле са нежељеном поштом и промоцијама.',
    'booking.e_g_berlin': 'нпр. Берлин',
    'booking.e_g_germany': 'нпр. Немачка',
    'booking.watchlist': 'Листа за посматрање',
    'booking.view_map': 'Погледај мапу',
    'booking.invalid_input': 'Неважећи унос',
    'booking.please_enter_only_numbers_for_the_zip_code':
      'Унесите само бројеве за поштански број.',
    'booking.pickup_zip_code': 'Поштански број за преузимање',
    'booking.delivery_zip_code': 'Поштански број за испоруку',
    'booking.select_vehicle_make': 'Изаберите марку возила',
    'booking.unnamed_item': 'Неименована ставка',
    'booking.cars': 'аутомобили',
    'booking.more_info': 'Више информација',
    'booking.loading': 'Учитавање...',
    'booking.no_items_found': 'Нема пронађених ставки',
    'booking.selected_cars': 'Одабрани аутомобили',
    'booking.unknown_type': 'Непознати тип',
    'booking.delete_car': 'Избриши ауто',
    'Toggle details': 'Укључите детаље',
    'auth.a_verification_email_has_been_sent_to_your_email_address_please_verify_your_emai':
      'Порука за верификацију је послата на вашу адресу е-поште. Молимо вас да потврдите своју е-пошту пре него што се пријавите.',
    'auth.an_unexpected_error_occurred_please_try_again':
      'Дошло је до неочекиване грешке. Покушајте поново.',
    'auth.failed_to_resend_email': 'Поново слање е-поште није успело',
    'auth.show_password': 'Прикажи лозинку',
    'auth.hide_password': 'Сакриј лозинку',
    'auth.incorrect_password_please_try_again':
      'Нетачна лозинка. Покушајте поново.',
    'auth.invalid_email_or_password_please_check_your_credentials_and_try_again':
      'Неважећа адреса е-поште или лозинка. Проверите своје акредитиве и покушајте поново.',
    'auth.network_error_check_your_connection_and_try_again':
      'Мрежна грешка. Проверите везу и покушајте поново.',
    'auth.no_account_found_with_this_email':
      'Није пронађен ниједан налог са овом е-поштом.',
    'auth.please_check_your_inbox': 'Молимо проверите пријемно сандуче.',
    'auth.please_make_sure_both_passwords_are_the_same':
      'Уверите се да су обе лозинке исте.',
    'auth.please_sign_in_to_resend_the_verification_email':
      'Пријавите се да бисте поново послали е-поруку за верификацију.',
    'auth.resend_verification_email': 'Поново пошаљи е-поруку за верификацију',
    'auth.awaiting_verification_artwork': 'Чекају верификацију уметничког дела',
    'auth.email_verification_required': 'Потребна је верификација е-поште',
    'auth.waiting_for_email_verification': 'Чека се верификацију е-поште',
    'auth.check_your_email': 'Проверите своју е-пошту',
    'auth.we_sent_your_verification_link_to':
      'Послали смо вашу везу за верификацију на',
    'auth.didnt_receive_it_check_spam_or_try_again':
      'Нисте га примили? Проверите фасциклу нежељене поште или покушајте поново.',
    'auth.resend_email': 'Поново пошаљи е-пошту',
    'auth.i_verified_my_email': 'Верификовао сам своју е-пошту',
    'auth.redirecting_you_now': 'Преусмеравам вас сада.',
    'auth.email_not_verified_yet': 'Имејл још није верификован',
    'auth.please_click_the_link_in_your_inbox_and_try_again':
      'Кликните на везу у пријемном сандучету и покушајте поново.',
    'auth.unable_to_resend_verification_email_right_now':
      'Тренутно није могуће поново послати е-поруку за верификацију.',
    'auth.unable_to_check_verification_status_right_now':
      'Тренутно није могуће проверити статус верификације.',
    'auth.we_sent_a_new_verification_link':
      'Послали смо нову везу за верификацију на вашу адресу е-поште.',
    'auth.we_automatically_check_every_30_seconds':
      'Аутоматски проверавамо ваш статус верификације сваких 30 секунди. Такође можете покренути тренутну проверу након верификације е-поште.',
    'auth.we_automatically_check_every_15_seconds':
      'Аутоматски проверавамо ваш статус верификације сваких 15 секунди. Такође можете покренути тренутну проверу након верификације е-поште.',
    'auth.the_email_address_is_not_valid': 'Адреса е-поште није важећа.',
    'auth.this_account_has_been_disabled': 'Овај налог је онемогућен.',
    'auth.too_many_failed_attempts_please_try_again_later_or_reset_your_password':
      'Превише неуспешних покушаја. Покушајте поново касније или ресетујте лозинку.',
    'auth.verification_email_resent': 'Имејл за верификацију је поново послат!',
    'auth.you_need_to_log_in_first': 'Прво се морате пријавити',
    'booking.error_fetching_data': 'Грешка при преузимању података',
    'booking.inputs_changed_recalculate_the_price':
      'Уноси су промењени. Прерачунајте цену.',
    'booking.no_opening_hours_provided': 'Није наведено радно време',
    'booking.no_vehicles_listed': 'Нема наведених возила',
    'booking.not_available': 'Није доступно',
    'booking.not_set': 'Није постављено',
    'booking.please_select_a_planned_date': 'Молимо изаберите планирани датум',
    'booking.required': 'Обавезно',
    'booking.to': 'да',
    'booking.order': 'Ред',
    'booking.duration': 'Трајање',
    'booking.vehicles_overview': 'Преглед возила',
    'booking.body': 'Тело',
    'booking.dims': 'Димс',
    'booking.select_vehicle_model': 'Изаберите модел возила',
    'booking.selected_type_value': 'Изабрано: {{value}}',
    'booking.select_a_vehicle_type': 'Изаберите тип возила:',
    'booking.select_vehicle_weight': 'Изаберите тежину возила',
    'booking.selected_weight_kg': 'Изабрано: {{value}} кг',
    'booking.adjust_weight': 'Подесите тежину',
    'Dates updated successfully': 'Датуми су успешно ажурирани',
    'Error updating dates': 'Грешка при ажурирању датума',
    'Set Planned Dates': 'Поставите планиране датуме',
    'Set your planned pickup and arrival dates below.':
      'Подесите планиране датуме преузимања и доласка у наставку.',
    'Changing dates after initial setup will deduct 20% from your performance score for this order.':
      'Промена датума након почетног подешавања ће одбити 20% од ваше оцене учинка за ову поруџбину.',
    'Planned Pickup Date': 'Планирани датум преузимања',
    'Planned Arrival Date': 'Планирани датум доласка',
    Listing: 'Листинг',
    'Try broadening the current search or status filter.':
      'Покушајте да проширите тренутну претрагу или филтер статуса.',
    'Try broadening the search, role, or status filters.':
      'Покушајте да проширите филтере за претрагу, улогу или статус.',
    'Monitor fleet compliance, validation status, and expiring insurance in one place.':
      'Пратите усклађеност возног парка, статус валидације и осигурање које истиче на једном месту.',
    'Active Listings': 'Ацтиве Листингс',
    'Open transport requests': 'Отворени захтеви за транспорт',
    'Quotes Today': 'Куотес Тодаи',
    'Submitted in last 24h': 'Послано у последња 24 сата',
    'Platform Revenue (MTD)': 'Приход од платформе (МТД)',
    'Month to date': 'Месец до данас',
    'Pending Partners': 'Партнери на чекању',
    'Awaiting approval': 'Чека се одобрење',
    'Unpaid Invoices': 'Неплаћене фактуре',
    'Requires action': 'Захтева акцију',
    'Completed Transports': 'Завршени транспорти',
    'All time delivered': 'Све време испоручено',
    'Admin Dashboard': 'Админ Дасхбоард',
    'Platform overview and key performance indicators.':
      'Преглед платформе и кључни индикатори учинка.',
    'Loading dashboard metrics...': 'Учитавање показатеља контролне табле...',
    Invoices: 'фактуре',
    'Review payout invoices uploaded by partners and keep payout processing organized.':
      'Прегледајте фактуре за исплате које су отпремили партнери и одржавајте организовану обраду исплата.',
    Flexible: 'Флексибилно',
    'Flexible dates': 'Флексибилни датуми',
    'Could not load this listing.': 'Није могуће учитати овај унос.',
    'Listing canceled': 'Оглас је отказан',
    'Failed to cancel listing': 'Отказивање уноса није успело',
    Reference: 'Референца',
    Category: 'Категорија',
    'Client type': 'Тип клијента',
    'Company country': 'Земља компаније',
    Expires: 'Истиче',
    'Back to listings': 'Назад на листе',
    'Listing not found.': 'Оглас није пронађен.',
    'Cancel Listing': 'Цанцел Листинг',
    'Listing details': 'Детаљи о листи',
    'Reference {{id}}': 'Референца {{id}}',
    'Read-only listing overview for admins.':
      'Преглед листе само за читање за администраторе.',
    'Pick-up': 'Пицк-уп',
    'No exact coordinates are stored for this listing yet.':
      'Још увек нису сачуване тачне координате за овај унос.',
    'Structured overview of quantities and handling details.':
      'Структурирани преглед количина и детаља руковања.',
    'Shipment images': 'Слике отпреме',
    'No shipment images were uploaded for this listing.':
      'За овај унос није отпремљена ниједна слика пошиљке.',
    'Proof of pickup': 'Доказ о преузимању',
    'Final documents': 'Завршни документи',
    Description: 'Опис',
    'Quotes ({{count}})': 'Цитати ({{count}})',
    'Loading quotes...': 'Учитавање цитата...',
    'No quotes for this listing.': 'Нема цитата за ову листу.',
    'Score: {{score}}/100': 'Оцена: {{score}}/100',
    'Pickup: {{date}}': 'Преузимање: {{date}}',
    'Delivery: {{date}}': 'Достава: {{date}}',
    'Cancel Listing?': 'Цанцел Листинг?',
    'This will permanently cancel the listing and notify the client. Continue?':
      'Ово ће трајно отказати унос и обавестити клијента. Наставити?',
    Keep: 'Задржи',
    'Review partner applications, check their documents, and keep approval decisions consistent.':
      'Прегледајте пријаве партнера, проверите њихове документе и држите одлуке о одобрењу доследним.',
    'No client payments recorded yet':
      'Још увек нису забележена плаћања клијената',
    'Client payment rows will appear here when the payments backend is connected.':
      'Редови за плаћање клијента ће се појавити овде када се повеже позадински систем плаћања.',
    Method: 'Метод',
    'No partner payouts recorded yet':
      'Још увек нису забележене исплате партнера',
    'Payout rows will appear here once partner payout processing is enabled.':
      'Редови за исплате ће се појавити овде када се омогући обрада исплате партнера.',
    'Payout Amount': 'Износ исплате',
    'No platform fees recorded yet':
      'Још увек нису забележене накнаде за платформу',
    'Fee rows will appear here once payment settlement data is available.':
      'Редови накнада ће се појавити овде када подаци о поравнању буду доступни.',
    Gross: 'Гросс',
    'Fee (20%)': 'Накнада (20%)',
    Payments: 'Паиментс',
    'Client payments, partner payouts, and platform fee tracking.':
      'Плаћања клијената, исплате партнера и праћење накнада за платформу.',
    'Client Payments': 'Цлиент Паиментс',
    'Partner Payouts': 'Партнерске исплате',
    'Platform Fees': 'Накнаде за платформу',
    'Failed to load reviews': 'Учитавање рецензија није успело',
    'Review removed': 'Рецензија је уклоњена',
    'Failed to remove review': 'Уклањање рецензије није успело',
    Reviews: 'Рецензије',
    'All partner and transport reviews submitted by clients.':
      'Све рецензије партнера и транспорта достављене од стране клијената.',
    'Loading reviews...': 'Учитавање рецензија...',
    'No reviews found': 'Није пронађена ниједна рецензија',
    'Client feedback will appear here when reviews are submitted.':
      'Повратне информације клијената ће се појавити овде када се рецензије пошаљу.',
    Stars: 'Звезде',
    Comment: 'Коментар',
    'Search, review, and maintain user accounts with one consistent admin workflow.':
      'Претражујте, прегледајте и одржавајте корисничке налоге помоћу једног доследног тока рада администратора.',
    'Track paid and unpaid partner payout invoices, and upload the next delivered listing invoice quickly.':
      'Пратите плаћене и неплаћене фактуре за исплате партнера и брзо отпремите следећу испоручену фактуру за унос.',
    'Search by invoice number, file name, or listing ID':
      'Претражујте по броју фактуре, називу датотеке или ИД-у листе',
    'Loading delivered listings...': 'Учитавање испоручених огласа...',
    'Search delivered listing by reference, title, or route':
      'Претражите достављену листу према референци, наслову или рути',
    'Route details available in listing': 'Детаљи руте доступни су у листи',
    'No matching delivered listings': 'Нема одговарајућих испоручених огласа',
    'Selected listing': 'Изабрани листинг',
    'Has quotes': 'Има цитате',
    'In transit': 'У транзиту',
    Open: 'Отвори',
    Accepted: 'Прихваћено',
    Completed: 'Завршено',
    'Client Dashboard': 'Контролна табла за клијенте',
    'Overview of your current transport listings, quote activity, and recent requests.':
      'Преглед ваших тренутних уноса транспорта, активности понуде и недавних захтева.',
    'Total listings': 'Тотал листингс',
    'Active listings': 'Активни огласи',
    'Listings with quotes': 'Огласи са цитатима',
    'Accepted transport': 'Прихваћен транспорт',
    'Listing status timeline': 'Временска линија статуса листе',
    'Last 6 months of listings grouped by current status.':
      'Последњих 6 месеци уноса груписаних према тренутном статусу.',
    'No listing activity yet': 'Још нема активности на листи',
    'Create your first listing to start tracking request activity here.':
      'Направите свој први унос да бисте започели праћење активности захтева овде.',
    'Create new listing': 'Направите нову листу',
    'Create a new transport request for the marketplace.':
      'Креирајте нови захтев за транспорт за тржиште.',
    'View my listings': 'Погледајте моје листе',
    'Review quote activity and manage your transport requests.':
      'Прегледајте активност понуде и управљајте својим захтевима за транспорт.',
    'Recent listings': 'Недавни огласи',
    'No listings yet': 'Још нема огласа',
    'Your newest transport requests will appear here once you create them.':
      'Ваши најновији захтеви за транспорт ће се појавити овде када их направите.',
    'Unknown origin': 'Непознато порекло',
    '{{count}} quote(s)': '{{count}} цитат(и)',
    '{{value}} completed listings': '{{value}} завршени огласи',
    'Monitor current performance, fleet readiness, quote flow, and your active transport queue.':
      'Пратите тренутне перформансе, спремност возног парка, ток понуде и ваш активни ред транспорта.',
    'Total assigned': 'Укупно додељено',
    'Quarter rating': 'Куартер ратинг',
    'Based on current quarter performance':
      'На основу текућег кварталног учинка',
    Rating: 'Оцена',
    'Requirement met': 'Захтев испуњен',
    'Requirement not met': 'Захтев није испуњен',
    'Completed listings per period': 'Завршени огласи по периоду',
    'No completion data yet': 'Још нема података о завршетку',
    'Statistics will appear here after your first delivered work.':
      'Статистике ће се појавити овде након вашег првог испорученог рада.',
    'Completed listings': 'Завршени огласи',
    'Review truck documents and refresh anything close to expiry.':
      'Прегледајте документацију камиона и освежите све што је близу истека.',
    'Search deliveries': 'Претражите испоруке',
    'Review available marketplace listings and submit quotes.':
      'Прегледајте доступне листе на тржишту и поднесите понуде.',
    'My quotes': 'Моји цитати',
    'Track accepted, pending, and rejected quotes in one place.':
      'Пратите прихваћене, на чекању и одбијене цитате на једном месту.',
    'Profile settings': 'Подешавања профила',
    'Keep company information and compliance details up to date.':
      'Ажурирајте информације о компанији и детаље о усклађености.',
    'No active queue items': 'Нема активних ставки у реду',
    'Accepted and in-progress work will appear here as your transport activity grows.':
      'Прихваћени радови и радови у току ће се појавити овде како ваша транспортна активност расте.',
    'Your role does not have permission to open this page.':
      'Ваша улога нема дозволу да отвори ову страницу.',
    'Go to dashboard': 'Идите на контролну таблу',
    'Trailer capacity is required.': 'Потребан је капацитет приколице.',
    'How many cars can this trailer carry?':
      'Колико аутомобила може да понесе ова приколица?',
    'Set maximum number of cars this trailer can carry (1-20).':
      'Подесите максималан број аутомобила које ова приколица може да носи (1-20).',
    'Invalid max load (kg).': 'Неважеће максимално оптерећење (кг).',
    'Enter a valid weight between 1 and 100000 kg, or leave it empty.':
      'Унесите важећу тежину између 1 и 100000 кг или оставите празно.',
    'Maximum payload weight this truck can carry (optional).':
      'Максимална тежина терета који овај камион може да понесе (опционо).',
    'Manage the company and contact details that appear across your listings, invoices, and account verification flows.':
      'Управљајте компанијом и детаљима за контакт који се појављују у вашим уносима, фактурама и токовима верификације налога.',
    'Keep these details up to date so listings, invoices, and partner verification stay accurate.':
      'Ажурирајте ове детаље како би огласи, фактуре и верификација партнера остали тачни.',
    'Unsaved changes': 'Несачуване промене',
    'All changes saved': 'Све промене су сачуване',
    'auth.sign_up_failed': 'Регистрација није успела',
    'auth.please_select_a_valid_role': 'Изаберите важећу улогу.',
    'booking.pickup_not_found': 'Преузимање није пронађено.',
    'booking.delivery_not_found': 'Достава није пронађена.',
    'booking.capacity': 'Капацитет',
    'booking.cmr_expiry': 'ЦМР Екпири',
    'booking.uploaded': 'Отпремљено',
    'booking.missing': 'Недостаје',
    'booking.cmr_document': 'ЦМР документ',
    'booking.go_to_profile': 'Идите на Профил',
    'booking.click_to_download_purchase_terms':
      'Кликните да преузмете Услове куповине',
    'admin.purchase_terms_management': 'Управљање условима куповине',
    'admin.purchase_terms_management_subtitle':
      'Отпремите и одржавајте локализоване ПДФ-ове са условима куповине који се користе за прихватање поруџбине партнера.',
    'admin.document_language': 'Језик документа',
    'admin.click_to_download_purchase_terms':
      'Кликните да преузмете Услове куповине',
    'admin.current_language_label': 'Тренутни језик: {{language}}',
    'admin.purchase_terms_unavailable_for_selected_language':
      'Документ услова куповине није доступан за изабрани језик.',
    'Download and review the active purchase terms in your current interface language before continuing.':
      'Преузмите и прегледајте активне услове куповине на вашем тренутном језику интерфејса пре него што наставите.',
    'We make agreements and conclude a contract for the carriage of goods. I have just read this agreement in full and agree to its contents.':
      'Договарамо се и закључујемо уговор о превозу робе. Управо сам прочитао овај споразум у целости и сагласан сам са његовим садржајем.',
    'I confirm that I will schedule this order within 24 hours':
      'Потврђујем да ћу заказати ову поруџбину у року од 24 сата',
    'Failed to load purchase terms document.':
      'Учитавање документа услова куповине није успело.',
    'Partner rating': 'Рејтинг партнера',
    'Bronze requirements': 'Бронзани захтеви',
    'Orders in quarter': 'Поруџбине у кварталу',
    'Cancellation rate / 100 orders': 'Стопа отказивања / 100 поруџбина',
    'Damage claims / 100 orders': 'Захтеви за штету / 100 налога',
    '{{current}} / min {{target}}': '{{current}} / мин {{target}}',
    '{{current}} / max {{target}}': '{{current}} / мак {{target}}',
    Met: 'Мет',
    'Not met': 'Није испуњено',
    Unranked: 'Унранкед',
    'profile.incompleteDescriptionPartner':
      'Молимо вас да попуните информације о свом профилу (компанија, телефон, адреса, град, поштански број, ПДВ број) да бисте приступили свим функцијама.',
    'profile.incompleteDescriptionClient':
      'Унесите информације о свом профилу (број телефона) да бисте приступили свим функцијама.',
    'auth.verification_email_sent': 'Порука за верификацију је послата',
    '{{amount}} above the client target': '{{amount}} изнад циља клијента',
    '{{amount}} below the client target': '{{amount}} испод циља клијента',
    '{{count}} image(s) added to the listing.':
      '{{count}} слика(а) је додата на листу.',
    '{{count}} quote(s) received': 'Примљени цитати од {{count}}',
    '{{count}} reviews': '{{count}} рецензије',
    '{{count}} total': '{{count}} укупно',
    '{{count}} visible': '{{count}} видљиво',
    '{{weight}} kg': '{{weight}} кг',
    'A Google route preview with pins A and B appears here once pickup and delivery coordinates are available.':
      'Преглед Гоогле руте са пиновима А и Б се појављује овде када координате преузимања и испоруке буду доступне.',
    'A route preview appears once map coordinates are available.':
      'Преглед руте се појављује када координате карте буду доступне.',
    'A timeline of clarifications connected to this listing.':
      'Временски оквир појашњења у вези са овим уносом.',
    "Accept {{partner}}'s quote for {{amount}}?":
      'Прихватите понуду {{partner}} за {{amount}}?',
    'Accept Listing': 'Прихвати листинг',
    'Accept quote': 'Прихвати цитат',
    'Accepted quote': 'Прихваћен цитат',
    'Accepted quote required': 'Потребна је прихваћена понуда',
    'Accepting...': 'Прихватам...',
    Active: 'Ацтиве',
    'Active statuses': 'Активни статуси',
    'Add another item': 'Додајте још једну ставку',
    'Add images': 'Додајте слике',
    'Add more shipment images': 'Додајте још слика пошиљке',
    'After you confirm an AI action, open the prepared destination immediately instead of waiting for a manual click.':
      'Након што потврдите радњу АИ, одмах отворите припремљено одредиште уместо да чекате ручни клик.',
    'AI Assistant': 'АИ Ассистант',
    'AI assistant disabled for all users.':
      'АИ асистент је онемогућен за све кориснике.',
    'AI assistant enabled for all users.':
      'АИ асистент је омогућен за све кориснике.',
    'AI assistant preferences updated': 'Подешавања помоћника АИ су ажурирана',
    'AI disabled for user.': 'АИ онемогућен за корисника.',
    'AI enabled for user.': 'АИ омогућен за корисника.',
    'AI-powered message translation between languages':
      'Превођење порука између језика помоћу вештачке интелигенције',
    'All route-critical information in one place before you review quotes or documents.':
      'Све информације критичне за руту на једном месту пре него што прегледате понуде или документе.',
    View: 'Погледај',
    Answer: 'Одговори',
    Archive: 'Архива',
    'Archived statuses': 'Архивирани статуси',
    'Are you sure you want to reject the quote from':
      'Да ли сте сигурни да желите да одбијете цитат из',
    'Ask a question about this listing...': 'Поставите питање о овој листи...',
    'Ask for matching lanes, quote help, or the next operational step.':
      'Затражите одговарајуће траке, понудите помоћ или следећи оперативни корак.',
    'Ask for quote comparisons or a prepared next step from this shipment screen.':
      'Затражите поређење понуда или припремљени следећи корак са овог екрана за испоруку.',
    'Assistant history cleared': 'Историја помоћника је обрисана',
    'Automatically translate messages from other users into your preferred language using AI.':
      'Аутоматски преводите поруке од других корисника на жељени језик помоћу вештачке интелигенције.',
    'Back to listing': 'Назад на листу',
    'Best offer': 'Најбоља понуда',
    'Best quote': 'Најбољи цитат',
    'Body type: {{type}}': 'Тип тела: {{type}}',
    'Breed: {{breed}}': 'Раса: {{breed}}',
    Budget: 'Буџет',
    'Cancel listing': 'Откажите унос',
    'Canceled and completed work will appear here once listings move out of the active view.':
      'Отказани и завршени радови ће се појавити овде када се огласи повуку из активног приказа.',
    'Cargo Details': 'Царго Детаилс',
    Categories: 'Категорије',
    'Choose the interface language. This preference is saved locally and applies immediately.':
      'Изаберите језик интерфејса. Ово подешавање се чува локално и одмах се примењује.',
    'Clear all': 'Обриши све',
    'Clear assistant history': 'Обришите историју помоћника',
    'Client price in EUR': 'Цена клијента у ЕУР',
    'Client target price': 'Циљна цена клијента',
    'Complete the payment below to lock the fixed-price acceptance and let the partner start planning.':
      'Довршите плаћање у наставку да бисте закључали прихватање фиксне цене и дозволили партнеру да почне да планира.',
    'Complete the payment below to lock the selected quote and let the partner start planning.':
      'Довршите плаћање испод да бисте закључали изабрану понуду и пустили партнера да почне да планира.',
    'Compose area prepared for listing Q&A. Submission remains disabled until the live question endpoint is connected on this page.':
      'Саставите област припремљену за навођење питања и одговора. Подношење остаје онемогућено док се крајња тачка питања уживо не повеже на овој страници.',
    'Confirm delivery complete': 'Потврдите да је испорука завршена',
    'Confirm payment received': 'Потврдите примљену уплату',
    'Confirm that you have received the bank transfer or payment for this listing. This will move the listing to Paid status and allow the partner to mark it as planned.':
      'Потврдите да сте примили банковни трансфер или уплату за овај унос. Ово ће померити унос у статус Плаћено и омогућити партнеру да га означи као планирано.',
    'Confirm the exact fleet and dates before the listing moves to Planned.':
      'Потврдите тачан возни парк и датуме пре него што се листа премести у Планирано.',
    'Confirm Transport Plan': 'Потврдите транспортни план',
    'Confirming...': 'Потврђивање...',
    'Control how the web assistant behaves on this device. These settings do not change your account data.':
      'Контролишите како се веб помоћник понаша на овом уређају. Ова подешавања не мењају податке о вашем налогу.',
    'Create listing': 'Направите листу',
    'Create with AI': 'Креирајте помоћу вештачке интелигенције',
    'Create your next transport request and it will appear here with route, item, and quote activity.':
      'Креирајте свој следећи захтев за транспорт и он ће се појавити овде са активношћу руте, ставке и понуде.',
    'Current stage:': 'Тренутна фаза:',
    'Current status': 'Тренутни статус',
    'Delivery confirmation needed': 'Потребна је потврда испоруке',
    'Delivery radius': 'Радијус испоруке',
    'Delivery:': 'Достава:',
    'Describe the route and cargo, then review the prepared listing draft before publishing.':
      'Опишите руту и ​​терет, а затим прегледајте припремљени нацрт листе пре објављивања.',
    'Describe the shipment you need and review the prepared request before publishing.':
      'Опишите пошиљку која вам је потребна и прегледајте припремљени захтев пре објављивања.',
    'Download and review the purchase terms before confirming the transport plan.':
      'Преузмите и прегледајте услове куповине пре него што потврдите транспортни план.',
    'Download invoice': 'Преузмите фактуру',
    'Download Purchase Terms': 'Преузмите Услове куповине',
    'Draft with AI': 'Нацрт са АИ',
    'Draft your review first, then submit it here when you are satisfied.':
      'Прво нацртајте своју рецензију, а затим је пошаљите овде када будете задовољни.',
    'Edit listing': 'Уреди листу',
    'Edit Quote': 'Уреди цитат',
    Enable: 'Омогући',
    'Enable live translation': 'Омогући превођење уживо',
    'Enabled Users': 'Омогућени корисници',
    'Engagement Activity': 'Ангажована активност',
    'Expires:': 'Истиче:',
    'Failed to accept listing': 'Прихватање уноса није успело',
    'Failed to accept quote': 'Прихватање цитата није успело',
    'Failed to clear assistant history':
      'Брисање историје помоћника није успело',
    'Failed to complete listing': 'Довршавање листе није успело',
    'Failed to confirm payment': 'Потврда уплате није успела',
    'Failed to confirm transport plan':
      'Потврђивање плана транспорта није успело',
    'Failed to disable AI for user.':
      'Онемогућавање АИ за корисника није успело.',
    'Failed to enable AI for user.': 'Омогућавање АИ за корисника није успело.',
    'Failed to load listing.': 'Учитавање листе није успело.',
    'Failed to load listings': 'Учитавање листа није успело',
    'Failed to load listings. Please try again.':
      'Учитавање листа није успело. Покушајте поново.',
    'Failed to load review context.':
      'Учитавање контекста рецензије није успело.',
    'Failed to load settings.': 'Учитавање подешавања није успело.',
    'Failed to refresh Stripe payment status':
      'Освежавање статуса плаћања Стрипе није успело',
    'Failed to reject quote': 'Одбијање цитата није успело',
    'Failed to release listing': 'Објављивање листе није успело',
    'Failed to save quote': 'Чување цитата није успело',
    'Failed to update listing': 'Ажурирање листе није успело',
    'Failed to update preferred language':
      'Ажурирање жељеног језика није успело',
    'Failed to update setting.': 'Ажурирање подешавања није успело.',
    'Failed to update status': 'Ажурирање статуса није успело',
    'Failed to update translation preference':
      'Ажурирање подешавања превода није успело',
    'Failed to update watchlist': 'Ажурирање листе за гледање није успело',
    'Failed to withdraw quote': 'Повлачење цитата није успело',
    'Feature Flags': 'Феатуре Флагс',
    'Filter invoice uploads, search by reference, and page through payout records.':
      'Филтрирајте отпремања фактура, претражујте по референци и прелистајте записе о исплатама.',
    Filters: 'Филтери',
    'Final delivery documents': 'Завршни документи за испоруку',
    'Fixed price only': 'Само фиксна цена',
    'Flexible / not set': 'Флексибилно / није подешено',
    'Generated automatically when the transport plan is confirmed.':
      'Генерише се аутоматски када је план транспорта потврђен.',
    'Generation: {{generation}}': 'Генерација: {{generation}}',
    'Goods delivered — awaiting client confirmation.':
      'Роба испоручена — чека се потврда клијента.',
    'Gross price': 'Бруто цена',
    'I have read and agree to the purchase terms for this transport job.':
      'Прочитао сам и прихватам услове куповине за овај посао транспорта.',
    'I understand that accepting this listing assigns it to me at the fixed client price shown above.':
      'Разумем да прихватам овај унос мени га додељује по фиксној цени клијента приказаној изнад.',
    'Image upload failed': 'Отпремање слике није успело',
    'Images uploaded': 'Слике су отпремљене',
    'Interface language': 'Језик интерфејса',
    'Invoice documents': 'Документи фактура',
    'Item {{number}}': 'Ставка {{number}}',
    items: 'ставке',
    'Keep listing': 'Наставите са листингом',
    'Keep quote': 'Задржи цитат',
    'Keep the current AI session available after closing the browser on this device.':
      'Нека тренутна АИ сесија буде доступна након затварања прегледача на овом уређају.',
    'Language & Region': 'Језик и регион',
    'Lift: {{origin}} / {{destination}}': 'Лифт: {{origin}} / {{destination}}',
    Listed: 'Наведено',
    'Listing {{id}}': 'Листинг {{id}}',
    'Listing accepted': 'Оглас прихваћен',
    'Listing expired': 'Листинг је истекао',
    'Listing images': 'Листинг имагес',
    'Listing is live': 'Оглас је уживо',
    'Listing reference': 'Листинг референце',
    'Listing snapshot': 'Снимак листе',
    'Listing unavailable': 'Листинг недоступан',
    'Listing updated': 'Оглас је ажуриран',
    'Live Translation': 'Ливе Транслатион',
    'Live translation disabled.': 'Превођење уживо је онемогућено.',
    'Live translation enabled.': 'Превод уживо је омогућен.',
    'Loading approved trucks...': 'Утовар одобрених камиона...',
    'Loading fleet...': 'Учитавање возног парка...',
    'Loading listing details...': 'Учитавање детаља о листи...',
    'Loading listings...': 'Учитавање листе...',
    'Loading review details...': 'Учитавање детаља рецензије...',
    'Loading settings...': 'Учитавање подешавања...',
    'Manage AI Assistant Users': 'Управљајте корисницима АИ Ассистант-а',
    'Manage platform-wide feature flags and configuration.':
      'Управљајте ознакама функција и конфигурацијом широм платформе.',
    'Manage Users': 'Управљајте корисницима',
    'Manage your transport requests, monitor quote activity, and keep active and archived work easy to scan.':
      'Управљајте својим захтевима за транспорт, пратите активност понуде и очувајте активни и архивирани рад лаким за скенирање.',
    'Mark Picked Up': 'Марк Пицкед Уп',
    'Matches the client target price': 'Одговара циљној цени клијента',
    Media: 'Медији',
    Messages: 'Поруке',
    'Messages will be translated into this language.':
      'Поруке ће бити преведене на овај језик.',
    'Minimum net:': 'Минимална нето:',
    'My invoices': 'Моје фактуре',
    Net: 'Нет',
    'Net price': 'Нето цена',
    'Net quote': 'Нето цитат',
    'New images appear immediately in the listing details for client, partner, and admin views.':
      'Нове слике се одмах појављују у детаљима листе за прегледе клијената, партнера и администратора.',
    'Next step': 'Следећи корак',
    'No active listings yet': 'Још нема активних огласа',
    'No address provided': 'Није наведена адреса',
    'No answer yet.': 'Још нема одговора.',
    'No archived listings yet': 'Још нема архивираних уноса',
    'No description added.': 'Није додат опис.',
    'no destination': 'нема одредишта',
    'No expiry': 'Без истека',
    'No listings match the current filters. Try broadening the search or date range.':
      'Ниједна листа не одговара тренутним филтерима. Покушајте да проширите претрагу или период.',
    'no origin': 'без порекла',
    'No questions yet': 'Још нема питања',
    'No quotes yet': 'Још нема цитата',
    'No shipment images uploaded yet.':
      'Још увек није отпремљена ниједна слика пошиљке.',
    'No trailer selected': 'Није изабрана приколица',
    'No unread messages': 'Нема непрочитаних порука',
    'No users found.': 'Није пронађен ниједан корисник.',
    'No users have AI enabled.': 'Ниједан корисник није омогућио АИ.',
    'Not selected': 'Није изабрано',
    'Offers summary': 'Понуде резиме',
    'Open AI assistant': 'Отворите АИ асистента',
    'Open prepared screens automatically':
      'Аутоматски отварајте припремљене екране',
    'Optional visible price shown to partners as your target budget.':
      'Опциона видљива цена која се приказује партнерима као ваш циљни буџет.',
    'Other quotes will be declined automatically once this offer is accepted.':
      'Остале понуде ће бити аутоматски одбијене када ова понуда буде прихваћена.',
    'Partner delivery': 'Испорука партнера',
    'Partner pickup': 'Преузимање партнера',
    'Partner quote': 'Понуда партнера',
    'Payment confirmed': 'Плаћање потврђено',
    'Payment confirmed — listing status set to paid':
      'Плаћање потврђено — статус листе је подешен на плаћено',
    'Payment confirmed. Confirm the assigned fleet and planned dates before the listing moves to Planned.':
      'Плаћање потврђено. Потврдите додељену флоту и планиране датуме пре него што се листа премести у Планирано.',
    'Payment is confirmed. The partner now needs to confirm the truck, driver, and planned dates.':
      'Уплата је потврђена. Партнер сада треба да потврди камион, возача и планиране датуме.',
    'Payment required': 'Обавезно плаћање',
    'Photos uploaded for the shipment and visible across client, partner, and admin views.':
      'Фотографије отпремљене за испоруку и видљиве на клијентским, партнерским и административним приказима.',
    'Pickup is complete and the transport is currently underway.':
      'Преузимање је завршено и транспорт је тренутно у току.',
    'Pickup proof': 'Доказ о преузимању',
    'Pickup proof and final delivery files uploaded by the transport partner.':
      'Доказ о преузимању и датотеке коначне испоруке које је отпремио транспортни партнер.',
    'Pickup to delivery overview': 'Преузимање до прегледа испоруке',
    'Pickup:': 'преузимање:',
    'Plan and authorization': 'План и овлашћење',
    'Plan transport': 'Планирајте транспорт',
    'Plan Transport': 'План Транспорт',
    'Planned dates:': 'Планирани датуми:',
    'Planned delivery date': 'Планирани датум испоруке',
    'Platform Settings': 'Подешавања платформе',
    'Preferred language': 'Жељени језик',
    'Preferred language updated': 'Жељени језик је ажуриран',
    'Prepare a quote or ask for the next lane action, then confirm before anything is submitted.':
      'Припремите понуду или затражите следећу акцију, а затим потврдите пре него што било шта пошаљете.',
    'Purchase Terms': 'Услови куповине',
    'Quantities, dimensions, and handling details ready for transport review.':
      'Количине, димензије и детаљи руковања спремни за преглед транспорта.',
    Question: 'Питање',
    Questions: 'Питања',
    'Questions & answers': 'Питања и одговори',
    'Questions and answers for this listing will appear here once the messaging flow is active.':
      'Питања и одговори за овај унос ће се појавити овде када ток порука буде активан.',
    'Quick access to the current shipment, quote, and billing state.':
      'Брз приступ тренутном стању испоруке, понуде и фактурисања.',
    'Quote accepted': 'Цитат прихваћен',
    'Quote count': 'Број цитата',
    'Quote message': 'Цитирај поруку',
    'Quote rejected': 'Цитат одбијен',
    'Quote withdrawn': 'Цитат повучен',
    Quotes: 'Цитати',
    'Quotes and questions': 'Цитати и питања',
    'Quotes are disabled for this listing. The first partner to accept the fixed price will be assigned automatically.':
      'Цитати су онемогућени за овај унос. Први партнер који прихвати фиксну цену биће додељен аутоматски.',
    'Quotes are disabled for this shipment. If you accept it, the client price becomes an accepted booking immediately.':
      'Понуде су онемогућене за ову пошиљку. Ако је прихватите, цена клијента одмах постаје прихваћена резервација.',
    'Quotes from transport providers usually begin to appear shortly after publishing. Refresh to check again.':
      'Цитати добављача транспорта обично почињу да се појављују убрзо након објављивања. Освежите да бисте поново проверили.',
    'Reference #{{id}}': 'Референца #{{id}}',
    'Refresh listings': 'Освежите листе',
    'Reject quote': 'Одбијте цитат',
    'Rejecting...': 'Одбијање...',
    Release: 'Релеасе',
    'Release Listing': 'Листинг издања',
    'Remember assistant conversation': 'Запамтите разговор помоћника',
    'Required for fixed-price listings. Partners accept this amount directly.':
      'Обавезно за огласе са фиксним ценама. Партнери прихватају овај износ директно.',
    'Required. Partners will be able to accept this listing at the fixed client price without sending a quote.':
      'Обавезно. Партнери ће моћи да прихвате ову понуду по фиксној цени клијента без слања понуде.',
    'Review submission failed.': 'Слање прегледа није успело.',
    'Review the completed transport using the standard product flow.':
      'Прегледајте завршен транспорт користећи стандардни ток производа.',
    'Route pending': 'Рута на чекању',
    'Save changes': 'Сачувај промене',
    'Saving...': 'Чување...',
    'Search by title, route, category, or item':
      'Претражујте по наслову, рути, категорији или ставци',
    'Search Results': 'Сеарцх Ресултс',
    'Search users by email...': 'Претражите кориснике путем е-поште...',
    'Select a truck, driver, pickup date, and delivery date.':
      'Изаберите камион, возача, датум преузимања и датум испоруке.',
    'Select approved truck': 'Изаберите одобрени камион',
    'Select driver': 'Изаберите драјвер',
    'Send Revision': 'Пошаљи ревизију',
    Sentiment: 'Сентимент',
    'Share what went well and what could improve':
      'Поделите шта је прошло добро, а шта би могло да се побољша',
    'Shipment in transit': 'Пошиљка у транзиту',
    'Shipment notes': 'Биљешке о отпреми',
    'Shipment tracking will be shared': 'Праћење пошиљке ће бити подељено',
    'Show AI launchers': 'Прикажи АИ лансере',
    'Show or hide AI assistant buttons on supported dashboard and listing pages.':
      'Прикажите или сакријте дугмад АИ помоћника на подржаној контролној табли и страницама са листингом.',
    'Special needs or notes': 'Посебне потребе или белешке',
    'Specify delivery dates': 'Наведите датуме испоруке',
    'Specify pickup dates': 'Наведите датуме преузимања',
    Stage: 'Стаге',
    'Status updated to {{status}}': 'Статус је ажуриран на {{status}}',
    'Stripe payment confirmed and booking updated':
      'Плаћање на траку потврђено и резервација ажурирана',
    'Stripe status: {{status}}': 'Статус траке: {{status}}',
    'Submit question': 'Пошаљите питање',
    'Submit review': 'Пошаљите рецензију',
    'Submitting...': 'Слање...',
    'The AI assistant is currently disabled for this environment. Existing local session data can still be cleared here.':
      'АИ асистент је тренутно онемогућен за ово окружење. Постојећи подаци о локалној сесији се и даље могу избрисати овде.',
    'The listing expired before a transport was confirmed.':
      'Листинг је истекао пре него што је транспорт потврђен.',
    'The listing has been fully completed and archived as a finished transport.':
      'Листинг је у потпуности завршен и архивиран као готов транспорт.',
    'The lowest net price you would still accept for this shipment.':
      'Најнижа нето цена коју бисте и даље прихватили за ову пошиљку.',
    'The partner has confirmed the route plan. Pickup and delivery dates are now scheduled.':
      'Партнер је потврдио план руте. Датуми преузимања и испоруке су сада заказани.',
    'The partner marked the shipment as delivered. Review the final documents and confirm completion.':
      'Партнер је означио пошиљку као испоручену. Прегледајте коначне документе и потврдите завршетак.',
    'The partner-confirmed plan and LOA stay grouped together for faster review.':
      'План који је потврдио партнер и ЛОА остају груписани заједно ради бржег прегледа.',
    'This action notifies the transport provider and removes the quote from active consideration.':
      'Ова радња обавештава добављача транспорта и уклања понуду из активног разматрања.',
    'This listing is archived and no further transport actions are available.':
      'Овај унос је архивиран и нису доступне даље радње транспорта.',
    'This listing needs an accepted quote before a review can be created.':
      'За овај унос је потребна прихваћена понуда пре него што се може направити рецензија.',
    'This will soft-cancel the listing and move it to your archive.':
      'Ово ће лагано отказати унос и преместити га у вашу архиву.',
    'This will soft-cancel the listing for the client and remove it from active marketplace views.':
      'Ово ће софт-отказати унос за клијента и уклонити га из активних приказа тржишта.',
    'Total quote': 'Тотал куоте',
    'Tracking not promised': 'Праћење није обећано',
    'Tracking shared': 'Праћење је подељено',
    'Tracking visibility': 'Праћење видљивости',
    'Trailer (Optional)': 'Трејлер (опционо)',
    'Translation preference updated': 'Подешавања превода су ажурирана',
    'Transport completed': 'Транспорт завршен',
    'Transport completed.': 'Транспорт завршен.',
    'Transport documents': 'Транспортна документа',
    'Transport marked as complete': 'Транспорт је означен као завршен',
    'Transport package': 'Транспортни пакет',
    'Transport plan confirmed': 'План транспорта потврђен',
    'Transport plan updated': 'План транспорта је ажуриран',
    'Transport planned': 'Планиран транспорт',
    'Transport Provider': 'Транспорт Провидер',
    'Transport providers can review your shipment and send offers.':
      'Провајдери транспорта могу прегледати вашу пошиљку и послати понуде.',
    'Transport stage': 'Транспортна фаза',
    Truck: 'Камион',
    'Truck, driver, trailer, and planned dates for this shipment.':
      'Камион, возач, приколица и планирани датуми за ову пошиљку.',
    'Try widening the current listing filters.':
      'Покушајте да проширите тренутне филтере листе.',
    'Unable to upload listing images.': 'Није могуће отпремити слике са листе.',
    'Unknown error': 'Непозната грешка',
    'Untitled listing': 'Унтитлед листинг',
    'Untitled Listing': 'Унтитлед Листинг',
    'Update media': 'Ажурирајте медије',
    'Update transport plan': 'Ажурирајте транспортни план',
    'Update Transport Plan': 'Ажурирајте транспортни план',
    'Upload a CMR or delivery photos before marking delivered.':
      'Отпремите ЦМР или фотографије испоруке пре него што означите испоручено.',
    'Upload a CMR or delivery photos before the listing can move to Delivered.':
      'Отпремите ЦМР или фотографије испоруке пре него што се листа може преместити у Испоручено.',
    'Upload at least one pickup proof before the listing can move to Picked Up.':
      'Отпремите најмање један доказ о преузимању пре него што се листа може преместити у Преузето.',
    'Upload final documents': 'Отпремите завршне документе',
    'Upload proof of pickup': 'Отпремите доказ о преузимању',
    'Uploading...': 'Отпремање...',
    'Use fresh photos when the shipment changes or you want to clarify the item condition.':
      'Користите свеже фотографије када се пошиљка промени или желите да разјасните стање артикла.',
    'users enabled': 'корисницима омогућено',
    'Visible to you while quoting. You can still send your own net offer below or above this amount.':
      'Видљиво за вас док цитирате. И даље можете послати сопствену нето понуду испод или изнад овог износа.',
    'Waiting for partner acceptance': 'Чека се прихватање партнера',
    'Waiting for transport planning': 'Чека се планирање транспорта',
    'When enabled, messages from other users will be automatically translated to your preferred language.':
      'Када је омогућено, поруке других корисника ће бити аутоматски преведене на ваш жељени језик.',
    Withdraw: 'Повуци се',
    'Write Review': 'Врите Ревиев',
    'You are about to release this listing back to the marketplace.':
      'Спремате се да вратите ову листу на тржиште.',
    'You are now the assigned partner for this fixed-price listing.':
      'Ви сте сада додељени партнер за овај листинг са фиксном ценом.',
    'Your quote has been accepted. Awaiting payment confirmation from the admin before you can begin the job.':
      'Ваша понуда је прихваћена. Чека се потврда плаћања од администратора пре него што почнете са послом.',
    'VIN: {{vin}}': 'ВИН: {{vin}}',
  },
  mk: {
    to: 'до',
    Required: 'Задолжително',
    'Change language': 'Променете го јазикот',
    'Loading...': 'Се вчитува…',
    'Error:': 'Грешка:',
    Close: 'Затвори',
    Yes: 'Да',
    No: 'бр',
    'Keep order': 'Одржувајте ред',
    Price: 'Цена',
    'Purchase terms': 'Услови за купување',
    'Power of attorney': 'полномошно',
    'Transport details': 'Детали за транспорт',
    'Upload damages': 'Поставете штети',
    'Download (PDF)': 'Преземи (PDF)',
    'Mark as picked up': 'Обележете како подигнат',
    'Mark as delivered': 'Обележете како доставено',
    'Cancel booking': 'Откажете ја резервацијата',
    'Order marked as picked up': 'Нарачката е означена како подигната',
    'Order marked as delivered': 'Нарачката е означена како испорачана',
    'Order canceled': 'Нарачката е откажана',
    'Failed to cancel order': 'Не успеа да се откаже нарачката',
    'Added {{count}} file(s)': 'Додадени {{count}}-датотеки',
    Pages: 'Страници',
    'Awaiting Verification': 'Се чека потврда',
    Profile: 'Профил',
    'Profile Incomplete': 'Профилот е нецелосен',
    'Please complete your profile information (Company, Phone, Address, City, Post Code) to access all features.':
      'Ве молиме пополнете ги информациите за вашиот профил (компанија, телефон, адреса, град, поштенски број) за да пристапите до сите функции.',
    'Go to Profile': 'Одете во Профил',
    'Forgot Password': 'Ја заборавивте лозинката',
    Hello: 'Здраво',
    friend: 'пријател',
    'Book your transport': 'Резервирајте го вашиот превоз',
    'fast and easy': 'брзо и лесно',
    'Keep an eye on the route and quote at a glance.':
      'Внимавајте на маршрутата и цитирајте на прв поглед.',
    Origin: 'Потекло',
    Destination: 'Дестинација',
    'Postal code': 'Поштенски број',
    'Calculate to preview': 'Пресметајте за преглед',
    "Can't be calculated yet": 'Сè уште не може да се пресмета',
    'Awaiting payment badge': 'Се чека плаќање',
    'Ref {{id}}': 'Реф {{id}}',
    'Change planning': 'Променете го планирањето',
    'Change driver': 'Променете го возачот',
    'No vehicles listed': 'Нема наведени возила',
    'Order not found.': 'Нарачката не е пронајдена.',
    'Not available': 'Недостапно',
    'For {{date}}': 'За {{date}}',
    'Picked on {{date}}': 'Избрано на {{date}}',
    'Delivered on {{date}}': 'Доставено на {{date}}',
    'Loading notification: {{value}}': 'Известување за вчитување: {{value}}',
    'CO₂ compensation: {{value}}': 'Компензација на CO₂: {{value}}',
    'Bio fuel: {{value}}': 'Био гориво: {{value}}',
    Remove: 'Отстрани',
    'Copy {{label}}': 'Копирајте го {{label}}',
    'Open navigation menu': 'Отворете го менито за навигација',
    'Open menu': 'Отворете го менито',
    'Error fetching data': 'Грешка при преземањето податоци',
    'Not set': 'Не е поставено',
    'No opening hours provided': 'Не е предвидено работно време',
    'Please select a planned date': 'Изберете планиран датум',
    'Saved favorite route filter': 'Зачуван филтер за омилена рута',
    'Radius search': 'Пребарување со радиус',
    'City or town': 'Град или град',
    'Country (optional)': 'Земја (изборно)',
    Radius: 'Радиус',
    'Searching…': 'Се бара…',
    'City not found': 'Градот не е пронајден',
    'Within {{radius}} {{unit}} of {{place}}':
      'Во рамките на {{radius}} {{unit}} од {{place}}',
    'Clear radius': 'Јасен радиус',
    'auth.account_status_pending_review': 'Статус на сметката: Се чека преглед',
    'auth.your_account_is_pending_approval': 'Вашата сметка чека одобрување',
    'auth.upload_your_verification_documents_below_and_we_ll_notify_you_by_email_once_your_account_is_approved':
      'Поставете ги вашите документи за потврда подолу и ќе ве известиме по е-пошта штом вашата сметка ќе биде одобрена.',
    'auth.check_status': 'Проверете го статусот',
    'auth.upload_verification_documents': 'Поставете документи за потврда',
    'auth.your_uploaded_documents': 'Вашите поставени документи',
    'auth.back_to_sign_in': 'Назад за да се најавите',
    'Q1 2025': 'Q1 2025 година',
    'Q2 2025': 'К2 2025 година',
    'Q3 2025': 'К3 2025 година',
    'Error loading documents': 'Грешка при вчитување документи',
    'Are you sure you want to delete this document?':
      'Дали сте сигурни дека сакате да го избришете овој документ?',
    'Document deleted': 'Документот е избришан',
    'Failed to delete': 'Не успеа да се избрише',
    'Failed to get download link': 'Не успеа да се добие врската за преземање',
    'Status updated': 'Статусот е ажуриран',
    'Update failed': 'Ажурирањето не успеа',
    'Email cannot be changed.': 'Е-поштата не може да се смени.',
    'No documents found.': 'Не се пронајдени документи.',
    'Invoice #': 'Фактура #',
    'File Name': 'Име на датотека',
    Amount: 'Износ',
    Actions: 'Акции',
    Download: 'Преземи',
    'Mark Unpaid': 'Означи како неплатен',
    'Mark Paid': 'Означи платено',
    'Please save the record before uploading documents.':
      'Ве молиме зачувајте го записот пред да поставите документи.',
    'Select a file before uploading.':
      'Изберете датотека пред да ја поставите.',
    'Please enter an invoice number.': 'Внесете број на фактура.',
    'Upload successful': 'Поставувањето е успешно',
    '{{count}} file(s) uploaded successfully.':
      '{{count}} датотека(и) се поставени успешно.',
    'Upload failed': 'Поставувањето не успеа',
    'Unable to upload the document.': 'Не може да се постави документот.',
    'Invoice Number': 'Број на фактура',
    'Selected files:': 'Избрани датотеки:',
    Upload: 'Поставете',
    'Save this record before uploading documents.':
      'Зачувајте го овој запис пред да поставите документи.',
    'Error approving user': 'Грешка при одобрување на корисникот',
    'Error rejecting user': 'Грешка при одбивањето на корисникот',
    'Error disabling user': 'Грешка при оневозможување на корисникот',
    'User marked as VIP': 'Корисникот е означен како ВИП',
    'User unmarked as VIP': 'Корисникот е отстранет како ВИП',
    'Error marking user as VIP': 'Грешка при означување на корисникот како ВИП',
    'Error unmarking user as VIP':
      'Грешка при одбележувањето на корисникот како ВИП',
    'Failed to approve user': 'Не успеа да се одобри корисникот',
    'Failed to reject user': 'Не успеа да се одбие корисникот',
    'Failed to disable user': 'Не успеа да се оневозможи корисникот',
    'Failed to unmark user as VIP':
      'Не успеа да се отстрани ознаката на корисникот како ВИП',
    'Failed to mark user as VIP': 'Не успеа да се означи корисникот како ВИП',
    'Invoice Management': 'Управување со фактура',
    'All Invoices': 'Сите фактури',
    'Manage all invoices uploaded by partners.':
      'Управувајте со сите фактури поставени од партнерите.',
    'An unexpected error occurred. Please try again.':
      'Настана неочекувана грешка. Ве молиме обидете се повторно.',
    'The email address is not valid.': 'Адресата на е-пошта не е валидна.',
    'This account has been disabled.': 'Оваа сметка е оневозможена.',
    'No account found with this email.':
      'Не е пронајдена сметка со оваа е-пошта.',
    'Incorrect password. Please try again.':
      'Неточна лозинка. Ве молиме обидете се повторно.',
    'Invalid email or password. Please check your credentials and try again.':
      'Неважечка е-пошта или лозинка. Проверете ги вашите ингеренции и обидете се повторно.',
    'Too many failed attempts. Please try again later or reset your password.':
      'Премногу неуспешни обиди. Обидете се повторно подоцна или ресетирајте ја лозинката.',
    'Network error. Check your connection and try again.':
      'Мрежна грешка. Проверете ја врската и обидете се повторно.',
    'A verification email has been sent to your email address. Please verify your email before logging in.':
      'На вашата е-пошта е испратена е-пошта за потврда. Ве молиме потврдете ја вашата е-пошта пред да се најавите.',
    'Please make sure both passwords are the same.':
      'Ве молиме проверете дали двете лозинки се исти.',
    'Verification email resent!': 'Е-поштата за потврда повторно е испратена!',
    'Please check your inbox.': 'Ве молиме проверете го вашето сандаче.',
    'You need to log in first': 'Прво треба да се најавите',
    'Please sign in to resend the verification email.':
      'Најавете се за повторно да ја испратите е-поштата за потврда.',
    'Failed to resend email': 'Не успеа повторно да се испрати е-пошта',
    'Resend verification email': 'Повторно испратете е-пошта за потврда',
    'Show password': 'Прикажи лозинка',
    'Hide password': 'Сокриј ја лозинката',
    'Awaiting verification artwork': 'Се чека потврда за уметничко дело',
    'Account status: Pending review': 'Статус на сметката: Се чека преглед',
    'Your account is pending approval': 'Вашата сметка чека одобрување',
    "Upload your verification documents below and we'll notify you by email once your account is approved.":
      'Поставете ги вашите документи за потврда подолу и ќе ве известиме по е-пошта штом вашата сметка ќе биде одобрена.',
    'Check status': 'Проверете го статусот',
    'Upload verification documents': 'Поставете документи за потврда',
    'Your uploaded documents': 'Вашите поставени документи',
    'Back to sign in': 'Назад за да се најавите',
    'Hide documents': 'Скриј документи',
    'Email verification required': 'Потребна е потврда на е-пошта',
    'Waiting for email verification': 'Се чека потврда за е-пошта',
    'Check your email': 'Проверете ја вашата е-пошта',
    'We sent your verification link to':
      'Ја испративме вашата врска за потврда на',
    "Didn't receive it? Check your spam folder or try again.":
      'Не го примивте? Проверете ја папката со спам или обидете се повторно.',
    'Resend email': 'Повторно прати е-пошта',
    "I've verified my email": 'Ја потврдив мојата е-пошта',
    'Redirecting you now.': 'Ве пренасочувам сега.',
    'Email not verified yet': 'Е-пошта сè уште не е потврдена',
    'Please click the link in your inbox and try again.':
      'Ве молиме кликнете на врската во вашето сандаче и обидете се повторно.',
    'Unable to resend verification email right now.':
      'Не може повторно да се испрати е-пошта за потврда во моментов.',
    'Unable to check verification status right now.':
      'Не може да се провери статусот на потврдата во моментов.',
    "We've sent a new verification link to your email address.":
      'Испративме нова врска за потврда на вашата адреса на е-пошта.',
    'We automatically check your verification status every 30 seconds. You can also trigger an instant check after verifying your email.':
      'Ние автоматски го проверуваме вашиот статус на потврда на секои 30 секунди. Може да активирате и инстантна проверка откако ќе ја потврдите вашата е-пошта.',
    'We automatically check your verification status every 15 seconds. You can also trigger an instant check after verifying your email.':
      'Ние автоматски го проверуваме вашиот статус на потврда на секои 15 секунди. Може да активирате и инстантна проверка откако ќе ја потврдите вашата е-пошта.',
    'Inputs changed. Recalculate the price.':
      'Влезовите се сменија. Пресметајте ја цената.',
    'My Invoices': 'Мои фактури',
    'Upload New Invoice': 'Поставете нова фактура',
    'Please enter the invoice number and upload the invoice document. It will be reviewed by an administrator.':
      'Ве молиме внесете го бројот на фактурата и поставете го документот за фактурата. Ќе биде разгледан од администратор.',
    'Invoice History': 'Историја на фактура',
    'Client ref · {{clientRef}}': 'Реф на клиент · {{clientRef}}',
    'Order Documents': 'Документи за нарачка',
    'Upload Proof of Pickup': 'Поставете доказ за подигање',
    'Status will be updated to Picked Up after successful upload.':
      'Статусот ќе биде ажуриран во „Прибран“ по успешното поставување.',
    'Upload Proof of Delivery': 'Поставете доказ за испорака',
    'Status will be updated to Delivered after successful upload.':
      'Статусот ќе се ажурира на Доставен по успешното поставување.',
    'Enter first name': 'Внесете име',
    'Enter last name': 'Внесете презиме',
    'Enter phone number': 'Внесете телефонски број',
    'Driver updated.': 'Возачот е ажуриран.',
    'The driver has been successfully updated.': 'Возачот е успешно ажуриран.',
    'Driver added.': 'Додаден е возач.',
    'The new driver has been successfully added.':
      'Новиот драјвер е успешно додаден.',
    'Driver deleted.': 'Возачот е избришан.',
    'The driver has been successfully deleted.': 'Возачот е успешно избришан.',
    'Trailer updated.': 'Трејлерот е ажуриран.',
    'The trailer has been successfully updated.':
      'Трејлерот е успешно ажуриран.',
    'Trailer added.': 'Додадена е трејлер.',
    'The new trailer has been successfully added.':
      'Новиот трејлер е успешно додаден.',
    'Trailer deleted.': 'Трејлерот е избришан.',
    'The trailer has been successfully deleted.':
      'Трејлерот е успешно избришан.',
    'User account not found. Please complete registration.':
      'Корисничката сметка не е пронајдена. Ве молиме пополнете ја регистрацијата.',
    'No token provided': 'Не е обезбеден токен',
    'Token expired': 'Токенот е истечен',
    'Token revoked': 'Токенот е отповикан',
    'Invalid ID token': 'Неважечки ID токен',
    Unauthorized: 'Неовластено',
    'Unauthorized: User not authenticated.':
      'Неовластено: Корисникот не е автентициран.',
    'Unauthorized: User role not found.':
      'Неовластено: Улогата на корисникот не е пронајдена.',
    'Forbidden: Your role is not allowed to perform this action.':
      'Забрането: Вашата улога не смее да го изврши ова дејство.',
    'Forbidden: This action requires a partner role.':
      'Забрането: Оваа акција бара партнерска улога.',
    'Forbidden: This action requires a client role.':
      'Забрането: оваа акција бара улога на клиент.',
    'Forbidden: This action requires an admin role.':
      'Забрането: за оваа акција е потребна административна улога.',
    'This user has not been approved': 'Овој корисник не е одобрен',
    'User email has not been verified': 'Корисничката е-пошта не е потврдена',
    'User account has been disabled': 'Корисничката сметка е оневозможена',
    'Booking not found': 'Резервацијата не е пронајдена',
    'Route not found': 'Маршрутата не е пронајдена',
    'Pickup location (country and postalCode) is required':
      'Потребна е локација за подигање (земја и поштенски код).',
    'Delivery location (country and postalCode) is required':
      'Потребна е локација за испорака (земја и поштенски код).',
    'Unable to calculate route. Please check the locations and try again.':
      'Не може да се пресмета маршрутата. Проверете ги локациите и обидете се повторно.',
    'Error calculating transport price':
      'Грешка при пресметувањето на цената на транспортот',
    'Booking canceled successfully': 'Резервацијата е успешно откажана',
    'Invalid request.': 'Неважечко барање.',
    'Access denied.': 'Пристапот е одбиен.',
    'Resource not found.': 'Ресурсот не е пронајден.',
    'Request conflict.': 'Побарајте конфликт.',
    'Invalid data provided.': 'Обезбедени се неважечки податоци.',
    'Too many requests. Please try again later.':
      'Премногу барања. Обидете се повторно подоцна.',
    'Internal server error. Please try again later.':
      'Грешка на внатрешен сервер. Обидете се повторно подоцна.',
    'Service temporarily unavailable.': 'Услугата е привремено недостапна.',
    'booking.load_preset': 'Вчитај претходно поставено',
    'booking.save_preset_tooltip':
      'Зачувајте ги тековните филтри како ваша меморираност за брз пристап',
    'booking.load_preset_tooltip':
      'Вчитајте го зачуваниот претходно поставен филтер',
    'booking.preset_saved': 'Претходно поставеното е зачувано',
    'booking.preset_saved_desc': 'Вашиот претходно поставен филтер е зачуван.',
    'booking.preset_loaded': 'Вчитано е претходно поставеното',
    'booking.preset_load_error': 'Не успеа да се вчита претходно поставеното',
    'booking.no_preset_saved': 'Сè уште нема зачувано претходно поставено',
    'booking.date_from': 'Датум од',
    'booking.date_to': 'Датум до',
    'Active filters': 'Активни филтри',
    'All booking states': 'Сите резервации држави',
    'All partners': 'Сите партнери',
    'All payments': 'Сите плаќања',
    'All roles': 'Сите улоги',
    'All statuses': 'Сите статуси',
    'All Users': 'Сите корисници',
    'Are you sure you want to cancel booking {{id}}?':
      'Дали сте сигурни дека сакате да ја откажете резервацијата на {{id}}?',
    'Attach the CMR Insurance before finishing truck setup.':
      'Прикачете ја CMR-фактурата пред да го завршите поставувањето на камионот.',
    Awaiting: 'Се чека',
    'Awaiting payout': 'Се чека исплата',
    'Booking canceled': 'Резервацијата е откажана',
    'Booking marked as paid': 'Резервацијата е означена како платена',
    'Booking released and returned to marketplace':
      'Резервацијата е објавена и вратена на пазарот',
    'booking.allowed_range': 'Дозволен опсег',
    'booking.assign_transport': 'Доделете транспорт',
    'booking.back': 'Назад',
    'booking.back_to_summary': 'Назад на резимето',
    'booking.booking_created_but_pickup_document_not_uploaded_upload_from_order_details':
      'Резервацијата беше создадена, но документот за подигање не беше поставен. Можете да го поставите од Детали за нарачка.',
    'booking.city_not_found': 'Градот не е пронајден',
    'booking.city_or_town': 'Град или град',
    'booking.clear_radius': 'Јасен радиус',
    'booking.continue': 'Продолжи',
    'booking.country_optional': 'Земја (изборно)',
    'booking.delivery_constraint_info':
      'Датумот на испорака мора да биде на или по датумот на подигање.',
    'booking.delivery_date_cannot_be_earlier_than_pickup_date':
      'Датумот на испорака не може да биде порано од датумот на подигање',
    'booking.driver': 'Возач',
    'booking.failed_to_open_letter_of_attorney':
      'Не успеа да се отвори полномошно',
    'booking.go_to_order': 'Одете на Нарачка',
    'booking.i_accept_terms': 'Ги прифаќам условите',
    'booking.invalid_license_plate_or_vin_length':
      'Неважечка регистарска табличка или VIN должина.',
    'booking.invalid_vin_format_i_o_q_not_allowed':
      'Неважечки VIN формат. Знаците I, O и Q не се дозволени.',
    'booking.letter_of_attorney_file_is_empty':
      'Досието за полномошно е празно',
    'booking.no_additional_details': 'Нема дополнителни детали',
    'booking.no_vehicle_info': 'Нема информации за возилото',
    'booking.open_letter_of_attorney': 'Отворено полномошно',
    'booking.opening_letter_of_attorney': 'Отворено полномошно...',
    'booking.order_accepted_successfully': 'Нарачката е успешно прифатена',
    'booking.order_cars_exceed_selected_truck_capacity':
      'Оваа нарачка има {{orderCars}} автомобили, но избраниот капацитет на камионот е {{capacity}}.',
    'booking.pickup_constraint_info':
      'Потребен е датум на подигање пред да се додели транспортот.',
    'booking.pickup_document_upload_failed':
      'Подигнувањето на документот за подигање не успеа',
    'booking.preparing_secure_document_preview':
      'Се подготвува безбеден преглед на документи...',
    'booking.radius_km': 'Радиус (км)',
    'booking.radius_search': 'Пребарување со радиус',
    'booking.route_and_details': 'Пат и детали',
    'booking.schedule': 'Распоред',
    'booking.searching': 'Се бара…',
    'booking.select_pickup_and_delivery': 'Изберете подигање и испорака',
    'booking.select_pickup_and_delivery_dates_before_confirming':
      'Изберете датуми за подигање и испорака пред да потврдите',
    'booking.select_pickup_date': 'Изберете датум на подигање',
    'booking.select_truck_driver_and_trailer':
      'Изберете камион, возач и приколка',
    'booking.supported_formats_jpg_png_pdf_doc_docx':
      'Поддржани формати: JPG, PNG, PDF, DOC, DOCX',
    'booking.terms_and_conditions': 'Услови и правила',
    'booking.terms_text':
      'Ги потврдувам условите за транспорт и условите за одговорност.',
    'booking.track_shipment': 'Следете ја пратката',
    'booking.trailer': 'Трејлер',
    'booking.transport_details': 'Детали за транспорт',
    'booking.truck': 'Камион',
    'booking.truck_driver_planning_saved_letter_of_attorney_available':
      'Камионот, возачот и датумите на планирање беа зачувани. Полномошното сега е достапно.',
    'booking.unexpected_error': 'Неочекувана грешка',
    'booking.vehicles_plural': 'Возила',
    'booking.view_details': 'Погледнете детали',
    'booking.vip_price_must_be_between_min_max_50_to_150_percent_of_estimated_price':
      'Цената на ВИП мора да биде помеѓу {{min}} EUR и {{max}} EUR (50% до 150% од проценетата цена).',
    'booking.vip_price_must_be_positive_number':
      'Цената на ВИП мора да биде позитивен број.',
    'booking.within_radius_km_of_place':
      'Во рамките на {{radius}} км од {{place}}',
    Capacity: 'Капацитет',
    'Car Capacity': 'Капацитет на автомобилот',
    'Car capacity is required.': 'Потребен е капацитет на автомобилот.',
    cars: 'автомобили',
    Changed: 'Променет',
    'CMR Document': 'CMR документ',
    'CMR expiry': 'CMR истекување',
    'CMR Expiry': 'Истекување на CMR',
    'CMR expiry date is required': 'Потребен е датум на истекување на CMR',
    'CMR Insurance': 'CMR осигурување',
    'CMR insurance expiry date': 'Датум на истекување на CMR осигурување',
    'CMR Insurance Expiry Date': 'Датум на истекување на CMR осигурување',
    'CMR insurance has expired. Upload a new CMR Insurance for review.':
      'Поставете нова CMR фактура за преглед.',
    'CMR insurance is expiring within 14 days.':
      'ЦМР осигурувањето истекува во рок од 14 дена.',
    'CMR Insurance required': 'Потребна е CMR фактура',
    Company: 'Компанијата',
    'Copy order ID': 'Копирај ID на нарачка',
    Created: 'Создаден',
    'Current expiry': 'Тековен рок на траење',
    'Date range': 'Опсег на датуми',
    days: 'денови',
    Delay: 'Одложување',
    'Delivered + partner invoice uploaded + unpaid':
      'Доставено + ставена фактура од партнер + неплатена',
    Document: 'Документ',
    'Documents uploaded': 'Поставени документи',
    Done: 'Готово',
    'Download Client Invoice #{{id}}':
      'Преземете ја фактурата на клиентот #{{id}}',
    'Download Invoice': 'Преземете фактура',
    'Enter a valid capacity between 1 and 20 cars.':
      'Внесете важечки капацитет од 1 до 20 автомобили.',
    'Enter license plate': 'Внесете регистарска табличка',
    'Enter plate and upload CMR to add truck':
      'Внесете табличка и поставете CMR за да додадете камион',
    'Error fetching users': 'Грешка при преземањето на корисниците',
    'Expire Soon (14 days)': 'Истекува наскоро (14 дена)',
    'Explain why this CMR was rejected': 'Објаснете зошто овој CMR беше одбиен',
    'Failed to copy order ID': 'ИД на нарачката не успеа да се копира',
    'Failed to download invoice': 'Не успеа да се преземе фактурата',
    'Failed to download proforma invoice':
      'Не успеа да се преземе профактурата',
    'Failed to generate invoice': 'Не успеа да се генерира фактура',
    'Failed to load invoice summary':
      'Не успеа да се вчита резимето на фактурата',
    'Failed to load letter of attorney': 'Не успеа да се вчита полномошното',
    'Failed to open letter of attorney': 'Не успеа да се отвори полномошно',
    'Failed to release booking': 'Не успеа да се ослободи резервацијата',
    'Fleet data refreshed': 'Податоците за флотата се освежени',
    'Generate Client Invoice': 'Генерирајте фактура за клиент',
    'Generate Invoice': 'Генерирајте фактура',
    'Generated at': 'Генерирани во',
    'How many cars can this truck carry?':
      'Колку автомобили може да носи овој камион?',
    'In progress': 'Во тек',
    Invoice: 'Фактура',
    'Invoice generated': 'Генерирана фактура',
    'Invoice generated successfully': 'Фактурата е генерирана успешно',
    'Invoice uploaded': 'Фактурата е поставена',
    'Invoices uploaded by partners for platform payout processing. Client invoices are generated in each order view.':
      'Фактурите на клиентите се генерираат во секој приказ на нарачката.',
    'Keep booking': 'Продолжете да резервирате',
    'Keep your active drivers and contact details up to date.':
      'Ажурирајте ги активните драјвери и деталите за контакт.',
    'Last Rejection': 'Последно одбивање',
    'Last rejection reason': 'Последна причина за одбивање',
    'Letter of Attorney': 'Полномошно',
    'Letter of attorney file is empty': 'Досието за полномошно е празно',
    'License plate cannot be changed after creation. Re-upload CMR Insurance instead.':
      'Наместо тоа, повторно поставете CMR фактура.',
    'License plate is required.': 'Потребна е регистарска табличка.',
    'Manage large order volumes with search, payment actions, and invoice workflows.':
      'Управувајте со големи количини на нарачки со пребарување, дејства за плаќање и работни текови на фактури.',
    'Manage license plates and keep CMR Insurances approved and valid.':
      'Управувајте со регистарските таблички и одржувајте ги фактурите за CMR одобрени и валидни.',
    'Manage status updates, documents, and payment steps from one place.':
      'Управувајте со ажурирањата на статусот, документите и чекорите за плаќање од едно место.',
    'Manage trailer plate records and keep availability current.':
      'Управувајте со евиденцијата на табличките на приколката и одржувајте ја моменталната достапност.',
    'Mark booking {{id}} as paid?':
      'Означете ја резервацијата {{id}} како платена?',
    Missing: 'Недостасува',
    'Needs attention': 'Потребно е внимание',
    'New (14 days)': 'Ново (14 дена)',
    'No bookings found for the current filters.':
      'Не се пронајдени резервации за тековните филтри.',
    'No confirmed CMR document uploaded yet.':
      'Сè уште не е поставен документ за CMR потврден.',
    'No driver assigned': 'Не е доделен возач',
    'No letter of attorney has been generated yet.':
      'Сè уште не е генерирано полномошно.',
    'No matching delivered orders': 'Нема соодветни испорачани нарачки',
    'No new notifications': 'Нема нови известувања',
    'No partners found.': 'Не се пронајдени партнери.',
    'No trucks found for this filter.': 'Не се најдени камиони за овој филтер.',
    'No users found for current filters.':
      'Не се најдени корисници за тековните филтри.',
    'Not uploaded': 'Не е поставено',
    Notifications: 'Известувања',
    of: 'на',
    'Only admins can set or update this expiry date after reviewing your CMR insurance.':
      'Само администраторите можат да го постават или ажурираат овој датум на истекување откако ќе го прегледаат вашето CMR осигурување.',
    'Open letter of attorney': 'Отворено полномошно',
    Order: 'Нарачајте',
    'Order actions': 'Нарачајте дејства',
    'Order ID copied': 'ИД на нарачката е копирана',
    Owner: 'Сопственик',
    Page: 'Страница',
    'Paid date': 'Датум на плаќање',
    'Partner delivery date': 'Датум на испорака на партнер',
    'Partner documents': 'Партнерски документи',
    'Partner Invoice': 'Партнерска фактура',
    'Partner invoice uploaded': 'Партнерска фактура е поставена',
    'Partner Payout Invoices': 'Фактури за исплата на партнери',
    'Partner pickup date': 'Датум на подигање од партнер',
    'Partner score': 'Партнер резултат',
    Payment: 'Плаќање',
    'Payout date': 'Датум на исплата',
    'penalties applied': 'применети казни',
    'Pending admin review': 'Се чека преглед од администраторот',
    'Pending review': 'Се чека преглед',
    'Pending trucks': 'Камиони што чекаат',
    'Please provide a clear reason for rejection.':
      'Ве молиме наведете јасна причина за одбивање.',
    'Please select an order before uploading an invoice.':
      'Изберете нарачка пред да поставите фактура.',
    'Please try again.': 'Ве молиме обидете се повторно.',
    'Proforma Invoice': 'Профактура',
    'Provide a rejection reason for this CMR review.':
      'Наведете причина за одбивање за овој преглед на CMR.',
    'Quarter Score': 'Четврт резултат',
    'Re-upload CMR': 'Повторно вчитајте CMR',
    Refresh: 'Освежи',
    'Rejection reason': 'Причина за одбивање',
    'Rejection reason is required': 'Потребна е причина за одбивање',
    'Release booking {{id}} back to the marketplace so another partner can accept it?':
      'Да ја ослободите резервацијата на {{id}} назад на пазарот за да може друг партнер да ја прифати?',
    Reset: 'Ресетирај',
    'Review Bookings': 'Прегледајте резервации',
    Revision: 'Ревизија',
    Rows: 'Редови',
    'Search by invoice number, file name, or booking ID':
      'Пребарувајте по број на фактура, име на датотека или ID на резервација',
    'Search by name, email, company': 'Пребарувајте по име, е-пошта, компанија',
    'Search by name, email, company, uid':
      'Пребарувајте по име, е-пошта, компанија, uid',
    'Search client': 'Барај клиент',
    'Search delivered order': 'Пребарајте испорачана нарачка',
    'Search license plate or owner':
      'Пребарајте регистарска табличка или сопственик',
    'Search order ID': 'ID на нарачка за пребарување',
    'Search partner': 'Барај партнер',
    'Select a new CMR Insurance to re-upload for this truck.':
      'Изберете нова CMR фактура за повторно поставување за овој камион.',
    'Select paid date': 'Изберете датум на плаќање',
    'Set CMR insurance expiry date to approve this truck.':
      'Поставете го датумот на истекување на CMR осигурување за да го одобрите овој камион.',
    'Set maximum number of cars this truck can carry (1-20).':
      'Поставете максимален број на автомобили што може да ги носи овој камион (1-20).',
    'Set the CMR insurance expiry date before approval.':
      'Поставете го датумот на истекување на CMR осигурување пред одобрување.',
    Showing: 'Се прикажува',
    'Showing page {{page}} of {{pages}} • {{total}} invoices':
      'Се прикажува страница {{page}} од {{pages}} • {{total}} фактури',
    'Status will be updated to Picked Up after successful upload. You can add multiple car photos before uploading.':
      'Можете да додадете повеќе фотографии од автомобилот пред да ги поставите.',
    Terms: 'Услови',
    Total: 'Вкупно',
    'Track paid and unpaid invoices, expected payout dates, and upload new invoices quickly.':
      'Следете ги платените и неплатените фактури, очекуваните датуми на исплата и брзо испраќајте нови фактури.',
    'Truck approved successfully': 'Камионот е успешно одобрен',
    'Truck documents': 'Документи за камиони',
    'Truck license plate': 'Регистерски таблички на камион',
    'Truck rejected successfully': 'Камионот беше успешно одбиен',
    'truck(s) are pending admin CMR expiry date.':
      'камион(и) чекаат на административен CMR датум на истекување.',
    'truck(s) have expired CMR insurance and are disabled.':
      'камион(и) имаат истечен CMR осигурување и се оневозможени.',
    'truck(s) will expire within 14 days.':
      'камион(и) ќе истече во рок од 14 дена.',
    'Unable to prepare the record for upload.':
      'Записот не може да се подготви за прикачување.',
    Unpaid: 'Неплатено',
    'Upload a CMR Insurance before closing this truck setup.':
      'Поставете CMR фактура пред да го затворите поставувањето на камионот.',
    'Upload a valid CMR insurance. Each upload sends the truck back to pending review.':
      'Секое прикачување го враќа камионот на преглед кој чека.',
    'Upload documents': 'Поставете документи',
    'Upload Invoice': 'Поставете фактура',
    'Upload order documents': 'Поставете документи за нарачка',
    'Upload unavailable': 'Поставувањето е недостапно',
    Uploaded: 'Прикачено',
    'Uploaded • Paid': 'Поставено • Платено',
    'Uploaded • Partially paid': 'Поставено • Делумно платено',
    'Uploaded by partner for platform payout processing.':
      'Поставено од партнер за обработка на исплати на платформата.',
    User: 'Корисник',
    'Verification code': 'Код за верификација',
    'View details': 'Погледнете детали',
    'View Partners': 'Прикажи ги партнерите',
    'Working hours not provided': 'Работното време не е обезбедено',
    '{{value}} orders': '{{value}} нарачки',
    Invoiced: 'Фактурирана',
    'Loading admin data...': 'Се вчитуваат административните податоци...',
    'Pending partners': 'Партнери во очекување',
    'Unpaid bookings': 'Неплатени резервации',
    'Total users': 'Вкупно корисници',
    'Orders per period': 'Нарачки по период',
    'Orders by status': 'Нарачки по статус',
    'Quick actions': 'Брзи акции',
    'Verify new partners': 'Потврдете ги новите партнери',
    'Review partner applications and approve or reject requests.':
      'Прегледајте ги апликациите за партнери и одобрувајте или отфрлете ги барањата.',
    'Manage all trucks': 'Управувајте со сите камиони',
    'Review, approve, reject, disable, and filter all trucks.':
      'Прегледајте, одобрувајте, отфрлете, оневозможете и филтрирајте ги сите камиони.',
    'Review bookings': 'Прегледајте резервации',
    'Review all transport orders, payment states, and generated invoices.':
      'Прегледајте ги сите транспортни нарачки, состојби на плаќање и генерирани фактури.',
    'Manage all users': 'Управувајте со сите корисници',
    'Manage user status, roles, and validation records.':
      'Управувајте со статусот на корисникот, улогите и записите за валидација.',
    'User breakdown': 'Дефект на корисникот',
    Clients: 'Клиенти',
    Partners: 'Партнери',
    Admins: 'Администратори',
    'Top 5 pending partners': 'Топ 5 партнери во очекување',
    'No pending partners right now.': 'Во моментов нема партнери што чекаат.',
    pending: 'во очекување',
    'Top 5 pending trucks': 'Топ 5 камиони што чекаат',
    'No pending trucks right now.': 'Во моментов нема камиони на чекање.',
    'Unknown owner': 'Непознат сопственик',
    'KPI cards and top lists link directly to filtered admin screens.':
      'KPI-картичките и топ листите директно се поврзуваат со филтрирани администраторски екрани.',
    'booking.available_orders_title': 'Достапни нарачки',
    'booking.available_orders_description':
      'Прегледајте ги можностите за дојдовен транспорт и применувајте филтри за да одговараат на вашиот капацитет.',
    'booking.vehicle_pickup_location': 'Локација за подигање на возилото',
    'booking.pickup_opening_hours': 'Работно време на пикап',
    'booking.vehicle_delivery_location': 'Локација за испорака на возилото',
    'booking.delivery_opening_hours': 'Работно време за испорака',
    'booking.pickup_contact': 'Контакт за пикап',
    'booking.delivery_contact': 'Контакт за испорака',
    'booking.vehicles_scheduled': 'Закажани возила',
    'booking.watchlist_title': 'Список за следење',
    'booking.watchlist_description':
      'Следете ги зачуваните можности и дејствувајте брзо како што се менува достапноста.',
    'Loading dashboard...': 'Се вчитува контролната табла...',
    'Total bookings': 'Вкупно резервации',
    'Open bookings': 'Отворете резервации',
    'Order status timeline': 'Временска рамка за статусот на нарачката',
    'Last 6 months of bookings grouped by current status.':
      'Последните 6 месеци резервации групирани според моменталниот статус.',
    'Create new order': 'Создадете нов ред',
    'Create a new transport booking request.':
      'Направете ново барање за резервација за превоз.',
    'View my orders': 'Погледнете ги моите нарачки',
    'Review status and details of your bookings.':
      'Прегледајте го статусот и деталите за вашите резервации.',
    'Open profile': 'Отворете го профилот',
    'Update company and contact details.':
      'Ажурирајте ја компанијата и деталите за контакт.',
    'Recent bookings': 'Неодамнешни резервации',
    'No bookings yet.': 'Сè уште нема резервации.',
    'Unknown destination': 'Непозната дестинација',
    'Quarter score': 'Четврт резултат',
    '{{value}} completed': '{{value}} е завршен',
    'Truck CMR warning': 'Камион CMR предупредување',
    'One truck has CMR expiry risk. Review it in Fleet.':
      'Еден камион има ризик од истекување на CMR. Прегледајте го во Fleet.',
    '{{count}} trucks have CMR expiry risk. Review them in Fleet.':
      'Камионите {{count}} имаат ризик од истекување на CMR. Прегледајте ги во Fleet.',
    'Active queue': 'Активна редица',
    'Delivered bookings': 'Доставени резервации',
    'Cars delivered': 'Испорачани автомобили',
    'Canceled bookings': 'Откажани резервации',
    'Avg assign-to-pickup': 'Просечно доделување на подигање',
    'Quarter Partner Score': 'Квартален резултат на партнерот',
    'Payment delay: +{{days}} days': 'Одложување на плаќање: +{{days}} дена',
    'Penalty events': 'Настани за пенали',
    Current: 'Актуелно',
    'Completed orders per period': 'Завршени нарачки по период',
    'Completed orders': 'Завршени нарачки',
    'Truck CMR status alerts': 'Известувања за статусот CMR на камионот',
    '{{count}} truck(s) have expired CMR insurance.':
      'На камион(и) {{count}} им е истечен CMR осигурувањето.',
    '{{count}} truck(s) will expire within 14 days.':
      '{{count}} камион(и) ќе истече во рок од 14 дена.',
    '{{count}} truck(s) are missing CMR expiry date.':
      'На камион(и) {{count}} им недостасува датумот на истекување на CMR.',
    'Upload a new CMR Insurance in Fleet. The truck will stay pending until admin review.':
      'Поставете нова CMR фактура во Fleet. Камионот ќе остане на чекање до прегледот од администраторот.',
    'Open fleet to resolve CMR alerts':
      'Отворете ја флотата за да ги решите предупредувањата за CMR',
    'Operational actions': 'Оперативни дејствија',
    'Open marketplace orders': 'Нарачки на отворен пазар',
    'Review available orders and plan assignments.':
      'Прегледајте ги достапните нарачки и планирајте задачи.',
    'My accepted orders': 'Моите прифатени нарачки',
    'Manage delivery progress and documents.':
      'Управувајте со напредокот на испораката и документите.',
    'Update trucks, trailers, and availability.':
      'Ажурирајте ги камионите, приколките и достапноста.',
    'Partner invoices': 'Партнерски фактури',
    'Upload and track invoice payments.':
      'Поставете и следете ги плаќањата на фактурите.',
    'No active orders in queue.': 'Нема активни нарачки во редот.',
    'profile.incompleteTitle': 'Профилот е нецелосен',
    'profile.incompleteDescription':
      'Ве молиме пополнете ги информациите за вашиот профил (компанија, телефон, адреса, град, поштенски број) за да пристапите до сите функции.',
    'profile.goToProfile': 'Одете во Профил',
    'auth.email_placeholder': 'name@company.com',
    'auth.authentication_mode_switch': 'Прекинувач за режим за автентикација',
    'auth.invalid_email': 'Неважечка е-пошта',
    'auth.please_enter_a_valid_email_address':
      'Внесете важечка адреса за е-пошта.',
    'auth.email_not_found': 'Е-поштата не е пронајдена',
    'auth.no_account_found_with_that_email_address':
      'Не е пронајдена сметка со таа адреса на е-пошта.',
    'auth.email_sent': 'Испратена е-пошта!',
    'auth.something_went_wrong_try_again':
      'Нешто тргна наопаку. Обидете се повторно.',
    'auth.we_sent_a_password_reset_link_open_your_inbox_and_follow_the_instructions':
      'Испративме врска за ресетирање лозинка. Отворете го вашето сандаче и следете ги упатствата.',
    'auth.forgot_your_password': 'Ја заборавивте лозинката?',
    'auth.enter_your_account_email_and_we_will_send_you_a_password_reset_link':
      'Внесете ја е-поштата на вашата сметка и ние ќе ви испратиме врска за ресетирање на лозинката.',
    'auth.email_address': 'Адреса на е-пошта',
    'auth.send_reset_link': 'Испрати врска за ресетирање',
    'auth.cancel': 'Откажи',
    'auth.tip_if_you_do_not_receive_the_email_check_spam_and_promotions_folders':
      'Совет: ако не ја добиете е-поштата, проверете ги папките за спам и промоции.',
    'booking.e_g_berlin': 'на пр. Берлин',
    'booking.e_g_germany': 'на пр. Германија',
    'booking.watchlist': 'Список за следење',
    'booking.view_map': 'Погледнете ја картата',
    'booking.invalid_input': 'Неважечки влез',
    'booking.please_enter_only_numbers_for_the_zip_code':
      'Внесете само броеви за поштенскиот број.',
    'booking.pickup_zip_code': 'Поштенски број за подигање',
    'booking.delivery_zip_code': 'Поштенски број за испорака',
    'booking.select_vehicle_make': 'Изберете марка на возилото',
    'booking.unnamed_item': 'Неименувана ставка',
    'booking.cars': 'автомобили',
    'booking.more_info': 'Повеќе информации',
    'booking.loading': 'Се вчитува...',
    'booking.no_items_found': 'Не се пронајдени ставки',
    'booking.selected_cars': 'Избрани автомобили',
    'booking.unknown_type': 'Непознат тип',
    'booking.delete_car': 'Избриши автомобил',
    'Toggle details': 'Вклучи детали',
    'auth.a_verification_email_has_been_sent_to_your_email_address_please_verify_your_emai':
      'На вашата е-пошта е испратена е-пошта за потврда. Ве молиме потврдете ја вашата е-пошта пред да се најавите.',
    'auth.an_unexpected_error_occurred_please_try_again':
      'Настана неочекувана грешка. Ве молиме обидете се повторно.',
    'auth.failed_to_resend_email': 'Не успеа повторно да се испрати е-пошта',
    'auth.show_password': 'Прикажи лозинка',
    'auth.hide_password': 'Сокриј ја лозинката',
    'auth.incorrect_password_please_try_again':
      'Неточна лозинка. Ве молиме обидете се повторно.',
    'auth.invalid_email_or_password_please_check_your_credentials_and_try_again':
      'Неважечка е-пошта или лозинка. Проверете ги вашите ингеренции и обидете се повторно.',
    'auth.network_error_check_your_connection_and_try_again':
      'Мрежна грешка. Проверете ја врската и обидете се повторно.',
    'auth.no_account_found_with_this_email':
      'Не е пронајдена сметка со оваа е-пошта.',
    'auth.please_check_your_inbox': 'Ве молиме проверете го вашето сандаче.',
    'auth.please_make_sure_both_passwords_are_the_same':
      'Ве молиме проверете дали двете лозинки се исти.',
    'auth.please_sign_in_to_resend_the_verification_email':
      'Најавете се за повторно да ја испратите е-поштата за потврда.',
    'auth.resend_verification_email': 'Повторно испратете е-пошта за потврда',
    'auth.awaiting_verification_artwork': 'Се чека потврда за уметничко дело',
    'auth.email_verification_required': 'Потребна е потврда на е-пошта',
    'auth.waiting_for_email_verification': 'Се чека потврда за е-пошта',
    'auth.check_your_email': 'Проверете ја вашата е-пошта',
    'auth.we_sent_your_verification_link_to':
      'Ја испративме вашата врска за потврда на',
    'auth.didnt_receive_it_check_spam_or_try_again':
      'Не го примивте? Проверете ја папката со спам или обидете се повторно.',
    'auth.resend_email': 'Повторно прати е-пошта',
    'auth.i_verified_my_email': 'Ја потврдив мојата е-пошта',
    'auth.redirecting_you_now': 'Ве пренасочувам сега.',
    'auth.email_not_verified_yet': 'Е-пошта сè уште не е потврдена',
    'auth.please_click_the_link_in_your_inbox_and_try_again':
      'Ве молиме кликнете на врската во вашето сандаче и обидете се повторно.',
    'auth.unable_to_resend_verification_email_right_now':
      'Не може повторно да се испрати е-пошта за потврда во моментов.',
    'auth.unable_to_check_verification_status_right_now':
      'Не може да се провери статусот на потврдата во моментов.',
    'auth.we_sent_a_new_verification_link':
      'Испративме нова врска за потврда на вашата адреса на е-пошта.',
    'auth.we_automatically_check_every_30_seconds':
      'Ние автоматски го проверуваме вашиот статус на потврда на секои 30 секунди. Може да активирате и инстантна проверка откако ќе ја потврдите вашата е-пошта.',
    'auth.we_automatically_check_every_15_seconds':
      'Ние автоматски го проверуваме вашиот статус на потврда на секои 15 секунди. Може да активирате и инстантна проверка откако ќе ја потврдите вашата е-пошта.',
    'auth.the_email_address_is_not_valid': 'Адресата на е-пошта не е валидна.',
    'auth.this_account_has_been_disabled': 'Оваа сметка е оневозможена.',
    'auth.too_many_failed_attempts_please_try_again_later_or_reset_your_password':
      'Премногу неуспешни обиди. Обидете се повторно подоцна или ресетирајте ја лозинката.',
    'auth.verification_email_resent':
      'Е-поштата за потврда повторно е испратена!',
    'auth.you_need_to_log_in_first': 'Прво треба да се најавите',
    'booking.error_fetching_data': 'Грешка при преземањето податоци',
    'booking.inputs_changed_recalculate_the_price':
      'Влезовите се сменија. Пресметајте ја цената.',
    'booking.no_opening_hours_provided': 'Не е предвидено работно време',
    'booking.no_vehicles_listed': 'Нема наведени возила',
    'booking.not_available': 'Недостапно',
    'booking.not_set': 'Не е поставено',
    'booking.please_select_a_planned_date': 'Изберете планиран датум',
    'booking.required': 'Задолжително',
    'booking.to': 'до',
    'booking.order': 'Нарачајте',
    'booking.duration': 'Времетраење',
    'booking.vehicles_overview': 'Преглед на возила',
    'booking.body': 'Тело',
    'booking.dims': 'Затемнува',
    'booking.select_vehicle_model': 'Изберете модел на возило',
    'booking.selected_type_value': 'Избрано: {{value}}',
    'booking.select_a_vehicle_type': 'Изберете тип на возило:',
    'booking.select_vehicle_weight': 'Изберете тежина на возилото',
    'booking.selected_weight_kg': 'Избрано: {{value}} kg',
    'booking.adjust_weight': 'Прилагодете ја тежината',
    'Dates updated successfully': 'Датумите се успешно ажурирани',
    'Error updating dates': 'Грешка при ажурирањето на датумите',
    'Set Planned Dates': 'Поставете ги планираните датуми',
    'Set your planned pickup and arrival dates below.':
      'Поставете ги планираните датуми за подигање и пристигнување подолу.',
    'Changing dates after initial setup will deduct 20% from your performance score for this order.':
      'Промената на датумите по првичното поставување ќе одземе 20% од вашиот резултат за изведба за оваа нарачка.',
    'Planned Pickup Date': 'Планиран датум на подигање',
    'Planned Arrival Date': 'Планиран датум на пристигнување',
    Listing: 'Список',
    'Try broadening the current search or status filter.':
      'Обидете се да го проширите тековниот филтер за пребарување или статус.',
    'Try broadening the search, role, or status filters.':
      'Обидете се да ги проширите филтрите за пребарување, улоги или статуси.',
    'Monitor fleet compliance, validation status, and expiring insurance in one place.':
      'Следете ја усогласеноста на возниот парк, статусот на валидација и осигурувањето што истекува на едно место.',
    'Active Listings': 'Активни огласи',
    'Open transport requests': 'Отворете барања за транспорт',
    'Quotes Today': 'Цитати денес',
    'Submitted in last 24h': 'Поднесено во последните 24 часа',
    'Platform Revenue (MTD)': 'Приходи од платформата (MTD)',
    'Month to date': 'Месец до денес',
    'Pending Partners': 'Партнери во очекување',
    'Awaiting approval': 'Се чека одобрување',
    'Unpaid Invoices': 'Неплатени фактури',
    'Requires action': 'Бара акција',
    'Completed Transports': 'Завршени транспорти',
    'All time delivered': 'Цело време испорачано',
    'Admin Dashboard': 'Административна табла',
    'Platform overview and key performance indicators.':
      'Преглед на платформата и клучни индикатори за перформанси.',
    'Loading dashboard metrics...':
      'Се вчитуваат метрика на контролната табла...',
    Invoices: 'Фактури',
    'Review payout invoices uploaded by partners and keep payout processing organized.':
      'Прегледајте ги фактурите за исплати поставени од партнерите и одржувајте организирана обработка на исплатите.',
    Flexible: 'Флексибилен',
    'Flexible dates': 'Флексибилни датуми',
    'Could not load this listing.': 'Не може да се вчита овој оглас.',
    'Listing canceled': 'Описот е откажан',
    'Failed to cancel listing': 'Не успеа да се откаже огласот',
    Reference: 'Референца',
    Category: 'Категорија',
    'Client type': 'Тип на клиент',
    'Company country': 'Земја на компанијата',
    Expires: 'Истекува',
    'Back to listings': 'Назад на огласите',
    'Listing not found.': 'Списокот не е пронајден.',
    'Cancel Listing': 'Откажи оглас',
    'Listing details': 'Детали за списокот',
    'Reference {{id}}': 'Референца {{id}}',
    'Read-only listing overview for admins.':
      'Преглед на списоци само за читање за администратори.',
    'Pick-up': 'Подигнување',
    'No exact coordinates are stored for this listing yet.':
      'Сè уште не се зачувани точни координати за овој оглас.',
    'Structured overview of quantities and handling details.':
      'Структуриран преглед на количини и детали за ракување.',
    'Shipment images': 'Слики од пратката',
    'No shipment images were uploaded for this listing.':
      'Не беа поставени слики од пратката за овој оглас.',
    'Proof of pickup': 'Доказ за пикап',
    'Final documents': 'Конечни документи',
    Description: 'Опис',
    'Quotes ({{count}})': 'Цитати ({{count}})',
    'Loading quotes...': 'Се вчитуваат цитати...',
    'No quotes for this listing.': 'Нема понуди за овој оглас.',
    'Score: {{score}}/100': 'Оценка: {{score}}/100',
    'Pickup: {{date}}': 'Пикап: {{date}}',
    'Delivery: {{date}}': 'Испорака: {{date}}',
    'Cancel Listing?': 'Да се откаже огласот?',
    'This will permanently cancel the listing and notify the client. Continue?':
      'Ова трајно ќе го откаже огласот и ќе го извести клиентот. Продолжи?',
    Keep: 'Задржи',
    'Review partner applications, check their documents, and keep approval decisions consistent.':
      'Прегледајте ги апликациите на партнерите, проверете ги нивните документи и одржувајте ги конзистентни одлуките за одобрување.',
    'No client payments recorded yet':
      'Сè уште не се регистрирани плаќања од клиентот',
    'Client payment rows will appear here when the payments backend is connected.':
      'Редовите за плаќање на клиентот ќе се појават овде кога ќе се поврзе заднината за плаќања.',
    Method: 'Метод',
    'No partner payouts recorded yet':
      'Сè уште не се регистрирани исплати на партнери',
    'Payout rows will appear here once partner payout processing is enabled.':
      'Редовите за исплата ќе се појават овде откако ќе се овозможи обработката на исплатите на партнерот.',
    'Payout Amount': 'Износ на исплата',
    'No platform fees recorded yet':
      'Сè уште не се регистрирани такси за платформата',
    'Fee rows will appear here once payment settlement data is available.':
      'Редовите за надоместоци ќе се појават овде откако ќе бидат достапни податоците за порамнувањето на плаќањата.',
    Gross: 'Бруто',
    'Fee (20%)': 'Надомест (20%)',
    Payments: 'Плаќања',
    'Client payments, partner payouts, and platform fee tracking.':
      'Плаќања на клиенти, исплати на партнери и следење на надоместоците на платформата.',
    'Client Payments': 'Плаќања на клиентите',
    'Partner Payouts': 'Партнерски исплати',
    'Platform Fees': 'Надоместоци за платформа',
    'Failed to load reviews': 'Не успеа да се вчитаат рецензии',
    'Review removed': 'Прегледот е отстранет',
    'Failed to remove review': 'Не успеа да се отстрани прегледот',
    Reviews: 'Осврти',
    'All partner and transport reviews submitted by clients.':
      'Сите критики за партнери и транспорт доставени од клиенти.',
    'Loading reviews...': 'Се вчитуваат рецензии...',
    'No reviews found': 'Не се најдени критики',
    'Client feedback will appear here when reviews are submitted.':
      'Повратните информации од клиентите ќе се појават овде кога ќе се достават рецензии.',
    Stars: 'Ѕвезди',
    Comment: 'Коментар',
    'Search, review, and maintain user accounts with one consistent admin workflow.':
      'Пребарувајте, прегледувајте и одржувајте кориснички сметки со еден конзистентен работен тек на администраторот.',
    'Track paid and unpaid partner payout invoices, and upload the next delivered listing invoice quickly.':
      'Следете ги платените и неплатените фактури за исплата на партнерите и брзо прикачете ја следната испорачана фактура за оглас.',
    'Search by invoice number, file name, or listing ID':
      'Пребарувајте по број на фактура, име на датотека или ID на оглас',
    'Loading delivered listings...': 'Се вчитуваат доставените огласи...',
    'Search delivered listing by reference, title, or route':
      'Пребарувајте го доставениот оглас по референца, наслов или рута',
    'Route details available in listing':
      'Деталите за маршрутата се достапни во огласот',
    'No matching delivered listings': 'Нема соодветни доставени огласи',
    'Selected listing': 'Избран оглас',
    'Has quotes': 'Има цитати',
    'In transit': 'Во транзит',
    Open: 'Отвори',
    Accepted: 'Прифатено',
    Completed: 'Завршено',
    'Client Dashboard': 'Контролна табла на клиентот',
    'Overview of your current transport listings, quote activity, and recent requests.':
      'Преглед на вашите тековни транспортни списоци, активност на цитати и неодамнешни барања.',
    'Total listings': 'Вкупно огласи',
    'Active listings': 'Активни огласи',
    'Listings with quotes': 'Огласи со цитати',
    'Accepted transport': 'Прифатен превоз',
    'Listing status timeline': 'Временска рамка за статусот на огласот',
    'Last 6 months of listings grouped by current status.':
      'Последните 6 месеци списоци групирани според моменталниот статус.',
    'No listing activity yet': 'Сè уште нема активност на оглас',
    'Create your first listing to start tracking request activity here.':
      'Направете го вашиот прв оглас за да започнете да ја следите активноста на барањата овде.',
    'Create new listing': 'Создадете нов оглас',
    'Create a new transport request for the marketplace.':
      'Направете ново барање за транспорт на пазарот.',
    'View my listings': 'Погледнете ги моите огласи',
    'Review quote activity and manage your transport requests.':
      'Прегледајте ја активноста на понуди и управувајте со вашите барања за транспорт.',
    'Recent listings': 'Неодамнешни огласи',
    'No listings yet': 'Сè уште нема огласи',
    'Your newest transport requests will appear here once you create them.':
      'Вашите најнови барања за транспорт ќе се појават овде откако ќе ги креирате.',
    'Unknown origin': 'Непознато потекло',
    '{{count}} quote(s)': 'Цитат(и) за {{count}}',
    '{{value}} completed listings': '{{value}} завршени огласи',
    'Monitor current performance, fleet readiness, quote flow, and your active transport queue.':
      'Следете ги тековните перформанси, подготвеноста на флотата, протокот на понуди и вашата активна линија за транспорт.',
    'Total assigned': 'Вкупно доделени',
    'Quarter rating': 'Оценка за четвртина',
    'Based on current quarter performance':
      'Врз основа на тековните квартални перформанси',
    Rating: 'Рејтинг',
    'Requirement met': 'Условот е исполнет',
    'Requirement not met': 'Условот не е исполнет',
    'Completed listings per period': 'Завршени огласи по период',
    'No completion data yet': 'Сè уште нема податоци за завршување',
    'Statistics will appear here after your first delivered work.':
      'Статистиката ќе се појави овде по вашата прва испорачана работа.',
    'Completed listings': 'Завршени огласи',
    'Review truck documents and refresh anything close to expiry.':
      'Прегледајте ги документите за камионите и освежете се што е блиску до истекување.',
    'Search deliveries': 'Пребарајте испораки',
    'Review available marketplace listings and submit quotes.':
      'Прегледајте ги достапните огласи на пазарот и испратете понуди.',
    'My quotes': 'Мои цитати',
    'Track accepted, pending, and rejected quotes in one place.':
      'Следете ги прифатените, нерешени и одбиените цитати на едно место.',
    'Profile settings': 'Поставки на профилот',
    'Keep company information and compliance details up to date.':
      'Ажурирајте ги информациите за компанијата и деталите за усогласеноста.',
    'No active queue items': 'Нема активни ставки во редот',
    'Accepted and in-progress work will appear here as your transport activity grows.':
      'Прифатената и тековната работа ќе се појави овде како што расте вашата транспортна активност.',
    'Your role does not have permission to open this page.':
      'Вашата улога нема дозвола да ја отвори оваа страница.',
    'Go to dashboard': 'Одете на контролната табла',
    'Trailer capacity is required.': 'Потребен е капацитет на приколката.',
    'How many cars can this trailer carry?':
      'Колку автомобили може да носи оваа приколка?',
    'Set maximum number of cars this trailer can carry (1-20).':
      'Поставете го максималниот број на автомобили што може да ги носи оваа приколка (1-20).',
    'Invalid max load (kg).': 'Неважечко максимално оптоварување (кг).',
    'Enter a valid weight between 1 and 100000 kg, or leave it empty.':
      'Внесете валидна тежина помеѓу 1 и 100000 kg или оставете ја празна.',
    'Maximum payload weight this truck can carry (optional).':
      'Максимална тежина на носивост што може да ја носи овој камион (опционално).',
    'Manage the company and contact details that appear across your listings, invoices, and account verification flows.':
      'Управувајте со компанијата и деталите за контакт што се појавуваат низ вашите огласи, фактури и текови за потврда на сметката.',
    'Keep these details up to date so listings, invoices, and partner verification stay accurate.':
      'Одржувајте ги овие детали ажурирани за да останат точни списоците, фактурите и потврдата на партнерот.',
    'Unsaved changes': 'Незачувани промени',
    'All changes saved': 'Сите промени се зачувани',
    'auth.sign_up_failed': 'Пријавувањето не успеа',
    'auth.please_select_a_valid_role': 'Изберете валидна улога.',
    'booking.pickup_not_found': 'Не е пронајден пикап.',
    'booking.delivery_not_found': 'Испораката не е пронајдена.',
    'booking.capacity': 'Капацитет',
    'booking.cmr_expiry': 'Истекување на CMR',
    'booking.uploaded': 'Прикачено',
    'booking.missing': 'Недостасува',
    'booking.cmr_document': 'CMR документ',
    'booking.go_to_profile': 'Одете во Профил',
    'booking.click_to_download_purchase_terms':
      'Кликнете за да ги преземете Условите за купување',
    'admin.purchase_terms_management': 'Управување со условите за купување',
    'admin.purchase_terms_management_subtitle':
      'Поставете и одржувајте локализирани PDF-датотеки за Услови за купување што се користат за прифаќање на нарачки од партнер.',
    'admin.document_language': 'Јазик на документот',
    'admin.click_to_download_purchase_terms':
      'Кликнете за да ги преземете Условите за купување',
    'admin.current_language_label': 'Тековен јазик: {{language}}',
    'admin.purchase_terms_unavailable_for_selected_language':
      'Документот за условите за купување е недостапен за избраниот јазик.',
    'Download and review the active purchase terms in your current interface language before continuing.':
      'Преземете ги и прегледајте ги активните услови за купување на вашиот тековен јазик на интерфејсот пред да продолжите.',
    'We make agreements and conclude a contract for the carriage of goods. I have just read this agreement in full and agree to its contents.':
      'Склучуваме договори и склучуваме договор за превоз на стоки. Штотуку го прочитав овој договор во целост и се согласувам со неговата содржина.',
    'I confirm that I will schedule this order within 24 hours':
      'Потврдувам дека ќе ја закажам оваа нарачка во рок од 24 часа',
    'Failed to load purchase terms document.':
      'Не успеа да се вчита документот за условите за купување.',
    'Partner rating': 'Оценка на партнерот',
    'Bronze requirements': 'Барања за бронза',
    'Orders in quarter': 'Нарачки во четвртина',
    'Cancellation rate / 100 orders': 'Стапка на откажување / 100 нарачки',
    'Damage claims / 100 orders': 'Побарувања за штети / 100 нарачки',
    '{{current}} / min {{target}}': '{{current}} / мин. {{target}}',
    '{{current}} / max {{target}}': '{{current}} / максимум {{target}}',
    Met: 'Мет',
    'Not met': 'Не е исполнето',
    Unranked: 'Нерангирани',
    'profile.incompleteDescriptionPartner':
      'Пополнете ги информациите за вашиот профил (компанија, телефон, адреса, град, поштенски број, ДДВ број) за да пристапите до сите функции.',
    'profile.incompleteDescriptionClient':
      'Пополнете ги информациите за вашиот профил (Телефонски број) за да пристапите до сите функции.',
    'auth.verification_email_sent': 'Испратена е-порака за потврда',
    '{{amount}} above the client target': '{{amount}} над целта на клиентот',
    '{{amount}} below the client target': '{{amount}} под целта на клиентот',
    '{{count}} image(s) added to the listing.':
      '{{count}} слика(и) додадени на огласот.',
    '{{count}} quote(s) received': '{{count}} понуда(и).',
    '{{count}} reviews': '{{count}} прегледи',
    '{{count}} total': '{{count}} вкупно',
    '{{count}} visible': '{{count}} видливи',
    '{{weight}} kg': '{{weight}} kg',
    'A Google route preview with pins A and B appears here once pickup and delivery coordinates are available.':
      'Овде се појавува преглед на маршрутата на Google со пиновите А и Б откако ќе бидат достапни координатите за подигање и испорака.',
    'A route preview appears once map coordinates are available.':
      'Се појавува преглед на маршрутата штом се достапни координатите на картата.',
    'A timeline of clarifications connected to this listing.':
      'Временска рамка на појаснувања поврзани со оваа листа.',
    "Accept {{partner}}'s quote for {{amount}}?":
      'Да се ​​прифати понудата на {{partner}} за {{amount}}?',
    'Accept Listing': 'Прифатете го огласот',
    'Accept quote': 'Прифатете ја понудата',
    'Accepted quote': 'Прифатен цитат',
    'Accepted quote required': 'Потребна е прифатена понуда',
    'Accepting...': 'Прифаќање...',
    Active: 'Активен',
    'Active statuses': 'Активни статуси',
    'Add another item': 'Додадете друга ставка',
    'Add images': 'Додадете слики',
    'Add more shipment images': 'Додадете повеќе слики од пратката',
    'After you confirm an AI action, open the prepared destination immediately instead of waiting for a manual click.':
      'Откако ќе потврдите дејство со вештачка интелигенција, веднаш отворете ја подготвената дестинација наместо да чекате рачно кликнување.',
    'AI Assistant': 'Асистент со вештачка интелигенција',
    'AI assistant disabled for all users.':
      'Асистентот за вештачка интелигенција е оневозможен за сите корисници.',
    'AI assistant enabled for all users.':
      'Асистентот за вештачка интелигенција е овозможен за сите корисници.',
    'AI assistant preferences updated':
      'Поставките за помошникот за вештачка интелигенција се ажурирани',
    'AI disabled for user.': 'ВИ е оневозможена за корисникот.',
    'AI enabled for user.': 'ВИ е овозможена за корисникот.',
    'AI-powered message translation between languages':
      'Превод на пораки со вештачка интелигенција помеѓу јазиците',
    'All route-critical information in one place before you review quotes or documents.':
      'Сите информации кои се важни за маршрутата на едно место пред да прегледате цитати или документи.',
    View: 'Преглед',
    Answer: 'Одговор',
    Archive: 'Архива',
    'Archived statuses': 'Архивирани статуси',
    'Are you sure you want to reject the quote from':
      'Дали сте сигурни дека сакате да го одбиете цитатот од',
    'Ask a question about this listing...':
      'Поставете прашање за оваа листа...',
    'Ask for matching lanes, quote help, or the next operational step.':
      'Побарајте соодветни ленти, цитирајте помош или следниот оперативен чекор.',
    'Ask for quote comparisons or a prepared next step from this shipment screen.':
      'Побарајте споредба на понуди или подготвен следен чекор од овој екран за пратка.',
    'Assistant history cleared': 'Историјата на „Помошникот“ е исчистена',
    'Automatically translate messages from other users into your preferred language using AI.':
      'Автоматски преведувајте пораки од други корисници на вашиот претпочитан јазик користејќи вештачка интелигенција.',
    'Back to listing': 'Назад на огласот',
    'Best offer': 'Најдобра понуда',
    'Best quote': 'Најдобар цитат',
    'Body type: {{type}}': 'Тип на тело: {{type}}',
    'Breed: {{breed}}': 'Раса: {{breed}}',
    Budget: 'Буџет',
    'Cancel listing': 'Откажете го огласот',
    'Canceled and completed work will appear here once listings move out of the active view.':
      'Откажаната и завршената работа ќе се појави овде штом огласите ќе излезат од активниот приказ.',
    'Cargo Details': 'Детали за карго',
    Categories: 'Категории',
    'Choose the interface language. This preference is saved locally and applies immediately.':
      'Изберете го јазикот на интерфејсот. Оваа поставка е зачувана локално и се применува веднаш.',
    'Clear all': 'Исчистете ги сите',
    'Clear assistant history': 'Исчистете ја историјата на асистентот',
    'Client price in EUR': 'Клиентска цена во евра',
    'Client target price': 'Целна цена на клиентот',
    'Complete the payment below to lock the fixed-price acceptance and let the partner start planning.':
      'Завршете го плаќањето подолу за да го заклучите прифаќањето со фиксна цена и да му дозволите на партнерот да почне да планира.',
    'Complete the payment below to lock the selected quote and let the partner start planning.':
      'Завршете ја уплатата подолу за да ја заклучите избраната понуда и да му дозволите на партнерот да почне да планира.',
    'Compose area prepared for listing Q&A. Submission remains disabled until the live question endpoint is connected on this page.':
      'Составете област подготвена за огласување прашања и одговори. Поднесувањето останува оневозможено додека крајната точка на прашањата во живо не се поврзе на оваа страница.',
    'Confirm delivery complete': 'Потврдете дека испораката е завршена',
    'Confirm payment received': 'Потврдете ја примената уплата',
    'Confirm that you have received the bank transfer or payment for this listing. This will move the listing to Paid status and allow the partner to mark it as planned.':
      'Потврдете дека сте примиле банкарски трансфер или плаќање за овој оглас. Ова ќе го премести огласот во статус Платен и ќе му овозможи на партнерот да го означи како што е планирано.',
    'Confirm the exact fleet and dates before the listing moves to Planned.':
      'Потврдете ја точната флота и датумите пред огласот да се пресели во Планирано.',
    'Confirm Transport Plan': 'Потврдете го транспортниот план',
    'Confirming...': 'Се потврдува...',
    'Control how the web assistant behaves on this device. These settings do not change your account data.':
      'Контролирајте како се однесува веб-помошникот на овој уред. Овие поставки не ги менуваат податоците на вашата сметка.',
    'Create listing': 'Создадете оглас',
    'Create with AI': 'Креирајте со вештачка интелигенција',
    'Create your next transport request and it will appear here with route, item, and quote activity.':
      'Направете го вашето следно барање за транспорт и тоа ќе се појави овде со активност на маршрута, ставка и понуда.',
    'Current stage:': 'Тековна фаза:',
    'Current status': 'Тековен статус',
    'Delivery confirmation needed': 'Потребна е потврда за испорака',
    'Delivery radius': 'Радиус на испорака',
    'Delivery:': 'Испорака:',
    'Describe the route and cargo, then review the prepared listing draft before publishing.':
      'Опишете ја маршрутата и товарот, а потоа прегледајте го подготвениот нацрт на огласот пред да го објавите.',
    'Describe the shipment you need and review the prepared request before publishing.':
      'Опишете ја пратката што ви треба и прегледајте го подготвеното барање пред да го објавите.',
    'Download and review the purchase terms before confirming the transport plan.':
      'Преземете ги и прегледајте ги условите за купување пред да го потврдите транспортниот план.',
    'Download invoice': 'Преземете фактура',
    'Download Purchase Terms': 'Преземете Услови за купување',
    'Draft with AI': 'Нацрт со вештачка интелигенција',
    'Draft your review first, then submit it here when you are satisfied.':
      'Прво изгответе ја вашата рецензија, а потоа поднесете ја овде кога ќе бидете задоволни.',
    'Edit listing': 'Уредете го огласот',
    'Edit Quote': 'Уреди Цитат',
    Enable: 'Овозможи',
    'Enable live translation': 'Овозможете превод во живо',
    'Enabled Users': 'Овозможени корисници',
    'Engagement Activity': 'Активност за ангажман',
    'Expires:': 'Истекува:',
    'Failed to accept listing': 'Не успеа да се прифати огласот',
    'Failed to accept quote': 'Не успеа да се прифати понудата',
    'Failed to clear assistant history':
      'Не успеа да се исчисти историјата на помошникот',
    'Failed to complete listing': 'Не успеа да се комплетира огласот',
    'Failed to confirm payment': 'Не успеа да се потврди плаќањето',
    'Failed to confirm transport plan':
      'Не успеа да се потврди транспортниот план',
    'Failed to disable AI for user.':
      'Не успеа да се оневозможи вештачката интелигенција за корисникот.',
    'Failed to enable AI for user.':
      'Не успеа да се овозможи вештачка интелигенција за корисникот.',
    'Failed to load listing.': 'Не успеа да се вчита огласот.',
    'Failed to load listings': 'Не успеа да се вчитаат огласите',
    'Failed to load listings. Please try again.':
      'Не успеа да се вчитаат огласите. Ве молиме обидете се повторно.',
    'Failed to load review context.':
      'Не успеа да се вчита контекстот за преглед.',
    'Failed to load settings.': 'Не успеа да се вчитаат поставките.',
    'Failed to refresh Stripe payment status':
      'Не успеа да се освежи статусот на плаќање Stripe',
    'Failed to reject quote': 'Не успеа да се одбие понудата',
    'Failed to release listing': 'Не успеа да се објави огласот',
    'Failed to save quote': 'Не успеа да се зачува понудата',
    'Failed to update listing': 'Не успеа да се ажурира огласот',
    'Failed to update preferred language':
      'Не успеа да се ажурира претпочитаниот јазик',
    'Failed to update setting.': 'Не успеа да се ажурира поставката.',
    'Failed to update status': 'Не успеа да се ажурира статусот',
    'Failed to update translation preference':
      'Не успеа да се ажурира поставката за превод',
    'Failed to update watchlist': 'Не успеа да се ажурира списокот за следење',
    'Failed to withdraw quote': 'Не успеа да се повлече понудата',
    'Feature Flags': 'Знамиња со карактеристики',
    'Filter invoice uploads, search by reference, and page through payout records.':
      'Филтрирајте ги прикачувањата на фактурите, пребарувајте по референца и страница преку евиденција за исплата.',
    Filters: 'Филтри',
    'Final delivery documents': 'Конечни документи за испорака',
    'Fixed price only': 'Само фиксна цена',
    'Flexible / not set': 'Флексибилен / не е поставен',
    'Generated automatically when the transport plan is confirmed.':
      'Се генерира автоматски кога ќе се потврди транспортниот план.',
    'Generation: {{generation}}': 'Генерација: {{generation}}',
    'Goods delivered — awaiting client confirmation.':
      'Испорачана стока - се чека потврда од клиентот.',
    'Gross price': 'Бруто цена',
    'I have read and agree to the purchase terms for this transport job.':
      'Ги прочитав и се согласувам со условите за купување за оваа транспортна работа.',
    'I understand that accepting this listing assigns it to me at the fixed client price shown above.':
      'Разбирам дека прифаќањето на овој оглас ми го доделува по фиксната клиентска цена прикажана погоре.',
    'Image upload failed': 'Поставувањето на сликата не успеа',
    'Images uploaded': 'Поставени слики',
    'Interface language': 'Јазик на интерфејс',
    'Invoice documents': 'Фактурни документи',
    'Item {{number}}': 'Ставка {{number}}',
    items: 'предмети',
    'Keep listing': 'Продолжете да наведувате',
    'Keep quote': 'Чувајте го цитатот',
    'Keep the current AI session available after closing the browser on this device.':
      'Чувајте ја тековната сесија за вештачка интелигенција достапна откако ќе го затворите прелистувачот на овој уред.',
    'Language & Region': 'Јазик и регион',
    'Lift: {{origin}} / {{destination}}': 'Лифт: {{origin}} / {{destination}}',
    Listed: 'Наведени',
    'Listing {{id}}': 'Оглас {{id}}',
    'Listing accepted': 'Огласот е прифатен',
    'Listing expired': 'Списокот е истечен',
    'Listing images': 'Сликите на список',
    'Listing is live': 'Списокот е во живо',
    'Listing reference': 'Референца за огласување',
    'Listing snapshot': 'Снимка од огласот',
    'Listing unavailable': 'Списокот е недостапен',
    'Listing updated': 'Списокот е ажуриран',
    'Live Translation': 'Превод во живо',
    'Live translation disabled.': 'Преводот во живо е оневозможен.',
    'Live translation enabled.': 'Преводот во живо е овозможен.',
    'Loading approved trucks...': 'Се вчитуваат одобрени камиони...',
    'Loading fleet...': 'Се вчитува флотата...',
    'Loading listing details...': 'Се вчитуваат детали за огласот...',
    'Loading listings...': 'Вчитување огласи...',
    'Loading review details...': 'Се вчитуваат детали за преглед...',
    'Loading settings...': 'Се вчитуваат поставките...',
    'Manage AI Assistant Users':
      'Управувајте со корисниците на помошникот со вештачка интелигенција',
    'Manage platform-wide feature flags and configuration.':
      'Управувајте со знаменцата и конфигурацијата на функциите на целата платформа.',
    'Manage Users': 'Управувајте со корисници',
    'Manage your transport requests, monitor quote activity, and keep active and archived work easy to scan.':
      'Управувајте со вашите барања за транспорт, следете ја активноста на понудите и одржувајте активна и архивирана работа лесна за скенирање.',
    'Mark Picked Up': 'Означи подигнат',
    'Matches the client target price': 'Одговара на целната цена на клиентот',
    Media: 'Медиуми',
    Messages: 'Пораки',
    'Messages will be translated into this language.':
      'Пораките ќе бидат преведени на овој јазик.',
    'Minimum net:': 'Минимална мрежа:',
    'My invoices': 'Моите фактури',
    Net: 'Нето',
    'Net price': 'Нето цена',
    'Net quote': 'Нето понуда',
    'New images appear immediately in the listing details for client, partner, and admin views.':
      'Новите слики се појавуваат веднаш во деталите за списокот за прегледи на клиент, партнер и администратор.',
    'Next step': 'Следен чекор',
    'No active listings yet': 'Сè уште нема активни огласи',
    'No address provided': 'Не е наведена адреса',
    'No answer yet.': 'Сеуште нема одговор.',
    'No archived listings yet': 'Сè уште нема архивирани огласи',
    'No description added.': 'Не е додаден опис.',
    'no destination': 'нема дестинација',
    'No expiry': 'Нема истекување',
    'No listings match the current filters. Try broadening the search or date range.':
      'Ниту еден оглас не одговара на тековните филтри. Обидете се да го проширите опсегот на пребарување или датуми.',
    'no origin': 'нема потекло',
    'No questions yet': 'Сè уште нема прашања',
    'No quotes yet': 'Сè уште нема цитати',
    'No shipment images uploaded yet.':
      'Сè уште нема поставени слики од пратката.',
    'No trailer selected': 'Не е избрана трејлер',
    'No unread messages': 'Нема непрочитани пораки',
    'No users found.': 'Не се пронајдени корисници.',
    'No users have AI enabled.':
      'Ниеден корисник нема овозможена вештачка интелигенција.',
    'Not selected': 'Не е избрано',
    'Offers summary': 'Резиме на понуди',
    'Open AI assistant': 'Отворете го помошникот за вештачка интелигенција',
    'Open prepared screens automatically':
      'Отворете ги подготвените екрани автоматски',
    'Optional visible price shown to partners as your target budget.':
      'Изборна видлива цена прикажана на партнерите како целен буџет.',
    'Other quotes will be declined automatically once this offer is accepted.':
      'Другите понуди ќе бидат одбиени автоматски откако оваа понуда ќе биде прифатена.',
    'Partner delivery': 'Партнерска испорака',
    'Partner pickup': 'Партнерски пикап',
    'Partner quote': 'Цитат за партнери',
    'Payment confirmed': 'Плаќањето е потврдено',
    'Payment confirmed — listing status set to paid':
      'Плаќањето е потврдено — статусот на листата е поставен на платено',
    'Payment confirmed. Confirm the assigned fleet and planned dates before the listing moves to Planned.':
      'Плаќањето е потврдено. Потврдете ја доделената флота и планираните датуми пред огласот да се пресели во Планирано.',
    'Payment is confirmed. The partner now needs to confirm the truck, driver, and planned dates.':
      'Плаќањето е потврдено. Партнерот сега треба да ги потврди камионот, возачот и планираните датуми.',
    'Payment required': 'Потребно е плаќање',
    'Photos uploaded for the shipment and visible across client, partner, and admin views.':
      'Фотографиите се поставени за пратката и видливи преку прегледите на клиентот, партнерот и администраторот.',
    'Pickup is complete and the transport is currently underway.':
      'Подигнувањето е завршено, а транспортот е во тек.',
    'Pickup proof': 'Доказ за пикап',
    'Pickup proof and final delivery files uploaded by the transport partner.':
      'Доказ за подигање и датотеки за финална испорака поставени од транспортниот партнер.',
    'Pickup to delivery overview': 'Преглед на подигање до испорака',
    'Pickup:': 'Подигнување:',
    'Plan and authorization': 'План и овластување',
    'Plan transport': 'Планирајте транспорт',
    'Plan Transport': 'План за транспорт',
    'Planned dates:': 'Планирани датуми:',
    'Planned delivery date': 'Планиран датум на испорака',
    'Platform Settings': 'Поставки на платформата',
    'Preferred language': 'Префериран јазик',
    'Preferred language updated': 'Претпочитаниот јазик е ажуриран',
    'Prepare a quote or ask for the next lane action, then confirm before anything is submitted.':
      'Подгответе понуда или побарајте следно дејство на лента, а потоа потврдете пред било што да се испрати.',
    'Purchase Terms': 'Услови за купување',
    'Quantities, dimensions, and handling details ready for transport review.':
      'Количините, димензиите и деталите за ракување подготвени за преглед на транспортот.',
    Question: 'Прашање',
    Questions: 'Прашања',
    'Questions & answers': 'Прашања и одговори',
    'Questions and answers for this listing will appear here once the messaging flow is active.':
      'Прашањата и одговорите за овој оглас ќе се појават овде штом протокот на пораки ќе биде активен.',
    'Quick access to the current shipment, quote, and billing state.':
      'Брз пристап до моменталната пратка, понуда и состојба на наплата.',
    'Quote accepted': 'Цитат е прифатен',
    'Quote count': 'Број на цитати',
    'Quote message': 'Порака за цитат',
    'Quote rejected': 'Цитат е одбиен',
    'Quote withdrawn': 'Цитат е повлечен',
    Quotes: 'Цитати',
    'Quotes and questions': 'Цитати и прашања',
    'Quotes are disabled for this listing. The first partner to accept the fixed price will be assigned automatically.':
      'Цитатите се оневозможени за овој оглас. Првиот партнер што ќе ја прифати фиксната цена ќе биде назначен автоматски.',
    'Quotes are disabled for this shipment. If you accept it, the client price becomes an accepted booking immediately.':
      'Цитатите се оневозможени за оваа пратка. Ако го прифатите, цената на клиентот станува прифатена резервација веднаш.',
    'Quotes from transport providers usually begin to appear shortly after publishing. Refresh to check again.':
      'Цитатите од давателите на транспорт обично почнуваат да се појавуваат набргу по објавувањето. Освежете за повторно да проверите.',
    'Reference #{{id}}': 'Референца #{{id}}',
    'Refresh listings': 'Освежете ги огласите',
    'Reject quote': 'Одбијте го цитатот',
    'Rejecting...': 'Отфрлање...',
    Release: 'Ослободување',
    'Release Listing': 'Објавување на оглас',
    'Remember assistant conversation': 'Запомнете го разговорот со помошникот',
    'Required for fixed-price listings. Partners accept this amount directly.':
      'Потребно за огласи со фиксна цена. Партнерите директно ја прифаќаат оваа сума.',
    'Required. Partners will be able to accept this listing at the fixed client price without sending a quote.':
      'Задолжително. Партнерите ќе можат да го прифатат овој оглас по фиксна клиентска цена без да испратат понуда.',
    'Review submission failed.': 'Поднесувањето на прегледот не успеа.',
    'Review the completed transport using the standard product flow.':
      'Прегледајте го завршениот транспорт користејќи го стандардниот проток на производи.',
    'Route pending': 'Маршрутата е на чекање',
    'Save changes': 'Зачувајте ги промените',
    'Saving...': 'Се зачувува...',
    'Search by title, route, category, or item':
      'Пребарувајте по наслов, рута, категорија или ставка',
    'Search Results': 'Резултати од пребарувањето',
    'Search users by email...': 'Пребарувајте корисници по е-пошта...',
    'Select a truck, driver, pickup date, and delivery date.':
      'Изберете камион, возач, датум на подигање и датум на испорака.',
    'Select approved truck': 'Изберете одобрен камион',
    'Select driver': 'Изберете возач',
    'Send Revision': 'Испрати ревизија',
    Sentiment: 'Сентимент',
    'Share what went well and what could improve':
      'Споделете што помина добро и што може да се подобри',
    'Shipment in transit': 'Пратка во транзит',
    'Shipment notes': 'Белешки за испорака',
    'Shipment tracking will be shared':
      'Следењето на пратката ќе биде споделено',
    'Show AI launchers': 'Прикажи фрлачи со вештачка интелигенција',
    'Show or hide AI assistant buttons on supported dashboard and listing pages.':
      'Прикажи или скриј ги копчињата за помошник со вештачка интелигенција на поддржаната контролна табла и страници со списоци.',
    'Special needs or notes': 'Посебни потреби или белешки',
    'Specify delivery dates': 'Наведете датуми на испорака',
    'Specify pickup dates': 'Наведете датуми за подигање',
    Stage: 'Фаза',
    'Status updated to {{status}}': 'Статусот е ажуриран на {{status}}',
    'Stripe payment confirmed and booking updated':
      'Плаќањето со ленти е потврдено и резервацијата е ажурирана',
    'Stripe status: {{status}}': 'Статус на лента: {{status}}',
    'Submit question': 'Поднесете прашање',
    'Submit review': 'Поднесете преглед',
    'Submitting...': 'Се поднесува...',
    'The AI assistant is currently disabled for this environment. Existing local session data can still be cleared here.':
      'Асистентот за вештачка интелигенција во моментов е оневозможен за оваа средина. Тука сè уште може да се исчистат постоечките податоци за локална сесија.',
    'The listing expired before a transport was confirmed.':
      'Огласот истече пред да се потврди транспортот.',
    'The listing has been fully completed and archived as a finished transport.':
      'Списокот е целосно комплетиран и архивиран како готов транспорт.',
    'The lowest net price you would still accept for this shipment.':
      'Најниската нето цена што сепак би ја прифатиле за оваа пратка.',
    'The partner has confirmed the route plan. Pickup and delivery dates are now scheduled.':
      'Партнерот го потврди планот на рутата. Сега се закажани датумите за подигање и испорака.',
    'The partner marked the shipment as delivered. Review the final documents and confirm completion.':
      'Партнерот ја означил пратката како испорачана. Прегледајте ги финалните документи и потврдете го комплетирањето.',
    'The partner-confirmed plan and LOA stay grouped together for faster review.':
      'Планот потврден од партнерот и LOA остануваат групирани за побрз преглед.',
    'This action notifies the transport provider and removes the quote from active consideration.':
      'Оваа акција го известува давателот на транспорт и ја отстранува понудата од активно разгледување.',
    'This listing is archived and no further transport actions are available.':
      'Овој список е архивиран и не се достапни дополнителни транспортни активности.',
    'This listing needs an accepted quote before a review can be created.':
      'На оваа листа му треба прифатена понуда пред да може да се креира преглед.',
    'This will soft-cancel the listing and move it to your archive.':
      'Ова меко ќе го откаже огласот и ќе го премести во вашата архива.',
    'This will soft-cancel the listing for the client and remove it from active marketplace views.':
      'Ова меко ќе го откаже огласот за клиентот и ќе го отстрани од активните прегледи на пазарот.',
    'Total quote': 'Вкупен цитат',
    'Tracking not promised': 'Следењето не е ветено',
    'Tracking shared': 'Следењето е споделено',
    'Tracking visibility': 'Видливост за следење',
    'Trailer (Optional)': 'Трејлер (опционално)',
    'Translation preference updated': 'Поставките за превод се ажурирани',
    'Transport completed': 'Транспортот е завршен',
    'Transport completed.': 'Транспортот е завршен.',
    'Transport documents': 'Транспортни документи',
    'Transport marked as complete': 'Транспортот е означен како завршен',
    'Transport package': 'Транспортен пакет',
    'Transport plan confirmed': 'Планот за транспорт е потврден',
    'Transport plan updated': 'Планот за транспорт е ажуриран',
    'Transport planned': 'Планиран транспорт',
    'Transport Provider': 'Транспортен провајдер',
    'Transport providers can review your shipment and send offers.':
      'Давателите на транспорт може да ја прегледаат вашата пратка и да испраќаат понуди.',
    'Transport stage': 'Фаза на транспорт',
    Truck: 'Камион',
    'Truck, driver, trailer, and planned dates for this shipment.':
      'Камион, возач, приколка и планирани датуми за оваа пратка.',
    'Try widening the current listing filters.':
      'Обидете се да ги проширите тековните филтри за огласи.',
    'Unable to upload listing images.':
      'Не може да се прикачат слики од списокот.',
    'Unknown error': 'Непозната грешка',
    'Untitled listing': 'Оглас без наслов',
    'Untitled Listing': 'Оглас без наслов',
    'Update media': 'Ажурирајте ги медиумите',
    'Update transport plan': 'Ажурирајте го транспортниот план',
    'Update Transport Plan': 'Ажурирајте го транспортниот план',
    'Upload a CMR or delivery photos before marking delivered.':
      'Поставете CMR или фотографии за испорака пред да ја означите доставата.',
    'Upload a CMR or delivery photos before the listing can move to Delivered.':
      'Поставете CMR или фотографии за испорака пред огласот да се премести во Доставен.',
    'Upload at least one pickup proof before the listing can move to Picked Up.':
      'Поставете барем еден доказ за подигнување пред огласот да може да се премести во Подигнат.',
    'Upload final documents': 'Поставете финални документи',
    'Upload proof of pickup': 'Поставете доказ за подигање',
    'Uploading...': 'Се прикачува...',
    'Use fresh photos when the shipment changes or you want to clarify the item condition.':
      'Користете свежи фотографии кога пратката се менува или сакате да ја разјасните состојбата на предметот.',
    'users enabled': 'корисниците се овозможени',
    'Visible to you while quoting. You can still send your own net offer below or above this amount.':
      'Видливо за вас додека цитирате. Сè уште можете да испратите своја сопствена нето понуда под или над оваа сума.',
    'Waiting for partner acceptance': 'Се чека прифаќање на партнерот',
    'Waiting for transport planning': 'Се чека планирање на транспортот',
    'When enabled, messages from other users will be automatically translated to your preferred language.':
      'Кога е овозможено, пораките од други корисници автоматски ќе бидат преведени на вашиот претпочитан јазик.',
    Withdraw: 'Повлечете',
    'Write Review': 'Напишете преглед',
    'You are about to release this listing back to the marketplace.':
      'Ќе го објавите овој оглас назад на пазарот.',
    'You are now the assigned partner for this fixed-price listing.':
      'Сега сте доделен партнер за овој оглас со фиксна цена.',
    'Your quote has been accepted. Awaiting payment confirmation from the admin before you can begin the job.':
      'Вашата понуда е прифатена. Се чека потврда за плаќање од администраторот пред да можете да ја започнете работата.',
    'VIN: {{vin}}': 'VIN: {{vin}}',
  },
  hu: {
    to: 'hogy',
    kg: 'kg',
    Hatchback: 'Ferdehátú',
    Crossover: 'Crossover',
    Required: 'Kötelező',
    'Change language': 'Nyelv módosítása',
    'Loading...': 'Betöltés…',
    'Error:': 'Hiba:',
    Close: 'Bezárás',
    Yes: 'Igen',
    No: 'Nem',
    'Keep order': 'Tartsa rendet',
    Price: 'Ár',
    'Purchase terms': 'Vásárlási feltételek',
    'Power of attorney': 'Meghatalmazás',
    'Transport details': 'Szállítási adatok',
    'Upload damages': 'Feltöltési károk',
    'Download (PDF)': 'Letöltés (PDF)',
    'Mark as picked up': 'Megjelölés felvettként',
    'Mark as delivered': 'Megjelölés kézbesítettként',
    'Cancel booking': 'Foglalás lemondása',
    'Order marked as picked up': 'A rendelés átvételként megjelölve',
    'Order marked as delivered': 'A megrendelés kézbesítettnek jelölve',
    'Order canceled': 'Megrendelés törölve',
    'Failed to cancel order': 'Nem sikerült törölni a rendelést',
    'Added {{count}} file(s)': '{{count}} fájl(ok) hozzáadva',
    Pages: 'Oldalak',
    'Awaiting Verification': 'Ellenőrzésre vár',
    'Profile Incomplete': 'A profil hiányos',
    'Please complete your profile information (Company, Phone, Address, City, Post Code) to access all features.':
      'Kérjük, töltse ki profiladatait (Cég, Telefon, Cím, Város, Irányítószám) az összes funkció eléréséhez.',
    'Go to Profile': 'Lépjen a Profilra',
    'Forgot Password': 'Elfelejtett jelszó',
    Hello: 'Hello',
    friend: 'barátja',
    'Book your transport': 'Foglalja le szállítását',
    'fast and easy': 'gyors és egyszerű',
    'Keep an eye on the route and quote at a glance.':
      'Tartsa szemmel az útvonalat, és egy pillantással idézzen.',
    Origin: 'Eredet',
    Destination: 'Úticél',
    'Postal code': 'Irányítószám',
    'Calculate to preview': 'Számítsa ki az előnézethez',
    "Can't be calculated yet": 'Még nem lehet kiszámítani',
    'Awaiting payment badge': 'Fizetésre vár',
    'Ref {{id}}': 'Ref. {{id}}',
    'Change planning': 'Változás tervezés',
    'Change driver': 'Cseréljen illesztőprogramot',
    'No vehicles listed': 'Nincsenek listán szereplő járművek',
    Bank: 'Bank',
    'Order not found.': 'A rendelés nem található.',
    'Not available': 'Nem elérhető',
    'For {{date}}': '{{date}}-hez',
    'Picked on {{date}}': 'A {{date}}-re választották',
    'Delivered on {{date}}': '{{date}}-en szállítjuk',
    'Loading notification: {{value}}': 'Betöltési értesítés: {{value}}',
    'CO₂ compensation: {{value}}': 'CO₂ kompenzáció: {{value}}',
    'Bio fuel: {{value}}': 'Bio üzemanyag: {{value}}',
    Remove: 'Távolítsa el',
    'Copy {{label}}': 'Másolja a {{label}}-et',
    'Open navigation menu': 'Nyissa meg a navigációs menüt',
    'Open menu': 'Menü megnyitása',
    'Error fetching data': 'Hiba az adatok lekérésekor',
    'Not set': 'Nincs beállítva',
    'No opening hours provided': 'Nyitvatartási idő nincs megadva',
    'Please select a planned date': 'Kérjük, válasszon egy tervezett dátumot',
    Email: 'E-mail',
    'Saved favorite route filter': 'Mentett kedvenc útvonalszűrő',
    km: 'km',
    mi: 'mi',
    'Radius search': 'Sugárkeresés',
    'City or town': 'Város vagy település',
    'Country (optional)': 'Ország (nem kötelező)',
    Radius: 'Sugár',
    'Searching…': 'Keresés…',
    'City not found': 'A város nem található',
    'Within {{radius}} {{unit}} of {{place}}':
      'A {{place}} {{radius}} {{unit}}-en belül',
    'Clear radius': 'Tiszta sugár',
    'auth.account_status_pending_review': 'Fiók állapota: Ellenőrzésre vár',
    'auth.your_account_is_pending_approval': 'Fiókja jóváhagyásra vár',
    'auth.upload_your_verification_documents_below_and_we_ll_notify_you_by_email_once_your_account_is_approved':
      'Töltse fel alább az igazoló dokumentumokat, és e-mailben értesítjük fiókja jóváhagyásáról.',
    'auth.check_status': 'Állapot ellenőrzése',
    'auth.upload_verification_documents':
      'Töltsön fel ellenőrző dokumentumokat',
    'auth.your_uploaded_documents': 'A feltöltött dokumentumaid',
    'auth.back_to_sign_in': 'Vissza a bejelentkezéshez',
    role_partner: 'Partner',
    partner: 'Partner',
    admin: 'Admin',
    Andorra: 'Andorra',
    Belgium: 'Belgium',
    Liechtenstein: 'Liechtenstein',
    Moldova: 'Moldova',
    Monaco: 'Monaco',
    'San Marino': 'San Marino',
    'BodyType.Sedan': 'Sedan',
    'BodyType.Crossover': 'Crossover',
    'BodyType.Pickup': 'Pickup',
    'N/A': 'N/A',
    Partner: 'Partner',
    StartPoint: 'Indítsa el',
    EndPoint: 'Vége',
    'Error loading documents': 'Hiba a dokumentumok betöltésekor',
    'Are you sure you want to delete this document?':
      'Biztosan törli ezt a dokumentumot?',
    'Document deleted': 'A dokumentum törölve',
    'Failed to delete': 'Nem sikerült törölni',
    'Failed to get download link': 'Nem sikerült letölteni a linket',
    'Status updated': 'Állapot frissítve',
    'Update failed': 'A frissítés nem sikerült',
    'Email cannot be changed.': 'Az e-mail cím nem módosítható.',
    'No documents found.': 'Nem találhatók dokumentumok.',
    'Invoice #': 'Számla száma',
    'File Name': 'Fájlnév',
    Amount: 'Összeg',
    Actions: 'Akciók',
    Download: 'Letöltés',
    'Mark Unpaid': 'Megjelölés kifizetetlennek',
    'Mark Paid': 'Fizetett megjelölés',
    'Please save the record before uploading documents.':
      'Kérjük, mentse el a rekordot a dokumentumok feltöltése előtt.',
    'Select a file before uploading.': 'Feltöltés előtt válasszon egy fájlt.',
    'Please enter an invoice number.': 'Kérjük, adja meg a számla számát.',
    'Upload successful': 'Feltöltés sikeres',
    '{{count}} file(s) uploaded successfully.':
      '{{count}} fájl(ok) sikeresen feltöltve.',
    'Upload failed': 'A feltöltés sikertelen',
    'Unable to upload the document.': 'Nem sikerült feltölteni a dokumentumot.',
    'Invoice Number': 'Számlaszám',
    'Selected files:': 'Kiválasztott fájlok:',
    Upload: 'Feltöltés',
    'Save this record before uploading documents.':
      'A dokumentumok feltöltése előtt mentse el ezt a rekordot.',
    'Error approving user': 'Hiba történt a felhasználó jóváhagyásakor',
    'Error rejecting user': 'Hiba a felhasználó elutasításakor',
    'Error disabling user': 'Hiba történt a felhasználó letiltásakor',
    'User marked as VIP': 'A felhasználó VIP-ként megjelölve',
    'User unmarked as VIP': 'A felhasználó VIP-jelölése törölve',
    'Error marking user as VIP':
      'Hiba történt a felhasználó VIP-ként való megjelölésekor',
    'Error unmarking user as VIP':
      'Hiba történt a felhasználó VIP-jelölésének törlésekor',
    'Failed to approve user': 'Nem sikerült jóváhagyni a felhasználót',
    'Failed to reject user': 'Nem sikerült elutasítani a felhasználót',
    'Failed to disable user': 'Nem sikerült letiltani a felhasználót',
    'Failed to unmark user as VIP':
      'Nem sikerült törölni a felhasználó VIP-jelölését',
    'Failed to mark user as VIP':
      'Nem sikerült a felhasználót VIP-ként megjelölni',
    'Invoice Management': 'Számlakezelés',
    'All Invoices': 'Minden számla',
    'Manage all invoices uploaded by partners.':
      'Kezelje a partnerek által feltöltött összes számlát.',
    'An unexpected error occurred. Please try again.':
      'Váratlan hiba történt. Kérjük, próbálja újra.',
    'The email address is not valid.': 'Az email cím nem érvényes.',
    'This account has been disabled.': 'Ez a fiók le van tiltva.',
    'No account found with this email.':
      'Nem található fiók ezzel az e-mail-címmel.',
    'Incorrect password. Please try again.':
      'Helytelen jelszó. Kérjük, próbálja újra.',
    'Invalid email or password. Please check your credentials and try again.':
      'Érvénytelen e-mail cím vagy jelszó. Kérjük, ellenőrizze hitelesítő adatait, és próbálja újra.',
    'Too many failed attempts. Please try again later or reset your password.':
      'Túl sok sikertelen próbálkozás. Kérjük, próbálja újra később, vagy állítsa vissza jelszavát.',
    'Network error. Check your connection and try again.':
      'Hálózati hiba. Ellenőrizze a kapcsolatot, és próbálja újra.',
    'A verification email has been sent to your email address. Please verify your email before logging in.':
      'Ellenőrző e-mailt küldtünk az Ön e-mail címére. Kérjük, bejelentkezés előtt igazolja e-mail-címét.',
    'Please make sure both passwords are the same.':
      'Kérjük, győződjön meg arról, hogy mindkét jelszó azonos.',
    'Verification email resent!': 'Az ellenőrző e-mail újra elküldve!',
    'Please check your inbox.': 'Kérjük, ellenőrizze a postaládáját.',
    'You need to log in first': 'Először be kell jelentkeznie',
    'Please sign in to resend the verification email.':
      'Az ellenőrző e-mail újraküldéséhez jelentkezzen be.',
    'Failed to resend email': 'Nem sikerült újraküldeni az e-mailt',
    'Resend verification email': 'Ellenőrző e-mail újraküldése',
    'Show password': 'Jelszó megjelenítése',
    'Hide password': 'Jelszó elrejtése',
    'Awaiting verification artwork': 'A műalkotás ellenőrzésére vár',
    'Account status: Pending review': 'Fiók állapota: Ellenőrzésre vár',
    'Your account is pending approval': 'Fiókja jóváhagyásra vár',
    "Upload your verification documents below and we'll notify you by email once your account is approved.":
      'Töltse fel alább az igazoló dokumentumokat, és e-mailben értesítjük fiókja jóváhagyásáról.',
    'Check status': 'Állapot ellenőrzése',
    'Upload verification documents': 'Töltsön fel ellenőrző dokumentumokat',
    'Your uploaded documents': 'A feltöltött dokumentumaid',
    'Back to sign in': 'Vissza a bejelentkezéshez',
    'Hide documents': 'Dokumentumok elrejtése',
    'Email verification required': 'E-mail ellenőrzés szükséges',
    'Waiting for email verification': 'Várakozás az e-mail-ellenőrzésre',
    'Check your email': 'Ellenőrizze az e-mailjét',
    'We sent your verification link to':
      'Elküldtük ellenőrző linkjét a következő címre:',
    "Didn't receive it? Check your spam folder or try again.":
      'nem kapta meg? Ellenőrizze a spam mappát, vagy próbálja újra.',
    'Resend email': 'E-mail újraküldése',
    "I've verified my email": 'Megerősítettem az e-mail címem',
    'Redirecting you now.': 'Átirányítás most.',
    'Email not verified yet': 'Az e-mail cím még nincs ellenőrizve',
    'Please click the link in your inbox and try again.':
      'Kérjük, kattintson a linkre a postaládájában, és próbálja újra.',
    'Unable to resend verification email right now.':
      'Jelenleg nem lehet újraküldeni az ellenőrző e-mailt.',
    'Unable to check verification status right now.':
      'Jelenleg nem lehet ellenőrizni az ellenőrzés állapotát.',
    "We've sent a new verification link to your email address.":
      'Új ellenőrző linket küldtünk az e-mail címére.',
    'We automatically check your verification status every 30 seconds. You can also trigger an instant check after verifying your email.':
      'Az ellenőrzés állapotát 30 másodpercenként automatikusan ellenőrizzük. Az e-mail-cím ellenőrzése után azonnali ellenőrzést is indíthat.',
    'We automatically check your verification status every 15 seconds. You can also trigger an instant check after verifying your email.':
      'Az ellenőrzés állapotát 15 másodpercenként automatikusan ellenőrizzük. Az e-mail-cím ellenőrzése után azonnali ellenőrzést is indíthat.',
    'Inputs changed. Recalculate the price.':
      'A bemenetek megváltoztak. Számolja újra az árat.',
    'My Invoices': 'Saját számláim',
    'Upload New Invoice': 'Új számla feltöltése',
    'Please enter the invoice number and upload the invoice document. It will be reviewed by an administrator.':
      'Kérjük, adja meg a számla számát és töltse fel a számla bizonylatot. A rendszergazda felülvizsgálja.',
    'Invoice History': 'Számlaelőzmények',
    'Client ref · {{clientRef}}': 'Ügyfél ref · {{clientRef}}',
    'Order Documents': 'Rendelési dokumentumok',
    'Upload Proof of Pickup': 'Töltsd fel az átvétel igazolását',
    'Status will be updated to Picked Up after successful upload.':
      'Sikeres feltöltés után az állapot Felvett állapotba kerül.',
    'Upload Proof of Delivery': 'Szállítási igazolás feltöltése',
    'Status will be updated to Delivered after successful upload.':
      'Sikeres feltöltés után az állapot Kézbesítve lesz.',
    'Enter first name': 'Írja be a keresztnevet',
    'Enter last name': 'Írja be a vezetéknevet',
    'Enter phone number': 'Adja meg a telefonszámot',
    'Driver updated.': 'Driver frissítve.',
    'The driver has been successfully updated.':
      'Az illesztőprogram frissítése sikeresen megtörtént.',
    'Driver added.': 'Hozzátette a sofőr.',
    'The new driver has been successfully added.':
      'Az új illesztőprogram hozzáadása sikeresen megtörtént.',
    'Driver deleted.': 'Illesztőprogram törölve.',
    'The driver has been successfully deleted.':
      'Az illesztőprogram sikeresen törölve.',
    'Trailer updated.': 'Trailer frissítve.',
    'The trailer has been successfully updated.':
      'Az előzetes frissítése sikeresen megtörtént.',
    'Trailer added.': 'Előzetes hozzáadva.',
    'The new trailer has been successfully added.':
      'Az új előzetes sikeresen hozzáadva.',
    'Trailer deleted.': 'Előzetes törölve.',
    'The trailer has been successfully deleted.':
      'Az előzetes sikeresen törölve.',
    'User account not found. Please complete registration.':
      'Felhasználói fiók nem található. Kérjük, fejezze be a regisztrációt.',
    'No token provided': 'Nincs token',
    'Token expired': 'A token lejárt',
    'Token revoked': 'Token visszavonva',
    'Invalid ID token': 'Érvénytelen azonosító token',
    Unauthorized: 'Jogosulatlan',
    'Unauthorized: User not authenticated.':
      'Jogosulatlan: A felhasználó nincs hitelesítve.',
    'Unauthorized: User role not found.':
      'Jogosulatlan: A felhasználói szerepkör nem található.',
    'Forbidden: Your role is not allowed to perform this action.':
      'Tiltott: Az Ön szerepköre nem hajthatja végre ezt a műveletet.',
    'Forbidden: This action requires a partner role.':
      'Tiltott: ehhez a művelethez partner szerep szükséges.',
    'Forbidden: This action requires a client role.':
      'Tiltott: ehhez a művelethez ügyfélszerep szükséges.',
    'Forbidden: This action requires an admin role.':
      'Tiltott: ehhez a művelethez rendszergazdai szerepkör szükséges.',
    'This user has not been approved': 'Ezt a felhasználót nem hagyták jóvá',
    'User email has not been verified':
      'A felhasználói e-mail-cím nincs ellenőrizve',
    'User account has been disabled': 'A felhasználói fiók letiltva',
    'Booking not found': 'Foglalás nem található',
    'Route not found': 'Az útvonal nem található',
    'Pickup location (country and postalCode) is required':
      'Az átvétel helye (ország és irányítószám) kötelező',
    'Delivery location (country and postalCode) is required':
      'A kézbesítés helye (ország és irányítószám) kötelező',
    'Unable to calculate route. Please check the locations and try again.':
      'Nem lehet kiszámítani az útvonalat. Kérjük, ellenőrizze a helyeket, és próbálja újra.',
    'Error calculating transport price': 'Hiba a szállítási ár kiszámításakor',
    'Booking canceled successfully': 'A foglalás sikeresen törölve',
    'Invalid request.': 'Érvénytelen kérés.',
    'Access denied.': 'Hozzáférés megtagadva.',
    'Resource not found.': 'Az erőforrás nem található.',
    'Request conflict.': 'Konfliktus kérése.',
    'Invalid data provided.': 'Érvénytelen adatok.',
    'Too many requests. Please try again later.':
      'Túl sok kérés. Kérjük, próbálja újra később.',
    'Internal server error. Please try again later.':
      'Belső szerver hiba. Kérjük, próbálja újra később.',
    'Service temporarily unavailable.':
      'A szolgáltatás átmenetileg nem elérhető.',
    'booking.load_preset': 'Előbeállítás betöltése',
    'booking.save_preset_tooltip':
      'Mentse el az aktuális szűrőket gyorselérési beállításként',
    'booking.load_preset_tooltip': 'Töltse be a mentett szűrőbeállítást',
    'booking.preset_saved': 'Előbeállítás mentve',
    'booking.preset_saved_desc': 'Az előre beállított szűrő elmentve.',
    'booking.preset_loaded': 'Előre beállítva',
    'booking.preset_load_error':
      'Nem sikerült betölteni az előre beállított értékeket',
    'booking.no_preset_saved': 'Még nem mentett előre beállítás',
    'booking.date_from': 'Dátum innen:',
    'booking.date_to': 'Dátum ig',
    'Active filters': 'Aktív szűrők',
    'All booking states': 'Minden foglalási állapot',
    'All partners': 'Minden partner',
    'All payments': 'Minden fizetés',
    'All roles': 'Minden szerep',
    'All statuses': 'Minden állapot',
    'All Users': 'Minden felhasználó',
    'Are you sure you want to cancel booking {{id}}?':
      'Biztosan lemondja a {{id}} foglalását?',
    'Attach the CMR Insurance before finishing truck setup.':
      'A teherautó beállításának befejezése előtt csatolja a CMR számlát.',
    Awaiting: 'Várakozás',
    'Awaiting payout': 'Kifizetésre vár',
    'Booking canceled': 'A foglalás törölve',
    'Booking marked as paid': 'A foglalás fizetettként megjelölve',
    'Booking released and returned to marketplace':
      'A foglalás feloldva és visszakerült a piactérre',
    'booking.allowed_range': 'Engedélyezett tartomány',
    'booking.assign_transport': 'Közlekedés hozzárendelése',
    'booking.back': 'Vissza',
    'booking.back_to_summary': 'Vissza az összefoglalóhoz',
    'booking.booking_created_but_pickup_document_not_uploaded_upload_from_order_details':
      'A foglalás létrejött, de az átvételi dokumentumot nem töltötték fel. Feltöltheti a Megrendelés részletei között.',
    'booking.city_not_found': 'A város nem található',
    'booking.city_or_town': 'Város vagy település',
    'booking.clear_radius': 'Tiszta sugár',
    'booking.continue': 'Folytatás',
    'booking.country_optional': 'Ország (nem kötelező)',
    'booking.delivery_constraint_info':
      'A kézbesítés dátumának az átvétel napján vagy azt követően kell lennie.',
    'booking.delivery_date_cannot_be_earlier_than_pickup_date':
      'A kiszállítás dátuma nem lehet korábbi, mint az átvétel dátuma',
    'booking.driver': 'Driver',
    'booking.failed_to_open_letter_of_attorney':
      'Nem sikerült felbontani a meghatalmazott levelet',
    'booking.go_to_order': 'Lépjen a Rendelésre',
    'booking.i_accept_terms': 'Elfogadom a feltételeket',
    'booking.invalid_license_plate_or_vin_length':
      'Érvénytelen rendszám vagy VIN hosszúság.',
    'booking.invalid_vin_format_i_o_q_not_allowed':
      'Érvénytelen VIN-formátum. Az I, O és Q karakterek nem engedélyezettek.',
    'booking.letter_of_attorney_file_is_empty':
      'A meghatalmazási levél fájl üres',
    'booking.no_additional_details': 'Nincsenek további részletek',
    'booking.no_vehicle_info': 'Nincs információ a járműről',
    'booking.open_letter_of_attorney': 'Nyílt ügyvédi levél',
    'booking.opening_letter_of_attorney': 'Megnyitó meghatalmazott...',
    'booking.order_accepted_successfully': 'Megrendelés sikeresen elfogadva',
    'booking.order_cars_exceed_selected_truck_capacity':
      'Ez a rendelés {{orderCars}} autókat tartalmaz, de a kiválasztott teherautó kapacitása {{capacity}}.',
    'booking.pickup_constraint_info':
      'A szállítás kijelölése előtt szükséges az átvétel dátuma.',
    'booking.pickup_document_upload_failed':
      'Az átvételi dokumentum feltöltése nem sikerült',
    'booking.preparing_secure_document_preview':
      'Biztonságos dokumentum-előnézet előkészítése...',
    'booking.radius_km': 'Sugár (km)',
    'booking.radius_search': 'Sugárkeresés',
    'booking.route_and_details': 'Útvonal és részletek',
    'booking.schedule': 'Ütemezés',
    'booking.searching': 'Keresés…',
    'booking.select_pickup_and_delivery':
      'Válassza ki az átvételt és a kiszállítást',
    'booking.select_pickup_and_delivery_dates_before_confirming':
      'A megerősítés előtt válassza ki az átvételi és szállítási dátumokat',
    'booking.select_pickup_date': 'Válassza ki az átvétel dátumát',
    'booking.select_truck_driver_and_trailer':
      'Válassza ki a teherautót, a sofőrt és az utánfutót',
    'booking.supported_formats_jpg_png_pdf_doc_docx':
      'Támogatott formátumok: JPG, PNG, PDF, DOC, DOCX',
    'booking.terms_and_conditions': 'Feltételek',
    'booking.terms_text':
      'Megerősítem a szállítási feltételeket és a felelősségi feltételeket.',
    'booking.track_shipment': 'Kövesse nyomon a szállítmányt',
    'booking.trailer': 'Előzetes',
    'booking.transport_details': 'Szállítási adatok',
    'booking.truck': 'Teherautó',
    'booking.truck_driver_planning_saved_letter_of_attorney_available':
      'A teherautó, a sofőr és a tervezési dátumok el lettek mentve. A meghatalmazás már elérhető.',
    'booking.unexpected_error': 'Váratlan hiba',
    'booking.vehicles_plural': 'Járművek',
    'booking.view_details': 'Részletek megtekintése',
    'booking.vip_price_must_be_between_min_max_50_to_150_percent_of_estimated_price':
      'A VIP árnak {{min}} EUR és {{max}} EUR között kell lennie (a becsült ár 50-150%-a).',
    'booking.vip_price_must_be_positive_number':
      'A VIP árnak pozitív számnak kell lennie.',
    'booking.within_radius_km_of_place':
      '{{radius}} km-en belül a {{place}}-től',
    Capacity: 'Kapacitás',
    'Car Capacity': 'Autó kapacitás',
    'Car capacity is required.': 'Az autó kapacitása szükséges.',
    cars: 'autók',
    Changed: 'Megváltozott',
    'CMR Document': 'CMR dokumentum',
    'CMR expiry': 'CMR lejárat',
    'CMR Expiry': 'CMR lejárat',
    'CMR expiry date is required': 'A CMR lejárati dátuma kötelező',
    'CMR Insurance': 'CMR biztosítás',
    'CMR insurance expiry date': 'CMR biztosítás lejárati dátuma',
    'CMR Insurance Expiry Date': 'CMR biztosítás lejárati dátuma',
    'CMR insurance has expired. Upload a new CMR Insurance for review.':
      'Töltsön fel új CMR-számlát felülvizsgálatra.',
    'CMR insurance is expiring within 14 days.':
      'A CMR biztosítás 14 napon belül lejár.',
    'CMR Insurance required': 'CMR számla szükséges',
    Company: 'Társaság',
    'Copy order ID': 'Rendelésazonosító másolása',
    Created: 'Létrehozva',
    'Current expiry': 'Jelenlegi lejárat',
    'Date range': 'Dátumtartomány',
    days: 'napokon',
    Delay: 'Késleltetés',
    'Delivered + partner invoice uploaded + unpaid':
      'Kézbesítve + partnerszámla feltöltve + kifizetetlen',
    Document: 'dokumentum',
    'Documents uploaded': 'Feltöltött dokumentumok',
    Done: 'Kész',
    'Download Client Invoice #{{id}}': 'Töltse le a {{id}} számú ügyfélszámlát',
    'Download Invoice': 'Számla letöltése',
    'Enter a valid capacity between 1 and 20 cars.':
      'Adjon meg egy érvényes kapacitást 1 és 20 autó között.',
    'Enter license plate': 'Adja meg a rendszámot',
    'Enter plate and upload CMR to add truck':
      'Adja meg a táblát, és töltse fel a CMR-t a teherautó hozzáadásához',
    'Error fetching users': 'Hiba történt a felhasználók lekérésekor',
    'Expire Soon (14 days)': 'Hamarosan lejár (14 nap)',
    'Explain why this CMR was rejected':
      'Magyarázza el, miért utasították el ezt a CMR-t',
    'Failed to copy order ID': 'Nem sikerült másolni a rendelésazonosítót',
    'Failed to download invoice': 'Nem sikerült letölteni a számlát',
    'Failed to download proforma invoice':
      'Nem sikerült letölteni a proforma számlát',
    'Failed to generate invoice': 'Nem sikerült létrehozni a számlát',
    'Failed to load invoice summary':
      'Nem sikerült betölteni a számlaösszesítőt',
    'Failed to load letter of attorney':
      'Nem sikerült betölteni a meghatalmazást',
    'Failed to open letter of attorney':
      'Nem sikerült felbontani a meghatalmazott levelet',
    'Failed to release booking': 'Nem sikerült feloldani a foglalást',
    'Fleet data refreshed': 'A flottaadatok frissítve',
    'Generate Client Invoice': 'Ügyfélszámla generálása',
    'Generate Invoice': 'Számla generálása',
    'Generated at': 'Generálva:',
    'How many cars can this truck carry?':
      'Hány autót képes szállítani ez a teherautó?',
    'In progress': 'Folyamatban',
    Invoice: 'Számla',
    'Invoice generated': 'Számla generálva',
    'Invoice generated successfully': 'A számla sikeresen generálva',
    'Invoice uploaded': 'Számla feltöltve',
    'Invoices uploaded by partners for platform payout processing. Client invoices are generated in each order view.':
      'Az ügyfélszámlák minden rendelési nézetben generálódnak.',
    'Keep booking': 'Foglaljon tovább',
    'Keep your active drivers and contact details up to date.':
      'Tartsa naprakészen aktív járművezetőit és elérhetőségeit.',
    'Last Rejection': 'Utolsó elutasítás',
    'Last rejection reason': 'Utolsó elutasítási ok',
    'Letter of Attorney': 'Ügyvédi levél',
    'Letter of attorney file is empty': 'A meghatalmazási levél fájl üres',
    'License plate cannot be changed after creation. Re-upload CMR Insurance instead.':
      'Helyette töltse fel újra a CMR számlát.',
    'License plate is required.': 'Rendszám szükséges.',
    'Manage large order volumes with search, payment actions, and invoice workflows.':
      'Nagy rendelési mennyiségek kezelése kereséssel, fizetési műveletekkel és számlázási munkafolyamatokkal.',
    'Manage license plates and keep CMR Insurances approved and valid.':
      'Kezelje a rendszámokat, és tartsa jóváhagyott és érvényes CMR számlákat.',
    'Manage status updates, documents, and payment steps from one place.':
      'Egy helyről kezelheti az állapotfrissítéseket, a dokumentumokat és a fizetési lépéseket.',
    'Manage trailer plate records and keep availability current.':
      'Kezelje a pótkocsi rendszámtáblázatát, és tartsa naprakészen a rendelkezésre állást.',
    'Mark booking {{id}} as paid?':
      'Megjelöli a {{id}} foglalást kifizetettként?',
    Missing: 'Hiányzik',
    'Needs attention': 'Figyelmet igényel',
    'New (14 days)': 'Új (14 nap)',
    'No bookings found for the current filters.':
      'A jelenlegi szűrőkhöz nem található foglalás.',
    'No confirmed CMR document uploaded yet.':
      'Még nincs feltöltött megerősített CMR dokumentum.',
    'No driver assigned': 'Nincs illesztőprogram hozzárendelve',
    'No letter of attorney has been generated yet.':
      'Megbízólevél még nem készült.',
    'No matching delivered orders': 'Nincsenek megfelelő szállított rendelések',
    'No new notifications': 'Nincsenek új értesítések',
    'No partners found.': 'Nem található partner.',
    'No trucks found for this filter.':
      'Nem található teherautó ehhez a szűrőhöz.',
    'No users found for current filters.':
      'Nem található felhasználó a jelenlegi szűrőknek.',
    'Not uploaded': 'Nincs feltöltve',
    Notifications: 'Értesítések',
    of: 'a',
    'Only admins can set or update this expiry date after reviewing your CMR insurance.':
      'Csak a rendszergazdák állíthatják be vagy frissíthetik ezt a lejárati dátumot a CMR-biztosítás áttekintése után.',
    'Open letter of attorney': 'Nyílt meghatalmazott levél',
    Order: 'Rendeljen',
    'Order actions': 'Rendeljen műveleteket',
    'Order ID copied': 'Rendelésazonosító másolva',
    Owner: 'Tulajdonos',
    Page: 'oldal',
    'Paid date': 'Fizetési dátum',
    'Partner delivery date': 'Partner szállítási dátum',
    'Partner documents': 'Partner dokumentumok',
    'Partner Invoice': 'Partner számla',
    'Partner invoice uploaded': 'Partnerszámla feltöltve',
    'Partner Payout Invoices': 'Partner kifizetési számlák',
    'Partner pickup date': 'Partner átvétel dátuma',
    'Partner score': 'Partner pontszám',
    Payment: 'Fizetés',
    'Payout date': 'Kifizetés dátuma',
    'penalties applied': 'alkalmazott büntetések',
    'Pending admin review': 'Adminisztrátori felülvizsgálatra vár',
    'Pending review': 'Felülvizsgálatra vár',
    'Pending trucks': 'Függőben lévő teherautók',
    'Please provide a clear reason for rejection.':
      'Kérjük, adja meg az elutasítás egyértelmű okát.',
    'Please select an order before uploading an invoice.':
      'Kérjük, válasszon egy rendelést a számla feltöltése előtt.',
    'Please try again.': 'Kérjük, próbálja újra.',
    'Proforma Invoice': 'Proforma számla',
    'Provide a rejection reason for this CMR review.':
      'Adja meg a CMR-felülvizsgálat elutasításának indokát.',
    'Quarter Score': 'Negyed pontszám',
    'Re-upload CMR': 'Töltse fel újra a CMR-t',
    Refresh: 'Frissítés',
    'Rejection reason': 'Elutasítás oka',
    'Rejection reason is required': 'Az elutasítás okát meg kell adni',
    'Release booking {{id}} back to the marketplace so another partner can accept it?':
      'Visszaadja a {{id}} foglalást a piactéren, hogy egy másik partner elfogadhassa?',
    Reset: 'Reset',
    'Review Bookings': 'Foglalások áttekintése',
    Revision: 'Revízió',
    Rows: 'Sorok',
    'Search by invoice number, file name, or booking ID':
      'Keresés számlaszám, fájlnév vagy foglalási azonosító alapján',
    'Search by name, email, company': 'Keresés név, e-mail, cég szerint',
    'Search by name, email, company, uid':
      'Keresés név, e-mail, cég, uid szerint',
    'Search client': 'Keresés kliens',
    'Search delivered order': 'Keressen kiszállított rendelést',
    'Search license plate or owner': 'Rendszám vagy tulajdonos keresése',
    'Search order ID': 'Rendelési azonosító keresése',
    'Search partner': 'Keresőpartner',
    'Select a new CMR Insurance to re-upload for this truck.':
      'Válasszon ki egy új CMR-számlát, amelyet újra feltölthet ehhez a teherautóhoz.',
    'Select paid date': 'Válassza ki a fizetés dátumát',
    'Set CMR insurance expiry date to approve this truck.':
      'Állítsa be a CMR-biztosítás lejárati dátumát a teherautó jóváhagyásához.',
    'Set maximum number of cars this truck can carry (1-20).':
      'Állítsa be a teherautó által szállítható autók maximális számát (1-20).',
    'Set the CMR insurance expiry date before approval.':
      'Állítsa be a CMR-biztosítás lejárati dátumát a jóváhagyás előtt.',
    Showing: 'Megjelenítés',
    'Showing page {{page}} of {{pages}} • {{total}} invoices':
      '{{pages}}/{{page}} oldal megjelenítése • {{total}} számlák',
    'Status will be updated to Picked Up after successful upload. You can add multiple car photos before uploading.':
      'Feltöltés előtt több autós fotót is hozzáadhat.',
    Terms: 'Feltételek',
    Total: 'Összesen',
    'Track paid and unpaid invoices, expected payout dates, and upload new invoices quickly.':
      'Kövesse nyomon a kifizetett és kifizetetlen számlákat, a várható kifizetési dátumokat, és gyorsan töltse fel az új számlákat.',
    'Truck approved successfully': 'A teherautó sikeresen jóváhagyva',
    'Truck documents': 'Teherautó dokumentumok',
    'Truck license plate': 'Teherautó rendszáma',
    'Truck rejected successfully': 'A teherautó sikeresen elutasítva',
    'truck(s) are pending admin CMR expiry date.':
      'teherautó(k) admin CMR lejárati dátumra várnak.',
    'truck(s) have expired CMR insurance and are disabled.':
      'A teherautó(k)nak lejárt CMR-biztosítása van, és letiltottak.',
    'truck(s) will expire within 14 days.':
      'teherautó(k) 14 napon belül lejárnak.',
    'Unable to prepare the record for upload.':
      'Nem sikerült előkészíteni a rekordot a feltöltésre.',
    Unpaid: 'Kifizetetlen',
    'Upload a CMR Insurance before closing this truck setup.':
      'Töltsön fel egy CMR-számlát a teherautó-beállítás lezárása előtt.',
    'Upload a valid CMR insurance. Each upload sends the truck back to pending review.':
      'Minden egyes feltöltés visszaküldi a teherautót a függőben lévő felülvizsgálatra.',
    'Upload documents': 'Dokumentumok feltöltése',
    'Upload Invoice': 'Számla feltöltése',
    'Upload order documents': 'Töltsön fel rendelési dokumentumokat',
    'Upload unavailable': 'A feltöltés nem érhető el',
    Uploaded: 'Feltöltve',
    'Uploaded • Paid': 'Feltöltve • Fizetett',
    'Uploaded • Partially paid': 'Feltöltve • Részben fizetve',
    'Uploaded by partner for platform payout processing.':
      'A partner feltöltötte a platform kifizetésének feldolgozásához.',
    User: 'Felhasználó',
    'Verification code': 'Ellenőrző kód',
    'View details': 'Részletek megtekintése',
    'View Partners': 'Partnerek megtekintése',
    'Working hours not provided': 'Munkaidő nincs biztosítva',
    '{{value}} orders': '{{value}} megrendelések',
    Invoiced: 'Kiszámlázott',
    'Loading admin data...': 'Rendszergazdai adatok betöltése...',
    'Pending partners': 'Függőben lévő partnerek',
    'Unpaid bookings': 'Ki nem fizetett foglalások',
    'Total users': 'Összes felhasználó',
    'Orders per period': 'Megrendelések időszakonként',
    'Orders by status': 'Rendelések állapot szerint',
    'Quick actions': 'Gyors cselekvések',
    'Verify new partners': 'Új partnerek ellenőrzése',
    'Review partner applications and approve or reject requests.':
      'Tekintse át a partnerjelentkezéseket, és hagyja jóvá vagy utasítsa el a kéréseket.',
    'Manage all trucks': 'Kezelje az összes teherautót',
    'Review, approve, reject, disable, and filter all trucks.':
      'Tekintse át, hagyja jóvá, utasítsa el, tiltsa le és szűrje le az összes teherautót.',
    'Review bookings': 'Foglalások áttekintése',
    'Review all transport orders, payment states, and generated invoices.':
      'Tekintse át az összes szállítási rendelést, fizetési állapotot és generált számlát.',
    'Manage all users': 'Az összes felhasználó kezelése',
    'Manage user status, roles, and validation records.':
      'Kezelje a felhasználói állapotot, a szerepköröket és az érvényesítési rekordokat.',
    'User breakdown': 'Felhasználói bontás',
    Clients: 'Ügyfelek',
    Partners: 'Partnerek',
    Admins: 'Adminok',
    'Top 5 pending partners': 'Az 5 legjobb függőben lévő partner',
    'No pending partners right now.':
      'Jelenleg nincsenek függőben lévő partnerek.',
    pending: 'függőben',
    'Top 5 pending trucks': 'Az 5 legjobb függőben lévő teherautó',
    'No pending trucks right now.':
      'Jelenleg nincsenek függőben lévő teherautók.',
    'Unknown owner': 'Ismeretlen tulajdonos',
    'KPI cards and top lists link directly to filtered admin screens.':
      'A KPI-kártyák és a toplisták közvetlenül a szűrt adminisztrátori képernyőkre mutatnak.',
    'booking.available_orders_title': 'Elérhető rendelések',
    'booking.available_orders_description':
      'Tekintse át a bejövő szállítási lehetőségeket, és alkalmazzon szűrőket a kapacitásának megfelelően.',
    'booking.vehicle_pickup_location': 'A jármű átvételi helye',
    'booking.pickup_opening_hours': 'Átvételi nyitva tartás',
    'booking.vehicle_delivery_location': 'A jármű szállítási helye',
    'booking.delivery_opening_hours': 'Szállítási nyitva tartás',
    'booking.pickup_contact': 'Felvételi kapcsolat',
    'booking.delivery_contact': 'Szállítási kapcsolat',
    'booking.vehicles_scheduled': 'Járművek menetrend szerint',
    'booking.watchlist_title': 'Figyelőlista',
    'booking.watchlist_description':
      'Kövesse nyomon a mentett lehetőségeket, és gyorsan cselekedjen a rendelkezésre állás változásaival.',
    'Loading dashboard...': 'Irányítópult betöltése...',
    'Total bookings': 'Összes foglalás',
    'Open bookings': 'Nyitott foglalások',
    'Order status timeline': 'Megrendelés állapotának idővonala',
    'Last 6 months of bookings grouped by current status.':
      'Az elmúlt 6 hónap foglalásai aktuális állapot szerint csoportosítva.',
    'Create new order': 'Új rendelés létrehozása',
    'Create a new transport booking request.':
      'Hozzon létre egy új szállítási foglalási kérelmet.',
    'View my orders': 'Tekintse meg rendeléseimet',
    'Review status and details of your bookings.':
      'Tekintse át foglalásai állapotát és részleteit.',
    'Open profile': 'Profil megnyitása',
    'Update company and contact details.':
      'Frissítse a céget és az elérhetőségeket.',
    'Recent bookings': 'Legutóbbi foglalások',
    'No bookings yet.': 'Még nincsenek foglalások.',
    'Unknown destination': 'Ismeretlen úti cél',
    'Quarter score': 'Negyed pontszám',
    '{{value}} completed': '{{value}} elkészült',
    'Truck CMR warning': 'Teherautó CMR figyelmeztetés',
    'One truck has CMR expiry risk. Review it in Fleet.':
      'Egy teherautó rendelkezik CMR lejárati kockázattal. Tekintse át a Fleetben.',
    '{{count}} trucks have CMR expiry risk. Review them in Fleet.':
      'A {{count}} teherautók CMR lejárati kockázattal járnak. Tekintse át őket a Fleetben.',
    'Active queue': 'Aktív sor',
    'Delivered bookings': 'Kézbesített foglalások',
    'Cars delivered': 'Szállított autók',
    'Canceled bookings': 'Törölt foglalások',
    'Avg assign-to-pickup': 'Átl. hozzárendelés az átvételhez',
    'Quarter Partner Score': 'Negyedéves partner pontszám',
    'Payment delay: +{{days}} days': 'Fizetési késedelem: +{{days}} nap',
    'Penalty events': 'Büntetéses események',
    Current: 'Aktuális',
    'Completed orders per period': 'Teljesített rendelések időszakonként',
    'Completed orders': 'Teljesített megrendelések',
    'Truck CMR status alerts': 'Teherautó CMR állapotfigyelmeztetések',
    '{{count}} truck(s) have expired CMR insurance.':
      'A {{count}} teherautó(k) lejárt CMR biztosítással rendelkeznek.',
    '{{count}} truck(s) will expire within 14 days.':
      'A {{count}} teherautó(k) 14 napon belül lejárnak.',
    '{{count}} truck(s) are missing CMR expiry date.':
      'A {{count}} teherautó(k)ról hiányzik a CMR lejárati dátuma.',
    'Upload a new CMR Insurance in Fleet. The truck will stay pending until admin review.':
      'Töltsön fel új CMR számlát a Fleetbe. A teherautó függőben marad az adminisztrátori felülvizsgálatig.',
    'Open fleet to resolve CMR alerts':
      'Nyissa meg a flottát a CMR-riasztások megoldásához',
    'Operational actions': 'Operatív intézkedések',
    'Open marketplace orders': 'Nyílt piaci rendelések',
    'Review available orders and plan assignments.':
      'Tekintse át az elérhető rendeléseket és tervezze meg a megbízásokat.',
    'My accepted orders': 'Elfogadott rendeléseim',
    'Manage delivery progress and documents.':
      'Kezelje a kézbesítés folyamatát és a dokumentumokat.',
    'Update trucks, trailers, and availability.':
      'Frissítse a teherautókat, pótkocsikat és a rendelkezsre állást.',
    'Partner invoices': 'Partneri számlák',
    'Upload and track invoice payments.':
      'Töltse fel és kövesse nyomon a számlafizetést.',
    'No active orders in queue.': 'Nincs aktív rendelés a sorban.',
    'profile.incompleteTitle': 'A profil hiányos',
    'profile.incompleteDescription':
      'Kérjük, töltse ki profiladatait (Cég, Telefon, Cím, Város, Irányítószám) az összes funkció eléréséhez.',
    'profile.goToProfile': 'Lépjen a Profilra',
    'auth.email_placeholder': 'név@cég.com',
    'auth.authentication_mode_switch': 'Hitelesítési mód kapcsoló',
    'auth.invalid_email': 'Érvénytelen e-mail-cím',
    'auth.please_enter_a_valid_email_address':
      'Kérjük, adjon meg egy érvényes e-mail címet.',
    'auth.email_not_found': 'E-mail nem található',
    'auth.no_account_found_with_that_email_address':
      'Nem található fiók ezzel az e-mail címmel.',
    'auth.email_sent': 'E-mail elküldve!',
    'auth.something_went_wrong_try_again': 'Valami elromlott. Próbáld újra.',
    'auth.we_sent_a_password_reset_link_open_your_inbox_and_follow_the_instructions':
      'Küldtünk egy jelszó-visszaállítási linket. Nyissa meg a beérkező leveleket, és kövesse az utasításokat.',
    'auth.forgot_your_password': 'Elfelejtette jelszavát?',
    'auth.enter_your_account_email_and_we_will_send_you_a_password_reset_link':
      'Adja meg fiókjának e-mail-címét, és küldünk egy jelszó-visszaállítási linket.',
    'auth.email_address': 'E-mail cím',
    'auth.send_reset_link': 'Reset link küldése',
    'auth.cancel': 'Mégsem',
    'auth.tip_if_you_do_not_receive_the_email_check_spam_and_promotions_folders':
      'Tipp: ha nem kapja meg az e-mailt, ellenőrizze a spam és promóciós mappákat.',
    'booking.e_g_berlin': 'például Berlin',
    'booking.e_g_germany': 'pl. Németország',
    'booking.watchlist': 'Figyelőlista',
    'booking.view_map': 'Térkép megtekintése',
    'booking.invalid_input': 'Érvénytelen bevitel',
    'booking.please_enter_only_numbers_for_the_zip_code':
      'Kérjük, csak számokat írjon be az irányítószámhoz.',
    'booking.pickup_zip_code': 'Pickup irányítószám',
    'booking.delivery_zip_code': 'Szállítási irányítószám',
    'booking.select_vehicle_make': 'Válassza ki a jármű gyártmányát',
    'booking.unnamed_item': 'Névtelen elem',
    'booking.cars': 'autók',
    'booking.more_info': 'További információ',
    'booking.loading': 'Betöltés...',
    'booking.no_items_found': 'Nem található elemek',
    'booking.selected_cars': 'Válogatott autók',
    'booking.unknown_type': 'Ismeretlen típus',
    'booking.delete_car': 'Autó törlése',
    'Toggle details': 'Részletek váltása',
    'auth.a_verification_email_has_been_sent_to_your_email_address_please_verify_your_emai':
      'Ellenőrző e-mailt küldtünk az Ön e-mail címére. Kérjük, bejelentkezés előtt igazolja e-mail-címét.',
    'auth.an_unexpected_error_occurred_please_try_again':
      'Váratlan hiba történt. Kérjük, próbálja újra.',
    'auth.email': 'E-mail',
    'auth.failed_to_resend_email': 'Nem sikerült újraküldeni az e-mailt',
    'auth.show_password': 'Jelszó megjelenítése',
    'auth.hide_password': 'Jelszó elrejtése',
    'auth.incorrect_password_please_try_again':
      'Helytelen jelszó. Kérjük, próbálja újra.',
    'auth.invalid_email_or_password_please_check_your_credentials_and_try_again':
      'Érvénytelen e-mail cím vagy jelszó. Kérjük, ellenőrizze hitelesítő adatait, és próbálja újra.',
    'auth.network_error_check_your_connection_and_try_again':
      'Hálózati hiba. Ellenőrizze a kapcsolatot, és próbálja újra.',
    'auth.no_account_found_with_this_email':
      'Nem található fiók ezzel az e-mail-címmel.',
    'auth.partner': 'Partner',
    'auth.please_check_your_inbox': 'Kérjük, ellenőrizze a postaládáját.',
    'auth.please_make_sure_both_passwords_are_the_same':
      'Kérjük, győződjön meg arról, hogy mindkét jelszó azonos.',
    'auth.please_sign_in_to_resend_the_verification_email':
      'Az ellenőrző e-mail újraküldéséhez jelentkezzen be.',
    'auth.resend_verification_email': 'Ellenőrző e-mail újraküldése',
    'auth.awaiting_verification_artwork': 'A műalkotás ellenőrzésére vár',
    'auth.email_verification_required': 'E-mail ellenőrzés szükséges',
    'auth.waiting_for_email_verification': 'Várakozás az e-mail-ellenőrzésre',
    'auth.check_your_email': 'Ellenőrizze az e-mailjét',
    'auth.we_sent_your_verification_link_to':
      'Elküldtük ellenőrző linkjét a következő címre:',
    'auth.didnt_receive_it_check_spam_or_try_again':
      'nem kapta meg? Ellenőrizze a spam mappát, vagy próbálja újra.',
    'auth.resend_email': 'E-mail újraküldése',
    'auth.i_verified_my_email': 'Megerősítettem az e-mail címem',
    'auth.redirecting_you_now': 'Átirányítás most.',
    'auth.email_not_verified_yet': 'Az e-mail cím még nincs ellenőrizve',
    'auth.please_click_the_link_in_your_inbox_and_try_again':
      'Kérjük, kattintson a linkre a postaládájában, és próbálja újra.',
    'auth.unable_to_resend_verification_email_right_now':
      'Jelenleg nem lehet újraküldeni az ellenőrző e-mailt.',
    'auth.unable_to_check_verification_status_right_now':
      'Jelenleg nem lehet ellenőrizni az ellenőrzés állapotát.',
    'auth.we_sent_a_new_verification_link':
      'Új ellenőrző linket küldtünk az e-mail címére.',
    'auth.we_automatically_check_every_30_seconds':
      'Az ellenőrzés állapotát 30 másodpercenként automatikusan ellenőrizzük. Az e-mail-cím ellenőrzése után azonnali ellenőrzést is indíthat.',
    'auth.we_automatically_check_every_15_seconds':
      'Az ellenőrzés állapotát 15 másodpercenként automatikusan ellenőrizzük. Az e-mail-cím ellenőrzése után azonnali ellenőrzést is indíthat.',
    'auth.the_email_address_is_not_valid': 'Az email cím nem érvényes.',
    'auth.this_account_has_been_disabled': 'Ez a fiók le van tiltva.',
    'auth.too_many_failed_attempts_please_try_again_later_or_reset_your_password':
      'Túl sok sikertelen próbálkozás. Kérjük, próbálja újra később, vagy állítsa vissza jelszavát.',
    'auth.verification_email_resent': 'Az ellenőrző e-mail újra elküldve!',
    'auth.you_need_to_log_in_first': 'Először be kell jelentkeznie',
    'booking.email': 'E-mail',
    'booking.endpoint': 'Vége',
    'booking.error_fetching_data': 'Hiba az adatok lekérésekor',
    'booking.inputs_changed_recalculate_the_price':
      'A bemenetek megváltoztak. Számolja újra az árat.',
    'booking.kg': 'kg',
    'booking.km': 'km',
    'booking.mi': 'mi',
    'booking.no_opening_hours_provided': 'Nyitvatartási idő nincs megadva',
    'booking.no_vehicles_listed': 'Nincsenek listán szereplő járművek',
    'booking.not_available': 'Nem elérhető',
    'booking.not_set': 'Nincs beállítva',
    'booking.please_select_a_planned_date':
      'Kérjük, válasszon egy tervezett dátumot',
    'booking.required': 'Kötelező',
    'booking.startpoint': 'Indítsa el',
    'booking.to': 'hogy',
    'booking.order': 'Rendeljen',
    'booking.duration': 'Időtartam',
    'booking.vehicles_overview': 'A járművek áttekintése',
    'booking.body': 'Test',
    'booking.dims': 'Elsötétül',
    'booking.select_vehicle_model': 'Válassza ki a jármű modelljét',
    'booking.selected_type_value': 'Kiválasztva: {{value}}',
    'booking.select_a_vehicle_type': 'Válasszon járműtípust:',
    'booking.select_vehicle_weight': 'Válassza ki a jármű tömegét',
    'booking.selected_weight_kg': 'Kiválasztva: {{value}} kg',
    'booking.adjust_weight': 'Állítsa be a súlyt',
    'Dates updated successfully': 'A dátumok sikeresen frissítve',
    'Error updating dates': 'Hiba a dátumok frissítésekor',
    'Set Planned Dates': 'Állítsa be a tervezett dátumokat',
    'Set your planned pickup and arrival dates below.':
      'Állítsa be a tervezett átvételi és érkezési dátumokat alább.',
    'Changing dates after initial setup will deduct 20% from your performance score for this order.':
      'A kezdeti beállítás utáni dátumok módosítása 20%-ot von le a rendelés teljesítménypontszámából.',
    'Planned Pickup Date': 'Tervezett átvételi dátum',
    'Planned Arrival Date': 'Tervezett érkezési dátum',
    Listing: 'Felsorolás',
    'Try broadening the current search or status filter.':
      'Próbálja kiszélesíteni az aktuális keresést vagy állapotszűrőt.',
    'Try broadening the search, role, or status filters.':
      'Próbálja kibővíteni a keresési, szerep- vagy állapotszűrőket.',
    'Monitor fleet compliance, validation status, and expiring insurance in one place.':
      'Egy helyen nyomon követheti a flotta megfelelőségét, az érvényesítési állapotot és a lejáró biztosítást.',
    'Active Listings': 'Aktív listák',
    'Open transport requests': 'Nyissa meg a szállítási kérelmeket',
    'Quotes Today': 'Idézetek ma',
    'Submitted in last 24h': 'Beküldve az elmúlt 24 órában',
    'Platform Revenue (MTD)': 'Platform bevétel (MTD)',
    'Month to date': 'Hónap a mai napig',
    'Pending Partners': 'Függőben lévő partnerek',
    'Awaiting approval': 'Jóváhagyásra vár',
    'Unpaid Invoices': 'Kifizetetlen számlák',
    'Requires action': 'Intézkedést igényel',
    'Completed Transports': 'Befejezett szállítások',
    'All time delivered': 'Mindig szállítva',
    'Admin Dashboard': 'Rendszergazdai irányítópult',
    'Platform overview and key performance indicators.':
      'A platform áttekintése és a fő teljesítménymutatók.',
    'Loading dashboard metrics...': 'Az irányítópult mutatóinak betöltése...',
    Invoices: 'Számlák',
    'Review payout invoices uploaded by partners and keep payout processing organized.':
      'Tekintse át a partnerek által feltöltött kifizetési számlákat, és tartsa megszervezve a kifizetések feldolgozását.',
    Flexible: 'Rugalmas',
    'Flexible dates': 'Rugalmas időpontok',
    'Could not load this listing.': 'Nem sikerült betölteni ezt az adatlapot.',
    'Listing canceled': 'Listázás törölve',
    'Failed to cancel listing': 'Nem sikerült törölni a listát',
    Reference: 'Hivatkozás',
    Category: 'Kategória',
    'Client type': 'Ügyfél típusa',
    'Company country': 'A cég országa',
    Expires: 'Lejár',
    'Back to listings': 'Vissza a listákhoz',
    'Listing not found.': 'A lista nem található.',
    'Cancel Listing': 'Listázás törlése',
    'Listing details': 'A lista részletei',
    'Reference {{id}}': 'Hivatkozás {{id}}',
    'Read-only listing overview for admins.':
      'Csak olvasható lista áttekintése rendszergazdák számára.',
    'Pick-up': 'Felvétel',
    'No exact coordinates are stored for this listing yet.':
      'Ehhez az adatlaphoz még nincsenek tárolva pontos koordináták.',
    'Structured overview of quantities and handling details.':
      'A mennyiségek és kezelési részletek strukturált áttekintése.',
    'Shipment images': 'Szállítási képek',
    'No shipment images were uploaded for this listing.':
      'Ehhez az adatlaphoz nem töltöttek fel szállítmányképet.',
    'Proof of pickup': 'Az átvétel igazolása',
    'Final documents': 'Végső dokumentumok',
    Description: 'Leírás',
    'Quotes ({{count}})': 'Idézetek ({{count}})',
    'Loading quotes...': 'Árajánlatok betöltése...',
    'No quotes for this listing.': 'Ehhez az adatlaphoz nincsenek idézetek.',
    'Score: {{score}}/100': 'Pontszám: {{score}}/100',
    'Pickup: {{date}}': 'Átvétel: {{date}}',
    'Delivery: {{date}}': 'Szállítás: {{date}}',
    'Cancel Listing?': 'Törli a listát?',
    'This will permanently cancel the listing and notify the client. Continue?':
      'Ezzel véglegesen törli a listát, és értesíti az ügyfelet. Folytatja?',
    Keep: 'Tartsa',
    'Review partner applications, check their documents, and keep approval decisions consistent.':
      'Tekintse át a partnerek jelentkezését, ellenőrizze dokumentumaikat, és tartsa konzisztens jóváhagyási döntéseket.',
    'No client payments recorded yet':
      'Még nincsenek rögzítve az ügyfelek kifizetései',
    'Client payment rows will appear here when the payments backend is connected.':
      'Az ügyfél fizetési sorai jelennek meg itt, amikor a fizetési háttérrendszer csatlakozik.',
    Method: 'módszer',
    'No partner payouts recorded yet':
      'Még nem rögzítettek partnerkifizetéseket',
    'Payout rows will appear here once partner payout processing is enabled.':
      'A kifizetési sorok itt jelennek meg, amint engedélyezve van a partnerkifizetések feldolgozása.',
    'Payout Amount': 'Kifizetés összege',
    'No platform fees recorded yet': 'Még nem rögzítették a platformdíjakat',
    'Fee rows will appear here once payment settlement data is available.':
      'A díjsorok itt jelennek meg, amint rendelkezésre állnak a fizetési elszámolási adatok.',
    Gross: 'Bruttó',
    'Fee (20%)': 'díj (20%)',
    Payments: 'Kifizetések',
    'Client payments, partner payouts, and platform fee tracking.':
      'Ügyfélfizetések, partnerkifizetések és platformdíjak követése.',
    'Client Payments': 'Ügyfélfizetések',
    'Partner Payouts': 'Partnerkifizetések',
    'Platform Fees': 'Platformdíjak',
    'Failed to load reviews': 'Nem sikerült betölteni a véleményeket',
    'Review removed': 'A vélemény eltávolítva',
    'Failed to remove review': 'Nem sikerült eltávolítani a véleményt',
    Reviews: 'Vélemények',
    'All partner and transport reviews submitted by clients.':
      'Az ügyfelek által benyújtott összes partner- és szállítási vélemény.',
    'Loading reviews...': 'Vélemények betöltése...',
    'No reviews found': 'Nem található értékelés',
    'Client feedback will appear here when reviews are submitted.':
      'Az ügyfelek visszajelzései itt jelennek meg, amikor a véleményeket elküldik.',
    Stars: 'Csillagok',
    Comment: 'Megjegyzés',
    'Search, review, and maintain user accounts with one consistent admin workflow.':
      'A felhasználói fiókok keresése, áttekintése és karbantartása egyetlen következetes adminisztrátori munkafolyamattal.',
    'Track paid and unpaid partner payout invoices, and upload the next delivered listing invoice quickly.':
      'Kövesse nyomon a kifizetett és kifizetetlen partnerek kifizetési számláit, és gyorsan töltse fel a következő kézbesített listás számlát.',
    'Search by invoice number, file name, or listing ID':
      'Keresés számlaszám, fájlnév vagy listaazonosító alapján',
    'Loading delivered listings...': 'Kézbesített adatok betöltése...',
    'Search delivered listing by reference, title, or route':
      'Keressen a szállított listában hivatkozás, cím vagy útvonal alapján',
    'Route details available in listing':
      'Az útvonal részletei a listában találhatók',
    'No matching delivered listings': 'Nincsenek megfelelő kézbesített adatok',
    'Selected listing': 'Kiválasztott lista',
    'Has quotes': 'Idézetek vannak',
    'In transit': 'Átszállításban',
    Open: 'Nyissa meg',
    Accepted: 'Elfogadva',
    Completed: 'Befejezve',
    'Client Dashboard': 'Ügyfél irányítópultja',
    'Overview of your current transport listings, quote activity, and recent requests.':
      'Áttekintés az aktuális szállítási listáiról, az ajánlattevékenységekről és a legutóbbi kérésekről.',
    'Total listings': 'Összes lista',
    'Active listings': 'Aktív listák',
    'Listings with quotes': 'Listákat idézőjelekkel',
    'Accepted transport': 'Elfogadott szállítás',
    'Listing status timeline': 'A lista állapotának idővonala',
    'Last 6 months of listings grouped by current status.':
      'Az elmúlt 6 hónap adatai az aktuális állapot szerint csoportosítva.',
    'No listing activity yet': 'Még nincs listázási tevékenység',
    'Create your first listing to start tracking request activity here.':
      'Hozza létre első bejegyzését, hogy itt követhesse nyomon a kéréseket.',
    'Create new listing': 'Új adatlap létrehozása',
    'Create a new transport request for the marketplace.':
      'Hozzon létre egy új szállítási kérelmet a piactérhez.',
    'View my listings': 'Tekintse meg hirdetéseimet',
    'Review quote activity and manage your transport requests.':
      'Tekintse át az ajánlattevékenységet és kezelje szállítási kéréseit.',
    'Recent listings': 'Legutóbbi listák',
    'No listings yet': 'Még nincsenek listák',
    'Your newest transport requests will appear here once you create them.':
      'A legújabb szállítási kérelmei itt jelennek meg, miután létrehozta őket.',
    'Unknown origin': 'Ismeretlen eredet',
    '{{count}} quote(s)': '{{count}} idézet',
    '{{value}} completed listings': '{{value}} elkészült listák',
    'Monitor current performance, fleet readiness, quote flow, and your active transport queue.':
      'Kövesse nyomon az aktuális teljesítményt, a flotta készenlétét, az ajánlatfolyamatokat és az aktív szállítási sort.',
    'Total assigned': 'Összesen hozzárendelve',
    'Quarter rating': 'Negyedéves minősítés',
    'Based on current quarter performance':
      'A jelenlegi negyedéves teljesítmény alapján',
    Rating: 'Értékelés',
    'Requirement met': 'A követelmény teljesült',
    'Requirement not met': 'A követelmény nem teljesül',
    'Completed listings per period': 'Elkészült listák időszakonként',
    'No completion data yet': 'Még nincsenek befejezési adatok',
    'Statistics will appear here after your first delivered work.':
      'A statisztikák az első kézbesített munka után jelennek meg itt.',
    'Completed listings': 'Elkészült a listák',
    'Review truck documents and refresh anything close to expiry.':
      'Tekintse át a teherautó dokumentumait, és frissítsen mindent, ami a lejárathoz közeledik.',
    'Search deliveries': 'Szállítások keresése',
    'Review available marketplace listings and submit quotes.':
      'Tekintse át a rendelkezésre álló piacterek listáját, és nyújtson be árajánlatot.',
    'My quotes': 'Az én idézeteim',
    'Track accepted, pending, and rejected quotes in one place.':
      'Nyomon követheti az elfogadott, függőben lévő és elutasított árajánlatokat egy helyen.',
    'Profile settings': 'Profilbeállítások',
    'Keep company information and compliance details up to date.':
      'Tartsa naprakészen a vállalati információkat és a megfelelőségi adatokat.',
    'No active queue items': 'Nincsenek aktív sorelemek',
    'Accepted and in-progress work will appear here as your transport activity grows.':
      'Az elfogadott és folyamatban lévő munkák itt jelennek meg, ahogy a szállítási tevékenysége nő.',
    'Your role does not have permission to open this page.':
      'Az Ön szerepkörének nincs engedélye az oldal megnyitásához.',
    'Go to dashboard': 'Ugrás az irányítópultra',
    'Trailer capacity is required.': 'Az utánfutó kapacitása szükséges.',
    'How many cars can this trailer carry?':
      'Hány autót tud elvinni ez a pótkocsi?',
    'Set maximum number of cars this trailer can carry (1-20).':
      'Állítsa be a pótkocsi által szállítható autók maximális számát (1-20).',
    'Invalid max load (kg).': 'Érvénytelen maximális terhelés (kg).',
    'Enter a valid weight between 1 and 100000 kg, or leave it empty.':
      'Adjon meg egy érvényes súlyt 1 és 100 000 kg között, vagy hagyja üresen.',
    'Maximum payload weight this truck can carry (optional).':
      'A teherautó által szállítható maximális teherbírás (opcionális).',
    'Manage the company and contact details that appear across your listings, invoices, and account verification flows.':
      'Kezelje az adatlapokon, számlákon és fiókellenőrzési folyamatokban megjelenő vállalati és kapcsolatfelvételi adatokat.',
    'Keep these details up to date so listings, invoices, and partner verification stay accurate.':
      'Tartsa naprakészen ezeket az adatokat, hogy a listák, a számlák és a partnerellenőrzés pontosak maradjanak.',
    'Unsaved changes': 'Nem mentett módosítások',
    'All changes saved': 'Minden változtatás mentve',
    'auth.sign_up_failed': 'A regisztráció sikertelen',
    'auth.please_select_a_valid_role': 'Kérjük, válasszon érvényes szerepet.',
    'booking.pickup_not_found': 'Az átvétel nem található.',
    'booking.delivery_not_found': 'A kiszállítás nem található.',
    'booking.capacity': 'Kapacitás',
    'booking.cmr_expiry': 'CMR lejárat',
    'booking.uploaded': 'Feltöltve',
    'booking.missing': 'Hiányzik',
    'booking.cmr_document': 'CMR dokumentum',
    'booking.go_to_profile': 'Lépjen a Profilra',
    'booking.click_to_download_purchase_terms':
      'Kattintson a Vásárlási feltételek letöltéséhez',
    'admin.purchase_terms_management': 'Vásárlási feltételek kezelése',
    'admin.purchase_terms_management_subtitle':
      'Töltsön fel és tartson fenn lokalizált beszerzési feltételek PDF-fájlokat, amelyeket a partnerrendelések elfogadásához használnak.',
    'admin.document_language': 'A dokumentum nyelve',
    'admin.click_to_download_purchase_terms':
      'Kattintson a Vásárlási feltételek letöltéséhez',
    'admin.current_language_label': 'Jelenlegi nyelv: {{language}}',
    'admin.purchase_terms_unavailable_for_selected_language':
      'A vásárlási feltételek dokumentuma nem érhető el a kiválasztott nyelven.',
    'Download and review the active purchase terms in your current interface language before continuing.':
      'A folytatás előtt töltse le és tekintse át az aktív vásárlási feltételeket az aktuális kezelőfelület nyelvén.',
    'We make agreements and conclude a contract for the carriage of goods. I have just read this agreement in full and agree to its contents.':
      'Megállapodásokat kötünk és szerződést kötünk áruszállításra. Most olvastam el ezt a megállapodást, és elfogadom a benne foglaltakat.',
    'I confirm that I will schedule this order within 24 hours':
      'Megerősítem, hogy ezt a rendelést 24 órán belül ütemezem',
    'Failed to load purchase terms document.':
      'Nem sikerült betölteni a vásárlási feltételek dokumentumát.',
    'Partner rating': 'Partner minősítés',
    'Bronze requirements': 'Bronz követelmények',
    'Orders in quarter': 'Megrendelések negyedévben',
    'Cancellation rate / 100 orders': 'Lemondási arány / 100 rendelés',
    'Damage claims / 100 orders': 'Kártérítési igények / 100 megrendelés',
    '{{current}} / min {{target}}': '{{current}} / perc {{target}}',
    '{{current}} / max {{target}}': '{{current}} / max {{target}}',
    Met: 'Met',
    'Not met': 'Nem találkozott',
    Unranked: 'Nem rangsorolt',
    'profile.incompleteDescriptionPartner':
      'Kérjük, töltse ki profiladatait (Vállalat, Telefonszám, Cím, Város, Irányítószám, ÁFA szám) az összes funkció eléréséhez.',
    'profile.incompleteDescriptionClient':
      'Kérjük, töltse ki profiladatait (telefonszáma) az összes funkció eléréséhez.',
    'auth.verification_email_sent': 'Ellenőrző e-mail elküldve',
    '{{amount}} above the client target': '{{amount}} az ügyfélcél felett',
    '{{amount}} below the client target': '{{amount}} az ügyfélcél alatt',
    '{{count}} image(s) added to the listing.':
      '{{count}} kép hozzáadva a listához.',
    '{{count}} quote(s) received': '{{count}} árajánlat érkezett',
    '{{count}} reviews': '{{count}} értékelés',
    '{{count}} total': '{{count}} összesen',
    '{{count}} visible': '{{count}} látható',
    '{{weight}} kg': '{{weight}} kg',
    'A Google route preview with pins A and B appears here once pickup and delivery coordinates are available.':
      'Itt jelenik meg a Google útvonal előnézete az A és B tűkkel, ha rendelkezésre állnak a felvételi és szállítási koordináták.',
    'A route preview appears once map coordinates are available.':
      'Egy útvonal előnézete jelenik meg, ha a térkép koordinátái elérhetők.',
    'A timeline of clarifications connected to this listing.':
      'Az ehhez a listához kapcsolódó pontosítások ütemezése.',
    "Accept {{partner}}'s quote for {{amount}}?":
      'Elfogadja {{partner}} {{amount}} árajánlatát?',
    'Accept Listing': 'Listázás elfogadása',
    'Accept quote': 'Ajánlat elfogadása',
    'Accepted quote': 'Elfogadott árajánlat',
    'Accepted quote required': 'Elfogadott árajánlat szükséges',
    'Accepting...': 'Elfogadás...',
    Active: 'Aktív',
    'Active statuses': 'Aktív állapotok',
    'Add another item': 'Adjon hozzá egy másik elemet',
    'Add images': 'Képek hozzáadása',
    'Add more shipment images': 'Adjon hozzá további képeket a szállítmányról',
    'After you confirm an AI action, open the prepared destination immediately instead of waiting for a manual click.':
      'Miután megerősítette az AI-műveletet, azonnal nyissa meg az előkészített célt ahelyett, hogy a kézi kattintásra várna.',
    'AI Assistant': 'AI-asszisztens',
    'AI assistant disabled for all users.':
      'Az AI-asszisztens minden felhasználó számára letiltva.',
    'AI assistant enabled for all users.':
      'Az AI-asszisztens minden felhasználó számára engedélyezett.',
    'AI assistant preferences updated':
      'Az AI-asszisztens beállításai frissítve',
    'AI disabled for user.': 'Az AI letiltva a felhasználó számára.',
    'AI enabled for user.': 'AI engedélyezve a felhasználó számára.',
    'AI-powered message translation between languages':
      'AI-alapú üzenetfordítás nyelvek között',
    'All route-critical information in one place before you review quotes or documents.':
      'Az összes útvonal-kritikus információ egy helyen, mielőtt áttekinti az árajánlatokat vagy dokumentumokat.',
    View: 'Megtekintés',
    Answer: 'Válasz',
    Archive: 'Archívum',
    'Archived statuses': 'Archivált állapotok',
    'Are you sure you want to reject the quote from':
      'Biztos, hogy vissza akarja utasítani a(z) ajánlatot?',
    'Ask a question about this listing...':
      'Tegyen fel kérdést ezzel az adatlappal kapcsolatban...',
    'Ask for matching lanes, quote help, or the next operational step.':
      'Kérjen egyező sávokat, kérjen segítséget vagy a következő műveleti lépést.',
    'Ask for quote comparisons or a prepared next step from this shipment screen.':
      'Kérjen árajánlat-összehasonlítást vagy előkészített következő lépést erről a szállítási képernyőről.',
    'Assistant history cleared': 'Az asszisztens előzményei törölve',
    'Automatically translate messages from other users into your preferred language using AI.':
      'Más felhasználók üzeneteinek automatikus lefordítása a kívánt nyelvre az AI segítségével.',
    'Back to listing': 'Vissza a listához',
    'Best offer': 'Legjobb ajánlat',
    'Best quote': 'Legjobb idézet',
    'Body type: {{type}}': 'Testtípus: {{type}}',
    'Breed: {{breed}}': 'Fajta: {{breed}}',
    Budget: 'Költségvetés',
    'Cancel listing': 'Törölje a listát',
    'Canceled and completed work will appear here once listings move out of the active view.':
      'A törölt és befejezett munkák itt jelennek meg, amint a listák kikerülnek az aktív nézetből.',
    'Cargo Details': 'Rakomány részletei',
    Categories: 'Kategóriák',
    'Choose the interface language. This preference is saved locally and applies immediately.':
      'Válassza ki a felület nyelvét. Ezt a preferenciát a rendszer helyileg menti, és azonnal érvényesül.',
    'Clear all': 'Minden törlése',
    'Clear assistant history': 'Az asszisztens előzményeinek törlése',
    'Client price in EUR': 'Ügyfélár EUR-ban',
    'Client target price': 'Ügyfél irányár',
    'Complete the payment below to lock the fixed-price acceptance and let the partner start planning.':
      'Hajtsa végre az alábbi fizetést a fix áras elfogadás zárolásához, és hagyja, hogy a partner elkezdje a tervezést.',
    'Complete the payment below to lock the selected quote and let the partner start planning.':
      'Hajtsa végre az alábbi fizetést a kiválasztott árajánlat zárolásához, és hagyja, hogy a partner elkezdje a tervezést.',
    'Compose area prepared for listing Q&A. Submission remains disabled until the live question endpoint is connected on this page.':
      'Írja be a Q&A listázásához előkészített területet. A beküldés le van tiltva mindaddig, amíg az élő kérdés végpontja nem kapcsolódik ezen az oldalon.',
    'Confirm delivery complete': 'Erősítse meg a szállítás befejezését',
    'Confirm payment received': 'Erősítse meg a fizetés megérkezését',
    'Confirm that you have received the bank transfer or payment for this listing. This will move the listing to Paid status and allow the partner to mark it as planned.':
      'Erősítse meg, hogy megkapta az adatok banki átutalását vagy kifizetését. Ezzel a listát Fizetett állapotba helyezi, és lehetővé teszi a partner számára, hogy tervezettnek jelölje meg.',
    'Confirm the exact fleet and dates before the listing moves to Planned.':
      'Erősítse meg a pontos flottát és dátumokat, mielőtt a lista a Tervezett oldalra kerül.',
    'Confirm Transport Plan': 'Erősítse meg a szállítási tervet',
    'Confirming...': 'Megerősítés...',
    'Control how the web assistant behaves on this device. These settings do not change your account data.':
      'Szabályozza, hogy a webes asszisztens hogyan viselkedjen ezen az eszközön. Ezek a beállítások nem változtatják meg fiókadatait.',
    'Create listing': 'Lista létrehozása',
    'Create with AI': 'Hozzon létre AI-val',
    'Create your next transport request and it will appear here with route, item, and quote activity.':
      'Hozza létre a következő szállítási kérelmét, és itt megjelenik az útvonallal, cikkel és ajánlattevékenységgel.',
    'Current stage:': 'Jelenlegi szakasz:',
    'Current status': 'Jelenlegi állapot',
    'Delivery confirmation needed': 'Szállítási visszaigazolás szükséges',
    'Delivery radius': 'Szállítási sugár',
    'Delivery:': 'Szállítás:',
    'Describe the route and cargo, then review the prepared listing draft before publishing.':
      'Ismertesse az útvonalat és a rakományt, majd a közzététel előtt tekintse át az elkészített listatervezetet.',
    'Describe the shipment you need and review the prepared request before publishing.':
      'Ismertesse a szükséges szállítmányt, és a közzététel előtt tekintse át az elkészített kérelmet.',
    'Download and review the purchase terms before confirming the transport plan.':
      'Töltse le és tekintse át a vásárlási feltételeket a szállítási terv megerősítése előtt.',
    'Download invoice': 'Számla letöltése',
    'Download Purchase Terms': 'Töltse le a Vásárlási feltételeket',
    'Draft with AI': 'Vázlat AI-val',
    'Draft your review first, then submit it here when you are satisfied.':
      'Először készítse el véleményét, majd küldje el ide, ha elégedett.',
    'Edit listing': 'Lista szerkesztése',
    'Edit Quote': 'Idézet szerkesztése',
    Enable: 'Engedélyezés',
    'Enable live translation': 'Élő fordítás engedélyezése',
    'Enabled Users': 'Engedélyezett felhasználók',
    'Engagement Activity': 'Eljegyzési tevékenység',
    'Expires:': 'Lejár:',
    'Failed to accept listing': 'Nem sikerült elfogadni a listát',
    'Failed to accept quote': 'Nem sikerült elfogadni az árajánlatot',
    'Failed to clear assistant history':
      'Nem sikerült törölni az asszisztens előzményeit',
    'Failed to complete listing': 'Nem sikerült a listázás befejezése',
    'Failed to confirm payment': 'Nem sikerült megerősíteni a fizetést',
    'Failed to confirm transport plan':
      'Nem sikerült megerősíteni a szállítási tervet',
    'Failed to disable AI for user.':
      'Nem sikerült letiltani az AI-t a felhasználó számára.',
    'Failed to enable AI for user.':
      'Nem sikerült engedélyezni az AI-t a felhasználó számára.',
    'Failed to load listing.': 'Nem sikerült betölteni a listát.',
    'Failed to load listings': 'Nem sikerült betölteni a listákat',
    'Failed to load listings. Please try again.':
      'Nem sikerült betölteni a listákat. Kérjük, próbálja újra.',
    'Failed to load review context.':
      'Nem sikerült betölteni a véleménykörnyezetet.',
    'Failed to load settings.': 'Nem sikerült betölteni a beállításokat.',
    'Failed to refresh Stripe payment status':
      'Nem sikerült frissíteni a Stripe fizetési állapotot',
    'Failed to reject quote': 'Nem sikerült elutasítani az árajánlatot',
    'Failed to release listing': 'Nem sikerült közzétenni a listát',
    'Failed to save quote': 'Nem sikerült menteni az árajánlatot',
    'Failed to update listing': 'Nem sikerült frissíteni a listát',
    'Failed to update preferred language':
      'Nem sikerült frissíteni a preferált nyelvet',
    'Failed to update setting.': 'Nem sikerült frissíteni a beállítást.',
    'Failed to update status': 'Nem sikerült frissíteni az állapotot',
    'Failed to update translation preference':
      'Nem sikerült frissíteni a fordítási beállításokat',
    'Failed to update watchlist': 'Nem sikerült frissíteni a figyelőlistát',
    'Failed to withdraw quote': 'Nem sikerült visszavonni az árajánlatot',
    'Feature Flags': 'Jellemző zászlók',
    'Filter invoice uploads, search by reference, and page through payout records.':
      'Szűrje a számlafeltöltéseket, keressen hivatkozás alapján, és lapozzon a kifizetési rekordok között.',
    Filters: 'Szűrők',
    'Final delivery documents': 'Végső szállítási dokumentumok',
    'Fixed price only': 'Csak fix ár',
    'Flexible / not set': 'Rugalmas / nincs beállítva',
    'Generated automatically when the transport plan is confirmed.':
      'A szállítási terv megerősítésekor automatikusan generálódik.',
    'Generation: {{generation}}': 'Generáció: {{generation}}',
    'Goods delivered — awaiting client confirmation.':
      'Kiszállított áru – az ügyfél megerősítésére vár.',
    'Gross price': 'Bruttó ár',
    'I have read and agree to the purchase terms for this transport job.':
      'Elolvastam és elfogadom a szállítási munkára vonatkozó vásárlási feltételeket.',
    'I understand that accepting this listing assigns it to me at the fixed client price shown above.':
      'Tudomásul veszem, hogy ennek a kiírásnak az elfogadása a fent látható fix ügyféláron rendeli hozzám.',
    'Image upload failed': 'A kép feltöltése sikertelen',
    'Images uploaded': 'Képek feltöltve',
    'Interface language': 'Interfész nyelve',
    'Invoice documents': 'Számla dokumentumok',
    'Item {{number}}': '{{number}} tétel',
    items: 'tételeket',
    'Keep listing': 'Folytasd a listázást',
    'Keep quote': 'Tartsa meg az idézetet',
    'Keep the current AI session available after closing the browser on this device.':
      'Tartsa elérhetővé az aktuális AI-munkamenetet az eszköz böngészőjének bezárása után.',
    'Language & Region': 'Nyelv és régió',
    'Lift: {{origin}} / {{destination}}': 'Emelő: {{origin}} / {{destination}}',
    Listed: 'Felsorolt',
    'Listing {{id}}': 'Listázás {{id}}',
    'Listing accepted': 'A lista elfogadva',
    'Listing expired': 'A lista lejárt',
    'Listing images': 'Képek listázása',
    'Listing is live': 'A lista élő',
    'Listing reference': 'Listázási hivatkozás',
    'Listing snapshot': 'Listázás pillanatképe',
    'Listing unavailable': 'A lista nem érhető el',
    'Listing updated': 'A lista frissítve',
    'Live Translation': 'Élő fordítás',
    'Live translation disabled.': 'Élő fordítás letiltva.',
    'Live translation enabled.': 'Élő fordítás engedélyezve.',
    'Loading approved trucks...': 'Jóváhagyott teherautók betöltése...',
    'Loading fleet...': 'Flotta betöltése...',
    'Loading listing details...': 'A hirdetés részleteinek betöltése...',
    'Loading listings...': 'Adatok betöltése...',
    'Loading review details...': 'Vélemény részleteinek betöltése...',
    'Loading settings...': 'Beállítások betöltése...',
    'Manage AI Assistant Users': 'Az AI-asszisztens-felhasználók kezelése',
    'Manage platform-wide feature flags and configuration.':
      'A platformszintű funkciójelzők és konfigurációk kezelése.',
    'Manage Users': 'Felhasználók kezelése',
    'Manage your transport requests, monitor quote activity, and keep active and archived work easy to scan.':
      'Kezelje szállítási kéréseit, figyelje az ajánlattevékenységet, és tartsa könnyen áttekinthetővé az aktív és archivált munkákat.',
    'Mark Picked Up': 'Mark felvette',
    'Matches the client target price': 'Megfelel az ügyfél irányárának',
    Media: 'Média',
    Messages: 'Üzenetek',
    'Messages will be translated into this language.':
      'Az üzeneteket erre a nyelvre fordítjuk le.',
    'Minimum net:': 'Minimális nettó:',
    'My invoices': 'A számláim',
    Net: 'Net',
    'Net price': 'Nettó ár',
    'Net quote': 'Nettó idézet',
    'New images appear immediately in the listing details for client, partner, and admin views.':
      'Az új képek azonnal megjelennek az adatlap adatai között ügyfél-, partner- és adminisztrátori nézetben.',
    'Next step': 'Következő lépés',
    'No active listings yet': 'Még nincsenek aktív listák',
    'No address provided': 'Nincs megadva cím',
    'No answer yet.': 'Még nincs válasz.',
    'No archived listings yet': 'Még nincsenek archivált adatok',
    'No description added.': 'Nincs leírás hozzáadva.',
    'no destination': 'nincs úti cél',
    'No expiry': 'Nincs lejárat',
    'No listings match the current filters. Try broadening the search or date range.':
      'Egyetlen adat sem felel meg a jelenlegi szűrőknek. Próbálja kiszélesíteni a keresést vagy a dátumtartományt.',
    'no origin': 'nincs eredete',
    'No questions yet': 'Még nincs kérdés',
    'No quotes yet': 'Még nincsenek idézetek',
    'No shipment images uploaded yet.':
      'Még nem töltöttek fel képeket a szállítmányról.',
    'No trailer selected': 'Nincs kiválasztott előzetes',
    'No unread messages': 'Nincsenek olvasatlan üzenetek',
    'No users found.': 'Nem található felhasználó.',
    'No users have AI enabled.':
      'Egyetlen felhasználó sem engedélyezte az AI-t.',
    'Not selected': 'Nincs kiválasztva',
    'Offers summary': 'Ajánlatok összefoglalója',
    'Open AI assistant': 'Nyissa meg az AI-asszisztenst',
    'Open prepared screens automatically':
      'Az előkészített képernyők automatikus megnyitása',
    'Optional visible price shown to partners as your target budget.':
      'Opcionálisan látható ár, amely megjelenik a partnerek számára célköltségkeretként.',
    'Other quotes will be declined automatically once this offer is accepted.':
      'A többi árajánlatot a rendszer automatikusan elutasítja, amint ezt az ajánlatot elfogadják.',
    'Partner delivery': 'Partner szállítás',
    'Partner pickup': 'Partner átvétel',
    'Partner quote': 'Partner ajánlat',
    'Payment confirmed': 'Fizetés megerősítve',
    'Payment confirmed — listing status set to paid':
      'Fizetés megerősítve – a lista állapota fizetettre van állítva',
    'Payment confirmed. Confirm the assigned fleet and planned dates before the listing moves to Planned.':
      'Fizetés megerősítve. Erősítse meg a hozzárendelt flottát és a tervezett dátumokat, mielőtt a lista a Tervezett közé kerül.',
    'Payment is confirmed. The partner now needs to confirm the truck, driver, and planned dates.':
      'A fizetés visszaigazolva. A partnernek most meg kell erősítenie a teherautót, a sofőrt és a tervezett dátumokat.',
    'Payment required': 'Fizetés szükséges',
    'Photos uploaded for the shipment and visible across client, partner, and admin views.':
      'A szállítmányhoz feltöltött, ügyfél-, partner- és adminisztrátori nézetben látható fotók.',
    'Pickup is complete and the transport is currently underway.':
      'Az átvétel befejeződött, a szállítás jelenleg zajlik.',
    'Pickup proof': 'Felvétel igazolás',
    'Pickup proof and final delivery files uploaded by the transport partner.':
      'A szállítási partner által feltöltött átvételt igazoló és végső kiszállítási fájlok.',
    'Pickup to delivery overview': 'Átvétel a szállításig',
    'Pickup:': 'Átvétel:',
    'Plan and authorization': 'Terv és felhatalmazás',
    'Plan transport': 'Tervezze meg a közlekedést',
    'Plan Transport': 'Tervezze meg a közlekedést',
    'Planned dates:': 'Tervezett időpontok:',
    'Planned delivery date': 'Tervezett szállítási dátum',
    'Platform Settings': 'Platform beállítások',
    'Preferred language': 'Előnyben részesített nyelv',
    'Preferred language updated': 'A preferált nyelv frissítve',
    'Prepare a quote or ask for the next lane action, then confirm before anything is submitted.':
      'Készítsen árajánlatot, vagy kérje a következő sáv műveletet, majd erősítse meg, mielőtt bármit benyújtana.',
    'Purchase Terms': 'Vásárlási feltételek',
    'Quantities, dimensions, and handling details ready for transport review.':
      'A mennyiségek, méretek és kezelési adatok készen állnak a szállításra.',
    Question: 'kérdés',
    Questions: 'Kérdések',
    'Questions & answers': 'Kérdések és válaszok',
    'Questions and answers for this listing will appear here once the messaging flow is active.':
      'Az ehhez a listához tartozó kérdések és válaszok itt jelennek meg, amint az üzenetküldési folyamat aktív.',
    'Quick access to the current shipment, quote, and billing state.':
      'Gyors hozzáférés az aktuális szállítmányhoz, árajánlathoz és számlázási állapothoz.',
    'Quote accepted': 'Az árajánlat elfogadva',
    'Quote count': 'Idézetek száma',
    'Quote message': 'Idézet üzenetet',
    'Quote rejected': 'Az idézet elutasítva',
    'Quote withdrawn': 'Az idézet visszavonva',
    Quotes: 'Idézetek',
    'Quotes and questions': 'Idézetek és kérdések',
    'Quotes are disabled for this listing. The first partner to accept the fixed price will be assigned automatically.':
      'Az idézetek le vannak tiltva ennél a hirdetésnél. Az első partner, aki elfogadja a rögzített árat, automatikusan hozzárendelésre kerül.',
    'Quotes are disabled for this shipment. If you accept it, the client price becomes an accepted booking immediately.':
      'Az árajánlatok le vannak tiltva ennél a szállítmánynál. Ha elfogadja, az ügyfélár azonnal elfogadott foglalássá válik.',
    'Quotes from transport providers usually begin to appear shortly after publishing. Refresh to check again.':
      'A közlekedési szolgáltatóktól származó idézetek általában röviddel a közzététel után jelennek meg. Frissítse az újbóli ellenőrzéshez.',
    'Reference #{{id}}': '#{{id}} hivatkozás',
    'Refresh listings': 'Frissítse a listákat',
    'Reject quote': 'Ajánlat elutasítása',
    'Rejecting...': 'Elutasítás...',
    Release: 'Kiadás',
    'Release Listing': 'Kiadási lista',
    'Remember assistant conversation':
      'Emlékezzen az asszisztensi beszélgetésre',
    'Required for fixed-price listings. Partners accept this amount directly.':
      'Kötelező a fix áras listákhoz. A partnerek ezt az összeget közvetlenül elfogadják.',
    'Required. Partners will be able to accept this listing at the fixed client price without sending a quote.':
      'Kívánt. A partnerek ezt a listát a rögzített ügyféláron árajánlat küldése nélkül is elfogadhatják.',
    'Review submission failed.': 'A felülvizsgálat elküldése sikertelen.',
    'Review the completed transport using the standard product flow.':
      'Tekintse át az elkészült szállítást a szabványos termékfolyamat segítségével.',
    'Route pending': 'Útvonal függőben',
    'Save changes': 'Módosítások mentése',
    'Saving...': 'Mentés...',
    'Search by title, route, category, or item':
      'Keresés cím, útvonal, kategória vagy elem szerint',
    'Search Results': 'Keresési eredmények',
    'Search users by email...': 'Felhasználók keresése e-mailben...',
    'Select a truck, driver, pickup date, and delivery date.':
      'Válassza ki a teherautót, a sofőrt, az átvétel dátumát és a szállítási dátumot.',
    'Select approved truck': 'Válassza ki a jóváhagyott teherautót',
    'Select driver': 'Válassza ki az illesztőprogramot',
    'Send Revision': 'Revízió küldése',
    Sentiment: 'Sentiment',
    'Share what went well and what could improve':
      'Oszd meg, mi ment jól, és mi az, ami még javítható',
    'Shipment in transit': 'Szállítás szállítás közben',
    'Shipment notes': 'Szállítási jegyzetek',
    'Shipment tracking will be shared':
      'A szállítmány nyomon követése megosztásra kerül',
    'Show AI launchers': 'AI indítók megjelenítése',
    'Show or hide AI assistant buttons on supported dashboard and listing pages.':
      'Az AI-segéd gombjainak megjelenítése vagy elrejtése a támogatott irányítópulton és a listaoldalakon.',
    'Special needs or notes': 'Különleges igények vagy megjegyzések',
    'Specify delivery dates': 'Adja meg a szállítási dátumokat',
    'Specify pickup dates': 'Adja meg az átvétel dátumát',
    Stage: 'Színpad',
    'Status updated to {{status}}': 'Az állapot frissítve {{status}}-re',
    'Stripe payment confirmed and booking updated':
      'A csíkos fizetés megerősítve és a foglalás frissítve',
    'Stripe status: {{status}}': 'Csík állapota: {{status}}',
    'Submit question': 'Kérdés beküldése',
    'Submit review': 'Vélemény elküldése',
    'Submitting...': 'Beküldés...',
    'The AI assistant is currently disabled for this environment. Existing local session data can still be cleared here.':
      'Az AI-asszisztens jelenleg le van tiltva ebben a környezetben. A meglévő helyi munkamenet-adatok itt továbbra is törölhetők.',
    'The listing expired before a transport was confirmed.':
      'A lista a szállítás megerősítése előtt lejárt.',
    'The listing has been fully completed and archived as a finished transport.':
      'A lista teljesen elkészült és kész szállításként archiválva lett.',
    'The lowest net price you would still accept for this shipment.':
      'A legalacsonyabb nettó ár, amelyet továbbra is elfogadna ennél a szállítmánynál.',
    'The partner has confirmed the route plan. Pickup and delivery dates are now scheduled.':
      'A partner megerősítette az útvonaltervet. Az átvételi és szállítási dátumok már ütemezettek.',
    'The partner marked the shipment as delivered. Review the final documents and confirm completion.':
      'A partner a szállítmányt kézbesítettnek jelölte. Tekintse át a végleges dokumentumokat, és erősítse meg a befejezést.',
    'The partner-confirmed plan and LOA stay grouped together for faster review.':
      'A partner által megerősített terv és a LOA a gyorsabb áttekintés érdekében csoportosítva marad.',
    'This action notifies the transport provider and removes the quote from active consideration.':
      'Ez a művelet értesíti a szállítási szolgáltatót, és eltávolítja az ajánlatot az aktív mérlegelésből.',
    'This listing is archived and no further transport actions are available.':
      'Ez az adatlap archiválva van, és további szállítási műveletekre nincs lehetőség.',
    'This listing needs an accepted quote before a review can be created.':
      'Ehhez az adatlaphoz egy elfogadott árajánlatra van szükség ahhoz, hogy véleményt lehessen létrehozni.',
    'This will soft-cancel the listing and move it to your archive.':
      'Ezzel lágyan törli a listát, és áthelyezi az archívumba.',
    'This will soft-cancel the listing for the client and remove it from active marketplace views.':
      'Ez lágyan törli az ügyfél adatlapját, és eltávolítja az aktív piactéri nézetekből.',
    'Total quote': 'Teljes árajánlat',
    'Tracking not promised': 'Nyomon követés nem ígért',
    'Tracking shared': 'Nyomon követés megosztva',
    'Tracking visibility': 'Nyomon követési láthatóság',
    'Trailer (Optional)': 'Előzetes (opcionális)',
    'Translation preference updated': 'A fordítási beállítás frissítve',
    'Transport completed': 'A szállítás befejeződött',
    'Transport completed.': 'A szállítás befejeződött.',
    'Transport documents': 'Szállítási dokumentumok',
    'Transport marked as complete': 'A szállítás befejezettként megjelölve',
    'Transport package': 'Szállítási csomag',
    'Transport plan confirmed': 'Megerősítették a szállítási tervet',
    'Transport plan updated': 'Közlekedési terv frissítve',
    'Transport planned': 'Szállítás tervezett',
    'Transport Provider': 'Szállítási szolgáltató',
    'Transport providers can review your shipment and send offers.':
      'A szállítmányozók áttekinthetik szállítmányát és ajánlatokat küldhetnek.',
    'Transport stage': 'Szállítási szakasz',
    Truck: 'Teherautó',
    'Truck, driver, trailer, and planned dates for this shipment.':
      'Teherautó, sofőr, pótkocsi és a szállítmány tervezett dátumai.',
    'Try widening the current listing filters.':
      'Próbálja kiszélesíteni az aktuális listaszűrőket.',
    'Unable to upload listing images.':
      'Nem sikerült feltölteni a listát tartalmazó képeket.',
    'Unknown error': 'Ismeretlen hiba',
    'Untitled listing': 'Névtelen lista',
    'Untitled Listing': 'Névtelen lista',
    'Update media': 'Média frissítése',
    'Update transport plan': 'Frissítse a közlekedési tervet',
    'Update Transport Plan': 'Frissítse a közlekedési tervet',
    'Upload a CMR or delivery photos before marking delivered.':
      'Töltsön fel CMR-t vagy szállítási fényképeket a kézbesített jelölés előtt.',
    'Upload a CMR or delivery photos before the listing can move to Delivered.':
      'Töltsön fel CMR- vagy szállítási fényképeket, mielőtt az adatlap átkerülne a Delivered oldalra.',
    'Upload at least one pickup proof before the listing can move to Picked Up.':
      'Töltsön fel legalább egy átvételi igazolást, mielőtt az adatlap átkerülhet az Átvehető oldalra.',
    'Upload final documents': 'Töltsd fel a végleges dokumentumokat',
    'Upload proof of pickup': 'Töltsd fel az átvétel igazolását',
    'Uploading...': 'Feltöltés...',
    'Use fresh photos when the shipment changes or you want to clarify the item condition.':
      'Használjon friss fényképeket, amikor a szállítmány megváltozik, vagy tisztázni szeretné a tétel állapotát.',
    'users enabled': 'felhasználók engedélyezve',
    'Visible to you while quoting. You can still send your own net offer below or above this amount.':
      'Idézés közben látható. Ezen összeg alatt vagy felett továbbra is küldheti saját nettó ajánlatát.',
    'Waiting for partner acceptance': 'Várakozás a partner elfogadására',
    'Waiting for transport planning': 'Várom a közlekedési tervezést',
    'When enabled, messages from other users will be automatically translated to your preferred language.':
      'Ha engedélyezve van, a többi felhasználótól érkező üzeneteket a rendszer automatikusan lefordítja az Ön által preferált nyelvre.',
    Withdraw: 'Visszavonás',
    'Write Review': 'Írjon véleményt',
    'You are about to release this listing back to the marketplace.':
      'Arra készül, hogy visszaadja ezt az adatlapot a piactéren.',
    'You are now the assigned partner for this fixed-price listing.':
      'Mostantól Ön ennek a fix áras adatlapnak a kijelölt partnere.',
    'Your quote has been accepted. Awaiting payment confirmation from the admin before you can begin the job.':
      'Árajánlatát elfogadtuk. A munka megkezdése előtt várja az adminisztrátor fizetési visszaigazolását.',
    'VIN: {{vin}}': 'VIN: {{vin}}',
  },
  sk: {
    to: 'do',
    kg: 'kg',
    Hatchback: 'Hatchback',
    Coupé: 'kupé',
    Superauto: 'Superauto',
    Sedan: 'sedan',
    Crossover: 'Crossover',
    Required: 'Povinné',
    'Change language': 'Zmeniť jazyk',
    'Loading...': 'Načítava sa…',
    'Error:': 'Chyba:',
    Close: 'Zavrieť',
    Yes: 'áno',
    No: 'Nie',
    'Keep order': 'Udržujte poriadok',
    Price: 'Cena',
    'Purchase terms': 'Podmienky nákupu',
    'Power of attorney': 'Splnomocnenie',
    'Transport details': 'Podrobnosti o doprave',
    'Upload damages': 'Odovzdajte škody',
    'Download (PDF)': 'Stiahnuť (PDF)',
    'Mark as picked up': 'Označiť ako vyzdvihnuté',
    'Mark as delivered': 'Označiť ako doručené',
    'Cancel booking': 'Zrušiť rezerváciu',
    'Order marked as picked up': 'Objednávka označená ako vyzdvihnutá',
    'Order marked as delivered': 'Objednávka označená ako doručená',
    'Order canceled': 'Objednávka zrušená',
    'Failed to cancel order': 'Objednávku sa nepodarilo zrušiť',
    'Added {{count}} file(s)': 'Pridané súbory {{count}}',
    Pages: 'Stránky',
    'Awaiting Verification': 'Čaká sa na overenie',
    Profile: 'Profil',
    'Profile Incomplete': 'Profil je neúplný',
    'Please complete your profile information (Company, Phone, Address, City, Post Code) to access all features.':
      'Vyplňte informácie o svojom profile (spoločnosť, telefón, adresa, mesto, PSČ), aby ste získali prístup ku všetkým funkciám.',
    'Go to Profile': 'Prejdite do profilu',
    'Forgot Password': 'Zabudnuté heslo',
    Hello: 'Dobrý deň',
    friend: 'priateľ',
    'Book your transport': 'Zarezervujte si dopravu',
    'fast and easy': 'rýchlo a jednoducho',
    'Keep an eye on the route and quote at a glance.':
      'Dávajte pozor na trasu a citujte na prvý pohľad.',
    Origin: 'Pôvod',
    Destination: 'Cieľ',
    'Postal code': 'PSČ',
    'Calculate to preview': 'Vypočítajte na zobrazenie ukážky',
    "Can't be calculated yet": 'Zatiaľ sa nedá vypočítať',
    'Awaiting payment badge': 'Čaká sa na platbu',
    'Ref {{id}}': 'Ref. {{id}}',
    'Change planning': 'Zmeňte plánovanie',
    'Change driver': 'Zmeniť vodiča',
    'No vehicles listed': 'V zozname nie sú žiadne vozidlá',
    'Order not found.': 'Objednávka sa nenašla.',
    'Not available': 'Nie je k dispozícii',
    'For {{date}}': 'Pre {{date}}',
    'Picked on {{date}}': 'Vybraté na {{date}}',
    'Delivered on {{date}}': 'Dodávané na {{date}}',
    'Loading notification: {{value}}': 'Upozornenie na načítanie: {{value}}',
    'CO₂ compensation: {{value}}': 'Kompenzácia CO₂: {{value}}',
    'Bio fuel: {{value}}': 'Bio palivo: {{value}}',
    Remove: 'Odstrániť',
    'Copy {{label}}': 'Skopírujte {{label}}',
    'Open navigation menu': 'Otvorte navigačnú ponuku',
    'Open menu': 'Otvoriť menu',
    'Error fetching data': 'Chyba pri načítavaní údajov',
    'Not set': 'Nie je nastavené',
    'No opening hours provided': 'Nie sú uvedené žiadne otváracie hodiny',
    'Please select a planned date': 'Vyberte prosím plánovaný dátum',
    Email: 'Email',
    'Saved favorite route filter': 'Uložený filter obľúbenej trasy',
    km: 'km',
    mi: 'mi',
    'Radius search': 'Hľadanie polomeru',
    'City or town': 'Mesto alebo mesto',
    'Country (optional)': 'Krajina (voliteľné)',
    Radius: 'Polomer',
    'Searching…': 'Hľadá sa…',
    'City not found': 'Mesto sa nenašlo',
    'Within {{radius}} {{unit}} of {{place}}':
      'V rámci {{radius}} {{unit}} od {{place}}',
    'Clear radius': 'Jasný polomer',
    'auth.account_status_pending_review': 'Stav účtu: Čaká sa na kontrolu',
    'auth.your_account_is_pending_approval': 'Váš účet čaká na schválenie',
    'auth.upload_your_verification_documents_below_and_we_ll_notify_you_by_email_once_your_account_is_approved':
      'Nižšie nahrajte svoje overovacie dokumenty a po schválení vášho účtu vás upozorníme e-mailom.',
    'auth.check_status': 'Skontrolujte stav',
    'auth.upload_verification_documents': 'Nahrajte overovacie dokumenty',
    'auth.your_uploaded_documents': 'Vaše nahrané dokumenty',
    'auth.back_to_sign_in': 'Späť na prihlásenie',
    role_partner: 'Partner',
    partner: 'Partner',
    admin: 'Admin',
    'Q1 2025': '1. štvrťrok 2025',
    'Q2 2025': '2. štvrťrok 2025',
    'Q3 2025': '3. štvrťrok 2025',
    Andorra: 'Andorra',
    Cyprus: 'Cyprus',
    Kosovo: 'Kosovo',
    Malta: 'Malta',
    'BodyType.Hatchback': 'Hatchback',
    'BodyType.Sedan': 'sedan',
    'BodyType.Crossover': 'Crossover',
    'BodyType.Pickup': 'Vyzdvihnutie',
    'N/A': 'N/A',
    Partner: 'Partner',
    Model: 'Model',
    'Error loading documents': 'Chyba pri načítavaní dokumentov',
    'Are you sure you want to delete this document?':
      'Naozaj chcete odstrániť tento dokument?',
    'Document deleted': 'Dokument bol odstránený',
    'Failed to delete': 'Odstránenie zlyhalo',
    'Failed to get download link': 'Nepodarilo sa získať odkaz na stiahnutie',
    'Status updated': 'Stav bol aktualizovaný',
    'Update failed': 'Aktualizácia zlyhala',
    'Email cannot be changed.': 'Email sa nedá zmeniť.',
    'No documents found.': 'Nenašli sa žiadne dokumenty.',
    'Invoice #': 'faktúra č.',
    'File Name': 'Názov súboru',
    Amount: 'Suma',
    Actions: 'Akcie',
    Download: 'Stiahnuť',
    'Mark Unpaid': 'Označiť ako neplatené',
    'Mark Paid': 'Mark Paid',
    'Please save the record before uploading documents.':
      'Pred odovzdaním dokumentov uložte záznam.',
    'Select a file before uploading.': 'Pred odovzdaním vyberte súbor.',
    'Please enter an invoice number.': 'Zadajte číslo faktúry.',
    'Upload successful': 'Odovzdanie bolo úspešné',
    '{{count}} file(s) uploaded successfully.':
      'Súbory {{count}} boli úspešne nahrané.',
    'Upload failed': 'Nahrávanie zlyhalo',
    'Unable to upload the document.': 'Dokument nie je možné nahrať.',
    'Invoice Number': 'Číslo faktúry',
    'Selected files:': 'Vybrané súbory:',
    Upload: 'Nahrať',
    'Save this record before uploading documents.':
      'Pred odovzdaním dokumentov si tento záznam uložte.',
    'Error approving user': 'Chyba pri schvaľovaní používateľa',
    'Error rejecting user': 'Chyba pri odmietnutí používateľa',
    'Error disabling user': 'Chyba pri deaktivácii používateľa',
    'User marked as VIP': 'Používateľ označený ako VIP',
    'User unmarked as VIP': 'Označenie používateľa ako VIP bolo zrušené',
    'Error marking user as VIP': 'Chyba pri označovaní používateľa ako VIP',
    'Error unmarking user as VIP':
      'Chyba pri rušení označenia používateľa ako VIP',
    'Failed to approve user': 'Používateľa sa nepodarilo schváliť',
    'Failed to reject user': 'Používateľa sa nepodarilo odmietnuť',
    'Failed to disable user': 'Používateľa sa nepodarilo zakázať',
    'Failed to unmark user as VIP':
      'Nepodarilo sa zrušiť označenie používateľa ako VIP',
    'Failed to mark user as VIP': 'Používateľa sa nepodarilo označiť ako VIP',
    'Invoice Management': 'Správa faktúr',
    'All Invoices': 'Všetky faktúry',
    'Manage all invoices uploaded by partners.':
      'Spravujte všetky faktúry nahrané partnermi.',
    'An unexpected error occurred. Please try again.':
      'Vyskytla sa neočakávaná chyba. Skúste to znova.',
    'The email address is not valid.': 'E-mailová adresa nie je platná.',
    'This account has been disabled.': 'Tento účet bol deaktivovaný.',
    'No account found with this email.':
      'S týmto e-mailom sa nenašiel žiadny účet.',
    'Incorrect password. Please try again.':
      'Nesprávne heslo. Skúste to znova.',
    'Invalid email or password. Please check your credentials and try again.':
      'Neplatný e-mail alebo heslo. Skontrolujte svoje poverenia a skúste to znova.',
    'Too many failed attempts. Please try again later or reset your password.':
      'Príliš veľa neúspešných pokusov. Skúste to znova neskôr alebo obnovte heslo.',
    'Network error. Check your connection and try again.':
      'Chyba siete. Skontrolujte pripojenie a skúste to znova.',
    'A verification email has been sent to your email address. Please verify your email before logging in.':
      'Na vašu e-mailovú adresu bol odoslaný overovací e-mail. Pred prihlásením overte svoj e-mail.',
    'Please make sure both passwords are the same.':
      'Uistite sa, že obe heslá sú rovnaké.',
    'Verification email resent!': 'Overovací e-mail bol odoslaný znova!',
    'Please check your inbox.': 'Skontrolujte si doručenú poštu.',
    'You need to log in first': 'Najprv sa musíte prihlásiť',
    'Please sign in to resend the verification email.':
      'Ak chcete znova odoslať overovací e-mail, prihláste sa.',
    'Failed to resend email': 'Opätovné odoslanie e-mailu zlyhalo',
    'Resend verification email': 'Znova odoslať overovací e-mail',
    'Show password': 'Zobraziť heslo',
    'Hide password': 'Skryť heslo',
    'Awaiting verification artwork': 'Čaká sa na overenie umeleckého diela',
    'Account status: Pending review': 'Stav účtu: Čaká sa na kontrolu',
    'Your account is pending approval': 'Váš účet čaká na schválenie',
    "Upload your verification documents below and we'll notify you by email once your account is approved.":
      'Nižšie nahrajte svoje overovacie dokumenty a po schválení vášho účtu vás upozorníme e-mailom.',
    'Check status': 'Skontrolujte stav',
    'Upload verification documents': 'Nahrajte overovacie dokumenty',
    'Your uploaded documents': 'Vaše nahrané dokumenty',
    'Back to sign in': 'Späť na prihlásenie',
    'Hide documents': 'Skryť dokumenty',
    'Email verification required': 'Vyžaduje sa overenie e-mailom',
    'Waiting for email verification': 'Čaká sa na overenie e-mailom',
    'Check your email': 'Skontrolujte si e-mail',
    'We sent your verification link to':
      'Váš overovací odkaz sme odoslali na adresu',
    "Didn't receive it? Check your spam folder or try again.":
      'Nedostali ste to? Skontrolujte priečinok so spamom alebo to skúste znova.',
    'Resend email': 'Znova odoslať e-mail',
    "I've verified my email": 'Overil som svoj e-mail',
    'Redirecting you now.': 'Prebieha presmerovanie.',
    'Email not verified yet': 'E-mail ešte nie je overený',
    'Please click the link in your inbox and try again.':
      'Kliknite na odkaz v doručenej pošte a skúste to znova.',
    'Unable to resend verification email right now.':
      'Momentálne nie je možné znova odoslať overovací e-mail.',
    'Unable to check verification status right now.':
      'Momentálne nie je možné skontrolovať stav overenia.',
    "We've sent a new verification link to your email address.":
      'Na vašu e-mailovú adresu sme odoslali nový overovací odkaz.',
    'We automatically check your verification status every 30 seconds. You can also trigger an instant check after verifying your email.':
      'Stav vášho overenia automaticky kontrolujeme každých 30 sekúnd. Okamžitú kontrolu môžete spustiť aj po overení e-mailu.',
    'We automatically check your verification status every 15 seconds. You can also trigger an instant check after verifying your email.':
      'Stav vášho overenia automaticky kontrolujeme každých 15 sekúnd. Okamžitú kontrolu môžete spustiť aj po overení e-mailu.',
    'Inputs changed. Recalculate the price.':
      'Vstupy sa zmenili. Prepočítajte si cenu.',
    'My Invoices': 'Moje faktúry',
    'Upload New Invoice': 'Nahrajte novú faktúru',
    'Please enter the invoice number and upload the invoice document. It will be reviewed by an administrator.':
      'Zadajte číslo faktúry a nahrajte doklad faktúry. Posúdi ho správca.',
    'Invoice History': 'História faktúr',
    'Client ref · {{clientRef}}': 'Referenčné číslo klienta · {{clientRef}}',
    'Order Documents': 'Objednávkové dokumenty',
    'Upload Proof of Pickup': 'Nahrajte doklad o vyzdvihnutí',
    'Status will be updated to Picked Up after successful upload.':
      'Stav sa po úspešnom odovzdaní aktualizuje na Vyzdvihnuté.',
    'Upload Proof of Delivery': 'Nahrajte potvrdenie o doručení',
    'Status will be updated to Delivered after successful upload.':
      'Stav sa po úspešnom nahraní aktualizuje na Doručené.',
    'Enter first name': 'Zadajte krstné meno',
    'Enter last name': 'Zadajte priezvisko',
    'Enter phone number': 'Zadajte telefónne číslo',
    'Driver updated.': 'Ovládač aktualizovaný.',
    'The driver has been successfully updated.':
      'Ovládač bol úspešne aktualizovaný.',
    'Driver added.': 'Pridaný vodič.',
    'The new driver has been successfully added.':
      'Nový ovládač bol úspešne pridaný.',
    'Driver deleted.': 'Ovládač odstránený.',
    'The driver has been successfully deleted.':
      'Ovládač bol úspešne odstránený.',
    'Trailer updated.': 'Trailer bol aktualizovaný.',
    'The trailer has been successfully updated.':
      'Upútavka bola úspešne aktualizovaná.',
    'Trailer added.': 'Pridaný trailer.',
    'The new trailer has been successfully added.':
      'Nový trailer bol úspešne pridaný.',
    'Trailer deleted.': 'Trailer bol odstránený.',
    'The trailer has been successfully deleted.':
      'Upútavka bola úspešne vymazaná.',
    'User account not found. Please complete registration.':
      'Používateľský účet sa nenašiel. Dokončite registráciu.',
    'No token provided': 'Nebol poskytnutý žiadny token',
    'Token expired': 'Platnosť tokenu vypršala',
    'Token revoked': 'Token bol odvolaný',
    'Invalid ID token': 'Neplatný token ID',
    Unauthorized: 'Neoprávnené',
    'Unauthorized: User not authenticated.':
      'Unauthorized: Používateľ nie je overený.',
    'Unauthorized: User role not found.':
      'Neoprávnené: Rola používateľa sa nenašla.',
    'Forbidden: Your role is not allowed to perform this action.':
      'Zakázané: Vaša rola nemá povolené vykonávať túto akciu.',
    'Forbidden: This action requires a partner role.':
      'Zakázané: Táto akcia vyžaduje rolu partnera.',
    'Forbidden: This action requires a client role.':
      'Zakázané: Táto akcia vyžaduje rolu klienta.',
    'Forbidden: This action requires an admin role.':
      'Zakázané: Táto akcia vyžaduje rolu správcu.',
    'This user has not been approved': 'Tento používateľ nebol schválený',
    'User email has not been verified': 'E-mail používateľa nebol overený',
    'User account has been disabled': 'Používateľský účet bol zakázaný',
    'Booking not found': 'Rezervácia sa nenašla',
    'Route not found': 'Trasa sa nenašla',
    'Pickup location (country and postalCode) is required':
      'Vyžaduje sa miesto vyzdvihnutia (krajina a PSČ).',
    'Delivery location (country and postalCode) is required':
      'Vyžaduje sa miesto doručenia (krajina a PSČ).',
    'Unable to calculate route. Please check the locations and try again.':
      'Nedá sa vypočítať trasa. Skontrolujte miesta a skúste to znova.',
    'Error calculating transport price': 'Chyba pri výpočte ceny dopravy',
    'Booking canceled successfully': 'Rezervácia bola úspešne zrušená',
    'Invalid request.': 'Neplatná požiadavka.',
    'Access denied.': 'Prístup odmietnutý.',
    'Resource not found.': 'Zdroj sa nenašiel.',
    'Request conflict.': 'Konflikt žiadostí.',
    'Invalid data provided.': 'Boli poskytnuté neplatné údaje.',
    'Too many requests. Please try again later.':
      'Príliš veľa žiadostí. Skúste to znova neskôr.',
    'Internal server error. Please try again later.':
      'Interná chyba servera. Skúste to znova neskôr.',
    'Service temporarily unavailable.': 'Služba je dočasne nedostupná.',
    'booking.load_preset': 'Načítať predvoľbu',
    'booking.save_preset_tooltip':
      'Uložte aktuálne filtre ako predvoľbu s rýchlym prístupom',
    'booking.load_preset_tooltip': 'Načítajte uloženú predvoľbu filtra',
    'booking.preset_saved': 'Predvoľba bola uložená',
    'booking.preset_saved_desc': 'Vaša predvoľba filtra bola uložená.',
    'booking.preset_loaded': 'Predvoľba načítaná',
    'booking.preset_load_error': 'Nepodarilo sa načítať predvoľbu',
    'booking.no_preset_saved': 'Zatiaľ nie je uložená žiadna predvoľba',
    'booking.date_from': 'Dátum od',
    'booking.date_to': 'Dátum do',
    'Active filters': 'Aktívne filtre',
    'All booking states': 'Všetky stavy rezervácie',
    'All partners': 'Všetci partneri',
    'All payments': 'Všetky platby',
    'All roles': 'Všetky roly',
    'All statuses': 'Všetky stavy',
    'All Users': 'Všetci používatelia',
    'Are you sure you want to cancel booking {{id}}?':
      'Naozaj chcete zrušiť rezerváciu {{id}}?',
    'Attach the CMR Insurance before finishing truck setup.':
      'Pred dokončením nastavenia nákladného vozidla priložte faktúru CMR.',
    Awaiting: 'Čakanie',
    'Awaiting payout': 'Čaká sa na výplatu',
    'Booking canceled': 'Rezervácia zrušená',
    'Booking marked as paid': 'Rezervácia označená ako zaplatená',
    'Booking released and returned to marketplace':
      'Rezervácia uvoľnená a vrátená na trh',
    'booking.allowed_range': 'Povolený rozsah',
    'booking.assign_transport': 'Priradiť dopravu',
    'booking.back': 'Späť',
    'booking.back_to_summary': 'Späť na zhrnutie',
    'booking.booking_created_but_pickup_document_not_uploaded_upload_from_order_details':
      'Rezervácia bola vytvorená, ale doklad o vyzdvihnutí nebol nahraný. Môžete ho nahrať z Podrobnosti objednávky.',
    'booking.city_not_found': 'Mesto sa nenašlo',
    'booking.city_or_town': 'Mesto alebo mesto',
    'booking.clear_radius': 'Jasný polomer',
    'booking.continue': 'Pokračovať',
    'booking.country_optional': 'Krajina (voliteľné)',
    'booking.delivery_constraint_info':
      'Dátum dodania musí byť v deň vyzdvihnutia alebo po ňom.',
    'booking.delivery_date_cannot_be_earlier_than_pickup_date':
      'Dátum dodania nemôže byť skorší ako dátum vyzdvihnutia',
    'booking.driver': 'Vodič',
    'booking.failed_to_open_letter_of_attorney':
      'Nepodarilo sa otvoriť splnomocnenie',
    'booking.go_to_order': 'Prejdite na Objednať',
    'booking.i_accept_terms': 'Prijímam podmienky',
    'booking.invalid_license_plate_or_vin_length':
      'Neplatná dĺžka ŠPZ alebo VIN.',
    'booking.invalid_vin_format_i_o_q_not_allowed':
      'Neplatný formát VIN. Znaky I, O a Q nie sú povolené.',
    'booking.letter_of_attorney_file_is_empty':
      'Súbor s plnou mocou je prázdny',
    'booking.no_additional_details': 'Žiadne ďalšie podrobnosti',
    'booking.no_vehicle_info': 'Žiadne informácie o vozidle',
    'booking.open_letter_of_attorney': 'Otvorená plná moc',
    'booking.opening_letter_of_attorney': 'Otváracia listina...',
    'booking.order_accepted_successfully': 'Objednávka bola úspešne prijatá',
    'booking.order_cars_exceed_selected_truck_capacity':
      'Táto objednávka obsahuje autá {{orderCars}}, ale vybraná kapacita nákladného vozidla je {{capacity}}.',
    'booking.pickup_constraint_info':
      'Pred pridelením prepravy je povinný dátum vyzdvihnutia.',
    'booking.pickup_document_upload_failed':
      'Odovzdanie dokumentu vyzdvihnutia zlyhalo',
    'booking.preparing_secure_document_preview':
      'Pripravuje sa zabezpečený náhľad dokumentu...',
    'booking.radius_km': 'Polomer (km)',
    'booking.radius_search': 'Hľadanie polomeru',
    'booking.route_and_details': 'Trasa a podrobnosti',
    'booking.schedule': 'Rozvrh',
    'booking.searching': 'Hľadá sa…',
    'booking.select_pickup_and_delivery': 'Vyberte vyzdvihnutie a doručenie',
    'booking.select_pickup_and_delivery_dates_before_confirming':
      'Pred potvrdením vyberte dátumy vyzdvihnutia a doručenia',
    'booking.select_pickup_date': 'Vyberte dátum vyzdvihnutia',
    'booking.select_truck_driver_and_trailer':
      'Vyberte nákladné auto, vodiča a príves',
    'booking.supported_formats_jpg_png_pdf_doc_docx':
      'Podporované formáty: JPG, PNG, PDF, DOC, DOCX',
    'booking.terms_and_conditions': 'Podmienky',
    'booking.terms_text':
      'Potvrdzujem prepravné podmienky a podmienky zodpovednosti.',
    'booking.track_shipment': 'Sledovať zásielku',
    'booking.trailer': 'Trailer',
    'booking.transport_details': 'Podrobnosti o doprave',
    'booking.truck': 'Nákladné auto',
    'booking.truck_driver_planning_saved_letter_of_attorney_available':
      'Dátumy nákladného vozidla, vodiča a plánovania boli uložené. Splnomocnenie je teraz k dispozícii.',
    'booking.unexpected_error': 'Neočakávaná chyba',
    'booking.vehicles_plural': 'Vozidlá',
    'booking.view_details': 'Zobraziť podrobnosti',
    'booking.vip_price_must_be_between_min_max_50_to_150_percent_of_estimated_price':
      'VIP cena musí byť medzi {{min}} EUR a {{max}} EUR (50 % až 150 % odhadovanej ceny).',
    'booking.vip_price_must_be_positive_number':
      'VIP cena musí byť kladné číslo.',
    'booking.within_radius_km_of_place': 'V rámci {{radius}} km od {{place}}',
    Capacity: 'Kapacita',
    'Car Capacity': 'Kapacita auta',
    'Car capacity is required.': 'Vyžaduje sa kapacita auta.',
    cars: 'autá',
    Changed: 'Zmenené',
    'CMR Document': 'Dokument CMR',
    'CMR expiry': 'Exspirácia CMR',
    'CMR Expiry': 'Expirácia CMR',
    'CMR expiry date is required': 'Vyžaduje sa dátum exspirácie CMR',
    'CMR Insurance': 'Poistenie CMR',
    'CMR insurance expiry date': 'Dátum skončenia platnosti poistenia CMR',
    'CMR Insurance Expiry Date': 'Dátum skončenia platnosti poistenia CMR',
    'CMR insurance has expired. Upload a new CMR Insurance for review.':
      'Nahrajte novú faktúru CMR na kontrolu.',
    'CMR insurance is expiring within 14 days.':
      'Poistenie CMR zaniká do 14 dní.',
    'CMR Insurance required': 'Vyžaduje sa faktúra CMR',
    Company: 'Spoločnosť',
    'Copy order ID': 'Skopírujte ID objednávky',
    Created: 'Vytvorené',
    'Current expiry': 'Aktuálne uplynutie platnosti',
    'Date range': 'Rozsah dátumov',
    days: 'dní',
    Delay: 'Oneskorenie',
    'Delivered + partner invoice uploaded + unpaid':
      'Doručené + faktúra partnera nahraná + nezaplatená',
    Document: 'Dokument',
    'Documents uploaded': 'Dokumenty boli odovzdané',
    Done: 'Hotovo',
    'Download Client Invoice #{{id}}':
      'Stiahnite si faktúru pre klienta #{{id}}',
    'Download Invoice': 'Stiahnite si faktúru',
    'Enter a valid capacity between 1 and 20 cars.':
      'Zadajte platnú kapacitu od 1 do 20 áut.',
    'Enter license plate': 'Zadajte ŠPZ',
    'Enter plate and upload CMR to add truck':
      'Ak chcete pridať nákladné vozidlo, zadajte štítok a nahrajte CMR',
    'Error fetching users': 'Chyba pri načítavaní používateľov',
    'Expire Soon (14 days)': 'Platnosť čoskoro vyprší (14 dní)',
    'Explain why this CMR was rejected':
      'Vysvetlite, prečo bol tento CMR zamietnutý',
    'Failed to copy order ID': 'Nepodarilo sa skopírovať ID objednávky',
    'Failed to download invoice': 'Stiahnutie faktúry zlyhalo',
    'Failed to download proforma invoice':
      'Stiahnutie proforma faktúry zlyhalo',
    'Failed to generate invoice': 'Nepodarilo sa vygenerovať faktúru',
    'Failed to load invoice summary': 'Nepodarilo sa načítať súhrn faktúry',
    'Failed to load letter of attorney': 'Nepodarilo sa načítať splnomocnenie',
    'Failed to open letter of attorney': 'Nepodarilo sa otvoriť splnomocnenie',
    'Failed to release booking': 'Rezerváciu sa nepodarilo uvoľniť',
    'Fleet data refreshed': 'Údaje o flotile boli obnovené',
    'Generate Client Invoice': 'Vygenerovať klientsku faktúru',
    'Generate Invoice': 'Vygenerovať faktúru',
    'Generated at': 'Vygenerované o',
    'How many cars can this truck carry?':
      'Koľko áut unesie toto nákladné auto?',
    'In progress': 'Prebieha',
    Invoice: 'Faktúra',
    'Invoice generated': 'Vygenerovaná faktúra',
    'Invoice generated successfully': 'Faktúra bola úspešne vygenerovaná',
    'Invoice uploaded': 'Faktúra bola nahraná',
    'Invoices uploaded by partners for platform payout processing. Client invoices are generated in each order view.':
      'Klientske faktúry sa generujú v každom zobrazení objednávky.',
    'Keep booking': 'Pokračujte v rezervácii',
    'Keep your active drivers and contact details up to date.':
      'Udržujte svoje aktívne ovládače a kontaktné údaje aktuálne.',
    'Last Rejection': 'Posledné odmietnutie',
    'Last rejection reason': 'Posledný dôvod odmietnutia',
    'Letter of Attorney': 'plná moc',
    'Letter of attorney file is empty': 'Súbor s plnou mocou je prázdny',
    'License plate cannot be changed after creation. Re-upload CMR Insurance instead.':
      'Namiesto toho znova nahrajte faktúru CMR.',
    'License plate is required.': 'ŠPZ je povinná.',
    'Manage large order volumes with search, payment actions, and invoice workflows.':
      'Spravujte veľké objemy objednávok pomocou vyhľadávania, platobných akcií a pracovných postupov fakturácie.',
    'Manage license plates and keep CMR Insurances approved and valid.':
      'Spravujte poznávacie značky a uchovávajte faktúry CMR schválené a platné.',
    'Manage status updates, documents, and payment steps from one place.':
      'Spravujte aktualizácie stavu, dokumenty a platobné kroky z jedného miesta.',
    'Manage trailer plate records and keep availability current.':
      'Spravujte záznamy o štítku prívesu a udržujte aktuálnosť dostupnosti.',
    'Mark booking {{id}} as paid?': 'Označiť rezerváciu {{id}} ako zaplatenú?',
    Missing: 'Chýba',
    'Needs attention': 'Vyžaduje pozornosť',
    'New (14 days)': 'Nové (14 dní)',
    'No bookings found for the current filters.':
      'Pre aktuálne filtre sa nenašli žiadne rezervácie.',
    'No confirmed CMR document uploaded yet.':
      'Zatiaľ nebol nahraný žiadny potvrdený dokument CMR.',
    'No driver assigned': 'Nie je pridelený žiadny vodič',
    'No letter of attorney has been generated yet.':
      'Zatiaľ nebola vygenerovaná žiadna plná moc.',
    'No matching delivered orders': 'Žiadne zodpovedajúce doručené objednávky',
    'No new notifications': 'Žiadne nové upozornenia',
    'No partners found.': 'Nenašli sa žiadni partneri.',
    'No trucks found for this filter.':
      'Pre tento filter sa nenašli žiadne nákladné autá.',
    'No users found for current filters.':
      'Pre aktuálne filtre sa nenašli žiadni používatelia.',
    'Not uploaded': 'Nenahrané',
    Notifications: 'Upozornenia',
    of: 'z',
    'Only admins can set or update this expiry date after reviewing your CMR insurance.':
      'Tento dátum vypršania platnosti môžu nastaviť alebo aktualizovať iba správcovia po skontrolovaní vášho poistenia CMR.',
    'Open letter of attorney': 'Otvorená plná moc',
    Order: 'Objednať',
    'Order actions': 'Objednať akcie',
    'Order ID copied': 'ID objednávky bolo skopírované',
    Owner: 'Vlastník',
    Page: 'Stránka',
    'Paid date': 'Zaplatený dátum',
    'Partner delivery date': 'Dátum dodania partnera',
    'Partner documents': 'Partnerské dokumenty',
    'Partner Invoice': 'Partnerská faktúra',
    'Partner invoice uploaded': 'Faktúra partnera bola nahraná',
    'Partner Payout Invoices': 'Partnerské výplatné faktúry',
    'Partner pickup date': 'Dátum vyzdvihnutia partnera',
    'Partner score': 'Partnerské skóre',
    Payment: 'Platba',
    'Payout date': 'Dátum výplaty',
    'penalties applied': 'udelené pokuty',
    'Pending admin review': 'Čaká sa na kontrolu správcu',
    'Pending review': 'Čaká sa na kontrolu',
    'Pending trucks': 'Čakajúce kamióny',
    'Please provide a clear reason for rejection.':
      'Uveďte jasný dôvod odmietnutia.',
    'Please select an order before uploading an invoice.':
      'Pred nahraním faktúry vyberte objednávku.',
    'Please try again.': 'Skúste to znova.',
    'Proforma Invoice': 'Proforma faktúra',
    'Provide a rejection reason for this CMR review.':
      'Uveďte dôvod odmietnutia tohto hodnotenia CMR.',
    'Quarter Score': 'Štvrťročné skóre',
    'Re-upload CMR': 'Znova nahrajte CMR',
    Refresh: 'Obnoviť',
    'Rejection reason': 'Dôvod odmietnutia',
    'Rejection reason is required': 'Vyžaduje sa dôvod odmietnutia',
    'Release booking {{id}} back to the marketplace so another partner can accept it?':
      'Uvoľniť rezerváciu {{id}} späť na trh, aby ju mohol prijať iný partner?',
    Reset: 'Resetovať',
    'Review Bookings': 'Skontrolujte rezervácie',
    Revision: 'Revízia',
    Rows: 'Riadky',
    'Search by invoice number, file name, or booking ID':
      'Vyhľadávajte podľa čísla faktúry, názvu súboru alebo ID rezervácie',
    'Search by name, email, company': 'Hľadajte podľa mena, emailu, firmy',
    'Search by name, email, company, uid':
      'Hľadajte podľa mena, e-mailu, spoločnosti, uid',
    'Search client': 'Vyhľadávací klient',
    'Search delivered order': 'Vyhľadajte doručenú objednávku',
    'Search license plate or owner':
      'Vyhľadajte poznávaciu značku alebo majiteľa',
    'Search order ID': 'Vyhľadať ID objednávky',
    'Search partner': 'Partner vyhľadávania',
    'Select a new CMR Insurance to re-upload for this truck.':
      'Vyberte novú faktúru CMR na opätovné nahranie pre toto nákladné vozidlo.',
    'Select paid date': 'Vyberte dátum platby',
    'Set CMR insurance expiry date to approve this truck.':
      'Nastavte dátum vypršania platnosti poistenia CMR na schválenie tohto nákladného vozidla.',
    'Set maximum number of cars this truck can carry (1-20).':
      'Nastavte maximálny počet áut, ktoré môže toto nákladné vozidlo prepraviť (1-20).',
    'Set the CMR insurance expiry date before approval.':
      'Pred schválením nastavte dátum vypršania platnosti poistenia CMR.',
    Showing: 'Zobrazuje sa',
    'Showing page {{page}} of {{pages}} • {{total}} invoices':
      'Zobrazuje sa strana {{page}} z faktúr {{pages}} • {{total}}',
    'Status will be updated to Picked Up after successful upload. You can add multiple car photos before uploading.':
      'Pred odovzdaním môžete pridať viacero fotografií áut.',
    Terms: 'Podmienky',
    Total: 'Celkom',
    'Track paid and unpaid invoices, expected payout dates, and upload new invoices quickly.':
      'Sledujte zaplatené a nezaplatené faktúry, očakávané dátumy výplat a rýchlo nahrávajte nové faktúry.',
    'Truck approved successfully': 'Nákladné auto úspešne schválené',
    'Truck documents': 'Nákladné doklady',
    'Truck license plate': 'ŠPZ nákladného auta',
    'Truck rejected successfully': 'Kamión bol úspešne odmietnutý',
    'truck(s) are pending admin CMR expiry date.':
      'truck(y) čakajú na dátum vypršania platnosti admin CMR.',
    'truck(s) have expired CMR insurance and are disabled.':
      'nákladné vozidlá majú ukončenú platnosť poistenia CMR a sú nefunkčné.',
    'truck(s) will expire within 14 days.':
      'kamiónu (kamiónov) vyprší platnosť do 14 dní.',
    'Unable to prepare the record for upload.':
      'Nie je možné pripraviť záznam na odovzdanie.',
    Unpaid: 'Nezaplatené',
    'Upload a CMR Insurance before closing this truck setup.':
      'Pred zatvorením tohto nastavenia nákladného vozidla nahrajte faktúru CMR.',
    'Upload a valid CMR insurance. Each upload sends the truck back to pending review.':
      'Každé odovzdanie pošle kamión späť na kontrolu čakajúcu na kontrolu.',
    'Upload documents': 'Nahrajte dokumenty',
    'Upload Invoice': 'Nahrať faktúru',
    'Upload order documents': 'Nahrajte dokumenty objednávky',
    'Upload unavailable': 'Odovzdanie nie je k dispozícii',
    Uploaded: 'Nahrané',
    'Uploaded • Paid': 'Nahrané • Zaplatené',
    'Uploaded • Partially paid': 'Nahrané • Čiastočne zaplatené',
    'Uploaded by partner for platform payout processing.':
      'Nahrané partnerom na spracovanie platieb na platforme.',
    User: 'Používateľ',
    'Verification code': 'Overovací kód',
    'View details': 'Zobraziť podrobnosti',
    'View Partners': 'Zobraziť partnerov',
    'Working hours not provided': 'Pracovná doba nie je uvedená',
    '{{value}} orders': 'Objednávky {{value}}',
    Invoiced: 'Fakturované',
    'Loading admin data...': 'Načítavajú sa údaje správcu...',
    'Pending partners': 'Čakajúci partneri',
    'Unpaid bookings': 'Nezaplatené rezervácie',
    'Total users': 'Celkový počet používateľov',
    'Orders per period': 'Objednávky za obdobie',
    'Orders by status': 'Objednávky podľa stavu',
    'Quick actions': 'Rýchle akcie',
    'Verify new partners': 'Overte nových partnerov',
    'Review partner applications and approve or reject requests.':
      'Skontrolujte žiadosti partnerov a schvaľujte alebo zamietajte žiadosti.',
    'Manage all trucks': 'Spravujte všetky nákladné autá',
    'Review, approve, reject, disable, and filter all trucks.':
      'Skontrolujte, schvaľujte, zamietajte, deaktivujte a filtrujte všetky nákladné vozidlá.',
    'Review bookings': 'Skontrolujte rezervácie',
    'Review all transport orders, payment states, and generated invoices.':
      'Skontrolujte všetky prepravné objednávky, stavy platieb a vygenerované faktúry.',
    'Manage all users': 'Spravovať všetkých používateľov',
    'Manage user status, roles, and validation records.':
      'Spravujte stav používateľov, roly a overovacie záznamy.',
    'User breakdown': 'Rozdelenie používateľov',
    Clients: 'klientov',
    Partners: 'Partneri',
    Admins: 'Správcovia',
    'Top 5 pending partners': 'Top 5 čakajúcich partnerov',
    'No pending partners right now.': 'Momentálne žiadni čakajúci partneri.',
    pending: 'čakajúce',
    'Top 5 pending trucks': 'Top 5 čakajúcich kamiónov',
    'No pending trucks right now.': 'Momentálne žiadne čakajúce kamióny.',
    'Unknown owner': 'Neznámy vlastník',
    'KPI cards and top lists link directly to filtered admin screens.':
      'Karty KPI a zoznamy najlepších odkazujú priamo na filtrované obrazovky správcu.',
    'booking.available_orders_title': 'Dostupné objednávky',
    'booking.available_orders_description':
      'Skontrolujte príležitosti prichádzajúcej dopravy a použite filtre, ktoré zodpovedajú vašej kapacite.',
    'booking.vehicle_pickup_location': 'Miesto vyzdvihnutia vozidla',
    'booking.pickup_opening_hours': 'Otváracie hodiny vyzdvihnutia',
    'booking.vehicle_delivery_location': 'Miesto dodania vozidla',
    'booking.delivery_opening_hours': 'Otváracie hodiny dodávky',
    'booking.pickup_contact': 'Kontakt na vyzdvihnutie',
    'booking.delivery_contact': 'Kontakt na doručenie',
    'booking.vehicles_scheduled': 'Vozidlá naplánované',
    'booking.watchlist_title': 'Zoznam sledovaných',
    'booking.watchlist_description':
      'Sledujte uložené príležitosti a rýchlo konajte pri zmenách dostupnosti.',
    'Loading dashboard...': 'Načítava sa informačný panel...',
    'Total bookings': 'Celkový počet rezervácií',
    'Open bookings': 'Otvoriť rezervácie',
    'Order status timeline': 'Časová os stavu objednávky',
    'Last 6 months of bookings grouped by current status.':
      'Posledných 6 mesiacov rezervácií zoskupených podľa aktuálneho stavu.',
    'Create new order': 'Vytvorte novú objednávku',
    'Create a new transport booking request.':
      'Vytvorte novú požiadavku na rezerváciu prepravy.',
    'View my orders': 'Pozrite si moje objednávky',
    'Review status and details of your bookings.':
      'Skontrolujte stav a podrobnosti svojich rezervácií.',
    'Open profile': 'Otvorte profil',
    'Update company and contact details.':
      'Aktualizujte spoločnosť a kontaktné údaje.',
    'Recent bookings': 'Nedávne rezervácie',
    'No bookings yet.': 'Zatiaľ žiadne rezervácie.',
    'Unknown destination': 'Neznámy cieľ',
    'Quarter score': 'Štvrťročné skóre',
    '{{value}} completed': '{{value}} dokončené',
    'Truck CMR warning': 'Výstraha CMR nákladného vozidla',
    'One truck has CMR expiry risk. Review it in Fleet.':
      'Jeden kamión má riziko uplynutia platnosti CMR. Pozrite si to vo Fleet.',
    '{{count}} trucks have CMR expiry risk. Review them in Fleet.':
      'Nákladné vozidlá {{count}} majú riziko uplynutia platnosti CMR. Skontrolujte ich vo flotile.',
    'Active queue': 'Aktívny rad',
    'Delivered bookings': 'Doručené rezervácie',
    'Cars delivered': 'Dodané autá',
    'Canceled bookings': 'Zrušené rezervácie',
    'Avg assign-to-pickup': 'Priem. pridelenie k vyzdvihnutiu',
    'Quarter Partner Score': 'Štvrťročné skóre partnera',
    'Payment delay: +{{days}} days': 'Oneskorenie platby: +{{days}} dní',
    'Penalty events': 'Penaltové udalosti',
    Current: 'Aktuálne',
    'Completed orders per period': 'Dokončené objednávky za obdobie',
    'Completed orders': 'Dokončené objednávky',
    'Truck CMR status alerts': 'Upozornenia na stav CMR nákladného vozidla',
    '{{count}} truck(s) have expired CMR insurance.':
      'Nákladné vozidlá {{count}} majú ukončenú platnosť poistenia CMR.',
    '{{count}} truck(s) will expire within 14 days.':
      'Platnosť nákladných vozidiel {{count}} vyprší do 14 dní.',
    '{{count}} truck(s) are missing CMR expiry date.':
      'Nákladným vozidlám {{count}} chýba dátum exspirácie CMR.',
    'Upload a new CMR Insurance in Fleet. The truck will stay pending until admin review.':
      'Nahrajte novú faktúru CMR do Fleet. Nákladné vozidlo bude čakať až do kontroly správcu.',
    'Open fleet to resolve CMR alerts':
      'Otvorte flotilu na vyriešenie upozornení CMR',
    'Operational actions': 'Operačné akcie',
    'Open marketplace orders': 'Objednávky na otvorenom trhu',
    'Review available orders and plan assignments.':
      'Skontrolujte dostupné objednávky a plánujte úlohy.',
    'My accepted orders': 'Moje prijaté objednávky',
    'Manage delivery progress and documents.':
      'Spravujte priebeh doručovania a dokumenty.',
    'Update trucks, trailers, and availability.':
      'Aktualizujte nákladné autá, prívesy a dostupnosť.',
    'Partner invoices': 'Partnerské faktúry',
    'Upload and track invoice payments.': 'Nahrajte a sledujte platby faktúr.',
    'No active orders in queue.': 'Žiadne aktívne objednávky v poradí.',
    'profile.incompleteTitle': 'Profil je neúplný',
    'profile.incompleteDescription':
      'Vyplňte informácie o svojom profile (spoločnosť, telefón, adresa, mesto, PSČ), aby ste získali prístup ku všetkým funkciám.',
    'profile.goToProfile': 'Prejdite do profilu',
    'auth.email_placeholder': 'meno@spolocnost.sk',
    'auth.authentication_mode_switch': 'Prepínač režimu overovania',
    'auth.invalid_email': 'Neplatný email',
    'auth.please_enter_a_valid_email_address':
      'Zadajte platnú e-mailovú adresu.',
    'auth.email_not_found': 'E-mail sa nenašiel',
    'auth.no_account_found_with_that_email_address':
      'Nebol nájdený žiadny účet s touto e-mailovou adresou.',
    'auth.email_sent': 'Email odoslaný!',
    'auth.something_went_wrong_try_again':
      'Niečo sa pokazilo. Skúste to znova.',
    'auth.we_sent_a_password_reset_link_open_your_inbox_and_follow_the_instructions':
      'Poslali sme odkaz na obnovenie hesla. Otvorte doručenú poštu a postupujte podľa pokynov.',
    'auth.forgot_your_password': 'Zabudli ste heslo?',
    'auth.enter_your_account_email_and_we_will_send_you_a_password_reset_link':
      'Zadajte e-mail svojho účtu a my vám pošleme odkaz na obnovenie hesla.',
    'auth.email_address': 'E-mailová adresa',
    'auth.send_reset_link': 'Odoslať odkaz na obnovenie',
    'auth.cancel': 'Zrušiť',
    'auth.tip_if_you_do_not_receive_the_email_check_spam_and_promotions_folders':
      'Tip: Ak e-mail nedostanete, skontrolujte priečinky so spamom a propagáciami.',
    'booking.e_g_berlin': 'napr. Berlín',
    'booking.e_g_germany': 'napr. Nemecko',
    'booking.watchlist': 'Zoznam sledovaných',
    'booking.view_map': 'Zobraziť mapu',
    'booking.invalid_input': 'Neplatný vstup',
    'booking.please_enter_only_numbers_for_the_zip_code':
      'Zadajte iba čísla PSČ.',
    'booking.pickup_zip_code': 'Vyzdvihnutie PSČ',
    'booking.delivery_zip_code': 'PSČ doručenia',
    'booking.select_vehicle_make': 'Vyberte značku vozidla',
    'booking.unnamed_item': 'Nepomenovaná položka',
    'booking.cars': 'autá',
    'booking.more_info': 'Viac info',
    'booking.loading': 'Načítava sa...',
    'booking.no_items_found': 'Nenašli sa žiadne položky',
    'booking.selected_cars': 'Vybrané autá',
    'booking.unknown_type': 'Neznámy typ',
    'booking.delete_car': 'Vymazať auto',
    'Toggle details': 'Prepnúť podrobnosti',
    'auth.a_verification_email_has_been_sent_to_your_email_address_please_verify_your_emai':
      'Na vašu e-mailovú adresu bol odoslaný overovací e-mail. Pred prihlásením overte svoj e-mail.',
    'auth.an_unexpected_error_occurred_please_try_again':
      'Vyskytla sa neočakávaná chyba. Skúste to znova.',
    'auth.email': 'Email',
    'auth.failed_to_resend_email': 'Opätovné odoslanie e-mailu zlyhalo',
    'auth.show_password': 'Zobraziť heslo',
    'auth.hide_password': 'Skryť heslo',
    'auth.incorrect_password_please_try_again':
      'Nesprávne heslo. Skúste to znova.',
    'auth.invalid_email_or_password_please_check_your_credentials_and_try_again':
      'Neplatný e-mail alebo heslo. Skontrolujte svoje poverenia a skúste to znova.',
    'auth.network_error_check_your_connection_and_try_again':
      'Chyba siete. Skontrolujte pripojenie a skúste to znova.',
    'auth.no_account_found_with_this_email':
      'S týmto e-mailom sa nenašiel žiadny účet.',
    'auth.partner': 'Partner',
    'auth.please_check_your_inbox': 'Skontrolujte si doručenú poštu.',
    'auth.please_make_sure_both_passwords_are_the_same':
      'Uistite sa, že obe heslá sú rovnaké.',
    'auth.please_sign_in_to_resend_the_verification_email':
      'Ak chcete znova odoslať overovací e-mail, prihláste sa.',
    'auth.resend_verification_email': 'Znova odoslať overovací e-mail',
    'auth.awaiting_verification_artwork':
      'Čaká sa na overenie umeleckého diela',
    'auth.email_verification_required': 'Vyžaduje sa overenie e-mailom',
    'auth.waiting_for_email_verification': 'Čaká sa na overenie e-mailom',
    'auth.check_your_email': 'Skontrolujte si e-mail',
    'auth.we_sent_your_verification_link_to':
      'Váš overovací odkaz sme odoslali na adresu',
    'auth.didnt_receive_it_check_spam_or_try_again':
      'Nedostali ste to? Skontrolujte priečinok so spamom alebo to skúste znova.',
    'auth.resend_email': 'Znova odoslať e-mail',
    'auth.i_verified_my_email': 'Overil som svoj e-mail',
    'auth.redirecting_you_now': 'Prebieha presmerovanie.',
    'auth.email_not_verified_yet': 'E-mail ešte nie je overený',
    'auth.please_click_the_link_in_your_inbox_and_try_again':
      'Kliknite na odkaz v doručenej pošte a skúste to znova.',
    'auth.unable_to_resend_verification_email_right_now':
      'Momentálne nie je možné znova odoslať overovací e-mail.',
    'auth.unable_to_check_verification_status_right_now':
      'Momentálne nie je možné skontrolovať stav overenia.',
    'auth.we_sent_a_new_verification_link':
      'Na vašu e-mailovú adresu sme odoslali nový overovací odkaz.',
    'auth.we_automatically_check_every_30_seconds':
      'Stav vášho overenia automaticky kontrolujeme každých 30 sekúnd. Okamžitú kontrolu môžete spustiť aj po overení e-mailu.',
    'auth.we_automatically_check_every_15_seconds':
      'Stav vášho overenia automaticky kontrolujeme každých 15 sekúnd. Okamžitú kontrolu môžete spustiť aj po overení e-mailu.',
    'auth.the_email_address_is_not_valid': 'E-mailová adresa nie je platná.',
    'auth.this_account_has_been_disabled': 'Tento účet bol deaktivovaný.',
    'auth.too_many_failed_attempts_please_try_again_later_or_reset_your_password':
      'Príliš veľa neúspešných pokusov. Skúste to znova neskôr alebo obnovte heslo.',
    'auth.verification_email_resent': 'Overovací e-mail bol odoslaný znova!',
    'auth.you_need_to_log_in_first': 'Najprv sa musíte prihlásiť',
    'booking.email': 'Email',
    'booking.error_fetching_data': 'Chyba pri načítavaní údajov',
    'booking.inputs_changed_recalculate_the_price':
      'Vstupy sa zmenili. Prepočítajte si cenu.',
    'booking.kg': 'kg',
    'booking.km': 'km',
    'booking.mi': 'mi',
    'booking.no_opening_hours_provided':
      'Nie sú uvedené žiadne otváracie hodiny',
    'booking.no_vehicles_listed': 'V zozname nie sú žiadne vozidlá',
    'booking.not_available': 'Nie je k dispozícii',
    'booking.not_set': 'Nie je nastavené',
    'booking.please_select_a_planned_date': 'Vyberte prosím plánovaný dátum',
    'booking.required': 'Povinné',
    'booking.to': 'do',
    'booking.order': 'Objednať',
    'booking.duration': 'Trvanie',
    'booking.vehicles_overview': 'Prehľad vozidiel',
    'booking.body': 'Telo',
    'booking.dims': 'Dims',
    'booking.select_vehicle_model': 'Vyberte model vozidla',
    'booking.selected_type_value': 'Zvolené: {{value}}',
    'booking.select_a_vehicle_type': 'Vyberte typ vozidla:',
    'booking.select_vehicle_weight': 'Vyberte hmotnosť vozidla',
    'booking.selected_weight_kg': 'Zvolené: {{value}} kg',
    'booking.adjust_weight': 'Upravte hmotnosť',
    'Dates updated successfully': 'Dátumy boli úspešne aktualizované',
    'Error updating dates': 'Chyba pri aktualizácii dátumov',
    'Set Planned Dates': 'Nastavte plánované dátumy',
    'Set your planned pickup and arrival dates below.':
      'Nižšie si nastavte plánovaný dátum vyzdvihnutia a príchodu.',
    'Changing dates after initial setup will deduct 20% from your performance score for this order.':
      'Zmena dátumov po úvodnom nastavení odpočíta 20 % z vášho skóre výkonnosti pre túto objednávku.',
    'Planned Pickup Date': 'Plánovaný dátum vyzdvihnutia',
    'Planned Arrival Date': 'Plánovaný dátum príchodu',
    Listing: 'Výpis',
    'Try broadening the current search or status filter.':
      'Skúste rozšíriť aktuálne vyhľadávanie alebo filter stavu.',
    'Try broadening the search, role, or status filters.':
      'Skúste rozšíriť filtre vyhľadávania, rolí alebo stavov.',
    'Monitor fleet compliance, validation status, and expiring insurance in one place.':
      'Monitorujte súlad s vozovým parkom, stav overenia a končiace poistenie na jednom mieste.',
    'Active Listings': 'Aktívne záznamy',
    'Open transport requests': 'Otvoriť požiadavky na prepravu',
    'Quotes Today': 'Citáty dnes',
    'Submitted in last 24h': 'Odoslané za posledných 24 hodín',
    'Platform Revenue (MTD)': 'Výnosy z platformy (MTD)',
    'Month to date': 'Mesiac do dnešného dňa',
    'Pending Partners': 'Čakajúci partneri',
    'Awaiting approval': 'Čaká sa na schválenie',
    'Unpaid Invoices': 'Nezaplatené faktúry',
    'Requires action': 'Vyžaduje akciu',
    'Completed Transports': 'Dokončené prepravy',
    'All time delivered': 'Celý čas doručený',
    'Admin Dashboard': 'Admin Dashboard',
    'Platform overview and key performance indicators.':
      'Prehľad platformy a kľúčové ukazovatele výkonnosti.',
    'Loading dashboard metrics...':
      'Načítavajú sa metriky informačného panela...',
    Invoices: 'faktúry',
    'Review payout invoices uploaded by partners and keep payout processing organized.':
      'Skontrolujte faktúry k platbám nahrané partnermi a udržujte si spracovanie platieb organizované.',
    Flexible: 'Flexibilné',
    'Flexible dates': 'Flexibilné termíny',
    'Could not load this listing.': 'Tento záznam sa nepodarilo načítať.',
    'Listing canceled': 'Záznam bol zrušený',
    'Failed to cancel listing': 'Záznam sa nepodarilo zrušiť',
    Reference: 'Odkaz',
    Category: 'Kategória',
    'Client type': 'Typ klienta',
    'Company country': 'Krajina spoločnosti',
    Expires: 'Platnosť vyprší',
    'Back to listings': 'Späť na výpisy',
    'Listing not found.': 'Záznam sa nenašiel.',
    'Cancel Listing': 'Zrušiť výpis',
    'Listing details': 'Podrobnosti výpisu',
    'Reference {{id}}': 'Referencia {{id}}',
    'Read-only listing overview for admins.':
      'Prehľad zoznamu iba na čítanie pre správcov.',
    'Pick-up': 'Vyzdvihnutie',
    'No exact coordinates are stored for this listing yet.':
      'Pre tento záznam zatiaľ nie sú uložené žiadne presné súradnice.',
    'Structured overview of quantities and handling details.':
      'Štruktúrovaný prehľad množstiev a manipulačných detailov.',
    'Shipment images': 'Obrázky zásielky',
    'No shipment images were uploaded for this listing.':
      'Pre tento záznam neboli nahrané žiadne obrázky zásielok.',
    'Proof of pickup': 'Doklad o prevzatí',
    'Final documents': 'Záverečné dokumenty',
    Description: 'Popis',
    'Quotes ({{count}})': 'Citácie ({{count}})',
    'Loading quotes...': 'Načítavam cenové ponuky...',
    'No quotes for this listing.': 'Žiadne cenové ponuky pre tento záznam.',
    'Score: {{score}}/100': 'Skóre: {{score}}/100',
    'Pickup: {{date}}': 'Vyzdvihnutie: {{date}}',
    'Delivery: {{date}}': 'Doručenie: {{date}}',
    'Cancel Listing?': 'Zrušiť záznam?',
    'This will permanently cancel the listing and notify the client. Continue?':
      'Toto natrvalo zruší záznam a informuje klienta. Pokračovať?',
    Keep: 'Ponechať',
    'Review partner applications, check their documents, and keep approval decisions consistent.':
      'Kontrolujte aplikácie partnerov, kontrolujte ich dokumenty a udržujte konzistentné rozhodnutia o schválení.',
    'No client payments recorded yet':
      'Zatiaľ neboli zaznamenané žiadne platby klientov',
    'Client payment rows will appear here when the payments backend is connected.':
      'Po pripojení backendu platieb sa tu zobrazia riadky platieb klienta.',
    Method: 'Metóda',
    'No partner payouts recorded yet':
      'Zatiaľ neboli zaznamenané žiadne výplaty partnerov',
    'Payout rows will appear here once partner payout processing is enabled.':
      'Po povolení spracovania partnerských platieb sa tu zobrazia riadky platieb.',
    'Payout Amount': 'Suma výplaty',
    'No platform fees recorded yet':
      'Zatiaľ neboli zaznamenané žiadne poplatky za platformu',
    'Fee rows will appear here once payment settlement data is available.':
      'Riadky s poplatkami sa tu zobrazia, keď budú k dispozícii údaje o zúčtovaní platieb.',
    Gross: 'Hrubý',
    'Fee (20%)': 'Poplatok (20 %)',
    Payments: 'Platby',
    'Client payments, partner payouts, and platform fee tracking.':
      'Klientske platby, partnerské platby a sledovanie poplatkov za platformu.',
    'Client Payments': 'Platby klienta',
    'Partner Payouts': 'Partnerské výplaty',
    'Platform Fees': 'Poplatky za platformu',
    'Failed to load reviews': 'Nepodarilo sa načítať recenzie',
    'Review removed': 'Recenzia bola odstránená',
    'Failed to remove review': 'Recenziu sa nepodarilo odstrániť',
    Reviews: 'Recenzie',
    'All partner and transport reviews submitted by clients.':
      'Všetky hodnotenia partnerov a dopravy odoslané klientmi.',
    'Loading reviews...': 'Načítavajú sa recenzie...',
    'No reviews found': 'Nenašli sa žiadne recenzie',
    'Client feedback will appear here when reviews are submitted.':
      'Pri odoslaní recenzií sa tu zobrazí spätná väzba od klientov.',
    Stars: 'hviezdy',
    Comment: 'Komentujte',
    'Search, review, and maintain user accounts with one consistent admin workflow.':
      'Vyhľadávajte, kontrolujte a udržiavajte používateľské účty pomocou jedného konzistentného pracovného postupu správcu.',
    'Track paid and unpaid partner payout invoices, and upload the next delivered listing invoice quickly.':
      'Sledujte platené a nezaplatené faktúry partnerov a rýchlo nahrajte ďalšiu doručenú faktúru s výpisom.',
    'Search by invoice number, file name, or listing ID':
      'Vyhľadávajte podľa čísla faktúry, názvu súboru alebo ID záznamu',
    'Loading delivered listings...': 'Načítavajú sa doručené ponuky...',
    'Search delivered listing by reference, title, or route':
      'Vyhľadávajte doručený záznam podľa referencie, názvu alebo cesty',
    'Route details available in listing':
      'Podrobnosti o trase nájdete v zozname',
    'No matching delivered listings': 'Žiadne zodpovedajúce doručené záznamy',
    'Selected listing': 'Vybraný záznam',
    'Has quotes': 'Má úvodzovky',
    'In transit': 'V tranzite',
    Open: 'Otvorte',
    Accepted: 'Prijaté',
    Completed: 'Dokončené',
    'Client Dashboard': 'Klientsky panel',
    'Overview of your current transport listings, quote activity, and recent requests.':
      'Prehľad vašich aktuálnych zoznamov dopravy, aktivity ponuky a nedávnych požiadaviek.',
    'Total listings': 'Celkový počet záznamov',
    'Active listings': 'Aktívne záznamy',
    'Listings with quotes': 'Výpisy s úvodzovkami',
    'Accepted transport': 'Akceptovaná doprava',
    'Listing status timeline': 'Časová os stavu záznamu',
    'Last 6 months of listings grouped by current status.':
      'Zoznamy za posledných 6 mesiacov zoskupené podľa aktuálneho stavu.',
    'No listing activity yet': 'Zatiaľ žiadna aktivita záznamu',
    'Create your first listing to start tracking request activity here.':
      'Ak chcete začať sledovať aktivitu žiadostí, vytvorte si svoj prvý záznam.',
    'Create new listing': 'Vytvoriť nový záznam',
    'Create a new transport request for the marketplace.':
      'Vytvorte novú požiadavku na prepravu pre trh.',
    'View my listings': 'Pozrite si moje inzeráty',
    'Review quote activity and manage your transport requests.':
      'Skontrolujte aktivitu ponuky a spravujte svoje požiadavky na prepravu.',
    'Recent listings': 'Nedávne záznamy',
    'No listings yet': 'Zatiaľ žiadne záznamy',
    'Your newest transport requests will appear here once you create them.':
      'Tu sa zobrazia vaše najnovšie požiadavky na prepravu, keď ich vytvoríte.',
    'Unknown origin': 'Neznámy pôvod',
    '{{count}} quote(s)': '{{count}} citát(y)',
    '{{value}} completed listings': '{{value}} dokončených záznamov',
    'Monitor current performance, fleet readiness, quote flow, and your active transport queue.':
      'Monitorujte aktuálny výkon, pripravenosť vozového parku, tok cenových ponúk a váš aktívny transportný front.',
    'Total assigned': 'Celkom pridelené',
    'Quarter rating': 'Štvrťročné hodnotenie',
    'Based on current quarter performance':
      'Na základe aktuálnej výkonnosti za štvrťrok',
    Rating: 'Hodnotenie',
    'Requirement met': 'Požiadavka splnená',
    'Requirement not met': 'Požiadavka nie je splnená',
    'Completed listings per period': 'Dokončené výpisy za obdobie',
    'No completion data yet': 'Zatiaľ žiadne údaje o dokončení',
    'Statistics will appear here after your first delivered work.':
      'Štatistiky sa tu objavia po vašej prvej dodanej práci.',
    'Completed listings': 'Dokončené výpisy',
    'Review truck documents and refresh anything close to expiry.':
      'Skontrolujte dokumenty nákladného vozidla a obnovte všetko, čo sa blíži k expirácii.',
    'Search deliveries': 'Vyhľadajte dodávky',
    'Review available marketplace listings and submit quotes.':
      'Skontrolujte dostupné zoznamy trhovísk a odošlite cenové ponuky.',
    'My quotes': 'Moje citáty',
    'Track accepted, pending, and rejected quotes in one place.':
      'Sledujte prijaté, čakajúce a odmietnuté ponuky na jednom mieste.',
    'Profile settings': 'Nastavenia profilu',
    'Keep company information and compliance details up to date.':
      'Udržujte informácie o spoločnosti a podrobnosti o dodržiavaní pravidiel aktuálne.',
    'No active queue items': 'Žiadne aktívne položky v poradí',
    'Accepted and in-progress work will appear here as your transport activity grows.':
      'Prijaté a prebiehajúce práce sa tu zobrazia s narastajúcou aktivitou v oblasti dopravy.',
    'Your role does not have permission to open this page.':
      'Vaša rola nemá povolenie na otvorenie tejto stránky.',
    'Go to dashboard': 'Prejdite na informačný panel',
    'Trailer capacity is required.': 'Vyžaduje sa kapacita prívesu.',
    'How many cars can this trailer carry?': 'Koľko áut unesie tento príves?',
    'Set maximum number of cars this trailer can carry (1-20).':
      'Nastavte maximálny počet áut, ktoré môže tento príves prepravovať (1-20).',
    'Invalid max load (kg).': 'Neplatné maximálne zaťaženie (kg).',
    'Enter a valid weight between 1 and 100000 kg, or leave it empty.':
      'Zadajte platnú hmotnosť od 1 do 100 000 kg alebo nechajte pole prázdne.',
    'Maximum payload weight this truck can carry (optional).':
      'Maximálna užitočná hmotnosť, ktorú toto nákladné vozidlo unesie (voliteľné).',
    'Manage the company and contact details that appear across your listings, invoices, and account verification flows.':
      'Spravujte podrobnosti o spoločnosti a kontaktoch, ktoré sa zobrazujú vo vašich záznamoch, faktúrach a postupoch overenia účtu.',
    'Keep these details up to date so listings, invoices, and partner verification stay accurate.':
      'Udržujte tieto podrobnosti aktuálne, aby záznamy, faktúry a overenie partnera zostali presné.',
    'Unsaved changes': 'Neuložené zmeny',
    'All changes saved': 'Všetky zmeny boli uložené',
    'auth.sign_up_failed': 'Registrácia zlyhala',
    'auth.please_select_a_valid_role': 'Vyberte platnú rolu.',
    'booking.pickup_not_found': 'Vyzdvihnutie sa nenašlo.',
    'booking.delivery_not_found': 'Dodávka sa nenašla.',
    'booking.capacity': 'Kapacita',
    'booking.cmr_expiry': 'Expirácia CMR',
    'booking.uploaded': 'Nahrané',
    'booking.missing': 'Chýba',
    'booking.cmr_document': 'Dokument CMR',
    'booking.go_to_profile': 'Prejdite do profilu',
    'booking.click_to_download_purchase_terms':
      'Kliknutím stiahnete podmienky nákupu',
    'admin.purchase_terms_management': 'Správa nákupných podmienok',
    'admin.purchase_terms_management_subtitle':
      'Nahrajte a spravujte lokalizované súbory PDF s podmienkami nákupu používané pri prijímaní partnerských objednávok.',
    'admin.document_language': 'Jazyk dokumentu',
    'admin.click_to_download_purchase_terms':
      'Kliknutím stiahnete podmienky nákupu',
    'admin.current_language_label': 'Aktuálny jazyk: {{language}}',
    'admin.purchase_terms_unavailable_for_selected_language':
      'Dokument s podmienkami nákupu nie je pre vybratý jazyk k dispozícii.',
    'Download and review the active purchase terms in your current interface language before continuing.':
      'Pred pokračovaním si stiahnite a skontrolujte podmienky aktívneho nákupu vo vašom aktuálnom jazyku rozhrania.',
    'We make agreements and conclude a contract for the carriage of goods. I have just read this agreement in full and agree to its contents.':
      'Robíme dohody a uzatvárame zmluvu o preprave tovaru. Práve som si prečítal celú túto zmluvu a súhlasím s jej obsahom.',
    'I confirm that I will schedule this order within 24 hours':
      'Potvrdzujem, že túto objednávku naplánujem do 24 hodín',
    'Failed to load purchase terms document.':
      'Nepodarilo sa načítať dokument nákupných podmienok.',
    'Partner rating': 'Hodnotenie partnera',
    'Bronze requirements': 'Bronzové požiadavky',
    'Orders in quarter': 'Objednávky za štvrťrok',
    'Cancellation rate / 100 orders': 'Miera zrušenia / 100 objednávok',
    'Damage claims / 100 orders': 'Nároky na poškodenie / 100 objednávok',
    '{{current}} / min {{target}}': '{{current}} / min {{target}}',
    '{{current}} / max {{target}}': '{{current}} / max {{target}}',
    Met: 'Met',
    'Not met': 'Nesplnené',
    Unranked: 'Nehodnotené',
    'profile.incompleteDescriptionPartner':
      'Vyplňte informácie o svojom profile (spoločnosť, telefón, adresa, mesto, PSČ, IČ DPH), aby ste získali prístup ku všetkým funkciám.',
    'profile.incompleteDescriptionClient':
      'Vyplňte informácie o svojom profile (telefónne číslo), aby ste získali prístup ku všetkým funkciám.',
    'auth.verification_email_sent': 'Overovací e-mail bol odoslaný',
    '{{amount}} above the client target': '{{amount}} nad klientskym cieľom',
    '{{amount}} below the client target': '{{amount}} pod klientskym cieľom',
    '{{count}} image(s) added to the listing.':
      '{{count}} snímky pridané do zoznamu.',
    '{{count}} quote(s) received': 'Prijaté ponuky {{count}}',
    '{{count}} reviews': '{{count}} recenzií',
    '{{count}} total': 'celkom {{count}}',
    '{{count}} visible': 'Viditeľné {{count}}',
    '{{weight}} kg': '{{weight}} kg',
    'A Google route preview with pins A and B appears here once pickup and delivery coordinates are available.':
      'Keď budú k dispozícii súradnice vyzdvihnutia a doručenia, zobrazí sa tu ukážka trasy Google s kolíkmi A a B.',
    'A route preview appears once map coordinates are available.':
      'Keď sú k dispozícii súradnice mapy, zobrazí sa náhľad trasy.',
    'A timeline of clarifications connected to this listing.':
      'Časová os objasnení spojených s týmto zoznamom.',
    "Accept {{partner}}'s quote for {{amount}}?":
      'Prijať cenovú ponuku {{partner}} za {{amount}}?',
    'Accept Listing': 'Prijať výpis',
    'Accept quote': 'Prijmite cenovú ponuku',
    'Accepted quote': 'Prijatá cenová ponuka',
    'Accepted quote required': 'Vyžaduje sa prijatá cenová ponuka',
    'Accepting...': 'Prijíma sa...',
    Active: 'Aktívne',
    'Active statuses': 'Aktívne stavy',
    'Add another item': 'Pridajte ďalšiu položku',
    'Add images': 'Pridajte obrázky',
    'Add more shipment images': 'Pridajte ďalšie obrázky zásielky',
    'After you confirm an AI action, open the prepared destination immediately instead of waiting for a manual click.':
      'Po potvrdení akcie AI okamžite otvorte pripravený cieľ namiesto čakania na manuálne kliknutie.',
    'AI Assistant': 'Asistent AI',
    'AI assistant disabled for all users.':
      'Asistent AI je zakázaný pre všetkých používateľov.',
    'AI assistant enabled for all users.':
      'Asistent AI povolený pre všetkých používateľov.',
    'AI assistant preferences updated':
      'Predvoľby asistenta AI boli aktualizované',
    'AI disabled for user.': 'AI je pre používateľa zakázaná.',
    'AI enabled for user.': 'AI povolená pre používateľa.',
    'AI-powered message translation between languages':
      'Preklad správ medzi jazykmi poháňaný AI',
    'All route-critical information in one place before you review quotes or documents.':
      'Všetky dôležité informácie o trase na jednom mieste predtým, ako si prezriete cenové ponuky alebo dokumenty.',
    View: 'Zobraziť',
    Answer: 'Odpoveď',
    Archive: 'Archív',
    'Archived statuses': 'Archivované stavy',
    'Are you sure you want to reject the quote from':
      'Naozaj chcete odmietnuť citát z?',
    'Ask a question about this listing...': 'Opýtajte sa na tento inzerát...',
    'Ask for matching lanes, quote help, or the next operational step.':
      'Požiadajte o zodpovedajúce pruhy, ponúknite pomoc alebo ďalší operačný krok.',
    'Ask for quote comparisons or a prepared next step from this shipment screen.':
      'Požiadajte o porovnanie cenových ponúk alebo pripravený ďalší krok z tejto obrazovky zásielky.',
    'Assistant history cleared': 'História Asistenta bola vymazaná',
    'Automatically translate messages from other users into your preferred language using AI.':
      'Automaticky preložte správy od iných používateľov do vášho preferovaného jazyka pomocou AI.',
    'Back to listing': 'Späť na výpis',
    'Best offer': 'Najlepšia ponuka',
    'Best quote': 'Najlepší citát',
    'Body type: {{type}}': 'Typ tela: {{type}}',
    'Breed: {{breed}}': 'Plemeno: {{breed}}',
    Budget: 'Rozpočet',
    'Cancel listing': 'Zrušiť výpis',
    'Canceled and completed work will appear here once listings move out of the active view.':
      'Zrušené a dokončené práce sa tu zobrazia, keď sa záznamy presunú z aktívneho zobrazenia.',
    'Cargo Details': 'Podrobnosti o náklade',
    Categories: 'kategórie',
    'Choose the interface language. This preference is saved locally and applies immediately.':
      'Vyberte jazyk rozhrania. Táto predvoľba sa uloží lokálne a okamžite sa použije.',
    'Clear all': 'Vymazať všetko',
    'Clear assistant history': 'Vymazať históriu asistenta',
    'Client price in EUR': 'Klientska cena v EUR',
    'Client target price': 'Cieľová cena klienta',
    'Complete the payment below to lock the fixed-price acceptance and let the partner start planning.':
      'Dokončite platbu nižšie, aby ste uzamkli prijatie pevnej ceny a umožnili partnerovi začať plánovať.',
    'Complete the payment below to lock the selected quote and let the partner start planning.':
      'Dokončite platbu nižšie, aby ste uzamkli vybranú cenovú ponuku a nechali partnera začať plánovať.',
    'Compose area prepared for listing Q&A. Submission remains disabled until the live question endpoint is connected on this page.':
      'Vytvoriť oblasť pripravenú na zoznam otázok a odpovedí. Odosielanie zostáva zakázané, kým sa na tejto stránke nepripojí koncový bod aktuálnej otázky.',
    'Confirm delivery complete': 'Potvrdenie dokončenia dodávky',
    'Confirm payment received': 'Potvrďte prijatú platbu',
    'Confirm that you have received the bank transfer or payment for this listing. This will move the listing to Paid status and allow the partner to mark it as planned.':
      'Potvrďte, že ste prijali bankový prevod alebo platbu za tento inzerát. Tým sa záznam presunie do stavu Platené a partner ho bude môcť označiť ako plánovaný.',
    'Confirm the exact fleet and dates before the listing moves to Planned.':
      'Potvrďte presnú flotilu a dátumy predtým, ako sa zoznam presunie do Plánovaného.',
    'Confirm Transport Plan': 'Potvrďte plán prepravy',
    'Confirming...': 'Potvrdzuje sa...',
    'Control how the web assistant behaves on this device. These settings do not change your account data.':
      'Ovládajte správanie webového asistenta na tomto zariadení. Tieto nastavenia nemenia údaje o vašom účte.',
    'Create listing': 'Vytvorte záznam',
    'Create with AI': 'Vytvárajte pomocou AI',
    'Create your next transport request and it will appear here with route, item, and quote activity.':
      'Vytvorte svoju ďalšiu požiadavku na prepravu a zobrazí sa tu s aktivitou trasy, položky a ponuky.',
    'Current stage:': 'Súčasná fáza:',
    'Current status': 'Aktuálny stav',
    'Delivery confirmation needed': 'Potrebné potvrdenie o doručení',
    'Delivery radius': 'Polomer doručenia',
    'Delivery:': 'Doručenie:',
    'Describe the route and cargo, then review the prepared listing draft before publishing.':
      'Popíšte trasu a náklad a pred zverejnením si prečítajte pripravený návrh zoznamu.',
    'Describe the shipment you need and review the prepared request before publishing.':
      'Popíšte zásielku, ktorú potrebujete, a pred zverejnením skontrolujte pripravenú žiadosť.',
    'Download and review the purchase terms before confirming the transport plan.':
      'Pred potvrdením plánu prepravy si stiahnite a skontrolujte podmienky nákupu.',
    'Download invoice': 'Stiahnite si faktúru',
    'Download Purchase Terms': 'Stiahnite si podmienky nákupu',
    'Draft with AI': 'Návrh s AI',
    'Draft your review first, then submit it here when you are satisfied.':
      'Najprv napíšte svoju recenziu a keď budete spokojní, odošlite ju sem.',
    'Edit listing': 'Upraviť záznam',
    'Edit Quote': 'Upraviť cenovú ponuku',
    Enable: 'Povoliť',
    'Enable live translation': 'Povoliť živý preklad',
    'Enabled Users': 'Povolení používatelia',
    'Engagement Activity': 'Zásnubná aktivita',
    'Expires:': 'Platnosť vyprší:',
    'Failed to accept listing': 'Nepodarilo sa prijať záznam',
    'Failed to accept quote': 'Nepodarilo sa prijať cenovú ponuku',
    'Failed to clear assistant history':
      'Históriu asistenta sa nepodarilo vymazať',
    'Failed to complete listing': 'Zoznam sa nepodarilo dokončiť',
    'Failed to confirm payment': 'Nepodarilo sa potvrdiť platbu',
    'Failed to confirm transport plan': 'Plán dopravy sa nepodarilo potvrdiť',
    'Failed to disable AI for user.':
      'Nepodarilo sa zakázať AI pre používateľa.',
    'Failed to enable AI for user.':
      'Nepodarilo sa povoliť AI pre používateľa.',
    'Failed to load listing.': 'Načítanie záznamu zlyhalo.',
    'Failed to load listings': 'Načítanie záznamov zlyhalo',
    'Failed to load listings. Please try again.':
      'Načítanie záznamov zlyhalo. Skúste to znova.',
    'Failed to load review context.': 'Nepodarilo sa načítať kontext recenzie.',
    'Failed to load settings.': 'Nepodarilo sa načítať nastavenia.',
    'Failed to refresh Stripe payment status':
      'Obnovenie stavu platby Stripe zlyhalo',
    'Failed to reject quote': 'Cenovú ponuku sa nepodarilo odmietnuť',
    'Failed to release listing': 'Uvoľnenie záznamu zlyhalo',
    'Failed to save quote': 'Cenovú ponuku sa nepodarilo uložiť',
    'Failed to update listing': 'Aktualizácia záznamu zlyhala',
    'Failed to update preferred language':
      'Aktualizácia preferovaného jazyka zlyhala',
    'Failed to update setting.': 'Aktualizácia nastavenia zlyhala.',
    'Failed to update status': 'Aktualizácia stavu zlyhala',
    'Failed to update translation preference':
      'Predvoľbu prekladu sa nepodarilo aktualizovať',
    'Failed to update watchlist': 'Aktualizácia zoznamu sledovaných zlyhala',
    'Failed to withdraw quote': 'Nepodarilo sa stiahnuť cenovú ponuku',
    'Feature Flags': 'Príznaky funkcie',
    'Filter invoice uploads, search by reference, and page through payout records.':
      'Filtrujte nahrávané faktúry, vyhľadávajte podľa referencií a listujte v záznamoch platieb.',
    Filters: 'Filtre',
    'Final delivery documents': 'Konečné dodacie dokumenty',
    'Fixed price only': 'Len pevná cena',
    'Flexible / not set': 'Flexibilné / nenastavené',
    'Generated automatically when the transport plan is confirmed.':
      'Generuje sa automaticky po potvrdení plánu prepravy.',
    'Generation: {{generation}}': 'Generácia: {{generation}}',
    'Goods delivered — awaiting client confirmation.':
      'Tovar doručený — čaká sa na potvrdenie klienta.',
    'Gross price': 'Hrubá cena',
    'I have read and agree to the purchase terms for this transport job.':
      'Prečítal som si a súhlasím s podmienkami nákupu pre túto prepravu.',
    'I understand that accepting this listing assigns it to me at the fixed client price shown above.':
      'Rozumiem, že akceptovaním tohto záznamu mi to prideľuje za fixnú klientsku cenu uvedenú vyššie.',
    'Image upload failed': 'Nahranie obrázka zlyhalo',
    'Images uploaded': 'Obrázky boli odovzdané',
    'Interface language': 'Jazyk rozhrania',
    'Invoice documents': 'Fakturačné doklady',
    'Item {{number}}': 'Položka {{number}}',
    items: 'položky',
    'Keep listing': 'Udržujte zoznam',
    'Keep quote': 'Ponechajte citát',
    'Keep the current AI session available after closing the browser on this device.':
      'Po zatvorení prehliadača na tomto zariadení nechajte aktuálnu reláciu AI k dispozícii.',
    'Language & Region': 'Jazyk a región',
    'Lift: {{origin}} / {{destination}}': 'Zdvih: {{origin}} / {{destination}}',
    Listed: 'Uvedené',
    'Listing {{id}}': 'Výpis {{id}}',
    'Listing accepted': 'Výpis prijatý',
    'Listing expired': 'Platnosť záznamu vypršala',
    'Listing images': 'Zoznam obrázkov',
    'Listing is live': 'Výpis je aktívny',
    'Listing reference': 'Odkaz na zoznam',
    'Listing snapshot': 'Snímka výpisu',
    'Listing unavailable': 'Zoznam nie je k dispozícii',
    'Listing updated': 'Zoznam bol aktualizovaný',
    'Live Translation': 'Živý preklad',
    'Live translation disabled.': 'Živý preklad je zakázaný.',
    'Live translation enabled.': 'Živý preklad je povolený.',
    'Loading approved trucks...': 'Načítavam schválené nákladné autá...',
    'Loading fleet...': 'Načítava sa flotila...',
    'Loading listing details...': 'Načítavajú sa podrobnosti záznamu...',
    'Loading listings...': 'Načítavajú sa záznamy...',
    'Loading review details...': 'Načítavajú sa podrobnosti recenzie...',
    'Loading settings...': 'Načítavajú sa nastavenia...',
    'Manage AI Assistant Users': 'Spravujte používateľov asistenta AI',
    'Manage platform-wide feature flags and configuration.':
      'Spravujte príznaky a konfiguráciu funkcií pre celú platformu.',
    'Manage Users': 'Spravovať používateľov',
    'Manage your transport requests, monitor quote activity, and keep active and archived work easy to scan.':
      'Spravujte svoje požiadavky na prepravu, monitorujte aktivitu cenových ponúk a zabezpečte, aby sa aktívna a archivovaná práca dala ľahko skenovať.',
    'Mark Picked Up': 'Mark vyzdvihnutý',
    'Matches the client target price': 'Zodpovedá cieľovej cene klienta',
    Media: 'Médiá',
    Messages: 'Správy',
    'Messages will be translated into this language.':
      'Správy budú preložené do tohto jazyka.',
    'Minimum net:': 'Minimálna čistá:',
    'My invoices': 'Moje faktúry',
    Net: 'Net',
    'Net price': 'Čistá cena',
    'Net quote': 'Čistá ponuka',
    'New images appear immediately in the listing details for client, partner, and admin views.':
      'Nové obrázky sa okamžite objavia v detailoch záznamu pre zobrazenia klienta, partnera a správcu.',
    'Next step': 'Ďalší krok',
    'No active listings yet': 'Zatiaľ žiadne aktívne záznamy',
    'No address provided': 'Nie je uvedená žiadna adresa',
    'No answer yet.': 'Zatiaľ žiadna odpoveď.',
    'No archived listings yet': 'Zatiaľ žiadne archivované záznamy',
    'No description added.': 'Nie je pridaný žiadny popis.',
    'no destination': 'žiadny cieľ',
    'No expiry': 'Žiadna platnosť',
    'No listings match the current filters. Try broadening the search or date range.':
      'Aktuálnym filtrom nevyhovujú žiadne záznamy. Skúste rozšíriť vyhľadávanie alebo rozsah dátumov.',
    'no origin': 'žiadny pôvod',
    'No questions yet': 'Zatiaľ žiadne otázky',
    'No quotes yet': 'Zatiaľ bez úvodzoviek',
    'No shipment images uploaded yet.':
      'Zatiaľ neboli nahrané žiadne obrázky zásielky.',
    'No trailer selected': 'Nie je vybratá žiadna upútavka',
    'No unread messages': 'Žiadne neprečítané správy',
    'No users found.': 'Nenašli sa žiadni používatelia.',
    'No users have AI enabled.': 'Žiadni používatelia nemajú povolenú AI.',
    'Not selected': 'Nevybraté',
    'Offers summary': 'Súhrn ponúk',
    'Open AI assistant': 'Otvorte asistenta AI',
    'Open prepared screens automatically':
      'Automaticky otvárať pripravené obrazovky',
    'Optional visible price shown to partners as your target budget.':
      'Voliteľná viditeľná cena zobrazená partnerom ako váš cieľový rozpočet.',
    'Other quotes will be declined automatically once this offer is accepted.':
      'Ostatné ponuky budú po prijatí tejto ponuky automaticky odmietnuté.',
    'Partner delivery': 'Partnerské doručenie',
    'Partner pickup': 'Partnerské vyzdvihnutie',
    'Partner quote': 'Cenová ponuka partnera',
    'Payment confirmed': 'Platba potvrdená',
    'Payment confirmed — listing status set to paid':
      'Platba potvrdená – stav záznamu nastavený na zaplatenú',
    'Payment confirmed. Confirm the assigned fleet and planned dates before the listing moves to Planned.':
      'Platba potvrdená. Potvrďte pridelenú flotilu a plánované dátumy predtým, ako sa zoznam presunie do Plánovaného.',
    'Payment is confirmed. The partner now needs to confirm the truck, driver, and planned dates.':
      'Platba je potvrdená. Partner teraz musí potvrdiť kamión, vodiča a plánované dátumy.',
    'Payment required': 'Vyžaduje sa platba',
    'Photos uploaded for the shipment and visible across client, partner, and admin views.':
      'Fotografie nahrané pre zásielku a viditeľné v zobrazeniach klienta, partnera a správcu.',
    'Pickup is complete and the transport is currently underway.':
      'Vyzdvihnutie je dokončené a doprava práve prebieha.',
    'Pickup proof': 'Doklad o vyzdvihnutí',
    'Pickup proof and final delivery files uploaded by the transport partner.':
      'Súbory dokladov o vyzdvihnutí a konečného doručenia nahrané prepravným partnerom.',
    'Pickup to delivery overview': 'Prehľad od prevzatia do doručenia',
    'Pickup:': 'Vyzdvihnutie:',
    'Plan and authorization': 'Plán a autorizácia',
    'Plan transport': 'Plánujte dopravu',
    'Plan Transport': 'Plánovanie dopravy',
    'Planned dates:': 'Plánované termíny:',
    'Planned delivery date': 'Plánovaný termín dodania',
    'Platform Settings': 'Nastavenia platformy',
    'Preferred language': 'Preferovaný jazyk',
    'Preferred language updated': 'Preferovaný jazyk bol aktualizovaný',
    'Prepare a quote or ask for the next lane action, then confirm before anything is submitted.':
      'Pripravte si cenovú ponuku alebo požiadajte o akciu v ďalšom jazdnom pruhu a potom potvrďte, než niečo odošlete.',
    'Purchase Terms': 'Podmienky nákupu',
    'Quantities, dimensions, and handling details ready for transport review.':
      'Množstvo, rozmery a podrobnosti o manipulácii pripravené na kontrolu prepravy.',
    Question: 'Otázka',
    Questions: 'Otázky',
    'Questions & answers': 'Otázky a odpovede',
    'Questions and answers for this listing will appear here once the messaging flow is active.':
      'Otázky a odpovede pre tento záznam sa tu zobrazia, keď bude tok správ aktívny.',
    'Quick access to the current shipment, quote, and billing state.':
      'Rýchly prístup k aktuálnemu stavu zásielky, cenovej ponuky a fakturácie.',
    'Quote accepted': 'Cenová ponuka bola prijatá',
    'Quote count': 'Počet citátov',
    'Quote message': 'Citovať správu',
    'Quote rejected': 'Cenová ponuka zamietnutá',
    'Quote withdrawn': 'Citácia stiahnutá',
    Quotes: 'Citáty',
    'Quotes and questions': 'Citáty a otázky',
    'Quotes are disabled for this listing. The first partner to accept the fixed price will be assigned automatically.':
      'Cenové ponuky sú pre tento záznam zakázané. Prvý partner, ktorý akceptuje pevnú cenu, bude priradený automaticky.',
    'Quotes are disabled for this shipment. If you accept it, the client price becomes an accepted booking immediately.':
      'Cenové ponuky sú pre túto zásielku zakázané. Ak ju prijmete, klientska cena sa okamžite stane akceptovanou rezerváciou.',
    'Quotes from transport providers usually begin to appear shortly after publishing. Refresh to check again.':
      'Cenové ponuky dopravcov sa zvyčajne začínajú objavovať krátko po zverejnení. Obnovte a skontrolujte znova.',
    'Reference #{{id}}': 'Referenčné číslo {{id}}',
    'Refresh listings': 'Obnoviť zoznamy',
    'Reject quote': 'Odmietnuť cenovú ponuku',
    'Rejecting...': 'Odmietanie...',
    Release: 'Uvoľnite',
    'Release Listing': 'Zoznam vydania',
    'Remember assistant conversation': 'Pamätajte na konverzáciu s asistentom',
    'Required for fixed-price listings. Partners accept this amount directly.':
      'Vyžaduje sa pre ponuky s pevnou cenou. Partneri akceptujú túto sumu priamo.',
    'Required. Partners will be able to accept this listing at the fixed client price without sending a quote.':
      'Povinné. Partneri budú môcť akceptovať túto ponuku za pevnú klientsku cenu bez odoslania cenovej ponuky.',
    'Review submission failed.': 'Odoslanie recenzie zlyhalo.',
    'Review the completed transport using the standard product flow.':
      'Skontrolujte dokončenú prepravu pomocou štandardného toku produktov.',
    'Route pending': 'Trasa čaká na spracovanie',
    'Save changes': 'Uložiť zmeny',
    'Saving...': 'Ukladá sa...',
    'Search by title, route, category, or item':
      'Vyhľadávajte podľa názvu, trasy, kategórie alebo položky',
    'Search Results': 'Výsledky vyhľadávania',
    'Search users by email...': 'Hľadať používateľov podľa e-mailu...',
    'Select a truck, driver, pickup date, and delivery date.':
      'Vyberte nákladné auto, vodiča, dátum vyzdvihnutia a dátum dodania.',
    'Select approved truck': 'Vyberte schválený nákladný automobil',
    'Select driver': 'Vyberte ovládač',
    'Send Revision': 'Odoslať revíziu',
    Sentiment: 'Sentiment',
    'Share what went well and what could improve':
      'Podeľte sa o to, čo sa vydarilo a čo by sa mohlo zlepšiť',
    'Shipment in transit': 'Zásielka v tranzite',
    'Shipment notes': 'Zásielkové listy',
    'Shipment tracking will be shared': 'Sledovanie zásielky bude zdieľané',
    'Show AI launchers': 'Ukážte spúšťače AI',
    'Show or hide AI assistant buttons on supported dashboard and listing pages.':
      'Zobraziť alebo skryť tlačidlá asistenta AI na podporovanom informačnom paneli a stránkach so zoznamom.',
    'Special needs or notes': 'Špeciálne potreby alebo poznámky',
    'Specify delivery dates': 'Uveďte dátumy doručenia',
    'Specify pickup dates': 'Uveďte dátumy vyzdvihnutia',
    Stage: 'Etapa',
    'Status updated to {{status}}': 'Stav bol aktualizovaný na {{status}}',
    'Stripe payment confirmed and booking updated':
      'Stripe platba bola potvrdená a rezervácia aktualizovaná',
    'Stripe status: {{status}}': 'Stav pruhu: {{status}}',
    'Submit question': 'Odoslať otázku',
    'Submit review': 'Odoslať recenziu',
    'Submitting...': 'Odosiela sa...',
    'The AI assistant is currently disabled for this environment. Existing local session data can still be cleared here.':
      'Asistent AI je momentálne pre toto prostredie vypnutý. Existujúce údaje o miestnej relácii tu možno stále vymazať.',
    'The listing expired before a transport was confirmed.':
      'Platnosť zoznamu vypršala pred potvrdením prepravy.',
    'The listing has been fully completed and archived as a finished transport.':
      'Výpis bol kompletne dokončený a archivovaný ako hotový transport.',
    'The lowest net price you would still accept for this shipment.':
      'Najnižšia čistá cena, ktorú by ste za túto zásielku ešte akceptovali.',
    'The partner has confirmed the route plan. Pickup and delivery dates are now scheduled.':
      'Partner potvrdil plán trasy. Termíny vyzdvihnutia a doručenia sú už naplánované.',
    'The partner marked the shipment as delivered. Review the final documents and confirm completion.':
      'Partner označil zásielku ako doručenú. Skontrolujte konečné dokumenty a potvrďte dokončenie.',
    'The partner-confirmed plan and LOA stay grouped together for faster review.':
      'Partnerom potvrdený plán a LOA zostávajú zoskupené kvôli rýchlejšej kontrole.',
    'This action notifies the transport provider and removes the quote from active consideration.':
      'Táto akcia upozorní poskytovateľa dopravy a odstráni ponuku z aktívneho posudzovania.',
    'This listing is archived and no further transport actions are available.':
      'Tento zoznam je archivovaný a nie sú k dispozícii žiadne ďalšie prepravné akcie.',
    'This listing needs an accepted quote before a review can be created.':
      'Tento záznam potrebuje pred vytvorením recenzie akceptovanú cenovú ponuku.',
    'This will soft-cancel the listing and move it to your archive.':
      'Týmto sa záznam jemne zruší a presunie sa do vášho archívu.',
    'This will soft-cancel the listing for the client and remove it from active marketplace views.':
      'Týmto sa záznam pre klienta jemne zruší a odstráni sa z aktívnych zobrazení trhoviska.',
    'Total quote': 'Celková cenová ponuka',
    'Tracking not promised': 'Sledovanie nie je sľúbené',
    'Tracking shared': 'Sledovanie zdieľané',
    'Tracking visibility': 'Viditeľnosť sledovania',
    'Trailer (Optional)': 'Upútavka (voliteľné)',
    'Translation preference updated': 'Predvoľba prekladu bola aktualizovaná',
    'Transport completed': 'Transport dokončený',
    'Transport completed.': 'Transport dokončený.',
    'Transport documents': 'Prepravné doklady',
    'Transport marked as complete': 'Preprava označená ako dokončená',
    'Transport package': 'Prepravný balík',
    'Transport plan confirmed': 'Plán dopravy potvrdený',
    'Transport plan updated': 'Plán dopravy bol aktualizovaný',
    'Transport planned': 'Plánovaná doprava',
    'Transport Provider': 'Poskytovateľ dopravy',
    'Transport providers can review your shipment and send offers.':
      'Poskytovatelia prepravy môžu skontrolovať vašu zásielku a poslať ponuky.',
    'Transport stage': 'Dopravné štádium',
    Truck: 'Nákladné auto',
    'Truck, driver, trailer, and planned dates for this shipment.':
      'Nákladné auto, vodič, príves a plánované dátumy pre túto zásielku.',
    'Try widening the current listing filters.':
      'Skúste rozšíriť aktuálne filtre záznamov.',
    'Unable to upload listing images.':
      'Nie je možné odovzdať obrázky záznamov.',
    'Unknown error': 'Neznáma chyba',
    'Untitled listing': 'Zoznam bez názvu',
    'Untitled Listing': 'Zoznam bez názvu',
    'Update media': 'Aktualizujte médiá',
    'Update transport plan': 'Aktualizujte plán dopravy',
    'Update Transport Plan': 'Aktualizovať dopravný plán',
    'Upload a CMR or delivery photos before marking delivered.':
      'Pred označením doručenia nahrajte CMR alebo fotografie doručenia.',
    'Upload a CMR or delivery photos before the listing can move to Delivered.':
      'Nahrajte CMR alebo fotografie doručenia predtým, než sa záznam presunie do Doručené.',
    'Upload at least one pickup proof before the listing can move to Picked Up.':
      'Nahrajte aspoň jeden doklad o vyzdvihnutí, kým sa záznam presunie do zoznamu Vyzdvihnuté.',
    'Upload final documents': 'Nahrajte finálne dokumenty',
    'Upload proof of pickup': 'Nahrajte doklad o vyzdvihnutí',
    'Uploading...': 'Nahráva sa...',
    'Use fresh photos when the shipment changes or you want to clarify the item condition.':
      'Použite čerstvé fotografie, keď sa zásielka zmení alebo ak chcete objasniť stav položky.',
    'users enabled': 'povolených používateľov',
    'Visible to you while quoting. You can still send your own net offer below or above this amount.':
      'Viditeľné pre vás počas citovania. Stále môžete poslať vlastnú čistú ponuku pod alebo nad túto sumu.',
    'Waiting for partner acceptance': 'Čakanie na prijatie partnera',
    'Waiting for transport planning': 'Čaká sa na plánovanie dopravy',
    'When enabled, messages from other users will be automatically translated to your preferred language.':
      'Keď je táto možnosť povolená, správy od iných používateľov sa automaticky preložia do vášho preferovaného jazyka.',
    Withdraw: 'Odstúpiť',
    'Write Review': 'Napíšte recenziu',
    'You are about to release this listing back to the marketplace.':
      'Chystáte sa vrátiť tento záznam späť na trh.',
    'You are now the assigned partner for this fixed-price listing.':
      'Teraz ste priradeným partnerom pre túto ponuku s pevnou cenou.',
    'Your quote has been accepted. Awaiting payment confirmation from the admin before you can begin the job.':
      'Vaša ponuka bola prijatá. Pred začatím práce sa čaká na potvrdenie platby od správcu.',
    'VIN: {{vin}}': 'VIN: {{vin}}',
  },
  sl: {
    to: 'do',
    kg: 'kg',
    Hatchback: 'Hatchback',
    Coupé: 'Coupé',
    Sedan: 'Limuzina',
    Crossover: 'Crossover',
    Required: 'Obvezno',
    'Change language': 'Spremeni jezik',
    'Loading...': 'Nalaganje ...',
    'Error:': 'Napaka:',
    Close: 'Zapri',
    Yes: 'ja',
    No: 'št',
    'Keep order': 'Ohranite red',
    Price: 'Cena',
    'Purchase terms': 'Nakupni pogoji',
    'Power of attorney': 'Pooblastilo',
    'Transport details': 'Podrobnosti o prevozu',
    'Upload damages': 'Poškodbe nalaganja',
    'Download (PDF)': 'Prenesi (PDF)',
    'Mark as picked up': 'Označi kot prevzeto',
    'Mark as delivered': 'Označi kot dostavljeno',
    'Cancel booking': 'Prekliči rezervacijo',
    'Order marked as picked up': 'Naročilo označeno kot prevzeto',
    'Order marked as delivered': 'Naročilo označeno kot dostavljeno',
    'Order canceled': 'Naročilo preklicano',
    'Failed to cancel order': 'Preklic naročila ni uspel',
    'Added {{count}} file(s)': 'Dodane datoteke {{count}}',
    Pages: 'Strani',
    'Awaiting Verification': 'Čakanje na preverjanje',
    Profile: 'Profil',
    'Profile Incomplete': 'Profil je nedokončan',
    'Please complete your profile information (Company, Phone, Address, City, Post Code) to access all features.':
      'Za dostop do vseh funkcij izpolnite podatke o svojem profilu (podjetje, telefon, naslov, mesto, poštna številka).',
    'Go to Profile': 'Pojdite na Profil',
    'Forgot Password': 'Pozabljeno geslo',
    Hello: 'zdravo',
    friend: 'prijatelj',
    'Book your transport': 'Rezervirajte svoj prevoz',
    'fast and easy': 'hitro in enostavno',
    'Keep an eye on the route and quote at a glance.':
      'Spremljajte pot in takoj preglejte ponudbo.',
    Origin: 'Izvor',
    Destination: 'Destinacija',
    'Postal code': 'Poštna številka',
    'Calculate to preview': 'Izračunajte za predogled',
    "Can't be calculated yet": 'Še ni mogoče izračunati',
    'Awaiting payment badge': 'Čakanje na plačilo',
    'Ref {{id}}': 'Ref. {{id}}',
    'Change planning': 'Spremenite načrtovanje',
    'Change driver': 'Zamenjajte voznika',
    'No vehicles listed': 'Ni navedenih vozil',
    'Order not found.': 'Naročilo ni bilo najdeno.',
    'Not available': 'Ni na voljo',
    'For {{date}}': 'Za {{date}}',
    'Picked on {{date}}': 'Izbrano na {{date}}',
    'Delivered on {{date}}': 'Dostavljeno na {{date}}',
    'Loading notification: {{value}}': 'Nalaganje obvestila: {{value}}',
    'CO₂ compensation: {{value}}': 'Kompenzacija CO₂: {{value}}',
    'Bio fuel: {{value}}': 'Biogorivo: {{value}}',
    Remove: 'Odstrani',
    'Copy {{label}}': 'Kopiraj {{label}}',
    'Open navigation menu': 'Odpri navigacijski meni',
    'Open menu': 'Odpri meni',
    'Error fetching data': 'Napaka pri pridobivanju podatkov',
    'Not set': 'Ni nastavljeno',
    'No opening hours provided': 'Odpiralni čas ni naveden',
    'Please select a planned date': 'Izberite načrtovani datum',
    'Saved favorite route filter': 'Shranjen filter priljubljenih poti',
    km: 'km',
    mi: 'mi',
    'Radius search': 'Iskanje po radiusu',
    'City or town': 'Mesto ali kraj',
    'Country (optional)': 'Država (neobvezno)',
    Radius: 'Radij',
    'Searching…': 'Iskanje ...',
    'City not found': 'Mesto ni bilo najdeno',
    'Within {{radius}} {{unit}} of {{place}}':
      'Znotraj {{radius}} {{unit}} od {{place}}',
    'Clear radius': 'Čisti polmer',
    'auth.status_label': 'Stanje',
    'auth.account_status_pending_review': 'Stanje računa: čaka na pregled',
    'auth.your_account_is_pending_approval': 'Vaš račun čaka na odobritev',
    'auth.upload_your_verification_documents_below_and_we_ll_notify_you_by_email_once_your_account_is_approved':
      'Spodaj naložite dokumente za preverjanje in obvestili vas bomo po e-pošti, ko bo vaš račun odobren.',
    'auth.check_status': 'Preverite stanje',
    'auth.upload_verification_documents': 'Naložite dokumente za preverjanje',
    'auth.your_uploaded_documents': 'Vaši naloženi dokumenti',
    'auth.back_to_sign_in': 'Nazaj na prijavo',
    role_partner: 'Partner',
    partner: 'Partner',
    admin: 'skrbnik',
    'Q1 2025': '1. četrtletje 2025',
    'Q2 2025': '2. četrtletje 2025',
    'Q3 2025': '3. četrtletje 2025',
    Kosovo: 'Kosovo',
    Malta: 'Malta',
    'San Marino': 'San Marino',
    'BodyType.Hatchback': 'Hatchback',
    'BodyType.Crossover': 'Crossover',
    'BodyType.Pickup': 'Prevzem',
    'N/A': 'N/A',
    Partner: 'Partner',
    Model: 'Model',
    'Error loading documents': 'Napaka pri nalaganju dokumentov',
    'Are you sure you want to delete this document?':
      'Ali ste prepričani, da želite izbrisati ta dokument?',
    'Document deleted': 'Dokument izbrisan',
    'Failed to delete': 'Brisanje ni uspelo',
    'Failed to get download link':
      'Povezave za prenos ni bilo mogoče pridobiti',
    'Status updated': 'Status posodobljen',
    'Update failed': 'Posodobitev ni uspela',
    'Email cannot be changed.': 'E-pošte ni mogoče spremeniti.',
    'No documents found.': 'Ni dokumentov.',
    'Invoice #': 'št. računa',
    'File Name': 'Ime datoteke',
    Amount: 'Znesek',
    Actions: 'Dejanja',
    Download: 'Prenos',
    'Mark Unpaid': 'Označi Neplačano',
    'Mark Paid': 'Označi Plačano',
    'Please save the record before uploading documents.':
      'Pred nalaganjem dokumentov shranite zapis.',
    'Select a file before uploading.': 'Pred nalaganjem izberite datoteko.',
    'Please enter an invoice number.': 'Vnesite številko računa.',
    'Upload successful': 'Nalaganje uspešno',
    '{{count}} file(s) uploaded successfully.':
      'Datoteke {{count}} so bile uspešno naložene.',
    'Upload failed': 'Nalaganje ni uspelo',
    'Unable to upload the document.': 'Dokumenta ni mogoče naložiti.',
    'Invoice Number': 'Številka računa',
    'Selected files:': 'Izbrane datoteke:',
    Upload: 'Naloži',
    'Save this record before uploading documents.':
      'Pred nalaganjem dokumentov shranite ta zapis.',
    'Error approving user': 'Napaka pri odobritvi uporabnika',
    'Error rejecting user': 'Napaka pri zavrnitvi uporabnika',
    'Error disabling user': 'Napaka pri onemogočanju uporabnika',
    'User marked as VIP': 'Uporabnik je označen kot VIP',
    'User unmarked as VIP': 'Uporabnik ni označen kot VIP',
    'Error marking user as VIP': 'Napaka pri označevanju uporabnika kot VIP',
    'Error unmarking user as VIP':
      'Napaka pri odstranjevanju oznake uporabnika kot VIP',
    'Failed to approve user': 'Uporabnika ni bilo mogoče odobriti',
    'Failed to reject user': 'Uporabnika ni bilo mogoče zavrniti',
    'Failed to disable user': 'Onemogočanje uporabnika ni uspelo',
    'Failed to unmark user as VIP':
      'Uporabnika ni bilo mogoče odznačiti kot VIP',
    'Failed to mark user as VIP': 'Uporabnika ni bilo mogoče označiti kot VIP',
    'Invoice Management': 'Upravljanje računov',
    'All Invoices': 'Vsi računi',
    'Manage all invoices uploaded by partners.':
      'Upravljajte vse račune, ki so jih naložili partnerji.',
    'An unexpected error occurred. Please try again.':
      'Prišlo je do nepričakovane napake. prosim poskusite znova',
    'The email address is not valid.': 'E-poštni naslov ni veljaven.',
    'This account has been disabled.': 'Ta račun je bil onemogočen.',
    'No account found with this email.':
      'S tem e-poštnim naslovom ni bilo mogoče najti nobenega računa.',
    'Incorrect password. Please try again.':
      'Napačno geslo. prosim poskusite znova',
    'Invalid email or password. Please check your credentials and try again.':
      'Neveljaven e-poštni naslov ali geslo. Preverite svoje poverilnice in poskusite znova.',
    'Too many failed attempts. Please try again later or reset your password.':
      'Preveč neuspelih poskusov. Poskusite znova pozneje ali ponastavite geslo.',
    'Network error. Check your connection and try again.':
      'Omrežna napaka. Preverite povezavo in poskusite znova.',
    'A verification email has been sent to your email address. Please verify your email before logging in.':
      'Potrditveno e-poštno sporočilo je bilo poslano na vaš e-poštni naslov. Preden se prijavite, potrdite svoj e-poštni naslov.',
    'Please make sure both passwords are the same.':
      'Prepričajte se, da sta obe gesli enaki.',
    'Verification email resent!':
      'Ponovno poslano potrditveno e-poštno sporočilo!',
    'Please check your inbox.': 'Prosimo, preverite svoj nabiralnik.',
    'You need to log in first': 'Najprej se morate prijaviti',
    'Please sign in to resend the verification email.':
      'Za ponovno pošiljanje potrditvenega e-poštnega sporočila se prijavite.',
    'Failed to resend email': 'Ponovno pošiljanje e-pošte ni uspelo',
    'Resend verification email': 'Ponovno pošlji potrditveno e-pošto',
    'Show password': 'Prikaži geslo',
    'Hide password': 'Skrij geslo',
    'Awaiting verification artwork': 'Čakanje na umetniško delo',
    'Account status: Pending review': 'Stanje računa: čaka na pregled',
    'Your account is pending approval': 'Vaš račun čaka na odobritev',
    "Upload your verification documents below and we'll notify you by email once your account is approved.":
      'Spodaj naložite dokumente za preverjanje in obvestili vas bomo po e-pošti, ko bo vaš račun odobren.',
    'Check status': 'Preverite stanje',
    'Upload verification documents': 'Naložite dokumente za preverjanje',
    'Your uploaded documents': 'Vaši naloženi dokumenti',
    'Back to sign in': 'Nazaj na prijavo',
    'Hide documents': 'Skrij dokumente',
    'Email verification required': 'Zahtevano je preverjanje e-pošte',
    'Waiting for email verification': 'Čakanje na potrditev e-pošte',
    'Check your email': 'Preverite svojo e-pošto',
    'We sent your verification link to':
      'Vašo povezavo za preverjanje smo poslali na',
    "Didn't receive it? Check your spam folder or try again.":
      'Niste ga prejeli? Preverite mapo z vsiljeno pošto ali poskusite znova.',
    'Resend email': 'Ponovno pošlji e-pošto',
    "I've verified my email": 'Preveril sem svoj e-poštni naslov',
    'Redirecting you now.': 'Preusmerjam vas zdaj.',
    'Email not verified yet': 'E-pošta še ni preverjena',
    'Please click the link in your inbox and try again.':
      'Kliknite povezavo v mapi »Prejeto« in poskusite znova.',
    'Unable to resend verification email right now.':
      'Trenutno ni mogoče znova poslati potrditvenega e-poštnega sporočila.',
    'Unable to check verification status right now.':
      'Stanja preverjanja trenutno ni mogoče preveriti.',
    "We've sent a new verification link to your email address.":
      'Na vaš e-poštni naslov smo poslali novo povezavo za preverjanje.',
    'We automatically check your verification status every 30 seconds. You can also trigger an instant check after verifying your email.':
      'Vsakih 30 sekund samodejno preverimo vaš status preverjanja. Po potrditvi e-pošte lahko sprožite tudi takojšnje preverjanje.',
    'We automatically check your verification status every 15 seconds. You can also trigger an instant check after verifying your email.':
      'Vsakih 15 sekund samodejno preverimo vaš status preverjanja. Po potrditvi e-pošte lahko sprožite tudi takojšnje preverjanje.',
    'Inputs changed. Recalculate the price.':
      'Spremenjeni vnosi. Preračunajte ceno.',
    'My Invoices': 'Moji računi',
    'Upload New Invoice': 'Naloži nov račun',
    'Please enter the invoice number and upload the invoice document. It will be reviewed by an administrator.':
      'Vnesite številko računa in naložite dokument računa. Pregledal ga bo administrator.',
    'Invoice History': 'Zgodovina računov',
    'Client ref · {{clientRef}}': 'Ref naročnika · {{clientRef}}',
    'Order Documents': 'Dokumenti za naročilo',
    'Upload Proof of Pickup': 'Naložite dokazilo o prevzemu',
    'Status will be updated to Picked Up after successful upload.':
      'Po uspešnem nalaganju bo status posodobljen na Prevzeto.',
    'Upload Proof of Delivery': 'Naložite dokazilo o dostavi',
    'Status will be updated to Delivered after successful upload.':
      'Po uspešnem nalaganju bo stanje posodobljeno na Dostavljeno.',
    'Enter first name': 'Vnesite ime',
    'Enter last name': 'Vnesite priimek',
    'Enter phone number': 'Vnesite telefonsko številko',
    'Driver updated.': 'Gonilnik posodobljen.',
    'The driver has been successfully updated.':
      'Gonilnik je bil uspešno posodobljen.',
    'Driver added.': 'Dodan gonilnik.',
    'The new driver has been successfully added.':
      'Nov gonilnik je bil uspešno dodan.',
    'Driver deleted.': 'Gonilnik izbrisan.',
    'The driver has been successfully deleted.':
      'Gonilnik je bil uspešno izbrisan.',
    'Trailer updated.': 'Napovednik posodobljen.',
    'The trailer has been successfully updated.':
      'Napovednik je bil uspešno posodobljen.',
    'Trailer added.': 'Dodan napovednik.',
    'The new trailer has been successfully added.':
      'Nov napovednik je bil uspešno dodan.',
    'Trailer deleted.': 'Napovednik izbrisan.',
    'The trailer has been successfully deleted.':
      'Napovednik je bil uspešno izbrisan.',
    'User account not found. Please complete registration.':
      'Uporabniški račun ni bil najden. Prosimo dokončajte registracijo.',
    'No token provided': 'Žeton ni na voljo',
    'Token expired': 'Žeton je potekel',
    'Token revoked': 'Žeton preklican',
    'Invalid ID token': 'Neveljaven ID žeton',
    Unauthorized: 'Nepooblaščeno',
    'Unauthorized: User not authenticated.':
      'Nepooblaščeno: uporabnik ni preverjen.',
    'Unauthorized: User role not found.':
      'Nepooblaščeno: vloga uporabnika ni bila najdena.',
    'Forbidden: Your role is not allowed to perform this action.':
      'Prepovedano: Vaša vloga ne sme izvajati tega dejanja.',
    'Forbidden: This action requires a partner role.':
      'Prepovedano: To dejanje zahteva partnersko vlogo.',
    'Forbidden: This action requires a client role.':
      'Prepovedano: To dejanje zahteva vlogo odjemalca.',
    'Forbidden: This action requires an admin role.':
      'Prepovedano: To dejanje zahteva vlogo skrbnika.',
    'This user has not been approved': 'Ta uporabnik ni bil odobren',
    'User email has not been verified': 'E-pošta uporabnika ni bila preverjena',
    'User account has been disabled': 'Uporabniški račun je bil onemogočen',
    'Booking not found': 'Rezervacije ni mogoče najti',
    'Route not found': 'Poti ni bilo mogoče najti',
    'Pickup location (country and postalCode) is required':
      'Zahtevana je lokacija prevzema (država in poštna številka).',
    'Delivery location (country and postalCode) is required':
      'Zahtevana je lokacija dostave (država in poštna številka).',
    'Unable to calculate route. Please check the locations and try again.':
      'Poti ni mogoče izračunati. Preverite lokacije in poskusite znova.',
    'Error calculating transport price': 'Napaka pri izračunu cene prevoza',
    'Booking canceled successfully': 'Rezervacija uspešno preklicana',
    'Invalid request.': 'Neveljavna zahteva.',
    'Access denied.': 'Dostop zavrnjen.',
    'Resource not found.': 'Vira ni bilo mogoče najti.',
    'Request conflict.': 'Konflikt zahtev.',
    'Invalid data provided.': 'Navedeni neveljavni podatki.',
    'Too many requests. Please try again later.':
      'Preveč zahtev. Poskusite znova pozneje.',
    'Internal server error. Please try again later.':
      'Notranja napaka strežnika. Poskusite znova pozneje.',
    'Service temporarily unavailable.': 'Storitev začasno ni na voljo.',
    'booking.load_preset': 'Naloži prednastavitev',
    'booking.save_preset_tooltip':
      'Shranite trenutne filtre kot prednastavitev za hiter dostop',
    'booking.load_preset_tooltip': 'Naložite shranjeno prednastavitev filtra',
    'booking.preset_saved': 'Prednastavitev shranjena',
    'booking.preset_saved_desc':
      'Vaša prednastavitev filtra je bila shranjena.',
    'booking.preset_loaded': 'Prednastavitev je naložena',
    'booking.preset_load_error': 'Prednastavitve ni bilo mogoče naložiti',
    'booking.no_preset_saved': 'Nobena prednastavitev še ni shranjena',
    'booking.date_from': 'Datum od',
    'booking.date_to': 'Datum do',
    'Active filters': 'Aktivni filtri',
    'All booking states': 'Vsa stanja rezervacije',
    'All partners': 'Vsi partnerji',
    'All payments': 'Vsa plačila',
    'All roles': 'Vse vloge',
    'All statuses': 'Vsi statusi',
    'All Users': 'Vsi uporabniki',
    'Are you sure you want to cancel booking {{id}}?':
      'Ali ste prepričani, da želite preklicati rezervacijo {{id}}?',
    'Attach the CMR Insurance before finishing truck setup.':
      'Pred dokončanjem nastavitve tovornjaka priložite račun CMR.',
    Awaiting: 'Čakanje',
    'Awaiting payout': 'Čakanje na izplačilo',
    'Booking canceled': 'Rezervacija preklicana',
    'Booking marked as paid': 'Rezervacija označena kot plačana',
    'Booking released and returned to marketplace':
      'Rezervacija je sproščena in vrnjena na trg',
    'booking.allowed_range': 'Dovoljeno območje',
    'booking.assign_transport': 'Dodeli prevoz',
    'booking.back': 'Nazaj',
    'booking.back_to_summary': 'Nazaj na povzetek',
    'booking.booking_created_but_pickup_document_not_uploaded_upload_from_order_details':
      'Rezervacija je bila ustvarjena, vendar dokument o prevzemu ni bil naložen. Naložite ga lahko iz Podrobnosti naročila.',
    'booking.city_not_found': 'Mesto ni bilo najdeno',
    'booking.city_or_town': 'Mesto ali kraj',
    'booking.clear_radius': 'Čisti polmer',
    'booking.continue': 'Nadaljuj',
    'booking.country_optional': 'Država (neobvezno)',
    'booking.delivery_constraint_info':
      'Datum dostave mora biti na ali po datumu prevzema.',
    'booking.delivery_date_cannot_be_earlier_than_pickup_date':
      'Datum dostave ne more biti pred datumom prevzema',
    'booking.driver': 'Voznik',
    'booking.failed_to_open_letter_of_attorney':
      'Pooblastila ni bilo mogoče odpreti',
    'booking.go_to_order': 'Pojdite na Naročilo',
    'booking.i_accept_terms': 'Sprejemam pogoje',
    'booking.invalid_license_plate_or_vin_length':
      'Neveljavna registrska tablica ali dolžina VIN.',
    'booking.invalid_vin_format_i_o_q_not_allowed':
      'Neveljavna oblika VIN. Znaki I, O in Q niso dovoljeni.',
    'booking.letter_of_attorney_file_is_empty':
      'Datoteka s pooblastilom je prazna',
    'booking.no_additional_details': 'Brez dodatnih podrobnosti',
    'booking.no_vehicle_info': 'Ni podatkov o vozilu',
    'booking.open_letter_of_attorney': 'Odprto pismo odvetnika',
    'booking.opening_letter_of_attorney': 'Uvodno pismo odvetnika ...',
    'booking.order_accepted_successfully': 'Naročilo je bilo uspešno sprejeto',
    'booking.order_cars_exceed_selected_truck_capacity':
      'To naročilo vključuje avtomobile {{orderCars}}, vendar je izbrana zmogljivost tovornjaka {{capacity}}.',
    'booking.pickup_constraint_info':
      'Pred dodelitvijo prevoza je potreben datum prevzema.',
    'booking.pickup_document_upload_failed':
      'Nalaganje dokumenta za prevzem ni uspelo',
    'booking.preparing_secure_document_preview':
      'Priprava varnega predogleda dokumenta ...',
    'booking.radius_km': 'Radij (km)',
    'booking.radius_search': 'Iskanje po radiusu',
    'booking.route_and_details': 'Pot in podrobnosti',
    'booking.schedule': 'Urnik',
    'booking.searching': 'Iskanje ...',
    'booking.select_pickup_and_delivery': 'Izberite prevzem in dostavo',
    'booking.select_pickup_and_delivery_dates_before_confirming':
      'Pred potrditvijo izberite datum prevzema in dostave',
    'booking.select_pickup_date': 'Izberite datum prevzema',
    'booking.select_truck_driver_and_trailer':
      'Izberite tovornjak, voznika in prikolico',
    'booking.supported_formats_jpg_png_pdf_doc_docx':
      'Podprti formati: JPG, PNG, PDF, DOC, DOCX',
    'booking.terms_and_conditions': 'Pogoji',
    'booking.terms_text': 'Potrjujem prevozne pogoje in pogoje odgovornosti.',
    'booking.track_shipment': 'Sledite pošiljki',
    'booking.trailer': 'Napovednik',
    'booking.transport_details': 'Podrobnosti o prevozu',
    'booking.truck': 'Tovornjak',
    'booking.truck_driver_planning_saved_letter_of_attorney_available':
      'Tovornjak, voznik in datumi načrtovanja so bili shranjeni. Pooblastilo je zdaj na voljo.',
    'booking.unexpected_error': 'Nepričakovana napaka',
    'booking.vehicles_plural': 'Vozila',
    'booking.view_details': 'Poglej podrobnosti',
    'booking.vip_price_must_be_between_min_max_50_to_150_percent_of_estimated_price':
      'VIP cena mora biti med {{min}} EUR in {{max}} EUR (50 % do 150 % ocenjene cene).',
    'booking.vip_price_must_be_positive_number':
      'VIP cena mora biti pozitivno število.',
    'booking.within_radius_km_of_place': 'Znotraj {{radius}} km od {{place}}',
    Capacity: 'Zmogljivost',
    'Car Capacity': 'Zmogljivost avtomobila',
    'Car capacity is required.': 'Zahtevana je zmogljivost avtomobila.',
    cars: 'avtomobili',
    Changed: 'Spremenjeno',
    'CMR Document': 'Dokument CMR',
    'CMR expiry': 'potek CMR',
    'CMR Expiry': 'Potek CMR',
    'CMR expiry date is required': 'Potreben je datum poteka CMR',
    'CMR Insurance': 'Zavarovanje CMR',
    'CMR insurance expiry date': 'Datum poteka zavarovanja CMR',
    'CMR Insurance Expiry Date': 'Datum poteka zavarovanja CMR',
    'CMR insurance has expired. Upload a new CMR Insurance for review.':
      'Naložite nov račun CMR za pregled.',
    'CMR insurance is expiring within 14 days.':
      'CMR zavarovanje poteče v 14 dneh.',
    'CMR Insurance required': 'Potreben je CMR račun',
    Company: 'Podjetje',
    'Copy order ID': 'Kopiraj ID naročila',
    Created: 'Ustvarjeno',
    'Current expiry': 'Trenutni potek',
    'Date range': 'Časovno obdobje',
    days: 'dni',
    Delay: 'Zamuda',
    'Delivered + partner invoice uploaded + unpaid':
      'Dostavljeno + račun partnerja naložen + neplačan',
    Document: 'Dokument',
    'Documents uploaded': 'Dokumenti naloženi',
    Done: 'Končano',
    'Download Client Invoice #{{id}}': 'Prenesite račun stranke #{{id}}',
    'Download Invoice': 'Prenesi račun',
    'Enter a valid capacity between 1 and 20 cars.':
      'Vnesite veljavno kapaciteto med 1 in 20 avtomobili.',
    'Enter license plate': 'Vnesite registrsko tablico',
    'Enter plate and upload CMR to add truck':
      'Vnesite tablico in naložite CMR, da dodate tovornjak',
    'Error fetching users': 'Napaka pri pridobivanju uporabnikov',
    'Expire Soon (14 days)': 'Kmalu poteče (14 dni)',
    'Explain why this CMR was rejected':
      'Pojasnite, zakaj je bil ta CMR zavrnjen',
    'Failed to copy order ID': 'Kopiranje ID-ja naročila ni uspelo',
    'Failed to download invoice': 'Prenos računa ni uspel',
    'Failed to download proforma invoice': 'Prenos predračuna ni uspel',
    'Failed to generate invoice': 'Računa ni bilo mogoče ustvariti',
    'Failed to load invoice summary': 'Nalaganje povzetka računa ni uspelo',
    'Failed to load letter of attorney': 'Pooblastila ni bilo mogoče naložiti',
    'Failed to open letter of attorney': 'Pooblastila ni bilo mogoče odpreti',
    'Failed to release booking': 'Rezervacije ni bilo mogoče sprostiti',
    'Fleet data refreshed': 'Podatki o voznem parku osveženi',
    'Generate Client Invoice': 'Ustvarite račun za stranko',
    'Generate Invoice': 'Ustvarite račun',
    'Generated at': 'Ustvarjeno ob',
    'How many cars can this truck carry?':
      'Koliko avtomobilov lahko prevaža ta tovornjak?',
    'In progress': 'V teku',
    Invoice: 'Račun',
    'Invoice generated': 'Račun ustvarjen',
    'Invoice generated successfully': 'Račun je bil uspešno ustvarjen',
    'Invoice uploaded': 'Račun naložen',
    'Invoices uploaded by partners for platform payout processing. Client invoices are generated in each order view.':
      'Računi strank se generirajo v pogledu vsakega naročila.',
    'Keep booking': 'Nadaljujte z rezervacijo',
    'Keep your active drivers and contact details up to date.':
      'Poskrbite, da bodo vaši aktivni vozniki in kontaktni podatki posodobljeni.',
    'Last Rejection': 'Zadnja zavrnitev',
    'Last rejection reason': 'Zadnji razlog za zavrnitev',
    'Letter of Attorney': 'Odvetniško pismo',
    'Letter of attorney file is empty': 'Datoteka s pooblastilom je prazna',
    'License plate cannot be changed after creation. Re-upload CMR Insurance instead.':
      'Namesto tega znova naložite račun CMR.',
    'License plate is required.': 'Zahtevana je registrska tablica.',
    'Manage large order volumes with search, payment actions, and invoice workflows.':
      'Upravljajte velike količine naročil z iskanjem, plačilnimi dejanji in poteki dela na računih.',
    'Manage license plates and keep CMR Insurances approved and valid.':
      'Upravljajte registrske tablice in poskrbite, da bodo računi CMR odobreni in veljavni.',
    'Manage status updates, documents, and payment steps from one place.':
      'Upravljajte posodobitve stanja, dokumente in plačilne korake z enega mesta.',
    'Manage trailer plate records and keep availability current.':
      'Upravljajte evidenco tablic priklopnika in vzdržujte tekočo razpoložljivost.',
    'Mark booking {{id}} as paid?': 'Označi rezervacijo {{id}} kot plačano?',
    Missing: 'manjka',
    'Needs attention': 'Potrebuje pozornost',
    'New (14 days)': 'Novo (14 dni)',
    'No bookings found for the current filters.':
      'Za trenutne filtre ni bilo najdenih rezervacij.',
    'No confirmed CMR document uploaded yet.':
      'Naložen še ni noben potrjen dokument CMR.',
    'No driver assigned': 'Voznik ni dodeljen',
    'No letter of attorney has been generated yet.':
      'Ustvarjeno še ni bilo nobeno pooblastilo.',
    'No matching delivered orders': 'Ni ustreznih dostavljenih naročil',
    'No new notifications': 'Ni novih obvestil',
    'No partners found.': 'Ni najdenih partnerjev.',
    'No trucks found for this filter.':
      'Za ta filter ni bilo najdenih tovornjakov.',
    'No users found for current filters.': 'Ni uporabnikov za trenutne filtre.',
    'Not uploaded': 'Ni naloženo',
    Notifications: 'Obvestila',
    of: 'od',
    'Only admins can set or update this expiry date after reviewing your CMR insurance.':
      'Samo skrbniki lahko nastavijo ali posodobijo ta datum poteka po pregledu vašega zavarovanja CMR.',
    'Open letter of attorney': 'Odprto pismo odvetnika',
    Order: 'naročilo',
    'Order actions': 'Naroči dejanja',
    'Order ID copied': 'ID naročila je kopiran',
    Owner: 'Lastnik',
    Page: 'Stran',
    'Paid date': 'Plačan datum',
    'Partner delivery date': 'Datum dostave partnerja',
    'Partner documents': 'Partnerski dokumenti',
    'Partner Invoice': 'Partnerski račun',
    'Partner invoice uploaded': 'Partnerski račun je naložen',
    'Partner Payout Invoices': 'Računi za izplačilo partnerjev',
    'Partner pickup date': 'Datum prevzema partnerja',
    'Partner score': 'Rezultat partnerja',
    Payment: 'Plačilo',
    'Payout date': 'Datum izplačila',
    'penalties applied': 'uporabljene kazni',
    'Pending admin review': 'Čaka na skrbniški pregled',
    'Pending review': 'Čaka na pregled',
    'Pending trucks': 'Čakajoča tovorna vozila',
    'Please provide a clear reason for rejection.':
      'Navedite jasen razlog za zavrnitev.',
    'Please select an order before uploading an invoice.':
      'Preden naložite račun, izberite naročilo.',
    'Please try again.': 'prosim poskusite znova',
    'Proforma Invoice': 'Predračun',
    'Provide a rejection reason for this CMR review.':
      'Navedite razlog za zavrnitev tega pregleda CMR.',
    'Quarter Score': 'Rezultat četrtine',
    'Re-upload CMR': 'Znova naložite CMR',
    Refresh: 'Osveži',
    'Rejection reason': 'Razlog za zavrnitev',
    'Rejection reason is required': 'Zahtevan je razlog za zavrnitev',
    'Release booking {{id}} back to the marketplace so another partner can accept it?':
      'Ali želite sprostiti rezervacijo {{id}} nazaj na trg, da jo lahko sprejme drug partner?',
    Reset: 'Ponastavi',
    'Review Bookings': 'Pregled rezervacij',
    Revision: 'Revizija',
    Rows: 'Vrstice',
    'Search by invoice number, file name, or booking ID':
      'Iščite po številki računa, imenu datoteke ali ID-ju rezervacije',
    'Search by name, email, company': 'Iskanje po imenu, e-pošti, podjetju',
    'Search by name, email, company, uid':
      'Iskanje po imenu, e-pošti, podjetju, uid',
    'Search client': 'Odjemalec iskanja',
    'Search delivered order': 'Iskanje dostavljenega naročila',
    'Search license plate or owner': 'Iskanje registrske tablice ali lastnika',
    'Search order ID': 'ID naloga za iskanje',
    'Search partner': 'Iskalni partner',
    'Select a new CMR Insurance to re-upload for this truck.':
      'Izberite nov račun CMR za ponovno nalaganje za ta tovornjak.',
    'Select paid date': 'Izberite datum plačila',
    'Set CMR insurance expiry date to approve this truck.':
      'Za odobritev tega tovornjaka nastavite datum poteka zavarovanja CMR.',
    'Set maximum number of cars this truck can carry (1-20).':
      'Nastavite največje število avtomobilov, ki jih lahko prevaža ta tovornjak (1-20).',
    'Set the CMR insurance expiry date before approval.':
      'Pred odobritvijo določite datum poteka zavarovanja CMR.',
    Showing: 'Prikazovanje',
    'Showing page {{page}} of {{pages}} • {{total}} invoices':
      'Prikaz strani {{page}} od {{pages}} • {{total}} računov',
    'Status will be updated to Picked Up after successful upload. You can add multiple car photos before uploading.':
      'Pred nalaganjem lahko dodate več fotografij avtomobilov.',
    Terms: 'Pogoji',
    Total: 'Skupaj',
    'Track paid and unpaid invoices, expected payout dates, and upload new invoices quickly.':
      'Sledite plačanim in neplačanim računom, pričakovanim datumom izplačil in hitro naložite nove račune.',
    'Truck approved successfully': 'Tovornjak je bil uspešno odobren',
    'Truck documents': 'Dokumenti za tovorno vozilo',
    'Truck license plate': 'Registrska tablica tovornjaka',
    'Truck rejected successfully': 'Tovornjak je bil uspešno zavrnjen',
    'truck(s) are pending admin CMR expiry date.':
      'tovornjaki čakajo na datum izteka admin CMR.',
    'truck(s) have expired CMR insurance and are disabled.':
      'tovornjakom(-om) je poteklo zavarovanje CMR in so onesposobljeni.',
    'truck(s) will expire within 14 days.': 'tovornjakov poteče v 14 dneh.',
    'Unable to prepare the record for upload.':
      'Zapisa ni mogoče pripraviti za nalaganje.',
    Unpaid: 'Neplačano',
    'Upload a CMR Insurance before closing this truck setup.':
      'Naložite račun CMR, preden zaprete to nastavitev tovornjaka.',
    'Upload a valid CMR insurance. Each upload sends the truck back to pending review.':
      'Vsako nalaganje pošlje tovornjak nazaj na pregled v čakanju.',
    'Upload documents': 'Nalaganje dokumentov',
    'Upload Invoice': 'Naložite račun',
    'Upload order documents': 'Naložite naročilne dokumente',
    'Upload unavailable': 'Nalaganje ni na voljo',
    Uploaded: 'Naloženo',
    'Uploaded • Paid': 'Naloženo • Plačano',
    'Uploaded • Partially paid': 'Naloženo • Delno plačano',
    'Uploaded by partner for platform payout processing.':
      'Naložil partner za obdelavo izplačil platforme.',
    User: 'Uporabnik',
    'Verification code': 'Koda za preverjanje',
    'View details': 'Poglej podrobnosti',
    'View Partners': 'Oglejte si partnerje',
    'Working hours not provided': 'Delovni čas ni naveden',
    '{{value}} orders': '{{value}} naročila',
    Invoiced: 'Fakturirano',
    'Loading admin data...': 'Nalaganje skrbniških podatkov ...',
    'Pending partners': 'Čakajoči partnerji',
    'Unpaid bookings': 'Neplačane rezervacije',
    'Total users': 'Skupno število uporabnikov',
    'Orders per period': 'Naročila na obdobje',
    'Orders by status': 'Naročila po statusu',
    'Quick actions': 'Hitra dejanja',
    'Verify new partners': 'Preverite nove partnerje',
    'Review partner applications and approve or reject requests.':
      'Preglejte partnerske prijave in odobrite ali zavrnite zahteve.',
    'Manage all trucks': 'Upravljajte vse tovornjake',
    'Review, approve, reject, disable, and filter all trucks.':
      'Preglejte, odobrite, zavrnite, onemogočite in filtrirajte vse tovornjake.',
    'Review bookings': 'Preglejte rezervacije',
    'Review all transport orders, payment states, and generated invoices.':
      'Preglejte vse transportne naloge, plačilna stanja in generirane račune.',
    'Manage all users': 'Upravljanje vseh uporabnikov',
    'Manage user status, roles, and validation records.':
      'Upravljajte status uporabnika, vloge in zapise o potrditvi.',
    'User breakdown': 'Razčlenitev uporabnikov',
    Clients: 'Stranke',
    Partners: 'Partnerji',
    Admins: 'Administratorji',
    'Top 5 pending partners': 'Top 5 partnerjev na čakanju',
    'No pending partners right now.': 'Trenutno ni čakajočih partnerjev.',
    pending: 'v teku',
    'Top 5 pending trucks': 'Top 5 čakajočih tovornjakov',
    'No pending trucks right now.': 'Trenutno ni čakajočih tovornjakov.',
    'Unknown owner': 'Neznan lastnik',
    'KPI cards and top lists link directly to filtered admin screens.':
      'Kartice KPI in seznami najboljših so neposredno povezani s filtriranimi skrbniškimi zasloni.',
    'booking.available_orders_title': 'Razpoložljiva naročila',
    'booking.available_orders_description':
      'Preglejte dohodne možnosti prevoza in uporabite filtre, ki ustrezajo vaši zmogljivosti.',
    'booking.vehicle_pickup_location': 'Lokacija prevzema vozila',
    'booking.pickup_opening_hours': 'Delovni čas prevzema',
    'booking.vehicle_delivery_location': 'Lokacija dostave vozila',
    'booking.delivery_opening_hours': 'Delovni čas dostave',
    'booking.pickup_contact': 'Kontakt za prevzem',
    'booking.delivery_contact': 'Kontakt za dostavo',
    'booking.vehicles_scheduled': 'Vozila po urniku',
    'booking.watchlist_title': 'Seznam za spremljanje',
    'booking.watchlist_description':
      'Sledite shranjenim priložnostim in hitro ukrepajte ob spremembah razpoložljivosti.',
    'Loading dashboard...': 'Nalaganje nadzorne plošče ...',
    'Total bookings': 'Skupno število rezervacij',
    'Open bookings': 'Odprte rezervacije',
    'Order status timeline': 'Časovnica statusa naročila',
    'Last 6 months of bookings grouped by current status.':
      'Zadnjih 6 mesecev rezervacij, razvrščenih po trenutnem statusu.',
    'Create new order': 'Ustvari novo naročilo',
    'Create a new transport booking request.':
      'Ustvarite novo zahtevo za rezervacijo prevoza.',
    'View my orders': 'Poglej moja naročila',
    'Review status and details of your bookings.':
      'Preglejte stanje in podrobnosti svojih rezervacij.',
    'Open profile': 'Odpri profil',
    'Update company and contact details.':
      'Posodobite podjetje in kontaktne podatke.',
    'Recent bookings': 'Nedavne rezervacije',
    'No bookings yet.': 'Rezervacij še ni.',
    'Unknown destination': 'Neznan cilj',
    'Quarter score': 'Rezultat četrtine',
    '{{value}} completed': '{{value}} dokončan',
    'Truck CMR warning': 'Opozorilo CMR za tovornjake',
    'One truck has CMR expiry risk. Review it in Fleet.':
      'En tovornjak ima nevarnost izteka CMR. Preglejte ga v Fleetu.',
    '{{count}} trucks have CMR expiry risk. Review them in Fleet.':
      'Tovornjaki {{count}} imajo nevarnost izteka CMR. Preglejte jih v Fleetu.',
    'Active queue': 'Aktivna čakalna vrsta',
    'Delivered bookings': 'Dostavljene rezervacije',
    'Cars delivered': 'Avtomobili dostavljeni',
    'Canceled bookings': 'Odpovedane rezervacije',
    'Avg assign-to-pickup': 'Povpr. dodelitev do prevzema',
    'Quarter Partner Score': 'Rezultat četrtletnega partnerja',
    'Payment delay: +{{days}} days': 'Zamuda pri plačilu: +{{days}} dni',
    'Penalty events': 'Kazenski dogodki',
    Current: 'Trenutno',
    'Completed orders per period': 'Izpolnjena naročila po obdobju',
    'Completed orders': 'Zaključena naročila',
    'Truck CMR status alerts': 'Opozorila o stanju CMR za tovornjake',
    '{{count}} truck(s) have expired CMR insurance.':
      'Tovornjakom(-om) {{count}} je poteklo zavarovanje CMR.',
    '{{count}} truck(s) will expire within 14 days.':
      'Tovornjaki {{count}} potečejo v 14 dneh.',
    '{{count}} truck(s) are missing CMR expiry date.':
      'Tovornjakom(-om) {{count}} manjka datum poteka CMR.',
    'Upload a new CMR Insurance in Fleet. The truck will stay pending until admin review.':
      'Naložite nov račun CMR v Fleet. Tovornjak bo ostal na čakanju do skrbniškega pregleda.',
    'Open fleet to resolve CMR alerts':
      'Odprite vozni park za razrešitev opozoril CMR',
    'Operational actions': 'Operativne akcije',
    'Open marketplace orders': 'Naročila na odprtem trgu',
    'Review available orders and plan assignments.':
      'Preglejte razpoložljiva naročila in načrtujte dodelitve.',
    'My accepted orders': 'Moja sprejeta naročila',
    'Manage delivery progress and documents.':
      'Upravljajte potek dostave in dokumente.',
    'Update trucks, trailers, and availability.':
      'Posodobite tovornjake, prikolice in razpoložljivost.',
    'Partner invoices': 'Partnerski računi',
    'Upload and track invoice payments.':
      'Naložite in sledite plačilom računov.',
    'No active orders in queue.': 'V čakalni vrsti ni aktivnih naročil.',
    'profile.incompleteTitle': 'Profil je nedokončan',
    'profile.incompleteDescription':
      'Za dostop do vseh funkcij izpolnite podatke o svojem profilu (podjetje, telefon, naslov, mesto, poštna številka).',
    'profile.goToProfile': 'Pojdite na Profil',
    'auth.email_placeholder': 'ime@podjetje.com',
    'auth.authentication_mode_switch':
      'Stikalo za način preverjanja pristnosti',
    'auth.invalid_email': 'Neveljaven e-poštni naslov',
    'auth.please_enter_a_valid_email_address':
      'Vnesite veljaven e-poštni naslov.',
    'auth.email_not_found': 'E-pošte ni bilo mogoče najti',
    'auth.no_account_found_with_that_email_address':
      'S tem e-poštnim naslovom ni bilo mogoče najti nobenega računa.',
    'auth.email_sent': 'E-pošta poslana!',
    'auth.something_went_wrong_try_again':
      'Nekaj ​​je šlo narobe. poskusi ponovno',
    'auth.we_sent_a_password_reset_link_open_your_inbox_and_follow_the_instructions':
      'Poslali smo povezavo za ponastavitev gesla. Odprite mapo »Prejeto« in sledite navodilom.',
    'auth.forgot_your_password': 'Ste pozabili geslo?',
    'auth.enter_your_account_email_and_we_will_send_you_a_password_reset_link':
      'Vnesite e-poštni naslov računa in poslali vam bomo povezavo za ponastavitev gesla.',
    'auth.email_address': 'E-poštni naslov',
    'auth.send_reset_link': 'Pošlji povezavo za ponastavitev',
    'auth.cancel': 'Prekliči',
    'auth.tip_if_you_do_not_receive_the_email_check_spam_and_promotions_folders':
      'Nasvet: če ne prejmete e-pošte, preverite mape z vsiljeno pošto in promocijami.',
    'booking.e_g_berlin': 'npr. Berlin',
    'booking.e_g_germany': 'npr. Nemčija',
    'booking.watchlist': 'Seznam za spremljanje',
    'booking.view_map': 'Ogled zemljevida',
    'booking.invalid_input': 'Neveljaven vnos',
    'booking.please_enter_only_numbers_for_the_zip_code':
      'Za poštno številko vnesite samo številke.',
    'booking.pickup_zip_code': 'Poštna številka za prevzem',
    'booking.delivery_zip_code': 'Poštna številka dostave',
    'booking.select_vehicle_make': 'Izberite znamko vozila',
    'booking.unnamed_item': 'Neimenovan predmet',
    'booking.cars': 'avtomobili',
    'booking.more_info': 'Več informacij',
    'booking.loading': 'Nalaganje...',
    'booking.no_items_found': 'Ni elementov',
    'booking.selected_cars': 'Izbrani avtomobili',
    'booking.unknown_type': 'Neznana vrsta',
    'booking.delete_car': 'Izbriši avto',
    'Toggle details': 'Preklop podrobnosti',
    'auth.a_verification_email_has_been_sent_to_your_email_address_please_verify_your_emai':
      'Potrditveno e-poštno sporočilo je bilo poslano na vaš e-poštni naslov. Preden se prijavite, potrdite svoj e-poštni naslov.',
    'auth.an_unexpected_error_occurred_please_try_again':
      'Prišlo je do nepričakovane napake. prosim poskusite znova',
    'auth.failed_to_resend_email': 'Ponovno pošiljanje e-pošte ni uspelo',
    'auth.show_password': 'Prikaži geslo',
    'auth.hide_password': 'Skrij geslo',
    'auth.incorrect_password_please_try_again':
      'Napačno geslo. prosim poskusite znova',
    'auth.invalid_email_or_password_please_check_your_credentials_and_try_again':
      'Neveljaven e-poštni naslov ali geslo. Preverite svoje poverilnice in poskusite znova.',
    'auth.network_error_check_your_connection_and_try_again':
      'Omrežna napaka. Preverite povezavo in poskusite znova.',
    'auth.no_account_found_with_this_email':
      'S tem e-poštnim naslovom ni bilo mogoče najti nobenega računa.',
    'auth.partner': 'Partner',
    'auth.please_check_your_inbox': 'Prosimo, preverite svoj nabiralnik.',
    'auth.please_make_sure_both_passwords_are_the_same':
      'Prepričajte se, da sta obe gesli enaki.',
    'auth.please_sign_in_to_resend_the_verification_email':
      'Za ponovno pošiljanje potrditvenega e-poštnega sporočila se prijavite.',
    'auth.resend_verification_email': 'Ponovno pošlji potrditveno e-pošto',
    'auth.awaiting_verification_artwork': 'Čakanje na umetniško delo',
    'auth.email_verification_required': 'Zahtevano je preverjanje e-pošte',
    'auth.waiting_for_email_verification': 'Čakanje na potrditev e-pošte',
    'auth.check_your_email': 'Preverite svojo e-pošto',
    'auth.we_sent_your_verification_link_to':
      'Vašo povezavo za preverjanje smo poslali na',
    'auth.didnt_receive_it_check_spam_or_try_again':
      'Niste ga prejeli? Preverite mapo z vsiljeno pošto ali poskusite znova.',
    'auth.resend_email': 'Ponovno pošlji e-pošto',
    'auth.i_verified_my_email': 'Preveril sem svoj e-poštni naslov',
    'auth.redirecting_you_now': 'Preusmerjam vas zdaj.',
    'auth.email_not_verified_yet': 'E-pošta še ni preverjena',
    'auth.please_click_the_link_in_your_inbox_and_try_again':
      'Kliknite povezavo v mapi »Prejeto« in poskusite znova.',
    'auth.unable_to_resend_verification_email_right_now':
      'Trenutno ni mogoče znova poslati potrditvenega e-poštnega sporočila.',
    'auth.unable_to_check_verification_status_right_now':
      'Stanja preverjanja trenutno ni mogoče preveriti.',
    'auth.we_sent_a_new_verification_link':
      'Na vaš e-poštni naslov smo poslali novo povezavo za preverjanje.',
    'auth.we_automatically_check_every_30_seconds':
      'Vsakih 30 sekund samodejno preverimo vaš status preverjanja. Po potrditvi e-pošte lahko sprožite tudi takojšnje preverjanje.',
    'auth.we_automatically_check_every_15_seconds':
      'Vsakih 15 sekund samodejno preverimo vaš status preverjanja. Po potrditvi e-pošte lahko sprožite tudi takojšnje preverjanje.',
    'auth.the_email_address_is_not_valid': 'E-poštni naslov ni veljaven.',
    'auth.this_account_has_been_disabled': 'Ta račun je bil onemogočen.',
    'auth.too_many_failed_attempts_please_try_again_later_or_reset_your_password':
      'Preveč neuspelih poskusov. Poskusite znova pozneje ali ponastavite geslo.',
    'auth.verification_email_resent':
      'Ponovno poslano potrditveno e-poštno sporočilo!',
    'auth.you_need_to_log_in_first': 'Najprej se morate prijaviti',
    'booking.error_fetching_data': 'Napaka pri pridobivanju podatkov',
    'booking.inputs_changed_recalculate_the_price':
      'Spremenjeni vnosi. Preračunajte ceno.',
    'booking.kg': 'kg',
    'booking.km': 'km',
    'booking.mi': 'mi',
    'booking.no_opening_hours_provided': 'Odpiralni čas ni naveden',
    'booking.no_vehicles_listed': 'Ni navedenih vozil',
    'booking.not_available': 'Ni na voljo',
    'booking.not_set': 'Ni nastavljeno',
    'booking.please_select_a_planned_date': 'Izberite načrtovani datum',
    'booking.required': 'Obvezno',
    'booking.to': 'do',
    'booking.order': 'naročilo',
    'booking.duration': 'Trajanje',
    'booking.vehicles_overview': 'Pregled vozil',
    'booking.body': 'Telo',
    'booking.dims': 'Zatemnitve',
    'booking.select_vehicle_model': 'Izberite model vozila',
    'booking.selected_type_value': 'Izbrano: {{value}}',
    'booking.select_a_vehicle_type': 'Izberite tip vozila:',
    'booking.select_vehicle_weight': 'Izberite težo vozila',
    'booking.selected_weight_kg': 'Izbrano: {{value}} kg',
    'booking.adjust_weight': 'Prilagodite težo',
    'Dates updated successfully': 'Datumi so bili uspešno posodobljeni',
    'Error updating dates': 'Napaka pri posodabljanju datumov',
    'Set Planned Dates': 'Nastavite načrtovane datume',
    'Set your planned pickup and arrival dates below.':
      'Spodaj nastavite načrtovane datume prevzema in prihoda.',
    'Changing dates after initial setup will deduct 20% from your performance score for this order.':
      'Spreminjanje datumov po začetni nastavitvi bo odštelo 20 % vaše ocene uspešnosti za to naročilo.',
    'Planned Pickup Date': 'Načrtovani datum prevzema',
    'Planned Arrival Date': 'Načrtovani datum prihoda',
    Listing: 'Seznam',
    'Try broadening the current search or status filter.':
      'Poskusite razširiti trenutno iskanje ali filter stanja.',
    'Try broadening the search, role, or status filters.':
      'Poskusite razširiti filtre za iskanje, vlogo ali status.',
    'Monitor fleet compliance, validation status, and expiring insurance in one place.':
      'Spremljajte skladnost voznega parka, stanje potrjevanja in poteče zavarovanje na enem mestu.',
    'Active Listings': 'Aktivni oglasi',
    'Open transport requests': 'Odprte zahteve za prevoz',
    'Quotes Today': 'Citati danes',
    'Submitted in last 24h': 'Oddano v zadnjih 24 urah',
    'Platform Revenue (MTD)': 'Prihodek platforme (MTD)',
    'Month to date': 'Mesec do datuma',
    'Pending Partners': 'Partnerji v teku',
    'Awaiting approval': 'Čakanje na odobritev',
    'Unpaid Invoices': 'Neplačani računi',
    'Requires action': 'Zahteva ukrepanje',
    'Completed Transports': 'Opravljeni prevozi',
    'All time delivered': 'Ves čas dostavljeno',
    'Admin Dashboard': 'Skrbniška nadzorna plošča',
    'Platform overview and key performance indicators.':
      'Pregled platforme in ključni kazalniki uspešnosti.',
    'Loading dashboard metrics...': 'Nalaganje meritev nadzorne plošče ...',
    Invoices: 'Računi',
    'Review payout invoices uploaded by partners and keep payout processing organized.':
      'Preglejte račune za izplačilo, ki so jih naložili partnerji, in organizirajte obdelavo izplačil.',
    Flexible: 'Prilagodljiv',
    'Flexible dates': 'Prilagodljivi datumi',
    'Could not load this listing.': 'Tega seznama ni bilo mogoče naložiti.',
    'Listing canceled': 'Oglas preklican',
    'Failed to cancel listing': 'Navedbe ni bilo mogoče preklicati',
    Reference: 'Referenca',
    Category: 'Kategorija',
    'Client type': 'Tip stranke',
    'Company country': 'Država podjetja',
    Expires: 'poteče',
    'Back to listings': 'Nazaj na sezname',
    'Listing not found.': 'Oglasa ni bilo mogoče najti.',
    'Cancel Listing': 'Prekliči vnos',
    'Listing details': 'Podrobnosti seznama',
    'Reference {{id}}': 'Referenca {{id}}',
    'Read-only listing overview for admins.':
      'Pregled seznama samo za branje za skrbnike.',
    'Pick-up': 'Prevzem',
    'No exact coordinates are stored for this listing yet.':
      'Za ta seznam še ni shranjenih natančnih koordinat.',
    'Structured overview of quantities and handling details.':
      'Strukturiran pregled količin in podrobnosti manipulacije.',
    'Shipment images': 'Slike pošiljk',
    'No shipment images were uploaded for this listing.':
      'Za ta seznam ni bila naložena nobena slika pošiljke.',
    'Proof of pickup': 'Dokazilo o prevzemu',
    'Final documents': 'Končni dokumenti',
    Description: 'Opis',
    'Quotes ({{count}})': 'Citati ({{count}})',
    'Loading quotes...': 'Nalaganje ponudb ...',
    'No quotes for this listing.': 'Za ta seznam ni ponudb.',
    'Score: {{score}}/100': 'Rezultat: {{score}}/100',
    'Pickup: {{date}}': 'Prevzem: {{date}}',
    'Delivery: {{date}}': 'Dostava: {{date}}',
    'Cancel Listing?': 'Preklic vnosa?',
    'This will permanently cancel the listing and notify the client. Continue?':
      'To bo trajno preklicalo vnos in obvestilo stranko. Nadaljevati?',
    Keep: 'obdrži',
    'Review partner applications, check their documents, and keep approval decisions consistent.':
      'Preglejte prijave partnerjev, preverite njihove dokumente in poskrbite, da bodo odločitve o odobritvi dosledne.',
    'No client payments recorded yet': 'Plačila strank še niso zabeležena',
    'Client payment rows will appear here when the payments backend is connected.':
      'Vrstice s plačili odjemalca se bodo prikazale tukaj, ko bo zaledje plačil povezano.',
    Method: 'Metoda',
    'No partner payouts recorded yet':
      'Izplačila partnerjev še niso zabeležena',
    'Payout rows will appear here once partner payout processing is enabled.':
      'Vrstice za izplačila se bodo pojavile tukaj, ko bo obdelava izplačil partnerja omogočena.',
    'Payout Amount': 'Znesek izplačila',
    'No platform fees recorded yet':
      'Provizije za platformo še niso zabeležene',
    'Fee rows will appear here once payment settlement data is available.':
      'Vrstice s stroški se bodo pojavile tukaj, ko bodo na voljo podatki o poravnavi plačila.',
    Gross: 'Gross',
    'Fee (20%)': 'Provizija (20%)',
    Payments: 'Plačila',
    'Client payments, partner payouts, and platform fee tracking.':
      'Plačila strank, izplačila partnerjev in sledenje provizij platforme.',
    'Client Payments': 'Plačila strank',
    'Partner Payouts': 'Partnerska izplačila',
    'Platform Fees': 'Pristojbine za platformo',
    'Failed to load reviews': 'Ocen ni bilo mogoče naložiti',
    'Review removed': 'Ocena odstranjena',
    'Failed to remove review': 'Ocene ni bilo mogoče odstraniti',
    Reviews: 'Ocene',
    'All partner and transport reviews submitted by clients.':
      'Vse ocene partnerjev in prevozov, ki so jih predložile stranke.',
    'Loading reviews...': 'Nalaganje mnenj ...',
    'No reviews found': 'Ni recenzij',
    'Client feedback will appear here when reviews are submitted.':
      'Povratne informacije strank bodo prikazane tukaj, ko bodo ocene oddane.',
    Stars: 'Zvezdice',
    Comment: 'Komentiraj',
    'Search, review, and maintain user accounts with one consistent admin workflow.':
      'Iščite, pregledujte in vzdržujte uporabniške račune z enim doslednim skrbniškim potekom dela.',
    'Track paid and unpaid partner payout invoices, and upload the next delivered listing invoice quickly.':
      'Sledite plačanim in neplačanim računom za izplačilo partnerjev in hitro naložite naslednji dostavljeni račun za seznam.',
    'Search by invoice number, file name, or listing ID':
      'Iščite po številki računa, imenu datoteke ali ID-ju seznama',
    'Loading delivered listings...': 'Nalaganje dostavljenih seznamov ...',
    'Search delivered listing by reference, title, or route':
      'Iskanje dostavljenega seznama po sklicu, naslovu ali poti',
    'Route details available in listing':
      'Podrobnosti o poti so na voljo na seznamu',
    'No matching delivered listings': 'Ni ustreznih dostavljenih seznamov',
    'Selected listing': 'Izbrani seznam',
    'Has quotes': 'Ima citate',
    'In transit': 'V tranzitu',
    Open: 'Odpri',
    Accepted: 'Sprejeto',
    Completed: 'Dokončano',
    'Client Dashboard': 'Nadzorna plošča odjemalca',
    'Overview of your current transport listings, quote activity, and recent requests.':
      'Pregled vaših trenutnih seznamov prevozov, dejavnosti ponudb in nedavnih zahtev.',
    'Total listings': 'Skupaj oglasi',
    'Active listings': 'Aktivni oglasi',
    'Listings with quotes': 'Oglasi s ponudbami',
    'Accepted transport': 'Sprejet prevoz',
    'Listing status timeline': 'Časovnica statusa seznama',
    'Last 6 months of listings grouped by current status.':
      'Zadnjih 6 mesecev seznamov, razvrščenih po trenutnem stanju.',
    'No listing activity yet': 'Ni še dejavnosti na seznamu',
    'Create your first listing to start tracking request activity here.':
      'Ustvarite svoj prvi seznam, da začnete slediti dejavnosti zahtev tukaj.',
    'Create new listing': 'Ustvari nov seznam',
    'Create a new transport request for the marketplace.':
      'Ustvarite novo zahtevo za prevoz za trg.',
    'View my listings': 'Oglejte si moje oglase',
    'Review quote activity and manage your transport requests.':
      'Preglejte dejavnost ponudbe in upravljajte svoje zahteve za prevoz.',
    'Recent listings': 'Nedavni oglasi',
    'No listings yet': 'Ni še nobenih oglasov',
    'Your newest transport requests will appear here once you create them.':
      'Vaše najnovejše zahteve za prevoz bodo prikazane tukaj, ko jih ustvarite.',
    'Unknown origin': 'Neznanega izvora',
    '{{count}} quote(s)': '{{count}} citat(i)',
    '{{value}} completed listings': '{{value}} dokončanih oglasov',
    'Monitor current performance, fleet readiness, quote flow, and your active transport queue.':
      'Spremljajte trenutno zmogljivost, pripravljenost voznega parka, tok ponudb in svojo aktivno transportno čakalno vrsto.',
    'Total assigned': 'Skupaj dodeljeno',
    'Quarter rating': 'Četrtletna ocena',
    'Based on current quarter performance':
      'Na podlagi trenutne četrtletne uspešnosti',
    Rating: 'Ocena',
    'Requirement met': 'Zahteva izpolnjena',
    'Requirement not met': 'Zahteva ni izpolnjena',
    'Completed listings per period': 'Dokončani oglasi na obdobje',
    'No completion data yet': 'Podatkov o zaključku še ni',
    'Statistics will appear here after your first delivered work.':
      'Statistika se bo pojavila tukaj po vašem prvem oddanem delu.',
    'Completed listings': 'Dokončani seznami',
    'Review truck documents and refresh anything close to expiry.':
      'Preglejte dokumente tovornjaka in osvežite vse, kar se bliža izteku.',
    'Search deliveries': 'Iskanje dostav',
    'Review available marketplace listings and submit quotes.':
      'Preglejte razpoložljive sezname tržnic in oddajte ponudbe.',
    'My quotes': 'Moji citati',
    'Track accepted, pending, and rejected quotes in one place.':
      'Sledite sprejetim, čakajočim in zavrnjenim ponudbam na enem mestu.',
    'Profile settings': 'Nastavitve profila',
    'Keep company information and compliance details up to date.':
      'Podatke o podjetju in podrobnosti o skladnosti posodabljajte.',
    'No active queue items': 'Ni aktivnih elementov čakalne vrste',
    'Accepted and in-progress work will appear here as your transport activity grows.':
      'Sprejeto in delo v teku se bo pojavilo tukaj, ko bo vaša transportna dejavnost rasla.',
    'Your role does not have permission to open this page.':
      'Vaša vloga nima dovoljenja za odpiranje te strani.',
    'Go to dashboard': 'Pojdi na nadzorno ploščo',
    'Trailer capacity is required.': 'Zahtevana je zmogljivost prikolice.',
    'How many cars can this trailer carry?':
      'Koliko avtomobilov lahko prevaža ta prikolica?',
    'Set maximum number of cars this trailer can carry (1-20).':
      'Nastavite največje število avtomobilov, ki jih lahko prevaža ta prikolica (1-20).',
    'Invalid max load (kg).': 'Neveljavna največja obremenitev (kg).',
    'Enter a valid weight between 1 and 100000 kg, or leave it empty.':
      'Vnesite veljavno težo med 1 in 100000 kg ali pustite prazno.',
    'Maximum payload weight this truck can carry (optional).':
      'Največja teža tovora, ki jo lahko prenese ta tovornjak (izbirno).',
    'Manage the company and contact details that appear across your listings, invoices, and account verification flows.':
      'Upravljajte podatke o podjetju in kontaktne podatke, ki so prikazani v vaših seznamih, računih in potekih preverjanja računa.',
    'Keep these details up to date so listings, invoices, and partner verification stay accurate.':
      'Te podatke posodabljajte, da bodo seznami, računi in preverjanje partnerjev točni.',
    'Unsaved changes': 'Neshranjene spremembe',
    'All changes saved': 'Vse spremembe so shranjene',
    'auth.sign_up_failed': 'Prijava ni uspela',
    'auth.please_select_a_valid_role': 'Izberite veljavno vlogo.',
    'booking.pickup_not_found': 'Prevzema ni bilo mogoče najti.',
    'booking.delivery_not_found': 'Dostava ni bila najdena.',
    'booking.capacity': 'Zmogljivost',
    'booking.cmr_expiry': 'Potek CMR',
    'booking.uploaded': 'Naloženo',
    'booking.missing': 'manjka',
    'booking.cmr_document': 'Dokument CMR',
    'booking.go_to_profile': 'Pojdite na Profil',
    'booking.click_to_download_purchase_terms':
      'Kliknite za prenos pogojev nakupa',
    'admin.purchase_terms_management': 'Upravljanje nakupnih pogojev',
    'admin.purchase_terms_management_subtitle':
      'Naložite in vzdržujte lokalizirane PDF-je s pogoji nakupa, ki se uporabljajo pri sprejemanju partnerskih naročil.',
    'admin.document_language': 'Jezik dokumenta',
    'admin.click_to_download_purchase_terms':
      'Kliknite za prenos pogojev nakupa',
    'admin.current_language_label': 'Trenutni jezik: {{language}}',
    'admin.purchase_terms_unavailable_for_selected_language':
      'Dokument s pogoji nakupa ni na voljo za izbrani jezik.',
    'Download and review the active purchase terms in your current interface language before continuing.':
      'Pred nadaljevanjem prenesite in preglejte aktivne pogoje nakupa v vašem trenutnem jeziku vmesnika.',
    'We make agreements and conclude a contract for the carriage of goods. I have just read this agreement in full and agree to its contents.':
      'Dogovarjamo se in sklenemo pogodbo o prevozu blaga. Pravkar sem v celoti prebral to pogodbo in se strinjam z njeno vsebino.',
    'I confirm that I will schedule this order within 24 hours':
      'Potrjujem, da bom to naročilo načrtoval v 24 urah',
    'Failed to load purchase terms document.':
      'Dokumenta s pogoji nakupa ni bilo mogoče naložiti.',
    'Partner rating': 'Ocena partnerja',
    'Bronze requirements': 'Bronaste zahteve',
    'Orders in quarter': 'Naročila v četrtletju',
    'Cancellation rate / 100 orders': 'Stopnja odpovedi / 100 naročil',
    'Damage claims / 100 orders': 'Odškodninski zahtevki / 100 naročil',
    '{{current}} / min {{target}}': '{{current}} / min {{target}}',
    '{{current}} / max {{target}}': '{{current}} / največ {{target}}',
    Met: 'Met',
    'Not met': 'Niso izpolnjeni',
    Unranked: 'Neuvrščen',
    'profile.incompleteDescriptionPartner':
      'Za dostop do vseh funkcij izpolnite podatke o svojem profilu (podjetje, telefon, naslov, mesto, poštna številka, številka za DDV).',
    'profile.incompleteDescriptionClient':
      'Za dostop do vseh funkcij izpolnite podatke o svojem profilu (telefonsko številko).',
    'auth.verification_email_sent': 'Potrditveno e-poštno sporočilo je poslano',
    '{{amount}} above the client target': '{{amount}} nad ciljno stranko',
    '{{amount}} below the client target': '{{amount}} pod ciljem stranke',
    '{{count}} image(s) added to the listing.':
      '{{count}} slik, dodanih na seznam.',
    '{{count}} quote(s) received': 'Prejetih {{count}} ponudb',
    '{{count}} reviews': '{{count}} ocene',
    '{{count}} total': '{{count}} skupaj',
    '{{count}} visible': '{{count}} vidno',
    '{{weight}} kg': '{{weight}} kg',
    'A Google route preview with pins A and B appears here once pickup and delivery coordinates are available.':
      'Predogled Googlove poti z žebljičkoma A in B se prikaže tukaj, ko so na voljo koordinate prevzema in dostave.',
    'A route preview appears once map coordinates are available.':
      'Predogled poti se prikaže, ko so na voljo koordinate zemljevida.',
    'A timeline of clarifications connected to this listing.':
      'Časovnica pojasnil, povezanih s tem seznamom.',
    "Accept {{partner}}'s quote for {{amount}}?":
      'Sprejeti ponudbo {{partner}} za {{amount}}?',
    'Accept Listing': 'Sprejmi vnos',
    'Accept quote': 'Sprejmi ponudbo',
    'Accepted quote': 'Sprejeta ponudba',
    'Accepted quote required': 'Zahtevana je sprejeta ponudba',
    'Accepting...': 'Sprejemanje ...',
    Active: 'Aktiven',
    'Active statuses': 'Aktivna stanja',
    'Add another item': 'Dodajte še en predmet',
    'Add images': 'Dodajte slike',
    'Add more shipment images': 'Dodajte več slik pošiljke',
    'After you confirm an AI action, open the prepared destination immediately instead of waiting for a manual click.':
      'Ko potrdite dejanje AI, takoj odprite pripravljen cilj, namesto da čakate na ročni klik.',
    'AI Assistant': 'Pomočnik AI',
    'AI assistant disabled for all users.':
      'Pomočnik AI je onemogočen za vse uporabnike.',
    'AI assistant enabled for all users.':
      'AI pomočnik omogočen za vse uporabnike.',
    'AI assistant preferences updated':
      'Nastavitve pomočnika AI so posodobljene',
    'AI disabled for user.': 'AI onemogočen za uporabnika.',
    'AI enabled for user.': 'AI omogočen za uporabnika.',
    'AI-powered message translation between languages':
      'Prevajanje sporočil med jeziki s pomočjo umetne inteligence',
    'All route-critical information in one place before you review quotes or documents.':
      'Vse pomembne informacije o poti na enem mestu, preden pregledate ponudbe ali dokumente.',
    View: 'Pregledaj',
    Answer: 'Odgovori',
    Archive: 'Arhiv',
    'Archived statuses': 'Arhivirana stanja',
    'Are you sure you want to reject the quote from':
      'Ali ste prepričani, da želite zavrniti citat od',
    'Ask a question about this listing...':
      'Zastavite vprašanje o tem seznamu ...',
    'Ask for matching lanes, quote help, or the next operational step.':
      'Prosite za ustrezne pasove, navedite pomoč ali naslednji operativni korak.',
    'Ask for quote comparisons or a prepared next step from this shipment screen.':
      'Na tem zaslonu za pošiljanje zahtevajte primerjave ponudb ali pripravljen naslednji korak.',
    'Assistant history cleared': 'Zgodovina Pomočnika je izbrisana',
    'Automatically translate messages from other users into your preferred language using AI.':
      'Z AI samodejno prevedite sporočila drugih uporabnikov v vaš želeni jezik.',
    'Back to listing': 'Nazaj na seznam',
    'Best offer': 'Najboljša ponudba',
    'Best quote': 'Najboljša ponudba',
    'Body type: {{type}}': 'Tip telesa: {{type}}',
    'Breed: {{breed}}': 'Pasma: {{breed}}',
    Budget: 'Proračun',
    'Cancel listing': 'Prekliči vnos',
    'Canceled and completed work will appear here once listings move out of the active view.':
      'Preklicano in dokončano delo se bo tukaj prikazalo, ko se oglasi premaknejo iz aktivnega pogleda.',
    'Cargo Details': 'Podrobnosti o tovoru',
    Categories: 'kategorije',
    'Choose the interface language. This preference is saved locally and applies immediately.':
      'Izberite jezik vmesnika. Ta nastavitev se shrani lokalno in velja takoj.',
    'Clear all': 'Počisti vse',
    'Clear assistant history': 'Počisti zgodovino pomočnika',
    'Client price in EUR': 'Cena za naročnika v EUR',
    'Client target price': 'Ciljna cena za stranko',
    'Complete the payment below to lock the fixed-price acceptance and let the partner start planning.':
      'Izvedite spodnje plačilo, da zaklenete sprejem s fiksno ceno in omogočite partnerju, da začne načrtovati.',
    'Complete the payment below to lock the selected quote and let the partner start planning.':
      'Izvedite spodnje plačilo, da zaklenete izbrano ponudbo in pustite partnerju, da začne načrtovati.',
    'Compose area prepared for listing Q&A. Submission remains disabled until the live question endpoint is connected on this page.':
      'Območje za sestavljanje, pripravljeno za navajanje vprašanj in odgovorov. Oddaja ostane onemogočena, dokler končna točka vprašanja v živo ni povezana na tej strani.',
    'Confirm delivery complete': 'Potrdite dokončano dostavo',
    'Confirm payment received': 'Potrdite prejeto plačilo',
    'Confirm that you have received the bank transfer or payment for this listing. This will move the listing to Paid status and allow the partner to mark it as planned.':
      'Potrdite, da ste prejeli bančno nakazilo ali plačilo za ta seznam. S tem bo seznam premaknjen v status Plačano in partnerju bo omogočeno, da ga označi kot načrtovanega.',
    'Confirm the exact fleet and dates before the listing moves to Planned.':
      'Potrdite natančno floto in datume, preden se seznam premakne v Načrtovano.',
    'Confirm Transport Plan': 'Potrdite prometni načrt',
    'Confirming...': 'Potrjujem ...',
    'Control how the web assistant behaves on this device. These settings do not change your account data.':
      'Nadzorujte, kako se spletni pomočnik obnaša v tej napravi. Te nastavitve ne spremenijo podatkov vašega računa.',
    'Create listing': 'Ustvari seznam',
    'Create with AI': 'Ustvarjajte z AI',
    'Create your next transport request and it will appear here with route, item, and quote activity.':
      'Ustvarite svojo naslednjo zahtevo za prevoz in prikazana bo tukaj z dejavnostjo poti, predmeta in ponudbe.',
    'Current stage:': 'Trenutna faza:',
    'Current status': 'Trenutno stanje',
    'Delivery confirmation needed': 'Potrebna je potrditev dostave',
    'Delivery radius': 'Radij dostave',
    'Delivery:': 'Dostava:',
    'Describe the route and cargo, then review the prepared listing draft before publishing.':
      'Opišite pot in tovor, nato pa pred objavo preglejte pripravljen osnutek seznama.',
    'Describe the shipment you need and review the prepared request before publishing.':
      'Opišite pošiljko, ki jo potrebujete, in pred objavo preglejte pripravljeno zahtevo.',
    'Download and review the purchase terms before confirming the transport plan.':
      'Prenesite in preglejte pogoje nakupa, preden potrdite transportni načrt.',
    'Download invoice': 'Prenesite račun',
    'Download Purchase Terms': 'Prenesite pogoje nakupa',
    'Draft with AI': 'Osnutek z AI',
    'Draft your review first, then submit it here when you are satisfied.':
      'Najprej pripravite svojo oceno, nato pa jo oddajte sem, ko boste zadovoljni.',
    'Edit listing': 'Uredi seznam',
    'Edit Quote': 'Uredi ponudbo',
    Enable: 'Omogoči',
    'Enable live translation': 'Omogoči prevod v živo',
    'Enabled Users': 'Omogočeni uporabniki',
    'Engagement Activity': 'Zaročena dejavnost',
    'Expires:': 'poteče:',
    'Failed to accept listing': 'Vnosa ni bilo mogoče sprejeti',
    'Failed to accept quote': 'Sprejem ponudbe ni uspel',
    'Failed to clear assistant history':
      'Zgodovine pomočnika ni bilo mogoče izbrisati',
    'Failed to complete listing': 'Navedbe ni bilo mogoče dokončati',
    'Failed to confirm payment': 'Potrditev plačila ni uspela',
    'Failed to confirm transport plan':
      'Prevoznega načrta ni bilo mogoče potrditi',
    'Failed to disable AI for user.':
      'Umetne inteligence za uporabnika ni bilo mogoče onemogočiti.',
    'Failed to enable AI for user.':
      'Umetne inteligence za uporabnika ni bilo mogoče omogočiti.',
    'Failed to load listing.': 'Nalaganje seznama ni uspelo.',
    'Failed to load listings': 'Oglasov ni bilo mogoče naložiti',
    'Failed to load listings. Please try again.':
      'Oglasov ni bilo mogoče naložiti. prosim poskusite ponovno',
    'Failed to load review context.':
      'Ni bilo mogoče naložiti konteksta pregleda.',
    'Failed to load settings.': 'Nastavitev ni bilo mogoče naložiti.',
    'Failed to refresh Stripe payment status':
      'Stanja plačila Stripe ni bilo mogoče osvežiti',
    'Failed to reject quote': 'Zavrnitev ponudbe ni uspela',
    'Failed to release listing': 'Objava seznama ni uspela',
    'Failed to save quote': 'Ponudbe ni bilo mogoče shraniti',
    'Failed to update listing': 'Vnosa ni bilo mogoče posodobiti',
    'Failed to update preferred language':
      'Posodobitev želenega jezika ni uspela',
    'Failed to update setting.': 'Nastavitve ni bilo mogoče posodobiti.',
    'Failed to update status': 'Stanja ni bilo mogoče posodobiti',
    'Failed to update translation preference':
      'Nastavitev prevoda ni bilo mogoče posodobiti',
    'Failed to update watchlist':
      'Seznama za spremljanje ni bilo mogoče posodobiti',
    'Failed to withdraw quote': 'Umik ponudbe ni uspel',
    'Feature Flags': 'Zastavice funkcij',
    'Filter invoice uploads, search by reference, and page through payout records.':
      'Filtrirajte nalaganje računov, iščite po sklicu in listajte po zapisih izplačil.',
    Filters: 'Filtri',
    'Final delivery documents': 'Dokumenti končne dostave',
    'Fixed price only': 'Samo fiksna cena',
    'Flexible / not set': 'Prilagodljivo / ni nastavljeno',
    'Generated automatically when the transport plan is confirmed.':
      'Ustvari se samodejno, ko je transportni načrt potrjen.',
    'Generation: {{generation}}': 'Generacija: {{generation}}',
    'Goods delivered — awaiting client confirmation.':
      'Blago dostavljeno — čaka na potrditev stranke.',
    'Gross price': 'Bruto cena',
    'I have read and agree to the purchase terms for this transport job.':
      'Prebral sem in se strinjam s pogoji nakupa za to prevozno službo.',
    'I understand that accepting this listing assigns it to me at the fixed client price shown above.':
      'Razumem, da mi je s sprejetjem tega seznama dodeljen po fiksni ceni za stranko, prikazani zgoraj.',
    'Image upload failed': 'Nalaganje slike ni uspelo',
    'Images uploaded': 'Slike naložene',
    'Interface language': 'Jezik vmesnika',
    'Invoice documents': 'Dokumenti za račune',
    'Item {{number}}': 'Postavka {{number}}',
    items: 'predmete',
    'Keep listing': 'Nadaljujte s seznamom',
    'Keep quote': 'Obdrži citat',
    'Keep the current AI session available after closing the browser on this device.':
      'Naj bo trenutna seja AI na voljo po zaprtju brskalnika v tej napravi.',
    'Language & Region': 'Jezik in regija',
    'Lift: {{origin}} / {{destination}}':
      'Dvigalo: {{origin}} / {{destination}}',
    Listed: 'Na seznamu',
    'Listing {{id}}': 'Oglas {{id}}',
    'Listing accepted': 'Oglas sprejet',
    'Listing expired': 'Oglas je potekel',
    'Listing images': 'Seznam slik',
    'Listing is live': 'Oglas je v živo',
    'Listing reference': 'Referenca seznama',
    'Listing snapshot': 'Posnetek seznama',
    'Listing unavailable': 'Oglas ni na voljo',
    'Listing updated': 'Vnos posodobljen',
    'Live Translation': 'Prevajanje v živo',
    'Live translation disabled.': 'Prevajanje v živo onemogočeno.',
    'Live translation enabled.': 'Omogočeno prevajanje v živo.',
    'Loading approved trucks...': 'Nalaganje odobrenih tovornjakov ...',
    'Loading fleet...': 'Nalaganje voznega parka ...',
    'Loading listing details...': 'Nalaganje podrobnosti seznama ...',
    'Loading listings...': 'Nalaganje seznamov ...',
    'Loading review details...': 'Nalaganje podrobnosti ocene ...',
    'Loading settings...': 'Nalaganje nastavitev ...',
    'Manage AI Assistant Users': 'Upravljanje uporabnikov AI Assistant',
    'Manage platform-wide feature flags and configuration.':
      'Upravljajte zastavice funkcij in konfiguracijo celotne platforme.',
    'Manage Users': 'Upravljanje uporabnikov',
    'Manage your transport requests, monitor quote activity, and keep active and archived work easy to scan.':
      'Upravljajte svoje zahteve za prevoz, spremljajte ponudbeno dejavnost ter poskrbite, da bo aktivno in arhivirano delo enostavno skenirati.',
    'Mark Picked Up': 'Mark Pobral',
    'Matches the client target price': 'Ustreza ciljni ceni stranke',
    Media: 'Mediji',
    Messages: 'Sporočila',
    'Messages will be translated into this language.':
      'Sporočila bodo prevedena v ta jezik.',
    'Minimum net:': 'Najmanjši neto:',
    'My invoices': 'Moji računi',
    Net: 'Net',
    'Net price': 'Neto cena',
    'Net quote': 'Neto ponudba',
    'New images appear immediately in the listing details for client, partner, and admin views.':
      'Nove slike se takoj prikažejo v podrobnostih seznama za poglede strank, partnerjev in skrbnikov.',
    'Next step': 'Naslednji korak',
    'No active listings yet': 'Ni še aktivnih oglasov',
    'No address provided': 'Naslov ni naveden',
    'No answer yet.': 'Še ni odgovora.',
    'No archived listings yet': 'Ni še arhiviranih oglasov',
    'No description added.': 'Opis ni dodan.',
    'no destination': 'brez cilja',
    'No expiry': 'Brez poteka',
    'No listings match the current filters. Try broadening the search or date range.':
      'Noben seznam se ne ujema s trenutnimi filtri. Poskusite razširiti iskanje ali časovno obdobje.',
    'no origin': 'brez izvora',
    'No questions yet': 'Vprašanj še ni',
    'No quotes yet': 'Narekovajev še ni',
    'No shipment images uploaded yet.': 'Naložena še ni nobena slika pošiljke.',
    'No trailer selected': 'Ni izbranega napovednika',
    'No unread messages': 'Ni neprebranih sporočil',
    'No users found.': 'Ni najdenih uporabnikov.',
    'No users have AI enabled.':
      'Noben uporabnik nima omogočene umetne inteligence.',
    'Not selected': 'Ni izbrano',
    'Offers summary': 'Povzetek ponudb',
    'Open AI assistant': 'Odprite pomočnika AI',
    'Open prepared screens automatically':
      'Samodejno odpiranje pripravljenih zaslonov',
    'Optional visible price shown to partners as your target budget.':
      'Izbirna vidna cena, prikazana partnerjem kot vaš ciljni proračun.',
    'Other quotes will be declined automatically once this offer is accepted.':
      'Druge ponudbe bodo samodejno zavrnjene, ko bo ta ponudba sprejeta.',
    'Partner delivery': 'Partnerska dostava',
    'Partner pickup': 'Prevzem partnerja',
    'Partner quote': 'Partnerski citat',
    'Payment confirmed': 'Plačilo potrjeno',
    'Payment confirmed — listing status set to paid':
      'Plačilo potrjeno — status vnosa je nastavljen na plačano',
    'Payment confirmed. Confirm the assigned fleet and planned dates before the listing moves to Planned.':
      'Plačilo potrjeno. Potrdite dodeljeno floto in načrtovane datume, preden se seznam premakne v Načrtovano.',
    'Payment is confirmed. The partner now needs to confirm the truck, driver, and planned dates.':
      'Plačilo je potrjeno. Partner mora zdaj potrditi tovornjak, voznika in načrtovane datume.',
    'Payment required': 'Obvezno plačilo',
    'Photos uploaded for the shipment and visible across client, partner, and admin views.':
      'Fotografije, naložene za pošiljko in vidne v pogledih strank, partnerjev in skrbnikov.',
    'Pickup is complete and the transport is currently underway.':
      'Prevzem je končan in transport trenutno poteka.',
    'Pickup proof': 'Dokazilo o prevzemu',
    'Pickup proof and final delivery files uploaded by the transport partner.':
      'Datoteke z dokazili o prevzemu in končne dostave, ki jih naloži transportni partner.',
    'Pickup to delivery overview': 'Pregled od prevzema do dostave',
    'Pickup:': 'Prevzem:',
    'Plan and authorization': 'Načrt in avtorizacija',
    'Plan transport': 'Načrtujte prevoz',
    'Plan Transport': 'Načrtujte prevoz',
    'Planned dates:': 'Načrtovani datumi:',
    'Planned delivery date': 'Načrtovani datum dostave',
    'Platform Settings': 'Nastavitve platforme',
    'Preferred language': 'Prednostni jezik',
    'Preferred language updated': 'Prednostni jezik je posodobljen',
    'Prepare a quote or ask for the next lane action, then confirm before anything is submitted.':
      'Pripravite ponudbo ali vprašajte za naslednjo akcijo na voznem pasu, nato potrdite, preden kar koli oddate.',
    'Purchase Terms': 'Pogoji nakupa',
    'Quantities, dimensions, and handling details ready for transport review.':
      'Količine, dimenzije in podrobnosti o rokovanju pripravljene za pregled transporta.',
    Question: 'vprašanje',
    Questions: 'Vprašanja',
    'Questions & answers': 'Vprašanja in odgovori',
    'Questions and answers for this listing will appear here once the messaging flow is active.':
      'Vprašanja in odgovori za ta seznam se bodo pojavili tukaj, ko bo tok sporočanja aktiven.',
    'Quick access to the current shipment, quote, and billing state.':
      'Hiter dostop do trenutne pošiljke, ponudbe in stanja obračuna.',
    'Quote accepted': 'Ponudba sprejeta',
    'Quote count': 'Število citatov',
    'Quote message': 'Citiraj sporočilo',
    'Quote rejected': 'Ponudba zavrnjena',
    'Quote withdrawn': 'Citat umaknjen',
    Quotes: 'Citati',
    'Quotes and questions': 'Citati in vprašanja',
    'Quotes are disabled for this listing. The first partner to accept the fixed price will be assigned automatically.':
      'Narekovaji so za ta seznam onemogočeni. Prvi partner, ki bo sprejel fiksno ceno, bo samodejno dodeljen.',
    'Quotes are disabled for this shipment. If you accept it, the client price becomes an accepted booking immediately.':
      'Za to pošiljko so ponudbe onemogočene. Če jo sprejmete, cena stranke takoj postane sprejeta rezervacija.',
    'Quotes from transport providers usually begin to appear shortly after publishing. Refresh to check again.':
      'Citati ponudnikov prevozov se običajno začnejo pojavljati kmalu po objavi. Osvežite, da znova preverite.',
    'Reference #{{id}}': 'Referenca #{{id}}',
    'Refresh listings': 'Osveži sezname',
    'Reject quote': 'Zavrni ponudbo',
    'Rejecting...': 'Zavračanje ...',
    Release: 'Sprostitev',
    'Release Listing': 'Seznam izdaj',
    'Remember assistant conversation': 'Zapomni si pogovor pomočnika',
    'Required for fixed-price listings. Partners accept this amount directly.':
      'Zahtevano za objave s fiksno ceno. Partnerji sprejmejo ta znesek neposredno.',
    'Required. Partners will be able to accept this listing at the fixed client price without sending a quote.':
      'Obvezno. Partnerji bodo lahko sprejeli ta seznam po fiksni ceni za stranko brez pošiljanja ponudbe.',
    'Review submission failed.': 'Oddaja pregleda ni uspela.',
    'Review the completed transport using the standard product flow.':
      'Preglejte opravljen prevoz z uporabo standardnega toka izdelkov.',
    'Route pending': 'Pot v teku',
    'Save changes': 'Shranite spremembe',
    'Saving...': 'Shranjevanje ...',
    'Search by title, route, category, or item':
      'Iščite po naslovu, poti, kategoriji ali predmetu',
    'Search Results': 'Rezultati iskanja',
    'Search users by email...': 'Iskanje uporabnikov po elektronski pošti ...',
    'Select a truck, driver, pickup date, and delivery date.':
      'Izberite tovornjak, voznika, datum prevzema in datum dostave.',
    'Select approved truck': 'Izberite odobren tovornjak',
    'Select driver': 'Izberite gonilnik',
    'Send Revision': 'Pošlji revizijo',
    Sentiment: 'Sentiment',
    'Share what went well and what could improve':
      'Delite, kaj je šlo dobro in kaj bi lahko izboljšali',
    'Shipment in transit': 'Pošiljka v tranzitu',
    'Shipment notes': 'Opombe o pošiljki',
    'Shipment tracking will be shared': 'Sledenje pošiljke bo deljeno',
    'Show AI launchers': 'Pokaži zaganjalnike AI',
    'Show or hide AI assistant buttons on supported dashboard and listing pages.':
      'Pokaži ali skrij gumbe pomočnika AI na podprtih nadzornih ploščah in straneh s seznami.',
    'Special needs or notes': 'Posebne potrebe ali opombe',
    'Specify delivery dates': 'Določite datume dostave',
    'Specify pickup dates': 'Določite datume prevzema',
    Stage: 'Oder',
    'Status updated to {{status}}': 'Status posodobljen na {{status}}',
    'Stripe payment confirmed and booking updated':
      'Plačilo Stripe potrjeno in rezervacija posodobljena',
    'Stripe status: {{status}}': 'Stanje črte: {{status}}',
    'Submit question': 'Pošlji vprašanje',
    'Submit review': 'Oddaj oceno',
    'Submitting...': 'Pošiljanje ...',
    'The AI assistant is currently disabled for this environment. Existing local session data can still be cleared here.':
      'Pomočnik AI je trenutno onemogočen za to okolje. Obstoječe podatke o lokalni seji lahko še vedno izbrišete tukaj.',
    'The listing expired before a transport was confirmed.':
      'Seznam je potekel, preden je bil prevoz potrjen.',
    'The listing has been fully completed and archived as a finished transport.':
      'Seznam je v celoti dokončan in arhiviran kot končan transport.',
    'The lowest net price you would still accept for this shipment.':
      'Najnižja neto cena, ki bi jo še sprejeli za to pošiljko.',
    'The partner has confirmed the route plan. Pickup and delivery dates are now scheduled.':
      'Partner je potrdil načrt poti. Datumi prevzema in dostave so zdaj načrtovani.',
    'The partner marked the shipment as delivered. Review the final documents and confirm completion.':
      'Partner je pošiljko označil kot dostavljeno. Preglejte končne dokumente in potrdite zaključek.',
    'The partner-confirmed plan and LOA stay grouped together for faster review.':
      'Načrt, ki ga je potrdil partner, in LOA ostaneta združena za hitrejši pregled.',
    'This action notifies the transport provider and removes the quote from active consideration.':
      'To dejanje obvesti ponudnika prevoza in odstrani ponudbo iz aktivne obravnave.',
    'This listing is archived and no further transport actions are available.':
      'Ta seznam je arhiviran in nadaljnja transportna dejanja niso na voljo.',
    'This listing needs an accepted quote before a review can be created.':
      'Za ta seznam je potrebna sprejeta ponudba, preden se lahko ustvari ocena.',
    'This will soft-cancel the listing and move it to your archive.':
      'To bo mehko preklicalo vnos in ga premaknilo v vaš arhiv.',
    'This will soft-cancel the listing for the client and remove it from active marketplace views.':
      'To bo mehko preklicalo seznam za stranko in ga odstranilo iz aktivnih pogledov tržnice.',
    'Total quote': 'Skupna ponudba',
    'Tracking not promised': 'Sledenje ni obljubljeno',
    'Tracking shared': 'Sledenje v skupni rabi',
    'Tracking visibility': 'Sledenje vidljivosti',
    'Trailer (Optional)': 'Napovednik (neobvezno)',
    'Translation preference updated': 'Nastavitve prevoda posodobljene',
    'Transport completed': 'Prevoz opravljen',
    'Transport completed.': 'Prevoz opravljen.',
    'Transport documents': 'Prevozne listine',
    'Transport marked as complete': 'Transport označen kot opravljen',
    'Transport package': 'Transportni paket',
    'Transport plan confirmed': 'Transportni načrt potrjen',
    'Transport plan updated': 'Prometni načrt posodobljen',
    'Transport planned': 'Prevoz načrtovan',
    'Transport Provider': 'Ponudnik prevoza',
    'Transport providers can review your shipment and send offers.':
      'Prevozniki lahko pregledajo vašo pošiljko in pošljejo ponudbe.',
    'Transport stage': 'Transportna stopnja',
    Truck: 'Tovornjak',
    'Truck, driver, trailer, and planned dates for this shipment.':
      'Tovornjak, voznik, priklopnik in načrtovani datumi za to pošiljko.',
    'Try widening the current listing filters.':
      'Poskusite razširiti trenutne filtre seznama.',
    'Unable to upload listing images.': 'Ni mogoče naložiti slik seznama.',
    'Unknown error': 'Neznana napaka',
    'Untitled listing': 'Seznam brez naslova',
    'Untitled Listing': 'Oglas brez naslova',
    'Update media': 'Posodobite medije',
    'Update transport plan': 'Posodobite prometni načrt',
    'Update Transport Plan': 'Posodobi prometni načrt',
    'Upload a CMR or delivery photos before marking delivered.':
      'Naložite CMR ali fotografije dostave, preden označite dostavljeno.',
    'Upload a CMR or delivery photos before the listing can move to Delivered.':
      'Naložite CMR ali fotografije dostave, preden se seznam lahko premakne v Delivered.',
    'Upload at least one pickup proof before the listing can move to Picked Up.':
      'Naložite vsaj eno dokazilo o prevzemu, preden se lahko vnos premakne na Prevzeto.',
    'Upload final documents': 'Naloži končne dokumente',
    'Upload proof of pickup': 'Naložite dokazilo o prevzemu',
    'Uploading...': 'Nalaganje ...',
    'Use fresh photos when the shipment changes or you want to clarify the item condition.':
      'Uporabite sveže fotografije, ko se pošiljka spremeni ali želite razjasniti stanje artikla.',
    'users enabled': 'uporabnikom omogočeno',
    'Visible to you while quoting. You can still send your own net offer below or above this amount.':
      'Vidno vam med citiranjem. Še vedno lahko pošljete svojo neto ponudbo pod ali nad tem zneskom.',
    'Waiting for partner acceptance': 'Čakanje na sprejem partnerja',
    'Waiting for transport planning': 'Čakanje na načrtovanje prevoza',
    'When enabled, messages from other users will be automatically translated to your preferred language.':
      'Ko je omogočeno, bodo sporočila drugih uporabnikov samodejno prevedena v vaš želeni jezik.',
    Withdraw: 'Umakni se',
    'Write Review': 'Napiši oceno',
    'You are about to release this listing back to the marketplace.':
      'Ta seznam boste objavili nazaj na trg.',
    'You are now the assigned partner for this fixed-price listing.':
      'Zdaj ste dodeljeni partner za to ponudbo s fiksno ceno.',
    'Your quote has been accepted. Awaiting payment confirmation from the admin before you can begin the job.':
      'Vaša ponudba je bila sprejeta. Čakanje na potrditev plačila s strani skrbnika, preden lahko začnete z delom.',
    'VIN: {{vin}}': 'VIN: {{vin}}',
    'Material: {{type}}': 'Material: {{type}}',
  },
  es: {
    to: 'a',
    'X total': '{{count}} total',
    kg: 'kilos',
    Hatchback: 'Hatchback',
    Coupé: 'cupé',
    Crossover: 'cruce',
    total: 'total',
    Required: 'Requerido',
    'Change language': 'Cambiar idioma',
    'Loading...': 'Cargando…',
    Error: 'error',
    'Error:': 'Error:',
    Close: 'Cerrar',
    Yes: 'si',
    No: 'No',
    'Keep order': 'mantener el orden',
    Price: 'Precio',
    'Purchase terms': 'Condiciones de compra',
    'Power of attorney': 'poder notarial',
    'Transport details': 'Detalles de transporte',
    'Upload damages': 'Subir daños',
    'Download (PDF)': 'Descargar (PDF)',
    'Mark as picked up': 'Marcar como recogido',
    'Mark as delivered': 'Marcar como entregado',
    'Cancel booking': 'Cancelar reserva',
    'Order marked as picked up': 'Pedido marcado como recogido',
    'Order marked as delivered': 'Pedido marcado como entregado',
    'Order canceled': 'Orden cancelada',
    'Failed to cancel order': 'No se pudo cancelar el pedido',
    'Added {{count}} file(s)': 'Archivo(s) {{count}} agregados',
    Pages: 'paginas',
    'Awaiting Verification': 'En espera de verificación',
    'Profile Incomplete': 'Perfil incompleto',
    'Please complete your profile information (Company, Phone, Address, City, Post Code) to access all features.':
      'Complete la información de su perfil (empresa, teléfono, dirección, ciudad, código postal) para acceder a todas las funciones.',
    'Go to Profile': 'Ir al perfil',
    'Forgot Password': 'Olvidé mi contraseña',
    Hello: 'hola',
    friend: 'amigo',
    'Book your transport': 'Reserva tu transporte',
    'fast and easy': 'rápido y fácil',
    'Keep an eye on the route and quote at a glance.':
      'Esté atento a la ruta y cotice de un vistazo.',
    Origin: 'Origen',
    Destination: 'Destino',
    'Postal code': 'código postal',
    'Calculate to preview': 'Calcular para obtener una vista previa',
    "Can't be calculated yet": 'Aún no se puede calcular',
    'Awaiting payment badge': 'En espera de pago',
    'Ref {{id}}': 'Ref.{{id}}',
    'Change planning': 'Planificación del cambio',
    'Change driver': 'Cambiar conductor',
    'No vehicles listed': 'No hay vehículos listados',
    'Order not found.': 'Orden no encontrada.',
    'Not available': 'No disponible',
    'For {{date}}': 'Para {{date}}',
    'Picked on {{date}}': 'Recogido en {{date}}',
    'Delivered on {{date}}': 'Entregado el {{date}}',
    'Loading notification: {{value}}': 'Notificación de carga: {{value}}',
    'CO₂ compensation: {{value}}': 'Compensación de CO₂: {{value}}',
    'Bio fuel: {{value}}': 'Biocombustible: {{value}}',
    Remove: 'Quitar',
    'Copy {{label}}': 'Copiar {{label}}',
    'Open navigation menu': 'Abrir menú de navegación',
    'Open menu': 'abrir menú',
    'Error fetching data': 'Error al obtener datos',
    'Not set': 'No establecido',
    'No opening hours provided': 'No se proporcionan horarios de apertura',
    'Please select a planned date':
      'Por favor seleccione una fecha planificada',
    'Saved favorite route filter': 'Filtro de ruta favorita guardada',
    km: 'kilómetros',
    mi: 'mi',
    'Radius search': 'Búsqueda de radio',
    'City or town': 'ciudad o pueblo',
    'Country (optional)': 'País (opcional)',
    Radius: 'Radio',
    'Searching…': 'Buscando…',
    'City not found': 'Ciudad no encontrada',
    'Within {{radius}} {{unit}} of {{place}}':
      'Dentro de {{radius}} {{unit}} de {{place}}',
    'Clear radius': 'Borrar radio',
    'auth.account_status_pending_review':
      'Estado de la cuenta: Pendiente de revisión',
    'auth.your_account_is_pending_approval':
      'Tu cuenta está pendiente de aprobación',
    'auth.upload_your_verification_documents_below_and_we_ll_notify_you_by_email_once_your_account_is_approved':
      'Cargue sus documentos de verificación a continuación y le notificaremos por correo electrónico una vez que se apruebe su cuenta.',
    'auth.check_status': 'comprobar estado',
    'auth.upload_verification_documents': 'Cargar documentos de verificación',
    'auth.your_uploaded_documents': 'Tus documentos cargados',
    'auth.back_to_sign_in': 'Volver para iniciar sesión',
    admin: 'administrador',
    Albania: 'Albania',
    Andorra: 'Andorra',
    Armenia: 'armenia',
    Austria: 'austria',
    Bulgaria: 'bulgaria',
    Estonia: 'Estonia',
    Georgia: 'georgia',
    Kosovo: 'Kosovo',
    Liechtenstein: 'Liechtenstein',
    Malta: 'malta',
    Montenegro: 'Montenegro',
    Portugal: 'portugal',
    'San Marino': 'San Marino',
    Serbia: 'Serbia',
    'BodyType.Hatchback': 'Hatchback',
    'BodyType.Coupe': 'cupé',
    'BodyType.Crossover': 'cruce',
    'BodyType.Pickup': 'Recogida',
    ' total': 'total',
    'Error loading documents': 'Error al cargar documentos',
    'Are you sure you want to delete this document?':
      '¿Está seguro de que desea eliminar este documento?',
    'Document deleted': 'Documento eliminado',
    'Failed to delete': 'No se pudo eliminar',
    'Failed to get download link': 'No se pudo obtener el enlace de descarga',
    'Status updated': 'Estado actualizado',
    'Update failed': 'La actualización falló',
    'Email cannot be changed.': 'El correo electrónico no se puede cambiar.',
    'No documents found.': 'No se encontraron documentos.',
    'Invoice #': 'Factura #',
    'File Name': 'Nombre de archivo',
    Amount: 'Cantidad',
    Actions: 'Acciones',
    Download: 'Descargar',
    'Mark Unpaid': 'Marcar como no pagado',
    'Mark Paid': 'Marcar pagado',
    'Please save the record before uploading documents.':
      'Guarde el registro antes de cargar documentos.',
    'Select a file before uploading.':
      'Seleccione un archivo antes de cargarlo.',
    'Please enter an invoice number.':
      'Por favor ingrese un número de factura.',
    'Upload successful': 'Subida exitosa',
    '{{count}} file(s) uploaded successfully.':
      'Los archivos {{count}} se cargaron correctamente.',
    'Upload failed': 'Error al subir',
    'Unable to upload the document.': 'No se puede cargar el documento.',
    'Invoice Number': 'Número de factura',
    'Selected files:': 'Archivos seleccionados:',
    Upload: 'Subir',
    'Save this record before uploading documents.':
      'Guarde este registro antes de cargar documentos.',
    'Error approving user': 'Error al aprobar usuario',
    'Error rejecting user': 'Error al rechazar usuario',
    'Error disabling user': 'Error al inhabilitar usuario',
    'User marked as VIP': 'Usuario marcado como VIP',
    'User unmarked as VIP': 'Usuario desmarcado como VIP',
    'Error marking user as VIP': 'Error al marcar al usuario como VIP',
    'Error unmarking user as VIP': 'Error al desmarcar al usuario como VIP',
    'Failed to approve user': 'No se pudo aprobar el usuario',
    'Failed to reject user': 'No se pudo rechazar al usuario',
    'Failed to disable user': 'No se pudo deshabilitar al usuario',
    'Failed to unmark user as VIP': 'No se pudo desmarcar al usuario como VIP',
    'Failed to mark user as VIP': 'No se pudo marcar al usuario como VIP',
    'Invoice Management': 'Gestión de facturas',
    'All Invoices': 'Todas las facturas',
    'Manage all invoices uploaded by partners.':
      'Gestione todas las facturas cargadas por los socios.',
    'An unexpected error occurred. Please try again.':
      'Se produjo un error inesperado. Por favor inténtalo de nuevo.',
    'The email address is not valid.':
      'La dirección de correo electrónico no es válida.',
    'This account has been disabled.': 'Esta cuenta ha sido deshabilitada.',
    'No account found with this email.':
      'No se encontró ninguna cuenta con este correo electrónico.',
    'Incorrect password. Please try again.':
      'Contraseña incorrecta. Por favor inténtalo de nuevo.',
    'Invalid email or password. Please check your credentials and try again.':
      'Correo electrónico o contraseña no válidos. Por favor verifique sus credenciales e inténtelo nuevamente.',
    'Too many failed attempts. Please try again later or reset your password.':
      'Demasiados intentos fallidos. Inténtelo de nuevo más tarde o restablezca su contraseña.',
    'Network error. Check your connection and try again.':
      'Error de red. Comprueba tu conexión y vuelve a intentarlo.',
    'A verification email has been sent to your email address. Please verify your email before logging in.':
      'Se ha enviado un correo electrónico de verificación a su dirección de correo electrónico. Por favor verifique su correo electrónico antes de iniciar sesión.',
    'Please make sure both passwords are the same.':
      'Asegúrese de que ambas contraseñas sean iguales.',
    'Verification email resent!':
      '¡Correo electrónico de verificación reenviado!',
    'Please check your inbox.': 'Por favor revisa tu bandeja de entrada.',
    'You need to log in first': 'Primero debes iniciar sesión',
    'Please sign in to resend the verification email.':
      'Inicie sesión para reenviar el correo electrónico de verificación.',
    'Failed to resend email': 'No se pudo reenviar el correo electrónico',
    'Resend verification email': 'Reenviar correo electrónico de verificación',
    'Show password': 'Mostrar contraseña',
    'Hide password': 'Ocultar contraseña',
    'Awaiting verification artwork': 'En espera de verificación',
    'Account status: Pending review':
      'Estado de la cuenta: Pendiente de revisión',
    'Your account is pending approval':
      'Tu cuenta está pendiente de aprobación',
    "Upload your verification documents below and we'll notify you by email once your account is approved.":
      'Cargue sus documentos de verificación a continuación y le notificaremos por correo electrónico una vez que se apruebe su cuenta.',
    'Check status': 'comprobar estado',
    'Upload verification documents': 'Cargar documentos de verificación',
    'Your uploaded documents': 'Tus documentos cargados',
    'Back to sign in': 'Volver para iniciar sesión',
    'Hide documents': 'Ocultar documentos',
    'Email verification required':
      'Se requiere verificación por correo electrónico',
    'Waiting for email verification':
      'Esperando verificación por correo electrónico',
    'Check your email': 'Revisa tu correo electrónico',
    'We sent your verification link to': 'Enviamos su enlace de verificación a',
    "Didn't receive it? Check your spam folder or try again.":
      '¿No lo recibiste? Revisa tu carpeta de spam o inténtalo de nuevo.',
    'Resend email': 'Reenviar correo electrónico',
    "I've verified my email": 'He verificado mi correo electrónico',
    'Redirecting you now.': 'Redireccionándote ahora.',
    'Email not verified yet': 'Correo electrónico aún no verificado',
    'Please click the link in your inbox and try again.':
      'Haga clic en el enlace de su bandeja de entrada e inténtelo de nuevo.',
    'Unable to resend verification email right now.':
      'No se puede reenviar el correo electrónico de verificación en este momento.',
    'Unable to check verification status right now.':
      'No se puede verificar el estado de verificación en este momento.',
    "We've sent a new verification link to your email address.":
      'Hemos enviado un nuevo enlace de verificación a su dirección de correo electrónico.',
    'We automatically check your verification status every 30 seconds. You can also trigger an instant check after verifying your email.':
      'Verificamos automáticamente su estado de verificación cada 30 segundos. También puede activar una verificación instantánea después de verificar su correo electrónico.',
    'We automatically check your verification status every 15 seconds. You can also trigger an instant check after verifying your email.':
      'Verificamos automáticamente su estado de verificación cada 15 segundos. También puede activar una verificación instantánea después de verificar su correo electrónico.',
    'Inputs changed. Recalculate the price.':
      'Las entradas cambiaron. Vuelva a calcular el precio.',
    'My Invoices': 'Mis facturas',
    'Upload New Invoice': 'Cargar nueva factura',
    'Please enter the invoice number and upload the invoice document. It will be reviewed by an administrator.':
      'Ingrese el número de factura y cargue el documento de factura. Será revisado por un administrador.',
    'Invoice History': 'Historial de facturas',
    'Client ref · {{clientRef}}': 'Referencia del cliente · {{clientRef}}',
    'Order Documents': 'Documentos de pedido',
    'Upload Proof of Pickup': 'Cargar comprobante de recogida',
    'Status will be updated to Picked Up after successful upload.':
      'El estado se actualizará a Recogido después de una carga exitosa.',
    'Upload Proof of Delivery': 'Cargar comprobante de entrega',
    'Status will be updated to Delivered after successful upload.':
      'El estado se actualizará a Entregado después de una carga exitosa.',
    'Enter first name': 'Introduce el nombre',
    'Enter last name': 'Introduce el apellido',
    'Enter phone number': 'Introduce el número de teléfono',
    'Driver updated.': 'Controlador actualizado.',
    'The driver has been successfully updated.':
      'El controlador se ha actualizado correctamente.',
    'Driver added.': 'Conductor añadido.',
    'The new driver has been successfully added.':
      'El nuevo controlador se ha agregado exitosamente.',
    'Driver deleted.': 'Controlador eliminado.',
    'The driver has been successfully deleted.':
      'El controlador se ha eliminado correctamente.',
    'Trailer updated.': 'Tráiler actualizado.',
    'The trailer has been successfully updated.':
      'El tráiler se ha actualizado correctamente.',
    'Trailer added.': 'Se agregó el tráiler.',
    'The new trailer has been successfully added.':
      'El nuevo tráiler se ha agregado con éxito.',
    'Trailer deleted.': 'Tráiler eliminado.',
    'The trailer has been successfully deleted.':
      'El tráiler se ha eliminado correctamente.',
    'User account not found. Please complete registration.':
      'Cuenta de usuario no encontrada. Por favor complete el registro.',
    'No token provided': 'No se proporciona ningún token',
    'Token expired': 'Token caducado',
    'Token revoked': 'Token revocado',
    'Invalid ID token': 'Token de identificación no válido',
    Unauthorized: 'No autorizado',
    'Unauthorized: User not authenticated.':
      'No autorizado: Usuario no autenticado.',
    'Unauthorized: User role not found.':
      'No autorizado: rol de usuario no encontrado.',
    'Forbidden: Your role is not allowed to perform this action.':
      'Prohibido: Tu rol no puede realizar esta acción.',
    'Forbidden: This action requires a partner role.':
      'Prohibido: esta acción requiere un rol de socio.',
    'Forbidden: This action requires a client role.':
      'Prohibido: esta acción requiere un rol de cliente.',
    'Forbidden: This action requires an admin role.':
      'Prohibido: esta acción requiere una función de administrador.',
    'This user has not been approved': 'Este usuario no ha sido aprobado.',
    'User email has not been verified':
      'El correo electrónico del usuario no ha sido verificado.',
    'User account has been disabled':
      'La cuenta de usuario ha sido deshabilitada',
    'Booking not found': 'Reserva no encontrada',
    'Route not found': 'Ruta no encontrada',
    'Pickup location (country and postalCode) is required':
      'Se requiere lugar de recogida (país y código postal)',
    'Delivery location (country and postalCode) is required':
      'Se requiere lugar de entrega (país y código postal)',
    'Unable to calculate route. Please check the locations and try again.':
      'No se puede calcular la ruta. Verifique las ubicaciones e inténtelo nuevamente.',
    'Error calculating transport price':
      'Error al calcular el precio del transporte',
    'Booking canceled successfully': 'Reserva cancelada con éxito',
    'Invalid request.': 'Solicitud no válida.',
    'Access denied.': 'Acceso denegado.',
    'Resource not found.': 'Recurso no encontrado.',
    'Request conflict.': 'Solicitar conflicto.',
    'Invalid data provided.': 'Se proporcionaron datos no válidos.',
    'Too many requests. Please try again later.':
      'Demasiadas solicitudes. Inténtelo de nuevo más tarde.',
    'Internal server error. Please try again later.':
      'Error Interno del Servidor. Inténtelo de nuevo más tarde.',
    'Service temporarily unavailable.': 'Servicio no disponible temporalmente.',
    'booking.load_preset': 'Cargar preajuste',
    'booking.save_preset_tooltip':
      'Guarde los filtros actuales como su ajuste preestablecido de acceso rápido',
    'booking.load_preset_tooltip': 'Cargue su filtro preestablecido guardado',
    'booking.preset_saved': 'Preajuste guardado',
    'booking.preset_saved_desc': 'Su filtro preestablecido se ha guardado.',
    'booking.preset_loaded': 'Preestablecido cargado',
    'booking.preset_load_error': 'No se pudo cargar el ajuste preestablecido',
    'booking.no_preset_saved':
      'Aún no se ha guardado ningún ajuste preestablecido',
    'booking.date_from': 'Fecha de',
    'booking.date_to': 'Fecha hasta',
    'Active filters': 'Filtros activos',
    'All booking states': 'Todos los estados de reserva',
    'All partners': 'Todos los socios',
    'All payments': 'Todos los pagos',
    'All roles': 'Todos los roles',
    'All statuses': 'Todos los estados',
    'All Users': 'Todos los usuarios',
    'Are you sure you want to cancel booking {{id}}?':
      '¿Estás seguro de que deseas cancelar la reserva {{id}}?',
    'Attach the CMR Insurance before finishing truck setup.':
      'Adjunte la factura de CMR antes de finalizar la configuración del camión.',
    Awaiting: 'esperando',
    'Awaiting payout': 'En espera de pago',
    'Booking canceled': 'Reserva cancelada',
    'Booking marked as paid': 'Reserva marcada como pagada',
    'Booking released and returned to marketplace':
      'Reserva liberada y devuelta al mercado',
    'booking.allowed_range': 'rango permitido',
    'booking.assign_transport': 'Asignar transporte',
    'booking.back': 'Atrás',
    'booking.back_to_summary': 'Volver al resumen',
    'booking.booking_created_but_pickup_document_not_uploaded_upload_from_order_details':
      'Se creó la reserva, pero no se cargó el documento de recogida. Puede cargarlo desde Detalles del pedido.',
    'booking.city_not_found': 'Ciudad no encontrada',
    'booking.city_or_town': 'ciudad o pueblo',
    'booking.clear_radius': 'Borrar radio',
    'booking.continue': 'Continuar',
    'booking.country_optional': 'País (opcional)',
    'booking.delivery_constraint_info':
      'La fecha de entrega debe ser en o después de la fecha de recogida.',
    'booking.delivery_date_cannot_be_earlier_than_pickup_date':
      'La fecha de entrega no puede ser anterior a la fecha de recogida.',
    'booking.driver': 'Conductor',
    'booking.failed_to_open_letter_of_attorney':
      'No se pudo abrir la carta del abogado',
    'booking.go_to_order': 'Ir al pedido',
    'booking.i_accept_terms': 'Acepto los términos',
    'booking.invalid_license_plate_or_vin_length':
      'Placa de matrícula o longitud de VIN no válida.',
    'booking.invalid_vin_format_i_o_q_not_allowed':
      'Formato VIN no válido. Los caracteres I, O y Q no están permitidos.',
    'booking.letter_of_attorney_file_is_empty':
      'El archivo de carta notarial está vacío',
    'booking.no_additional_details': 'Sin detalles adicionales',
    'booking.no_vehicle_info': 'Sin información del vehículo',
    'booking.open_letter_of_attorney': 'Carta abierta del abogado',
    'booking.opening_letter_of_attorney': 'Carta de apertura del abogado...',
    'booking.order_accepted_successfully': 'Pedido aceptado con éxito',
    'booking.order_cars_exceed_selected_truck_capacity':
      'Este pedido tiene automóviles {{orderCars}}, pero la capacidad del camión seleccionado es {{capacity}}.',
    'booking.pickup_constraint_info':
      'Se requiere la fecha de recogida antes de asignar el transporte.',
    'booking.pickup_document_upload_failed':
      'Error al cargar el documento de recogida',
    'booking.preparing_secure_document_preview':
      'Preparando vista previa segura del documento...',
    'booking.radius_km': 'Radio (km)',
    'booking.radius_search': 'Búsqueda de radio',
    'booking.route_and_details': 'Ruta y detalles',
    'booking.schedule': 'Horario',
    'booking.searching': 'Buscando…',
    'booking.select_pickup_and_delivery': 'Seleccione recogida y entrega',
    'booking.select_pickup_and_delivery_dates_before_confirming':
      'Selecciona fechas de recogida y entrega antes de confirmar',
    'booking.select_pickup_date': 'Selecciona fecha de recogida',
    'booking.select_truck_driver_and_trailer':
      'Seleccione camión, conductor y remolque',
    'booking.supported_formats_jpg_png_pdf_doc_docx':
      'Formatos soportados: JPG, PNG, PDF, DOC, DOCX',
    'booking.terms_and_conditions': 'Términos y condiciones',
    'booking.terms_text':
      'Confirmo los términos de transporte y las condiciones de responsabilidad.',
    'booking.track_shipment': 'Seguimiento del envío',
    'booking.trailer': 'Tráiler',
    'booking.transport_details': 'Detalles de transporte',
    'booking.truck': 'camión',
    'booking.truck_driver_planning_saved_letter_of_attorney_available':
      'Se guardaron las fechas de planificación, conductor y camión. La carta de representación ya está disponible.',
    'booking.unexpected_error': 'error inesperado',
    'booking.vehicles_plural': 'Vehículos',
    'booking.view_details': 'Ver detalles',
    'booking.vip_price_must_be_between_min_max_50_to_150_percent_of_estimated_price':
      'El precio VIP debe estar entre {{min}} EUR y {{max}} EUR (50% a 150% del precio estimado).',
    'booking.vip_price_must_be_positive_number':
      'El precio VIP debe ser un número positivo.',
    'booking.within_radius_km_of_place': 'Dentro de {{radius}} km de {{place}}',
    Capacity: 'Capacidad',
    'Car Capacity': 'Capacidad del coche',
    'Car capacity is required.': 'Se requiere capacidad del coche.',
    cars: 'carros',
    Changed: 'cambiado',
    'CMR Document': 'Documento CMR',
    'CMR expiry': 'Caducidad del CMR',
    'CMR Expiry': 'Caducidad del CMR',
    'CMR expiry date is required': 'Se requiere fecha de vencimiento de CMR',
    'CMR Insurance': 'Seguro CMR',
    'CMR insurance expiry date': 'Fecha de vencimiento del seguro CMR',
    'CMR Insurance Expiry Date': 'Fecha de Vencimiento del Seguro CMR',
    'CMR insurance has expired. Upload a new CMR Insurance for review.':
      'Cargue una nueva factura CMR para su revisión.',
    'CMR insurance is expiring within 14 days.':
      'El seguro CMR vence en 14 días.',
    'CMR Insurance required': 'Se requiere factura CMR',
    Company: 'Empresa',
    'Copy order ID': 'Copiar ID de pedido',
    Created: 'Creado',
    'Current expiry': 'Vencimiento actual',
    'Date range': 'Rango de fechas',
    days: 'dias',
    Delay: 'Retraso',
    'Delivered + partner invoice uploaded + unpaid':
      'Entregado + factura de socio cargada + impago',
    Document: 'Documento',
    'Documents uploaded': 'Documentos cargados',
    Done: 'hecho',
    'Download Client Invoice #{{id}}': 'Descargar Factura del Cliente #{{id}}',
    'Download Invoice': 'Descargar Factura',
    'Enter a valid capacity between 1 and 20 cars.':
      'Introduce una capacidad válida entre 1 y 20 coches.',
    'Enter license plate': 'Introducir matrícula',
    'Enter plate and upload CMR to add truck':
      'Ingrese la placa y cargue CMR para agregar camión',
    'Error fetching users': 'Error al recuperar usuarios',
    'Expire Soon (14 days)': 'Caducará pronto (14 días)',
    'Explain why this CMR was rejected':
      'Explique por qué se rechazó este CMR.',
    'Failed to copy order ID': 'No se pudo copiar el ID del pedido',
    'Failed to download invoice': 'No se pudo descargar la factura',
    'Failed to download proforma invoice':
      'No se pudo descargar la factura proforma',
    'Failed to generate invoice': 'No se pudo generar la factura',
    'Failed to load invoice summary':
      'No se pudo cargar el resumen de la factura',
    'Failed to load letter of attorney':
      'No se pudo cargar la carta del abogado',
    'Failed to open letter of attorney':
      'No se pudo abrir la carta del abogado',
    'Failed to release booking': 'No se pudo liberar la reserva',
    'Fleet data refreshed': 'Datos de flota actualizados',
    'Generate Client Invoice': 'Generar factura de cliente',
    'Generate Invoice': 'Generar factura',
    'Generated at': 'Generado en',
    'How many cars can this truck carry?':
      '¿Cuántos autos puede transportar este camión?',
    'In progress': 'En progreso',
    Invoice: 'factura',
    'Invoice generated': 'Factura generada',
    'Invoice generated successfully': 'Factura generada exitosamente',
    'Invoice uploaded': 'Factura cargada',
    'Invoices uploaded by partners for platform payout processing. Client invoices are generated in each order view.':
      'Las facturas de los clientes se generan en cada vista de pedido.',
    'Keep booking': 'Seguir reservando',
    'Keep your active drivers and contact details up to date.':
      'Mantenga actualizados sus conductores activos y sus datos de contacto.',
    'Last Rejection': 'Último rechazo',
    'Last rejection reason': 'Último motivo de rechazo',
    'Letter of Attorney': 'Carta de abogado',
    'Letter of attorney file is empty':
      'El archivo de carta notarial está vacío',
    'License plate cannot be changed after creation. Re-upload CMR Insurance instead.':
      'En su lugar, vuelva a cargar la factura CMR.',
    'License plate is required.': 'Se requiere matrícula.',
    'Manage large order volumes with search, payment actions, and invoice workflows.':
      'Administre grandes volúmenes de pedidos con búsqueda, acciones de pago y flujos de trabajo de facturación.',
    'Manage license plates and keep CMR Insurances approved and valid.':
      'Gestionar matrículas y mantener aprobadas y válidas las facturas CMR.',
    'Manage status updates, documents, and payment steps from one place.':
      'Administre actualizaciones de estado, documentos y pasos de pago desde un solo lugar.',
    'Manage trailer plate records and keep availability current.':
      'Administre los registros de placas de remolque y mantenga la disponibilidad actualizada.',
    'Mark booking {{id}} as paid?': '¿Marcar la reserva {{id}} como pagada?',
    Missing: 'desaparecido',
    'Needs attention': 'necesita atencion',
    'New (14 days)': 'Nuevo (14 días)',
    'No bookings found for the current filters.':
      'No se encontraron reservas para los filtros actuales.',
    'No confirmed CMR document uploaded yet.':
      'Aún no se ha subido ningún documento CMR confirmado.',
    'No driver assigned': 'Ningún conductor asignado',
    'No letter of attorney has been generated yet.':
      'Aún no se ha generado ninguna carta de representación.',
    'No matching delivered orders': 'No hay pedidos entregados coincidentes',
    'No new notifications': 'No hay notificaciones nuevas',
    'No partners found.': 'No se encontraron socios.',
    'No trucks found for this filter.':
      'No se encontraron camiones para este filtro.',
    'No users found for current filters.':
      'No se encontraron usuarios para los filtros actuales.',
    'Not uploaded': 'No subido',
    Notifications: 'Notificaciones',
    of: 'de',
    'Only admins can set or update this expiry date after reviewing your CMR insurance.':
      'Solo los administradores pueden establecer o actualizar esta fecha de vencimiento después de revisar su seguro CMR.',
    'Open letter of attorney': 'carta abierta de abogado',
    Order: 'Orden',
    'Order actions': 'Ordenar acciones',
    'Order ID copied': 'ID del pedido copiado',
    Owner: 'propietario',
    Page: 'Página',
    'Paid date': 'fecha pagada',
    'Partner delivery date': 'Fecha de entrega del socio',
    'Partner documents': 'Documentos de socios',
    'Partner Invoice': 'Factura de socio',
    'Partner invoice uploaded': 'Factura de socio cargada',
    'Partner Payout Invoices': 'Facturas de pago de socios',
    'Partner pickup date': 'Fecha de recogida del socio',
    'Partner score': 'Puntuación de socio',
    Payment: 'Pago',
    'Payout date': 'fecha de pago',
    'penalties applied': 'sanciones aplicadas',
    'Pending admin review': 'Pendiente de revisión administrativa',
    'Pending review': 'Pendiente de revisión',
    'Pending trucks': 'Camiones pendientes',
    'Please provide a clear reason for rejection.':
      'Proporcione un motivo claro del rechazo.',
    'Please select an order before uploading an invoice.':
      'Seleccione un pedido antes de cargar una factura.',
    'Please try again.': 'Por favor inténtalo de nuevo.',
    'Proforma Invoice': 'Factura proforma',
    'Provide a rejection reason for this CMR review.':
      'Proporcione un motivo de rechazo para esta revisión de CMR.',
    'Quarter Score': 'Puntuación del cuarto',
    'Re-upload CMR': 'Vuelva a cargar CMR',
    Refresh: 'Actualizar',
    'Rejection reason': 'Motivo del rechazo',
    'Rejection reason is required': 'Se requiere motivo de rechazo',
    'Release booking {{id}} back to the marketplace so another partner can accept it?':
      '¿Liberar la reserva {{id}} al mercado para que otro socio pueda aceptarla?',
    Reset: 'Reiniciar',
    'Review Bookings': 'Revisar Reservas',
    Revision: 'Revisión',
    Rows: 'Filas',
    'Search by invoice number, file name, or booking ID':
      'Buscar por número de factura, nombre de archivo o ID de reserva',
    'Search by name, email, company':
      'Buscar por nombre, correo electrónico, empresa',
    'Search by name, email, company, uid':
      'Buscar por nombre, correo electrónico, empresa, uid',
    'Search client': 'Buscar cliente',
    'Search delivered order': 'Buscar pedido entregado',
    'Search license plate or owner': 'Buscar matrícula o propietario',
    'Search order ID': 'Buscar ID de pedido',
    'Search partner': 'Socio de búsqueda',
    'Select a new CMR Insurance to re-upload for this truck.':
      'Seleccione una nueva factura CMR para volver a cargar para este camión.',
    'Select paid date': 'Seleccionar fecha de pago',
    'Set CMR insurance expiry date to approve this truck.':
      'Establezca la fecha de vencimiento del seguro CMR para aprobar este camión.',
    'Set maximum number of cars this truck can carry (1-20).':
      'Establezca el número máximo de automóviles que este camión puede transportar (1-20).',
    'Set the CMR insurance expiry date before approval.':
      'Establezca la fecha de vencimiento del seguro CMR antes de la aprobación.',
    Showing: 'Mostrando',
    'Showing page {{page}} of {{pages}} • {{total}} invoices':
      'Mostrando página {{page}} de facturas {{pages}} • {{total}}',
    'Status will be updated to Picked Up after successful upload. You can add multiple car photos before uploading.':
      'Puede agregar varias fotos de automóviles antes de cargarlas.',
    Terms: 'Términos',
    Total: 'totales',
    'Track paid and unpaid invoices, expected payout dates, and upload new invoices quickly.':
      'Realice un seguimiento de las facturas pagadas y impagas, las fechas de pago previstas y cargue nuevas facturas rápidamente.',
    'Truck approved successfully': 'Camión aprobado con éxito',
    'Truck documents': 'Documentos del camión',
    'Truck license plate': 'Matrícula de camión',
    'Truck rejected successfully': 'Camión rechazado con éxito',
    'truck(s) are pending admin CMR expiry date.':
      'Los camiones están pendientes de la fecha de vencimiento del CMR administrativo.',
    'truck(s) have expired CMR insurance and are disabled.':
      'Los camiones tienen seguro CMR vencido y están incapacitados.',
    'truck(s) will expire within 14 days.':
      'los camiones vencerán dentro de los 14 días.',
    'Unable to prepare the record for upload.':
      'No se puede preparar el registro para cargarlo.',
    Unpaid: 'No remunerado',
    'Upload a CMR Insurance before closing this truck setup.':
      'Cargue una factura CMR antes de cerrar la configuración de este camión.',
    'Upload a valid CMR insurance. Each upload sends the truck back to pending review.':
      'Cada carga envía el camión nuevamente a revisión pendiente.',
    'Upload documents': 'Subir documentos',
    'Upload Invoice': 'Cargar factura',
    'Upload order documents': 'Cargar documentos de pedido',
    'Upload unavailable': 'Subir no disponible',
    Uploaded: 'subido',
    'Uploaded • Paid': 'Subido • Pagado',
    'Uploaded • Partially paid': 'Subido • Parcialmente pagado',
    'Uploaded by partner for platform payout processing.':
      'Subido por el socio para el procesamiento de pagos de la plataforma.',
    User: 'Usuario',
    'Verification code': 'Código de verificación',
    'View details': 'Ver detalles',
    'View Partners': 'Ver socios',
    'Working hours not provided': 'Horas de trabajo no proporcionadas',
    '{{value}} orders': 'Órdenes {{value}}',
    Invoiced: 'Facturado',
    'Loading admin data...': 'Cargando datos de administrador...',
    'Pending partners': 'Socios pendientes',
    'Unpaid bookings': 'Reservas impagas',
    'Total users': 'Usuarios totales',
    'Orders per period': 'Pedidos por periodo',
    'Orders by status': 'Pedidos por estado',
    'Quick actions': 'Acciones rápidas',
    'Verify new partners': 'Verificar nuevos socios',
    'Review partner applications and approve or reject requests.':
      'Revise las solicitudes de socios y apruebe o rechace solicitudes.',
    'Manage all trucks': 'Administrar todos los camiones',
    'Review, approve, reject, disable, and filter all trucks.':
      'Revise, apruebe, rechace, deshabilite y filtre todos los camiones.',
    'Review bookings': 'Revisar reservas',
    'Review all transport orders, payment states, and generated invoices.':
      'Revise todas las órdenes de transporte, estados de pago y facturas generadas.',
    'Manage all users': 'Administrar todos los usuarios',
    'Manage user status, roles, and validation records.':
      'Administre el estado de los usuarios, roles y registros de validación.',
    'User breakdown': 'Desglose de usuarios',
    Clients: 'Clientes',
    Partners: 'Socios',
    Admins: 'Administradores',
    'Top 5 pending partners': 'Top 5 socios pendientes',
    'No pending partners right now.':
      'No hay socios pendientes en este momento.',
    pending: 'pendiente',
    'Top 5 pending trucks': 'Top 5 camiones pendientes',
    'No pending trucks right now.':
      'No hay camiones pendientes en este momento.',
    'Unknown owner': 'Dueño desconocido',
    'KPI cards and top lists link directly to filtered admin screens.':
      'Las tarjetas de KPI y las listas principales se vinculan directamente a las pantallas de administración filtradas.',
    'booking.available_orders_title': 'Pedidos disponibles',
    'booking.available_orders_description':
      'Revise las oportunidades de transporte entrante y aplique filtros para que coincidan con su capacidad.',
    'booking.vehicle_pickup_location': 'Lugar de recogida del vehículo',
    'booking.pickup_opening_hours': 'Horario de recogida',
    'booking.vehicle_delivery_location': 'Lugar de entrega del vehículo',
    'booking.delivery_opening_hours': 'Horario de entrega',
    'booking.pickup_contact': 'contacto de recogida',
    'booking.delivery_contact': 'contacto de entrega',
    'booking.vehicles_scheduled': 'Vehículos programados',
    'booking.watchlist_title': 'Lista de vigilancia',
    'booking.watchlist_description':
      'Realice un seguimiento de las oportunidades guardadas y actúe rápidamente cuando cambie la disponibilidad.',
    'Loading dashboard...': 'Cargando panel...',
    'Total bookings': 'Reservas totales',
    'Open bookings': 'Reservas abiertas',
    'Order status timeline': 'Cronograma del estado del pedido',
    'Last 6 months of bookings grouped by current status.':
      'Últimos 6 meses de reservas agrupadas por estado actual.',
    'Create new order': 'Crear nuevo pedido',
    'Create a new transport booking request.':
      'Cree una nueva solicitud de reserva de transporte.',
    'View my orders': 'Ver mis pedidos',
    'Review status and details of your bookings.':
      'Revisa el estado y los detalles de tus reservas.',
    'Open profile': 'Abrir perfil',
    'Update company and contact details.':
      'Actualizar datos de empresa y contacto.',
    'Recent bookings': 'Reservas recientes',
    'No bookings yet.': 'Aún no hay reservas.',
    'Unknown destination': 'Destino desconocido',
    'Quarter score': 'Puntuación del cuarto',
    '{{value}} completed': '{{value}} completado',
    'Truck CMR warning': 'Advertencia CMR de camión',
    'One truck has CMR expiry risk. Review it in Fleet.':
      'Un camión tiene riesgo de caducidad de CMR. Revíselo en Fleet.',
    '{{count}} trucks have CMR expiry risk. Review them in Fleet.':
      'Los camiones {{count}} tienen riesgo de caducidad de CMR. Revísalos en Fleet.',
    'Active queue': 'Cola activa',
    'Delivered bookings': 'Reservas entregadas',
    'Cars delivered': 'Coches entregados',
    'Canceled bookings': 'Reservas canceladas',
    'Avg assign-to-pickup': 'Promedio de asignación a recogida',
    'Quarter Partner Score': 'Puntuación del socio trimestral',
    'Payment delay: +{{days}} days': 'Retraso en el pago: +{{days}} días',
    'Penalty events': 'Eventos de penalización',
    Current: 'Actual',
    'Completed orders per period': 'Pedidos completados por periodo',
    'Completed orders': 'Pedidos completados',
    'Truck CMR status alerts': 'Alertas de estado de CMR de camiones',
    '{{count}} truck(s) have expired CMR insurance.':
      'Los camiones {{count}} tienen el seguro CMR vencido.',
    '{{count}} truck(s) will expire within 14 days.':
      'Los camiones {{count}} caducarán en un plazo de 14 días.',
    '{{count}} truck(s) are missing CMR expiry date.':
      'A los camiones {{count}} les falta la fecha de vencimiento de CMR.',
    'Upload a new CMR Insurance in Fleet. The truck will stay pending until admin review.':
      'Cargue una nueva factura CMR en Fleet. El camión permanecerá pendiente hasta la revisión del administrador.',
    'Open fleet to resolve CMR alerts':
      'Flota abierta para resolver alertas CMR',
    'Operational actions': 'Acciones operativas',
    'Open marketplace orders': 'Órdenes de mercado abierto',
    'Review available orders and plan assignments.':
      'Revise los pedidos disponibles y planifique las asignaciones.',
    'My accepted orders': 'Mis pedidos aceptados',
    'Manage delivery progress and documents.':
      'Gestionar el progreso de la entrega y los documentos.',
    'Update trucks, trailers, and availability.':
      'Actualizar camiones, remolques y disponibilidad.',
    'Partner invoices': 'Facturas de socios',
    'Upload and track invoice payments.':
      'Cargue y realice un seguimiento de los pagos de facturas.',
    'No active orders in queue.': 'No hay pedidos activos en cola.',
    'profile.incompleteTitle': 'Perfil incompleto',
    'profile.incompleteDescription':
      'Complete la información de su perfil (empresa, teléfono, dirección, ciudad, código postal) para acceder a todas las funciones.',
    'profile.goToProfile': 'Ir al perfil',
    'auth.email_placeholder': 'nombre@empresa.com',
    'auth.authentication_mode_switch': 'Cambio de modo de autenticación',
    'auth.invalid_email': 'Correo electrónico no válido',
    'auth.please_enter_a_valid_email_address':
      'Por favor ingrese una dirección de correo electrónico válida.',
    'auth.email_not_found': 'Correo electrónico no encontrado',
    'auth.no_account_found_with_that_email_address':
      'No se encontró ninguna cuenta con esa dirección de correo electrónico.',
    'auth.email_sent': 'Correo electrónico enviado!',
    'auth.something_went_wrong_try_again': 'Algo salió mal. Intentar otra vez.',
    'auth.we_sent_a_password_reset_link_open_your_inbox_and_follow_the_instructions':
      'Enviamos un enlace para restablecer la contraseña. Abre tu bandeja de entrada y sigue las instrucciones.',
    'auth.forgot_your_password': '¿Olvidaste tu contraseña?',
    'auth.enter_your_account_email_and_we_will_send_you_a_password_reset_link':
      'Ingrese el correo electrónico de su cuenta y le enviaremos un enlace para restablecer su contraseña.',
    'auth.email_address': 'Dirección de correo electrónico',
    'auth.send_reset_link': 'Enviar enlace de reinicio',
    'auth.cancel': 'Cancelar',
    'auth.tip_if_you_do_not_receive_the_email_check_spam_and_promotions_folders':
      'Consejo: si no recibes el correo electrónico, revisa las carpetas de spam y promociones.',
    'booking.e_g_berlin': 'p.ej. Berlín',
    'booking.e_g_germany': 'por ej. Alemania',
    'booking.watchlist': 'Lista de vigilancia',
    'booking.view_map': 'Ver mapa',
    'booking.invalid_input': 'Entrada no válida',
    'booking.please_enter_only_numbers_for_the_zip_code':
      'Ingrese solo números para el código postal.',
    'booking.pickup_zip_code': 'Código postal de recogida',
    'booking.delivery_zip_code': 'Código postal de entrega',
    'booking.select_vehicle_make': 'Seleccione la marca del vehículo',
    'booking.unnamed_item': 'Artículo sin nombre',
    'booking.cars': 'carros',
    'booking.more_info': 'Más información',
    'booking.loading': 'Cargando...',
    'booking.no_items_found': 'No se encontraron artículos',
    'booking.selected_cars': 'Coches seleccionados',
    'booking.unknown_type': 'tipo desconocido',
    'booking.delete_car': 'eliminar auto',
    'Toggle details': 'Alternar detalles',
    'auth.a_verification_email_has_been_sent_to_your_email_address_please_verify_your_emai':
      'Se ha enviado un correo electrónico de verificación a su dirección de correo electrónico. Por favor verifique su correo electrónico antes de iniciar sesión.',
    'auth.an_unexpected_error_occurred_please_try_again':
      'Se produjo un error inesperado. Por favor inténtalo de nuevo.',
    'auth.failed_to_resend_email': 'No se pudo reenviar el correo electrónico',
    'auth.show_password': 'Mostrar contraseña',
    'auth.hide_password': 'Ocultar contraseña',
    'auth.incorrect_password_please_try_again':
      'Contraseña incorrecta. Por favor inténtalo de nuevo.',
    'auth.invalid_email_or_password_please_check_your_credentials_and_try_again':
      'Correo electrónico o contraseña no válidos. Por favor verifique sus credenciales e inténtelo nuevamente.',
    'auth.network_error_check_your_connection_and_try_again':
      'Error de red. Comprueba tu conexión y vuelve a intentarlo.',
    'auth.no_account_found_with_this_email':
      'No se encontró ninguna cuenta con este correo electrónico.',
    'auth.please_check_your_inbox': 'Por favor revisa tu bandeja de entrada.',
    'auth.please_make_sure_both_passwords_are_the_same':
      'Asegúrese de que ambas contraseñas sean iguales.',
    'auth.please_sign_in_to_resend_the_verification_email':
      'Inicie sesión para reenviar el correo electrónico de verificación.',
    'auth.resend_verification_email':
      'Reenviar correo electrónico de verificación',
    'auth.awaiting_verification_artwork': 'En espera de verificación',
    'auth.error': 'error',
    'auth.email_verification_required':
      'Se requiere verificación por correo electrónico',
    'auth.waiting_for_email_verification':
      'Esperando verificación por correo electrónico',
    'auth.check_your_email': 'Revisa tu correo electrónico',
    'auth.we_sent_your_verification_link_to':
      'Enviamos su enlace de verificación a',
    'auth.didnt_receive_it_check_spam_or_try_again':
      '¿No lo recibiste? Revisa tu carpeta de spam o inténtalo de nuevo.',
    'auth.resend_email': 'Reenviar correo electrónico',
    'auth.i_verified_my_email': 'He verificado mi correo electrónico',
    'auth.redirecting_you_now': 'Redireccionándote ahora.',
    'auth.email_not_verified_yet': 'Correo electrónico aún no verificado',
    'auth.please_click_the_link_in_your_inbox_and_try_again':
      'Haga clic en el enlace de su bandeja de entrada e inténtelo de nuevo.',
    'auth.unable_to_resend_verification_email_right_now':
      'No se puede reenviar el correo electrónico de verificación en este momento.',
    'auth.unable_to_check_verification_status_right_now':
      'No se puede verificar el estado de verificación en este momento.',
    'auth.we_sent_a_new_verification_link':
      'Hemos enviado un nuevo enlace de verificación a su dirección de correo electrónico.',
    'auth.we_automatically_check_every_30_seconds':
      'Verificamos automáticamente su estado de verificación cada 30 segundos. También puede activar una verificación instantánea después de verificar su correo electrónico.',
    'auth.we_automatically_check_every_15_seconds':
      'Verificamos automáticamente su estado de verificación cada 15 segundos. También puede activar una verificación instantánea después de verificar su correo electrónico.',
    'auth.the_email_address_is_not_valid':
      'La dirección de correo electrónico no es válida.',
    'auth.this_account_has_been_disabled': 'Esta cuenta ha sido deshabilitada.',
    'auth.too_many_failed_attempts_please_try_again_later_or_reset_your_password':
      'Demasiados intentos fallidos. Inténtelo de nuevo más tarde o restablezca su contraseña.',
    'auth.verification_email_resent':
      '¡Correo electrónico de verificación reenviado!',
    'auth.you_need_to_log_in_first': 'Primero debes iniciar sesión',
    'booking.error_fetching_data': 'Error al obtener datos',
    'booking.inputs_changed_recalculate_the_price':
      'Las entradas cambiaron. Vuelva a calcular el precio.',
    'booking.kg': 'kilos',
    'booking.km': 'kilómetros',
    'booking.mi': 'mi',
    'booking.no_opening_hours_provided':
      'No se proporcionan horarios de apertura',
    'booking.no_vehicles_listed': 'No hay vehículos listados',
    'booking.not_available': 'No disponible',
    'booking.not_set': 'No establecido',
    'booking.please_select_a_planned_date':
      'Por favor seleccione una fecha planificada',
    'booking.required': 'Requerido',
    'booking.to': 'a',
    'booking.total': 'total',
    'booking.order': 'Orden',
    'booking.duration': 'Duración',
    'booking.vehicles_overview': 'Resumen de vehículos',
    'booking.body': 'cuerpo',
    'booking.dims': 'Se atenúa',
    'booking.select_vehicle_model': 'Seleccione modelo de vehículo',
    'booking.selected_type_value': 'Seleccionado: {{value}}',
    'booking.select_a_vehicle_type': 'Seleccione un tipo de vehículo:',
    'booking.select_vehicle_weight': 'Seleccione el peso del vehículo',
    'booking.selected_weight_kg': 'Seleccionado: {{value}} kg',
    'booking.adjust_weight': 'Ajustar peso',
    'Dates updated successfully': 'Fechas actualizadas exitosamente',
    'Error updating dates': 'Error al actualizar fechas',
    'Set Planned Dates': 'Establecer fechas planificadas',
    'Set your planned pickup and arrival dates below.':
      'Establezca sus fechas planificadas de recogida y llegada a continuación.',
    'Changing dates after initial setup will deduct 20% from your performance score for this order.':
      'Cambiar las fechas después de la configuración inicial deducirá el 20 % de su puntuación de rendimiento para este pedido.',
    'Planned Pickup Date': 'Fecha de recogida prevista',
    'Planned Arrival Date': 'Fecha de llegada prevista',
    Listing: 'Listado',
    'Try broadening the current search or status filter.':
      'Intente ampliar la búsqueda actual o el filtro de estado.',
    'Try broadening the search, role, or status filters.':
      'Intente ampliar los filtros de búsqueda, rol o estado.',
    'Monitor fleet compliance, validation status, and expiring insurance in one place.':
      'Supervise el cumplimiento de la flota, el estado de validación y el vencimiento del seguro en un solo lugar.',
    'Active Listings': 'Listados activos',
    'Open transport requests': 'Solicitudes de transporte abiertas',
    'Quotes Today': 'Cotizaciones hoy',
    'Submitted in last 24h': 'Enviado en las últimas 24h',
    'Platform Revenue (MTD)': 'Ingresos de la plataforma (MTD)',
    'Month to date': 'Mes hasta la fecha',
    'Pending Partners': 'Socios pendientes',
    'Awaiting approval': 'En espera de aprobación',
    'Unpaid Invoices': 'Facturas impagas',
    'Requires action': 'Requiere acción',
    'Completed Transports': 'Transportes completados',
    'All time delivered': 'Entregado todo el tiempo',
    'Admin Dashboard': 'Panel de administración',
    'Platform overview and key performance indicators.':
      'Descripción general de la plataforma e indicadores clave de rendimiento.',
    'Loading dashboard metrics...': 'Cargando métricas del panel...',
    Invoices: 'Facturas',
    'Review payout invoices uploaded by partners and keep payout processing organized.':
      'Revise las facturas de pago cargadas por los socios y mantenga organizado el procesamiento de pagos.',
    Flexible: 'Flexibles',
    'Flexible dates': 'Fechas flexibles',
    'Could not load this listing.': 'No se pudo cargar este listado.',
    'Listing canceled': 'Anuncio cancelado',
    'Failed to cancel listing': 'No se pudo cancelar la lista',
    Reference: 'Referencia',
    Category: 'categoría',
    'Client type': 'Tipo de cliente',
    'Company country': 'País de la empresa',
    Expires: 'Vence',
    'Back to listings': 'Volver a listados',
    'Listing not found.': 'Listado no encontrado.',
    'Cancel Listing': 'Cancelar listado',
    'Listing details': 'Detalles del listado',
    'Reference {{id}}': 'Referencia {{id}}',
    'Read-only listing overview for admins.':
      'Descripción general del listado de solo lectura para administradores.',
    'Pick-up': 'recogida',
    'No exact coordinates are stored for this listing yet.':
      'Aún no se almacenan coordenadas exactas para este listado.',
    'Structured overview of quantities and handling details.':
      'Resumen estructurado de cantidades y detalles de manipulación.',
    'Shipment images': 'Imágenes de envío',
    'No shipment images were uploaded for this listing.':
      'No se cargaron imágenes de envío para este listado.',
    'Proof of pickup': 'Prueba de recogida',
    'Final documents': 'Documentos finales',
    Description: 'Descripción',
    'Quotes ({{count}})': 'Cotizaciones ({{count}})',
    'Loading quotes...': 'Cargando cotizaciones...',
    'No quotes for this listing.': 'No hay cotizaciones para este listado.',
    'Score: {{score}}/100': 'Puntuación: {{score}}/100',
    'Pickup: {{date}}': 'Recogida: {{date}}',
    'Delivery: {{date}}': 'Entrega: {{date}}',
    'Cancel Listing?': '¿Cancelar listado?',
    'This will permanently cancel the listing and notify the client. Continue?':
      'Esto cancelará permanentemente el listado y notificará al cliente. ¿Continuar?',
    Keep: 'mantener',
    'Review partner applications, check their documents, and keep approval decisions consistent.':
      'Revise las solicitudes de socios, verifique sus documentos y mantenga consistentes las decisiones de aprobación.',
    'No client payments recorded yet':
      'Aún no se han registrado pagos de clientes',
    'Client payment rows will appear here when the payments backend is connected.':
      'Las filas de pago del cliente aparecerán aquí cuando el backend de pagos esté conectado.',
    Method: 'Método',
    'No partner payouts recorded yet':
      'Aún no se han registrado pagos a socios',
    'Payout rows will appear here once partner payout processing is enabled.':
      'Las filas de pagos aparecerán aquí una vez que se habilite el procesamiento de pagos de socios.',
    'Payout Amount': 'Monto del pago',
    'No platform fees recorded yet':
      'Aún no se han registrado tarifas de plataforma',
    'Fee rows will appear here once payment settlement data is available.':
      'Las filas de tarifas aparecerán aquí una vez que los datos de liquidación de pagos estén disponibles.',
    Gross: 'bruto',
    'Fee (20%)': 'Tarifa (20%)',
    Payments: 'Pagos',
    'Client payments, partner payouts, and platform fee tracking.':
      'Pagos de clientes, pagos de socios y seguimiento de tarifas de plataforma.',
    'Client Payments': 'Pagos de clientes',
    'Partner Payouts': 'Pagos de socios',
    'Platform Fees': 'Tarifas de plataforma',
    'Failed to load reviews': 'No se pudieron cargar las reseñas',
    'Review removed': 'Revisión eliminada',
    'Failed to remove review': 'No se pudo eliminar la reseña',
    Reviews: 'Reseñas',
    'All partner and transport reviews submitted by clients.':
      'Todas las reseñas de socios y transporte enviadas por los clientes.',
    'Loading reviews...': 'Cargando reseñas...',
    'No reviews found': 'No se encontraron reseñas',
    'Client feedback will appear here when reviews are submitted.':
      'Los comentarios de los clientes aparecerán aquí cuando se envíen las reseñas.',
    Stars: 'estrellas',
    Comment: 'Comentario',
    'Search, review, and maintain user accounts with one consistent admin workflow.':
      'Busque, revise y mantenga cuentas de usuario con un flujo de trabajo de administración consistente.',
    'Track paid and unpaid partner payout invoices, and upload the next delivered listing invoice quickly.':
      'Realice un seguimiento de las facturas de pagos de socios pagadas y no pagadas y cargue rápidamente la siguiente factura del listado entregada.',
    'Search by invoice number, file name, or listing ID':
      'Buscar por número de factura, nombre de archivo o ID de listado',
    'Loading delivered listings...': 'Cargando listados entregados...',
    'Search delivered listing by reference, title, or route':
      'Buscar listado entregado por referencia, título o ruta',
    'Route details available in listing':
      'Detalles de la ruta disponibles en el listado',
    'No matching delivered listings':
      'No hay anuncios entregados que coincidan',
    'Selected listing': 'Listado seleccionado',
    'Has quotes': 'tiene comillas',
    'In transit': 'En tránsito',
    Open: 'Abierto',
    Accepted: 'Aceptado',
    Completed: 'Completado',
    'Client Dashboard': 'Panel de cliente',
    'Overview of your current transport listings, quote activity, and recent requests.':
      'Descripción general de sus listados de transporte actuales, actividad de cotizaciones y solicitudes recientes.',
    'Total listings': 'listados totales',
    'Active listings': 'Listados activos',
    'Listings with quotes': 'Listados con cotizaciones',
    'Accepted transport': 'Transporte aceptado',
    'Listing status timeline': 'Cronología del estado del listado',
    'Last 6 months of listings grouped by current status.':
      'Últimos 6 meses de listados agrupados por estado actual.',
    'No listing activity yet': 'Aún no hay actividad en el listado',
    'Create your first listing to start tracking request activity here.':
      'Cree su primer listado para comenzar a rastrear la actividad de las solicitudes aquí.',
    'Create new listing': 'Crear nuevo listado',
    'Create a new transport request for the marketplace.':
      'Cree una nueva solicitud de transporte para el mercado.',
    'View my listings': 'Ver mis listados',
    'Review quote activity and manage your transport requests.':
      'Revise la actividad de cotización y gestione sus solicitudes de transporte.',
    'Recent listings': 'Listados recientes',
    'No listings yet': 'Aún no hay anuncios',
    'Your newest transport requests will appear here once you create them.':
      'Sus solicitudes de transporte más recientes aparecerán aquí una vez que las cree.',
    'Unknown origin': 'Origen desconocido',
    '{{count}} quote(s)': '{{count}} cotización(es)',
    '{{value}} completed listings': '{{value}} listados completados',
    'Monitor current performance, fleet readiness, quote flow, and your active transport queue.':
      'Supervise el rendimiento actual, la preparación de la flota, el flujo de cotizaciones y su cola de transporte activa.',
    'Total assigned': 'Total asignado',
    'Quarter rating': 'Calificación trimestral',
    'Based on current quarter performance':
      'Basado en el desempeño del trimestre actual',
    Rating: 'Calificación',
    'Requirement met': 'Requisito cumplido',
    'Requirement not met': 'Requisito no cumplido',
    'Completed listings per period': 'Listados completos por período',
    'No completion data yet': 'Aún no hay datos de finalización',
    'Statistics will appear here after your first delivered work.':
      'Las estadísticas aparecerán aquí después de su primer trabajo entregado.',
    'Completed listings': 'Listados completos',
    'Review truck documents and refresh anything close to expiry.':
      'Revise los documentos del camión y actualice todo lo que esté a punto de caducar.',
    'Search deliveries': 'Buscar entregas',
    'Review available marketplace listings and submit quotes.':
      'Revise los listados de mercados disponibles y envíe cotizaciones.',
    'My quotes': 'mis citas',
    'Track accepted, pending, and rejected quotes in one place.':
      'Realice un seguimiento de las cotizaciones aceptadas, pendientes y rechazadas en un solo lugar.',
    'Profile settings': 'Configuración de perfil',
    'Keep company information and compliance details up to date.':
      'Mantenga actualizada la información de la empresa y los detalles de cumplimiento.',
    'No active queue items': 'No hay elementos de cola activos',
    'Accepted and in-progress work will appear here as your transport activity grows.':
      'Los trabajos aceptados y en curso aparecerán aquí a medida que crezca su actividad de transporte.',
    'Your role does not have permission to open this page.':
      'Su rol no tiene permiso para abrir esta página.',
    'Go to dashboard': 'Ir al panel',
    'Trailer capacity is required.': 'Se requiere capacidad de remolque.',
    'How many cars can this trailer carry?':
      '¿Cuántos coches puede transportar este remolque?',
    'Set maximum number of cars this trailer can carry (1-20).':
      'Establezca el número máximo de automóviles que puede transportar este remolque (1-20).',
    'Invalid max load (kg).': 'Carga máxima no válida (kg).',
    'Enter a valid weight between 1 and 100000 kg, or leave it empty.':
      'Introduzca un peso válido entre 1 y 100000 kg o déjelo vacío.',
    'Maximum payload weight this truck can carry (optional).':
      'Peso máximo de carga útil que este camión puede transportar (opcional).',
    'Manage the company and contact details that appear across your listings, invoices, and account verification flows.':
      'Administre la empresa y los detalles de contacto que aparecen en sus listados, facturas y flujos de verificación de cuentas.',
    'Keep these details up to date so listings, invoices, and partner verification stay accurate.':
      'Mantenga estos detalles actualizados para que los listados, las facturas y la verificación de socios sean precisos.',
    'Unsaved changes': 'Cambios no guardados',
    'All changes saved': 'Todos los cambios guardados',
    'auth.sign_up_failed': 'Error al registrarse',
    'auth.please_select_a_valid_role': 'Seleccione un rol válido.',
    'booking.pickup_not_found': 'Recogida no encontrada.',
    'booking.delivery_not_found': 'Entrega no encontrada.',
    'booking.capacity': 'Capacidad',
    'booking.cmr_expiry': 'Caducidad del CMR',
    'booking.uploaded': 'subido',
    'booking.missing': 'desaparecido',
    'booking.cmr_document': 'Documento CMR',
    'booking.go_to_profile': 'Ir al perfil',
    'booking.click_to_download_purchase_terms':
      'Haga clic para descargar los términos de compra',
    'admin.purchase_terms_management': 'Gestión de términos de compra',
    'admin.purchase_terms_management_subtitle':
      'Cargue y mantenga archivos PDF de términos de compra localizados utilizados en la aceptación de pedidos de socios.',
    'admin.document_language': 'Idioma del documento',
    'admin.click_to_download_purchase_terms':
      'Haga clic para descargar los términos de compra',
    'admin.current_language_label': 'Idioma actual: {{language}}',
    'admin.purchase_terms_unavailable_for_selected_language':
      'El documento de términos de compra no está disponible para el idioma seleccionado.',
    'Download and review the active purchase terms in your current interface language before continuing.':
      'Descargue y revise los términos de compra activos en el idioma de su interfaz actual antes de continuar.',
    'We make agreements and conclude a contract for the carriage of goods. I have just read this agreement in full and agree to its contents.':
      'Celebramos acuerdos y celebramos un contrato para el transporte de mercancías. Acabo de leer este acuerdo en su totalidad y acepto su contenido.',
    'I confirm that I will schedule this order within 24 hours':
      'Confirmo que programaré este pedido dentro de las 24 horas',
    'Failed to load purchase terms document.':
      'No se pudo cargar el documento de términos de compra.',
    'Partner rating': 'Calificación de socio',
    'Bronze requirements': 'Requisitos de bronce',
    'Orders in quarter': 'Pedidos en trimestre',
    'Cancellation rate / 100 orders': 'Tasa de cancelación / 100 pedidos',
    'Damage claims / 100 orders': 'Reclamaciones por daños / 100 pedidos',
    '{{current}} / min {{target}}': '{{current}} / min {{target}}',
    '{{current}} / max {{target}}': '{{current}} / máx {{target}}',
    Met: 'Cumplió',
    'Not met': 'No cumplido',
    Unranked: 'Sin clasificar',
    'profile.incompleteDescriptionPartner':
      'Complete la información de su perfil (empresa, teléfono, dirección, ciudad, código postal, número de IVA) para acceder a todas las funciones.',
    'profile.incompleteDescriptionClient':
      'Complete la información de su perfil (número de teléfono) para acceder a todas las funciones.',
    'auth.verification_email_sent':
      'Correo electrónico de verificación enviado',
    '{{amount}} above the client target':
      '{{amount}} por encima del objetivo del cliente',
    '{{amount}} below the client target':
      '{{amount}} por debajo del objetivo del cliente',
    '{{count}} image(s) added to the listing.':
      '{{count}} imagen(es) añadida(s) al listado.',
    '{{count}} quote(s) received': '{{count}} cotización(es) recibida(s)',
    '{{count}} reviews': '{{count}} opiniones',
    '{{count}} total': '{{count}} total',
    '{{count}} visible': '{{count}} visible',
    '{{weight}} kg': '{{weight}} kilos',
    'A Google route preview with pins A and B appears here once pickup and delivery coordinates are available.':
      'Aquí aparece una vista previa de la ruta de Google con los pines A y B una vez que las coordenadas de recogida y entrega estén disponibles.',
    'A route preview appears once map coordinates are available.':
      'Aparece una vista previa de la ruta una vez que las coordenadas del mapa están disponibles.',
    'A timeline of clarifications connected to this listing.':
      'Una cronología de aclaraciones relacionadas con esta lista.',
    "Accept {{partner}}'s quote for {{amount}}?":
      '¿Aceptar la cotización de {{partner}} por {{amount}}?',
    'Accept Listing': 'Aceptar listado',
    'Accept quote': 'Aceptar cotización',
    'Accepted quote': 'Cotización aceptada',
    'Accepted quote required': 'Se requiere cotización aceptada',
    'Accepting...': 'Aceptando...',
    Active: 'Activo',
    'Active statuses': 'Estados activos',
    'Add another item': 'Agregar otro elemento',
    'Add images': 'Agregar imágenes',
    'Add more shipment images': 'Agregar más imágenes de envío',
    'After you confirm an AI action, open the prepared destination immediately instead of waiting for a manual click.':
      'Después de confirmar una acción de IA, abra el destino preparado inmediatamente en lugar de esperar un clic manual.',
    'AI Assistant': 'Asistente de IA',
    'AI assistant disabled for all users.':
      'Asistente de IA deshabilitado para todos los usuarios.',
    'AI assistant enabled for all users.':
      'Asistente de IA habilitado para todos los usuarios.',
    'AI assistant preferences updated':
      'Preferencias del asistente de IA actualizadas',
    'AI disabled for user.': 'IA deshabilitada para el usuario.',
    'AI enabled for user.': 'IA habilitada para el usuario.',
    'AI-powered message translation between languages':
      'Traducción de mensajes entre idiomas impulsada por IA',
    'All route-critical information in one place before you review quotes or documents.':
      'Toda la información crítica de la ruta en un solo lugar antes de revisar cotizaciones o documentos.',
    View: 'Ver',
    Answer: 'respuesta',
    Archive: 'Archivo',
    'Archived statuses': 'Estados archivados',
    'Are you sure you want to reject the quote from':
      '¿Está seguro de que desea rechazar la cotización de',
    'Ask a question about this listing...':
      'Haga una pregunta sobre este listado...',
    'Ask for matching lanes, quote help, or the next operational step.':
      'Solicite carriles coincidentes, cotización de ayuda o el siguiente paso operativo.',
    'Ask for quote comparisons or a prepared next step from this shipment screen.':
      'Solicite comparaciones de cotizaciones o un siguiente paso preparado desde esta pantalla de envío.',
    'Assistant history cleared': 'Historial del asistente borrado',
    'Automatically translate messages from other users into your preferred language using AI.':
      'Traduce automáticamente mensajes de otros usuarios a tu idioma preferido mediante IA.',
    'Back to listing': 'Volver al listado',
    'Best offer': 'Mejor oferta',
    'Best quote': 'mejor cita',
    'Body type: {{type}}': 'Tipo de cuerpo: {{type}}',
    'Breed: {{breed}}': 'Raza: {{breed}}',
    Budget: 'Presupuesto',
    'Cancel listing': 'Cancelar listado',
    'Canceled and completed work will appear here once listings move out of the active view.':
      'El trabajo cancelado y completado aparecerá aquí una vez que los listados salgan de la vista activa.',
    'Cargo Details': 'Detalles de carga',
    Categories: 'Categorías',
    'Choose the interface language. This preference is saved locally and applies immediately.':
      'Elija el idioma de la interfaz. Esta preferencia se guarda localmente y se aplica inmediatamente.',
    'Clear all': 'Borrar todo',
    'Clear assistant history': 'Borrar historial de asistente',
    'Client price in EUR': 'Precio al cliente en EUR',
    'Client target price': 'Precio objetivo del cliente',
    'Complete the payment below to lock the fixed-price acceptance and let the partner start planning.':
      'Complete el pago a continuación para bloquear la aceptación del precio fijo y permitir que el socio comience a planificar.',
    'Complete the payment below to lock the selected quote and let the partner start planning.':
      'Complete el pago a continuación para bloquear la cotización seleccionada y permitir que el socio comience a planificar.',
    'Compose area prepared for listing Q&A. Submission remains disabled until the live question endpoint is connected on this page.':
      'Área de redacción preparada para enumerar preguntas y respuestas. El envío permanece deshabilitado hasta que el punto final de la pregunta en vivo esté conectado en esta página.',
    'Confirm delivery complete': 'Confirmar entrega completa',
    'Confirm payment received': 'Confirmar pago recibido',
    'Confirm that you have received the bank transfer or payment for this listing. This will move the listing to Paid status and allow the partner to mark it as planned.':
      'Confirma que has recibido la transferencia bancaria o el pago de este anuncio. Esto moverá el listado al estado Pagado y permitirá al socio marcarlo como estaba planeado.',
    'Confirm the exact fleet and dates before the listing moves to Planned.':
      'Confirme la flota y las fechas exactas antes de que el listado pase a Planificado.',
    'Confirm Transport Plan': 'Confirmar plan de transporte',
    'Confirming...': 'Confirmando...',
    'Control how the web assistant behaves on this device. These settings do not change your account data.':
      'Controla cómo se comporta el asistente web en este dispositivo. Estas configuraciones no cambian los datos de su cuenta.',
    'Create listing': 'Crear listado',
    'Create with AI': 'Crear con IA',
    'Create your next transport request and it will appear here with route, item, and quote activity.':
      'Cree su próxima solicitud de transporte y aparecerá aquí con ruta, artículo y actividad de cotización.',
    'Current stage:': 'Etapa actual:',
    'Current status': 'Estado actual',
    'Delivery confirmation needed': 'Se necesita confirmación de entrega',
    'Delivery radius': 'Radio de entrega',
    'Delivery:': 'Entrega:',
    'Describe the route and cargo, then review the prepared listing draft before publishing.':
      'Describa la ruta y la carga, luego revise el borrador del listado preparado antes de publicarlo.',
    'Describe the shipment you need and review the prepared request before publishing.':
      'Describe el envío que necesitas y revisa la solicitud preparada antes de publicarla.',
    'Download and review the purchase terms before confirming the transport plan.':
      'Descarga y revisa los términos de compra antes de confirmar el plan de transporte.',
    'Download invoice': 'Descargar factura',
    'Download Purchase Terms': 'Descargar Condiciones de Compra',
    'Draft with AI': 'Borrador con IA',
    'Draft your review first, then submit it here when you are satisfied.':
      'Primero redacte su reseña y luego envíela aquí cuando esté satisfecho.',
    'Edit listing': 'Editar listado',
    'Edit Quote': 'Editar cotización',
    Enable: 'Habilitar',
    'Enable live translation': 'Habilitar traducción en vivo',
    'Enabled Users': 'Usuarios habilitados',
    'Engagement Activity': 'Actividad de participación',
    'Expires:': 'Vence:',
    'Failed to accept listing': 'No se pudo aceptar el listado',
    'Failed to accept quote': 'No se pudo aceptar la cotización',
    'Failed to clear assistant history':
      'No se pudo borrar el historial del asistente',
    'Failed to complete listing': 'No se pudo completar el listado',
    'Failed to confirm payment': 'No se pudo confirmar el pago',
    'Failed to confirm transport plan':
      'No se pudo confirmar el plan de transporte',
    'Failed to disable AI for user.':
      'No se pudo desactivar la IA para el usuario.',
    'Failed to enable AI for user.':
      'No se pudo habilitar la IA para el usuario.',
    'Failed to load listing.': 'No se pudo cargar el listado.',
    'Failed to load listings': 'No se pudieron cargar los listados',
    'Failed to load listings. Please try again.':
      'No se pudieron cargar los listados. Por favor inténtalo de nuevo.',
    'Failed to load review context.':
      'No se pudo cargar el contexto de revisión.',
    'Failed to load settings.': 'No se pudo cargar la configuración.',
    'Failed to refresh Stripe payment status':
      'No se pudo actualizar el estado de pago de Stripe',
    'Failed to reject quote': 'No se pudo rechazar la cotización',
    'Failed to release listing': 'No se ha podido publicar el listado',
    'Failed to save quote': 'No se pudo guardar la cotización',
    'Failed to update listing': 'No se pudo actualizar el listado',
    'Failed to update preferred language':
      'No se pudo actualizar el idioma preferido',
    'Failed to update setting.': 'No se pudo actualizar la configuración.',
    'Failed to update status': 'No se pudo actualizar el estado',
    'Failed to update translation preference':
      'No se pudo actualizar la preferencia de traducción',
    'Failed to update watchlist':
      'No se pudo actualizar la lista de seguimiento',
    'Failed to withdraw quote': 'No se pudo retirar la cotización',
    'Feature Flags': 'Banderas de características',
    'Filter invoice uploads, search by reference, and page through payout records.':
      'Filtre las cargas de facturas, busque por referencia y revise los registros de pago.',
    Filters: 'Filtros',
    'Final delivery documents': 'Documentos de entrega finales',
    'Fixed price only': 'Solo precio fijo',
    'Flexible / not set': 'Flexible / no configurado',
    'Generated automatically when the transport plan is confirmed.':
      'Se genera automáticamente cuando se confirma el plan de transporte.',
    'Generation: {{generation}}': 'Generación: {{generation}}',
    'Goods delivered — awaiting client confirmation.':
      'Bienes entregados, a la espera de la confirmación del cliente.',
    'Gross price': 'precio bruto',
    'I have read and agree to the purchase terms for this transport job.':
      'He leído y acepto los términos de compra de este trabajo de transporte.',
    'I understand that accepting this listing assigns it to me at the fixed client price shown above.':
      'Entiendo que aceptar este listado me lo asigna al precio fijo para el cliente que se muestra arriba.',
    'Image upload failed': 'Error al subir la imagen',
    'Images uploaded': 'Imágenes cargadas',
    'Interface language': 'Idioma de la interfaz',
    'Invoice documents': 'Documentos de factura',
    'Item {{number}}': 'Artículo {{number}}',
    items: 'artículos',
    'Keep listing': 'Seguir listado',
    'Keep quote': 'Mantener cotización',
    'Keep the current AI session available after closing the browser on this device.':
      'Mantenga disponible la sesión de IA actual después de cerrar el navegador en este dispositivo.',
    'Language & Region': 'Idioma y región',
    'Lift: {{origin}} / {{destination}}':
      'Ascensor: {{origin}} / {{destination}}',
    Listed: 'Listado',
    'Listing {{id}}': 'Listado {{id}}',
    'Listing accepted': 'Listado aceptado',
    'Listing expired': 'Listado caducado',
    'Listing images': 'Listado de imágenes',
    'Listing is live': 'El listado está activo',
    'Listing reference': 'Referencia de listado',
    'Listing snapshot': 'Instantánea del listado',
    'Listing unavailable': 'Listado no disponible',
    'Listing updated': 'Listado actualizado',
    'Live Translation': 'Traducción en vivo',
    'Live translation disabled.': 'Traducción en vivo deshabilitada.',
    'Live translation enabled.': 'Traducción en vivo habilitada.',
    'Loading approved trucks...': 'Cargando camiones homologados...',
    'Loading fleet...': 'Cargando flota...',
    'Loading listing details...': 'Cargando detalles del listado...',
    'Loading listings...': 'Cargando listados...',
    'Loading review details...': 'Cargando detalles de la reseña...',
    'Loading settings...': 'Cargando configuración...',
    'Manage AI Assistant Users': 'Administrar usuarios del asistente de IA',
    'Manage platform-wide feature flags and configuration.':
      'Administre los indicadores y la configuración de funciones de toda la plataforma.',
    'Manage Users': 'Administrar usuarios',
    'Manage your transport requests, monitor quote activity, and keep active and archived work easy to scan.':
      'Administre sus solicitudes de transporte, supervise la actividad de cotizaciones y mantenga el trabajo activo y archivado fácil de escanear.',
    'Mark Picked Up': 'marca recogió',
    'Matches the client target price':
      'Coincide con el precio objetivo del cliente',
    Media: 'Medios',
    Messages: 'Mensajes',
    'Messages will be translated into this language.':
      'Los mensajes serán traducidos a este idioma.',
    'Minimum net:': 'Neto mínimo:',
    'My invoices': 'Mis facturas',
    Net: 'neto',
    'Net price': 'Precio neto',
    'Net quote': 'Cotización neta',
    'New images appear immediately in the listing details for client, partner, and admin views.':
      'Las nuevas imágenes aparecen inmediatamente en los detalles del listado para las vistas de clientes, socios y administradores.',
    'Next step': 'Siguiente paso',
    'No active listings yet': 'Aún no hay listados activos',
    'No address provided': 'No se proporcionó ninguna dirección',
    'No answer yet.': 'Aún no hay respuesta.',
    'No archived listings yet': 'Aún no hay listados archivados',
    'No description added.': 'No se agregó ninguna descripción.',
    'no destination': 'sin destino',
    'No expiry': 'Sin caducidad',
    'No listings match the current filters. Try broadening the search or date range.':
      'Ningún listado coincide con los filtros actuales. Intente ampliar la búsqueda o el rango de fechas.',
    'no origin': 'sin origen',
    'No questions yet': 'Aún no hay preguntas',
    'No quotes yet': 'Aún no hay cotizaciones',
    'No shipment images uploaded yet.':
      'Aún no se han cargado imágenes de envío.',
    'No trailer selected': 'Ningún tráiler seleccionado',
    'No unread messages': 'No hay mensajes no leídos',
    'No users found.': 'No se encontraron usuarios.',
    'No users have AI enabled.': 'Ningún usuario tiene la IA habilitada.',
    'Not selected': 'No seleccionado',
    'Offers summary': 'Resumen de ofertas',
    'Open AI assistant': 'Asistente de IA abierto',
    'Open prepared screens automatically':
      'Abrir pantallas preparadas automáticamente',
    'Optional visible price shown to partners as your target budget.':
      'Precio visible opcional que se muestra a los socios como su presupuesto objetivo.',
    'Other quotes will be declined automatically once this offer is accepted.':
      'Otras cotizaciones se rechazarán automáticamente una vez que se acepte esta oferta.',
    'Partner delivery': 'Entrega de socios',
    'Partner pickup': 'Recogida de socios',
    'Partner quote': 'Cotización de socio',
    'Payment confirmed': 'Pago confirmado',
    'Payment confirmed — listing status set to paid':
      'Pago confirmado: estado del listado configurado como pagado',
    'Payment confirmed. Confirm the assigned fleet and planned dates before the listing moves to Planned.':
      'Pago confirmado. Confirme la flota asignada y las fechas planificadas antes de que el listado pase a Planificado.',
    'Payment is confirmed. The partner now needs to confirm the truck, driver, and planned dates.':
      'El pago está confirmado. El socio ahora necesita confirmar el camión, el conductor y las fechas previstas.',
    'Payment required': 'Pago requerido',
    'Photos uploaded for the shipment and visible across client, partner, and admin views.':
      'Fotos cargadas para el envío y visibles en las vistas de clientes, socios y administradores.',
    'Pickup is complete and the transport is currently underway.':
      'La recogida ha finalizado y el transporte ya está en marcha.',
    'Pickup proof': 'Prueba de recogida',
    'Pickup proof and final delivery files uploaded by the transport partner.':
      'Archivos de prueba de recogida y entrega final cargados por el socio de transporte.',
    'Pickup to delivery overview': 'Resumen de recogida a entrega',
    'Pickup:': 'Recogida:',
    'Plan and authorization': 'Plan y autorización',
    'Plan transport': 'Planificar transporte',
    'Plan Transport': 'Planificar Transporte',
    'Planned dates:': 'Fechas previstas:',
    'Planned delivery date': 'Fecha de entrega prevista',
    'Platform Settings': 'Configuración de la plataforma',
    'Preferred language': 'Idioma preferido',
    'Preferred language updated': 'Idioma preferido actualizado',
    'Prepare a quote or ask for the next lane action, then confirm before anything is submitted.':
      'Prepare una cotización o solicite la acción del siguiente carril, luego confirme antes de enviar algo.',
    'Purchase Terms': 'Condiciones de compra',
    'Quantities, dimensions, and handling details ready for transport review.':
      'Cantidades, dimensiones y detalles de manejo listos para revisión de transporte.',
    Question: 'Pregunta',
    Questions: 'Preguntas',
    'Questions & answers': 'Preguntas y respuestas',
    'Questions and answers for this listing will appear here once the messaging flow is active.':
      'Las preguntas y respuestas de este listado aparecerán aquí una vez que el flujo de mensajes esté activo.',
    'Quick access to the current shipment, quote, and billing state.':
      'Acceso rápido al estado actual de envío, cotización y facturación.',
    'Quote accepted': 'Cotización aceptada',
    'Quote count': 'Recuento de cotizaciones',
    'Quote message': 'Mensaje de cotización',
    'Quote rejected': 'Cotización rechazada',
    'Quote withdrawn': 'Cotización retirada',
    Quotes: 'Cotizaciones',
    'Quotes and questions': 'Citas y preguntas',
    'Quotes are disabled for this listing. The first partner to accept the fixed price will be assigned automatically.':
      'Las cotizaciones están deshabilitadas para este listado. El primer socio que acepte el precio fijo será asignado automáticamente.',
    'Quotes are disabled for this shipment. If you accept it, the client price becomes an accepted booking immediately.':
      'Las cotizaciones están deshabilitadas para este envío. Si lo aceptas, el precio del cliente se convierte inmediatamente en una reserva aceptada.',
    'Quotes from transport providers usually begin to appear shortly after publishing. Refresh to check again.':
      'Las cotizaciones de los proveedores de transporte suelen aparecer poco después de su publicación. Actualice para verificar nuevamente.',
    'Reference #{{id}}': 'Referencia #{{id}}',
    'Refresh listings': 'Actualizar listados',
    'Reject quote': 'Rechazar cotización',
    'Rejecting...': 'Rechazando...',
    Release: 'Lanzamiento',
    'Release Listing': 'Listado de versiones',
    'Remember assistant conversation':
      'Recuerda la conversación del asistente.',
    'Required for fixed-price listings. Partners accept this amount directly.':
      'Requerido para listados de precio fijo. Los socios aceptan esta cantidad directamente.',
    'Required. Partners will be able to accept this listing at the fixed client price without sending a quote.':
      'Requerido. Los socios podrán aceptar este listado al precio fijo del cliente sin enviar una cotización.',
    'Review submission failed.': 'Error al enviar la revisión.',
    'Review the completed transport using the standard product flow.':
      'Revisar el transporte completado utilizando el flujo de producto estándar.',
    'Route pending': 'Ruta pendiente',
    'Save changes': 'Guardar cambios',
    'Saving...': 'Guardando...',
    'Search by title, route, category, or item':
      'Buscar por título, ruta, categoría o artículo',
    'Search Results': 'Resultados de la búsqueda',
    'Search users by email...': 'Buscar usuarios por correo electrónico...',
    'Select a truck, driver, pickup date, and delivery date.':
      'Seleccione un camión, conductor, fecha de recogida y fecha de entrega.',
    'Select approved truck': 'Seleccionar camión homologado',
    'Select driver': 'Seleccionar conductor',
    'Send Revision': 'Enviar revisión',
    Sentiment: 'Sentimiento',
    'Share what went well and what could improve':
      'Comparte lo que salió bien y lo que podría mejorar',
    'Shipment in transit': 'Envío en tránsito',
    'Shipment notes': 'Notas de envío',
    'Shipment tracking will be shared':
      'El seguimiento del envío será compartido.',
    'Show AI launchers': 'Mostrar lanzadores de IA',
    'Show or hide AI assistant buttons on supported dashboard and listing pages.':
      'Muestre u oculte los botones del asistente de IA en el panel compatible y en las páginas de listado.',
    'Special needs or notes': 'Necesidades especiales o notas',
    'Specify delivery dates': 'Especificar fechas de entrega',
    'Specify pickup dates': 'Especificar fechas de recogida',
    Stage: 'etapa',
    'Status updated to {{status}}': 'Estado actualizado a {{status}}',
    'Stripe payment confirmed and booking updated':
      'Pago de Stripe confirmado y reserva actualizada.',
    'Stripe status: {{status}}': 'Estado de la raya: {{status}}',
    'Submit question': 'Enviar pregunta',
    'Submit review': 'Enviar reseña',
    'Submitting...': 'Enviando...',
    'The AI assistant is currently disabled for this environment. Existing local session data can still be cleared here.':
      'El asistente de IA está actualmente deshabilitado para este entorno. Los datos de la sesión local existentes aún se pueden borrar aquí.',
    'The listing expired before a transport was confirmed.':
      'El listado expiró antes de que se confirmara el transporte.',
    'The listing has been fully completed and archived as a finished transport.':
      'El listado ha sido completamente completado y archivado como transporte terminado.',
    'The lowest net price you would still accept for this shipment.':
      'El precio neto más bajo que aún aceptaría para este envío.',
    'The partner has confirmed the route plan. Pickup and delivery dates are now scheduled.':
      'El socio ha confirmado el plan de ruta. Las fechas de recogida y entrega ya están programadas.',
    'The partner marked the shipment as delivered. Review the final documents and confirm completion.':
      'El socio marcó el envío como entregado. Revise los documentos finales y confirme su finalización.',
    'The partner-confirmed plan and LOA stay grouped together for faster review.':
      'El plan confirmado por el socio y la LOA permanecen agrupados para una revisión más rápida.',
    'This action notifies the transport provider and removes the quote from active consideration.':
      'Esta acción notifica al proveedor de transporte y elimina la cotización de la consideración activa.',
    'This listing is archived and no further transport actions are available.':
      'Este listado está archivado y no hay más acciones de transporte disponibles.',
    'This listing needs an accepted quote before a review can be created.':
      'Este listado necesita una cotización aceptada antes de que se pueda crear una revisión.',
    'This will soft-cancel the listing and move it to your archive.':
      'Esto cancelará suavemente el listado y lo moverá a su archivo.',
    'This will soft-cancel the listing for the client and remove it from active marketplace views.':
      'Esto cancelará suavemente el listado del cliente y lo eliminará de las vistas activas del mercado.',
    'Total quote': 'cotización total',
    'Tracking not promised': 'Seguimiento no prometido',
    'Tracking shared': 'Seguimiento compartido',
    'Tracking visibility': 'Visibilidad de seguimiento',
    'Trailer (Optional)': 'Remolque (opcional)',
    'Translation preference updated': 'Preferencia de traducción actualizada',
    'Transport completed': 'Transporte completado',
    'Transport completed.': 'Transporte completado.',
    'Transport documents': 'Documentos de transporte',
    'Transport marked as complete': 'Transporte marcado como completo',
    'Transport package': 'Paquete de transporte',
    'Transport plan confirmed': 'Plan de transporte confirmado',
    'Transport plan updated': 'Plan de transporte actualizado',
    'Transport planned': 'Transporte previsto',
    'Transport Provider': 'Proveedor de transporte',
    'Transport providers can review your shipment and send offers.':
      'Los proveedores de transporte pueden revisar su envío y enviar ofertas.',
    'Transport stage': 'Etapa de transporte',
    Truck: 'camión',
    'Truck, driver, trailer, and planned dates for this shipment.':
      'Camión, conductor, remolque y fechas previstas para este envío.',
    'Try widening the current listing filters.':
      'Intente ampliar los filtros de listado actuales.',
    'Unable to upload listing images.':
      'No se pueden cargar imágenes de listado.',
    'Unknown error': 'Error desconocido',
    'Untitled listing': 'Listado sin título',
    'Untitled Listing': 'Listado sin título',
    'Update media': 'Actualizar medios',
    'Update transport plan': 'Actualizar plan de transporte',
    'Update Transport Plan': 'Actualizar Plan de Transporte',
    'Upload a CMR or delivery photos before marking delivered.':
      'Cargue un CMR o fotografías de entrega antes de marcar la entrega.',
    'Upload a CMR or delivery photos before the listing can move to Delivered.':
      'Cargue un CMR o fotografías de entrega antes de que el listado pueda pasar a Entregado.',
    'Upload at least one pickup proof before the listing can move to Picked Up.':
      'Cargue al menos un comprobante de recogida antes de que el anuncio pueda pasar a Recogido.',
    'Upload final documents': 'Subir documentos finales',
    'Upload proof of pickup': 'Subir comprobante de recogida',
    'Uploading...': 'Subiendo...',
    'Use fresh photos when the shipment changes or you want to clarify the item condition.':
      'Utilice fotografías nuevas cuando cambie el envío o desee aclarar el estado del artículo.',
    'users enabled': 'usuarios habilitados',
    'Visible to you while quoting. You can still send your own net offer below or above this amount.':
      'Visible para usted mientras cotiza. Aún puedes enviar tu propia oferta neta por debajo o por encima de esta cantidad.',
    'Waiting for partner acceptance': 'Esperando la aceptación del socio',
    'Waiting for transport planning':
      'A la espera de la planificación del transporte.',
    'When enabled, messages from other users will be automatically translated to your preferred language.':
      'Cuando esté habilitado, los mensajes de otros usuarios se traducirán automáticamente a su idioma preferido.',
    Withdraw: 'Retirar',
    'Write Review': 'Escribir reseña',
    'You are about to release this listing back to the marketplace.':
      'Está a punto de publicar este listado nuevamente en el mercado.',
    'You are now the assigned partner for this fixed-price listing.':
      'Ahora eres el socio asignado para este anuncio de precio fijo.',
    'Your quote has been accepted. Awaiting payment confirmation from the admin before you can begin the job.':
      'Su cotización ha sido aceptada. Esperando la confirmación del pago por parte del administrador antes de poder comenzar el trabajo.',
    'VIN: {{vin}}': 'Número de bastidor: {{vin}}',
    'Material: {{type}}': 'Material: {{type}}',
    'L cm': 'largo cm',
    'H cm': 'altura cm',
  },
  fi: {
    to: 'to',
    Su: 'Su',
    kg: 'kg',
    Hatchback: 'Viistoperä',
    Coupé: 'Coupé',
    Superauto: 'Superauto',
    Sedan: 'Sedan',
    Crossover: 'Crossover',
    Required: 'Pakollinen',
    'Change language': 'Vaihda kieli',
    'Loading...': 'Ladataan…',
    'Error:': 'Virhe:',
    Close: 'Sulje',
    Yes: 'Kyllä',
    No: 'Ei',
    'Keep order': 'Pidä järjestys',
    Price: 'Hinta',
    'Purchase terms': 'Ostoehdot',
    'Power of attorney': 'Valtakirja',
    'Transport details': 'Kuljetustiedot',
    'Upload damages': 'Lataa vahingot',
    'Download (PDF)': 'Lataa (PDF)',
    'Mark as picked up': 'Merkitse noudetuksi',
    'Mark as delivered': 'Merkitse toimitetuksi',
    'Cancel booking': 'Peruuta varaus',
    'Order marked as picked up': 'Tilaus merkitty noudetuksi',
    'Order marked as delivered': 'Tilaus merkitty toimitetuksi',
    'Order canceled': 'Tilaus peruutettu',
    'Failed to cancel order': 'Tilauksen peruuttaminen epäonnistui',
    'Added {{count}} file(s)': 'Lisätty {{count}}-tiedosto(t)',
    Pages: 'Sivut',
    'Awaiting Verification': 'Odottaa vahvistusta',
    'Profile Incomplete': 'Profiili keskeneräinen',
    'Please complete your profile information (Company, Phone, Address, City, Post Code) to access all features.':
      'Täytä profiilitietosi (yritys, puhelinnumero, osoite, kaupunki, postinumero) päästäksesi kaikkiin ominaisuuksiin.',
    'Go to Profile': 'Siirry Profiiliin',
    'Forgot Password': 'Salasana unohtunut',
    Hello: 'Hei',
    friend: 'ystävä',
    'Book your transport': 'Varaa kuljetus',
    'fast and easy': 'nopeaa ja helppoa',
    'Keep an eye on the route and quote at a glance.':
      'Pidä reittiä silmällä ja lainaa yhdellä silmäyksellä.',
    'VIP price': 'VIP hinta',
    Origin: 'Alkuperä',
    Destination: 'Kohde',
    'Postal code': 'postinumero',
    'Calculate to preview': 'Laske esikatselua varten',
    "Can't be calculated yet": 'Ei voi vielä laskea',
    'Awaiting payment badge': 'Odottaa maksua',
    'Ref {{id}}': 'Viite {{id}}',
    'Change planning': 'Muuta suunnittelua',
    'Change driver': 'Vaihda kuljettaja',
    'No vehicles listed': 'Ei luettelossa olevia ajoneuvoja',
    'Order not found.': 'Tilausta ei löydy.',
    'Not available': 'Ei saatavilla',
    'For {{date}}': 'Mallille {{date}}',
    'Picked on {{date}}': 'Valittu malliin {{date}}',
    'Delivered on {{date}}': 'Toimitetaan mallilla {{date}}',
    'Loading notification: {{value}}': 'Latausilmoitus: {{value}}',
    'CO₂ compensation: {{value}}': 'CO₂-kompensointi: {{value}}',
    'Bio fuel: {{value}}': 'Biopolttoaine: {{value}}',
    Remove: 'Poista',
    'Copy {{label}}': 'Kopioi {{label}}',
    'Open navigation menu': 'Avaa navigointivalikko',
    'Open menu': 'Avaa valikko',
    'Error fetching data': 'Virhe haettaessa tietoja',
    'Not set': 'Ei asetettu',
    'No opening hours provided': 'Aukioloaikoja ei ole ilmoitettu',
    'Please select a planned date': 'Valitse suunniteltu päivämäärä',
    'Saved favorite route filter': 'Suosikkireittisuodatin tallennettu',
    km: 'km',
    mi: 'mi',
    'Radius search': 'Säteen haku',
    'City or town': 'Kaupunki tai kylä',
    'Country (optional)': 'Maa (valinnainen)',
    Radius: 'Säde',
    'Searching…': 'Haetaan…',
    'City not found': 'Kaupunkia ei löydy',
    'Within {{radius}} {{unit}} of {{place}}':
      '{{radius}} {{unit}} ja {{place}} sisällä',
    'Clear radius': 'Selkeä säde',
    'auth.account_status_pending_review': 'Tilin tila: Odottaa tarkistusta',
    'auth.your_account_is_pending_approval': 'Tilisi odottaa hyväksyntää',
    'auth.upload_your_verification_documents_below_and_we_ll_notify_you_by_email_once_your_account_is_approved':
      'Lähetä vahvistusasiakirjasi alle, niin ilmoitamme sinulle sähköpostitse, kun tilisi on hyväksytty.',
    'auth.check_status': 'Tarkista tila',
    'auth.upload_verification_documents': 'Lataa vahvistusasiakirjat',
    'auth.your_uploaded_documents': 'Lähettämäsi asiakirjat',
    'auth.back_to_sign_in': 'Takaisin kirjautumaan sisään',
    'Q1 2025': 'Q1 2025',
    'Q2 2025': 'Q2 2025',
    'Q3 2025': 'Q3 2025',
    Albania: 'Albania',
    Andorra: 'Andorra',
    Armenia: 'Armenia',
    Bulgaria: 'Bulgaria',
    Georgia: 'Georgia',
    Kosovo: 'Kosovo',
    Latvia: 'Latvia',
    Liechtenstein: 'Liechtenstein',
    Malta: 'Malta',
    Moldova: 'Moldova',
    Monaco: 'Monaco',
    Montenegro: 'Montenegro',
    Romania: 'Romania',
    'San Marino': 'San Marino',
    Serbia: 'Serbia',
    Slovakia: 'Slovakia',
    Slovenia: 'Slovenia',
    'BodyType.Coupe': 'Coupé',
    'BodyType.Sedan': 'Sedan',
    'BodyType.Crossover': 'Crossover',
    'BodyType.Pickup': 'Nouto',
    StartPoint: 'Aloita',
    EndPoint: 'Loppu',
    'Error loading documents': 'Virhe ladattaessa asiakirjoja',
    'Are you sure you want to delete this document?':
      'Haluatko varmasti poistaa tämän asiakirjan?',
    'Document deleted': 'Asiakirja poistettu',
    'Failed to delete': 'Poistaminen epäonnistui',
    'Failed to get download link': 'Latauslinkin hakeminen epäonnistui',
    'Status updated': 'Tila päivitetty',
    'Update failed': 'Päivitys epäonnistui',
    'Email cannot be changed.': 'Sähköpostiosoitetta ei voi muuttaa.',
    'No documents found.': 'Asiakirjoja ei löytynyt.',
    'Invoice #': 'Lasku nro',
    'File Name': 'Tiedoston nimi',
    Amount: 'Summa',
    Actions: 'Toiminnot',
    Download: 'Lataa',
    'Mark Unpaid': 'Merkitse maksamattomaksi',
    'Mark Paid': 'Mark Maksettu',
    'Please save the record before uploading documents.':
      'Tallenna tietue ennen asiakirjojen lataamista.',
    'Select a file before uploading.': 'Valitse tiedosto ennen lataamista.',
    'Please enter an invoice number.': 'Anna laskun numero.',
    'Upload successful': 'Lataus onnistui',
    '{{count}} file(s) uploaded successfully.':
      '{{count}}-tiedosto(t) lähetetty onnistuneesti.',
    'Upload failed': 'Lataus epäonnistui',
    'Unable to upload the document.': 'Asiakirjaa ei voi ladata.',
    'Invoice Number': 'Laskun numero',
    'Selected files:': 'Valitut tiedostot:',
    Upload: 'Lataa',
    'Save this record before uploading documents.':
      'Tallenna tämä tietue ennen asiakirjojen lataamista.',
    'Error approving user': 'Virhe käyttäjän hyväksymisessä',
    'Error rejecting user': 'Virhe käyttäjän hylkäämisessä',
    'Error disabling user': 'Virhe poistettaessa käyttäjää käytöstä',
    'User marked as VIP': 'Käyttäjä merkitty VIP:ksi',
    'User unmarked as VIP': 'Käyttäjän VIP-merkintä poistettu',
    'Error marking user as VIP': 'Virhe merkittäessä käyttäjää VIP-jäseneksi',
    'Error unmarking user as VIP':
      'Virhe poistettaessa käyttäjän VIP-merkintää',
    'Failed to approve user': 'Käyttäjän hyväksyminen epäonnistui',
    'Failed to reject user': 'Käyttäjän hylkääminen epäonnistui',
    'Failed to disable user': 'Käyttäjän poistaminen käytöstä epäonnistui',
    'Failed to unmark user as VIP':
      'Käyttäjän VIP-merkinnän poistaminen epäonnistui',
    'Failed to mark user as VIP': 'Käyttäjän merkitseminen VIP:ksi epäonnistui',
    'Invoice Management': 'Laskujen hallinta',
    'All Invoices': 'Kaikki laskut',
    'Manage all invoices uploaded by partners.':
      'Hallinnoi kaikkia kumppanien lähettämiä laskuja.',
    'An unexpected error occurred. Please try again.':
      'Tapahtui odottamaton virhe. Yritä uudelleen.',
    'The email address is not valid.': 'Sähköpostiosoite ei kelpaa.',
    'This account has been disabled.': 'Tämä tili on poistettu käytöstä.',
    'No account found with this email.':
      'Tällä sähköpostilla ei löytynyt tiliä.',
    'Incorrect password. Please try again.': 'Väärä salasana. Yritä uudelleen.',
    'Invalid email or password. Please check your credentials and try again.':
      'Virheellinen sähköpostiosoite tai salasana. Tarkista kirjautumistietosi ja yritä uudelleen.',
    'Too many failed attempts. Please try again later or reset your password.':
      'Liian monta epäonnistunutta yritystä. Yritä myöhemmin uudelleen tai vaihda salasanasi.',
    'Network error. Check your connection and try again.':
      'Verkkovirhe. Tarkista yhteys ja yritä uudelleen.',
    'A verification email has been sent to your email address. Please verify your email before logging in.':
      'Sähköpostiosoitteeseesi on lähetetty vahvistussähköposti. Vahvista sähköpostiosoitteesi ennen kirjautumista.',
    'Please make sure both passwords are the same.':
      'Varmista, että molemmat salasanat ovat samat.',
    'Verification email resent!': 'Vahvistussähköposti lähetetty uudelleen!',
    'Please check your inbox.': 'Tarkista postilaatikkosi.',
    'You need to log in first': 'Sinun on ensin kirjauduttava sisään',
    'Please sign in to resend the verification email.':
      'Kirjaudu sisään lähettääksesi vahvistussähköpostin uudelleen.',
    'Failed to resend email': 'Sähköpostin uudelleenlähetys epäonnistui',
    'Resend verification email': 'Lähetä vahvistussähköposti uudelleen',
    'Show password': 'Näytä salasana',
    'Hide password': 'Piilota salasana',
    'Awaiting verification artwork': 'Odottaa vahvistusta taidetta',
    'Account status: Pending review': 'Tilin tila: Odottaa tarkistusta',
    'Your account is pending approval': 'Tilisi odottaa hyväksyntää',
    "Upload your verification documents below and we'll notify you by email once your account is approved.":
      'Lähetä vahvistusasiakirjasi alle, niin ilmoitamme sinulle sähköpostitse, kun tilisi on hyväksytty.',
    'Check status': 'Tarkista tila',
    'Upload verification documents': 'Lataa vahvistusasiakirjat',
    'Your uploaded documents': 'Lähettämäsi asiakirjat',
    'Back to sign in': 'Takaisin kirjautumaan sisään',
    'Hide documents': 'Piilota asiakirjat',
    'Email verification required': 'Sähköpostivahvistus vaaditaan',
    'Waiting for email verification': 'Odotetaan sähköpostin vahvistusta',
    'Check your email': 'Tarkista sähköpostisi',
    'We sent your verification link to':
      'Lähetimme vahvistuslinkin osoitteeseen',
    "Didn't receive it? Check your spam folder or try again.":
      'Etkö saanut sitä? Tarkista roskapostikansiosi tai yritä uudelleen.',
    'Resend email': 'Lähetä sähköposti uudelleen',
    "I've verified my email": 'Olen vahvistanut sähköpostini',
    'Redirecting you now.': 'Sinut uudelleenohjataan nyt.',
    'Email not verified yet': 'Sähköpostiosoitetta ei ole vielä vahvistettu',
    'Please click the link in your inbox and try again.':
      'Napsauta postilaatikossasi olevaa linkkiä ja yritä uudelleen.',
    'Unable to resend verification email right now.':
      'Vahvistussähköpostia ei voi lähettää uudelleen juuri nyt.',
    'Unable to check verification status right now.':
      'Vahvistuksen tilaa ei voi tarkistaa juuri nyt.',
    "We've sent a new verification link to your email address.":
      'Olemme lähettäneet uuden vahvistuslinkin sähköpostiosoitteeseesi.',
    'We automatically check your verification status every 30 seconds. You can also trigger an instant check after verifying your email.':
      'Tarkistamme vahvistuksen tilan automaattisesti 30 sekunnin välein. Voit myös käynnistää välittömän tarkistuksen sähköpostisi vahvistamisen jälkeen.',
    'We automatically check your verification status every 15 seconds. You can also trigger an instant check after verifying your email.':
      'Tarkistamme vahvistuksen tilan automaattisesti 15 sekunnin välein. Voit myös käynnistää välittömän tarkistuksen sähköpostisi vahvistamisen jälkeen.',
    'Inputs changed. Recalculate the price.':
      'Sisääntulot muutettu. Laske hinta uudelleen.',
    'My Invoices': 'Omat laskut',
    'Upload New Invoice': 'Lataa uusi lasku',
    'Please enter the invoice number and upload the invoice document. It will be reviewed by an administrator.':
      'Syötä laskun numero ja lataa laskutosite. Järjestelmänvalvoja tarkistaa sen.',
    'Invoice History': 'Laskuhistoria',
    'Client ref · {{clientRef}}': 'Asiakasviite · {{clientRef}}',
    'Order Documents': 'Tilaa asiakirjoja',
    'Upload Proof of Pickup': 'Lataa noutotodistus',
    'Status will be updated to Picked Up after successful upload.':
      'Tilaksi päivitetään Noudettu onnistuneen latauksen jälkeen.',
    'Upload Proof of Delivery': 'Lataa toimitustodistus',
    'Status will be updated to Delivered after successful upload.':
      'Tilaksi päivitetään Toimitettu onnistuneen latauksen jälkeen.',
    'Enter first name': 'Anna etunimi',
    'Enter last name': 'Kirjoita sukunimi',
    'Enter phone number': 'Anna puhelinnumero',
    'Driver updated.': 'Ajuri päivitetty.',
    'The driver has been successfully updated.':
      'Ohjain on päivitetty onnistuneesti.',
    'Driver added.': 'Kuljettaja lisätty.',
    'The new driver has been successfully added.':
      'Uusi ohjain on lisätty onnistuneesti.',
    'Driver deleted.': 'Kuljettaja poistettu.',
    'The driver has been successfully deleted.':
      'Ohjaimen poistaminen onnistui.',
    'Trailer updated.': 'Traileri päivitetty.',
    'The trailer has been successfully updated.':
      'Traileri on päivitetty onnistuneesti.',
    'Trailer added.': 'Traileri lisätty.',
    'The new trailer has been successfully added.':
      'Uusi traileri on lisätty onnistuneesti.',
    'Trailer deleted.': 'Traileri poistettu.',
    'The trailer has been successfully deleted.':
      'Traileri on poistettu onnistuneesti.',
    'User account not found. Please complete registration.':
      'Käyttäjätiliä ei löydy. Suorita rekisteröinti loppuun.',
    'No token provided': 'Tunnusta ei ole annettu',
    'Token expired': 'Tunnus on vanhentunut',
    'Token revoked': 'Tunnus peruutettu',
    'Invalid ID token': 'Virheellinen tunnus',
    Unauthorized: 'Luvaton',
    'Unauthorized: User not authenticated.':
      'Luvaton: Käyttäjää ei ole todennettu.',
    'Unauthorized: User role not found.': 'Luvaton: Käyttäjäroolia ei löydy.',
    'Forbidden: Your role is not allowed to perform this action.':
      'Kielletty: Roolisi ei saa suorittaa tätä toimintoa.',
    'Forbidden: This action requires a partner role.':
      'Kielletty: Tämä toiminto vaatii kumppaniroolin.',
    'Forbidden: This action requires a client role.':
      'Kielletty: Tämä toiminto vaatii asiakasroolin.',
    'Forbidden: This action requires an admin role.':
      'Kielletty: Tämä toiminto vaatii järjestelmänvalvojan roolin.',
    'This user has not been approved': 'Tätä käyttäjää ei ole hyväksytty',
    'User email has not been verified':
      'Käyttäjän sähköpostiosoitetta ei ole vahvistettu',
    'User account has been disabled': 'Käyttäjätili on poistettu käytöstä',
    'Booking not found': 'Varausta ei löytynyt',
    'Route not found': 'Reittiä ei löydy',
    'Pickup location (country and postalCode) is required':
      'Noutopaikka (maa ja postinumero) vaaditaan',
    'Delivery location (country and postalCode) is required':
      'Toimituspaikka (maa ja postinumero) vaaditaan',
    'Unable to calculate route. Please check the locations and try again.':
      'Reittiä ei voi laskea. Tarkista sijainnit ja yritä uudelleen.',
    'Error calculating transport price': 'Virhe laskettaessa kuljetushintaa',
    'Booking canceled successfully': 'Varaus peruutettu onnistuneesti',
    'Invalid request.': 'Virheellinen pyyntö.',
    'Access denied.': 'Käyttö estetty.',
    'Resource not found.': 'Resurssia ei löydy.',
    'Request conflict.': 'Pyydä ristiriitaa.',
    'Invalid data provided.': 'Virheelliset tiedot.',
    'Too many requests. Please try again later.':
      'Liikaa pyyntöjä. Yritä myöhemmin uudelleen.',
    'Internal server error. Please try again later.':
      'Sisäinen palvelinvirhe. Yritä myöhemmin uudelleen.',
    'Service temporarily unavailable.': 'Palvelu tilapäisesti poissa käytöstä.',
    'booking.load_preset': 'Lataa esiasetus',
    'booking.save_preset_tooltip':
      'Tallenna nykyiset suodattimet pikakäyttöasetuksiksi',
    'booking.load_preset_tooltip': 'Lataa tallennettu suodattimen esiasetus',
    'booking.preset_saved': 'Esiasetus tallennettu',
    'booking.preset_saved_desc': 'Suodattimen esiasetus on tallennettu.',
    'booking.preset_loaded': 'Esiasetus ladattu',
    'booking.preset_load_error': 'Esiasetuksen lataaminen epäonnistui',
    'booking.no_preset_saved': 'Esiasetuksia ei ole vielä tallennettu',
    'booking.date_from': 'Päivämäärä alkaen',
    'booking.date_to': 'Päivämäärä',
    'Active filters': 'Aktiiviset suodattimet',
    'All booking states': 'Kaikki varaustilat',
    'All partners': 'Kaikki yhteistyökumppanit',
    'All payments': 'Kaikki maksut',
    'All roles': 'Kaikki roolit',
    'All statuses': 'Kaikki tilat',
    'All Users': 'Kaikki käyttäjät',
    'Are you sure you want to cancel booking {{id}}?':
      'Haluatko varmasti peruuttaa varauksen {{id}}?',
    'Attach the CMR Insurance before finishing truck setup.':
      'Liitä CMR-lasku ennen kuorma-auton asennuksen viimeistelyä.',
    Awaiting: 'Odotetaan',
    'Awaiting payout': 'Odottaa maksua',
    'Booking canceled': 'Varaus peruttu',
    'Booking marked as paid': 'Varaus merkitty maksetuksi',
    'Booking released and returned to marketplace':
      'Varaus purettu ja palautettu torille',
    'booking.allowed_range': 'Sallittu alue',
    'booking.assign_transport': 'Määritä kuljetus',
    'booking.back': 'Takaisin',
    'booking.back_to_summary': 'Takaisin yhteenvetoon',
    'booking.booking_created_but_pickup_document_not_uploaded_upload_from_order_details':
      'Varaus luotiin, mutta noutoasiakirjaa ei ladattu. Voit ladata sen tilaustiedoista.',
    'booking.city_not_found': 'Kaupunkia ei löydy',
    'booking.city_or_town': 'Kaupunki tai kylä',
    'booking.clear_radius': 'Selkeä säde',
    'booking.continue': 'Jatka',
    'booking.country_optional': 'Maa (valinnainen)',
    'booking.delivery_constraint_info':
      'Toimituspäivän tulee olla noutopäivänä tai sen jälkeen.',
    'booking.delivery_date_cannot_be_earlier_than_pickup_date':
      'Toimituspäivä ei voi olla aikaisempi kuin noutopäivä',
    'booking.driver': 'Kuljettaja',
    'booking.failed_to_open_letter_of_attorney':
      'Valtuutuksen avaaminen epäonnistui',
    'booking.go_to_order': 'Siirry kohtaan Tilaa',
    'booking.i_accept_terms': 'Hyväksyn ehdot',
    'booking.invalid_license_plate_or_vin_length':
      'Virheellinen rekisterikilven tai VIN-numeron pituus.',
    'booking.invalid_vin_format_i_o_q_not_allowed':
      'Virheellinen VIN-muoto. Merkit I, O ja Q eivät ole sallittuja.',
    'booking.letter_of_attorney_file_is_empty': 'Valtakirjatiedosto on tyhjä',
    'booking.no_additional_details': 'Ei lisätietoja',
    'booking.no_vehicle_info': 'Ei tietoja ajoneuvosta',
    'booking.open_letter_of_attorney': 'Avoin valtakirja',
    'booking.opening_letter_of_attorney': 'Avausvaltakirja...',
    'booking.order_accepted_successfully': 'Tilaus vastaanotettu onnistuneesti',
    'booking.order_cars_exceed_selected_truck_capacity':
      'Tässä tilauksessa on {{orderCars}}-autoja, mutta valittu kuorma-auton kapasiteetti on {{capacity}}.',
    'booking.pickup_constraint_info':
      'Noutopäivä vaaditaan ennen kuljetuksen määräämistä.',
    'booking.pickup_document_upload_failed':
      'Noutoasiakirjan lataus epäonnistui',
    'booking.preparing_secure_document_preview':
      'Valmistellaan suojattua asiakirjan esikatselua...',
    'booking.radius_km': 'Säde (km)',
    'booking.radius_search': 'Säteen haku',
    'booking.route_and_details': 'Reitti ja yksityiskohdat',
    'booking.schedule': 'Aikataulu',
    'booking.searching': 'Haetaan…',
    'booking.select_pickup_and_delivery': 'Valitse nouto ja toimitus',
    'booking.select_pickup_and_delivery_dates_before_confirming':
      'Valitse nouto- ja toimituspäivät ennen vahvistamista',
    'booking.select_pickup_date': 'Valitse noutopäivä',
    'booking.select_truck_driver_and_trailer':
      'Valitse kuorma-auto, kuljettaja ja perävaunu',
    'booking.supported_formats_jpg_png_pdf_doc_docx':
      'Tuetut tiedostomuodot: JPG, PNG, PDF, DOC, DOCX',
    'booking.terms_and_conditions': 'Ehdot',
    'booking.terms_text': 'Vahvistan kuljetusehdot ja vastuuehdot.',
    'booking.track_shipment': 'Seuraa lähetystä',
    'booking.trailer': 'Traileri',
    'booking.transport_details': 'Kuljetustiedot',
    'booking.truck': 'Kuorma-auto',
    'booking.truck_driver_planning_saved_letter_of_attorney_available':
      'Kuorma-auton, kuljettajan ja suunnittelupäivät tallennettiin. Valtakirja on nyt saatavilla.',
    'booking.unexpected_error': 'Odottamaton virhe',
    'booking.vehicles_plural': 'Ajoneuvot',
    'booking.view_details': 'Näytä tiedot',
    'booking.vip_price_must_be_between_min_max_50_to_150_percent_of_estimated_price':
      'VIP-hinnan on oltava välillä {{min}} EUR ja {{max}} EUR (50–150 % arvioidusta hinnasta).',
    'booking.vip_price_must_be_positive_number':
      'VIP-hinnan on oltava positiivinen luku.',
    'booking.within_radius_km_of_place':
      '{{radius}} km:n säteellä kohteesta {{place}}',
    Capacity: 'Kapasiteetti',
    'Car Capacity': 'Auton kapasiteetti',
    'Car capacity is required.': 'Auton kapasiteetti vaaditaan.',
    cars: 'autoja',
    Changed: 'Muutettu',
    'CMR Document': 'CMR-asiakirja',
    'CMR expiry': 'CMR voimassaolon päättyminen',
    'CMR Expiry': 'CMR voimassaolon päättyminen',
    'CMR expiry date is required': 'CMR:n viimeinen käyttöpäivä vaaditaan',
    'CMR Insurance': 'CMR vakuutus',
    'CMR insurance expiry date': 'CMR-vakuutuksen päättymispäivä',
    'CMR Insurance Expiry Date': 'CMR-vakuutuksen päättymispäivä',
    'CMR insurance has expired. Upload a new CMR Insurance for review.':
      'Lataa uusi CMR-lasku tarkistettavaksi.',
    'CMR insurance is expiring within 14 days.':
      'CMR-vakuutus vanhenee 14 päivän sisällä.',
    'CMR Insurance required': 'CMR-lasku vaaditaan',
    Company: 'Yritys',
    'Copy order ID': 'Kopioi tilaustunnus',
    Created: 'Luotu',
    'Current expiry': 'Nykyinen voimassaoloaika',
    'Date range': 'Ajanjakso',
    days: 'päivää',
    Delay: 'Viive',
    'Delivered + partner invoice uploaded + unpaid':
      'Toimitettu + kumppanin lasku ladattu + maksamaton',
    Document: 'Asiakirja',
    'Documents uploaded': 'Asiakirjat ladattu',
    Done: 'Valmis',
    'Download Client Invoice #{{id}}': 'Lataa asiakaslasku #{{id}}',
    'Download Invoice': 'Lataa lasku',
    'Enter a valid capacity between 1 and 20 cars.':
      'Anna kelvollinen kapasiteetti 1–20 autoa.',
    'Enter license plate': 'Syötä rekisterikilpi',
    'Enter plate and upload CMR to add truck':
      'Syötä kilpi ja lataa CMR lisätäksesi kuorma-auton',
    'Error fetching users': 'Virhe haettaessa käyttäjiä',
    'Expire Soon (14 days)': 'Vanhenee pian (14 päivää)',
    'Explain why this CMR was rejected': 'Selitä, miksi tämä CMR hylättiin',
    'Failed to copy order ID': 'Tilaustunnuksen kopioiminen epäonnistui',
    'Failed to download invoice': 'Laskun lataaminen epäonnistui',
    'Failed to download proforma invoice':
      'Proforma-laskun lataaminen epäonnistui',
    'Failed to generate invoice': 'Laskun luominen epäonnistui',
    'Failed to load invoice summary':
      'Laskun yhteenvedon lataaminen epäonnistui',
    'Failed to load letter of attorney': 'Valtakirjan lataaminen epäonnistui',
    'Failed to open letter of attorney': 'Valtuutuksen avaaminen epäonnistui',
    'Failed to release booking': 'Varauksen vapauttaminen epäonnistui',
    'Fleet data refreshed': 'Laivaston tiedot päivitetty',
    'Generate Client Invoice': 'Luo asiakaslasku',
    'Generate Invoice': 'Luo lasku',
    'Generated at': 'Luotu klo',
    'How many cars can this truck carry?':
      'Kuinka monta autoa tämä kuorma-auto voi kuljettaa?',
    'In progress': 'Käynnissä',
    Invoice: 'Lasku',
    'Invoice generated': 'Lasku luotu',
    'Invoice generated successfully': 'Laskun luominen onnistui',
    'Invoice uploaded': 'Lasku ladattu',
    'Invoices uploaded by partners for platform payout processing. Client invoices are generated in each order view.':
      'Asiakkaan laskut luodaan jokaisessa tilausnäkymässä.',
    'Keep booking': 'Jatka varausta',
    'Keep your active drivers and contact details up to date.':
      'Pidä aktiiviset kuljettajasi ja yhteystietosi ajan tasalla.',
    'Last Rejection': 'Viimeinen hylkääminen',
    'Last rejection reason': 'Viimeinen hylkäämisen syy',
    'Letter of Attorney': 'Asianajokirja',
    'Letter of attorney file is empty': 'Valtakirjatiedosto on tyhjä',
    'License plate cannot be changed after creation. Re-upload CMR Insurance instead.':
      'Lataa sen sijaan CMR-lasku uudelleen.',
    'License plate is required.': 'Rekisterikilpi vaaditaan.',
    'Manage large order volumes with search, payment actions, and invoice workflows.':
      'Hallitse suuria tilausmääriä haun, maksutoimintojen ja laskujen työnkulkujen avulla.',
    'Manage license plates and keep CMR Insurances approved and valid.':
      'Hallinnoi rekisterikilpiä ja pidä CMR-laskut hyväksyttyinä ja voimassa.',
    'Manage status updates, documents, and payment steps from one place.':
      'Hallitse tilapäivityksiä, asiakirjoja ja maksuvaiheita yhdestä paikasta.',
    'Manage trailer plate records and keep availability current.':
      'Hallinnoi perävaunukilpien tietueita ja pidä saatavuus ajan tasalla.',
    'Mark booking {{id}} as paid?': 'Merkitäänkö varaus {{id}} maksetuksi?',
    Missing: 'Puuttuu',
    'Needs attention': 'Vaatii huomiota',
    'New (14 days)': 'Uusi (14 päivää)',
    'No bookings found for the current filters.':
      'Varauksia ei löytynyt nykyisille suodattimille.',
    'No confirmed CMR document uploaded yet.':
      'Vahvistettua CMR-asiakirjaa ei ole vielä ladattu.',
    'No driver assigned': 'Ei määritettyä kuljettajaa',
    'No letter of attorney has been generated yet.':
      'Valtakirjaa ei ole vielä laadittu.',
    'No matching delivered orders': 'Ei vastaavia toimitettuja tilauksia',
    'No new notifications': 'Ei uusia ilmoituksia',
    'No partners found.': 'Kumppaneita ei löytynyt.',
    'No trucks found for this filter.':
      'Tälle suodattimelle ei löytynyt kuorma-autoja.',
    'No users found for current filters.':
      'Käyttäjiä ei löytynyt nykyisille suodattimille.',
    'Not uploaded': 'Ei ladattu',
    Notifications: 'Ilmoitukset',
    of: '/',
    'Only admins can set or update this expiry date after reviewing your CMR insurance.':
      'Vain järjestelmänvalvojat voivat asettaa tai päivittää tämän päättymispäivän tarkistettuaan CMR-vakuutuksesi.',
    'Open letter of attorney': 'Avoin valtakirja',
    Order: 'Tilaa',
    'Order actions': 'Tilaa toiminnot',
    'Order ID copied': 'Tilaustunnus kopioitu',
    Owner: 'Omistaja',
    Page: 'Sivu',
    'Paid date': 'Maksupäivä',
    'Partner delivery date': 'Yhteistyökumppanin toimituspäivä',
    'Partner documents': 'Kumppaniasiakirjat',
    'Partner Invoice': 'Yhteistyökumppanin lasku',
    'Partner invoice uploaded': 'Kumppanin lasku ladattu',
    'Partner Payout Invoices': 'Kumppanin maksulaskut',
    'Partner pickup date': 'Kumppanin noutopäivä',
    'Partner score': 'Kumppanin pisteet',
    Payment: 'Maksu',
    'Payout date': 'Maksupäivä',
    'penalties applied': 'sovelletut rangaistukset',
    'Pending admin review': 'Odottaa järjestelmänvalvojan tarkistusta',
    'Pending review': 'Odottaa tarkistusta',
    'Pending trucks': 'Odottavat kuorma-autot',
    'Please provide a clear reason for rejection.':
      'Anna selkeä syy hylkäämiselle.',
    'Please select an order before uploading an invoice.':
      'Valitse tilaus ennen laskun lataamista.',
    'Please try again.': 'Yritä uudelleen.',
    'Proforma Invoice': 'Proforma lasku',
    'Provide a rejection reason for this CMR review.':
      'Ilmoita tämän CMR-arvioinnin hylkäämisen syy.',
    'Quarter Score': 'Neljännespisteet',
    'Re-upload CMR': 'Lataa CMR uudelleen',
    Refresh: 'Päivitä',
    'Rejection reason': 'Hylkäämisen syy',
    'Rejection reason is required': 'Hylkäämisen syy vaaditaan',
    'Release booking {{id}} back to the marketplace so another partner can accept it?':
      'Vapautetaanko varaus {{id}} takaisin kauppapaikalle, jotta toinen kumppani voi hyväksyä sen?',
    Reset: 'Nollaa',
    'Review Bookings': 'Tarkista varaukset',
    Revision: 'Tarkistus',
    Rows: 'Rivit',
    'Search by invoice number, file name, or booking ID':
      'Hae laskun numeron, tiedostonimen tai varaustunnuksen perusteella',
    'Search by name, email, company':
      'Hae nimen, sähköpostin, yrityksen mukaan',
    'Search by name, email, company, uid':
      'Hae nimen, sähköpostin, yrityksen, uid:n mukaan',
    'Search client': 'Etsi asiakas',
    'Search delivered order': 'Hae toimitettu tilaus',
    'Search license plate or owner': 'Etsi rekisterikilpi tai omistaja',
    'Search order ID': 'Hae tilaustunnusta',
    'Search partner': 'Hakukumppani',
    'Select a new CMR Insurance to re-upload for this truck.':
      'Valitse uusi CMR-lasku ladattavaksi uudelleen tälle kuorma-autolle.',
    'Select paid date': 'Valitse maksupäivä',
    'Set CMR insurance expiry date to approve this truck.':
      'Aseta CMR-vakuutuksen viimeinen voimassaolopäivä hyväksyäksesi tämän kuorma-auton.',
    'Set maximum number of cars this truck can carry (1-20).':
      'Aseta enimmäismäärä autoja, joita tämä kuorma-auto voi kuljettaa (1-20).',
    'Set the CMR insurance expiry date before approval.':
      'Aseta CMR-vakuutuksen päättymispäivä ennen hyväksyntää.',
    Showing: 'Näytetään',
    'Showing page {{page}} of {{pages}} • {{total}} invoices':
      'Näytetään sivu {{page}} / {{pages}} • {{total}} laskut',
    'Status will be updated to Picked Up after successful upload. You can add multiple car photos before uploading.':
      'Voit lisätä useita autokuvia ennen lataamista.',
    Terms: 'Ehdot',
    Total: 'Yhteensä',
    'Track paid and unpaid invoices, expected payout dates, and upload new invoices quickly.':
      'Seuraa maksettuja ja maksamattomia laskuja, odotettuja maksupäiviä ja lataa uudet laskut nopeasti.',
    'Truck approved successfully': 'Kuorma-auto hyväksyttiin onnistuneesti',
    'Truck documents': 'Kuorma-auton asiakirjat',
    'Truck license plate': 'Kuorma-auton rekisterikilpi',
    'Truck rejected successfully': 'Kuorma-auto hylätty onnistuneesti',
    'truck(s) are pending admin CMR expiry date.':
      'kuorma-autot odottavat järjestelmänvalvojan CMR-vanhenemispäivää.',
    'truck(s) have expired CMR insurance and are disabled.':
      'kuorma-autoilla on vanhentunut CMR-vakuutus ja ne ovat vammaisia.',
    'truck(s) will expire within 14 days.':
      'kuorma-autot vanhenevat 14 päivän kuluessa.',
    'Unable to prepare the record for upload.':
      'Tietuetta ei voi valmistella lähetystä varten.',
    Unpaid: 'Maksamaton',
    'Upload a CMR Insurance before closing this truck setup.':
      'Lataa CMR-lasku ennen tämän kuorma-auton asennuksen sulkemista.',
    'Upload a valid CMR insurance. Each upload sends the truck back to pending review.':
      'Jokainen lataus lähettää kuorma-auton takaisin odottamaan tarkistusta.',
    'Upload documents': 'Lataa asiakirjat',
    'Upload Invoice': 'Lataa lasku',
    'Upload order documents': 'Lataa tilausasiakirjat',
    'Upload unavailable': 'Lataus ei ole käytettävissä',
    Uploaded: 'Ladattu',
    'Uploaded • Paid': 'Ladattu • Maksettu',
    'Uploaded • Partially paid': 'Lähetetty • Osittain maksettu',
    'Uploaded by partner for platform payout processing.':
      'Kumppanin lataama alustan maksujen käsittelyä varten.',
    User: 'Käyttäjä',
    'Verification code': 'Vahvistuskoodi',
    'View details': 'Näytä tiedot',
    'View Partners': 'Näytä yhteistyökumppanit',
    'Working hours not provided': 'Työaikaa ei ole ilmoitettu',
    '{{value}} orders': '{{value}} tilaukset',
    Invoiced: 'Laskutettu',
    'Loading admin data...': 'Ladataan järjestelmänvalvojan tietoja...',
    'Pending partners': 'Odottavat kumppanit',
    'Unpaid bookings': 'Maksamattomat varaukset',
    'Total users': 'Käyttäjiä yhteensä',
    'Orders per period': 'Tilaukset jaksoittain',
    'Orders by status': 'Tilaukset tilan mukaan',
    'Quick actions': 'Nopeita toimia',
    'Verify new partners': 'Vahvista uudet kumppanit',
    'Review partner applications and approve or reject requests.':
      'Tarkista kumppanihakemukset ja hyväksy tai hylkää pyynnöt.',
    'Manage all trucks': 'Hallitse kaikkia kuorma-autoja',
    'Review, approve, reject, disable, and filter all trucks.':
      'Tarkista, hyväksy, hylkää, poista käytöstä ja suodata kaikki kuorma-autot.',
    'Review bookings': 'Tarkista varaukset',
    'Review all transport orders, payment states, and generated invoices.':
      'Tarkista kaikki kuljetustilaukset, maksutilat ja luodut laskut.',
    'Manage all users': 'Hallitse kaikkia käyttäjiä',
    'Manage user status, roles, and validation records.':
      'Hallitse käyttäjän tilaa, rooleja ja validointitietueita.',
    'User breakdown': 'Käyttäjän erittely',
    Clients: 'Asiakkaat',
    Partners: 'Yhteistyökumppanit',
    Admins: 'Järjestelmänvalvojat',
    'Top 5 pending partners': '5 parasta odottavaa kumppania',
    'No pending partners right now.':
      'Ei vireillä olevia kumppaneita tällä hetkellä.',
    pending: 'vireillä',
    'Top 5 pending trucks': '5 parasta odottavaa kuorma-autoa',
    'No pending trucks right now.':
      'Ei odottavia kuorma-autoja tällä hetkellä.',
    'Unknown owner': 'Tuntematon omistaja',
    'KPI cards and top lists link directly to filtered admin screens.':
      'KPI-kortit ja suosituimmat luettelot linkittävät suoraan suodatetuille järjestelmänvalvojan näytöille.',
    'booking.available_orders_title': 'Saatavilla olevat tilaukset',
    'booking.available_orders_description':
      'Tarkista saapuvat kuljetusmahdollisuudet ja käytä suodattimia kapasiteettisi mukaan.',
    'booking.vehicle_pickup_location': 'Ajoneuvon noutopaikka',
    'booking.pickup_opening_hours': 'Nouto aukioloajat',
    'booking.vehicle_delivery_location': 'Ajoneuvon toimituspaikka',
    'booking.delivery_opening_hours': 'Toimituksen aukioloajat',
    'booking.pickup_contact': 'Noudon yhteyshenkilö',
    'booking.delivery_contact': 'Toimituksen yhteystiedot',
    'booking.vehicles_scheduled': 'Ajoneuvot aikataulussa',
    'booking.watchlist_title': 'Tarkkailulista',
    'booking.watchlist_description':
      'Seuraa tallennettuja mahdollisuuksia ja toimi nopeasti saatavuuden muuttuessa.',
    'Loading dashboard...': 'Ladataan hallintapaneelia...',
    'Total bookings': 'Varaukset yhteensä',
    'Open bookings': 'Avoimet varaukset',
    'Order status timeline': 'Tilauksen tilan aikajana',
    'Last 6 months of bookings grouped by current status.':
      'Viimeisen 6 kuukauden varaukset ryhmitelty nykytilan mukaan.',
    'Create new order': 'Luo uusi tilaus',
    'Create a new transport booking request.': 'Luo uusi kuljetusvarauspyyntö.',
    'View my orders': 'Katso tilaukseni',
    'Review status and details of your bookings.':
      'Tarkista varaustesi tila ja tiedot.',
    'Open profile': 'Avaa profiili',
    'Update company and contact details.': 'Päivitä yritys ja yhteystiedot.',
    'Recent bookings': 'Viimeaikaiset varaukset',
    'No bookings yet.': 'Ei vielä varauksia.',
    'Unknown destination': 'Tuntematon määränpää',
    'Quarter score': 'Neljänneksen tulos',
    '{{value}} completed': '{{value}} valmis',
    'Truck CMR warning': 'Kuorma-auton CMR-varoitus',
    'One truck has CMR expiry risk. Review it in Fleet.':
      'Yhdellä kuorma-autolla on CMR-vanhenemisriski. Tarkista se Fleetissä.',
    '{{count}} trucks have CMR expiry risk. Review them in Fleet.':
      '{{count}}-kuorma-autoissa on CMR-vanhenemisriski. Tarkista ne Fleetissä.',
    'Active queue': 'Aktiivinen jono',
    'Delivered bookings': 'Toimitetut varaukset',
    'Cars delivered': 'Autot toimitettu',
    'Canceled bookings': 'Peruutetut varaukset',
    'Avg assign-to-pickup': 'Keskim. määräys noutoon',
    'Quarter Partner Score': 'Neljänneksen kumppanipisteet',
    'Payment delay: +{{days}} days': 'Maksuviive: +{{days}} päivää',
    'Penalty events': 'Rangaistustapahtumat',
    Current: 'Nykyinen',
    'Completed orders per period': 'Valmiit tilaukset jaksoittain',
    'Completed orders': 'Valmiit tilaukset',
    'Truck CMR status alerts': 'Kuorma-auton CMR-tilahälytykset',
    '{{count}} truck(s) have expired CMR insurance.':
      '{{count}}-kuorma-autoilla on vanhentunut CMR-vakuutus.',
    '{{count}} truck(s) will expire within 14 days.':
      '{{count}} kuorma-autot vanhenevat 14 päivän sisällä.',
    '{{count}} truck(s) are missing CMR expiry date.':
      '{{count}}-kuorma-autoista puuttuu CMR:n viimeinen käyttöpäivä.',
    'Upload a new CMR Insurance in Fleet. The truck will stay pending until admin review.':
      'Lataa uusi CMR-lasku Fleetiin. Kuorma-auto jää odottamaan järjestelmänvalvojan tarkastukseen asti.',
    'Open fleet to resolve CMR alerts':
      'Avaa kalusto ratkaistaksesi CMR-hälytykset',
    'Operational actions': 'Operatiiviset toimet',
    'Open marketplace orders': 'Avoimet markkinapaikkatilaukset',
    'Review available orders and plan assignments.':
      'Tarkista saatavilla olevat tilaukset ja suunnittele toimeksiannot.',
    'My accepted orders': 'Hyväksytyt tilaukseni',
    'Manage delivery progress and documents.':
      'Hallitse toimituksen edistymistä ja asiakirjoja.',
    'Update trucks, trailers, and availability.':
      'Päivitä kuorma-autot, perävaunut ja saatavuus.',
    'Partner invoices': 'Yhteistyökumppanien laskut',
    'Upload and track invoice payments.': 'Lataa ja seuraa laskujen maksuja.',
    'No active orders in queue.': 'Ei aktiivisia tilauksia jonossa.',
    'profile.incompleteTitle': 'Profiili keskeneräinen',
    'profile.incompleteDescription':
      'Täytä profiilitietosi (yritys, puhelinnumero, osoite, kaupunki, postinumero) päästäksesi kaikkiin ominaisuuksiin.',
    'profile.goToProfile': 'Siirry Profiiliin',
    'auth.email_placeholder': 'nimi@yritys.com',
    'auth.authentication_mode_switch': 'Todennustilan kytkin',
    'auth.invalid_email': 'Virheellinen sähköpostiosoite',
    'auth.please_enter_a_valid_email_address':
      'Anna kelvollinen sähköpostiosoite.',
    'auth.email_not_found': 'Sähköpostia ei löydy',
    'auth.no_account_found_with_that_email_address':
      'Tällä sähköpostiosoitteella ei löytynyt tiliä.',
    'auth.email_sent': 'Sähköposti lähetetty!',
    'auth.something_went_wrong_try_again':
      'Jotain meni pieleen. Yritä uudelleen.',
    'auth.we_sent_a_password_reset_link_open_your_inbox_and_follow_the_instructions':
      'Lähetimme salasanan palautuslinkin. Avaa postilaatikkosi ja seuraa ohjeita.',
    'auth.forgot_your_password': 'Unohditko salasanasi?',
    'auth.enter_your_account_email_and_we_will_send_you_a_password_reset_link':
      'Anna tilisi sähköpostiosoite, niin lähetämme sinulle salasanan palautuslinkin.',
    'auth.email_address': 'Sähköpostiosoite',
    'auth.send_reset_link': 'Lähetä nollauslinkki',
    'auth.cancel': 'Peruuta',
    'auth.tip_if_you_do_not_receive_the_email_check_spam_and_promotions_folders':
      'Vinkki: jos et saa sähköpostia, tarkista roskaposti- ja tarjouskansiot.',
    'booking.e_g_berlin': 'esim. Berliini',
    'booking.e_g_germany': 'esim. Saksa',
    'booking.watchlist': 'Tarkkailulista',
    'booking.view_map': 'Näytä kartta',
    'booking.invalid_input': 'Virheellinen syöte',
    'booking.please_enter_only_numbers_for_the_zip_code':
      'Syötä postinumeroa varten vain numeroita.',
    'booking.pickup_zip_code': 'Noudon postinumero',
    'booking.delivery_zip_code': 'Toimituksen postinumero',
    'booking.select_vehicle_make': 'Valitse ajoneuvon merkki',
    'booking.unnamed_item': 'Nimetön kohde',
    'booking.cars': 'autoja',
    'booking.more_info': 'Lisätietoja',
    'booking.loading': 'Ladataan...',
    'booking.no_items_found': 'Kohteita ei löytynyt',
    'booking.selected_cars': 'Valitut autot',
    'booking.unknown_type': 'Tuntematon tyyppi',
    'booking.delete_car': 'Poista auto',
    'Toggle details': 'Vaihda tiedot',
    'auth.a_verification_email_has_been_sent_to_your_email_address_please_verify_your_emai':
      'Sähköpostiosoitteeseesi on lähetetty vahvistussähköposti. Vahvista sähköpostiosoitteesi ennen kirjautumista.',
    'auth.an_unexpected_error_occurred_please_try_again':
      'Tapahtui odottamaton virhe. Yritä uudelleen.',
    'auth.failed_to_resend_email': 'Sähköpostin uudelleenlähetys epäonnistui',
    'auth.show_password': 'Näytä salasana',
    'auth.hide_password': 'Piilota salasana',
    'auth.incorrect_password_please_try_again':
      'Väärä salasana. Yritä uudelleen.',
    'auth.invalid_email_or_password_please_check_your_credentials_and_try_again':
      'Virheellinen sähköpostiosoite tai salasana. Tarkista kirjautumistietosi ja yritä uudelleen.',
    'auth.network_error_check_your_connection_and_try_again':
      'Verkkovirhe. Tarkista yhteys ja yritä uudelleen.',
    'auth.no_account_found_with_this_email':
      'Tällä sähköpostilla ei löytynyt tiliä.',
    'auth.please_check_your_inbox': 'Tarkista postilaatikkosi.',
    'auth.please_make_sure_both_passwords_are_the_same':
      'Varmista, että molemmat salasanat ovat samat.',
    'auth.please_sign_in_to_resend_the_verification_email':
      'Kirjaudu sisään lähettääksesi vahvistussähköpostin uudelleen.',
    'auth.resend_verification_email': 'Lähetä vahvistussähköposti uudelleen',
    'auth.awaiting_verification_artwork': 'Odottaa vahvistusta taidetta',
    'auth.email_verification_required': 'Sähköpostivahvistus vaaditaan',
    'auth.waiting_for_email_verification': 'Odotetaan sähköpostin vahvistusta',
    'auth.check_your_email': 'Tarkista sähköpostisi',
    'auth.we_sent_your_verification_link_to':
      'Lähetimme vahvistuslinkin osoitteeseen',
    'auth.didnt_receive_it_check_spam_or_try_again':
      'Etkö saanut sitä? Tarkista roskapostikansiosi tai yritä uudelleen.',
    'auth.resend_email': 'Lähetä sähköposti uudelleen',
    'auth.i_verified_my_email': 'Olen vahvistanut sähköpostini',
    'auth.redirecting_you_now': 'Sinut uudelleenohjataan nyt.',
    'auth.email_not_verified_yet':
      'Sähköpostiosoitetta ei ole vielä vahvistettu',
    'auth.please_click_the_link_in_your_inbox_and_try_again':
      'Napsauta postilaatikossasi olevaa linkkiä ja yritä uudelleen.',
    'auth.unable_to_resend_verification_email_right_now':
      'Vahvistussähköpostia ei voi lähettää uudelleen juuri nyt.',
    'auth.unable_to_check_verification_status_right_now':
      'Vahvistuksen tilaa ei voi tarkistaa juuri nyt.',
    'auth.we_sent_a_new_verification_link':
      'Olemme lähettäneet uuden vahvistuslinkin sähköpostiosoitteeseesi.',
    'auth.we_automatically_check_every_30_seconds':
      'Tarkistamme vahvistuksen tilan automaattisesti 30 sekunnin välein. Voit myös käynnistää välittömän tarkistuksen sähköpostisi vahvistamisen jälkeen.',
    'auth.we_automatically_check_every_15_seconds':
      'Tarkistamme vahvistuksen tilan automaattisesti 15 sekunnin välein. Voit myös käynnistää välittömän tarkistuksen sähköpostisi vahvistamisen jälkeen.',
    'auth.the_email_address_is_not_valid': 'Sähköpostiosoite ei kelpaa.',
    'auth.this_account_has_been_disabled': 'Tämä tili on poistettu käytöstä.',
    'auth.too_many_failed_attempts_please_try_again_later_or_reset_your_password':
      'Liian monta epäonnistunutta yritystä. Yritä myöhemmin uudelleen tai vaihda salasanasi.',
    'auth.verification_email_resent':
      'Vahvistussähköposti lähetetty uudelleen!',
    'auth.you_need_to_log_in_first': 'Sinun on ensin kirjauduttava sisään',
    'booking.endpoint': 'Loppu',
    'booking.error_fetching_data': 'Virhe haettaessa tietoja',
    'booking.inputs_changed_recalculate_the_price':
      'Sisääntulot muutettu. Laske hinta uudelleen.',
    'booking.kg': 'kg',
    'booking.km': 'km',
    'booking.mi': 'mi',
    'booking.no_opening_hours_provided': 'Aukioloaikoja ei ole ilmoitettu',
    'booking.no_vehicles_listed': 'Ei luettelossa olevia ajoneuvoja',
    'booking.not_available': 'Ei saatavilla',
    'booking.not_set': 'Ei asetettu',
    'booking.please_select_a_planned_date': 'Valitse suunniteltu päivämäärä',
    'booking.required': 'Pakollinen',
    'booking.startpoint': 'Aloita',
    'booking.to': 'to',
    'booking.vip_price': 'VIP hinta',
    'booking.order': 'Tilaa',
    'booking.duration': 'Kesto',
    'booking.vehicles_overview': 'Ajoneuvojen yleiskatsaus',
    'booking.body': 'Runko',
    'booking.dims': 'Himmentää',
    'booking.select_vehicle_model': 'Valitse ajoneuvomalli',
    'booking.selected_type_value': 'Valittu: {{value}}',
    'booking.select_a_vehicle_type': 'Valitse ajoneuvotyyppi:',
    'booking.select_vehicle_weight': 'Valitse ajoneuvon paino',
    'booking.selected_weight_kg': 'Valittu: {{value}} kg',
    'booking.adjust_weight': 'Säädä painoa',
    'Dates updated successfully': 'Päivämäärät päivitetty onnistuneesti',
    'Error updating dates': 'Virhe päivitettäessä päivämääriä',
    'Set Planned Dates': 'Aseta suunnitellut päivämäärät',
    'Set your planned pickup and arrival dates below.':
      'Aseta suunnitellut nouto- ja saapumispäivät alle.',
    'Changing dates after initial setup will deduct 20% from your performance score for this order.':
      'Päivämäärien muuttaminen alkuperäisen määrityksen jälkeen vähentää 20 % tämän tilauksen suorituspisteistä.',
    'Planned Pickup Date': 'Suunniteltu noutopäivä',
    'Planned Arrival Date': 'Suunniteltu saapumispäivä',
    Listing: 'Listaus',
    'Try broadening the current search or status filter.':
      'Yritä laajentaa nykyistä hakua tai tilasuodatinta.',
    'Try broadening the search, role, or status filters.':
      'Kokeile laajentaa haku-, rooli- tai tilasuodattimia.',
    'Monitor fleet compliance, validation status, and expiring insurance in one place.':
      'Valvo kaluston vaatimustenmukaisuutta, validointitilaa ja vanhenevia vakuutuksia yhdestä paikasta.',
    'Active Listings': 'Aktiiviset ilmoitukset',
    'Open transport requests': 'Avaa kuljetuspyynnöt',
    'Quotes Today': 'Lainaukset tänään',
    'Submitted in last 24h': 'Lähetetty viimeisen 24 tunnin aikana',
    'Platform Revenue (MTD)': 'Alustan tuotto (MTD)',
    'Month to date': 'Kuukausi tähän päivään mennessä',
    'Pending Partners': 'Odottavat kumppanit',
    'Awaiting approval': 'Odottaa hyväksyntää',
    'Unpaid Invoices': 'Maksamattomat laskut',
    'Requires action': 'Vaatii toimia',
    'Completed Transports': 'Valmistuneet kuljetukset',
    'All time delivered': 'Toimitettu koko ajan',
    'Admin Dashboard': 'Admin Dashboard',
    'Platform overview and key performance indicators.':
      'Alustan yleiskatsaus ja keskeiset suorituskykyindikaattorit.',
    'Loading dashboard metrics...': 'Ladataan hallintapaneelin tietoja...',
    Invoices: 'Laskut',
    'Review payout invoices uploaded by partners and keep payout processing organized.':
      'Tarkista kumppanien lataamat maksulaskut ja pidä maksujen käsittely järjestyksessä.',
    Flexible: 'Joustava',
    'Flexible dates': 'Joustavat päivämäärät',
    'Could not load this listing.': 'Tätä yritystietoa ei voitu ladata.',
    'Listing canceled': 'Listaus peruttu',
    'Failed to cancel listing': 'Tietojen peruuttaminen epäonnistui',
    Reference: 'Viite',
    Category: 'Luokka',
    'Client type': 'Asiakastyyppi',
    'Company country': 'Yrityksen maa',
    Expires: 'Vanhenee',
    'Back to listings': 'Takaisin listauksiin',
    'Listing not found.': 'Tietoa ei löydy.',
    'Cancel Listing': 'Peruuta listaus',
    'Listing details': 'Listauksen tiedot',
    'Reference {{id}}': 'Viite {{id}}',
    'Read-only listing overview for admins.':
      'Vain luku -luettelon yleiskatsaus järjestelmänvalvojille.',
    'Pick-up': 'Nouto',
    'No exact coordinates are stored for this listing yet.':
      'Tälle listalle ei ole vielä tallennettu tarkkoja koordinaatteja.',
    'Structured overview of quantities and handling details.':
      'Strukturoitu yleiskatsaus määristä ja käsittelyn yksityiskohdista.',
    'Shipment images': 'Lähetys kuvat',
    'No shipment images were uploaded for this listing.':
      'Tälle listalle ei ole ladattu lähetyskuvia.',
    'Proof of pickup': 'Todiste noudosta',
    'Final documents': 'Lopulliset asiakirjat',
    Description: 'Kuvaus',
    'Quotes ({{count}})': 'Lainaukset ({{count}})',
    'Loading quotes...': 'Ladataan lainauksia...',
    'No quotes for this listing.': 'Ei lainauksia tälle listalle.',
    'Pickup: {{date}}': 'Nouto: {{date}}',
    'Delivery: {{date}}': 'Toimitus: {{date}}',
    'Cancel Listing?': 'Perutaanko listaus?',
    'This will permanently cancel the listing and notify the client. Continue?':
      'Tämä peruuttaa listauksen pysyvästi ja ilmoittaa asiasta asiakkaalle. Jatkaa?',
    Keep: 'Pidä',
    'Review partner applications, check their documents, and keep approval decisions consistent.':
      'Tarkista kumppanihakemukset, tarkista heidän asiakirjansa ja pidä hyväksymispäätökset johdonmukaisina.',
    'No client payments recorded yet': 'Asiakasmaksuja ei ole vielä kirjattu',
    'Client payment rows will appear here when the payments backend is connected.':
      'Asiakasmaksurivit näkyvät täällä, kun maksujen taustajärjestelmä on yhdistetty.',
    Method: 'menetelmä',
    'No partner payouts recorded yet':
      'Kumppanimaksuja ei ole vielä tallennettu',
    'Payout rows will appear here once partner payout processing is enabled.':
      'Maksurivit näkyvät täällä, kun kumppanimaksujen käsittely on otettu käyttöön.',
    'Payout Amount': 'Maksun summa',
    'No platform fees recorded yet': 'Alustamaksuja ei ole vielä kirjattu',
    'Fee rows will appear here once payment settlement data is available.':
      'Maksurivit näkyvät täällä, kun maksujen selvitystiedot ovat saatavilla.',
    Gross: 'Törkeää',
    'Fee (20%)': 'Maksu (20 %)',
    Payments: 'Maksut',
    'Client payments, partner payouts, and platform fee tracking.':
      'Asiakasmaksut, kumppanimaksut ja alustamaksujen seuranta.',
    'Client Payments': 'Asiakasmaksut',
    'Partner Payouts': 'Kumppanimaksut',
    'Platform Fees': 'Alustamaksut',
    'Failed to load reviews': 'Arvostelujen lataaminen epäonnistui',
    'Review removed': 'Arvostelu poistettu',
    'Failed to remove review': 'Arvostelun poistaminen epäonnistui',
    Reviews: 'Arvostelut',
    'All partner and transport reviews submitted by clients.':
      'Kaikki asiakkaiden lähettämät kumppani- ja kuljetusarvostelut.',
    'Loading reviews...': 'Ladataan arvosteluja...',
    'No reviews found': 'Arvosteluja ei löytynyt',
    'Client feedback will appear here when reviews are submitted.':
      'Asiakkaiden palaute näkyy täällä, kun arvostelut lähetetään.',
    Stars: 'Tähdet',
    Comment: 'Kommentoi',
    'Search, review, and maintain user accounts with one consistent admin workflow.':
      'Etsi, tarkista ja ylläpidä käyttäjätilejä yhdellä johdonmukaisella järjestelmänvalvojan työnkululla.',
    'Track paid and unpaid partner payout invoices, and upload the next delivered listing invoice quickly.':
      'Seuraa maksettuja ja maksamattomia kumppanien maksulaskuja ja lataa seuraava toimitettu listauslasku nopeasti.',
    'Search by invoice number, file name, or listing ID':
      'Hae laskun numeron, tiedostonimen tai listaustunnuksen mukaan',
    'Loading delivered listings...': 'Ladataan toimitettuja tietoja...',
    'Search delivered listing by reference, title, or route':
      'Hae toimitettuja luetteloita viitteen, otsikon tai reitin perusteella',
    'Route details available in listing': 'Reitin tiedot löytyvät listauksesta',
    'No matching delivered listings': 'Ei vastaavia toimitettuja luetteloita',
    'Selected listing': 'Valittu listaus',
    'Has quotes': 'Sisältää lainauksia',
    'In transit': 'Kuljetuksessa',
    Open: 'Avaa',
    Accepted: 'Hyväksytty',
    Completed: 'Valmis',
    'Client Dashboard': 'Asiakashallintapaneeli',
    'Overview of your current transport listings, quote activity, and recent requests.':
      'Yleiskatsaus nykyisistä kuljetuslistauksistasi, tarjoustoiminnastasi ja viimeaikaisista pyynnöistäsi.',
    'Total listings': 'Listaukset yhteensä',
    'Active listings': 'Aktiiviset listaukset',
    'Listings with quotes': 'Listaukset lainausmerkeillä',
    'Accepted transport': 'Hyväksytty kuljetus',
    'Listing status timeline': 'Listauksen tilan aikajana',
    'Last 6 months of listings grouped by current status.':
      'Viimeisen 6 kuukauden tiedot ryhmitelty nykytilan mukaan.',
    'No listing activity yet': 'Ei vielä listaustoimintaa',
    'Create your first listing to start tracking request activity here.':
      'Luo ensimmäiset yritystietosi, jotta voit alkaa seurata pyyntötoimintaa täällä.',
    'Create new listing': 'Luo uusi listaus',
    'Create a new transport request for the marketplace.':
      'Luo uusi kuljetuspyyntö kauppapaikalle.',
    'View my listings': 'Katso ilmoitukseni',
    'Review quote activity and manage your transport requests.':
      'Tarkista tarjoustoiminta ja hallinnoi kuljetuspyyntöjäsi.',
    'Recent listings': 'Viimeaikaiset listaukset',
    'No listings yet': 'Ei listauksia vielä',
    'Your newest transport requests will appear here once you create them.':
      'Uusimmat kuljetuspyyntösi näkyvät täällä, kun olet luonut ne.',
    'Unknown origin': 'Tuntematon alkuperä',
    '{{count}} quote(s)': '{{count}} lainaus',
    '{{value}} completed listings': '{{value}} valmiit listaukset',
    'Monitor current performance, fleet readiness, quote flow, and your active transport queue.':
      'Tarkkaile nykyistä suorituskykyä, kaluston valmiutta, tarjousvirtaa ja aktiivista kuljetusjonoasi.',
    'Total assigned': 'Määrätty yhteensä',
    'Quarter rating': 'Neljänneksen luokitus',
    'Based on current quarter performance':
      'Perustuu kuluvan vuosineljänneksen tulokseen',
    Rating: 'Luokitus',
    'Requirement met': 'Vaatimus täytetty',
    'Requirement not met': 'Vaatimus ei täyty',
    'Completed listings per period': 'Valmiit listaukset jaksoittain',
    'No completion data yet': 'Ei vielä valmistumistietoja',
    'Statistics will appear here after your first delivered work.':
      'Tilastot näkyvät täällä ensimmäisen toimitetun työsi jälkeen.',
    'Completed listings': 'Valmiit listaukset',
    'Review truck documents and refresh anything close to expiry.':
      'Tarkista kuorma-auton asiakirjat ja päivitä kaikki lähellä olevaa voimassaoloaikaa.',
    'Search deliveries': 'Hae toimituksia',
    'Review available marketplace listings and submit quotes.':
      'Tarkista saatavilla olevat markkinapaikat ja lähetä tarjoukset.',
    'My quotes': 'Minun lainaukset',
    'Track accepted, pending, and rejected quotes in one place.':
      'Seuraa hyväksyttyjä, odottavia ja hylättyjä tarjouksia yhdessä paikassa.',
    'Profile settings': 'Profiilin asetukset',
    'Keep company information and compliance details up to date.':
      'Pidä yrityksen tiedot ja vaatimustenmukaisuustiedot ajan tasalla.',
    'No active queue items': 'Ei aktiivisia jonon kohteita',
    'Accepted and in-progress work will appear here as your transport activity grows.':
      'Hyväksytyt ja keskeneräiset työt näkyvät täällä, kun kuljetusaktiviteettisi kasvaa.',
    'Your role does not have permission to open this page.':
      'Roolillasi ei ole lupaa avata tätä sivua.',
    'Go to dashboard': 'Siirry kojelautaan',
    'Trailer capacity is required.': 'Perävaunun kapasiteetti vaaditaan.',
    'How many cars can this trailer carry?':
      'Kuinka monta autoa tähän perävaunuun mahtuu?',
    'Set maximum number of cars this trailer can carry (1-20).':
      'Aseta tämän perävaunun kuljettamien autojen enimmäismäärä (1-20).',
    'Invalid max load (kg).': 'Virheellinen enimmäiskuorma (kg).',
    'Enter a valid weight between 1 and 100000 kg, or leave it empty.':
      'Anna kelvollinen paino väliltä 1 - 100000 kg tai jätä se tyhjäksi.',
    'Maximum payload weight this truck can carry (optional).':
      'Suurin hyötykuorma, jonka tämä kuorma-auto voi kantaa (valinnainen).',
    'Manage the company and contact details that appear across your listings, invoices, and account verification flows.':
      'Hallinnoi yritys- ja yhteystietoja, jotka näkyvät yritystiedoissasi, laskuissasi ja tilin vahvistuskuluissasi.',
    'Keep these details up to date so listings, invoices, and partner verification stay accurate.':
      'Pidä nämä tiedot ajan tasalla, jotta tiedot, laskut ja kumppanin vahvistus pysyvät oikein.',
    'Unsaved changes': 'Tallentamattomat muutokset',
    'All changes saved': 'Kaikki muutokset tallennettu',
    'auth.sign_up_failed': 'Ilmoittautuminen epäonnistui',
    'auth.please_select_a_valid_role': 'Valitse kelvollinen rooli.',
    'booking.pickup_not_found': 'Noutoa ei löytynyt.',
    'booking.delivery_not_found': 'Toimitusta ei löydy.',
    'booking.capacity': 'Kapasiteetti',
    'booking.cmr_expiry': 'CMR voimassaolon päättyminen',
    'booking.uploaded': 'Ladattu',
    'booking.missing': 'Puuttuu',
    'booking.cmr_document': 'CMR-asiakirja',
    'booking.go_to_profile': 'Siirry Profiiliin',
    'booking.click_to_download_purchase_terms':
      'Napsauta ladataksesi ostoehdot',
    'admin.purchase_terms_management': 'Ostoehtojen hallinta',
    'admin.purchase_terms_management_subtitle':
      'Lataa ja ylläpidä lokalisoituja ostoehtojen PDF-tiedostoja, joita käytetään kumppanitilausten hyväksymisessä.',
    'admin.document_language': 'Asiakirjan kieli',
    'admin.click_to_download_purchase_terms': 'Napsauta ladataksesi ostoehdot',
    'admin.current_language_label': 'Nykyinen kieli: {{language}}',
    'admin.purchase_terms_unavailable_for_selected_language':
      'Ostoehtoasiakirja ei ole saatavilla valitulle kielelle.',
    'Download and review the active purchase terms in your current interface language before continuing.':
      'Lataa ja tarkista aktiiviset ostoehdot nykyisellä käyttöliittymäkielelläsi ennen kuin jatkat.',
    'We make agreements and conclude a contract for the carriage of goods. I have just read this agreement in full and agree to its contents.':
      'Teemme sopimuksia ja sopimuksen tavarankuljetuksesta. Olen juuri lukenut tämän sopimuksen kokonaan ja hyväksyn sen sisällön.',
    'I confirm that I will schedule this order within 24 hours':
      'Vahvistan, että ajoitan tämän tilauksen 24 tunnin sisällä',
    'Failed to load purchase terms document.':
      'Ostoehtoasiakirjan lataaminen epäonnistui.',
    'Partner rating': 'Kumppaniluokitus',
    'Bronze requirements': 'Pronssivaatimukset',
    'Orders in quarter': 'Tilaukset vuosineljänneksellä',
    'Cancellation rate / 100 orders': 'Peruutusprosentti / 100 tilausta',
    'Damage claims / 100 orders': 'Vahinkokorvaukset / 100 tilausta',
    '{{current}} / min {{target}}': '{{current}} / min {{target}}',
    '{{current}} / max {{target}}': '{{current}} / max {{target}}',
    Met: 'Met',
    'Not met': 'Ei tavattu',
    Unranked: 'Ei rankingissa',
    'profile.incompleteDescriptionPartner':
      'Täytä profiilitietosi (yritys, puhelinnumero, osoite, kaupunki, postinumero, alv-numero) käyttääksesi kaikkia ominaisuuksia.',
    'profile.incompleteDescriptionClient':
      'Täytä profiilitietosi (puhelinnumero), jotta pääset käyttämään kaikkia ominaisuuksia.',
    'auth.verification_email_sent': 'Vahvistussähköposti lähetetty',
    '{{amount}} above the client target':
      '{{amount}} asiakastavoitteen yläpuolella',
    '{{amount}} below the client target':
      '{{amount}} asiakastavoitteen alapuolella',
    '{{count}} image(s) added to the listing.':
      '{{count}} kuvaa lisätty listalle.',
    '{{count}} quote(s) received': '{{count}} tarjous vastaanotettu',
    '{{count}} reviews': '{{count}} arvostelua',
    '{{count}} total': '{{count}} yhteensä',
    '{{count}} visible': '{{count}} näkyvissä',
    '{{weight}} kg': '{{weight}} kg',
    'A Google route preview with pins A and B appears here once pickup and delivery coordinates are available.':
      'Google-reitin esikatselu nastoilla A ja B näkyy tässä, kun nouto- ja toimituskoordinaatit ovat saatavilla.',
    'A route preview appears once map coordinates are available.':
      'Reitin esikatselu tulee näkyviin, kun karttakoordinaatit ovat saatavilla.',
    'A timeline of clarifications connected to this listing.':
      'Aikajana tähän ilmoitukseen liittyvistä selvennyksistä.',
    "Accept {{partner}}'s quote for {{amount}}?":
      'Hyväksytäänkö {{partner}}:n tarjous {{amount}}:stä?',
    'Accept Listing': 'Hyväksy listaus',
    'Accept quote': 'Hyväksy tarjous',
    'Accepted quote': 'Hyväksytty lainaus',
    'Accepted quote required': 'Hyväksytty tarjous vaaditaan',
    'Accepting...': 'Hyväksytään...',
    Active: 'Aktiivinen',
    'Active statuses': 'Aktiiviset tilat',
    'Add another item': 'Lisää toinen kohde',
    'Add images': 'Lisää kuvia',
    'Add more shipment images': 'Lisää lähetyskuvia',
    'After you confirm an AI action, open the prepared destination immediately instead of waiting for a manual click.':
      'Kun olet vahvistanut tekoälytoiminnon, avaa valmis kohde välittömästi sen sijaan, että odotat manuaalista napsautusta.',
    'AI Assistant': 'AI Assistant',
    'AI assistant disabled for all users.':
      'AI-avustaja ei ole käytössä kaikilta käyttäjiltä.',
    'AI assistant enabled for all users.':
      'AI-avustaja käytössä kaikille käyttäjille.',
    'AI assistant preferences updated': 'AI-avustajan asetukset päivitetty',
    'AI disabled for user.': 'AI pois käytöstä käyttäjältä.',
    'AI enabled for user.': 'AI käytössä käyttäjälle.',
    'AI-powered message translation between languages':
      'AI-käyttöinen viestien kääntäminen kielten välillä',
    'All route-critical information in one place before you review quotes or documents.':
      'Kaikki reitin kannalta tärkeät tiedot yhdessä paikassa ennen tarjousten tai asiakirjojen tarkistamista.',
    View: 'Tarkastele',
    Answer: 'Vastaa',
    Archive: 'Arkisto',
    'Archived statuses': 'Arkistoidut tilat',
    'Are you sure you want to reject the quote from':
      'Haluatko varmasti hylätä lainauksen kohteesta',
    'Ask a question about this listing...':
      'Esitä kysymys tästä ilmoituksesta...',
    'Ask for matching lanes, quote help, or the next operational step.':
      'Pyydä vastaavia kaistaa, lainaa apua tai seuraavaa toimintavaihetta.',
    'Ask for quote comparisons or a prepared next step from this shipment screen.':
      'Pyydä tarjousvertailuja tai valmisteltua seuraavaa vaihetta tältä lähetysnäytöltä.',
    'Assistant history cleared': 'Assistantin historia tyhjennettiin',
    'Automatically translate messages from other users into your preferred language using AI.':
      'Käännä muiden käyttäjien viestit automaattisesti haluamallesi kielelle tekoälyn avulla.',
    'Back to listing': 'Takaisin listaukseen',
    'Best offer': 'Paras tarjous',
    'Best quote': 'Paras lainaus',
    'Body type: {{type}}': 'Runkotyyppi: {{type}}',
    'Breed: {{breed}}': 'Rotu: {{breed}}',
    Budget: 'Budjetti',
    'Cancel listing': 'Peruuta listaus',
    'Canceled and completed work will appear here once listings move out of the active view.':
      'Peruutetut ja valmiit työt näkyvät täällä, kun tiedot siirtyvät pois aktiivisesta näkymästä.',
    'Cargo Details': 'Lastin tiedot',
    Categories: 'Luokat',
    'Choose the interface language. This preference is saved locally and applies immediately.':
      'Valitse käyttöliittymän kieli. Tämä asetus tallennetaan paikallisesti ja otetaan käyttöön välittömästi.',
    'Clear all': 'Tyhjennä kaikki',
    'Clear assistant history': 'Tyhjennä avustajan historia',
    'Client price in EUR': 'Asiakashinta euroina',
    'Client target price': 'Asiakkaan tavoitehinta',
    'Complete the payment below to lock the fixed-price acceptance and let the partner start planning.':
      'Suorita alla oleva maksu lukitaksesi kiinteähintaisen hyväksynnän ja anna kumppanin aloittaa suunnittelu.',
    'Complete the payment below to lock the selected quote and let the partner start planning.':
      'Lukitse valittu tarjous suorittamalla alla oleva maksu ja anna kumppanin aloittaa suunnittelu.',
    'Compose area prepared for listing Q&A. Submission remains disabled until the live question endpoint is connected on this page.':
      'Kirjoita alue, joka on valmis listaamaan Q&A. Lähetys pysyy poissa käytöstä, kunnes live-kysymyksen päätepiste yhdistetään tällä sivulla.',
    'Confirm delivery complete': 'Vahvista toimituksen valmistuminen',
    'Confirm payment received': 'Vahvista maksun vastaanottaminen',
    'Confirm that you have received the bank transfer or payment for this listing. This will move the listing to Paid status and allow the partner to mark it as planned.':
      'Vahvista, että olet vastaanottanut pankkisiirron tai maksun näistä tiedoista. Tämä siirtää tiedot maksettu-tilaan ja antaa kumppanille mahdollisuuden merkitä ne suunnitelluksi.',
    'Confirm the exact fleet and dates before the listing moves to Planned.':
      'Vahvista tarkka kalusto ja päivämäärät ennen kuin listaus siirtyy Suunniteltuihin.',
    'Confirm Transport Plan': 'Vahvista kuljetussuunnitelma',
    'Confirming...': 'Vahvistetaan...',
    'Control how the web assistant behaves on this device. These settings do not change your account data.':
      'Hallitse, miten verkkoavustaja toimii tällä laitteella. Nämä asetukset eivät muuta tilitietojasi.',
    'Create listing': 'Luo listaus',
    'Create with AI': 'Luo tekoälyllä',
    'Create your next transport request and it will appear here with route, item, and quote activity.':
      'Luo seuraava kuljetuspyyntösi, niin se näkyy täällä reitin, kohteen ja tarjoustoiminnan kanssa.',
    'Current stage:': 'Nykyinen vaihe:',
    'Current status': 'Nykyinen tila',
    'Delivery confirmation needed': 'Toimitusvahvistus tarvitaan',
    'Delivery radius': 'Toimitussäde',
    'Delivery:': 'Toimitus:',
    'Describe the route and cargo, then review the prepared listing draft before publishing.':
      'Kuvaile reittiä ja rahtia ja tarkista sitten valmis listausluonnos ennen julkaisemista.',
    'Describe the shipment you need and review the prepared request before publishing.':
      'Kuvaile tarvitsemasi lähetys ja tutustu valmisteltuun pyyntöön ennen julkaisua.',
    'Download and review the purchase terms before confirming the transport plan.':
      'Lataa ja tarkista ostoehdot ennen kuljetussuunnitelman vahvistamista.',
    'Download invoice': 'Lataa lasku',
    'Download Purchase Terms': 'Lataa ostoehdot',
    'Draft with AI': 'Luonnos tekoälyllä',
    'Draft your review first, then submit it here when you are satisfied.':
      'Laadi ensin arvostelusi ja lähetä se sitten tänne, kun olet tyytyväinen.',
    'Edit listing': 'Muokkaa luetteloa',
    'Edit Quote': 'Muokkaa lainausta',
    Enable: 'Ota käyttöön',
    'Enable live translation': 'Ota live-käännös käyttöön',
    'Enabled Users': 'Käytössä olevat käyttäjät',
    'Engagement Activity': 'Sitoutumistoiminta',
    'Expires:': 'Vanhenee:',
    'Failed to accept listing': 'Ilmoituksen hyväksyminen epäonnistui',
    'Failed to accept quote': 'Tarjouksen hyväksyminen epäonnistui',
    'Failed to clear assistant history':
      'Assistentin historian tyhjennys epäonnistui',
    'Failed to complete listing': 'Listauksen viimeistely epäonnistui',
    'Failed to confirm payment': 'Maksun vahvistaminen epäonnistui',
    'Failed to confirm transport plan':
      'Kuljetussuunnitelman vahvistaminen epäonnistui',
    'Failed to disable AI for user.':
      'Tekoälyn poistaminen käytöstä käyttäjältä epäonnistui.',
    'Failed to enable AI for user.':
      'AI:n käyttöönotto käyttäjälle epäonnistui.',
    'Failed to load listing.': 'Tietojen lataaminen epäonnistui.',
    'Failed to load listings': 'Tietojen lataaminen epäonnistui',
    'Failed to load listings. Please try again.':
      'Tietojen lataaminen epäonnistui. Yritä uudelleen.',
    'Failed to load review context.':
      'Arvostelun kontekstin lataaminen epäonnistui.',
    'Failed to load settings.': 'Asetusten lataaminen epäonnistui.',
    'Failed to refresh Stripe payment status':
      'Stripe-maksutilan päivittäminen epäonnistui',
    'Failed to reject quote': 'Tarjouksen hylkääminen epäonnistui',
    'Failed to release listing': 'Tietojen julkaiseminen epäonnistui',
    'Failed to save quote': 'Tarjouksen tallentaminen epäonnistui',
    'Failed to update listing': 'Tietojen päivittäminen epäonnistui',
    'Failed to update preferred language':
      'Ensisijaisen kielen päivittäminen epäonnistui',
    'Failed to update setting.': 'Asetuksen päivittäminen epäonnistui.',
    'Failed to update status': 'Tilan päivittäminen epäonnistui',
    'Failed to update translation preference':
      'Käännösasetuksen päivittäminen epäonnistui',
    'Failed to update watchlist': 'Tarkkailulistan päivittäminen epäonnistui',
    'Failed to withdraw quote': 'Tarjouksen peruuttaminen epäonnistui',
    'Feature Flags': 'Ominaisuusliput',
    'Filter invoice uploads, search by reference, and page through payout records.':
      'Suodata laskujen lataukset, etsi viitteen perusteella ja selaa maksutietueita.',
    Filters: 'Suodattimet',
    'Final delivery documents': 'Lopulliset toimitusasiakirjat',
    'Fixed price only': 'Vain kiinteä hinta',
    'Flexible / not set': 'Joustava / ei asetettu',
    'Generated automatically when the transport plan is confirmed.':
      'Luodaan automaattisesti, kun kuljetussuunnitelma on vahvistettu.',
    'Generation: {{generation}}': 'Sukupolvi: {{generation}}',
    'Goods delivered — awaiting client confirmation.':
      'Tavarat toimitettu - odottaa asiakkaan vahvistusta.',
    'Gross price': 'Bruttohinta',
    'I have read and agree to the purchase terms for this transport job.':
      'Olen lukenut ja hyväksyn tämän kuljetustyön ostoehdot.',
    'I understand that accepting this listing assigns it to me at the fixed client price shown above.':
      'Ymmärrän, että tämän listauksen hyväksyminen määrittää sen minulle yllä näkyvään kiinteään asiakashintaan.',
    'Image upload failed': 'Kuvan lataus epäonnistui',
    'Images uploaded': 'Kuvat ladattu',
    'Interface language': 'Käyttöliittymän kieli',
    'Invoice documents': 'Laskuasiakirjat',
    'Item {{number}}': 'Tuote {{number}}',
    items: 'kohteita',
    'Keep listing': 'Jatka listaamista',
    'Keep quote': 'Pidä lainaus',
    'Keep the current AI session available after closing the browser on this device.':
      'Pidä nykyinen AI-istunto saatavilla, kun suljet tämän laitteen selaimen.',
    'Language & Region': 'Kieli ja alue',
    'Lift: {{origin}} / {{destination}}': 'Hissi: {{origin}} / {{destination}}',
    Listed: 'Listattu',
    'Listing {{id}}': 'Listaus {{id}}',
    'Listing accepted': 'Listaus hyväksytty',
    'Listing expired': 'Listaus vanhentunut',
    'Listing images': 'Kuvien luettelointi',
    'Listing is live': 'Listaus on live-tilassa',
    'Listing reference': 'Listauksen viite',
    'Listing snapshot': 'Listauksen tilannekuva',
    'Listing unavailable': 'Tietoa ei ole saatavilla',
    'Listing updated': 'Listaus päivitetty',
    'Live Translation': 'Live-käännös',
    'Live translation disabled.': 'Live-käännös poistettu käytöstä.',
    'Live translation enabled.': 'Suora käännös käytössä.',
    'Loading approved trucks...': 'Ladataan hyväksyttyjä kuorma-autoja...',
    'Loading fleet...': 'Ladataan kalustoa...',
    'Loading listing details...': 'Ladataan yritystietojen tietoja...',
    'Loading listings...': 'Ladataan tietoja...',
    'Loading review details...': 'Ladataan arvostelun tietoja...',
    'Loading settings...': 'Ladataan asetuksia...',
    'Manage AI Assistant Users': 'Hallitse AI Assistant -käyttäjiä',
    'Manage platform-wide feature flags and configuration.':
      'Hallitse alustan laajuisia ominaisuuslippuja ja määrityksiä.',
    'Manage Users': 'Hallinnoi käyttäjiä',
    'Manage your transport requests, monitor quote activity, and keep active and archived work easy to scan.':
      'Hallinnoi kuljetuspyyntöjäsi, seuraa tarjoustoimintaa ja pidä aktiiviset ja arkistoidut työt helposti tarkistettavissa.',
    'Mark Picked Up': 'Mark otti vastaan',
    'Matches the client target price': 'Vastaa asiakkaan tavoitehintaa',
    Media: 'Media',
    Messages: 'Viestit',
    'Messages will be translated into this language.':
      'Viestit käännetään tälle kielelle.',
    'Minimum net:': 'Minimi netto:',
    'My invoices': 'Minun laskuni',
    Net: 'Net',
    'Net price': 'Nettohinta',
    'Net quote': 'Nettolainaus',
    'New images appear immediately in the listing details for client, partner, and admin views.':
      'Uudet kuvat näkyvät välittömästi yritystietojen tiedoissa asiakas-, kumppani- ja järjestelmänvalvojanäkymässä.',
    'Next step': 'Seuraava askel',
    'No active listings yet': 'Ei vielä aktiivisia listauksia',
    'No address provided': 'Osoitetta ei ole annettu',
    'No answer yet.': 'Ei vastausta vielä.',
    'No archived listings yet': 'Ei vielä arkistoituja tietoja',
    'No description added.': 'Kuvausta ei ole lisätty.',
    'no destination': 'ei määränpäätä',
    'No expiry': 'Ei voimassaoloaikaa',
    'No listings match the current filters. Try broadening the search or date range.':
      'Yksikään listaus ei vastaa nykyisiä suodattimia. Yritä laajentaa hakua tai ajanjaksoa.',
    'no origin': 'ei alkuperää',
    'No questions yet': 'Ei kysymyksiä vielä',
    'No quotes yet': 'Ei lainauksia vielä',
    'No shipment images uploaded yet.': 'Lähetyskuvia ei ole vielä ladattu.',
    'No trailer selected': 'Traileria ei ole valittu',
    'No unread messages': 'Ei lukemattomia viestejä',
    'No users found.': 'Käyttäjiä ei löytynyt.',
    'No users have AI enabled.':
      'Yksikään käyttäjä ei ole ottanut tekoälyä käyttöön.',
    'Not selected': 'Ei valittu',
    'Offers summary': 'Tarjousten yhteenveto',
    'Open AI assistant': 'Avaa AI-avustaja',
    'Open prepared screens automatically':
      'Avaa valmistetut näytöt automaattisesti',
    'Optional visible price shown to partners as your target budget.':
      'Valinnainen näkyvä hinta, joka näytetään kumppaneille tavoitebudjettisi.',
    'Other quotes will be declined automatically once this offer is accepted.':
      'Muut tarjoukset hylätään automaattisesti, kun tämä tarjous on hyväksytty.',
    'Partner delivery': 'Yhteistyökumppanin toimitus',
    'Partner pickup': 'Yhteistyökumppanin nouto',
    'Partner quote': 'Kumppanin lainaus',
    'Payment confirmed': 'Maksu vahvistettu',
    'Payment confirmed — listing status set to paid':
      'Maksu vahvistettu – listauksen tilaksi on asetettu maksettu',
    'Payment confirmed. Confirm the assigned fleet and planned dates before the listing moves to Planned.':
      'Maksu vahvistettu. Vahvista määrätty laivasto ja suunnitellut päivämäärät ennen kuin listaus siirtyy Suunniteltuihin.',
    'Payment is confirmed. The partner now needs to confirm the truck, driver, and planned dates.':
      'Maksu on vahvistettu. Kumppanin on nyt vahvistettava kuorma-auto, kuljettaja ja suunnitellut päivämäärät.',
    'Payment required': 'Maksu vaaditaan',
    'Photos uploaded for the shipment and visible across client, partner, and admin views.':
      'Lähetystä varten ladatut kuvat näkyvät asiakkaan, kumppanin ja järjestelmänvalvojan näkymissä.',
    'Pickup is complete and the transport is currently underway.':
      'Nouto on valmis ja kuljetus on parhaillaan käynnissä.',
    'Pickup proof': 'Nouto todiste',
    'Pickup proof and final delivery files uploaded by the transport partner.':
      'Kuljetuskumppanin lataamat noutotodistukset ja lopulliset toimitustiedostot.',
    'Pickup to delivery overview': 'Nouto toimitukseen yleiskatsaus',
    'Pickup:': 'Nouto:',
    'Plan and authorization': 'Suunnitelma ja valtuutus',
    'Plan transport': 'Suunnittele kuljetus',
    'Plan Transport': 'Suunnittele kuljetus',
    'Planned dates:': 'Suunnitellut päivämäärät:',
    'Planned delivery date': 'Suunniteltu toimituspäivä',
    'Platform Settings': 'Alustan asetukset',
    'Preferred language': 'Suosittu kieli',
    'Preferred language updated': 'Ensisijainen kieli päivitetty',
    'Prepare a quote or ask for the next lane action, then confirm before anything is submitted.':
      'Tee tarjous tai pyydä seuraavaa kaistatoimintoa ja vahvista sitten ennen kuin lähetät mitään.',
    'Purchase Terms': 'Ostoehdot',
    'Quantities, dimensions, and handling details ready for transport review.':
      'Määrät, mitat ja käsittelytiedot valmiina kuljetusta varten.',
    Question: 'Kysymys',
    Questions: 'Kysymyksiä',
    'Questions & answers': 'Kysymyksiä & vastauksia',
    'Questions and answers for this listing will appear here once the messaging flow is active.':
      'Näitä tietoja koskevat kysymykset ja vastaukset näkyvät täällä, kun viestikulku on aktiivinen.',
    'Quick access to the current shipment, quote, and billing state.':
      'Nopea pääsy nykyiseen lähetykseen, tarjoukseen ja laskutustilaan.',
    'Quote accepted': 'Lainaus hyväksytty',
    'Quote count': 'Lainausmäärä',
    'Quote message': 'Lainaus viestiä',
    'Quote rejected': 'Lainaus hylätty',
    'Quote withdrawn': 'Lainaus peruttu',
    Quotes: 'Lainaukset',
    'Quotes and questions': 'Lainauksia ja kysymyksiä',
    'Quotes are disabled for this listing. The first partner to accept the fixed price will be assigned automatically.':
      'Lainaukset on poistettu käytöstä tässä ilmoituksessa. Ensimmäinen kumppani, joka hyväksyy kiinteän hinnan, määrätään automaattisesti.',
    'Quotes are disabled for this shipment. If you accept it, the client price becomes an accepted booking immediately.':
      'Tarjoukset on poistettu käytöstä tälle lähetykselle. Jos hyväksyt sen, asiakashinnasta tulee välittömästi hyväksytty varaus.',
    'Quotes from transport providers usually begin to appear shortly after publishing. Refresh to check again.':
      'Kuljetuspalveluntarjoajien lainaukset alkavat yleensä ilmestyä pian julkaisun jälkeen. Päivitä tarkistaaksesi uudelleen.',
    'Reference #{{id}}': 'Viite #{{id}}',
    'Refresh listings': 'Päivitä listaukset',
    'Reject quote': 'Hylkää lainaus',
    'Rejecting...': 'Hylkääminen...',
    Release: 'Vapauta',
    'Release Listing': 'Julkaisuluettelo',
    'Remember assistant conversation': 'Muista avustajan keskustelu',
    'Required for fixed-price listings. Partners accept this amount directly.':
      'Pakollinen kiinteähintaisille listauksille. Kumppanit hyväksyvät tämän summan suoraan.',
    'Required. Partners will be able to accept this listing at the fixed client price without sending a quote.':
      'Pakollinen. Yhteistyökumppanit voivat hyväksyä tämän listauksen kiinteään asiakashintaan lähettämättä tarjousta.',
    'Review submission failed.': 'Tarkistuksen lähetys epäonnistui.',
    'Review the completed transport using the standard product flow.':
      'Tarkista valmis kuljetus vakiotuotevirran avulla.',
    'Route pending': 'Reitti odottaa',
    'Save changes': 'Tallenna muutokset',
    'Saving...': 'Tallennetaan...',
    'Search by title, route, category, or item':
      'Hae otsikon, reitin, luokan tai kohteen mukaan',
    'Search Results': 'Hakutulokset',
    'Search users by email...': 'Hae käyttäjiä sähköpostitse...',
    'Select a truck, driver, pickup date, and delivery date.':
      'Valitse kuorma-auto, kuljettaja, noutopäivä ja toimituspäivä.',
    'Select approved truck': 'Valitse hyväksytty kuorma-auto',
    'Select driver': 'Valitse ohjain',
    'Send Revision': 'Lähetä versio',
    Sentiment: 'Tunnelma',
    'Share what went well and what could improve':
      'Kerro, mikä meni hyvin ja mikä voisi parantaa',
    'Shipment in transit': 'Lähetys kuljetuksessa',
    'Shipment notes': 'Lähetysilmoitukset',
    'Shipment tracking will be shared': 'Lähetyksen seuranta jaetaan',
    'Show AI launchers': 'Näytä AI-laukaisimet',
    'Show or hide AI assistant buttons on supported dashboard and listing pages.':
      'Näytä tai piilota AI-avustajan painikkeet tuetuilla kojelaudalla ja listaussivuilla.',
    'Special needs or notes': 'Erityistarpeita tai huomautuksia',
    'Specify delivery dates': 'Määritä toimituspäivät',
    'Specify pickup dates': 'Määritä noutopäivät',
    Stage: 'Vaihe',
    'Status updated to {{status}}': 'Tila päivitetty {{status}}',
    'Stripe payment confirmed and booking updated':
      'Raitamaksu vahvistettu ja varaus päivitetty',
    'Stripe status: {{status}}': 'Raidan tila: {{status}}',
    'Submit question': 'Lähetä kysymys',
    'Submit review': 'Lähetä arvostelu',
    'Submitting...': 'Lähetetään...',
    'The AI assistant is currently disabled for this environment. Existing local session data can still be cleared here.':
      'AI-avustaja on tällä hetkellä poissa käytöstä tässä ympäristössä. Olemassa olevat paikalliset istuntotiedot voidaan edelleen tyhjentää täällä.',
    'The listing expired before a transport was confirmed.':
      'Listaus vanheni ennen kuljetuksen vahvistamista.',
    'The listing has been fully completed and archived as a finished transport.':
      'Listaus on täysin valmis ja arkistoitu valmiina kuljetuksena.',
    'The lowest net price you would still accept for this shipment.':
      'Alin nettohinta, jonka vielä hyväksyisit tästä lähetyksestä.',
    'The partner has confirmed the route plan. Pickup and delivery dates are now scheduled.':
      'Yhteistyökumppani on vahvistanut reittisuunnitelman. Nouto- ja toimituspäivät on nyt sovittu.',
    'The partner marked the shipment as delivered. Review the final documents and confirm completion.':
      'Kumppani merkitsi lähetyksen toimitetuksi. Tarkista lopulliset asiakirjat ja vahvista valmistuminen.',
    'The partner-confirmed plan and LOA stay grouped together for faster review.':
      'Kumppanin vahvistama suunnitelma ja LOA pysyvät ryhmiteltyinä nopeuttaakseen tarkistusta.',
    'This action notifies the transport provider and removes the quote from active consideration.':
      'Tämä toiminto ilmoittaa kuljetuksen tarjoajalle ja poistaa tarjouksen aktiivisesta käsittelystä.',
    'This listing is archived and no further transport actions are available.':
      'Tämä listaus on arkistoitu, eikä muita kuljetustoimenpiteitä ole saatavilla.',
    'This listing needs an accepted quote before a review can be created.':
      'Nämä tiedot tarvitsevat hyväksytyn tarjouksen, ennen kuin arvostelu voidaan luoda.',
    'This will soft-cancel the listing and move it to your archive.':
      'Tämä peruuttaa tiedot pehmeästi ja siirtää ne arkistoon.',
    'This will soft-cancel the listing for the client and remove it from active marketplace views.':
      'Tämä peruuttaa asiakkaan listauksen pehmeästi ja poistaa sen aktiivisista markkinapaikkanäkymistä.',
    'Total quote': 'Koko tarjous',
    'Tracking not promised': 'Seurantaa ei luvattu',
    'Tracking shared': 'Seuranta jaettu',
    'Tracking visibility': 'Seurannan näkyvyys',
    'Trailer (Optional)': 'Traileri (valinnainen)',
    'Translation preference updated': 'Käännösasetus päivitetty',
    'Transport completed': 'Kuljetus suoritettu',
    'Transport completed.': 'Kuljetus suoritettu.',
    'Transport documents': 'Kuljetusasiakirjat',
    'Transport marked as complete': 'Kuljetus merkitty valmiiksi',
    'Transport package': 'Kuljetuspaketti',
    'Transport plan confirmed': 'Liikennesuunnitelma vahvistettu',
    'Transport plan updated': 'Liikennesuunnitelma päivitetty',
    'Transport planned': 'Kuljetus suunniteltu',
    'Transport Provider': 'Kuljetuksen tarjoaja',
    'Transport providers can review your shipment and send offers.':
      'Kuljetuspalveluntarjoajat voivat tarkistaa lähetyksesi ja lähettää tarjouksia.',
    'Transport stage': 'Kuljetusvaihe',
    Truck: 'Kuorma-auto',
    'Truck, driver, trailer, and planned dates for this shipment.':
      'Kuorma-auto, kuljettaja, perävaunu ja tämän lähetyksen suunnitellut päivämäärät.',
    'Try widening the current listing filters.':
      'Yritä laajentaa nykyisiä listauksen suodattimia.',
    'Unable to upload listing images.': 'Luettelokuvia ei voi ladata.',
    'Unknown error': 'Tuntematon virhe',
    'Untitled listing': 'Nimetön listaus',
    'Untitled Listing': 'Nimetön listaus',
    'Update media': 'Päivitä media',
    'Update transport plan': 'Päivitä liikennesuunnitelma',
    'Update Transport Plan': 'Päivitä liikennesuunnitelma',
    'Upload a CMR or delivery photos before marking delivered.':
      'Lataa CMR- tai toimituskuvat ennen toimitetuksi merkitsemistä.',
    'Upload a CMR or delivery photos before the listing can move to Delivered.':
      'Lataa CMR- tai toimituskuvat, ennen kuin tiedot siirtyvät Toimitettuun.',
    'Upload at least one pickup proof before the listing can move to Picked Up.':
      'Lataa vähintään yksi noutotodistus, ennen kuin tiedot voivat siirtyä Noudettu-kohtaan.',
    'Upload final documents': 'Lataa lopulliset asiakirjat',
    'Upload proof of pickup': 'Lataa noutotodistus',
    'Uploading...': 'Ladataan...',
    'Use fresh photos when the shipment changes or you want to clarify the item condition.':
      'Käytä tuoreita kuvia, kun lähetys muuttuu tai haluat selventää tuotteen kuntoa.',
    'users enabled': 'käyttäjät käytössä',
    'Visible to you while quoting. You can still send your own net offer below or above this amount.':
      'Näkyy sinulle lainauksen aikana. Voit silti lähettää oman nettotarjouksesi tämän summan alle tai yli.',
    'Waiting for partner acceptance': 'Odotetaan kumppanin hyväksyntää',
    'Waiting for transport planning': 'Kuljetussuunnittelua odotellessa',
    'When enabled, messages from other users will be automatically translated to your preferred language.':
      'Kun tämä on käytössä, muiden käyttäjien viestit käännetään automaattisesti haluamallesi kielelle.',
    Withdraw: 'vetäytyä',
    'Write Review': 'Kirjoita arvostelu',
    'You are about to release this listing back to the marketplace.':
      'Olet julkaisemassa tämän listauksen takaisin markkinoille.',
    'You are now the assigned partner for this fixed-price listing.':
      'Olet nyt määrätty kumppani tälle kiinteähintaiselle listalle.',
    'Your quote has been accepted. Awaiting payment confirmation from the admin before you can begin the job.':
      'Tarjouksesi on hyväksytty. Odotetaan maksun vahvistusta järjestelmänvalvojalta ennen kuin voit aloittaa työn.',
    'VIN: {{vin}}': 'VIN: {{vin}}',
  },
  el: {
    Listing: 'Καταχώρηση',
    'Try broadening the current search or status filter.':
      'Δοκιμάστε να διευρύνετε το τρέχον φίλτρο αναζήτησης ή κατάστασης.',
    'Try broadening the search, role, or status filters.':
      'Δοκιμάστε να διευρύνετε τα φίλτρα αναζήτησης, ρόλου ή κατάστασης.',
    'Monitor fleet compliance, validation status, and expiring insurance in one place.':
      'Παρακολουθήστε τη συμμόρφωση του στόλου, την κατάσταση επικύρωσης και την ασφάλιση που λήγει σε ένα μέρος.',
    'Active Listings': 'Ενεργές καταχωρίσεις',
    'Open transport requests': 'Ανοιχτές αιτήσεις μεταφοράς',
    'Quotes Today': 'Αποσπάσματα σήμερα',
    'Submitted in last 24h': 'Υποβλήθηκε τις τελευταίες 24 ώρες',
    'Platform Revenue (MTD)': 'Έσοδα πλατφόρμας (MTD)',
    'Month to date': 'Μήνας μέχρι σήμερα',
    'Pending Partners': 'Συνεργάτες σε εκκρεμότητα',
    'Awaiting approval': 'Εν αναμονή έγκρισης',
    'Unpaid Invoices': 'Απλήρωτα τιμολόγια',
    'Requires action': 'Απαιτεί δράση',
    'Completed Transports': 'Ολοκληρωμένες μεταφορές',
    'All time delivered': 'Παραδίδεται όλο το χρόνο',
    'Admin Dashboard': 'Πίνακας ελέγχου διαχειριστή',
    'Platform overview and key performance indicators.':
      'Επισκόπηση πλατφόρμας και βασικοί δείκτες απόδοσης.',
    'Loading dashboard metrics...': 'Φόρτωση μετρήσεων πίνακα ελέγχου...',
    Invoices: 'τιμολόγια',
    'Review payout invoices uploaded by partners and keep payout processing organized.':
      'Ελέγξτε τα τιμολόγια πληρωμών που ανέβηκαν από συνεργάτες και διατηρήστε οργανωμένη την επεξεργασία πληρωμών.',
    Flexible: 'Ευέλικτο',
    'Flexible dates': 'Ευέλικτες ημερομηνίες',
    'Could not load this listing.':
      'Δεν ήταν δυνατή η φόρτωση αυτής της καταχώρισης.',
    'Listing canceled': 'Η καταχώριση ακυρώθηκε',
    'Failed to cancel listing': 'Η ακύρωση της καταχώρισης απέτυχε',
    Reference: 'Αναφορά',
    Category: 'Κατηγορία',
    'Client type': 'Τύπος πελάτη',
    'Company country': 'Χώρα της εταιρείας',
    Expires: 'Λήγει',
    'Back to listings': 'Επιστροφή στις λίστες',
    'Listing not found.': 'Η καταχώριση δεν βρέθηκε.',
    'Cancel Listing': 'Ακύρωση καταχώρισης',
    'Listing details': 'Λεπτομέρειες καταχώρισης',
    'Reference {{id}}': 'Αναφορά {{id}}',
    'Read-only listing overview for admins.':
      'Επισκόπηση καταχώρισης μόνο για ανάγνωση για διαχειριστές.',
    'Pick-up': 'Παραλαβή',
    'No exact coordinates are stored for this listing yet.':
      'Δεν έχουν αποθηκευτεί ακόμη ακριβείς συντεταγμένες για αυτήν την καταχώριση.',
    'Structured overview of quantities and handling details.':
      'Δομημένη επισκόπηση των ποσοτήτων και των λεπτομερειών χειρισμού.',
    'Shipment images': 'Εικόνες αποστολής',
    'No shipment images were uploaded for this listing.':
      'Δεν μεταφορτώθηκαν εικόνες αποστολής για αυτήν την καταχώριση.',
    'Proof of pickup': 'Απόδειξη παραλαβής',
    'Final documents': 'Τελικά έγγραφα',
    Description: 'Περιγραφή',
    'Quotes ({{count}})': 'Τιμές ({{count}})',
    'Loading quotes...': 'Φόρτωση εισαγωγικών...',
    'No quotes for this listing.':
      'Δεν υπάρχουν προσφορές για αυτήν την καταχώριση.',
    'Score: {{score}}/100': 'Βαθμολογία: {{score}}/100',
    'Pickup: {{date}}': 'Παραλαβή: {{date}}',
    'Delivery: {{date}}': 'Παράδοση: {{date}}',
    'Cancel Listing?': 'Ακύρωση καταχώρισης;',
    'This will permanently cancel the listing and notify the client. Continue?':
      'Αυτό θα ακυρώσει οριστικά την καταχώριση και θα ειδοποιήσει τον πελάτη. Συνεχίζω;',
    Keep: 'Κρατήστε',
    'Review partner applications, check their documents, and keep approval decisions consistent.':
      'Ελέγξτε τις αιτήσεις συνεργατών, ελέγξτε τα έγγραφά τους και διατηρήστε τις αποφάσεις έγκρισης συνεπείς.',
    'No client payments recorded yet':
      'Δεν έχουν καταγραφεί ακόμη πληρωμές πελατών',
    'Client payment rows will appear here when the payments backend is connected.':
      'Οι σειρές πληρωμών πελάτη θα εμφανίζονται εδώ όταν συνδεθεί το backend πληρωμών.',
    Method: 'Μέθοδος',
    'No partner payouts recorded yet':
      'Δεν έχουν καταγραφεί ακόμη πληρωμές συνεργατών',
    'Payout rows will appear here once partner payout processing is enabled.':
      'Οι σειρές πληρωμών θα εμφανίζονται εδώ μόλις ενεργοποιηθεί η επεξεργασία πληρωμών συνεργάτη.',
    'Payout Amount': 'Ποσό πληρωμής',
    'No platform fees recorded yet':
      'Δεν έχουν καταγραφεί ακόμη χρεώσεις πλατφόρμας',
    'Fee rows will appear here once payment settlement data is available.':
      'Οι σειρές χρεώσεων θα εμφανιστούν εδώ μόλις διατεθούν τα δεδομένα διακανονισμού πληρωμών.',
    Gross: 'Ακαθάριστο',
    'Fee (20%)': 'Χρέωση (20%)',
    Payments: 'Πληρωμές',
    'Client payments, partner payouts, and platform fee tracking.':
      'Πληρωμές πελατών, πληρωμές συνεργατών και παρακολούθηση τελών πλατφόρμας.',
    'Client Payments': 'Πληρωμές πελατών',
    'Partner Payouts': 'Πληρωμές συνεργατών',
    'Platform Fees': 'Τέλη πλατφόρμας',
    'Failed to load reviews': 'Αποτυχία φόρτωσης κριτικών',
    'Review removed': 'Η κριτική καταργήθηκε',
    'Failed to remove review': 'Η κατάργηση της κριτικής απέτυχε',
    Reviews: 'Κριτικές',
    'All partner and transport reviews submitted by clients.':
      'Όλες οι κριτικές συνεργατών και μεταφορών που υποβάλλονται από πελάτες.',
    'Loading reviews...': 'Φόρτωση κριτικών...',
    'No reviews found': 'Δεν βρέθηκαν κριτικές',
    'Client feedback will appear here when reviews are submitted.':
      'Τα σχόλια των πελατών θα εμφανίζονται εδώ όταν υποβάλλονται κριτικές.',
    Stars: 'αστέρια',
    Comment: 'Σχόλιο',
    'Search, review, and maintain user accounts with one consistent admin workflow.':
      'Αναζητήστε, ελέγξτε και διατηρήστε λογαριασμούς χρηστών με μια συνεπή ροή εργασίας διαχειριστή.',
    'Track paid and unpaid partner payout invoices, and upload the next delivered listing invoice quickly.':
      'Παρακολουθήστε πληρωμένα και απλήρωτα τιμολόγια πληρωμών συνεργατών και μεταφορτώστε γρήγορα το επόμενο τιμολόγιο καταχώρισης που παραδόθηκε.',
    'Search by invoice number, file name, or listing ID':
      'Αναζήτηση με αριθμό τιμολογίου, όνομα αρχείου ή αναγνωριστικό καταχώρισης',
    'Loading delivered listings...': 'Φόρτωση παραδοτέων καταχωρίσεων...',
    'Search delivered listing by reference, title, or route':
      'Αναζήτηση παραδοθείσας καταχώρισης με αναφορά, τίτλο ή διαδρομή',
    'Route details available in listing':
      'Λεπτομέρειες διαδρομής είναι διαθέσιμες στην καταχώριση',
    'No matching delivered listings':
      'Δεν υπάρχουν παραδοτέες καταχωρίσεις που να ταιριάζουν',
    'Selected listing': 'Επιλεγμένη καταχώριση',
    'Has quotes': 'Έχει εισαγωγικά',
    'In transit': 'Κατά τη μεταφορά',
    Open: 'Ανοίξτε',
    Accepted: 'Αποδεκτό',
    Completed: 'Ολοκληρώθηκε',
    'Client Dashboard': 'Πίνακας ελέγχου πελάτη',
    'Overview of your current transport listings, quote activity, and recent requests.':
      'Επισκόπηση των τρεχουσών καταχωρίσεων μεταφοράς, της δραστηριότητας προσφορών και των πρόσφατων αιτημάτων σας.',
    'Total listings': 'Σύνολο καταχωρίσεων',
    'Active listings': 'Ενεργές καταχωρίσεις',
    'Listings with quotes': 'Καταχωρήσεις με εισαγωγικά',
    'Accepted transport': 'Αποδεκτή μεταφορά',
    'Listing status timeline': 'Χρονολόγιο κατάστασης καταχώρισης',
    'Last 6 months of listings grouped by current status.':
      'Οι τελευταίοι 6 μήνες καταχωρίσεων ομαδοποιούνται με βάση την τρέχουσα κατάσταση.',
    'No listing activity yet': 'Δεν υπάρχει δραστηριότητα καταχώρισης ακόμα',
    'Create your first listing to start tracking request activity here.':
      'Δημιουργήστε την πρώτη σας καταχώριση για να ξεκινήσετε την παρακολούθηση της δραστηριότητας αιτημάτων εδώ.',
    'Create new listing': 'Δημιουργία νέας καταχώρισης',
    'Create a new transport request for the marketplace.':
      'Δημιουργήστε ένα νέο αίτημα μεταφοράς για την αγορά.',
    'View my listings': 'Δείτε τις καταχωρίσεις μου',
    'Review quote activity and manage your transport requests.':
      'Ελέγξτε τη δραστηριότητα προσφοράς και διαχειριστείτε τα αιτήματά σας για μεταφορά.',
    'Recent listings': 'Πρόσφατες καταχωρίσεις',
    'No listings yet': 'Δεν υπάρχουν καταχωρήσεις ακόμα',
    'Your newest transport requests will appear here once you create them.':
      'Τα πιο πρόσφατα αιτήματα μεταφοράς θα εμφανιστούν εδώ μόλις τα δημιουργήσετε.',
    'Unknown origin': 'Άγνωστη προέλευση',
    '{{count}} quote(s)': '{{count}} προσφορά',
    '{{value}} completed listings': '{{value}} ολοκληρωμένες καταχωρίσεις',
    'Monitor current performance, fleet readiness, quote flow, and your active transport queue.':
      'Παρακολουθήστε την τρέχουσα απόδοση, την ετοιμότητα του στόλου, τη ροή των προσφορών και την ενεργή ουρά μεταφοράς σας.',
    'Total assigned': 'Σύνολο εκχωρήθηκε',
    'Quarter rating': 'Βαθμολογία τριμήνου',
    'Based on current quarter performance':
      'Με βάση την απόδοση του τρέχοντος τριμήνου',
    Rating: 'Βαθμολογία',
    'Requirement met': 'Η απαίτηση ικανοποιήθηκε',
    'Requirement not met': 'Η απαίτηση δεν πληρούται',
    'Completed listings per period': 'Ολοκληρωμένες καταχωρίσεις ανά περίοδο',
    'No completion data yet': 'Δεν υπάρχουν ακόμη στοιχεία ολοκλήρωσης',
    'Statistics will appear here after your first delivered work.':
      'Τα στατιστικά στοιχεία θα εμφανιστούν εδώ μετά την πρώτη παραδοθείσα εργασία σας.',
    'Completed listings': 'Ολοκληρωμένες καταχωρίσεις',
    'Review truck documents and refresh anything close to expiry.':
      'Ελέγξτε τα έγγραφα του φορτηγού και ανανεώστε οτιδήποτε βρίσκεται κοντά στη λήξη.',
    'Search deliveries': 'Αναζήτηση παραδόσεων',
    'Review available marketplace listings and submit quotes.':
      'Ελέγξτε τις διαθέσιμες καταχωρίσεις στην αγορά και υποβάλετε προσφορές.',
    'My quotes': 'Τα αποσπάσματα μου',
    'Track accepted, pending, and rejected quotes in one place.':
      'Παρακολουθήστε αποδεκτές, εκκρεμείς και απορριφθείσες προσφορές σε ένα μέρος.',
    'Profile settings': 'Ρυθμίσεις προφίλ',
    'Keep company information and compliance details up to date.':
      'Διατηρείτε ενημερωμένες τις πληροφορίες της εταιρείας και τις λεπτομέρειες συμμόρφωσης.',
    'No active queue items': 'Δεν υπάρχουν ενεργά στοιχεία ουράς',
    'Accepted and in-progress work will appear here as your transport activity grows.':
      'Οι αποδεκτές και οι εργασίες σε εξέλιξη θα εμφανίζονται εδώ καθώς αυξάνεται η μεταφορική σας δραστηριότητα.',
    'Your role does not have permission to open this page.':
      'Ο ρόλος σας δεν έχει άδεια να ανοίξει αυτήν τη σελίδα.',
    'Go to dashboard': 'Μεταβείτε στον πίνακα ελέγχου',
    'Trailer capacity is required.': 'Απαιτείται χωρητικότητα ρυμουλκούμενου.',
    'How many cars can this trailer carry?':
      'Πόσα αυτοκίνητα μπορεί να μεταφέρει αυτό το τρέιλερ;',
    'Set maximum number of cars this trailer can carry (1-20).':
      'Ορίστε τον μέγιστο αριθμό αυτοκινήτων που μπορεί να μεταφέρει αυτό το τρέιλερ (1-20).',
    'Invalid max load (kg).': 'Μη έγκυρο μέγιστο φορτίο (kg).',
    'Enter a valid weight between 1 and 100000 kg, or leave it empty.':
      'Εισαγάγετε ένα έγκυρο βάρος μεταξύ 1 και 100000 kg ή αφήστε το κενό.',
    'Maximum payload weight this truck can carry (optional).':
      'Μέγιστο βάρος ωφέλιμου φορτίου που μπορεί να μεταφέρει αυτό το φορτηγό (προαιρετικό).',
    'Manage the company and contact details that appear across your listings, invoices, and account verification flows.':
      'Διαχειριστείτε την εταιρεία και τα στοιχεία επικοινωνίας που εμφανίζονται στις καταχωρίσεις, τα τιμολόγια και τις ροές επαλήθευσης του λογαριασμού σας.',
    'Keep these details up to date so listings, invoices, and partner verification stay accurate.':
      'Διατηρήστε αυτές τις λεπτομέρειες ενημερωμένες, ώστε οι καταχωρίσεις, τα τιμολόγια και η επαλήθευση συνεργάτη να παραμένουν ακριβείς.',
    'Unsaved changes': 'Μη αποθηκευμένες αλλαγές',
    'All changes saved': 'Όλες οι αλλαγές αποθηκεύτηκαν',
    'auth.the_email_address_is_not_valid':
      'Η διεύθυνση email δεν είναι έγκυρη.',
    'auth.this_account_has_been_disabled':
      'Αυτός ο λογαριασμός έχει απενεργοποιηθεί.',
    'auth.no_account_found_with_this_email':
      'Δεν βρέθηκε λογαριασμός με αυτό το email.',
    'auth.too_many_failed_attempts_please_try_again_later_or_reset_your_password':
      'Πάρα πολλές αποτυχημένες προσπάθειες. Δοκιμάστε ξανά αργότερα ή επαναφέρετε τον κωδικό πρόσβασής σας.',
    'auth.network_error_check_your_connection_and_try_again':
      'Σφάλμα δικτύου. Ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.',
    'auth.sign_up_failed': 'Η εγγραφή απέτυχε',
    'auth.verification_email_resent': 'Το email επαλήθευσης στάλθηκε εκ νέου',
    'auth.please_check_your_inbox': 'Ελέγξτε τα εισερχόμενά σας.',
    'auth.you_need_to_log_in_first': 'Πρέπει πρώτα να συνδεθείτε.',
    'auth.please_sign_in_to_resend_the_verification_email':
      'Συνδεθείτε για να στείλετε ξανά το email επαλήθευσης.',
    'auth.please_select_a_valid_role': 'Επιλέξτε έναν έγκυρο ρόλο.',
    'booking.pickup_not_found': 'Η παραλαβή δεν βρέθηκε.',
    'booking.delivery_not_found': 'Η παράδοση δεν βρέθηκε.',
    'booking.profile_incomplete_partner_message':
      'Συμπληρώστε τα στοιχεία της εταιρείας σας (Επωνυμία, ΑΦΜ, Διεύθυνση, Πόλη, Τ.Κ., Τηλέφωνο) πριν αποδεχτείτε τις παραγγελίες.',
    'booking.profile_incomplete_partner_short':
      'Συμπληρώστε τα στοιχεία της εταιρείας σας για να δεχθείτε παραγγελίες.',
    'booking.not_set': 'Δεν έχει οριστεί',
    'booking.capacity': 'χωρητικότητα',
    'booking.cmr_expiry': 'Λήξη CMR',
    'booking.weight_kg': 'Βάρος (kg)',
    'booking.uploaded': 'Μεταφορτώθηκε',
    'booking.missing': 'Λείπει',
    'booking.cmr_document': 'Έγγραφο CMR',
    'Finalize the handover plan with scheduling cues, site availability, and sustainability preferences. This view keeps everything critical in one place without repeating details from earlier steps.':
      'Ολοκληρώστε το σχέδιο παράδοσης με ενδείξεις προγραμματισμού, διαθεσιμότητα τοποθεσίας και προτιμήσεις βιωσιμότητας. Αυτή η προβολή διατηρεί τα πάντα κρίσιμα σε ένα μέρος χωρίς να επαναλαμβάνει λεπτομέρειες από προηγούμενα βήματα.',
    'Preferences & notes': 'Προτιμήσεις & σημειώσεις',
    'Loading notifications': 'Φόρτωση ειδοποιήσεων',
    None: 'Κανένα',
    '1 day before': '1 μέρα πριν',
    '2 days before': '2 μέρες πριν',
    '1 week before': '1 εβδομάδα πριν',
    'Sustainability options': 'Επιλογές βιωσιμότητας',
    'Offset CO₂ emissions for this shipment':
      'Αντιστάθμιση εκπομπών CO₂ για αυτήν την αποστολή',
    'Prefer biofuel usage where available':
      'Προτιμήστε τη χρήση βιοκαυσίμων όπου είναι διαθέσιμο',
    'Environmental or compliance notes':
      'Σημειώσεις για το περιβάλλον ή τη συμμόρφωση',
    'Share green requirements, certification numbers, or carbon reporting needs.':
      'Μοιραστείτε τις πράσινες απαιτήσεις, τους αριθμούς πιστοποίησης ή τις ανάγκες αναφοράς άνθρακα.',
    Previous: 'Προηγούμενο',
    Next: 'Επόμενο',
    'Select Pick up Date': 'Επιλέξτε Ημερομηνία παραλαβής',
    'Select the date when the cargo is to be picked up.':
      'Επιλέξτε την ημερομηνία που θα παραληφθεί το φορτίο.',
    'Select Delivery Date': 'Επιλέξτε Ημερομηνία Παράδοσης',
    'Select the date when the cargo is to be delivered.':
      'Επιλέξτε την ημερομηνία παράδοσης του φορτίου.',
    'Vehicle pickup location': 'Τοποθεσία παραλαβής οχήματος',
    'Vehicle delivery location': 'Τοποθεσία παράδοσης οχήματος',
    'Route preview': 'Προεπισκόπηση διαδρομής',
    'Provide both pickup and delivery postal codes to preview the lane on the map.':
      'Καταχωρίστε τους ταχυδρομικούς κωδικούς παραλαβής και παράδοσης για προεπισκόπηση της λωρίδας στο χάρτη.',
    'No contact set': 'Δεν έχει οριστεί επαφή',
    'Vehicles scheduled': 'Προγραμματισμένα οχήματα',
    'Quoted price': 'Αναφερόμενη τιμή',
    'Excl. any partner fees': 'Εξαιρ. τυχόν αμοιβές συνεργατών',
    'No vehicles added yet.': 'Δεν έχουν προστεθεί ακόμη οχήματα.',
    'Recalculate price': 'Υπολογίστε ξανά την τιμή',
    'Add at least one vehicle.': 'Προσθέστε τουλάχιστον ένα όχημα.',
    'Add the vehicle weight.': 'Προσθέστε το βάρος του οχήματος.',
    'Add at least one pickup time window.':
      'Προσθέστε τουλάχιστον ένα παράθυρο χρόνου παραλαβής.',
    'Confirm the pickup opening hours.':
      'Επιβεβαιώστε τις ώρες λειτουργίας της παραλαβής.',
    'Pickup date must be selected.':
      'Πρέπει να επιλεγεί η ημερομηνία παραλαβής.',
    'Add at least one delivery time window.':
      'Προσθέστε τουλάχιστον ένα παράθυρο χρόνου παράδοσης.',
    'Confirm the delivery opening hours.':
      'Επιβεβαιώστε τις ώρες λειτουργίας παράδοσης.',
    'Add a weight for each vehicle.': 'Προσθέστε ένα βάρος για κάθε όχημα.',
    'One of the locations could not be positioned on the map.':
      'Δεν ήταν δυνατή η τοποθέτηση μιας από τις τοποθεσίες στον χάρτη.',
    'Unable to load the map preview right now.':
      'Δεν είναι δυνατή η φόρτωση της προεπισκόπησης χάρτη αυτήν τη στιγμή.',
    'Quote updated': 'Η προσφορά ενημερώθηκε',
    'Estimated total client price €{{price}}':
      'Εκτιμώμενη συνολική τιμή πελάτη €{{price}}',
    'Complete missing data': 'Συμπληρώστε δεδομένα που λείπουν',
    'Finish each step before creating the booking.':
      'Ολοκληρώστε κάθε βήμα πριν δημιουργήσετε την κράτηση.',
    'User not logged in': 'Ο χρήστης δεν είναι συνδεδεμένος',
    'Booking created': 'Η κράτηση δημιουργήθηκε',
    'Your transport request is now visible under My Orders.':
      'Το αίτημα μεταφοράς σας είναι πλέον ορατό στην ενότητα Οι παραγγελίες μου.',
    'Booking failed': 'Η κράτηση απέτυχε',
    Bookings: 'Κρατήσεις',
    Trucks: 'Φορτηγά',
    Drivers: 'Οδηγοί',
    'Booking was created but no id returned.':
      'Η κράτηση δημιουργήθηκε αλλά δεν επέστρεψε κανένα αναγνωριστικό.',
    'Error creating booking': 'Σφάλμα κατά τη δημιουργία κράτησης',
    'An unexpected error occurred.': 'Παρουσιάστηκε απροσδόκητο σφάλμα.',
    'Fill in the address and contact person. This helps dispatch align pickups with logistics partners.':
      'Συμπληρώστε τη διεύθυνση και το άτομο επικοινωνίας. Αυτό βοηθά στην αποστολή να ευθυγραμμιστούν τα pickups με τους συνεργάτες logistics.',
    'Loading only possible from 08:00 to 17:00. Ask for Johan.':
      'Η φόρτωση είναι δυνατή μόνο από τις 08:00 έως τις 17:00. Ζητήστε τον Γιόχαν.',
    'Avoid additional costs by sharing the exact depot availability.':
      'Αποφύγετε επιπλέον κόστος κοινοποιώντας την ακριβή διαθεσιμότητα της αποθήκης.',
    'Avoid missed trips by matching the window the truck can enter the premises.':
      'Αποφύγετε τα χαμένα ταξίδια ταιριάζοντας με το παράθυρο που μπορεί να εισέλθει το φορτηγό στις εγκαταστάσεις.',
    'I confirm the pickup opening hours':
      'Επιβεβαιώνω τις ώρες λειτουργίας της παραλαβής',
    'I confirm the delivery opening hours':
      'Επιβεβαιώνω τις ώρες λειτουργίας παράδοσης',
    to: 'να',
    Closed: 'Κλειστό',
    Mo: 'Μο',
    Tu: 'Tu',
    We: 'Εμείς',
    Th: 'Th',
    Fr: 'Ο π',
    Sa: 'Sa',
    Su: 'Su',
    Monday: 'Δευτέρα',
    Tuesday: 'Τρίτη',
    Wednesday: 'Τετάρτη',
    Thursday: 'Πέμπτη',
    Friday: 'Παρασκευή',
    Saturday: 'Σάββατο',
    Sunday: 'Κυριακή',
    'e.g. 2200': 'π.χ. 2200',
    'X vehicle(s)': '{{count}} όχημα(α)',
    'X total': '{{count}} σύνολο',
    kg: 'κιλά',
    'Weight (kg)*': 'Βάρος (kg)*',
    'Length (cm)': 'Μήκος (cm)',
    'Height (cm)': 'Ύψος (cm)',
    'Width (cm)': 'Πλάτος (cm)',
    'Dimensions (cm)': 'Διαστάσεις (cm)',
    'Make / Model': 'Μάρκα / Μοντέλο',
    'Chassis Number/Licence plate':
      'Αριθμός πλαισίου/Πινακίδα άδειας κυκλοφορίας',
    'Fill in the details and specify the parameters for every vehicle type.':
      'Συμπληρώστε τα στοιχεία και καθορίστε τις παραμέτρους για κάθε τύπο οχήματος.',
    'Calculate a price to proceed.': 'Υπολογίστε μια τιμή για να συνεχίσετε.',
    'Zip Code': 'Ταχυδρομικός Κώδικας',
    'Delivery Country': 'Χώρα παράδοσης',
    'Pickup Country': 'Χώρα παραλαβής',
    'Calculate price': 'Υπολογίστε την τιμή',
    Compact: 'Συμπαγές',
    Hatchback: 'Χάτσμπακ',
    Coupé: 'Κουπέ',
    Superauto: 'Υπεραυτόματο',
    Sedan: 'Σεντάν',
    'Station Wagon': 'Station Wagon',
    Crossover: 'Crossover',
    'Transport Car': 'Αυτοκίνητο μεταφοράς',
    Van: 'Van',
    'Provide route details': 'Δώστε λεπτομέρειες διαδρομής',
    'City not set': 'Η πόλη δεν έχει οριστεί',
    From: 'Από',
    To: 'προς',
    'Body type': 'Σωματότυπος',
    'Remove vehicle': 'Αφαιρέστε το όχημα',
    'Vehicle type': 'Τύπος οχήματος',
    'Non-runner': 'Μη δρομέας',
    'Avg. weight (kg)': 'Μέσος όρος βάρος (kg)',
    'Provide an estimated weight to calculate price.':
      'Δώστε ένα εκτιμώμενο βάρος για τον υπολογισμό της τιμής.',
    'Pickup document': 'Έγγραφο παραλαβής',
    'Upload or drag & drop. Accepted: .jpg, .png, .pdf, .docx, .xls':
      'Μεταφόρτωση ή μεταφορά και απόθεση. Αποδεκτό: .jpg, .png, .pdf, .docx, .xls',
    'Remove file': 'Κατάργηση αρχείου',
    'Choose file': 'Επιλέξτε αρχείο',
    'Company name': 'Επωνυμία εταιρείας',
    'Contact person': 'Υπεύθυνος επικοινωνίας',
    'Contact language': 'Γλώσσα επικοινωνίας',
    'Contact phone': 'Τηλέφωνο επικοινωνίας',
    'Contact email': 'Email επικοινωνίας',
    'Loading address is logistic centre':
      'Η διεύθυνση φόρτωσης είναι κέντρο υλικοτεχνικής υποστήριξης',
    'Documents needed on site': 'Έγγραφα που απαιτούνται επί τόπου',
    'Pick up document': 'Παραλαβή εγγράφου',
    'Pick up code': 'Κωδικός παραλαβής',
    'Vehicle registration': 'Εγγραφή οχήματος',
    'Notes for the partner': 'Σημειώσεις για τον συνεργάτη',
    'Local time': 'Τοπική ώρα',
    'Add time': 'Προσθέστε χρόνο',
    'Remove time slot': 'Αφαιρέστε τη χρονική υποδοχή',
    'Keep an eye on the quote as you tweak route details or vehicle mix.':
      'Παρακολουθήστε την προσφορά καθώς τροποποιείτε τις λεπτομέρειες της διαδρομής ή το μείγμα οχημάτων.',
    'Transit time: {{hours}}h': 'Χρόνος διέλευσης: {{hours}}h',
    'Calculate to preview your quote.':
      'Υπολογίστε για να κάνετε προεπισκόπηση της προσφοράς σας.',
    total: 'σύνολο',
    Required: 'Απαιτείται',
    'Add vehicle': 'Προσθήκη οχήματος',
    'Route details': 'Λεπτομέρειες διαδρομής',
    'Latest quote preview': 'Τελευταία προεπισκόπηση προσφοράς',
    or: 'ή',
    'Enter manual price': 'Εισαγάγετε μη αυτόματη τιμή',
    Lane: 'Lane',
    'Distance & time': 'Απόσταση & χρόνος',
    'Change language': 'Άλλαξε γλώσσα',
    'Loading...': 'Φόρτωση…',
    'Error:': 'Σφάλμα:',
    Close: 'Κλείσιμο',
    Confirm: 'Επιβεβαίωση',
    Yes: 'Ναι',
    No: 'Όχι',
    'Keep order': 'Κρατήστε την τάξη',
    'Order ID': 'Ταυτότητα παραγγελίας',
    Date: 'Ημερομηνία',
    'Ready from': 'Έτοιμοι από',
    'Latest pick up': 'Τελευταία παραλαβή',
    Price: 'Τιμή',
    Status: 'Κατάσταση',
    'Payment status': 'Κατάσταση πληρωμής',
    'Customer information': 'Πληροφορίες πελατών',
    'Additional information': 'Πρόσθετες πληροφορίες',
    'Documents & damages': 'Έγγραφα & ζημιές',
    'Purchase terms': 'Όροι αγοράς',
    'Power of attorney': 'πληρεξούσιο',
    Damages: 'Ζημιές',
    'No files': 'Δεν υπάρχουν αρχεία',
    Performance: 'Απόδοση',
    'Transport details': 'Λεπτομέρειες μεταφοράς',
    Schedule: 'Πρόγραμμα',
    Driver: 'Οδηγός',
    'License plate': 'πινακίδα κυκλοφορίας',
    'Vehicle details': 'Στοιχεία οχήματος',
    Vehicle: 'Όχημα',
    'Chassis number': 'Αριθμός πλαισίου',
    Width: 'Πλάτος',
    Height: 'Ύψος',
    Length: 'Μήκος',
    Weight: 'Βάρος',
    'Extra wheels': 'Επιπλέον τροχοί',
    Towing: 'Ρυμούλκηση',
    'Electric / Hybrid': 'Ηλεκτρικό / Υβριδικό',
    'Copy vehicle details': 'Αντιγράψτε τα στοιχεία του οχήματος',
    'Upload damages': 'Ανεβάστε ζημιές',
    'Download (PDF)': 'Λήψη (PDF)',
    'Mark as picked up': 'Επισήμανση ως παραλήφθηκε',
    'Mark as delivered': 'Επισήμανση ως παράδοσης',
    'Cancel order': 'Ακύρωση παραγγελίας',
    'Cancel booking': 'Ακύρωση κράτησης',
    'Are you sure you want to cancel order {{id}}? This action cannot be undone.':
      'Είστε βέβαιοι ότι θέλετε να ακυρώσετε την παραγγελία {{id}}; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
    'Order marked as picked up': 'Η παραγγελία επισημάνθηκε ως παραλήφθηκε',
    'Order marked as delivered': 'Η παραγγελία επισημάνθηκε ως παραδοθείσα',
    'Order canceled': 'Η παραγγελία ακυρώθηκε',
    'Failed to cancel order': 'Η ακύρωση της παραγγελίας απέτυχε',
    'Added {{count}} file(s)': 'Προστέθηκαν αρχεία {{count}}',
    Pages: 'Σελίδες',
    'Awaiting Verification': 'Αναμονή επαλήθευσης',
    'View Profile': 'Προβολή Προφίλ',
    'Profile Incomplete': 'Ημιτελές προφίλ',
    'Please complete your profile information (Company, Phone, Address, City, Post Code) to access all features.':
      'Συμπληρώστε τα στοιχεία του προφίλ σας (Εταιρία, Τηλέφωνο, Διεύθυνση, Πόλη, Ταχυδρομικός Κώδικας) για να αποκτήσετε πρόσβαση σε όλες τις λειτουργίες.',
    'Go to Profile': 'Μεταβείτε στο Προφίλ',
    'Forgot Password': 'Ξέχασα τον κωδικό πρόσβασης',
    Hello: 'Γεια σας',
    friend: 'φίλος',
    'Book your transport': 'Κάντε κράτηση για τη μεταφορά σας',
    'fast and easy': 'γρήγορα και εύκολα',
    Route: 'Διαδρομή',
    Summary: 'Περίληψη',
    'Keep an eye on the route and quote at a glance.':
      'Παρακολουθήστε τη διαδρομή και αναφέρετε με μια ματιά.',
    'Estimated price': 'Εκτιμώμενη τιμή',
    'VIP price': 'Τιμή VIP',
    'Valid until {{date}}': 'Ισχύει έως {{date}}',
    'Transit time: ~{{hours}}h': 'Χρόνος διέλευσης: ~{{hours}}h',
    Origin: 'Προέλευση',
    Destination: 'Προορισμός',
    'Postal code': 'Ταχυδρομικός κώδικας',
    'Calculate to preview': 'Υπολογίστε για προεπισκόπηση',
    'Speed Score': 'Βαθμολογία ταχύτητας',
    "Can't be calculated yet": 'Δεν μπορεί να υπολογιστεί ακόμα',
    'Planning Score': 'Βαθμολογία προγραμματισμού',
    'Accurate Planning': 'Ακριβής Σχεδιασμός',
    'No Change of plans': 'Καμία αλλαγή σχεδίων',
    Preplanned: 'Προσχεδιασμένο',
    Planned: 'Προγραμματισμένη',
    'Picked up': 'Σήκωσε',
    Delivered: 'Παραδόθηκε',
    Canceled: 'Ακυρώθηκε',
    Unknown: 'Άγνωστο',
    Paid: 'Πληρωμένη',
    'Awaiting payment': 'Αναμονή πληρωμής',
    'Awaiting payment badge': 'Αναμονή πληρωμής',
    'Ref {{id}}': 'Αναφ. {{id}}',
    'Planned pickup date': 'Προγραμματισμένη ημερομηνία παραλαβής',
    'Planned arrival date': 'Προγραμματισμένη ημερομηνία άφιξης',
    'Change planning': 'Αλλαγή προγραμματισμού',
    'Change driver': 'Αλλαγή προγράμματος οδήγησης',
    'Pickup contact': 'Επικοινωνία παραλαβής',
    'Delivery contact': 'Επικοινωνία παράδοσης',
    Pickup: 'Παραλαβή',
    Delivery: 'Παράδοση',
    Vehicles: 'Οχήματα',
    'No vehicles listed': 'Δεν αναφέρονται οχήματα',
    Quantity: 'Ποσότητα',
    'VIN / Chassis': 'VIN / Πλαίσιο',
    Info: 'Πληροφορίες',
    Beneficiary: 'Δικαιούχος',
    Address: 'Διεύθυνση',
    Bank: 'Τράπεζα',
    'Order not found.': 'Η παραγγελία δεν βρέθηκε.',
    'Not available': 'Μη διαθέσιμο',
    'For {{date}}': 'Για {{date}}',
    'Picked on {{date}}': 'Επιλέχτηκε με {{date}}',
    'Delivered on {{date}}': 'Παράδοση στα {{date}}',
    'Loading notification: {{value}}': 'Ειδοποίηση φόρτωσης: {{value}}',
    'CO₂ compensation: {{value}}': 'Αντιστάθμιση CO₂: {{value}}',
    'Bio fuel: {{value}}': 'Βιοκαύσιμο: {{value}}',
    Remove: 'Αφαίρεση',
    'Payment reference': 'Αναφορά πληρωμής',
    'Use the details below to transfer the outstanding balance. Always include the reference so we can match your payment to the correct order.':
      'Χρησιμοποιήστε τις παρακάτω λεπτομέρειες για να μεταφέρετε το οφειλόμενο υπόλοιπο. Να συμπεριλαμβάνετε πάντα την αναφορά, ώστε να μπορούμε να αντιστοιχίσουμε την πληρωμή σας στη σωστή παραγγελία.',
    'Got it': 'Κατάλαβα',
    'Copy {{label}}': 'Αντιγραφή {{label}}',
    'Open navigation menu': 'Ανοίξτε το μενού πλοήγησης',
    'Open menu': 'Άνοιγμα μενού',
    'System ID': 'Αναγνωριστικό συστήματος',
    'Human ID': 'Ανθρώπινη ταυτότητα',
    'Client Price': 'Τιμή πελάτη',
    'Partner Price': 'Τιμή συνεργάτη',
    'View Details': 'Προβολή λεπτομερειών',
    'Cancel Booking': 'Ακύρωση κράτησης',
    'Mark as Paid': 'Επισήμανση ως πληρωμένη',
    'Mark booking as paid?': 'Επισήμανση της κράτησης ως πληρωμένης;',
    'This will mark the booking as paid. Continue?':
      'Αυτό θα επισημάνει την κράτηση ως πληρωμένη. Συνεχίζω;',
    'Cancel booking?': 'Ακύρωση κράτησης;',
    'This action cannot be undone': 'Αυτή η ενέργεια δεν μπορεί να αναιρεθεί',
    'Keep Booking': 'Συνεχίστε την κράτηση',
    'Yes, Cancel': 'Ναι, Ακύρωση',
    'Failed to load owner information':
      'Απέτυχε η φόρτωση των πληροφοριών κατόχου',
    'Unexpected error': 'Απροσδόκητο σφάλμα',
    'Booking marked as paid successfully!':
      'Η κράτηση επισημάνθηκε ως πληρωμένη με επιτυχία!',
    'Failed to mark booking as paid':
      'Αποτυχία επισήμανσης της κράτησης ως πληρωμένης',
    'Booking canceled successfully!': 'Η κράτηση ακυρώθηκε με επιτυχία!',
    'Failed to cancel booking': 'Η ακύρωση της κράτησης απέτυχε',
    'Review Unpaid Bookings': 'Ελέγξτε τις κρατήσεις χωρίς πληρωμή',
    'Manage All Trucks': 'Διαχείριση όλων των φορτηγών',
    'Monitor every booking with the same clarity as the New Order wizard. Filter by lane, status, or time window and jump into the details faster.':
      'Παρακολουθήστε κάθε κράτηση με την ίδια σαφήνεια όπως ο οδηγός Νέας Παραγγελίας. Φιλτράρετε ανά λωρίδα, κατάσταση ή χρονικό παράθυρο και μεταβείτε στις λεπτομέρειες πιο γρήγορα.',
    'Open filters': 'Ανοίξτε τα φίλτρα',
    'Orders refresh automatically every 5 minutes.':
      'Οι παραγγελίες ανανεώνονται αυτόματα κάθε 5 λεπτά.',
    'Refresh now': 'Ανανέωση τώρα',
    'Filter orders': 'Φιλτράρισμα παραγγελιών',
    'No orders match your filter.':
      'Καμία παραγγελία δεν ταιριάζει με το φίλτρο σας.',
    'Error fetching data': 'Σφάλμα κατά την ανάκτηση δεδομένων',
    'Not set': 'Δεν έχει οριστεί',
    'Add to watchlist': 'Προσθήκη στη λίστα παρακολούθησης',
    'Remove from watchlist': 'Κατάργηση από τη λίστα παρακολούθησης',
    'Open map': 'Άνοιγμα χάρτη',
    'Pick up': 'Σήκωσε',
    'Opening hours': 'Ώρες λειτουργίας',
    'Route map': 'Χάρτης διαδρομής',
    'No opening hours provided': 'Δεν παρέχονται ώρες λειτουργίας',
    'Arrival Date': 'Ημερομηνία Άφιξης',
    'Pickup Date': 'Ημερομηνία παραλαβής',
    Point: 'Σημείο',
    Country: 'Χώρα',
    Location: 'Τοποθεσία',
    'Current price': 'Τρέχουσα τιμή',
    Distance: 'Απόσταση',
    Estimated: 'Εκτιμώμενος',
    Accept: 'Αποδοχή',
    Autobid: 'Αυτόματη προσφορά',
    'Set Autobid': 'Ορίστε την Αυτόματη Προσφορά',
    'Maximum price': 'Μέγιστη τιμή',
    'e.g. 200': 'π.χ. 200',
    Save: 'Αποθήκευση',
    'Select Planned Date': 'Επιλέξτε Προγραμματισμένη ημερομηνία',
    'Select Truck and Driver': 'Επιλέξτε Truck and Driver',
    'Please select a planned date': 'Επιλέξτε μια προγραμματισμένη ημερομηνία',
    'Please select a driver and truck': 'Επιλέξτε οδηγό και φορτηγό',
    'Order accepted for {{date}}': 'Δεκτή παραγγελία για {{date}}',
    'Failed to accept': 'Αποτυχία αποδοχής',
    'booking.go_to_profile': 'Μεταβείτε στο Προφίλ',
    'booking.click_to_download_purchase_terms':
      'Κάντε κλικ για λήψη των Όρων Αγοράς',
    'admin.purchase_terms_management': 'Διαχείριση Όρων Αγοράς',
    'admin.purchase_terms_management_subtitle':
      'Μεταφορτώστε και διατηρήστε μεταφρασμένους Όρους Αγοράς PDF που χρησιμοποιούνται για την αποδοχή παραγγελιών συνεργάτη.',
    'admin.document_language': 'Γλώσσα εγγράφου',
    'admin.click_to_download_purchase_terms':
      'Κάντε κλικ για λήψη των Όρων Αγοράς',
    'admin.current_language_label': 'Τρέχουσα γλώσσα: {{language}}',
    'admin.purchase_terms_unavailable_for_selected_language':
      'Το έγγραφο όρων αγοράς δεν είναι διαθέσιμο για την επιλεγμένη γλώσσα.',
    'Download and review the active purchase terms in your current interface language before continuing.':
      'Κάντε λήψη και ελέγξτε τους ενεργούς όρους αγοράς στην τρέχουσα γλώσσα διεπαφής πριν συνεχίσετε.',
    'We make agreements and conclude a contract for the carriage of goods. I have just read this agreement in full and agree to its contents.':
      'Κάνουμε συμφωνίες και συνάπτουμε σύμβαση για τη μεταφορά εμπορευμάτων. Μόλις διάβασα πλήρως αυτήν τη συμφωνία και συμφωνώ με το περιεχόμενό της.',
    'I confirm that I will schedule this order within 24 hours':
      'Επιβεβαιώνω ότι θα προγραμματίσω αυτήν την παραγγελία εντός 24 ωρών',
    'Failed to load purchase terms document.':
      'Η φόρτωση του εγγράφου όρων αγοράς απέτυχε.',
    'Autobid set up to {{price}}': 'Ρύθμιση αυτόματης προσφοράς έως {{price}}',
    'Select a Truck': 'Επιλέξτε ένα φορτηγό',
    'Select a Trailer': 'Επιλέξτε ένα τρέιλερ',
    'Select a Driver': 'Επιλέξτε ένα πρόγραμμα οδήγησης',
    All: 'Όλα',
    'Search by ID, ref, city...': 'Αναζήτηση με ταυτότητα, αναφορά, πόλη...',
    'Pick up country': 'Πάρτε χώρα',
    'Pick up city': 'Πάρτε την πόλη',
    'Delivery country': 'Χώρα παράδοσης',
    'Delivery city': 'Πόλη παράδοσης',
    'Min cars': 'Ελάχιστα αυτοκίνητα',
    'Max cars': 'Max αυτοκίνητα',
    'Loading notification': 'Φόρτωση ειδοποίησης',
    Email: 'Email',
    'Favorite routes stay saved for quick access.':
      'Οι αγαπημένες διαδρομές παραμένουν αποθηκευμένες για γρήγορη πρόσβαση.',
    'Apply filters': 'Εφαρμόστε φίλτρα',
    Clear: 'Καθαρό',
    'Save preset': 'Αποθήκευση προεπιλογής',
    'Saved favorite route filter': 'Αποθηκευμένο φίλτρο αγαπημένης διαδρομής',
    km: 'χλμ',
    mi: 'mi',
    'Radius search': 'Αναζήτηση ακτίνας',
    'City or town': 'Πόλη ή πόλη',
    'Country (optional)': 'Χώρα (προαιρετικό)',
    Radius: 'Ακτίνα',
    Search: 'Αναζήτηση',
    'Searching…': 'Αναζήτηση…',
    'City not found': 'Η πόλη δεν βρέθηκε',
    'Within {{radius}} {{unit}} of {{place}}':
      'Εντός {{radius}} {{unit}} από {{place}}',
    'Clear radius': 'Καθαρή ακτίνα',
    'auth.status_label': 'Κατάσταση',
    'auth.back_to_sign_in': 'Επιστροφή για είσοδο',
    Gold: 'Χρυσός',
    Bronze: 'Χάλκινο',
    admin: 'Διαχειρ',
    'Q1 2025': '1ο τρίμηνο 2025',
    'Q2 2025': '2ο τρίμηνο 2025',
    'Orders Delivered': 'Οι παραγγελίες παραδόθηκαν',
    'Cars Delivered': 'Παραδόθηκαν αυτοκίνητα',
    'Avg. Assign to Pick-up': 'Μέσος όρος Αντιστοίχιση στο Pick-up',
    'Correctly Planned Orders': 'Σωστά προγραμματισμένες παραγγελίες',
    'Plan Changes': 'Αλλαγές σχεδίου',
    'Orders cancelled': 'Οι παραγγελίες ακυρώθηκαν',
    'Orders Added': 'Προστέθηκαν παραγγελίες',
    'Wheels of Excellence — modernized overview':
      'Wheels of Excellence — εκσυγχρονισμένη επισκόπηση',
    'Current Quarter': 'Τρέχον Τρίμηνο',
    Rank: 'Κατάταξη',
    Score: 'Σκορ',
    'Cancelled Bookings': 'Ακυρωμένες κρατήσεις',
    'Delivered Bookings': 'Παραδοτέες κρατήσεις',
    'Transport Titan score': 'Βαθμολογία Τιτάνων Μεταφορών',
    Days: 'Μέρες',
    'Q3 2025': '3ο τρίμηνο 2025',
    'Not achieved yet': 'Δεν έχει επιτευχθεί ακόμη',
    'Additional Metrics': 'Πρόσθετες μετρήσεις',
    'Previous Quarters': 'Προηγούμενα τρίμηνα',
    Quarter: 'τέταρτο',
    'Total orders': 'Σύνολο παραγγελιών',
    Speed: 'Ταχύτητα',
    'Total score': 'Συνολική βαθμολογία',
    'Find the right order': 'Βρείτε τη σωστή σειρά',
    'Match the wizard styling with graceful mobile stacking by using the shortcut controls below.':
      'Ταιριάξτε το στυλ του οδηγού με τη χαριτωμένη στοίβαξη για κινητά χρησιμοποιώντας τα χειριστήρια συντομεύσεων παρακάτω.',
    Sorting: 'Ταξινόμηση',
    'Ready from date · Newest first':
      'Έτοιμο από ημερομηνία · Πρώτα τα νεότερα',
    'Ready from date · Oldest first':
      'Έτοιμο από ημερομηνία · Πρώτα τα παλαιότερα',
    'Search by ID, Ref, City': 'Αναζήτηση με ταυτότητα, αναφορά, πόλη',
    'No orders match your criteria.':
      'Καμία παραγγελία δεν ταιριάζει με τα κριτήριά σας.',
    'Client ref · {order.clientRef}': 'Αναφορά πελάτη · {order.clientRef}',
    'Planned for': 'Προγραμματισμένη για',
    'Driver info': 'Πληροφορίες προγράμματος οδήγησης',
    'No driver has been assigned yet': 'Κανένας οδηγός δεν έχει ανατεθεί ακόμα',
    'When a partner picks up this order, a driver will be assigned':
      'Όταν ένας συνεργάτης παραλάβει αυτήν την παραγγελία, θα ανατεθεί ένας οδηγός',
    'Route summary': 'Περίληψη διαδρομής',
    'Order Details': 'Στοιχεία παραγγελίας',
    Details: 'Λεπτομέρειες',
    'No vehicles selected yet.': 'Δεν έχουν επιλεγεί ακόμη οχήματα.',
    'Please add the vehicle weight to continue.':
      'Προσθέστε το βάρος του οχήματος για να συνεχίσετε.',
    'Weight (kg)': 'Βάρος (kg)',
    English: 'Αγγλικά',
    German: 'Γερμανός',
    Dutch: 'Ολλανδικά',
    French: 'Γαλλικά',
    Spanish: 'Ισπανικά',
    Italian: 'ιταλική',
    Albania: 'Αλβανία',
    Andorra: 'Ανδόρα',
    Armenia: 'Αρμενία',
    Austria: 'Αυστρία',
    Azerbaijan: 'Αζερμπαϊτζάν',
    Belarus: 'Λευκορωσία',
    Belgium: 'Βέλγιο',
    'Bosnia and Herzegovina': 'Βοσνία-Ερζεγοβίνη',
    Bulgaria: 'Βουλγαρία',
    Croatia: 'την Κροατία',
    Cyprus: 'Κύπρος',
    'Czech Republic': 'Τσεχική Δημοκρατία',
    Denmark: 'Δανία',
    Estonia: 'Εσθονία',
    Finland: 'Φινλανδία',
    France: 'Γαλλία',
    Georgia: 'Γεωργία',
    Germany: 'Γερμανία',
    Greece: 'Ελλάδα',
    Hungary: 'Ουγγαρία',
    Iceland: 'Ισλανδία',
    Ireland: 'Ιρλανδία',
    Italy: 'Ιταλία',
    Kazakhstan: 'Καζακστάν',
    Kosovo: 'Κοσσυφοπέδιο',
    Latvia: 'Λετονία',
    Liechtenstein: 'Λιχτενστάιν',
    Lithuania: 'Λιθουανία',
    Luxembourg: 'Λουξεμβούργο',
    Malta: 'Μάλτα',
    Moldova: 'Μολδαβία',
    Monaco: 'Μονακό',
    Montenegro: 'Μαυροβούνιο',
    Netherlands: 'Κάτω Χώρες',
    'North Macedonia': 'Βόρεια Μακεδονία',
    Norway: 'Νορβηγία',
    Poland: 'Πολωνία',
    Portugal: 'Πορτογαλία',
    Romania: 'Ρουμανία',
    Russia: 'Ρωσία',
    'San Marino': 'Άγιος Μαρίνος',
    Serbia: 'Σερβία',
    Slovakia: 'Σλοβακία',
    Slovenia: 'Σλοβενία',
    Spain: 'Ισπανία',
    Sweden: 'Σουηδία',
    Switzerland: 'Ελβετία',
    Turkey: 'Τουρκία',
    Ukraine: 'Ουκρανία',
    'United Kingdom': 'Ηνωμένο Βασίλειο',
    'Vatican City': 'Πόλη του Βατικανού',
    'BodyType.Compact': 'Συμπαγές',
    'BodyType.Hatchback': 'Χάτσμπακ',
    'BodyType.Coupe': 'Κουπέ',
    'BodyType.Superauto': 'Supercar',
    'BodyType.Sedan': 'Σεντάν',
    'BodyType.StationWagon': 'Station Wagon',
    'BodyType.Crossover': 'Crossover',
    'BodyType.Pickup': 'Παραλαβή',
    'BodyType.Transport': 'Αυτοκίνητο μεταφοράς',
    'BodyType.Van': 'Van',
    'Loading address is not logistic centre':
      'Η διεύθυνση φόρτωσης δεν είναι κέντρο υλικοτεχνικής υποστήριξης',
    'VAT Number': 'ΑΦΜ',
    'VAT number is required': 'Απαιτείται ΑΦΜ',
    'Company name is required': 'Απαιτείται το όνομα της εταιρείας',
    'VAT number must not exceed 30 characters':
      'Ο ΑΦΜ δεν πρέπει να υπερβαίνει τους 30 χαρακτήρες',
    'I confirm these opening hours are correct':
      'Επιβεβαιώνω ότι αυτές οι ώρες λειτουργίας είναι σωστές',
    'Inputs changed · recalc to refresh quote':
      'Οι είσοδοι άλλαξαν · επανυπολογισμός για ανανέωση της προσφοράς',
    'Fill in the VIN or specs for each vehicle type.':
      'Συμπληρώστε το VIN ή τις προδιαγραφές για κάθε τύπο οχήματος.',
    'Tell us where we collect the vehicles and who to contact.':
      'Πείτε μας πού μαζεύουμε τα οχήματα και με ποιον να επικοινωνήσουμε.',
    'Confirm the destination contact and address.':
      'Επιβεβαιώστε την επαφή και τη διεύθυνση προορισμού.',
    'Add schedule, opening hours, and special instructions.':
      'Προσθέστε πρόγραμμα, ώρες λειτουργίας και ειδικές οδηγίες.',
    'Finalize the handover plan':
      'Ολοκληρώστε το σχέδιο παράδοσης με ενδείξεις προγραμματισμού, διαθεσιμότητα τοποθεσίας και προτιμήσεις βιωσιμότητας. Αυτή η προβολή διατηρεί τα πάντα κρίσιμα σε ένα μέρος χωρίς να επαναλαμβάνει λεπτομέρειες από προηγούμενα βήματα.',
    'Premium pricing for VIP customers': 'Premium τιμολόγηση για VIP πελάτες',
    'Determine the route and select options that match your vehicle mix.':
      'Καθορίστε τη διαδρομή και επιλέξτε επιλογές που ταιριάζουν με το μείγμα του οχήματός σας.',
    'Delivery opening hours': 'Ώρες λειτουργίας παράδοσης',
    ' total': 'σύνολο',
    'e.g. Mercedes-Benz GLE 450': 'π.χ. Mercedes-Benz GLE 450',
    'Pickup opening hours': 'Ώρες λειτουργίας παραλαβής',
    'No name': 'Κανένα όνομα',
    '(you)': '(εσείς)',
    'User email has been verified': 'Το email χρήστη έχει επαληθευτεί',
    'Mark as VIP': 'Επισήμανση ως VIP',
    'Unmark as VIP': 'Κατάργηση επισήμανσης ως VIP',
    'This is a VIP client functionality only':
      'Αυτή είναι μια λειτουργία VIP πελάτη μόνο',
    'N/A': 'N/A',
    Approved: 'Εγκρίθηκε',
    Pending: 'Σε εκκρεμότητα',
    Rejected: 'Απορρίφθηκε',
    Disabled: 'ΑμεΑ',
    'Partner validated by:': 'Συνεργάτης επικυρωμένος από:',
    Approve: 'Έγκριση',
    Reject: 'Απόρριψη',
    Disable: 'Απενεργοποίηση',
    'Confirm action': 'Επιβεβαιώστε την ενέργεια',
    'Are you sure you want to approve this user?':
      'Είστε βέβαιοι ότι θέλετε να εγκρίνετε αυτόν τον χρήστη;',
    'Are you sure you want to reject this user?':
      'Είστε βέβαιοι ότι θέλετε να απορρίψετε αυτόν τον χρήστη;',
    'Are you sure you want to mark this client as VIP?':
      'Είστε βέβαιοι ότι θέλετε να επισημάνετε αυτόν τον πελάτη ως VIP;',
    'Are you sure you want to unmark this client as VIP?':
      'Είστε βέβαιοι ότι θέλετε να καταργήσετε την επισήμανση αυτού του πελάτη ως VIP;',
    'This will disable the user account. Continue?':
      'Αυτό θα απενεργοποιήσει τον λογαριασμό χρήστη. Συνεχίζω;',
    Client: 'πελάτη',
    Partner: 'Συνεργάτης',
    Admin: 'Διαχειρ',
    'User disabled': 'Ο χρήστης απενεργοποιήθηκε',
    'User approved': 'Εγκρίθηκε από τον χρήστη',
    'Invalid Date': 'Μη έγκυρη ημερομηνία',
    'User rejected': 'Ο χρήστης απορρίφθηκε',
    'View Documents': 'Προβολή Εγγράφων',
    'Partner approved successfully!': 'Ο συνεργάτης εγκρίθηκε με επιτυχία!',
    'Failed to approve partner': 'Αποτυχία έγκρισης συνεργάτη',
    'There was an issue approving this partner.':
      'Παρουσιάστηκε πρόβλημα με την έγκριση αυτού του συνεργάτη.',
    'Partner rejected successfully.': 'Ο συνεργάτης απορρίφθηκε με επιτυχία.',
    'Failed to reject partner': 'Αποτυχία απόρριψης συνεργάτη',
    'There was an issue rejecting this partner.':
      'Παρουσιάστηκε πρόβλημα με την απόρριψη αυτού του συνεργάτη.',
    'Approve partner?': 'Έγκριση συνεργάτη;',
    'This will approve the partner and grant access.':
      'Αυτό θα εγκρίνει τον συνεργάτη και θα παραχωρήσει πρόσβαση.',
    'Reject partner?': 'Απόρριψη συνεργάτη;',
    'ValidationStatus.pending': 'Σε εκκρεμότητα',
    'ValidationStatus.approved': 'Εγκρίθηκε',
    'ValidationStatus.rejected': 'Απορρίφθηκε',
    'ValidationStatus.disabled': 'ΑμεΑ',
    'No pending partners found.': 'Δεν βρέθηκαν συνεργάτες σε εκκρεμότητα.',
    'Error fetching data.': 'Σφάλμα κατά την ανάκτηση δεδομένων.',
    'No opening hours provided.': 'Δεν παρέχονται ώρες λειτουργίας.',
    StartPoint: 'Έναρξη',
    EndPoint: 'Τέλος',
    'Please select a planned date.':
      'Επιλέξτε μια προγραμματισμένη ημερομηνία.',
    'Saved favorite route filters': 'Αποθηκευμένα φίλτρα αγαπημένων διαδρομών',
    Trailers: 'Ρυμουλκούμενα',
    'Search trailers...': 'Αναζήτηση τρέιλερ...',
    'Add trailer': 'Προσθήκη τρέιλερ',
    'Error loading trailers': 'Σφάλμα κατά τη φόρτωση τρέιλερ',
    'No trailers found.': 'Δεν βρέθηκαν τρέιλερ.',
    'No trailers found for your search.':
      'Δεν βρέθηκαν τρέιλερ για την αναζήτησή σας.',
    'Edit trailer': 'Επεξεργασία τρέιλερ',
    'Loading profile...': 'Φόρτωση προφίλ...',
    'Error loading profile': 'Σφάλμα κατά τη φόρτωση του προφίλ',
    'User not found.': 'Ο χρήστης δεν βρέθηκε.',
    'Not logged in': 'Δεν έχετε συνδεθεί',
    'Company Information': 'Πληροφορίες εταιρείας',
    'Company Name': 'Όνομα εταιρείας',
    City: 'Πόλη',
    'Post code': 'Ταχυδρομικός κώδικας',
    'Phone Number': 'Αριθμός τηλεφώνου',
    'Upload your documents': 'Ανεβάστε τα έγγραφά σας',
    'Store identity or compliance files securely so admins can verify your profile. Supported types: PDF, JPG, PNG, DOC.':
      'Αποθηκεύστε τα αρχεία ταυτότητας ή συμμόρφωσης με ασφάλεια, ώστε οι διαχειριστές να μπορούν να επαληθεύσουν το προφίλ σας. Υποστηριζόμενοι τύποι: PDF, JPG, PNG, DOC.',
    'Sign in to upload documents to your profile.':
      'Συνδεθείτε για να ανεβάσετε έγγραφα στο προφίλ σας.',
    'After uploading, support staff can review and approve your account.':
      'Μετά τη μεταφόρτωση, το προσωπικό υποστήριξης μπορεί να ελέγξει και να εγκρίνει τον λογαριασμό σας.',
    Name: 'Όνομα',
    'No Name': 'Χωρίς Όνομα',
    'No Email': 'Χωρίς email',
    Role: 'Ρόλος',
    'Manage fleet': 'Διαχείριση στόλου',
    'No pending trucks found': 'Δεν βρέθηκαν φορτηγά σε εκκρεμότητα',
    'Truck approved successfully!': 'Το φορτηγό εγκρίθηκε με επιτυχία!',
    'Failed to approve truck': 'Αποτυχία έγκρισης φορτηγού',
    'There was an issue approving this truck.':
      'Παρουσιάστηκε πρόβλημα με την έγκριση αυτού του φορτηγού.',
    'Truck rejected successfully.': 'Το φορτηγό απορρίφθηκε με επιτυχία.',
    'Failed to reject truck': 'Αποτυχία απόρριψης φορτηγού',
    'There was an issue rejecting this truck.':
      'Παρουσιάστηκε πρόβλημα με την απόρριψη αυτού του φορτηγού.',
    'Approve truck?': 'Έγκριση φορτηγού;',
    'This will approve the truck and make it available for bookings.':
      'Αυτό θα εγκρίνει το φορτηγό και θα το κάνει διαθέσιμο για κρατήσεις.',
    'Reject truck?': 'Απόρριψη φορτηγού;',
    'This action will reject the truck and cannot be undone.':
      'Αυτή η ενέργεια θα απορρίψει το φορτηγό και δεν μπορεί να αναιρεθεί.',
    'Error fetching trucks': 'Σφάλμα κατά την ανάκτηση φορτηγών',
    'Truck has been validated by:': 'Το φορτηγό έχει επικυρωθεί από:',
    on: 'επάνω',
    'Coming soon': 'Προσεχώς',
    'View documents': 'Προβολή εγγράφων',
    'This truck is already disabled':
      'Αυτό το φορτηγό είναι ήδη απενεργοποιημένο',
    'Disable this truck': 'Απενεργοποιήστε αυτό το φορτηγό',
    'Disable Truck': 'Απενεργοποιήστε το φορτηγό',
    'Are you sure you want to disable this truck? This action cannot be undone.':
      'Είστε βέβαιοι ότι θέλετε να απενεργοποιήσετε αυτό το φορτηγό; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
    'Email verified': 'Το email επαληθεύτηκε',
    'View profile': 'Επισκόπηση προφίλ',
    'No unpaid bookings found.': 'Δεν βρέθηκαν κρατήσεις χωρίς πληρωμή.',
    'Add Truck': 'Προσθήκη φορτηγού',
    'Edit Truck': 'Επεξεργασία φορτηγού',
    Make: 'Κάντε',
    Model: 'Μοντέλο',
    Year: 'έτος',
    'License Plate': 'πινακίδα κυκλοφορίας',
    Documents: 'Έγγραφα',
    'Save the truck first to enable document uploads.':
      'Αποθηκεύστε πρώτα το φορτηγό για να ενεργοποιήσετε τη μεταφόρτωση εγγράφων.',
    'Search trucks...': 'Αναζήτηση φορτηγών...',
    'Error loading trucks': 'Σφάλμα κατά τη φόρτωση φορτηγών',
    'No trucks found.': 'Δεν βρέθηκαν φορτηγά.',
    'No trucks found for your search.':
      'Δεν βρέθηκαν φορτηγά για την αναζήτησή σας.',
    'Pending approval': 'Εκκρεμεί έγκριση',
    Plate: 'πιάτο',
    Edit: 'Επεξεργασία',
    Delete: 'Διαγραφή',
    'Truck updated.': 'Το φορτηγό ενημερώθηκε.',
    'The truck has been successfully updated.':
      'Το φορτηγό έχει ενημερωθεί με επιτυχία.',
    'Truck added.': 'Το φορτηγό προστέθηκε.',
    'The new truck has been successfully added.':
      'Το νέο φορτηγό προστέθηκε με επιτυχία.',
    'Truck deleted.': 'Το φορτηγό διαγράφηκε.',
    'Delete Truck': 'Διαγραφή φορτηγού',
    'Delete Driver': 'Διαγραφή προγράμματος οδήγησης',
    'Delete Trailer': 'Διαγραφή τρέιλερ',
    "Are you sure? You can't undo this action afterwards.":
      'Είσαι σίγουρος; Δεν μπορείτε να αναιρέσετε αυτήν την ενέργεια στη συνέχεια.',
    'The truck has been successfully deleted.':
      'Το φορτηγό διαγράφηκε με επιτυχία.',
    'Search drivers...': 'Αναζήτηση προγραμμάτων οδήγησης...',
    'Add driver': 'Προσθήκη προγράμματος οδήγησης',
    'Error loading drivers': 'Σφάλμα κατά τη φόρτωση προγραμμάτων οδήγησης',
    'No drivers found.': 'Δεν βρέθηκαν προγράμματα οδήγησης.',
    'No drivers found for your search.':
      'Δεν βρέθηκαν προγράμματα οδήγησης για την αναζήτησή σας.',
    'Edit driver': 'Επεξεργασία προγράμματος οδήγησης',
    'First Name': 'Όνομα',
    'Last Name': 'Επώνυμο',
    'License ID': 'Αναγνωριστικό άδειας',
    'License Date of Issue': 'Ημερομηνία Έκδοσης Άδειας',
    'License Date of Expiration': 'Ημερομηνία λήξης άδειας',
    'No phone': 'Κανένα τηλέφωνο',
    'No email': 'Χωρίς email',
    'No license': 'Χωρίς άδεια',
    Issue: 'Τεύχος',
    Expiry: 'Λήξη',
    'Sign in': 'Συνδεθείτε',
    'Sign up': 'Εγγραφείτε',
    'Enter your email and password to sign in!':
      'Εισαγάγετε το email και τον κωδικό πρόσβασής σας για να συνδεθείτε!',
    'Enter your email, create a password, and choose a role to register.':
      'Εισαγάγετε το email σας, δημιουργήστε έναν κωδικό πρόσβασης και επιλέξτε έναν ρόλο για εγγραφή.',
    'Login Failed': 'Η σύνδεση απέτυχε',
    'Verification Email Sent': 'Το email επαλήθευσης εστάλη',
    'Sign-up failed': 'Η εγγραφή απέτυχε',
    'Please select a valid role': 'Επιλέξτε έναν έγκυρο ρόλο',
    'Passwords do not match': 'Οι κωδικοί πρόσβασης δεν ταιριάζουν',
    'Sign In': 'Είσοδος',
    'Create Account': 'Δημιουργία λογαριασμού',
    'I want to register as a': 'Θέλω να εγγραφώ ως α',
    Username: 'Όνομα χρήστη',
    'Your name': 'Το όνομά σου',
    'Username is required.': 'Απαιτείται όνομα χρήστη.',
    'Email is required.': 'Απαιτείται email.',
    'Invalid email format.': 'Μη έγκυρη μορφή email.',
    Password: 'Κωδικός πρόσβασης',
    'Password is required.': 'Απαιτείται κωδικός πρόσβασης.',
    'Confirm password': 'Επιβεβαίωση κωδικού πρόσβασης',
    'Confirm password is required.':
      'Απαιτείται επιβεβαίωση κωδικού πρόσβασης.',
    'Passwords do not match.': 'Οι κωδικοί πρόσβασης δεν ταιριάζουν.',
    'Forgot password?': 'Ξεχάσατε τον κωδικό πρόσβασης;',
    'Min. 8 characters': 'Ελάχ. 8 χαρακτήρες',
    'Order transportation in the automotive branch.':
      'Παραγγελία μεταφοράς στο υποκατάστημα αυτοκινήτων.',
    'Join our network of transport partners.':
      'Γίνετε μέλος του δικτύου συνεργατών μας στον τομέα των μεταφορών.',
    'Sign Up': 'Εγγραφείτε',
    'Driver with this phone number already exists.':
      'Το πρόγραμμα οδήγησης με αυτόν τον αριθμό τηλεφώνου υπάρχει ήδη.',
    'First name is required': 'Το όνομα είναι υποχρεωτικό.',
    'Last name is required': 'Το επώνυμο είναι υποχρεωτικό.',
    'Phone number is required': 'Απαιτείται αριθμός τηλεφώνου.',
    'Driver with this phone already exists.':
      'Το πρόγραμμα οδήγησης με αυτόν τον αριθμό τηλεφώνου υπάρχει ήδη.',
    "Driver's phone number must contain only digits and be 8–15 characters long. Optional leading + allowed.":
      'Ο αριθμός τηλεφώνου του οδηγού πρέπει να περιέχει μόνο ψηφία και να αποτελείται από 8–15 χαρακτήρες. Προαιρετική ηγεσία + επιτρέπεται.',
    'Manage Fleet': 'Διαχείριση Στόλου',
    'Error loading documents': 'Σφάλμα κατά τη φόρτωση εγγράφων',
    'Are you sure you want to delete this document?':
      'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το έγγραφο;',
    'Document deleted': 'Το έγγραφο διαγράφηκε',
    'Failed to delete': 'Η διαγραφή απέτυχε',
    'Failed to get download link': 'Αποτυχία λήψης συνδέσμου λήψης',
    'Status updated': 'Η κατάσταση ενημερώθηκε',
    'Update failed': 'Η ενημέρωση απέτυχε',
    'Email cannot be changed.': 'Το email δεν μπορεί να αλλάξει.',
    'No documents found.': 'Δεν βρέθηκαν έγγραφα.',
    'Invoice #': 'Τιμολόγιο #',
    'File Name': 'Όνομα αρχείου',
    Amount: 'Ποσό',
    Actions: 'Δράσεις',
    Download: 'Λήψη',
    'Mark Unpaid': 'Σημειώστε απλήρωτο',
    'Mark Paid': 'Mark Paid',
    'Please save the record before uploading documents.':
      'Αποθηκεύστε το αρχείο πριν ανεβάσετε έγγραφα.',
    'Select a file before uploading.': 'Επιλέξτε ένα αρχείο πριν το ανεβάσετε.',
    'Please enter an invoice number.': 'Εισαγάγετε έναν αριθμό τιμολογίου.',
    'Upload successful': 'Επιτυχής μεταφόρτωση',
    '{{count}} file(s) uploaded successfully.':
      '{{count}} αρχεία μεταφορτώθηκαν με επιτυχία.',
    'Upload failed': 'Η μεταφόρτωση απέτυχε',
    'Unable to upload the document.':
      'Δεν είναι δυνατή η μεταφόρτωση του εγγράφου.',
    'Invoice Number': 'Αριθμός Τιμολογίου',
    'Selected files:': 'Επιλεγμένα αρχεία:',
    Upload: 'Μεταφόρτωση',
    'Save this record before uploading documents.':
      'Αποθηκεύστε αυτήν την εγγραφή πριν ανεβάσετε έγγραφα.',
    'Error approving user': 'Σφάλμα έγκρισης χρήστη',
    'Error rejecting user': 'Σφάλμα απόρριψης χρήστη',
    'Error disabling user': 'Σφάλμα κατά την απενεργοποίηση του χρήστη',
    'User marked as VIP': 'Ο χρήστης επισημάνθηκε ως VIP',
    'User unmarked as VIP': 'Ο χρήστης καταργήθηκε ως VIP',
    'Error marking user as VIP': 'Σφάλμα επισήμανσης χρήστη ως VIP',
    'Error unmarking user as VIP':
      'Σφάλμα κατά την κατάργηση της επισήμανσης χρήστη ως VIP',
    'Failed to approve user': 'Αποτυχία έγκρισης χρήστη',
    'Failed to reject user': 'Αποτυχία απόρριψης χρήστη',
    'Failed to disable user': 'Η απενεργοποίηση του χρήστη απέτυχε',
    'Failed to unmark user as VIP':
      'Αποτυχία κατάργησης επισήμανσης χρήστη ως VIP',
    'Failed to mark user as VIP': 'Αποτυχία επισήμανσης χρήστη ως VIP',
    'Invoice Management': 'Διαχείριση Τιμολογίων',
    'All Invoices': 'Όλα τα τιμολόγια',
    'Manage all invoices uploaded by partners.':
      'Διαχειριστείτε όλα τα τιμολόγια που έχουν μεταφορτωθεί από συνεργάτες.',
    'An unexpected error occurred. Please try again.':
      'Παρουσιάστηκε απροσδόκητο σφάλμα. Δοκιμάστε ξανά.',
    'The email address is not valid.': 'Η διεύθυνση email δεν είναι έγκυρη.',
    'This account has been disabled.':
      'Αυτός ο λογαριασμός έχει απενεργοποιηθεί.',
    'No account found with this email.':
      'Δεν βρέθηκε λογαριασμός με αυτό το email.',
    'Incorrect password. Please try again.':
      'Λανθασμένος κωδικός πρόσβασης. Δοκιμάστε ξανά.',
    'Invalid email or password. Please check your credentials and try again.':
      'Μη έγκυρο email ή κωδικός πρόσβασης. Ελέγξτε τα διαπιστευτήριά σας και δοκιμάστε ξανά.',
    'Too many failed attempts. Please try again later or reset your password.':
      'Πάρα πολλές αποτυχημένες προσπάθειες. Δοκιμάστε ξανά αργότερα ή επαναφέρετε τον κωδικό πρόσβασής σας.',
    'Network error. Check your connection and try again.':
      'Σφάλμα δικτύου. Ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.',
    'A verification email has been sent to your email address. Please verify your email before logging in.':
      'Ένα email επαλήθευσης έχει σταλεί στη διεύθυνση email σας. Επαληθεύστε το email σας πριν συνδεθείτε.',
    'Please make sure both passwords are the same.':
      'Βεβαιωθείτε ότι και οι δύο κωδικοί πρόσβασης είναι ίδιοι.',
    'Verification email resent!': 'Το email επαλήθευσης στάλθηκε εκ νέου!',
    'Please check your inbox.': 'Ελέγξτε τα εισερχόμενά σας.',
    'You need to log in first': 'Πρέπει πρώτα να συνδεθείτε',
    'Please sign in to resend the verification email.':
      'Συνδεθείτε για να στείλετε ξανά το email επαλήθευσης.',
    'Failed to resend email': 'Απέτυχε η εκ νέου αποστολή email',
    'Resend verification email': 'Αποστολή εκ νέου email επαλήθευσης',
    'Show password': 'Εμφάνιση κωδικού πρόσβασης',
    'Hide password': 'Απόκρυψη κωδικού πρόσβασης',
    'Awaiting verification artwork': 'Έργο τέχνης σε αναμονή επαλήθευσης',
    'Account status: Pending review': 'Κατάσταση λογαριασμού: Εκκρεμεί έλεγχος',
    'Your account is pending approval': 'Ο λογαριασμός σας εκκρεμεί έγκριση',
    "Upload your verification documents below and we'll notify you by email once your account is approved.":
      'Ανεβάστε τα έγγραφα επαλήθευσης παρακάτω και θα σας ειδοποιήσουμε μέσω email μόλις εγκριθεί ο λογαριασμός σας.',
    'Check status': 'Ελέγξτε την κατάσταση',
    'Upload verification documents': 'Μεταφόρτωση εγγράφων επαλήθευσης',
    'Your uploaded documents': 'Τα ανεβασμένα έγγραφά σας',
    'Back to sign in': 'Επιστροφή για είσοδο',
    'Hide documents': 'Απόκρυψη εγγράφων',
    'Email verification required': 'Απαιτείται επαλήθευση μέσω email',
    'Waiting for email verification': 'Αναμονή για επαλήθευση μέσω email',
    'Check your email': 'Ελέγξτε το email σας',
    'We sent your verification link to':
      'Στείλαμε τον σύνδεσμο επαλήθευσης στη διεύθυνση',
    "Didn't receive it? Check your spam folder or try again.":
      'Δεν το έλαβες; Ελέγξτε το φάκελο ανεπιθύμητης αλληλογραφίας ή δοκιμάστε ξανά.',
    'Resend email': 'Επανάληψη αποστολής email',
    "I've verified my email": 'Έχω επαληθεύσει το email μου',
    'Redirecting you now.': 'Ανακατεύθυνση σας τώρα.',
    'Email not verified yet': 'Το email δεν έχει επαληθευτεί ακόμα',
    'Please click the link in your inbox and try again.':
      'Κάντε κλικ στον σύνδεσμο στα εισερχόμενά σας και δοκιμάστε ξανά.',
    'Unable to resend verification email right now.':
      'Δεν είναι δυνατή η εκ νέου αποστολή email επαλήθευσης αυτήν τη στιγμή.',
    'Unable to check verification status right now.':
      'Δεν είναι δυνατός ο έλεγχος της κατάστασης επαλήθευσης αυτήν τη στιγμή.',
    "We've sent a new verification link to your email address.":
      'Έχουμε στείλει έναν νέο σύνδεσμο επαλήθευσης στη διεύθυνση email σας.',
    'We automatically check your verification status every 30 seconds. You can also trigger an instant check after verifying your email.':
      'Ελέγχουμε αυτόματα την κατάσταση επαλήθευσης κάθε 30 δευτερόλεπτα. Μπορείτε επίσης να ενεργοποιήσετε έναν άμεσο έλεγχο αφού επαληθεύσετε το email σας.',
    'We automatically check your verification status every 15 seconds. You can also trigger an instant check after verifying your email.':
      'Ελέγχουμε αυτόματα την κατάσταση επαλήθευσης κάθε 15 δευτερόλεπτα. Μπορείτε επίσης να ενεργοποιήσετε έναν άμεσο έλεγχο αφού επαληθεύσετε το email σας.',
    'Inputs changed. Recalculate the price.':
      'Οι είσοδοι άλλαξαν. Υπολογίστε ξανά την τιμή.',
    'My Invoices': 'Τα τιμολόγιά μου',
    'Upload New Invoice': 'Μεταφόρτωση νέου τιμολογίου',
    'Please enter the invoice number and upload the invoice document. It will be reviewed by an administrator.':
      'Εισαγάγετε τον αριθμό τιμολογίου και μεταφορτώστε το παραστατικό τιμολογίου. Θα ελεγχθεί από έναν διαχειριστή.',
    'Invoice History': 'Ιστορικό Τιμολογίων',
    'Client ref · {{clientRef}}': 'Αναφορά πελάτη · {{clientRef}}',
    'Order Documents': 'Έγγραφα Παραγγελίας',
    'Upload Proof of Pickup': 'Μεταφορτώστε την απόδειξη παραλαβής',
    'Status will be updated to Picked Up after successful upload.':
      'Η κατάσταση θα ενημερωθεί σε Παραλαβή μετά την επιτυχή μεταφόρτωση.',
    'Upload Proof of Delivery': 'Ανεβάστε την απόδειξη παράδοσης',
    'Status will be updated to Delivered after successful upload.':
      'Η κατάσταση θα ενημερωθεί σε Παραδόθηκε μετά την επιτυχή μεταφόρτωση.',
    'Enter first name': 'Εισαγάγετε το όνομα',
    'Enter last name': 'Εισαγάγετε το επώνυμο',
    'Enter phone number': 'Εισαγάγετε τον αριθμό τηλεφώνου',
    'Driver updated.': 'Ενημερώθηκε το πρόγραμμα οδήγησης.',
    'The driver has been successfully updated.':
      'Το πρόγραμμα οδήγησης έχει ενημερωθεί με επιτυχία.',
    'Driver added.': 'Προστέθηκε πρόγραμμα οδήγησης.',
    'The new driver has been successfully added.':
      'Το νέο πρόγραμμα οδήγησης προστέθηκε με επιτυχία.',
    'Driver deleted.': 'Το πρόγραμμα οδήγησης διαγράφηκε.',
    'The driver has been successfully deleted.':
      'Το πρόγραμμα οδήγησης διαγράφηκε με επιτυχία.',
    'Trailer updated.': 'Το τρέιλερ ενημερώθηκε.',
    'The trailer has been successfully updated.':
      'Το τρέιλερ ενημερώθηκε με επιτυχία.',
    'Trailer added.': 'Προστέθηκε τρέιλερ.',
    'The new trailer has been successfully added.':
      'Το νέο τρέιλερ προστέθηκε με επιτυχία.',
    'Trailer deleted.': 'Το τρέιλερ διαγράφηκε.',
    'The trailer has been successfully deleted.':
      'Το τρέιλερ διαγράφηκε με επιτυχία.',
    'User account not found. Please complete registration.':
      'Ο λογαριασμός χρήστη δεν βρέθηκε. Παρακαλούμε ολοκληρώστε την εγγραφή.',
    'No token provided': 'Δεν παρέχεται διακριτικό',
    'Token expired': 'Το διακριτικό έληξε',
    'Token revoked': 'Token ανακλήθηκε',
    'Invalid ID token': 'Μη έγκυρο διακριτικό αναγνωριστικού',
    Unauthorized: 'Μη εξουσιοδοτημένο',
    'Unauthorized: User not authenticated.':
      'Μη εξουσιοδοτημένο: Ο χρήστης δεν έχει πιστοποιηθεί.',
    'Unauthorized: User role not found.':
      'Μη εξουσιοδοτημένο: Ο ρόλος χρήστη δεν βρέθηκε.',
    'Forbidden: Your role is not allowed to perform this action.':
      'Απαγορευμένο: Ο ρόλος σας δεν επιτρέπεται να εκτελέσει αυτήν την ενέργεια.',
    'Forbidden: This action requires a partner role.':
      'Απαγορευμένο: Αυτή η ενέργεια απαιτεί ρόλο συνεργάτη.',
    'Forbidden: This action requires a client role.':
      'Απαγορευμένο: Αυτή η ενέργεια απαιτεί ρόλο πελάτη.',
    'Forbidden: This action requires an admin role.':
      'Απαγορευμένο: Αυτή η ενέργεια απαιτεί ρόλο διαχειριστή.',
    'This user has not been approved': 'Αυτός ο χρήστης δεν έχει εγκριθεί',
    'User email has not been verified': 'Το email χρήστη δεν έχει επαληθευτεί',
    'User account has been disabled':
      'Ο λογαριασμός χρήστη έχει απενεργοποιηθεί',
    'Booking not found': 'Η κράτηση δεν βρέθηκε',
    'Route not found': 'Η διαδρομή δεν βρέθηκε',
    'Pickup location (country and postalCode) is required':
      'Απαιτείται τοποθεσία παραλαβής (χώρα και ταχυδρομικός κώδικας).',
    'Delivery location (country and postalCode) is required':
      'Απαιτείται τόπος παράδοσης (χώρα και ταχυδρομικός κώδικας).',
    'Unable to calculate route. Please check the locations and try again.':
      'Δεν είναι δυνατός ο υπολογισμός της διαδρομής. Ελέγξτε τις τοποθεσίες και δοκιμάστε ξανά.',
    'Error calculating transport price':
      'Σφάλμα στον υπολογισμό της τιμής μεταφοράς',
    'Booking canceled successfully': 'Η κράτηση ακυρώθηκε με επιτυχία',
    'Invalid request.': 'Μη έγκυρο αίτημα.',
    'Access denied.': 'Δεν επιτρέπεται η πρόσβαση.',
    'Resource not found.': 'Ο πόρος δεν βρέθηκε.',
    'Request conflict.': 'Αίτημα σύγκρουσης.',
    'Invalid data provided.': 'Παρέχονται μη έγκυρα δεδομένα.',
    'Too many requests. Please try again later.':
      'Πάρα πολλά αιτήματα. Δοκιμάστε ξανά αργότερα.',
    'Internal server error. Please try again later.':
      'Σφάλμα εσωτερικού διακομιστή. Δοκιμάστε ξανά αργότερα.',
    'Service temporarily unavailable.':
      'Η υπηρεσία δεν είναι διαθέσιμη προσωρινά.',
    'booking.load_preset': 'Φόρτωση προεπιλογής',
    'booking.save_preset_tooltip':
      'Αποθηκεύστε τα τρέχοντα φίλτρα ως προεπιλογή γρήγορης πρόσβασης',
    'booking.load_preset_tooltip':
      'Φορτώστε την αποθηκευμένη προεπιλογή φίλτρου',
    'booking.preset_saved': 'Η προεπιλογή αποθηκεύτηκε',
    'booking.preset_saved_desc':
      'Η προεπιλογή του φίλτρου σας έχει αποθηκευτεί.',
    'booking.preset_loaded': 'Η προεπιλογή φορτώθηκε',
    'booking.preset_load_error':
      'Η φόρτωση της προκαθορισμένης ρύθμισης απέτυχε',
    'booking.no_preset_saved': 'Δεν έχει αποθηκευτεί ακόμα καμία προεπιλογή',
    'booking.date_from': 'Ημερομηνία από',
    'booking.date_to': 'Ημερομηνία έως',
    'Active filters': 'Ενεργά φίλτρα',
    'All booking states': 'Όλες οι πολιτείες κρατήσεων',
    'All partners': 'Όλοι οι συνεργάτες',
    'All payments': 'Όλες οι πληρωμές',
    'All roles': 'Όλοι οι ρόλοι',
    'All statuses': 'Όλες οι καταστάσεις',
    'All Users': 'Όλοι οι Χρήστες',
    'Are you sure you want to cancel booking {{id}}?':
      'Είστε βέβαιοι ότι θέλετε να ακυρώσετε την κράτηση {{id}};',
    'Attach the CMR Insurance before finishing truck setup.':
      'Συνδέστε την ασφάλεια CMR πριν ολοκληρώσετε τη ρύθμιση του φορτηγού.',
    Awaiting: 'Αναμονή',
    'Awaiting payout': 'Αναμονή πληρωμής',
    'Booking canceled': 'Η κράτηση ακυρώθηκε',
    'Booking marked as paid': 'Η κράτηση επισημάνθηκε ως πληρωμένη',
    'Booking released and returned to marketplace':
      'Η κράτηση κυκλοφόρησε και επέστρεψε στην αγορά',
    'booking.allowed_range': 'Επιτρεπόμενο εύρος',
    'booking.assign_transport': 'Αναθέστε μεταφορά',
    'booking.back': 'Πίσω',
    'booking.back_to_summary': 'Επιστροφή στην περίληψη',
    'booking.booking_created_but_pickup_document_not_uploaded_upload_from_order_details':
      'Η κράτηση δημιουργήθηκε, αλλά το έγγραφο παραλαβής δεν μεταφορτώθηκε. Μπορείτε να το ανεβάσετε από τα Στοιχεία Παραγγελίας.',
    'booking.city_not_found': 'Η πόλη δεν βρέθηκε',
    'booking.city_or_town': 'Πόλη ή πόλη',
    'booking.clear_radius': 'Καθαρή ακτίνα',
    'booking.continue': 'Συνέχεια',
    'booking.country_optional': 'Χώρα (προαιρετικό)',
    'booking.delivery_constraint_info':
      'Η ημερομηνία παράδοσης πρέπει να είναι κατά ή μετά την ημερομηνία παραλαβής.',
    'booking.delivery_date_cannot_be_earlier_than_pickup_date':
      'Η ημερομηνία παράδοσης δεν μπορεί να είναι προγενέστερη από την ημερομηνία παραλαβής',
    'booking.driver': 'Οδηγός',
    'booking.failed_to_open_letter_of_attorney':
      'Απέτυχε το άνοιγμα της πληρεξούσιας επιστολής',
    'booking.go_to_order': 'Μεταβείτε στην παραγγελία',
    'booking.i_accept_terms': 'Αποδέχομαι τους όρους',
    'booking.invalid_license_plate_or_vin_length':
      'Μη έγκυρη πινακίδα κυκλοφορίας ή μήκος VIN.',
    'booking.invalid_vin_format_i_o_q_not_allowed':
      'Μη έγκυρη μορφή VIN. Οι χαρακτήρες I, O και Q δεν επιτρέπονται.',
    'booking.letter_of_attorney_file_is_empty':
      'Ο φάκελος της πληρεξουσίας είναι κενός',
    'booking.no_additional_details': 'Χωρίς πρόσθετες λεπτομέρειες',
    'booking.no_vehicle_info': 'Δεν υπάρχουν πληροφορίες για το όχημα',
    'booking.open_letter_of_attorney': 'Ανοιχτή πληρεξούσια επιστολή',
    'booking.opening_letter_of_attorney': 'Εναρκτήρια πληρεξούσιο...',
    'booking.order_accepted_successfully':
      'Η παραγγελία έγινε αποδεκτή με επιτυχία',
    'booking.order_cars_exceed_selected_truck_capacity':
      'Αυτή η παραγγελία έχει αυτοκίνητα {{orderCars}}, αλλά η επιλεγμένη χωρητικότητα φορτηγού είναι {{capacity}}.',
    'booking.pickup_constraint_info':
      'Απαιτείται ημερομηνία παραλαβής πριν από την ανάθεση μεταφοράς.',
    'booking.pickup_document_upload_failed':
      'Η μεταφόρτωση εγγράφου παραλαβής απέτυχε',
    'booking.preparing_secure_document_preview':
      'Προετοιμασία ασφαλούς προεπισκόπησης εγγράφου...',
    'booking.radius_km': 'Ακτίνα (χλμ)',
    'booking.radius_search': 'Αναζήτηση ακτίνας',
    'booking.route_and_details': 'Διαδρομή και λεπτομέρειες',
    'booking.schedule': 'Πρόγραμμα',
    'booking.searching': 'Αναζήτηση…',
    'booking.select_pickup_and_delivery': 'Επιλέξτε παραλαβή και παράδοση',
    'booking.select_pickup_and_delivery_dates_before_confirming':
      'Επιλέξτε ημερομηνίες παραλαβής και παράδοσης πριν την επιβεβαίωση',
    'booking.select_pickup_date': 'Επιλέξτε ημερομηνία παραλαβής',
    'booking.select_truck_driver_and_trailer':
      'Επιλέξτε φορτηγό, οδηγό και ρυμουλκούμενο',
    'booking.supported_formats_jpg_png_pdf_doc_docx':
      'Υποστηριζόμενες μορφές: JPG, PNG, PDF, DOC, DOCX',
    'booking.terms_and_conditions': 'Όροι και προϋποθέσεις',
    'booking.terms_text':
      'Επιβεβαιώνω τους όρους μεταφοράς και τις προϋποθέσεις ευθύνης.',
    'booking.track_shipment': 'Παρακολούθηση αποστολής',
    'booking.trailer': 'Τρέιλερ',
    'booking.transport_details': 'Λεπτομέρειες μεταφοράς',
    'booking.truck': 'Φορτηγό',
    'booking.truck_driver_planning_saved_letter_of_attorney_available':
      'Οι ημερομηνίες του φορτηγού, του οδηγού και του προγραμματισμού αποθηκεύτηκαν. Η πληρεξούσια επιστολή είναι πλέον διαθέσιμη.',
    'booking.unexpected_error': 'Απροσδόκητο σφάλμα',
    'booking.vehicles_plural': 'Οχήματα',
    'booking.view_details': 'Δείτε λεπτομέρειες',
    'booking.vip_price_must_be_between_min_max_50_to_150_percent_of_estimated_price':
      'Η τιμή VIP πρέπει να είναι μεταξύ {{min}} EUR και {{max}} EUR (50% έως 150% της εκτιμώμενης τιμής).',
    'booking.vip_price_must_be_positive_number':
      'Η τιμή VIP πρέπει να είναι θετικός αριθμός.',
    'booking.within_radius_km_of_place':
      'Σε απόσταση {{radius}} χιλιομέτρων από {{place}}',
    Capacity: 'χωρητικότητα',
    'Car Capacity': 'Χωρητικότητα αυτοκινήτου',
    'Car capacity is required.': 'Απαιτείται χωρητικότητα αυτοκινήτου.',
    cars: 'αυτοκίνητα',
    Changed: 'Άλλαξε',
    'CMR Document': 'Έγγραφο CMR',
    'CMR expiry': 'Λήξη CMR',
    'CMR Expiry': 'Λήξη CMR',
    'CMR expiry date is required': 'Απαιτείται ημερομηνία λήξης CMR',
    'CMR Insurance': 'Ασφάλιση CMR',
    'CMR insurance expiry date': 'Ημερομηνία λήξης ασφάλισης CMR',
    'CMR Insurance Expiry Date': 'Ημερομηνία λήξης ασφάλισης CMR',
    'CMR insurance has expired. Upload a new CMR Insurance for review.':
      'Ανεβάστε μια νέα ασφάλιση CMR για έλεγχο.',
    'CMR insurance is expiring within 14 days.':
      'Η ασφάλιση CMR λήγει εντός 14 ημερών.',
    'CMR Insurance required': 'Απαιτείται ασφάλιση CMR',
    Company: 'Εταιρεία',
    'Copy order ID': 'Αντιγραφή αναγνωριστικού παραγγελίας',
    Created: 'Δημιουργήθηκε',
    'Current expiry': 'Τρέχουσα λήξη',
    'Date range': 'Εύρος ημερομηνιών',
    days: 'ημέρες',
    Delay: 'Καθυστέρηση',
    'Delivered + partner invoice uploaded + unpaid':
      'Παραδόθηκε + τιμολόγιο συνεργάτη μεταφορτώθηκε + απλήρωτο',
    Document: 'Έγγραφο',
    'Documents uploaded': 'Έγγραφα μεταφορτώθηκαν',
    Done: 'Έγινε',
    'Download Client Invoice #{{id}}': 'Λήψη τιμολογίου πελάτη #{{id}}',
    'Download Invoice': 'Λήψη τιμολογίου',
    'Enter a valid capacity between 1 and 20 cars.':
      'Εισαγάγετε μια έγκυρη χωρητικότητα μεταξύ 1 και 20 αυτοκινήτων.',
    'Enter license plate': 'Εισαγάγετε την πινακίδα κυκλοφορίας',
    'Enter plate and upload CMR to add truck':
      'Εισαγάγετε πινακίδα και ανεβάστε CMR για να προσθέσετε φορτηγό',
    'Error fetching users': 'Σφάλμα κατά την ανάκτηση χρηστών',
    'Expire Soon (14 days)': 'Λήγει σύντομα (14 ημέρες)',
    'Explain why this CMR was rejected':
      'Εξηγήστε γιατί απορρίφθηκε αυτή η CMR',
    'Failed to copy order ID': 'Αποτυχία αντιγραφής αναγνωριστικού παραγγελίας',
    'Failed to download invoice': 'Η λήψη του τιμολογίου απέτυχε',
    'Failed to download proforma invoice': 'Η λήψη του προτιμολογίου απέτυχε',
    'Failed to generate invoice': 'Αποτυχία δημιουργίας τιμολογίου',
    'Failed to load invoice summary':
      'Η φόρτωση της περίληψης τιμολογίου απέτυχε',
    'Failed to load letter of attorney':
      'Απέτυχε η φόρτωση της πληρεξούσιας επιστολής',
    'Failed to open letter of attorney':
      'Απέτυχε το άνοιγμα της πληρεξούσιας επιστολής',
    'Failed to release booking': 'Η απελευθέρωση της κράτησης απέτυχε',
    'Fleet data refreshed': 'Τα δεδομένα στόλου ανανεώθηκαν',
    'Generate Client Invoice': 'Δημιουργία τιμολογίου πελάτη',
    'Generate Invoice': 'Δημιουργία Τιμολογίου',
    'Generated at': 'Δημιουργήθηκε στις',
    'How many cars can this truck carry?':
      'Πόσα αυτοκίνητα μπορεί να μεταφέρει αυτό το φορτηγό;',
    'In progress': 'Σε εξέλιξη',
    Invoice: 'Τιμολόγιο',
    'Invoice generated': 'Δημιουργήθηκε τιμολόγιο',
    'Invoice generated successfully': 'Το τιμολόγιο δημιουργήθηκε με επιτυχία',
    'Invoice uploaded': 'Το τιμολόγιο ανέβηκε',
    'Invoices uploaded by partners for platform payout processing. Client invoices are generated in each order view.':
      'Τα τιμολόγια πελάτη δημιουργούνται σε κάθε προβολή παραγγελίας.',
    'Keep booking': 'Συνεχίστε την κράτηση',
    'Keep your active drivers and contact details up to date.':
      'Διατηρήστε τα ενεργά προγράμματα οδήγησης και τα στοιχεία επικοινωνίας σας ενημερωμένα.',
    'Last Rejection': 'Τελευταία Απόρριψη',
    'Last rejection reason': 'Τελευταίος λόγος απόρριψης',
    'Letter of Attorney': 'Δικηγορική επιστολή',
    'Letter of attorney file is empty':
      'Ο φάκελος της πληρεξουσίας είναι κενός',
    'License plate cannot be changed after creation. Re-upload CMR Insurance instead.':
      'Ανεβάστε ξανά το CMR Insurance.',
    'License plate is required.': 'Απαιτείται πινακίδα κυκλοφορίας.',
    'Manage large order volumes with search, payment actions, and invoice workflows.':
      'Διαχειριστείτε μεγάλους όγκους παραγγελιών με αναζήτηση, ενέργειες πληρωμής και ροές εργασιών τιμολογίων.',
    'Manage license plates and keep CMR Insurances approved and valid.':
      'Διαχειριστείτε τις πινακίδες κυκλοφορίας και διατηρήστε τις ασφαλίσεις CMR εγκεκριμένες και έγκυρες.',
    'Manage status updates, documents, and payment steps from one place.':
      'Διαχειριστείτε ενημερώσεις κατάστασης, έγγραφα και βήματα πληρωμής από ένα μέρος.',
    'Manage trailer plate records and keep availability current.':
      'Διαχειριστείτε τα αρχεία πινακίδας τρέιλερ και διατηρήστε ενημερωμένη τη διαθεσιμότητα.',
    'Mark booking {{id}} as paid?': 'Επισήμανση κράτησης {{id}} ως πληρωμένη;',
    Missing: 'Λείπει',
    'Needs attention': 'Χρειάζεται προσοχή',
    'New (14 days)': 'Νέο (14 ημέρες)',
    'No bookings found for the current filters.':
      'Δεν βρέθηκαν κρατήσεις για τα τρέχοντα φίλτρα.',
    'No confirmed CMR document uploaded yet.':
      'Δεν έχει μεταφορτωθεί ακόμη επιβεβαιωμένο έγγραφο CMR.',
    'No driver assigned': 'Δεν έχει εκχωρηθεί πρόγραμμα οδήγησης',
    'No letter of attorney has been generated yet.':
      'Δεν έχει δημιουργηθεί ακόμη πληρεξούσιο έγγραφο.',
    'No matching delivered orders':
      'Δεν υπάρχουν παραγγελίες που να ταιριάζουν',
    'No new notifications': 'Δεν υπάρχουν νέες ειδοποιήσεις',
    'No partners found.': 'Δεν βρέθηκαν συνεργάτες.',
    'No trucks found for this filter.':
      'Δεν βρέθηκαν φορτηγά για αυτό το φίλτρο.',
    'No users found for current filters.':
      'Δεν βρέθηκαν χρήστες για τα τρέχοντα φίλτρα.',
    'Not uploaded': 'Δεν μεταφορτώθηκε',
    Notifications: 'Ειδοποιήσεις',
    of: 'του',
    'Only admins can set or update this expiry date after reviewing your CMR insurance.':
      'Μόνο οι διαχειριστές μπορούν να ορίσουν ή να ενημερώσουν αυτήν την ημερομηνία λήξης αφού ελέγξουν την ασφάλιση CMR.',
    'Open letter of attorney': 'Ανοικτή πληρεξούσια επιστολή',
    Order: 'Παραγγελία',
    'Order actions': 'Παραγγελία ενεργειών',
    'Order ID copied': 'Το αναγνωριστικό παραγγελίας αντιγράφηκε',
    Owner: 'Ιδιοκτήτης',
    Page: 'Σελίδα',
    'Paid date': 'Ημερομηνία πληρωμής',
    'Partner delivery date': 'Ημερομηνία παράδοσης συνεργάτη',
    'Partner documents': 'Έγγραφα συνεργατών',
    'Partner Invoice': 'Τιμολόγιο συνεργάτη',
    'Partner invoice uploaded': 'Μεταφορτώθηκε το τιμολόγιο συνεργάτη',
    'Partner Payout Invoices': 'Τιμολόγια πληρωμών συνεργάτη',
    'Partner pickup date': 'Ημερομηνία παραλαβής από συνεργάτη',
    'Partner score': 'Βαθμολογία συνεργάτη',
    Payment: 'Πληρωμή',
    'Payout date': 'Ημερομηνία πληρωμής',
    'penalties applied': 'επιβλήθηκαν κυρώσεις',
    'Pending admin review': 'Εκκρεμεί έλεγχος διαχειριστή',
    'Pending review': 'Εκκρεμεί έλεγχος',
    'Pending trucks': 'Φορτηγά σε εκκρεμότητα',
    'Please provide a clear reason for rejection.':
      'Δώστε έναν σαφή λόγο απόρριψης.',
    'Please select an order before uploading an invoice.':
      'Επιλέξτε μια παραγγελία πριν ανεβάσετε ένα τιμολόγιο.',
    'Please try again.': 'Δοκιμάστε ξανά.',
    'Proforma Invoice': 'Προτιμολόγιο',
    'Provide a rejection reason for this CMR review.':
      'Δώστε έναν λόγο απόρριψης για αυτήν την αξιολόγηση CMR.',
    'Quarter Score': 'Βαθμολογία τετάρτου',
    'Re-upload CMR': 'Ανεβάστε ξανά το CMR',
    Refresh: 'Ανανέωση',
    'Rejection reason': 'Λόγος απόρριψης',
    'Rejection reason is required': 'Απαιτείται λόγος απόρριψης',
    'Release booking {{id}} back to the marketplace so another partner can accept it?':
      'Απελευθέρωση της κράτησης {{id}} πίσω στην αγορά, ώστε κάποιος άλλος συνεργάτης να την αποδεχτεί;',
    Reset: 'Επαναφορά',
    'Review Bookings': 'Κρατήσεις κριτικής',
    Revision: 'Αναθεώρηση',
    Rows: 'Σειρές',
    'Search by invoice number, file name, or booking ID':
      'Αναζήτηση με αριθμό τιμολογίου, όνομα αρχείου ή αναγνωριστικό κράτησης',
    'Search by name, email, company': 'Αναζήτηση με όνομα, email, εταιρεία',
    'Search by name, email, company, uid':
      'Αναζήτηση με όνομα, email, εταιρεία, uid',
    'Search client': 'Αναζήτηση πελάτη',
    'Search delivered order': 'Αναζήτηση παραδοθείσας παραγγελίας',
    'Search license plate or owner':
      'Αναζήτηση πινακίδας κυκλοφορίας ή ιδιοκτήτη',
    'Search order ID': 'Αναγνωριστικό παραγγελίας αναζήτησης',
    'Search partner': 'Συνεργάτης αναζήτησης',
    'Select a new CMR Insurance to re-upload for this truck.':
      'Επιλέξτε μια νέα ασφάλιση CMR για να ανεβάσετε ξανά για αυτό το φορτηγό.',
    'Select paid date': 'Επιλέξτε ημερομηνία πληρωμής',
    'Set CMR insurance expiry date to approve this truck.':
      'Ορίστε την ημερομηνία λήξης της ασφάλισης CMR για να εγκρίνετε αυτό το φορτηγό.',
    'Set maximum number of cars this truck can carry (1-20).':
      'Ορίστε τον μέγιστο αριθμό αυτοκινήτων που μπορεί να μεταφέρει αυτό το φορτηγό (1-20).',
    'Set the CMR insurance expiry date before approval.':
      'Ορίστε την ημερομηνία λήξης της ασφάλισης CMR πριν από την έγκριση.',
    Showing: 'Εμφάνιση',
    'Showing page {{page}} of {{pages}} • {{total}} invoices':
      'Εμφάνιση σελίδας {{page}} από {{pages}} • {{total}} τιμολογίων',
    'Status will be updated to Picked Up after successful upload. You can add multiple car photos before uploading.':
      'Μπορείτε να προσθέσετε πολλές φωτογραφίες αυτοκινήτου πριν τις ανεβάσετε.',
    Terms: 'Όροι',
    Total: 'Σύνολο',
    'Track paid and unpaid invoices, expected payout dates, and upload new invoices quickly.':
      'Παρακολουθήστε πληρωμένα και απλήρωτα τιμολόγια, αναμενόμενες ημερομηνίες πληρωμής και ανεβάστε γρήγορα νέα τιμολόγια.',
    'Truck approved successfully': 'Το φορτηγό εγκρίθηκε με επιτυχία',
    'Truck documents': 'Έγγραφα φορτηγών',
    'Truck license plate': 'πινακίδα φορτηγού',
    'Truck rejected successfully': 'Το φορτηγό απορρίφθηκε με επιτυχία',
    'truck(s) are pending admin CMR expiry date.':
      'εκκρεμεί η ημερομηνία λήξης του διαχειριστή CMR.',
    'truck(s) have expired CMR insurance and are disabled.':
      'τα φορτηγά έχουν λήξει η ασφάλιση CMR και είναι απενεργοποιημένα.',
    'truck(s) will expire within 14 days.':
      'τα φορτηγά θα λήξουν εντός 14 ημερών.',
    'Unable to prepare the record for upload.':
      'Δεν είναι δυνατή η προετοιμασία της εγγραφής για μεταφόρτωση.',
    Unpaid: 'Απλήρωτοι',
    'Upload a CMR Insurance before closing this truck setup.':
      'Ανεβάστε μια ασφάλεια CMR πριν κλείσετε αυτήν τη ρύθμιση φορτηγού.',
    'Upload a valid CMR insurance. Each upload sends the truck back to pending review.':
      'Κάθε μεταφόρτωση στέλνει το φορτηγό σε εκκρεμή έλεγχο.',
    'Upload documents': 'Μεταφόρτωση εγγράφων',
    'Upload Invoice': 'Μεταφόρτωση τιμολογίου',
    'Upload order documents': 'Ανεβάστε έγγραφα παραγγελίας',
    'Upload unavailable': 'Η μεταφόρτωση δεν είναι διαθέσιμη',
    Uploaded: 'Μεταφορτώθηκε',
    'Uploaded • Paid': 'Μεταφορτώθηκε • Πληρώθηκε',
    'Uploaded • Partially paid': 'Μεταφορτώθηκε • Μερικώς πληρωμένη',
    'Uploaded by partner for platform payout processing.':
      'Μεταφορτώθηκε από συνεργάτη για επεξεργασία πληρωμών πλατφόρμας.',
    User: 'Χρήστης',
    'Verification code': 'Κωδικός επαλήθευσης',
    'View details': 'Δείτε λεπτομέρειες',
    'View Partners': 'Προβολή Συνεργατών',
    'Working hours not provided': 'Δεν παρέχονται ώρες εργασίας',
    '{{value}} orders': 'Παραγγελίες {{value}}',
    Invoiced: 'Τιμολογήθηκε',
    'Loading admin data...': 'Φόρτωση δεδομένων διαχειριστή...',
    'Pending partners': 'Εκκρεμείς συνεργάτες',
    'Unpaid bookings': 'Απλήρωτες κρατήσεις',
    'Total users': 'Σύνολο χρηστών',
    'Orders per period': 'Παραγγελίες ανά περίοδο',
    'Orders by status': 'Παραγγελίες ανά κατάσταση',
    'Quick actions': 'Γρήγορες ενέργειες',
    'Verify new partners': 'Επαληθεύστε νέους συνεργάτες',
    'Review partner applications and approve or reject requests.':
      'Ελέγξτε τις αιτήσεις συνεργατών και εγκρίνετε ή απορρίπτετε αιτήματα.',
    'Manage all trucks': 'Διαχειριστείτε όλα τα φορτηγά',
    'Review, approve, reject, disable, and filter all trucks.':
      'Ελέγξτε, εγκρίνετε, απορρίψτε, απενεργοποιήστε και φιλτράρετε όλα τα φορτηγά.',
    'Review bookings': 'Ελέγξτε τις κρατήσεις',
    'Review all transport orders, payment states, and generated invoices.':
      'Ελέγξτε όλες τις παραγγελίες μεταφοράς, τις καταστάσεις πληρωμής και τα τιμολόγια που δημιουργήθηκαν.',
    'Manage all users': 'Διαχείριση όλων των χρηστών',
    'Manage user status, roles, and validation records.':
      'Διαχειριστείτε την κατάσταση χρήστη, τους ρόλους και τις εγγραφές επικύρωσης.',
    'User breakdown': 'Ανάλυση χρήστη',
    Clients: 'πελάτες',
    Partners: 'Συνεργάτες',
    Admins: 'Διαχειριστές',
    'Top 5 pending partners': 'Οι κορυφαίοι 5 συνεργάτες σε εκκρεμότητα',
    'No pending partners right now.':
      'Δεν υπάρχουν εκκρεμείς συνεργάτες αυτήν τη στιγμή.',
    pending: 'σε εκκρεμότητα',
    'Top 5 pending trucks': 'Κορυφαία 5 φορτηγά σε εκκρεμότητα',
    'No pending trucks right now.':
      'Δεν υπάρχουν φορτηγά σε εκκρεμότητα αυτήν τη στιγμή.',
    'Unknown owner': 'Άγνωστος ιδιοκτήτης',
    'KPI cards and top lists link directly to filtered admin screens.':
      'Οι κάρτες KPI και οι κορυφαίες λίστες συνδέονται απευθείας με φιλτραρισμένες οθόνες διαχειριστή.',
    'booking.available_orders_title': 'Διαθέσιμες παραγγελίες',
    'booking.available_orders_description':
      'Ελέγξτε τις εισερχόμενες ευκαιρίες μεταφοράς και εφαρμόστε φίλτρα που ταιριάζουν με τη χωρητικότητά σας.',
    'booking.vehicle_pickup_location': 'Τοποθεσία παραλαβής οχήματος',
    'booking.pickup_opening_hours': 'Ώρες λειτουργίας παραλαβής',
    'booking.vehicle_delivery_location': 'Τοποθεσία παράδοσης οχήματος',
    'booking.delivery_opening_hours': 'Ώρες λειτουργίας παράδοσης',
    'booking.pickup_contact': 'Επικοινωνία παραλαβής',
    'booking.delivery_contact': 'Επικοινωνία παράδοσης',
    'booking.vehicles_scheduled': 'Προγραμματισμένα οχήματα',
    'booking.watchlist_title': 'Λίστα παρακολούθησης',
    'booking.watchlist_description':
      'Παρακολουθήστε τις αποθηκευμένες ευκαιρίες και ενεργήστε γρήγορα καθώς αλλάζει η διαθεσιμότητα.',
    'Loading dashboard...': 'Φόρτωση πίνακα ελέγχου...',
    'Total bookings': 'Σύνολο κρατήσεων',
    'Open bookings': 'Ανοιχτές κρατήσεις',
    'Order status timeline': 'Χρονοδιάγραμμα κατάστασης παραγγελίας',
    'Last 6 months of bookings grouped by current status.':
      'Οι τελευταίοι 6 μήνες κρατήσεων ομαδοποιούνται με βάση την τρέχουσα κατάσταση.',
    'Create new order': 'Δημιουργία νέας παραγγελίας',
    'Create a new transport booking request.':
      'Δημιουργήστε ένα νέο αίτημα κράτησης μεταφοράς.',
    'View my orders': 'Δείτε τις παραγγελίες μου',
    'Review status and details of your bookings.':
      'Ελέγξτε την κατάσταση και τις λεπτομέρειες των κρατήσεών σας.',
    'Open profile': 'Άνοιγμα προφίλ',
    'Update company and contact details.':
      'Ενημέρωση εταιρείας και στοιχείων επικοινωνίας.',
    'Recent bookings': 'Πρόσφατες κρατήσεις',
    'No bookings yet.': 'Δεν υπάρχουν ακόμη κρατήσεις.',
    'Unknown destination': 'Άγνωστος προορισμός',
    'Quarter score': 'Σκορ τέταρτο',
    '{{value}} completed': '{{value}} ολοκληρωθεί',
    'Truck CMR warning': 'Προειδοποίηση CMR φορτηγού',
    'One truck has CMR expiry risk. Review it in Fleet.':
      'Ένα φορτηγό έχει κίνδυνο λήξης CMR. Ελέγξτε το στο Fleet.',
    '{{count}} trucks have CMR expiry risk. Review them in Fleet.':
      'Τα φορτηγά {{count}} έχουν κίνδυνο λήξης CMR. Ελέγξτε τα στο Fleet.',
    'Active queue': 'Ενεργή ουρά',
    'Delivered bookings': 'Παραδόθηκαν κρατήσεις',
    'Cars delivered': 'Παραδόθηκαν αυτοκίνητα',
    'Canceled bookings': 'Ακυρωμένες κρατήσεις',
    'Avg assign-to-pickup': 'Μέση ανάθεση σε παραλαβή',
    'Quarter Partner Score': 'Βαθμολογία συνεργάτη τριμήνου',
    'Payment delay: +{{days}} days': 'Καθυστέρηση πληρωμής: +{{days}} ημέρες',
    'Penalty events': 'Γεγονότα πέναλτι',
    'Partner rating': 'Αξιολόγηση συνεργάτη',
    'Bronze requirements': 'Απαιτήσεις για μπρούτζο',
    'Orders in quarter': 'Παραγγελίες σε τρίμηνο',
    'Cancellation rate / 100 orders': 'Ποσοστό ακύρωσης / 100 παραγγελίες',
    'Damage claims / 100 orders': 'Αξιώσεις αποζημίωσης / 100 παραγγελίες',
    '{{current}} / min {{target}}': '{{current}} / λεπτό {{target}}',
    '{{current}} / max {{target}}': '{{current}} / μέγιστο {{target}}',
    Met: 'Met',
    'Not met': 'Δεν συναντήθηκε',
    Unranked: 'Χωρίς κατάταξη',
    Current: 'Τρέχον',
    'Completed orders per period': 'Ολοκληρωμένες παραγγελίες ανά περίοδο',
    'Completed orders': 'Ολοκληρωμένες παραγγελίες',
    'Truck CMR status alerts': 'Ειδοποιήσεις κατάστασης CMR φορτηγού',
    '{{count}} truck(s) have expired CMR insurance.':
      '{{count}} φορτηγό(α) έχουν λήξει η ασφάλεια CMR.',
    '{{count}} truck(s) will expire within 14 days.':
      'Τα φορτηγά {{count}} θα λήξουν εντός 14 ημερών.',
    '{{count}} truck(s) are missing CMR expiry date.':
      'Λείπει η ημερομηνία λήξης CMR σε φορτηγά {{count}}.',
    'Upload a new CMR Insurance in Fleet. The truck will stay pending until admin review.':
      'Ανεβάστε μια νέα ασφάλιση CMR στο Fleet. Το φορτηγό θα παραμείνει σε εκκρεμότητα μέχρι τον έλεγχο από τον διαχειριστή.',
    'Open fleet to resolve CMR alerts':
      'Ανοίξτε τον στόλο για επίλυση ειδοποιήσεων CMR',
    'Operational actions': 'Επιχειρησιακές ενέργειες',
    'Open marketplace orders': 'Παραγγελίες ανοιχτής αγοράς',
    'Review available orders and plan assignments.':
      'Ελέγξτε τις διαθέσιμες παραγγελίες και σχεδιάστε αναθέσεις.',
    'My accepted orders': 'Αποδεκτές παραγγελίες μου',
    'Manage delivery progress and documents.':
      'Διαχειριστείτε την πρόοδο και τα έγγραφα παράδοσης.',
    'Update trucks, trailers, and availability.':
      'Ενημερώστε τα φορτηγά, τα ρυμουλκούμενα και τη διαθεσιμότητα.',
    'Partner invoices': 'Τιμολόγια συνεργατών',
    'Upload and track invoice payments.':
      'Μεταφορτώστε και παρακολουθήστε τις πληρωμές τιμολογίων.',
    'No active orders in queue.': 'Δεν υπάρχουν ενεργές παραγγελίες στην ουρά.',
    'profile.incompleteTitle': 'Ημιτελές προφίλ',
    'profile.incompleteDescription':
      'Συμπληρώστε τα στοιχεία του προφίλ σας (Εταιρία, Τηλέφωνο, Διεύθυνση, Πόλη, Ταχυδρομικός Κώδικας) για να αποκτήσετε πρόσβαση σε όλες τις λειτουργίες.',
    'profile.incompleteDescriptionPartner':
      'Συμπληρώστε τα στοιχεία του προφίλ σας (Εταιρία, Τηλέφωνο, Διεύθυνση, Πόλη, Ταχυδρομικός Κώδικας, ΑΦΜ) για πρόσβαση σε όλες τις λειτουργίες.',
    'profile.incompleteDescriptionClient':
      'Συμπληρώστε τα στοιχεία του προφίλ σας (Αριθμός τηλεφώνου) για πρόσβαση σε όλες τις λειτουργίες.',
    'profile.goToProfile': 'Μεταβείτε στο Προφίλ',
    'auth.email_placeholder': 'name@company.com',
    'auth.authentication_mode_switch':
      'Διακόπτης λειτουργίας ελέγχου ταυτότητας',
    'auth.invalid_email': 'Μη έγκυρο email',
    'auth.please_enter_a_valid_email_address':
      'Εισαγάγετε μια έγκυρη διεύθυνση email.',
    'auth.email_not_found': 'Το email δεν βρέθηκε',
    'auth.no_account_found_with_that_email_address':
      'Δεν βρέθηκε λογαριασμός με αυτήν τη διεύθυνση email.',
    'auth.email_sent': 'Το email στάλθηκε!',
    'auth.something_went_wrong_try_again':
      'Κάτι πήγε στραβά. Προσπαθήστε ξανά.',
    'auth.we_sent_a_password_reset_link_open_your_inbox_and_follow_the_instructions':
      'Στείλαμε έναν σύνδεσμο επαναφοράς κωδικού πρόσβασης. Ανοίξτε τα εισερχόμενά σας και ακολουθήστε τις οδηγίες.',
    'auth.forgot_your_password': 'Ξεχάσατε τον κωδικό σας;',
    'auth.enter_your_account_email_and_we_will_send_you_a_password_reset_link':
      'Εισαγάγετε το email του λογαριασμού σας και θα σας στείλουμε έναν σύνδεσμο επαναφοράς κωδικού πρόσβασης.',
    'auth.email_address': 'Διεύθυνση ηλεκτρονικού ταχυδρομείου',
    'auth.send_reset_link': 'Αποστολή συνδέσμου επαναφοράς',
    'auth.cancel': 'Ακύρωση',
    'auth.tip_if_you_do_not_receive_the_email_check_spam_and_promotions_folders':
      'Συμβουλή: εάν δεν λάβετε το email, ελέγξτε τους φακέλους ανεπιθύμητων μηνυμάτων και προσφορών.',
    'auth.confirm_password': 'Επιβεβαίωση κωδικού πρόσβασης',
    'auth.confirm_password_is_required':
      'Απαιτείται επιβεβαίωση κωδικού πρόσβασης.',
    'auth.create_account': 'Δημιουργία λογαριασμού',
    'auth.email': 'Email',
    'auth.email_is_required': 'Απαιτείται email.',
    'auth.enter_your_email_and_password_to_sign_in':
      'Εισαγάγετε το email και τον κωδικό πρόσβασής σας για να συνδεθείτε!',
    'auth.enter_your_email_create_a_password_and_choose_a_role_to_register':
      'Εισαγάγετε το email σας, δημιουργήστε έναν κωδικό πρόσβασης και επιλέξτε έναν ρόλο για εγγραφή.',
    'auth.failed_to_resend_email': 'Απέτυχε η εκ νέου αποστολή email',
    'auth.forgot_password': 'Ξεχάσατε τον κωδικό πρόσβασης;',
    'auth.show_password': 'Εμφάνιση κωδικού πρόσβασης',
    'auth.hide_password': 'Απόκρυψη κωδικού πρόσβασης',
    'auth.i_want_to_register_as_a': 'Θέλω να εγγραφώ ως α',
    'auth.incorrect_password_please_try_again':
      'Λανθασμένος κωδικός πρόσβασης. Δοκιμάστε ξανά.',
    'auth.invalid_email_format': 'Μη έγκυρη μορφή email.',
    'auth.invalid_email_or_password_please_check_your_credentials_and_try_again':
      'Μη έγκυρο email ή κωδικός πρόσβασης. Ελέγξτε τα διαπιστευτήριά σας και δοκιμάστε ξανά.',
    'auth.join_our_network_of_transport_partners':
      'Γίνετε μέλος του δικτύου συνεργατών μας στον τομέα των μεταφορών.',
    'auth.login_failed': 'Η σύνδεση απέτυχε',
    'auth.min_8_characters': 'Ελάχ. 8 χαρακτήρες',
    'auth.order_transportation_in_the_automotive_branch':
      'Παραγγελία μεταφοράς στο υποκατάστημα αυτοκινήτων.',
    'auth.password': 'Κωδικός πρόσβασης',
    'auth.password_is_required': 'Απαιτείται κωδικός πρόσβασης.',
    'auth.passwords_do_not_match': 'Οι κωδικοί πρόσβασης δεν ταιριάζουν.',
    'auth.resend_verification_email': 'Αποστολή εκ νέου email επαλήθευσης',
    'auth.verification_email_sent': 'Το email επαλήθευσης στάλθηκε',
    'auth.we_sent_a_new_verification_link':
      'Στείλαμε έναν νέο σύνδεσμο επαλήθευσης στη διεύθυνση email σας.',
    'auth.unable_to_resend_verification_email_right_now':
      'Δεν είναι δυνατή η εκ νέου αποστολή email επαλήθευσης αυτήν τη στιγμή.',
    'auth.email_verified': 'Το email επαληθεύτηκε',
    'auth.redirecting_you_now': 'Ανακατεύθυνση σας τώρα.',
    'auth.email_not_verified_yet': 'Το email δεν έχει επαληθευτεί ακόμα',
    'auth.please_click_the_link_in_your_inbox_and_try_again':
      'Κάντε κλικ στον σύνδεσμο στα εισερχόμενά σας και δοκιμάστε ξανά.',
    'auth.unable_to_check_verification_status_right_now':
      'Δεν είναι δυνατός ο έλεγχος της κατάστασης επαλήθευσης αυτήν τη στιγμή.',
    'auth.email_verification_required': 'Απαιτείται επαλήθευση email',
    'auth.check_your_email': 'Ελέγξτε το email σας',
    'auth.waiting_for_email_verification': 'Αναμονή για επαλήθευση μέσω email',
    'auth.we_sent_your_verification_link_to':
      'Στείλαμε τον σύνδεσμο επαλήθευσης στη διεύθυνση',
    'auth.didnt_receive_it_check_spam_or_try_again':
      'Δεν το έλαβες; Ελέγξτε το ανεπιθύμητο περιεχόμενο ή δοκιμάστε ξανά.',
    'auth.i_verified_my_email': 'Επιβεβαίωσα το email μου',
    'auth.resend_email': 'Επανάληψη αποστολής email',
    'auth.we_automatically_check_every_15_seconds':
      'Ελέγχουμε αυτόματα την κατάσταση επαλήθευσης κάθε 15 δευτερόλεπτα. Μπορείτε επίσης να ενεργοποιήσετε έναν άμεσο έλεγχο αφού επαληθεύσετε το email σας.',
    'auth.sign_in': 'Είσοδος',
    'auth.sign_in_2': 'Συνδεθείτε',
    'auth.sign_up': 'Εγγραφείτε',
    'auth.sign_up_2': 'Εγγραφείτε',
    'auth.username': 'Όνομα χρήστη',
    'auth.username_is_required': 'Απαιτείται όνομα χρήστη.',
    'auth.your_name': 'Το όνομά σου',
    'booking.e_g_berlin': 'π.χ. Βερολίνο',
    'booking.e_g_germany': 'π.χ. Γερμανία',
    'booking.watchlist': 'Λίστα παρακολούθησης',
    'booking.view_map': 'Προβολή χάρτη',
    'booking.invalid_input': 'Μη έγκυρη εισαγωγή',
    'booking.please_enter_only_numbers_for_the_zip_code':
      'Εισαγάγετε μόνο αριθμούς για τον ταχυδρομικό κώδικα.',
    'booking.pickup_zip_code': 'Ταχυδρομικός κώδικας παραλαβής',
    'booking.delivery_zip_code': 'Ταχυδρομικός κώδικας παράδοσης',
    'booking.select_vehicle_make': 'Επιλέξτε μάρκα οχήματος',
    'booking.unnamed_item': 'Ανώνυμο στοιχείο',
    'booking.cars': 'αυτοκίνητα',
    'booking.more_info': 'Περισσότερες πληροφορίες',
    'booking.loading': 'Φόρτωση...',
    'booking.no_items_found': 'Δεν βρέθηκαν στοιχεία',
    'booking.selected_cars': 'Επιλεγμένα αυτοκίνητα',
    'booking.unknown_type': 'Άγνωστος τύπος',
    'booking.delete_car': 'Διαγραφή αυτοκινήτου',
    'Toggle details': 'Εναλλαγή λεπτομερειών',
    'booking.order': 'Παραγγελία',
    'booking.duration': 'Διάρκεια',
    'booking.vehicles_overview': 'Επισκόπηση οχημάτων',
    'booking.body': 'Σώμα',
    'booking.dims': 'Dims',
    'booking.select_vehicle_model': 'Επιλέξτε μοντέλο οχήματος',
    'booking.selected_type_value': 'Επιλεγμένα: {{value}}',
    'booking.select_a_vehicle_type': 'Επιλέξτε τύπο οχήματος:',
    'booking.select_vehicle_weight': 'Επιλέξτε το βάρος του οχήματος',
    'booking.selected_weight_kg': 'Επιλεγμένα: {{value}} kg',
    'booking.adjust_weight': 'Ρυθμίστε το βάρος',
    'Dates updated successfully': 'Οι ημερομηνίες ενημερώθηκαν με επιτυχία',
    'Error updating dates': 'Σφάλμα ενημέρωσης ημερομηνιών',
    'Set Planned Dates': 'Ορίστε προγραμματισμένες ημερομηνίες',
    'Set your planned pickup and arrival dates below.':
      'Ορίστε τις προγραμματισμένες ημερομηνίες παραλαβής και άφιξης παρακάτω.',
    'Changing dates after initial setup will deduct 20% from your performance score for this order.':
      'Η αλλαγή ημερομηνιών μετά την αρχική ρύθμιση θα αφαιρέσει 20% από τη βαθμολογία απόδοσής σας για αυτήν την παραγγελία.',
    'Planned Pickup Date': 'Προγραμματισμένη ημερομηνία παραλαβής',
    'Planned Arrival Date': 'Προγραμματισμένη ημερομηνία άφιξης',
    'auth.a_verification_email_has_been_sent_to_your_email_address_please_verify_your_emai':
      'Ένα email επαλήθευσης έχει σταλεί στη διεύθυνση email σας. Επαληθεύστε το email σας πριν συνδεθείτε.',
    'auth.an_unexpected_error_occurred_please_try_again':
      'Παρουσιάστηκε απροσδόκητο σφάλμα. Δοκιμάστε ξανά.',
    'booking.accept': 'Αποδοχή',
    'booking.add_a_weight_for_each_vehicle':
      'Προσθέστε ένα βάρος για κάθε όχημα.',
    'booking.add_at_least_one_delivery_time_window':
      'Προσθέστε τουλάχιστον ένα παράθυρο χρόνου παράδοσης.',
    'booking.add_at_least_one_pickup_time_window':
      'Προσθέστε τουλάχιστον ένα παράθυρο χρόνου παραλαβής.',
    'booking.add_at_least_one_vehicle': 'Προσθέστε τουλάχιστον ένα όχημα.',
    'booking.add_time': 'Προσθέστε χρόνο',
    'booking.add_to_watchlist': 'Προσθήκη στη λίστα παρακολούθησης',
    'booking.add_vehicle': 'Προσθήκη οχήματος',
    'booking.additional_information': 'Πρόσθετες πληροφορίες',
    'booking.address': 'Διεύθυνση',
    'booking.an_unexpected_error_occurred': 'Παρουσιάστηκε απροσδόκητο σφάλμα.',
    'booking.apply_filters': 'Εφαρμόστε φίλτρα',
    'booking.arrival_date': 'Ημερομηνία Άφιξης',
    'booking.autobid': 'Αυτόματη προσφορά',
    'booking.autobid_set_up_to_price':
      'Ρύθμιση αυτόματης προσφοράς έως {{price}}',
    'booking.avg_weight_kg': 'Μέσος όρος βάρος (kg)',
    'booking.avoid_missed_trips_by_matching_the_window_the_truck_can_enter_the_premises':
      'Αποφύγετε τα χαμένα ταξίδια ταιριάζοντας με το παράθυρο που μπορεί να εισέλθει το φορτηγό στις εγκαταστάσεις.',
    'booking.body_type': 'Σωματότυπος',
    'booking.booking_created': 'Η κράτηση δημιουργήθηκε',
    'booking.booking_failed': 'Η κράτηση απέτυχε',
    'booking.booking_was_created_but_no_id_returned':
      'Η κράτηση δημιουργήθηκε αλλά δεν επέστρεψε κανένα αναγνωριστικό.',
    'booking.calculate_a_price_to_proceed':
      'Υπολογίστε μια τιμή για να συνεχίσετε.',
    'booking.calculate_to_preview_your_quote':
      'Υπολογίστε για να κάνετε προεπισκόπηση της προσφοράς σας.',
    'booking.chassis_number_licence_plate':
      'Αριθμός πλαισίου/Πινακίδα άδειας κυκλοφορίας',
    'booking.choose_file': 'Επιλέξτε αρχείο',
    'booking.city_not_set': 'Η πόλη δεν έχει οριστεί',
    'booking.clear': 'Καθαρό',
    'booking.closed': 'Κλειστό',
    'booking.company_name': 'Επωνυμία εταιρείας',
    'booking.complete_missing_data': 'Συμπληρώστε δεδομένα που λείπουν',
    'booking.confirm': 'Επιβεβαίωση',
    'booking.confirm_the_delivery_opening_hours':
      'Επιβεβαιώστε τις ώρες λειτουργίας παράδοσης.',
    'booking.confirm_the_pickup_opening_hours':
      'Επιβεβαιώστε τις ώρες λειτουργίας της παραλαβής.',
    'booking.contact_email': 'Email επικοινωνίας',
    'booking.contact_language': 'Γλώσσα επικοινωνίας',
    'booking.contact_person': 'Υπεύθυνος επικοινωνίας',
    'booking.contact_phone': 'Τηλέφωνο επικοινωνίας',
    'booking.country': 'Χώρα',
    'booking.current_price': 'Τρέχουσα τιμή',
    'booking.delivery': 'Παράδοση',
    'booking.delivery_city': 'Πόλη παράδοσης',
    'booking.delivery_country': 'Χώρα παράδοσης',
    'booking.details': 'Λεπτομέρειες',
    'booking.determine_the_route_and_select_options_that_match_your_vehicle_mix':
      'Καθορίστε τη διαδρομή και επιλέξτε επιλογές που ταιριάζουν με το μείγμα του οχήματός σας.',
    'booking.dimensions_cm': 'Διαστάσεις (cm)',
    'booking.distance': 'Απόσταση',
    'booking.distance_and_time': 'Απόσταση & χρόνος',
    'booking.documents_needed_on_site': 'Έγγραφα που απαιτούνται επί τόπου',
    'booking.e_g_200': 'π.χ. 200',
    'booking.e_g_2200': 'π.χ. 2200',
    'booking.e_g_mercedes_benz_gle_450': 'π.χ. Mercedes-Benz GLE 450',
    'booking.email': 'Email',
    'booking.endpoint': 'Τέλος',
    'booking.enter_manual_price': 'Εισαγάγετε μη αυτόματη τιμή',
    'booking.environmental_or_compliance_notes':
      'Σημειώσεις για το περιβάλλον ή τη συμμόρφωση',
    'booking.error_creating_booking': 'Σφάλμα κατά τη δημιουργία κράτησης',
    'booking.error_fetching_data': 'Σφάλμα κατά την ανάκτηση δεδομένων',
    'booking.estimated': 'Εκτιμώμενος',
    'booking.estimated_price': 'Εκτιμώμενη τιμή',
    'booking.estimated_total_client_price_price':
      'Εκτιμώμενη συνολική τιμή πελάτη €{{price}}',
    'booking.excl_any_partner_fees': 'Εξαιρ. τυχόν αμοιβές συνεργατών',
    'booking.failed_to_accept': 'Αποτυχία αποδοχής',
    'booking.profile_incomplete_title': 'Ημιτελές προφίλ',
    'booking.favorite_routes_stay_saved_for_quick_access':
      'Οι αγαπημένες διαδρομές παραμένουν αποθηκευμένες για γρήγορη πρόσβαση.',
    'booking.fill_in_the_address_and_contact_person_this_helps_dispatch_align_pickups_with_lo':
      'Συμπληρώστε τη διεύθυνση και το άτομο επικοινωνίας. Αυτό βοηθά στην αποστολή να ευθυγραμμιστούν τα pickups με τους συνεργάτες logistics.',
    'booking.fill_in_the_details_and_specify_the_parameters_for_every_vehicle_type':
      'Συμπληρώστε τα στοιχεία και καθορίστε τις παραμέτρους για κάθε τύπο οχήματος.',
    'booking.filter_orders': 'Φιλτράρισμα παραγγελιών',
    'booking.finalize_the_handover_plan_with_scheduling_cues_site_availability_and_sustainabi':
      'Ολοκληρώστε το σχέδιο παράδοσης με ενδείξεις προγραμματισμού, διαθεσιμότητα τοποθεσίας και προτιμήσεις βιωσιμότητας. Αυτή η προβολή διατηρεί τα πάντα κρίσιμα σε ένα μέρος χωρίς να επαναλαμβάνει λεπτομέρειες από προηγούμενα βήματα.',
    'booking.finish_each_step_before_creating_the_booking':
      'Ολοκληρώστε κάθε βήμα πριν δημιουργήσετε την κράτηση.',
    'booking.from': 'Από',
    'booking.height_cm': 'Ύψος (cm)',
    'booking.i_confirm_the_delivery_opening_hours':
      'Επιβεβαιώνω τις ώρες λειτουργίας παράδοσης',
    'booking.i_confirm_the_pickup_opening_hours':
      'Επιβεβαιώνω τις ώρες λειτουργίας της παραλαβής',
    'booking.i_confirm_these_opening_hours_are_correct':
      'Επιβεβαιώνω ότι αυτές οι ώρες λειτουργίας είναι σωστές',
    'booking.inputs_changed_recalc_to_refresh_quote':
      'Οι είσοδοι άλλαξαν · επανυπολογισμός για ανανέωση της προσφοράς',
    'booking.inputs_changed_recalculate_the_price':
      'Οι είσοδοι άλλαξαν. Υπολογίστε ξανά την τιμή.',
    'booking.keep_an_eye_on_the_quote_as_you_tweak_route_details_or_vehicle_mix':
      'Παρακολουθήστε την προσφορά καθώς τροποποιείτε τις λεπτομέρειες της διαδρομής ή το μείγμα οχημάτων.',
    'booking.kg': 'κιλά',
    'booking.km': 'χλμ',
    'booking.lane': 'Lane',
    'booking.latest_quote_preview': 'Τελευταία προεπισκόπηση προσφοράς',
    'booking.length_cm': 'Μήκος (cm)',
    'booking.loading_address_is_logistic_centre':
      'Η διεύθυνση φόρτωσης είναι κέντρο υλικοτεχνικής υποστήριξης',
    'booking.loading_address_is_not_logistic_centre':
      'Η διεύθυνση φόρτωσης δεν είναι κέντρο υλικοτεχνικής υποστήριξης',
    'booking.loading_notification': 'Φόρτωση ειδοποίησης',
    'booking.loading_notifications': 'Φόρτωση ειδοποιήσεων',
    'booking.loading_only_possible_from_08_00_to_17_00_ask_for_johan':
      'Η φόρτωση είναι δυνατή μόνο από τις 08:00 έως τις 17:00. Ζητήστε τον Γιόχαν.',
    'booking.local_time': 'Τοπική ώρα',
    'booking.location': 'Τοποθεσία',
    'booking.make_model': 'Μάρκα / Μοντέλο',
    'booking.max_cars': 'Max αυτοκίνητα',
    'booking.maximum_price': 'Μέγιστη τιμή',
    'booking.mi': 'mi',
    'booking.min_cars': 'Ελάχιστα αυτοκίνητα',
    'booking.monitor_every_booking_with_the_same_clarity_as_the_new_order_wizard_filter_by_la':
      'Παρακολουθήστε κάθε κράτηση με την ίδια σαφήνεια όπως ο οδηγός Νέας Παραγγελίας. Φιλτράρετε ανά λωρίδα, κατάσταση ή χρονικό παράθυρο και μεταβείτε στις λεπτομέρειες πιο γρήγορα.',
    'booking.n_1_day_before': '1 μέρα πριν',
    'booking.n_1_week_before': '1 εβδομάδα πριν',
    'booking.n_2_days_before': '2 μέρες πριν',
    'booking.next': 'Επόμενο',
    'booking.no_contact_set': 'Δεν έχει οριστεί επαφή',
    'booking.no_opening_hours_provided': 'Δεν παρέχονται ώρες λειτουργίας',
    'booking.no_orders_match_your_filter':
      'Καμία παραγγελία δεν ταιριάζει με το φίλτρο σας.',
    'booking.no_vehicles_added_yet': 'Δεν έχουν προστεθεί ακόμη οχήματα.',
    'booking.no_vehicles_listed': 'Δεν αναφέρονται οχήματα',
    'booking.no_vehicles_selected_yet': 'Δεν έχουν επιλεγεί ακόμη οχήματα.',
    'booking.non_runner': 'Μη δρομέας',
    'booking.none': 'Κανένα',
    'booking.not_available': 'Μη διαθέσιμο',
    'booking.notes_for_the_partner': 'Σημειώσεις για τον συνεργάτη',
    'booking.offset_co_emissions_for_this_shipment':
      'Αντιστάθμιση εκπομπών CO₂ για αυτήν την αποστολή',
    'booking.one_of_the_locations_could_not_be_positioned_on_the_map':
      'Δεν ήταν δυνατή η τοποθέτηση μιας από τις τοποθεσίες στον χάρτη.',
    'booking.open_filters': 'Ανοίξτε τα φίλτρα',
    'booking.open_map': 'Άνοιγμα χάρτη',
    'booking.opening_hours': 'Ώρες λειτουργίας',
    'booking.or': 'ή',
    'booking.order_accepted_for_date': 'Δεκτή παραγγελία για {{date}}',
    'booking.orders_refresh_automatically_every_5_minutes':
      'Οι παραγγελίες ανανεώνονται αυτόματα κάθε 5 λεπτά.',
    'booking.pick_up': 'Σήκωσε',
    'booking.pick_up_city': 'Πάρτε την πόλη',
    'booking.pick_up_country': 'Πάρτε χώρα',
    'booking.pickup_date': 'Ημερομηνία παραλαβής',
    'booking.pickup_date_must_be_selected':
      'Πρέπει να επιλεγεί η ημερομηνία παραλαβής.',
    'booking.pickup_document': 'Έγγραφο παραλαβής',
    'booking.please_select_a_driver_and_truck': 'Επιλέξτε οδηγό και φορτηγό',
    'booking.please_select_a_planned_date':
      'Επιλέξτε μια προγραμματισμένη ημερομηνία',
    'booking.point': 'Σημείο',
    'booking.prefer_biofuel_usage_where_available':
      'Προτιμήστε τη χρήση βιοκαυσίμων όπου είναι διαθέσιμο',
    'booking.preferences_and_notes': 'Προτιμήσεις & σημειώσεις',
    'booking.premium_pricing_for_vip_customers':
      'Premium τιμολόγηση για VIP πελάτες',
    'booking.previous': 'Προηγούμενο',
    'booking.provide_an_estimated_weight_to_calculate_price':
      'Δώστε ένα εκτιμώμενο βάρος για τον υπολογισμό της τιμής.',
    'booking.provide_both_pickup_and_delivery_postal_codes_to_preview_the_lane_on_the_map':
      'Καταχωρίστε τους ταχυδρομικούς κωδικούς παραλαβής και παράδοσης για προεπισκόπηση της λωρίδας στο χάρτη.',
    'booking.provide_route_details': 'Δώστε λεπτομέρειες διαδρομής',
    'booking.quantity': 'Ποσότητα',
    'booking.quote_updated': 'Η προσφορά ενημερώθηκε',
    'booking.quoted_price': 'Αναφερόμενη τιμή',
    'booking.ready_from': 'Έτοιμοι από',
    'booking.refresh_now': 'Ανανέωση τώρα',
    'booking.remove_file': 'Κατάργηση αρχείου',
    'booking.remove_from_watchlist': 'Κατάργηση από τη λίστα παρακολούθησης',
    'booking.remove_time_slot': 'Αφαιρέστε τη χρονική υποδοχή',
    'booking.remove_vehicle': 'Αφαιρέστε το όχημα',
    'booking.required': 'Απαιτείται',
    'booking.route': 'Διαδρομή',
    'booking.route_details': 'Λεπτομέρειες διαδρομής',
    'booking.route_map': 'Χάρτης διαδρομής',
    'booking.route_preview': 'Προεπισκόπηση διαδρομής',
    'booking.save': 'Αποθήκευση',
    'booking.save_preset': 'Αποθήκευση προεπιλογής',
    'booking.search_by_id_ref_city': 'Αναζήτηση με ταυτότητα, αναφορά, πόλη...',
    'booking.select_a_driver': 'Επιλέξτε ένα πρόγραμμα οδήγησης',
    'booking.select_a_trailer': 'Επιλέξτε ένα τρέιλερ',
    'booking.select_a_truck': 'Επιλέξτε ένα φορτηγό',
    'booking.select_delivery_date': 'Επιλέξτε Ημερομηνία Παράδοσης',
    'booking.select_pick_up_date': 'Επιλέξτε Ημερομηνία παραλαβής',
    'booking.select_planned_date': 'Επιλέξτε Προγραμματισμένη ημερομηνία',
    'booking.select_the_date_when_the_cargo_is_to_be_delivered':
      'Επιλέξτε την ημερομηνία παράδοσης του φορτίου.',
    'booking.select_the_date_when_the_cargo_is_to_be_picked_up':
      'Επιλέξτε την ημερομηνία που θα παραληφθεί το φορτίο.',
    'booking.select_truck_and_driver': 'Επιλέξτε Truck and Driver',
    'booking.set_autobid': 'Ορίστε την Αυτόματη Προσφορά',
    'booking.share_green_requirements_certification_numbers_or_carbon_reporting_needs':
      'Μοιραστείτε τις πράσινες απαιτήσεις, τους αριθμούς πιστοποίησης ή τις ανάγκες αναφοράς άνθρακα.',
    'booking.startpoint': 'Έναρξη',
    'booking.summary': 'Περίληψη',
    'booking.sustainability_options': 'Επιλογές βιωσιμότητας',
    'booking.this_is_a_vip_client_functionality_only':
      'Αυτή είναι μια λειτουργία VIP πελάτη μόνο',
    'booking.to': 'να',
    'booking.to_2': 'προς',
    'booking.total': 'σύνολο',
    'booking.transit_time_hours_h': 'Χρόνος διέλευσης: {{hours}}h',
    'booking.unable_to_load_the_map_preview_right_now':
      'Δεν είναι δυνατή η φόρτωση της προεπισκόπησης χάρτη αυτήν τη στιγμή.',
    'booking.upload_or_drag_and_drop_accepted_jpg_png_pdf_docx_xls':
      'Μεταφόρτωση ή μεταφορά και απόθεση. Αποδεκτό: .jpg, .png, .pdf, .docx, .xls',
    'booking.user_not_logged_in': 'Ο χρήστης δεν είναι συνδεδεμένος',
    'booking.valid_until_date': 'Ισχύει έως {{date}}',
    'booking.vehicle': 'Όχημα',
    'booking.vehicle_details': 'Στοιχεία οχήματος',
    'booking.vehicle_type': 'Τύπος οχήματος',
    'booking.vehicles': 'Οχήματα',
    'booking.vin_chassis': 'VIN / Πλαίσιο',
    'booking.vip_price': 'Τιμή VIP',
    'booking.weight': 'Βάρος',
    'booking.width_cm': 'Πλάτος (cm)',
    'booking.x_vehicle_s': '{{count}} όχημα(α)',
    'booking.your_transport_request_is_now_visible_under_my_orders':
      'Το αίτημα μεταφοράς σας είναι πλέον ορατό στην ενότητα Οι παραγγελίες μου.',
    '{{amount}} above the client target':
      '{{amount}} πάνω από τον στόχο πελάτη',
    '{{amount}} below the client target':
      '{{amount}} κάτω από τον στόχο πελάτη',
    '{{count}} image(s) added to the listing.':
      'Προστέθηκαν {{count}} εικόνες στην καταχώριση.',
    '{{count}} quote(s) received': 'Λήφθηκαν {{count}} προσφορά',
    '{{count}} reviews': '{{count}} κριτικές',
    '{{count}} total': '{{count}} σύνολο',
    '{{count}} visible': '{{count}} ορατό',
    '{{weight}} kg': '{{weight}} κιλά',
    'A Google route preview with pins A and B appears here once pickup and delivery coordinates are available.':
      'Μια προεπισκόπηση διαδρομής Google με τα pin A και B εμφανίζεται εδώ μόλις είναι διαθέσιμες οι συντεταγμένες παραλαβής και παράδοσης.',
    'A route preview appears once map coordinates are available.':
      'Μια προεπισκόπηση διαδρομής εμφανίζεται όταν είναι διαθέσιμες οι συντεταγμένες χάρτη.',
    'A timeline of clarifications connected to this listing.':
      'Χρονοδιάγραμμα διευκρινίσεων που συνδέονται με αυτήν την καταχώριση.',
    "Accept {{partner}}'s quote for {{amount}}?":
      'Αποδεχτείτε την προσφορά του {{partner}} για {{amount}};',
    'Accept Listing': 'Αποδοχή καταχώρισης',
    'Accept quote': 'Αποδοχή προσφοράς',
    'Accepted quote': 'Αποδεκτή προσφορά',
    'Accepted quote required': 'Απαιτείται αποδεκτή προσφορά',
    'Accepting...': 'Αποδοχή...',
    Active: 'Ενεργός',
    'Active statuses': 'Ενεργές καταστάσεις',
    'Add another item': 'Προσθέστε ένα άλλο στοιχείο',
    'Add images': 'Προσθήκη εικόνων',
    'Add more shipment images': 'Προσθέστε περισσότερες εικόνες αποστολής',
    'After you confirm an AI action, open the prepared destination immediately instead of waiting for a manual click.':
      'Αφού επιβεβαιώσετε μια ενέργεια AI, ανοίξτε αμέσως τον προετοιμασμένο προορισμό αντί να περιμένετε ένα μη αυτόματο κλικ.',
    'AI Assistant': 'Βοηθός AI',
    'AI assistant disabled for all users.':
      'Ο βοηθός AI απενεργοποιήθηκε για όλους τους χρήστες.',
    'AI assistant enabled for all users.':
      'Ο βοηθός AI ενεργοποιήθηκε για όλους τους χρήστες.',
    'AI assistant preferences updated':
      'Οι προτιμήσεις του βοηθού AI ενημερώθηκαν',
    'AI disabled for user.': 'Το AI απενεργοποιήθηκε για τον χρήστη.',
    'AI enabled for user.': 'AI ενεργοποιημένη για τον χρήστη.',
    'AI-powered message translation between languages':
      'Μετάφραση μηνυμάτων με τεχνητή νοημοσύνη μεταξύ γλωσσών',
    'All route-critical information in one place before you review quotes or documents.':
      'Όλες οι κρίσιμες για τη διαδρομή πληροφορίες σε ένα μέρος πριν ελέγξετε προσφορές ή έγγραφα.',
    View: 'Δείτε',
    Answer: 'Απάντηση',
    Archive: 'Αρχείο',
    'Archived statuses': 'Αρχειοθετημένες καταστάσεις',
    'Are you sure you want to reject the quote from':
      'Είστε βέβαιοι ότι θέλετε να απορρίψετε το απόσπασμα από',
    'Ask a question about this listing...':
      'Κάντε μια ερώτηση σχετικά με αυτήν την καταχώριση...',
    'Ask for matching lanes, quote help, or the next operational step.':
      'Ζητήστε αντίστοιχες λωρίδες, προσφορά βοήθειας ή το επόμενο λειτουργικό βήμα.',
    'Ask for quote comparisons or a prepared next step from this shipment screen.':
      'Ζητήστε συγκρίσεις προσφορών ή προετοιμασμένο επόμενο βήμα από αυτήν την οθόνη αποστολής.',
    'Assistant history cleared': 'Το ιστορικό του Βοηθού διαγράφηκε',
    'Automatically translate messages from other users into your preferred language using AI.':
      'Μεταφράστε αυτόματα μηνύματα από άλλους χρήστες στη γλώσσα που προτιμάτε χρησιμοποιώντας AI.',
    'Back to listing': 'Επιστροφή στην καταχώριση',
    'Best offer': 'Καλύτερη προσφορά',
    'Best quote': 'Το καλύτερο απόσπασμα',
    'Body type: {{type}}': 'Σωματότυπος: {{type}}',
    'Breed: {{breed}}': 'Ράτσα: {{breed}}',
    Budget: 'Προϋπολογισμός',
    'Cancel listing': 'Ακύρωση καταχώρισης',
    'Canceled and completed work will appear here once listings move out of the active view.':
      'Η ακυρωμένη και ολοκληρωμένη εργασία θα εμφανιστεί εδώ μόλις οι καταχωρίσεις απομακρυνθούν από την ενεργή προβολή.',
    'Cargo Details': 'Στοιχεία φορτίου',
    Categories: 'Κατηγορίες',
    'Choose the interface language. This preference is saved locally and applies immediately.':
      'Επιλέξτε τη γλώσσα διεπαφής. Αυτή η προτίμηση αποθηκεύεται τοπικά και ισχύει άμεσα.',
    'Clear all': 'Καθαρίστε όλα',
    'Clear assistant history': 'Διαγραφή ιστορικού βοηθού',
    'Client price in EUR': 'Τιμή πελάτη σε ευρώ',
    'Client target price': 'Τιμή-στόχος πελάτη',
    'Complete the payment below to lock the fixed-price acceptance and let the partner start planning.':
      'Ολοκληρώστε την παρακάτω πληρωμή για να κλειδώσετε την αποδοχή σταθερής τιμής και αφήστε τον συνεργάτη να ξεκινήσει τον προγραμματισμό.',
    'Complete the payment below to lock the selected quote and let the partner start planning.':
      'Ολοκληρώστε την παρακάτω πληρωμή για να κλειδώσετε την επιλεγμένη προσφορά και αφήστε τον συνεργάτη να ξεκινήσει τον προγραμματισμό.',
    'Compose area prepared for listing Q&A. Submission remains disabled until the live question endpoint is connected on this page.':
      'Σύνθεση περιοχής προετοιμασμένη για καταχώριση Q&A. Η υποβολή παραμένει απενεργοποιημένη μέχρι να συνδεθεί το τελικό σημείο της ζωντανής ερώτησης σε αυτήν τη σελίδα.',
    'Confirm delivery complete': 'Επιβεβαιώστε την ολοκλήρωση της παράδοσης',
    'Confirm payment received': 'Επιβεβαιώστε την πληρωμή που ελήφθη',
    'Confirm that you have received the bank transfer or payment for this listing. This will move the listing to Paid status and allow the partner to mark it as planned.':
      'Επιβεβαιώστε ότι λάβατε την τραπεζική μεταφορά ή την πληρωμή για αυτήν την καταχώριση. Αυτό θα μετακινήσει την καταχώριση σε κατάσταση επί πληρωμή και θα επιτρέψει στον συνεργάτη να την επισημάνει όπως έχει προγραμματιστεί.',
    'Confirm the exact fleet and dates before the listing moves to Planned.':
      'Επιβεβαιώστε τον ακριβή στόλο και τις ημερομηνίες πριν η καταχώριση μεταφερθεί στο Προγραμματισμένο.',
    'Confirm Transport Plan': 'Επιβεβαιώστε το σχέδιο μεταφοράς',
    'Confirming...': 'Επιβεβαίωση...',
    'Control how the web assistant behaves on this device. These settings do not change your account data.':
      'Ελέγξτε πώς συμπεριφέρεται ο βοηθός ιστού σε αυτήν τη συσκευή. Αυτές οι ρυθμίσεις δεν αλλάζουν τα δεδομένα του λογαριασμού σας.',
    'Create listing': 'Δημιουργία καταχώρισης',
    'Create with AI': 'Δημιουργία με AI',
    'Create your next transport request and it will appear here with route, item, and quote activity.':
      'Δημιουργήστε το επόμενο αίτημα μεταφοράς και θα εμφανιστεί εδώ με δραστηριότητα διαδρομής, στοιχείου και προσφοράς.',
    'Current stage:': 'Τρέχον στάδιο:',
    'Current status': 'Τρέχουσα κατάσταση',
    'Delivery confirmation needed': 'Απαιτείται επιβεβαίωση παράδοσης',
    'Delivery radius': 'Ακτίνα παράδοσης',
    'Delivery:': 'Παράδοση:',
    'Describe the route and cargo, then review the prepared listing draft before publishing.':
      'Περιγράψτε τη διαδρομή και το φορτίο και, στη συνέχεια, ελέγξτε το έτοιμο προσχέδιο της καταχώρισης πριν από τη δημοσίευση.',
    'Describe the shipment you need and review the prepared request before publishing.':
      'Περιγράψτε την αποστολή που χρειάζεστε και ελέγξτε το έτοιμο αίτημα πριν από τη δημοσίευση.',
    'Download and review the purchase terms before confirming the transport plan.':
      'Κατεβάστε και ελέγξτε τους όρους αγοράς πριν επιβεβαιώσετε το σχέδιο μεταφοράς.',
    'Download invoice': 'Λήψη τιμολογίου',
    'Download Purchase Terms': 'Λήψη Όρων Αγοράς',
    'Draft with AI': 'Σχέδιο με AI',
    'Draft your review first, then submit it here when you are satisfied.':
      'Πρώτα συντάξτε την κριτική σας και μετά υποβάλετέ την εδώ όταν μείνετε ικανοποιημένοι.',
    'Edit listing': 'Επεξεργασία καταχώρισης',
    'Edit Quote': 'Επεξεργασία Προσφοράς',
    Enable: 'Ενεργοποίηση',
    'Enable live translation': 'Ενεργοποίηση ζωντανής μετάφρασης',
    'Enabled Users': 'Ενεργοποιημένοι χρήστες',
    'Engagement Activity': 'Δραστηριότητα δέσμευσης',
    'Expires:': 'Λήγει:',
    'Failed to accept listing': 'Αποτυχία αποδοχής καταχώρισης',
    'Failed to accept quote': 'Αποτυχία αποδοχής προσφοράς',
    'Failed to clear assistant history':
      'Απέτυχε η εκκαθάριση του ιστορικού του βοηθού',
    'Failed to complete listing': 'Η ολοκλήρωση της καταχώρισης απέτυχε',
    'Failed to confirm payment': 'Η επιβεβαίωση της πληρωμής απέτυχε',
    'Failed to confirm transport plan':
      'Αποτυχία επιβεβαίωσης του σχεδίου μεταφοράς',
    'Failed to disable AI for user.':
      'Απέτυχε η απενεργοποίηση της τεχνητής νοημοσύνης για τον χρήστη.',
    'Failed to enable AI for user.':
      'Απέτυχε η ενεργοποίηση της τεχνητής νοημοσύνης για τον χρήστη.',
    'Failed to load listing.': 'Η φόρτωση της καταχώρισης απέτυχε.',
    'Failed to load listings': 'Αποτυχία φόρτωσης καταχωρίσεων',
    'Failed to load listings. Please try again.':
      'Αποτυχία φόρτωσης καταχωρίσεων. Δοκιμάστε ξανά.',
    'Failed to load review context.':
      'Αποτυχία φόρτωσης του πλαισίου κριτικής.',
    'Failed to load settings.': 'Αποτυχία φόρτωσης ρυθμίσεων.',
    'Failed to refresh Stripe payment status':
      'Η ανανέωση της κατάστασης πληρωμής Stripe απέτυχε',
    'Failed to reject quote': 'Απέτυχε η απόρριψη της προσφοράς',
    'Failed to release listing': 'Η κυκλοφορία της καταχώρισης απέτυχε',
    'Failed to save quote': 'Αποτυχία αποθήκευσης προσφοράς',
    'Failed to update listing': 'Η ενημέρωση της καταχώρισης απέτυχε',
    'Failed to update preferred language':
      'Η ενημέρωση της προτιμώμενης γλώσσας απέτυχε',
    'Failed to update setting.': 'Η ενημέρωση της ρύθμισης απέτυχε.',
    'Failed to update status': 'Η ενημέρωση της κατάστασης απέτυχε',
    'Failed to update translation preference':
      'Η ενημέρωση της προτίμησης μετάφρασης απέτυχε',
    'Failed to update watchlist':
      'Η ενημέρωση της λίστας παρακολούθησης απέτυχε',
    'Failed to withdraw quote': 'Αποτυχία ανάκλησης της προσφοράς',
    'Feature Flags': 'Σημαίες χαρακτηριστικών',
    'Filter invoice uploads, search by reference, and page through payout records.':
      'Φιλτράρετε τις μεταφορτώσεις τιμολογίων, την αναζήτηση με αναφορά και τη σελίδα μέσω των εγγραφών πληρωμών.',
    Filters: 'Φίλτρα',
    'Final delivery documents': 'Τελικά έγγραφα παράδοσης',
    'Fixed price only': 'Μόνο σταθερή τιμή',
    'Flexible / not set': 'Ευέλικτο / μη ρυθμισμένο',
    'Generated automatically when the transport plan is confirmed.':
      'Δημιουργείται αυτόματα όταν επιβεβαιωθεί το σχέδιο μεταφοράς.',
    'Generation: {{generation}}': 'Γενιά: {{generation}}',
    'Goods delivered — awaiting client confirmation.':
      'Παραδόθηκαν αγαθά — σε αναμονή επιβεβαίωσης από τον πελάτη.',
    'Gross price': 'Ακαθάριστη τιμή',
    'I have read and agree to the purchase terms for this transport job.':
      'Έχω διαβάσει και συμφωνώ με τους όρους αγοράς για αυτήν την εργασία μεταφοράς.',
    'I understand that accepting this listing assigns it to me at the fixed client price shown above.':
      'Κατανοώ ότι η αποδοχή αυτής της καταχώρισης μου την εκχωρεί στη σταθερή τιμή πελάτη που φαίνεται παραπάνω.',
    'Image upload failed': 'Η μεταφόρτωση εικόνας απέτυχε',
    'Images uploaded': 'Μεταφορτώθηκαν εικόνες',
    'Interface language': 'Γλώσσα διεπαφής',
    'Invoice documents': 'Παραστατικά τιμολογίων',
    'Item {{number}}': 'Στοιχείο {{number}}',
    items: 'είδη',
    'Keep listing': 'Συνεχίστε την καταχώριση',
    'Keep quote': 'Κρατήστε την προσφορά',
    'Keep the current AI session available after closing the browser on this device.':
      'Διατηρήστε την τρέχουσα περίοδο λειτουργίας AI διαθέσιμη μετά το κλείσιμο του προγράμματος περιήγησης σε αυτήν τη συσκευή.',
    'Language & Region': 'Γλώσσα & Περιοχή',
    'Lift: {{origin}} / {{destination}}':
      'Ανελκυστήρας: {{origin}} / {{destination}}',
    Listed: 'Εισηγμένη',
    'Listing {{id}}': 'Καταχώρηση {{id}}',
    'Listing accepted': 'Η καταχώριση έγινε αποδεκτή',
    'Listing expired': 'Η καταχώριση έληξε',
    'Listing images': 'Εικόνες καταχώρισης',
    'Listing is live': 'Η καταχώριση είναι ζωντανή',
    'Listing reference': 'Αναφορά καταχώρισης',
    'Listing snapshot': 'Στιγμιότυπο καταχώρισης',
    'Listing unavailable': 'Η καταχώριση δεν είναι διαθέσιμη',
    'Listing updated': 'Η καταχώριση ενημερώθηκε',
    'Live Translation': 'Ζωντανή μετάφραση',
    'Live translation disabled.': 'Απενεργοποιήθηκε η ζωντανή μετάφραση.',
    'Live translation enabled.': 'Ενεργοποιήθηκε η ζωντανή μετάφραση.',
    'Loading approved trucks...': 'Φόρτωση εγκεκριμένων φορτηγών...',
    'Loading fleet...': 'Φόρτωση στόλου...',
    'Loading listing details...': 'Φόρτωση λεπτομερειών καταχώρισης...',
    'Loading listings...': 'Φόρτωση καταχωρίσεων...',
    'Loading review details...': 'Φόρτωση λεπτομερειών κριτικής...',
    'Loading settings...': 'Φόρτωση ρυθμίσεων...',
    'Manage AI Assistant Users': 'Διαχείριση χρηστών AI Assistant',
    'Manage platform-wide feature flags and configuration.':
      'Διαχειριστείτε τις σημαίες και τη διαμόρφωση δυνατοτήτων σε ολόκληρη την πλατφόρμα.',
    'Manage Users': 'Διαχείριση χρηστών',
    'Manage your transport requests, monitor quote activity, and keep active and archived work easy to scan.':
      'Διαχειριστείτε τα αιτήματά σας μεταφοράς, παρακολουθήστε τη δραστηριότητα προσφορών και διατηρήστε την ενεργή και αρχειοθετημένη εργασία εύκολη στη σάρωση.',
    'Mark Picked Up': 'Mark Picked Up',
    'Matches the client target price': 'Ταιριάζει με την τιμή-στόχο πελάτη',
    Media: 'ΜΜΕ',
    Messages: 'Μηνύματα',
    'Messages will be translated into this language.':
      'Τα μηνύματα θα μεταφραστούν σε αυτήν τη γλώσσα.',
    'Minimum net:': 'Ελάχιστο καθαρό:',
    'My invoices': 'Τα τιμολόγιά μου',
    Net: 'Καθαρό',
    'Net price': 'Καθαρή τιμή',
    'Net quote': 'Καθαρή προσφορά',
    'New images appear immediately in the listing details for client, partner, and admin views.':
      'Οι νέες εικόνες εμφανίζονται αμέσως στις λεπτομέρειες της καταχώρισης για προβολές πελάτη, συνεργάτη και διαχειριστή.',
    'Next step': 'Επόμενο βήμα',
    'No active listings yet': 'Δεν υπάρχουν ακόμη ενεργές καταχωρίσεις',
    'No address provided': 'Δεν παρέχεται διεύθυνση',
    'No answer yet.': 'Καμία απάντηση ακόμα.',
    'No archived listings yet':
      'Δεν υπάρχουν ακόμα αρχειοθετημένες καταχωρίσεις',
    'No description added.': 'Δεν προστέθηκε περιγραφή.',
    'no destination': 'κανένας προορισμός',
    'No expiry': 'Χωρίς λήξη',
    'No listings match the current filters. Try broadening the search or date range.':
      'Δεν υπάρχουν καταχωρίσεις που να ταιριάζουν με τα τρέχοντα φίλτρα. Δοκιμάστε να διευρύνετε την αναζήτηση ή το εύρος ημερομηνιών.',
    'no origin': 'καμία προέλευση',
    'No questions yet': 'Δεν υπάρχουν ερωτήσεις ακόμα',
    'No quotes yet': 'Δεν υπάρχουν ακόμη εισαγωγικά',
    'No shipment images uploaded yet.':
      'Δεν έχουν μεταφορτωθεί ακόμη εικόνες αποστολής.',
    'No trailer selected': 'Δεν έχει επιλεγεί τρέιλερ',
    'No unread messages': 'Δεν υπάρχουν μη αναγνωσμένα μηνύματα',
    'No users found.': 'Δεν βρέθηκαν χρήστες.',
    'No users have AI enabled.':
      'Κανένας χρήστης δεν έχει ενεργοποιήσει το AI.',
    'Not selected': 'Δεν έχει επιλεγεί',
    'Offers summary': 'Περίληψη προσφορών',
    'Open AI assistant': 'Ανοίξτε τον βοηθό AI',
    'Open prepared screens automatically':
      'Ανοίξτε αυτόματα τις προετοιμασμένες οθόνες',
    'Optional visible price shown to partners as your target budget.':
      'Προαιρετική ορατή τιμή που εμφανίζεται στους συνεργάτες ως ο προϋπολογισμός-στόχος σας.',
    'Other quotes will be declined automatically once this offer is accepted.':
      'Άλλες προσφορές θα απορριφθούν αυτόματα μόλις γίνει αποδεκτή αυτή η προσφορά.',
    'Partner delivery': 'Παράδοση συνεργάτη',
    'Partner pickup': 'Παραλαβή από συνεργάτη',
    'Partner quote': 'Προσφορά συνεργάτη',
    'Payment confirmed': 'Η πληρωμή επιβεβαιώθηκε',
    'Payment confirmed — listing status set to paid':
      'Η πληρωμή επιβεβαιώθηκε — η κατάσταση καταχώρισης ορίστηκε σε πληρωμένη',
    'Payment confirmed. Confirm the assigned fleet and planned dates before the listing moves to Planned.':
      'Η πληρωμή επιβεβαιώθηκε. Επιβεβαιώστε τον εκχωρημένο στόλο και τις προγραμματισμένες ημερομηνίες πριν η καταχώριση μεταφερθεί στο Προγραμματισμένο.',
    'Payment is confirmed. The partner now needs to confirm the truck, driver, and planned dates.':
      'Η πληρωμή επιβεβαιώνεται. Ο συνεργάτης πρέπει τώρα να επιβεβαιώσει το φορτηγό, τον οδηγό και τις προγραμματισμένες ημερομηνίες.',
    'Payment required': 'Απαιτείται πληρωμή',
    'Photos uploaded for the shipment and visible across client, partner, and admin views.':
      'Φωτογραφίες που μεταφορτώνονται για την αποστολή και είναι ορατές σε προβολές πελάτη, συνεργάτη και διαχειριστή.',
    'Pickup is complete and the transport is currently underway.':
      'Η παραλαβή έχει ολοκληρωθεί και η μεταφορά βρίσκεται σε εξέλιξη.',
    'Pickup proof': 'Απόδειξη παραλαβής',
    'Pickup proof and final delivery files uploaded by the transport partner.':
      'Αρχεία απόδειξης παραλαβής και τελικής παράδοσης που ανέβηκαν από τον συνεργάτη μεταφοράς.',
    'Pickup to delivery overview': 'Επισκόπηση παραλαβής έως παράδοσης',
    'Pickup:': 'Παραλαβή:',
    'Plan and authorization': 'Σχέδιο και εξουσιοδότηση',
    'Plan transport': 'Σχέδιο μεταφοράς',
    'Plan Transport': 'Σχέδιο μεταφοράς',
    'Planned dates:': 'Προγραμματισμένες ημερομηνίες:',
    'Planned delivery date': 'Προγραμματισμένη ημερομηνία παράδοσης',
    'Platform Settings': 'Ρυθμίσεις πλατφόρμας',
    'Preferred language': 'Προτιμώμενη γλώσσα',
    'Preferred language updated': 'Η προτιμώμενη γλώσσα ενημερώθηκε',
    'Prepare a quote or ask for the next lane action, then confirm before anything is submitted.':
      'Προετοιμάστε μια προσφορά ή ζητήστε την επόμενη ενέργεια λωρίδας και, στη συνέχεια, επιβεβαιώστε πριν υποβληθεί οτιδήποτε.',
    'Purchase Terms': 'Όροι Αγοράς',
    'Quantities, dimensions, and handling details ready for transport review.':
      'Ποσότητες, διαστάσεις και λεπτομέρειες χειρισμού έτοιμες για έλεγχο μεταφοράς.',
    Question: 'Ερώτηση',
    Questions: 'Ερωτήσεις',
    'Questions & answers': 'Ερωτήσεις & απαντήσεις',
    'Questions and answers for this listing will appear here once the messaging flow is active.':
      'Οι ερωτήσεις και οι απαντήσεις για αυτήν την καταχώριση θα εμφανίζονται εδώ μόλις ενεργοποιηθεί η ροή μηνυμάτων.',
    'Quick access to the current shipment, quote, and billing state.':
      'Γρήγορη πρόσβαση στην τρέχουσα κατάσταση αποστολής, προσφοράς και χρέωσης.',
    'Quote accepted': 'Η προσφορά έγινε δεκτή',
    'Quote count': 'Πλήθος προσφορών',
    'Quote message': 'Μήνυμα προσφοράς',
    'Quote rejected': 'Η προσφορά απορρίφθηκε',
    'Quote withdrawn': 'Η προσφορά αποσύρθηκε',
    Quotes: 'Εισαγωγικά',
    'Quotes and questions': 'Αποσπάσματα και ερωτήσεις',
    'Quotes are disabled for this listing. The first partner to accept the fixed price will be assigned automatically.':
      'Οι προσφορές είναι απενεργοποιημένες για αυτήν την καταχώριση. Ο πρώτος συνεργάτης που θα αποδεχτεί τη σταθερή τιμή θα εκχωρηθεί αυτόματα.',
    'Quotes are disabled for this shipment. If you accept it, the client price becomes an accepted booking immediately.':
      'Οι προσφορές είναι απενεργοποιημένες για αυτήν την αποστολή. Εάν το αποδεχτείτε, η τιμή πελάτη γίνεται αμέσως αποδεκτή κράτηση.',
    'Quotes from transport providers usually begin to appear shortly after publishing. Refresh to check again.':
      'Οι προσφορές από τους παρόχους μεταφορών συνήθως αρχίζουν να εμφανίζονται αμέσως μετά τη δημοσίευση. Κάντε ανανέωση για να ελέγξετε ξανά.',
    'Reference #{{id}}': 'Αναφορά #{{id}}',
    'Refresh listings': 'Ανανέωση καταχωρίσεων',
    'Reject quote': 'Απόρριψη απόσπασμα',
    'Rejecting...': 'Απόρριψη...',
    Release: 'Απελευθέρωση',
    'Release Listing': 'Καταχώριση έκδοσης',
    'Remember assistant conversation': 'Θυμηθείτε τη συνομιλία του βοηθού',
    'Required for fixed-price listings. Partners accept this amount directly.':
      'Απαιτείται για καταχωρίσεις σταθερής τιμής. Οι συνεργάτες δέχονται απευθείας αυτό το ποσό.',
    'Required. Partners will be able to accept this listing at the fixed client price without sending a quote.':
      'Υποχρεούμαι. Οι συνεργάτες θα μπορούν να αποδεχτούν αυτήν την καταχώριση στη σταθερή τιμή πελάτη χωρίς να στείλουν προσφορά.',
    'Review submission failed.': 'Η υποβολή αξιολόγησης απέτυχε.',
    'Review the completed transport using the standard product flow.':
      'Ελέγξτε την ολοκληρωμένη μεταφορά χρησιμοποιώντας την τυπική ροή προϊόντος.',
    'Route pending': 'Διαδρομή σε εκκρεμότητα',
    'Save changes': 'Αποθήκευση αλλαγών',
    'Saving...': 'Αποθήκευση...',
    'Search by title, route, category, or item':
      'Αναζήτηση κατά τίτλο, διαδρομή, κατηγορία ή αντικείμενο',
    'Search Results': 'Αποτελέσματα αναζήτησης',
    'Search users by email...': 'Αναζήτηση χρηστών μέσω email...',
    'Select a truck, driver, pickup date, and delivery date.':
      'Επιλέξτε φορτηγό, οδηγό, ημερομηνία παραλαβής και ημερομηνία παράδοσης.',
    'Select approved truck': 'Επιλέξτε εγκεκριμένο φορτηγό',
    'Select driver': 'Επιλέξτε πρόγραμμα οδήγησης',
    'Send Revision': 'Αποστολή αναθεώρησης',
    Sentiment: 'Συναίσθημα',
    'Share what went well and what could improve':
      'Μοιραστείτε τι πήγε καλά και τι θα μπορούσε να βελτιωθεί',
    'Shipment in transit': 'Αποστολή σε διαμετακόμιση',
    'Shipment notes': 'Δελτία αποστολής',
    'Shipment tracking will be shared':
      'Θα γίνει κοινή χρήση της παρακολούθησης αποστολής',
    'Show AI launchers': 'Εμφάνιση εκτοξευτών AI',
    'Show or hide AI assistant buttons on supported dashboard and listing pages.':
      'Εμφάνιση ή απόκρυψη κουμπιών βοηθού τεχνητής νοημοσύνης σε υποστηριζόμενες σελίδες εργαλείων και καταχωρίσεων.',
    'Special needs or notes': 'Ειδικές ανάγκες ή σημειώσεις',
    'Specify delivery dates': 'Καθορίστε ημερομηνίες παράδοσης',
    'Specify pickup dates': 'Καθορίστε ημερομηνίες παραλαβής',
    Stage: 'Σκηνή',
    'Status updated to {{status}}': 'Η κατάσταση ενημερώθηκε σε {{status}}',
    'Stripe payment confirmed and booking updated':
      'Η λωρίδα πληρωμής επιβεβαιώθηκε και η κράτηση ενημερώθηκε',
    'Stripe status: {{status}}': 'Κατάσταση λωρίδας: {{status}}',
    'Submit question': 'Υποβολή ερώτησης',
    'Submit review': 'Υποβολή κριτικής',
    'Submitting...': 'Υποβολή...',
    'The AI assistant is currently disabled for this environment. Existing local session data can still be cleared here.':
      'Ο βοηθός AI είναι προς το παρόν απενεργοποιημένος για αυτό το περιβάλλον. Τα υπάρχοντα δεδομένα τοπικής περιόδου σύνδεσης μπορούν ακόμα να διαγραφούν εδώ.',
    'The listing expired before a transport was confirmed.':
      'Η καταχώριση έληξε πριν επιβεβαιωθεί μια μεταφορά.',
    'The listing has been fully completed and archived as a finished transport.':
      'Η καταχώριση έχει ολοκληρωθεί πλήρως και έχει αρχειοθετηθεί ως ολοκληρωμένη μεταφορά.',
    'The lowest net price you would still accept for this shipment.':
      'Η χαμηλότερη καθαρή τιμή που θα δεχόσασταν ακόμα για αυτήν την αποστολή.',
    'The partner has confirmed the route plan. Pickup and delivery dates are now scheduled.':
      'Ο συνεργάτης επιβεβαίωσε το σχέδιο διαδρομής. Οι ημερομηνίες παραλαβής και παράδοσης έχουν πλέον προγραμματιστεί.',
    'The partner marked the shipment as delivered. Review the final documents and confirm completion.':
      'Ο συνεργάτης επισήμανε την αποστολή ως παραδοθείσα. Ελέγξτε τα τελικά έγγραφα και επιβεβαιώστε την ολοκλήρωση.',
    'The partner-confirmed plan and LOA stay grouped together for faster review.':
      'Το επιβεβαιωμένο από συνεργάτη σχέδιο και το LOA παραμένουν ομαδοποιημένα για ταχύτερο έλεγχο.',
    'This action notifies the transport provider and removes the quote from active consideration.':
      'Αυτή η ενέργεια ειδοποιεί τον πάροχο μεταφορών και αφαιρεί την προσφορά από την ενεργό εξέταση.',
    'This listing is archived and no further transport actions are available.':
      'Αυτή η καταχώριση είναι αρχειοθετημένη και δεν διατίθενται περαιτέρω ενέργειες μεταφοράς.',
    'This listing needs an accepted quote before a review can be created.':
      'Αυτή η καταχώριση χρειάζεται μια αποδεκτή προσφορά για να μπορέσει να δημιουργηθεί μια κριτική.',
    'This will soft-cancel the listing and move it to your archive.':
      'Αυτό θα ακυρώσει την καταχώριση και θα τη μετακινήσει στο αρχείο σας.',
    'This will soft-cancel the listing for the client and remove it from active marketplace views.':
      'Αυτό θα ακυρώσει την καταχώριση για τον πελάτη και θα την καταργήσει από τις ενεργές προβολές αγοράς.',
    'Total quote': 'Συνολική προσφορά',
    'Tracking not promised': 'Η παρακολούθηση δεν υποσχέθηκε',
    'Tracking shared': 'Κοινόχρηστη παρακολούθηση',
    'Tracking visibility': 'Παρακολούθηση ορατότητας',
    'Trailer (Optional)': 'Τρέιλερ (Προαιρετικό)',
    'Translation preference updated': 'Η προτίμηση μετάφρασης ενημερώθηκε',
    'Transport completed': 'Η μεταφορά ολοκληρώθηκε',
    'Transport completed.': 'Η μεταφορά ολοκληρώθηκε.',
    'Transport documents': 'Έγγραφα μεταφοράς',
    'Transport marked as complete': 'Η μεταφορά επισημάνθηκε ως ολοκληρωμένη',
    'Transport package': 'Πακέτο μεταφοράς',
    'Transport plan confirmed': 'Επιβεβαιώθηκε το σχέδιο μεταφοράς',
    'Transport plan updated': 'Το σχέδιο μεταφοράς ενημερώθηκε',
    'Transport planned': 'Προγραμματισμένη μεταφορά',
    'Transport Provider': 'Πάροχος Μεταφορών',
    'Transport providers can review your shipment and send offers.':
      'Οι πάροχοι μεταφορών μπορούν να ελέγξουν την αποστολή σας και να στείλουν προσφορές.',
    'Transport stage': 'Στάδιο μεταφοράς',
    Truck: 'Φορτηγό',
    'Truck, driver, trailer, and planned dates for this shipment.':
      'Φορτηγό, οδηγός, ρυμουλκούμενο και προγραμματισμένες ημερομηνίες για αυτήν την αποστολή.',
    'Try widening the current listing filters.':
      'Δοκιμάστε να διευρύνετε τα τρέχοντα φίλτρα καταχώρισης.',
    'Unable to upload listing images.':
      'Δεν είναι δυνατή η μεταφόρτωση εικόνων καταχώρισης.',
    'Unknown error': 'Άγνωστο σφάλμα',
    'Untitled listing': 'Καταχώριση χωρίς τίτλο',
    'Untitled Listing': 'Καταχώριση χωρίς τίτλο',
    'Update media': 'Ενημέρωση πολυμέσων',
    'Update transport plan': 'Ενημέρωση σχεδίου μεταφοράς',
    'Update Transport Plan': 'Ενημέρωση σχεδίου μεταφορών',
    'Upload a CMR or delivery photos before marking delivered.':
      'Ανεβάστε ένα CMR ή φωτογραφίες παράδοσης πριν επισημάνετε την παράδοση.',
    'Upload a CMR or delivery photos before the listing can move to Delivered.':
      'Ανεβάστε ένα CMR ή φωτογραφίες παράδοσης προτού η καταχώριση μεταφερθεί στο Παράδοση.',
    'Upload at least one pickup proof before the listing can move to Picked Up.':
      'Ανεβάστε τουλάχιστον ένα αποδεικτικό παραλαβής προτού η καταχώριση μεταφερθεί στο Picked Up.',
    'Upload final documents': 'Ανεβάστε τελικά έγγραφα',
    'Upload proof of pickup': 'Ανεβάστε την απόδειξη παραλαβής',
    'Uploading...': 'Μεταφόρτωση...',
    'Use fresh photos when the shipment changes or you want to clarify the item condition.':
      'Use fresh photos when the shipment changes or you want to clarify the item condition.',
    'users enabled': 'ενεργοποιημένοι χρήστες',
    'Visible to you while quoting. You can still send your own net offer below or above this amount.':
      'Ορατό σε εσάς κατά την παράθεση. Μπορείτε ακόμα να στείλετε τη δική σας καθαρή προσφορά κάτω ή πάνω από αυτό το ποσό.',
    'Waiting for partner acceptance': 'Αναμονή για αποδοχή συνεργάτη',
    'Waiting for transport planning': 'Αναμονή για προγραμματισμό μεταφορών',
    'When enabled, messages from other users will be automatically translated to your preferred language.':
      'Όταν είναι ενεργοποιημένο, τα μηνύματα από άλλους χρήστες θα μεταφράζονται αυτόματα στη γλώσσα που προτιμάτε.',
    Withdraw: 'Απόσυρση',
    'Write Review': 'Γράψτε Αξιολόγηση',
    'You are about to release this listing back to the marketplace.':
      'Πρόκειται να κυκλοφορήσετε αυτήν την καταχώριση πίσω στην αγορά.',
    'You are now the assigned partner for this fixed-price listing.':
      'Είστε πλέον ο εκχωρημένος συνεργάτης για αυτήν την καταχώριση σταθερής τιμής.',
    'Your quote has been accepted. Awaiting payment confirmation from the admin before you can begin the job.':
      'Η προσφορά σας έγινε αποδεκτή. Αναμένεται επιβεβαίωση πληρωμής από τον διαχειριστή πριν ξεκινήσετε την εργασία.',
    'Select a category': 'Επιλέξτε μια κατηγορία',
    'You will receive the best transport quotes and save up to 60%!':
      'Θα λάβετε τις καλύτερες προσφορές μεταφοράς και θα εξοικονομήσετε έως και 60%!',
    Furniture: 'Έπιπλα',
    Removals: 'Μετακομίσεις',
    motorcycles: 'Μοτοσικλέτες & Σκούτερ',
    Pallets: 'Παλέτες',
    Freight: 'Φορτίο',
    Parcels: 'Δέματα',
    'Machinery & Equipment': 'Μηχανήματα & Εξοπλισμός',
    'Other Vehicles': 'Άλλα Οχήματα',
    Pets: 'Κατοικίδια',
    'Building Materials': 'Οικοδομικά Υλικά',
    'Fragile Goods': 'Εύθραυστα αγαθά',
    Boats: 'Βάρκες',
    Bicycles: 'Ποδήλατα',
    'Vehicle Parts': 'Ανταλλακτικά οχημάτων',
    'Household Appliances': 'Οικιακές Συσκευές',
    Other: 'Άλλο',
    'Choose a route': 'Επιλέξτε μια διαδρομή',
    'Enter pick-up and delivery locations.':
      'Εισαγάγετε τοποθεσίες παραλαβής και παράδοσης.',
    'Pick-up location': 'Τοποθεσία παραλαβής',
    'Search with AI': 'Αναζήτηση με AI',
    'Describe the lane you want and review the prepared marketplace filters.':
      'Περιγράψτε τη λωρίδα που θέλετε και ελέγξτε τα προετοιμασμένα φίλτρα αγοράς.',
    'Scan open marketplace requests quickly with a compact filter bar and richer delivery cards built for quoting decisions.':
      'Σαρώστε γρήγορα αιτήματα ανοιχτής αγοράς με μια συμπαγή γραμμή φίλτρου και πιο πλούσιες κάρτες παράδοσης που έχουν σχεδιαστεί για την προσφορά αποφάσεων.',
    'Select all': 'Επιλέξτε όλα',
    Watching: 'Παρακολούθηση',
    Watched: 'Παρακολούθησαν',
    'Search title, city, description...':
      'Αναζήτηση τίτλου, πόλης, περιγραφής...',
    'Hide filters': 'Απόκρυψη φίλτρων',
    'More filters': 'Περισσότερα φίλτρα',
    'Marketplace view': 'Θέα στην αγορά',
    'Any country': 'Οποιαδήποτε χώρα',
    Postcode: 'Ταχυδρομικός κώδικας',
    'Any radius': 'Οποιαδήποτε ακτίνα',
    Keyword: 'Λέξη-κλειδί',
    'Title, item, route, description...':
      'Τίτλος, αντικείμενο, διαδρομή, περιγραφή...',
    'Searching marketplace...': 'Αναζήτηση αγοράς...',
    '{{count}} open deliveries': '{{count}} ανοιχτές παραδόσεις',
    'Route filtered': 'Η διαδρομή φιλτραρίστηκε',
    'Loading open deliveries...': 'Φόρτωση ανοιχτών παραδόσεων...',
    'No listings found': 'Δεν βρέθηκαν καταχωρήσεις',
    'Try widening the route, date, keyword, or category filters to see more marketplace opportunities.':
      'Δοκιμάστε να διευρύνετε τα φίλτρα διαδρομής, ημερομηνίας, λέξης-κλειδιού ή κατηγορίας για να δείτε περισσότερες ευκαιρίες αγοράς.',
    'Clear filters': 'Καθαρίστε τα φίλτρα',
    'Load more deliveries': 'Φορτώστε περισσότερες παραδόσεις',
    'Search Listings': 'Αναζήτηση καταχωρίσεων',
    '{{count}} categories': 'Κατηγορίες {{count}}',
    '{{count}} item(s)': '{{count}} αντικείμενο(α)',
    Qty: 'Ποσ',
    Operable: 'Λειτουργικό',
    'Target budget': 'Προϋπολογισμός-στόχος',
    'Accept listing': 'Αποδοχή καταχώρισης',
    Watch: 'Παρακολουθήστε',
    Unwatch: 'Unwatch',
    'Pick-up window': 'Παράθυρο παραλαβής',
    Posted: 'Δημοσιεύτηκε',
    item: 'αντικείμενο',
    'quick view': 'γρήγορη θέα',
    'Private Person': 'Ιδιωτικό Πρόσωπο',
    Cars: 'Αυτοκίνητα',
    Motorcycles: 'Μοτοσικλέτες',
    Machinery: 'Μηχανήματα',
    Fragile: 'Εύθραυστο',
    Household: 'Οικιακό',
    'HAS QUOTES': 'ΕΧΕΙ ΑΠΟΣΠΑΣΜΑΤΑ',
    'Street address': 'Διεύθυνση οδού',
    'City *': 'Πόλη *',
    'Country *': 'Χώρα *',
    'Delivery location': 'Τοποθεσία παράδοσης',
    'I want to specify dates': 'Θέλω να προσδιορίσω ημερομηνίες',
    'Pick-up date range': 'Εύρος ημερομηνιών παραλαβής',
    'Delivery date range': 'Εύρος ημερομηνιών παράδοσης',
    'Invalid date': 'Μη έγκυρη ημερομηνία',
    'Delivery must be after pickup':
      'Η παράδοση πρέπει να γίνει μετά την παραλαβή',
    'Add or select pick-up and delivery addresses to preview the Google map route with pins A and B.':
      'Προσθέστε ή επιλέξτε διευθύνσεις παραλαβής και παράδοσης για προεπισκόπηση της διαδρομής του χάρτη Google με τις πινέζες Α και Β.',
    'Route distance: {{distance}} km': 'Απόσταση διαδρομής: {{distance}} km',
    'The map will appear when the pickup and delivery addresses are added.':
      'Ο χάρτης θα εμφανιστεί όταν προστεθούν οι διευθύνσεις παραλαβής και παράδοσης.',
    'Go to item details': 'Μεταβείτε στις λεπτομέρειες του στοιχείου',
    'Pet type': 'Τύπος κατοικίδιου',
    Breed: 'Φυλή',
    'Any special needs or notes': 'Τυχόν ειδικές ανάγκες ή σημειώσεις',
    'Category: {{category}}': 'Κατηγορία: {{category}}',
    'Item {{index}}': 'Στοιχείο {{index}}',
    'Remove item': 'Αφαίρεση στοιχείου',
    '+ Add another item': '+ Προσθήκη άλλου στοιχείου',
    'I am listing delivery as': 'Αναφέρω την παράδοση ως',
    'Private person': 'Ιδιωτικός',
    'A company': 'Μια εταιρεία',
    'Pricing and quote policy': 'Πολιτική τιμολόγησης και προσφοράς',
    'Allow partner quotes': 'Να επιτρέπονται προσφορές συνεργατών',
    'Client price visible to partners':
      'Η τιμή πελάτη είναι ορατή στους συνεργάτες',
    'Enter amount in EUR': 'Εισαγάγετε το ποσό σε ευρώ',
    'Visible price: {{price}}': 'Εμφανή τιμή: {{price}}',
    'Hide description': 'Απόκρυψη περιγραφής',
    'Add description (optional)': 'Προσθήκη περιγραφής (προαιρετικό)',
    'Describe your shipment…': 'Περιγράψτε την αποστολή σας…',
    'Add images (optional)': 'Προσθήκη εικόνων (προαιρετικά)',
    'Upload shipment photos': 'Ανεβάστε φωτογραφίες αποστολής',
    'Choose images': 'Επιλέξτε εικόνες',
    'Remove {{name}}': 'Αφαιρέστε {{name}}',
    'Go to summary': 'Μετάβαση στην περίληψη',
    'Origin floor': 'Όροφος προέλευσης',
    'Add up to 10 images. JPG and PNG files work best for listing previews.':
      'Προσθέστε έως και 10 εικόνες. Τα αρχεία JPG και PNG λειτουργούν καλύτερα για την καταχώριση προεπισκοπήσεων.',
    'List a delivery for free and with no commitment':
      'Καταχωρίστε μια παράδοση δωρεάν και χωρίς δέσμευση',
    'Preparing listing draft...': 'Προετοιμασία προσχέδιο καταχώρισης...',
    'Uploading image {{index}} of {{total}}...':
      'Μεταφόρτωση εικόνας {{index}} από {{total}}...',
    'Publishing listing...': 'Δημοσίευση καταχώρισης...',
    'Listing created!': 'Η καταχώριση δημιουργήθηκε!',
    'Your fixed-price listing is live. Partners can now accept it directly.':
      'Η καταχώρισή σας με σταθερή τιμή είναι ζωντανή. Οι συνεργάτες μπορούν πλέον να το αποδεχτούν απευθείας.',
    'Your listing is live. Carriers will send quotes soon.':
      'Η καταχώρισή σας είναι ζωντανή. Οι μεταφορείς θα στείλουν προσφορές σύντομα.',
    'Could not create listing': 'Δεν ήταν δυνατή η δημιουργία καταχώρισης',
    'Addresses and dates': 'Διευθύνσεις και ημερομηνίες',
    'Item details': 'Λεπτομέρειες αντικειμένου',
    'Non-operable': 'Μη λειτουργικό',
    'Vehicle status': 'Κατάσταση οχήματος',
    'Make & Model': 'Κατασκευή & Μοντέλο',
    Choose: 'Επιλέξτε',
    'Review each item, quantity and handling status before publishing.':
      'Ελέγξτε κάθε στοιχείο, ποσότητα και κατάσταση χειρισμού πριν από τη δημοσίευση.',
    'Company ({{country}})': 'Εταιρεία ({{country}})',
    'country not set': 'χώρα δεν έχει οριστεί',
    'Attached images ({{count}})': 'Συνημμένες εικόνες ({{count}})',
    Pricing: 'Τιμολόγηση',
    'No visible client price set': 'Δεν έχει οριστεί ορατή τιμή πελάτη',
    'Quotes are disabled. The first partner to accept this price will be assigned automatically.':
      'Οι προσφορές είναι απενεργοποιημένες. Ο πρώτος συνεργάτης που θα αποδεχτεί αυτήν την τιμή θα εκχωρηθεί αυτόματα.',
    'Give your listing a title (optional)':
      'Δώστε στην καταχώρισή σας έναν τίτλο (προαιρετικό)',
    'Add a listing title (optional)':
      'Προσθήκη τίτλου καταχώρισης (προαιρετικό)',
    'Edit title': 'Επεξεργασία τίτλου',
    'Publish Fixed Price': 'Δημοσίευση Σταθερής Τιμής',
    'Get Quotes': 'Λάβετε προσφορές',
    'Publishing...': 'Δημοσίευση...',
    'Set a fixed price': 'Ορίστε μια σταθερή τιμή',
    'A fixed-price listing needs a visible client price before publishing.':
      'Μια καταχώριση σταθερής τιμής χρειάζεται μια ορατή τιμή πελάτη πριν από τη δημοσίευση.',
    'Create Listing': 'Δημιουργία καταχώρισης',
    'Publish a transport request using the same structured workflow used across partner operations.':
      'Δημοσιεύστε ένα αίτημα μεταφοράς χρησιμοποιώντας την ίδια δομημένη ροή εργασίας που χρησιμοποιείται σε όλες τις λειτουργίες συνεργατών.',
    'Select category': 'Επιλέξτε κατηγορία',
    'Choose route': 'Επιλέξτε διαδρομή',
    'Status not set': 'Η κατάσταση δεν ορίστηκε',
    Items: 'Είδη',
    'VIN: {{vin}}': 'VIN: {{vin}}',
    'Pallet type: {{type}}': 'Τύπος παλέτας: {{type}}',
    'Material: {{type}}': 'Υλικό: {{type}}',
    'Special handling: {{details}}': 'Ειδικός χειρισμός: {{details}}',
    'Freight type: {{type}}': 'Είδος φορτίου: {{type}}',
    'Weight: {{weight}} kg': 'Βάρος: {{weight}} kg',
    'Volume: {{volume}} m³': 'Όγκος: {{volume}} m³',
    'Size: {{dimensions}}': 'Μέγεθος: {{dimensions}}',
    'Floors: {{from}} to {{to}}': 'Δάπεδα: {{from}} έως {{to}}',
    origin: 'καταγωγής',
    destination: 'προορισμός',
    'QTY {{quantity}}': 'ΠΟΣΟΤΗΤΑ {{quantity}}',
    'e.g. Wooden dining table': 'π.χ. Ξύλινη τραπεζαρία',
    'L cm': 'L cm',
    'W cm': 'W cm',
    'H cm': 'H cm',
    'Optional. Partners will see this as your target budget, but they can still send their own quote.':
      'Προαιρετικό. Οι συνεργάτες θα το δουν ως τον προϋπολογισμό-στόχο σας, αλλά μπορούν ακόμα να στείλουν τη δική τους προσφορά.',
    'Turn this off to publish a fixed-price listing that partners can accept directly.':
      'Απενεργοποιήστε αυτήν τη ρύθμιση για να δημοσιεύσετε μια λίστα με σταθερή τιμή την οποία μπορούν να αποδεχτούν απευθείας οι συνεργάτες.',
    'Quotes are enabled. Partners can see this price as a target budget and still send their own offers.':
      'Οι προσφορές είναι ενεργοποιημένες. Οι συνεργάτες μπορούν να δουν αυτήν την τιμή ως προϋπολογισμό-στόχο και εξακολουθούν να στέλνουν τις δικές τους προσφορές.',
    'Total volume (m³)': 'Συνολικός όγκος (m³)',
    'Dest. floor': 'Dest. όροφος',
    'Elevator at destination': 'Ανελκυστήρας στον προορισμό',
    'Elevator at origin': 'Ανελκυστήρας στην αρχή',
    'e.g. BMW 3 Series': 'π.χ. BMW Σειρά 3',
  },
};

const buildLocale = (code, overrides = {}) => {
  const injected = {};
  Object.entries(sharedTranslations).forEach(([key, values]) => {
    if (values[code]) {
      injected[key] = values[code];
    }
  });
  return applySemanticAliases({
    ...english,
    ...injected,
    ...(AUTO_TRANSLATED_LOCALE_OVERRIDES[code] || {}),
    ...overrides,
  });
};

export const translations = {
  en: english,
  bg: buildLocale('bg', {
    Language: 'Език',
    'Select language': 'Избор на език',
    'Loading…': 'Зареждане…',
    Price: 'Цена',
    Error: 'Грешка',
    Back: 'Назад',
    Cancel: 'Отказ',
    Pages: 'Страници',
    Dashboard: 'Табло',
    Profile: 'Профил',
    'Profile Incomplete': 'Непълен профил',
    'Please complete your profile information (Company, Phone, Address, City, Post Code) to access all features.':
      'Моля, попълнете информацията за профила си (Фирма, Телефон, Адрес, Град, Пощенски код), за да получите достъп до всички функции.',
    'Go to Profile': 'Към профила',
    Orders: 'Поръчки',
    'My Orders': 'Моите поръчки',
    'New Order': 'Нова поръчка',
    Watchlist: 'Наблюдение',
    'Fleet Management': 'Управление на автопарка',
    'Verify New Partners': 'Потвърди нови партньори',
    'Manage All Users': 'Управление на потребители',
    'Manage Pending Trucks': 'Управление на чакащи камиони',
    'Log out': 'Изход',
    'My Profile': 'Моят профил',
    'Order details': 'Детайли за поръчката',
    'Upload damages': 'Качи щети',
    'Payment instructions': 'Инструкции за плащане',
    Copy: 'Копирай',
    'Copied!': 'Копирано!',
    'booking.profile_incomplete_title': 'Непълен профил',
    'booking.profile_incomplete_partner_message':
      'Моля, попълнете фирмената информация (Име на фирма, ДДС номер, Адрес, Град, Пощенски код, Телефон), преди да приемате поръчки.',
    'booking.profile_incomplete_partner_short':
      'Попълнете фирмената информация, за да приемате поръчки.',
    'Purchase Terms Management': 'Управление на условията за покупка',
    'Document language': 'Език на документа',
    'Current language: {{language}}': 'Текущ език: {{language}}',
    'Click to download Purchase Terms':
      'Кликнете за изтегляне на условията за покупка',
    'Purchase terms document is unavailable for the selected language.':
      'Условията за покупка не са налични за избрания език.',
    'Upload and maintain localized Purchase Terms PDFs used in partner order acceptance.':
      'Качвайте и поддържайте локализирани PDF файлове с условия за покупка, използвани при приемане на поръчки от партньори.',
    'booking.purchase_terms_label': 'Условия за покупка',
    'booking.download_purchase_terms_caption':
      'Изтеглете и прегледайте активните условия за покупка на текущия език на интерфейса, преди да продължите.',
    'booking.accept_contract_checkbox':
      'Сключваме споразумения и договор за превоз на стоки. Току-що прочетох това споразумение изцяло и съм съгласен със съдържанието му.',
    'booking.confirm_schedule_24h_checkbox':
      'Потвърждавам, че ще планирам тази поръчка в рамките на 24 часа',
    'booking.failed_to_load_purchase_terms_document':
      'Неуспешно зареждане на документа с условия за покупка.',
  }),
  de: buildLocale('de', {
    Language: 'Sprache',
    'Select language': 'Sprache wählen',
    'Loading…': 'Wird geladen…',
    Error: 'Fehler',
    Back: 'Zurück',
    Cancel: 'Abbrechen',
    Dashboard: 'Dashboard',
    Profile: 'Profil',
    Orders: 'Bestellungen',
    'My Orders': 'Meine Bestellungen',
    'New Order': 'Neue Bestellung',
    Watchlist: 'Merkliste',
    'Fleet Management': 'Fuhrparkverwaltung',
    'Verify New Partners': 'Neue Partner prüfen',
    'Manage All Users': 'Alle Nutzer verwalten',
    'Manage Pending Trucks': 'Offene Lkw verwalten',
    'Log out': 'Abmelden',
    'My Profile': 'Mein Profil',
    'Order details': 'Bestelldetails',
    'Payment instructions': 'Zahlungsanweisungen',
    Copy: 'Kopieren',
    'Copied!': 'Kopiert!',
    'booking.profile_incomplete_title': 'Profil unvollständig',
    'booking.profile_incomplete_partner_message':
      'Bitte vervollständigen Sie Ihre Firmeninformationen (Firmenname, USt-IdNr., Adresse, Stadt, Postleitzahl, Telefon), bevor Sie Aufträge annehmen.',
    'booking.profile_incomplete_partner_short':
      'Vervollständigen Sie Ihre Firmeninformationen, um Aufträge anzunehmen.',
    'Purchase Terms Management': 'Verwaltung der Einkaufsbedingungen',
    'Document language': 'Dokumentensprache',
    'Current language: {{language}}': 'Aktuelle Sprache: {{language}}',
    'Click to download Purchase Terms':
      'Klicken Sie hier, um die Einkaufsbedingungen herunterzuladen',
    'Purchase terms document is unavailable for the selected language.':
      'Das Dokument mit den Einkaufsbedingungen ist für die ausgewählte Sprache nicht verfügbar.',
    'Upload and maintain localized Purchase Terms PDFs used in partner order acceptance.':
      'Laden Sie lokalisierte PDFs mit Einkaufsbedingungen hoch und verwalten Sie sie, die bei der Auftragsannahme durch Partner verwendet werden.',
    'booking.purchase_terms_label': 'Einkaufsbedingungen',
    'booking.download_purchase_terms_caption':
      'Laden Sie die aktiven Einkaufsbedingungen in Ihrer aktuellen Interfacesprache herunter und überprüfen Sie sie, bevor Sie fortfahren.',
    'booking.accept_contract_checkbox':
      'Wir schließen Vereinbarungen und einen Vertrag für den Transport von Waren ab. Ich habe diese Vereinbarung soeben vollständig gelesen und stimme ihrem Inhalt zu.',
    'booking.confirm_schedule_24h_checkbox':
      'Ich bestätige, dass ich diesen Auftrag innerhalb von 24 Stunden plane',
    'booking.failed_to_load_purchase_terms_document':
      'Fehler beim Laden des Dokuments mit den Einkaufsbedingungen.',
    'Pickup: {{date}}': 'Abholung: {{date}}',
    '{{current}} / min {{target}}': '{{current}} / Min. {{target}}',
    '{{current}} / max {{target}}': '{{current}} / Max. {{target}}',
  }),
  fr: buildLocale('fr', {
    Language: 'Langue',
    'Select language': 'Choisir la langue',
    'Loading…': 'Chargement…',
    Error: 'Erreur',
    Back: 'Retour',
    Cancel: 'Annuler',
    Dashboard: 'Tableau de bord',
    Profile: 'Profil',
    Orders: 'Commandes',
    'My Orders': 'Mes commandes',
    'New Order': 'Nouvelle commande',
    Watchlist: 'Liste de suivi',
    'Fleet Management': 'Gestion de flotte',
    'Verify New Partners': 'Vérifier les nouveaux partenaires',
    'Manage All Users': 'Gérer tous les utilisateurs',
    'Manage Pending Trucks': 'Gérer les camions en attente',
    'Log out': 'Se déconnecter',
    'My Profile': 'Mon profil',
    'Order details': 'Détails de la commande',
    'Payment instructions': 'Instructions de paiement',
    Copy: 'Copier',
    'Copied!': 'Copié !',
    'X total': '{{count}} au total',
    'booking.selected_weight_kg': 'Sélectionné : {{value}} kg',
    'booking.profile_incomplete_title': 'Profil incomplet',
    'booking.profile_incomplete_partner_message':
      "Veuillez compléter les informations de votre entreprise (Nom de l'entreprise, TVA, Adresse, Ville, Code postal, Téléphone) avant d'accepter des commandes.",
    'booking.profile_incomplete_partner_short':
      'Complétez les informations de votre entreprise pour accepter des commandes.',
    'Purchase Terms Management': "Gestion des conditions d'achat",
    'Document language': 'Langue du document',
    'Current language: {{language}}': 'Langue actuelle : {{language}}',
    'Click to download Purchase Terms':
      "Cliquez pour télécharger les conditions d'achat",
    'Purchase terms document is unavailable for the selected language.':
      "Le document des conditions d'achat n'est pas disponible pour la langue sélectionnée.",
    'Upload and maintain localized Purchase Terms PDFs used in partner order acceptance.':
      "Téléchargez et maintenez des PDF localisés des conditions d'achat utilisés lors de l'acceptation des commandes par les partenaires.",
    'booking.purchase_terms_label': "Conditions d'achat",
    'booking.download_purchase_terms_caption':
      "Téléchargez et consultez les conditions d'achat actives dans la langue actuelle de votre interface avant de continuer.",
    'booking.accept_contract_checkbox':
      "Nous concluons des accords et un contrat pour le transport de marchandises. Je viens de lire cet accord en entier et j'accepte son contenu.",
    'booking.confirm_schedule_24h_checkbox':
      'Je confirme que je planifierai cette commande dans les 24 heures',
    'booking.failed_to_load_purchase_terms_document':
      "Échec du chargement du document des conditions d'achat.",
    'Reference {{id}}': 'Référence {{id}}',
    'Quotes ({{count}})': 'Devis ({{count}})',
    'Score: {{score}}/100': 'Score : {{score}}/100',
    'Pickup: {{date}}': 'Enlèvement : {{date}}',
    'Delivery: {{date}}': 'Livraison : {{date}}',
    '{{count}} quote(s)': '{{count}} devis',
    '{{current}} / min {{target}}': '{{current}} / min. {{target}}',
    '{{current}} / max {{target}}': '{{current}} / max. {{target}}',
  }),
  ro: buildLocale('ro', {
    Language: 'Limbă',
    'Select language': 'Selectează limba',
    'Loading…': 'Se încarcă…',
    Error: 'Eroare',
    Back: 'Înapoi',
    Cancel: 'Anulează',
    Dashboard: 'Tablou de bord',
    Orders: 'Comenzi',
    'My Orders': 'Comenzile mele',
    'New Order': 'Comandă nouă',
    Watchlist: 'Listă de urmărit',
    'Fleet Management': 'Administrare flotă',
    'Verify New Partners': 'Verifică parteneri noi',
    'Manage All Users': 'Gestionează utilizatorii',
    'Manage Pending Trucks': 'Gestionează camioane în așteptare',
    'Log out': 'Deconectare',
    'My Profile': 'Profilul meu',
    'Order details': 'Detalii comandă',
    'Payment instructions': 'Instrucțiuni de plată',
    Copy: 'Copiază',
    'Copied!': 'Copiat!',
    'booking.profile_incomplete_title': 'Profil incomplet',
    'booking.profile_incomplete_partner_message':
      'Vă rugăm să completați informațiile companiei (Numele companiei, CIF, Adresă, Oraș, Cod poștal, Telefon) înainte de a accepta comenzi.',
    'booking.profile_incomplete_partner_short':
      'Completați informațiile companiei pentru a accepta comenzi.',
    'Purchase Terms Management': 'Gestionarea condițiilor de cumpărare',
    'Document language': 'Limba documentului',
    'Current language: {{language}}': 'Limba curentă: {{language}}',
    'Click to download Purchase Terms':
      'Faceți clic pentru a descărca condițiile de cumpărare',
    'Purchase terms document is unavailable for the selected language.':
      'Documentul cu condițiile de cumpărare nu este disponibil pentru limba selectată.',
    'Upload and maintain localized Purchase Terms PDFs used in partner order acceptance.':
      'Încărcați și mențineți PDF-uri localizate cu condiții de cumpărare utilizate la acceptarea comenzilor de către parteneri.',
    'booking.purchase_terms_label': 'Condiții de cumpărare',
    'booking.download_purchase_terms_caption':
      'Descărcați și consultați condițiile de cumpărare active în limba curentă a interfeței înainte de a continua.',
    'booking.accept_contract_checkbox':
      'Încheiem acorduri și un contract pentru transportul de mărfuri. Tocmai am citit acest acord în întregime și sunt de acord cu conținutul său.',
    'booking.confirm_schedule_24h_checkbox':
      'Confirm că voi planifica această comandă în termen de 24 de ore',
    'booking.failed_to_load_purchase_terms_document':
      'Nu s-a putut încărca documentul cu condițiile de cumpărare.',
    'booking.trailer': 'Remorcă',
    'Ref {{id}}': 'Referință {{id}}',
    '{{current}} / min {{target}}': '{{current}} / minim {{target}}',
    '{{current}} / max {{target}}': '{{current}} / maxim {{target}}',
  }),
  tr: buildLocale('tr', {
    Language: 'Dil',
    'Select language': 'Dil seç',
    'Loading…': 'Yükleniyor…',
    Error: 'Hata',
    Back: 'Geri',
    Cancel: 'İptal',
    Dashboard: 'Kontrol Paneli',
    Profile: 'Profil',
    Orders: 'Siparişler',
    'My Orders': 'Siparişlerim',
    'New Order': 'Yeni sipariş',
    Watchlist: 'İzleme listesi',
    'Fleet Management': 'Filo yönetimi',
    'Verify New Partners': 'Yeni ortakları doğrula',
    'Manage All Users': 'Kullanıcıları yönet',
    'Manage Pending Trucks': 'Bekleyen kamyonları yönet',
    'Log out': 'Çıkış yap',
    'My Profile': 'Profilim',
    'Order details': 'Sipariş detayları',
    'Payment instructions': 'Ödeme talimatları',
    Copy: 'Kopyala',
    'Copied!': 'Kopyalandı!',
    'booking.profile_incomplete_title': 'Profil Tamamlanmadı',
    'booking.profile_incomplete_partner_message':
      'Lütfen sipariş kabul etmeden önce şirket bilgilerinizi (Şirket Adı, Vergi No, Adres, Şehir, Posta Kodu, Telefon) tamamlayın.',
    'booking.profile_incomplete_partner_short':
      'Sipariş kabul etmek için şirket bilgilerinizi tamamlayın.',
    'Purchase Terms Management': 'Satın Alma Koşulları Yönetimi',
    'Document language': 'Doküman dili',
    'Current language: {{language}}': 'Mevcut dil: {{language}}',
    'Click to download Purchase Terms':
      'Satın Alma Koşullarını indirmek için tıklayın',
    'Purchase terms document is unavailable for the selected language.':
      'Satın alma koşulları belgesi seçilen dil için mevcut değil.',
    'Upload and maintain localized Purchase Terms PDFs used in partner order acceptance.':
      "Ortak sipariş kabulünde kullanılan yerelleştirilmiş Satın Alma Koşulları PDF'lerini yükleyin ve yönetin.",
    'booking.purchase_terms_label': 'Satın alma koşulları',
    'booking.download_purchase_terms_caption':
      'Devam etmeden önce mevcut arayüz dilinizdeki aktif satın alma koşullarını indirin ve inceleyin.',
    'booking.accept_contract_checkbox':
      'Eşya taşıması için anlaşmalar yapıyoruz ve sözleşme imzalıyoruz. Bu anlaşmayı az önce tamamen okudum ve içeriğini kabul ediyorum.',
    'booking.confirm_schedule_24h_checkbox':
      'Bu siparişi 24 saat içinde planlayacağımı onaylıyorum',
    'booking.failed_to_load_purchase_terms_document':
      'Satın alma koşulları belgesi yüklenemedi.',
  }),
  sr: buildLocale('sr', {
    Language: 'Језик',
    'Select language': 'Изабери језик',
    'Loading…': 'Учитавам…',
    Error: 'Грешка',
    Back: 'Назад',
    Cancel: 'Откажи',
    Dashboard: 'Контролна табла',
    Profile: 'Профил',
    Orders: 'Наредбе',
    'My Orders': 'Моје наруџбине',
    'New Order': 'Нова наруџбина',
    Watchlist: 'Листа за праћење',
    'Fleet Management': 'Управљање флотом',
    'Verify New Partners': 'Провери нове партнере',
    'Manage All Users': 'Управљај свим корисницима',
    'Manage Pending Trucks': 'Камиони на чекању',
    'Log out': 'Одјава',
    'My Profile': 'Мој профил',
    'Order details': 'Детаљи наруџбине',
    'Payment instructions': 'Упутство за плаћање',
    Copy: 'Копирај',
    'Copied!': 'Копирано!',
    'booking.profile_incomplete_title': 'Профил Непотпун',
    'booking.profile_incomplete_partner_message':
      'Молимо вас да попуните информације о вашој компанији (Назив компаније, ПИБ, Адреса, Град, Поштански број, Телефон) пре него што прихватите наруџбине.',
    'booking.profile_incomplete_partner_short':
      'Попуните информације о компанији да бисте прихватили наруџбине.',
    'Purchase Terms Management': 'Управљање условима куповине',
    'Document language': 'Језик документа',
    'Current language: {{language}}': 'Тренутни језик: {{language}}',
    'Click to download Purchase Terms': 'Кликните да преузмете услове куповине',
    'Purchase terms document is unavailable for the selected language.':
      'Документ са условима куповине није доступан за одабрани језик.',
    'Upload and maintain localized Purchase Terms PDFs used in partner order acceptance.':
      'Отпремајте и одржавајте локализоване PDF-ове са условима куповине који се користе при прихватању наруџбина од стране партнера.',
    'booking.purchase_terms_label': 'Услови куповине',
    'booking.download_purchase_terms_caption':
      'Преузмите и прегледајте активне услове куповине на тренутном језику интерфејса пре него што наставите.',
    'booking.accept_contract_checkbox':
      'Закључујемо споразуме и уговор о превозу робе. Управо сам прочитао овај споразум у целости и слажем се са његовим садржајем.',
    'booking.confirm_schedule_24h_checkbox':
      'Потврђујем да ћу планирати ову наруџбину у року од 24 сата',
    'booking.failed_to_load_purchase_terms_document':
      'Неуспешно учитавање документа са условима куповине.',
  }),
  mk: buildLocale('mk', {
    Language: 'Јазик',
    'Select language': 'Изберете јазик',
    'Loading…': 'Се вчитува…',
    Error: 'Грешка',
    Back: 'Назад',
    Cancel: 'Откажи',
    Dashboard: 'Командна табла',
    Orders: 'Нарачки',
    'My Orders': 'Мои нарачки',
    'New Order': 'Нова нарачка',
    Watchlist: 'Листа за следење',
    'Fleet Management': 'Менаџмент на флота',
    'Verify New Partners': 'Потврди нови партнери',
    'Manage All Users': 'Управувај со корисници',
    'Manage Pending Trucks': 'Неразрешени камиони',
    'Log out': 'Одјава',
    'My Profile': 'Мој профил',
    'Order details': 'Детали за нарачката',
    'Payment instructions': 'Инструкции за плаќање',
    Copy: 'Копирај',
    'Copied!': 'Копирано!',
    'booking.profile_incomplete_title': 'Профилот е нецелосен',
    'booking.profile_incomplete_partner_message':
      'Ве молиме пополнете ги информациите за вашата компанија (Име на компанија, ДДВ број, Адреса, Град, Поштенски број, Телефон) пред да прифатите нарачки.',
    'booking.profile_incomplete_partner_short':
      'Пополнете ги информациите за компанијата за да прифатите нарачки.',
    'Purchase Terms Management': 'Управување со условите за купување',
    'Document language': 'Јазик на документот',
    'Current language: {{language}}': 'Тековен јазик: {{language}}',
    'Click to download Purchase Terms':
      'Кликнете за преземање на условите за купување',
    'Purchase terms document is unavailable for the selected language.':
      'Документот со услови за купување не е достапен за избраниот јазик.',
    'Upload and maintain localized Purchase Terms PDFs used in partner order acceptance.':
      'Поставувајте и одржувајте локализирани PDF датотеки со услови за купување кои се користат при прифаќање на нарачки од партнери.',
    'booking.purchase_terms_label': 'Услови за купување',
    'booking.download_purchase_terms_caption':
      'Преземете и прегледајте ги активните услови за купување на тековниот јазик на интерфејсот пред да продолжите.',
    'booking.accept_contract_checkbox':
      'Склучуваме договори и договор за превоз на стоки. Току-што го прочитав овој договор во целост и се согласувам со неговата содржина.',
    'booking.confirm_schedule_24h_checkbox':
      'Потврдувам дека ќе го планирам оваа нарачка во рок од 24 часа',
    'booking.failed_to_load_purchase_terms_document':
      'Неуспешно вчитување на документот со услови за купување.',
  }),
  hu: buildLocale('hu', {
    Language: 'Nyelv',
    'Select language': 'Nyelv választása',
    'Loading…': 'Betöltés…',
    Error: 'Hiba',
    Back: 'Vissza',
    Cancel: 'Mégse',
    Dashboard: 'Irányítópult',
    Profile: 'Profil',
    Orders: 'Rendelések',
    'My Orders': 'Rendeléseim',
    'New Order': 'Új rendelés',
    Watchlist: 'Figyelőlista',
    'Fleet Management': 'Flottakezelés',
    'Verify New Partners': 'Új partnerek jóváhagyása',
    'Manage All Users': 'Felhasználók kezelése',
    'Manage Pending Trucks': 'Függő teherautók',
    'Log out': 'Kijelentkezés',
    'My Profile': 'Profilom',
    'Order details': 'Rendelés részletei',
    'Payment instructions': 'Fizetési utasítások',
    Copy: 'Másolás',
    'Copied!': 'Másolva!',
    'booking.profile_incomplete_title': 'A profil hiányos',
    'booking.profile_incomplete_partner_message':
      'Kérjük, töltse ki a céges adatokat (Cégnév, Adószám, Cím, Város, Irányítószám, Telefon) a rendelések elfogadása előtt.',
    'booking.profile_incomplete_partner_short':
      'Töltse ki a céges adatokat a rendelések elfogadásához.',
    'Purchase Terms Management': 'Vásárlási feltételek kezelése',
    'Document language': 'Dokumentum nyelve',
    'Current language: {{language}}': 'Aktuális nyelv: {{language}}',
    'Click to download Purchase Terms':
      'Kattintson a vásárlási feltételek letöltéséhez',
    'Purchase terms document is unavailable for the selected language.':
      'A vásárlási feltételeket tartalmazó dokumentum nem elérhető a kiválasztott nyelven.',
    'Upload and maintain localized Purchase Terms PDFs used in partner order acceptance.':
      'Töltsön fel és kezeljen lokalizált vásárlási feltételeket tartalmazó PDF-eket, amelyeket a partner rendelések elfogadásakor használnak.',
    'booking.purchase_terms_label': 'Vásárlási feltételek',
    'booking.download_purchase_terms_caption':
      'Töltse le és tekintse át az aktív vásárlási feltételeket az aktuális felület nyelvén, mielőtt folytatná.',
    'booking.accept_contract_checkbox':
      'Megállapodásokat kötünk és szerződést kötünk az áruk szállítására. Éppen most olvastam el ezt a megállapodást teljes egészében, és egyetértek annak tartalmával.',
    'booking.confirm_schedule_24h_checkbox':
      'Megerősítem, hogy 24 órán belül ütemezem ezt a rendelést',
    'booking.failed_to_load_purchase_terms_document':
      'Nem sikerült betölteni a vásárlási feltételeket tartalmazó dokumentumot.',
    Hello: 'Szia',
    Reset: 'Visszaállítás',
    'booking.driver': 'Sofőr',
    '{{current}} / max {{target}}': '{{current}} / max. {{target}}',
  }),
  sk: buildLocale('sk', {
    Language: 'Jazyk',
    'Select language': 'Vyber jazyk',
    'Loading…': 'Načítavam…',
    Error: 'Chyba',
    Back: 'Späť',
    Cancel: 'Zrušiť',
    Dashboard: 'Prehľad',
    Orders: 'Objednávky',
    'My Orders': 'Moje objednávky',
    'New Order': 'Nová objednávka',
    Watchlist: 'Sledovanie',
    'Fleet Management': 'Správa flotily',
    'Verify New Partners': 'Over nových partnerov',
    'Manage All Users': 'Spravovať používateľov',
    'Manage Pending Trucks': 'Správa čakajúcich vozidiel',
    'Log out': 'Odhlásiť sa',
    'My Profile': 'Môj profil',
    'Order details': 'Detaily objednávky',
    'Payment instructions': 'Pokyny k platbe',
    Copy: 'Kopírovať',
    'Copied!': 'Skopírované!',
    'booking.profile_incomplete_title': 'Profil je neúplný',
    'booking.profile_incomplete_partner_message':
      'Vyplňte prosím informácie o vašej spoločnosti (Názov spoločnosti, DIČ, Adresa, Mesto, PSČ, Telefón) pred prijatím objednávok.',
    'booking.profile_incomplete_partner_short':
      'Vyplňte informácie o spoločnosti na prijímanie objednávok.',
    'Purchase Terms Management': 'Správa podmienok nákupu',
    'Document language': 'Jazyk dokumentu',
    'Current language: {{language}}': 'Aktuálny jazyk: {{language}}',
    'Click to download Purchase Terms':
      'Kliknite na stiahnutie podmienok nákupu',
    'Purchase terms document is unavailable for the selected language.':
      'Dokument s podmienkami nákupu nie je dostupný pre vybraný jazyk.',
    'Upload and maintain localized Purchase Terms PDFs used in partner order acceptance.':
      'Nahrajte a spravujte lokalizované PDF súbory s podmienkami nákupu používané pri prijímaní objednávok partnermi.',
    'booking.purchase_terms_label': 'Podmienky nákupu',
    'booking.download_purchase_terms_caption':
      'Stiahnite a skontrolujte aktívne podmienky nákupu vo vašom aktuálnom jazyku rozhrania pred pokračovaním.',
    'booking.accept_contract_checkbox':
      'Uzatvárame dohody a zmluvu o preprave tovaru. Túto zmluvu som práve prečítal v plnom znení a súhlasím s jej obsahom.',
    'booking.confirm_schedule_24h_checkbox':
      'Potvrdzujem, že naplánujem túto objednávku do 24 hodín',
    'booking.failed_to_load_purchase_terms_document':
      'Nepodarilo sa načítať dokument s podmienkami nákupu.',
    'Mark Paid': 'Označiť ako zaplatené',
    Email: 'E-mail',
    'Admin Dashboard': 'Administrátorský panel',
    'auth.email': 'E-mail',
    'booking.trailer': 'Príves',
    '{{current}} / min {{target}}': '{{current}} / min. {{target}}',
    '{{current}} / max {{target}}': '{{current}} / max. {{target}}',
  }),
  sl: buildLocale('sl', {
    Language: 'Jezik',
    'Select language': 'Izberi jezik',
    'Loading…': 'Nalaganje…',
    Error: 'Napaka',
    Back: 'Nazaj',
    Cancel: 'Prekliči',
    Dashboard: 'Nadzorna plošča',
    Orders: 'Naročila',
    'My Orders': 'Moja naročila',
    'New Order': 'Novo naročilo',
    Watchlist: 'Seznam spremljanja',
    'Fleet Management': 'Upravljanje flote',
    'Verify New Partners': 'Preveri nove partnerje',
    'Manage All Users': 'Upravljaj uporabnike',
    'Manage Pending Trucks': 'Upravljanje čakajočih tovornjakov',
    'Log out': 'Odjava',
    'My Profile': 'Moj profil',
    'Order details': 'Podrobnosti naročila',
    'Payment instructions': 'Plačilna navodila',
    Copy: 'Kopiraj',
    'Copied!': 'Kopirano!',
    'booking.profile_incomplete_title': 'Profil je nedokončan',
    'booking.profile_incomplete_partner_message':
      'Prosimo, izpolnite podatke o vašem podjetju (Ime podjetja, Davčna št., Naslov, Mesto, Poštna št., Telefon), preden sprejmete naročila.',
    'booking.profile_incomplete_partner_short':
      'Izpolnite podatke o podjetju za sprejemanje naročil.',
    'Purchase Terms Management': 'Upravljanje pogojev nakupa',
    'Document language': 'Jezik dokumenta',
    'Current language: {{language}}': 'Trenutni jezik: {{language}}',
    'Click to download Purchase Terms': 'Kliknite za prenos pogojev nakupa',
    'Purchase terms document is unavailable for the selected language.':
      'Dokument s pogoji nakupa ni na voljo za izbrani jezik.',
    'Upload and maintain localized Purchase Terms PDFs used in partner order acceptance.':
      'Naložite in vzdržujte lokalizirane PDF-je s pogoji nakupa, ki se uporabljajo pri sprejemanju naročil s strani partnerjev.',
    'booking.purchase_terms_label': 'Pogoji nakupa',
    'booking.download_purchase_terms_caption':
      'Prenesite in preglejte aktivne pogoje nakupa v trenutnem jeziku vmesnika, preden nadaljujete.',
    'booking.accept_contract_checkbox':
      'Sklepamo dogovore in pogodbo o prevozu blaga. To pogodbo sem ravnokar v celoti prebral in se strinjam z njenim vsebino.',
    'booking.confirm_schedule_24h_checkbox':
      'Potrjujem, da bom to naročilo načrtoval v roku 24 ur',
    'booking.failed_to_load_purchase_terms_document':
      'Napaka pri nalaganju dokumenta s pogoji nakupa.',
    Gross: 'Bruto',
    '{{current}} / min {{target}}': '{{current}} / min. {{target}}',
  }),
  es: buildLocale('es', {
    Language: 'Idioma',
    'Select language': 'Seleccionar idioma',
    'Loading…': 'Cargando…',
    Error: 'Error',
    Back: 'Atrás',
    Cancel: 'Cancelar',
    Dashboard: 'Panel',
    Profile: 'Perfil',
    Orders: 'Pedidos',
    'My Orders': 'Mis pedidos',
    'New Order': 'Nuevo pedido',
    Watchlist: 'Lista de seguimiento',
    'Fleet Management': 'Gestión de flota',
    'Verify New Partners': 'Verificar nuevos socios',
    'Manage All Users': 'Gestionar usuarios',
    'Manage Pending Trucks': 'Gestionar camiones pendientes',
    'Log out': 'Cerrar sesión',
    'My Profile': 'Mi perfil',
    'Order details': 'Detalles del pedido',
    'Payment instructions': 'Instrucciones de pago',
    Copy: 'Copiar',
    'Copied!': '¡Copiado!',
    'booking.profile_incomplete_title': 'Perfil incompleto',
    'booking.profile_incomplete_partner_message':
      'Por favor complete la información de su empresa (Nombre de la empresa, NIF, Dirección, Ciudad, Código postal, Teléfono) antes de aceptar pedidos.',
    'booking.profile_incomplete_partner_short':
      'Complete la información de su empresa para aceptar pedidos.',
    'Purchase Terms Management': 'Gestión de condiciones de compra',
    'Document language': 'Idioma del documento',
    'Current language: {{language}}': 'Idioma actual: {{language}}',
    'Click to download Purchase Terms':
      'Haga clic para descargar las condiciones de compra',
    'Purchase terms document is unavailable for the selected language.':
      'El documento de condiciones de compra no está disponible para el idioma seleccionado.',
    'Upload and maintain localized Purchase Terms PDFs used in partner order acceptance.':
      'Suba y mantenga PDFs de condiciones de compra localizados utilizados en la aceptación de pedidos por socios.',
    'booking.purchase_terms_label': 'Condiciones de compra',
    'booking.download_purchase_terms_caption':
      'Descargue y revise las condiciones de compra activas en el idioma actual de su interfaz antes de continuar.',
    'booking.accept_contract_checkbox':
      'Celebramos acuerdos y concluimos un contrato para el transporte de mercancías. Acabo de leer este acuerdo en su totalidad y acepto su contenido.',
    'booking.confirm_schedule_24h_checkbox':
      'Confirmo que programaré este pedido dentro de las 24 horas',
    'booking.failed_to_load_purchase_terms_document':
      'No se pudo cargar el documento de condiciones de compra.',
    '{{current}} / min {{target}}': '{{current}} / min. {{target}}',
  }),
  fi: buildLocale('fi', {
    Language: 'Kieli',
    'Select language': 'Valitse kieli',
    'Loading…': 'Ladataan…',
    Error: 'Virhe',
    Back: 'Takaisin',
    Cancel: 'Peruuta',
    Dashboard: 'Hallintapaneeli',
    Profile: 'Profiili',
    Orders: 'Tilaukset',
    'My Orders': 'Tilaukseni',
    'New Order': 'Uusi tilaus',
    Watchlist: 'Seurantalista',
    'Fleet Management': 'Kaluston hallinta',
    'Verify New Partners': 'Vahvista uudet kumppanit',
    'Manage All Users': 'Hallinnoi käyttäjiä',
    'Manage Pending Trucks': 'Odottavat kuorma-autot',
    'Log out': 'Kirjaudu ulos',
    'My Profile': 'Profiilini',
    'Order details': 'Tilauksen tiedot',
    'Payment instructions': 'Maksuohjeet',
    Copy: 'Kopioi',
    'Copied!': 'Kopioitu!',
    'booking.profile_incomplete_title': 'Profiili keskeneräinen',
    'booking.profile_incomplete_partner_message':
      'Täytä yritystietosi (Yrityksen nimi, ALV-numero, Osoite, Kaupunki, Postinumero, Puhelin) ennen tilausten hyväksymistä.',
    'booking.profile_incomplete_partner_short':
      'Täytä yritystiedot tilausten hyväksymistä varten.',
    'Purchase Terms Management': 'Ostoehtojen hallinta',
    'Document language': 'Dokumentin kieli',
    'Current language: {{language}}': 'Nykyinen kieli: {{language}}',
    'Click to download Purchase Terms': 'Napsauta ladataksesi ostoehdot',
    'Purchase terms document is unavailable for the selected language.':
      'Ostoehtoja sisältävä asiakirja ei ole saatavilla valitulla kielellä.',
    'Upload and maintain localized Purchase Terms PDFs used in partner order acceptance.':
      'Lataa ja ylläpidä kumppanien tilausten hyväksynnässä käytettäviä lokalisoituja ostoehto-PDF:itä.',
    'booking.purchase_terms_label': 'Ostoehdot',
    'booking.download_purchase_terms_caption':
      'Lataa ja tarkista aktiiviset ostoehdot nykyisellä käyttöliittymän kielellä ennen jatkamista.',
    'booking.accept_contract_checkbox':
      'Teemme sopimuksia ja solmimme sopimuksen tavaroiden kuljetuksesta. Olen juuri lukenut tämän sopimuksen kokonaan ja hyväksyn sen sisällön.',
    'booking.confirm_schedule_24h_checkbox':
      'Vahvistan, että aion aikatauluttaa tämän tilauksen 24 tunnin kuluessa',
    'booking.failed_to_load_purchase_terms_document':
      'Ostoehtoasiakirjan lataaminen epäonnistui.',
    'Admin Dashboard': 'Yllapitajan hallintapaneeli',
    'Score: {{score}}/100': 'Pisteet: {{score}}/100',
    '{{current}} / min {{target}}': '{{current}} / vah. {{target}}',
    '{{current}} / max {{target}}': '{{current}} / enint. {{target}}',
  }),
  el: buildLocale('el', {
    'auth.client': 'Πελάτης',
    'auth.confirm_password': 'Επιβεβαίωση κωδικού πρόσβασης',
    'auth.confirm_password_is_required':
      'Η επιβεβαίωση κωδικού πρόσβασης είναι υποχρεωτική.',
    'auth.create_account': 'Δημιουργία λογαριασμού',
    'auth.email': 'Email',
    'auth.email_is_required': 'Το email είναι υποχρεωτικό.',
    'auth.enter_your_email_and_password_to_sign_in':
      'Εισαγάγετε το email και τον κωδικό πρόσβασής σας για να συνδεθείτε!',
    'auth.enter_your_email_create_a_password_and_choose_a_role_to_register':
      'Εισαγάγετε το email σας, δημιουργήστε έναν κωδικό πρόσβασης και επιλέξτε έναν ρόλο για να εγγραφείτε.',
    'auth.failed_to_resend_email': 'Αποτυχία επαναποστολής email',
    'auth.forgot_password': 'Ξεχάσατε τον κωδικό πρόσβασης;',
    'auth.hide_password': 'Απόκρυψη κωδικού πρόσβασης',
    'auth.i_want_to_register_as_a': 'Θέλω να εγγραφώ ως',
    'auth.incorrect_password_please_try_again':
      'Λανθασμένος κωδικός πρόσβασης. Παρακαλούμε προσπαθήστε ξανά.',
    'auth.invalid_email_format': 'Μη έγκυρη μορφή email.',
    'auth.invalid_email_or_password_please_check_your_credentials_and_try_again':
      'Μη έγκυρο email ή κωδικός πρόσβασης. Παρακαλούμε ελέγξτε τα στοιχεία σας και προσπαθήστε ξανά.',
    'auth.join_our_network_of_transport_partners':
      'Γίνετε μέλος του δικτύου των μεταφορικών συνεργατών μας.',
    'auth.login_failed': 'Αποτυχία σύνδεσης',
    'auth.min_8_characters': 'Τουλάχιστον 8 χαρακτήρες',
    'auth.order_transportation_in_the_automotive_branch':
      'Παραγγείλετε μεταφορά στον κλάδο της αυτοκινητοβιομηχανίας.',
    'auth.partner': 'Συνεργάτης',
    'auth.password': 'Κωδικός πρόσβασης',
    'auth.password_is_required': 'Ο κωδικός πρόσβασης είναι υποχρεωτικός.',
    'auth.passwords_do_not_match': 'Οι κωδικοί πρόσβασης δεν ταιριάζουν.',
    'auth.resend_verification_email': 'Επαναποστολή email επαλήθευσης',
    'auth.show_password': 'Εμφάνιση κωδικού πρόσβασης',
    'auth.sign_in': 'Σύνδεση',
    'auth.sign_in_2': 'Σύνδεση',
    'auth.sign_up': 'Εγγραφή',
    'auth.sign_up_2': 'Εγγραφή',
    'auth.username': 'Όνομα χρήστη',
    'auth.username_is_required': 'Το όνομα χρήστη είναι υποχρεωτικό.',
    'auth.your_name': 'Το όνομά σας',
    Language: 'Γλώσσα',
    'Select language': 'Επιλογή γλώσσας',
    'Loading…': 'Φόρτωση…',
    Error: 'Σφάλμα',
    Back: 'Πίσω',
    Cancel: 'Ακύρωση',
    Dashboard: 'Πίνακας ελέγχου',
    Profile: 'Προφίλ',
    Orders: 'Παραγγελίες',
    'My Orders': 'Οι παραγγελίες μου',
    'New Order': 'Νέα παραγγελία',
    Watchlist: 'Λίστα παρακολούθησης',
    'Fleet Management': 'Διαχείριση στόλου',
    'Verify New Partners': 'Επαλήθευση νέων συνεργατών',
    'Manage All Users': 'Διαχείριση όλων των χρηστών',
    'Manage Pending Trucks': 'Διαχείριση εκκρεμών φορτηγών',
    'Log out': 'Αποσύνδεση',
    'My Profile': 'Το προφίλ μου',
    'Order details': 'Λεπτομέρειες παραγγελίας',
    'Payment instructions': 'Οδηγίες πληρωμής',
    Copy: 'Αντιγραφή',
    'Copied!': 'Αντιγράφηκε!',
    'Purchase Terms Management': 'Διαχείριση όρων αγοράς',
    'Document language': 'Γλώσσα εγγράφου',
    'Current language: {{language}}': 'Τρέχουσα γλώσσα: {{language}}',
    'Click to download Purchase Terms': 'Κάντε κλικ για λήψη των όρων αγοράς',
    'Purchase terms document is unavailable for the selected language.':
      'Το έγγραφο με τους όρους αγοράς δεν είναι διαθέσιμο για την επιλεγμένη γλώσσα.',
    'Upload and maintain localized Purchase Terms PDFs used in partner order acceptance.':
      'Ανεβάστε και διατηρήστε εξατομικευμένα PDF όρων αγοράς που χρησιμοποιούνται στην αποδοχή παραγγελιών από συνεργάτες.',
    'booking.purchase_terms_label': 'Όροι αγοράς',
    'booking.download_purchase_terms_caption':
      'Κατεβάστε και ελέγξτε τους ενεργούς όρους αγοράς στην τρέχουσα γλώσσα της διεπαφής σας πριν συνεχίσετε.',
    'booking.accept_contract_checkbox':
      'Συνάπτουμε συμφωνίες και συμβόλαιο για τη μεταφορά εμπορευμάτων. Μόλις διάβασα πλήρως αυτή τη συμφωνία και συμφωνώ με το περιεχόμενό της.',
    'booking.confirm_schedule_24h_checkbox':
      'Επιβεβαιώνω ότι θα προγραμματίσω αυτή την παραγγελία εντός 24 ωρών',
    'booking.failed_to_load_purchase_terms_document':
      'Αποτυχία φόρτωσης του εγγράφου με τους όρους αγοράς.',
    'Mark Paid': 'Σήμανση ως πληρωμένο',
    Email: 'Ηλεκτρονικό ταχυδρομείο',
  }),
};
